/* tslint:disable */
/* eslint-disable */
/**
 * Public REVER API
 * The public REVER API allows you to manage your e-commerce returns and integrate your sites.  * Integrate the returns portal in your site * Programmatically create returns * Retrieve returns information * Action the returns from your apps (accept, reject) * Edit returns data  You can download the openapi file in [here](https://api.byrever.com/v1/docs/openapi.yaml) and use it to generate your client code.  ## E-commerce IDs and groups Most of the times, you will just have to use the e-commerce ID given at onboarding time.  However, in case you want to manage multiple e-commerces at the same time, a group id is needed. An e-commerce group is just a name that identifies a group of e-commerces that are managed together. Typically, these are different brands belonging to the same group.  ## Branding and configuration At this moment, settings and configuration are read-only.  They can only be changed upon request to your account manager.  We are planning to release a set of methods to allow self-configuration very soon!  ## Authentication This API has public and private methods. The private methods must use one of the following authentication methods:  * API Key * OAuth  ### Authenticating via API key This authentication method is normally used for Server to Server (unattended) scenarios. You must request the API key via your account manager. **You must keep the API key secret**, do not share it with anybody.  To authenticate a request using an api key, use the header **x-rever-api-key**. Example: `x-rever-api-key: 87bf223499abeef`  ### Authenticating via OAuth token This authentication method is normally used for User to Server scenarios. You must request the creation of a user via your account manager.  To authenticate a request using an OAuth token:  * Obtain a token at `https://rever-dashboard.eu.auth0.com/oauth/token`. Please follow [these instructions](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). * `Authentication: Bearer <token obtained>`  ## Integration with REVER REVER has [out-of-the-box integrations with the most popular e-commerce](https://itsrever.com/) platforms. However, if you want to integrate REVER with your own e-commerce, you can do it in two ways:  * Implementing yourself the API as described below in `Implementing your own integration` * Requesting a custom integration to your account manager  You can download the openapi file just with the integration methods in [here](https://api.byrever.com/v1/docs/openapi_integration.yaml) and use it to generate your stubs and tests.  Please forward any issue, question or typo to developer@itsrever.com  ## Linking to the returns portal The Returns Portal is the REVER application that shoppers use to start and manage their return processes. Typically, shoppers have to introduce some data from the order they want to return, like the order number and the e-mail used. If you want to link directly to a specific return process for a specific order from your platform, use the following URL structure:  ``` https://returns.itsrever.com/<slug>?orderNumber=<order_number>&email=<customer_email> ```  Parameters:  - **slug**: Represents your unique e-commerce identifier. - **orderNumber**: The order number associated with the return. - **email**: The email of the customer initiating the return.  Here is an example for the slug `XYZ`:  `https://returns.itsrever.com/XYZ?orderNumber=%23REVER123&email=demo@itsrever.com`  Make sure to replace `slug`, `orderNumber`, and `email` with appropriate values for each use case.  Remember to URL-encode special characters like #.  ## Implementing your own integration Integrating with REVER is very simple. You just need to implement the API methods described in the [integration section](#public-rever-api-integration). Depending on the REVER features you want to use, you will need to implement some or all of the methods.  List of features:  * Instant Refund: Ability to refund the customer instantly, directly from REVER * Gift Card: Ability to refund the customer with a gift cad * Promo Code: Ability to refund the customer with a promo code instead of a gift card * Original Payment Method (OPM): Ability to refund the customer with the original payment method * Exchange order: Ability to create an exchange order as a refund method. Requires products with variants * Non returnable items (NRI): Ability to mark some items or orders as non returnable. Requires that the order brings tagging information.  Table of requirements per feature:  |     Method                                   | Instant Refund | Gift Card | Promo Code | OPM | Exchange order |  | -------------------------------------------- | -------------- | --------- | ---------- | --- | -------------- | | [GET order](#findorderbycustomerprintedorderid)   | X              | X         | X          |  X  | X              | | [POST note](#addnotetoorder)                 | X              | X         | X          |  X  | X              | | [POST return](#createreturn)                 | X              | X         | X          |  X  | X              | | [PUT return](#updatereturn)                  | X              | X         | X          |  X  | X              | | PUT gift                                     |                | X         |            |     |                | | DELETE gift                                  |                | X         |            |     |                | | POST promo                                   |                |           | X          |     |                | | DELETE promo                                 |                |           | X          |     |                | | PUT order                                    |                |           |            |     | X              | | GET shipping                                 |                |           |            |     | X              | | [POST refund] (#createrefund)                |                |           |            |  X  |                |  ### URLs and authentication The methods can be implemented at any url. However, the HTTP verb is mandatory.  For each endpoint, we expect a request pattern.  For example, the `GET order` method could be implemented as `GET yourdomain.com/api/rever/{order_id}`.  The `{order_id}` is a placeholder for the order id. The `{order_id}` is mandatory, but the rest of the url is up to you.  At this moment, we only support the following authentication methods:  - **API key authentication** In each request, we will provide the API key you set up for REVER in the given header, for example `x-rever-api-key`. - **OAuth 2.0 (two legged)** Before each request, we will request a token in the provided auth server using the provided `client_id` and `client_secret`.  ### Developing and testing your integration To facilitate the integration, we provide a [public repository](https://github.com/itsrever/integration) with a sample implementation of the API and the testing framework for any language.  Thanks to this Docker image, you can test your integration at any point without connecting with REVER. Just execute the following command:  ``` docker run -it --rm      --name rever-integration-tester \\     --key=[API_KEY] \\     --order=https://yourdomain.com/api/rever/{order_id} \\     --product=https://yourdomain.com/api/rever/product/{product_id} \\     ... ``` The output of that command describes which test scenarios passed or not.  Please check the [README](https://github.com/itsrever/integration) to check how to setup the OAuth 2.0 authentication.  ### Submitting your integration Once you have implemented the methods you need, and verified that all of the testing scenarios pass, you can submit your integration to REVER. Just send an email to `developer@itsrever.com` with the information below and we will add your integration to the system.  - Your data     - Company     - Contact information (important, for notifications) - Features supported - Methods implemented     - Production URL pattern for each - Output of the testing framework - If using API Key: Auth header name + API key to be used in production through onetimesecret.com (or similar) - If using OAuth: Auth server URL + Client ID + Client Secret through onetimesecret.com (or similar)  ### Integration disclaimer  * REVER is not responsible for any issues that may arise from the integration of the API.  * At the moment that any bug is discovered by any of the parties, it should be shared as soon as possible. * REVER might request rotating the API key if it is considered that the key has been compromised. * New features might require the implementation of new methods or the amendment of existing ones. * Submitting the integration does not guarantee that it will be approved. REVER reserves the right to reject any integration. * REVER reserves the right to remove any integration at any time. * REVER reserves the right to change the API at any time. * REVER reserves the right to change the testing scenarios at any time. * REVER reserves the right to change the testing framework at any time.  ## Rate limiting The API is rate limited. If you receive a 429 error, please wait a few seconds and retry.  ## CORS policy At the moment, only the requests coming from browsers in the address https://dashboard.byrever.com or https://returns.itsrever.com are allowed.  If you require to use a custom domain, please contact your account manager. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddNoteToOrderRequest
 */
export interface AddNoteToOrderRequest {
    /**
     * The text to be associated to the order
     * @type {string}
     * @memberof AddNoteToOrderRequest
     */
    'note'?: string;
}
/**
 * Content of a single AI insight for a given period
 * @export
 * @interface AiinsightspbAIInsightsContent
 */
export interface AiinsightspbAIInsightsContent {
    /**
     * Unique identifier for this AI insight
     * @type {number}
     * @memberof AiinsightspbAIInsightsContent
     */
    'id'?: number;
    /**
     * The actual insight data, including title and description
     * @type {AiinsightspbInsight}
     * @memberof AiinsightspbAIInsightsContent
     */
    'insight'?: AiinsightspbInsight;
    /**
     * Period for which the insight is valid
     * @type {AiinsightspbPeriod}
     * @memberof AiinsightspbAIInsightsContent
     */
    'period'?: AiinsightspbPeriod;
}
/**
 * Payload for the AIInsightsResponse response
 * @export
 * @interface AiinsightspbAIInsightsResponse
 */
export interface AiinsightspbAIInsightsResponse {
    /**
     * List of insights content for the ecommerce
     * @type {Array<AiinsightspbAIInsightsContent>}
     * @memberof AiinsightspbAIInsightsResponse
     */
    'content_insights'?: Array<AiinsightspbAIInsightsContent>;
}
/**
 * Details of the insight
 * @export
 * @interface AiinsightspbInsight
 */
export interface AiinsightspbInsight {
    /**
     * Description of the insight
     * @type {string}
     * @memberof AiinsightspbInsight
     */
    'description'?: string;
    /**
     * Title of the insight
     * @type {string}
     * @memberof AiinsightspbInsight
     */
    'title'?: string;
}
/**
 * Period of time for the insight
 * @export
 * @interface AiinsightspbPeriod
 */
export interface AiinsightspbPeriod {
    /**
     * Start date of the period (YYYY-MM-DD)
     * @type {string}
     * @memberof AiinsightspbPeriod
     */
    'from_date'?: string;
    /**
     * End date of the period (YYYY-MM-DD)
     * @type {string}
     * @memberof AiinsightspbPeriod
     */
    'to_date'?: string;
}
/**
 * Payload for the PostAIInsightsFeedback request
 * @export
 * @interface AiinsightspbPostAIInsightsFeedbackRequest
 */
export interface AiinsightspbPostAIInsightsFeedbackRequest {
    /**
     * Ecommerce ID for which feedback is given. Required.
     * @type {string}
     * @memberof AiinsightspbPostAIInsightsFeedbackRequest
     */
    'ecommerce_id'?: string;
    /**
     * Feedback message from the user. Optional.
     * @type {string}
     * @memberof AiinsightspbPostAIInsightsFeedbackRequest
     */
    'feedback_message'?: string;
    /**
     * Insight ID this feedback refers to. Required.
     * @type {number}
     * @memberof AiinsightspbPostAIInsightsFeedbackRequest
     */
    'insight_id'?: number;
    /**
     * Thumb rating (e.g., \"up\", \"down\"). Required.
     * @type {string}
     * @memberof AiinsightspbPostAIInsightsFeedbackRequest
     */
    'thumb_rating'?: AiinsightspbPostAIInsightsFeedbackRequestThumbRatingEnum;
}

export const AiinsightspbPostAIInsightsFeedbackRequestThumbRatingEnum = {
    Unspecified: 'THUMB_RATING_UNSPECIFIED',
    ThumbsUp: 'THUMB_RATING_THUMBS_UP',
    ThumbsDown: 'THUMB_RATING_THUMBS_DOWN'
} as const;

export type AiinsightspbPostAIInsightsFeedbackRequestThumbRatingEnum = typeof AiinsightspbPostAIInsightsFeedbackRequestThumbRatingEnum[keyof typeof AiinsightspbPostAIInsightsFeedbackRequestThumbRatingEnum];

/**
 * Response for integration details
 * @export
 * @interface AppstoreintegrationspbGetIntegrationDetailsResponse
 */
export interface AppstoreintegrationspbGetIntegrationDetailsResponse {
    /**
     * Required API keys for the integration
     * @type {{ [key: string]: string; }}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'api_required_keys'?: { [key: string]: string; };
    /**
     * Category tags for the integration
     * @type {Array<string>}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'integration_category_tags'?: Array<string>;
    /**
     * Detailed description of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'integration_description'?: string;
    /**
     * ID of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'integration_id'?: string;
    /**
     * URL of the integration\'s logo
     * @type {string}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'integration_logo'?: string;
    /**
     * Name of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'integration_name'?: string;
    /**
     * URL to the integration\'s documentation or setup page
     * @type {string}
     * @memberof AppstoreintegrationspbGetIntegrationDetailsResponse
     */
    'integration_url'?: string;
}
/**
 * Response for getting integrations status
 * @export
 * @interface AppstoreintegrationspbGetIntegrationsStatusResponse
 */
export interface AppstoreintegrationspbGetIntegrationsStatusResponse {
    /**
     * List of integrations with their status
     * @type {Array<AppstoreintegrationspbIntegrationStatusRow>}
     * @memberof AppstoreintegrationspbGetIntegrationsStatusResponse
     */
    'integrations'?: Array<AppstoreintegrationspbIntegrationStatusRow>;
}
/**
 * Basic integration card information
 * @export
 * @interface AppstoreintegrationspbIntegrationCard
 */
export interface AppstoreintegrationspbIntegrationCard {
    /**
     * Category tags for the integration
     * @type {Array<string>}
     * @memberof AppstoreintegrationspbIntegrationCard
     */
    'integration_category_tags'?: Array<string>;
    /**
     * Description of what the integration does
     * @type {string}
     * @memberof AppstoreintegrationspbIntegrationCard
     */
    'integration_description'?: string;
    /**
     * ID of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbIntegrationCard
     */
    'integration_id'?: string;
    /**
     * URL of the integration\'s logo
     * @type {string}
     * @memberof AppstoreintegrationspbIntegrationCard
     */
    'integration_logo'?: string;
    /**
     * Name of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbIntegrationCard
     */
    'integration_name'?: string;
    /**
     * Whether the integration is currently connected
     * @type {boolean}
     * @memberof AppstoreintegrationspbIntegrationCard
     */
    'is_connected'?: boolean;
}
/**
 * 
 * @export
 * @interface AppstoreintegrationspbIntegrationStatusRow
 */
export interface AppstoreintegrationspbIntegrationStatusRow {
    /**
     * Name of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbIntegrationStatusRow
     */
    'name'?: string;
    /**
     * Status of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbIntegrationStatusRow
     */
    'status'?: AppstoreintegrationspbIntegrationStatusRowStatusEnum;
}

export const AppstoreintegrationspbIntegrationStatusRowStatusEnum = {
    UnknownUnspecified: 'INTEGRATION_STATUS_UNKNOWN_UNSPECIFIED',
    Active: 'INTEGRATION_STATUS_ACTIVE',
    Inactive: 'INTEGRATION_STATUS_INACTIVE',
    Error: 'INTEGRATION_STATUS_ERROR'
} as const;

export type AppstoreintegrationspbIntegrationStatusRowStatusEnum = typeof AppstoreintegrationspbIntegrationStatusRowStatusEnum[keyof typeof AppstoreintegrationspbIntegrationStatusRowStatusEnum];

/**
 * Response for listing available integrations
 * @export
 * @interface AppstoreintegrationspbListAvailableIntegrationsResponse
 */
export interface AppstoreintegrationspbListAvailableIntegrationsResponse {
    /**
     * List of available integration cards
     * @type {Array<AppstoreintegrationspbIntegrationCard>}
     * @memberof AppstoreintegrationspbListAvailableIntegrationsResponse
     */
    'integrations'?: Array<AppstoreintegrationspbIntegrationCard>;
}
/**
 * Request for saving integration credentials
 * @export
 * @interface AppstoreintegrationspbSaveIntegrationCredentialsRequest
 */
export interface AppstoreintegrationspbSaveIntegrationCredentialsRequest {
    /**
     * Credentials
     * @type {{ [key: string]: string; }}
     * @memberof AppstoreintegrationspbSaveIntegrationCredentialsRequest
     */
    'credentials'?: { [key: string]: string; };
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof AppstoreintegrationspbSaveIntegrationCredentialsRequest
     */
    'ecommerce_id'?: string;
    /**
     * ID of the integration to save credentials for
     * @type {string}
     * @memberof AppstoreintegrationspbSaveIntegrationCredentialsRequest
     */
    'integration_id'?: string;
    /**
     * Name of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbSaveIntegrationCredentialsRequest
     */
    'integration_name'?: string;
    /**
     * Status of the integration
     * @type {string}
     * @memberof AppstoreintegrationspbSaveIntegrationCredentialsRequest
     */
    'status'?: AppstoreintegrationspbSaveIntegrationCredentialsRequestStatusEnum;
}

export const AppstoreintegrationspbSaveIntegrationCredentialsRequestStatusEnum = {
    UnknownUnspecified: 'INTEGRATION_STATUS_UNKNOWN_UNSPECIFIED',
    Active: 'INTEGRATION_STATUS_ACTIVE',
    Inactive: 'INTEGRATION_STATUS_INACTIVE',
    Error: 'INTEGRATION_STATUS_ERROR'
} as const;

export type AppstoreintegrationspbSaveIntegrationCredentialsRequestStatusEnum = typeof AppstoreintegrationspbSaveIntegrationCredentialsRequestStatusEnum[keyof typeof AppstoreintegrationspbSaveIntegrationCredentialsRequestStatusEnum];

/**
 * APIKeyGroupSummary counts the keys held by one ecommerce group.
 * @export
 * @interface AuthsAPIKeyGroupSummary
 */
export interface AuthsAPIKeyGroupSummary {
    /**
     * Group as STORED. Groups differing only in case are reported separately on purpose, because that exact spelling is what group-scoped lookups elsewhere match on, so the drift is worth seeing.
     * @type {string}
     * @memberof AuthsAPIKeyGroupSummary
     */
    'ecommerce_group'?: string;
    /**
     * How many keys this group holds.
     * @type {number}
     * @memberof AuthsAPIKeyGroupSummary
     */
    'key_count'?: number;
    /**
     * Creation time of this group\'s most recent key.
     * @type {string}
     * @memberof AuthsAPIKeyGroupSummary
     */
    'newest_created_at'?: string;
}
/**
 * APIKeyInfo is the public metadata of an API key. Never includes the key value or its hash.
 * @export
 * @interface AuthsAPIKeyInfo
 */
export interface AuthsAPIKeyInfo {
    /**
     * When the key was created.
     * @type {string}
     * @memberof AuthsAPIKeyInfo
     */
    'created_at'?: string;
    /**
     * Who issued the key, taken from the caller\'s own identity rather than the request. Empty on keys created before attribution was recorded, which is not the same as \"issued by nobody\".
     * @type {string}
     * @memberof AuthsAPIKeyInfo
     */
    'created_by'?: string;
    /**
     * Ecommerce group of the key, as STORED. Listing matches the group case-insensitively, so this  may differ in case from the group that was queried; it is the spelling the key actually holds.
     * @type {string}
     * @memberof AuthsAPIKeyInfo
     */
    'ecommerce_group'?: string;
    /**
     * Last time a request authenticated with the key, accurate to the hour. Unset if the key has not been used since this started being recorded.
     * @type {string}
     * @memberof AuthsAPIKeyInfo
     */
    'last_used_at'?: string;
    /**
     * Scopes granted to the key.
     * @type {Array<string>}
     * @memberof AuthsAPIKeyInfo
     */
    'scopes'?: Array<string>;
    /**
     * Recipient of the key; part of the key\'s logical identity together with the group.
     * @type {string}
     * @memberof AuthsAPIKeyInfo
     */
    'user_email'?: string;
}
/**
 * CreateAPIKeyRequest represents the request to create a new API key
 * @export
 * @interface AuthsCreateAPIKeyRequest
 */
export interface AuthsCreateAPIKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthsCreateAPIKeyRequest
     */
    'ecommerce_group'?: string;
    /**
     * \"resource:action\" scopes; a new key requires at least one. Empty re-sends the existing key as is,  and re-issuance with scopes that differ from the stored set returns InvalidArgument.
     * @type {Array<string>}
     * @memberof AuthsCreateAPIKeyRequest
     */
    'scopes'?: Array<string>;
    /**
     * Recipient of the key; together with ecommerce_group it is the key\'s logical identity.  (Not enforced by the database.) A group may hold several keys, one per user_email.  Re-issuing the same (ecommerce_group, user_email) re-sends the existing key.
     * @type {string}
     * @memberof AuthsCreateAPIKeyRequest
     */
    'user_email'?: string;
}
/**
 * CreateAPIKeyResponse represents the response after creating an API key.   This message is a COMPLETE CREDENTIAL: one_time_link plus one_time_passphrase together open the  API key. Callers must never log it, cache it, persist it, or forward it to another system; hand it  to the requesting operator and drop it. The passphrase travels with the link because the response  returns to the calling operator tool directly, not through a chat or mail channel where unfurl  bots and URL scanners would burn the single-view secret before anyone read it.   This RPC authenticates nobody: it validates its fields and scopes and nothing else. Keeping the  credential out of the wrong hands is entirely the caller\'s job — today that is the backoffice,  which gates the operation behind an Auth0 session, plus the fact that /v1/internal/auth is  routed only on Envoy\'s internal virtual host.
 * @export
 * @interface AuthsCreateAPIKeyResponse
 */
export interface AuthsCreateAPIKeyResponse {
    /**
     * Always empty: the key value never crosses this boundary, one_time_link is the only delivery channel.
     * @type {string}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'api_key'?: string;
    /**
     * When the key was created. On a re-issuance this is the original creation time.
     * @type {string}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'ecommerce_group'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'one_time_link'?: string;
    /**
     * Passphrase that opens one_time_link. Together with the link this is the API key itself, so it  must never be logged, cached or persisted by any caller. It is returned here — instead of being  delivered out of band — because the response reaches the calling operator tool directly, where  no unfurl bot or URL scanner can spend the single-view secret first.
     * @type {string}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'one_time_passphrase'?: string;
    /**
     * True when the existing key of (ecommerce_group, user_email) was re-sent instead of a new one created.
     * @type {boolean}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'reissued'?: boolean;
    /**
     * Effective scopes granted to this key.
     * @type {Array<string>}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'scopes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AuthsCreateAPIKeyResponse
     */
    'user_email'?: string;
}
/**
 * ListAPIKeyGroupsInternalResponse represents the groups that hold at least one API key.
 * @export
 * @interface AuthsListAPIKeyGroupsInternalResponse
 */
export interface AuthsListAPIKeyGroupsInternalResponse {
    /**
     * One entry per distinct stored group, newest activity first.
     * @type {Array<AuthsAPIKeyGroupSummary>}
     * @memberof AuthsListAPIKeyGroupsInternalResponse
     */
    'groups'?: Array<AuthsAPIKeyGroupSummary>;
}
/**
 * ListAPIKeysInternalResponse represents the metadata of the keys of an ecommerce group
 * @export
 * @interface AuthsListAPIKeysInternalResponse
 */
export interface AuthsListAPIKeysInternalResponse {
    /**
     * 
     * @type {Array<AuthsAPIKeyInfo>}
     * @memberof AuthsListAPIKeysInternalResponse
     */
    'keys'?: Array<AuthsAPIKeyInfo>;
}
/**
 * ListKnownScopesInternalResponse represents the canonical scope catalog.
 * @export
 * @interface AuthsListKnownScopesInternalResponse
 */
export interface AuthsListKnownScopesInternalResponse {
    /**
     * Every known scope, in catalog order.
     * @type {Array<AuthsScopeDescriptor>}
     * @memberof AuthsListKnownScopesInternalResponse
     */
    'scopes'?: Array<AuthsScopeDescriptor>;
}
/**
 * ResolveAPIKeyInternalRequest represents the request to resolve a raw API key
 * @export
 * @interface AuthsResolveAPIKeyInternalRequest
 */
export interface AuthsResolveAPIKeyInternalRequest {
    /**
     * The raw API key to resolve. Never logged or echoed back.
     * @type {string}
     * @memberof AuthsResolveAPIKeyInternalRequest
     */
    'api_key'?: string;
}
/**
 * ResolveAPIKeyInternalResponse represents the resolved identity of an API key.  Never includes the key value or its hash.
 * @export
 * @interface AuthsResolveAPIKeyInternalResponse
 */
export interface AuthsResolveAPIKeyInternalResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthsResolveAPIKeyInternalResponse
     */
    'ecommerce_group'?: string;
    /**
     * Scopes granted to the key.
     * @type {Array<string>}
     * @memberof AuthsResolveAPIKeyInternalResponse
     */
    'scopes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AuthsResolveAPIKeyInternalResponse
     */
    'user_email'?: string;
}
/**
 * ScopeDescriptor carries the mechanical facts about one scope, and intentionally no display name: human wording belongs to the caller, so new scopes do not need a release here to be labelled.
 * @export
 * @interface AuthsScopeDescriptor
 */
export interface AuthsScopeDescriptor {
    /**
     * True for the bare \"*\" wildcard, which grants every scope that does not require an explicit grant.
     * @type {boolean}
     * @memberof AuthsScopeDescriptor
     */
    'is_wildcard'?: boolean;
    /**
     * True when \"*\" does NOT satisfy this scope and it must be granted verbatim. A caller offering a  \"full access\" option must still offer these separately, or it mints keys that cannot use them.
     * @type {boolean}
     * @memberof AuthsScopeDescriptor
     */
    'requires_explicit_grant'?: boolean;
    /**
     * The scope identifier, as it must appear verbatim in a key\'s grant set.
     * @type {string}
     * @memberof AuthsScopeDescriptor
     */
    'scope'?: string;
}
/**
 * DashboardDay is one UTC-day bucket of the offer funnel time series.
 * @export
 * @interface BackofficeanalyticspbDashboardDay
 */
export interface BackofficeanalyticspbDashboardDay {
    /**
     * Orders with COVER added that day.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDay
     */
    'added_orders'?: string;
    /**
     * Day in YYYY-MM-DD (UTC).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDay
     */
    'date'?: string;
    /**
     * Orders with a COVER offer shown that day.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDay
     */
    'offered_orders'?: string;
    /**
     * Orders created that day.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDay
     */
    'total_orders'?: string;
    /**
     * Orders where the widget loaded and requested a quote that day.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDay
     */
    'widget_loaded_orders'?: string;
}
/**
 * DashboardDayPremium is one (UTC day, currency) bucket of premiums paid.
 * @export
 * @interface BackofficeanalyticspbDashboardDayPremium
 */
export interface BackofficeanalyticspbDashboardDayPremium {
    /**
     * ISO-4217 currency of the amount.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDayPremium
     */
    'currency'?: string;
    /**
     * Day in YYYY-MM-DD (UTC).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDayPremium
     */
    'date'?: string;
    /**
     * Premiums paid on orders created that day, in minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardDayPremium
     */
    'premium_cents'?: string;
}
/**
 * DashboardMoney aggregates premium and payout amounts for one currency.  Amounts are never converted across currencies (no FX in v1).
 * @export
 * @interface BackofficeanalyticspbDashboardMoney
 */
export interface BackofficeanalyticspbDashboardMoney {
    /**
     * Accepted orders in this currency (denominator for the average premium).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'added_orders'?: string;
    /**
     * Claim payouts approved by Seel, minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'claim_refund_cents'?: string;
    /**
     * ISO-4217 currency code the amounts are denominated in.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'currency'?: string;
    /**
     * Sum of premiums paid, minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'premium_cents'?: string;
    /**
     * Sum of taxes on those premiums, minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'premium_tax_cents'?: string;
    /**
     * Portion of premium_cents later refunded, minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'refunded_premium_cents'?: string;
    /**
     * Shipping label costs covered on free returns, minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'rsi_label_cost_cents'?: string;
    /**
     * REVER service fees covered on free returns, minor units.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardMoney
     */
    'rsi_service_fee_cents'?: string;
}
/**
 * DashboardOrder is one order row of the dashboard drill-down.
 * @export
 * @interface BackofficeanalyticspbDashboardOrder
 */
export interface BackofficeanalyticspbDashboardOrder {
    /**
     * When the shopper requested the 24h cancellation. Null when never.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'cancellation_requested_at'?: string;
    /**
     * Customer country (ISO-3166 alpha-2 from the locale); empty when unknown.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'country'?: string;
    /**
     * Order creation time.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'created_at'?: string;
    /**
     * ISO-4217 currency of premium_cents.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'currency'?: string;
    /**
     * EcommerceID the order belongs to.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'ecommerce_id'?: string;
    /**
     * Why no offer was shown (widget_rejected | widget_absent); empty otherwise.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'no_offer_reason'?: string;
    /**
     * Offer outcome: accepted | declined | no_offer.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'offer_status'?: string;
    /**
     * ISO-4217 currency of offered_premium_cents.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'offered_currency'?: string;
    /**
     * Quoted premium in minor units when an offer existed.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'offered_premium_cents'?: string;
    /**
     * Premium paid in minor units (accepted orders).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'premium_cents'?: string;
    /**
     * When the premium was refunded. Null when never refunded.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'refunded_at'?: string;
    /**
     * Deep link to the order in the Shopify admin. Empty when the merchant\'s  shop domain could not be resolved.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'shopify_admin_url'?: string;
    /**
     * Bare Shopify order id.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'shopify_order_id'?: string;
    /**
     * Human Shopify order number.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardOrder
     */
    'shopify_order_number'?: string;
}
/**
 * DashboardReturn is one return-process row of the dashboard drill-down.
 * @export
 * @interface BackofficeanalyticspbDashboardReturn
 */
export interface BackofficeanalyticspbDashboardReturn {
    /**
     * Amount covered for the shopper, in minor units: the claim payout, or the  return fee waived by the FREE_RETURN_PROMOTION on free returns.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'amount_cents'?: string;
    /**
     * When the claim / free return was created.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'created_at'?: string;
    /**
     * ISO-4217 currency of amount_cents.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'currency'?: string;
    /**
     * EcommerceID the process belongs to.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'ecommerce_id'?: string;
    /**
     * When the claim reached a terminal state. Null for free returns.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'resolved_at'?: string;
    /**
     * REVER return process id (retp_...), links to the ops backoffice.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'return_process_id'?: string;
    /**
     * Bare Shopify order id of the covered order.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'shopify_order_id'?: string;
    /**
     * Human Shopify order number of the covered order.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'shopify_order_number'?: string;
    /**
     * Claim lifecycle status; \"used\" for free returns.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'status'?: string;
    /**
     * Row kind: claim | free_return.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardReturn
     */
    'type'?: string;
}
/**
 * DashboardSlice is one bucket of a categorical breakdown (per ecommerce or  per customer country) of the offer funnel.
 * @export
 * @interface BackofficeanalyticspbDashboardSlice
 */
export interface BackofficeanalyticspbDashboardSlice {
    /**
     * Orders with COVER added.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'added_orders'?: string;
    /**
     * ISO-4217 currency of the premium amounts (by_ecommerce only; empty when  the bucket has no premiums).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'currency'?: string;
    /**
     * Bucket key: an ecommerce_id, or an ISO-3166 alpha-2 country (empty when  the customer locale carries no region).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'key'?: string;
    /**
     * Orders with a COVER offer shown.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'offered_orders'?: string;
    /**
     * Sum of premiums paid in the bucket, minor units. Only populated on the  by_ecommerce breakdown; zero on by_country.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'premium_cents'?: string;
    /**
     * Distinct premium currencies seen in the bucket. When above 1 the premium  amounts mix currencies and must not be rendered as one figure (no FX).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'premium_currencies'?: string;
    /**
     * Sum of taxes on those premiums, minor units (by_ecommerce only).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'premium_tax_cents'?: string;
    /**
     * Orders in the bucket.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'total_orders'?: string;
    /**
     * Orders where the widget loaded and requested a quote.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardSlice
     */
    'widget_loaded_orders'?: string;
}
/**
 * DashboardStatusCount is one status bucket of a lifecycle breakdown.
 * @export
 * @interface BackofficeanalyticspbDashboardStatusCount
 */
export interface BackofficeanalyticspbDashboardStatusCount {
    /**
     * Rows in that status.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardStatusCount
     */
    'count'?: string;
    /**
     * REVER-internal status value (cover.claim.status or cover.contract.status).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardStatusCount
     */
    'status'?: string;
}
/**
 * DashboardTotals carries the order-level COVER offer funnel and the  return-processes split over the filtered window.
 * @export
 * @interface BackofficeanalyticspbDashboardTotals
 */
export interface BackofficeanalyticspbDashboardTotals {
    /**
     * Orders where COVER was added and paid (offer_status accepted).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'added_orders'?: string;
    /**
     * Orders that added COVER and then used the shopper 24h cancellation  (contract cancellation_initiator = shopper_24h, including requests still  pending Seel confirmation).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'cancelled_24h_orders'?: string;
    /**
     * Return processes on COVER orders filed as Seel claims (cover.claim rows).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'claims'?: string;
    /**
     * Orders where the offer was shown but not added.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'declined_orders'?: string;
    /**
     * Return processes on COVER orders consuming the free return  (cover.rsi_usage rows, excluding cancelled ones).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'free_returns'?: string;
    /**
     * Orders where no offer was shown.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'no_offer_orders'?: string;
    /**
     * No-offer split: the widget never ran (Shop App, POS, in-app browser).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'no_offer_widget_absent'?: string;
    /**
     * No-offer split: the widget ran but Seel rejected the quote.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'no_offer_widget_rejected'?: string;
    /**
     * Orders where a COVER offer was shown (offer_status accepted or declined).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'offered_orders'?: string;
    /**
     * Accepted orders whose premium was later refunded.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'premium_refunded_orders'?: string;
    /**
     * All orders seen by the COVER pipeline (every cover.order_mapping row).
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'total_orders'?: string;
    /**
     * Orders where the COVER widget loaded and requested a quote (an offer was  shown, or Seel rejected it). Denominator of Seel\'s real offer rate.
     * @type {string}
     * @memberof BackofficeanalyticspbDashboardTotals
     */
    'widget_loaded_orders'?: string;
}
/**
 * GetDashboardRequest filters the COVER dashboard aggregates. All fields  are optional; zero values mean \"no filter\".
 * @export
 * @interface BackofficeanalyticspbGetDashboardRequest
 */
export interface BackofficeanalyticspbGetDashboardRequest {
    /**
     * Restrict to a customer country, ISO-3166 alpha-2, derived from the region  of cover.order_mapping.customer_locale (e.g. \"ES\" from \"en-ES\").
     * @type {string}
     * @memberof BackofficeanalyticspbGetDashboardRequest
     */
    'country'?: string;
    /**
     * Restrict to a single ecommerce.
     * @type {string}
     * @memberof BackofficeanalyticspbGetDashboardRequest
     */
    'ecommerce_id'?: string;
    /**
     * Inclusive lower bound on row creation time (UTC).
     * @type {string}
     * @memberof BackofficeanalyticspbGetDashboardRequest
     */
    'from'?: string;
    /**
     * Exclusive upper bound on row creation time (UTC).
     * @type {string}
     * @memberof BackofficeanalyticspbGetDashboardRequest
     */
    'to'?: string;
}
/**
 * GetDashboardResponse carries every aggregate the COVER dashboard renders.  Rates (attachment rate, offer rate) are computed client-side from the counts.
 * @export
 * @interface BackofficeanalyticspbGetDashboardResponse
 */
export interface BackofficeanalyticspbGetDashboardResponse {
    /**
     * Funnel broken down by customer country, descending by total orders.  Facet-style: ignores the request\'s country filter (all other filters  apply) so selectors keep listing every country with orders.
     * @type {Array<BackofficeanalyticspbDashboardSlice>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'by_country'?: Array<BackofficeanalyticspbDashboardSlice>;
    /**
     * Funnel broken down by ecommerce, descending by total orders. Facet-style:  ignores the request\'s ecommerce_id filter (all other filters apply) so  selectors keep listing every ecommerce with orders.
     * @type {Array<BackofficeanalyticspbDashboardSlice>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'by_ecommerce'?: Array<BackofficeanalyticspbDashboardSlice>;
    /**
     * cover.claim rows by status.
     * @type {Array<BackofficeanalyticspbDashboardStatusCount>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'claims_by_status'?: Array<BackofficeanalyticspbDashboardStatusCount>;
    /**
     * cover.contract rows by status.
     * @type {Array<BackofficeanalyticspbDashboardStatusCount>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'contracts_by_status'?: Array<BackofficeanalyticspbDashboardStatusCount>;
    /**
     * Offer funnel per UTC day, ascending.
     * @type {Array<BackofficeanalyticspbDashboardDay>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'days'?: Array<BackofficeanalyticspbDashboardDay>;
    /**
     * Money aggregates, one entry per currency seen in the window.
     * @type {Array<BackofficeanalyticspbDashboardMoney>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'money'?: Array<BackofficeanalyticspbDashboardMoney>;
    /**
     * Premiums paid per (UTC day, currency), ascending by day.
     * @type {Array<BackofficeanalyticspbDashboardDayPremium>}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'premium_days'?: Array<BackofficeanalyticspbDashboardDayPremium>;
    /**
     * Funnel and return-process totals.
     * @type {BackofficeanalyticspbDashboardTotals}
     * @memberof BackofficeanalyticspbGetDashboardResponse
     */
    'totals'?: BackofficeanalyticspbDashboardTotals;
}
/**
 * 
 * @export
 * @interface BackofficeanalyticspbGetRouteUsageResponse
 */
export interface BackofficeanalyticspbGetRouteUsageResponse {
    /**
     * Busiest routes first, at most 100.
     * @type {Array<BackofficeanalyticspbRouteUsage>}
     * @memberof BackofficeanalyticspbGetRouteUsageResponse
     */
    'routes'?: Array<BackofficeanalyticspbRouteUsage>;
}
/**
 * ListDashboardOrdersRequest filters the order drill-down list. The filter  fields match GetDashboardRequest.
 * @export
 * @interface BackofficeanalyticspbListDashboardOrdersRequest
 */
export interface BackofficeanalyticspbListDashboardOrdersRequest {
    /**
     * Restrict to a customer country (ISO-3166 alpha-2). Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardOrdersRequest
     */
    'country'?: string;
    /**
     * Restrict to a single ecommerce. Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardOrdersRequest
     */
    'ecommerce_id'?: string;
    /**
     * Inclusive lower bound on order creation time (UTC). Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardOrdersRequest
     */
    'from'?: string;
    /**
     * Maximum rows returned, newest first. Defaults to 200, capped at 500.
     * @type {number}
     * @memberof BackofficeanalyticspbListDashboardOrdersRequest
     */
    'limit'?: number;
    /**
     * Which KPI tile\'s orders to list.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardOrdersRequest
     */
    'segment'?: BackofficeanalyticspbListDashboardOrdersRequestSegmentEnum;
    /**
     * Exclusive upper bound on order creation time (UTC). Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardOrdersRequest
     */
    'to'?: string;
}

export const BackofficeanalyticspbListDashboardOrdersRequestSegmentEnum = {
    Unspecified: 'DASHBOARD_ORDER_SEGMENT_UNSPECIFIED',
    Total: 'DASHBOARD_ORDER_SEGMENT_TOTAL',
    Offered: 'DASHBOARD_ORDER_SEGMENT_OFFERED',
    Added: 'DASHBOARD_ORDER_SEGMENT_ADDED',
    Canceled24H: 'DASHBOARD_ORDER_SEGMENT_CANCELED_24H',
    WidgetLoaded: 'DASHBOARD_ORDER_SEGMENT_WIDGET_LOADED'
} as const;

export type BackofficeanalyticspbListDashboardOrdersRequestSegmentEnum = typeof BackofficeanalyticspbListDashboardOrdersRequestSegmentEnum[keyof typeof BackofficeanalyticspbListDashboardOrdersRequestSegmentEnum];

/**
 * ListDashboardOrdersResponse carries the drill-down order rows.
 * @export
 * @interface BackofficeanalyticspbListDashboardOrdersResponse
 */
export interface BackofficeanalyticspbListDashboardOrdersResponse {
    /**
     * Matching orders, newest first, truncated to the request limit.
     * @type {Array<BackofficeanalyticspbDashboardOrder>}
     * @memberof BackofficeanalyticspbListDashboardOrdersResponse
     */
    'orders'?: Array<BackofficeanalyticspbDashboardOrder>;
    /**
     * Total matching orders before truncation.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardOrdersResponse
     */
    'total'?: string;
}
/**
 * ListDashboardReturnsRequest filters the return-process drill-down list.  The filter fields match GetDashboardRequest.
 * @export
 * @interface BackofficeanalyticspbListDashboardReturnsRequest
 */
export interface BackofficeanalyticspbListDashboardReturnsRequest {
    /**
     * Restrict to a customer country (ISO-3166 alpha-2). Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardReturnsRequest
     */
    'country'?: string;
    /**
     * Restrict to a single ecommerce. Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardReturnsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Inclusive lower bound on claim / free-return creation time (UTC). Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardReturnsRequest
     */
    'from'?: string;
    /**
     * Maximum rows returned, newest first. Defaults to 200, capped at 500.
     * @type {number}
     * @memberof BackofficeanalyticspbListDashboardReturnsRequest
     */
    'limit'?: number;
    /**
     * Which returns tile\'s processes to list.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardReturnsRequest
     */
    'segment'?: BackofficeanalyticspbListDashboardReturnsRequestSegmentEnum;
    /**
     * Exclusive upper bound on claim / free-return creation time (UTC). Optional.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardReturnsRequest
     */
    'to'?: string;
}

export const BackofficeanalyticspbListDashboardReturnsRequestSegmentEnum = {
    Unspecified: 'DASHBOARD_RETURN_SEGMENT_UNSPECIFIED',
    All: 'DASHBOARD_RETURN_SEGMENT_ALL',
    Claims: 'DASHBOARD_RETURN_SEGMENT_CLAIMS',
    FreeReturns: 'DASHBOARD_RETURN_SEGMENT_FREE_RETURNS'
} as const;

export type BackofficeanalyticspbListDashboardReturnsRequestSegmentEnum = typeof BackofficeanalyticspbListDashboardReturnsRequestSegmentEnum[keyof typeof BackofficeanalyticspbListDashboardReturnsRequestSegmentEnum];

/**
 * ListDashboardReturnsResponse carries the drill-down return rows.
 * @export
 * @interface BackofficeanalyticspbListDashboardReturnsResponse
 */
export interface BackofficeanalyticspbListDashboardReturnsResponse {
    /**
     * Matching return processes, newest first, truncated to the request limit.
     * @type {Array<BackofficeanalyticspbDashboardReturn>}
     * @memberof BackofficeanalyticspbListDashboardReturnsResponse
     */
    'returns'?: Array<BackofficeanalyticspbDashboardReturn>;
    /**
     * Total matching processes before truncation.
     * @type {string}
     * @memberof BackofficeanalyticspbListDashboardReturnsResponse
     */
    'total'?: string;
}
/**
 * RouteUsage is one provider + carrier + return method on one route (shopper  country to warehouse country), across every ecommerce.
 * @export
 * @interface BackofficeanalyticspbRouteUsage
 */
export interface BackofficeanalyticspbRouteUsage {
    /**
     * Carrier as the shipment recorded it, lowercase.
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'carrier'?: string;
    /**
     * Shopper country, ISO-3166 alpha-2 uppercase.
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'from_country'?: string;
    /**
     * When the most recent shipment on this row was created.
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'last_used_at'?: string;
    /**
     * Provider as the shipment recorded it, lowercase.
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'provider'?: string;
    /**
     * Return method as logistics-api stores it, e.g. \"dropoff\".
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'return_method'?: string;
    /**
     * Warehouse country, ISO-3166 alpha-2 uppercase.
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'to_country'?: string;
    /**
     * Persisted, non-testing shipments created in the window. A shipment exists  only once the provider accepted the request: creations, not deliveries.
     * @type {string}
     * @memberof BackofficeanalyticspbRouteUsage
     */
    'usage_count'?: string;
}
/**
 * A single message of the conversation history
 * @export
 * @interface ChatpbChatMessage
 */
export interface ChatpbChatMessage {
    /**
     * Text content of the message
     * @type {string}
     * @memberof ChatpbChatMessage
     */
    'content'?: string;
    /**
     * Author of the message: \"user\" or \"assistant\"
     * @type {string}
     * @memberof ChatpbChatMessage
     */
    'role'?: string;
}
/**
 * Payload for the Chat request
 * @export
 * @interface ChatpbChatRequest
 */
export interface ChatpbChatRequest {
    /**
     * Ecommerce ID the conversation is about. Required.
     * @type {string}
     * @memberof ChatpbChatRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional Auth0 access token (audience-scoped to a downstream MCP server, e.g.  analytics-mcp) that a tab\'s Mastra context forwards as-is to authenticate with  that downstream server. Opaque here; only the relevant Mastra context reads it.
     * @type {string}
     * @memberof ChatpbChatRequest
     */
    'mcp_access_token'?: string;
    /**
     * Full conversation history; the last entry is the current user message
     * @type {Array<ChatpbChatMessage>}
     * @memberof ChatpbChatRequest
     */
    'messages'?: Array<ChatpbChatMessage>;
    /**
     * The screen\'s own state. MUST include a \"current_tab\" field naming the screen  (e.g. \"shipping-costs\") that Mastra routes on; the rest is that tab\'s UI state.  Example: { \"current_tab\": \"shipping-costs\", \"rules\": [ ...wire-form rules... ] }
     * @type {object}
     * @memberof ChatpbChatRequest
     */
    'payload'?: object;
}
/**
 * Payload for the Chat response
 * @export
 * @interface ChatpbChatResponse
 */
export interface ChatpbChatResponse {
    /**
     * What the assistant decided to do. Vocabulary is per-tab; for shipping-costs:  \"quote\" | \"rules_updated\" | \"none\".
     * @type {string}
     * @memberof ChatpbChatResponse
     */
    'action'?: string;
    /**
     * Assistant reply to render in the chat, in the user\'s language
     * @type {string}
     * @memberof ChatpbChatResponse
     */
    'reply'?: string;
    /**
     * Per-tab result. For shipping-costs \"rules_updated\" it is  { \"rules\": [ ...complete wire-form set... ] }; empty for other actions.
     * @type {object}
     * @memberof ChatpbChatResponse
     */
    'result'?: object;
}
/**
 * 
 * @export
 * @interface CreateReturn200Response
 */
export interface CreateReturn200Response {
    /**
     * the id of the return generated in the platform
     * @type {string}
     * @memberof CreateReturn200Response
     */
    'return_id': string;
}
/**
 * Typeform webhook envelope, as events-api forwards it.
 * @export
 * @interface CsatpbUpsertResponseRequest
 */
export interface CsatpbUpsertResponseRequest {
    /**
     * Typeform webhook delivery ID.
     * @type {string}
     * @memberof CsatpbUpsertResponseRequest
     */
    'event_id'?: string;
    /**
     * Typeform event type. Only \"form_response\" is stored.
     * @type {string}
     * @memberof CsatpbUpsertResponseRequest
     */
    'event_type'?: string;
    /**
     * Typeform form_response object, stored verbatim.
     * @type {object}
     * @memberof CsatpbUpsertResponseRequest
     */
    'form_response'?: object;
}
/**
 * Result of UpsertResponseInternal.
 * @export
 * @interface CsatpbUpsertResponseResponse
 */
export interface CsatpbUpsertResponseResponse {
    /**
     * False when the event was not a form_response and was skipped.
     * @type {boolean}
     * @memberof CsatpbUpsertResponseResponse
     */
    'stored'?: boolean;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbAggregatedPeriodReturnRate
 */
export interface DashboardanalyticspbAggregatedPeriodReturnRate {
    /**
     * currency shop
     * @type {string}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'currency_shop'?: string;
    /**
     * items returned
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'items_returned'?: number;
    /**
     * items returned split
     * @type {DashboardanalyticspbItemsReturnedSplit}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'items_returned_split'?: DashboardanalyticspbItemsReturnedSplit;
    /**
     * items sold
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'items_sold'?: number;
    /**
     * period
     * @type {string}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'period'?: string;
    /**
     * refund rate
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'refund_rate'?: number;
    /**
     * return rate
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedPeriodReturnRate
     */
    'return_rate'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbAggregatedProductReturnRate
 */
export interface DashboardanalyticspbAggregatedProductReturnRate {
    /**
     * items returned
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedProductReturnRate
     */
    'items_returned'?: number;
    /**
     * items sold
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedProductReturnRate
     */
    'items_sold'?: number;
    /**
     * period
     * @type {string}
     * @memberof DashboardanalyticspbAggregatedProductReturnRate
     */
    'period'?: string;
    /**
     * return rate
     * @type {number}
     * @memberof DashboardanalyticspbAggregatedProductReturnRate
     */
    'return_rate'?: number;
}
/**
 * Message that represents an analyzed product.
 * @export
 * @interface DashboardanalyticspbAnalyzedProduct
 */
export interface DashboardanalyticspbAnalyzedProduct {
    /**
     * URL of the product image.
     * @type {string}
     * @memberof DashboardanalyticspbAnalyzedProduct
     */
    'image_url'?: string;
    /**
     * Name of the product.
     * @type {string}
     * @memberof DashboardanalyticspbAnalyzedProduct
     */
    'name'?: string;
    /**
     * ID of the product.
     * @type {string}
     * @memberof DashboardanalyticspbAnalyzedProduct
     */
    'product_id'?: string;
    /**
     * product reference
     * @type {string}
     * @memberof DashboardanalyticspbAnalyzedProduct
     */
    'product_reference'?: string;
    /**
     * Number of returns for the product.
     * @type {number}
     * @memberof DashboardanalyticspbAnalyzedProduct
     */
    'return_count'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbCountryReturnRateTableEntry
 */
export interface DashboardanalyticspbCountryReturnRateTableEntry {
    /**
     * country iso
     * @type {string}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'country'?: string;
    /**
     * currency shop
     * @type {string}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'currency_shop'?: string;
    /**
     * items returned
     * @type {number}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'items_returned'?: number;
    /**
     * items returned split
     * @type {DashboardanalyticspbItemsReturnedSplit}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'items_returned_split'?: DashboardanalyticspbItemsReturnedSplit;
    /**
     * items sold
     * @type {number}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'items_sold'?: number;
    /**
     * rdv
     * @type {number}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'rdv'?: number;
    /**
     * refund rate
     * @type {number}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'refund_rate'?: number;
    /**
     * return rate
     * @type {number}
     * @memberof DashboardanalyticspbCountryReturnRateTableEntry
     */
    'return_rate'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbCountryReturnRateTableResponse
 */
export interface DashboardanalyticspbCountryReturnRateTableResponse {
    /**
     * table entries
     * @type {Array<DashboardanalyticspbCountryReturnRateTableEntry>}
     * @memberof DashboardanalyticspbCountryReturnRateTableResponse
     */
    'entries'?: Array<DashboardanalyticspbCountryReturnRateTableEntry>;
    /**
     * total entries
     * @type {number}
     * @memberof DashboardanalyticspbCountryReturnRateTableResponse
     */
    'total_entries'?: number;
}
/**
 * FindProductsResponse is the response message that contains  the products and the total amount of different products given a period of time.
 * @export
 * @interface DashboardanalyticspbFindProductsResponse
 */
export interface DashboardanalyticspbFindProductsResponse {
    /**
     * List of analyzed products.
     * @type {Array<DashboardanalyticspbAnalyzedProduct>}
     * @memberof DashboardanalyticspbFindProductsResponse
     */
    'products'?: Array<DashboardanalyticspbAnalyzedProduct>;
    /**
     * Total number of distinct returned products.
     * @type {number}
     * @memberof DashboardanalyticspbFindProductsResponse
     */
    'total_distinct_returned_products'?: number;
}
/**
 * Payload for the GetFilters response
 * @export
 * @interface DashboardanalyticspbGetAvailableFiltersResponse
 */
export interface DashboardanalyticspbGetAvailableFiltersResponse {
    /**
     * List of collections
     * @type {Array<string>}
     * @memberof DashboardanalyticspbGetAvailableFiltersResponse
     */
    'collections'?: Array<string>;
    /**
     * List of countries
     * @type {Array<string>}
     * @memberof DashboardanalyticspbGetAvailableFiltersResponse
     */
    'countries'?: Array<string>;
}
/**
 * Payload for the GetItemsAndTotalsPerDay response
 * @export
 * @interface DashboardanalyticspbGetItemsAndTotalsPerDayResponse
 */
export interface DashboardanalyticspbGetItemsAndTotalsPerDayResponse {
    /**
     * List of items and totals by day.
     * @type {Array<DashboardanalyticspbItemsAndTotalsDay>}
     * @memberof DashboardanalyticspbGetItemsAndTotalsPerDayResponse
     */
    'items_and_totals_days'?: Array<DashboardanalyticspbItemsAndTotalsDay>;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbGetScopePortalsResponse
 */
export interface DashboardanalyticspbGetScopePortalsResponse {
    /**
     * Every portal of the caller\'s group, eligible or not.
     * @type {Array<DashboardanalyticspbScopePortal>}
     * @memberof DashboardanalyticspbGetScopePortalsResponse
     */
    'portals'?: Array<DashboardanalyticspbScopePortal>;
}
/**
 * Payload for the GetUpsell response. An exchange is an upsell when the items the  shopper took are worth more than the ones sent back for exchange.
 * @export
 * @interface DashboardanalyticspbGetUpsellResponse
 */
export interface DashboardanalyticspbGetUpsellResponse {
    /**
     * Currency the amount is reported in.
     * @type {string}
     * @memberof DashboardanalyticspbGetUpsellResponse
     */
    'currency'?: string;
    /**
     * Exchanges in the time range.
     * @type {number}
     * @memberof DashboardanalyticspbGetUpsellResponse
     */
    'exchanges'?: number;
    /**
     * Money format
     * @type {DashboardanalyticspbMoneyFormat}
     * @memberof DashboardanalyticspbGetUpsellResponse
     */
    'money_format'?: DashboardanalyticspbMoneyFormat;
    /**
     * Extra value the upsells brought in: the items taken minus the ones sent back,  in minor units of the currency (see money_format.amount_multiplied).
     * @type {string}
     * @memberof DashboardanalyticspbGetUpsellResponse
     */
    'upsell_amount'?: string;
    /**
     * Exchanges that were an upsell.
     * @type {number}
     * @memberof DashboardanalyticspbGetUpsellResponse
     */
    'upsells'?: number;
}
/**
 * Message that represents items and totals by day.
 * @export
 * @interface DashboardanalyticspbItemsAndTotalsDay
 */
export interface DashboardanalyticspbItemsAndTotalsDay {
    /**
     * Date of the items and totals.
     * @type {string}
     * @memberof DashboardanalyticspbItemsAndTotalsDay
     */
    'date'?: string;
    /**
     * Number of items returned.
     * @type {number}
     * @memberof DashboardanalyticspbItemsAndTotalsDay
     */
    'item_count'?: number;
    /**
     * Total returned.
     * @type {number}
     * @memberof DashboardanalyticspbItemsAndTotalsDay
     */
    'returns_total_amount'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbItemsReturnedSplit
 */
export interface DashboardanalyticspbItemsReturnedSplit {
    /**
     * items returned exchange
     * @type {number}
     * @memberof DashboardanalyticspbItemsReturnedSplit
     */
    'items_returned_exchange'?: number;
    /**
     * items returned refund
     * @type {number}
     * @memberof DashboardanalyticspbItemsReturnedSplit
     */
    'items_returned_refund'?: number;
    /**
     * items returned store credit
     * @type {number}
     * @memberof DashboardanalyticspbItemsReturnedSplit
     */
    'items_returned_store_credit'?: number;
}
/**
 * Money format
 * @export
 * @interface DashboardanalyticspbMoneyFormat
 */
export interface DashboardanalyticspbMoneyFormat {
    /**
     * Amount multiplied by
     * @type {number}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'amount_multiplied'?: number;
    /**
     * Currency
     * @type {string}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'currency'?: string;
    /**
     * Currency symbol
     * @type {string}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'currency_symbol'?: string;
    /**
     * Decimal separator
     * @type {string}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'decimal_separator'?: string;
    /**
     * Display prices with tax
     * @type {boolean}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'display_prices_taxes'?: boolean;
    /**
     * Thousands separator
     * @type {string}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'thousand_separator'?: string;
    /**
     * Visible number of decimals
     * @type {number}
     * @memberof DashboardanalyticspbMoneyFormat
     */
    'visible_number_decimals'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbPeriodReturnRateResponse
 */
export interface DashboardanalyticspbPeriodReturnRateResponse {
    /**
     * return rate by period
     * @type {Array<DashboardanalyticspbAggregatedPeriodReturnRate>}
     * @memberof DashboardanalyticspbPeriodReturnRateResponse
     */
    'aggregated_period_return_rates'?: Array<DashboardanalyticspbAggregatedPeriodReturnRate>;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbProblematicProduct
 */
export interface DashboardanalyticspbProblematicProduct {
    /**
     * product image url
     * @type {string}
     * @memberof DashboardanalyticspbProblematicProduct
     */
    'image_url'?: string;
    /**
     * product id
     * @type {string}
     * @memberof DashboardanalyticspbProblematicProduct
     */
    'product_id'?: string;
    /**
     * product name
     * @type {string}
     * @memberof DashboardanalyticspbProblematicProduct
     */
    'product_name'?: string;
    /**
     * problematic reason
     * @type {string}
     * @memberof DashboardanalyticspbProblematicProduct
     */
    'reason'?: DashboardanalyticspbProblematicProductReasonEnum;
}

export const DashboardanalyticspbProblematicProductReasonEnum = {
    Unspecified: 'PROBLEMATIC_REASON_UNSPECIFIED',
    ReturnRate: 'PROBLEMATIC_REASON_RETURN_RATE',
    TooSmall: 'PROBLEMATIC_REASON_TOO_SMALL',
    TooBig: 'PROBLEMATIC_REASON_TOO_BIG'
} as const;

export type DashboardanalyticspbProblematicProductReasonEnum = typeof DashboardanalyticspbProblematicProductReasonEnum[keyof typeof DashboardanalyticspbProblematicProductReasonEnum];

/**
 * 
 * @export
 * @interface DashboardanalyticspbProblematicProductsResponse
 */
export interface DashboardanalyticspbProblematicProductsResponse {
    /**
     * problematic products
     * @type {Array<DashboardanalyticspbProblematicProduct>}
     * @memberof DashboardanalyticspbProblematicProductsResponse
     */
    'problematic_products'?: Array<DashboardanalyticspbProblematicProduct>;
}
/**
 * Message that contains product analytics data for  a specific ecommerce in a specific time range.
 * @export
 * @interface DashboardanalyticspbProductAnalytics
 */
export interface DashboardanalyticspbProductAnalytics {
    /**
     * List of analyzed products.
     * @type {Array<DashboardanalyticspbAnalyzedProduct>}
     * @memberof DashboardanalyticspbProductAnalytics
     */
    'products'?: Array<DashboardanalyticspbAnalyzedProduct>;
    /**
     * List of reasons for product returns.
     * @type {Array<DashboardanalyticspbReason>}
     * @memberof DashboardanalyticspbProductAnalytics
     */
    'reasons'?: Array<DashboardanalyticspbReason>;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbProductCountryReturnRate
 */
export interface DashboardanalyticspbProductCountryReturnRate {
    /**
     * country iso
     * @type {string}
     * @memberof DashboardanalyticspbProductCountryReturnRate
     */
    'country'?: string;
    /**
     * items returned
     * @type {number}
     * @memberof DashboardanalyticspbProductCountryReturnRate
     */
    'items_returned'?: number;
    /**
     * items sold
     * @type {number}
     * @memberof DashboardanalyticspbProductCountryReturnRate
     */
    'items_sold'?: number;
    /**
     * return rate
     * @type {number}
     * @memberof DashboardanalyticspbProductCountryReturnRate
     */
    'return_rate'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbProductCountryReturnRateResponse
 */
export interface DashboardanalyticspbProductCountryReturnRateResponse {
    /**
     * return rate of the product per shipping country, sorted by items sold
     * @type {Array<DashboardanalyticspbProductCountryReturnRate>}
     * @memberof DashboardanalyticspbProductCountryReturnRateResponse
     */
    'country_return_rates'?: Array<DashboardanalyticspbProductCountryReturnRate>;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbProductDetailAnalytics
 */
export interface DashboardanalyticspbProductDetailAnalytics {
    /**
     * List of analyzed products.
     * @type {DashboardanalyticspbAnalyzedProduct}
     * @memberof DashboardanalyticspbProductDetailAnalytics
     */
    'product'?: DashboardanalyticspbAnalyzedProduct;
    /**
     * List of processes associated with the product
     * @type {Array<DashboardanalyticspbProductProcesses>}
     * @memberof DashboardanalyticspbProductDetailAnalytics
     */
    'product_processes'?: Array<DashboardanalyticspbProductProcesses>;
    /**
     * List of reasons for product returns.
     * @type {Array<DashboardanalyticspbReason>}
     * @memberof DashboardanalyticspbProductDetailAnalytics
     */
    'reasons'?: Array<DashboardanalyticspbReason>;
    /**
     * List of number of returns per day for the product.
     * @type {Array<DashboardanalyticspbReturnCountPerDay>}
     * @memberof DashboardanalyticspbProductDetailAnalytics
     */
    'return_count_per_days'?: Array<DashboardanalyticspbReturnCountPerDay>;
    /**
     * List of variants and returned items by variant
     * @type {Array<DashboardanalyticspbVariantBreakdowns>}
     * @memberof DashboardanalyticspbProductDetailAnalytics
     */
    'variant_breakdowns'?: Array<DashboardanalyticspbVariantBreakdowns>;
}
/**
 * Payload for the ProductDetailView response
 * @export
 * @interface DashboardanalyticspbProductDetailViewResponse
 */
export interface DashboardanalyticspbProductDetailViewResponse {
    /**
     * Product analytics data for the given ecommerce and time range.
     * @type {DashboardanalyticspbProductDetailAnalytics}
     * @memberof DashboardanalyticspbProductDetailViewResponse
     */
    'product_analytics'?: DashboardanalyticspbProductDetailAnalytics;
}
/**
 * Payload for the ProductMainView response
 * @export
 * @interface DashboardanalyticspbProductMainViewResponse
 */
export interface DashboardanalyticspbProductMainViewResponse {
    /**
     * Product analytics data for the given ecommerce and time range
     * @type {DashboardanalyticspbProductAnalytics}
     * @memberof DashboardanalyticspbProductMainViewResponse
     */
    'product_analytics'?: DashboardanalyticspbProductAnalytics;
}
/**
 * Message that represents a process associated with a product.
 * @export
 * @interface DashboardanalyticspbProductProcesses
 */
export interface DashboardanalyticspbProductProcesses {
    /**
     * Customer printed order ID.
     * @type {string}
     * @memberof DashboardanalyticspbProductProcesses
     */
    'customer_printed_order_id'?: string;
    /**
     * ID of the process.
     * @type {string}
     * @memberof DashboardanalyticspbProductProcesses
     */
    'process_id'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof DashboardanalyticspbProductProcesses
     */
    'quantity'?: number;
    /**
     * Reason
     * @type {string}
     * @memberof DashboardanalyticspbProductProcesses
     */
    'reason'?: string;
    /**
     * Created at date of the process.
     * @type {string}
     * @memberof DashboardanalyticspbProductProcesses
     */
    'started'?: string;
    /**
     * Variant name
     * @type {string}
     * @memberof DashboardanalyticspbProductProcesses
     */
    'variant_name'?: string;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbProductReturnRateResponse
 */
export interface DashboardanalyticspbProductReturnRateResponse {
    /**
     * return rate by product aggregated by month
     * @type {Array<DashboardanalyticspbAggregatedProductReturnRate>}
     * @memberof DashboardanalyticspbProductReturnRateResponse
     */
    'aggregated_product_return_rates'?: Array<DashboardanalyticspbAggregatedProductReturnRate>;
}
/**
 * Message that represents a reason for product returns.
 * @export
 * @interface DashboardanalyticspbReason
 */
export interface DashboardanalyticspbReason {
    /**
     * Number of items due to this reason.
     * @type {number}
     * @memberof DashboardanalyticspbReason
     */
    'items_count'?: number;
    /**
     * Name of the reason.
     * @type {string}
     * @memberof DashboardanalyticspbReason
     */
    'name'?: string;
    /**
     * Percentage of returns due to this reason.
     * @type {number}
     * @memberof DashboardanalyticspbReason
     */
    'percentage'?: number;
}
/**
 * Refunds types
 * @export
 * @interface DashboardanalyticspbRefundsTypes
 */
export interface DashboardanalyticspbRefundsTypes {
    /**
     * Bank transfer
     * @type {number}
     * @memberof DashboardanalyticspbRefundsTypes
     */
    'bank_transfer_refund_total'?: number;
    /**
     * Exchange
     * @type {number}
     * @memberof DashboardanalyticspbRefundsTypes
     */
    'exchange_refund_total'?: number;
    /**
     * Full exchange
     * @type {number}
     * @memberof DashboardanalyticspbRefundsTypes
     */
    'full_exchange_refund_total'?: number;
    /**
     * One on one exchange
     * @type {number}
     * @memberof DashboardanalyticspbRefundsTypes
     */
    'one_one_exchange_refund_total'?: number;
    /**
     * Original pm
     * @type {number}
     * @memberof DashboardanalyticspbRefundsTypes
     */
    'original_pm_refund_total'?: number;
    /**
     * Store credit
     * @type {number}
     * @memberof DashboardanalyticspbRefundsTypes
     */
    'store_credit_refund_total'?: number;
}
/**
 * Message that represents a number of returns per day for a product.
 * @export
 * @interface DashboardanalyticspbReturnCountPerDay
 */
export interface DashboardanalyticspbReturnCountPerDay {
    /**
     * Date of the return.
     * @type {string}
     * @memberof DashboardanalyticspbReturnCountPerDay
     */
    'date'?: string;
    /**
     * Number of returns for the product.
     * @type {number}
     * @memberof DashboardanalyticspbReturnCountPerDay
     */
    'return_count'?: number;
}
/**
 * Message that represents a return by country.
 * @export
 * @interface DashboardanalyticspbReturnCountry
 */
export interface DashboardanalyticspbReturnCountry {
    /**
     * Country
     * @type {string}
     * @memberof DashboardanalyticspbReturnCountry
     */
    'country'?: string;
    /**
     * Percentage of returns
     * @type {number}
     * @memberof DashboardanalyticspbReturnCountry
     */
    'percentage'?: number;
    /**
     * Number of returns
     * @type {number}
     * @memberof DashboardanalyticspbReturnCountry
     */
    'returns_count'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbReturnRateTableEntry
 */
export interface DashboardanalyticspbReturnRateTableEntry {
    /**
     * items returned
     * @type {number}
     * @memberof DashboardanalyticspbReturnRateTableEntry
     */
    'items_returned'?: number;
    /**
     * items sold
     * @type {number}
     * @memberof DashboardanalyticspbReturnRateTableEntry
     */
    'items_sold'?: number;
    /**
     * product id
     * @type {string}
     * @memberof DashboardanalyticspbReturnRateTableEntry
     */
    'product_id'?: string;
    /**
     * product name
     * @type {string}
     * @memberof DashboardanalyticspbReturnRateTableEntry
     */
    'product_name'?: string;
    /**
     * product reference
     * @type {string}
     * @memberof DashboardanalyticspbReturnRateTableEntry
     */
    'product_reference'?: string;
    /**
     * return rate
     * @type {number}
     * @memberof DashboardanalyticspbReturnRateTableEntry
     */
    'return_rate'?: number;
}
/**
 * 
 * @export
 * @interface DashboardanalyticspbReturnRateTableResponse
 */
export interface DashboardanalyticspbReturnRateTableResponse {
    /**
     * table entries
     * @type {Array<DashboardanalyticspbReturnRateTableEntry>}
     * @memberof DashboardanalyticspbReturnRateTableResponse
     */
    'entries'?: Array<DashboardanalyticspbReturnRateTableEntry>;
    /**
     * total entries
     * @type {number}
     * @memberof DashboardanalyticspbReturnRateTableResponse
     */
    'total_entries'?: number;
}
/**
 * Payload for the ReturnsByCountryAndProduct response
 * @export
 * @interface DashboardanalyticspbReturnsCountryProductResponse
 */
export interface DashboardanalyticspbReturnsCountryProductResponse {
    /**
     * List of returns by country
     * @type {Array<DashboardanalyticspbReturnCountry>}
     * @memberof DashboardanalyticspbReturnsCountryProductResponse
     */
    'return_countries'?: Array<DashboardanalyticspbReturnCountry>;
}
/**
 * Payload for the ReturnsByCountry response
 * @export
 * @interface DashboardanalyticspbReturnsCountryResponse
 */
export interface DashboardanalyticspbReturnsCountryResponse {
    /**
     * List of returns by country
     * @type {Array<DashboardanalyticspbReturnCountry>}
     * @memberof DashboardanalyticspbReturnsCountryResponse
     */
    'return_countries'?: Array<DashboardanalyticspbReturnCountry>;
}
/**
 * Payload for the ReturnsMainView response
 * @export
 * @interface DashboardanalyticspbReturnsMainViewResponse
 */
export interface DashboardanalyticspbReturnsMainViewResponse {
    /**
     * Currency of the ecommerce
     * @type {string}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'currency'?: string;
    /**
     * Total returned items
     * @type {number}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'items'?: number;
    /**
     * Money format
     * @type {DashboardanalyticspbMoneyFormat}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'money_format'?: DashboardanalyticspbMoneyFormat;
    /**
     * RDV total
     * @type {number}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'rdv'?: number;
    /**
     * RDV percentage
     * @type {number}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'rdv_perc'?: number;
    /**
     * Refunds types
     * @type {DashboardanalyticspbRefundsTypes}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'refunds_types'?: DashboardanalyticspbRefundsTypes;
    /**
     * Number of returns for the ecommerce and time range
     * @type {number}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'returns'?: number;
    /**
     * Yearmonth ecommerce
     * @type {string}
     * @memberof DashboardanalyticspbReturnsMainViewResponse
     */
    'yearmonth_ecommerce'?: string;
}
/**
 * One portal of the caller\'s group, with the flags the analytics UI needs to  render a selector without reimplementing the eligibility rules server-side.
 * @export
 * @interface DashboardanalyticspbScopePortal
 */
export interface DashboardanalyticspbScopePortal {
    /**
     * Portal identifier, the value to send back in ecommerce_ids.
     * @type {string}
     * @memberof DashboardanalyticspbScopePortal
     */
    'ecommerce_id'?: string;
    /**
     * Display name of the portal.
     * @type {string}
     * @memberof DashboardanalyticspbScopePortal
     */
    'ecommerce_name'?: string;
    /**
     * Whether the portal has sales rows in the requested range.
     * @type {boolean}
     * @memberof DashboardanalyticspbScopePortal
     */
    'has_sales_data'?: boolean;
    /**
     * Whether the portal counts towards return-rate denominators. Warranty,  internal and lite portals register returns but hold no orders, so including  them would inflate any rate.
     * @type {boolean}
     * @memberof DashboardanalyticspbScopePortal
     */
    'included_in_rates'?: boolean;
    /**
     * Whether the portal is one of the demo ids that return fake data.
     * @type {boolean}
     * @memberof DashboardanalyticspbScopePortal
     */
    'is_demo'?: boolean;
    /**
     * Whether the portal is enabled.
     * @type {boolean}
     * @memberof DashboardanalyticspbScopePortal
     */
    'is_enabled'?: boolean;
    /**
     * Whether the portal is a testing one.
     * @type {boolean}
     * @memberof DashboardanalyticspbScopePortal
     */
    'is_testing'?: boolean;
    /**
     * E-commerce platform (SHOPIFY, PRESTASHOP, MAGENTO_V2, ...).
     * @type {string}
     * @memberof DashboardanalyticspbScopePortal
     */
    'platform'?: string;
    /**
     * Portal use case. GARANTIA, INTERNAL and LITE register returns against orders they do  not hold.
     * @type {string}
     * @memberof DashboardanalyticspbScopePortal
     */
    'use_case'?: string;
}
/**
 * Message that represents a number of returns per variant for a product.
 * @export
 * @interface DashboardanalyticspbVariantBreakdowns
 */
export interface DashboardanalyticspbVariantBreakdowns {
    /**
     * Number of returns for the product.
     * @type {number}
     * @memberof DashboardanalyticspbVariantBreakdowns
     */
    'return_count'?: number;
    /**
     * Variant of the product.
     * @type {string}
     * @memberof DashboardanalyticspbVariantBreakdowns
     */
    'variant_name'?: string;
}
/**
 * AsyncRefundConfirmationResponse is returned on successful processing of an async refund confirmation.
 * @export
 * @interface EventspbAsyncRefundConfirmationResponse
 */
export interface EventspbAsyncRefundConfirmationResponse {
    /**
     * Literal receipt acknowledgement — always \"OK\". Confirms the webhook was received, not  that every entry in the payload resolved to a known transaction.
     * @type {string}
     * @memberof EventspbAsyncRefundConfirmationResponse
     */
    'received'?: string;
}
/**
 * CreateEventRequest contains the event data to create
 * @export
 * @interface EventspbCreateEventRequest
 */
export interface EventspbCreateEventRequest {
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventRequest
     */
    'ecommerce_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventRequest
     */
    'event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventRequest
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventRequest
     */
    'payload'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventRequest
     */
    'process_id'?: string;
}
/**
 * CreateEventResponse contains the workflow information
 * @export
 * @interface EventspbCreateEventResponse
 */
export interface EventspbCreateEventResponse {
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventResponse
     */
    'run_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateEventResponse
     */
    'workflow_id'?: string;
}
/**
 * CreateSubscriptionRequest contains the data needed to create a subscription
 * @export
 * @interface EventspbCreateSubscriptionRequest
 */
export interface EventspbCreateSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'action'?: EventspbCreateSubscriptionRequestActionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'active'?: boolean;
    /**
     * Allow filter by group. Empty matches any group; otherwise the event\'s group must be in  this list.
     * @type {Array<string>}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'allow_ecommerce_groups'?: Array<string>;
    /**
     * Allow filter by ecommerce. Empty matches any ecommerce; otherwise the event\'s ecommerce  must be in this list. Combined with allow_ecommerce_groups via AND when both are set.
     * @type {Array<string>}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'allow_ecommerce_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'config'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'cron_expression'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'event_type'?: string;
    /**
     * Ecommerce groups to exclude from delivery; meaningful when allow_ecommerce_groups is empty.
     * @type {Array<string>}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'omit_ecommerce_groups'?: Array<string>;
    /**
     * Ecommerce IDs to exclude from delivery; meaningful when allow_ecommerce_ids is empty.
     * @type {Array<string>}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'omit_ecommerce_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionRequest
     */
    'source'?: EventspbCreateSubscriptionRequestSourceEnum;
}

export const EventspbCreateSubscriptionRequestActionEnum = {
    Unspecified: 'SUBSCRIPTION_ACTION_UNSPECIFIED',
    UrlPost: 'SUBSCRIPTION_ACTION_URL_POST',
    Slack: 'SUBSCRIPTION_ACTION_SLACK',
    BoggiCreditNote: 'SUBSCRIPTION_ACTION_BOGGI_CREDIT_NOTE',
    CreateTask: 'SUBSCRIPTION_ACTION_CREATE_TASK',
    CloseTask: 'SUBSCRIPTION_ACTION_CLOSE_TASK',
    CancelTask: 'SUBSCRIPTION_ACTION_CANCEL_TASK',
    DisableWebhook: 'SUBSCRIPTION_ACTION_DISABLE_WEBHOOK',
    CreateSubscriptionTask: 'SUBSCRIPTION_ACTION_CREATE_SUBSCRIPTION_TASK',
    CloseSubscriptionTask: 'SUBSCRIPTION_ACTION_CLOSE_SUBSCRIPTION_TASK',
    CreateEscalationTask: 'SUBSCRIPTION_ACTION_CREATE_ESCALATION_TASK'
} as const;

export type EventspbCreateSubscriptionRequestActionEnum = typeof EventspbCreateSubscriptionRequestActionEnum[keyof typeof EventspbCreateSubscriptionRequestActionEnum];
export const EventspbCreateSubscriptionRequestSourceEnum = {
    Unspecified: 'SUBSCRIPTION_SOURCE_UNSPECIFIED',
    Internal: 'SUBSCRIPTION_SOURCE_INTERNAL',
    Rever: 'SUBSCRIPTION_SOURCE_REVER',
    Customer: 'SUBSCRIPTION_SOURCE_CUSTOMER'
} as const;

export type EventspbCreateSubscriptionRequestSourceEnum = typeof EventspbCreateSubscriptionRequestSourceEnum[keyof typeof EventspbCreateSubscriptionRequestSourceEnum];

/**
 * CreateSubscriptionResponse contains the created subscription information
 * @export
 * @interface EventspbCreateSubscriptionResponse
 */
export interface EventspbCreateSubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionResponse
     */
    'subscription_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbCreateSubscriptionResponse
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface EventspbDeleteSubscriptionResponse
 */
export interface EventspbDeleteSubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof EventspbDeleteSubscriptionResponse
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbDeleteSubscriptionResponse
     */
    'subscription_id'?: string;
}
/**
 * DismissEventResponse returns how many subscription deliveries were dismissed.
 * @export
 * @interface EventspbDismissEventResponse
 */
export interface EventspbDismissEventResponse {
    /**
     * 
     * @type {number}
     * @memberof EventspbDismissEventResponse
     */
    'dismissed_count'?: number;
}
/**
 * DuplicateEventRequest identifies the event to clone and re-process.
 * @export
 * @interface EventspbDuplicateEventRequest
 */
export interface EventspbDuplicateEventRequest {
    /**
     * 
     * @type {string}
     * @memberof EventspbDuplicateEventRequest
     */
    'event_id'?: string;
}
/**
 * DuplicateEventResponse returns the new event id and its workflow identifiers.
 * @export
 * @interface EventspbDuplicateEventResponse
 */
export interface EventspbDuplicateEventResponse {
    /**
     * 
     * @type {string}
     * @memberof EventspbDuplicateEventResponse
     */
    'new_event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbDuplicateEventResponse
     */
    'run_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbDuplicateEventResponse
     */
    'workflow_id'?: string;
}
/**
 * Event represents a stored event from events.events
 * @export
 * @interface EventspbEvent
 */
export interface EventspbEvent {
    /**
     * 
     * @type {string}
     * @memberof EventspbEvent
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEvent
     */
    'ecommerce_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEvent
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEvent
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEvent
     */
    'payload'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEvent
     */
    'process_id'?: string;
    /**
     * Derived from event_log: aggregated status across all subscription deliveries for this event.
     * @type {string}
     * @memberof EventspbEvent
     */
    'status'?: EventspbEventStatusEnum;
}

export const EventspbEventStatusEnum = {
    Unspecified: 'EVENT_STATUS_UNSPECIFIED',
    Pending: 'EVENT_STATUS_PENDING',
    Success: 'EVENT_STATUS_SUCCESS',
    Failed: 'EVENT_STATUS_FAILED',
    NoDeliveries: 'EVENT_STATUS_NO_DELIVERIES',
    Dismissed: 'EVENT_STATUS_DISMISSED'
} as const;

export type EventspbEventStatusEnum = typeof EventspbEventStatusEnum[keyof typeof EventspbEventStatusEnum];

/**
 * EventDetails is the custom response type for GetEventDetailsInternal: the event plus  the last event log from each subscription that has at least one log for this event.
 * @export
 * @interface EventspbEventDetails
 */
export interface EventspbEventDetails {
    /**
     * 
     * @type {EventspbEvent}
     * @memberof EventspbEventDetails
     */
    'event'?: EventspbEvent;
    /**
     * 
     * @type {Array<EventspbEventLog>}
     * @memberof EventspbEventDetails
     */
    'last_log_per_subscription'?: Array<EventspbEventLog>;
}
/**
 * 
 * @export
 * @interface EventspbEventLog
 */
export interface EventspbEventLog {
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'created_at'?: string;
    /**
     * Ecommerce the parent event belongs to (joined from the events table; empty if the parent event is absent)
     * @type {string}
     * @memberof EventspbEventLog
     */
    'ecommerce_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'event_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'id'?: string;
    /**
     * Free-form JSON metadata for action-specific data (e.g., URL_POST stores url, request  payload, response)
     * @type {string}
     * @memberof EventspbEventLog
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'payload'?: string;
    /**
     * Process the parent event belongs to (joined from the events table; empty if the parent event is absent)
     * @type {string}
     * @memberof EventspbEventLog
     */
    'process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'response_body'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'status'?: EventspbEventLogStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EventspbEventLog
     */
    'subscription_id'?: string;
}

export const EventspbEventLogStatusEnum = {
    Unspecified: 'EVENT_LOG_STATUS_UNSPECIFIED',
    Pending: 'EVENT_LOG_STATUS_PENDING',
    Success: 'EVENT_LOG_STATUS_SUCCESS',
    Failed: 'EVENT_LOG_STATUS_FAILED',
    ResendFailed: 'EVENT_LOG_STATUS_RESEND_FAILED',
    Dismissed: 'EVENT_LOG_STATUS_DISMISSED'
} as const;

export type EventspbEventLogStatusEnum = typeof EventspbEventLogStatusEnum[keyof typeof EventspbEventLogStatusEnum];

/**
 * FailingSubscriptionDelivery identifies one (event, subscription) pair whose latest delivery  is currently FAILED, with enough context to raise a task for it without a further lookup.
 * @export
 * @interface EventspbFailingSubscriptionDelivery
 */
export interface EventspbFailingSubscriptionDelivery {
    /**
     * Ecommerce the event relates to, if any.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'ecommerce_id'?: string;
    /**
     * ID of the failing event.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'event_id'?: string;
    /**
     * The parent event payload\'s \"source\", empty when it carries none. Lets a caller reproduce the  live pipeline\'s loop guard: an ON_TASK_CREATED failure for an EVENTS-sourced task raises nothing.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'event_source'?: string;
    /**
     * Type of the failing event (e.g. ORDER_CREATED).
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'event_type'?: string;
    /**
     * Timestamp of the most recent delivery attempt, i.e. when this pair last became/stayed FAILED.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'last_attempt_at'?: string;
    /**
     * Return process the event relates to, if any.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'process_id'?: string;
    /**
     * Action the subscription would have performed (e.g. URL_POST, CREATE_SUBSCRIPTION_TASK).
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'subscription_action'?: string;
    /**
     * ID of the subscription that failed to deliver the event.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'subscription_id'?: string;
    /**
     * The failing subscription\'s own source (INTERNAL/REVER/CUSTOMER). Callers raising tasks from  this list should scope to INTERNAL, matching what the live pipeline raises tasks for.
     * @type {string}
     * @memberof EventspbFailingSubscriptionDelivery
     */
    'subscription_source'?: string;
}
/**
 * 
 * @export
 * @interface EventspbFindEventLogsResponse
 */
export interface EventspbFindEventLogsResponse {
    /**
     * 
     * @type {Array<EventspbEventLog>}
     * @memberof EventspbFindEventLogsResponse
     */
    'logs'?: Array<EventspbEventLog>;
    /**
     * 
     * @type {number}
     * @memberof EventspbFindEventLogsResponse
     */
    'next_page_token'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventspbFindEventLogsResponse
     */
    'total_records'?: number;
}
/**
 * GetEventDetailsResponse returns the event details (event + last log per subscription).
 * @export
 * @interface EventspbGetEventDetailsResponse
 */
export interface EventspbGetEventDetailsResponse {
    /**
     * 
     * @type {EventspbEventDetails}
     * @memberof EventspbGetEventDetailsResponse
     */
    'event_details'?: EventspbEventDetails;
}
/**
 * 
 * @export
 * @interface EventspbGetEventLogsResponse
 */
export interface EventspbGetEventLogsResponse {
    /**
     * 
     * @type {Array<EventspbEventLog>}
     * @memberof EventspbGetEventLogsResponse
     */
    'logs'?: Array<EventspbEventLog>;
    /**
     * 
     * @type {number}
     * @memberof EventspbGetEventLogsResponse
     */
    'next_page_token'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventspbGetEventLogsResponse
     */
    'total_records'?: number;
}
/**
 * GetEventTypesResponse returns the distinct event types, sorted ascending.
 * @export
 * @interface EventspbGetEventTypesResponse
 */
export interface EventspbGetEventTypesResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof EventspbGetEventTypesResponse
     */
    'event_types'?: Array<string>;
}
/**
 * GetEventsResponse returns the list of matching events with pagination
 * @export
 * @interface EventspbGetEventsResponse
 */
export interface EventspbGetEventsResponse {
    /**
     * 
     * @type {Array<EventspbEvent>}
     * @memberof EventspbGetEventsResponse
     */
    'events'?: Array<EventspbEvent>;
    /**
     * 
     * @type {number}
     * @memberof EventspbGetEventsResponse
     */
    'next_page_token'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventspbGetEventsResponse
     */
    'total_records'?: number;
}
/**
 * GetSubscriptionsResponse returns the list of matching subscriptions with pagination
 * @export
 * @interface EventspbGetSubscriptionsResponse
 */
export interface EventspbGetSubscriptionsResponse {
    /**
     * 
     * @type {number}
     * @memberof EventspbGetSubscriptionsResponse
     */
    'next_page_token'?: number;
    /**
     * 
     * @type {Array<EventspbSubscriptionItem>}
     * @memberof EventspbGetSubscriptionsResponse
     */
    'subscriptions'?: Array<EventspbSubscriptionItem>;
    /**
     * 
     * @type {number}
     * @memberof EventspbGetSubscriptionsResponse
     */
    'total_records'?: number;
}
/**
 * ListFailingSubscriptionDeliveriesResponse is one page of currently-failing deliveries.
 * @export
 * @interface EventspbListFailingSubscriptionDeliveriesResponse
 */
export interface EventspbListFailingSubscriptionDeliveriesResponse {
    /**
     * The (event, subscription) pairs on this page.
     * @type {Array<EventspbFailingSubscriptionDelivery>}
     * @memberof EventspbListFailingSubscriptionDeliveriesResponse
     */
    'deliveries'?: Array<EventspbFailingSubscriptionDelivery>;
    /**
     * Offset of the next page, or -1 when this is the last one.
     * @type {number}
     * @memberof EventspbListFailingSubscriptionDeliveriesResponse
     */
    'next_page_token'?: number;
    /**
     * Total failing deliveries across all pages.
     * @type {number}
     * @memberof EventspbListFailingSubscriptionDeliveriesResponse
     */
    'total_records'?: number;
}
/**
 * OmitList wraps a repeated string so the absence of the field can be distinguished from  an explicit empty list (used by UpdateSubscriptionRequest to clear an omit list).
 * @export
 * @interface EventspbOmitList
 */
export interface EventspbOmitList {
    /**
     * 
     * @type {Array<string>}
     * @memberof EventspbOmitList
     */
    'values'?: Array<string>;
}
/**
 * ReExecuteSubscriptionResponse returns the resulting re-send status (SUCCESS or RESEND_FAILED).
 * @export
 * @interface EventspbReExecuteSubscriptionResponse
 */
export interface EventspbReExecuteSubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof EventspbReExecuteSubscriptionResponse
     */
    'status'?: EventspbReExecuteSubscriptionResponseStatusEnum;
}

export const EventspbReExecuteSubscriptionResponseStatusEnum = {
    Unspecified: 'EVENT_LOG_STATUS_UNSPECIFIED',
    Pending: 'EVENT_LOG_STATUS_PENDING',
    Success: 'EVENT_LOG_STATUS_SUCCESS',
    Failed: 'EVENT_LOG_STATUS_FAILED',
    ResendFailed: 'EVENT_LOG_STATUS_RESEND_FAILED',
    Dismissed: 'EVENT_LOG_STATUS_DISMISSED'
} as const;

export type EventspbReExecuteSubscriptionResponseStatusEnum = typeof EventspbReExecuteSubscriptionResponseStatusEnum[keyof typeof EventspbReExecuteSubscriptionResponseStatusEnum];

/**
 * StringList wraps a repeated string so the absence of the field can be distinguished from  an explicit empty list (used by UpdateSubscriptionRequest to clear an allow list).
 * @export
 * @interface EventspbStringList
 */
export interface EventspbStringList {
    /**
     * 
     * @type {Array<string>}
     * @memberof EventspbStringList
     */
    'values'?: Array<string>;
}
/**
 * SubscriptionItem represents a subscription in list responses
 * @export
 * @interface EventspbSubscriptionItem
 */
export interface EventspbSubscriptionItem {
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'action'?: EventspbSubscriptionItemActionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EventspbSubscriptionItem
     */
    'active'?: boolean;
    /**
     * Allow filter by group; empty matches any group.
     * @type {Array<string>}
     * @memberof EventspbSubscriptionItem
     */
    'allow_ecommerce_groups'?: Array<string>;
    /**
     * Allow filter by ecommerce; empty matches any ecommerce.
     * @type {Array<string>}
     * @memberof EventspbSubscriptionItem
     */
    'allow_ecommerce_ids'?: Array<string>;
    /**
     * JSON string containing action-specific configuration
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'config'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'event_type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventspbSubscriptionItem
     */
    'omit_ecommerce_groups'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventspbSubscriptionItem
     */
    'omit_ecommerce_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'source'?: EventspbSubscriptionItemSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'subscription_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbSubscriptionItem
     */
    'updated_at'?: string;
}

export const EventspbSubscriptionItemActionEnum = {
    Unspecified: 'SUBSCRIPTION_ACTION_UNSPECIFIED',
    UrlPost: 'SUBSCRIPTION_ACTION_URL_POST',
    Slack: 'SUBSCRIPTION_ACTION_SLACK',
    BoggiCreditNote: 'SUBSCRIPTION_ACTION_BOGGI_CREDIT_NOTE',
    CreateTask: 'SUBSCRIPTION_ACTION_CREATE_TASK',
    CloseTask: 'SUBSCRIPTION_ACTION_CLOSE_TASK',
    CancelTask: 'SUBSCRIPTION_ACTION_CANCEL_TASK',
    DisableWebhook: 'SUBSCRIPTION_ACTION_DISABLE_WEBHOOK',
    CreateSubscriptionTask: 'SUBSCRIPTION_ACTION_CREATE_SUBSCRIPTION_TASK',
    CloseSubscriptionTask: 'SUBSCRIPTION_ACTION_CLOSE_SUBSCRIPTION_TASK',
    CreateEscalationTask: 'SUBSCRIPTION_ACTION_CREATE_ESCALATION_TASK'
} as const;

export type EventspbSubscriptionItemActionEnum = typeof EventspbSubscriptionItemActionEnum[keyof typeof EventspbSubscriptionItemActionEnum];
export const EventspbSubscriptionItemSourceEnum = {
    Unspecified: 'SUBSCRIPTION_SOURCE_UNSPECIFIED',
    Internal: 'SUBSCRIPTION_SOURCE_INTERNAL',
    Rever: 'SUBSCRIPTION_SOURCE_REVER',
    Customer: 'SUBSCRIPTION_SOURCE_CUSTOMER'
} as const;

export type EventspbSubscriptionItemSourceEnum = typeof EventspbSubscriptionItemSourceEnum[keyof typeof EventspbSubscriptionItemSourceEnum];

/**
 * UpdateSubscriptionRequest contains the data needed to update a subscription
 * @export
 * @interface EventspbUpdateSubscriptionRequest
 */
export interface EventspbUpdateSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'action_id'?: EventspbUpdateSubscriptionRequestActionIdEnum;
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'action_prms'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'active'?: boolean;
    /**
     * When set, replaces the allow_ecommerce_groups list (empty values clears it, making the  subscription match any group). nil leaves it unchanged.
     * @type {EventspbStringList}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'allow_ecommerce_groups'?: EventspbStringList;
    /**
     * When set, replaces the allow_ecommerce_ids list (empty values clears it, making the  subscription match any ecommerce). nil leaves it unchanged.
     * @type {EventspbStringList}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'allow_ecommerce_ids'?: EventspbStringList;
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'cron_expression'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'logging_enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'logging_retention_days'?: number;
    /**
     * When set, replaces the omit_ecommerce_groups list (empty values clears it). nil leaves  it unchanged.
     * @type {EventspbOmitList}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'omit_ecommerce_groups'?: EventspbOmitList;
    /**
     * When set, replaces the omit_ecommerce_ids list (empty values clears it). nil leaves  it unchanged.
     * @type {EventspbOmitList}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'omit_ecommerce_ids'?: EventspbOmitList;
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionRequest
     */
    'subscription_id'?: string;
}

export const EventspbUpdateSubscriptionRequestActionIdEnum = {
    Unspecified: 'SUBSCRIPTION_ACTION_UNSPECIFIED',
    UrlPost: 'SUBSCRIPTION_ACTION_URL_POST',
    Slack: 'SUBSCRIPTION_ACTION_SLACK',
    BoggiCreditNote: 'SUBSCRIPTION_ACTION_BOGGI_CREDIT_NOTE',
    CreateTask: 'SUBSCRIPTION_ACTION_CREATE_TASK',
    CloseTask: 'SUBSCRIPTION_ACTION_CLOSE_TASK',
    CancelTask: 'SUBSCRIPTION_ACTION_CANCEL_TASK',
    DisableWebhook: 'SUBSCRIPTION_ACTION_DISABLE_WEBHOOK',
    CreateSubscriptionTask: 'SUBSCRIPTION_ACTION_CREATE_SUBSCRIPTION_TASK',
    CloseSubscriptionTask: 'SUBSCRIPTION_ACTION_CLOSE_SUBSCRIPTION_TASK',
    CreateEscalationTask: 'SUBSCRIPTION_ACTION_CREATE_ESCALATION_TASK'
} as const;

export type EventspbUpdateSubscriptionRequestActionIdEnum = typeof EventspbUpdateSubscriptionRequestActionIdEnum[keyof typeof EventspbUpdateSubscriptionRequestActionIdEnum];

/**
 * UpdateSubscriptionResponse contains the updated subscription information
 * @export
 * @interface EventspbUpdateSubscriptionResponse
 */
export interface EventspbUpdateSubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionResponse
     */
    'subscription_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventspbUpdateSubscriptionResponse
     */
    'updated_at'?: string;
}
/**
 * Contains an arbitrary serialized message along with a @type that describes the type of the serialized message.
 * @export
 * @interface GoogleProtobufAny
 */
export interface GoogleProtobufAny {
    [key: string]: any;

    /**
     * The type of the serialized message.
     * @type {string}
     * @memberof GoogleProtobufAny
     */
    '@type'?: string;
}
/**
 * The `Status` type defines a logical error model that is suitable for different programming environments, including REST APIs and RPC APIs. It is used by [gRPC](https://github.com/grpc). Each `Status` message contains three pieces of data: error code, error message, and error details. You can find out more about this error model and how to work with it in the [API Design Guide](https://cloud.google.com/apis/design/errors).
 * @export
 * @interface GoogleRpcStatus
 */
export interface GoogleRpcStatus {
    /**
     * The status code, which should be an enum value of [google.rpc.Code][google.rpc.Code].
     * @type {number}
     * @memberof GoogleRpcStatus
     */
    'code'?: number;
    /**
     * A list of messages that carry the error details.  There is a common set of message types for APIs to use.
     * @type {Array<GoogleProtobufAny>}
     * @memberof GoogleRpcStatus
     */
    'details'?: Array<GoogleProtobufAny>;
    /**
     * A developer-facing error message, which should be in English. Any user-facing error message should be localized and sent in the [google.rpc.Status.details][google.rpc.Status.details] field, or localized by the client.
     * @type {string}
     * @memberof GoogleRpcStatus
     */
    'message'?: string;
}
/**
 * Payload for the GenerateFileUploadURLRequest request
 * @export
 * @interface InditexpbGenerateFileUploadURLRequest
 */
export interface InditexpbGenerateFileUploadURLRequest {
    /**
     * date of the day of the orders to upload
     * @type {string}
     * @memberof InditexpbGenerateFileUploadURLRequest
     */
    'date'?: string;
    /**
     * type of the file
     * @type {string}
     * @memberof InditexpbGenerateFileUploadURLRequest
     */
    'file_entity'?: string;
    /**
     * group_id of the group
     * @type {string}
     * @memberof InditexpbGenerateFileUploadURLRequest
     */
    'group_id'?: string;
}
/**
 * Payload for the GenerateFileUploadURLResponse response
 * @export
 * @interface InditexpbGenerateFileUploadURLResponse
 */
export interface InditexpbGenerateFileUploadURLResponse {
    /**
     * upload_url of the file
     * @type {string}
     * @memberof InditexpbGenerateFileUploadURLResponse
     */
    'upload_url'?: string;
}
/**
 * Generic address used in many scenarios
 * @export
 * @interface IntegrationAddress
 */
export interface IntegrationAddress {
    /**
     * Main address line. Usually the street and number. Should not be larger than 15 characters
     * @type {string}
     * @memberof IntegrationAddress
     */
    'address_line_1': string;
    /**
     * Secondary address line. Usually the floor, door, etc. Should not be larger than 15 characters
     * @type {string}
     * @memberof IntegrationAddress
     */
    'address_line_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'company'?: string;
    /**
     * The name of the country as it is usually used in the language of the e-commerce
     * @type {string}
     * @memberof IntegrationAddress
     */
    'country': string;
    /**
     * the 2-letter country code (alpha-2) from the ISO 3166
     * @type {string}
     * @memberof IntegrationAddress
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'postcode': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationAddress
     */
    'state_province'?: string;
}
/**
 * A category from the e-commerce catalog. It can be used to filter products or decide if a product is returnable or not.
 * @export
 * @interface IntegrationCategory
 */
export interface IntegrationCategory {
    /**
     * 
     * @type {string}
     * @memberof IntegrationCategory
     */
    'id': string;
}
/**
 * Customer associated to the order
 * @export
 * @interface IntegrationCustomer
 */
export interface IntegrationCustomer {
    /**
     * Email address of the customer. This field will be used to match the customer when starting a return process 
     * @type {string}
     * @memberof IntegrationCustomer
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCustomer
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCustomer
     */
    'last_name'?: string;
    /**
     * two-letter code as per the ISO 639-1 codes, preferred by the customer 
     * @type {string}
     * @memberof IntegrationCustomer
     */
    'preferred_lang'?: string;
}
/**
 * Line item fulfilled in an order
 * @export
 * @interface IntegrationFulfillment
 */
export interface IntegrationFulfillment {
    /**
     * ID of the line item being fulfilled. Must exist in the `line_items` array of the order.
     * @type {string}
     * @memberof IntegrationFulfillment
     */
    'line_item_id': string;
    /**
     * Number of products fulfilled. The sum of quantities per `line_item_id` must match the total quantity of the line item.
     * @type {number}
     * @memberof IntegrationFulfillment
     */
    'quantity': number;
}
/**
 * Represents either an item or a group of items in an order that are to be fulfilled from the same location.  There can be more than one fulfillment order for an order at a given location 
 * @export
 * @interface IntegrationFulfillmentOrder
 */
export interface IntegrationFulfillmentOrder {
    /**
     * Date when the fulfillment was executed 
     * @type {string}
     * @memberof IntegrationFulfillmentOrder
     */
    'date': string;
    /**
     * Information of the `line_items` fulfilled in this order  
     * @type {Array<IntegrationFulfillment>}
     * @memberof IntegrationFulfillmentOrder
     */
    'fulfillments': Array<IntegrationFulfillment>;
    /**
     * An identifier of the e-commerce location that shipped the items in this fulfillment order. 
     * @type {string}
     * @memberof IntegrationFulfillmentOrder
     */
    'location_id': string;
}
/**
 * Extended data for identifying an order in any e-commerce
 * @export
 * @interface IntegrationIdentification
 */
export interface IntegrationIdentification {
    /**
     * This is the `order_id` as seen by the customer (for example, in the email confirmation) 
     * @type {string}
     * @memberof IntegrationIdentification
     */
    'customer_printed_order_id': string;
    /**
     * Unique identifier in the origin platform. Might not be customer-friendly. It can be the same as the `customer_printed_order_id``
     * @type {string}
     * @memberof IntegrationIdentification
     */
    'id'?: string;
}
/**
 * An image from the e-commerce catalog
 * @export
 * @interface IntegrationImage
 */
export interface IntegrationImage {
    /**
     * Image alternative text
     * @type {string}
     * @memberof IntegrationImage
     */
    'alt'?: string;
    /**
     * Image name
     * @type {string}
     * @memberof IntegrationImage
     */
    'name'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof IntegrationImage
     */
    'src': string;
}
/**
 * One of the line items from the Order. Consist of a quantity of a product or a product variant, with the associated price, taxes and discounts. For the properties of the item sold, the property `product` should be used. If the item sold is a variant of a product, the property `variant` should be filled additionally, with the variant information, and the properties in there will override the properties in the `product` object. 
 * @export
 * @interface IntegrationLineItem
 */
export interface IntegrationLineItem {
    /**
     * Optional customer comments/notes for the line item
     * @type {string}
     * @memberof IntegrationLineItem
     */
    'comment'?: string;
    /**
     * Id of the line item in the source platform. Must be unique within the order.
     * @type {string}
     * @memberof IntegrationLineItem
     */
    'id': string;
    /**
     * Name of the line item (not necessarily the name of the product). If possible, in the customer `preferred_lang`
     * @type {string}
     * @memberof IntegrationLineItem
     */
    'name': string;
    /**
     * 
     * @type {IntegrationProduct}
     * @memberof IntegrationLineItem
     */
    'product': IntegrationProduct;
    /**
     * number of items of the same product and variant
     * @type {number}
     * @memberof IntegrationLineItem
     */
    'quantity': number;
    /**
     * sub total amount of the line before discounts and taxes `subtotal = unit_price * quantity`
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationLineItem
     */
    'subtotal': IntegrationMultiMoney;
    /**
     * total amount of the line including discounts and taxes total = (subtotal - total_discounts) + total_taxes this is going to be the amount to be refunded (multiplied by items_returned/quantity)
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationLineItem
     */
    'total': IntegrationMultiMoney;
    /**
     * total amount of discounts applied to this line item. Each item of this line item has a proportional discount.
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationLineItem
     */
    'total_discounts': IntegrationMultiMoney;
    /**
     * total amount of taxes for this line. Each item of this line item has proportional taxes.
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationLineItem
     */
    'total_taxes': IntegrationMultiMoney;
    /**
     * unit price of a single item (product as listed, no discounts, no taxes, quantity = 1)
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationLineItem
     */
    'unit_price': IntegrationMultiMoney;
    /**
     * Variant ID of the product. The same Product ID can have different variants but they  must be listed in a different line item. A Variant can be the size: S, M, L, XL, etc. Only one variant ia allowed at the moment (one dimension). The `variant_id` must exist in the `variants` array of the `product` object.
     * @type {string}
     * @memberof IntegrationLineItem
     */
    'variant_id'?: string;
    /**
     * Name of the variant, in the customer preferred language
     * @type {string}
     * @memberof IntegrationLineItem
     */
    'variant_name'?: string;
    /**
     * weight for products from the order, measured in grams
     * @type {number}
     * @memberof IntegrationLineItem
     */
    'weight'?: number;
}
/**
 * Model for an amount plus the currency in which it is expressed. 
 * @export
 * @interface IntegrationMoney
 */
export interface IntegrationMoney {
    /**
     * amount (optionally with decimals), without currency symbol and thousands separator
     * @type {number}
     * @memberof IntegrationMoney
     */
    'amount': number;
    /**
     * three-letter code as ISO 4217 currency code.  Examples: EUR, USD, JPY, GBP... The currency must be supported by REVER. 
     * @type {string}
     * @memberof IntegrationMoney
     */
    'currency': string;
}
/**
 * An amount that is expressed in two currencies: the shop and the customer one. They can be the same or not. 
 * @export
 * @interface IntegrationMultiMoney
 */
export interface IntegrationMultiMoney {
    /**
     * Amount in the customer currency.  Used as the amount + currency that the customer is really going to use for paying, the currency that the customer selected in the website. Usually, this comes from applying a conversion rate to the shop currency.  
     * @type {IntegrationMoney}
     * @memberof IntegrationMultiMoney
     */
    'amount_customer': IntegrationMoney;
    /**
     * Amount in the shop currency.  Useful for accounting purposes, to provide reporting in this currency.  Usually, the shop currency is the same for every order within the e-commerce. 
     * @type {IntegrationMoney}
     * @memberof IntegrationMultiMoney
     */
    'amount_shop': IntegrationMoney;
}
/**
 * Note (text) associated to an order
 * @export
 * @interface IntegrationNote
 */
export interface IntegrationNote {
    /**
     * Date when the note was added to the order 
     * @type {string}
     * @memberof IntegrationNote
     */
    'date': string;
    /**
     * Arbitrary text associated to the order 
     * @type {string}
     * @memberof IntegrationNote
     */
    'text': string;
    /**
     * User that added the note. Can be the customer or a third-party, like REVER. This is optional, but it\'s recommended. Integrators can guess the name of the app through the usage of the API key. 
     * @type {string}
     * @memberof IntegrationNote
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface IntegrationOption
 */
export interface IntegrationOption {
    /**
     * Name of the option
     * @type {string}
     * @memberof IntegrationOption
     */
    'name': string;
    /**
     * Value of the option
     * @type {string}
     * @memberof IntegrationOption
     */
    'value': string;
}
/**
 * Model for an Order returned by a custom integration. REVER supports multi-currency with the following restrictions:    * the shop currency must be the same for every order within the same e-commerce   * there must be only one customer currency per order (it can be the same or not than the shop currency)  In addition, discounts are supported as pre-tax calculations.  Gift cards are not considered discounts but a payment method. 
 * @export
 * @interface IntegrationOrder
 */
export interface IntegrationOrder {
    /**
     * Address for invoicing (not shipping, though it can be the same) 
     * @type {IntegrationAddress}
     * @memberof IntegrationOrder
     */
    'billing_address': IntegrationAddress;
    /**
     * 
     * @type {IntegrationCustomer}
     * @memberof IntegrationOrder
     */
    'customer': IntegrationCustomer;
    /**
     * Date when the Order was created in the e-commerce 
     * @type {string}
     * @memberof IntegrationOrder
     */
    'date': string;
    /**
     * List of fulfillment orders per items or groups of items in the order. 
     * @type {Array<IntegrationFulfillmentOrder>}
     * @memberof IntegrationOrder
     */
    'fulfillment_orders': Array<IntegrationFulfillmentOrder>;
    /**
     * 
     * @type {IntegrationIdentification}
     * @memberof IntegrationOrder
     */
    'identification'?: IntegrationIdentification;
    /**
     * List of items in the order. It should only include products or services,  not shipping costs. When working with international orders, the customer currency and shop currency might be different. As REVER supports multicurrency, 2 currencies  can be specified per `line_item`. However, all of the `line_items` must have the same shop and  customer currency.  
     * @type {Array<IntegrationLineItem>}
     * @memberof IntegrationOrder
     */
    'line_items': Array<IntegrationLineItem>;
    /**
     * List of notes added to the order. The notes are ordered by date, the most recent one first. They can include orders from the customer or from other third-parties, like REVER. 
     * @type {Array<IntegrationNote>}
     * @memberof IntegrationOrder
     */
    'notes'?: Array<IntegrationNote>;
    /**
     * 
     * @type {IntegrationPayment}
     * @memberof IntegrationOrder
     */
    'payment': IntegrationPayment;
    /**
     * List of refunds already associated to the order. Optional, only if OPM is supported. 
     * @type {Array<IntegrationRefundOrder>}
     * @memberof IntegrationOrder
     */
    'refunds'?: Array<IntegrationRefundOrder>;
    /**
     * List of returns already associated to the order 
     * @type {Array<IntegrationReturnOrder>}
     * @memberof IntegrationOrder
     */
    'returns': Array<IntegrationReturnOrder>;
    /**
     * 
     * @type {IntegrationShipping}
     * @memberof IntegrationOrder
     */
    'shipping': IntegrationShipping;
    /**
     * Address to where the Order was shipped. 
     * @type {IntegrationAddress}
     * @memberof IntegrationOrder
     */
    'shipping_address': IntegrationAddress;
    /**
     * Indicates if the taxes should be displayed as included in the total amount of the order or separated 
     * @type {boolean}
     * @memberof IntegrationOrder
     */
    'taxes_included': boolean;
    /**
     * Total amount of the order, including taxes, discounts and shipping costs. Must match the sum of the `line_items`  using the shop and customer currency, plus the shipping costs. 
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationOrder
     */
    'total_amount': IntegrationMultiMoney;
    /**
     * Total taxes of the order 
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationOrder
     */
    'total_taxes': IntegrationMultiMoney;
}
/**
 * Payment information for the order
 * @export
 * @interface IntegrationPayment
 */
export interface IntegrationPayment {
    /**
     * Date when the payment for the whole order was made. This field should be present with a valid value if the order has been fully paid (not just partially). 
     * @type {string}
     * @memberof IntegrationPayment
     */
    'date': string;
    /**
     * List of transactions executed as payment for the order.  If the order is `fully_paid`, then this list should have at least one element. 
     * @type {Array<IntegrationTransaction>}
     * @memberof IntegrationPayment
     */
    'transactions': Array<IntegrationTransaction>;
}
/**
 * A product from the e-commerce catalog (enabled or not). Products that are removed from the catalog should still be available in the orders.
 * @export
 * @interface IntegrationProduct
 */
export interface IntegrationProduct {
    /**
     * 
     * @type {Array<IntegrationCategory>}
     * @memberof IntegrationProduct
     */
    'categories'?: Array<IntegrationCategory>;
    /**
     * Product description
     * @type {string}
     * @memberof IntegrationProduct
     */
    'description'?: string;
    /**
     * Unique identifier for this resource in the source platform
     * @type {string}
     * @memberof IntegrationProduct
     */
    'id': string;
    /**
     * Images associated to the product
     * @type {Array<IntegrationImage>}
     * @memberof IntegrationProduct
     */
    'images'?: Array<IntegrationImage>;
    /**
     * Optional inventory quantity. Overridden if there are variants defined. This field is not in use yet but it will be in the future for offering exchanges not based in  variants. 
     * @type {number}
     * @memberof IntegrationProduct
     */
    'inventory_quantity'?: number;
    /**
     * Product name
     * @type {string}
     * @memberof IntegrationProduct
     */
    'name': string;
    /**
     * Product short description
     * @type {string}
     * @memberof IntegrationProduct
     */
    'short_description'?: string;
    /**
     * stock-keeping unit (SKU) is a scannable bar code, most often seen printed on product labels in a retail store. Should be present if there are no variants.
     * @type {string}
     * @memberof IntegrationProduct
     */
    'sku'?: string;
    /**
     * Optional tags associated to the product. They can be used to mark it as non-returnable.
     * @type {Array<IntegrationTag>}
     * @memberof IntegrationProduct
     */
    'tags'?: Array<IntegrationTag>;
    /**
     * Price per unit of the product in the shop currency. Must be present if there are no variants. Does not include taxes nor discounts. Those will be applied later on.
     * @type {IntegrationMoney}
     * @memberof IntegrationProduct
     */
    'unit_price': IntegrationMoney;
    /**
     * All of the available product variations (if any). This is useful for offering exchanges of variants. If a `line_item`` references a variation, the attributes of the variation have to be used instead of the ones of the product
     * @type {Array<IntegrationVariant>}
     * @memberof IntegrationProduct
     */
    'variants'?: Array<IntegrationVariant>;
}
/**
 * A refund operation executed over one or more items of an order 
 * @export
 * @interface IntegrationRefund
 */
export interface IntegrationRefund {
    /**
     * ID of the line item returned. Must exist in the `line_items` array of the order.
     * @type {string}
     * @memberof IntegrationRefund
     */
    'line_item_id': string;
    /**
     * Number of products returned. The sum of quantities per `line_item_id` must match the total quantity of the line item.
     * @type {number}
     * @memberof IntegrationRefund
     */
    'quantity': number;
}
/**
 * Error response for the method CreateRefund.
 * @export
 * @interface IntegrationRefundError
 */
export interface IntegrationRefundError {
    /**
     * The error message.
     * @type {string}
     * @memberof IntegrationRefundError
     */
    'error': string;
}
/**
 * A refund operation executed over one or more items of an order.  
 * @export
 * @interface IntegrationRefundOrder
 */
export interface IntegrationRefundOrder {
    /**
     * Amount of the refund, with currency associated. Must match the customer currency given in the `Order` object 
     * @type {IntegrationMoney}
     * @memberof IntegrationRefundOrder
     */
    'amount': IntegrationMoney;
    /**
     * Date when the refund was executed 
     * @type {string}
     * @memberof IntegrationRefundOrder
     */
    'date': string;
    /**
     * An optional text associated to the refund order
     * @type {string}
     * @memberof IntegrationRefundOrder
     */
    'description'?: string;
    /**
     * Unique identifier of the refund order in the e-commerce 
     * @type {string}
     * @memberof IntegrationRefundOrder
     */
    'refund_id': string;
    /**
     * List of items refunded in this refund order 
     * @type {Array<IntegrationRefund>}
     * @memberof IntegrationRefundOrder
     */
    'refunds': Array<IntegrationRefund>;
    /**
     * Optional identifier of the gateway transaction associated (payment refund) 
     * @type {string}
     * @memberof IntegrationRefundOrder
     */
    'transaction_id'?: string;
}
/**
 * Payload for the method CreateRefund.
 * @export
 * @interface IntegrationRefundRequest
 */
export interface IntegrationRefundRequest {
    /**
     * List of items to be refunded.
     * @type {Array<IntegrationRefundRequestItem>}
     * @memberof IntegrationRefundRequest
     */
    'items': Array<IntegrationRefundRequestItem>;
}
/**
 * Items from an order being to be refunded.
 * @export
 * @interface IntegrationRefundRequestItem
 */
export interface IntegrationRefundRequestItem {
    /**
     * The total amount to be refunded for this line item.
     * @type {IntegrationMoney}
     * @memberof IntegrationRefundRequestItem
     */
    'amount': IntegrationMoney;
    /**
     * The unique identifier for the line item in the order.
     * @type {string}
     * @memberof IntegrationRefundRequestItem
     */
    'line_item_id': string;
    /**
     * The quantity of the item to be refunded.
     * @type {number}
     * @memberof IntegrationRefundRequestItem
     */
    'quantity': number;
}
/**
 * Items from an order being to be refunded.
 * @export
 * @interface IntegrationRefundResponse
 */
export interface IntegrationRefundResponse {
    /**
     * List of items to be refunded.
     * @type {Array<IntegrationRefundRequestItem>}
     * @memberof IntegrationRefundResponse
     */
    'items': Array<IntegrationRefundRequestItem>;
    /**
     * The unique identifier for the refund in the e-commerce.
     * @type {string}
     * @memberof IntegrationRefundResponse
     */
    'refund_id': string;
    /**
     * The unique identifier for the transaction in the e-commerce.
     * @type {string}
     * @memberof IntegrationRefundResponse
     */
    'transaction_id'?: string;
}
/**
 * A return operation executed over one or more items of an order. It might be in progress or successfully completed. 
 * @export
 * @interface IntegrationReturn
 */
export interface IntegrationReturn {
    /**
     * ID of the line item returned. Must exist in the `line_items` array of the order.
     * @type {string}
     * @memberof IntegrationReturn
     */
    'line_item_id': string;
    /**
     * Number of products returned. The sum of quantities per `line_item_id` must match the total quantity of the line item.
     * @type {number}
     * @memberof IntegrationReturn
     */
    'quantity': number;
    /**
     * 
     * @type {IntegrationStatus}
     * @memberof IntegrationReturn
     */
    'status': IntegrationStatus;
}
/**
 * A return operation executed over one or more items of an order. It might be in progress or successfully completed. 
 * @export
 * @interface IntegrationReturnOrder
 */
export interface IntegrationReturnOrder {
    /**
     * Date when the return was executed 
     * @type {string}
     * @memberof IntegrationReturnOrder
     */
    'date': string;
    /**
     * An optional text associated to the return order
     * @type {string}
     * @memberof IntegrationReturnOrder
     */
    'description'?: string;
    /**
     * Unique identifier of the return order 
     * @type {string}
     * @memberof IntegrationReturnOrder
     */
    'return_id': string;
    /**
     * List of items returned in this return order 
     * @type {Array<IntegrationReturn>}
     * @memberof IntegrationReturnOrder
     */
    'returns': Array<IntegrationReturn>;
}
/**
 * Payload for the method CreateReturn.
 * @export
 * @interface IntegrationReturnRequest
 */
export interface IntegrationReturnRequest {
    /**
     * List of items to mark (or unmark) as returned. Can\'t be empty.
     * @type {Array<IntegrationReturnRequestItem>}
     * @memberof IntegrationReturnRequest
     */
    'returns': Array<IntegrationReturnRequestItem>;
}
/**
 * Items from an order being marked as returned
 * @export
 * @interface IntegrationReturnRequestItem
 */
export interface IntegrationReturnRequestItem {
    /**
     * The id of the line item from the order, corresponding to the product/variant being returned List of items to mark (or unmark) as returned
     * @type {string}
     * @memberof IntegrationReturnRequestItem
     */
    'line_item_id': string;
    /**
     * Number of items from that line item being returned. It should be positive integer.
     * @type {number}
     * @memberof IntegrationReturnRequestItem
     */
    'quantity': number;
    /**
     * 
     * @type {IntegrationStatus}
     * @memberof IntegrationReturnRequestItem
     */
    'status': IntegrationStatus;
}
/**
 * Shipping information
 * @export
 * @interface IntegrationShipping
 */
export interface IntegrationShipping {
    /**
     * Total amount charged as shipping costs. Taxes are included. Can be zero. 
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationShipping
     */
    'amount': IntegrationMultiMoney;
    /**
     * Text associated to the shipping line.
     * @type {string}
     * @memberof IntegrationShipping
     */
    'description'?: string;
    /**
     * Total amount of taxes for the shipping. Included in the amount. Can be zero. 
     * @type {IntegrationMultiMoney}
     * @memberof IntegrationShipping
     */
    'taxes': IntegrationMultiMoney;
}
/**
 * 
 * @export
 * @interface IntegrationStatus
 */
export interface IntegrationStatus {
    /**
     * Status of the return which could be set to accepted, rejected or missing by the ecommerce after the review.
     * @type {string}
     * @memberof IntegrationStatus
     */
    'status'?: IntegrationStatusStatusEnum;
}

export const IntegrationStatusStatusEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Missing: 'MISSING'
} as const;

export type IntegrationStatusStatusEnum = typeof IntegrationStatusStatusEnum[keyof typeof IntegrationStatusStatusEnum];

/**
 * a tag (string) associated to one resource
 * @export
 * @interface IntegrationTag
 */
export interface IntegrationTag {
    /**
     * 
     * @type {string}
     * @memberof IntegrationTag
     */
    'name': string;
}
/**
 * Transaction executed as payment for an order
 * @export
 * @interface IntegrationTransaction
 */
export interface IntegrationTransaction {
    /**
     * Amount of the transaction, with currency associated. Must match the customer currency given in the `Order` object 
     * @type {IntegrationMoney}
     * @memberof IntegrationTransaction
     */
    'amount': IntegrationMoney;
    /**
     * Date when the transaction was executed 
     * @type {string}
     * @memberof IntegrationTransaction
     */
    'date': string;
    /**
     * Payment method used for this transaction. Any string can be returned in here, but some do have a special meaning and should have be preferred if possible:   - `manual`: the payment was made manually, outside of the e-commerce   - `cash-on-delivery`: the payment was made in cash when the order was delivered   - `bnpl`: the payment was made using a Buy Now Pay Later method   - `credit-card`: the payment was made using a credit card   - `debit-card`: the payment was made using a debit card   - `paypal`: the payment was made using PayPal   - `gift`: the payment was made using a gift card 
     * @type {string}
     * @memberof IntegrationTransaction
     */
    'payment_method_type': string;
    /**
     * Identifier of the transaction in the payment gateway 
     * @type {string}
     * @memberof IntegrationTransaction
     */
    'transaction_id': string;
}
/**
 * A variant of a product from the e-commerce catalog. It\'s the combination of one or more option values (e.g. size or size + color)
 * @export
 * @interface IntegrationVariant
 */
export interface IntegrationVariant {
    /**
     * Variant description
     * @type {string}
     * @memberof IntegrationVariant
     */
    'description'?: string;
    /**
     * If this product variant should be selectable by the customer
     * @type {boolean}
     * @memberof IntegrationVariant
     */
    'enabled': boolean;
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof IntegrationVariant
     */
    'id': string;
    /**
     * Images associated to the variant
     * @type {Array<IntegrationImage>}
     * @memberof IntegrationVariant
     */
    'images'?: Array<IntegrationImage>;
    /**
     * Optional inventory quantity. Replaces the one from the product. This information must be provided for offering exchanges based in variants. If you don\'t provide this information, it will be assumed that the variant is not available. 
     * @type {number}
     * @memberof IntegrationVariant
     */
    'inventory_quantity'?: number;
    /**
     * Name of the variant
     * @type {string}
     * @memberof IntegrationVariant
     */
    'name': string;
    /**
     * The list of options that conforms this variant
     * @type {Array<IntegrationOption>}
     * @memberof IntegrationVariant
     */
    'options': Array<IntegrationOption>;
    /**
     * Variant short description
     * @type {string}
     * @memberof IntegrationVariant
     */
    'short_description'?: string;
    /**
     * Optional unique identifier of the product as SKU. Replaces the one from the product.
     * @type {string}
     * @memberof IntegrationVariant
     */
    'sku'?: string;
    /**
     * Unit price in the shop currency. Does not include taxes nor discounts. Those will be applied later on.
     * @type {IntegrationMoney}
     * @memberof IntegrationVariant
     */
    'unit_price': IntegrationMoney;
    /**
     * weight for this product variant, measured in grams. Replaces the one from the product.
     * @type {number}
     * @memberof IntegrationVariant
     */
    'weight'?: number;
}
/**
 * Billing state of one Stripe customer
 * @export
 * @interface InvoicingapipbCustomerBillingStatus
 */
export interface InvoicingapipbCustomerBillingStatus {
    /**
     * Ecommerce group the customer invoices
     * @type {string}
     * @memberof InvoicingapipbCustomerBillingStatus
     */
    'ecommerce_group'?: string;
    /**
     * Whether the blocking rules apply to this status
     * @type {boolean}
     * @memberof InvoicingapipbCustomerBillingStatus
     */
    'managed'?: boolean;
    /**
     * Open invoices that are past their due date plus the grace period
     * @type {Array<InvoicingapipbOverdueInvoice>}
     * @memberof InvoicingapipbCustomerBillingStatus
     */
    'overdue_invoices'?: Array<InvoicingapipbOverdueInvoice>;
    /**
     * Commercial status of the group (live, blocked, churned, lost, ...)
     * @type {string}
     * @memberof InvoicingapipbCustomerBillingStatus
     */
    'status'?: string;
    /**
     * Stripe customer ID
     * @type {string}
     * @memberof InvoicingapipbCustomerBillingStatus
     */
    'stripe_customer_id'?: string;
}
/**
 * Payload for the GetInvoicedEcommerces response
 * @export
 * @interface InvoicingapipbECommerceIdResponse
 */
export interface InvoicingapipbECommerceIdResponse {
    /**
     * List of E-commerce ids
     * @type {Array<string>}
     * @memberof InvoicingapipbECommerceIdResponse
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * Payload for the GetBillingStatus response
 * @export
 * @interface InvoicingapipbGetBillingStatusResponse
 */
export interface InvoicingapipbGetBillingStatusResponse {
    /**
     * Whether the ecommerce is currently listed in the dashboard-block flag.
     * @type {boolean}
     * @memberof InvoicingapipbGetBillingStatusResponse
     */
    'blocked_in_flag'?: boolean;
    /**
     * Billing customers the ecommerce is invoiced through. Usually one.
     * @type {Array<InvoicingapipbCustomerBillingStatus>}
     * @memberof InvoicingapipbGetBillingStatusResponse
     */
    'customers'?: Array<InvoicingapipbCustomerBillingStatus>;
    /**
     * Whether the ecommerce\'s dashboard must be blocked: one of its billing customers owes an  overdue invoice and has a status the blocking rules apply to.
     * @type {boolean}
     * @memberof InvoicingapipbGetBillingStatusResponse
     */
    'should_block'?: boolean;
}
/**
 * A temporary link to one invoice document
 * @export
 * @interface InvoicingapipbGetInvoiceFileURLResponse
 */
export interface InvoicingapipbGetInvoiceFileURLResponse {
    /**
     * The url to download the document from. Expires shortly after it is issued.
     * @type {string}
     * @memberof InvoicingapipbGetInvoiceFileURLResponse
     */
    'url'?: string;
}
/**
 * Payload for the GetInvoices response
 * @export
 * @interface InvoicingapipbGetInvoicesResponse
 */
export interface InvoicingapipbGetInvoicesResponse {
    /**
     * The invoices of the e-commerce, most recent first
     * @type {Array<InvoicingapipbInvoice>}
     * @memberof InvoicingapipbGetInvoicesResponse
     */
    'invoices'?: Array<InvoicingapipbInvoice>;
}
/**
 * One invoice REVER issued to an e-commerce
 * @export
 * @interface InvoicingapipbInvoice
 */
export interface InvoicingapipbInvoice {
    /**
     * ISO-4217 code of the total
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'currency'?: string;
    /**
     * When the invoice is due, RFC-3339. Empty when it is charged automatically, which has no due  date, and on invoices that are not waiting for payment.
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'due_at'?: string;
    /**
     * Whether a processes breakdown can be downloaded for this invoice
     * @type {boolean}
     * @memberof InvoicingapipbInvoice
     */
    'has_breakdown'?: boolean;
    /**
     * Whether a supplied expenses note can be downloaded for this invoice
     * @type {boolean}
     * @memberof InvoicingapipbInvoice
     */
    'has_supplied_note'?: boolean;
    /**
     * The stripe invoice id
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'id'?: string;
    /**
     * Url of the invoice document itself, hosted by stripe. Empty while the invoice is a draft.
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'invoice_url'?: string;
    /**
     * When the invoice was issued, RFC-3339
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'issued_at'?: string;
    /**
     * The invoice number shown to the merchant. Empty while the invoice is a draft.
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'number'?: string;
    /**
     * Whether a charge was attempted and refused. Only set while the invoice is unpaid.
     * @type {boolean}
     * @memberof InvoicingapipbInvoice
     */
    'payment_failed'?: boolean;
    /**
     * Whether the bank is still settling a payment. The invoice is paid as far as the merchant is  concerned, so it is neither late nor failed.
     * @type {boolean}
     * @memberof InvoicingapipbInvoice
     */
    'payment_processing'?: boolean;
    /**
     * The billed period, as the invoicing run labels it (e.g. \"M 2026-09-01 - 2026-09-30\")
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'period'?: string;
    /**
     * Stripe status: draft, open, paid, void or uncollectible
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'status'?: string;
    /**
     * Total charged, in cents
     * @type {string}
     * @memberof InvoicingapipbInvoice
     */
    'total'?: string;
}
/**
 * An open invoice past its due date plus the grace period
 * @export
 * @interface InvoicingapipbOverdueInvoice
 */
export interface InvoicingapipbOverdueInvoice {
    /**
     * Amount left to pay, in the currency\'s minor unit
     * @type {string}
     * @memberof InvoicingapipbOverdueInvoice
     */
    'amount_remaining'?: string;
    /**
     * How the invoice is collected: charge_automatically or send_invoice
     * @type {string}
     * @memberof InvoicingapipbOverdueInvoice
     */
    'collection_method'?: string;
    /**
     * ISO 4217 currency code, lowercase
     * @type {string}
     * @memberof InvoicingapipbOverdueInvoice
     */
    'currency'?: string;
    /**
     * When the invoice became due. Unset for automatically charged invoices.
     * @type {string}
     * @memberof InvoicingapipbOverdueInvoice
     */
    'due_at'?: string;
    /**
     * When the invoice was issued
     * @type {string}
     * @memberof InvoicingapipbOverdueInvoice
     */
    'finalized_at'?: string;
    /**
     * Stripe invoice ID
     * @type {string}
     * @memberof InvoicingapipbOverdueInvoice
     */
    'id'?: string;
}
/**
 * Stripe customer portal session information
 * @export
 * @interface InvoicingapipbStripeCustomerPortalURL
 */
export interface InvoicingapipbStripeCustomerPortalURL {
    /**
     * The url to redirect the user to the stripe customer portal
     * @type {string}
     * @memberof InvoicingapipbStripeCustomerPortalURL
     */
    'stripe_url'?: string;
}
/**
 * Payload for the GetEcommerceInvoicingInfo response
 * @export
 * @interface InvoicingpbGetEcommerceInvoicingInfoResponse
 */
export interface InvoicingpbGetEcommerceInvoicingInfoResponse {
    /**
     * Account manager
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'account_manager'?: string;
    /**
     * Country
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'country'?: string;
    /**
     * Deal owner
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'deal_owner'?: string;
    /**
     * First day the ecommerce group went live on REVER (YYYY-MM-DD). Empty when  it never has.
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'first_live_date'?: string;
    /**
     * Frequency discount
     * @type {number}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'frequency_discount'?: number;
    /**
     * GTV
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'gtv'?: string;
    /**
     * Invoicing POC
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'invoicing_poc'?: string;
    /**
     * Legal address
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'legal_address'?: string;
    /**
     * Legal country
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'legal_country'?: string;
    /**
     * Legal ID
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'legal_id'?: string;
    /**
     * Legal name
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'legal_name'?: string;
    /**
     * Logistics rates tier
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'logistics_rates_tier'?: string;
    /**
     * Platform
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'platform'?: string;
    /**
     * POC mail
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'poc_mail'?: string;
    /**
     * POC name
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'poc_name'?: string;
    /**
     * POC phone
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'poc_phone'?: string;
    /**
     * Selected plan
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'selected_plan'?: string;
    /**
     * Signed date
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'signed_date'?: string;
    /**
     * Status
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'status'?: string;
    /**
     * Days of trial
     * @type {number}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'trial_days'?: number;
    /**
     * End of trial date
     * @type {string}
     * @memberof InvoicingpbGetEcommerceInvoicingInfoResponse
     */
    'trial_end_date'?: string;
}
/**
 * Payload for the GetInvoicingCopies response
 * @export
 * @interface InvoicingpbGetInvoicingCopiesResponse
 */
export interface InvoicingpbGetInvoicingCopiesResponse {
    /**
     * List of copies
     * @type {Array<InvoicingpbInvoicingCopy>}
     * @memberof InvoicingpbGetInvoicingCopiesResponse
     */
    'copies'?: Array<InvoicingpbInvoicingCopy>;
}
/**
 * Structure of an InvoicingCopy
 * @export
 * @interface InvoicingpbInvoicingCopy
 */
export interface InvoicingpbInvoicingCopy {
    /**
     * Name
     * @type {string}
     * @memberof InvoicingpbInvoicingCopy
     */
    'name'?: string;
    /**
     * Text
     * @type {string}
     * @memberof InvoicingpbInvoicingCopy
     */
    'text'?: string;
}
/**
 * AddressIssue is one field REVER\'s own format rules say the carrier would reject, found  without asking the carrier: a phone the country\'s plan cannot hold, a postcode in the  wrong shape, a street line that is only a house number. Independent of the locality  verdict that status and suggestions report.
 * @export
 * @interface LogisticsAddressIssue
 */
export interface LogisticsAddressIssue {
    /**
     * Machine-readable reason, e.g. \"phone_invalid\", \"postcode_format\", \"state_required\".
     * @type {string}
     * @memberof LogisticsAddressIssue
     */
    'code'?: string;
    /**
     * How sure the rule is that suggested_value is what the carrier wants: \"high\" is safe  to apply unattended, \"medium\" and \"low\" need a person to confirm.
     * @type {string}
     * @memberof LogisticsAddressIssue
     */
    'confidence'?: string;
    /**
     * One line saying why, for logs and task comments. Not shopper copy.
     * @type {string}
     * @memberof LogisticsAddressIssue
     */
    'detail'?: string;
    /**
     * Field the issue is about, as the address model names it: \"address_line_1\",  \"address_line_2\", \"postcode\", \"state_province_code\", \"country_code\", \"phone\",  \"email\".
     * @type {string}
     * @memberof LogisticsAddressIssue
     */
    'field'?: string;
    /**
     * The corrected value when the fix is mechanical (separators, prefixes, case, a merge  of two lines). Empty clears the field. Absent when the shopper has to retype it.
     * @type {string}
     * @memberof LogisticsAddressIssue
     */
    'suggested_value'?: string;
}
/**
 * AddressSuggestion is one correction the carrier\'s source proposes.
 * @export
 * @interface LogisticsAddressSuggestion
 */
export interface LogisticsAddressSuggestion {
    /**
     * Locality as the carrier spells it. Empty keeps the shopper\'s.
     * @type {string}
     * @memberof LogisticsAddressSuggestion
     */
    'city'?: string;
    /**
     * How sure the source is: \"high\", \"medium\" or \"low\".
     * @type {string}
     * @memberof LogisticsAddressSuggestion
     */
    'confidence'?: string;
    /**
     * Postcode. Empty keeps the shopper\'s.
     * @type {string}
     * @memberof LogisticsAddressSuggestion
     */
    'postcode'?: string;
    /**
     * Province or state code. Empty keeps the shopper\'s.
     * @type {string}
     * @memberof LogisticsAddressSuggestion
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsCancelOrderRequest
 */
export interface LogisticsCancelOrderRequest {
    /**
     * E-commerce of the process. Needed to reach a label bought on the merchant\'s  own provider account; empty skips those labels
     * @type {string}
     * @memberof LogisticsCancelOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * True when the process is closed and nothing will regenerate the label, so  a v3 return is voided too. False for a logistics reset
     * @type {boolean}
     * @memberof LogisticsCancelOrderRequest
     */
    'final'?: boolean;
    /**
     * REVER ID of the return process whose logistic order is cancelled
     * @type {string}
     * @memberof LogisticsCancelOrderRequest
     */
    'process_id'?: string;
    /**
     * Why the label is voided, for metrics: \"label_expired\" for an unused label  past its window. Empty derives it from final
     * @type {string}
     * @memberof LogisticsCancelOrderRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsCancelOrderResponse
 */
export interface LogisticsCancelOrderResponse {
    /**
     * What happened to the label: confirmed, pending, failed, not_supported,  no_order (no logistic order stored), nothing_to_cancel (an order without a  label reference) or kept (a v3 return left for a logistics reset to reuse)
     * @type {string}
     * @memberof LogisticsCancelOrderResponse
     */
    'outcome'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsCarrierInfo
 */
export interface LogisticsCarrierInfo {
    /**
     * URL of the carrier\'s drop-off point locator. Empty when none is known for the carrier
     * @type {string}
     * @memberof LogisticsCarrierInfo
     */
    'drop_off_point_url'?: string;
    /**
     * Carrier name to show the shopper (e.g. \"BRT\"). Some providers echo the requested  carrier code instead
     * @type {string}
     * @memberof LogisticsCarrierInfo
     */
    'name'?: string;
}
/**
 * ConfigurationField is one key a provider name reads from its connection.
 * @export
 * @interface LogisticsConfigurationField
 */
export interface LogisticsConfigurationField {
    /**
     * One line for operators on what the key holds.
     * @type {string}
     * @memberof LogisticsConfigurationField
     */
    'description'?: string;
    /**
     * Key inside the connection, e.g. \"contract_number\".
     * @type {string}
     * @memberof LogisticsConfigurationField
     */
    'key'?: string;
    /**
     * Where the key belongs: on the connection, on a partner contract, or on the route.
     * @type {string}
     * @memberof LogisticsConfigurationField
     */
    'kind'?: LogisticsConfigurationFieldKindEnum;
    /**
     * True when labels fail without it.
     * @type {boolean}
     * @memberof LogisticsConfigurationField
     */
    'required'?: boolean;
    /**
     * True when the value must be masked and never echoed back.
     * @type {boolean}
     * @memberof LogisticsConfigurationField
     */
    'secret'?: boolean;
}

export const LogisticsConfigurationFieldKindEnum = {
    Unspecified: 'FIELD_KIND_UNSPECIFIED',
    Credential: 'FIELD_KIND_CREDENTIAL',
    Contract: 'FIELD_KIND_CONTRACT',
    Option: 'FIELD_KIND_OPTION',
    Service: 'FIELD_KIND_SERVICE',
    AccountSetting: 'FIELD_KIND_ACCOUNT_SETTING'
} as const;

export type LogisticsConfigurationFieldKindEnum = typeof LogisticsConfigurationFieldKindEnum[keyof typeof LogisticsConfigurationFieldKindEnum];

/**
 * ConfigurationScope is the presence of one declared entry\'s keys.
 * @export
 * @interface LogisticsConfigurationScope
 */
export interface LogisticsConfigurationScope {
    /**
     * Carrier the entry is scoped to. Empty covers every carrier of the name.
     * @type {string}
     * @memberof LogisticsConfigurationScope
     */
    'carrier'?: string;
    /**
     * settings-api connection id checked.
     * @type {string}
     * @memberof LogisticsConfigurationScope
     */
    'connection'?: string;
    /**
     * Optional keys that are empty or absent.
     * @type {Array<string>}
     * @memberof LogisticsConfigurationScope
     */
    'missing_optional'?: Array<string>;
    /**
     * Required keys that are empty or absent.
     * @type {Array<string>}
     * @memberof LogisticsConfigurationScope
     */
    'missing_required'?: Array<string>;
    /**
     * Optional keys that are filled.
     * @type {Array<string>}
     * @memberof LogisticsConfigurationScope
     */
    'present_optional'?: Array<string>;
}
/**
 * 
 * @export
 * @interface LogisticsCreateLogisticOrderRequest
 */
export interface LogisticsCreateLogisticOrderRequest {
    /**
     * Carrier to be used for generating the pickup (DHL, UPS, Correos...)  kwown & available for the given provider
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'carrier'?: string;
    /**
     * Currency code (e.g. \"EUR\", \"USD\"). Falls back to EUR if empty.
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'currency'?: string;
    /**
     * Customer personal data
     * @type {ModelsCustomer}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'customer'?: ModelsCustomer;
    /**
     * Origin address of the logistic order
     * @type {ModelsAddress}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'customer_address'?: ModelsAddress;
    /**
     * ecommerce group
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce associated to this logistic order
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * Id of the original ecommerce order (if any) associated to this shipping
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'ecommerce_order_id'?: string;
    /**
     * destination address of the logistic order
     * @type {ModelsAddress}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'ecommerce_warehouse_address'?: ModelsAddress;
    /**
     * Exchange flow of the return. Some carriers vary the label by this  (e.g. CTT for Álvaro Moreno uses a different additional code on exchanges).
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'exchange_flow'?: LogisticsCreateLogisticOrderRequestExchangeFlowEnum;
    /**
     * Legal entity info for customs/importerDetails (from analytics invoicing endpoint)
     * @type {LogisticsLegalEntity}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'legal_entity'?: LogisticsLegalEntity;
    /**
     * Line items
     * @type {Array<LogisticsLogisticsLineItem>}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'line_items'?: Array<LogisticsLogisticsLineItem>;
    /**
     * Line items type used for customs/product data generation for some providers (e.g.  UPS). Example values:  - \"random\": send a single aggregated product line instead of real items  - \"real\": send one product per returned item  If empty, providers fall back to their default behavior.
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'line_items_type'?: string;
    /**
     * Id of the original order (if any) associated to this shipping  E-commerces uses this to match the original order when the  package arrives to the warehouse
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'order_number'?: string;
    /**
     * When the original order was purchased. Used to scope order lookups on  platforms that don\'t key orders by the shop\'s order number (e.g. Monta  colourfulrebel, resolved via a date-windowed Reference search).
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'order_purchased_at'?: string;
    /**
     * Carriers that shipped the original outbound order (used to flag same-carrier  returns).
     * @type {Array<string>}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'original_carriers'?: Array<string>;
    /**
     * Original tracking numbers
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'original_trackings'?: string;
    /**
     * Pick-up time ranges. Only required for return_type = PICKUP
     * @type {Array<string>}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'pickup_ranges'?: Array<LogisticsCreateLogisticOrderRequestPickupRangesEnum>;
    /**
     * Id of the return process in the source platform. Some carriers use it as  the client reference on the label (e.g. CTT for Álvaro Moreno).
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'platform_process_id'?: string;
    /**
     * Id of the process that the pickup is associated to
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'process_id'?: string;
    /**
     * Provider to be used for generating the pickup (SendCloud, OPS, etc).
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'provider'?: string;
    /**
     * Return method associated to the logistic order (PICKUP, DROP_OFF)
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'return_type'?: LogisticsCreateLogisticOrderRequestReturnTypeEnum;
    /**
     * deprecated
     * @type {LogisticsLogisticSettings}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'settings'?: LogisticsLogisticSettings;
    /**
     * VAT Number
     * @type {string}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'vat_number'?: string;
    /**
     * protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS  Weight of the total sum of packags in grams
     * @type {number}
     * @memberof LogisticsCreateLogisticOrderRequest
     */
    'weight_in_grams'?: number;
}

export const LogisticsCreateLogisticOrderRequestExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type LogisticsCreateLogisticOrderRequestExchangeFlowEnum = typeof LogisticsCreateLogisticOrderRequestExchangeFlowEnum[keyof typeof LogisticsCreateLogisticOrderRequestExchangeFlowEnum];
export const LogisticsCreateLogisticOrderRequestPickupRangesEnum = {
    NoRange: 'NO_RANGE',
    Range8To12: 'RANGE_8_TO_12',
    Range12To16: 'RANGE_12_TO_16',
    Range16To20: 'RANGE_16_TO_20'
} as const;

export type LogisticsCreateLogisticOrderRequestPickupRangesEnum = typeof LogisticsCreateLogisticOrderRequestPickupRangesEnum[keyof typeof LogisticsCreateLogisticOrderRequestPickupRangesEnum];
export const LogisticsCreateLogisticOrderRequestReturnTypeEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsCreateLogisticOrderRequestReturnTypeEnum = typeof LogisticsCreateLogisticOrderRequestReturnTypeEnum[keyof typeof LogisticsCreateLogisticOrderRequestReturnTypeEnum];

/**
 * 
 * @export
 * @interface LogisticsCreatePickupRequest
 */
export interface LogisticsCreatePickupRequest {
    /**
     * Carrier to be used for generating the pickup (DHL, UPS, Correos...)  must be available for the given provider
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'carrier'?: string;
    /**
     * Currency code of the declared value, e.g. \"EUR\"
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'currency'?: string;
    /**
     * Customer personal data
     * @type {ModelsCustomer}
     * @memberof LogisticsCreatePickupRequest
     */
    'customer'?: ModelsCustomer;
    /**
     * Total declared value of the shipment in REVER money
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'declared_value'?: string;
    /**
     * Ecommerce associated to this logistic order
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'ecommerce_id'?: string;
    /**
     * Order number shown to the customer, used as the carrier\'s own reference for  the collect. Some carriers require it.
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'order_number'?: string;
    /**
     * Address where the package is going to be picked up
     * @type {ModelsAddress}
     * @memberof LogisticsCreatePickupRequest
     */
    'pickup_address'?: ModelsAddress;
    /**
     * Preferred times for the pickup a the customer address
     * @type {Array<string>}
     * @memberof LogisticsCreatePickupRequest
     */
    'pickup_ranges'?: Array<LogisticsCreatePickupRequestPickupRangesEnum>;
    /**
     * Id of the process that the pickup is associated to
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'process_id'?: string;
    /**
     * Provider to be used for generating the pickup (SendCloud, OPS, etc).
     * @type {string}
     * @memberof LogisticsCreatePickupRequest
     */
    'provider'?: string;
    /**
     * Repickup attempt number. 0 means first pickup, >0 means repickup.  Used to bypass duplicate-pickup guards for providers like GLS  where a new collect code (tracking ID) is generated per pickup.
     * @type {number}
     * @memberof LogisticsCreatePickupRequest
     */
    'repickup_attempt'?: number;
    /**
     * deprecated
     * @type {LogisticsLogisticSettings}
     * @memberof LogisticsCreatePickupRequest
     */
    'settings'?: LogisticsLogisticSettings;
}

export const LogisticsCreatePickupRequestPickupRangesEnum = {
    NoRange: 'NO_RANGE',
    Range8To12: 'RANGE_8_TO_12',
    Range12To16: 'RANGE_12_TO_16',
    Range16To20: 'RANGE_16_TO_20'
} as const;

export type LogisticsCreatePickupRequestPickupRangesEnum = typeof LogisticsCreatePickupRequestPickupRangesEnum[keyof typeof LogisticsCreatePickupRequestPickupRangesEnum];

/**
 * Response of the CreatePickup method
 * @export
 * @interface LogisticsCreatePickupResponse
 */
export interface LogisticsCreatePickupResponse {
    /**
     * Pickup order created if any
     * @type {LogisticsPickupOrder}
     * @memberof LogisticsCreatePickupResponse
     */
    'pickup_order'?: LogisticsPickupOrder;
}
/**
 * 
 * @export
 * @interface LogisticsCreateTestLabelRequest
 */
export interface LogisticsCreateTestLabelRequest {
    /**
     * Carrier known to the provider (e.g. \"dhleconnect\", \"fedex\")
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'carrier'?: string;
    /**
     * Credential fields used for this label only and never saved, keyed as the provider\'s  credential fields in ListProviderCapabilities. Without sandbox they override the  ecommerce\'s stored values one by one
     * @type {{ [key: string]: string; }}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'credential_overrides'?: { [key: string]: string; };
    /**
     * Currency for declared values (ISO 4217). Defaults to EUR
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'currency'?: string;
    /**
     * Shopper (origin) address. Required: it fixes the lane the carrier validates
     * @type {ModelsAddress}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'customer_address'?: ModelsAddress;
    /**
     * Ecommerce whose carrier credentials (PA settings) sign the request
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'ecommerce_id'?: string;
    /**
     * Warehouse (destination) address. Defaults to REVER\'s Barcelona office
     * @type {ModelsAddress}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'ecommerce_warehouse_address'?: ModelsAddress;
    /**
     * Merchant\'s legal entity, as CreateLogisticOrderRequest.legal_entity. Unset sends none
     * @type {LogisticsLegalEntity}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'legal_entity'?: LogisticsLegalEntity;
    /**
     * Line items used for customs/commodities. Defaults to one placeholder item
     * @type {Array<LogisticsLogisticsLineItem>}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'line_items'?: Array<LogisticsLogisticsLineItem>;
    /**
     * Order number printed as the label reference. Defaults to a generated TEST-xxxxxxxx
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'order_number'?: string;
    /**
     * Outbound tracking the return reverses, as  CreateLogisticOrderRequest.original_trackings. Empty sends none
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'original_trackings'?: string;
    /**
     * Provider that generates the label (e.g. \"dhleconnect_ecommerce\", \"fedex\")
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'provider'?: string;
    /**
     * Return method to simulate. Defaults to DROP_OFF_POINT
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'return_method'?: LogisticsCreateTestLabelRequestReturnMethodEnum;
    /**
     * Sends the label to the carrier\'s sandbox, for carriers that certify accounts there.  The stored credentials are ignored: credential_overrides must hold every required  field
     * @type {boolean}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'sandbox'?: boolean;
    /**
     * Provider-specific service override, same meaning as return_logistics.service_id.  For DHL Express this is the product code, which overrides the one the route  would pick - the way to retry a lane the merchant\'s account refuses
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'service_id'?: string;
    /**
     * Merchant\'s VAT number, as CreateLogisticOrderRequest.vat_number. Empty sends none
     * @type {string}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'vat_number'?: string;
    /**
     * protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS  Parcel weight in grams. Defaults to 1000
     * @type {number}
     * @memberof LogisticsCreateTestLabelRequest
     */
    'weight_in_grams'?: number;
}

export const LogisticsCreateTestLabelRequestReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsCreateTestLabelRequestReturnMethodEnum = typeof LogisticsCreateTestLabelRequestReturnMethodEnum[keyof typeof LogisticsCreateTestLabelRequestReturnMethodEnum];

/**
 * 
 * @export
 * @interface LogisticsCreateTestLabelResponse
 */
export interface LogisticsCreateTestLabelResponse {
    /**
     * What became of the shipment once the label was captured. Providers that can  void a label do so at once, so the test shipment is never billed
     * @type {LogisticsTestLabelCancellation}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'cancellation'?: LogisticsTestLabelCancellation;
    /**
     * Carrier that generated the label
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'carrier'?: string;
    /**
     * Carrier account the shipment was booked on. Empty when the provider does  not report one, which is not the same as no account having been used
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'carrier_account'?: string;
    /**
     * Label file content (base64 over JSON)
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'label'?: string;
    /**
     * Label file extension: pdf, png or jpg
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'label_extension'?: string;
    /**
     * Short-lived presigned URL of the stored label. Empty if signing failed
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'label_url'?: string;
    /**
     * Provider that generated the label
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'provider'?: string;
    /**
     * Whether the provider treated the lane as a customs (international) shipment
     * @type {boolean}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'requires_customs'?: boolean;
    /**
     * Carrier product or service the provider asked for, e.g. DHL Express \"P\".  Empty when the provider does not report one
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'service_code'?: string;
    /**
     * Carrier tracking number of the test shipment
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'tracking_id'?: string;
    /**
     * Carrier tracking URL, when the provider builds one
     * @type {string}
     * @memberof LogisticsCreateTestLabelResponse
     */
    'tracking_url'?: string;
}
/**
 * CredentialField is one credential key a provider reads.
 * @export
 * @interface LogisticsCredentialField
 */
export interface LogisticsCredentialField {
    /**
     * What the field holds, for operators.
     * @type {string}
     * @memberof LogisticsCredentialField
     */
    'description'?: string;
    /**
     * Key as stored in the connection and sent in credential_overrides, e.g. \"client_id\".
     * @type {string}
     * @memberof LogisticsCredentialField
     */
    'key'?: string;
    /**
     * Whether the label fails without it.
     * @type {boolean}
     * @memberof LogisticsCredentialField
     */
    'required'?: boolean;
    /**
     * In sandbox mode a blank value falls back to the ecommerce\'s saved one, because the  carrier\'s sandbox shares it with production. Never true for a secret
     * @type {boolean}
     * @memberof LogisticsCredentialField
     */
    'sandbox_uses_saved'?: boolean;
    /**
     * Whether UIs must mask it.
     * @type {boolean}
     * @memberof LogisticsCredentialField
     */
    'secret'?: boolean;
}
/**
 * Package dimensions for a single unit (one piece) of a product, in  whole centimeters - i.e. the dimensions of the parcel/box the unit  ships in, not the bare product itself.   @Description Per-unit package dimensions in centimeters (parcel, not bare product)  @name api.logistics.Dimensions
 * @export
 * @interface LogisticsDimensions
 */
export interface LogisticsDimensions {
    /**
     * Package height in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof LogisticsDimensions
     */
    'height_cm'?: string;
    /**
     * Package length in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof LogisticsDimensions
     */
    'length_cm'?: string;
    /**
     * Package width in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof LogisticsDimensions
     */
    'width_cm'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsDocument
 */
export interface LogisticsDocument {
    /**
     * Kind of document: label, return instructions or delivery note
     * @type {string}
     * @memberof LogisticsDocument
     */
    'document_type'?: LogisticsDocumentDocumentTypeEnum;
    /**
     * File format of the stored document
     * @type {string}
     * @memberof LogisticsDocument
     */
    'file_extension'?: LogisticsDocumentFileExtensionEnum;
    /**
     * Storage key of the file (e.g. \"<process_id>/delivery_note_<random>.pdf\"). Pass it to  GeneratePresignedUrl to get a download URL.
     * @type {string}
     * @memberof LogisticsDocument
     */
    'path'?: string;
    /**
     * Return process the document belongs to
     * @type {string}
     * @memberof LogisticsDocument
     */
    'process_id'?: string;
}

export const LogisticsDocumentDocumentTypeEnum = {
    Unspecified: 'DOCUMENT_TYPE_UNSPECIFIED',
    Label: 'DOCUMENT_TYPE_LABEL',
    ReturnInstructions: 'DOCUMENT_TYPE_RETURN_INSTRUCTIONS',
    DeliveryNote: 'DOCUMENT_TYPE_DELIVERY_NOTE'
} as const;

export type LogisticsDocumentDocumentTypeEnum = typeof LogisticsDocumentDocumentTypeEnum[keyof typeof LogisticsDocumentDocumentTypeEnum];
export const LogisticsDocumentFileExtensionEnum = {
    Unspecified: 'DOCUMENT_EXTENSION_UNSPECIFIED',
    Pdf: 'DOCUMENT_EXTENSION_PDF',
    Png: 'DOCUMENT_EXTENSION_PNG',
    Jpg: 'DOCUMENT_EXTENSION_JPG'
} as const;

export type LogisticsDocumentFileExtensionEnum = typeof LogisticsDocumentFileExtensionEnum[keyof typeof LogisticsDocumentFileExtensionEnum];

/**
 * 
 * @export
 * @interface LogisticsFindAllDocumentsByProcessIdResponse
 */
export interface LogisticsFindAllDocumentsByProcessIdResponse {
    /**
     * List of documents
     * @type {Array<LogisticsDocument>}
     * @memberof LogisticsFindAllDocumentsByProcessIdResponse
     */
    'documents'?: Array<LogisticsDocument>;
}
/**
 * 
 * @export
 * @interface LogisticsGeneratePresignedUrlResponse
 */
export interface LogisticsGeneratePresignedUrlResponse {
    /**
     * file data (in chunks - stream)
     * @type {string}
     * @memberof LogisticsGeneratePresignedUrlResponse
     */
    'presigned_url'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsGetCarrierInfoResponse
 */
export interface LogisticsGetCarrierInfoResponse {
    /**
     * Name and drop-off point locator of the requested carrier
     * @type {LogisticsCarrierInfo}
     * @memberof LogisticsGetCarrierInfoResponse
     */
    'carrier_info'?: LogisticsCarrierInfo;
}
/**
 * 
 * @export
 * @interface LogisticsGetLogisticOrderResponse
 */
export interface LogisticsGetLogisticOrderResponse {
    /**
     * logistic order retrieved
     * @type {ModelsLogisticOrder}
     * @memberof LogisticsGetLogisticOrderResponse
     */
    'order'?: ModelsLogisticOrder;
}
/**
 * 
 * @export
 * @interface LogisticsGetParcelTrackingStatusResponse
 */
export interface LogisticsGetParcelTrackingStatusResponse {
    /**
     * Tracking status
     * @type {string}
     * @memberof LogisticsGetParcelTrackingStatusResponse
     */
    'status'?: LogisticsGetParcelTrackingStatusResponseStatusEnum;
}

export const LogisticsGetParcelTrackingStatusResponseStatusEnum = {
    NoShippingStatusUnspecified: 'LOGISTICS_SHIPPING_STATUS_NO_SHIPPING_STATUS_UNSPECIFIED',
    Created: 'LOGISTICS_SHIPPING_STATUS_CREATED',
    Collected: 'LOGISTICS_SHIPPING_STATUS_COLLECTED',
    InWarehouse: 'LOGISTICS_SHIPPING_STATUS_IN_WAREHOUSE',
    Error: 'LOGISTICS_SHIPPING_STATUS_ERROR',
    Canceled: 'LOGISTICS_SHIPPING_STATUS_CANCELED'
} as const;

export type LogisticsGetParcelTrackingStatusResponseStatusEnum = typeof LogisticsGetParcelTrackingStatusResponseStatusEnum[keyof typeof LogisticsGetParcelTrackingStatusResponseStatusEnum];

/**
 * 
 * @export
 * @interface LogisticsGetPresignedURLLabelResponse
 */
export interface LogisticsGetPresignedURLLabelResponse {
    /**
     * URL to download the label file
     * @type {string}
     * @memberof LogisticsGetPresignedURLLabelResponse
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsGetProcessInfoResponse
 */
export interface LogisticsGetProcessInfoResponse {
    /**
     * Warehouse stored for the requested process
     * @type {LogisticsProcessInfo}
     * @memberof LogisticsGetProcessInfoResponse
     */
    'process_info'?: LogisticsProcessInfo;
}
/**
 * 
 * @export
 * @interface LogisticsGetProviderConfigurationStatusRequest
 */
export interface LogisticsGetProviderConfigurationStatusRequest {
    /**
     * Merchant whose connections are checked.
     * @type {string}
     * @memberof LogisticsGetProviderConfigurationStatusRequest
     */
    'ecommerce_id'?: string;
    /**
     * Providers to report on. One report each, in this order.
     * @type {Array<LogisticsProviderQuery>}
     * @memberof LogisticsGetProviderConfigurationStatusRequest
     */
    'providers'?: Array<LogisticsProviderQuery>;
}
/**
 * 
 * @export
 * @interface LogisticsGetProviderConfigurationStatusResponse
 */
export interface LogisticsGetProviderConfigurationStatusResponse {
    /**
     * One report per requested provider name, in request order.
     * @type {Array<LogisticsProviderConfigurationReport>}
     * @memberof LogisticsGetProviderConfigurationStatusResponse
     */
    'reports'?: Array<LogisticsProviderConfigurationReport>;
}
/**
 * protolint:disable:next MESSAGE_NAMES_EXCLUDE_PREPOSITIONS
 * @export
 * @interface LogisticsGetWfpLogisticsCostResponse
 */
export interface LogisticsGetWfpLogisticsCostResponse {
    /**
     * ISO 4217 currency code of the costs (e.g. \"EUR\").
     * @type {string}
     * @memberof LogisticsGetWfpLogisticsCostResponse
     */
    'currency'?: string;
    /**
     * Customs cost in minor units (cents) of `currency`. Zero when not applicable.
     * @type {number}
     * @memberof LogisticsGetWfpLogisticsCostResponse
     */
    'customs_cost'?: number;
    /**
     * Logistics cost in minor units (cents) of `currency`.
     * @type {number}
     * @memberof LogisticsGetWfpLogisticsCostResponse
     */
    'logistics_cost'?: number;
    /**
     * Sum of logistics_cost and customs_cost in minor units (cents).
     * @type {number}
     * @memberof LogisticsGetWfpLogisticsCostResponse
     */
    'total_cost'?: number;
}
/**
 * 
 * @export
 * @interface LogisticsIsPickupAvailableRequest
 */
export interface LogisticsIsPickupAvailableRequest {
    /**
     * Carrier
     * @type {string}
     * @memberof LogisticsIsPickupAvailableRequest
     */
    'carrier'?: string;
    /**
     * Address where the package is going to be picked up
     * @type {ModelsAddress}
     * @memberof LogisticsIsPickupAvailableRequest
     */
    'pickup_address'?: ModelsAddress;
    /**
     * Provider
     * @type {string}
     * @memberof LogisticsIsPickupAvailableRequest
     */
    'provider'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsIsPickupAvailableResponse
 */
export interface LogisticsIsPickupAvailableResponse {
    /**
     * Is pickup available
     * @type {boolean}
     * @memberof LogisticsIsPickupAvailableResponse
     */
    'is_pickup_available'?: boolean;
    /**
     * Pick-up time ranges
     * @type {Array<string>}
     * @memberof LogisticsIsPickupAvailableResponse
     */
    'pickup_ranges'?: Array<LogisticsIsPickupAvailableResponsePickupRangesEnum>;
}

export const LogisticsIsPickupAvailableResponsePickupRangesEnum = {
    NoRange: 'NO_RANGE',
    Range8To12: 'RANGE_8_TO_12',
    Range12To16: 'RANGE_12_TO_16',
    Range16To20: 'RANGE_16_TO_20'
} as const;

export type LogisticsIsPickupAvailableResponsePickupRangesEnum = typeof LogisticsIsPickupAvailableResponsePickupRangesEnum[keyof typeof LogisticsIsPickupAvailableResponsePickupRangesEnum];

/**
 * 
 * @export
 * @interface LogisticsLegalEntity
 */
export interface LogisticsLegalEntity {
    /**
     * Legal address as one free-text line (e.g. \"C/ de Muntaner, 440, 08006 Barcelona\").
     * @type {string}
     * @memberof LogisticsLegalEntity
     */
    'address'?: string;
    /**
     * Merchant\'s registered legal name.
     * @type {string}
     * @memberof LogisticsLegalEntity
     */
    'company_name'?: string;
    /**
     * Country of the legal address as stored in invoicing data. May be a full name  (e.g. \"Spain\") rather than an ISO code.
     * @type {string}
     * @memberof LogisticsLegalEntity
     */
    'country'?: string;
    /**
     * Email of the merchant\'s point of contact, from invoicing data. May hold several  comma-separated addresses, or be empty.
     * @type {string}
     * @memberof LogisticsLegalEntity
     */
    'email'?: string;
    /**
     * Name of the merchant\'s point of contact, from invoicing data.
     * @type {string}
     * @memberof LogisticsLegalEntity
     */
    'full_name'?: string;
    /**
     * Phone of the merchant\'s point of contact, from invoicing data.
     * @type {string}
     * @memberof LogisticsLegalEntity
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsListProviderCapabilitiesResponse
 */
export interface LogisticsListProviderCapabilitiesResponse {
    /**
     * Every declared combination, one entry per provider + carrier + return method.
     * @type {Array<LogisticsProviderCapability>}
     * @memberof LogisticsListProviderCapabilitiesResponse
     */
    'capabilities'?: Array<LogisticsProviderCapability>;
    /**
     * The credential fields of every provider whose credentials live in an ecommerce  connection.
     * @type {Array<LogisticsProviderCredentials>}
     * @memberof LogisticsListProviderCapabilitiesResponse
     */
    'credentials'?: Array<LogisticsProviderCredentials>;
}
/**
 * 
 * @export
 * @interface LogisticsListProviderConfigurationsResponse
 */
export interface LogisticsListProviderConfigurationsResponse {
    /**
     * One entry per provider name, or per provider name and carrier when the connection  differs by carrier.
     * @type {Array<LogisticsProviderConfiguration>}
     * @memberof LogisticsListProviderConfigurationsResponse
     */
    'configurations'?: Array<LogisticsProviderConfiguration>;
}
/**
 * LogisticConfig is deprecated
 * @export
 * @interface LogisticsLogisticConfig
 */
export interface LogisticsLogisticConfig {
    /**
     * carrier
     * @type {string}
     * @memberof LogisticsLogisticConfig
     */
    'carrier'?: string;
    /**
     * provider
     * @type {string}
     * @memberof LogisticsLogisticConfig
     */
    'provider'?: string;
    /**
     * Optional carrier-specific service id override from back office.  When empty, logistics-api falls back to the carrier default service resolution.
     * @type {string}
     * @memberof LogisticsLogisticConfig
     */
    'service_id'?: string;
}
/**
 * LogisticContract model
 * @export
 * @interface LogisticsLogisticContract
 */
export interface LogisticsLogisticContract {
    /**
     * Carrier
     * @type {string}
     * @memberof LogisticsLogisticContract
     */
    'carrier'?: string;
    /**
     * ContractID
     * @type {string}
     * @memberof LogisticsLogisticContract
     */
    'contract_id'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof LogisticsLogisticContract
     */
    'ecommerce_id'?: string;
    /**
     * Provider
     * @type {string}
     * @memberof LogisticsLogisticContract
     */
    'provider'?: string;
    /**
     * True when contract_id is one of REVER\'s own Sendcloud contracts (country  overrides included), so a rule on it ships on REVER\'s contract, not the  merchant\'s. Read-only: ignored on save.
     * @type {boolean}
     * @memberof LogisticsLogisticContract
     */
    'rever_contract'?: boolean;
}
/**
 * 
 * @export
 * @interface LogisticsLogisticContractsRes
 */
export interface LogisticsLogisticContractsRes {
    /**
     * Carrier contracts stored for the requested ecommerce_id. Empty when it has none.
     * @type {Array<LogisticsLogisticContract>}
     * @memberof LogisticsLogisticContractsRes
     */
    'contracts'?: Array<LogisticsLogisticContract>;
}
/**
 * LogisticSettings is deprecated  this message is going to be removed when  the dynamic return methods are fully rolled out
 * @export
 * @interface LogisticsLogisticSettings
 */
export interface LogisticsLogisticSettings {
    /**
     * protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<LogisticsLogisticConfig>}
     * @memberof LogisticsLogisticSettings
     */
    'logistic_config'?: Array<LogisticsLogisticConfig>;
    /**
     * Return method associated to the logistic order (PICKUP, DROP_OFF)
     * @type {string}
     * @memberof LogisticsLogisticSettings
     */
    'return_method'?: LogisticsLogisticSettingsReturnMethodEnum;
}

export const LogisticsLogisticSettingsReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsLogisticSettingsReturnMethodEnum = typeof LogisticsLogisticSettingsReturnMethodEnum[keyof typeof LogisticsLogisticSettingsReturnMethodEnum];

/**
 * 
 * @export
 * @interface LogisticsLogisticsLineItem
 */
export interface LogisticsLogisticsLineItem {
    /**
     * Free-form per-unit attributes propagated from the source platform.
     * @type {object}
     * @memberof LogisticsLogisticsLineItem
     */
    'custom_attributes'?: object;
    /**
     * Per-unit physical dimensions in centimeters. Multiply by `quantity` for  parcel sizing. Optional - populated only when the source platform exposes them.
     * @type {LogisticsDimensions}
     * @memberof LogisticsLogisticsLineItem
     */
    'dimensions'?: LogisticsDimensions;
    /**
     * European Article Number / barcode. Some platforms key order lines by EAN  rather than SKU (e.g. Monta for colourfulrebel), so providers match on both.
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'ean'?: string;
    /**
     * Id of the line item in the source platform
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'id'?: string;
    /**
     * Name of the line item (not necessarily the name of the product)
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'name'?: string;
    /**
     * Return reason for this item (e.g. \"DEFECTIVE\"). Some carriers flag the  shipment based on it (e.g. CTT marks defective Álvaro Moreno returns).
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'product_return_reason'?: string;
    /**
     * number of items of the same product
     * @type {number}
     * @memberof LogisticsLogisticsLineItem
     */
    'quantity'?: number;
    /**
     * stock-keeping unit (SKU) from the source platform
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'sku'?: string;
    /**
     * sub total amount of the line before discounts and taxes
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'subtotal'?: string;
    /**
     * total amount of the line including discounts and tax
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'total'?: string;
    /**
     * total amount of taxes included in `total`. Customs paperwork declares the  value net of it: an export is not a taxable supply in the shipper\'s territory.
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'total_taxes'?: string;
    /**
     * unit price of a single item (no discounts, no taxes)
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'unit_price'?: string;
    /**
     * Per-unit weight in grams (NOT total line weight). Multiply by `quantity`  for the full line weight. Propagated from ReturnLineItem.weight.
     * @type {string}
     * @memberof LogisticsLogisticsLineItem
     */
    'weight'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsManualLogisticOrder
 */
export interface LogisticsManualLogisticOrder {
    /**
     * Carrier within the provider that was used to generate the logistic order  Example: DHL
     * @type {string}
     * @memberof LogisticsManualLogisticOrder
     */
    'carrier'?: string;
    /**
     * protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS  Origin address of the logistic order
     * @type {ModelsAddress}
     * @memberof LogisticsManualLogisticOrder
     */
    'from'?: ModelsAddress;
    /**
     * Id of the process that the logistic order is associated to
     * @type {string}
     * @memberof LogisticsManualLogisticOrder
     */
    'process_id'?: string;
    /**
     * Provider that was used to generate the logistic order  Example: OPS
     * @type {string}
     * @memberof LogisticsManualLogisticOrder
     */
    'provider'?: string;
    /**
     * Return method associated to the logistic order (PICKUP, DROP_OFF)
     * @type {string}
     * @memberof LogisticsManualLogisticOrder
     */
    'return_method'?: LogisticsManualLogisticOrderReturnMethodEnum;
    /**
     * protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS  Destination address of the logistic order
     * @type {ModelsAddress}
     * @memberof LogisticsManualLogisticOrder
     */
    'to'?: ModelsAddress;
    /**
     * Tracking ID that was generated for the logistic order
     * @type {string}
     * @memberof LogisticsManualLogisticOrder
     */
    'tracking_id'?: string;
    /**
     * Tracking URL that was generated for the logistic order
     * @type {string}
     * @memberof LogisticsManualLogisticOrder
     */
    'tracking_url'?: string;
}

export const LogisticsManualLogisticOrderReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsManualLogisticOrderReturnMethodEnum = typeof LogisticsManualLogisticOrderReturnMethodEnum[keyof typeof LogisticsManualLogisticOrderReturnMethodEnum];

/**
 * A pickup order created in the system
 * @export
 * @interface LogisticsPickupOrder
 */
export interface LogisticsPickupOrder {
    /**
     * Carrier that was used to geenrate the pickup
     * @type {string}
     * @memberof LogisticsPickupOrder
     */
    'carrier'?: string;
    /**
     * Platform specific id of the pickup
     * @type {string}
     * @memberof LogisticsPickupOrder
     */
    'id'?: string;
    /**
     * Pickup Range
     * @type {LogisticsPickupRange}
     * @memberof LogisticsPickupOrder
     */
    'pickup_range'?: LogisticsPickupRange;
    /**
     * Provider that was used to generate the pickup
     * @type {string}
     * @memberof LogisticsPickupOrder
     */
    'provider'?: string;
    /**
     * Tracking URL for the pickup. Populated for providers like GLS where  the pickup generates the tracking information.
     * @type {string}
     * @memberof LogisticsPickupOrder
     */
    'tracking_url'?: string;
    /**
     * Transaction provider to record for the pickup.
     * @type {string}
     * @memberof LogisticsPickupOrder
     */
    'transaction_provider'?: LogisticsPickupOrderTransactionProviderEnum;
}

export const LogisticsPickupOrderTransactionProviderEnum = {
    Mock: 'TXPROVIDER_MOCK',
    Woocommerce: 'TXPROVIDER_WOOCOMMERCE',
    Shopify: 'TXPROVIDER_SHOPIFY',
    CustomGeneric: 'TXPROVIDER_CUSTOM_GENERIC',
    Prestashop: 'TXPROVIDER_PRESTASHOP',
    MagentoV1: 'TXPROVIDER_MAGENTO_V1',
    MagentoV2: 'TXPROVIDER_MAGENTO_V2',
    Salesforce: 'TXPROVIDER_SALESFORCE',
    Revolut: 'TXPROVIDER_REVOLUT',
    Stripe: 'TXPROVIDER_STRIPE',
    Sendcloud: 'TXPROVIDER_SENDCLOUD',
    Correos: 'TXPROVIDER_CORREOS',
    CorreosExpress: 'TXPROVIDER_CORREOS_EXPRESS',
    ShippyPro: 'TXPROVIDER_SHIPPY_PRO',
    Ups: 'TXPROVIDER_UPS',
    Gls: 'TXPROVIDER_GLS',
    Dhl: 'TXPROVIDER_DHL',
    DhlExpress: 'TXPROVIDER_DHL_EXPRESS',
    DhlParcel: 'TXPROVIDER_DHL_PARCEL',
    Rhenus: 'TXPROVIDER_RHENUS',
    Fedex: 'TXPROVIDER_FEDEX',
    Zeleris: 'TXPROVIDER_ZELERIS',
    SendcloudEcommerce: 'TXPROVIDER_SENDCLOUD_ECOMMERCE',
    Enovo: 'TXPROVIDER_ENOVO',
    Zelo: 'TXPROVIDER_ZELO',
    Colissimo: 'TXPROVIDER_COLISSIMO',
    Ctt: 'TXPROVIDER_CTT',
    Monta: 'TXPROVIDER_MONTA',
    Brt: 'TXPROVIDER_BRT',
    Esendeo: 'TXPROVIDER_ESENDEO',
    Estafeta: 'TXPROVIDER_ESTAFETA',
    Chronopost: 'TXPROVIDER_CHRONOPOST',
    Canadapost: 'TXPROVIDER_CANADAPOST',
    Inpost: 'TXPROVIDER_INPOST',
    Packeta: 'TXPROVIDER_PACKETA',
    Dpd: 'TXPROVIDER_DPD',
    Mondialrelay: 'TXPROVIDER_MONDIALRELAY',
    Easypost: 'TXPROVIDER_EASYPOST',
    Flexport: 'TXPROVIDER_FLEXPORT',
    Tamdis: 'TXPROVIDER_TAMDIS',
    Seur: 'TXPROVIDER_SEUR',
    Cttportugal: 'TXPROVIDER_CTTPORTUGAL',
    Tnt: 'TXPROVIDER_TNT',
    Dhleconnect: 'TXPROVIDER_DHLECONNECT',
    Dhlbenelux: 'TXPROVIDER_DHLBENELUX',
    Swisspost: 'TXPROVIDER_SWISSPOST',
    Dpdportugal: 'TXPROVIDER_DPDPORTUGAL',
    Mbe: 'TXPROVIDER_MBE',
    Globale: 'TXPROVIDER_GLOBALE',
    Amphora: 'TXPROVIDER_AMPHORA',
    Dpdireland: 'TXPROVIDER_DPDIRELAND',
    Innosend: 'TXPROVIDER_INNOSEND',
    Exporto: 'TXPROVIDER_EXPORTO',
    Royalmail: 'TXPROVIDER_ROYALMAIL',
    Glsitaly: 'TXPROVIDER_GLSITALY',
    Glsczech: 'TXPROVIDER_GLSCZECH',
    Bigblue: 'TXPROVIDER_BIGBLUE',
    Myparcel: 'TXPROVIDER_MYPARCEL',
    Boardriders: 'TXPROVIDER_BOARDRIDERS',
    Glsshopreturns: 'TXPROVIDER_GLSSHOPRETURNS',
    None: 'TXPROVIDER_NONE'
} as const;

export type LogisticsPickupOrderTransactionProviderEnum = typeof LogisticsPickupOrderTransactionProviderEnum[keyof typeof LogisticsPickupOrderTransactionProviderEnum];

/**
 * 
 * @export
 * @interface LogisticsPickupRange
 */
export interface LogisticsPickupRange {
    /**
     * Start time of the pickup range
     * @type {string}
     * @memberof LogisticsPickupRange
     */
    'from'?: string;
    /**
     * End time of the pickup range
     * @type {string}
     * @memberof LogisticsPickupRange
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsProcessInfo
 */
export interface LogisticsProcessInfo {
    /**
     * Return process the entry belongs to
     * @type {string}
     * @memberof LogisticsProcessInfo
     */
    'process_id'?: string;
    /**
     * Id of the settings-api warehouse the return ships to, chosen at checkout. Empty when  none was chosen; processes-api then resolves the warehouse itself
     * @type {string}
     * @memberof LogisticsProcessInfo
     */
    'warehouse_id'?: string;
}
/**
 * ProviderCapability is one provider + carrier + return method a wired provider serves.
 * @export
 * @interface LogisticsProviderCapability
 */
export interface LogisticsProviderCapability {
    /**
     * Carrier as written in a return-logistics rule, e.g. \"correosexpress\".
     * @type {string}
     * @memberof LogisticsProviderCapability
     */
    'carrier'?: string;
    /**
     * Provider name as written in a return-logistics rule, e.g. \"sendcloud_ecommerce\".
     * @type {string}
     * @memberof LogisticsProviderCapability
     */
    'provider'?: string;
    /**
     * Return method this provider + carrier pair serves.
     * @type {string}
     * @memberof LogisticsProviderCapability
     */
    'return_method'?: LogisticsProviderCapabilityReturnMethodEnum;
}

export const LogisticsProviderCapabilityReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsProviderCapabilityReturnMethodEnum = typeof LogisticsProviderCapabilityReturnMethodEnum[keyof typeof LogisticsProviderCapabilityReturnMethodEnum];

/**
 * ProviderConfiguration is what one provider name, optionally scoped to one carrier,  needs from the merchant.
 * @export
 * @interface LogisticsProviderConfiguration
 */
export interface LogisticsProviderConfiguration {
    /**
     * Carrier the entry is scoped to. Empty covers every carrier of the name.
     * @type {string}
     * @memberof LogisticsProviderConfiguration
     */
    'carrier'?: string;
    /**
     * settings-api connection id, e.g. \"ups\". Set only for CONFIGURATION_SOURCE_CONNECTION.
     * @type {string}
     * @memberof LogisticsProviderConfiguration
     */
    'connection'?: string;
    /**
     * Keys read from the connection, in declaration order.
     * @type {Array<LogisticsConfigurationField>}
     * @memberof LogisticsProviderConfiguration
     */
    'fields'?: Array<LogisticsConfigurationField>;
    /**
     * Why nothing is needed, or context the fields alone do not carry.
     * @type {string}
     * @memberof LogisticsProviderConfiguration
     */
    'note'?: string;
    /**
     * Partner a logistics contract is registered with, e.g. \"sendcloud\".
     * @type {string}
     * @memberof LogisticsProviderConfiguration
     */
    'partner'?: string;
    /**
     * Provider name as written in a return-logistics rule, e.g. \"ups_ecommerce\".
     * @type {string}
     * @memberof LogisticsProviderConfiguration
     */
    'provider'?: string;
    /**
     * Where the merchant data lives.
     * @type {string}
     * @memberof LogisticsProviderConfiguration
     */
    'source'?: LogisticsProviderConfigurationSourceEnum;
}

export const LogisticsProviderConfigurationSourceEnum = {
    Unspecified: 'CONFIGURATION_SOURCE_UNSPECIFIED',
    None: 'CONFIGURATION_SOURCE_NONE',
    Connection: 'CONFIGURATION_SOURCE_CONNECTION',
    LogisticsContract: 'CONFIGURATION_SOURCE_LOGISTICS_CONTRACT'
} as const;

export type LogisticsProviderConfigurationSourceEnum = typeof LogisticsProviderConfigurationSourceEnum[keyof typeof LogisticsProviderConfigurationSourceEnum];

/**
 * ProviderConfigurationReport is one provider name\'s status for the merchant.
 * @export
 * @interface LogisticsProviderConfigurationReport
 */
export interface LogisticsProviderConfigurationReport {
    /**
     * Carrier as requested; empty when every scope was judged.
     * @type {string}
     * @memberof LogisticsProviderConfigurationReport
     */
    'carrier'?: string;
    /**
     * The declaration\'s note, if any.
     * @type {string}
     * @memberof LogisticsProviderConfigurationReport
     */
    'note'?: string;
    /**
     * Provider name as requested.
     * @type {string}
     * @memberof LogisticsProviderConfigurationReport
     */
    'provider'?: string;
    /**
     * One scope per judged connection entry. Empty unless the name reads a connection.
     * @type {Array<LogisticsConfigurationScope>}
     * @memberof LogisticsProviderConfigurationReport
     */
    'scopes'?: Array<LogisticsConfigurationScope>;
    /**
     * Overall status across every scope.
     * @type {string}
     * @memberof LogisticsProviderConfigurationReport
     */
    'status'?: LogisticsProviderConfigurationReportStatusEnum;
}

export const LogisticsProviderConfigurationReportStatusEnum = {
    Unspecified: 'PROVIDER_CONFIGURATION_STATUS_UNSPECIFIED',
    Present: 'PROVIDER_CONFIGURATION_STATUS_PRESENT',
    Missing: 'PROVIDER_CONFIGURATION_STATUS_MISSING',
    NotNeeded: 'PROVIDER_CONFIGURATION_STATUS_NOT_NEEDED',
    Unverified: 'PROVIDER_CONFIGURATION_STATUS_UNVERIFIED',
    Unknown: 'PROVIDER_CONFIGURATION_STATUS_UNKNOWN'
} as const;

export type LogisticsProviderConfigurationReportStatusEnum = typeof LogisticsProviderConfigurationReportStatusEnum[keyof typeof LogisticsProviderConfigurationReportStatusEnum];

/**
 * ProviderCredentials is what one provider name reads from the ecommerce\'s connection.
 * @export
 * @interface LogisticsProviderCredentials
 */
export interface LogisticsProviderCredentials {
    /**
     * Carrier the entry is scoped to. Empty covers every carrier of the provider.
     * @type {string}
     * @memberof LogisticsProviderCredentials
     */
    'carrier'?: string;
    /**
     * Fields in declaration order. In sandbox mode these are what credential_overrides must  hold.
     * @type {Array<LogisticsCredentialField>}
     * @memberof LogisticsProviderCredentials
     */
    'fields'?: Array<LogisticsCredentialField>;
    /**
     * Provider name as written in a return-logistics rule, e.g. \"fedex_ecommerce\".
     * @type {string}
     * @memberof LogisticsProviderCredentials
     */
    'provider'?: string;
    /**
     * True when CreateTestLabel accepts sandbox for this provider.
     * @type {boolean}
     * @memberof LogisticsProviderCredentials
     */
    'supports_sandbox'?: boolean;
}
/**
 * ProviderQuery names one provider, and optionally the carrier a route books it for.
 * @export
 * @interface LogisticsProviderQuery
 */
export interface LogisticsProviderQuery {
    /**
     * Carrier of the route. Set it to judge only that carrier\'s scope; empty judges every  scope of the name.
     * @type {string}
     * @memberof LogisticsProviderQuery
     */
    'carrier'?: string;
    /**
     * Provider name as written in a return-logistics rule, e.g. \"exporto_ecommerce\".
     * @type {string}
     * @memberof LogisticsProviderQuery
     */
    'provider'?: string;
}
/**
 * ReturnLogisticsRuleToValidate is the part of a return-logistics rule the  capabilities decide on. Conditions and service ids play no role here.
 * @export
 * @interface LogisticsReturnLogisticsRuleToValidate
 */
export interface LogisticsReturnLogisticsRuleToValidate {
    /**
     * The rule\'s carrier, e.g. \"ups\".
     * @type {string}
     * @memberof LogisticsReturnLogisticsRuleToValidate
     */
    'carrier'?: string;
    /**
     * The rule\'s provider, e.g. \"ups_ecommerce\".
     * @type {string}
     * @memberof LogisticsReturnLogisticsRuleToValidate
     */
    'provider'?: string;
    /**
     * The rule\'s return method.
     * @type {string}
     * @memberof LogisticsReturnLogisticsRuleToValidate
     */
    'return_method'?: LogisticsReturnLogisticsRuleToValidateReturnMethodEnum;
}

export const LogisticsReturnLogisticsRuleToValidateReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsReturnLogisticsRuleToValidateReturnMethodEnum = typeof LogisticsReturnLogisticsRuleToValidateReturnMethodEnum[keyof typeof LogisticsReturnLogisticsRuleToValidateReturnMethodEnum];

/**
 * ReturnLogisticsRuleVerdict is the outcome for one rule.
 * @export
 * @interface LogisticsReturnLogisticsRuleVerdict
 */
export interface LogisticsReturnLogisticsRuleVerdict {
    /**
     * Why the rule is invalid, naming what is declared instead. Empty when valid.
     * @type {string}
     * @memberof LogisticsReturnLogisticsRuleVerdict
     */
    'reason'?: string;
    /**
     * True when a provider declares exactly this provider + carrier + return method.  IN_STORE rules are always valid: no provider takes part in them.
     * @type {boolean}
     * @memberof LogisticsReturnLogisticsRuleVerdict
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface LogisticsSaveDocumentRequest
 */
export interface LogisticsSaveDocumentRequest {
    /**
     * The content of the document file, base64 encoded
     * @type {string}
     * @memberof LogisticsSaveDocumentRequest
     */
    'document'?: string;
    /**
     * The extension of the document file, just 3 letters  Only \"pdf\", \"png\" and \"jpg\" are allowed
     * @type {string}
     * @memberof LogisticsSaveDocumentRequest
     */
    'document_extension'?: LogisticsSaveDocumentRequestDocumentExtensionEnum;
    /**
     * Document type
     * @type {string}
     * @memberof LogisticsSaveDocumentRequest
     */
    'document_type'?: LogisticsSaveDocumentRequestDocumentTypeEnum;
    /**
     * Id of the process to identify the label from
     * @type {string}
     * @memberof LogisticsSaveDocumentRequest
     */
    'process_id'?: string;
}

export const LogisticsSaveDocumentRequestDocumentExtensionEnum = {
    Unspecified: 'DOCUMENT_EXTENSION_UNSPECIFIED',
    Pdf: 'DOCUMENT_EXTENSION_PDF',
    Png: 'DOCUMENT_EXTENSION_PNG',
    Jpg: 'DOCUMENT_EXTENSION_JPG'
} as const;

export type LogisticsSaveDocumentRequestDocumentExtensionEnum = typeof LogisticsSaveDocumentRequestDocumentExtensionEnum[keyof typeof LogisticsSaveDocumentRequestDocumentExtensionEnum];
export const LogisticsSaveDocumentRequestDocumentTypeEnum = {
    Unspecified: 'DOCUMENT_TYPE_UNSPECIFIED',
    Label: 'DOCUMENT_TYPE_LABEL',
    ReturnInstructions: 'DOCUMENT_TYPE_RETURN_INSTRUCTIONS',
    DeliveryNote: 'DOCUMENT_TYPE_DELIVERY_NOTE'
} as const;

export type LogisticsSaveDocumentRequestDocumentTypeEnum = typeof LogisticsSaveDocumentRequestDocumentTypeEnum[keyof typeof LogisticsSaveDocumentRequestDocumentTypeEnum];

/**
 * LogisticContract save request
 * @export
 * @interface LogisticsSaveLogisticContractReq
 */
export interface LogisticsSaveLogisticContractReq {
    /**
     * Carrier
     * @type {string}
     * @memberof LogisticsSaveLogisticContractReq
     */
    'carrier'?: string;
    /**
     * ContractID
     * @type {string}
     * @memberof LogisticsSaveLogisticContractReq
     */
    'contract_id'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof LogisticsSaveLogisticContractReq
     */
    'ecommerce_id'?: string;
    /**
     * Provider
     * @type {string}
     * @memberof LogisticsSaveLogisticContractReq
     */
    'provider'?: string;
    /**
     * User
     * @type {string}
     * @memberof LogisticsSaveLogisticContractReq
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsSaveLogisticOrderResponse
 */
export interface LogisticsSaveLogisticOrderResponse {
    /**
     * logistic order created
     * @type {ModelsLogisticOrder}
     * @memberof LogisticsSaveLogisticOrderResponse
     */
    'order'?: ModelsLogisticOrder;
    /**
     * Transaction provider to record for the label. Unset for manually saved orders.
     * @type {string}
     * @memberof LogisticsSaveLogisticOrderResponse
     */
    'transaction_provider'?: LogisticsSaveLogisticOrderResponseTransactionProviderEnum;
}

export const LogisticsSaveLogisticOrderResponseTransactionProviderEnum = {
    Mock: 'TXPROVIDER_MOCK',
    Woocommerce: 'TXPROVIDER_WOOCOMMERCE',
    Shopify: 'TXPROVIDER_SHOPIFY',
    CustomGeneric: 'TXPROVIDER_CUSTOM_GENERIC',
    Prestashop: 'TXPROVIDER_PRESTASHOP',
    MagentoV1: 'TXPROVIDER_MAGENTO_V1',
    MagentoV2: 'TXPROVIDER_MAGENTO_V2',
    Salesforce: 'TXPROVIDER_SALESFORCE',
    Revolut: 'TXPROVIDER_REVOLUT',
    Stripe: 'TXPROVIDER_STRIPE',
    Sendcloud: 'TXPROVIDER_SENDCLOUD',
    Correos: 'TXPROVIDER_CORREOS',
    CorreosExpress: 'TXPROVIDER_CORREOS_EXPRESS',
    ShippyPro: 'TXPROVIDER_SHIPPY_PRO',
    Ups: 'TXPROVIDER_UPS',
    Gls: 'TXPROVIDER_GLS',
    Dhl: 'TXPROVIDER_DHL',
    DhlExpress: 'TXPROVIDER_DHL_EXPRESS',
    DhlParcel: 'TXPROVIDER_DHL_PARCEL',
    Rhenus: 'TXPROVIDER_RHENUS',
    Fedex: 'TXPROVIDER_FEDEX',
    Zeleris: 'TXPROVIDER_ZELERIS',
    SendcloudEcommerce: 'TXPROVIDER_SENDCLOUD_ECOMMERCE',
    Enovo: 'TXPROVIDER_ENOVO',
    Zelo: 'TXPROVIDER_ZELO',
    Colissimo: 'TXPROVIDER_COLISSIMO',
    Ctt: 'TXPROVIDER_CTT',
    Monta: 'TXPROVIDER_MONTA',
    Brt: 'TXPROVIDER_BRT',
    Esendeo: 'TXPROVIDER_ESENDEO',
    Estafeta: 'TXPROVIDER_ESTAFETA',
    Chronopost: 'TXPROVIDER_CHRONOPOST',
    Canadapost: 'TXPROVIDER_CANADAPOST',
    Inpost: 'TXPROVIDER_INPOST',
    Packeta: 'TXPROVIDER_PACKETA',
    Dpd: 'TXPROVIDER_DPD',
    Mondialrelay: 'TXPROVIDER_MONDIALRELAY',
    Easypost: 'TXPROVIDER_EASYPOST',
    Flexport: 'TXPROVIDER_FLEXPORT',
    Tamdis: 'TXPROVIDER_TAMDIS',
    Seur: 'TXPROVIDER_SEUR',
    Cttportugal: 'TXPROVIDER_CTTPORTUGAL',
    Tnt: 'TXPROVIDER_TNT',
    Dhleconnect: 'TXPROVIDER_DHLECONNECT',
    Dhlbenelux: 'TXPROVIDER_DHLBENELUX',
    Swisspost: 'TXPROVIDER_SWISSPOST',
    Dpdportugal: 'TXPROVIDER_DPDPORTUGAL',
    Mbe: 'TXPROVIDER_MBE',
    Globale: 'TXPROVIDER_GLOBALE',
    Amphora: 'TXPROVIDER_AMPHORA',
    Dpdireland: 'TXPROVIDER_DPDIRELAND',
    Innosend: 'TXPROVIDER_INNOSEND',
    Exporto: 'TXPROVIDER_EXPORTO',
    Royalmail: 'TXPROVIDER_ROYALMAIL',
    Glsitaly: 'TXPROVIDER_GLSITALY',
    Glsczech: 'TXPROVIDER_GLSCZECH',
    Bigblue: 'TXPROVIDER_BIGBLUE',
    Myparcel: 'TXPROVIDER_MYPARCEL',
    Boardriders: 'TXPROVIDER_BOARDRIDERS',
    Glsshopreturns: 'TXPROVIDER_GLSSHOPRETURNS',
    None: 'TXPROVIDER_NONE'
} as const;

export type LogisticsSaveLogisticOrderResponseTransactionProviderEnum = typeof LogisticsSaveLogisticOrderResponseTransactionProviderEnum[keyof typeof LogisticsSaveLogisticOrderResponseTransactionProviderEnum];

/**
 * 
 * @export
 * @interface LogisticsSaveManuallyCreatedLogisticOrderRequest
 */
export interface LogisticsSaveManuallyCreatedLogisticOrderRequest {
    /**
     * The content of the label file, base64 encoded
     * @type {string}
     * @memberof LogisticsSaveManuallyCreatedLogisticOrderRequest
     */
    'label'?: string;
    /**
     * The extension of the label file, just 3 letters  Only \"pdf\", \"png\" and \"jpg\" are allowed
     * @type {string}
     * @memberof LogisticsSaveManuallyCreatedLogisticOrderRequest
     */
    'label_extension'?: string;
    /**
     * The logistic order data with the process_id
     * @type {LogisticsManualLogisticOrder}
     * @memberof LogisticsSaveManuallyCreatedLogisticOrderRequest
     */
    'order'?: LogisticsManualLogisticOrder;
}
/**
 * 
 * @export
 * @interface LogisticsSaveProcessInfoRequest
 */
export interface LogisticsSaveProcessInfoRequest {
    /**
     * Process and warehouse to store. Replaces any entry already stored for the process
     * @type {LogisticsProcessInfo}
     * @memberof LogisticsSaveProcessInfoRequest
     */
    'process_info'?: LogisticsProcessInfo;
}
/**
 * 
 * @export
 * @interface LogisticsSendCloudContractTesterRequest
 */
export interface LogisticsSendCloudContractTesterRequest {
    /**
     * Sendcloud carrier code to query (e.g. \"correos\", \"dhl_express\")
     * @type {string}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'carrier'?: string;
    /**
     * Sendcloud contract id to test. Empty asks for the account\'s default contract for  the carrier
     * @type {string}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'contract_id'?: string;
    /**
     * Ecommerce whose own Sendcloud keys are used. Required when provider is  sendcloud_account_ecommerce
     * @type {string}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'ecommerce_id'?: string;
    /**
     * Two-letter code of the country the shopper ships from (e.g. \"ES\")
     * @type {string}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'from_country'?: string;
    /**
     * Sent as Sendcloud\'s returns filter: true asks for return shipping products. Turn it  off for carriers that ship returns on outbound labels
     * @type {boolean}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'is_return'?: boolean;
    /**
     * Provider the contract belongs to; picks the Sendcloud account asked (REVER\'s main or  UK account, or the merchant\'s own for sendcloud_account_ecommerce). Empty means  REVER\'s.
     * @type {string}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'provider'?: string;
    /**
     * Two-letter code of the country the warehouse is in
     * @type {string}
     * @memberof LogisticsSendCloudContractTesterRequest
     */
    'to_country'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsSendCloudContractTesterResponse
 */
export interface LogisticsSendCloudContractTesterResponse {
    /**
     * Shipping methods the contract sells on the lane, across all of Sendcloud\'s shipping  products. Empty when it sells none there
     * @type {Array<LogisticsSendcloudService>}
     * @memberof LogisticsSendCloudContractTesterResponse
     */
    'services'?: Array<LogisticsSendcloudService>;
}
/**
 * SendcloudRouteCheck is one gate\'s result.
 * @export
 * @interface LogisticsSendcloudRouteCheck
 */
export interface LogisticsSendcloudRouteCheck {
    /**
     * What was found.
     * @type {string}
     * @memberof LogisticsSendcloudRouteCheck
     */
    'detail'?: string;
    /**
     * What to change. Empty unless the verdict is BLOCK.
     * @type {string}
     * @memberof LogisticsSendcloudRouteCheck
     */
    'fix'?: string;
    /**
     * Which configuration fact was checked: contract, route, weight_band,  service_point, requirements or customs.
     * @type {string}
     * @memberof LogisticsSendcloudRouteCheck
     */
    'gate'?: string;
    /**
     * PASS, BLOCK, SKIP or UNKNOWN. UNKNOWN must never be read as a pass.
     * @type {string}
     * @memberof LogisticsSendcloudRouteCheck
     */
    'verdict'?: string;
}
/**
 * 
 * @export
 * @interface LogisticsSendcloudService
 */
export interface LogisticsSendcloudService {
    /**
     * Sendcloud\'s v3 shipping option code. Empty when only the v2 catalog listed the  service
     * @type {string}
     * @memberof LogisticsSendcloudService
     */
    'code'?: string;
    /**
     * Sendcloud\'s v2 shipping method id, as a decimal string. Empty when the service  is only known by its v3 code
     * @type {string}
     * @memberof LogisticsSendcloudService
     */
    'id'?: string;
    /**
     * Sendcloud\'s name for the shipping method
     * @type {string}
     * @memberof LogisticsSendcloudService
     */
    'name'?: string;
}
/**
 * SendcloudSoldService is one service a contract sells on the validated route.
 * @export
 * @interface LogisticsSendcloudSoldService
 */
export interface LogisticsSendcloudSoldService {
    /**
     * Sendcloud\'s v3 shipping option code, the value a rule\'s service_id may hold  instead of the id. Empty when only the v2 catalogue listed the service.
     * @type {string}
     * @memberof LogisticsSendcloudSoldService
     */
    'code'?: string;
    /**
     * Sendcloud\'s v2 shipping method id, the value a rule\'s service_id holds. 0 when  the service is only known by its v3 code.
     * @type {string}
     * @memberof LogisticsSendcloudSoldService
     */
    'id'?: string;
    /**
     * Highest weight the service accepts, in kilograms. 0 means unbounded.
     * @type {number}
     * @memberof LogisticsSendcloudSoldService
     */
    'max_weight_kg'?: number;
    /**
     * Lowest weight the service accepts, in kilograms. 0 means unbounded.
     * @type {number}
     * @memberof LogisticsSendcloudSoldService
     */
    'min_weight_kg'?: number;
    /**
     * The service\'s name in Sendcloud.
     * @type {string}
     * @memberof LogisticsSendcloudSoldService
     */
    'name'?: string;
    /**
     * True when the service will not produce a label without a drop-off point.  Absent when Sendcloud did not state the requirement, which must not be  presented as \"no drop-off point needed\".
     * @type {boolean}
     * @memberof LogisticsSendcloudSoldService
     */
    'requires_service_point'?: boolean;
}
/**
 * Whether the test shipment was voided after its label was captured
 * @export
 * @interface LogisticsTestLabelCancellation
 */
export interface LogisticsTestLabelCancellation {
    /**
     * Provider\'s own status or error message, verbatim
     * @type {string}
     * @memberof LogisticsTestLabelCancellation
     */
    'detail'?: string;
    /**
     * Outcome of the cancellation attempt
     * @type {string}
     * @memberof LogisticsTestLabelCancellation
     */
    'outcome'?: LogisticsTestLabelCancellationOutcomeEnum;
    /**
     * Provider\'s own id for the shipment (e.g. the Sendcloud parcel id), to cancel by hand  when needed
     * @type {string}
     * @memberof LogisticsTestLabelCancellation
     */
    'provider_reference'?: string;
}

export const LogisticsTestLabelCancellationOutcomeEnum = {
    Unspecified: 'TEST_LABEL_CANCELLATION_OUTCOME_UNSPECIFIED',
    NotSupported: 'TEST_LABEL_CANCELLATION_OUTCOME_NOT_SUPPORTED',
    Confirmed: 'TEST_LABEL_CANCELLATION_OUTCOME_CONFIRMED',
    Pending: 'TEST_LABEL_CANCELLATION_OUTCOME_PENDING',
    Failed: 'TEST_LABEL_CANCELLATION_OUTCOME_FAILED'
} as const;

export type LogisticsTestLabelCancellationOutcomeEnum = typeof LogisticsTestLabelCancellationOutcomeEnum[keyof typeof LogisticsTestLabelCancellationOutcomeEnum];

/**
 * ValidateAddressRequest is one captured address plus the rule that will ship it.
 * @export
 * @interface LogisticsValidateAddressRequest
 */
export interface LogisticsValidateAddressRequest {
    /**
     * The shopper\'s address as captured. Required, with a two-letter country code.
     * @type {ModelsAddress}
     * @memberof LogisticsValidateAddressRequest
     */
    'address'?: ModelsAddress;
    /**
     * The rule\'s carrier, e.g. \"brt\". Required.
     * @type {string}
     * @memberof LogisticsValidateAddressRequest
     */
    'carrier'?: string;
    /**
     * The e-commerce the return belongs to. Required.
     * @type {string}
     * @memberof LogisticsValidateAddressRequest
     */
    'ecommerce_id'?: string;
    /**
     * The rule\'s provider, e.g. \"brt\" or \"brt_ecommerce\". Required.
     * @type {string}
     * @memberof LogisticsValidateAddressRequest
     */
    'provider'?: string;
    /**
     * The return method the address is captured for.
     * @type {string}
     * @memberof LogisticsValidateAddressRequest
     */
    'return_method'?: LogisticsValidateAddressRequestReturnMethodEnum;
}

export const LogisticsValidateAddressRequestReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsValidateAddressRequestReturnMethodEnum = typeof LogisticsValidateAddressRequestReturnMethodEnum[keyof typeof LogisticsValidateAddressRequestReturnMethodEnum];

/**
 * ValidateAddressResponse is what the carrier\'s source said.
 * @export
 * @interface LogisticsValidateAddressResponse
 */
export interface LogisticsValidateAddressResponse {
    /**
     * One line saying why, for logs and task comments. Not shopper copy.
     * @type {string}
     * @memberof LogisticsValidateAddressResponse
     */
    'detail'?: string;
    /**
     * Fields REVER\'s own format rules flag, in field order, at most one per field. Set with  any status, UNKNOWN included: a carrier nobody can check still rejects a bad phone.
     * @type {Array<LogisticsAddressIssue>}
     * @memberof LogisticsValidateAddressResponse
     */
    'issues'?: Array<LogisticsAddressIssue>;
    /**
     * What answered, e.g. \"brt_catalog\". Empty when UNKNOWN.
     * @type {string}
     * @memberof LogisticsValidateAddressResponse
     */
    'source'?: string;
    /**
     * The headline outcome.
     * @type {string}
     * @memberof LogisticsValidateAddressResponse
     */
    'status'?: LogisticsValidateAddressResponseStatusEnum;
    /**
     * Candidate corrections, best first, when status is SUGGESTION. When status is  VALID, the one entry is the address as the carrier spells it.
     * @type {Array<LogisticsAddressSuggestion>}
     * @memberof LogisticsValidateAddressResponse
     */
    'suggestions'?: Array<LogisticsAddressSuggestion>;
}

export const LogisticsValidateAddressResponseStatusEnum = {
    Unspecified: 'ADDRESS_VALIDATION_STATUS_UNSPECIFIED',
    Valid: 'ADDRESS_VALIDATION_STATUS_VALID',
    Suggestion: 'ADDRESS_VALIDATION_STATUS_SUGGESTION',
    NotFound: 'ADDRESS_VALIDATION_STATUS_NOT_FOUND',
    Unknown: 'ADDRESS_VALIDATION_STATUS_UNKNOWN'
} as const;

export type LogisticsValidateAddressResponseStatusEnum = typeof LogisticsValidateAddressResponseStatusEnum[keyof typeof LogisticsValidateAddressResponseStatusEnum];

/**
 * 
 * @export
 * @interface LogisticsValidateReturnLogisticsRequest
 */
export interface LogisticsValidateReturnLogisticsRequest {
    /**
     * Rules in configuration order; verdicts come back in the same order.
     * @type {Array<LogisticsReturnLogisticsRuleToValidate>}
     * @memberof LogisticsValidateReturnLogisticsRequest
     */
    'rules'?: Array<LogisticsReturnLogisticsRuleToValidate>;
}
/**
 * 
 * @export
 * @interface LogisticsValidateReturnLogisticsResponse
 */
export interface LogisticsValidateReturnLogisticsResponse {
    /**
     * One verdict per rule, in request order.
     * @type {Array<LogisticsReturnLogisticsRuleVerdict>}
     * @memberof LogisticsValidateReturnLogisticsResponse
     */
    'verdicts'?: Array<LogisticsReturnLogisticsRuleVerdict>;
}
/**
 * ValidateSendcloudRouteRequest is one configured rule plus the concrete route  to validate it on.
 * @export
 * @interface LogisticsValidateSendcloudRouteRequest
 */
export interface LogisticsValidateSendcloudRouteRequest {
    /**
     * The rule\'s carrier, e.g. \"inpost\". Required.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'carrier'?: string;
    /**
     * Connection the rule names as submitted, empty for the default: judges a rule not  saved yet. Unset reads the e-commerce\'s stored rules.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'carrier_connection_id'?: string;
    /**
     * The e-commerce group, which can change how an order number is formatted.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'ecommerce_group'?: string;
    /**
     * The e-commerce whose rule is being validated. Required.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'ecommerce_id'?: string;
    /**
     * Country the return ships from: the shopper. Required.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'from_country'?: string;
    /**
     * Postal code the return ships from. Required for zonal carriers only.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'from_postal_code'?: string;
    /**
     * The rule\'s provider, e.g. \"sendcloud\" or \"sendcloud_ecommerce\". Required.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'provider'?: string;
    /**
     * The rule\'s return method, which decides whether a drop-off point is collected.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'return_method'?: LogisticsValidateSendcloudRouteRequestReturnMethodEnum;
    /**
     * The rule\'s service_id. Empty means the carrier\'s own default service.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'service_id'?: string;
    /**
     * Country the return ships to: the warehouse. Required.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'to_country'?: string;
    /**
     * Postal code the return ships to. Required for zonal carriers only.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'to_postal_code'?: string;
    /**
     * Representative parcel weight in grams. 0 uses the same default as a real label.
     * @type {number}
     * @memberof LogisticsValidateSendcloudRouteRequest
     */
    'weight_in_grams'?: number;
}

export const LogisticsValidateSendcloudRouteRequestReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type LogisticsValidateSendcloudRouteRequestReturnMethodEnum = typeof LogisticsValidateSendcloudRouteRequestReturnMethodEnum[keyof typeof LogisticsValidateSendcloudRouteRequestReturnMethodEnum];

/**
 * ValidateSendcloudRouteResponse is what validation found. Status is the  summary; the checks say which gate failed and how to fix it.
 * @export
 * @interface LogisticsValidateSendcloudRouteResponse
 */
export interface LogisticsValidateSendcloudRouteResponse {
    /**
     * One entry per gate, in the order they were evaluated.
     * @type {Array<LogisticsSendcloudRouteCheck>}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'checks'?: Array<LogisticsSendcloudRouteCheck>;
    /**
     * The contract a label on this route would be created on.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'contract_id'?: string;
    /**
     * Who the carrier bills for a test label on this route. UNSPECIFIED means no  contract resolved, so nobody would be billed - not the same as REVER.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'contract_owner'?: LogisticsValidateSendcloudRouteResponseContractOwnerEnum;
    /**
     * The parcel weight a real label would declare, in kilograms.
     * @type {number}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'declared_weight_kg'?: number;
    /**
     * The v3 shipping option code a label on this route would ship with. Empty when  the service is only known by its v2 id.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'service_code'?: string;
    /**
     * The service a label on this route would use, after config and carrier defaults.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'service_id'?: string;
    /**
     * The service\'s name in Sendcloud, empty when the contract does not sell it.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'service_name'?: string;
    /**
     * The services the contract does sell on this route, for fixing a blocked rule.
     * @type {Array<LogisticsSendcloudSoldService>}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'sold_services'?: Array<LogisticsSendcloudSoldService>;
    /**
     * The headline outcome. Gate go-live on this and nothing else.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'status'?: LogisticsValidateSendcloudRouteResponseStatusEnum;
    /**
     * One operator-facing sentence describing the outcome, e.g. \"4 of 5 checks  passed. Could not determine: drop-off point.\" Says what status omits: an  undecided gate does not mean the rest of the route is wrong.
     * @type {string}
     * @memberof LogisticsValidateSendcloudRouteResponse
     */
    'summary'?: string;
}

export const LogisticsValidateSendcloudRouteResponseContractOwnerEnum = {
    Unspecified: 'ROUTE_CONTRACT_OWNER_UNSPECIFIED',
    Rever: 'ROUTE_CONTRACT_OWNER_REVER',
    Merchant: 'ROUTE_CONTRACT_OWNER_MERCHANT'
} as const;

export type LogisticsValidateSendcloudRouteResponseContractOwnerEnum = typeof LogisticsValidateSendcloudRouteResponseContractOwnerEnum[keyof typeof LogisticsValidateSendcloudRouteResponseContractOwnerEnum];
export const LogisticsValidateSendcloudRouteResponseStatusEnum = {
    Unspecified: 'SENDCLOUD_ROUTE_STATUS_UNSPECIFIED',
    Ready: 'SENDCLOUD_ROUTE_STATUS_READY',
    Blocked: 'SENDCLOUD_ROUTE_STATUS_BLOCKED',
    Inconclusive: 'SENDCLOUD_ROUTE_STATUS_INCONCLUSIVE'
} as const;

export type LogisticsValidateSendcloudRouteResponseStatusEnum = typeof LogisticsValidateSendcloudRouteResponseStatusEnum[keyof typeof LogisticsValidateSendcloudRouteResponseStatusEnum];

/**
 * A product the shopper ordered in several sizes
 * @export
 * @interface MessagingpbBracketedProduct
 */
export interface MessagingpbBracketedProduct {
    /**
     * The variants ordered.
     * @type {Array<MessagingpbOrderItem>}
     * @memberof MessagingpbBracketedProduct
     */
    'items'?: Array<MessagingpbOrderItem>;
    /**
     * Variant the shopper chose to keep, empty until they choose.
     * @type {string}
     * @memberof MessagingpbBracketedProduct
     */
    'kept_variant_id'?: string;
    /**
     * Platform ID of the product.
     * @type {string}
     * @memberof MessagingpbBracketedProduct
     */
    'product_id'?: string;
    /**
     * Product title.
     * @type {string}
     * @memberof MessagingpbBracketedProduct
     */
    'title'?: string;
}
/**
 * A conversation about one order
 * @export
 * @interface MessagingpbBracketingCase
 */
export interface MessagingpbBracketingCase {
    /**
     * When the case was created.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'created_at'?: string;
    /**
     * ID of the ecommerce.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'ecommerce_id'?: string;
    /**
     * Why the case was handed to a person, when it was.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'handoff_reason'?: string;
    /**
     * ID of the case.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'id'?: string;
    /**
     * Whether the shopper wants every size shipped.
     * @type {boolean}
     * @memberof MessagingpbBracketingCase
     */
    'keep_all'?: boolean;
    /**
     * Messages exchanged, oldest first.
     * @type {Array<MessagingpbConversationMessage>}
     * @memberof MessagingpbBracketingCase
     */
    'messages'?: Array<MessagingpbConversationMessage>;
    /**
     * Platform ID of the order.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'order_id'?: string;
    /**
     * Order name.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'order_name'?: string;
    /**
     * Products ordered in several sizes, with the shopper\'s choice for each.
     * @type {Array<MessagingpbBracketedProduct>}
     * @memberof MessagingpbBracketingCase
     */
    'products'?: Array<MessagingpbBracketedProduct>;
    /**
     * When the shopper last decided, if they did.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'resolved_at'?: string;
    /**
     * Current status.
     * @type {string}
     * @memberof MessagingpbBracketingCase
     */
    'status'?: MessagingpbBracketingCaseStatusEnum;
}

export const MessagingpbBracketingCaseStatusEnum = {
    Unspecified: 'BRACKETING_STATUS_UNSPECIFIED',
    AwaitingReply: 'BRACKETING_STATUS_AWAITING_REPLY',
    Resolved: 'BRACKETING_STATUS_RESOLVED',
    HandedOff: 'BRACKETING_STATUS_HANDED_OFF',
    OptedOut: 'BRACKETING_STATUS_OPTED_OUT',
    PendingSend: 'BRACKETING_STATUS_PENDING_SEND'
} as const;

export type MessagingpbBracketingCaseStatusEnum = typeof MessagingpbBracketingCaseStatusEnum[keyof typeof MessagingpbBracketingCaseStatusEnum];

/**
 * A WhatsApp message of a case
 * @export
 * @interface MessagingpbConversationMessage
 */
export interface MessagingpbConversationMessage {
    /**
     * When it was sent or received.
     * @type {string}
     * @memberof MessagingpbConversationMessage
     */
    'created_at'?: string;
    /**
     * Who sent it.
     * @type {string}
     * @memberof MessagingpbConversationMessage
     */
    'direction'?: MessagingpbConversationMessageDirectionEnum;
    /**
     * ID of the message.
     * @type {string}
     * @memberof MessagingpbConversationMessage
     */
    'id'?: string;
    /**
     * Text of the message, or the title of the button pressed.
     * @type {string}
     * @memberof MessagingpbConversationMessage
     */
    'text'?: string;
}

export const MessagingpbConversationMessageDirectionEnum = {
    Unspecified: 'MESSAGE_DIRECTION_UNSPECIFIED',
    Inbound: 'MESSAGE_DIRECTION_INBOUND',
    Outbound: 'MESSAGE_DIRECTION_OUTBOUND'
} as const;

export type MessagingpbConversationMessageDirectionEnum = typeof MessagingpbConversationMessageDirectionEnum[keyof typeof MessagingpbConversationMessageDirectionEnum];

/**
 * A line item of the order
 * @export
 * @interface MessagingpbOrderItem
 */
export interface MessagingpbOrderItem {
    /**
     * Platform ID of the product. Required.
     * @type {string}
     * @memberof MessagingpbOrderItem
     */
    'product_id'?: string;
    /**
     * Units ordered. Required, at least 1.
     * @type {number}
     * @memberof MessagingpbOrderItem
     */
    'quantity'?: number;
    /**
     * Size of the variant, e.g. \"M\" or \"42\". Required.
     * @type {string}
     * @memberof MessagingpbOrderItem
     */
    'size'?: string;
    /**
     * Product title. Required.
     * @type {string}
     * @memberof MessagingpbOrderItem
     */
    'title'?: string;
    /**
     * Platform ID of the variant. Required.
     * @type {string}
     * @memberof MessagingpbOrderItem
     */
    'variant_id'?: string;
}
/**
 * Payload for the ProcessWhatsAppMessageInternal request, the WHATSAPP_MESSAGE_RECEIVED event payload
 * @export
 * @interface MessagingpbProcessWhatsAppMessageInternalRequest
 */
export interface MessagingpbProcessWhatsAppMessageInternalRequest {
    /**
     * ID of the case the message belongs to. Required.
     * @type {string}
     * @memberof MessagingpbProcessWhatsAppMessageInternalRequest
     */
    'case_id'?: string;
    /**
     * ID of the stored inbound message that raised the event. Required.
     * @type {string}
     * @memberof MessagingpbProcessWhatsAppMessageInternalRequest
     */
    'message_id'?: string;
    /**
     * WhatsApp id of that message, for logs.
     * @type {string}
     * @memberof MessagingpbProcessWhatsAppMessageInternalRequest
     */
    'wa_message_id'?: string;
}
/**
 * Payload for the StartBracketingConversation request
 * @export
 * @interface MessagingpbStartBracketingConversationRequest
 */
export interface MessagingpbStartBracketingConversationRequest {
    /**
     * Brand name used in the messages. Required.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'brand_name'?: string;
    /**
     * Shopper\'s first name. Optional.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'customer_first_name'?: string;
    /**
     * ID of the ecommerce the order belongs to. Required.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'ecommerce_id'?: string;
    /**
     * Order line items. Required.
     * @type {Array<MessagingpbOrderItem>}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'items'?: Array<MessagingpbOrderItem>;
    /**
     * BCP 47 language of the shopper, e.g. \"es\". Defaults to the configured template language.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'language'?: string;
    /**
     * Platform ID of the order. Required.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'order_id'?: string;
    /**
     * Order name shown to the shopper, e.g. \"#1043\". Required.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'order_name'?: string;
    /**
     * Shopper\'s phone in E.164 format, e.g. \"+34612345678\". Required.
     * @type {string}
     * @memberof MessagingpbStartBracketingConversationRequest
     */
    'phone'?: string;
}
/**
 * Payload for the StartBracketingConversation response
 * @export
 * @interface MessagingpbStartBracketingConversationResponse
 */
export interface MessagingpbStartBracketingConversationResponse {
    /**
     * The case for the order.
     * @type {MessagingpbBracketingCase}
     * @memberof MessagingpbStartBracketingConversationResponse
     */
    'case'?: MessagingpbBracketingCase;
    /**
     * Whether this call created the case. False when it already existed.
     * @type {boolean}
     * @memberof MessagingpbStartBracketingConversationResponse
     */
    'created'?: boolean;
}
/**
 * Address   @Description generic address used in many scenarios  @name api.Address
 * @export
 * @interface ModelsAddress
 */
export interface ModelsAddress {
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'address_line_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'company'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'postcode'?: string;
    /**
     * Unique ID in the rever platform
     * @type {string}
     * @memberof ModelsAddress
     */
    'rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'state_province'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsAddress
     */
    'state_province_code'?: string;
}
/**
 * Comments data
 * @export
 * @interface ModelsComment
 */
export interface ModelsComment {
    /**
     * Comment type
     * @type {string}
     * @memberof ModelsComment
     */
    'comment_type'?: string;
    /**
     * Extra comments/data field text -- any format
     * @type {string}
     * @memberof ModelsComment
     */
    'extra'?: string;
    /**
     * If the comment is manual (by a person) or automatic (by the workflow)
     * @type {boolean}
     * @memberof ModelsComment
     */
    'is_manual'?: boolean;
    /**
     * Id of the comment in rever system
     * @type {string}
     * @memberof ModelsComment
     */
    'rever_id'?: string;
    /**
     * Comment text -- might have markdown text
     * @type {string}
     * @memberof ModelsComment
     */
    'text'?: string;
    /**
     * Time of the comment
     * @type {string}
     * @memberof ModelsComment
     */
    'timestamp'?: string;
    /**
     * User that is related to the comment
     * @type {string}
     * @memberof ModelsComment
     */
    'user'?: string;
}
/**
 * Customer  Important! the alias at the end is for API docs generation  @Description A generic customer in the Rever platform  @name api.Customer
 * @export
 * @interface ModelsCustomer
 */
export interface ModelsCustomer {
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsCustomer
     */
    'last_name'?: string;
    /**
     * When available, this is the customer ID in the ecommerce platform
     * @type {string}
     * @memberof ModelsCustomer
     */
    'platform_customer_id'?: string;
    /**
     * Unique ID in the rever platform
     * @type {string}
     * @memberof ModelsCustomer
     */
    'rever_id'?: string;
}
/**
 * Package dimensions for a single unit (one piece) of a product, in  centimeters - i.e. the dimensions of the parcel/box the unit ships in,  not the bare product itself. Source platforms typically expose these as  \"package length/width/height\" on the variant or as shipping metafields.  All fields are optional - populated only when the source platform exposes them.  Consumers must multiply by line item quantity to compute parcel-level totals.  @Description Per-unit package dimensions in centimeters (parcel, not bare product)  @name api.Dimensions
 * @export
 * @interface ModelsDimensions
 */
export interface ModelsDimensions {
    /**
     * Package height in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof ModelsDimensions
     */
    'height_cm'?: string;
    /**
     * Package length in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof ModelsDimensions
     */
    'length_cm'?: string;
    /**
     * Package width in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof ModelsDimensions
     */
    'width_cm'?: string;
}
/**
 * LineItemReview represents each verification of an individual item of a line item
 * @export
 * @interface ModelsLineItemReview
 */
export interface ModelsLineItemReview {
    /**
     * Line item ID
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'line_item_id'?: string;
    /**
     * Location ID where the item was restocked
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'location_id'?: string;
    /**
     * Reason in case the review is a Reject
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'reject_reason'?: string;
    /**
     * ID of the review in our system
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'rever_id'?: string;
    /**
     * Should Restock indicates if the item should be restocked in the ecommerce platform
     * @type {boolean}
     * @memberof ModelsLineItemReview
     */
    'should_restock'?: boolean;
    /**
     * Show reject reason to the user
     * @type {boolean}
     * @memberof ModelsLineItemReview
     */
    'show_reject_reason'?: boolean;
    /**
     * Status of the reviewed item
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'status'?: string;
    /**
     * Time of the review
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'timestamp'?: string;
    /**
     * User that completed the review
     * @type {string}
     * @memberof ModelsLineItemReview
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface ModelsLogisticOrder
 */
export interface ModelsLogisticOrder {
    /**
     * 
     * @type {string}
     * @memberof ModelsLogisticOrder
     */
    'carrier'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsLogisticOrder
     */
    'currency_code'?: string;
    /**
     * Logistic Order ID
     * @type {string}
     * @memberof ModelsLogisticOrder
     */
    'id'?: string;
    /**
     * Carriers that shipped the original outbound order.
     * @type {Array<string>}
     * @memberof ModelsLogisticOrder
     */
    'original_carriers'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ModelsLogisticOrder
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ModelsLogisticOrder
     */
    'provider'?: string;
    /**
     * Provider\'s own id for the order when it has one beyond the shipment (e.g. the  Sendcloud v3 return id).
     * @type {string}
     * @memberof ModelsLogisticOrder
     */
    'provider_reference'?: string;
    /**
     * Whether the generated label was treated as a customs shipment.
     * @type {boolean}
     * @memberof ModelsLogisticOrder
     */
    'requires_customs'?: boolean;
    /**
     * Whether the return label\'s carrier matches the original outbound carrier(s) (strict  1:1).
     * @type {boolean}
     * @memberof ModelsLogisticOrder
     */
    'same_carrier_as_original'?: boolean;
    /**
     * 
     * @type {Array<ModelsShipment>}
     * @memberof ModelsLogisticOrder
     */
    'shipments'?: Array<ModelsShipment>;
}
/**
 * MoneyFormat describes how to deal with money fields (total, price..)  Important! the alias at the end is for API docs generation  @Description describes how amounts should be displayed in the client side  @name api.MoneyFormat
 * @export
 * @interface ModelsMoneyFormat
 */
export interface ModelsMoneyFormat {
    /**
     * 
     * @type {number}
     * @memberof ModelsMoneyFormat
     */
    'amount_multiplied_by'?: number;
    /**
     * ISO format (EUR, JPY, USD...)
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'currency_symbol'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'decimal_separator'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsMoneyFormat
     */
    'display_prices_with_taxes'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsMoneyFormat
     */
    'is_currency_left_position'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsMoneyFormat
     */
    'thousand_separator'?: string;
    /**
     * Deprecated: use GetNumberOfDecimalsStored method instead
     * @type {number}
     * @memberof ModelsMoneyFormat
     */
    'visible_number_of_decimals'?: number;
}
/**
 * 
 * @export
 * @interface ModelsPackage
 */
export interface ModelsPackage {
    /**
     * 
     * @type {string}
     * @memberof ModelsPackage
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPackage
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsPackage
     */
    'shipment_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ModelsPackage
     */
    'weight_in_grams'?: number;
}
/**
 * Product models any product from any e-commerce platform  Important! the alias at the end is for API docs generation  @Description A product from the e-commerce  @name api.Product
 * @export
 * @interface ModelsProduct
 */
export interface ModelsProduct {
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof ModelsProduct
     */
    'id'?: string;
    /**
     * Images associated to the product
     * @type {Array<ModelsProductImage>}
     * @memberof ModelsProduct
     */
    'images'?: Array<ModelsProductImage>;
    /**
     * Product name
     * @type {string}
     * @memberof ModelsProduct
     */
    'name'?: string;
    /**
     * price per unit (following MoneyFormat)
     * @type {string}
     * @memberof ModelsProduct
     */
    'price'?: string;
    /**
     * unique identifier of the product
     * @type {string}
     * @memberof ModelsProduct
     */
    'sku'?: string;
    /**
     * Optional: product variations  if a line-item references a varition, the attributes of the variation  have to be used instead of the ones of the product
     * @type {Array<ModelsProductVariant>}
     * @memberof ModelsProduct
     */
    'variants'?: Array<ModelsProductVariant>;
}
/**
 * Image  Alias is for API docs generation  Important! the alias at the end is for API docs generation  @Description An image from the e-commerce catalog  @name api.Image
 * @export
 * @interface ModelsProductImage
 */
export interface ModelsProductImage {
    /**
     * Image alternative text
     * @type {string}
     * @memberof ModelsProductImage
     */
    'alt'?: string;
    /**
     * Image name
     * @type {string}
     * @memberof ModelsProductImage
     */
    'name'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof ModelsProductImage
     */
    'src'?: string;
}
/**
 * 
 * @export
 * @interface ModelsProductVariant
 */
export interface ModelsProductVariant {
    /**
     * enabled or disabled
     * @type {boolean}
     * @memberof ModelsProductVariant
     */
    'enabled'?: boolean;
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'id'?: string;
    /**
     * Images associated to the variant
     * @type {Array<ModelsProductImage>}
     * @memberof ModelsProductVariant
     */
    'images'?: Array<ModelsProductImage>;
    /**
     * inventory quantity (only check if inventory_enabled is true)
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'inventory_quantity'?: string;
    /**
     * should be checked before checking quantity
     * @type {boolean}
     * @memberof ModelsProductVariant
     */
    'is_inventory_enabled'?: boolean;
    /**
     * Name of the variant
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'name'?: string;
    /**
     * unit price
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'price'?: string;
    /**
     * unique identifier of the product
     * @type {string}
     * @memberof ModelsProductVariant
     */
    'sku'?: string;
}
/**
 * 
 * @export
 * @interface ModelsRefundActionConfig
 */
export interface ModelsRefundActionConfig {
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundActionConfig
     */
    'name'?: ModelsRefundActionConfigNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundActionConfig
     */
    'rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundActionConfig
     */
    'timing'?: ModelsRefundActionConfigTimingEnum;
    /**
     * When conditions to evaluate  Every entry is evaluated as an AND condition  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof ModelsRefundActionConfig
     */
    'when'?: Array<string>;
}

export const ModelsRefundActionConfigNameEnum = {
    NoAction: 'NO_ACTION',
    ToExchange: 'TO_EXCHANGE',
    ToReturn: 'TO_RETURN'
} as const;

export type ModelsRefundActionConfigNameEnum = typeof ModelsRefundActionConfigNameEnum[keyof typeof ModelsRefundActionConfigNameEnum];
export const ModelsRefundActionConfigTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type ModelsRefundActionConfigTimingEnum = typeof ModelsRefundActionConfigTimingEnum[keyof typeof ModelsRefundActionConfigTimingEnum];

/**
 * 
 * @export
 * @interface ModelsRefundPaymentMethodConfig
 */
export interface ModelsRefundPaymentMethodConfig {
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'name'?: ModelsRefundPaymentMethodConfigNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'timing'?: ModelsRefundPaymentMethodConfigTimingEnum;
    /**
     * When conditions to evaluate  Every entry is evaluated as an AND condition  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof ModelsRefundPaymentMethodConfig
     */
    'when'?: Array<string>;
}

export const ModelsRefundPaymentMethodConfigNameEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type ModelsRefundPaymentMethodConfigNameEnum = typeof ModelsRefundPaymentMethodConfigNameEnum[keyof typeof ModelsRefundPaymentMethodConfigNameEnum];
export const ModelsRefundPaymentMethodConfigTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type ModelsRefundPaymentMethodConfigTimingEnum = typeof ModelsRefundPaymentMethodConfigTimingEnum[keyof typeof ModelsRefundPaymentMethodConfigTimingEnum];

/**
 * ReturnLineItem  Important! the alias at the end is for API docs generation  @Description One of the line items in a return process
 * @export
 * @interface ModelsReturnLineItem
 */
export interface ModelsReturnLineItem {
    /**
     * User action with this item
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'action'?: ModelsReturnLineItemActionEnum;
    /**
     * Whether this line item contributes to the total_payment_amount charged at checkout
     * @type {boolean}
     * @memberof ModelsReturnLineItem
     */
    'checkout_payment_item'?: boolean;
    /**
     * Return comment
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'comment'?: string;
    /**
     * Free-form per-unit attributes propagated from the source platform.
     * @type {object}
     * @memberof ModelsReturnLineItem
     */
    'custom_attributes'?: object;
    /**
     * Per-unit package dimensions in centimeters (parcel, not bare product),  propagated from the order line item. Aggregate by `quantity` for parcel  sizing. Optional.
     * @type {ModelsDimensions}
     * @memberof ModelsReturnLineItem
     */
    'dimensions'?: ModelsDimensions;
    /**
     * Id of the line item in the source platform
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'id'?: string;
    /**
     * Name of the line item (not necessarily the name of the product)
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'name'?: string;
    /**
     * if this line item refers to an item that we need to buy (exchange)
     * @type {boolean}
     * @memberof ModelsReturnLineItem
     */
    'pending_purchase'?: boolean;
    /**
     * Deprecated: Product is nil outside of Workflow
     * @type {ModelsProduct}
     * @memberof ModelsReturnLineItem
     */
    'product'?: ModelsProduct;
    /**
     * to get product details, request the product (API)
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_id'?: string;
    /**
     * URL of the main image of the product/line-item
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_image_url'?: string;
    /**
     * Reference of the product (usually more human readable than product ID)
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_reference'?: string;
    /**
     * ProductReturnReason
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'product_return_reason'?: string;
    /**
     * number of items of the same product + variant
     * @type {number}
     * @memberof ModelsReturnLineItem
     */
    'quantity'?: number;
    /**
     * User refund payment method
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'refund_payment_method'?: ModelsReturnLineItemRefundPaymentMethodEnum;
    /**
     * Reason why it\'s returned  Deprecated
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'return_reason'?: ModelsReturnLineItemReturnReasonEnum;
    /**
     * Id of the line item in rever system
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'rever_id'?: string;
    /**
     * Reviews of individual items included in the line item
     * @type {Array<ModelsLineItemReview>}
     * @memberof ModelsReturnLineItem
     */
    'reviews'?: Array<ModelsLineItemReview>;
    /**
     * stock-keeping unit (SKU) is a scannable bar code, most   often seen printed on product labels in a retail store
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'sku'?: string;
    /**
     * sub total amount of the line following the MoneyFormat of the order  before discounts and taxes  subtotal = unit_price * quantity
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'subtotal'?: string;
    /**
     * Subtype of the item
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'subtype'?: string;
    /**
     * total amount of the line following the MoneyFormat of the order  including discounts and tax  total = (subtotal - total_discounts) + total_taxes  this is the amount to be refunded (multiplied by items_returned/quantity)
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'total'?: string;
    /**
     * total amount of discounts of the line following the MoneyFormat
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'total_discounts'?: string;
    /**
     * total amount of taxes of the line following the MoneyFormat
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'total_taxes'?: string;
    /**
     * Return line item type
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'type'?: string;
    /**
     * unit price of a single  item (no discounts, no taxes)  follows MoneyFormat associated
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'unit_price'?: string;
    /**
     * True when the ecommerce\'s upload documents rules ask the customer for photos or  documents of this item. Set at checkout.
     * @type {boolean}
     * @memberof ModelsReturnLineItem
     */
    'upload_documents_required'?: boolean;
    /**
     * Variant EAN
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_ean'?: string;
    /**
     * variant of the product (same ProductID, different Variant)  we are allowing only one variant at the moment (one dimension)
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_id'?: string;
    /**
     * Name of the variant
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_name'?: string;
    /**
     * Reference of the variant (usually more human readable than variant ID)
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'variant_reference'?: string;
    /**
     * Per-unit weight in grams (NOT total line weight). Multiply by `quantity`  for the full line weight. Propagated from OrderLineItem.weight.
     * @type {string}
     * @memberof ModelsReturnLineItem
     */
    'weight'?: string;
}

export const ModelsReturnLineItemActionEnum = {
    NoAction: 'NO_ACTION',
    ToExchange: 'TO_EXCHANGE',
    ToReturn: 'TO_RETURN'
} as const;

export type ModelsReturnLineItemActionEnum = typeof ModelsReturnLineItemActionEnum[keyof typeof ModelsReturnLineItemActionEnum];
export const ModelsReturnLineItemRefundPaymentMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type ModelsReturnLineItemRefundPaymentMethodEnum = typeof ModelsReturnLineItemRefundPaymentMethodEnum[keyof typeof ModelsReturnLineItemRefundPaymentMethodEnum];
export const ModelsReturnLineItemReturnReasonEnum = {
    NoReturnReason: 'NO_RETURN_REASON',
    WrongSize: 'WRONG_SIZE',
    WrongColor: 'WRONG_COLOR',
    NotAsExpected: 'NOT_AS_EXPECTED',
    Defective: 'DEFECTIVE',
    ChangedMyMind: 'CHANGED_MY_MIND',
    WrongItem: 'WRONG_ITEM',
    WrongSizeTooSmall: 'WRONG_SIZE_TOO_SMALL',
    WrongSizeTooBig: 'WRONG_SIZE_TOO_BIG'
} as const;

export type ModelsReturnLineItemReturnReasonEnum = typeof ModelsReturnLineItemReturnReasonEnum[keyof typeof ModelsReturnLineItemReturnReasonEnum];

/**
 * A return process happening in the platform  @Description A return process happening in the platform  @Name api.ReturnProcess
 * @export
 * @interface ModelsReturnProcess
 */
export interface ModelsReturnProcess {
    /**
     * Do not change field name, we have \"ReviewFlow\" in the JSON   right now instead of `review_flow``.  Review flow can be manual (MANUAL) or automatic (AUTO)  If an item has to be reviewed when reaching the warehouse and the flow is MANUAL,   the process will wait for manual input. If AUTO, it will be approved automatically  protolint:disable:next FIELD_NAMES_LOWER_SNAKE_CASE
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'ReviewFlow'?: string;
    /**
     * protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<ModelsRefundActionConfig>}
     * @memberof ModelsReturnProcess
     */
    'action_config'?: Array<ModelsRefundActionConfig>;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'authorization_status'?: string;
    /**
     * bank_account_country
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'bank_account_country'?: string;
    /**
     * BBAN Basic Bank Account number
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'bban'?: string;
    /**
     * Deprecated: it is not stored in the db
     * @type {ModelsAddress}
     * @memberof ModelsReturnProcess
     */
    'billing_address'?: ModelsAddress;
    /**
     * When the process was canceled
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'canceled_at'?: string;
    /**
     * the Name of the carrier != provider
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'carrier_name'?: string;
    /**
     * Checkout id
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'checkout_id'?: string;
    /**
     * When the shipping status first reached COLLECTED,  or IN_WAREHOUSE if it skipped COLLECTED
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'collected_at'?: string;
    /**
     * When the process was completed
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'completed_at'?: string;
    /**
     * Return process\' currency (in most cases, currency in which the order was paid)
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'currency'?: string;
    /**
     * Shop\'s default currency
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'currency_shop'?: string;
    /**
     * the customer that ordered the return
     * @type {ModelsCustomer}
     * @memberof ModelsReturnProcess
     */
    'customer'?: ModelsCustomer;
    /**
     * for searching/information purposes
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'customer_printed_order_id'?: string;
    /**
     * Delivery note status
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'delivery_note_status'?: string;
    /**
     * where to drop-off this return
     * @type {ModelsAddress}
     * @memberof ModelsReturnProcess
     */
    'drop_off_address'?: ModelsAddress;
    /**
     * Internal Rever e-commerce_id
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'ecommerce_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'exchange_flow'?: ModelsReturnProcessExchangeFlowEnum;
    /**
     * Order number (customer printed) of the order created for the exchange  TODO: this is going to be deprecated by a Transaction entry  so that we can treat all of the external operations equally
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'exchange_order_number'?: string;
    /**
     * Relation between shop and customer amounts saved in db  Exchange rate = Shop currency amount in DB / Customer currency amount in DB  Exchange rate = (Shop currency real amount * Shop currency amount_multiplied_by)  divided by Customer currency real amount * Customer currency amount_multiplied_by)
     * @type {number}
     * @memberof ModelsReturnProcess
     */
    'exchange_rate'?: number;
    /**
     * address where to send the exchanged items
     * @type {ModelsAddress}
     * @memberof ModelsReturnProcess
     */
    'exchange_shipping_address'?: ModelsAddress;
    /**
     * Fraud model group
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'fraud_model_group'?: string;
    /**
     * Fraud model outcome
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'fraud_model_outcome'?: string;
    /**
     * Fraud model score
     * @type {number}
     * @memberof ModelsReturnProcess
     */
    'fraud_model_score'?: number;
    /**
     * Group
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'group'?: string;
    /**
     * IBAN
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'iban'?: string;
    /**
     * address where the items are picked up from the store (IN_STORE internal logistics)
     * @type {ModelsAddress}
     * @memberof ModelsReturnProcess
     */
    'in_store_pickup_address'?: ModelsAddress;
    /**
     * When the shipping status first reached IN_WAREHOUSE; a warehouse review sets it too
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'in_warehouse_at'?: string;
    /**
     * Comments associated to the return process (internal -- only REVER should see them)
     * @type {Array<ModelsComment>}
     * @memberof ModelsReturnProcess
     */
    'internal_comments'?: Array<ModelsComment>;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsReturnProcess
     */
    'is_lite'?: boolean;
    /**
     * if the return process is a test one or not
     * @type {boolean}
     * @memberof ModelsReturnProcess
     */
    'is_testing'?: boolean;
    /**
     * Keep your item type
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'keep_your_item_type'?: string;
    /**
     * last communicated status of the shipping
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'last_known_shipping_status'?: ModelsReturnProcessLastKnownShippingStatusEnum;
    /**
     * Return LineItems --> the items being returned + lines   related to the balance (example: shipping cost)
     * @type {Array<ModelsReturnLineItem>}
     * @memberof ModelsReturnProcess
     */
    'line_items'?: Array<ModelsReturnLineItem>;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'logistic_order_id'?: string;
    /**
     * Arbitrary JSON metadata associated with the return process
     * @type {object}
     * @memberof ModelsReturnProcess
     */
    'metadata'?: object;
    /**
     * Order ID in the source platform
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'order_id'?: string;
    /**
     * When the order was purchased
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'order_purchased_at'?: string;
    /**
     * Refund method and action configurations  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<ModelsRefundPaymentMethodConfig>}
     * @memberof ModelsReturnProcess
     */
    'payment_method_config'?: Array<ModelsRefundPaymentMethodConfig>;
    /**
     * where to pick-up this return
     * @type {ModelsAddress}
     * @memberof ModelsReturnProcess
     */
    'pickup_address'?: ModelsAddress;
    /**
     * Pickup ranges for deliver the returns
     * @type {Array<string>}
     * @memberof ModelsReturnProcess
     */
    'pickup_ranges'?: Array<ModelsReturnProcessPickupRangesEnum>;
    /**
     * Platform from where this order was retrieved
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'platform'?: ModelsReturnProcessPlatformEnum;
    /**
     * Platform process id  This is the id of the return process in the source platform
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'platform_process_id'?: string;
    /**
     * Identifier of the workflow - generated externally  Unique ID for the entity
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'process_id'?: string;
    /**
     * When the refund/exchange transactions will be executed
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'refund_timing'?: ModelsReturnProcessRefundTimingEnum;
    /**
     * where to return this return process
     * @type {ModelsAddress}
     * @memberof ModelsReturnProcess
     */
    'return_address'?: ModelsAddress;
    /**
     * Return method
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'return_method'?: ModelsReturnProcessReturnMethodEnum;
    /**
     * The timing for starting a return on the ecommerce platoform
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'start_return_on_platform_time'?: ModelsReturnProcessStartReturnOnPlatformTimeEnum;
    /**
     * When the process was started
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'started_at'?: string;
    /**
     * current status of the process
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'status'?: ModelsReturnProcessStatusEnum;
    /**
     * SWIFT For international accounts numbers
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'swift'?: string;
    /**
     * Transactions associated to the return process  executed in third party platforms
     * @type {Array<ModelsTransaction>}
     * @memberof ModelsReturnProcess
     */
    'transactions'?: Array<ModelsTransaction>;
    /**
     * Upload documents enabled
     * @type {boolean}
     * @memberof ModelsReturnProcess
     */
    'upload_documents_enabled'?: boolean;
    /**
     * the language the user selected for the return process  Should have values like \"es\" or \"es-ES\", \"en\", \"en-GB\"....
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'user_preferred_lang'?: string;
    /**
     * Which carrier has the user selected. It can be NONE as default or  a specific one like Correos, UPS, DHL, etc.  It\'s not necessarily the one used to finally create the shipping label  This values is the one that the user selected in the UI
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'user_selected_carrier'?: string;
    /**
     * Which logistics provider has the user selected. It can be NONE as default, OPS  to use REVER\'s ops team or a specific provider (ie SendCloud).
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'user_selected_provider'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsReturnProcess
     */
    'warehouse_id'?: string;
}

export const ModelsReturnProcessExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type ModelsReturnProcessExchangeFlowEnum = typeof ModelsReturnProcessExchangeFlowEnum[keyof typeof ModelsReturnProcessExchangeFlowEnum];
export const ModelsReturnProcessLastKnownShippingStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type ModelsReturnProcessLastKnownShippingStatusEnum = typeof ModelsReturnProcessLastKnownShippingStatusEnum[keyof typeof ModelsReturnProcessLastKnownShippingStatusEnum];
export const ModelsReturnProcessPickupRangesEnum = {
    NoRange: 'NO_RANGE',
    Range8To12: 'RANGE_8_TO_12',
    Range12To16: 'RANGE_12_TO_16',
    Range16To20: 'RANGE_16_TO_20'
} as const;

export type ModelsReturnProcessPickupRangesEnum = typeof ModelsReturnProcessPickupRangesEnum[keyof typeof ModelsReturnProcessPickupRangesEnum];
export const ModelsReturnProcessPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type ModelsReturnProcessPlatformEnum = typeof ModelsReturnProcessPlatformEnum[keyof typeof ModelsReturnProcessPlatformEnum];
export const ModelsReturnProcessRefundTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type ModelsReturnProcessRefundTimingEnum = typeof ModelsReturnProcessRefundTimingEnum[keyof typeof ModelsReturnProcessRefundTimingEnum];
export const ModelsReturnProcessReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type ModelsReturnProcessReturnMethodEnum = typeof ModelsReturnProcessReturnMethodEnum[keyof typeof ModelsReturnProcessReturnMethodEnum];
export const ModelsReturnProcessStartReturnOnPlatformTimeEnum = {
    Unspecified: 'START_RETURN_ON_PLATFORM_TIME_UNSPECIFIED',
    OnStart: 'START_RETURN_ON_PLATFORM_TIME_ON_START',
    OnItemVerification: 'START_RETURN_ON_PLATFORM_TIME_ON_ITEM_VERIFICATION',
    Never: 'START_RETURN_ON_PLATFORM_TIME_NEVER'
} as const;

export type ModelsReturnProcessStartReturnOnPlatformTimeEnum = typeof ModelsReturnProcessStartReturnOnPlatformTimeEnum[keyof typeof ModelsReturnProcessStartReturnOnPlatformTimeEnum];
export const ModelsReturnProcessStatusEnum = {
    Running: 'RUNNING',
    Failed: 'FAILED',
    Completed: 'COMPLETED',
    OnHold: 'ON_HOLD',
    ReturnStatusCanceled: 'RETURN_STATUS_CANCELED'
} as const;

export type ModelsReturnProcessStatusEnum = typeof ModelsReturnProcessStatusEnum[keyof typeof ModelsReturnProcessStatusEnum];

/**
 * 
 * @export
 * @interface ModelsShipment
 */
export interface ModelsShipment {
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'delivery_date'?: string;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsShipment
     */
    'from'?: ModelsAddress;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsShipment
     */
    'is_without_label'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'logistic_order_id'?: string;
    /**
     * 
     * @type {Array<ModelsPackage>}
     * @memberof ModelsShipment
     */
    'packages'?: Array<ModelsPackage>;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'process_id'?: string;
    /**
     * Provider\'s own id for this shipment (e.g. the Sendcloud parcel id), what cancel and  document calls need.
     * @type {string}
     * @memberof ModelsShipment
     */
    'provider_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'shipment_type'?: ModelsShipmentShipmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'status'?: string;
    /**
     * 
     * @type {ModelsAddress}
     * @memberof ModelsShipment
     */
    'to'?: ModelsAddress;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'tracking_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'tracking_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelsShipment
     */
    'updated_at'?: string;
}

export const ModelsShipmentShipmentTypeEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type ModelsShipmentShipmentTypeEnum = typeof ModelsShipmentShipmentTypeEnum[keyof typeof ModelsShipmentShipmentTypeEnum];

/**
 * Transaction   @Description model of a transaction executed in a third party  provider associated to a return process  @name api.Transaction
 * @export
 * @interface ModelsTransaction
 */
export interface ModelsTransaction {
    /**
     * Amount following MoneyFormat
     * @type {string}
     * @memberof ModelsTransaction
     */
    'amount'?: string;
    /**
     * Should we include the user? it\'s the one coming from the return process  When the transaction started its execution
     * @type {string}
     * @memberof ModelsTransaction
     */
    'created_at'?: string;
    /**
     * Currency
     * @type {string}
     * @memberof ModelsTransaction
     */
    'currency'?: string;
    /**
     * Metadata associated to the transaction
     * @type {object}
     * @memberof ModelsTransaction
     */
    'metadata'?: object;
    /**
     * Description/notes associated
     * @type {string}
     * @memberof ModelsTransaction
     */
    'note'?: string;
    /**
     * Links a TX_COMPLETED / TX_FAILED confirmation record back to  the original TX_IN_PROGRESS entry for the same async refund.
     * @type {string}
     * @memberof ModelsTransaction
     */
    'parent_transaction_id'?: string;
    /**
     * Identifier of the transaction in the provider  Examples: the order_id when an excahnge is created,   or the tracking_id when the shipping is created
     * @type {string}
     * @memberof ModelsTransaction
     */
    'platform_id'?: string;
    /**
     * URL associated to this transaction in the external system  Examples: tracking_url of a shipment
     * @type {string}
     * @memberof ModelsTransaction
     */
    'platform_url'?: string;
    /**
     * Rever Return Process associated to this transaction (can only be one)
     * @type {string}
     * @memberof ModelsTransaction
     */
    'process_id'?: string;
    /**
     * Provider of the transaction (where we execute the transaction)  Example: if it\'s an exchange, it\'s the e-commerce platform like SHOPIFY. Same for  refunding on original payment method  Other values could be: BIZUM, REVOLUT, STRIPE....
     * @type {string}
     * @memberof ModelsTransaction
     */
    'provider'?: ModelsTransactionProviderEnum;
    /**
     * Payment method associated (only when action == TO_REFUND)
     * @type {string}
     * @memberof ModelsTransaction
     */
    'refund_payment_method'?: ModelsTransactionRefundPaymentMethodEnum;
    /**
     * Unique ID in the rever platform   Should start with tx_
     * @type {string}
     * @memberof ModelsTransaction
     */
    'rever_id'?: string;
    /**
     * Status of the transaction. Only consider COMPLETED as successful
     * @type {string}
     * @memberof ModelsTransaction
     */
    'status'?: ModelsTransactionStatusEnum;
    /**
     * Type of transaction (exchange operation, refund operation....)
     * @type {string}
     * @memberof ModelsTransaction
     */
    'type'?: ModelsTransactionTypeEnum;
    /**
     * Time of the last update (status might have changed  for example, from IN_PROGRESS to COMPLETED)
     * @type {string}
     * @memberof ModelsTransaction
     */
    'updated_at'?: string;
    /**
     * Who executed it
     * @type {string}
     * @memberof ModelsTransaction
     */
    'user'?: string;
}

export const ModelsTransactionProviderEnum = {
    Mock: 'TXPROVIDER_MOCK',
    Woocommerce: 'TXPROVIDER_WOOCOMMERCE',
    Shopify: 'TXPROVIDER_SHOPIFY',
    CustomGeneric: 'TXPROVIDER_CUSTOM_GENERIC',
    Prestashop: 'TXPROVIDER_PRESTASHOP',
    MagentoV1: 'TXPROVIDER_MAGENTO_V1',
    MagentoV2: 'TXPROVIDER_MAGENTO_V2',
    Salesforce: 'TXPROVIDER_SALESFORCE',
    Revolut: 'TXPROVIDER_REVOLUT',
    Stripe: 'TXPROVIDER_STRIPE',
    Sendcloud: 'TXPROVIDER_SENDCLOUD',
    Correos: 'TXPROVIDER_CORREOS',
    CorreosExpress: 'TXPROVIDER_CORREOS_EXPRESS',
    ShippyPro: 'TXPROVIDER_SHIPPY_PRO',
    Ups: 'TXPROVIDER_UPS',
    Gls: 'TXPROVIDER_GLS',
    Dhl: 'TXPROVIDER_DHL',
    DhlExpress: 'TXPROVIDER_DHL_EXPRESS',
    DhlParcel: 'TXPROVIDER_DHL_PARCEL',
    Rhenus: 'TXPROVIDER_RHENUS',
    Fedex: 'TXPROVIDER_FEDEX',
    Zeleris: 'TXPROVIDER_ZELERIS',
    SendcloudEcommerce: 'TXPROVIDER_SENDCLOUD_ECOMMERCE',
    Enovo: 'TXPROVIDER_ENOVO',
    Zelo: 'TXPROVIDER_ZELO',
    Colissimo: 'TXPROVIDER_COLISSIMO',
    Ctt: 'TXPROVIDER_CTT',
    Monta: 'TXPROVIDER_MONTA',
    Brt: 'TXPROVIDER_BRT',
    Esendeo: 'TXPROVIDER_ESENDEO',
    Estafeta: 'TXPROVIDER_ESTAFETA',
    Chronopost: 'TXPROVIDER_CHRONOPOST',
    Canadapost: 'TXPROVIDER_CANADAPOST',
    Inpost: 'TXPROVIDER_INPOST',
    Packeta: 'TXPROVIDER_PACKETA',
    Dpd: 'TXPROVIDER_DPD',
    Mondialrelay: 'TXPROVIDER_MONDIALRELAY',
    Easypost: 'TXPROVIDER_EASYPOST',
    Flexport: 'TXPROVIDER_FLEXPORT',
    Tamdis: 'TXPROVIDER_TAMDIS',
    Seur: 'TXPROVIDER_SEUR',
    Cttportugal: 'TXPROVIDER_CTTPORTUGAL',
    Tnt: 'TXPROVIDER_TNT',
    Dhleconnect: 'TXPROVIDER_DHLECONNECT',
    Dhlbenelux: 'TXPROVIDER_DHLBENELUX',
    Swisspost: 'TXPROVIDER_SWISSPOST',
    Dpdportugal: 'TXPROVIDER_DPDPORTUGAL',
    Mbe: 'TXPROVIDER_MBE',
    Globale: 'TXPROVIDER_GLOBALE',
    Amphora: 'TXPROVIDER_AMPHORA',
    Dpdireland: 'TXPROVIDER_DPDIRELAND',
    Innosend: 'TXPROVIDER_INNOSEND',
    Exporto: 'TXPROVIDER_EXPORTO',
    Royalmail: 'TXPROVIDER_ROYALMAIL',
    Glsitaly: 'TXPROVIDER_GLSITALY',
    Glsczech: 'TXPROVIDER_GLSCZECH',
    Bigblue: 'TXPROVIDER_BIGBLUE',
    Myparcel: 'TXPROVIDER_MYPARCEL',
    Boardriders: 'TXPROVIDER_BOARDRIDERS',
    Glsshopreturns: 'TXPROVIDER_GLSSHOPRETURNS',
    None: 'TXPROVIDER_NONE'
} as const;

export type ModelsTransactionProviderEnum = typeof ModelsTransactionProviderEnum[keyof typeof ModelsTransactionProviderEnum];
export const ModelsTransactionRefundPaymentMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type ModelsTransactionRefundPaymentMethodEnum = typeof ModelsTransactionRefundPaymentMethodEnum[keyof typeof ModelsTransactionRefundPaymentMethodEnum];
export const ModelsTransactionStatusEnum = {
    NoTransactionStatus: 'NO_TRANSACTION_STATUS',
    TxCompleted: 'TX_COMPLETED',
    TxDenied: 'TX_DENIED',
    TxInProgress: 'TX_IN_PROGRESS',
    TxError: 'TX_ERROR',
    TxCanceled: 'TX_CANCELED',
    TxFailed: 'TX_FAILED'
} as const;

export type ModelsTransactionStatusEnum = typeof ModelsTransactionStatusEnum[keyof typeof ModelsTransactionStatusEnum];
export const ModelsTransactionTypeEnum = {
    Unknown: 'TXTYPE_UNKNOWN',
    Refund: 'TXTYPE_REFUND',
    Exchange: 'TXTYPE_EXCHANGE',
    Logistics: 'TXTYPE_LOGISTICS',
    Return: 'TXTYPE_RETURN',
    Pickup: 'TXTYPE_PICKUP',
    Commit: 'TXTYPE_COMMIT',
    Lost: 'TXTYPE_LOST',
    Payment: 'TXTYPE_PAYMENT',
    CommitPayment: 'TXTYPE_COMMIT_PAYMENT',
    CommitExchange: 'TXTYPE_COMMIT_EXCHANGE'
} as const;

export type ModelsTransactionTypeEnum = typeof ModelsTransactionTypeEnum[keyof typeof ModelsTransactionTypeEnum];

/**
 * Request for AddTheBraderyBrandTag.
 * @export
 * @interface OpspbAddTheBraderyBrandTagRequest
 */
export interface OpspbAddTheBraderyBrandTagRequest {
    /**
     * Shopify product tag to add to the brand; letters, digits and underscores only
     * @type {string}
     * @memberof OpspbAddTheBraderyBrandTagRequest
     */
    'new_tag'?: string;
    /**
     * Any Shopify product tag the brand already has
     * @type {string}
     * @memberof OpspbAddTheBraderyBrandTagRequest
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface OpspbBatchMarkAsRefundedExternallyError
 */
export interface OpspbBatchMarkAsRefundedExternallyError {
    /**
     * Error message describing the failure
     * @type {string}
     * @memberof OpspbBatchMarkAsRefundedExternallyError
     */
    'error_message'?: string;
    /**
     * Process ID that failed
     * @type {string}
     * @memberof OpspbBatchMarkAsRefundedExternallyError
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface OpspbBatchMarkAsRefundedExternallyRequest
 */
export interface OpspbBatchMarkAsRefundedExternallyRequest {
    /**
     * Note explaining the reason for the manual refund (shared across all processes)
     * @type {string}
     * @memberof OpspbBatchMarkAsRefundedExternallyRequest
     */
    'note': string;
    /**
     * List of process IDs to mark as refunded externally
     * @type {Array<string>}
     * @memberof OpspbBatchMarkAsRefundedExternallyRequest
     */
    'process_ids': Array<string>;
    /**
     * Delay in milliseconds between processing each process (default: 500ms)
     * @type {number}
     * @memberof OpspbBatchMarkAsRefundedExternallyRequest
     */
    'wait_between_ms'?: number;
}
/**
 * 
 * @export
 * @interface OpspbBatchMarkAsRefundedExternallyResponse
 */
export interface OpspbBatchMarkAsRefundedExternallyResponse {
    /**
     * List of processes that failed with their error details
     * @type {Array<OpspbBatchMarkAsRefundedExternallyError>}
     * @memberof OpspbBatchMarkAsRefundedExternallyResponse
     */
    'errors'?: Array<OpspbBatchMarkAsRefundedExternallyError>;
    /**
     * Number of processes successfully marked as refunded
     * @type {number}
     * @memberof OpspbBatchMarkAsRefundedExternallyResponse
     */
    'successful_count'?: number;
}
/**
 * 
 * @export
 * @interface OpspbBatchTriggerReturnCompletedWebhookError
 */
export interface OpspbBatchTriggerReturnCompletedWebhookError {
    /**
     * Error message describing the failure
     * @type {string}
     * @memberof OpspbBatchTriggerReturnCompletedWebhookError
     */
    'error_message'?: string;
    /**
     * Process ID that failed
     * @type {string}
     * @memberof OpspbBatchTriggerReturnCompletedWebhookError
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface OpspbBatchTriggerReturnCompletedWebhookRequest
 */
export interface OpspbBatchTriggerReturnCompletedWebhookRequest {
    /**
     * List of process IDs to trigger the return completed webhook for
     * @type {Array<string>}
     * @memberof OpspbBatchTriggerReturnCompletedWebhookRequest
     */
    'process_ids': Array<string>;
    /**
     * Delay in milliseconds between processing each process.  Values <= 0 are ignored and the default of 500ms is used.
     * @type {number}
     * @memberof OpspbBatchTriggerReturnCompletedWebhookRequest
     */
    'wait_between_ms'?: number;
}
/**
 * 
 * @export
 * @interface OpspbBatchTriggerReturnCompletedWebhookResponse
 */
export interface OpspbBatchTriggerReturnCompletedWebhookResponse {
    /**
     * List of processes that failed with their error details
     * @type {Array<OpspbBatchTriggerReturnCompletedWebhookError>}
     * @memberof OpspbBatchTriggerReturnCompletedWebhookResponse
     */
    'errors'?: Array<OpspbBatchTriggerReturnCompletedWebhookError>;
    /**
     * Number of processes that successfully triggered the webhook
     * @type {number}
     * @memberof OpspbBatchTriggerReturnCompletedWebhookResponse
     */
    'successful_count'?: number;
}
/**
 * 
 * @export
 * @interface OpspbBatchTriggerWebhookError
 */
export interface OpspbBatchTriggerWebhookError {
    /**
     * Error message describing the failure
     * @type {string}
     * @memberof OpspbBatchTriggerWebhookError
     */
    'error_message'?: string;
    /**
     * Process ID that failed
     * @type {string}
     * @memberof OpspbBatchTriggerWebhookError
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface OpspbBatchTriggerWebhookRequest
 */
export interface OpspbBatchTriggerWebhookRequest {
    /**
     * List of process IDs to trigger the webhook for
     * @type {Array<string>}
     * @memberof OpspbBatchTriggerWebhookRequest
     */
    'process_ids': Array<string>;
    /**
     * Delay in milliseconds between processing each process.  Values <= 0 are ignored and the default of 500ms is used.
     * @type {number}
     * @memberof OpspbBatchTriggerWebhookRequest
     */
    'wait_between_ms'?: number;
    /**
     * The webhook to trigger for each process.
     * @type {string}
     * @memberof OpspbBatchTriggerWebhookRequest
     */
    'webhook_type'?: OpspbBatchTriggerWebhookRequestWebhookTypeEnum;
}

export const OpspbBatchTriggerWebhookRequestWebhookTypeEnum = {
    OnComplete: 'ON_COMPLETE',
    UpdateAlvaromorenoCustomField: 'UPDATE_ALVAROMORENO_CUSTOM_FIELD',
    OnCompleteEvent: 'ON_COMPLETE_EVENT'
} as const;

export type OpspbBatchTriggerWebhookRequestWebhookTypeEnum = typeof OpspbBatchTriggerWebhookRequestWebhookTypeEnum[keyof typeof OpspbBatchTriggerWebhookRequestWebhookTypeEnum];

/**
 * 
 * @export
 * @interface OpspbBatchTriggerWebhookResponse
 */
export interface OpspbBatchTriggerWebhookResponse {
    /**
     * List of processes that failed with their error details
     * @type {Array<OpspbBatchTriggerWebhookError>}
     * @memberof OpspbBatchTriggerWebhookResponse
     */
    'errors'?: Array<OpspbBatchTriggerWebhookError>;
    /**
     * Number of processes that successfully triggered the webhook
     * @type {number}
     * @memberof OpspbBatchTriggerWebhookResponse
     */
    'successful_count'?: number;
}
/**
 * 
 * @export
 * @interface OpspbCancelInternalRequest
 */
export interface OpspbCancelInternalRequest {
    /**
     * 
     * @type {string}
     * @memberof OpspbCancelInternalRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbCancelInternalRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbCancelInternalRequest
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface OpspbCancelRequest
 */
export interface OpspbCancelRequest {
    /**
     * 
     * @type {string}
     * @memberof OpspbCancelRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbCancelRequest
     */
    'reason'?: string;
}
/**
 * Request to confirm or fail a pending async refund transaction.
 * @export
 * @interface OpspbConfirmRefundTransactionRequest
 */
export interface OpspbConfirmRefundTransactionRequest {
    /**
     * Executed amount as a decimal string in the transaction\'s currency (e.g. \"51.94\").  Optional; defaults to the pending transaction\'s amount.
     * @type {string}
     * @memberof OpspbConfirmRefundTransactionRequest
     */
    'executed_amount'?: string;
    /**
     * Optional metadata from the merchant (e.g. merchant refund ID, pipeline)
     * @type {{ [key: string]: string; }}
     * @memberof OpspbConfirmRefundTransactionRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * Merchant\'s id for the executed refund, stored as the confirmation row\'s platform_id.  Optional; defaults to the pending transaction\'s platform_id.
     * @type {string}
     * @memberof OpspbConfirmRefundTransactionRequest
     */
    'platform_transaction_id'?: string;
    /**
     * Process the transaction must belong to. Optional; when set and different from the  transaction\'s process the request is rejected with FAILED_PRECONDITION.
     * @type {string}
     * @memberof OpspbConfirmRefundTransactionRequest
     */
    'process_id'?: string;
    /**
     * TX_COMPLETED on success, TX_FAILED on merchant rejection
     * @type {string}
     * @memberof OpspbConfirmRefundTransactionRequest
     */
    'status'?: OpspbConfirmRefundTransactionRequestStatusEnum;
    /**
     * Rever transaction ID of the pending TX_IN_PROGRESS record
     * @type {string}
     * @memberof OpspbConfirmRefundTransactionRequest
     */
    'transaction_id'?: string;
}

export const OpspbConfirmRefundTransactionRequestStatusEnum = {
    NoTransactionStatus: 'NO_TRANSACTION_STATUS',
    TxCompleted: 'TX_COMPLETED',
    TxDenied: 'TX_DENIED',
    TxInProgress: 'TX_IN_PROGRESS',
    TxError: 'TX_ERROR',
    TxCanceled: 'TX_CANCELED',
    TxFailed: 'TX_FAILED'
} as const;

export type OpspbConfirmRefundTransactionRequestStatusEnum = typeof OpspbConfirmRefundTransactionRequestStatusEnum[keyof typeof OpspbConfirmRefundTransactionRequestStatusEnum];

/**
 * Request for CreateTheBraderyBrand.
 * @export
 * @interface OpspbCreateTheBraderyBrandRequest
 */
export interface OpspbCreateTheBraderyBrandRequest {
    /**
     * Shopify product tag of the brand\'s products; letters, digits and underscores only
     * @type {string}
     * @memberof OpspbCreateTheBraderyBrandRequest
     */
    'tag'?: string;
    /**
     * Warehouse the brand\'s returns are sent to; its email is the brand\'s dashboard login
     * @type {OpspbTheBraderyWarehouse}
     * @memberof OpspbCreateTheBraderyBrandRequest
     */
    'warehouse'?: OpspbTheBraderyWarehouse;
}
/**
 * 
 * @export
 * @interface OpspbEcommerceAudit
 */
export interface OpspbEcommerceAudit {
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'entity'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbEcommerceAudit
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface OpspbEcommerceAuditRequest
 */
export interface OpspbEcommerceAuditRequest {
    /**
     * ecommerce whose audit events, and its group\'s, are returned
     * @type {string}
     * @memberof OpspbEcommerceAuditRequest
     */
    'ecommerce_id'?: string;
    /**
     * optional start of the window; defaults to 30 days before `to`
     * @type {string}
     * @memberof OpspbEcommerceAuditRequest
     */
    'from'?: string;
    /**
     * fail instead of returning only the ecommerce\'s own events when its group cannot be resolved
     * @type {boolean}
     * @memberof OpspbEcommerceAuditRequest
     */
    'require_group'?: boolean;
    /**
     * optional end of the window; defaults to now
     * @type {string}
     * @memberof OpspbEcommerceAuditRequest
     */
    'to'?: string;
}
/**
 * 
 * @export
 * @interface OpspbEcommerceAuditResponse
 */
export interface OpspbEcommerceAuditResponse {
    /**
     * 
     * @type {Array<OpspbEcommerceAudit>}
     * @memberof OpspbEcommerceAuditResponse
     */
    'audits'?: Array<OpspbEcommerceAudit>;
}
/**
 * 
 * @export
 * @interface OpspbItemReviewGeneric
 */
export interface OpspbItemReviewGeneric {
    /**
     * Item being reviewed: the REVER line item id, the e-commerce platform\'s line item id or the  product SKU. Either this or `sku` is required.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'line_item_id'?: string;
    /**
     * E-commerce platform location to restock the unit at. Used only when `should_restock` is true.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'location_id'?: string;
    /**
     * Why the unit was rejected. Required when `status` is `DECLINED`, ignored otherwise.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'reject_reason'?: string;
    /**
     * When true, REVER restocks one unit of this item in the e-commerce platform at `location_id`.
     * @type {boolean}
     * @memberof OpspbItemReviewGeneric
     */
    'should_restock'?: boolean;
    /**
     * Product SKU of the item being reviewed. Alternative to `line_item_id`, matched against the  platform line item id or the product SKU.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'sku'?: string;
    /**
     * Outcome of the review, case-sensitive. It decides the refund and the emails the customer receives.  - `APPROVED`: the unit was received and accepted.  - `DECLINED`: the unit was received and rejected. Requires `reject_reason`.  - `MISSING`: the unit was expected but not received.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'status': OpspbItemReviewGenericStatusEnum;
    /**
     * Ignored. REVER records the time it saves the review.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'timestamp'?: string;
    /**
     * Ignored. Reviews are attributed to the user of the API key.
     * @type {string}
     * @memberof OpspbItemReviewGeneric
     */
    'user'?: string;
}

export const OpspbItemReviewGenericStatusEnum = {
    Approved: 'APPROVED',
    Declined: 'DECLINED',
    Missing: 'MISSING'
} as const;

export type OpspbItemReviewGenericStatusEnum = typeof OpspbItemReviewGenericStatusEnum[keyof typeof OpspbItemReviewGenericStatusEnum];

/**
 * 
 * @export
 * @interface OpspbJiraRequest
 */
export interface OpspbJiraRequest {
    /**
     * optional operator note used as the ticket description
     * @type {string}
     * @memberof OpspbJiraRequest
     */
    'message'?: string;
    /**
     * optional on-hold occurrence to file the ticket for; when empty every parked branch answers
     * @type {string}
     * @memberof OpspbJiraRequest
     */
    'on_hold_id'?: string;
    /**
     * return process whose on-hold workflow files the ticket
     * @type {string}
     * @memberof OpspbJiraRequest
     */
    'process_id'?: string;
    /**
     * workflow to signal; when empty it is resolved from the process\'s on-hold workflows
     * @type {string}
     * @memberof OpspbJiraRequest
     */
    'workflow_id'?: string;
}
/**
 * Response for ListTheBraderyBrands.
 * @export
 * @interface OpspbListTheBraderyBrandsResponse
 */
export interface OpspbListTheBraderyBrandsResponse {
    /**
     * Brands, in the order the main store routes them
     * @type {Array<OpspbTheBraderyBrand>}
     * @memberof OpspbListTheBraderyBrandsResponse
     */
    'brands'?: Array<OpspbTheBraderyBrand>;
}
/**
 * 
 * @export
 * @interface OpspbLogisticsRequest
 */
export interface OpspbLogisticsRequest {
    /**
     * When true, re-trigger (or first-create) logistics even if no logistic order exists yet.  Operator override for stuck processes; still refused while GenerateLogisticOrder is ON_HOLD.
     * @type {boolean}
     * @memberof OpspbLogisticsRequest
     */
    'force'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpspbLogisticsRequest
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface OpspbMarkAsRefundedExternallyRequest
 */
export interface OpspbMarkAsRefundedExternallyRequest {
    /**
     * Optional: override the refund amount (if not provided, uses pending amount)
     * @type {OpspbOpsMoney}
     * @memberof OpspbMarkAsRefundedExternallyRequest
     */
    'amount_override'?: OpspbOpsMoney;
    /**
     * Note explaining the reason for the manual refund
     * @type {string}
     * @memberof OpspbMarkAsRefundedExternallyRequest
     */
    'note': string;
    /**
     * Process ID to mark as refunded
     * @type {string}
     * @memberof OpspbMarkAsRefundedExternallyRequest
     */
    'process_id': string;
}
/**
 * 
 * @export
 * @interface OpspbOpsMoney
 */
export interface OpspbOpsMoney {
    /**
     * Amount as a decimal string.
     * @type {string}
     * @memberof OpspbOpsMoney
     */
    'amount'?: string;
    /**
     * ISO 4217 currency code.
     * @type {string}
     * @memberof OpspbOpsMoney
     */
    'currency_code'?: string;
}
/**
 * Refund amount to use instead of the one REVER calculated.
 * @export
 * @interface OpspbRefundOverride
 */
export interface OpspbRefundOverride {
    /**
     * Amount to refund. Must be in the currency of the return process.
     * @type {OpspbOpsMoney}
     * @memberof OpspbRefundOverride
     */
    'amount'?: OpspbOpsMoney;
    /**
     * Why the refund amount is being changed.
     * @type {string}
     * @memberof OpspbRefundOverride
     */
    'reason'?: string;
    /**
     * Set to true to apply the override. When false, the rest of the override is ignored.
     * @type {boolean}
     * @memberof OpspbRefundOverride
     */
    'requested'?: boolean;
}
/**
 * Refund amount to use instead of the one REVER calculated.
 * @export
 * @interface OpspbRefundOverrideGeneric
 */
export interface OpspbRefundOverrideGeneric {
    /**
     * Amount to refund. Required when `requested` is true.
     * @type {OpspbRefundOverrideGenericAmount}
     * @memberof OpspbRefundOverrideGeneric
     */
    'amount'?: OpspbRefundOverrideGenericAmount;
    /**
     * Why the refund amount is being changed.
     * @type {string}
     * @memberof OpspbRefundOverrideGeneric
     */
    'reason'?: string;
    /**
     * Set to true to apply the override. When false, the rest of the override is ignored.
     * @type {boolean}
     * @memberof OpspbRefundOverrideGeneric
     */
    'requested'?: boolean;
}
/**
 * 
 * @export
 * @interface OpspbRefundOverrideGenericAmount
 */
export interface OpspbRefundOverrideGenericAmount {
    /**
     * Amount in minor currency units, as an integer string: \"1200\" is 12.00 EUR. It cannot be  negative or above the amount that can be refunded for the process.
     * @type {string}
     * @memberof OpspbRefundOverrideGenericAmount
     */
    'amount'?: string;
    /**
     * ISO 4217 currency code. Must be the currency of the return process.
     * @type {string}
     * @memberof OpspbRefundOverrideGenericAmount
     */
    'currency_code'?: string;
}
/**
 * 
 * @export
 * @interface OpspbRestockItem
 */
export interface OpspbRestockItem {
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItem
     */
    'line_item_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItem
     */
    'location_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItem
     */
    'product_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OpspbRestockItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItem
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface OpspbRestockItemsRequest
 */
export interface OpspbRestockItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItemsRequest
     */
    'ecommerce_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItemsRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {Array<OpspbRestockItem>}
     * @memberof OpspbRestockItemsRequest
     */
    'restock_items'?: Array<OpspbRestockItem>;
    /**
     * 
     * @type {string}
     * @memberof OpspbRestockItemsRequest
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface OpspbReview
 */
export interface OpspbReview {
    /**
     * REVER id of the returned line item being reviewed.
     * @type {string}
     * @memberof OpspbReview
     */
    'line_item_id': string;
    /**
     * E-commerce platform location to restock the unit at. Used only when `should_restock` is true.
     * @type {string}
     * @memberof OpspbReview
     */
    'location_id'?: string;
    /**
     * Why the unit was rejected. Required when `status` is `DECLINED`, ignored otherwise.
     * @type {string}
     * @memberof OpspbReview
     */
    'reject_reason'?: string;
    /**
     * Ignored. REVER assigns the review id.
     * @type {string}
     * @memberof OpspbReview
     */
    'rever_id'?: string;
    /**
     * When true, REVER restocks one unit of this item in the e-commerce platform at `location_id`.
     * @type {boolean}
     * @memberof OpspbReview
     */
    'should_restock'?: boolean;
    /**
     * When true and `status` is `DECLINED`, the rejection email shows the customer `reject_reason`.
     * @type {boolean}
     * @memberof OpspbReview
     */
    'show_reject_reason'?: boolean;
    /**
     * Outcome of the review, case-sensitive. It decides the refund and the emails the customer receives.  - `APPROVED`: the unit was received and accepted.  - `DECLINED`: the unit was received and rejected. Requires `reject_reason`.  - `MISSING`: the unit was expected but not received.
     * @type {string}
     * @memberof OpspbReview
     */
    'status': string;
    /**
     * Ignored. REVER records the time it saves the review.
     * @type {string}
     * @memberof OpspbReview
     */
    'timestamp'?: string;
    /**
     * Ignored. Reviews are attributed to the caller.
     * @type {string}
     * @memberof OpspbReview
     */
    'user'?: string;
}
/**
 * Request to review a specific line item identified by order ID and SKU.  Example: order_id=\"ORD-12345\" sku=\"SKU-001\" ecommerce_id=\"bershka\" refundable_status=\"Refundable\"
 * @export
 * @interface OpspbReviewItemByOrderSKURequest
 */
export interface OpspbReviewItemByOrderSKURequest {
    /**
     * Ecommerce platform identifier used to scope the order lookup.  Example: \"bershka\"
     * @type {string}
     * @memberof OpspbReviewItemByOrderSKURequest
     */
    'ecommerce_id'?: string;
    /**
     * Platform order ID used to locate the return process.  Example: \"ORD-12345\"
     * @type {string}
     * @memberof OpspbReviewItemByOrderSKURequest
     */
    'order_id'?: string;
    /**
     * Refundable status from the review system.  Accepted values: \"Refundable\" (maps to APPROVED), \"Non refundable\" (maps to DECLINED),  any other value maps to MISSING.
     * @type {string}
     * @memberof OpspbReviewItemByOrderSKURequest
     */
    'refundable_status'?: string;
    /**
     * Product SKU identifying the specific line item within the order.  Example: \"SKU-001\"
     * @type {string}
     * @memberof OpspbReviewItemByOrderSKURequest
     */
    'sku'?: string;
}
/**
 * Response for ReviewItemByOrderSKU.
 * @export
 * @interface OpspbReviewItemByOrderSKUResponse
 */
export interface OpspbReviewItemByOrderSKUResponse {
    /**
     * True when the line item was found and the review was submitted successfully.  False when no matching line item was found (graceful skip — not an error).
     * @type {boolean}
     * @memberof OpspbReviewItemByOrderSKUResponse
     */
    'processed'?: boolean;
}
/**
 * 
 * @export
 * @interface OpspbReviewItemsGenericRequest
 */
export interface OpspbReviewItemsGenericRequest {
    /**
     * When true, REVER also approves the process\'s pending authorization once the reviews are  accepted. The refund override is not applied to that authorization.
     * @type {boolean}
     * @memberof OpspbReviewItemsGenericRequest
     */
    'override_authorization'?: boolean;
    /**
     * Deprecated: use `process_id`. Read when `process_id` is empty, and must also hold the REVER  process id: a platform order or return id is not found.
     * @type {string}
     * @memberof OpspbReviewItemsGenericRequest
     */
    'platform_process_id'?: string;
    /**
     * REVER id of the return process being reviewed. Required unless the deprecated  `platform_process_id` is set.
     * @type {string}
     * @memberof OpspbReviewItemsGenericRequest
     */
    'process_id'?: string;
    /**
     * Optional. Changes the amount REVER refunds for this process.
     * @type {OpspbRefundOverrideGeneric}
     * @memberof OpspbReviewItemsGenericRequest
     */
    'refund_override'?: OpspbRefundOverrideGeneric;
    /**
     * One review per returned unit. An item returned with quantity 2 needs two reviews.
     * @type {Array<OpspbItemReviewGeneric>}
     * @memberof OpspbReviewItemsGenericRequest
     */
    'reviews': Array<OpspbItemReviewGeneric>;
}
/**
 * 
 * @export
 * @interface OpspbReviewItemsInternalRequest
 */
export interface OpspbReviewItemsInternalRequest {
    /**
     * Return process whose items are being reviewed.
     * @type {string}
     * @memberof OpspbReviewItemsInternalRequest
     */
    'process_id'?: string;
    /**
     * Optional refund amount override.
     * @type {OpspbRefundOverride}
     * @memberof OpspbReviewItemsInternalRequest
     */
    'refund_override'?: OpspbRefundOverride;
    /**
     * Reviews to be processed, one per returned unit.
     * @type {Array<OpspbReview>}
     * @memberof OpspbReviewItemsInternalRequest
     */
    'reviews'?: Array<OpspbReview>;
    /**
     * User the reviews are attributed to. Overrides the user on each review, exactly as the  username claim does on the public RPC, which an internal caller does not have.
     * @type {string}
     * @memberof OpspbReviewItemsInternalRequest
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface OpspbReviewItemsRequest
 */
export interface OpspbReviewItemsRequest {
    /**
     * REVER id of the return process being reviewed.
     * @type {string}
     * @memberof OpspbReviewItemsRequest
     */
    'process_id': string;
    /**
     * Optional. Changes the amount REVER refunds for this process. The amount is a decimal  string in major currency units (\"12.50\" is 12.50 EUR), and an empty amount means 0.
     * @type {OpspbRefundOverride}
     * @memberof OpspbReviewItemsRequest
     */
    'refund_override'?: OpspbRefundOverride;
    /**
     * One review per returned unit. An item returned with quantity 2 needs two reviews.
     * @type {Array<OpspbReview>}
     * @memberof OpspbReviewItemsRequest
     */
    'reviews': Array<OpspbReview>;
}
/**
 * Request to send a CSAT survey email for a completed return process.
 * @export
 * @interface OpspbSendCSATInternalRequest
 */
export interface OpspbSendCSATInternalRequest {
    /**
     * Return process ID.
     * @type {string}
     * @memberof OpspbSendCSATInternalRequest
     */
    'process_id': string;
}
/**
 * Response for SendCSATInternal.
 * @export
 * @interface OpspbSendCSATInternalResponse
 */
export interface OpspbSendCSATInternalResponse {
    /**
     * Populated when the email was intentionally skipped (e.g. outside sending hours).
     * @type {string}
     * @memberof OpspbSendCSATInternalResponse
     */
    'reason'?: string;
    /**
     * True when the email was dispatched.
     * @type {boolean}
     * @memberof OpspbSendCSATInternalResponse
     */
    'sent'?: boolean;
}
/**
 * 
 * @export
 * @interface OpspbSignalFailRequest
 */
export interface OpspbSignalFailRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OpspbSignalFailRequest
     */
    'process_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OpspbSignalFailResponse
 */
export interface OpspbSignalFailResponse {
    /**
     * 
     * @type {Array<OpspbSignalWorkflowError>}
     * @memberof OpspbSignalFailResponse
     */
    'errors'?: Array<OpspbSignalWorkflowError>;
}
/**
 * 
 * @export
 * @interface OpspbSignalWorkflowError
 */
export interface OpspbSignalWorkflowError {
    /**
     * 
     * @type {string}
     * @memberof OpspbSignalWorkflowError
     */
    'error_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbSignalWorkflowError
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface OpspbSoftDeleteRequest
 */
export interface OpspbSoftDeleteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OpspbSoftDeleteRequest
     */
    'process_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OpspbSubmitAuthorizationRequest
 */
export interface OpspbSubmitAuthorizationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof OpspbSubmitAuthorizationRequest
     */
    'authorized'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OpspbSubmitAuthorizationRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {OpspbRefundOverride}
     * @memberof OpspbSubmitAuthorizationRequest
     */
    'refund_override'?: OpspbRefundOverride;
    /**
     * 
     * @type {string}
     * @memberof OpspbSubmitAuthorizationRequest
     */
    'unauthorized_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbSubmitAuthorizationRequest
     */
    'user'?: string;
}
/**
 * TheBraderyBrand is the Shopify product tags The Bradery\'s stores route to a brand\'s warehouse
 * @export
 * @interface OpspbTheBraderyBrand
 */
export interface OpspbTheBraderyBrand {
    /**
     * Shopify product tag of the brand\'s products; the first of tags
     * @type {string}
     * @memberof OpspbTheBraderyBrand
     */
    'tag'?: string;
    /**
     * Every Shopify product tag routed to the brand\'s warehouse, one per sale, in the order the main store routes them
     * @type {Array<string>}
     * @memberof OpspbTheBraderyBrand
     */
    'tags'?: Array<string>;
    /**
     * Warehouse the brand\'s returns are sent to
     * @type {OpspbTheBraderyWarehouse}
     * @memberof OpspbTheBraderyBrand
     */
    'warehouse'?: OpspbTheBraderyWarehouse;
}
/**
 * TheBraderyWarehouse is the warehouse a The Bradery brand\'s returns are sent to
 * @export
 * @interface OpspbTheBraderyWarehouse
 */
export interface OpspbTheBraderyWarehouse {
    /**
     * First address line
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'address_line1'?: string;
    /**
     * Second address line
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'address_line2'?: string;
    /**
     * City
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'city'?: string;
    /**
     * Company
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'company'?: string;
    /**
     * Country
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'country'?: string;
    /**
     * ISO country code: FR or ES
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'country_code'?: string;
    /**
     * Contact email, which is also the brand\'s dashboard login
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'email'?: string;
    /**
     * Contact first name
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'first_name'?: string;
    /**
     * Warehouse id; set by the server
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'id'?: string;
    /**
     * Contact last name
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'last_name'?: string;
    /**
     * Contact phone, starting with + and the country code
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'phone'?: string;
    /**
     * Postcode
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'postcode'?: string;
    /**
     * State or province
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'state_province'?: string;
    /**
     * State or province code
     * @type {string}
     * @memberof OpspbTheBraderyWarehouse
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface OpspbTransitionLKSSInternalRequest
 */
export interface OpspbTransitionLKSSInternalRequest {
    /**
     * Target shipping status to transition to
     * @type {string}
     * @memberof OpspbTransitionLKSSInternalRequest
     */
    'lkss'?: OpspbTransitionLKSSInternalRequestLkssEnum;
    /**
     * Platform process ID, used when process_id is not provided
     * @type {string}
     * @memberof OpspbTransitionLKSSInternalRequest
     */
    'platform_process_id'?: string;
    /**
     * ID of the process whose shipping status should transition
     * @type {string}
     * @memberof OpspbTransitionLKSSInternalRequest
     */
    'process_id'?: string;
    /**
     * Actor performing the transition, recorded in the audit trail
     * @type {string}
     * @memberof OpspbTransitionLKSSInternalRequest
     */
    'user'?: string;
}

export const OpspbTransitionLKSSInternalRequestLkssEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type OpspbTransitionLKSSInternalRequestLkssEnum = typeof OpspbTransitionLKSSInternalRequestLkssEnum[keyof typeof OpspbTransitionLKSSInternalRequestLkssEnum];

/**
 * 
 * @export
 * @interface OpspbTransitionLKSSRequest
 */
export interface OpspbTransitionLKSSRequest {
    /**
     * Target shipping status to transition to
     * @type {string}
     * @memberof OpspbTransitionLKSSRequest
     */
    'lkss'?: OpspbTransitionLKSSRequestLkssEnum;
    /**
     * ID of the process whose shipping status should transition
     * @type {string}
     * @memberof OpspbTransitionLKSSRequest
     */
    'process_id'?: string;
    /**
     * Platform process ID, used when process_id is not provided
     * @type {string}
     * @memberof OpspbTransitionLKSSRequest
     */
    'process_platform_id'?: string;
}

export const OpspbTransitionLKSSRequestLkssEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type OpspbTransitionLKSSRequestLkssEnum = typeof OpspbTransitionLKSSRequestLkssEnum[keyof typeof OpspbTransitionLKSSRequestLkssEnum];

/**
 * 
 * @export
 * @interface OpspbTransitionLKSSResponse
 */
export interface OpspbTransitionLKSSResponse {
    /**
     * Shipping status after the request was processed (unchanged when not transitioned)
     * @type {string}
     * @memberof OpspbTransitionLKSSResponse
     */
    'current_status'?: OpspbTransitionLKSSResponseCurrentStatusEnum;
    /**
     * Shipping status before the request was processed
     * @type {string}
     * @memberof OpspbTransitionLKSSResponse
     */
    'previous_status'?: OpspbTransitionLKSSResponsePreviousStatusEnum;
    /**
     * True when the status changed; false when the transition was invalid and skipped
     * @type {boolean}
     * @memberof OpspbTransitionLKSSResponse
     */
    'transitioned'?: boolean;
}

export const OpspbTransitionLKSSResponseCurrentStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type OpspbTransitionLKSSResponseCurrentStatusEnum = typeof OpspbTransitionLKSSResponseCurrentStatusEnum[keyof typeof OpspbTransitionLKSSResponseCurrentStatusEnum];
export const OpspbTransitionLKSSResponsePreviousStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type OpspbTransitionLKSSResponsePreviousStatusEnum = typeof OpspbTransitionLKSSResponsePreviousStatusEnum[keyof typeof OpspbTransitionLKSSResponsePreviousStatusEnum];

/**
 * 
 * @export
 * @interface OpspbUpdateLKSSInternalRequest
 */
export interface OpspbUpdateLKSSInternalRequest {
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSInternalRequest
     */
    'lkss'?: OpspbUpdateLKSSInternalRequestLkssEnum;
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSInternalRequest
     */
    'platform_process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSInternalRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSInternalRequest
     */
    'user'?: string;
}

export const OpspbUpdateLKSSInternalRequestLkssEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type OpspbUpdateLKSSInternalRequestLkssEnum = typeof OpspbUpdateLKSSInternalRequestLkssEnum[keyof typeof OpspbUpdateLKSSInternalRequestLkssEnum];

/**
 * 
 * @export
 * @interface OpspbUpdateLKSSRequest
 */
export interface OpspbUpdateLKSSRequest {
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSRequest
     */
    'lkss'?: OpspbUpdateLKSSRequestLkssEnum;
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpspbUpdateLKSSRequest
     */
    'process_platform_id'?: string;
}

export const OpspbUpdateLKSSRequestLkssEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type OpspbUpdateLKSSRequestLkssEnum = typeof OpspbUpdateLKSSRequestLkssEnum[keyof typeof OpspbUpdateLKSSRequestLkssEnum];

/**
 * Request for UpdateTheBraderyBrandEmail.
 * @export
 * @interface OpspbUpdateTheBraderyBrandEmailRequest
 */
export interface OpspbUpdateTheBraderyBrandEmailRequest {
    /**
     * New email of the brand\'s warehouses and dashboard login
     * @type {string}
     * @memberof OpspbUpdateTheBraderyBrandEmailRequest
     */
    'email'?: string;
    /**
     * Shopify product tag of the brand
     * @type {string}
     * @memberof OpspbUpdateTheBraderyBrandEmailRequest
     */
    'tag'?: string;
}
/**
 * Ticket snapshot sent by the Zendesk trigger, as events-api forwards it.
 * @export
 * @interface OpspbUpsertZendeskTicketInternalRequest
 */
export interface OpspbUpsertZendeskTicketInternalRequest {
    /**
     * Zendesk ID of the assigned agent. Empty when unassigned.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'agent_id'?: string;
    /**
     * Contact reason custom field value.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'contact_reason'?: string;
    /**
     * Ticket creation time, RFC 3339.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'created_at': string;
    /**
     * Incidence type custom field value.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'incidence_type'?: string;
    /**
     * Return process ID from the ticket\'s process custom field. Empty when the ticket is not about a  return.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'process_id'?: string;
    /**
     * Email of the ticket requester.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'requester_email'?: string;
    /**
     * Requester type custom field value.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'requester_type'?: string;
    /**
     * Zendesk ticket status (new, open, pending, hold, solved, closed).
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'status': string;
    /**
     * Ticket subject.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'subject'?: string;
    /**
     * Zendesk ticket ID.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'ticket_id': string;
    /**
     * Time of the ticket update that fired the trigger, RFC 3339.
     * @type {string}
     * @memberof OpspbUpsertZendeskTicketInternalRequest
     */
    'updated_at': string;
}
/**
 * APIKey is the metadata of an API key. It never carries the key value.
 * @export
 * @interface PbAPIKey
 */
export interface PbAPIKey {
    /**
     * When the key was created
     * @type {string}
     * @memberof PbAPIKey
     */
    'created_at'?: string;
    /**
     * Who created the key. Empty on keys created before this was recorded, and on keys issued  by REVER.
     * @type {string}
     * @memberof PbAPIKey
     */
    'created_by'?: string;
    /**
     * Ecommerce group the key is issued for, as stored
     * @type {string}
     * @memberof PbAPIKey
     */
    'ecommerce_group'?: string;
    /**
     * Last time a request authenticated with the key, accurate to the hour. Unset if the key has  not been used since this started being recorded.
     * @type {string}
     * @memberof PbAPIKey
     */
    'last_used_at'?: string;
    /**
     * Name of the key, unique within its group. Together with the group it identifies the key.
     * @type {string}
     * @memberof PbAPIKey
     */
    'name'?: string;
    /**
     * Scopes granted to the key
     * @type {Array<string>}
     * @memberof PbAPIKey
     */
    'scopes'?: Array<string>;
}
/**
 * APIKeyCredentials contains API key for authentication
 * @export
 * @interface PbAPIKeyCredentials
 */
export interface PbAPIKeyCredentials {
    /**
     * API key for authentication
     * @type {string}
     * @memberof PbAPIKeyCredentials
     */
    'api_key'?: string;
}
/**
 * APIKeyGroup is an ecommerce group that holds API keys.
 * @export
 * @interface PbAPIKeyGroup
 */
export interface PbAPIKeyGroup {
    /**
     * Ecommerce group, as stored
     * @type {string}
     * @memberof PbAPIKeyGroup
     */
    'ecommerce_group'?: string;
    /**
     * How many keys the group holds
     * @type {number}
     * @memberof PbAPIKeyGroup
     */
    'key_count'?: number;
}
/**
 * APIKeyValueResponse carries the value of an API key.   The value field is a LIVE CREDENTIAL: callers must never log it, cache it, or forward it  to another system. Hand it to the requesting user and drop it.
 * @export
 * @interface PbAPIKeyValueResponse
 */
export interface PbAPIKeyValueResponse {
    /**
     * The key value
     * @type {string}
     * @memberof PbAPIKeyValueResponse
     */
    'value'?: string;
}
/**
 * ActionConfig
 * @export
 * @interface PbActionConfig
 */
export interface PbActionConfig {
    /**
     * Name
     * @type {string}
     * @memberof PbActionConfig
     */
    'name'?: string;
    /**
     * Timing
     * @type {string}
     * @memberof PbActionConfig
     */
    'timing'?: string;
    /**
     * Whens
     * @type {Array<string>}
     * @memberof PbActionConfig
     */
    'whens'?: Array<string>;
}
/**
 * AddAdjustmentRequest is the request to add an adjustment to a return process.
 * @export
 * @interface PbAddAdjustmentRequest
 */
export interface PbAddAdjustmentRequest {
    /**
     * The amount of the adjustment.
     * @type {number}
     * @memberof PbAddAdjustmentRequest
     */
    'amount'?: number;
    /**
     * The ID of the return process to add the adjustment to.
     * @type {string}
     * @memberof PbAddAdjustmentRequest
     */
    'process_id'?: string;
    /**
     * The reason for the adjustment.
     * @type {string}
     * @memberof PbAddAdjustmentRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface PbAddCommentInternalRequest
 */
export interface PbAddCommentInternalRequest {
    /**
     * 
     * @type {string}
     * @memberof PbAddCommentInternalRequest
     */
    'comment_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbAddCommentInternalRequest
     */
    'extra'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PbAddCommentInternalRequest
     */
    'manual'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PbAddCommentInternalRequest
     */
    'process_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbAddCommentInternalRequest
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbAddCommentInternalRequest
     */
    'user'?: string;
}
/**
 * Payload for creating a comment in the system.
 * @export
 * @interface PbAddCommentRequest
 */
export interface PbAddCommentRequest {
    /**
     * Comment type
     * @type {string}
     * @memberof PbAddCommentRequest
     */
    'comment_type'?: string;
    /**
     * Optional (extra) data associated to the comment
     * @type {string}
     * @memberof PbAddCommentRequest
     */
    'extra'?: string;
    /**
     * If the comment is created directly by a human or it\'s automated  Affects in how the comments are displayed
     * @type {boolean}
     * @memberof PbAddCommentRequest
     */
    'manual'?: boolean;
    /**
     * Process ID to associate the comment. Required.
     * @type {string}
     * @memberof PbAddCommentRequest
     */
    'process_id'?: string;
    /**
     * Comment\'s text. Required.
     * @type {string}
     * @memberof PbAddCommentRequest
     */
    'text'?: string;
}
/**
 * AddNewPASettingRequest contains the request to add a new setting to a section
 * @export
 * @interface PbAddNewPASettingRequest
 */
export interface PbAddNewPASettingRequest {
    /**
     * The new settings to be added
     * @type {Array<PbPANewSetting>}
     * @memberof PbAddNewPASettingRequest
     */
    'new_settings'?: Array<PbPANewSetting>;
    /**
     * The section where the new settigns will be added to
     * @type {string}
     * @memberof PbAddNewPASettingRequest
     */
    'section_name'?: string;
}
/**
 * TODO: this should have been AddNoteRequest  protolint:disable:next MESSAGE_NAMES_EXCLUDE_PREPOSITIONS
 * @export
 * @interface PbAddNoteToReverRequest
 */
export interface PbAddNoteToReverRequest {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbAddNoteToReverRequest
     */
    'ecommerce_id'?: string;
    /**
     * text/event to be associated with the order  at this point in time
     * @type {string}
     * @memberof PbAddNoteToReverRequest
     */
    'note'?: string;
    /**
     * platform order id (not necessarily the customer printed order id)
     * @type {string}
     * @memberof PbAddNoteToReverRequest
     */
    'order_id'?: string;
}
/**
 * AddPASettingsSectionRequest contains the request to add a new section to the PA settings
 * @export
 * @interface PbAddPASettingsSectionRequest
 */
export interface PbAddPASettingsSectionRequest {
    /**
     * The section defaults
     * @type {Array<PbPANewSetting>}
     * @memberof PbAddPASettingsSectionRequest
     */
    'section_defaults'?: Array<PbPANewSetting>;
    /**
     * The section name
     * @type {string}
     * @memberof PbAddPASettingsSectionRequest
     */
    'section_name'?: string;
}
/**
 * 
 * @export
 * @interface PbAddReviewRequest
 */
export interface PbAddReviewRequest {
    /**
     * ID of the process in where the review is being added. Required.
     * @type {string}
     * @memberof PbAddReviewRequest
     */
    'process_id'?: string;
    /**
     * Refund override
     * @type {PbRefundOverride}
     * @memberof PbAddReviewRequest
     */
    'refund_override'?: PbRefundOverride;
    /**
     * Review data. Required.
     * @type {Array<PbReviewLineItem>}
     * @memberof PbAddReviewRequest
     */
    'reviews'?: Array<PbReviewLineItem>;
}
/**
 * Payload for adding transactions to a process  The transactions are added to the process and the process is updated
 * @export
 * @interface PbAddTransactionsInternalRequest
 */
export interface PbAddTransactionsInternalRequest {
    /**
     * Process ID to associate the transactions. Required.
     * @type {string}
     * @memberof PbAddTransactionsInternalRequest
     */
    'process_id'?: string;
    /**
     * List of transaction inputs.
     * @type {Array<PbTransactionInput>}
     * @memberof PbAddTransactionsInternalRequest
     */
    'transaction_inputs'?: Array<PbTransactionInput>;
    /**
     * User that created the transactions.
     * @type {string}
     * @memberof PbAddTransactionsInternalRequest
     */
    'user'?: string;
}
/**
 * Payload for adding transactions to a process  The transactions are added to the process and the process is updated
 * @export
 * @interface PbAddTransactionsRequest
 */
export interface PbAddTransactionsRequest {
    /**
     * Process ID to associate the transactions. Required.
     * @type {string}
     * @memberof PbAddTransactionsRequest
     */
    'process_id'?: string;
    /**
     * List of transaction inputs.
     * @type {Array<PbTransactionInput>}
     * @memberof PbAddTransactionsRequest
     */
    'transaction_inputs'?: Array<PbTransactionInput>;
}
/**
 * Response for adding transactions to a process
 * @export
 * @interface PbAddTransactionsResponse
 */
export interface PbAddTransactionsResponse {
    /**
     * IDs of the created transactions, in input order.
     * @type {Array<string>}
     * @memberof PbAddTransactionsResponse
     */
    'transaction_ids'?: Array<string>;
}
/**
 * Generic address used in many scenarios
 * @export
 * @interface PbAddress
 */
export interface PbAddress {
    /**
     * Address line 1 (max 24 chars)
     * @type {string}
     * @memberof PbAddress
     */
    'address_line_1'?: string;
    /**
     * Address line 2 (max 24 chars)
     * @type {string}
     * @memberof PbAddress
     */
    'address_line_2'?: string;
    /**
     * City, Required.
     * @type {string}
     * @memberof PbAddress
     */
    'city'?: string;
    /**
     * Company name
     * @type {string}
     * @memberof PbAddress
     */
    'company'?: string;
    /**
     * Country name. No specific language is required  Required.
     * @type {string}
     * @memberof PbAddress
     */
    'country'?: string;
    /**
     * Country code ISO 3166-1 alpha-2  Required
     * @type {string}
     * @memberof PbAddress
     */
    'country_code'?: string;
    /**
     * Email (Optional)
     * @type {string}
     * @memberof PbAddress
     */
    'email'?: string;
    /**
     * Name of the person, Required
     * @type {string}
     * @memberof PbAddress
     */
    'first_name'?: string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof PbAddress
     */
    'last_name'?: string;
    /**
     * Phone (Optional)
     * @type {string}
     * @memberof PbAddress
     */
    'phone'?: string;
    /**
     * Postal code. Required.
     * @type {string}
     * @memberof PbAddress
     */
    'postcode'?: string;
    /**
     * State or province
     * @type {string}
     * @memberof PbAddress
     */
    'state_province'?: string;
    /**
     * State or province code (optional)  TODO: what is the expected format?
     * @type {string}
     * @memberof PbAddress
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface PbAdjustment
 */
export interface PbAdjustment {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbAdjustment
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbAdjustment
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbAdjustment
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbAdjustment
     */
    'user'?: string;
}
/**
 * AdyenGatewaySettings is the settings for the Adyen gateway
 * @export
 * @interface PbAdyenGatewaySettings
 */
export interface PbAdyenGatewaySettings {
    /**
     * Api key
     * @type {string}
     * @memberof PbAdyenGatewaySettings
     */
    'api_key'?: string;
    /**
     * Environment
     * @type {string}
     * @memberof PbAdyenGatewaySettings
     */
    'environment'?: PbAdyenGatewaySettingsEnvironmentEnum;
    /**
     * Is active
     * @type {boolean}
     * @memberof PbAdyenGatewaySettings
     */
    'is_active'?: boolean;
    /**
     * Store ID
     * @type {string}
     * @memberof PbAdyenGatewaySettings
     */
    'merchant_account'?: string;
    /**
     * Refund prefix for live environment
     * @type {string}
     * @memberof PbAdyenGatewaySettings
     */
    'refund_prefix'?: string;
}

export const PbAdyenGatewaySettingsEnvironmentEnum = {
    Unspecified: 'ENVIRONMENT_UNSPECIFIED',
    Production: 'ENVIRONMENT_PRODUCTION',
    Development: 'ENVIRONMENT_DEVELOPMENT',
    Sandbox: 'ENVIRONMENT_SANDBOX'
} as const;

export type PbAdyenGatewaySettingsEnvironmentEnum = typeof PbAdyenGatewaySettingsEnvironmentEnum[keyof typeof PbAdyenGatewaySettingsEnvironmentEnum];

/**
 * Payload representing an allocated risk event.
 * @export
 * @interface PbAllocatedRiskEvent
 */
export interface PbAllocatedRiskEvent {
    /**
     * Allocated timing identifier.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'allocated_timing_id'?: string;
    /**
     * End-customer identifier belonging to the ecommerce account.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'customer_id'?: string;
    /**
     * Platform-wide ecommerce identifier.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'ecommerce_id'?: string;
    /**
     * Describes how the event impacts risk (captured, cleared, expired).
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'event_action'?: PbAllocatedRiskEventEventActionEnum;
    /**
     * Categorizes the event as allocation or realization.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'event_category'?: PbAllocatedRiskEventEventCategoryEnum;
    /**
     * Classifies whether the event is a debit or a credit event.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'event_type'?: PbAllocatedRiskEventEventTypeEnum;
    /**
     * Client-facing return identifier from external systems.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'external_return_id'?: string;
    /**
     * Amount at risk expressed in euro cents.
     * @type {string}
     * @memberof PbAllocatedRiskEvent
     */
    'risked_amount_eur'?: string;
}

export const PbAllocatedRiskEventEventActionEnum = {
    Unspecified: 'RISK_EVENT_ACTION_UNSPECIFIED',
    Captured: 'RISK_EVENT_ACTION_CAPTURED',
    Cleared: 'RISK_EVENT_ACTION_CLEARED',
    Expired: 'RISK_EVENT_ACTION_EXPIRED'
} as const;

export type PbAllocatedRiskEventEventActionEnum = typeof PbAllocatedRiskEventEventActionEnum[keyof typeof PbAllocatedRiskEventEventActionEnum];
export const PbAllocatedRiskEventEventCategoryEnum = {
    Unspecified: 'RISK_EVENT_CATEGORY_UNSPECIFIED',
    Allocation: 'RISK_EVENT_CATEGORY_ALLOCATION',
    Realization: 'RISK_EVENT_CATEGORY_REALIZATION'
} as const;

export type PbAllocatedRiskEventEventCategoryEnum = typeof PbAllocatedRiskEventEventCategoryEnum[keyof typeof PbAllocatedRiskEventEventCategoryEnum];
export const PbAllocatedRiskEventEventTypeEnum = {
    Unspecified: 'RISK_EVENT_TYPE_UNSPECIFIED',
    Debit: 'RISK_EVENT_TYPE_DEBIT',
    Credit: 'RISK_EVENT_TYPE_CREDIT'
} as const;

export type PbAllocatedRiskEventEventTypeEnum = typeof PbAllocatedRiskEventEventTypeEnum[keyof typeof PbAllocatedRiskEventEventTypeEnum];

/**
 * AlreadyExecutedRefund represents a refund leg REVER already executed directly (outside this  e-commerce platform), e.g. a Stripe refund for the cash-upcharge portion of an exchange order.  Batch refunders surface these informationally alongside merchant-executed entries.
 * @export
 * @interface PbAlreadyExecutedRefund
 */
export interface PbAlreadyExecutedRefund {
    /**
     * Refunded amount, in this request\'s money_format minor units. Always positive.
     * @type {string}
     * @memberof PbAlreadyExecutedRefund
     */
    'amount'?: string;
    /**
     * The original payment/instrument this leg refunds
     * @type {string}
     * @memberof PbAlreadyExecutedRefund
     */
    'original_transaction_id'?: string;
    /**
     * This leg\'s own id in the executing payment platform, e.g. a Stripe refund id
     * @type {string}
     * @memberof PbAlreadyExecutedRefund
     */
    'platform_transaction_id'?: string;
    /**
     * Human-readable label for what executed this leg, e.g. \"REVER payments (Stripe)\"
     * @type {string}
     * @memberof PbAlreadyExecutedRefund
     */
    'provider'?: string;
    /**
     * REVER\'s own transaction id for this leg
     * @type {string}
     * @memberof PbAlreadyExecutedRefund
     */
    'transaction_id'?: string;
}
/**
 * Analytics settings
 * @export
 * @interface PbAnalytics
 */
export interface PbAnalytics {
    /**
     * Flag to enable analytics order sync
     * @type {boolean}
     * @memberof PbAnalytics
     */
    'order_sync_disabled'?: boolean;
}
/**
 * 
 * @export
 * @interface PbApproveAllRequest
 */
export interface PbApproveAllRequest {
    /**
     * ID of the process withe the return items to be approved. Required.
     * @type {string}
     * @memberof PbApproveAllRequest
     */
    'process_id'?: string;
    /**
     * User that performed the approval. Required.
     * @type {string}
     * @memberof PbApproveAllRequest
     */
    'user'?: string;
}
/**
 * AssignNangoPlatformConnectionRequest makes one of the group\'s Nango connections the one an ecommerce reads its  platform credentials from.
 * @export
 * @interface PbAssignNangoPlatformConnectionRequest
 */
export interface PbAssignNangoPlatformConnectionRequest {
    /**
     * Nango connection id; the connection must point at the ecommerce\'s store, unless switch_store is set.
     * @type {string}
     * @memberof PbAssignNangoPlatformConnectionRequest
     */
    'connection_id'?: string;
    /**
     * Ecommerce that reads its platform credentials from the connection.
     * @type {string}
     * @memberof PbAssignNangoPlatformConnectionRequest
     */
    'ecommerce_id'?: string;
    /**
     * Nango integration (provider_config_key) the connection belongs to; it must be the ecommerce\'s platform.
     * @type {string}
     * @memberof PbAssignNangoPlatformConnectionRequest
     */
    'integration'?: string;
    /**
     * Whether to save the connection\'s store on the ecommerce when it points at another one, as when the shop moved to  a new domain: set it once the merchant confirmed the switch. Shopify portals never switch shop.
     * @type {boolean}
     * @memberof PbAssignNangoPlatformConnectionRequest
     */
    'switch_store'?: boolean;
}
/**
 * AssignNangoPlatformConnectionResponse is the assigned connection.
 * @export
 * @interface PbAssignNangoPlatformConnectionResponse
 */
export interface PbAssignNangoPlatformConnectionResponse {
    /**
     * The connection, as now linked to the ecommerce in place of the one it used.
     * @type {PbNangoConnection}
     * @memberof PbAssignNangoPlatformConnectionResponse
     */
    'connection'?: PbNangoConnection;
}
/**
 * 
 * @export
 * @interface PbAvailableReturnReasons
 */
export interface PbAvailableReturnReasons {
    /**
     * list of available reasons
     * @type {Array<PbEcommerceReturnReason>}
     * @memberof PbAvailableReturnReasons
     */
    'available_reasons'?: Array<PbEcommerceReturnReason>;
    /**
     * mother reason
     * @type {PbEcommerceReturnReason}
     * @memberof PbAvailableReturnReasons
     */
    'parent_reason'?: PbEcommerceReturnReason;
}
/**
 * AxerveGatewaySettings is the settings for the Axerve gateway
 * @export
 * @interface PbAxerveGatewaySettings
 */
export interface PbAxerveGatewaySettings {
    /**
     * Api key
     * @type {string}
     * @memberof PbAxerveGatewaySettings
     */
    'api_key'?: string;
    /**
     * Environment
     * @type {string}
     * @memberof PbAxerveGatewaySettings
     */
    'environment'?: PbAxerveGatewaySettingsEnvironmentEnum;
    /**
     * Is active
     * @type {boolean}
     * @memberof PbAxerveGatewaySettings
     */
    'is_active'?: boolean;
    /**
     * Store ID
     * @type {string}
     * @memberof PbAxerveGatewaySettings
     */
    'store_id'?: string;
}

export const PbAxerveGatewaySettingsEnvironmentEnum = {
    Unspecified: 'ENVIRONMENT_UNSPECIFIED',
    Production: 'ENVIRONMENT_PRODUCTION',
    Development: 'ENVIRONMENT_DEVELOPMENT',
    Sandbox: 'ENVIRONMENT_SANDBOX'
} as const;

export type PbAxerveGatewaySettingsEnvironmentEnum = typeof PbAxerveGatewaySettingsEnvironmentEnum[keyof typeof PbAxerveGatewaySettingsEnvironmentEnum];

/**
 * B2C Commerce specific settings
 * @export
 * @interface PbB2CSettings
 */
export interface PbB2CSettings {
    /**
     * List of banned categories from Side Menu on Full Catalog
     * @type {string}
     * @memberof PbB2CSettings
     */
    'banned_categories'?: string;
    /**
     * Base URL for static files
     * @type {string}
     * @memberof PbB2CSettings
     */
    'base_static_files_url'?: string;
    /**
     * Business manager URL for the B2C Commerce instance
     * @type {string}
     * @memberof PbB2CSettings
     */
    'business_manager_url'?: string;
    /**
     * ID of the product catalog
     * @type {string}
     * @memberof PbB2CSettings
     */
    'catalog_id'?: string;
    /**
     * Default currency for the store
     * @type {string}
     * @memberof PbB2CSettings
     */
    'default_currency'?: string;
    /**
     * ID of the Salesforce organization
     * @type {string}
     * @memberof PbB2CSettings
     */
    'organization_id'?: string;
    /**
     * Public domain for the B2C Commerce instance
     * @type {string}
     * @memberof PbB2CSettings
     */
    'public_domain'?: string;
    /**
     * Short code for the B2C Commerce instance
     * @type {string}
     * @memberof PbB2CSettings
     */
    'short_code'?: string;
    /**
     * ID of the B2C Commerce site
     * @type {string}
     * @memberof PbB2CSettings
     */
    'site_id'?: string;
}
/**
 * 
 * @export
 * @interface PbBankTransferCompensation
 */
export interface PbBankTransferCompensation {
    /**
     * 
     * @type {Array<PbBankTransferRefund>}
     * @memberof PbBankTransferCompensation
     */
    'refunds'?: Array<PbBankTransferRefund>;
    /**
     * 
     * @type {PbCompensationSummary}
     * @memberof PbBankTransferCompensation
     */
    'summary'?: PbCompensationSummary;
}
/**
 * 
 * @export
 * @interface PbBankTransferRefund
 */
export interface PbBankTransferRefund {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbBankTransferRefund
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbBankTransferRefund
     */
    'created_at'?: string;
}
/**
 * BasicAuthCredentials contains username and password for basic authentication
 * @export
 * @interface PbBasicAuthCredentials
 */
export interface PbBasicAuthCredentials {
    /**
     * Password for authentication
     * @type {string}
     * @memberof PbBasicAuthCredentials
     */
    'password'?: string;
    /**
     * Username for authentication
     * @type {string}
     * @memberof PbBasicAuthCredentials
     */
    'username'?: string;
}
/**
 * List of E-commerce basic E-commerce info
 * @export
 * @interface PbBasicECommerceInfoResponse
 */
export interface PbBasicECommerceInfoResponse {
    /**
     * List of E-commerce info
     * @type {Array<PbBasicEcommerceInfo>}
     * @memberof PbBasicECommerceInfoResponse
     */
    'ecommerces'?: Array<PbBasicEcommerceInfo>;
}
/**
 * Basic E-commerce info
 * @export
 * @interface PbBasicEcommerceInfo
 */
export interface PbBasicEcommerceInfo {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbBasicEcommerceInfo
     */
    'ecommerce_id'?: string;
    /**
     * The group of the e-commerce.
     * @type {string}
     * @memberof PbBasicEcommerceInfo
     */
    'group'?: string;
}
/**
 * 
 * @export
 * @interface PbBasicProcessData
 */
export interface PbBasicProcessData {
    /**
     * Customer printed order ID  Deprecated: Use order_name instead
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'customer_printed_order_id'?: string;
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'ecommerce_id'?: string;
    /**
     * IsLite
     * @type {boolean}
     * @memberof PbBasicProcessData
     */
    'is_lite'?: boolean;
    /**
     * Flag for a test process
     * @type {boolean}
     * @memberof PbBasicProcessData
     */
    'is_testing'?: boolean;
    /**
     * Order ID
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'order_id'?: string;
    /**
     * Order name
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'order_name'?: string;
    /**
     * Order Purchase Date
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'order_purchased_at'?: string;
    /**
     * Platform
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'platform'?: PbBasicProcessDataPlatformEnum;
    /**
     * Platform process ID
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'platform_process_id'?: string;
    /**
     * Process ID
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'process_id'?: string;
    /**
     * Started at
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'started_at'?: string;
    /**
     * Warehouse ID
     * @type {string}
     * @memberof PbBasicProcessData
     */
    'warehouse_id'?: string;
}

export const PbBasicProcessDataPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type PbBasicProcessDataPlatformEnum = typeof PbBasicProcessDataPlatformEnum[keyof typeof PbBasicProcessDataPlatformEnum];

/**
 * Deprecated: was settings for the synchronous batch-refund outbound call (e.g. Boardriders).  The endpoint is now a hardcoded constant and auth is HMAC-only; this message is unused.
 * @export
 * @interface PbBatchRefundSettings
 */
export interface PbBatchRefundSettings {
    /**
     * HTTP header name carrying the merchant-issued credential
     * @type {string}
     * @memberof PbBatchRefundSettings
     */
    'auth_header'?: string;
    /**
     * HTTP header value (the credential itself)
     * @type {string}
     * @memberof PbBatchRefundSettings
     */
    'auth_value'?: string;
    /**
     * Merchant endpoint that receives the batch refund request
     * @type {string}
     * @memberof PbBatchRefundSettings
     */
    'endpoint'?: string;
}
/**
 * BrandInformation is the general information about the brand
 * @export
 * @interface PbBrandInformation
 */
export interface PbBrandInformation {
    /**
     * name of the brand
     * @type {string}
     * @memberof PbBrandInformation
     */
    'ecommerce_name'?: string;
    /**
     * group
     * @type {string}
     * @memberof PbBrandInformation
     */
    'group'?: string;
    /**
     * platform
     * @type {string}
     * @memberof PbBrandInformation
     */
    'platform'?: PbBrandInformationPlatformEnum;
    /**
     * restocking available
     * @type {boolean}
     * @memberof PbBrandInformation
     */
    'restocking_available'?: boolean;
}

export const PbBrandInformationPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type PbBrandInformationPlatformEnum = typeof PbBrandInformationPlatformEnum[keyof typeof PbBrandInformationPlatformEnum];

/**
 * Branding model
 * @export
 * @interface PbBranding
 */
export interface PbBranding {
    /**
     * BackgroundImageUrl
     * @type {string}
     * @memberof PbBranding
     */
    'background_image_url'?: string;
    /**
     * BackgroundTextColor
     * @type {string}
     * @memberof PbBranding
     */
    'background_text_color'?: string;
    /**
     * BorderRadius
     * @type {string}
     * @memberof PbBranding
     */
    'border_radius'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbBranding
     */
    'ecommerce_id'?: string;
    /**
     * FaviconUrl
     * @type {string}
     * @memberof PbBranding
     */
    'favicon_url'?: string;
    /**
     * FullCatalogProductImageRatio
     * @type {string}
     * @memberof PbBranding
     */
    'full_catalog_product_image_ratio'?: string;
    /**
     * InputVariant
     * @type {string}
     * @memberof PbBranding
     */
    'input_variant'?: string;
    /**
     * LayoutDesignValues
     * @type {string}
     * @memberof PbBranding
     */
    'layout_design_values'?: PbBrandingLayoutDesignValuesEnum;
    /**
     * LogoHeightDesktop
     * @type {string}
     * @memberof PbBranding
     */
    'logo_height_desktop'?: string;
    /**
     * LogoHeightMobile
     * @type {string}
     * @memberof PbBranding
     */
    'logo_height_mobile'?: string;
    /**
     * LogoUrl
     * @type {string}
     * @memberof PbBranding
     */
    'logo_url'?: string;
    /**
     * MailLogoUrl
     * @type {string}
     * @memberof PbBranding
     */
    'mail_logo_url'?: string;
    /**
     * MailMainColor
     * @type {string}
     * @memberof PbBranding
     */
    'mail_main_color'?: string;
    /**
     * PersistentLogoType
     * @type {string}
     * @memberof PbBranding
     */
    'persistent_logo_type'?: PbBrandingPersistentLogoTypeEnum;
    /**
     * PrimaryThemeColorContrastText
     * @type {string}
     * @memberof PbBranding
     */
    'primary_theme_color_contrast_text'?: string;
    /**
     * PrimaryThemeColorDark
     * @type {string}
     * @memberof PbBranding
     */
    'primary_theme_color_dark'?: string;
    /**
     * PrimaryThemeColorLight
     * @type {string}
     * @memberof PbBranding
     */
    'primary_theme_color_light'?: string;
    /**
     * PrimaryThemeColorMain
     * @type {string}
     * @memberof PbBranding
     */
    'primary_theme_color_main'?: string;
    /**
     * SecondaryThemeColorContrastText
     * @type {string}
     * @memberof PbBranding
     */
    'secondary_theme_color_contrast_text'?: string;
    /**
     * SecondaryThemeColorDark
     * @type {string}
     * @memberof PbBranding
     */
    'secondary_theme_color_dark'?: string;
    /**
     * SecondaryThemeColorLight
     * @type {string}
     * @memberof PbBranding
     */
    'secondary_theme_color_light'?: string;
    /**
     * SecondaryThemeColorMain
     * @type {string}
     * @memberof PbBranding
     */
    'secondary_theme_color_main'?: string;
    /**
     * Slogan
     * @type {string}
     * @memberof PbBranding
     */
    'slogan'?: string;
    /**
     * Title
     * @type {string}
     * @memberof PbBranding
     */
    'title'?: string;
}

export const PbBrandingLayoutDesignValuesEnum = {
    Default: 'DEFAULT',
    Vertical: 'VERTICAL',
    Simplified: 'SIMPLIFIED'
} as const;

export type PbBrandingLayoutDesignValuesEnum = typeof PbBrandingLayoutDesignValuesEnum[keyof typeof PbBrandingLayoutDesignValuesEnum];
export const PbBrandingPersistentLogoTypeEnum = {
    Unspecified: 'PERSISTENT_LOGO_TYPE_UNSPECIFIED',
    Enabled: 'PERSISTENT_LOGO_TYPE_ENABLED',
    Disabled: 'PERSISTENT_LOGO_TYPE_DISABLED'
} as const;

export type PbBrandingPersistentLogoTypeEnum = typeof PbBrandingPersistentLogoTypeEnum[keyof typeof PbBrandingPersistentLogoTypeEnum];

/**
 * Credentials for Business Manager access
 * @export
 * @interface PbBusinessManagerCredentials
 */
export interface PbBusinessManagerCredentials {
    /**
     * Access Key for Business Manager
     * @type {string}
     * @memberof PbBusinessManagerCredentials
     */
    'business_manager_user_access_key'?: string;
    /**
     * User ID for Business Manager
     * @type {string}
     * @memberof PbBusinessManagerCredentials
     */
    'business_manager_user_id'?: string;
    /**
     * Password for Business Manager
     * @type {string}
     * @memberof PbBusinessManagerCredentials
     */
    'business_manager_user_password'?: string;
    /**
     * OCAPI (Open Commerce API) credentials
     * @type {PbOcapiCredentials}
     * @memberof PbBusinessManagerCredentials
     */
    'ocapi_credentials'?: PbOcapiCredentials;
}
/**
 * BusinessRule
 * @export
 * @interface PbBusinessRule
 */
export interface PbBusinessRule {
    /**
     * Name of Business rule
     * @type {string}
     * @memberof PbBusinessRule
     */
    'name'?: string;
    /**
     * Params needed for the business rule
     * @type {{ [key: string]: string; }}
     * @memberof PbBusinessRule
     */
    'params'?: { [key: string]: string; };
    /**
     * When conditions to evaluate  Every entry is evaluated as an AND condition  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbBusinessRule
     */
    'when'?: Array<string>;
}
/**
 * BxGyDiscount keeps the data for the Buy X Get Y discount
 * @export
 * @interface PbBxGyDiscount
 */
export interface PbBxGyDiscount {
    /**
     * list of line item ids that were paid for completely
     * @type {Array<string>}
     * @memberof PbBxGyDiscount
     */
    'buy_line_item_ids'?: Array<string>;
    /**
     * Units of buy_line_item_ids that must stay with the shopper for the promotion  to hold. 0 when the platform does not state it, and the caller then keeps its  own rule (every buy line indispensable).
     * @type {number}
     * @memberof PbBxGyDiscount
     */
    'buy_min_units'?: number;
    /**
     * list of line item ids that were discounted
     * @type {Array<PbBxGyGetLineItem>}
     * @memberof PbBxGyDiscount
     */
    'get_line_items'?: Array<PbBxGyGetLineItem>;
    /**
     * Promotion title as it appears on the order\'s discount_applications. Used to  resolve the promotion\'s buy/get scope from the platform. May be empty.
     * @type {string}
     * @memberof PbBxGyDiscount
     */
    'title'?: string;
}
/**
 * Line Item
 * @export
 * @interface PbBxGyGetLineItem
 */
export interface PbBxGyGetLineItem {
    /**
     * amount discounted
     * @type {PbEcommerceMoney}
     * @memberof PbBxGyGetLineItem
     */
    'amount'?: PbEcommerceMoney;
    /**
     * line item id that was discounted
     * @type {string}
     * @memberof PbBxGyGetLineItem
     */
    'line_item_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCancelReturnProcessRequest
 */
export interface PbCancelReturnProcessRequest {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbCancelReturnProcessRequest
     */
    'ecommerce_id'?: string;
    /**
     * Order ID
     * @type {string}
     * @memberof PbCancelReturnProcessRequest
     */
    'order_id'?: string;
    /**
     * Return process platform ID
     * @type {string}
     * @memberof PbCancelReturnProcessRequest
     */
    'return_process_platform_id'?: string;
}
/**
 * CarrierConnection is one way a group can book a carrier; a route names one or falls back to the carrier\'s default.
 * @export
 * @interface PbCarrierConnection
 */
export interface PbCarrierConnection {
    /**
     * Carrier booked, e.g. \"ups\".
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'carrier'?: string;
    /**
     * Account settings (environment, test flags), stored readable; on save, empty keeps the stored ones.
     * @type {{ [key: string]: string; }}
     * @memberof PbCarrierConnection
     */
    'config'?: { [key: string]: string; };
    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'group'?: string;
    /**
     * Connection id, assigned on create.
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'id'?: string;
    /**
     * Whether routes without a connection id book through this one.
     * @type {boolean}
     * @memberof PbCarrierConnection
     */
    'is_default'?: boolean;
    /**
     * Label telling connections of one carrier apart.
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'name'?: string;
    /**
     * Partner the carrier is booked through; empty for a direct booking.
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'partner'?: string;
    /**
     * Partner connection used when the merchant\'s own partner account books; empty when REVER\'s does.
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'partner_connection_id'?: string;
    /**
     * Declared settings of the connection; secret values read back masked.
     * @type {{ [key: string]: string; }}
     * @memberof PbCarrierConnection
     */
    'settings'?: { [key: string]: string; };
    /**
     * Who is billed.
     * @type {string}
     * @memberof PbCarrierConnection
     */
    'source'?: PbCarrierConnectionSourceEnum;
}

export const PbCarrierConnectionSourceEnum = {
    Unspecified: 'CARRIER_CONNECTION_SOURCE_UNSPECIFIED',
    Rever: 'CARRIER_CONNECTION_SOURCE_REVER',
    Ecommerce: 'CARRIER_CONNECTION_SOURCE_ECOMMERCE'
} as const;

export type PbCarrierConnectionSourceEnum = typeof PbCarrierConnectionSourceEnum[keyof typeof PbCarrierConnectionSourceEnum];

/**
 * A catalog entry a non-returnable rule can name
 * @export
 * @interface PbCatalogItem
 */
export interface PbCatalogItem {
    /**
     * The value a non-returnable rule stores for this entry
     * @type {string}
     * @memberof PbCatalogItem
     */
    'id'?: string;
    /**
     * Image of a product or collection
     * @type {string}
     * @memberof PbCatalogItem
     */
    'image_url'?: string;
    /**
     * The name shown to the merchant
     * @type {string}
     * @memberof PbCatalogItem
     */
    'label'?: string;
    /**
     * Product type of a product
     * @type {string}
     * @memberof PbCatalogItem
     */
    'product_type'?: string;
    /**
     * Number of products in a collection
     * @type {string}
     * @memberof PbCatalogItem
     */
    'products_count'?: string;
    /**
     * Number of variants of a product
     * @type {string}
     * @memberof PbCatalogItem
     */
    'variants_count'?: string;
}
/**
 * 
 * @export
 * @interface PbChangeCompensationMethodRequest
 */
export interface PbChangeCompensationMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof PbChangeCompensationMethodRequest
     */
    'compensation_method'?: PbChangeCompensationMethodRequestCompensationMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PbChangeCompensationMethodRequest
     */
    'process_id'?: string;
}

export const PbChangeCompensationMethodRequestCompensationMethodEnum = {
    Unspecified: 'REFUND_PAYMENT_METHOD_UNSPECIFIED',
    NoPaymentMethod: 'REFUND_PAYMENT_METHOD_NO_PAYMENT_METHOD',
    BankTransfer: 'REFUND_PAYMENT_METHOD_BANK_TRANSFER',
    Original: 'REFUND_PAYMENT_METHOD_ORIGINAL',
    PromoCode: 'REFUND_PAYMENT_METHOD_PROMO_CODE',
    GiftCard: 'REFUND_PAYMENT_METHOD_GIFT_CARD'
} as const;

export type PbChangeCompensationMethodRequestCompensationMethodEnum = typeof PbChangeCompensationMethodRequestCompensationMethodEnum[keyof typeof PbChangeCompensationMethodRequestCompensationMethodEnum];

/**
 * CheckNangoConnectionRequest asks the store whether it accepts one of the group\'s connections now.
 * @export
 * @interface PbCheckNangoConnectionRequest
 */
export interface PbCheckNangoConnectionRequest {
    /**
     * Nango connection id.
     * @type {string}
     * @memberof PbCheckNangoConnectionRequest
     */
    'connection_id'?: string;
    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof PbCheckNangoConnectionRequest
     */
    'group'?: string;
    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof PbCheckNangoConnectionRequest
     */
    'integration'?: string;
}
/**
 * CheckNangoConnectionResponse is the connection\'s health after the check.
 * @export
 * @interface PbCheckNangoConnectionResponse
 */
export interface PbCheckNangoConnectionResponse {
    /**
     * What the store answered.
     * @type {PbNangoConnectionHealth}
     * @memberof PbCheckNangoConnectionResponse
     */
    'health'?: PbNangoConnectionHealth;
}
/**
 * ChildExchangeOrder is the child order that was created in an exchange process
 * @export
 * @interface PbChildExchangeOrder
 */
export interface PbChildExchangeOrder {
    /**
     * Child order id
     * @type {string}
     * @memberof PbChildExchangeOrder
     */
    'child_order_id'?: string;
    /**
     * Child order number
     * @type {string}
     * @memberof PbChildExchangeOrder
     */
    'child_order_number'?: string;
}
/**
 * CloneEcommerceRequest is the request to clone every settings group from a  source e-commerce into a newly created destination e-commerce.
 * @export
 * @interface PbCloneEcommerceRequest
 */
export interface PbCloneEcommerceRequest {
    /**
     * The id of the source e-commerce to copy the settings from.
     * @type {string}
     * @memberof PbCloneEcommerceRequest
     */
    'from_ecommerce_id'?: string;
    /**
     * The display name for the destination e-commerce. If empty, the source  name is inherited.
     * @type {string}
     * @memberof PbCloneEcommerceRequest
     */
    'name'?: string;
    /**
     * The unique slug for the destination e-commerce. Required.
     * @type {string}
     * @memberof PbCloneEcommerceRequest
     */
    'slug'?: string;
    /**
     * The id of the new destination e-commerce to create and populate.
     * @type {string}
     * @memberof PbCloneEcommerceRequest
     */
    'to_ecommerce_id'?: string;
    /**
     * The website URL for the destination e-commerce. If empty, the source  website URL is inherited.
     * @type {string}
     * @memberof PbCloneEcommerceRequest
     */
    'website_url'?: string;
}
/**
 * 
 * @export
 * @interface PbCollection
 */
export interface PbCollection {
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof PbCollection
     */
    'id'?: string;
}
/**
 * Specific settings for an e-commerce using the Commerce Layer platform
 * @export
 * @interface PbCommercelayerSettings
 */
export interface PbCommercelayerSettings {
    /**
     * OAuth2 API access token. Derived on the read path and never persisted.
     * @type {string}
     * @memberof PbCommercelayerSettings
     */
    'api_token'?: string;
    /**
     * Unix epoch seconds at which api_token expires. Derived alongside api_token.
     * @type {string}
     * @memberof PbCommercelayerSettings
     */
    'api_token_expires_at'?: string;
    /**
     * OAuth2 Client ID of a Commerce Layer Integration application (role admin)
     * @type {string}
     * @memberof PbCommercelayerSettings
     */
    'client_id'?: string;
    /**
     * OAuth2 Client Secret of the Integration application
     * @type {string}
     * @memberof PbCommercelayerSettings
     */
    'client_secret'?: string;
    /**
     * Commerce Layer organization slug, e.g. \"acme\". The Core API base URL is  derived from it as https://{organization_slug}.commercelayer.io, never stored.
     * @type {string}
     * @memberof PbCommercelayerSettings
     */
    'organization_slug'?: string;
    /**
     * Commerce Layer stock location ID that returns are shipped to. An ID rather  than a code, because stock location codes are nullable.
     * @type {string}
     * @memberof PbCommercelayerSettings
     */
    'return_stock_location_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCompensation
 */
export interface PbCompensation {
    /**
     * 
     * @type {PbBankTransferCompensation}
     * @memberof PbCompensation
     */
    'bank_transfer'?: PbBankTransferCompensation;
    /**
     * 
     * @type {PbCompensationStatusSummary}
     * @memberof PbCompensation
     */
    'compensation_status_summary'?: PbCompensationStatusSummary;
    /**
     * 
     * @type {PbCompensationEditableRefundAmount}
     * @memberof PbCompensation
     */
    'editable_refund_amount'?: PbCompensationEditableRefundAmount;
    /**
     * 
     * @type {PbExchangeCompensation}
     * @memberof PbCompensation
     */
    'exchange'?: PbExchangeCompensation;
    /**
     * 
     * @type {PbGiftCardCompensation}
     * @memberof PbCompensation
     */
    'gift_card'?: PbGiftCardCompensation;
    /**
     * 
     * @type {PbOriginalPaymentMethodCompensation}
     * @memberof PbCompensation
     */
    'original_payment_method'?: PbOriginalPaymentMethodCompensation;
    /**
     * 
     * @type {PbPromocodeCompensation}
     * @memberof PbCompensation
     */
    'promocode'?: PbPromocodeCompensation;
}
/**
 * 
 * @export
 * @interface PbCompensationEditableRefundAmount
 */
export interface PbCompensationEditableRefundAmount {
    /**
     * 
     * @type {boolean}
     * @memberof PbCompensationEditableRefundAmount
     */
    'is_refund_amount_editable'?: boolean;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbCompensationEditableRefundAmount
     */
    'maximum_refundable_amount'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbCompensationStatusSummary
 */
export interface PbCompensationStatusSummary {
    /**
     * 
     * @type {PbExternalRefundDetails}
     * @memberof PbCompensationStatusSummary
     */
    'external_refund_details'?: PbExternalRefundDetails;
    /**
     * Total pending refund amount excluding exchanges (sum of pending for OPM, bank transfer,  promocode, gift card only).
     * @type {PbMoneyBag}
     * @memberof PbCompensationStatusSummary
     */
    'total_pending_refund_amount'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbCompensationSummary
 */
export interface PbCompensationSummary {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbCompensationSummary
     */
    'adjusted_commitment'?: PbMoneyBag;
    /**
     * Deprecated, use adjustments_list instead.
     * @type {string}
     * @memberof PbCompensationSummary
     */
    'adjustment_reason'?: string;
    /**
     * Deprecated, use adjustments_list instead.
     * @type {PbMoneyBag}
     * @memberof PbCompensationSummary
     */
    'adjustments'?: PbMoneyBag;
    /**
     * 
     * @type {Array<PbAdjustment>}
     * @memberof PbCompensationSummary
     */
    'adjustments_list'?: Array<PbAdjustment>;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbCompensationSummary
     */
    'executed'?: PbMoneyBag;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbCompensationSummary
     */
    'initial_commitment'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbCompensationSummary
     */
    'timing'?: PbCompensationSummaryTimingEnum;
}

export const PbCompensationSummaryTimingEnum = {
    Unspecified: 'TIMING_UNSPECIFIED',
    NoTiming: 'TIMING_NO_TIMING',
    OnStart: 'TIMING_ON_START',
    OnSent: 'TIMING_ON_SENT',
    OnVerified: 'TIMING_ON_VERIFIED'
} as const;

export type PbCompensationSummaryTimingEnum = typeof PbCompensationSummaryTimingEnum[keyof typeof PbCompensationSummaryTimingEnum];

/**
 * 
 * @export
 * @interface PbCompleteReturnRequest
 */
export interface PbCompleteReturnRequest {
    /**
     * currency associated to the `return_line_items` being returned
     * @type {string}
     * @memberof PbCompleteReturnRequest
     */
    'currency'?: string;
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbCompleteReturnRequest
     */
    'ecommerce_id'?: string;
    /**
     * platform order id (not necessarily the customer printed order id)
     * @type {string}
     * @memberof PbCompleteReturnRequest
     */
    'order_id'?: string;
    /**
     * Items to be returned, using the line item id from the e-commerce order  referred by `order_id`
     * @type {Array<PbReturnLineItem>}
     * @memberof PbCompleteReturnRequest
     */
    'return_line_items'?: Array<PbReturnLineItem>;
    /**
     * Platform id of the return process that is going to be completed
     * @type {string}
     * @memberof PbCompleteReturnRequest
     */
    'return_process_platform_id'?: string;
    /**
     * Rever Return process id
     * @type {string}
     * @memberof PbCompleteReturnRequest
     */
    'rever_return_process_id'?: string;
    /**
     * Shipping cost refund amount to the customer in the currency of the order
     * @type {string}
     * @memberof PbCompleteReturnRequest
     */
    'shipping_cost_refund_amount'?: string;
    /**
     * Whether the credit note should be skipped or not
     * @type {boolean}
     * @memberof PbCompleteReturnRequest
     */
    'skip_credit_note_creation'?: boolean;
}
/**
 * CompleteReturnResponse is the reponse of Ecommerce , after the return process is completed
 * @export
 * @interface PbCompleteReturnResponse
 */
export interface PbCompleteReturnResponse {
    /**
     * ID returned by the e-commerce platform for the return.  Returns should be visible by this id in the order detail.  Optional as some platforms don\'t return this id
     * @type {string}
     * @memberof PbCompleteReturnResponse
     */
    'return_id'?: string;
}
/**
 * Condition to evaluate
 * @export
 * @interface PbCondition
 */
export interface PbCondition {
    /**
     * Comparison to evaluate
     * @type {string}
     * @memberof PbCondition
     */
    'comparison'?: string;
    /**
     * Function to evaluate
     * @type {string}
     * @memberof PbCondition
     */
    'function'?: string;
    /**
     * Value to compare
     * @type {Array<string>}
     * @memberof PbCondition
     */
    'values'?: Array<string>;
    /**
     * Variable to evaluate
     * @type {string}
     * @memberof PbCondition
     */
    'variable'?: string;
}
/**
 * Configurations
 * @export
 * @interface PbConfig
 */
export interface PbConfig {
    /**
     * Functions
     * @type {Array<PbFunction>}
     * @memberof PbConfig
     */
    'functions'?: Array<PbFunction>;
    /**
     * Name of the configuration
     * @type {string}
     * @memberof PbConfig
     */
    'name'?: string;
    /**
     * Params
     * @type {Array<PbParam>}
     * @memberof PbConfig
     */
    'params'?: Array<PbParam>;
}
/**
 * Copy Details with default values
 * @export
 * @interface PbCopyDetail
 */
export interface PbCopyDetail {
    /**
     * The language of the copy.
     * @type {string}
     * @memberof PbCopyDetail
     */
    'lang_tag'?: string;
    /**
     * The text of the copy.
     * @type {string}
     * @memberof PbCopyDetail
     */
    'text'?: string;
}
/**
 * CopyDetails
 * @export
 * @interface PbCopyDetails
 */
export interface PbCopyDetails {
    /**
     * is the text editable by the e-commerce
     * @type {boolean}
     * @memberof PbCopyDetails
     */
    'editable'?: boolean;
    /**
     * tag of the copy
     * @type {string}
     * @memberof PbCopyDetails
     */
    'tag'?: string;
    /**
     * text per language
     * @type {string}
     * @memberof PbCopyDetails
     */
    'text'?: string;
}
/**
 * CopyKeyMap
 * @export
 * @interface PbCopyKeyMap
 */
export interface PbCopyKeyMap {
    /**
     * map of copy keys to text
     * @type {{ [key: string]: string; }}
     * @memberof PbCopyKeyMap
     */
    'copies'?: { [key: string]: string; };
}
/**
 * GetReturnAmountRequest is the request to get the return amount
 * @export
 * @interface PbCopyReturnAmountRequest
 */
export interface PbCopyReturnAmountRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbCopyReturnAmountRequest
     */
    'from_ecommerce_id'?: string;
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbCopyReturnAmountRequest
     */
    'to_ecommerce_id'?: string;
}
/**
 * CopyReturnAmountResponse is the response to get the return amount
 * @export
 * @interface PbCopyReturnAmountResponse
 */
export interface PbCopyReturnAmountResponse {
    /**
     * Return amount business rules
     * @type {Array<PbReturnAmountRule>}
     * @memberof PbCopyReturnAmountResponse
     */
    'rules'?: Array<PbReturnAmountRule>;
}
/**
 * CopyReturnReasons is the request to copy the return reasons
 * @export
 * @interface PbCopyReturnReasonsRequest
 */
export interface PbCopyReturnReasonsRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbCopyReturnReasonsRequest
     */
    'from_ecommerce_id'?: string;
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbCopyReturnReasonsRequest
     */
    'to_ecommerce_id'?: string;
}
/**
 * CopyTextCopies is the request to copy the text copies
 * @export
 * @interface PbCopyTextCopiesRequest
 */
export interface PbCopyTextCopiesRequest {
    /**
     * The id of the source e-commerce.
     * @type {string}
     * @memberof PbCopyTextCopiesRequest
     */
    'from_ecommerce_id'?: string;
    /**
     * The id of the destination e-commerce.
     * @type {string}
     * @memberof PbCopyTextCopiesRequest
     */
    'to_ecommerce_id'?: string;
}
/**
 * CopyTextDetail  CopyTgit sextDetail
 * @export
 * @interface PbCopyTextDetail
 */
export interface PbCopyTextDetail {
    /**
     * Name of the field Tag
     * @type {string}
     * @memberof PbCopyTextDetail
     */
    'field_tag'?: string;
    /**
     * is the text editable by the e-commerce
     * @type {boolean}
     * @memberof PbCopyTextDetail
     */
    'is_ecommerce_editable'?: boolean;
    /**
     * language of the text
     * @type {string}
     * @memberof PbCopyTextDetail
     */
    'lang_tag'?: string;
    /**
     * language of the text
     * @type {string}
     * @memberof PbCopyTextDetail
     */
    'text'?: string;
}
/**
 * CountJiraTicketsFiledRequest asks how many Jira tickets were filed in a window. No timezone: the  caller resolves its own calendar into instants, and nothing here is bucketed by day.
 * @export
 * @interface PbCountJiraTicketsFiledRequest
 */
export interface PbCountJiraTicketsFiledRequest {
    /**
     * Start of the window, inclusive. Required.
     * @type {string}
     * @memberof PbCountJiraTicketsFiledRequest
     */
    'from'?: string;
    /**
     * End of the window, EXCLUSIVE — unlike GetProcessActivitySeries above, whose end is inclusive.  A total has no day bucket to drop the boundary row into, so a ticket filed at exactly the end  of a week would otherwise be counted in that week and the next. Required.
     * @type {string}
     * @memberof PbCountJiraTicketsFiledRequest
     */
    'to'?: string;
}
/**
 * CountJiraTicketsFiledResponse is the platform-wide total.
 * @export
 * @interface PbCountJiraTicketsFiledResponse
 */
export interface PbCountJiraTicketsFiledResponse {
    /**
     * Tickets filed in the window, counted once each even when a retry recorded one twice.
     * @type {string}
     * @memberof PbCountJiraTicketsFiledResponse
     */
    'count'?: string;
}
/**
 * Country is an origin-country option for the country filter.
 * @export
 * @interface PbCountry
 */
export interface PbCountry {
    /**
     * ISO 3166-1 alpha-2 code (the value accepted by the country filter).
     * @type {string}
     * @memberof PbCountry
     */
    'iso'?: string;
    /**
     * Human-readable country name.
     * @type {string}
     * @memberof PbCountry
     */
    'name'?: string;
}
/**
 * CreateAPIKeyRequest names the API key to create.
 * @export
 * @interface PbCreateAPIKeyRequest
 */
export interface PbCreateAPIKeyRequest {
    /**
     * Ecommerce group the key is issued for
     * @type {string}
     * @memberof PbCreateAPIKeyRequest
     */
    'ecommerce_group'?: string;
    /**
     * Name of the key, unique within its group, e.g. the integration that will use it
     * @type {string}
     * @memberof PbCreateAPIKeyRequest
     */
    'name'?: string;
    /**
     * Scopes the key grants, from the auths catalog; at least one is required. Full access (\"*\")  cannot be requested here.
     * @type {Array<string>}
     * @memberof PbCreateAPIKeyRequest
     */
    'scopes'?: Array<string>;
}
/**
 * CreateAPIKeyResponse carries a new API key.   The value field is a LIVE CREDENTIAL: callers must never log it, cache it, or forward it  to another system. Hand it to the requesting user and drop it.
 * @export
 * @interface PbCreateAPIKeyResponse
 */
export interface PbCreateAPIKeyResponse {
    /**
     * True when the group already held a key with this name and that key was returned instead
     * @type {boolean}
     * @memberof PbCreateAPIKeyResponse
     */
    'existing'?: boolean;
    /**
     * The created key
     * @type {PbAPIKey}
     * @memberof PbCreateAPIKeyResponse
     */
    'key'?: PbAPIKey;
    /**
     * The key value
     * @type {string}
     * @memberof PbCreateAPIKeyResponse
     */
    'value'?: string;
}
/**
 * CreateDemoPortalRequest is the request to provision a demo returns portal  by cloning a template e-commerce and applying the branding extracted from  the prospect\'s storefront.
 * @export
 * @interface PbCreateDemoPortalRequest
 */
export interface PbCreateDemoPortalRequest {
    /**
     * The branding extracted from the prospect\'s storefront. Empty fields keep  the values cloned from the template.
     * @type {PbDemoBranding}
     * @memberof PbCreateDemoPortalRequest
     */
    'branding'?: PbDemoBranding;
    /**
     * The id of the template e-commerce to clone from, e.g. \"demorever\".
     * @type {string}
     * @memberof PbCreateDemoPortalRequest
     */
    'from_ecommerce_id'?: string;
    /**
     * The handle of the Shopify navigation menu created for the demo catalog;  stored as the platform main menu of the FULL catalog exchange flow.
     * @type {string}
     * @memberof PbCreateDemoPortalRequest
     */
    'menu_handle'?: string;
    /**
     * The display name of the demo shop, as typed by the requester.
     * @type {string}
     * @memberof PbCreateDemoPortalRequest
     */
    'name'?: string;
    /**
     * The portal slug; the returns portal is served at  returns.byrever.com/<slug>.
     * @type {string}
     * @memberof PbCreateDemoPortalRequest
     */
    'slug'?: string;
    /**
     * The id of the new demo e-commerce to create (equals the slug by  convention).
     * @type {string}
     * @memberof PbCreateDemoPortalRequest
     */
    'to_ecommerce_id'?: string;
}
/**
 * CreateDemoPortalResponse is the response to creating a demo portal.
 * @export
 * @interface PbCreateDemoPortalResponse
 */
export interface PbCreateDemoPortalResponse {
    /**
     * The id of the demo e-commerce that was created.
     * @type {string}
     * @memberof PbCreateDemoPortalResponse
     */
    'ecommerce_id'?: string;
    /**
     * Public URL of the demo returns portal, e.g.  https://returns.byrever.com/acme-demo.
     * @type {string}
     * @memberof PbCreateDemoPortalResponse
     */
    'portal_url'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateGiftCardRequest
 */
export interface PbCreateGiftCardRequest {
    /**
     * Amount of the promo code to be created, without decimals  in the `currency_return_process` format  TODO: should be renamed to `amount_customer` ?
     * @type {string}
     * @memberof PbCreateGiftCardRequest
     */
    'amount_return_process'?: string;
    /**
     * Amount of the promo code to be created, without decimals  in the `currency_shop` format
     * @type {string}
     * @memberof PbCreateGiftCardRequest
     */
    'amount_shop'?: string;
    /**
     * TODO: should be renamed to `currency_customer` ?  Currency of the `amount_return_process` field (customer currency)
     * @type {string}
     * @memberof PbCreateGiftCardRequest
     */
    'currency_return_process'?: string;
    /**
     * Currency of the `amount_shop` field (shop currency)
     * @type {string}
     * @memberof PbCreateGiftCardRequest
     */
    'currency_shop'?: string;
    /**
     * Customer printed order id (not necessarily the platform `order_id`)
     * @type {string}
     * @memberof PbCreateGiftCardRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbCreateGiftCardRequest
     */
    'ecommerce_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateGiftCardResponse
 */
export interface PbCreateGiftCardResponse {
    /**
     * Code of the created gift card (usable by customers)
     * @type {string}
     * @memberof PbCreateGiftCardResponse
     */
    'code'?: string;
    /**
     * Expires On is the expiration date of the gift card
     * @type {string}
     * @memberof PbCreateGiftCardResponse
     */
    'expires_on'?: string;
    /**
     * platform dependant ID of the created gift card - TO DEPRECATE
     * @type {string}
     * @memberof PbCreateGiftCardResponse
     */
    'id'?: string;
    /**
     * Platform ID is the ID of the gift card in the e-commerce platform
     * @type {string}
     * @memberof PbCreateGiftCardResponse
     */
    'platform_id'?: string;
}
/**
 * Payload for the CreateIncidentDocumentUploads request
 * @export
 * @interface PbCreateIncidentDocumentUploadsRequest
 */
export interface PbCreateIncidentDocumentUploadsRequest {
    /**
     * files to upload, between 1 and 6
     * @type {Array<PbCreateIncidentDocumentUploadsRequestIncidentDocument>}
     * @memberof PbCreateIncidentDocumentUploadsRequest
     */
    'documents'?: Array<PbCreateIncidentDocumentUploadsRequestIncidentDocument>;
    /**
     * id of the return process the incident is reported on
     * @type {string}
     * @memberof PbCreateIncidentDocumentUploadsRequest
     */
    'process_id'?: string;
}
/**
 * A file to upload
 * @export
 * @interface PbCreateIncidentDocumentUploadsRequestIncidentDocument
 */
export interface PbCreateIncidentDocumentUploadsRequestIncidentDocument {
    /**
     * MIME type of the file: application/pdf, image/jpeg or image/png
     * @type {string}
     * @memberof PbCreateIncidentDocumentUploadsRequestIncidentDocument
     */
    'content_type'?: string;
    /**
     * size of the file in bytes, up to 10 MB. The upload must send exactly this many bytes
     * @type {string}
     * @memberof PbCreateIncidentDocumentUploadsRequestIncidentDocument
     */
    'size_bytes'?: string;
}
/**
 * Response of the CreateIncidentDocumentUploads request
 * @export
 * @interface PbCreateIncidentDocumentUploadsResponse
 */
export interface PbCreateIncidentDocumentUploadsResponse {
    /**
     * one upload per requested document, in the same order
     * @type {Array<PbCreateIncidentDocumentUploadsResponseIncidentDocumentUpload>}
     * @memberof PbCreateIncidentDocumentUploadsResponse
     */
    'uploads'?: Array<PbCreateIncidentDocumentUploadsResponseIncidentDocumentUpload>;
}
/**
 * Where to upload a file and where to download it from
 * @export
 * @interface PbCreateIncidentDocumentUploadsResponseIncidentDocumentUpload
 */
export interface PbCreateIncidentDocumentUploadsResponseIncidentDocumentUpload {
    /**
     * presigned URL to GET the file from once uploaded, valid for 1 hour
     * @type {string}
     * @memberof PbCreateIncidentDocumentUploadsResponseIncidentDocumentUpload
     */
    'download_url'?: string;
    /**
     * presigned URL to PUT the file to, valid for 5 minutes
     * @type {string}
     * @memberof PbCreateIncidentDocumentUploadsResponseIncidentDocumentUpload
     */
    'upload_url'?: string;
}
/**
 * CreateNangoConnectSessionRequest opens a Nango Connect session for a group.
 * @export
 * @interface PbCreateNangoConnectSessionRequest
 */
export interface PbCreateNangoConnectSessionRequest {
    /**
     * Nango integrations the session may connect; empty allows every integration.
     * @type {Array<string>}
     * @memberof PbCreateNangoConnectSessionRequest
     */
    'allowed_integrations'?: Array<string>;
    /**
     * Ecommerce group the connections made in the session belong to.
     * @type {string}
     * @memberof PbCreateNangoConnectSessionRequest
     */
    'group'?: string;
}
/**
 * CreateNangoConnectSessionResponse is the token the Nango Connect UI opens with.
 * @export
 * @interface PbCreateNangoConnectSessionResponse
 */
export interface PbCreateNangoConnectSessionResponse {
    /**
     * When the token expires.
     * @type {string}
     * @memberof PbCreateNangoConnectSessionResponse
     */
    'expires_at'?: string;
    /**
     * Short-lived session token for the Nango Connect UI.
     * @type {string}
     * @memberof PbCreateNangoConnectSessionResponse
     */
    'token'?: string;
}
/**
 * CreateNangoReconnectSessionRequest opens a Nango Connect session that replaces the credentials of one of the  group\'s connections, keeping its id and the stores it is assigned to.
 * @export
 * @interface PbCreateNangoReconnectSessionRequest
 */
export interface PbCreateNangoReconnectSessionRequest {
    /**
     * Nango connection id.
     * @type {string}
     * @memberof PbCreateNangoReconnectSessionRequest
     */
    'connection_id'?: string;
    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof PbCreateNangoReconnectSessionRequest
     */
    'group'?: string;
    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof PbCreateNangoReconnectSessionRequest
     */
    'integration'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateOrderLineItem
 */
export interface PbCreateOrderLineItem {
    /**
     * Product id of the product
     * @type {string}
     * @memberof PbCreateOrderLineItem
     */
    'product_id'?: string;
    /**
     * Numer of items of type `product_id` + `variant_id`
     * @type {number}
     * @memberof PbCreateOrderLineItem
     */
    'quantity'?: number;
    /**
     * Variant id of the product
     * @type {string}
     * @memberof PbCreateOrderLineItem
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateOrderRequest
 */
export interface PbCreateOrderRequest {
    /**
     * Currency in which the order should be created
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'currency'?: string;
    /**
     * Ecommerce id. Required.
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * e-mail of the customer. Required.
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'email'?: string;
    /**
     * True when the exchange was created via instant exchange
     * @type {boolean}
     * @memberof PbCreateOrderRequest
     */
    'is_instant_exchange'?: boolean;
    /**
     * Line items of the order. Required.
     * @type {Array<PbCreateOrderLineItem>}
     * @memberof PbCreateOrderRequest
     */
    'line_items'?: Array<PbCreateOrderLineItem>;
    /**
     * Original platform `order_id` (not the customer printed order id) that  generated this order because of being returned. Required.
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'original_order_id'?: string;
    /**
     * Customer printed order id (not necessarily the platform `order_id`)
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'original_order_number'?: string;
    /**
     * Total of the exchange order, based on discounts applied to the original order
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'original_total'?: string;
    /**
     * The exchange order payment
     * @type {PbEcommerceMoney}
     * @memberof PbCreateOrderRequest
     */
    'payment'?: PbEcommerceMoney;
    /**
     * REVER ID of the return process that is creating this order
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'return_process_id'?: string;
    /**
     * Shipping address of the order. Required.
     * @type {ModelsAddress}
     * @memberof PbCreateOrderRequest
     */
    'shipping_address'?: ModelsAddress;
    /**
     * How the shipping (line) must be calculated and added to the order
     * @type {string}
     * @memberof PbCreateOrderRequest
     */
    'shipping_line'?: PbCreateOrderRequestShippingLineEnum;
}

export const PbCreateOrderRequestShippingLineEnum = {
    EcommerceDefault: 'ECOMMERCE_DEFAULT',
    Rever: 'REVER'
} as const;

export type PbCreateOrderRequestShippingLineEnum = typeof PbCreateOrderRequestShippingLineEnum[keyof typeof PbCreateOrderRequestShippingLineEnum];

/**
 * 
 * @export
 * @interface PbCreateOrderResponse
 */
export interface PbCreateOrderResponse {
    /**
     * Currency of the `order_total_price` field  ISO 4217 currency code (\"EUR\", \"USD\", \"GBP\"...)
     * @type {string}
     * @memberof PbCreateOrderResponse
     */
    'currency_code'?: string;
    /**
     * Order ID as the customer sees it in the email/platform
     * @type {string}
     * @memberof PbCreateOrderResponse
     */
    'customer_printed_order_id'?: string;
    /**
     * Order ID returned by the e-commerce platform
     * @type {string}
     * @memberof PbCreateOrderResponse
     */
    'order_id'?: string;
    /**
     * Line items of the created order
     * @type {Array<PbExchangeOrderLineItem>}
     * @memberof PbCreateOrderResponse
     */
    'order_line_items'?: Array<PbExchangeOrderLineItem>;
    /**
     * Total price of the order, without decimals, with the currency `currency_code`
     * @type {string}
     * @memberof PbCreateOrderResponse
     */
    'order_total_price'?: string;
}
/**
 * 
 * @export
 * @interface PbCreatePromocodeRequest
 */
export interface PbCreatePromocodeRequest {
    /**
     * Amount of the promo code to be created, without decimals  in the `currency_return_process` format  TODO: should be renamed to `amount_customer` ?
     * @type {string}
     * @memberof PbCreatePromocodeRequest
     */
    'amount_return_process'?: string;
    /**
     * Amount of the promo code to be created, without decimals  in the `currency_shop` format
     * @type {string}
     * @memberof PbCreatePromocodeRequest
     */
    'amount_shop'?: string;
    /**
     * TODO: should be renamed to `currency_customer` ?  Currency of the `amount_return_process` field (customer currency)
     * @type {string}
     * @memberof PbCreatePromocodeRequest
     */
    'currency_return_process'?: string;
    /**
     * Currency of the `amount_shop` field (shop currency)
     * @type {string}
     * @memberof PbCreatePromocodeRequest
     */
    'currency_shop'?: string;
    /**
     * Customer printed order id (not necessarily the platform `order_id`)
     * @type {string}
     * @memberof PbCreatePromocodeRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbCreatePromocodeRequest
     */
    'ecommerce_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCreatePromocodeResponse
 */
export interface PbCreatePromocodeResponse {
    /**
     * Code of the created promocode
     * @type {string}
     * @memberof PbCreatePromocodeResponse
     */
    'promocode'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateRefundRequest
 */
export interface PbCreateRefundRequest {
    /**
     * Refund legs REVER already executed outside this platform (e.g. a direct Stripe refund for  the cash-upcharge portion of an exchange order), included informationally in this same  batch-refund notification instead of triggering a duplicate merchant-side refund. Only  meaningful to batch refunders; ignored by non-batch platforms.
     * @type {Array<PbAlreadyExecutedRefund>}
     * @memberof PbCreateRefundRequest
     */
    'already_executed_refunds'?: Array<PbAlreadyExecutedRefund>;
    /**
     * In case there was a previous exchange of this order and this an OPM was requested  for the child order, we are doing the OPM in the parent order and we wanna know   the child order to keep track of it
     * @type {PbChildExchangeOrder}
     * @memberof PbCreateRefundRequest
     */
    'child_exchange_order'?: PbChildExchangeOrder;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'ecommerce_id': string;
    /**
     * Amount REVER approved to compensate via a *new* gift card, independent of any payment  instrument the order was originally paid with (RefundPaymentMethod_GIFT_CARD approval),  in this request\'s money_format minor units. Distinct from a batch refunder\'s own  instrument-based gift-card leg (derived from the order\'s real payment instruments by the  platform\'s refund strategy) — this is REVER/the reviewer\'s independent decision to  compensate with a gift card regardless of how the order was originally paid. Only  meaningful to batch refunders (see BatchRefunder); ignored by non-batch platforms, where  this compensation is instead issued through the standalone CreateGiftCard RPC.
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'gift_card_compensation_amount'?: string;
    /**
     * Idempotency key to be idempotent - used in salesforce & custom platform
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'idempotency_key'?: string;
    /**
     * Additional context for the refund request
     * @type {{ [key: string]: string; }}
     * @memberof PbCreateRefundRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * Money format of the `refundAmount` field. Going to be replaced soon by `currency`
     * @type {ModelsMoneyFormat}
     * @memberof PbCreateRefundRequest
     */
    'money_format': ModelsMoneyFormat;
    /**
     * OPM note
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'note'?: string;
    /**
     * platform order id (not necessarily the customer printed order id)
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'order_id': string;
    /**
     * Previous OPM executions from sibling return processes on the same order.  Required for payment gateways like Sequra that maintain cumulative refund state per order —  each refund call must include all previously executed refunds alongside the current one.  Populated by processes-api before calling ecommerce-api; ignored by all other gateways.
     * @type {Array<PbPreviousOPMExecution>}
     * @memberof PbCreateRefundRequest
     */
    'previous_opm_executions'?: Array<PbPreviousOPMExecution>;
    /**
     * Process id
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'process_id': string;
    /**
     * Adjustment amount to the refund amount  (positive or negative)  is the adjustment between the total value  of the items and the actual refund  Deprecated: no longer used, always 0
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'refund_adjustment_amount'?: string;
    /**
     * Items to be refunded (associated to the given amount)  that must exist in the order referred by `order_id`
     * @type {Array<PbRefundLineItem>}
     * @memberof PbCreateRefundRequest
     */
    'refund_line_items'?: Array<PbRefundLineItem>;
    /**
     * Amount to be refunded, without decimals, following the  currency/money format given in the request protolint:disable:next FIELD_NAMES_LOWER_SNAKE_CASE
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'refundAmount': string;
    /**
     * Platform id of the return process that is creating this return
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'return_process_platform_id': string;
    /**
     * Return shipping cost amount. This is the amount that was subtracted from the total refund  amount and won\'t be refunded to the customer. This is passed for preparing metadata information  about the return shipping costs.
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'return_shipping_cost_amount'?: string;
    /**
     * Shipping cost refund amount to the customer in the currency of the order
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'shipping_cost_refund_amount'?: string;
    /**
     * Idempotency key that stays the same across retries of this refund and differs between refunds:  a REVER resource id whose creation time the derived transaction ids sort by. Refunders derive  their REVER transaction ids from it, so a retry resends the same ids. Empty for callers that  don\'t need this (falls back to random ids).
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'transaction_idempotency_key'?: string;
    /**
     * Deprecated: the key now carries its own time. Only sent, together with a key that is not a  resource id, by refund workflows that fixed their key before that change.
     * @type {string}
     * @memberof PbCreateRefundRequest
     */
    'transaction_idempotency_key_time'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateRefundResponse
 */
export interface PbCreateRefundResponse {
    /**
     * ID returned by the e-commerce platform for the refund  Deprecated: platforms should return transactions executed instead
     * @type {string}
     * @memberof PbCreateRefundResponse
     */
    'id'?: string;
    /**
     * Transactions executed as part of the refund
     * @type {Array<PbRefundTransaction>}
     * @memberof PbCreateRefundResponse
     */
    'transactions'?: Array<PbRefundTransaction>;
}
/**
 * CreateUserRequest
 * @export
 * @interface PbCreateUserRequest
 */
export interface PbCreateUserRequest {
    /**
     * Group
     * @type {string}
     * @memberof PbCreateUserRequest
     */
    'ecommerce_group'?: string;
    /**
     * Optional. When set, the group is resolved from this ecommerce and ecommerce_group is  ignored — the dashboard names the ecommerce on screen, the backoffice names the group.
     * @type {string}
     * @memberof PbCreateUserRequest
     */
    'ecommerce_id'?: string;
    /**
     * User
     * @type {PbDashboardUser}
     * @memberof PbCreateUserRequest
     */
    'user'?: PbDashboardUser;
}
/**
 * CreateUserResponse
 * @export
 * @interface PbCreateUserResponse
 */
export interface PbCreateUserResponse {
    /**
     * User
     * @type {PbDashboardUser}
     * @memberof PbCreateUserResponse
     */
    'user'?: PbDashboardUser;
}
/**
 * CreateWfpFreeReturnRequest identifies the return process whose free return to notify Seel of. The  logistics label cost is resolved server-side from logistics-api.
 * @export
 * @interface PbCreateWfpFreeReturnRequest
 */
export interface PbCreateWfpFreeReturnRequest {
    /**
     * Return process id. Required.
     * @type {string}
     * @memberof PbCreateWfpFreeReturnRequest
     */
    'return_process_id'?: string;
}
/**
 * CreateWfpFreeReturnResponse reports the notification outcome and the data to persist via  SaveWfpFreeReturn.
 * @export
 * @interface PbCreateWfpFreeReturnResponse
 */
export interface PbCreateWfpFreeReturnResponse {
    /**
     * Currency of the recorded amounts (ISO-4217).
     * @type {string}
     * @memberof PbCreateWfpFreeReturnResponse
     */
    'currency'?: string;
    /**
     * Logistics label cost echoed back (cents), to persist on the ledger row.
     * @type {string}
     * @memberof PbCreateWfpFreeReturnResponse
     */
    'label_cost_cents'?: string;
    /**
     * Outcome. One of:    \"created\"            - free return notified (or skipped when no shipment); persist via                           SaveWfpFreeReturn    \"not_a_free_return\"  - no FREE_RETURN_PROMOTION line item, or no contract    \"is_claim\"           - return is a WFP claim (claim path owns it)    \"coverage_not_allowed\" - contract not active or outside coverage window    \"already_finalized\"  - the free return was already notified (seel_return_id present)
     * @type {string}
     * @memberof PbCreateWfpFreeReturnResponse
     */
    'result'?: string;
    /**
     * Provider-assigned id for the return. Empty when the provider is stubbed or  the call was skipped (no shipment data).
     * @type {string}
     * @memberof PbCreateWfpFreeReturnResponse
     */
    'seel_return_id'?: string;
    /**
     * Service fee echoed back (cents, = 150), to persist on the ledger row.
     * @type {string}
     * @memberof PbCreateWfpFreeReturnResponse
     */
    'service_fee_cents'?: string;
    /**
     * Seel contract id the free return belongs to. Populated when result = \"created\".
     * @type {string}
     * @memberof PbCreateWfpFreeReturnResponse
     */
    'wfp_contract_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCreateWithdrawalRequestInternalRequest
 */
export interface PbCreateWithdrawalRequestInternalRequest {
    /**
     * When the matched order\'s last item was delivered, or shipped when the carrier didn\'t  report the delivery
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'delivered_at'?: string;
    /**
     * E-commerce whose portal received it. Required.
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopper\'s email. Required.
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'email'?: string;
    /**
     * Language of the form, ISO 639-1. Defaults to en.
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'lang'?: string;
    /**
     * Shopper\'s name. Required.
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'name'?: string;
    /**
     * Platform ID of the order, when the caller matched it
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'order_id'?: string;
    /**
     * Order number as the shopper typed it. Required.
     * @type {string}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'order_number'?: string;
    /**
     * Whether any item of the matched order had shipped. The acknowledgment only  asks the shopper to send the goods back when it had.
     * @type {boolean}
     * @memberof PbCreateWithdrawalRequestInternalRequest
     */
    'order_shipped'?: boolean;
}
/**
 * Credentials request
 * @export
 * @interface PbCredentials
 */
export interface PbCredentials {
    /**
     * Optional -- only if Commerce Layer
     * @type {PbCommercelayerSettings}
     * @memberof PbCredentials
     */
    'commercelayer_settings'?: PbCommercelayerSettings;
    /**
     * Optional -- only if CustomIntegration
     * @type {PbCustomIntegrationSettings}
     * @memberof PbCredentials
     */
    'custom_integration_settings'?: PbCustomIntegrationSettings;
    /**
     * Optional -- only if CUSTOM_INTEGRATION_V2
     * @type {PbCustomIntegrationV2Settings}
     * @memberof PbCredentials
     */
    'custom_integration_v2_settings'?: PbCustomIntegrationV2Settings;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbCredentials
     */
    'ecommerce_id'?: string;
    /**
     * Optional -- only if Magento
     * @type {PbMagentoV2Settings}
     * @memberof PbCredentials
     */
    'magento_v2_settings'?: PbMagentoV2Settings;
    /**
     * Optional -- only if Prestashop
     * @type {PbPrestashopSettings}
     * @memberof PbCredentials
     */
    'prestashop_settings'?: PbPrestashopSettings;
    /**
     * Optional -- only if Shopify
     * @type {PbShopifySettings}
     * @memberof PbCredentials
     */
    'shopify_settings'?: PbShopifySettings;
    /**
     * Optional -- only if Shopware
     * @type {PbShopwareSettings}
     * @memberof PbCredentials
     */
    'shopware_settings'?: PbShopwareSettings;
    /**
     * Optional -- only if WooCommerce
     * @type {PbWooCommerceSettings}
     * @memberof PbCredentials
     */
    'woocommerce_settings'?: PbWooCommerceSettings;
}
/**
 * CustomCredentials contains all possible credential types and configuration
 * @export
 * @interface PbCustomCredentials
 */
export interface PbCustomCredentials {
    /**
     * API key credentials if using API key authentication
     * @type {PbAPIKeyCredentials}
     * @memberof PbCustomCredentials
     */
    'api_key'?: PbAPIKeyCredentials;
    /**
     * Basic auth credentials if using username/password authentication
     * @type {PbBasicAuthCredentials}
     * @memberof PbCustomCredentials
     */
    'basic_auth'?: PbBasicAuthCredentials;
    /**
     * Environment these credentials are for (production/development)
     * @type {string}
     * @memberof PbCustomCredentials
     */
    'environment'?: PbCustomCredentialsEnvironmentEnum;
    /**
     * Host for the custom platform
     * @type {string}
     * @memberof PbCustomCredentials
     */
    'host'?: string;
    /**
     * Whether these credentials are currently active
     * @type {boolean}
     * @memberof PbCustomCredentials
     */
    'is_active'?: boolean;
    /**
     * OAuth2 credentials if using OAuth2 authentication
     * @type {PbOAuth2Credentials}
     * @memberof PbCustomCredentials
     */
    'oauth2'?: PbOAuth2Credentials;
    /**
     * Custom credentials use cases
     * @type {Array<string>}
     * @memberof PbCustomCredentials
     */
    'use_cases'?: Array<PbCustomCredentialsUseCasesEnum>;
}

export const PbCustomCredentialsEnvironmentEnum = {
    Unspecified: 'ENVIRONMENT_UNSPECIFIED',
    Production: 'ENVIRONMENT_PRODUCTION',
    Development: 'ENVIRONMENT_DEVELOPMENT',
    Sandbox: 'ENVIRONMENT_SANDBOX'
} as const;

export type PbCustomCredentialsEnvironmentEnum = typeof PbCustomCredentialsEnvironmentEnum[keyof typeof PbCustomCredentialsEnvironmentEnum];
export const PbCustomCredentialsUseCasesEnum = {
    Unspecified: 'CUSTOM_CREDENTIALS_USE_CASE_UNSPECIFIED',
    GetReturnedItems: 'CUSTOM_CREDENTIALS_USE_CASE_GET_RETURNED_ITEMS'
} as const;

export type PbCustomCredentialsUseCasesEnum = typeof PbCustomCredentialsUseCasesEnum[keyof typeof PbCustomCredentialsUseCasesEnum];

/**
 * Amazon Pay payment gateway credentials for a custom integration
 * @export
 * @interface PbCustomIntegrationAmazonPayCredentials
 */
export interface PbCustomIntegrationAmazonPayCredentials {
    /**
     * Whether Amazon Pay is active for this e-commerce
     * @type {boolean}
     * @memberof PbCustomIntegrationAmazonPayCredentials
     */
    'is_active'?: boolean;
}
/**
 * API key specific settings in a custom integration
 * @export
 * @interface PbCustomIntegrationApiKey
 */
export interface PbCustomIntegrationApiKey {
    /**
     * API key provided by the integrator
     * @type {string}
     * @memberof PbCustomIntegrationApiKey
     */
    'api_key'?: string;
    /**
     * HTTP header to use for authentication (and set the api_key value)
     * @type {string}
     * @memberof PbCustomIntegrationApiKey
     */
    'header'?: string;
}
/**
 * Auth settings for a custom integration
 * @export
 * @interface PbCustomIntegrationAuth
 */
export interface PbCustomIntegrationAuth {
    /**
     * API Key configuration
     * @type {PbCustomIntegrationApiKey}
     * @memberof PbCustomIntegrationAuth
     */
    'api_key'?: PbCustomIntegrationApiKey;
    /**
     * Auth strategy to use
     * @type {string}
     * @memberof PbCustomIntegrationAuth
     */
    'auth_strategy'?: PbCustomIntegrationAuthAuthStrategyEnum;
    /**
     * OAuth 2.0 configuration
     * @type {PbCustomIntegrationOAuth2}
     * @memberof PbCustomIntegrationAuth
     */
    'o_auth2'?: PbCustomIntegrationOAuth2;
}

export const PbCustomIntegrationAuthAuthStrategyEnum = {
    BearerToken: 'BEARER_TOKEN',
    Oauth1: 'OAUTH_1',
    Apikey: 'APIKEY',
    Oauth2: 'OAUTH2'
} as const;

export type PbCustomIntegrationAuthAuthStrategyEnum = typeof PbCustomIntegrationAuthAuthStrategyEnum[keyof typeof PbCustomIntegrationAuthAuthStrategyEnum];

/**
 * Klarna payment gateway credentials for a custom integration
 * @export
 * @interface PbCustomIntegrationKlarnaCredentials
 */
export interface PbCustomIntegrationKlarnaCredentials {
    /**
     * Whether Klarna is active for this e-commerce
     * @type {boolean}
     * @memberof PbCustomIntegrationKlarnaCredentials
     */
    'is_active'?: boolean;
    /**
     * Whether to use the Klarna sandbox environment
     * @type {boolean}
     * @memberof PbCustomIntegrationKlarnaCredentials
     */
    'is_sandbox'?: boolean;
    /**
     * Klarna API password (secret)
     * @type {string}
     * @memberof PbCustomIntegrationKlarnaCredentials
     */
    'password'?: string;
    /**
     * Klarna merchant username
     * @type {string}
     * @memberof PbCustomIntegrationKlarnaCredentials
     */
    'username'?: string;
}
/**
 * OAuth2 specific settings in a custom integration
 * @export
 * @interface PbCustomIntegrationOAuth2
 */
export interface PbCustomIntegrationOAuth2 {
    /**
     * Client ID provided by the integrator
     * @type {string}
     * @memberof PbCustomIntegrationOAuth2
     */
    'client_id'?: string;
    /**
     * Client Secret provided by the integrator
     * @type {string}
     * @memberof PbCustomIntegrationOAuth2
     */
    'client_secret'?: string;
    /**
     * URL of the auth server for generating tokens
     * @type {string}
     * @memberof PbCustomIntegrationOAuth2
     */
    'token_url'?: string;
}
/**
 * Custom Integration Params contains the URL params for the onboarding
 * @export
 * @interface PbCustomIntegrationParams
 */
export interface PbCustomIntegrationParams {
    /**
     * Subplatform
     * @type {string}
     * @memberof PbCustomIntegrationParams
     */
    'subplatform'?: string;
    /**
     * Tiktok App code
     * @type {string}
     * @memberof PbCustomIntegrationParams
     */
    'tiktok_app_code'?: string;
    /**
     * Tiktok App key
     * @type {string}
     * @memberof PbCustomIntegrationParams
     */
    'tiktok_app_key'?: string;
    /**
     * Tiktok Shop ID
     * @type {string}
     * @memberof PbCustomIntegrationParams
     */
    'tiktok_shop_id'?: string;
}
/**
 * Payment gateway credentials for the custom integration DIRECT platform
 * @export
 * @interface PbCustomIntegrationPaymentGateway
 */
export interface PbCustomIntegrationPaymentGateway {
    /**
     * Amazon Pay payment gateway credentials
     * @type {PbCustomIntegrationAmazonPayCredentials}
     * @memberof PbCustomIntegrationPaymentGateway
     */
    'amazon_pay'?: PbCustomIntegrationAmazonPayCredentials;
    /**
     * Klarna payment gateway credentials
     * @type {PbCustomIntegrationKlarnaCredentials}
     * @memberof PbCustomIntegrationPaymentGateway
     */
    'klarna'?: PbCustomIntegrationKlarnaCredentials;
    /**
     * PayPal payment gateway credentials
     * @type {PbCustomIntegrationPaypalCredentials}
     * @memberof PbCustomIntegrationPaymentGateway
     */
    'paypal'?: PbCustomIntegrationPaypalCredentials;
    /**
     * Redsys payment gateway credentials
     * @type {PbCustomIntegrationRedsysCredentials}
     * @memberof PbCustomIntegrationPaymentGateway
     */
    'redsys'?: PbCustomIntegrationRedsysCredentials;
    /**
     * Sequra payment gateway credentials
     * @type {PbCustomIntegrationSequraCredentials}
     * @memberof PbCustomIntegrationPaymentGateway
     */
    'sequra'?: PbCustomIntegrationSequraCredentials;
    /**
     * Stripe payment gateway credentials
     * @type {PbCustomIntegrationStripeCredentials}
     * @memberof PbCustomIntegrationPaymentGateway
     */
    'stripe'?: PbCustomIntegrationStripeCredentials;
}
/**
 * PayPal payment gateway credentials for a custom integration
 * @export
 * @interface PbCustomIntegrationPaypalCredentials
 */
export interface PbCustomIntegrationPaypalCredentials {
    /**
     * PayPal OAuth2 client ID
     * @type {string}
     * @memberof PbCustomIntegrationPaypalCredentials
     */
    'client_id'?: string;
    /**
     * Whether PayPal is active for this e-commerce
     * @type {boolean}
     * @memberof PbCustomIntegrationPaypalCredentials
     */
    'is_active'?: boolean;
    /**
     * PayPal OAuth2 client secret
     * @type {string}
     * @memberof PbCustomIntegrationPaypalCredentials
     */
    'secret_id'?: string;
}
/**
 * Redsys payment gateway credentials for a custom integration
 * @export
 * @interface PbCustomIntegrationRedsysCredentials
 */
export interface PbCustomIntegrationRedsysCredentials {
    /**
     * Whether Redsys is active for this e-commerce
     * @type {boolean}
     * @memberof PbCustomIntegrationRedsysCredentials
     */
    'is_active'?: boolean;
    /**
     * Redsys merchant code
     * @type {string}
     * @memberof PbCustomIntegrationRedsysCredentials
     */
    'merchant_code'?: string;
    /**
     * Redsys signature (secret key used for HMAC signing)
     * @type {string}
     * @memberof PbCustomIntegrationRedsysCredentials
     */
    'signature'?: string;
    /**
     * Redsys terminal number
     * @type {number}
     * @memberof PbCustomIntegrationRedsysCredentials
     */
    'terminal'?: number;
}
/**
 * Sequra payment gateway credentials for a custom integration
 * @export
 * @interface PbCustomIntegrationSequraCredentials
 */
export interface PbCustomIntegrationSequraCredentials {
    /**
     * Whether Sequra is active for this e-commerce
     * @type {boolean}
     * @memberof PbCustomIntegrationSequraCredentials
     */
    'is_active'?: boolean;
    /**
     * Sequra API password
     * @type {string}
     * @memberof PbCustomIntegrationSequraCredentials
     */
    'password'?: string;
    /**
     * Sequra API username
     * @type {string}
     * @memberof PbCustomIntegrationSequraCredentials
     */
    'username'?: string;
}
/**
 * Specific settings for an e-commerce that has implemented his own  integration with REVER as explained in  https://api.byrever.com/v1/docs/#implementing-your-own-integration
 * @export
 * @interface PbCustomIntegrationSettings
 */
export interface PbCustomIntegrationSettings {
    /**
     * Base URL of the API to communicate with the e-commerce
     * @type {string}
     * @memberof PbCustomIntegrationSettings
     */
    'api_base_url'?: string;
    /**
     * Deprecated: use the auth field
     * @type {string}
     * @memberof PbCustomIntegrationSettings
     */
    'api_key'?: string;
    /**
     * Auth configuration
     * @type {PbCustomIntegrationAuth}
     * @memberof PbCustomIntegrationSettings
     */
    'auth'?: PbCustomIntegrationAuth;
    /**
     * Deprecated: use the auth field
     * @type {string}
     * @memberof PbCustomIntegrationSettings
     */
    'header'?: string;
    /**
     * Integration version - determines routing to legacy Lambda or direct HTTP  Falls back to legacy ecommerce-api routing when unspecified
     * @type {string}
     * @memberof PbCustomIntegrationSettings
     */
    'integration_version'?: PbCustomIntegrationSettingsIntegrationVersionEnum;
    /**
     * Configuration of the URLs for the different endpoints  of the integration
     * @type {PbCustomIntegrationURLMethods}
     * @memberof PbCustomIntegrationSettings
     */
    'methods_urls'?: PbCustomIntegrationURLMethods;
    /**
     * Payment gateway credentials for DIRECT integrations
     * @type {PbCustomIntegrationPaymentGateway}
     * @memberof PbCustomIntegrationSettings
     */
    'payment_gateway'?: PbCustomIntegrationPaymentGateway;
}

export const PbCustomIntegrationSettingsIntegrationVersionEnum = {
    Unspecified: 'CUSTOM_INTEGRATION_VERSION_UNSPECIFIED',
    Legacy: 'CUSTOM_INTEGRATION_VERSION_LEGACY',
    Direct: 'CUSTOM_INTEGRATION_VERSION_DIRECT'
} as const;

export type PbCustomIntegrationSettingsIntegrationVersionEnum = typeof PbCustomIntegrationSettingsIntegrationVersionEnum[keyof typeof PbCustomIntegrationSettingsIntegrationVersionEnum];

/**
 * Stripe payment gateway credentials for a custom integration
 * @export
 * @interface PbCustomIntegrationStripeCredentials
 */
export interface PbCustomIntegrationStripeCredentials {
    /**
     * Whether Stripe is active for this e-commerce
     * @type {boolean}
     * @memberof PbCustomIntegrationStripeCredentials
     */
    'is_active'?: boolean;
    /**
     * Stripe restricted secret key (secret) used to create refunds
     * @type {string}
     * @memberof PbCustomIntegrationStripeCredentials
     */
    'secret_key'?: string;
}
/**
 * Configuration of the URLs for the different endpoints
 * @export
 * @interface PbCustomIntegrationURLMethods
 */
export interface PbCustomIntegrationURLMethods {
    /**
     * Add note endpoint URL template  See // https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'add_note_url_template'?: string;
    /**
     * Create exchange order endpoint URL template  Used by DIRECT custom integrations to create the exchange order in the platform.  See https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'create_order_url_template'?: string;
    /**
     * Create promocode endpoint URL template  See https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'create_promocode_url_template'?: string;
    /**
     * Create refund endpoint URL template  See https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'create_refund_url_template'?: string;
    /**
     * Create return endpoint URL template  See https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'create_return_url_template'?: string;
    /**
     * find order by customer_order_printed_id URL endpoint template  See https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'find_order_url_template'?: string;
    /**
     * Update return endpoint URL template  See https://api.byrever.com/v1/docs/#implementing-your-own-integration
     * @type {string}
     * @memberof PbCustomIntegrationURLMethods
     */
    'update_return_url_template'?: string;
}
/**
 * Specific settings for an e-commerce that has implemented the v2 of the  custom integration contract. See the public OpenAPI spec at  https://docs.itsrever.com/apis/custom-integration-v2 for the HTTP surface  REVER calls.
 * @export
 * @interface PbCustomIntegrationV2Settings
 */
export interface PbCustomIntegrationV2Settings {
    /**
     * Base URL of the ecommerce\'s v2 API (e.g. https://shop.example.com/rever/v2).  REVER appends paths defined by the v2 OpenAPI spec.
     * @type {string}
     * @memberof PbCustomIntegrationV2Settings
     */
    'api_base_url'?: string;
    /**
     * Value sent in the X-rever-api-key header on every request.
     * @type {string}
     * @memberof PbCustomIntegrationV2Settings
     */
    'api_key'?: string;
}
/**
 * 
 * @export
 * @interface PbCustomPlatformSettingsResponse
 */
export interface PbCustomPlatformSettingsResponse {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'ecommerce_id'?: string;
    /**
     * Optional -- Generic custom platform settings
     * @type {PbGenericCustomSettings}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'generic_settings'?: PbGenericCustomSettings;
    /**
     * Optional -- Only if Logicommerce
     * @type {PbLogicommerceSettings}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'logicommerce_settings'?: PbLogicommerceSettings;
    /**
     * Optional -- Only if Mirakl
     * @type {PbMiraklPlatformSettings}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'mirakl_settings'?: PbMiraklPlatformSettings;
    /**
     * Optional -- Only if own platform
     * @type {PbOwnPlatformSettings}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'own_platform_settings'?: PbOwnPlatformSettings;
    /**
     * Optional -- Only if Tiktok
     * @type {PbTiktokPlatformSettings}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'tiktok_settings'?: PbTiktokPlatformSettings;
    /**
     * Optional -- Only if Vtex
     * @type {PbVtexPlatformSettings}
     * @memberof PbCustomPlatformSettingsResponse
     */
    'vtex_settings'?: PbVtexPlatformSettings;
}
/**
 * Customer information for business rule evaluation
 * @export
 * @interface PbCustomer
 */
export interface PbCustomer {
    /**
     * Platform-specific customer number
     * @type {string}
     * @memberof PbCustomer
     */
    'customer_no'?: string;
    /**
     * Whether the customer is loyal
     * @type {boolean}
     * @memberof PbCustomer
     */
    'is_loyal'?: boolean;
    /**
     * Platform-specific customer identifier
     * @type {string}
     * @memberof PbCustomer
     */
    'platform_customer_id'?: string;
}
/**
 * 
 * @export
 * @interface PbCustomerAddress
 */
export interface PbCustomerAddress {
    /**
     * 
     * @type {string}
     * @memberof PbCustomerAddress
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbCustomerAddress
     */
    'address_line_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbCustomerAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbCustomerAddress
     */
    'country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbCustomerAddress
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbCustomerAddress
     */
    'postal_code'?: string;
}
/**
 * DashboardUser is the user that can access the dashboard
 * @export
 * @interface PbDashboardUser
 */
export interface PbDashboardUser {
    /**
     * assigned warehouses
     * @type {Array<string>}
     * @memberof PbDashboardUser
     */
    'assigned_warehouses'?: Array<string>;
    /**
     * whether the user is blocked from logging in
     * @type {boolean}
     * @memberof PbDashboardUser
     */
    'blocked'?: boolean;
    /**
     * email
     * @type {string}
     * @memberof PbDashboardUser
     */
    'email'?: string;
    /**
     * Auth0 user id
     * @type {string}
     * @memberof PbDashboardUser
     */
    'id'?: string;
    /**
     * role
     * @type {string}
     * @memberof PbDashboardUser
     */
    'role'?: PbDashboardUserRoleEnum;
}

export const PbDashboardUserRoleEnum = {
    Unspecified: 'ROLE_UNSPECIFIED',
    WriteAll: 'ROLE_WRITE_ALL',
    ReadOnly: 'ROLE_READ_ONLY',
    Reviewer: 'ROLE_REVIEWER',
    AnalyticsOnly: 'ROLE_ANALYTICS_ONLY'
} as const;

export type PbDashboardUserRoleEnum = typeof PbDashboardUserRoleEnum[keyof typeof PbDashboardUserRoleEnum];

/**
 * DashboardUsers is the list of users that can access the dashboard
 * @export
 * @interface PbDashboardUsers
 */
export interface PbDashboardUsers {
    /**
     * list of user emails
     * @type {Array<PbDashboardUser>}
     * @memberof PbDashboardUsers
     */
    'users'?: Array<PbDashboardUser>;
}
/**
 * Delete warehouses request  Server enforces that deleted rows must satisfy both:    ecommerce_id = req.ecommerce_id AND id IN req.ids
 * @export
 * @interface PbDeleteWarehousesRequest
 */
export interface PbDeleteWarehousesRequest {
    /**
     * EcommerceID — scope for the deletion
     * @type {string}
     * @memberof PbDeleteWarehousesRequest
     */
    'ecommerce_id'?: string;
    /**
     * Warehouse ids to delete
     * @type {Array<string>}
     * @memberof PbDeleteWarehousesRequest
     */
    'ids'?: Array<string>;
}
/**
 * Delete warehouses response
 * @export
 * @interface PbDeleteWarehousesResponse
 */
export interface PbDeleteWarehousesResponse {
    /**
     * Number of rows actually deleted
     * @type {number}
     * @memberof PbDeleteWarehousesResponse
     */
    'deleted_count'?: number;
    /**
     * Ids that were actually deleted (subset of request.ids)
     * @type {Array<string>}
     * @memberof PbDeleteWarehousesResponse
     */
    'deleted_ids'?: Array<string>;
}
/**
 * Deletes warehouses of an ecommerce group. Only rows with both the group and one of the ids are deleted.
 * @export
 * @interface PbDeleteWarehousesV2Request
 */
export interface PbDeleteWarehousesV2Request {
    /**
     * Ecommerce group that owns the warehouses
     * @type {string}
     * @memberof PbDeleteWarehousesV2Request
     */
    'ecommerce_group'?: string;
    /**
     * Warehouse ids to delete
     * @type {Array<string>}
     * @memberof PbDeleteWarehousesV2Request
     */
    'ids'?: Array<string>;
}
/**
 * DemoBranding carries the branding fields extracted from a prospect\'s  storefront. Every field is optional: empty values keep the template\'s.
 * @export
 * @interface PbDemoBranding
 */
export interface PbDemoBranding {
    /**
     * URL of a hero/background image representing the brand.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'background_image_url'?: string;
    /**
     * URL of the site favicon.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'favicon_url'?: string;
    /**
     * URL of the brand logo image.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'logo_url'?: string;
    /**
     * Text color with enough contrast over the primary color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'primary_theme_color_contrast_text'?: string;
    /**
     * Dark variant of the primary color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'primary_theme_color_dark'?: string;
    /**
     * Light variant of the primary color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'primary_theme_color_light'?: string;
    /**
     * Primary theme color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'primary_theme_color_main'?: string;
    /**
     * Text color with enough contrast over the secondary color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'secondary_theme_color_contrast_text'?: string;
    /**
     * Dark variant of the secondary color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'secondary_theme_color_dark'?: string;
    /**
     * Light variant of the secondary color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'secondary_theme_color_light'?: string;
    /**
     * Secondary theme color, #rrggbb.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'secondary_theme_color_main'?: string;
    /**
     * Portal title, usually the shop display name.
     * @type {string}
     * @memberof PbDemoBranding
     */
    'title'?: string;
}
/**
 * Package dimensions for a single unit (one piece) of a product, in  centimeters - i.e. the dimensions of the parcel/box the unit ships in,  not the bare product itself. Source platforms typically expose these as  \"package length/width/height\" on the variant or as shipping metafields.  All fields are optional - populated only when the source platform exposes them.  Consumers must aggregate by line item quantity to compute parcel-level totals.  @Description Per-unit package dimensions in centimeters (parcel, not bare product)  @name api.Dimensions
 * @export
 * @interface PbDimensions
 */
export interface PbDimensions {
    /**
     * Package height in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof PbDimensions
     */
    'height_cm'?: string;
    /**
     * Package length in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof PbDimensions
     */
    'length_cm'?: string;
    /**
     * Package width in whole centimeters (sub-cm precision discarded).
     * @type {string}
     * @memberof PbDimensions
     */
    'width_cm'?: string;
}
/**
 * Discount code used to purchase an item
 * @export
 * @interface PbDiscountCode
 */
export interface PbDiscountCode {
    /**
     * Amount discounted from the line item
     * @type {string}
     * @memberof PbDiscountCode
     */
    'amount'?: string;
    /**
     * This discount code can be applied to any product
     * @type {boolean}
     * @memberof PbDiscountCode
     */
    'applies_to_all_products'?: boolean;
    /**
     * Code used to get the discount at purchase time
     * @type {string}
     * @memberof PbDiscountCode
     */
    'code'?: string;
    /**
     * Collections that are discounted by this code
     * @type {Array<string>}
     * @memberof PbDiscountCode
     */
    'collection_ids'?: Array<string>;
    /**
     * Unique id of the discount code
     * @type {string}
     * @memberof PbDiscountCode
     */
    'id'?: string;
    /**
     * True for Shopify automatic discounts; the `code` field then carries the discount title
     * @type {boolean}
     * @memberof PbDiscountCode
     */
    'is_automatic'?: boolean;
    /**
     * Products that are discounted by this code
     * @type {Array<string>}
     * @memberof PbDiscountCode
     */
    'product_ids'?: Array<string>;
    /**
     * Description of the discount code
     * @type {string}
     * @memberof PbDiscountCode
     */
    'summary'?: string;
    /**
     * Type can be fixed or percentage
     * @type {string}
     * @memberof PbDiscountCode
     */
    'type'?: string;
}
/**
 * List of copies for an ecommerce
 * @export
 * @interface PbECommerceCopies
 */
export interface PbECommerceCopies {
    /**
     * List of copies for an ecommerce
     * @type {Array<PbCopyTextDetail>}
     * @memberof PbECommerceCopies
     */
    'copies'?: Array<PbCopyTextDetail>;
}
/**
 * Map of copies for a given e-commerce
 * @export
 * @interface PbECommerceCopiesResponse
 */
export interface PbECommerceCopiesResponse {
    /**
     * List of copies for a given e-commerce
     * @type {Array<PbLanguageCopies>}
     * @memberof PbECommerceCopiesResponse
     */
    'language_copies'?: Array<PbLanguageCopies>;
}
/**
 * List of E-commerce ids
 * @export
 * @interface PbECommerceIdResponse
 */
export interface PbECommerceIdResponse {
    /**
     * List of E-commerce ids
     * @type {Array<string>}
     * @memberof PbECommerceIdResponse
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * How to identify an e-commerce  just use one of the fields that identifies the   e-commerce (by slug, id or group)
 * @export
 * @interface PbECommerceIdentification
 */
export interface PbECommerceIdentification {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof PbECommerceIdentification
     */
    'ecommerce_id'?: string;
    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof PbECommerceIdentification
     */
    'group'?: string;
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof PbECommerceIdentification
     */
    'slug'?: string;
}
/**
 * List of E-commerce ids from a group
 * @export
 * @interface PbECommerceIdsFromGroupResponse
 */
export interface PbECommerceIdsFromGroupResponse {
    /**
     * List of E-commerce Ids
     * @type {Array<string>}
     * @memberof PbECommerceIdsFromGroupResponse
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * List of E-commerce ids from a store id
 * @export
 * @interface PbECommerceIdsFromStoreIDResponse
 */
export interface PbECommerceIdsFromStoreIDResponse {
    /**
     * List of E-commerce Ids
     * @type {Array<string>}
     * @memberof PbECommerceIdsFromStoreIDResponse
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * Basic settings for an e-commerce  @Description  Basic settings for an e-commerce  @Name api.ECommerceSettings
 * @export
 * @interface PbECommerceSettings
 */
export interface PbECommerceSettings {
    /**
     * WebsiteSettings contains misc information about the e-commerce  Used, for example, for redirecting the user to the   e-commerce website after the  return is successfully created.  protolint:disable:next FIELD_NAMES_LOWER_SNAKE_CASE
     * @type {PbWebsiteSettings}
     * @memberof PbECommerceSettings
     */
    'WebsiteSettings'?: PbWebsiteSettings;
    /**
     * Analytics settings
     * @type {PbAnalytics}
     * @memberof PbECommerceSettings
     */
    'analytics'?: PbAnalytics;
    /**
     * Allows incrementally reviewing the line items of a process, that is, does  not require to bring all of the line items at once
     * @type {boolean}
     * @memberof PbECommerceSettings
     */
    'are_partial_reviews_allowed'?: boolean;
    /**
     * Optional -- only if Commerce Layer
     * @type {PbCommercelayerSettings}
     * @memberof PbECommerceSettings
     */
    'commercelayer_settings'?: PbCommercelayerSettings;
    /**
     * Currency code
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'currency_code'?: string;
    /**
     * Optional -- only if CustomIntegration
     * @type {PbCustomIntegrationSettings}
     * @memberof PbECommerceSettings
     */
    'custom_integration_settings'?: PbCustomIntegrationSettings;
    /**
     * Optional -- only if CUSTOM_INTEGRATION_V2
     * @type {PbCustomIntegrationV2Settings}
     * @memberof PbECommerceSettings
     */
    'custom_integration_v2_settings'?: PbCustomIntegrationV2Settings;
    /**
     * Delivery note configuration
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'delivery_note'?: string;
    /**
     * Identifier of the e-commerce in the Rever system
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'ecommerce_id'?: string;
    /**
     * ERP settings
     * @type {PbERPSettings}
     * @memberof PbECommerceSettings
     */
    'erp_settings'?: PbERPSettings;
    /**
     * Settings for the exchange order created in the ecommerce platform
     * @type {PbExchangeOrderSettings}
     * @memberof PbECommerceSettings
     */
    'exchange_order_settings'?: PbExchangeOrderSettings;
    /**
     * Exchange Threshold
     * @type {number}
     * @memberof PbECommerceSettings
     */
    'exchange_threshold'?: number;
    /**
     * External return policy URL
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'external_return_policy_url'?: string;
    /**
     * Fraud detection settings
     * @type {PbFraudDetectionSettings}
     * @memberof PbECommerceSettings
     */
    'fraud_detection_settings'?: PbFraudDetectionSettings;
    /**
     * Full exchange settings
     * @type {PbFullExchangeSettings}
     * @memberof PbECommerceSettings
     */
    'full_exchange_settings'?: PbFullExchangeSettings;
    /**
     * Group the e-commerce belongs to
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'group'?: string;
    /**
     * Identification flow
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'identification_flow'?: PbECommerceSettingsIdentificationFlowEnum;
    /**
     * InStore settings
     * @type {PbInStoreSettings}
     * @memberof PbECommerceSettings
     */
    'in_store_settings'?: PbInStoreSettings;
    /**
     * If the e-commerce is enabled
     * @type {boolean}
     * @memberof PbECommerceSettings
     */
    'is_enabled'?: boolean;
    /**
     * If this is not a production (paying) account
     * @type {boolean}
     * @memberof PbECommerceSettings
     */
    'is_testing_account'?: boolean;
    /**
     * Optional -- only if Magento
     * @type {PbMagentoV1Settings}
     * @memberof PbECommerceSettings
     */
    'magento_v1_settings'?: PbMagentoV1Settings;
    /**
     * Optional -- only if Magento
     * @type {PbMagentoV2Settings}
     * @memberof PbECommerceSettings
     */
    'magento_v2_settings'?: PbMagentoV2Settings;
    /**
     * Branding options for emails
     * @type {PbMailTheme}
     * @memberof PbECommerceSettings
     */
    'mail_theme'?: PbMailTheme;
    /**
     * When a review brings fewer line items than expected, treat every unit not  present in the review as MISSING instead of rejecting the review
     * @type {boolean}
     * @memberof PbECommerceSettings
     */
    'mark_unreviewed_items_as_missing'?: boolean;
    /**
     * Name of the E-commerce (user-friendly)
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'name'?: string;
    /**
     * NonReturnableItems contains the list of products, categories, brands...  that could be used to identify when a product has to be classified  as non-returnable.
     * @type {PbNonReturnableItems}
     * @memberof PbECommerceSettings
     */
    'non_returnable_items'?: PbNonReturnableItems;
    /**
     * Flag to enable payments
     * @type {boolean}
     * @memberof PbECommerceSettings
     */
    'payments_enabled'?: boolean;
    /**
     * Platform the e-commerce is based on
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'platform'?: PbECommerceSettingsPlatformEnum;
    /**
     * Optional -- only if Prestashop
     * @type {PbPrestashopSettings}
     * @memberof PbECommerceSettings
     */
    'prestashop_settings'?: PbPrestashopSettings;
    /**
     * Refund
     * @type {PbRefund}
     * @memberof PbECommerceSettings
     */
    'refund'?: PbRefund;
    /**
     * Reminder flow type
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'reminder_flow'?: string;
    /**
     * Restocking available
     * @type {boolean}
     * @memberof PbECommerceSettings
     */
    'restocking_available'?: boolean;
    /**
     * ReturnAmount with business rules
     * @type {PbReturnAmount}
     * @memberof PbECommerceSettings
     */
    'return_amount'?: PbReturnAmount;
    /**
     * Return logistics configures different ways for the users to  physically return the items to the e-commerce
     * @type {Array<PbReturnLogistics>}
     * @memberof PbECommerceSettings
     */
    'return_logistics'?: Array<PbReturnLogistics>;
    /**
     * Return days limit
     * @type {number}
     * @memberof PbECommerceSettings
     */
    'return_period_days'?: number;
    /**
     * Return deadlines of the orders purchased between two dates. The first rule that matches the  purchase date applies; return_period_days applies to every other order.
     * @type {Array<PbReturnPeriodRule>}
     * @memberof PbECommerceSettings
     */
    'return_period_rules'?: Array<PbReturnPeriodRule>;
    /**
     * Return reasons available  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbECommerceSettings
     */
    'return_reasons_available'?: Array<string>;
    /**
     * Review flow
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'review_flow'?: string;
    /**
     * Optional -- only if Shopify
     * @type {PbShopifySettings}
     * @memberof PbECommerceSettings
     */
    'shopify_settings'?: PbShopifySettings;
    /**
     * Optional -- only if Shopware
     * @type {PbShopwareSettings}
     * @memberof PbECommerceSettings
     */
    'shopware_settings'?: PbShopwareSettings;
    /**
     * List of workflow activities to skip (e.g., \"GenerateLogisticOrder\", \"SendACKEmail\")  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbECommerceSettings
     */
    'skip_workflow_activities'?: Array<string>;
    /**
     * Identifier of the E-commerce (url-friendly)
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'slug'?: string;
    /**
     * List of URLs of the e-commerce that list the available stores
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'store_list_url'?: string;
    /**
     * Theming
     * @type {PbTheming}
     * @memberof PbECommerceSettings
     */
    'theme'?: PbTheming;
    /**
     * Specifies the use case of ecommerce
     * @type {string}
     * @memberof PbECommerceSettings
     */
    'use_case'?: PbECommerceSettingsUseCaseEnum;
    /**
     * Address for warehouse
     * @type {PbAddress}
     * @memberof PbECommerceSettings
     */
    'warehouse_address'?: PbAddress;
    /**
     * Optional -- only if WooCommerce
     * @type {PbWooCommerceSettings}
     * @memberof PbECommerceSettings
     */
    'woocommerce_settings'?: PbWooCommerceSettings;
}

export const PbECommerceSettingsIdentificationFlowEnum = {
    IdentificationFlowUnspecified: 'IDENTIFICATION_FLOW_UNSPECIFIED',
    OrderIdAndEmail: 'ORDER_ID_AND_EMAIL',
    OrderIdAndPostalCode: 'ORDER_ID_AND_POSTAL_CODE'
} as const;

export type PbECommerceSettingsIdentificationFlowEnum = typeof PbECommerceSettingsIdentificationFlowEnum[keyof typeof PbECommerceSettingsIdentificationFlowEnum];
export const PbECommerceSettingsPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type PbECommerceSettingsPlatformEnum = typeof PbECommerceSettingsPlatformEnum[keyof typeof PbECommerceSettingsPlatformEnum];
export const PbECommerceSettingsUseCaseEnum = {
    Unspecified: 'USE_CASE_UNSPECIFIED',
    Standard: 'USE_CASE_STANDARD',
    Garantia: 'USE_CASE_GARANTIA',
    Internal: 'USE_CASE_INTERNAL',
    Lite: 'USE_CASE_LITE'
} as const;

export type PbECommerceSettingsUseCaseEnum = typeof PbECommerceSettingsUseCaseEnum[keyof typeof PbECommerceSettingsUseCaseEnum];

/**
 * ERP settings
 * @export
 * @interface PbERPSettings
 */
export interface PbERPSettings {
    /**
     * ERP name
     * @type {string}
     * @memberof PbERPSettings
     */
    'id'?: PbERPSettingsIdEnum;
}

export const PbERPSettingsIdEnum = {
    ErpUnspecified: 'ERP_UNSPECIFIED',
    Holded: 'HOLDED'
} as const;

export type PbERPSettingsIdEnum = typeof PbERPSettingsIdEnum[keyof typeof PbERPSettingsIdEnum];

/**
 * 
 * @export
 * @interface PbEcomerceReview
 */
export interface PbEcomerceReview {
    /**
     * line item id
     * @type {string}
     * @memberof PbEcomerceReview
     */
    'platform_line_item_id'?: string;
    /**
     * quantity
     * @type {string}
     * @memberof PbEcomerceReview
     */
    'quantity'?: string;
    /**
     * reject reason
     * @type {string}
     * @memberof PbEcomerceReview
     */
    'reject_reason'?: string;
    /**
     * review id
     * @type {string}
     * @memberof PbEcomerceReview
     */
    'rever_line_item_id'?: string;
    /**
     * status
     * @type {string}
     * @memberof PbEcomerceReview
     */
    'status'?: string;
    /**
     * timestamp
     * @type {string}
     * @memberof PbEcomerceReview
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface PbEcomerceReviewResponse
 */
export interface PbEcomerceReviewResponse {
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbEcomerceReviewResponse
     */
    'platform_process_id'?: string;
}
/**
 * Ecommerce model
 * @export
 * @interface PbEcommerce
 */
export interface PbEcommerce {
    /**
     * Allows incrementally reviewing the line items of a process, that is, does  not require to bring all of the line items at once
     * @type {boolean}
     * @memberof PbEcommerce
     */
    'are_partial_reviews_allowed'?: boolean;
    /**
     * CurrencyCode
     * @type {string}
     * @memberof PbEcommerce
     */
    'currency_code'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbEcommerce
     */
    'ecommerce_id'?: string;
    /**
     * EmailProvider
     * @type {string}
     * @memberof PbEcommerce
     */
    'email_provider'?: PbEcommerceEmailProviderEnum;
    /**
     * external policy url
     * @type {string}
     * @memberof PbEcommerce
     */
    'external_return_policy_url'?: string;
    /**
     * Group
     * @type {string}
     * @memberof PbEcommerce
     */
    'group'?: string;
    /**
     * How shoppers identify their orders
     * @type {string}
     * @memberof PbEcommerce
     */
    'identification_flow'?: PbEcommerceIdentificationFlowEnum;
    /**
     * IsEnabled
     * @type {boolean}
     * @memberof PbEcommerce
     */
    'is_enabled'?: boolean;
    /**
     * IsTesting
     * @type {boolean}
     * @memberof PbEcommerce
     */
    'is_testing'?: boolean;
    /**
     * When a review brings fewer line items than expected, treat every unit not  present in the review as MISSING instead of rejecting the review
     * @type {boolean}
     * @memberof PbEcommerce
     */
    'mark_unreviewed_items_as_missing'?: boolean;
    /**
     * name
     * @type {string}
     * @memberof PbEcommerce
     */
    'name'?: string;
    /**
     * OrdersSyncDisabled
     * @type {boolean}
     * @memberof PbEcommerce
     */
    'orders_sync_disabled'?: boolean;
    /**
     * Platform
     * @type {string}
     * @memberof PbEcommerce
     */
    'platform'?: string;
    /**
     * RestockingEnabled
     * @type {boolean}
     * @memberof PbEcommerce
     */
    'restocking_enabled'?: boolean;
    /**
     * slug
     * @type {string}
     * @memberof PbEcommerce
     */
    'slug'?: string;
    /**
     * StoreID
     * @type {string}
     * @memberof PbEcommerce
     */
    'store_id'?: string;
    /**
     * UseCase
     * @type {string}
     * @memberof PbEcommerce
     */
    'use_case'?: string;
    /**
     * WebsiteURL
     * @type {string}
     * @memberof PbEcommerce
     */
    'website_url'?: string;
}

export const PbEcommerceEmailProviderEnum = {
    Unspecified: 'EMAIL_PROVIDER_UNSPECIFIED',
    AwsSes: 'EMAIL_PROVIDER_AWS_SES',
    Inditex: 'EMAIL_PROVIDER_INDITEX'
} as const;

export type PbEcommerceEmailProviderEnum = typeof PbEcommerceEmailProviderEnum[keyof typeof PbEcommerceEmailProviderEnum];
export const PbEcommerceIdentificationFlowEnum = {
    IdentificationFlowUnspecified: 'IDENTIFICATION_FLOW_UNSPECIFIED',
    OrderIdAndEmail: 'ORDER_ID_AND_EMAIL',
    OrderIdAndPostalCode: 'ORDER_ID_AND_POSTAL_CODE'
} as const;

export type PbEcommerceIdentificationFlowEnum = typeof PbEcommerceIdentificationFlowEnum[keyof typeof PbEcommerceIdentificationFlowEnum];

/**
 * EcommerceContact is one point of contact of an e-commerce.
 * @export
 * @interface PbEcommerceContact
 */
export interface PbEcommerceContact {
    /**
     * Email address of the contact. Required.
     * @type {string}
     * @memberof PbEcommerceContact
     */
    'email'?: string;
    /**
     * Full name of the contact
     * @type {string}
     * @memberof PbEcommerceContact
     */
    'name'?: string;
    /**
     * Phone number of the contact
     * @type {string}
     * @memberof PbEcommerceContact
     */
    'phone'?: string;
    /**
     * Role this contact covers. Required. Several contacts may share a type.
     * @type {string}
     * @memberof PbEcommerceContact
     */
    'type'?: PbEcommerceContactTypeEnum;
}

export const PbEcommerceContactTypeEnum = {
    Unspecified: 'ECOMMERCE_CONTACT_TYPE_UNSPECIFIED',
    CustomerService: 'ECOMMERCE_CONTACT_TYPE_CUSTOMER_SERVICE',
    Logistics: 'ECOMMERCE_CONTACT_TYPE_LOGISTICS',
    Invoicing: 'ECOMMERCE_CONTACT_TYPE_INVOICING',
    TechnicalSupport: 'ECOMMERCE_CONTACT_TYPE_TECHNICAL_SUPPORT',
    Commercial: 'ECOMMERCE_CONTACT_TYPE_COMMERCIAL'
} as const;

export type PbEcommerceContactTypeEnum = typeof PbEcommerceContactTypeEnum[keyof typeof PbEcommerceContactTypeEnum];

/**
 * EcommerceContacts is the full set of points of contact of an e-commerce.
 * @export
 * @interface PbEcommerceContacts
 */
export interface PbEcommerceContacts {
    /**
     * Every stored contact, grouped by type in dashboard order
     * @type {Array<PbEcommerceContact>}
     * @memberof PbEcommerceContacts
     */
    'contacts'?: Array<PbEcommerceContact>;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbEcommerceContacts
     */
    'ecommerce_id'?: string;
}
/**
 * Exchanges settings an ecommerce uses instead of its group\'s
 * @export
 * @interface PbEcommerceExchangesSettingsOverridesV2
 */
export interface PbEcommerceExchangesSettingsOverridesV2 {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbEcommerceExchangesSettingsOverridesV2
     */
    'ecommerce_id'?: string;
    /**
     * Only the kinds it overrides
     * @type {PbExchangesSettingsV2}
     * @memberof PbEcommerceExchangesSettingsOverridesV2
     */
    'settings'?: PbExchangesSettingsV2;
}
/**
 * An e-commerce with the dates its record was created and last updated
 * @export
 * @interface PbEcommerceListEntry
 */
export interface PbEcommerceListEntry {
    /**
     * When the e-commerce was created. Unset when unknown.
     * @type {string}
     * @memberof PbEcommerceListEntry
     */
    'created_at'?: string;
    /**
     * The e-commerce
     * @type {PbEcommerce}
     * @memberof PbEcommerceListEntry
     */
    'ecommerce'?: PbEcommerce;
    /**
     * When the e-commerce was last updated. Unset when unknown.
     * @type {string}
     * @memberof PbEcommerceListEntry
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface PbEcommerceMoney
 */
export interface PbEcommerceMoney {
    /**
     * amount of the money
     * @type {string}
     * @memberof PbEcommerceMoney
     */
    'amount'?: string;
    /**
     * currency of the money
     * @type {string}
     * @memberof PbEcommerceMoney
     */
    'currency'?: string;
}
/**
 * Order the model for an order from any e-commerce (platform)  Important! the alias at the end is for API docs generation  @Description The model for an order from any e-commerce (platform)  @name api.Order
 * @export
 * @interface PbEcommerceOrder
 */
export interface PbEcommerceOrder {
    /**
     * billing address of the order
     * @type {ModelsAddress}
     * @memberof PbEcommerceOrder
     */
    'billing_address'?: ModelsAddress;
    /**
     * list of buy X get Y discounts
     * @type {Array<PbBxGyDiscount>}
     * @memberof PbEcommerceOrder
     */
    'bxgy_discounts'?: Array<PbBxGyDiscount>;
    /**
     * currency used by the customer
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'currency_customer'?: string;
    /**
     * currency used in the e-commerce
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'currency_shop'?: string;
    /**
     * customer associated to the order
     * @type {PbOrderCustomer}
     * @memberof PbEcommerceOrder
     */
    'customer'?: PbOrderCustomer;
    /**
     * exchange rate between the two currencies
     * @type {number}
     * @memberof PbEcommerceOrder
     */
    'exchange_rate'?: number;
    /**
     * protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS  date when the order was fulfilled
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'fulfilled_at'?: string;
    /**
     * identification of the order
     * @type {PbOrderIdentification}
     * @memberof PbEcommerceOrder
     */
    'identification'?: PbOrderIdentification;
    /**
     * line items of the order
     * @type {Array<PbOrderLineItem>}
     * @memberof PbEcommerceOrder
     */
    'line_items'?: Array<PbOrderLineItem>;
    /**
     * REVER 1.0 (Slice 1)  To be deprecated -->
     * @type {ModelsMoneyFormat}
     * @memberof PbEcommerceOrder
     */
    'money_format'?: ModelsMoneyFormat;
    /**
     * payment method used to pay the order
     * @type {PbPayment}
     * @memberof PbEcommerceOrder
     */
    'payment'?: PbPayment;
    /**
     * Payment methods used to pay the order in the e-commerce
     * @type {Array<string>}
     * @memberof PbEcommerceOrder
     */
    'payment_methods'?: Array<PbEcommerceOrderPaymentMethodsEnum>;
    /**
     * protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS  date when the order was purchased
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'purchased_at'?: string;
    /**
     * retrieval of the order
     * @type {PbOrderRetrieval}
     * @memberof PbEcommerceOrder
     */
    'retrieval'?: PbOrderRetrieval;
    /**
     * Per-order fixed amount subtracted from each return\'s refund, in money minor units.  Currently populated only by the SFCC connector via c_return_shipping_tax.  Absent or zero means no deduction.
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'return_shipping_tax'?: string;
    /**
     * Sales channel the order originated from, verbatim from the platform  (Shopify source_name: \"web\", \"pos\", \"bol\", ...). Empty when the platform  does not report one. Business rules read it via isPointOfSale.
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'sales_channel'?: string;
    /**
     * shipping address of the order
     * @type {ModelsAddress}
     * @memberof PbEcommerceOrder
     */
    'shipping_address'?: ModelsAddress;
    /**
     * shipping costs of the order
     * @type {Array<PbShippingCost>}
     * @memberof PbEcommerceOrder
     */
    'shipping_costs'?: Array<PbShippingCost>;
    /**
     * deprecated
     * @type {string}
     * @memberof PbEcommerceOrder
     */
    'shipping_method_id'?: string;
    /**
     * status of the order
     * @type {PbOrderStatus}
     * @memberof PbEcommerceOrder
     */
    'status'?: PbOrderStatus;
    /**
     * list of tags associated to the order
     * @type {Array<string>}
     * @memberof PbEcommerceOrder
     */
    'tags'?: Array<string>;
}

export const PbEcommerceOrderPaymentMethodsEnum = {
    Unknown: 'ORDERPM_UNKNOWN',
    PromoCode: 'ORDERPM_PROMO_CODE',
    GiftCard: 'ORDERPM_GIFT_CARD',
    Klarna: 'ORDERPM_KLARNA',
    OpmNotSupported: 'ORDERPM_OPM_NOT_SUPPORTED'
} as const;

export type PbEcommerceOrderPaymentMethodsEnum = typeof PbEcommerceOrderPaymentMethodsEnum[keyof typeof PbEcommerceOrderPaymentMethodsEnum];

/**
 * EcommercePASettings contains the Product Automations settings for an ecommerce
 * @export
 * @interface PbEcommercePASettings
 */
export interface PbEcommercePASettings {
    /**
     * ID of the ecommerce
     * @type {string}
     * @memberof PbEcommercePASettings
     */
    'ecommerce_id'?: string;
    /**
     * Group of the ecommerce
     * @type {string}
     * @memberof PbEcommercePASettings
     */
    'group'?: string;
    /**
     * If the ecommerce is the parent of the group (true if the ecommerce is the parent of the group)
     * @type {boolean}
     * @memberof PbEcommercePASettings
     */
    'is_parent'?: boolean;
    /**
     * The settings object where each section contains multiple key-value pairs for settings
     * @type {Array<PbPASection>}
     * @memberof PbEcommercePASettings
     */
    'sections'?: Array<PbPASection>;
}
/**
 * RDV surplus rules an ecommerce uses instead of its group\'s
 * @export
 * @interface PbEcommerceRDVSurplusV2
 */
export interface PbEcommerceRDVSurplusV2 {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbEcommerceRDVSurplusV2
     */
    'ecommerce_id'?: string;
    /**
     * Its rules
     * @type {PbRDVSurplusV2}
     * @memberof PbEcommerceRDVSurplusV2
     */
    'rdv_surplus'?: PbRDVSurplusV2;
}
/**
 * Refund configuration an ecommerce uses instead of its group\'s
 * @export
 * @interface PbEcommerceRefundConfigurationV2
 */
export interface PbEcommerceRefundConfigurationV2 {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbEcommerceRefundConfigurationV2
     */
    'ecommerce_id'?: string;
    /**
     * Its configuration
     * @type {PbRefundConfigurationV2}
     * @memberof PbEcommerceRefundConfigurationV2
     */
    'refund_configuration'?: PbRefundConfigurationV2;
}
/**
 * Return conditions an ecommerce uses instead of its group\'s
 * @export
 * @interface PbEcommerceReturnProcessConditionsV2
 */
export interface PbEcommerceReturnProcessConditionsV2 {
    /**
     * Its conditions
     * @type {PbReturnProcessConditions}
     * @memberof PbEcommerceReturnProcessConditionsV2
     */
    'conditions'?: PbReturnProcessConditions;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbEcommerceReturnProcessConditionsV2
     */
    'ecommerce_id'?: string;
}
/**
 * return reason
 * @export
 * @interface PbEcommerceReturnReason
 */
export interface PbEcommerceReturnReason {
    /**
     * cateogry of the reason
     * @type {Array<string>}
     * @memberof PbEcommerceReturnReason
     */
    'category_ids'?: Array<string>;
    /**
     * ecommerce id of th reason
     * @type {string}
     * @memberof PbEcommerceReturnReason
     */
    'ecommerce_id'?: string;
    /**
     * hidden
     * @type {boolean}
     * @memberof PbEcommerceReturnReason
     */
    'hidden'?: boolean;
    /**
     * Whether the returns portal requires the shopper to write a comment when  this reason is selected.
     * @type {boolean}
     * @memberof PbEcommerceReturnReason
     */
    'mandatory_comment'?: boolean;
    /**
     * name of the return reason
     * @type {string}
     * @memberof PbEcommerceReturnReason
     */
    'name'?: string;
}
/**
 * Return reasons an ecommerce uses instead of its group\'s
 * @export
 * @interface PbEcommerceReturnReasonsV2
 */
export interface PbEcommerceReturnReasonsV2 {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbEcommerceReturnReasonsV2
     */
    'ecommerce_id'?: string;
    /**
     * Its reasons
     * @type {PbReturnReasonsCollection}
     * @memberof PbEcommerceReturnReasonsV2
     */
    'return_reasons'?: PbReturnReasonsCollection;
}
/**
 * 
 * @export
 * @interface PbEcommerceReviewRequest
 */
export interface PbEcommerceReviewRequest {
    /**
     * ecommerce group
     * @type {string}
     * @memberof PbEcommerceReviewRequest
     */
    'ecommerce_group'?: string;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbEcommerceReviewRequest
     */
    'ecommerce_id'?: string;
    /**
     * order id
     * @type {string}
     * @memberof PbEcommerceReviewRequest
     */
    'platform_order_id'?: string;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbEcommerceReviewRequest
     */
    'platform_process_id'?: string;
    /**
     * process id
     * @type {string}
     * @memberof PbEcommerceReviewRequest
     */
    'rever_process_id'?: string;
    /**
     * reviews to be processed
     * @type {Array<PbEcomerceReview>}
     * @memberof PbEcommerceReviewRequest
     */
    'reviews'?: Array<PbEcomerceReview>;
}
/**
 * EcommerceStore represents a physical store of an ecommerce merchant.
 * @export
 * @interface PbEcommerceStore
 */
export interface PbEcommerceStore {
    /**
     * Street address line 1.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'address1'?: string;
    /**
     * Street address line 2 (suite, floor, etc.).
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'address2'?: string;
    /**
     * City.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'city'?: string;
    /**
     * ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'country_code'?: string;
    /**
     * Store email address.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'email'?: string;
    /**
     * Platform-side store identifier.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'id'?: string;
    /**
     * Display name of the store.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'name'?: string;
    /**
     * Store phone number.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'phone'?: string;
    /**
     * Postal/ZIP code.
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'postal_code'?: string;
    /**
     * State or region code (platform-dependent format).
     * @type {string}
     * @memberof PbEcommerceStore
     */
    'state_code'?: string;
}
/**
 * Evaluate RDV Surplus configuration response
 * @export
 * @interface PbEvaluateRDVSurplusResponse
 */
export interface PbEvaluateRDVSurplusResponse {
    /**
     * Surplus amount
     * @type {string}
     * @memberof PbEvaluateRDVSurplusResponse
     */
    'surplus_amount'?: string;
    /**
     * Surplus percentage
     * @type {number}
     * @memberof PbEvaluateRDVSurplusResponse
     */
    'surplus_percentage'?: number;
}
/**
 * ExchangeChainRoom is what the refund of an exchange-order return can still move along its  exchange chain.
 * @export
 * @interface PbExchangeChainRoom
 */
export interface PbExchangeChainRoom {
    /**
     * What REVER\'s own payments (Stripe) along the chain can still refund, in MoneyFormat minor units  of the process currency.
     * @type {string}
     * @memberof PbExchangeChainRoom
     */
    'rever_payments_remaining'?: string;
    /**
     * Platform id of the root order, the one the refund pays out of.
     * @type {string}
     * @memberof PbExchangeChainRoom
     */
    'root_order_id'?: string;
    /**
     * What the root order can still refund, in MoneyFormat minor units of the process currency; unset  when the root order could not be read, in which case no cap is applied.
     * @type {string}
     * @memberof PbExchangeChainRoom
     */
    'root_order_remaining'?: string;
}
/**
 * 
 * @export
 * @interface PbExchangeCompensation
 */
export interface PbExchangeCompensation {
    /**
     * 
     * @type {PbExchangeOrder}
     * @memberof PbExchangeCompensation
     */
    'exchange_order'?: PbExchangeOrder;
    /**
     * 
     * @type {PbCompensationSummary}
     * @memberof PbExchangeCompensation
     */
    'summary'?: PbCompensationSummary;
}
/**
 * ExchangeConditions model
 * @export
 * @interface PbExchangeConditions
 */
export interface PbExchangeConditions {
    /**
     * Use the destination warehouse\'s stock for exchanges instead of the store-wide total.
     * @type {boolean}
     * @memberof PbExchangeConditions
     */
    'destination_scoped_stock'?: boolean;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbExchangeConditions
     */
    'ecommerce_id'?: string;
    /**
     * exchange flow
     * @type {string}
     * @memberof PbExchangeConditions
     */
    'exchange_flow'?: PbExchangeConditionsExchangeFlowEnum;
    /**
     * PlatformMainMenuID
     * @type {string}
     * @memberof PbExchangeConditions
     */
    'platform_main_menu_id'?: string;
    /**
     * Threshold
     * @type {number}
     * @memberof PbExchangeConditions
     */
    'threshold'?: number;
}

export const PbExchangeConditionsExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type PbExchangeConditionsExchangeFlowEnum = typeof PbExchangeConditionsExchangeFlowEnum[keyof typeof PbExchangeConditionsExchangeFlowEnum];

/**
 * 
 * @export
 * @interface PbExchangeOrder
 */
export interface PbExchangeOrder {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbExchangeOrder
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbExchangeOrder
     */
    'created_at'?: string;
    /**
     * Navigation links for the exchange order.
     * @type {PbExchangeOrderNavigation}
     * @memberof PbExchangeOrder
     */
    'navigation'?: PbExchangeOrderNavigation;
    /**
     * 
     * @type {string}
     * @memberof PbExchangeOrder
     */
    'order_number'?: string;
    /**
     * Set when an exchanged item was rejected after this order had already shipped, so it could  not be canceled. Only detected on Shopify.
     * @type {string}
     * @memberof PbExchangeOrder
     */
    'shipped_notice'?: PbExchangeOrderShippedNoticeEnum;
}

export const PbExchangeOrderShippedNoticeEnum = {
    Unspecified: 'SHIPPED_NOTICE_UNSPECIFIED',
    DeductedFromRefund: 'SHIPPED_NOTICE_DEDUCTED_FROM_REFUND',
    NotCovered: 'SHIPPED_NOTICE_NOT_COVERED'
} as const;

export type PbExchangeOrderShippedNoticeEnum = typeof PbExchangeOrderShippedNoticeEnum[keyof typeof PbExchangeOrderShippedNoticeEnum];

/**
 * 
 * @export
 * @interface PbExchangeOrderLineItem
 */
export interface PbExchangeOrderLineItem {
    /**
     * Product id
     * @type {string}
     * @memberof PbExchangeOrderLineItem
     */
    'product_id'?: string;
    /**
     * Numer of items of type `product_id` + `variant_id`
     * @type {number}
     * @memberof PbExchangeOrderLineItem
     */
    'quantity'?: number;
    /**
     * Variant id of the product
     * @type {string}
     * @memberof PbExchangeOrderLineItem
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface PbExchangeOrderNavigation
 */
export interface PbExchangeOrderNavigation {
    /**
     * Browser-navigable URL to view the exchange order in the platform admin UI.  Empty when the platform is unsupported.
     * @type {string}
     * @memberof PbExchangeOrderNavigation
     */
    'admin_html_order_url'?: string;
}
/**
 * Settings for the exchange order created in the ecommerce platform
 * @export
 * @interface PbExchangeOrderSettings
 */
export interface PbExchangeOrderSettings {
    /**
     * Read exchange stock from the platform in the customer\'s country context  (the warehouse that will ship the exchange) instead of the store-wide total.  Off by default; enable for multi-warehouse merchants. Shopify only today.  Edited via exchange conditions (Settings > Exchange), not exchange order settings.
     * @type {boolean}
     * @memberof PbExchangeOrderSettings
     */
    'destination_scoped_stock'?: boolean;
    /**
     * Describe how inform the payment method of the exchange order  Example: `SAME_AS_ORIGINAL` for using the same payment method
     * @type {string}
     * @memberof PbExchangeOrderSettings
     */
    'payment_method'?: string;
    /**
     * Describes how the total of the exchange order is affected,   just for accounting purposes.   Example: `FULL` for normal price.   Example: `ZERO` for creating the order in the e-commerce platform   with total zero value.
     * @type {string}
     * @memberof PbExchangeOrderSettings
     */
    'price'?: string;
    /**
     * Describes how the shipping line will be created for the exchange   order in the e-commerce platform  Examples:  CHEAPEST, ZERO, ORIGINAL
     * @type {string}
     * @memberof PbExchangeOrderSettings
     */
    'shipping_line'?: string;
}
/**
 * ExchangeOrder model
 * @export
 * @interface PbExchangeOrderWithEcommerce
 */
export interface PbExchangeOrderWithEcommerce {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbExchangeOrderWithEcommerce
     */
    'ecommerce_id'?: string;
    /**
     * PaymentMethod
     * @type {string}
     * @memberof PbExchangeOrderWithEcommerce
     */
    'payment_method'?: string;
    /**
     * Price
     * @type {string}
     * @memberof PbExchangeOrderWithEcommerce
     */
    'price'?: string;
    /**
     * ShippingLine
     * @type {string}
     * @memberof PbExchangeOrderWithEcommerce
     */
    'shipping_line'?: string;
}
/**
 * How the exchange order is created
 * @export
 * @interface PbExchangeOrdersSettingsV2
 */
export interface PbExchangeOrdersSettingsV2 {
    /**
     * Give the exchange order the automatic discounts of the original order. Shopify only.
     * @type {boolean}
     * @memberof PbExchangeOrdersSettingsV2
     */
    'carry_over_automatic_discounts_on_exchanges'?: boolean;
    /**
     * Payment method the order shows: empty for \"Exchange by REVER\", or SAME_AS_ORIGINAL. PrestaShop only.
     * @type {string}
     * @memberof PbExchangeOrdersSettingsV2
     */
    'payment_method'?: string;
    /**
     * Price of the exchanged items: FULL or ZERO
     * @type {string}
     * @memberof PbExchangeOrdersSettingsV2
     */
    'price'?: string;
    /**
     * Shipping line: CHEAPEST, ZERO, ORIGINAL or ZERO_WITH_ZONE
     * @type {string}
     * @memberof PbExchangeOrdersSettingsV2
     */
    'shipping_line'?: string;
}
/**
 * Which exchanges shoppers are offered
 * @export
 * @interface PbExchangePolicyV2
 */
export interface PbExchangePolicyV2 {
    /**
     * Use the stock of the warehouse that ships to the shopper instead of the store-wide total. Shopify only.
     * @type {boolean}
     * @memberof PbExchangePolicyV2
     */
    'destination_scoped_stock'?: boolean;
    /**
     * Exchange flow
     * @type {string}
     * @memberof PbExchangePolicyV2
     */
    'exchange_flow'?: PbExchangePolicyV2ExchangeFlowEnum;
    /**
     * How much more expensive than the returned item a variant offered in exchange can be, in minor units
     * @type {number}
     * @memberof PbExchangePolicyV2
     */
    'threshold'?: number;
}

export const PbExchangePolicyV2ExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type PbExchangePolicyV2ExchangeFlowEnum = typeof PbExchangePolicyV2ExchangeFlowEnum[keyof typeof PbExchangePolicyV2ExchangeFlowEnum];

/**
 * Exchanges settings of a group or an ecommerce, one message per kind. A kind left out has no settings in a  response, and is left as it is in a save.
 * @export
 * @interface PbExchangesSettingsV2
 */
export interface PbExchangesSettingsV2 {
    /**
     * How the exchange order is created
     * @type {PbExchangeOrdersSettingsV2}
     * @memberof PbExchangesSettingsV2
     */
    'exchange_orders'?: PbExchangeOrdersSettingsV2;
    /**
     * The catalog shoppers pick from in a Full Catalog exchange
     * @type {PbFullCatalogSettingsV2}
     * @memberof PbExchangesSettingsV2
     */
    'full_catalog'?: PbFullCatalogSettingsV2;
    /**
     * Instant exchange, which only REVER can edit
     * @type {PbInstantExchangeSettingsV2}
     * @memberof PbExchangesSettingsV2
     */
    'instant_exchange'?: PbInstantExchangeSettingsV2;
    /**
     * Which exchanges shoppers are offered
     * @type {PbExchangePolicyV2}
     * @memberof PbExchangesSettingsV2
     */
    'policy'?: PbExchangePolicyV2;
}
/**
 * ExportReturnProcessesCsvRequest exports return processes as CSV using the  same filters as the FindProcesses listing endpoint. Pagination and sorting  are ignored (the export streams all matching processes).
 * @export
 * @interface PbExportReturnProcessesCsvRequest
 */
export interface PbExportReturnProcessesCsvRequest {
    /**
     * Filters mirroring the FindProcesses listing endpoint.
     * @type {PbFindProcessesRequest}
     * @memberof PbExportReturnProcessesCsvRequest
     */
    'filters'?: PbFindProcessesRequest;
}
/**
 * 
 * @export
 * @interface PbExportReturnProcessesRequest
 */
export interface PbExportReturnProcessesRequest {
    /**
     * 
     * @type {PbReturnProcessFilters}
     * @memberof PbExportReturnProcessesRequest
     */
    'filters'?: PbReturnProcessFilters;
}
/**
 * 
 * @export
 * @interface PbExportReturnProcessesResponse
 */
export interface PbExportReturnProcessesResponse {
    /**
     * 
     * @type {string}
     * @memberof PbExportReturnProcessesResponse
     */
    'download_url'?: string;
}
/**
 * ExternalRefund is a refund executed on the e-commerce platform outside REVER.
 * @export
 * @interface PbExternalRefund
 */
export interface PbExternalRefund {
    /**
     * Money moved by the refund in MoneyFormat minor units of currency (diagnostic only).
     * @type {string}
     * @memberof PbExternalRefund
     */
    'amount'?: string;
    /**
     * ISO 4217 currency of the amounts.
     * @type {string}
     * @memberof PbExternalRefund
     */
    'currency'?: string;
    /**
     * True for order-level money not attributed to any line item (appeasement).
     * @type {boolean}
     * @memberof PbExternalRefund
     */
    'is_appeasement'?: boolean;
    /**
     * Line items the refund was attributed to on the platform; empty for pooled refunds.
     * @type {Array<PbExternalRefundLineItem>}
     * @memberof PbExternalRefund
     */
    'line_items'?: Array<PbExternalRefundLineItem>;
    /**
     * Stable platform id of the refund; with the line item id it is the idempotency key of line  deductions.
     * @type {string}
     * @memberof PbExternalRefund
     */
    'platform_refund_id'?: string;
}
/**
 * ExternalRefundDeduction is a commit transaction created by the reconciliation.
 * @export
 * @interface PbExternalRefundDeduction
 */
export interface PbExternalRefundDeduction {
    /**
     * Positive amount deducted, in MoneyFormat minor units of the process currency.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'amount'?: string;
    /**
     * Rule that tied the refund to the line item: \"platform\" when the platform attributed it,  otherwise the reconciliation heuristic that inferred it (e.g. \"single_returned_item\"). Empty  for the cap deduction.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'attribution'?: string;
    /**
     * Platform line item id the deduction is attributed to; empty for the cap deduction.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'line_item_id'?: string;
    /**
     * Technical detail written on the created transaction\'s metadata: platform refund and line item  ids, the attribution rule, the platform actor, the amounts behind a cap.
     * @type {object}
     * @memberof PbExternalRefundDeduction
     */
    'metadata'?: object;
    /**
     * Merchant-facing note written on the created transaction.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'note'?: string;
    /**
     * Refund payment method whose commitment was reduced.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'payment_method'?: PbExternalRefundDeductionPaymentMethodEnum;
    /**
     * Platform refund id of the external refund; empty for the cap deduction.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'platform_refund_id'?: string;
    /**
     * REVER id of the created commit transaction.
     * @type {string}
     * @memberof PbExternalRefundDeduction
     */
    'transaction_id'?: string;
}

export const PbExternalRefundDeductionPaymentMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbExternalRefundDeductionPaymentMethodEnum = typeof PbExternalRefundDeductionPaymentMethodEnum[keyof typeof PbExternalRefundDeductionPaymentMethodEnum];

/**
 * 
 * @export
 * @interface PbExternalRefundDetails
 */
export interface PbExternalRefundDetails {
    /**
     * 
     * @type {string}
     * @memberof PbExternalRefundDetails
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbExternalRefundDetails
     */
    'user'?: string;
}
/**
 * ExternalRefundLineItem is the part of an external refund attributed to one order line item.
 * @export
 * @interface PbExternalRefundLineItem
 */
export interface PbExternalRefundLineItem {
    /**
     * Amount refunded for that line item, taxes included, in MoneyFormat minor units of currency.
     * @type {string}
     * @memberof PbExternalRefundLineItem
     */
    'amount'?: string;
    /**
     * ISO 4217 currency of the amount.
     * @type {string}
     * @memberof PbExternalRefundLineItem
     */
    'currency'?: string;
    /**
     * Platform id of the order line item (the same id carried by the return process line items).
     * @type {string}
     * @memberof PbExternalRefundLineItem
     */
    'line_item_id'?: string;
    /**
     * Quantity of that line item refunded.
     * @type {string}
     * @memberof PbExternalRefundLineItem
     */
    'quantity'?: string;
}
/**
 * 
 * @export
 * @interface PbExtraLineItem
 */
export interface PbExtraLineItem {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbExtraLineItem
     */
    'total'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbExtraLineItem
     */
    'type'?: PbExtraLineItemTypeEnum;
}

export const PbExtraLineItemTypeEnum = {
    Unspecified: 'TYPE_UNSPECIFIED',
    ReturnShippingCost: 'TYPE_RETURN_SHIPPING_COST',
    OriginalShippingRefund: 'TYPE_ORIGINAL_SHIPPING_REFUND',
    KeepYourItem: 'TYPE_KEEP_YOUR_ITEM',
    RdvSurplus: 'TYPE_RDV_SURPLUS',
    ServiceFee: 'TYPE_SERVICE_FEE',
    OriginalPromotionBroken: 'TYPE_ORIGINAL_PROMOTION_BROKEN',
    ExchangePromotion: 'TYPE_EXCHANGE_PROMOTION',
    InstantExchange: 'TYPE_INSTANT_EXCHANGE',
    FreeReturnPromotion: 'TYPE_FREE_RETURN_PROMOTION',
    ReturnShippingTax: 'TYPE_RETURN_SHIPPING_TAX',
    ExternalRefund: 'TYPE_EXTERNAL_REFUND',
    PlatformRefundableCap: 'TYPE_PLATFORM_REFUNDABLE_CAP'
} as const;

export type PbExtraLineItemTypeEnum = typeof PbExtraLineItemTypeEnum[keyof typeof PbExtraLineItemTypeEnum];

/**
 * 
 * @export
 * @interface PbExtraLineItems
 */
export interface PbExtraLineItems {
    /**
     * 
     * @type {Array<PbExtraLineItem>}
     * @memberof PbExtraLineItems
     */
    'extra_line_items'?: Array<PbExtraLineItem>;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbExtraLineItems
     */
    'total'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbExtraLineRequest
 */
export interface PbExtraLineRequest {
    /**
     * Extra line name
     * @type {string}
     * @memberof PbExtraLineRequest
     */
    'name'?: string;
    /**
     * Extra line price
     * @type {string}
     * @memberof PbExtraLineRequest
     */
    'price'?: string;
}
/**
 * protolint:disable:next MESSAGE_NAMES_EXCLUDE_PREPOSITIONS
 * @export
 * @interface PbFindByOrderIDAndSkuAndEcommerceIDResponse
 */
export interface PbFindByOrderIDAndSkuAndEcommerceIDResponse {
    /**
     * 
     * @type {PbFindByOrderIDAndSkuAndEcommerceIDResponseLineItemResult}
     * @memberof PbFindByOrderIDAndSkuAndEcommerceIDResponse
     */
    'result'?: PbFindByOrderIDAndSkuAndEcommerceIDResponseLineItemResult;
}
/**
 * 
 * @export
 * @interface PbFindByOrderIDAndSkuAndEcommerceIDResponseLineItemResult
 */
export interface PbFindByOrderIDAndSkuAndEcommerceIDResponseLineItemResult {
    /**
     * 
     * @type {string}
     * @memberof PbFindByOrderIDAndSkuAndEcommerceIDResponseLineItemResult
     */
    'line_item_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbFindByOrderIDAndSkuAndEcommerceIDResponseLineItemResult
     */
    'process_id'?: string;
}
/**
 * FindItemReturnReason request
 * @export
 * @interface PbFindItemReturnReason
 */
export interface PbFindItemReturnReason {
    /**
     * category ids
     * @type {Array<string>}
     * @memberof PbFindItemReturnReason
     */
    'category_ids'?: Array<string>;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbFindItemReturnReason
     */
    'ecommerce_id'?: string;
}
/**
 * FindLineItemReturnReasonsRequest scopes the reason options. Group and  warehouse scoping are applied from the caller\'s claims.
 * @export
 * @interface PbFindLineItemReturnReasonsRequest
 */
export interface PbFindLineItemReturnReasonsRequest {
    /**
     * Optional: restrict to a single ecommerce within the caller\'s group.
     * @type {string}
     * @memberof PbFindLineItemReturnReasonsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional: restrict to these ecommerces within the caller\'s group. Combined  with ecommerce_id when both are set.
     * @type {Array<string>}
     * @memberof PbFindLineItemReturnReasonsRequest
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * FindLineItemReturnReasonsResponse is the list of distinct return reasons.
 * @export
 * @interface PbFindLineItemReturnReasonsResponse
 */
export interface PbFindLineItemReturnReasonsResponse {
    /**
     * Distinct return reasons of the caller\'s returned products, sorted.
     * @type {Array<string>}
     * @memberof PbFindLineItemReturnReasonsResponse
     */
    'return_reasons'?: Array<string>;
}
/**
 * FindProcessCarriersRequest scopes the carrier options. Group and warehouse  scoping are applied from the caller\'s claims.
 * @export
 * @interface PbFindProcessCarriersRequest
 */
export interface PbFindProcessCarriersRequest {
    /**
     * Optional: restrict to a single ecommerce within the caller\'s group.
     * @type {string}
     * @memberof PbFindProcessCarriersRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional: restrict to these ecommerces within the caller\'s group. Combined  with ecommerce_id when both are set.
     * @type {Array<string>}
     * @memberof PbFindProcessCarriersRequest
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * FindProcessCarriersResponse is the list of distinct carrier names (the values  accepted by the carrier filter).
 * @export
 * @interface PbFindProcessCarriersResponse
 */
export interface PbFindProcessCarriersResponse {
    /**
     * Distinct carrier names present in the caller\'s processes, sorted.
     * @type {Array<string>}
     * @memberof PbFindProcessCarriersResponse
     */
    'carriers'?: Array<string>;
}
/**
 * FindProcessCountriesRequest scopes the country options. Group and warehouse  scoping are applied from the caller\'s claims.
 * @export
 * @interface PbFindProcessCountriesRequest
 */
export interface PbFindProcessCountriesRequest {
    /**
     * Optional: restrict to a single ecommerce within the caller\'s group.
     * @type {string}
     * @memberof PbFindProcessCountriesRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional: restrict to these ecommerces within the caller\'s group. Combined  with ecommerce_id when both are set.
     * @type {Array<string>}
     * @memberof PbFindProcessCountriesRequest
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * FindProcessCountriesResponse is the list of distinct origin countries.
 * @export
 * @interface PbFindProcessCountriesResponse
 */
export interface PbFindProcessCountriesResponse {
    /**
     * Distinct origin countries present in the caller\'s processes, sorted by name.
     * @type {Array<PbCountry>}
     * @memberof PbFindProcessCountriesResponse
     */
    'countries'?: Array<PbCountry>;
}
/**
 * FindProcessWarehousesRequest scopes the warehouse options. Group and reviewer  warehouse scoping are applied from the caller\'s claims.
 * @export
 * @interface PbFindProcessWarehousesRequest
 */
export interface PbFindProcessWarehousesRequest {
    /**
     * Optional: restrict to a single ecommerce (otherwise all in the group).
     * @type {string}
     * @memberof PbFindProcessWarehousesRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional: restrict to these ecommerces (otherwise all in the group).  Combined with ecommerce_id when both are set.
     * @type {Array<string>}
     * @memberof PbFindProcessWarehousesRequest
     */
    'ecommerce_ids'?: Array<string>;
    /**
     * Return only the warehouses some process already references, instead of every  warehouse the ecommerce owns. A filter dropdown wants this; a picker that  assigns a warehouse does not, since an unused one is still a valid target.
     * @type {boolean}
     * @memberof PbFindProcessWarehousesRequest
     */
    'only_referenced_by_processes'?: boolean;
}
/**
 * FindProcessWarehousesResponse is the list of warehouses the caller can filter  by (the values accepted by the warehouse_id filter).
 * @export
 * @interface PbFindProcessWarehousesResponse
 */
export interface PbFindProcessWarehousesResponse {
    /**
     * Warehouses visible to the caller, sorted by name.
     * @type {Array<PbWarehouseInfo>}
     * @memberof PbFindProcessWarehousesResponse
     */
    'warehouses'?: Array<PbWarehouseInfo>;
}
/**
 * 
 * @export
 * @interface PbFindProcessesByEmailAndEcommerceGroupResponse
 */
export interface PbFindProcessesByEmailAndEcommerceGroupResponse {
    /**
     * 
     * @type {Array<PbHelpDeskProcessData>}
     * @memberof PbFindProcessesByEmailAndEcommerceGroupResponse
     */
    'rever_returns_information'?: Array<PbHelpDeskProcessData>;
}
/**
 * FindProcessesRequest carries the filters, ordering and pagination for  FindProcesses. Empty/absent string fields mean \"no filtering\".
 * @export
 * @interface PbFindProcessesRequest
 */
export interface PbFindProcessesRequest {
    /**
     * Filter processes by bank transfer amount greater than this value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'bank_transfer_refund_amount_gt'?: string;
    /**
     * Filter by user-selected carrier. Multiple values are OR-ed.
     * @type {Array<string>}
     * @memberof PbFindProcessesRequest
     */
    'carrier'?: Array<string>;
    /**
     * Filter by compensation method (derived from committed refund amounts).  Allowed: ORIGINAL, BANK_TRANSFER, PROMO_CODE, GIFT_CARD, EXCHANGE. OR-ed.
     * @type {Array<string>}
     * @memberof PbFindProcessesRequest
     */
    'compensation'?: Array<string>;
    /**
     * Filter by origin country (ISO code of the pickup address). Multiple OR-ed.
     * @type {Array<string>}
     * @memberof PbFindProcessesRequest
     */
    'country'?: Array<string>;
    /**
     * Filter processes created on or after this date (created_at >=).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'created_at_gte'?: string;
    /**
     * Filter processes created on or before this date (created_at <=).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'created_at_lte'?: string;
    /**
     * Filter by customer email (maps to the customer.email column).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'customer_email'?: string;
    /**
     * Filter by customer_printed_order_id value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * Filter by ecommerce_id value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'ecommerce_id'?: string;
    /**
     * Filter by exchange_order_number value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'exchange_order_number'?: string;
    /**
     * Filter processes by exchange amount greater than this value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'exchange_refund_amount_gt'?: string;
    /**
     * Open text search across the process.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'freetext'?: string;
    /**
     * Filter by fully_refunded flag. If unset, no filtering is applied.
     * @type {boolean}
     * @memberof PbFindProcessesRequest
     */
    'fully_refunded'?: boolean;
    /**
     * Filter processes by gift card amount greater than this value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'gift_refund_amount_gt'?: string;
    /**
     * Filter by group value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'group'?: string;
    /**
     * Internal to REVER staff tooling; ignored for any other caller. When the  status filter includes ON_HOLD, also match processes with a running  workflow on hold whatever their stored status, and set has_open_on_hold.
     * @type {boolean}
     * @memberof PbFindProcessesRequest
     */
    'include_detached_on_hold'?: boolean;
    /**
     * Filter by is_testing flag. If unset, no filtering is applied.
     * @type {boolean}
     * @memberof PbFindProcessesRequest
     */
    'is_testing'?: boolean;
    /**
     * Filter by last known shipping status.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'last_known_shipping_status'?: string;
    /**
     * Maximum number of results. Default value is 20.
     * @type {number}
     * @memberof PbFindProcessesRequest
     */
    'limit'?: number;
    /**
     * Filter by line item refund payment method (maps to the  line_items.refund_payment_method column). Supports comma-separated values.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'line_items_refund_payment_method'?: string;
    /**
     * Filter by derived logistics status. NA means the process has no logistics  (no provider selected). Multiple values are OR-ed.
     * @type {Array<string>}
     * @memberof PbFindProcessesRequest
     */
    'logistics_status'?: Array<PbFindProcessesRequestLogisticsStatusEnum>;
    /**
     * Items offset. Default value is 0.
     * @type {number}
     * @memberof PbFindProcessesRequest
     */
    'offset'?: number;
    /**
     * Order direction: ASC or DESC. Default value is DESC.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'order'?: string;
    /**
     * Filter by order_id value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'order_id'?: string;
    /**
     * Filter processes by OPM amount greater than this value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'original_pm_refund_amount_gt'?: string;
    /**
     * Filter by platform value (SHOPIFY, MOCK, MAGENTO...).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'platform'?: string;
    /**
     * Filter by process_id value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'process_id'?: string;
    /**
     * Filter processes by promocode amount greater than this value.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'promocode_refund_amount_gt'?: string;
    /**
     * Filter by derived refund status. Multiple values are OR-ed.
     * @type {Array<string>}
     * @memberof PbFindProcessesRequest
     */
    'refund_status'?: Array<PbFindProcessesRequestRefundStatusEnum>;
    /**
     * Filter by return_method value (HOME_PICK_UP, DROP_OFF_POINT).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'return_method'?: string;
    /**
     * Filter by return status.
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'return_status'?: string;
    /**
     * Sort column. Default value is \"started_at\".
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'sortby'?: string;
    /**
     * Filter by status value (RUNNING, FAILED, COMPLETED).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'status'?: string;
    /**
     * Filter processes having a transaction with the given platform ID  (maps to the transactions.platform_id column).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'transactions_platform_id'?: string;
    /**
     * Filter by logistics provider (NONE, OPS, SendCloud...).
     * @type {string}
     * @memberof PbFindProcessesRequest
     */
    'user_selected_provider'?: string;
    /**
     * Filter by warehouse ID. Multiple values are OR-ed.
     * @type {Array<string>}
     * @memberof PbFindProcessesRequest
     */
    'warehouse_id'?: Array<string>;
}

export const PbFindProcessesRequestLogisticsStatusEnum = {
    Unspecified: 'LOGISTICS_STATUS_UNSPECIFIED',
    Na: 'LOGISTICS_STATUS_NA',
    LabelPending: 'LOGISTICS_STATUS_LABEL_PENDING',
    Created: 'LOGISTICS_STATUS_CREATED',
    Collected: 'LOGISTICS_STATUS_COLLECTED',
    Warehouse: 'LOGISTICS_STATUS_WAREHOUSE'
} as const;

export type PbFindProcessesRequestLogisticsStatusEnum = typeof PbFindProcessesRequestLogisticsStatusEnum[keyof typeof PbFindProcessesRequestLogisticsStatusEnum];
export const PbFindProcessesRequestRefundStatusEnum = {
    Unspecified: 'REFUND_STATUS_UNSPECIFIED',
    Na: 'REFUND_STATUS_NA',
    Pending: 'REFUND_STATUS_PENDING',
    Processing: 'REFUND_STATUS_PROCESSING',
    Completed: 'REFUND_STATUS_COMPLETED'
} as const;

export type PbFindProcessesRequestRefundStatusEnum = typeof PbFindProcessesRequestRefundStatusEnum[keyof typeof PbFindProcessesRequestRefundStatusEnum];

/**
 * FindProcessesResponse is the paginated result of FindProcesses.
 * @export
 * @interface PbFindProcessesResponse
 */
export interface PbFindProcessesResponse {
    /**
     * Page of processes matching the request, mapped from PublicReturnProcess.
     * @type {Array<PbPublicReturnProcess>}
     * @memberof PbFindProcessesResponse
     */
    'processes'?: Array<PbPublicReturnProcess>;
    /**
     * Total number of processes matching the filters, ignoring pagination.  Paginate via offset/limit in the request body.
     * @type {string}
     * @memberof PbFindProcessesResponse
     */
    'rowcount'?: string;
}
/**
 * FindRefundConfigurationResponse
 * @export
 * @interface PbFindRefundConfigurationResponse
 */
export interface PbFindRefundConfigurationResponse {
    /**
     * ActionConfig
     * @type {Array<PbActionConfig>}
     * @memberof PbFindRefundConfigurationResponse
     */
    'action_configs'?: Array<PbActionConfig>;
    /**
     * carry_over_automatic_discounts_on_exchanges
     * @type {boolean}
     * @memberof PbFindRefundConfigurationResponse
     */
    'carry_over_automatic_discounts_on_exchanges'?: boolean;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbFindRefundConfigurationResponse
     */
    'ecommerce_id'?: string;
    /**
     * PaymentMethodConfig
     * @type {Array<PbPaymentMethodConfig>}
     * @memberof PbFindRefundConfigurationResponse
     */
    'payment_method_configs'?: Array<PbPaymentMethodConfig>;
    /**
     * revoke_conditional_discounts
     * @type {boolean}
     * @memberof PbFindRefundConfigurationResponse
     */
    'revoke_conditional_discounts'?: boolean;
    /**
     * round_promocode
     * @type {boolean}
     * @memberof PbFindRefundConfigurationResponse
     */
    'round_promocode'?: boolean;
}
/**
 * FlattenedEcommercePASettings is a flattened version of the ecommerce PA settings
 * @export
 * @interface PbFlattenedEcommercePASettings
 */
export interface PbFlattenedEcommercePASettings {
    /**
     * The flattened settings including ecommerce id and group
     * @type {{ [key: string]: string; }}
     * @memberof PbFlattenedEcommercePASettings
     */
    'settings'?: { [key: string]: string; };
}
/**
 * ForwardWfpFulfillmentRequest carries the Shopify order data needed to notify  Seel that an order shipped. The ingestion layer (events-api) fetches the full  order from Shopify (it carries the `fulfillments[]` Seel reads) and resolves  the WFP-enabled shop before calling this endpoint.
 * @export
 * @interface PbForwardWfpFulfillmentRequest
 */
export interface PbForwardWfpFulfillmentRequest {
    /**
     * Shopify admin domain (`<store>.myshopify.com`). Validated against the  merchant\'s WFP settings before forwarding to Seel.
     * @type {string}
     * @memberof PbForwardWfpFulfillmentRequest
     */
    'admin_domain'?: string;
    /**
     * EcommerceID of the WFP-enabled merchant.
     * @type {string}
     * @memberof PbForwardWfpFulfillmentRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopify fulfillment id of the fulfillment that triggered this event. Used as  the wfp_fulfillment_log primary key and the idempotency guard so a  re-delivered fulfillment does not notify Seel twice.
     * @type {string}
     * @memberof PbForwardWfpFulfillmentRequest
     */
    'fulfillment_id'?: string;
    /**
     * Raw Shopify order JSON forwarded verbatim, with its `fulfillments[]`  embedded. The handler extracts the order id from this payload and forwards  the whole body to Seel — callers do not pre-shape the data.
     * @type {object}
     * @memberof PbForwardWfpFulfillmentRequest
     */
    'order'?: object;
}
/**
 * ForwardWfpOrderRequest carries the Shopify order data needed to start the  wfp_order_forward Temporal workflow. All fields come from the ingestion layer  (events-api) which has already performed HMAC verification, deduplication,  and WFP-shop resolution before calling this endpoint.
 * @export
 * @interface PbForwardWfpOrderRequest
 */
export interface PbForwardWfpOrderRequest {
    /**
     * Shopify admin domain (`<store>.myshopify.com`). Forwarded verbatim to  the WFP backend as the merchant lookup key.
     * @type {string}
     * @memberof PbForwardWfpOrderRequest
     */
    'admin_domain'?: string;
    /**
     * EcommerceID of the WFP-enabled merchant.
     * @type {string}
     * @memberof PbForwardWfpOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * SHA-256 of the raw Shopify payload; used for deduplication by the  workflow against the last attempt\'s payload hash.
     * @type {string}
     * @memberof PbForwardWfpOrderRequest
     */
    'last_seen_payload_hash'?: string;
    /**
     * Raw Shopify order JSON forwarded verbatim. The handler extracts what it  needs (line items, addresses, note_attributes) from this payload —  callers do not pre-shape the data.
     * @type {object}
     * @memberof PbForwardWfpOrderRequest
     */
    'order'?: object;
}
/**
 * Configuration for fraud detection
 * @export
 * @interface PbFraudDetectionSettings
 */
export interface PbFraudDetectionSettings {
    /**
     * Flag to enable fraud detection
     * @type {boolean}
     * @memberof PbFraudDetectionSettings
     */
    'skip_fraud_detection'?: boolean;
}
/**
 * 
 * @export
 * @interface PbFulfillment
 */
export interface PbFulfillment {
    /**
     * Fulfillment date
     * @type {string}
     * @memberof PbFulfillment
     */
    'date'?: string;
    /**
     * Fulfillment ID
     * @type {string}
     * @memberof PbFulfillment
     */
    'id'?: string;
    /**
     * quantity of the item
     * @type {string}
     * @memberof PbFulfillment
     */
    'quantity'?: string;
}
/**
 * Request to act on an order\'s fulfillment orders (hold, release hold, cancel).
 * @export
 * @interface PbFulfillmentOrderActionRequest
 */
export interface PbFulfillmentOrderActionRequest {
    /**
     * Ecommerce id. Required.
     * @type {string}
     * @memberof PbFulfillmentOrderActionRequest
     */
    'ecommerce_id'?: string;
    /**
     * Platform order id (not customer printed). Required.
     * @type {string}
     * @memberof PbFulfillmentOrderActionRequest
     */
    'order_id'?: string;
}
/**
 * Outcome of a fulfillment order hold/release/cancel action.
 * @export
 * @interface PbFulfillmentOrderActionResponse
 */
export interface PbFulfillmentOrderActionResponse {
    /**
     * How many this action changed; already-in-state ones are skipped (idempotent).
     * @type {number}
     * @memberof PbFulfillmentOrderActionResponse
     */
    'affected'?: number;
    /**
     * How many fulfillment orders the order had; zero usually means the platform hasn\'t created them  yet.
     * @type {number}
     * @memberof PbFulfillmentOrderActionResponse
     */
    'fulfillment_orders_found'?: number;
    /**
     * How many have already shipped (a successful fulfillment). Only set by CancelOrderFulfillment.
     * @type {number}
     * @memberof PbFulfillmentOrderActionResponse
     */
    'shipped'?: number;
}
/**
 * The catalog shoppers pick from in a Full Catalog exchange
 * @export
 * @interface PbFullCatalogSettingsV2
 */
export interface PbFullCatalogSettingsV2 {
    /**
     * Collections (categories outside Shopify) whose products shoppers cannot pick
     * @type {Array<string>}
     * @memberof PbFullCatalogSettingsV2
     */
    'excluded_collection_ids'?: Array<string>;
    /**
     * Products shoppers cannot pick
     * @type {Array<string>}
     * @memberof PbFullCatalogSettingsV2
     */
    'excluded_product_ids'?: Array<string>;
    /**
     * Product tags whose products shoppers cannot pick
     * @type {Array<string>}
     * @memberof PbFullCatalogSettingsV2
     */
    'excluded_tags'?: Array<string>;
    /**
     * Hide the products not published on the Online Store. Shopify only.
     * @type {boolean}
     * @memberof PbFullCatalogSettingsV2
     */
    'online_store_only'?: boolean;
    /**
     * Platform menu whose collections shoppers browse
     * @type {string}
     * @memberof PbFullCatalogSettingsV2
     */
    'platform_main_menu_id'?: string;
}
/**
 * Full exchange settings
 * @export
 * @interface PbFullExchangeSettings
 */
export interface PbFullExchangeSettings {
    /**
     * Collections (categories outside Shopify) whose products shoppers cannot pick in a Full Catalog exchange
     * @type {Array<string>}
     * @memberof PbFullExchangeSettings
     */
    'excluded_collection_ids'?: Array<string>;
    /**
     * Products shoppers cannot pick in a Full Catalog exchange
     * @type {Array<string>}
     * @memberof PbFullExchangeSettings
     */
    'excluded_product_ids'?: Array<string>;
    /**
     * Product tags whose products shoppers cannot pick in a Full Catalog exchange
     * @type {Array<string>}
     * @memberof PbFullExchangeSettings
     */
    'excluded_tags'?: Array<string>;
    /**
     * Hide the products not published on the Online Store from a Full Catalog exchange. Shopify only.
     * @type {boolean}
     * @memberof PbFullExchangeSettings
     */
    'online_store_only'?: boolean;
    /**
     * menu id of the website
     * @type {string}
     * @memberof PbFullExchangeSettings
     */
    'website_main_menu_id'?: string;
}
/**
 * Function
 * @export
 * @interface PbFunction
 */
export interface PbFunction {
    /**
     * Comparisons
     * @type {Array<string>}
     * @memberof PbFunction
     */
    'comparisons'?: Array<string>;
    /**
     * Name of the function
     * @type {string}
     * @memberof PbFunction
     */
    'name'?: string;
    /**
     * Values
     * @type {Array<string>}
     * @memberof PbFunction
     */
    'values'?: Array<string>;
    /**
     * Variable
     * @type {string}
     * @memberof PbFunction
     */
    'variable'?: string;
}
/**
 * GenericCustomSettings
 * @export
 * @interface PbGenericCustomSettings
 */
export interface PbGenericCustomSettings {
    /**
     * Base URL
     * @type {string}
     * @memberof PbGenericCustomSettings
     */
    'base_url'?: string;
    /**
     * Group
     * @type {string}
     * @memberof PbGenericCustomSettings
     */
    'group'?: string;
    /**
     * Is active
     * @type {boolean}
     * @memberof PbGenericCustomSettings
     */
    'is_active'?: boolean;
    /**
     * Subplatform name
     * @type {string}
     * @memberof PbGenericCustomSettings
     */
    'subplatform'?: string;
}
/**
 * 
 * @export
 * @interface PbGenericOPMSettings
 */
export interface PbGenericOPMSettings {
    /**
     * Paypal credentials
     * @type {PbPaypalCredentials}
     * @memberof PbGenericOPMSettings
     */
    'paypal_credentials'?: PbPaypalCredentials;
    /**
     * Redsys credentials
     * @type {PbRedsysCredentials}
     * @memberof PbGenericOPMSettings
     */
    'redsys_credentials'?: PbRedsysCredentials;
    /**
     * Sequra credentials
     * @type {PbSequraCredentials}
     * @memberof PbGenericOPMSettings
     */
    'sequra_credentials'?: PbSequraCredentials;
}
/**
 * Response containing all allocated risk events by allocated timing ID.
 * @export
 * @interface PbGetAllocatedRiskExposureEventsResponse
 */
export interface PbGetAllocatedRiskExposureEventsResponse {
    /**
     * 
     * @type {Array<PbAllocatedRiskEvent>}
     * @memberof PbGetAllocatedRiskExposureEventsResponse
     */
    'allocated_risk_events'?: Array<PbAllocatedRiskEvent>;
}
/**
 * 
 * @export
 * @interface PbGetAuthorizationStatusResponse
 */
export interface PbGetAuthorizationStatusResponse {
    /**
     * 
     * @type {PbGetAuthorizationStatusResponseAuthorizationDetails}
     * @memberof PbGetAuthorizationStatusResponse
     */
    'authorization_details'?: PbGetAuthorizationStatusResponseAuthorizationDetails;
    /**
     * 
     * @type {string}
     * @memberof PbGetAuthorizationStatusResponse
     */
    'authorization_status'?: PbGetAuthorizationStatusResponseAuthorizationStatusEnum;
    /**
     * 
     * @type {PbGetAuthorizationStatusResponseUnauthorizationDetails}
     * @memberof PbGetAuthorizationStatusResponse
     */
    'unauthorization_details'?: PbGetAuthorizationStatusResponseUnauthorizationDetails;
}

export const PbGetAuthorizationStatusResponseAuthorizationStatusEnum = {
    Unspecified: 'AUTHORIZATION_STATUS_UNSPECIFIED',
    AuthorizationPending: 'AUTHORIZATION_STATUS_AUTHORIZATION_PENDING',
    DocumentUploadPending: 'AUTHORIZATION_STATUS_DOCUMENT_UPLOAD_PENDING',
    Authorized: 'AUTHORIZATION_STATUS_AUTHORIZED',
    NotAuthorized: 'AUTHORIZATION_STATUS_NOT_AUTHORIZED',
    NoAuthorizationRequired: 'AUTHORIZATION_STATUS_NO_AUTHORIZATION_REQUIRED'
} as const;

export type PbGetAuthorizationStatusResponseAuthorizationStatusEnum = typeof PbGetAuthorizationStatusResponseAuthorizationStatusEnum[keyof typeof PbGetAuthorizationStatusResponseAuthorizationStatusEnum];

/**
 * 
 * @export
 * @interface PbGetAuthorizationStatusResponseAuthorizationDetails
 */
export interface PbGetAuthorizationStatusResponseAuthorizationDetails {
    /**
     * 
     * @type {PbMoney}
     * @memberof PbGetAuthorizationStatusResponseAuthorizationDetails
     */
    'refund_override_amount'?: PbMoney;
    /**
     * 
     * @type {string}
     * @memberof PbGetAuthorizationStatusResponseAuthorizationDetails
     */
    'refund_override_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetAuthorizationStatusResponseAuthorizationDetails
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface PbGetAuthorizationStatusResponseUnauthorizationDetails
 */
export interface PbGetAuthorizationStatusResponseUnauthorizationDetails {
    /**
     * 
     * @type {string}
     * @memberof PbGetAuthorizationStatusResponseUnauthorizationDetails
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetAuthorizationStatusResponseUnauthorizationDetails
     */
    'user'?: string;
}
/**
 * Available restock locations for the items in a process
 * @export
 * @interface PbGetAvailableRestockLocationsResponse
 */
export interface PbGetAvailableRestockLocationsResponse {
    /**
     * Restock locations
     * @type {Array<PbVariantRestockLocations>}
     * @memberof PbGetAvailableRestockLocationsResponse
     */
    'item_restock_locations'?: Array<PbVariantRestockLocations>;
}
/**
 * 
 * @export
 * @interface PbGetCancelExchangePreviewResponse
 */
export interface PbGetCancelExchangePreviewResponse {
    /**
     * Printed number of the exchange order; empty for OUTCOME_NO_EXCHANGE.
     * @type {string}
     * @memberof PbGetCancelExchangePreviewResponse
     */
    'exchange_order_number'?: string;
    /**
     * What the cancel will do to the exchange order.
     * @type {string}
     * @memberof PbGetCancelExchangePreviewResponse
     */
    'outcome'?: PbGetCancelExchangePreviewResponseOutcomeEnum;
}

export const PbGetCancelExchangePreviewResponseOutcomeEnum = {
    Unspecified: 'OUTCOME_UNSPECIFIED',
    NoExchange: 'OUTCOME_NO_EXCHANGE',
    NotHeld: 'OUTCOME_NOT_HELD',
    NotSupported: 'OUTCOME_NOT_SUPPORTED',
    WillCancel: 'OUTCOME_WILL_CANCEL',
    AlreadyShipped: 'OUTCOME_ALREADY_SHIPPED',
    AlreadyCanceled: 'OUTCOME_ALREADY_CANCELED'
} as const;

export type PbGetCancelExchangePreviewResponseOutcomeEnum = typeof PbGetCancelExchangePreviewResponseOutcomeEnum[keyof typeof PbGetCancelExchangePreviewResponseOutcomeEnum];

/**
 * GetCustomCredentialsResponse contains the retrieved credentials
 * @export
 * @interface PbGetCustomCredentialsResponse
 */
export interface PbGetCustomCredentialsResponse {
    /**
     * The retrieved credentials
     * @type {Array<PbCustomCredentials>}
     * @memberof PbGetCustomCredentialsResponse
     */
    'credentials'?: Array<PbCustomCredentials>;
    /**
     * ID of the ecommerce platform
     * @type {string}
     * @memberof PbGetCustomCredentialsResponse
     */
    'ecommerce_id'?: string;
}
/**
 * 
 * @export
 * @interface PbGetCustomerOutstandingRealizedRiskResponse
 */
export interface PbGetCustomerOutstandingRealizedRiskResponse {
    /**
     * Customer outstanding realized exposure expressed in euro cents.  Only considers events created more than 15 days ago.
     * @type {string}
     * @memberof PbGetCustomerOutstandingRealizedRiskResponse
     */
    'outstanding_realized_risk_eur'?: string;
}
/**
 * GetCustomerResponse contains customer-level data from the platform.
 * @export
 * @interface PbGetCustomerResponse
 */
export interface PbGetCustomerResponse {
    /**
     * Platform-specific customer identifier.
     * @type {string}
     * @memberof PbGetCustomerResponse
     */
    'customer_id'?: string;
    /**
     * Platform-specific customer number.
     * @type {string}
     * @memberof PbGetCustomerResponse
     */
    'customer_no'?: string;
    /**
     * Customer email address.
     * @type {string}
     * @memberof PbGetCustomerResponse
     */
    'email'?: string;
    /**
     * Whether the customer account is enabled on the platform.
     * @type {boolean}
     * @memberof PbGetCustomerResponse
     */
    'enabled'?: boolean;
    /**
     * Customer first name.
     * @type {string}
     * @memberof PbGetCustomerResponse
     */
    'first_name'?: string;
    /**
     * Whether the customer is considered loyal by the platform.
     * @type {boolean}
     * @memberof PbGetCustomerResponse
     */
    'is_loyal'?: boolean;
    /**
     * Customer last name.
     * @type {string}
     * @memberof PbGetCustomerResponse
     */
    'last_name'?: string;
}
/**
 * 
 * @export
 * @interface PbGetCustomerTotalRealizedRiskResponse
 */
export interface PbGetCustomerTotalRealizedRiskResponse {
    /**
     * Customer realized exposure expressed in euro cents.
     * @type {string}
     * @memberof PbGetCustomerTotalRealizedRiskResponse
     */
    'total_realized_risk_eur'?: string;
}
/**
 * 
 * @export
 * @interface PbGetEcommerceDailyRealizedRiskResponse
 */
export interface PbGetEcommerceDailyRealizedRiskResponse {
    /**
     * Realized exposure accrued during the last 24 hours in euro cents.
     * @type {string}
     * @memberof PbGetEcommerceDailyRealizedRiskResponse
     */
    'daily_realized_risk_eur'?: string;
}
/**
 * 
 * @export
 * @interface PbGetEcommerceRealizedRiskByDateResponse
 */
export interface PbGetEcommerceRealizedRiskByDateResponse {
    /**
     * Realized exposure for the specified date in euro cents.
     * @type {string}
     * @memberof PbGetEcommerceRealizedRiskByDateResponse
     */
    'realized_risk_eur'?: string;
}
/**
 * 
 * @export
 * @interface PbGetEcommerceTotalAllocatedRiskResponse
 */
export interface PbGetEcommerceTotalAllocatedRiskResponse {
    /**
     * Total allocated exposure expressed in euro cents.
     * @type {string}
     * @memberof PbGetEcommerceTotalAllocatedRiskResponse
     */
    'total_allocated_risk_eur'?: string;
}
/**
 * 
 * @export
 * @interface PbGetEcommerceTotalRealizedRiskResponse
 */
export interface PbGetEcommerceTotalRealizedRiskResponse {
    /**
     * Total realized exposure expressed in euro cents.
     * @type {string}
     * @memberof PbGetEcommerceTotalRealizedRiskResponse
     */
    'total_realized_risk_eur'?: string;
}
/**
 * Exchanges settings of a group or an ecommerce
 * @export
 * @interface PbGetExchangesSettingsV2Response
 */
export interface PbGetExchangesSettingsV2Response {
    /**
     * Ecommerce group the settings belong to. Set for an ecommerce request too.
     * @type {string}
     * @memberof PbGetExchangesSettingsV2Response
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce of the request, empty for a group request
     * @type {string}
     * @memberof PbGetExchangesSettingsV2Response
     */
    'ecommerce_id'?: string;
    /**
     * The group\'s portals are on more than one store, so the Full Catalog is set per portal: a group save with Full  Catalog settings is rejected
     * @type {boolean}
     * @memberof PbGetExchangesSettingsV2Response
     */
    'multiple_stores'?: boolean;
    /**
     * For an ecommerce request, the kinds it overrides instead of following its group
     * @type {Array<string>}
     * @memberof PbGetExchangesSettingsV2Response
     */
    'overridden_kinds'?: Array<PbGetExchangesSettingsV2ResponseOverriddenKindsEnum>;
    /**
     * For a group request, each ecommerce of the group with the kinds it overrides
     * @type {Array<PbEcommerceExchangesSettingsOverridesV2>}
     * @memberof PbGetExchangesSettingsV2Response
     */
    'overrides'?: Array<PbEcommerceExchangesSettingsOverridesV2>;
    /**
     * The group\'s settings, or the ones the ecommerce gets
     * @type {PbExchangesSettingsV2}
     * @memberof PbGetExchangesSettingsV2Response
     */
    'settings'?: PbExchangesSettingsV2;
}

export const PbGetExchangesSettingsV2ResponseOverriddenKindsEnum = {
    Unspecified: 'EXCHANGES_SETTINGS_KIND_V2_UNSPECIFIED',
    Policy: 'EXCHANGES_SETTINGS_KIND_V2_POLICY',
    ExchangeOrders: 'EXCHANGES_SETTINGS_KIND_V2_EXCHANGE_ORDERS',
    FullCatalog: 'EXCHANGES_SETTINGS_KIND_V2_FULL_CATALOG',
    InstantExchange: 'EXCHANGES_SETTINGS_KIND_V2_INSTANT_EXCHANGE'
} as const;

export type PbGetExchangesSettingsV2ResponseOverriddenKindsEnum = typeof PbGetExchangesSettingsV2ResponseOverriddenKindsEnum[keyof typeof PbGetExchangesSettingsV2ResponseOverriddenKindsEnum];

/**
 * 
 * @export
 * @interface PbGetGiftCardResponse
 */
export interface PbGetGiftCardResponse {
    /**
     * Amount of the gift card
     * @type {string}
     * @memberof PbGetGiftCardResponse
     */
    'amount'?: string;
    /**
     * Balance of the gift card
     * @type {string}
     * @memberof PbGetGiftCardResponse
     */
    'balance'?: string;
    /**
     * Code of the gift card (usable by customers)
     * @type {string}
     * @memberof PbGetGiftCardResponse
     */
    'code'?: string;
    /**
     * Currency of the gift card
     * @type {string}
     * @memberof PbGetGiftCardResponse
     */
    'currency'?: string;
    /**
     * Expires On is the expiration date of the gift card
     * @type {string}
     * @memberof PbGetGiftCardResponse
     */
    'expires_on'?: string;
    /**
     * Platform ID is the ID of the gift card in the e-commerce platform
     * @type {string}
     * @memberof PbGetGiftCardResponse
     */
    'id'?: string;
}
/**
 * GetJiraTicketSeriesRequest asks for the Jira tickets filed per calendar day over a window.
 * @export
 * @interface PbGetJiraTicketSeriesRequest
 */
export interface PbGetJiraTicketSeriesRequest {
    /**
     * Start of the window, inclusive. Required.
     * @type {string}
     * @memberof PbGetJiraTicketSeriesRequest
     */
    'from'?: string;
    /**
     * IANA timezone used to place each ticket into a day bucket (e.g. \"Europe/Madrid\"). Defaults to  UTC.
     * @type {string}
     * @memberof PbGetJiraTicketSeriesRequest
     */
    'timezone'?: string;
    /**
     * End of the window, exclusive, as in CountJiraTicketsFiledRequest. Required.
     * @type {string}
     * @memberof PbGetJiraTicketSeriesRequest
     */
    'to'?: string;
}
/**
 * GetJiraTicketSeriesResponse is the ordered list of day buckets (ascending). Days with no tickets  are omitted; callers treat missing days as zero.
 * @export
 * @interface PbGetJiraTicketSeriesResponse
 */
export interface PbGetJiraTicketSeriesResponse {
    /**
     * Day buckets ordered ascending by day_start.
     * @type {Array<PbJiraTicketDayBucket>}
     * @memberof PbGetJiraTicketSeriesResponse
     */
    'buckets'?: Array<PbJiraTicketDayBucket>;
}
/**
 * 
 * @export
 * @interface PbGetLogisticSummariesResponse
 */
export interface PbGetLogisticSummariesResponse {
    /**
     * 
     * @type {Array<PbLogisticsSummaryWithProcessId>}
     * @memberof PbGetLogisticSummariesResponse
     */
    'logistic_summaries'?: Array<PbLogisticsSummaryWithProcessId>;
    /**
     * 
     * @type {PbPagination}
     * @memberof PbGetLogisticSummariesResponse
     */
    'pagination'?: PbPagination;
}
/**
 * 
 * @export
 * @interface PbGetLogisticsSummaryResponse
 */
export interface PbGetLogisticsSummaryResponse {
    /**
     * 
     * @type {PbLogisticsSummary}
     * @memberof PbGetLogisticsSummaryResponse
     */
    'logistics_summary'?: PbLogisticsSummary;
}
/**
 * 
 * @export
 * @interface PbGetOPMRefundPlanForBoggiRequest
 */
export interface PbGetOPMRefundPlanForBoggiRequest {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'ecommerce_id': string;
    /**
     * Money format of the `refundAmount` field. Going to be replaced soon by `currency`
     * @type {ModelsMoneyFormat}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'money_format': ModelsMoneyFormat;
    /**
     * platform order id (not necessarily the customer printed order id)
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'order_id': string;
    /**
     * REVER Process id
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'process_id': string;
    /**
     * Amount to be refunded, without decimals, following the  currency/money format given in the request
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'refund_amount': string;
    /**
     * Items to be refunded (associated to the given amount)  that must exist in the order referred by `order_id`
     * @type {Array<PbRefundLineItem>}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'refund_line_items'?: Array<PbRefundLineItem>;
    /**
     * Return shipping cost amount. This is the amount that was subtracted from the total refund  amount and won\'t be refunded to the customer. This is passed for preparing metadata information  about the return shipping costs.
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'return_shipping_cost_amount'?: string;
    /**
     * Return shipping tax amount (sales tax on shipping). This is the amount that was subtracted from  the total refund amount and won\'t be refunded to the customer.  This is passed for preparing metadata information about the return shipping tax.
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'return_shipping_tax_amount'?: string;
    /**
     * Shipping cost refund amount to the customer in the currency of the order
     * @type {string}
     * @memberof PbGetOPMRefundPlanForBoggiRequest
     */
    'shipping_cost_refund_amount'?: string;
}
/**
 * 
 * @export
 * @interface PbGetOPMRefundPlanForBoggiResponse
 */
export interface PbGetOPMRefundPlanForBoggiResponse {
    /**
     * Transactions planned as part of the refund
     * @type {Array<PbRefundPlannedTransaction>}
     * @memberof PbGetOPMRefundPlanForBoggiResponse
     */
    'transactions'?: Array<PbRefundPlannedTransaction>;
}
/**
 * 
 * @export
 * @interface PbGetOnHoldWorkflowsResponse
 */
export interface PbGetOnHoldWorkflowsResponse {
    /**
     * 
     * @type {Array<PbGetOnHoldWorkflowsResponseWorkflow>}
     * @memberof PbGetOnHoldWorkflowsResponse
     */
    'on_hold_workflows'?: Array<PbGetOnHoldWorkflowsResponseWorkflow>;
    /**
     * Total number of matching workflows before pagination.
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponse
     */
    'total_count'?: string;
}
/**
 * 
 * @export
 * @interface PbGetOnHoldWorkflowsResponseWorkflow
 */
export interface PbGetOnHoldWorkflowsResponseWorkflow {
    /**
     * 
     * @type {PbBasicProcessData}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'basic_process_data'?: PbBasicProcessData;
    /**
     * 
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'error_activity'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'error_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'error_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'responsible_team'?: PbGetOnHoldWorkflowsResponseWorkflowResponsibleTeamEnum;
    /**
     * 
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'workflow_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetOnHoldWorkflowsResponseWorkflow
     */
    'workflow_type'?: string;
}

export const PbGetOnHoldWorkflowsResponseWorkflowResponsibleTeamEnum = {
    Unspecified: 'TEAM_UNSPECIFIED',
    Rx: 'TEAM_RX',
    Ex: 'TEAM_EX',
    Pa: 'TEAM_PA',
    Tech: 'TEAM_TECH',
    Integrations: 'TEAM_INTEGRATIONS'
} as const;

export type PbGetOnHoldWorkflowsResponseWorkflowResponsibleTeamEnum = typeof PbGetOnHoldWorkflowsResponseWorkflowResponsibleTeamEnum[keyof typeof PbGetOnHoldWorkflowsResponseWorkflowResponsibleTeamEnum];

/**
 * Response message for getting the original tracking numbers for an order
 * @export
 * @interface PbGetOrderOriginalTrackingNumbersResponse
 */
export interface PbGetOrderOriginalTrackingNumbersResponse {
    /**
     * Tracking numbers
     * @type {Array<PbTrackingNumber>}
     * @memberof PbGetOrderOriginalTrackingNumbersResponse
     */
    'tracking_numbers'?: Array<PbTrackingNumber>;
}
/**
 * protolint:disable:next MESSAGE_NAMES_EXCLUDE_PREPOSITIONS
 * @export
 * @interface PbGetOrderResponse
 */
export interface PbGetOrderResponse {
    /**
     * When the order is found, order data returned by the e-commerce platform  processed to be standardized
     * @type {PbEcommerceOrder}
     * @memberof PbGetOrderResponse
     */
    'order'?: PbEcommerceOrder;
}
/**
 * GetOrderTransactionsAndRefundsResponse returns the platform-side  transactions and refund documents of an order.
 * @export
 * @interface PbGetOrderTransactionsAndRefundsResponse
 */
export interface PbGetOrderTransactionsAndRefundsResponse {
    /**
     * Promocodes applied to the order, REVER\'s and the merchant\'s. They paid  part of the order but are not transactions, so they are listed apart.  Empty when the order has none or the platform does not report them.
     * @type {Array<PbOrderPromocode>}
     * @memberof PbGetOrderTransactionsAndRefundsResponse
     */
    'promocodes'?: Array<PbOrderPromocode>;
    /**
     * Refund documents attributing money the transactions moved to the order\'s  line items, joined via transaction_ids. A refund carries no amount, date or  author of its own — those are read from the transactions it names.  A refund with empty line_items attributes to no line in particular; the  amount is whatever its transactions moved that no line claims.
     * @type {Array<PbOrderRefund>}
     * @memberof PbGetOrderTransactionsAndRefundsResponse
     */
    'refunds'?: Array<PbOrderRefund>;
    /**
     * Transactions on the order, including refunds. Refund-kind rows have  a parent_id pointing at the original sale/capture when the platform  exposes that linkage.
     * @type {Array<PbOrderTransaction>}
     * @memberof PbGetOrderTransactionsAndRefundsResponse
     */
    'transactions'?: Array<PbOrderTransaction>;
}
/**
 * Response message containing Prestashop modules for a specific ecommerce ID
 * @export
 * @interface PbGetPrestashopModulesResponse
 */
export interface PbGetPrestashopModulesResponse {
    /**
     * ID of the ecommerce platform
     * @type {string}
     * @memberof PbGetPrestashopModulesResponse
     */
    'ecommerce_id'?: string;
    /**
     * List of Prestashop modules
     * @type {Array<PbPrestashopModule>}
     * @memberof PbGetPrestashopModulesResponse
     */
    'modules'?: Array<PbPrestashopModule>;
}
/**
 * GetProcessActivitySeriesRequest asks for the per-day count of processes started over [from, to].
 * @export
 * @interface PbGetProcessActivitySeriesRequest
 */
export interface PbGetProcessActivitySeriesRequest {
    /**
     * Start of the range, inclusive. Required.
     * @type {string}
     * @memberof PbGetProcessActivitySeriesRequest
     */
    'from'?: string;
    /**
     * IANA timezone used to place started_at into day buckets (e.g. \"Europe/Madrid\"). Defaults to  UTC.
     * @type {string}
     * @memberof PbGetProcessActivitySeriesRequest
     */
    'timezone'?: string;
    /**
     * End of the range, inclusive. Required.
     * @type {string}
     * @memberof PbGetProcessActivitySeriesRequest
     */
    'to'?: string;
}
/**
 * GetProcessActivitySeriesResponse is the ordered list of day buckets (ascending). Days with no  starts may be omitted; callers treat missing days as zero.
 * @export
 * @interface PbGetProcessActivitySeriesResponse
 */
export interface PbGetProcessActivitySeriesResponse {
    /**
     * Day buckets ordered ascending by bucket_start.
     * @type {Array<PbProcessActivityBucket>}
     * @memberof PbGetProcessActivitySeriesResponse
     */
    'buckets'?: Array<PbProcessActivityBucket>;
}
/**
 * GetProcessEcommerceIDInternalResponse carries only the ecommerce_id.
 * @export
 * @interface PbGetProcessEcommerceIDInternalResponse
 */
export interface PbGetProcessEcommerceIDInternalResponse {
    /**
     * EcommerceID of the return process.
     * @type {string}
     * @memberof PbGetProcessEcommerceIDInternalResponse
     */
    'ecommerce_id'?: string;
}
/**
 * 
 * @export
 * @interface PbGetProcessIDByPlatformIDInternalResponse
 */
export interface PbGetProcessIDByPlatformIDInternalResponse {
    /**
     * REVER process ID
     * @type {string}
     * @memberof PbGetProcessIDByPlatformIDInternalResponse
     */
    'process_id'?: string;
}
/**
 * Response for getting the products and brands from the bradery api
 * @export
 * @interface PbGetProductsAndBrandsTheBraderyResponse
 */
export interface PbGetProductsAndBrandsTheBraderyResponse {
    /**
     * Products and brands
     * @type {Array<PbProductAndBrand>}
     * @memberof PbGetProductsAndBrandsTheBraderyResponse
     */
    'products_and_brands'?: Array<PbProductAndBrand>;
}
/**
 * Response for the status of a promocode
 * @export
 * @interface PbGetPromocodeResponse
 */
export interface PbGetPromocodeResponse {
    /**
     * Ecommerce id the promocode belongs to
     * @type {string}
     * @memberof PbGetPromocodeResponse
     */
    'ecommerce_id'?: string;
    /**
     * Whether the promocode is enabled or not
     * @type {boolean}
     * @memberof PbGetPromocodeResponse
     */
    'enabled'?: boolean;
    /**
     * When available, the order_ids in where the promocode has been used
     * @type {Array<string>}
     * @memberof PbGetPromocodeResponse
     */
    'order_ids'?: Array<string>;
    /**
     * Code of the promocode to be queried
     * @type {string}
     * @memberof PbGetPromocodeResponse
     */
    'promocode'?: string;
    /**
     * If the promocode has been redeemed already (fully or partially)
     * @type {boolean}
     * @memberof PbGetPromocodeResponse
     */
    'used'?: boolean;
}
/**
 * 
 * @export
 * @interface PbGetProvincesResponse
 */
export interface PbGetProvincesResponse {
    /**
     * Provinces associated the country  TODO: put in the same message the country code as  echo of the input
     * @type {Array<PbProvinceData>}
     * @memberof PbGetProvincesResponse
     */
    'provinces'?: Array<PbProvinceData>;
}
/**
 * Get RDV Surplus configuration response
 * @export
 * @interface PbGetRDVSurplusResponse
 */
export interface PbGetRDVSurplusResponse {
    /**
     * Rules
     * @type {Array<PbRDVSurplusRule>}
     * @memberof PbGetRDVSurplusResponse
     */
    'rules'?: Array<PbRDVSurplusRule>;
}
/**
 * RDV surplus rules of a group or an ecommerce
 * @export
 * @interface PbGetRDVSurplusV2Response
 */
export interface PbGetRDVSurplusV2Response {
    /**
     * Ecommerce group the rules belong to. Set for an ecommerce request too.
     * @type {string}
     * @memberof PbGetRDVSurplusV2Response
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce of the request, empty for a group request
     * @type {string}
     * @memberof PbGetRDVSurplusV2Response
     */
    'ecommerce_id'?: string;
    /**
     * For an ecommerce request, whether it overrides its group\'s rules
     * @type {boolean}
     * @memberof PbGetRDVSurplusV2Response
     */
    'overridden'?: boolean;
    /**
     * For a group request, the rules of each ecommerce of the group that overrides them
     * @type {Array<PbEcommerceRDVSurplusV2>}
     * @memberof PbGetRDVSurplusV2Response
     */
    'overrides'?: Array<PbEcommerceRDVSurplusV2>;
    /**
     * The group\'s rules, or the ones the ecommerce gets. Unset when the group has none yet.
     * @type {PbRDVSurplusV2}
     * @memberof PbGetRDVSurplusV2Response
     */
    'rdv_surplus'?: PbRDVSurplusV2;
}
/**
 * Refund configuration of a group or an ecommerce
 * @export
 * @interface PbGetRefundConfigurationV2Response
 */
export interface PbGetRefundConfigurationV2Response {
    /**
     * Ecommerce group the configuration belongs to. Set for an ecommerce request too.
     * @type {string}
     * @memberof PbGetRefundConfigurationV2Response
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce of the request, empty for a group request
     * @type {string}
     * @memberof PbGetRefundConfigurationV2Response
     */
    'ecommerce_id'?: string;
    /**
     * For an ecommerce request, whether it overrides its group\'s configuration
     * @type {boolean}
     * @memberof PbGetRefundConfigurationV2Response
     */
    'overridden'?: boolean;
    /**
     * For a group request, the configuration of each ecommerce of the group that overrides it
     * @type {Array<PbEcommerceRefundConfigurationV2>}
     * @memberof PbGetRefundConfigurationV2Response
     */
    'overrides'?: Array<PbEcommerceRefundConfigurationV2>;
    /**
     * The group\'s configuration, or the one the ecommerce gets. Unset when the group has none yet.
     * @type {PbRefundConfigurationV2}
     * @memberof PbGetRefundConfigurationV2Response
     */
    'refund_configuration'?: PbRefundConfigurationV2;
}
/**
 * GetRefundGatewaySettingsResponse is the response for the GetRefundGatewaySettings method
 * @export
 * @interface PbGetRefundGatewaySettingsResponse
 */
export interface PbGetRefundGatewaySettingsResponse {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbGetRefundGatewaySettingsResponse
     */
    'ecommerce_id'?: string;
    /**
     * Refund gateway settings
     * @type {PbRefundGatewaySettings}
     * @memberof PbGetRefundGatewaySettingsResponse
     */
    'settings'?: PbRefundGatewaySettings;
}
/**
 * Response for reading a return process
 * @export
 * @interface PbGetResponse
 */
export interface PbGetResponse {
    /**
     * ReturnProcess recovered.
     * @type {ModelsReturnProcess}
     * @memberof PbGetResponse
     */
    'return_process'?: ModelsReturnProcess;
}
/**
 * 
 * @export
 * @interface PbGetRestockResponse
 */
export interface PbGetRestockResponse {
    /**
     * List of restocks
     * @type {Array<PbRestockDTO>}
     * @memberof PbGetRestockResponse
     */
    'restocks'?: Array<PbRestockDTO>;
}
/**
 * GetReturnAmountAvailableResponse is the response to get the return amount available
 * @export
 * @interface PbGetReturnAmountAvailableResponse
 */
export interface PbGetReturnAmountAvailableResponse {
    /**
     * Return amount configurations
     * @type {Array<PbConfig>}
     * @memberof PbGetReturnAmountAvailableResponse
     */
    'configurations'?: Array<PbConfig>;
}
/**
 * GetReturnAmountResponse is the response to get the return amount
 * @export
 * @interface PbGetReturnAmountResponse
 */
export interface PbGetReturnAmountResponse {
    /**
     * Return amount business rules
     * @type {Array<PbReturnAmountRule>}
     * @memberof PbGetReturnAmountResponse
     */
    'rules'?: Array<PbReturnAmountRule>;
}
/**
 * 
 * @export
 * @interface PbGetReturnDocumentsResponse
 */
export interface PbGetReturnDocumentsResponse {
    /**
     * 
     * @type {Array<PbGetReturnDocumentsResponseDocument>}
     * @memberof PbGetReturnDocumentsResponse
     */
    'documents'?: Array<PbGetReturnDocumentsResponseDocument>;
}
/**
 * 
 * @export
 * @interface PbGetReturnDocumentsResponseDocument
 */
export interface PbGetReturnDocumentsResponseDocument {
    /**
     * 
     * @type {string}
     * @memberof PbGetReturnDocumentsResponseDocument
     */
    'document_information'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGetReturnDocumentsResponseDocument
     */
    'document_url'?: string;
}
/**
 * Return conditions of a group or an ecommerce
 * @export
 * @interface PbGetReturnProcessConditionsV2Response
 */
export interface PbGetReturnProcessConditionsV2Response {
    /**
     * The group\'s conditions, or the ones the ecommerce gets. Unset when the group has none yet.
     * @type {PbReturnProcessConditions}
     * @memberof PbGetReturnProcessConditionsV2Response
     */
    'conditions'?: PbReturnProcessConditions;
    /**
     * Ecommerce group the conditions belong to. Set for an ecommerce request too.
     * @type {string}
     * @memberof PbGetReturnProcessConditionsV2Response
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce of the request, empty for a group request
     * @type {string}
     * @memberof PbGetReturnProcessConditionsV2Response
     */
    'ecommerce_id'?: string;
    /**
     * For an ecommerce request, whether it overrides its group\'s conditions
     * @type {boolean}
     * @memberof PbGetReturnProcessConditionsV2Response
     */
    'overridden'?: boolean;
    /**
     * For a group request, the conditions of each ecommerce of the group that overrides them
     * @type {Array<PbEcommerceReturnProcessConditionsV2>}
     * @memberof PbGetReturnProcessConditionsV2Response
     */
    'overrides'?: Array<PbEcommerceReturnProcessConditionsV2>;
}
/**
 * Return reasons of a group or an ecommerce
 * @export
 * @interface PbGetReturnReasonsV2Response
 */
export interface PbGetReturnReasonsV2Response {
    /**
     * Ecommerce group the reasons belong to. Set for an ecommerce request too.
     * @type {string}
     * @memberof PbGetReturnReasonsV2Response
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce of the request, empty for a group request
     * @type {string}
     * @memberof PbGetReturnReasonsV2Response
     */
    'ecommerce_id'?: string;
    /**
     * For an ecommerce request, whether it overrides its group\'s reasons
     * @type {boolean}
     * @memberof PbGetReturnReasonsV2Response
     */
    'overridden'?: boolean;
    /**
     * For a group request, the reasons of each ecommerce of the group that overrides them
     * @type {Array<PbEcommerceReturnReasonsV2>}
     * @memberof PbGetReturnReasonsV2Response
     */
    'overrides'?: Array<PbEcommerceReturnReasonsV2>;
    /**
     * Every reason of the group\'s catalog, sub-reasons under their parent. Unset when the group has none yet.
     * @type {PbReturnReasonsCollection}
     * @memberof PbGetReturnReasonsV2Response
     */
    'return_reasons'?: PbReturnReasonsCollection;
}
/**
 * 
 * @export
 * @interface PbGetReturnSummariesResponse
 */
export interface PbGetReturnSummariesResponse {
    /**
     * 
     * @type {PbPagination}
     * @memberof PbGetReturnSummariesResponse
     */
    'pagination'?: PbPagination;
    /**
     * 
     * @type {Array<PbReturnSummary>}
     * @memberof PbGetReturnSummariesResponse
     */
    'return_summaries'?: Array<PbReturnSummary>;
}
/**
 * 
 * @export
 * @interface PbGetReturnSummaryResponse
 */
export interface PbGetReturnSummaryResponse {
    /**
     * 
     * @type {PbReturnSummary}
     * @memberof PbGetReturnSummaryResponse
     */
    'return_summary'?: PbReturnSummary;
}
/**
 * 
 * @export
 * @interface PbGetReviewsResponse
 */
export interface PbGetReviewsResponse {
    /**
     * 
     * @type {Array<PbItemReview>}
     * @memberof PbGetReviewsResponse
     */
    'item_reviews'?: Array<PbItemReview>;
}
/**
 * RiskExposureSettings model
 * @export
 * @interface PbGetRiskExposureSettingsResponse
 */
export interface PbGetRiskExposureSettingsResponse {
    /**
     * AllocationTimeoutHours - hours before allocated risk expires (default: 6)
     * @type {string}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'allocation_timeout_hours'?: string;
    /**
     * ControlGroupProbability - probability for control group assignment, 0.0 to 1.0 (default: 0.1)
     * @type {number}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'control_group_probability'?: number;
    /**
     * CustomerThresholdEurCents
     * @type {string}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'customer_threshold_eur_cents'?: string;
    /**
     * DailyThresholdEurCents
     * @type {string}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'daily_threshold_eur_cents'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'ecommerce_id'?: string;
    /**
     * GlobalThresholdEurCents
     * @type {string}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'global_threshold_eur_cents'?: string;
    /**
     * OnItemSentThreshold - threshold for ON_ITEM_SENT timing, 0.0 to 1.0 (default: 0.5). If maxFraudScore >= this value,  timing is ON_ITEM_SENT (unless overridden by OnItemVerifiedThreshold).
     * @type {number}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'on_item_sent_threshold'?: number;
    /**
     * OnItemVerifiedThreshold - threshold for ON_ITEM_VERIFIED timing, 0.0 to 1.0 (default: 1.0). If maxFraudScore >=  this value, timing is ON_ITEM_VERIFIED. Must be >= on_item_sent_threshold.
     * @type {number}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'on_item_verified_threshold'?: number;
    /**
     * RealizationTimeoutDays - days before realized risk expires (default: 45)
     * @type {string}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'realization_timeout_days'?: string;
    /**
     * RiskEvaluationEnabled
     * @type {boolean}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'risk_evaluation_enabled'?: boolean;
    /**
     * TestingEnabled
     * @type {boolean}
     * @memberof PbGetRiskExposureSettingsResponse
     */
    'testing_enabled'?: boolean;
}
/**
 * Get service fees response
 * @export
 * @interface PbGetServiceFeesRes
 */
export interface PbGetServiceFeesRes {
    /**
     * Rules
     * @type {Array<PbServiceFeesRule>}
     * @memberof PbGetServiceFeesRes
     */
    'rules'?: Array<PbServiceFeesRule>;
}
/**
 * 
 * @export
 * @interface PbGetTransactionByReverIDInternalResponse
 */
export interface PbGetTransactionByReverIDInternalResponse {
    /**
     * The transaction, including the ID of the process it belongs to
     * @type {ModelsTransaction}
     * @memberof PbGetTransactionByReverIDInternalResponse
     */
    'transaction'?: ModelsTransaction;
}
/**
 * 
 * @export
 * @interface PbGetTransactionsResponse
 */
export interface PbGetTransactionsResponse {
    /**
     * List of all transactions for the given process
     * @type {Array<ModelsTransaction>}
     * @memberof PbGetTransactionsResponse
     */
    'transactions'?: Array<ModelsTransaction>;
}
/**
 * GetWarehouseConfigResponse
 * @export
 * @interface PbGetWarehouseConfigResponse
 */
export interface PbGetWarehouseConfigResponse {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbGetWarehouseConfigResponse
     */
    'ecommerce_id'?: string;
    /**
     * List of warehouses
     * @type {Array<PbWarehouseConfig>}
     * @memberof PbGetWarehouseConfigResponse
     */
    'warehouse_configs'?: Array<PbWarehouseConfig>;
}
/**
 * Warehouse routing rules of a group or an ecommerce
 * @export
 * @interface PbGetWarehouseConfigsV2Response
 */
export interface PbGetWarehouseConfigsV2Response {
    /**
     * Ecommerce group the rules belong to. Set for an ecommerce request too.
     * @type {string}
     * @memberof PbGetWarehouseConfigsV2Response
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce of the request, empty for a group request
     * @type {string}
     * @memberof PbGetWarehouseConfigsV2Response
     */
    'ecommerce_id'?: string;
    /**
     * True when the ecommerce has its own override instead of following its group\'s rules
     * @type {boolean}
     * @memberof PbGetWarehouseConfigsV2Response
     */
    'overridden'?: boolean;
    /**
     * For a group request, the routing rules of each of the group\'s ecommerces that overrides them. Empty for an  ecommerce request.
     * @type {Array<PbWarehouseConfigOverride>}
     * @memberof PbGetWarehouseConfigsV2Response
     */
    'overrides'?: Array<PbWarehouseConfigOverride>;
    /**
     * Routing rules. Empty when none are configured.
     * @type {Array<PbWarehouseConfig>}
     * @memberof PbGetWarehouseConfigsV2Response
     */
    'warehouse_configs'?: Array<PbWarehouseConfig>;
}
/**
 * GetWarehouseRequest
 * @export
 * @interface PbGetWarehouseRequest
 */
export interface PbGetWarehouseRequest {
    /**
     * Address
     * @type {PbAddress}
     * @memberof PbGetWarehouseRequest
     */
    'address'?: PbAddress;
    /**
     * Checkout Id
     * @type {string}
     * @memberof PbGetWarehouseRequest
     */
    'checkout_id'?: string;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbGetWarehouseRequest
     */
    'ecommerce_id'?: string;
    /**
     * Order
     * @type {PbOrder}
     * @memberof PbGetWarehouseRequest
     */
    'order'?: PbOrder;
    /**
     * return method
     * @type {string}
     * @memberof PbGetWarehouseRequest
     */
    'return_method'?: PbGetWarehouseRequestReturnMethodEnum;
    /**
     * ItemToReturn
     * @type {Array<PbReturningItem>}
     * @memberof PbGetWarehouseRequest
     */
    'returning_items'?: Array<PbReturningItem>;
}

export const PbGetWarehouseRequestReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type PbGetWarehouseRequestReturnMethodEnum = typeof PbGetWarehouseRequestReturnMethodEnum[keyof typeof PbGetWarehouseRequestReturnMethodEnum];

/**
 * GetWarehouseResponse
 * @export
 * @interface PbGetWarehouseResponse
 */
export interface PbGetWarehouseResponse {
    /**
     * warehouse
     * @type {PbWarehouse}
     * @memberof PbGetWarehouseResponse
     */
    'warehouse'?: PbWarehouse;
}
/**
 * GetWfpClaimByReturnProcessIDRequest looks up a wfp_claim by return process id.
 * @export
 * @interface PbGetWfpClaimByReturnProcessIDRequest
 */
export interface PbGetWfpClaimByReturnProcessIDRequest {
    /**
     * Return process id (wfp_claim.return_process_id, UNIQUE). Required.
     * @type {string}
     * @memberof PbGetWfpClaimByReturnProcessIDRequest
     */
    'return_process_id'?: string;
}
/**
 * GetWfpClaimByReturnProcessIDResponse carries the matched claim.
 * @export
 * @interface PbGetWfpClaimByReturnProcessIDResponse
 */
export interface PbGetWfpClaimByReturnProcessIDResponse {
    /**
     * The matched claim.
     * @type {PbWfpClaim}
     * @memberof PbGetWfpClaimByReturnProcessIDResponse
     */
    'claim'?: PbWfpClaim;
}
/**
 * GetWfpClaimRequest looks up a wfp_claim by its Seel claim id.
 * @export
 * @interface PbGetWfpClaimRequest
 */
export interface PbGetWfpClaimRequest {
    /**
     * Seel claim id (wfp_claim primary key). Required.
     * @type {string}
     * @memberof PbGetWfpClaimRequest
     */
    'seel_claim_id'?: string;
}
/**
 * GetWfpClaimResponse carries the matched claim.
 * @export
 * @interface PbGetWfpClaimResponse
 */
export interface PbGetWfpClaimResponse {
    /**
     * The matched claim.
     * @type {PbWfpClaim}
     * @memberof PbGetWfpClaimResponse
     */
    'claim'?: PbWfpClaim;
}
/**
 * GetWfpContractByShopifyOrderIDRequest looks up a WFP contract by its Shopify  order id (the wfp_contract.shopify_order_id key).
 * @export
 * @interface PbGetWfpContractByShopifyOrderIDRequest
 */
export interface PbGetWfpContractByShopifyOrderIDRequest {
    /**
     * Bare numeric Shopify order id; equals wfp_contract.shopify_order_id.  Required.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDRequest
     */
    'shopify_order_id'?: string;
}
/**
 * GetWfpContractByShopifyOrderIDResponse carries the contract fields the  cancellation endpoint needs, plus seel_order_id joined from wfp_order_mapping.
 * @export
 * @interface PbGetWfpContractByShopifyOrderIDResponse
 */
export interface PbGetWfpContractByShopifyOrderIDResponse {
    /**
     * Set once a cancellation has been requested (idempotency latch). Null when no  cancellation has been requested yet.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'cancellation_requested_at'?: string;
    /**
     * ISO-4217 currency code the premium is denominated in.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'currency'?: string;
    /**
     * EcommerceID the contract belongs to.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'ecommerce_id'?: string;
    /**
     * order_date == Seel created_ts (≈ order paid time); the basis for the 24h  cancellation window.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'order_date'?: string;
    /**
     * WFP premium amount in the smallest currency unit (cents); the refund amount.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'premium_amount_cents'?: string;
    /**
     * Tax on the WFP premium in the smallest currency unit (cents).
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'premium_tax_cents'?: string;
    /**
     * Seel contract id (wfp_contract primary key).
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'seel_contract_id'?: string;
    /**
     * Seel order id joined from wfp_order_mapping; needed to call Seel\'s cancel.  Empty when the mapping has not yet recorded the Seel order id.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'seel_order_id'?: string;
    /**
     * Shopify line item id of the WFP insurance product, joined from  wfp_order_mapping; the line item the cancellation flow refunds.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'shopify_wfp_line_item_id'?: string;
    /**
     * REVER-internal status: pending_activation | active | terminal states owned  by the contract.cancelled / expired / failed-activation handlers.
     * @type {string}
     * @memberof PbGetWfpContractByShopifyOrderIDResponse
     */
    'status'?: string;
}
/**
 * GetWfpRsiUsageByContractIDRequest looks up the RSI free-return ledger row for a  WFP contract.
 * @export
 * @interface PbGetWfpRsiUsageByContractIDRequest
 */
export interface PbGetWfpRsiUsageByContractIDRequest {
    /**
     * Seel contract id (wfp_rsi_usage.wfp_contract_id). Required.
     * @type {string}
     * @memberof PbGetWfpRsiUsageByContractIDRequest
     */
    'seel_contract_id'?: string;
}
/**
 * GetWfpRsiUsageByContractIDResponse reports whether the contract has already  consumed its free return.
 * @export
 * @interface PbGetWfpRsiUsageByContractIDResponse
 */
export interface PbGetWfpRsiUsageByContractIDResponse {
    /**
     * True when a wfp_rsi_usage row exists for the contract (free return used).
     * @type {boolean}
     * @memberof PbGetWfpRsiUsageByContractIDResponse
     */
    'exists'?: boolean;
}
/**
 * 
 * @export
 * @interface PbGetWorkflowsResponse
 */
export interface PbGetWorkflowsResponse {
    /**
     * 
     * @type {Array<PbWorkflow>}
     * @memberof PbGetWorkflowsResponse
     */
    'workflows'?: Array<PbWorkflow>;
}
/**
 * 
 * @export
 * @interface PbGiftCard
 */
export interface PbGiftCard {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbGiftCard
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbGiftCard
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbGiftCard
     */
    'created_at'?: string;
}
/**
 * 
 * @export
 * @interface PbGiftCardCompensation
 */
export interface PbGiftCardCompensation {
    /**
     * 
     * @type {PbGiftCard}
     * @memberof PbGiftCardCompensation
     */
    'gift_card'?: PbGiftCard;
    /**
     * 
     * @type {PbCompensationSummary}
     * @memberof PbGiftCardCompensation
     */
    'summary'?: PbCompensationSummary;
}
/**
 * GroupContacts is the full set of points of contact of a group.
 * @export
 * @interface PbGroupContacts
 */
export interface PbGroupContacts {
    /**
     * Every stored contact, grouped by type in dashboard order
     * @type {Array<PbEcommerceContact>}
     * @memberof PbGroupContacts
     */
    'contacts'?: Array<PbEcommerceContact>;
    /**
     * Group
     * @type {string}
     * @memberof PbGroupContacts
     */
    'ecommerce_group'?: string;
}
/**
 * Group of the storeID belongs to
 * @export
 * @interface PbGroupFromStoreIDResponse
 */
export interface PbGroupFromStoreIDResponse {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof PbGroupFromStoreIDResponse
     */
    'ecommerce_group'?: string;
}
/**
 * GroupNangoConnection is a Nango connection of a group, with the stores it is assigned to.
 * @export
 * @interface PbGroupNangoConnection
 */
export interface PbGroupNangoConnection {
    /**
     * Nango connection id, unique within its integration.
     * @type {string}
     * @memberof PbGroupNangoConnection
     */
    'connection_id'?: string;
    /**
     * When the connection was created in Nango.
     * @type {string}
     * @memberof PbGroupNangoConnection
     */
    'created_at'?: string;
    /**
     * Whether the store accepted the connection\'s credentials when REVER last checked them; unset if never checked.
     * @type {PbNangoConnectionHealth}
     * @memberof PbGroupNangoConnection
     */
    'health'?: PbNangoConnectionHealth;
    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof PbGroupNangoConnection
     */
    'integration'?: string;
    /**
     * Ecommerces of the group the connection is assigned to; empty when it is assigned to none.
     * @type {Array<string>}
     * @memberof PbGroupNangoConnection
     */
    'linked_ecommerce_ids'?: Array<string>;
    /**
     * Nango provider behind the integration, such as shopify.
     * @type {string}
     * @memberof PbGroupNangoConnection
     */
    'provider'?: string;
    /**
     * Store the connection connects, such as a shop name or URL; empty for an integration without one.
     * @type {string}
     * @memberof PbGroupNangoConnection
     */
    'store'?: string;
}
/**
 * List of settings
 * @export
 * @interface PbGroupSettingsResponse
 */
export interface PbGroupSettingsResponse {
    /**
     * List of settings corresponding to the e-commerces from the group
     * @type {Array<PbECommerceSettings>}
     * @memberof PbGroupSettingsResponse
     */
    'settings'?: Array<PbECommerceSettings>;
}
/**
 * HandleSeelClaimAcceptedRequest is the mapped SEEL_CLAIM_ACCEPTED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelClaimAcceptedRequest
 */
export interface PbHandleSeelClaimAcceptedRequest {
    /**
     * ISO-4217 currency code for the refund amount (e.g. \"USD\"). May be absent.
     * @type {string}
     * @memberof PbHandleSeelClaimAcceptedRequest
     */
    'currency'?: string;
    /**
     * Approved refund amount in the smallest currency unit (e.g. cents). Stored  on wfp_claim for audit; the actual refund is performed by the OPM pipeline  as a side-effect of the accept transition. Absent when Seel omits it.
     * @type {string}
     * @memberof PbHandleSeelClaimAcceptedRequest
     */
    'refund_amount_cents'?: string;
    /**
     * Seel claim ID. Primary key used to look up and update the wfp_claim row.  Required.
     * @type {string}
     * @memberof PbHandleSeelClaimAcceptedRequest
     */
    'seel_claim_id'?: string;
}
/**
 * HandleSeelClaimClosedRequest is the mapped SEEL_CLAIM_CLOSED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelClaimClosedRequest
 */
export interface PbHandleSeelClaimClosedRequest {
    /**
     * Seel claim ID. Primary key used to look up and update the wfp_claim row.  Required.
     * @type {string}
     * @memberof PbHandleSeelClaimClosedRequest
     */
    'seel_claim_id'?: string;
}
/**
 * HandleSeelClaimCreatedRequest is the mapped SEEL_CLAIM_CREATED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelClaimCreatedRequest
 */
export interface PbHandleSeelClaimCreatedRequest {
    /**
     * Seel claim ID. Primary key used to look up and update the wfp_claim row.  Required.
     * @type {string}
     * @memberof PbHandleSeelClaimCreatedRequest
     */
    'seel_claim_id'?: string;
}
/**
 * HandleSeelClaimRejectedRequest is the mapped SEEL_CLAIM_REJECTED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelClaimRejectedRequest
 */
export interface PbHandleSeelClaimRejectedRequest {
    /**
     * Seel claim ID. Primary key used to look up and update the wfp_claim row.  Required.
     * @type {string}
     * @memberof PbHandleSeelClaimRejectedRequest
     */
    'seel_claim_id'?: string;
    /**
     * Rejection reason provided by Seel. May be empty; the handler falls back to  a generic message for the shopper email.
     * @type {string}
     * @memberof PbHandleSeelClaimRejectedRequest
     */
    'status_reason'?: string;
}
/**
 * HandleSeelClaimReopenedRequest is the mapped SEEL_CLAIM_REOPENED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelClaimReopenedRequest
 */
export interface PbHandleSeelClaimReopenedRequest {
    /**
     * Seel claim ID. Primary key used to look up and update the wfp_claim row.  Required.
     * @type {string}
     * @memberof PbHandleSeelClaimReopenedRequest
     */
    'seel_claim_id'?: string;
}
/**
 * HandleSeelClaimResolvedRequest is the mapped SEEL_CLAIM_RESOLVED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelClaimResolvedRequest
 */
export interface PbHandleSeelClaimResolvedRequest {
    /**
     * Seel claim ID. Primary key used to look up and update the wfp_claim row.  Required.
     * @type {string}
     * @memberof PbHandleSeelClaimResolvedRequest
     */
    'seel_claim_id'?: string;
}
/**
 * HandleSeelContractActivatedRequest is the mapped SEEL_CONTRACT_ACTIVATED  payload. The contract must already exist (persisted by the  SEEL_CONTRACT_CREATED handler); this event only advances its status and fills  the coverage window.
 * @export
 * @interface PbHandleSeelContractActivatedRequest
 */
export interface PbHandleSeelContractActivatedRequest {
    /**
     * Coverage start timestamp: the moment the contract was activated. The  events-api transformer maps it from Seel\'s contract updated_ts on  contract.activated. Persisted as wfp_contract.coverage_start_at.
     * @type {string}
     * @memberof PbHandleSeelContractActivatedRequest
     */
    'activated_ts'?: string;
    /**
     * Coverage end timestamp from Seel (data.end_effective_ts). Seel sends it null  on contract.created and only provides the real value here; persisted as  wfp_contract.coverage_end_at — the source of truth for when coverage ends.
     * @type {string}
     * @memberof PbHandleSeelContractActivatedRequest
     */
    'end_effective_ts'?: string;
    /**
     * Seel contract id (primary key, used to look up the contract to activate).
     * @type {string}
     * @memberof PbHandleSeelContractActivatedRequest
     */
    'seel_contract_id'?: string;
}
/**
 * HandleSeelContractActivatedResponse is returned on a successful transition.
 * @export
 * @interface PbHandleSeelContractActivatedResponse
 */
export interface PbHandleSeelContractActivatedResponse {
    /**
     * Seel contract id of the activated contract.
     * @type {string}
     * @memberof PbHandleSeelContractActivatedResponse
     */
    'seel_contract_id'?: string;
    /**
     * REVER-internal status after handling (`active`, or the unchanged status  when the contract was already active or in a terminal state).
     * @type {string}
     * @memberof PbHandleSeelContractActivatedResponse
     */
    'status'?: string;
}
/**
 * HandleSeelContractCanceledRequest is the mapped SEEL_CONTRACT_CANCELED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelContractCanceledRequest
 */
export interface PbHandleSeelContractCanceledRequest {
    /**
     * Cancellation reason provided by Seel (data.cancellationReason). Persisted  as wfp_contract.status_reason and shown in the shopper cancellation email.  May be empty.
     * @type {string}
     * @memberof PbHandleSeelContractCanceledRequest
     */
    'cancellation_reason'?: string;
    /**
     * Seel contract id. Primary key used to look up and update the wfp_contract  row. Required.
     * @type {string}
     * @memberof PbHandleSeelContractCanceledRequest
     */
    'seel_contract_id'?: string;
}
/**
 * HandleSeelContractCanceledResponse is returned on a successful cancellation.
 * @export
 * @interface PbHandleSeelContractCanceledResponse
 */
export interface PbHandleSeelContractCanceledResponse {
    /**
     * Seel contract id of the cancelled contract.
     * @type {string}
     * @memberof PbHandleSeelContractCanceledResponse
     */
    'seel_contract_id'?: string;
    /**
     * REVER-internal status after handling (a cancelled_* substate, or the  unchanged status when the contract was already cancelled).
     * @type {string}
     * @memberof PbHandleSeelContractCanceledResponse
     */
    'status'?: string;
}
/**
 * HandleSeelContractCreatedRequest is the mapped SEEL_CONTRACT_CREATED payload.  All fields come straight from the Seel contract payload; the join field  (ecommerce_id) is resolved from wfp_order_mapping by the handler (DATA-799),  not supplied here.
 * @export
 * @interface PbHandleSeelContractCreatedRequest
 */
export interface PbHandleSeelContractCreatedRequest {
    /**
     * Coverages with their eligible items (Seel coverages[]).
     * @type {Array<PbWfpCoverage>}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'coverages'?: Array<PbWfpCoverage>;
    /**
     * Contract creation timestamp from Seel (data.created_ts). Seel\'s event does  not carry the Shopify order date, so this is persisted as  wfp_contract.order_date.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'created_ts'?: string;
    /**
     * ISO currency code of the premium.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'currency'?: string;
    /**
     * Coverage end timestamp from Seel (data.end_effective_ts). Persisted as  wfp_contract.coverage_end_at — the source of truth for when coverage ends.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'end_effective_ts'?: string;
    /**
     * Premium charged to the shopper, in major units exactly as Seel sends it  (e.g. 19.99). The handler converts it to minor units (cents) for storage.
     * @type {number}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'premium'?: number;
    /**
     * Tax charged on the premium, in major units exactly as Seel sends it. The  handler converts it to minor units (cents) for storage.
     * @type {number}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'premium_tax'?: number;
    /**
     * Seel contract id (primary key, used for idempotent UPSERT).
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'seel_contract_id'?: string;
    /**
     * Seel merchant id.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'seel_merchant_id'?: string;
    /**
     * Shopify order id (Seel\'s data.order_id; in WFP it is the Shopify order id).  Used to join wfp_order_mapping.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'shopify_order_id'?: string;
    /**
     * Shopper email used for the confirmation email.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'shopper_email'?: string;
    /**
     * Shopper first name (Seel customer.first_name).
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'shopper_first_name'?: string;
    /**
     * WFP quote id this contract originated from.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedRequest
     */
    'wfp_quote_id'?: string;
}
/**
 * HandleSeelContractCreatedResponse is returned on a successful UPSERT.
 * @export
 * @interface PbHandleSeelContractCreatedResponse
 */
export interface PbHandleSeelContractCreatedResponse {
    /**
     * Seel contract id of the persisted contract.
     * @type {string}
     * @memberof PbHandleSeelContractCreatedResponse
     */
    'seel_contract_id'?: string;
    /**
     * REVER-internal status after handling (always pending_activation here).
     * @type {string}
     * @memberof PbHandleSeelContractCreatedResponse
     */
    'status'?: string;
}
/**
 * HandleSeelContractExpiredRequest is the mapped SEEL_CONTRACT_EXPIRED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelContractExpiredRequest
 */
export interface PbHandleSeelContractExpiredRequest {
    /**
     * Seel contract id. Primary key used to look up and update the wfp_contract  row. Required.
     * @type {string}
     * @memberof PbHandleSeelContractExpiredRequest
     */
    'seel_contract_id'?: string;
}
/**
 * HandleSeelContractExpiredResponse is returned on a successful handling.
 * @export
 * @interface PbHandleSeelContractExpiredResponse
 */
export interface PbHandleSeelContractExpiredResponse {
    /**
     * Seel contract id of the expired contract.
     * @type {string}
     * @memberof PbHandleSeelContractExpiredResponse
     */
    'seel_contract_id'?: string;
    /**
     * REVER-internal status after handling (`expired`, or the unchanged status  when the contract was already in a terminal state).
     * @type {string}
     * @memberof PbHandleSeelContractExpiredResponse
     */
    'status'?: string;
}
/**
 * HandleSeelContractFailedRequest is the mapped SEEL_CONTRACT_FAILED payload  delivered by events-api after transformer extraction.
 * @export
 * @interface PbHandleSeelContractFailedRequest
 */
export interface PbHandleSeelContractFailedRequest {
    /**
     * Ineligibility reason provided by Seel (data.ineligibleReason). Shown in the  shopper failure email. May be empty.
     * @type {string}
     * @memberof PbHandleSeelContractFailedRequest
     */
    'ineligible_reason'?: string;
    /**
     * Shopify order id (Seel\'s data.order_id). The join key into  wfp_order_mapping; always present. contract.failed \"occurs whenever a  contract fails to be created\" (Seel), so no contract id exists — the  refund and email are keyed off this order id.
     * @type {string}
     * @memberof PbHandleSeelContractFailedRequest
     */
    'shopify_order_id'?: string;
}
/**
 * HandleSeelContractFailedResponse is returned on a successful handling.
 * @export
 * @interface PbHandleSeelContractFailedResponse
 */
export interface PbHandleSeelContractFailedResponse {
    /**
     * REVER-internal terminal status after handling (`failed_activation`).
     * @type {string}
     * @memberof PbHandleSeelContractFailedResponse
     */
    'status'?: string;
}
/**
 * HandleShopifyAppUninstalledRequest is the payload the  SHOPIFY_APP_UNINSTALLED subscription delivers to HandleShopifyAppUninstalled.  Built by the shopify_app_uninstalled_to_wfp_alert transformer.
 * @export
 * @interface PbHandleShopifyAppUninstalledRequest
 */
export interface PbHandleShopifyAppUninstalledRequest {
    /**
     * EcommerceID of the merchant whose WFP app was uninstalled. Required.
     * @type {string}
     * @memberof PbHandleShopifyAppUninstalledRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopify shop domain from the X-Shopify-Shop-Domain header. Informational,  included in the Slack alert. Optional.
     * @type {string}
     * @memberof PbHandleShopifyAppUninstalledRequest
     */
    'shop_domain'?: string;
}
/**
 * 
 * @export
 * @interface PbHandleShopifyFulfillmentOrderRoutingCompleteRequest
 */
export interface PbHandleShopifyFulfillmentOrderRoutingCompleteRequest {
    /**
     * EcommerceID of the merchant. Required.
     * @type {string}
     * @memberof PbHandleShopifyFulfillmentOrderRoutingCompleteRequest
     */
    'ecommerce_id'?: string;
    /**
     * Printed exchange order number (Shopify order name) used to correlate to the return process.  Required.
     * @type {string}
     * @memberof PbHandleShopifyFulfillmentOrderRoutingCompleteRequest
     */
    'exchange_order_number'?: string;
}
/**
 * HandleShopifyFulfillmentUpdatedRequest is the payload the  SHOPIFY_FULFILLMENT_UPDATED subscription delivers to  HandleShopifyFulfillmentUpdated.
 * @export
 * @interface PbHandleShopifyFulfillmentUpdatedRequest
 */
export interface PbHandleShopifyFulfillmentUpdatedRequest {
    /**
     * Shopify admin domain (`<store>.myshopify.com`). Validated against WFP  settings before calling Seel. Required.
     * @type {string}
     * @memberof PbHandleShopifyFulfillmentUpdatedRequest
     */
    'admin_domain'?: string;
    /**
     * EcommerceID of the merchant. Required.
     * @type {string}
     * @memberof PbHandleShopifyFulfillmentUpdatedRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopify fulfillment ID of the updated fulfillment. Used as the log key and  forwarded to Seel for CancelFulfillment. Required.
     * @type {string}
     * @memberof PbHandleShopifyFulfillmentUpdatedRequest
     */
    'fulfillment_id'?: string;
    /**
     * Raw Shopify order JSON with `fulfillments[]` embedded. Used to extract the  shopify_order_id (for mapping lookup) and forwarded verbatim to Seel for  UpdateFulfillment. Required.
     * @type {object}
     * @memberof PbHandleShopifyFulfillmentUpdatedRequest
     */
    'order'?: object;
    /**
     * Shopify fulfillment status (e.g. \"cancelled\", \"success\"). Drives the  cancel vs. update branch. Required.
     * @type {string}
     * @memberof PbHandleShopifyFulfillmentUpdatedRequest
     */
    'status'?: string;
}
/**
 * HandleShopifyOrderCancelledRequest is the payload the SHOPIFY_ORDER_CANCELED  subscription delivers to HandleShopifyOrderCancelled.
 * @export
 * @interface PbHandleShopifyOrderCancelledRequest
 */
export interface PbHandleShopifyOrderCancelledRequest {
    /**
     * EcommerceID of the merchant. Required.
     * @type {string}
     * @memberof PbHandleShopifyOrderCancelledRequest
     */
    'ecommerce_id'?: string;
    /**
     * Raw Shopify order JSON of the canceled order, forwarded verbatim to Seel.  Seel reads the cancellation signals (cancelled_at, cancel_reason, refunds)  from this body. Required.
     * @type {object}
     * @memberof PbHandleShopifyOrderCancelledRequest
     */
    'order'?: object;
    /**
     * Shopify order ID (numeric string). Required.
     * @type {string}
     * @memberof PbHandleShopifyOrderCancelledRequest
     */
    'shopify_order_id'?: string;
}
/**
 * HandleShopifyOrderUpdatedRequest is the payload the SHOPIFY_ORDER_UPDATED  subscription delivers to HandleShopifyOrderUpdated. Built by the  shopify_order_to_wfp_forward transformer, which fetches the full order from  the Shopify API.
 * @export
 * @interface PbHandleShopifyOrderUpdatedRequest
 */
export interface PbHandleShopifyOrderUpdatedRequest {
    /**
     * Shopify admin domain (`<store>.myshopify.com`). Validated against the  merchant\'s WFP settings before forwarding to Seel.
     * @type {string}
     * @memberof PbHandleShopifyOrderUpdatedRequest
     */
    'admin_domain'?: string;
    /**
     * EcommerceID of the WFP-enabled merchant. Required.
     * @type {string}
     * @memberof PbHandleShopifyOrderUpdatedRequest
     */
    'ecommerce_id'?: string;
    /**
     * SHA-256 of the raw Shopify payload, emitted by the shared transformer.  Currently unused by the handler (every update is forwarded).
     * @type {string}
     * @memberof PbHandleShopifyOrderUpdatedRequest
     */
    'last_seen_payload_hash'?: string;
    /**
     * Raw Shopify order JSON forwarded verbatim to Seel. The handler extracts  the order id from this payload — callers do not pre-shape the data.
     * @type {object}
     * @memberof PbHandleShopifyOrderUpdatedRequest
     */
    'order'?: object;
}
/**
 * HandleShopifyProductUpdatedRequest is the payload the  SHOPIFY_PRODUCT_UPDATED subscription delivers to HandleShopifyProductUpdated.  Built by the shopify_product_updated_to_wfp_alert transformer.
 * @export
 * @interface PbHandleShopifyProductUpdatedRequest
 */
export interface PbHandleShopifyProductUpdatedRequest {
    /**
     * EcommerceID of the merchant. Required.
     * @type {string}
     * @memberof PbHandleShopifyProductUpdatedRequest
     */
    'ecommerce_id'?: string;
    /**
     * Numeric Shopify product ID extracted from the products/update webhook.  Compared against wfp_settings.shopify_wfp_product_id. Required.
     * @type {string}
     * @memberof PbHandleShopifyProductUpdatedRequest
     */
    'shopify_product_id'?: string;
}
/**
 * HasOpenWfpClaimRequest identifies the return process to check.
 * @export
 * @interface PbHasOpenWfpClaimRequest
 */
export interface PbHasOpenWfpClaimRequest {
    /**
     * Return process id. Required.
     * @type {string}
     * @memberof PbHasOpenWfpClaimRequest
     */
    'return_process_id'?: string;
}
/**
 * HasOpenWfpClaimResponse reports whether an open WFP claim owns the process.
 * @export
 * @interface PbHasOpenWfpClaimResponse
 */
export interface PbHasOpenWfpClaimResponse {
    /**
     * True when a non-terminal claim row exists or the process is a damaged  claim awaiting photo evidence.
     * @type {boolean}
     * @memberof PbHasOpenWfpClaimResponse
     */
    'has_open_claim'?: boolean;
    /**
     * Why the process is considered owned by a claim. One of:    \"open_claim\"              - a non-terminal wfp_claim row exists    \"deferred_pending_photos\" - damaged claim awaiting photo evidence  Empty when has_open_claim is false.
     * @type {string}
     * @memberof PbHasOpenWfpClaimResponse
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessData
 */
export interface PbHelpDeskProcessData {
    /**
     * Address
     * @type {PbHelpDeskProcessDataReturnAddress}
     * @memberof PbHelpDeskProcessData
     */
    'address'?: PbHelpDeskProcessDataReturnAddress;
    /**
     * Customer
     * @type {PbHelpDeskProcessDataHelpDeskCustomer}
     * @memberof PbHelpDeskProcessData
     */
    'customer'?: PbHelpDeskProcessDataHelpDeskCustomer;
    /**
     * Line Items
     * @type {PbHelpDeskProcessDataHelpDeskReturnedItems}
     * @memberof PbHelpDeskProcessData
     */
    'line_items'?: PbHelpDeskProcessDataHelpDeskReturnedItems;
    /**
     * Logistics
     * @type {PbHelpDeskProcessDataHelpDeskLogistics}
     * @memberof PbHelpDeskProcessData
     */
    'logistics'?: PbHelpDeskProcessDataHelpDeskLogistics;
    /**
     * Basic Process Data
     * @type {PbHelpDeskProcessDataHelpDeskBasicProcessData}
     * @memberof PbHelpDeskProcessData
     */
    'process_data'?: PbHelpDeskProcessDataHelpDeskBasicProcessData;
    /**
     * Return Costs
     * @type {PbHelpDeskProcessDataHelpDeskReturnedItems}
     * @memberof PbHelpDeskProcessData
     */
    'return_costs'?: PbHelpDeskProcessDataHelpDeskReturnedItems;
    /**
     * Status
     * @type {PbHelpDeskProcessDataHelpDeskStatus}
     * @memberof PbHelpDeskProcessData
     */
    'status'?: PbHelpDeskProcessDataHelpDeskStatus;
    /**
     * Timings
     * @type {PbHelpDeskProcessDataHelpDeskTimings}
     * @memberof PbHelpDeskProcessData
     */
    'timings'?: PbHelpDeskProcessDataHelpDeskTimings;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskAddress
 */
export interface PbHelpDeskProcessDataHelpDeskAddress {
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskAddress
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskAddress
     */
    'address_line_2'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskAddress
     */
    'country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskAddress
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskAddress
     */
    'postal_code'?: string;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskBasicProcessData
 */
export interface PbHelpDeskProcessDataHelpDeskBasicProcessData {
    /**
     * Currency
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskBasicProcessData
     */
    'currency'?: string;
    /**
     * Ecommerce
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskBasicProcessData
     */
    'ecommerce'?: string;
    /**
     * Order Number
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskBasicProcessData
     */
    'order_number'?: string;
    /**
     * Platform
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskBasicProcessData
     */
    'platform'?: string;
    /**
     * Platform Values
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskBasicProcessData
     */
    'platform_value'?: PbHelpDeskProcessDataHelpDeskBasicProcessDataPlatformValueEnum;
    /**
     * Process ID
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskBasicProcessData
     */
    'process_id'?: string;
}

export const PbHelpDeskProcessDataHelpDeskBasicProcessDataPlatformValueEnum = {
    MockUnspecified: 'PLATFORM_VALUES_MOCK_UNSPECIFIED',
    Woocommerce: 'PLATFORM_VALUES_WOOCOMMERCE',
    Shopify: 'PLATFORM_VALUES_SHOPIFY',
    CustomGeneric: 'PLATFORM_VALUES_CUSTOM_GENERIC',
    Prestashop: 'PLATFORM_VALUES_PRESTASHOP',
    MagentoV1: 'PLATFORM_VALUES_MAGENTO_V1',
    MagentoV2: 'PLATFORM_VALUES_MAGENTO_V2',
    Salesforce: 'PLATFORM_VALUES_SALESFORCE'
} as const;

export type PbHelpDeskProcessDataHelpDeskBasicProcessDataPlatformValueEnum = typeof PbHelpDeskProcessDataHelpDeskBasicProcessDataPlatformValueEnum[keyof typeof PbHelpDeskProcessDataHelpDeskBasicProcessDataPlatformValueEnum];

/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskCustomer
 */
export interface PbHelpDeskProcessDataHelpDeskCustomer {
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskCustomer
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskCustomer
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskCustomer
     */
    'last_name'?: string;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskLogistics
 */
export interface PbHelpDeskProcessDataHelpDeskLogistics {
    /**
     * Carrier
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskLogistics
     */
    'carrier'?: string;
    /**
     * Return method
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskLogistics
     */
    'return_method'?: string;
    /**
     * Return method Enum
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskLogistics
     */
    'return_method_enum'?: PbHelpDeskProcessDataHelpDeskLogisticsReturnMethodEnumEnum;
    /**
     * Tracking ID
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskLogistics
     */
    'tracking_id'?: string;
    /**
     * Tracking URL
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskLogistics
     */
    'tracking_url'?: string;
}

export const PbHelpDeskProcessDataHelpDeskLogisticsReturnMethodEnumEnum = {
    Unspecified: 'RETURN_METHOD_UNSPECIFIED',
    NoReturnMethod: 'RETURN_METHOD_NO_RETURN_METHOD',
    PickUp: 'RETURN_METHOD_PICK_UP',
    DropOff: 'RETURN_METHOD_DROP_OFF',
    DeliveryPickup: 'RETURN_METHOD_DELIVERY_PICKUP',
    InStore: 'RETURN_METHOD_IN_STORE'
} as const;

export type PbHelpDeskProcessDataHelpDeskLogisticsReturnMethodEnumEnum = typeof PbHelpDeskProcessDataHelpDeskLogisticsReturnMethodEnumEnum[keyof typeof PbHelpDeskProcessDataHelpDeskLogisticsReturnMethodEnumEnum];

/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskReturnedItem
 */
export interface PbHelpDeskProcessDataHelpDeskReturnedItem {
    /**
     * 
     * @type {PbHelpDeskReturnedItemHelpDeskProductInfo}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'product_info'?: PbHelpDeskReturnedItemHelpDeskProductInfo;
    /**
     * 
     * @type {number}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'return_reason_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'subtype'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'total'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItem
     */
    'unit_price'?: string;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskReturnedItems
 */
export interface PbHelpDeskProcessDataHelpDeskReturnedItems {
    /**
     * 
     * @type {Array<PbHelpDeskProcessDataHelpDeskReturnedItem>}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItems
     */
    'returned_items'?: Array<PbHelpDeskProcessDataHelpDeskReturnedItem>;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbHelpDeskProcessDataHelpDeskReturnedItems
     */
    'total'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskStatus
 */
export interface PbHelpDeskProcessDataHelpDeskStatus {
    /**
     * Refunded
     * @type {boolean}
     * @memberof PbHelpDeskProcessDataHelpDeskStatus
     */
    'refunded'?: boolean;
    /**
     * Shipping Status
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskStatus
     */
    'shipping_status'?: string;
    /**
     * Shipping Status Enum
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskStatus
     */
    'shipping_status_enum'?: PbHelpDeskProcessDataHelpDeskStatusShippingStatusEnumEnum;
}

export const PbHelpDeskProcessDataHelpDeskStatusShippingStatusEnumEnum = {
    NoShippingStatusUnspecified: 'SHIPPING_STATUS_NO_SHIPPING_STATUS_UNSPECIFIED',
    Created: 'SHIPPING_STATUS_CREATED',
    Collected: 'SHIPPING_STATUS_COLLECTED',
    InWarehouse: 'SHIPPING_STATUS_IN_WAREHOUSE',
    Error: 'SHIPPING_STATUS_ERROR',
    Canceled: 'SHIPPING_STATUS_CANCELED'
} as const;

export type PbHelpDeskProcessDataHelpDeskStatusShippingStatusEnumEnum = typeof PbHelpDeskProcessDataHelpDeskStatusShippingStatusEnumEnum[keyof typeof PbHelpDeskProcessDataHelpDeskStatusShippingStatusEnumEnum];

/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataHelpDeskTimings
 */
export interface PbHelpDeskProcessDataHelpDeskTimings {
    /**
     * Returned At
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskTimings
     */
    'returned_at'?: string;
    /**
     * Started At
     * @type {string}
     * @memberof PbHelpDeskProcessDataHelpDeskTimings
     */
    'started_at'?: string;
}
/**
 * 
 * @export
 * @interface PbHelpDeskProcessDataReturnAddress
 */
export interface PbHelpDeskProcessDataReturnAddress {
    /**
     * Drop Off Address
     * @type {PbHelpDeskProcessDataHelpDeskAddress}
     * @memberof PbHelpDeskProcessDataReturnAddress
     */
    'drop_off_address'?: PbHelpDeskProcessDataHelpDeskAddress;
    /**
     * Exchange Shipping Address
     * @type {PbHelpDeskProcessDataHelpDeskAddress}
     * @memberof PbHelpDeskProcessDataReturnAddress
     */
    'exchange'?: PbHelpDeskProcessDataHelpDeskAddress;
    /**
     * Pickup Address
     * @type {PbHelpDeskProcessDataHelpDeskAddress}
     * @memberof PbHelpDeskProcessDataReturnAddress
     */
    'pickup_address'?: PbHelpDeskProcessDataHelpDeskAddress;
}
/**
 * 
 * @export
 * @interface PbHelpDeskReturnedItemHelpDeskProductInfo
 */
export interface PbHelpDeskReturnedItemHelpDeskProductInfo {
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskReturnedItemHelpDeskProductInfo
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskReturnedItemHelpDeskProductInfo
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbHelpDeskReturnedItemHelpDeskProductInfo
     */
    'variant_name'?: string;
}
/**
 * IdList wraps a list of ids so that it carries field presence inside a patch  request, which a bare repeated field cannot do in proto3.
 * @export
 * @interface PbIdList
 */
export interface PbIdList {
    /**
     * The ids to store. An empty list clears the stored ids.
     * @type {Array<string>}
     * @memberof PbIdList
     */
    'values'?: Array<string>;
}
/**
 * ImportCredentialsToNangoInternalRequest copies the stored credentials of a group\'s ecommerces into Nango.
 * @export
 * @interface PbImportCredentialsToNangoInternalRequest
 */
export interface PbImportCredentialsToNangoInternalRequest {
    /**
     * Returns the report without writing to Nango or linking any ecommerce.
     * @type {boolean}
     * @memberof PbImportCredentialsToNangoInternalRequest
     */
    'dry_run'?: boolean;
    /**
     * Group whose enabled ecommerces to import; \"*\" (every group) only on a dry run.
     * @type {string}
     * @memberof PbImportCredentialsToNangoInternalRequest
     */
    'group'?: string;
    /**
     * Nango environment to write to: \"prod\" (default when empty) or \"dev\".
     * @type {string}
     * @memberof PbImportCredentialsToNangoInternalRequest
     */
    'nango_environment'?: string;
}
/**
 * ImportCredentialsToNangoInternalResponse reports what the import did, or would do on a dry run.
 * @export
 * @interface PbImportCredentialsToNangoInternalResponse
 */
export interface PbImportCredentialsToNangoInternalResponse {
    /**
     * No longer filled: ecommerces holding different credentials for a store now get a variant each.
     * @type {Array<PbNangoImportStore>}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'conflicts'?: Array<PbNangoImportStore>;
    /**
     * Stores Nango or the link rejected.
     * @type {Array<PbNangoImportStore>}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'failed_stores'?: Array<PbNangoImportStore>;
    /**
     * Stores imported and linked, or that would be on a dry run.
     * @type {Array<PbNangoImportStore>}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'imported_stores'?: Array<PbNangoImportStore>;
    /**
     * Connections an import made for the group that none of its ecommerces holds any more, to delete; listed only  when importing one group.
     * @type {Array<PbNangoImportStore>}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'stale_connections'?: Array<PbNangoImportStore>;
    /**
     * Ecommerces per platform or authentication the import does not cover yet, custom integration  payment gateways holding a secret (\"custom gateway REDSYS\"), and ecommerces read from Nango,  whose credentials the dashboard manages (\"read from Nango\"), counted, not imported.
     * @type {{ [key: string]: number; }}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'unsupported_platforms'?: { [key: string]: number; };
    /**
     * Extra connections of stores whose ecommerces hold different credentials: the set most of them hold keeps the  store\'s id, each other set gets the id plus its first ecommerce.
     * @type {Array<PbNangoImportStore>}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'variants'?: Array<PbNangoImportStore>;
    /**
     * Ecommerces on an imported platform with no credentials to copy.
     * @type {Array<string>}
     * @memberof PbImportCredentialsToNangoInternalResponse
     */
    'without_credentials'?: Array<string>;
}
/**
 * Store settings
 * @export
 * @interface PbInStoreSettings
 */
export interface PbInStoreSettings {
    /**
     * Whether the automated store-to-warehouse logistics is enabled for this ecommerce.  When enabled, after clerk review a pickup courier is automatically created from  the store address to the warehouse.
     * @type {boolean}
     * @memberof PbInStoreSettings
     */
    'automated_store_to_warehouse_logistics_enabled'?: boolean;
    /**
     * Preferred time window for the internal store-to-warehouse pickup courier (e.g. \"RANGE_8_TO_12\").
     * @type {string}
     * @memberof PbInStoreSettings
     */
    'default_pickup_range'?: string;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbInStoreSettings
     */
    'ecommerce_id'?: string;
    /**
     * InStore portal enabled
     * @type {boolean}
     * @memberof PbInStoreSettings
     */
    'is_enabled'?: boolean;
    /**
     * location id of the store related to the portal
     * @type {string}
     * @memberof PbInStoreSettings
     */
    'location_id'?: string;
    /**
     * name of the store
     * @type {string}
     * @memberof PbInStoreSettings
     */
    'name'?: string;
}
/**
 * InstantExchangeSettings is the single source of truth for whether a merchant offers instant exchange  and how the fee is structured.
 * @export
 * @interface PbInstantExchangeSettings
 */
export interface PbInstantExchangeSettings {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbInstantExchangeSettings
     */
    'ecommerce_id'?: string;
    /**
     * Whether instant exchange is enabled (default: false).
     * @type {boolean}
     * @memberof PbInstantExchangeSettings
     */
    'enabled'?: boolean;
    /**
     * Optional maximum fee amount (minor units) when fee_type is PERCENTAGE (0 means unset).
     * @type {number}
     * @memberof PbInstantExchangeSettings
     */
    'fee_cap_amount'?: number;
    /**
     * Optional minimum fee amount (minor units) when fee_type is PERCENTAGE (0 means unset).  Stripe requires at least 50 (e.g., $0.50).
     * @type {number}
     * @memberof PbInstantExchangeSettings
     */
    'fee_floor_amount'?: number;
    /**
     * Fee type (PERCENTAGE or FIXED).
     * @type {string}
     * @memberof PbInstantExchangeSettings
     */
    'fee_type'?: PbInstantExchangeSettingsFeeTypeEnum;
    /**
     * Fixed fee amount (in the shop currency\'s minor units) when fee_type is FIXED.
     * @type {number}
     * @memberof PbInstantExchangeSettings
     */
    'fixed_fee_amount'?: number;
    /**
     * Percentage fee value (e.g., 5 = 5%) when fee_type is PERCENTAGE.
     * @type {number}
     * @memberof PbInstantExchangeSettings
     */
    'percentage_fee_value'?: number;
    /**
     * Timing when instant exchange is available.  Only ON_START_RETURN_PROCESS and ON_ITEM_SENT are supported.
     * @type {string}
     * @memberof PbInstantExchangeSettings
     */
    'timing'?: PbInstantExchangeSettingsTimingEnum;
}

export const PbInstantExchangeSettingsFeeTypeEnum = {
    InstantExchangeFeeTypeUnspecified: 'INSTANT_EXCHANGE_FEE_TYPE_UNSPECIFIED',
    Percentage: 'PERCENTAGE',
    Fixed: 'FIXED'
} as const;

export type PbInstantExchangeSettingsFeeTypeEnum = typeof PbInstantExchangeSettingsFeeTypeEnum[keyof typeof PbInstantExchangeSettingsFeeTypeEnum];
export const PbInstantExchangeSettingsTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type PbInstantExchangeSettingsTimingEnum = typeof PbInstantExchangeSettingsTimingEnum[keyof typeof PbInstantExchangeSettingsTimingEnum];

/**
 * Instant exchange: shoppers get the new item before sending theirs back, for a fee
 * @export
 * @interface PbInstantExchangeSettingsV2
 */
export interface PbInstantExchangeSettingsV2 {
    /**
     * Whether instant exchange is offered
     * @type {boolean}
     * @memberof PbInstantExchangeSettingsV2
     */
    'enabled'?: boolean;
    /**
     * Highest fee in minor units when fee_type is PERCENTAGE, 0 for none
     * @type {number}
     * @memberof PbInstantExchangeSettingsV2
     */
    'fee_cap_amount'?: number;
    /**
     * Lowest fee in minor units when fee_type is PERCENTAGE, 0 for none
     * @type {number}
     * @memberof PbInstantExchangeSettingsV2
     */
    'fee_floor_amount'?: number;
    /**
     * How the fee is calculated
     * @type {string}
     * @memberof PbInstantExchangeSettingsV2
     */
    'fee_type'?: PbInstantExchangeSettingsV2FeeTypeEnum;
    /**
     * Fee in minor units when fee_type is FIXED
     * @type {number}
     * @memberof PbInstantExchangeSettingsV2
     */
    'fixed_fee_amount'?: number;
    /**
     * Fee percentage (5 = 5%) when fee_type is PERCENTAGE
     * @type {number}
     * @memberof PbInstantExchangeSettingsV2
     */
    'percentage_fee_value'?: number;
    /**
     * When instant exchange is offered: ON_START_RETURN_PROCESS or ON_ITEM_SENT
     * @type {string}
     * @memberof PbInstantExchangeSettingsV2
     */
    'timing'?: PbInstantExchangeSettingsV2TimingEnum;
}

export const PbInstantExchangeSettingsV2FeeTypeEnum = {
    InstantExchangeFeeTypeUnspecified: 'INSTANT_EXCHANGE_FEE_TYPE_UNSPECIFIED',
    Percentage: 'PERCENTAGE',
    Fixed: 'FIXED'
} as const;

export type PbInstantExchangeSettingsV2FeeTypeEnum = typeof PbInstantExchangeSettingsV2FeeTypeEnum[keyof typeof PbInstantExchangeSettingsV2FeeTypeEnum];
export const PbInstantExchangeSettingsV2TimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type PbInstantExchangeSettingsV2TimingEnum = typeof PbInstantExchangeSettingsV2TimingEnum[keyof typeof PbInstantExchangeSettingsV2TimingEnum];

/**
 * Integration settings
 * @export
 * @interface PbIntegrationSettings
 */
export interface PbIntegrationSettings {
    /**
     * Deprecated: outbound batch-refund endpoint/auth are now hardcoded; only the HMAC  signing secret (settings-api webhooksecrets) is used for outbound auth.
     * @type {PbBatchRefundSettings}
     * @memberof PbIntegrationSettings
     */
    'batch_refund_settings'?: PbBatchRefundSettings;
    /**
     * Whether to fetch site locales from the OCAPI Data API in the shopping flow; requires the  locale_info resource granted to the OCAPI client
     * @type {boolean}
     * @memberof PbIntegrationSettings
     */
    'is_locales_fetch_enabled'?: boolean;
    /**
     * Is Rever Returns on Orders enabled
     * @type {boolean}
     * @memberof PbIntegrationSettings
     */
    'is_rever_returns_on_orders_enabled'?: boolean;
    /**
     * Which strategy to use to distribute refund amounts across payment instruments
     * @type {string}
     * @memberof PbIntegrationSettings
     */
    'refund_strategy'?: PbIntegrationSettingsRefundStrategyEnum;
}

export const PbIntegrationSettingsRefundStrategyEnum = {
    SalesforceRefundStrategyUnspecified: 'SALESFORCE_REFUND_STRATEGY_UNSPECIFIED',
    ProportionalRefundStrategy: 'PROPORTIONAL_REFUND_STRATEGY',
    BoggiMixedRefundStrategy: 'BOGGI_MIXED_REFUND_STRATEGY',
    WinnerTakesItAll: 'WINNER_TAKES_IT_ALL',
    GiftcardStrategy: 'GIFTCARD_STRATEGY'
} as const;

export type PbIntegrationSettingsRefundStrategyEnum = typeof PbIntegrationSettingsRefundStrategyEnum[keyof typeof PbIntegrationSettingsRefundStrategyEnum];

/**
 * Invoicing information for an e-commerce
 * @export
 * @interface PbInvoicingInformation
 */
export interface PbInvoicingInformation {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbInvoicingInformation
     */
    'ecommerce_id'?: string;
    /**
     * The stripe customer id
     * @type {string}
     * @memberof PbInvoicingInformation
     */
    'stripe_customer_id'?: string;
}
/**
 * Item product from item to return
 * @export
 * @interface PbItemProduct
 */
export interface PbItemProduct {
    /**
     * The list of categories
     * @type {Array<string>}
     * @memberof PbItemProduct
     */
    'category_ids'?: Array<string>;
    /**
     * The list of collections
     * @type {Array<string>}
     * @memberof PbItemProduct
     */
    'collection_ids'?: Array<string>;
    /**
     * The ID of the product
     * @type {string}
     * @memberof PbItemProduct
     */
    'product_id'?: string;
    /**
     * The list of tags
     * @type {Array<string>}
     * @memberof PbItemProduct
     */
    'tag_ids'?: Array<string>;
    /**
     * The ID of the variant
     * @type {string}
     * @memberof PbItemProduct
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface PbItemReview
 */
export interface PbItemReview {
    /**
     * 
     * @type {string}
     * @memberof PbItemReview
     */
    'outcome'?: PbItemReviewOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof PbItemReview
     */
    'reject_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbItemReview
     */
    'returned_item_rever_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbItemReview
     */
    'user'?: string;
}

export const PbItemReviewOutcomeEnum = {
    Unspecified: 'OUTCOME_UNSPECIFIED',
    Approved: 'OUTCOME_APPROVED',
    Declined: 'OUTCOME_DECLINED',
    Missing: 'OUTCOME_MISSING'
} as const;

export type PbItemReviewOutcomeEnum = typeof PbItemReviewOutcomeEnum[keyof typeof PbItemReviewOutcomeEnum];

/**
 * JiraTicketDayBucket is the number of Jira tickets filed in one calendar day.
 * @export
 * @interface PbJiraTicketDayBucket
 */
export interface PbJiraTicketDayBucket {
    /**
     * Tickets first filed in this day, counted once each even when a retry recorded one twice.
     * @type {string}
     * @memberof PbJiraTicketDayBucket
     */
    'count'?: string;
    /**
     * Start instant of the day bucket (local midnight, re-anchored to an instant).
     * @type {string}
     * @memberof PbJiraTicketDayBucket
     */
    'day_start'?: string;
}
/**
 * KeepYourItem
 * @export
 * @interface PbKeepYourItem
 */
export interface PbKeepYourItem {
    /**
     * enabled
     * @type {boolean}
     * @memberof PbKeepYourItem
     */
    'enabled'?: boolean;
    /**
     * options
     * @type {Array<PbKeepYourItemOptions>}
     * @memberof PbKeepYourItem
     */
    'options'?: Array<PbKeepYourItemOptions>;
}
/**
 * KeepYourItemOption request
 * @export
 * @interface PbKeepYourItemOptions
 */
export interface PbKeepYourItemOptions {
    /**
     * ForceKeepYourItem
     * @type {boolean}
     * @memberof PbKeepYourItemOptions
     */
    'force_keep_your_item'?: boolean;
    /**
     * refund percentage
     * @type {number}
     * @memberof PbKeepYourItemOptions
     */
    'refund_percentage'?: number;
    /**
     * when
     * @type {Array<string>}
     * @memberof PbKeepYourItemOptions
     */
    'whens'?: Array<string>;
}
/**
 * KlarnaGatewaySettings is the settings for the Klarna gateway
 * @export
 * @interface PbKlarnaGatewaySettings
 */
export interface PbKlarnaGatewaySettings {
    /**
     * Environment
     * @type {string}
     * @memberof PbKlarnaGatewaySettings
     */
    'environment'?: PbKlarnaGatewaySettingsEnvironmentEnum;
    /**
     * Is active
     * @type {boolean}
     * @memberof PbKlarnaGatewaySettings
     */
    'is_active'?: boolean;
    /**
     * Password
     * @type {string}
     * @memberof PbKlarnaGatewaySettings
     */
    'password'?: string;
    /**
     * Username
     * @type {string}
     * @memberof PbKlarnaGatewaySettings
     */
    'username'?: string;
}

export const PbKlarnaGatewaySettingsEnvironmentEnum = {
    Unspecified: 'ENVIRONMENT_UNSPECIFIED',
    Production: 'ENVIRONMENT_PRODUCTION',
    Development: 'ENVIRONMENT_DEVELOPMENT',
    Sandbox: 'ENVIRONMENT_SANDBOX'
} as const;

export type PbKlarnaGatewaySettingsEnvironmentEnum = typeof PbKlarnaGatewaySettingsEnvironmentEnum[keyof typeof PbKlarnaGatewaySettingsEnvironmentEnum];

/**
 * Copies for a given language
 * @export
 * @interface PbLanguageCopies
 */
export interface PbLanguageCopies {
    /**
     * List of copies for a given e-commerce
     * @type {Array<PbCopyDetails>}
     * @memberof PbLanguageCopies
     */
    'copies'?: Array<PbCopyDetails>;
    /**
     * Language of the copies
     * @type {string}
     * @memberof PbLanguageCopies
     */
    'language'?: PbLanguageCopiesLanguageEnum;
}

export const PbLanguageCopiesLanguageEnum = {
    Unspecified: 'UNSPECIFIED',
    En: 'EN',
    Fr: 'FR',
    Es: 'ES',
    It: 'IT',
    De: 'DE',
    Pt: 'PT',
    Nl: 'NL',
    Pl: 'PL',
    Cs: 'CS',
    Sk: 'SK'
} as const;

export type PbLanguageCopiesLanguageEnum = typeof PbLanguageCopiesLanguageEnum[keyof typeof PbLanguageCopiesLanguageEnum];

/**
 * LinkNangoConnectionRequest links one of the group\'s Nango connections to an ecommerce.
 * @export
 * @interface PbLinkNangoConnectionRequest
 */
export interface PbLinkNangoConnectionRequest {
    /**
     * Nango connection id, as the Connect UI returns it.
     * @type {string}
     * @memberof PbLinkNangoConnectionRequest
     */
    'connection_id'?: string;
    /**
     * Ecommerce that uses the connection.
     * @type {string}
     * @memberof PbLinkNangoConnectionRequest
     */
    'ecommerce_id'?: string;
    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof PbLinkNangoConnectionRequest
     */
    'integration'?: string;
}
/**
 * LinkNangoConnectionResponse is the linked connection.
 * @export
 * @interface PbLinkNangoConnectionResponse
 */
export interface PbLinkNangoConnectionResponse {
    /**
     * The connection, as now linked to the ecommerce.
     * @type {PbNangoConnection}
     * @memberof PbLinkNangoConnectionResponse
     */
    'connection'?: PbNangoConnection;
}
/**
 * LinkPrestashopShopResponse is returned after processing a link POST from  the module.
 * @export
 * @interface PbLinkPrestashopShopResponse
 */
export interface PbLinkPrestashopShopResponse {
    /**
     * E-commerces this link disconnected because the module no longer lists  them, sorted. They keep their credentials.
     * @type {Array<string>}
     * @memberof PbLinkPrestashopShopResponse
     */
    'unlinked_ecommerce_ids'?: Array<string>;
}
/**
 * ListAPIKeyGroupsResponse lists the ecommerce groups that hold API keys.
 * @export
 * @interface PbListAPIKeyGroupsResponse
 */
export interface PbListAPIKeyGroupsResponse {
    /**
     * Groups holding at least one key, newest activity first
     * @type {Array<PbAPIKeyGroup>}
     * @memberof PbListAPIKeyGroupsResponse
     */
    'groups'?: Array<PbAPIKeyGroup>;
}
/**
 * ListAPIKeysResponse lists API keys without their values.
 * @export
 * @interface PbListAPIKeysResponse
 */
export interface PbListAPIKeysResponse {
    /**
     * Keys of every requested group
     * @type {Array<PbAPIKey>}
     * @memberof PbListAPIKeysResponse
     */
    'keys'?: Array<PbAPIKey>;
}
/**
 * ListCarrierConnectionsResponse lists a group\'s carrier connections.
 * @export
 * @interface PbListCarrierConnectionsResponse
 */
export interface PbListCarrierConnectionsResponse {
    /**
     * Carrier connections of the group.
     * @type {Array<PbCarrierConnection>}
     * @memberof PbListCarrierConnectionsResponse
     */
    'connections'?: Array<PbCarrierConnection>;
}
/**
 * Every e-commerce, sorted by id
 * @export
 * @interface PbListEcommercesInternalResponse
 */
export interface PbListEcommercesInternalResponse {
    /**
     * The e-commerces
     * @type {Array<PbEcommerceListEntry>}
     * @memberof PbListEcommercesInternalResponse
     */
    'ecommerces'?: Array<PbEcommerceListEntry>;
}
/**
 * ListGroupNangoConnectionsResponse holds the group\'s Nango connections.
 * @export
 * @interface PbListGroupNangoConnectionsResponse
 */
export interface PbListGroupNangoConnectionsResponse {
    /**
     * Connections of the group.
     * @type {Array<PbGroupNangoConnection>}
     * @memberof PbListGroupNangoConnectionsResponse
     */
    'connections'?: Array<PbGroupNangoConnection>;
}
/**
 * ListNangoConnectionsResponse holds the ecommerce\'s Nango connections, oldest first.
 * @export
 * @interface PbListNangoConnectionsResponse
 */
export interface PbListNangoConnectionsResponse {
    /**
     * Connections the ecommerce uses.
     * @type {Array<PbNangoConnection>}
     * @memberof PbListNangoConnectionsResponse
     */
    'connections'?: Array<PbNangoConnection>;
}
/**
 * ListPartnerConnectionsResponse lists a group\'s partner connections.
 * @export
 * @interface PbListPartnerConnectionsResponse
 */
export interface PbListPartnerConnectionsResponse {
    /**
     * Partner connections of the group.
     * @type {Array<PbPartnerConnection>}
     * @memberof PbListPartnerConnectionsResponse
     */
    'connections'?: Array<PbPartnerConnection>;
}
/**
 * 
 * @export
 * @interface PbListRunningTestingProcessesInternalResponse
 */
export interface PbListRunningTestingProcessesInternalResponse {
    /**
     * IDs of the testing processes that are still running
     * @type {Array<string>}
     * @memberof PbListRunningTestingProcessesInternalResponse
     */
    'process_ids'?: Array<string>;
}
/**
 * ListServiceDefaultsResponse lists a group\'s label options per carrier.
 * @export
 * @interface PbListServiceDefaultsResponse
 */
export interface PbListServiceDefaultsResponse {
    /**
     * Service defaults of the group.
     * @type {Array<PbServiceDefault>}
     * @memberof PbListServiceDefaultsResponse
     */
    'defaults'?: Array<PbServiceDefault>;
}
/**
 * ListSizeSuggestionsSettingsResponse is the response holding every Size  Suggestions settings row.
 * @export
 * @interface PbListSizeSuggestionsSettingsResponse
 */
export interface PbListSizeSuggestionsSettingsResponse {
    /**
     * All Size Suggestions settings rows.
     * @type {Array<PbSizeSuggestionsSettings>}
     * @memberof PbListSizeSuggestionsSettingsResponse
     */
    'settings'?: Array<PbSizeSuggestionsSettings>;
}
/**
 * ListStoresResponse contains the stores returned by the platform.
 * @export
 * @interface PbListStoresResponse
 */
export interface PbListStoresResponse {
    /**
     * Stores available in the platform for the given country.
     * @type {Array<PbEcommerceStore>}
     * @memberof PbListStoresResponse
     */
    'stores'?: Array<PbEcommerceStore>;
}
/**
 * ListWebhookSigningSecretsResponse is the redacted audit history, newest first, plus  the scope the active secret covers.
 * @export
 * @interface PbListWebhookSigningSecretsResponse
 */
export interface PbListWebhookSigningSecretsResponse {
    /**
     * Ecommerce group these secrets belong to
     * @type {string}
     * @memberof PbListWebhookSigningSecretsResponse
     */
    'ecommerce_group'?: string;
    /**
     * Every ecommerce of the group. All of them are signed with the same active secret,  which is what lets a receiver verify a delivery without reading the body first.
     * @type {Array<string>}
     * @memberof PbListWebhookSigningSecretsResponse
     */
    'group_ecommerce_ids'?: Array<string>;
    /**
     * Every secret ever issued to the group, newest first
     * @type {Array<PbWebhookSigningSecretSummary>}
     * @memberof PbListWebhookSigningSecretsResponse
     */
    'secrets'?: Array<PbWebhookSigningSecretSummary>;
}
/**
 * ListWfpSettingsResponse is the response holding every WFP settings row.
 * @export
 * @interface PbListWfpSettingsResponse
 */
export interface PbListWfpSettingsResponse {
    /**
     * All WFP settings rows.
     * @type {Array<PbWfpSettings>}
     * @memberof PbListWfpSettingsResponse
     */
    'settings'?: Array<PbWfpSettings>;
}
/**
 * 
 * @export
 * @interface PbListWithdrawalRequestsResponse
 */
export interface PbListWithdrawalRequestsResponse {
    /**
     * Number of requests matching the filters
     * @type {string}
     * @memberof PbListWithdrawalRequestsResponse
     */
    'rowcount'?: string;
    /**
     * Requests, newest first
     * @type {Array<PbWithdrawalRequest>}
     * @memberof PbListWithdrawalRequestsResponse
     */
    'withdrawal_requests'?: Array<PbWithdrawalRequest>;
}
/**
 * 
 * @export
 * @interface PbLogicommercePaymentPlatforms
 */
export interface PbLogicommercePaymentPlatforms {
    /**
     * Bizum platform name
     * @type {string}
     * @memberof PbLogicommercePaymentPlatforms
     */
    'bizum'?: string;
    /**
     * Paypal platform name
     * @type {string}
     * @memberof PbLogicommercePaymentPlatforms
     */
    'paypal'?: string;
    /**
     * Redsys platform name
     * @type {string}
     * @memberof PbLogicommercePaymentPlatforms
     */
    'redsys'?: string;
    /**
     * Sequra platform name
     * @type {string}
     * @memberof PbLogicommercePaymentPlatforms
     */
    'sequra'?: string;
}
/**
 * LogicommerceSettings
 * @export
 * @interface PbLogicommerceSettings
 */
export interface PbLogicommerceSettings {
    /**
     * App ID
     * @type {string}
     * @memberof PbLogicommerceSettings
     */
    'app_id'?: string;
    /**
     * Api token
     * @type {string}
     * @memberof PbLogicommerceSettings
     */
    'app_key'?: string;
    /**
     * Is sandbox ecommerce
     * @type {boolean}
     * @memberof PbLogicommerceSettings
     */
    'is_sandbox'?: boolean;
    /**
     * OPM settings
     * @type {PbGenericOPMSettings}
     * @memberof PbLogicommerceSettings
     */
    'opm_settings'?: PbGenericOPMSettings;
    /**
     * Payment platforms
     * @type {PbLogicommercePaymentPlatforms}
     * @memberof PbLogicommerceSettings
     */
    'payment_platforms'?: PbLogicommercePaymentPlatforms;
    /**
     * Logicommerce version
     * @type {string}
     * @memberof PbLogicommerceSettings
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface PbLogisticData
 */
export interface PbLogisticData {
    /**
     * Return status
     * @type {string}
     * @memberof PbLogisticData
     */
    'status'?: string;
    /**
     * Tracking number of the return
     * @type {string}
     * @memberof PbLogisticData
     */
    'tracking_number'?: string;
    /**
     * Carrier of the return
     * @type {string}
     * @memberof PbLogisticData
     */
    'url'?: string;
}
/**
 * LogisticSetting model
 * @export
 * @interface PbLogisticSetting
 */
export interface PbLogisticSetting {
    /**
     * DeliveryNoteType
     * @type {string}
     * @memberof PbLogisticSetting
     */
    'delivery_note_type'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbLogisticSetting
     */
    'ecommerce_id'?: string;
    /**
     * ReminderFlow
     * @type {string}
     * @memberof PbLogisticSetting
     */
    'reminder_flow'?: string;
    /**
     * ReturnLogistics
     * @type {Array<PbReturnLogistics>}
     * @memberof PbLogisticSetting
     */
    'return_logistics'?: Array<PbReturnLogistics>;
    /**
     * StoreListUrl
     * @type {string}
     * @memberof PbLogisticSetting
     */
    'store_list_url'?: string;
}
/**
 * LogisticsConnectionsEnabledRequest asks which carriers of a group book from carrier connections.
 * @export
 * @interface PbLogisticsConnectionsEnabledRequest
 */
export interface PbLogisticsConnectionsEnabledRequest {
    /**
     * Carriers to check, e.g. \"ups\".
     * @type {Array<string>}
     * @memberof PbLogisticsConnectionsEnabledRequest
     */
    'carriers'?: Array<string>;
    /**
     * Ecommerce group.
     * @type {string}
     * @memberof PbLogisticsConnectionsEnabledRequest
     */
    'group'?: string;
}
/**
 * LogisticsConnectionsEnabledResponse says, per carrier, whether the group books from carrier connections.
 * @export
 * @interface PbLogisticsConnectionsEnabledResponse
 */
export interface PbLogisticsConnectionsEnabledResponse {
    /**
     * True for a carrier the group books from carrier connections; false while it books from integration settings.
     * @type {{ [key: string]: boolean; }}
     * @memberof PbLogisticsConnectionsEnabledResponse
     */
    'enabled'?: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface PbLogisticsSummary
 */
export interface PbLogisticsSummary {
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'carrier'?: string;
    /**
     * Address the customer set for the return to be picked up from; unset for non-pickup methods.
     * @type {ModelsAddress}
     * @memberof PbLogisticsSummary
     */
    'pickup_address'?: ModelsAddress;
    /**
     * Carrier reference of the latest scheduled pickup (e.g. UPS Pickup Reference Number); empty if  none.
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'pickup_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'pickups_scheduled'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'return_method'?: PbLogisticsSummaryReturnMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'status'?: PbLogisticsSummaryStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'tracking_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummary
     */
    'tracking_url'?: string;
    /**
     * Warehouse the return is routed to; unset when the process has no warehouse assigned.
     * @type {PbLogisticsSummaryWarehouse}
     * @memberof PbLogisticsSummary
     */
    'warehouse'?: PbLogisticsSummaryWarehouse;
}

export const PbLogisticsSummaryReturnMethodEnum = {
    Unspecified: 'RETURN_METHOD_UNSPECIFIED',
    NoReturnMethod: 'RETURN_METHOD_NO_RETURN_METHOD',
    PickUp: 'RETURN_METHOD_PICK_UP',
    DropOff: 'RETURN_METHOD_DROP_OFF',
    DeliveryPickup: 'RETURN_METHOD_DELIVERY_PICKUP',
    InStore: 'RETURN_METHOD_IN_STORE'
} as const;

export type PbLogisticsSummaryReturnMethodEnum = typeof PbLogisticsSummaryReturnMethodEnum[keyof typeof PbLogisticsSummaryReturnMethodEnum];
export const PbLogisticsSummaryStatusEnum = {
    Unspecified: 'STATUS_UNSPECIFIED',
    NoShippingStatus: 'STATUS_NO_SHIPPING_STATUS',
    Created: 'STATUS_CREATED',
    Collected: 'STATUS_COLLECTED',
    InWarehouse: 'STATUS_IN_WAREHOUSE',
    Canceled: 'STATUS_CANCELED'
} as const;

export type PbLogisticsSummaryStatusEnum = typeof PbLogisticsSummaryStatusEnum[keyof typeof PbLogisticsSummaryStatusEnum];

/**
 * 
 * @export
 * @interface PbLogisticsSummaryWarehouse
 */
export interface PbLogisticsSummaryWarehouse {
    /**
     * Address line 1
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'address_line1'?: string;
    /**
     * Address line 2
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'address_line2'?: string;
    /**
     * City
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'city'?: string;
    /**
     * Company name
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'company'?: string;
    /**
     * Country
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'country'?: string;
    /**
     * Country code (ISO 3166-1 alpha-2)
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'country_code'?: string;
    /**
     * Contact email
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'email'?: string;
    /**
     * Contact first name
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'first_name'?: string;
    /**
     * Warehouse ID in the REVER platform
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'id'?: string;
    /**
     * Contact last name
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'last_name'?: string;
    /**
     * Contact phone
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'phone'?: string;
    /**
     * Postcode
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'postcode'?: string;
    /**
     * State or province
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'state_province'?: string;
    /**
     * State or province code
     * @type {string}
     * @memberof PbLogisticsSummaryWarehouse
     */
    'state_province_code'?: string;
}
/**
 * 
 * @export
 * @interface PbLogisticsSummaryWithProcessId
 */
export interface PbLogisticsSummaryWithProcessId {
    /**
     * 
     * @type {PbLogisticsSummary}
     * @memberof PbLogisticsSummaryWithProcessId
     */
    'logistics_summary'?: PbLogisticsSummary;
    /**
     * 
     * @type {string}
     * @memberof PbLogisticsSummaryWithProcessId
     */
    'process_id'?: string;
}
/**
 * TODO: explain better these fields
 * @export
 * @interface PbMagentoV1Settings
 */
export interface PbMagentoV1Settings {
    /**
     * access token to authenticate with the API
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'access_token'?: string;
    /**
     * access token secret to authenticate with the API
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'access_token_secret'?: string;
    /**
     * URL of the admin panel
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'admin_url'?: string;
    /**
     * Base URL of the API to communicate with the e-commerce
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'api_base_url'?: string;
    /**
     * API key
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'api_key'?: string;
    /**
     * consumer key
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'consumer_key'?: string;
    /**
     * consumer secret
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'consumer_secret'?: string;
    /**
     * user to authenticate with the API
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'user'?: string;
    /**
     * Version of the API
     * @type {string}
     * @memberof PbMagentoV1Settings
     */
    'version'?: string;
}
/**
 * Specific settings for an e-commerce using the Magento platform
 * @export
 * @interface PbMagentoV2Settings
 */
export interface PbMagentoV2Settings {
    /**
     * Access token to authenticate with the API
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'access_token'?: string;
    /**
     * Access token secret to authenticate with the API
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'access_token_secret'?: string;
    /**
     * URL of the admin panel
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'admin_url'?: string;
    /**
     * Base URL of the API to communicate with the e-commerce
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'api_base_url'?: string;
    /**
     * API key
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'api_key'?: string;
    /**
     * Authentication strategy to use (BEARER_TOKEN or OAUTH_1)
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'auth_strategy'?: PbMagentoV2SettingsAuthStrategyEnum;
    /**
     * consumer key
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'consumer_key'?: string;
    /**
     * consumer secret
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'consumer_secret'?: string;
    /**
     * Returns Integration type
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'integration_type'?: PbMagentoV2SettingsIntegrationTypeEnum;
    /**
     * URL of the module release appointing to the module github
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'module_release_url'?: string;
    /**
     * Specific settings related to managing order statuses
     * @type {PbOrderStatusSettings}
     * @memberof PbMagentoV2Settings
     */
    'order_status_settings'?: PbOrderStatusSettings;
    /**
     * PriceExcludesTaxes
     * @type {boolean}
     * @memberof PbMagentoV2Settings
     */
    'price_excludes_taxes'?: boolean;
    /**
     * List of attributes that are used to identify a product
     * @type {PbProductAttributes}
     * @memberof PbMagentoV2Settings
     */
    'product_attributes'?: PbProductAttributes;
    /**
     * When true, uses the REVER Magento module for refunds instead of Magento\'s official API.  Default (false) uses Magento\'s official invoice refund API which handles credit memo creation.
     * @type {boolean}
     * @memberof PbMagentoV2Settings
     */
    'use_rever_module_for_refunds'?: boolean;
    /**
     * user to authenticate with the API
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'user'?: string;
    /**
     * Version of the API
     * @type {string}
     * @memberof PbMagentoV2Settings
     */
    'version'?: string;
}

export const PbMagentoV2SettingsAuthStrategyEnum = {
    BearerToken: 'BEARER_TOKEN',
    Oauth1: 'OAUTH_1',
    Apikey: 'APIKEY',
    Oauth2: 'OAUTH2'
} as const;

export type PbMagentoV2SettingsAuthStrategyEnum = typeof PbMagentoV2SettingsAuthStrategyEnum[keyof typeof PbMagentoV2SettingsAuthStrategyEnum];
export const PbMagentoV2SettingsIntegrationTypeEnum = {
    Unspecified: 'INTEGRATION_TYPE_UNSPECIFIED',
    OnlyStart: 'INTEGRATION_TYPE_ONLY_START',
    Full: 'INTEGRATION_TYPE_FULL',
    None: 'INTEGRATION_TYPE_NONE'
} as const;

export type PbMagentoV2SettingsIntegrationTypeEnum = typeof PbMagentoV2SettingsIntegrationTypeEnum[keyof typeof PbMagentoV2SettingsIntegrationTypeEnum];

/**
 * Branding options for emails
 * @export
 * @interface PbMailTheme
 */
export interface PbMailTheme {
    /**
     * URL of the logo to be displayed in emails.   Important! Must be a URL stored in REVER platform  for not impacting in the email deliverability / reputation
     * @type {string}
     * @memberof PbMailTheme
     */
    'logo_url'?: string;
    /**
     * Reference color for the color palette used in emails
     * @type {string}
     * @memberof PbMailTheme
     */
    'main_color'?: string;
}
/**
 * 
 * @export
 * @interface PbMarkAsRefundedExternallyInternalRequest
 */
export interface PbMarkAsRefundedExternallyInternalRequest {
    /**
     * Refunded amount, when it differs from the pending refund amount. Optional.
     * @type {PbMoney}
     * @memberof PbMarkAsRefundedExternallyInternalRequest
     */
    'amount_override'?: PbMoney;
    /**
     * Reason for the manual refund
     * @type {string}
     * @memberof PbMarkAsRefundedExternallyInternalRequest
     */
    'note'?: string;
    /**
     * ID of the process to mark as refunded
     * @type {string}
     * @memberof PbMarkAsRefundedExternallyInternalRequest
     */
    'process_id'?: string;
    /**
     * User recorded as the author of the refund transactions
     * @type {string}
     * @memberof PbMarkAsRefundedExternallyInternalRequest
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface PbMarkAsRefundedRequest
 */
export interface PbMarkAsRefundedRequest {
    /**
     * Currency of the order
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'currency'?: string;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'ecommerce_id'?: string;
    /**
     * Extra lines of the credit note
     * @type {Array<PbExtraLineRequest>}
     * @memberof PbMarkAsRefundedRequest
     */
    'extra_lines'?: Array<PbExtraLineRequest>;
    /**
     * Items of the credit note
     * @type {Array<PbRefundedLineItems>}
     * @memberof PbMarkAsRefundedRequest
     */
    'line_items'?: Array<PbRefundedLineItems>;
    /**
     * note
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'note'?: string;
    /**
     * Order ID
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'order_id'?: string;
    /**
     * Order reference
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'order_reference'?: string;
    /**
     * Process id
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'process_id'?: string;
    /**
     * return process platform id
     * @type {string}
     * @memberof PbMarkAsRefundedRequest
     */
    'return_process_platform_id'?: string;
    /**
     * total amount to refund of the order
     * @type {PbEcommerceMoney}
     * @memberof PbMarkAsRefundedRequest
     */
    'total_amount'?: PbEcommerceMoney;
    /**
     * total amount to refund in shop currency
     * @type {PbEcommerceMoney}
     * @memberof PbMarkAsRefundedRequest
     */
    'total_amount_shop'?: PbEcommerceMoney;
}
/**
 * 
 * @export
 * @interface PbMarkAsRefundedResponse
 */
export interface PbMarkAsRefundedResponse {
    /**
     * Credit note id
     * @type {string}
     * @memberof PbMarkAsRefundedResponse
     */
    'credit_note_id'?: string;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbMarkAsRefundedResponse
     */
    'ecommerce_id'?: string;
    /**
     * Process id
     * @type {string}
     * @memberof PbMarkAsRefundedResponse
     */
    'process_id'?: string;
}
/**
 * MarkWfpContractCancellationRequestedRequest records a cancellation request on  the contract.
 * @export
 * @interface PbMarkWfpContractCancellationRequestedRequest
 */
export interface PbMarkWfpContractCancellationRequestedRequest {
    /**
     * Initiator label; the self-service endpoint always sends \"shopper_24h\".
     * @type {string}
     * @memberof PbMarkWfpContractCancellationRequestedRequest
     */
    'cancellation_initiator'?: string;
    /**
     * Seel contract id of the contract to mark. Required.
     * @type {string}
     * @memberof PbMarkWfpContractCancellationRequestedRequest
     */
    'seel_contract_id'?: string;
}
/**
 * MeResponse for dashboard auth request
 * @export
 * @interface PbMeResponse
 */
export interface PbMeResponse {
    /**
     * ID
     * @type {string}
     * @memberof PbMeResponse
     */
    'id'?: string;
    /**
     * User
     * @type {PbUser}
     * @memberof PbMeResponse
     */
    'user'?: PbUser;
}
/**
 * Mirakl platform settings
 * @export
 * @interface PbMiraklPlatformSettings
 */
export interface PbMiraklPlatformSettings {
    /**
     * Api key
     * @type {string}
     * @memberof PbMiraklPlatformSettings
     */
    'api_key'?: string;
    /**
     * Marketplace ID
     * @type {number}
     * @memberof PbMiraklPlatformSettings
     */
    'marketplace_id'?: number;
}
/**
 * 
 * @export
 * @interface PbMoney
 */
export interface PbMoney {
    /**
     * 
     * @type {string}
     * @memberof PbMoney
     */
    'amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbMoney
     */
    'currency_code'?: string;
}
/**
 * 
 * @export
 * @interface PbMoneyBag
 */
export interface PbMoneyBag {
    /**
     * 
     * @type {PbMoney}
     * @memberof PbMoneyBag
     */
    'presentment_money'?: PbMoney;
}
/**
 * NangoConnection is a Nango connection of the group that an ecommerce uses.
 * @export
 * @interface PbNangoConnection
 */
export interface PbNangoConnection {
    /**
     * Nango connection id, unique within its integration.
     * @type {string}
     * @memberof PbNangoConnection
     */
    'connection_id'?: string;
    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof PbNangoConnection
     */
    'integration'?: string;
    /**
     * When the ecommerce linked the connection.
     * @type {string}
     * @memberof PbNangoConnection
     */
    'linked_at'?: string;
}
/**
 * NangoConnectionHealth is what the store answered the last time REVER checked a connection\'s credentials.
 * @export
 * @interface PbNangoConnectionHealth
 */
export interface PbNangoConnectionHealth {
    /**
     * When REVER last asked the store.
     * @type {string}
     * @memberof PbNangoConnectionHealth
     */
    'checked_at'?: string;
    /**
     * When the store started rejecting the credentials; unset when it accepts them.
     * @type {string}
     * @memberof PbNangoConnectionHealth
     */
    'failing_since'?: string;
    /**
     * What the store answered when it rejected the credentials; empty when it accepted them.
     * @type {string}
     * @memberof PbNangoConnectionHealth
     */
    'platform_error'?: string;
    /**
     * The store the connection\'s portals call when the connection now names another and that store rejects its  credentials, as after a Reconnect with another domain; empty otherwise.
     * @type {string}
     * @memberof PbNangoConnectionHealth
     */
    'portal_store'?: string;
    /**
     * Whether the store accepted the credentials.
     * @type {string}
     * @memberof PbNangoConnectionHealth
     */
    'state'?: PbNangoConnectionHealthStateEnum;
}

export const PbNangoConnectionHealthStateEnum = {
    Unspecified: 'NANGO_CONNECTION_HEALTH_STATE_UNSPECIFIED',
    Ok: 'NANGO_CONNECTION_HEALTH_STATE_OK',
    Invalid: 'NANGO_CONNECTION_HEALTH_STATE_INVALID'
} as const;

export type PbNangoConnectionHealthStateEnum = typeof PbNangoConnectionHealthStateEnum[keyof typeof PbNangoConnectionHealthStateEnum];

/**
 * NangoImportStore is one store\'s Nango connection and the ecommerces that use it.
 * @export
 * @interface PbNangoImportStore
 */
export interface PbNangoImportStore {
    /**
     * Nango connection id: the group and the store key, \"<group>:<store>\".
     * @type {string}
     * @memberof PbNangoImportStore
     */
    'connection_id'?: string;
    /**
     * Ecommerces on the store.
     * @type {Array<string>}
     * @memberof PbNangoImportStore
     */
    'ecommerce_ids'?: Array<string>;
    /**
     * Why the import failed, for failed stores.
     * @type {string}
     * @memberof PbNangoImportStore
     */
    'error'?: string;
    /**
     * Group that owns the connection.
     * @type {string}
     * @memberof PbNangoImportStore
     */
    'group'?: string;
    /**
     * Nango integration (provider_config_key) of the connection.
     * @type {string}
     * @memberof PbNangoImportStore
     */
    'integration'?: string;
}
/**
 * new return reason to add to the db
 * @export
 * @interface PbNewReturnReason
 */
export interface PbNewReturnReason {
    /**
     * category id of the return reason
     * @type {Array<string>}
     * @memberof PbNewReturnReason
     */
    'category_ids'?: Array<string>;
    /**
     * hidden
     * @type {boolean}
     * @memberof PbNewReturnReason
     */
    'hidden'?: boolean;
    /**
     * Whether the returns portal requires the shopper to write a comment when  this reason is selected. Defaults to false (the comment stays optional).
     * @type {boolean}
     * @memberof PbNewReturnReason
     */
    'mandatory_comment'?: boolean;
    /**
     * name of the return reason
     * @type {string}
     * @memberof PbNewReturnReason
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface PbNonReturnableItem
 */
export interface PbNonReturnableItem {
    /**
     * quantity of the item
     * @type {number}
     * @memberof PbNonReturnableItem
     */
    'quantity'?: number;
    /**
     * reason why the item is not returnable
     * @type {string}
     * @memberof PbNonReturnableItem
     */
    'reason'?: PbNonReturnableItemReasonEnum;
}

export const PbNonReturnableItemReasonEnum = {
    NoValue: 'NO_VALUE',
    InProgress: 'IN_PROGRESS',
    Returned: 'RETURNED',
    NonReturnable: 'NON_RETURNABLE',
    NotFulfilled: 'NOT_FULFILLED',
    OutOfReturnPeriod: 'OUT_OF_RETURN_PERIOD',
    ParentNotCompleted: 'PARENT_NOT_COMPLETED',
    Platform: 'PLATFORM'
} as const;

export type PbNonReturnableItemReasonEnum = typeof PbNonReturnableItemReasonEnum[keyof typeof PbNonReturnableItemReasonEnum];

/**
 * List of ids, tags, etc that could be used to identify when a product  should be non-returnable
 * @export
 * @interface PbNonReturnableItems
 */
export interface PbNonReturnableItems {
    /**
     * IDs (e-commerce platform dependant) of the brands  associated to non-returnable products
     * @type {Array<string>}
     * @memberof PbNonReturnableItems
     */
    'brand_ids'?: Array<string>;
    /**
     * IDs (e-commerce platform dependant) of the categories  that contain non-returnable products
     * @type {Array<string>}
     * @memberof PbNonReturnableItems
     */
    'category_ids'?: Array<string>;
    /**
     * Collection IDs (e-commerce platform dependant) associated to  non-returnable products
     * @type {Array<string>}
     * @memberof PbNonReturnableItems
     */
    'collection_ids'?: Array<string>;
    /**
     * IDs (e-commerce platform dependant) associated to  tags that are associated to orders that have products  considered non-returnable
     * @type {Array<string>}
     * @memberof PbNonReturnableItems
     */
    'order_tags_ids'?: Array<string>;
    /**
     * IDs (e-commerce platform) of non-returnable products
     * @type {Array<string>}
     * @memberof PbNonReturnableItems
     */
    'product_ids'?: Array<string>;
    /**
     * Tag IDs (e-commerce platform dependant) associated to   non-returnable products
     * @type {Array<string>}
     * @memberof PbNonReturnableItems
     */
    'tag_ids'?: Array<string>;
}
/**
 * OAuth2 credentials structure
 * @export
 * @interface PbOAuth2Credentials
 */
export interface PbOAuth2Credentials {
    /**
     * Client ID for OAuth2 authentication
     * @type {string}
     * @memberof PbOAuth2Credentials
     */
    'client_id'?: string;
    /**
     * Client secret for OAuth2 authentication
     * @type {string}
     * @memberof PbOAuth2Credentials
     */
    'client_secret'?: string;
    /**
     * List of OAuth2 scopes
     * @type {Array<string>}
     * @memberof PbOAuth2Credentials
     */
    'scopes'?: Array<string>;
}
/**
 * OCAPI (Open Commerce API) credentials
 * @export
 * @interface PbOcapiCredentials
 */
export interface PbOcapiCredentials {
    /**
     * Client ID for OCAPI
     * @type {string}
     * @memberof PbOcapiCredentials
     */
    'client_id'?: string;
    /**
     * Client secret for OCAPI
     * @type {string}
     * @memberof PbOcapiCredentials
     */
    'client_secret'?: string;
}
/**
 * OnboardingRequest is the request to onboard an e-commerce
 * @export
 * @interface PbOnboardingRequest
 */
export interface PbOnboardingRequest {
    /**
     * Brand Information
     * @type {PbBrandInformation}
     * @memberof PbOnboardingRequest
     */
    'brand_information'?: PbBrandInformation;
    /**
     * Points of contact of the e-commerce, added to its group\'s (shared by every  store of the group). At least one Commercial and one Customer service  contact with an email are required.
     * @type {Array<PbEcommerceContact>}
     * @memberof PbOnboardingRequest
     */
    'contacts'?: Array<PbEcommerceContact>;
    /**
     * Custom Integration Params
     * @type {PbCustomIntegrationParams}
     * @memberof PbOnboardingRequest
     */
    'custom_integration_params'?: PbCustomIntegrationParams;
    /**
     * Dashboard Users
     * @type {PbDashboardUsers}
     * @memberof PbOnboardingRequest
     */
    'dashboard_users'?: PbDashboardUsers;
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbOnboardingRequest
     */
    'ecommerce_id'?: string;
    /**
     * Refund Conditions
     * @type {PbRefundConditions}
     * @memberof PbOnboardingRequest
     */
    'refund_conditions'?: PbRefundConditions;
    /**
     * Return costs rules
     * @type {PbPostReturnAmountRequest}
     * @memberof PbOnboardingRequest
     */
    'return_amounts'?: PbPostReturnAmountRequest;
    /**
     * Return Conditions
     * @type {PbReturnConditions}
     * @memberof PbOnboardingRequest
     */
    'return_conditions'?: PbReturnConditions;
    /**
     * Return Reasons
     * @type {PbSaveReturnReasonsReq}
     * @memberof PbOnboardingRequest
     */
    'return_reasons'?: PbSaveReturnReasonsReq;
    /**
     * Warehouse Address
     * @type {PbWarehouseAddress}
     * @memberof PbOnboardingRequest
     */
    'warehouse_address'?: PbWarehouseAddress;
}
/**
 * 
 * @export
 * @interface PbOpenExchangeItem
 */
export interface PbOpenExchangeItem {
    /**
     * 
     * @type {string}
     * @memberof PbOpenExchangeItem
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PbOpenExchangeItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbOpenExchangeItem
     */
    'total'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbOpenExchangeItems
 */
export interface PbOpenExchangeItems {
    /**
     * 
     * @type {Array<PbOpenExchangeItem>}
     * @memberof PbOpenExchangeItems
     */
    'open_exchange_items'?: Array<PbOpenExchangeItem>;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbOpenExchangeItems
     */
    'total'?: PbMoneyBag;
}
/**
 * OptimizedCopyData
 * @export
 * @interface PbOptimizedCopyData
 */
export interface PbOptimizedCopyData {
    /**
     * map of language code to copies
     * @type {{ [key: string]: PbCopyKeyMap; }}
     * @memberof PbOptimizedCopyData
     */
    'languages'?: { [key: string]: PbCopyKeyMap; };
}
/**
 * Order model
 * @export
 * @interface PbOrder
 */
export interface PbOrder {
    /**
     * Currency
     * @type {string}
     * @memberof PbOrder
     */
    'currency'?: string;
    /**
     * Currency Customer
     * @type {string}
     * @memberof PbOrder
     */
    'currency_customer'?: string;
    /**
     * Customer information for loyalty rule evaluation (optional)
     * @type {PbCustomer}
     * @memberof PbOrder
     */
    'customer'?: PbCustomer;
    /**
     * Customer Printed Order ID
     * @type {string}
     * @memberof PbOrder
     */
    'customer_printed_order_id'?: string;
    /**
     * Exchange Rate
     * @type {number}
     * @memberof PbOrder
     */
    'exchange_rate'?: number;
    /**
     * Order ID
     * @type {string}
     * @memberof PbOrder
     */
    'id'?: string;
    /**
     * Is Exchange
     * @type {boolean}
     * @memberof PbOrder
     */
    'is_rever_exchange'?: boolean;
    /**
     * Order Line Items
     * @type {Array<PbOrderLineItem>}
     * @memberof PbOrder
     */
    'line_items'?: Array<PbOrderLineItem>;
    /**
     * Payment Gateway
     * @type {string}
     * @memberof PbOrder
     */
    'payment_gateway'?: string;
    /**
     * Payment Methods
     * @type {Array<string>}
     * @memberof PbOrder
     */
    'payment_methods'?: Array<PbOrderPaymentMethodsEnum>;
    /**
     * Purchased At
     * @type {string}
     * @memberof PbOrder
     */
    'purchased_at'?: string;
    /**
     * Sales channel the order originated from, verbatim from the platform  (Shopify source_name: \"web\", \"pos\", \"bol\", ...). Empty when the platform  does not report one. Business rules read it via isPointOfSale.
     * @type {string}
     * @memberof PbOrder
     */
    'sales_channel'?: string;
    /**
     * Shipping Address
     * @type {PbAddress}
     * @memberof PbOrder
     */
    'shipping_address'?: PbAddress;
    /**
     * Shipping Cost Amount
     * @type {string}
     * @memberof PbOrder
     */
    'shipping_cost_amount'?: string;
    /**
     * Order tags
     * @type {Array<string>}
     * @memberof PbOrder
     */
    'tags'?: Array<string>;
}

export const PbOrderPaymentMethodsEnum = {
    Unknown: 'ORDERPM_UNKNOWN',
    PromoCode: 'ORDERPM_PROMO_CODE',
    GiftCard: 'ORDERPM_GIFT_CARD',
    Klarna: 'ORDERPM_KLARNA',
    OpmNotSupported: 'ORDERPM_OPM_NOT_SUPPORTED'
} as const;

export type PbOrderPaymentMethodsEnum = typeof PbOrderPaymentMethodsEnum[keyof typeof PbOrderPaymentMethodsEnum];

/**
 * OrderCustomer  Important! the alias at the end is for API docs generation  @Description Customer associated to the order  @name api.OrderCustomer
 * @export
 * @interface PbOrderCustomer
 */
export interface PbOrderCustomer {
    /**
     * Platform-specific customer number (e.g. Salesforce customerNo)
     * @type {string}
     * @memberof PbOrderCustomer
     */
    'customer_no'?: string;
    /**
     * Customer email
     * @type {string}
     * @memberof PbOrderCustomer
     */
    'email'?: string;
    /**
     * Customer first name
     * @type {string}
     * @memberof PbOrderCustomer
     */
    'first_name'?: string;
    /**
     * Customer last name
     * @type {string}
     * @memberof PbOrderCustomer
     */
    'last_name'?: string;
    /**
     * Platform-specific customer identifier (e.g. Salesforce customerId)
     * @type {string}
     * @memberof PbOrderCustomer
     */
    'platform_customer_id'?: string;
}
/**
 * Read-only counts of an order\'s fulfillment orders, the ones a cancel would act on.
 * @export
 * @interface PbOrderFulfillmentStateResponse
 */
export interface PbOrderFulfillmentStateResponse {
    /**
     * How many fulfillment orders the order has; zero usually means the platform hasn\'t  created them yet.
     * @type {number}
     * @memberof PbOrderFulfillmentStateResponse
     */
    'fulfillment_orders_found'?: number;
    /**
     * How many are still open (not closed or canceled).
     * @type {number}
     * @memberof PbOrderFulfillmentStateResponse
     */
    'open'?: number;
    /**
     * How many have already shipped (a successful fulfillment).
     * @type {number}
     * @memberof PbOrderFulfillmentStateResponse
     */
    'shipped'?: number;
}
/**
 * OrderIdentification keeps the data for identifying an order within the  Rever platform and the e-commerce platform  Important! the alias at the end is for API docs generation  @Description Extended data for identifying an order in any e-commerce  @name api.OrderIdentification
 * @export
 * @interface PbOrderIdentification
 */
export interface PbOrderIdentification {
    /**
     * In Shopify GET https:/texanssaddles-com.myshopify.com/admin/orders.json?name=1066  Shopify --> The order name, generated by combining the order_number   with the order prefix and suffix that are set in the merchant\'s general settings.  This is different from the id property, which is the ID of the order used by the API.  This field can also be set by the API to be any string value.  In WooCommerce, users can install a plugin that changes how the field number   is generated so then id is no longer equal to number  If id == number then you can retrieve the order with GET /wp-json/wc/v3/orders/<id>  If not... there is not a way of retrieving a specific order by number  method --> GET /wp-json/wc/v3/orders and search over the list (!)  Shopify: order_number or name(TODO)  Woo: number
     * @type {string}
     * @memberof PbOrderIdentification
     */
    'customer_printed_order_id'?: string;
    /**
     * Internal Rever e-commerce_id
     * @type {string}
     * @memberof PbOrderIdentification
     */
    'ecommerce_id'?: string;
    /**
     * Shopify:id   Woo: id --> Not usually visible by end-users.   Unique identifier in the origin platform
     * @type {string}
     * @memberof PbOrderIdentification
     */
    'id'?: string;
    /**
     * Platform from where this order was retrieved
     * @type {string}
     * @memberof PbOrderIdentification
     */
    'platform'?: PbOrderIdentificationPlatformEnum;
    /**
     * Unique ID in the rever platform
     * @type {string}
     * @memberof PbOrderIdentification
     */
    'rever_id'?: string;
}

export const PbOrderIdentificationPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type PbOrderIdentificationPlatformEnum = typeof PbOrderIdentificationPlatformEnum[keyof typeof PbOrderIdentificationPlatformEnum];

/**
 * OrderLineItem  Important! the alias at the end is for API docs generation  @Description One of the line items from the Order
 * @export
 * @interface PbOrderLineItem
 */
export interface PbOrderLineItem {
    /**
     * Optional: when a customer send some comments
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'comment'?: string;
    /**
     * Discount codes used to purchase the item
     * @type {Array<PbDiscountCode>}
     * @memberof PbOrderLineItem
     */
    'discount_codes'?: Array<PbDiscountCode>;
    /**
     * Optional: ean for products from the order (International Article Number)
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'ean'?: string;
    /**
     * Fulfillments
     * @type {Array<PbFulfillment>}
     * @memberof PbOrderLineItem
     */
    'fulfillments'?: Array<PbFulfillment>;
    /**
     * Id of the line item in the source platform
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'id'?: string;
    /**
     * Name of the line item (not necessarily the name of the product)
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'name'?: string;
    /**
     * Optional: Information about non-returnable items
     * @type {Array<PbNonReturnableItem>}
     * @memberof PbOrderLineItem
     */
    'non_returnable_items'?: Array<PbNonReturnableItem>;
    /**
     * Optional payload of the product (with variations) specified in the field product_id
     * @type {PbProduct}
     * @memberof PbOrderLineItem
     */
    'product'?: PbProduct;
    /**
     * to get product details, request the product (API)
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'product_id'?: string;
    /**
     * number of items of the same product + variant
     * @type {number}
     * @memberof PbOrderLineItem
     */
    'quantity'?: number;
    /**
     * deprecated
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'return_reason'?: PbOrderLineItemReturnReasonEnum;
    /**
     * Returns completed count
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'returns_completed_count'?: string;
    /**
     * Returns in progress count
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'returns_in_progress_count'?: string;
    /**
     * Id of the line item in rever system
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'rever_id'?: string;
    /**
     * stock-keeping unit (SKU) is a scannable bar code,   most often seen printed on product labels in a retail store
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'sku'?: string;
    /**
     * sub total amount of the line following the MoneyFormat of the order  before discounts and taxes  subtotal = unit_price * quantity
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'subtotal'?: string;
    /**
     * total amount of the line following the MoneyFormat of the order  including discounts and tax  total = (subtotal - total_discounts) + total_taxes  this is the amount to be refunded (multiplied by items_returned/quantity)
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'total'?: string;
    /**
     * total amount of discounts of the line following the MoneyFormat
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'total_discounts'?: string;
    /**
     * total amount of taxes of the line following the MoneyFormat
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'total_taxes'?: string;
    /**
     * unit price of a single  item (no discounts, no taxes)  follows MoneyFormat associated  WARNING: This price can have roundings as some platforms   only share the unit_price + taxes.  Depending on the use case might be better to use the total directly   and add/substract taxes/discounts
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'unit_price'?: string;
    /**
     * variant of the product (same ProductID, different Variant)  we are allowing only one variant at the moment (one dimension)
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'variant_id'?: string;
    /**
     * Name of the variant
     * @type {string}
     * @memberof PbOrderLineItem
     */
    'variant_name'?: string;
}

export const PbOrderLineItemReturnReasonEnum = {
    NoReturnReason: 'NO_RETURN_REASON',
    WrongSize: 'WRONG_SIZE',
    WrongColor: 'WRONG_COLOR',
    NotAsExpected: 'NOT_AS_EXPECTED',
    Defective: 'DEFECTIVE',
    ChangedMyMind: 'CHANGED_MY_MIND',
    WrongItem: 'WRONG_ITEM',
    WrongSizeTooSmall: 'WRONG_SIZE_TOO_SMALL',
    WrongSizeTooBig: 'WRONG_SIZE_TOO_BIG'
} as const;

export type PbOrderLineItemReturnReasonEnum = typeof PbOrderLineItemReturnReasonEnum[keyof typeof PbOrderLineItemReturnReasonEnum];

/**
 * OrderPromocode is a promocode applied to an order, as the platform reports it.  Promocodes are fixed amounts: amount is what the code took off the order.  No platform reports promocodes as transactions, so consumers that weigh  what an order can still refund read them from here.  @Description Promocode applied to an order  @name api.OrderPromocode
 * @export
 * @interface PbOrderPromocode
 */
export interface PbOrderPromocode {
    /**
     * Amount the code took off the order, taxes included, in MoneyFormat minor  units. Always positive.
     * @type {string}
     * @memberof PbOrderPromocode
     */
    'amount'?: string;
    /**
     * When the code was applied. The order\'s creation time when the platform  does not record a date for the code itself.
     * @type {string}
     * @memberof PbOrderPromocode
     */
    'applied_at'?: string;
    /**
     * Code as entered on the platform (e.g. \"rv-331452-fectjpyaf\").
     * @type {string}
     * @memberof PbOrderPromocode
     */
    'code'?: string;
    /**
     * Currency of amount in ISO-4217 (e.g. EUR, USD).
     * @type {string}
     * @memberof PbOrderPromocode
     */
    'currency'?: string;
    /**
     * True when REVER issued the code (it starts with the REVER promocode  prefix), so REVER can refund its value as a new REVER promocode.
     * @type {boolean}
     * @memberof PbOrderPromocode
     */
    'is_rever'?: boolean;
    /**
     * Platform-side id of the code applied to the order (WooCommerce coupon  line id, PrestaShop cart rule id). Empty when the platform has none  (e.g. Magento 2).
     * @type {string}
     * @memberof PbOrderPromocode
     */
    'platform_id'?: string;
}
/**
 * OrderRefund attributes money the order\'s transactions moved to the line items  it paid for. It is a link and nothing more: how much moved, when, and who moved  it are stated by the transactions it names, never restated here. One refund can  settle through several transactions (e.g. gift card + card), which is why line  items live here and not on the transaction.   Every entry names at least one transaction of the same response. A refund  document the platform records without moving money (items marked refunded, say)  attributes nothing and is not reported at all.   An entry with no line items is order-level: the money its transactions moved  belongs to the order rather than to any one item. How much that is, is the part  of those transactions no line item claims.  @Description Platform-side attribution of refunded money to an order\'s line items  @name api.OrderRefund
 * @export
 * @interface PbOrderRefund
 */
export interface PbOrderRefund {
    /**
     * Platform-side refund id (stringified). Unique within the order.
     * @type {string}
     * @memberof PbOrderRefund
     */
    'id'?: string;
    /**
     * Per-line-item attribution of the money those transactions moved. Empty  when the money is order-level.
     * @type {Array<PbOrderRefundLineItem>}
     * @memberof PbOrderRefund
     */
    'line_items'?: Array<PbOrderRefundLineItem>;
    /**
     * Free-text note attached to the refund at the platform, when present.  Diagnostics only: never parsed, never matched against.
     * @type {string}
     * @memberof PbOrderRefund
     */
    'note'?: string;
    /**
     * Ids of the OrderTransaction rows that moved this refund\'s money. Joins  against GetOrderTransactionsAndRefundsResponse.transactions, and always  resolves: an entry naming no transaction of the order is not reported.
     * @type {Array<string>}
     * @memberof PbOrderRefund
     */
    'transaction_ids'?: Array<string>;
}
/**
 * OrderRefundLineItem is the portion of a refund attributed to one order line  item. subtotal_amount + tax_amount is the money actually returned to the  shopper for the line; across the lines of one refund that sum must never  exceed the money the refund\'s transactions moved — consumers subtract it  from what REVER owes the shopper.  @Description Line-item attribution of a platform-side refund  @name api.OrderRefundLineItem
 * @export
 * @interface PbOrderRefundLineItem
 */
export interface PbOrderRefundLineItem {
    /**
     * Currency in ISO-4217 (e.g. EUR, USD).
     * @type {string}
     * @memberof PbOrderRefundLineItem
     */
    'currency'?: string;
    /**
     * Platform-side id of the order line item this attribution points at  (stringified). Matches the line item ids returned by GetOrder.
     * @type {string}
     * @memberof PbOrderRefundLineItem
     */
    'line_item_id'?: string;
    /**
     * Refunded quantity of the line item.
     * @type {string}
     * @memberof PbOrderRefundLineItem
     */
    'quantity'?: string;
    /**
     * Refunded subtotal of the line excluding tax, in MoneyFormat minor units,  presentment currency. Normalized: on a tax-inclusive store the platform  reports the subtotal with the tax inside, and the platform implementation  must subtract the contained tax here so this field is always net —  reporting it as-is double counts the tax and takes it off the shopper\'s  refund.
     * @type {string}
     * @memberof PbOrderRefundLineItem
     */
    'subtotal_amount'?: string;
    /**
     * Refunded tax of the line in MoneyFormat minor units.
     * @type {string}
     * @memberof PbOrderRefundLineItem
     */
    'tax_amount'?: string;
}
/**
 * OrderRetrieval keeps data relative to how  this data was retrieved  Important! the alias at the end is for API docs generation  @Description information on how this order was retrieved  @name api.OrderRetrieval
 * @export
 * @interface PbOrderRetrieval
 */
export interface PbOrderRetrieval {
    /**
     * The timestamp where this data was retrieved from the corresponding endpoint  RFC3339 format
     * @type {string}
     * @memberof PbOrderRetrieval
     */
    'date'?: string;
    /**
     * Navigable links for this order (admin UI, API, etc.)
     * @type {PbOrderRetrievalNavigation}
     * @memberof PbOrderRetrieval
     */
    'navigation'?: PbOrderRetrievalNavigation;
    /**
     * Source URL for this order (API path used to retrieve it)
     * @type {string}
     * @memberof PbOrderRetrieval
     */
    'source'?: string;
}
/**
 * OrderRetrievalNavigation groups navigable URLs related to the order  (browser admin UI, public API, etc.)  @Description navigable URLs related to the order  @name api.OrderRetrievalNavigation
 * @export
 * @interface PbOrderRetrievalNavigation
 */
export interface PbOrderRetrievalNavigation {
    /**
     * Browser-navigable URL to view the order in the platform admin UI.  Use this to open the order directly in a browser.  Example (Shopify): https://my-store.myshopify.com/admin/orders/123456789
     * @type {string}
     * @memberof PbOrderRetrievalNavigation
     */
    'admin_html_order_url'?: string;
}
/**
 * OrderStatus keeps track of transient data of the order  Important! the alias at the end is for API docs generation  @Description Order status with time it was considered as PAID -- returns policy  uses this date as starting time
 * @export
 * @interface PbOrderStatus
 */
export interface PbOrderStatus {
    /**
     * The date since the returns policy starts counting at  Shopify: processed_at (verify) Woo: date_paid (verify)  RFC3399 format
     * @type {string}
     * @memberof PbOrderStatus
     */
    'customer_printed_date'?: string;
    /**
     * Status of the order. TODO: Available statuses
     * @type {string}
     * @memberof PbOrderStatus
     */
    'status'?: string;
}
/**
 * Specific settings related to the order status of   an e-commerce using the Magento platform  the ids represent the Magento order status ids
 * @export
 * @interface PbOrderStatusSettings
 */
export interface PbOrderStatusSettings {
    /**
     * TODO: improve description
     * @type {string}
     * @memberof PbOrderStatusSettings
     */
    'partially_returned_code'?: string;
    /**
     * TODO: improve description
     * @type {string}
     * @memberof PbOrderStatusSettings
     */
    'processing_code'?: string;
    /**
     * TODO: improve description
     * @type {string}
     * @memberof PbOrderStatusSettings
     */
    'return_completed_code'?: string;
    /**
     * TODO: improve description
     * @type {string}
     * @memberof PbOrderStatusSettings
     */
    'return_started_code'?: string;
}
/**
 * OrderTransaction is a platform-side transaction recorded against an order  (sale, capture, authorization, void, refund). Returned by  GetOrderTransactionsAndRefunds.  Refund-kind rows have a positive amount and, when the platform supports it,  a parent_id pointing at the SALE/CAPTURE row they offset. Consumers compute  net by subtracting REFUND amounts from sibling SALE/CAPTURE amounts.  @Description Platform-side transaction on an order (sale, capture, refund, ...)  @name api.OrderTransaction
 * @export
 * @interface PbOrderTransaction
 */
export interface PbOrderTransaction {
    /**
     * True when the platform recorded this refund without moving money: REVER  books it to account for a compensation it already gave by other means  (exchange, gift card, bank transfer). Consumers must count it neither as  money the shopper received nor as refundable room the order has used up.  Always false on a sale or capture.
     * @type {boolean}
     * @memberof PbOrderTransaction
     */
    'accounting_only'?: boolean;
    /**
     * Amount in MoneyFormat minor units. Always positive, including for refunds.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'amount'?: string;
    /**
     * Currency in ISO-4217 (e.g. EUR, USD).
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'currency'?: string;
    /**
     * When the transaction was executed at the platform (UTC). Empty if  the platform does not return a timestamp.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'executed_at'?: string;
    /**
     * Identifier of the user/staff member who executed the transaction at the  platform when available (e.g. Shopify staff user_id). Empty if the  transaction was executed automatically by the platform or the gateway,  or when the platform does not expose this field.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'executed_by'?: string;
    /**
     * Human-readable name of the author (staff member or app) when the platform  exposes it. Empty on Shopify (requires scopes REVER does not have).
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'executed_by_name'?: string;
    /**
     * True when the transaction was created by REVER\'s own platform app  (on Shopify: source matches the id of the currently authenticated app).  Consumers use this to tell REVER-executed refunds from external ones.
     * @type {boolean}
     * @memberof PbOrderTransaction
     */
    'executed_by_rever'?: boolean;
    /**
     * Payment gateway that processed the transaction (e.g. shopify_payments,  paypal, gift_card). Used by consumers to match against the original  payment method when reconciling refunds.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'gateway'?: string;
    /**
     * Platform-side transaction id (stringified). Unique within the order.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'id'?: string;
    /**
     * Kind of transaction (sale, capture, authorization, void, refund).
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'kind'?: PbOrderTransactionKindEnum;
    /**
     * For refund-kind rows, the platform-side id of the original sale/capture  this refund offsets. Empty when the platform does not expose this linkage  (e.g. WooCommerce, Prestashop).
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'parent_id'?: string;
    /**
     * Raw platform channel/app that created the transaction, when exposed.  On Shopify this is source_name: \"web\" for checkout, \"pos\" for point of  sale, or the numeric client id of the app that created the transaction.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'source'?: string;
    /**
     * Status of the transaction at the platform.
     * @type {string}
     * @memberof PbOrderTransaction
     */
    'status'?: PbOrderTransactionStatusEnum;
}

export const PbOrderTransactionKindEnum = {
    Unspecified: 'ORDER_TRANSACTION_KIND_UNSPECIFIED',
    Sale: 'ORDER_TRANSACTION_KIND_SALE',
    Capture: 'ORDER_TRANSACTION_KIND_CAPTURE',
    Authorization: 'ORDER_TRANSACTION_KIND_AUTHORIZATION',
    Void: 'ORDER_TRANSACTION_KIND_VOID',
    Refund: 'ORDER_TRANSACTION_KIND_REFUND'
} as const;

export type PbOrderTransactionKindEnum = typeof PbOrderTransactionKindEnum[keyof typeof PbOrderTransactionKindEnum];
export const PbOrderTransactionStatusEnum = {
    Unspecified: 'ORDER_TRANSACTION_STATUS_UNSPECIFIED',
    Success: 'ORDER_TRANSACTION_STATUS_SUCCESS',
    Pending: 'ORDER_TRANSACTION_STATUS_PENDING',
    Failure: 'ORDER_TRANSACTION_STATUS_FAILURE',
    Error: 'ORDER_TRANSACTION_STATUS_ERROR'
} as const;

export type PbOrderTransactionStatusEnum = typeof PbOrderTransactionStatusEnum[keyof typeof PbOrderTransactionStatusEnum];

/**
 * 
 * @export
 * @interface PbOrderedItem
 */
export interface PbOrderedItem {
    /**
     * 
     * @type {string}
     * @memberof PbOrderedItem
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbOrderedItem
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbOrderedItem
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PbOrderedItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbOrderedItem
     */
    'total'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbOrderedItem
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbOrderedItem
     */
    'variant_name'?: string;
}
/**
 * 
 * @export
 * @interface PbOrderedItems
 */
export interface PbOrderedItems {
    /**
     * 
     * @type {Array<PbOrderedItem>}
     * @memberof PbOrderedItems
     */
    'ordered_items'?: Array<PbOrderedItem>;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbOrderedItems
     */
    'total'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbOriginalPaymentMethodCompensation
 */
export interface PbOriginalPaymentMethodCompensation {
    /**
     * 
     * @type {boolean}
     * @memberof PbOriginalPaymentMethodCompensation
     */
    'bt_fallback_triggered'?: boolean;
    /**
     * 
     * @type {Array<PbOriginalPaymentMethodRefund>}
     * @memberof PbOriginalPaymentMethodCompensation
     */
    'refunds'?: Array<PbOriginalPaymentMethodRefund>;
    /**
     * 
     * @type {PbCompensationSummary}
     * @memberof PbOriginalPaymentMethodCompensation
     */
    'summary'?: PbCompensationSummary;
}
/**
 * 
 * @export
 * @interface PbOriginalPaymentMethodRefund
 */
export interface PbOriginalPaymentMethodRefund {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbOriginalPaymentMethodRefund
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbOriginalPaymentMethodRefund
     */
    'created_at'?: string;
}
/**
 * Own platform endpoints
 * @export
 * @interface PbOwnPlatformEndpoints
 */
export interface PbOwnPlatformEndpoints {
    /**
     * completeReturn endpoint
     * @type {string}
     * @memberof PbOwnPlatformEndpoints
     */
    'complete_return'?: string;
    /**
     * createOrder endpoint
     * @type {string}
     * @memberof PbOwnPlatformEndpoints
     */
    'create_order'?: string;
    /**
     * createPromocode endpoint
     * @type {string}
     * @memberof PbOwnPlatformEndpoints
     */
    'create_promocode'?: string;
    /**
     * deletePromocode endpoint
     * @type {string}
     * @memberof PbOwnPlatformEndpoints
     */
    'delete_promocode'?: string;
    /**
     * getOrder endpoint
     * @type {string}
     * @memberof PbOwnPlatformEndpoints
     */
    'get_order'?: string;
}
/**
 * Own platform settings
 * @export
 * @interface PbOwnPlatformSettings
 */
export interface PbOwnPlatformSettings {
    /**
     * Api key
     * @type {string}
     * @memberof PbOwnPlatformSettings
     */
    'api_key'?: string;
    /**
     * Own platform endpoints
     * @type {PbOwnPlatformEndpoints}
     * @memberof PbOwnPlatformSettings
     */
    'endpoints'?: PbOwnPlatformEndpoints;
    /**
     * Header key
     * @type {string}
     * @memberof PbOwnPlatformSettings
     */
    'header_key'?: string;
    /**
     * OPM settings
     * @type {PbGenericOPMSettings}
     * @memberof PbOwnPlatformSettings
     */
    'opm_settings'?: PbGenericOPMSettings;
    /**
     * What version of the custom platform is this (for now only 1)
     * @type {string}
     * @memberof PbOwnPlatformSettings
     */
    'version'?: string;
}
/**
 * PANewSettings defines the structure of a new setting
 * @export
 * @interface PbPANewSetting
 */
export interface PbPANewSetting {
    /**
     * A string containing the new setting default
     * @type {string}
     * @memberof PbPANewSetting
     */
    'default_value'?: string;
    /**
     * A string containing the new setting name
     * @type {string}
     * @memberof PbPANewSetting
     */
    'name'?: string;
}
/**
 * PASection contains the settings for a section
 * @export
 * @interface PbPASection
 */
export interface PbPASection {
    /**
     * The section id
     * @type {string}
     * @memberof PbPASection
     */
    'id'?: string;
    /**
     * The section settings
     * @type {{ [key: string]: string; }}
     * @memberof PbPASection
     */
    'settings'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface PbPagination
 */
export interface PbPagination {
    /**
     * 
     * @type {number}
     * @memberof PbPagination
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PbPagination
     */
    'page_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof PbPagination
     */
    'total_pages'?: number;
}
/**
 * Param
 * @export
 * @interface PbParam
 */
export interface PbParam {
    /**
     * Name of the param
     * @type {string}
     * @memberof PbParam
     */
    'name'?: string;
    /**
     * Type of the param
     * @type {string}
     * @memberof PbParam
     */
    'type'?: string;
}
/**
 * PartnerConnection is a partner account (Sendcloud, Amphora...) a group has connected.
 * @export
 * @interface PbPartnerConnection
 */
export interface PbPartnerConnection {
    /**
     * Ecommerce group the account belongs to.
     * @type {string}
     * @memberof PbPartnerConnection
     */
    'group'?: string;
    /**
     * Connection id, assigned on create.
     * @type {string}
     * @memberof PbPartnerConnection
     */
    'id'?: string;
    /**
     * Partner the account is with, e.g. \"sendcloud\".
     * @type {string}
     * @memberof PbPartnerConnection
     */
    'partner'?: string;
    /**
     * Declared settings of the partner; secret values read back masked.
     * @type {{ [key: string]: string; }}
     * @memberof PbPartnerConnection
     */
    'settings'?: { [key: string]: string; };
}
/**
 * Branding patch request. Only the attributes present are written, the rest are  left as stored.
 * @export
 * @interface PbPatchBrandingReq
 */
export interface PbPatchBrandingReq {
    /**
     * Portal background image url.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'background_image_url'?: string;
    /**
     * Text color used on top of the background image.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'background_text_color'?: string;
    /**
     * Border radius of portal buttons and inputs, as a CSS length.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'border_radius'?: string;
    /**
     * The e-commerce whose branding is patched. Required.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'ecommerce_id'?: string;
    /**
     * Portal favicon image url.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'favicon_url'?: string;
    /**
     * Aspect ratio of the product images in the full catalog exchange grid.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'full_catalog_product_image_ratio'?: string;
    /**
     * Style of the portal inputs, OUTLINED or STANDARD.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'input_variant'?: string;
    /**
     * Layout design of the portal.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'layout_design_values'?: PbPatchBrandingReqLayoutDesignValuesEnum;
    /**
     * Logo height on desktop, as a CSS length.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'logo_height_desktop'?: string;
    /**
     * Logo height on mobile, as a CSS length.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'logo_height_mobile'?: string;
    /**
     * Portal logo image url.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'logo_url'?: string;
    /**
     * Logo image url used in the e-commerce emails.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'mail_logo_url'?: string;
    /**
     * Main color used in the e-commerce emails.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'mail_main_color'?: string;
    /**
     * Whether the logo stays visible while the shopper scrolls.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'persistent_logo_type'?: PbPatchBrandingReqPersistentLogoTypeEnum;
    /**
     * Primary brand color. Its four variants are always written together.
     * @type {PbThemeColor}
     * @memberof PbPatchBrandingReq
     */
    'primary'?: PbThemeColor;
    /**
     * Secondary brand color. Its four variants are always written together.
     * @type {PbThemeColor}
     * @memberof PbPatchBrandingReq
     */
    'secondary'?: PbThemeColor;
    /**
     * Slogan shown next to the portal title.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'slogan'?: string;
    /**
     * Portal page title.
     * @type {string}
     * @memberof PbPatchBrandingReq
     */
    'title'?: string;
}

export const PbPatchBrandingReqLayoutDesignValuesEnum = {
    Default: 'DEFAULT',
    Vertical: 'VERTICAL',
    Simplified: 'SIMPLIFIED'
} as const;

export type PbPatchBrandingReqLayoutDesignValuesEnum = typeof PbPatchBrandingReqLayoutDesignValuesEnum[keyof typeof PbPatchBrandingReqLayoutDesignValuesEnum];
export const PbPatchBrandingReqPersistentLogoTypeEnum = {
    Unspecified: 'PERSISTENT_LOGO_TYPE_UNSPECIFIED',
    Enabled: 'PERSISTENT_LOGO_TYPE_ENABLED',
    Disabled: 'PERSISTENT_LOGO_TYPE_DISABLED'
} as const;

export type PbPatchBrandingReqPersistentLogoTypeEnum = typeof PbPatchBrandingReqPersistentLogoTypeEnum[keyof typeof PbPatchBrandingReqPersistentLogoTypeEnum];

/**
 * ReturnConditions patch request. Only the fields present in the request are  written; an absent field leaves the stored value untouched. Which attributes a  caller may set depends on the endpoint it calls.
 * @export
 * @interface PbPatchReturnProcessConditionsReq
 */
export interface PbPatchReturnProcessConditionsReq {
    /**
     * The e-commerce whose return conditions are patched. Required.
     * @type {string}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'ecommerce_id'?: string;
    /**
     * Rules deciding when the customer keeps the item instead of returning it.
     * @type {PbKeepYourItem}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'keep_your_item'?: PbKeepYourItem;
    /**
     * Deprecated: replaced by the per-reason NewReturnReason.mandatory_comment.  No handler reads it any more; kept for wire compatibility.
     * @type {boolean}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'mandatory_return_comment'?: boolean;
    /**
     * Days the customer has to hand the package to the carrier.
     * @type {number}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'max_days_to_send_package'?: number;
    /**
     * Brands that cannot be returned.
     * @type {PbIdList}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'non_returnable_brand_ids'?: PbIdList;
    /**
     * Categories that cannot be returned.
     * @type {PbIdList}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'non_returnable_category_ids'?: PbIdList;
    /**
     * Collections that cannot be returned.
     * @type {PbIdList}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'non_returnable_collection_ids'?: PbIdList;
    /**
     * Order tags whose orders cannot be returned.
     * @type {PbIdList}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'non_returnable_order_tag_ids'?: PbIdList;
    /**
     * Products that cannot be returned.
     * @type {PbIdList}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'non_returnable_product_ids'?: PbIdList;
    /**
     * Product tags that cannot be returned.
     * @type {PbIdList}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'non_returnable_tag_ids'?: PbIdList;
    /**
     * Rules deciding who pays for the return logistics.
     * @type {PbPayForLogistics}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'pay_for_logistics'?: PbPayForLogistics;
    /**
     * Whether payments are enabled for this e-commerce.
     * @type {boolean}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'payments_enabled'?: boolean;
    /**
     * Whether the returns portal shows the return reasons in a random order for  each shopper.
     * @type {boolean}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'randomize_return_reasons_order'?: boolean;
    /**
     * Rules deciding when a return needs manual authorization.
     * @type {PbRequireAuthorization}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'require_authorization'?: PbRequireAuthorization;
    /**
     * Days after the purchase in which a return can still be started.
     * @type {number}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'return_period_days'?: number;
    /**
     * Days to wait after the parcel reaches the warehouse before auto-completing a  MANUAL-review process with no review. 0 disables auto-completion.
     * @type {number}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'review_auto_complete_days'?: number;
    /**
     * What the review auto-complete applies to every unreviewed unit when the window  runs out. UNSPECIFIED behaves as MISSING.
     * @type {string}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'review_auto_complete_outcome'?: PbPatchReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum;
    /**
     * How returned items are reviewed, AUTO or MANUAL.
     * @type {string}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'review_flow'?: string;
    /**
     * Whether fraud detection is skipped for this e-commerce.
     * @type {boolean}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'skip_fraud_detection'?: boolean;
    /**
     * When the return is started on the e-commerce platform.
     * @type {string}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'start_return_on_platform_time'?: PbPatchReturnProcessConditionsReqStartReturnOnPlatformTimeEnum;
    /**
     * Rules deciding when the customer must upload documents.
     * @type {PbUploadDocuments}
     * @memberof PbPatchReturnProcessConditionsReq
     */
    'upload_documents'?: PbUploadDocuments;
}

export const PbPatchReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum = {
    Unspecified: 'REVIEW_AUTO_COMPLETE_OUTCOME_UNSPECIFIED',
    Missing: 'REVIEW_AUTO_COMPLETE_OUTCOME_MISSING',
    Approved: 'REVIEW_AUTO_COMPLETE_OUTCOME_APPROVED'
} as const;

export type PbPatchReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum = typeof PbPatchReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum[keyof typeof PbPatchReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum];
export const PbPatchReturnProcessConditionsReqStartReturnOnPlatformTimeEnum = {
    Unspecified: 'START_RETURN_ON_PLATFORM_TIME_UNSPECIFIED',
    OnStart: 'START_RETURN_ON_PLATFORM_TIME_ON_START',
    OnItemVerification: 'START_RETURN_ON_PLATFORM_TIME_ON_ITEM_VERIFICATION',
    Never: 'START_RETURN_ON_PLATFORM_TIME_NEVER'
} as const;

export type PbPatchReturnProcessConditionsReqStartReturnOnPlatformTimeEnum = typeof PbPatchReturnProcessConditionsReqStartReturnOnPlatformTimeEnum[keyof typeof PbPatchReturnProcessConditionsReqStartReturnOnPlatformTimeEnum];

/**
 * Payload for updating a return process via PATCH
 * @export
 * @interface PbPatchReturnProcessRequest
 */
export interface PbPatchReturnProcessRequest {
    /**
     * Preferred. map[string]interface{} as a json string
     * @type {string}
     * @memberof PbPatchReturnProcessRequest
     */
    'patch'?: string;
    /**
     * ID of the process to be updated. Required.
     * @type {string}
     * @memberof PbPatchReturnProcessRequest
     */
    'process_id'?: string;
    /**
     * Deprecated: use patch instead
     * @type {GoogleProtobufAny}
     * @memberof PbPatchReturnProcessRequest
     */
    'return_process_patch'?: GoogleProtobufAny;
    /**
     * User doing the patch
     * @type {string}
     * @memberof PbPatchReturnProcessRequest
     */
    'user'?: string;
}
/**
 * 
 * @export
 * @interface PbPatchReturnProcessResponse
 */
export interface PbPatchReturnProcessResponse {
    /**
     * value of the field `last_known_shipping_status` after the update
     * @type {string}
     * @memberof PbPatchReturnProcessResponse
     */
    'new_last_known_shipping_status'?: PbPatchReturnProcessResponseNewLastKnownShippingStatusEnum;
    /**
     * value of the field `last_known_shipping_status` before the update
     * @type {string}
     * @memberof PbPatchReturnProcessResponse
     */
    'previous_last_known_shipping_status'?: PbPatchReturnProcessResponsePreviousLastKnownShippingStatusEnum;
}

export const PbPatchReturnProcessResponseNewLastKnownShippingStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbPatchReturnProcessResponseNewLastKnownShippingStatusEnum = typeof PbPatchReturnProcessResponseNewLastKnownShippingStatusEnum[keyof typeof PbPatchReturnProcessResponseNewLastKnownShippingStatusEnum];
export const PbPatchReturnProcessResponsePreviousLastKnownShippingStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbPatchReturnProcessResponsePreviousLastKnownShippingStatusEnum = typeof PbPatchReturnProcessResponsePreviousLastKnownShippingStatusEnum[keyof typeof PbPatchReturnProcessResponsePreviousLastKnownShippingStatusEnum];

/**
 * PayForLogistics request
 * @export
 * @interface PbPayForLogistics
 */
export interface PbPayForLogistics {
    /**
     * always
     * @type {boolean}
     * @memberof PbPayForLogistics
     */
    'always'?: boolean;
    /**
     * options
     * @type {Array<PbPayForLogisticsOption>}
     * @memberof PbPayForLogistics
     */
    'options'?: Array<PbPayForLogisticsOption>;
}
/**
 * request to know if we should pay for logistics
 * @export
 * @interface PbPayForLogisticsOption
 */
export interface PbPayForLogisticsOption {
    /**
     * when
     * @type {Array<string>}
     * @memberof PbPayForLogisticsOption
     */
    'whens'?: Array<string>;
}
/**
 * PayPalGatewaySettings is the settings for the PayPal gateway
 * @export
 * @interface PbPayPalGatewaySettings
 */
export interface PbPayPalGatewaySettings {
    /**
     * Client ID
     * @type {string}
     * @memberof PbPayPalGatewaySettings
     */
    'client_id'?: string;
    /**
     * Environment
     * @type {string}
     * @memberof PbPayPalGatewaySettings
     */
    'environment'?: PbPayPalGatewaySettingsEnvironmentEnum;
    /**
     * Is active
     * @type {boolean}
     * @memberof PbPayPalGatewaySettings
     */
    'is_active'?: boolean;
    /**
     * Secret key
     * @type {string}
     * @memberof PbPayPalGatewaySettings
     */
    'secret_key'?: string;
}

export const PbPayPalGatewaySettingsEnvironmentEnum = {
    Unspecified: 'ENVIRONMENT_UNSPECIFIED',
    Production: 'ENVIRONMENT_PRODUCTION',
    Development: 'ENVIRONMENT_DEVELOPMENT',
    Sandbox: 'ENVIRONMENT_SANDBOX'
} as const;

export type PbPayPalGatewaySettingsEnvironmentEnum = typeof PbPayPalGatewaySettingsEnvironmentEnum[keyof typeof PbPayPalGatewaySettingsEnvironmentEnum];

/**
 * Payment keeps the data for the payment method used to pay an order
 * @export
 * @interface PbPayment
 */
export interface PbPayment {
    /**
     * gateway used to pay the order
     * @type {string}
     * @memberof PbPayment
     */
    'gateway'?: string;
}
/**
 * PaymentMethodConfig
 * @export
 * @interface PbPaymentMethodConfig
 */
export interface PbPaymentMethodConfig {
    /**
     * Name
     * @type {string}
     * @memberof PbPaymentMethodConfig
     */
    'name'?: string;
    /**
     * Timing
     * @type {string}
     * @memberof PbPaymentMethodConfig
     */
    'timing'?: string;
    /**
     * Whens
     * @type {Array<string>}
     * @memberof PbPaymentMethodConfig
     */
    'whens'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PbPaypalCredentials
 */
export interface PbPaypalCredentials {
    /**
     * Client ID
     * @type {string}
     * @memberof PbPaypalCredentials
     */
    'client_id'?: string;
    /**
     * Is active
     * @type {boolean}
     * @memberof PbPaypalCredentials
     */
    'is_active'?: boolean;
    /**
     * Secret ID
     * @type {string}
     * @memberof PbPaypalCredentials
     */
    'secret_id'?: string;
}
/**
 * PlatformTransaction is a money movement on the order as reported by the e-commerce platform.
 * @export
 * @interface PbPlatformTransaction
 */
export interface PbPlatformTransaction {
    /**
     * Positive amount in MoneyFormat minor units of currency.
     * @type {string}
     * @memberof PbPlatformTransaction
     */
    'amount'?: string;
    /**
     * ISO 4217 currency of the amount.
     * @type {string}
     * @memberof PbPlatformTransaction
     */
    'currency'?: string;
    /**
     * Payment gateway that processed the movement.
     * @type {string}
     * @memberof PbPlatformTransaction
     */
    'gateway'?: string;
    /**
     * Platform transaction id.
     * @type {string}
     * @memberof PbPlatformTransaction
     */
    'id'?: string;
    /**
     * Kind of movement.
     * @type {string}
     * @memberof PbPlatformTransaction
     */
    'kind'?: PbPlatformTransactionKindEnum;
    /**
     * Whether the movement completed successfully. Pending or failed movements do not change what is  refundable.
     * @type {boolean}
     * @memberof PbPlatformTransaction
     */
    'successful'?: boolean;
}

export const PbPlatformTransactionKindEnum = {
    Unspecified: 'PLATFORM_TRANSACTION_KIND_UNSPECIFIED',
    Capture: 'PLATFORM_TRANSACTION_KIND_CAPTURE',
    Refund: 'PLATFORM_TRANSACTION_KIND_REFUND'
} as const;

export type PbPlatformTransactionKindEnum = typeof PbPlatformTransactionKindEnum[keyof typeof PbPlatformTransactionKindEnum];

/**
 * PortalSettings model
 * @export
 * @interface PbPortalSettings
 */
export interface PbPortalSettings {
    /**
     * Branding
     * @type {PbBranding}
     * @memberof PbPortalSettings
     */
    'branding'?: PbBranding;
    /**
     * group_id of the ecommerce
     * @type {string}
     * @memberof PbPortalSettings
     */
    'ecommerce_group'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbPortalSettings
     */
    'ecommerce_id'?: string;
    /**
     * exchange_flow
     * @type {string}
     * @memberof PbPortalSettings
     */
    'exchange_flow'?: PbPortalSettingsExchangeFlowEnum;
    /**
     * external return policy url
     * @type {string}
     * @memberof PbPortalSettings
     */
    'external_return_policy_url'?: string;
    /**
     * How shoppers identify their orders
     * @type {string}
     * @memberof PbPortalSettings
     */
    'identification_flow'?: PbPortalSettingsIdentificationFlowEnum;
    /**
     * InStore settings
     * @type {PbInStoreSettings}
     * @memberof PbPortalSettings
     */
    'in_store_settings'?: PbInStoreSettings;
    /**
     * is_enabled
     * @type {boolean}
     * @memberof PbPortalSettings
     */
    'is_enabled'?: boolean;
    /**
     * is testing
     * @type {boolean}
     * @memberof PbPortalSettings
     */
    'is_testing'?: boolean;
    /**
     * Deprecated: the requirement is per reason now; read  EcommerceReturnReason.mandatory_comment from FindItemReturnReasons instead.
     * @type {boolean}
     * @memberof PbPortalSettings
     */
    'mandatory_return_comment'?: boolean;
    /**
     * Name of the ecommerce
     * @type {string}
     * @memberof PbPortalSettings
     */
    'name'?: string;
    /**
     * Whether the return reasons are shown in a random order for each shopper
     * @type {boolean}
     * @memberof PbPortalSettings
     */
    'randomize_return_reasons_order'?: boolean;
    /**
     * slug of the ecommerce
     * @type {string}
     * @memberof PbPortalSettings
     */
    'slug'?: string;
    /**
     * store_list_url
     * @type {string}
     * @memberof PbPortalSettings
     */
    'store_list_url'?: string;
    /**
     * Specifies the use case of ecommerce
     * @type {string}
     * @memberof PbPortalSettings
     */
    'use_case'?: PbPortalSettingsUseCaseEnum;
    /**
     * website_url
     * @type {string}
     * @memberof PbPortalSettings
     */
    'website_url'?: string;
    /**
     * Whether the portal shows the EU withdrawal form at /:slug/withdrawal
     * @type {boolean}
     * @memberof PbPortalSettings
     */
    'withdrawal_enabled'?: boolean;
}

export const PbPortalSettingsExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type PbPortalSettingsExchangeFlowEnum = typeof PbPortalSettingsExchangeFlowEnum[keyof typeof PbPortalSettingsExchangeFlowEnum];
export const PbPortalSettingsIdentificationFlowEnum = {
    IdentificationFlowUnspecified: 'IDENTIFICATION_FLOW_UNSPECIFIED',
    OrderIdAndEmail: 'ORDER_ID_AND_EMAIL',
    OrderIdAndPostalCode: 'ORDER_ID_AND_POSTAL_CODE'
} as const;

export type PbPortalSettingsIdentificationFlowEnum = typeof PbPortalSettingsIdentificationFlowEnum[keyof typeof PbPortalSettingsIdentificationFlowEnum];
export const PbPortalSettingsUseCaseEnum = {
    Unspecified: 'USE_CASE_UNSPECIFIED',
    Standard: 'USE_CASE_STANDARD',
    Garantia: 'USE_CASE_GARANTIA',
    Internal: 'USE_CASE_INTERNAL',
    Lite: 'USE_CASE_LITE'
} as const;

export type PbPortalSettingsUseCaseEnum = typeof PbPortalSettingsUseCaseEnum[keyof typeof PbPortalSettingsUseCaseEnum];

/**
 * PostReturnAmountRequest is the request to post the return amount
 * @export
 * @interface PbPostReturnAmountRequest
 */
export interface PbPostReturnAmountRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbPostReturnAmountRequest
     */
    'ecommerce_id'?: string;
    /**
     * Return amount business rules
     * @type {Array<PbReturnAmountRule>}
     * @memberof PbPostReturnAmountRequest
     */
    'rules'?: Array<PbReturnAmountRule>;
}
/**
 * Represents a Prestashop module with its properties
 * @export
 * @interface PbPrestashopModule
 */
export interface PbPrestashopModule {
    /**
     * Whether the module is currently active/enabled
     * @type {boolean}
     * @memberof PbPrestashopModule
     */
    'active'?: boolean;
    /**
     * Author/developer of the module
     * @type {string}
     * @memberof PbPrestashopModule
     */
    'author'?: string;
    /**
     * Description of the module\'s functionality
     * @type {string}
     * @memberof PbPrestashopModule
     */
    'description'?: string;
    /**
     * Display name shown in the admin interface
     * @type {string}
     * @memberof PbPrestashopModule
     */
    'display_name'?: string;
    /**
     * Technical name/identifier of the module
     * @type {string}
     * @memberof PbPrestashopModule
     */
    'name'?: string;
    /**
     * Version number of the module
     * @type {string}
     * @memberof PbPrestashopModule
     */
    'version'?: string;
}
/**
 * Specific settings for an e-commerce using the Prestashop platform
 * @export
 * @interface PbPrestashopSettings
 */
export interface PbPrestashopSettings {
    /**
     * URL of the admin panel
     * @type {string}
     * @memberof PbPrestashopSettings
     */
    'admin_url'?: string;
    /**
     * Base URL of the API to communicate with the e-commerce
     * @type {string}
     * @memberof PbPrestashopSettings
     */
    'api_base_url'?: string;
    /**
     * api key
     * @type {string}
     * @memberof PbPrestashopSettings
     */
    'api_key'?: string;
    /**
     * Installation path of the REVER Prestashop module
     * @type {string}
     * @memberof PbPrestashopSettings
     */
    'api_module_path'?: string;
    /**
     * State of the connection to the store. Only the PrestaShop link and  deactivate RPCs write it; SaveCredentials keeps the stored value.
     * @type {string}
     * @memberof PbPrestashopSettings
     */
    'connection_status'?: PbPrestashopSettingsConnectionStatusEnum;
    /**
     * Module installation connected to this e-commerce. Empty for e-commerces  connected before the module onboarding flow. Only the PrestaShop link and  deactivate RPCs write it; SaveCredentials keeps the stored value.
     * @type {string}
     * @memberof PbPrestashopSettings
     */
    'registration_id'?: string;
    /**
     * whether authentication with Prestashop is done with query string  or using the header. Default: false (header)
     * @type {boolean}
     * @memberof PbPrestashopSettings
     */
    'use_query_string_auth'?: boolean;
}

export const PbPrestashopSettingsConnectionStatusEnum = {
    Unspecified: 'PRESTASHOP_CONNECTION_STATUS_UNSPECIFIED',
    Legacy: 'PRESTASHOP_CONNECTION_STATUS_LEGACY',
    Active: 'PRESTASHOP_CONNECTION_STATUS_ACTIVE',
    Inactive: 'PRESTASHOP_CONNECTION_STATUS_INACTIVE'
} as const;

export type PbPrestashopSettingsConnectionStatusEnum = typeof PbPrestashopSettingsConnectionStatusEnum[keyof typeof PbPrestashopSettingsConnectionStatusEnum];

/**
 * PreviewDynamicWarehouseRequest evaluates an inline (unsaved) warehouse config  against a real order. The order is fetched from ecommerce-api using the  order_number and customer email.
 * @export
 * @interface PbPreviewDynamicWarehouseRequest
 */
export interface PbPreviewDynamicWarehouseRequest {
    /**
     * Inline (unsaved) warehouse config to evaluate.
     * @type {PbWarehouseConfig}
     * @memberof PbPreviewDynamicWarehouseRequest
     */
    'config'?: PbWarehouseConfig;
    /**
     * Ecommerce id. Required.
     * @type {string}
     * @memberof PbPreviewDynamicWarehouseRequest
     */
    'ecommerce_id'?: string;
    /**
     * Customer email. Required.
     * @type {string}
     * @memberof PbPreviewDynamicWarehouseRequest
     */
    'email'?: string;
    /**
     * Preferred customer language (ISO 639-1 code like \"en\", \"es\"). Optional.
     * @type {string}
     * @memberof PbPreviewDynamicWarehouseRequest
     */
    'lang'?: string;
    /**
     * Customer-printed order number. Required.
     * @type {string}
     * @memberof PbPreviewDynamicWarehouseRequest
     */
    'order_number'?: string;
    /**
     * Return method to evaluate the rules against.
     * @type {string}
     * @memberof PbPreviewDynamicWarehouseRequest
     */
    'return_method'?: PbPreviewDynamicWarehouseRequestReturnMethodEnum;
}

export const PbPreviewDynamicWarehouseRequestReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type PbPreviewDynamicWarehouseRequestReturnMethodEnum = typeof PbPreviewDynamicWarehouseRequestReturnMethodEnum[keyof typeof PbPreviewDynamicWarehouseRequestReturnMethodEnum];

/**
 * PreviewDynamicWarehouseResponse returns the warehouse id that would be  selected for this order and config in production, or empty if no rule matched.
 * @export
 * @interface PbPreviewDynamicWarehouseResponse
 */
export interface PbPreviewDynamicWarehouseResponse {
    /**
     * Warehouse id selected by the rules, empty when no rule matched.
     * @type {string}
     * @memberof PbPreviewDynamicWarehouseResponse
     */
    'matched_warehouse_id'?: string;
}
/**
 * PreviousOPMExecution represents an OPM refund already executed on a sibling return process  for the same order. Used to reconstruct cumulative refund history for stateful payment gateways.
 * @export
 * @interface PbPreviousOPMExecution
 */
export interface PbPreviousOPMExecution {
    /**
     * Refunded amount in REVER money format (minor units, no decimals)
     * @type {string}
     * @memberof PbPreviousOPMExecution
     */
    'amount'?: string;
    /**
     * ISO 4217 currency code of the refunded amount
     * @type {string}
     * @memberof PbPreviousOPMExecution
     */
    'currency'?: string;
    /**
     * REVER process ID of the sibling return process
     * @type {string}
     * @memberof PbPreviousOPMExecution
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface PbPreviousOrderReturnProcess
 */
export interface PbPreviousOrderReturnProcess {
    /**
     * Return process ID from the REVER platform
     * @type {string}
     * @memberof PbPreviousOrderReturnProcess
     */
    'process_id'?: string;
    /**
     * Return process ID from the ecommerce platform
     * @type {string}
     * @memberof PbPreviousOrderReturnProcess
     */
    'return_platform_id'?: string;
}
/**
 * ProcessActivityBucket is the count of processes started in one calendar day.
 * @export
 * @interface PbProcessActivityBucket
 */
export interface PbProcessActivityBucket {
    /**
     * Start instant of the day bucket (local midnight, re-anchored to an instant).
     * @type {string}
     * @memberof PbProcessActivityBucket
     */
    'bucket_start'?: string;
    /**
     * Number of processes started in this day bucket.
     * @type {string}
     * @memberof PbProcessActivityBucket
     */
    'count'?: string;
}
/**
 * Product models any product from any e-commerce platform  Important! the alias at the end is for API docs generation  @Description A product from the e-commerce  @name api.Product
 * @export
 * @interface PbProduct
 */
export interface PbProduct {
    /**
     * Optional: product categories
     * @type {Array<PbProductCategory>}
     * @memberof PbProduct
     */
    'categories'?: Array<PbProductCategory>;
    /**
     * Optional: product collections
     * @type {Array<PbCollection>}
     * @memberof PbProduct
     */
    'collections'?: Array<PbCollection>;
    /**
     * Free-form per-unit attributes from the source platform (PrestaShop  merchant-extended columns + features, Shopware customFields, Shopify  customAttributes). Keys are platform-defined. Variant custom_attributes  (when set) override this; this acts as the parent fallback.
     * @type {object}
     * @memberof PbProduct
     */
    'custom_attributes'?: object;
    /**
     * Product description
     * @type {string}
     * @memberof PbProduct
     */
    'description'?: string;
    /**
     * Per-unit package dimensions in centimeters - the parcel/box the unit  ships in. Optional. Variant dimensions (when present) override this;  this acts as the parent fallback.
     * @type {PbDimensions}
     * @memberof PbProduct
     */
    'dimensions'?: PbDimensions;
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof PbProduct
     */
    'id'?: string;
    /**
     * Images associated to the product
     * @type {Array<PbProductImage>}
     * @memberof PbProduct
     */
    'images'?: Array<PbProductImage>;
    /**
     * format for the amounts
     * @type {ModelsMoneyFormat}
     * @memberof PbProduct
     */
    'money_format'?: ModelsMoneyFormat;
    /**
     * Product name
     * @type {string}
     * @memberof PbProduct
     */
    'name'?: string;
    /**
     * platform from where this product comes from
     * @type {string}
     * @memberof PbProduct
     */
    'platform'?: PbProductPlatformEnum;
    /**
     * price per unit (following MoneyFormat)
     * @type {string}
     * @memberof PbProduct
     */
    'price'?: string;
    /**
     * Optional: product reference
     * @type {string}
     * @memberof PbProduct
     */
    'product_reference'?: string;
    /**
     * Product short description
     * @type {string}
     * @memberof PbProduct
     */
    'short_description'?: string;
    /**
     * unique identifier of the product
     * @type {string}
     * @memberof PbProduct
     */
    'sku'?: string;
    /**
     * Optional: product tags
     * @type {Array<PbTag>}
     * @memberof PbProduct
     */
    'tags'?: Array<PbTag>;
    /**
     * Optional: product variations  if a line-item references a varition, the attributes of the variation  have to be used instead of the ones of the product
     * @type {Array<PbProductVariant>}
     * @memberof PbProduct
     */
    'variants'?: Array<PbProductVariant>;
    /**
     * Per-unit weight in grams (NOT total). Optional - zero when the platform  does not expose a product-level weight. Variant weight (when present)  overrides this; this acts as the parent fallback. Mirrors the  OrderLineItem.weight contract.
     * @type {string}
     * @memberof PbProduct
     */
    'weight'?: string;
}

export const PbProductPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type PbProductPlatformEnum = typeof PbProductPlatformEnum[keyof typeof PbProductPlatformEnum];

/**
 * 
 * @export
 * @interface PbProductAndBrand
 */
export interface PbProductAndBrand {
    /**
     * Brand
     * @type {string}
     * @memberof PbProductAndBrand
     */
    'brand_name'?: string;
    /**
     * Product
     * @type {string}
     * @memberof PbProductAndBrand
     */
    'product_id'?: string;
}
/**
 * Magento Product Attribute
 * @export
 * @interface PbProductAttribute
 */
export interface PbProductAttribute {
    /**
     * Name of the attribute
     * @type {string}
     * @memberof PbProductAttribute
     */
    'platform_code'?: string;
}
/**
 * Magento Product Attributes
 * @export
 * @interface PbProductAttributes
 */
export interface PbProductAttributes {
    /**
     * ean attribute
     * @type {PbProductAttribute}
     * @memberof PbProductAttributes
     */
    'ean'?: PbProductAttribute;
}
/**
 * 
 * @export
 * @interface PbProductCategory
 */
export interface PbProductCategory {
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof PbProductCategory
     */
    'id'?: string;
}
/**
 * Image  Alias is for API docs generation  Important! the alias at the end is for API docs generation  @Description An image from the e-commerce catalog  @name api.Image
 * @export
 * @interface PbProductImage
 */
export interface PbProductImage {
    /**
     * Image alternative text
     * @type {string}
     * @memberof PbProductImage
     */
    'alt'?: string;
    /**
     * Image name
     * @type {string}
     * @memberof PbProductImage
     */
    'name'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof PbProductImage
     */
    'src'?: string;
}
/**
 * 
 * @export
 * @interface PbProductInfo
 */
export interface PbProductInfo {
    /**
     * URL of the product image
     * @type {string}
     * @memberof PbProductInfo
     */
    'image_url'?: string;
    /**
     * ID of the product
     * @type {string}
     * @memberof PbProductInfo
     */
    'product_id'?: string;
    /**
     * Name of the product
     * @type {string}
     * @memberof PbProductInfo
     */
    'product_name'?: string;
    /**
     * SKU code of the variant
     * @type {string}
     * @memberof PbProductInfo
     */
    'sku'?: string;
    /**
     * EAN code of the variant
     * @type {string}
     * @memberof PbProductInfo
     */
    'variant_ean'?: string;
    /**
     * ID of the variant
     * @type {string}
     * @memberof PbProductInfo
     */
    'variant_id'?: string;
    /**
     * Name of the variant
     * @type {string}
     * @memberof PbProductInfo
     */
    'variant_name'?: string;
}
/**
 * 
 * @export
 * @interface PbProductOption
 */
export interface PbProductOption {
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof PbProductOption
     */
    'id'?: string;
    /**
     * Name of the option
     * @type {string}
     * @memberof PbProductOption
     */
    'name'?: string;
    /**
     * Value of the option
     * @type {string}
     * @memberof PbProductOption
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface PbProductVariant
 */
export interface PbProductVariant {
    /**
     * barcode for product
     * @type {string}
     * @memberof PbProductVariant
     */
    'barcode'?: string;
    /**
     * Free-form per-unit attributes from the source platform. When set,  overrides the parent Product.custom_attributes for line items pointing  at this variant.
     * @type {object}
     * @memberof PbProductVariant
     */
    'custom_attributes'?: object;
    /**
     * Variant description
     * @type {string}
     * @memberof PbProductVariant
     */
    'description'?: string;
    /**
     * Per-unit package dimensions in centimeters. When present, overrides the  parent Product.dimensions for line items pointing at this variant.
     * @type {PbDimensions}
     * @memberof PbProductVariant
     */
    'dimensions'?: PbDimensions;
    /**
     * EAN code for product
     * @type {string}
     * @memberof PbProductVariant
     */
    'ean'?: string;
    /**
     * enabled or disabled
     * @type {boolean}
     * @memberof PbProductVariant
     */
    'enabled'?: boolean;
    /**
     * Unique identifier for the resource in the source platform
     * @type {string}
     * @memberof PbProductVariant
     */
    'id'?: string;
    /**
     * Images associated to the variant
     * @type {Array<PbProductImage>}
     * @memberof PbProductVariant
     */
    'images'?: Array<PbProductImage>;
    /**
     * inventory quantity (only check if inventory_enabled is true)
     * @type {string}
     * @memberof PbProductVariant
     */
    'inventory_quantity'?: string;
    /**
     * should be checked before checking quantity
     * @type {boolean}
     * @memberof PbProductVariant
     */
    'is_inventory_enabled'?: boolean;
    /**
     * Name of the variant
     * @type {string}
     * @memberof PbProductVariant
     */
    'name'?: string;
    /**
     * The list of options that conforms this variant
     * @type {Array<PbProductOption>}
     * @memberof PbProductVariant
     */
    'options'?: Array<PbProductOption>;
    /**
     * unit price
     * @type {string}
     * @memberof PbProductVariant
     */
    'price'?: string;
    /**
     * Variant short description
     * @type {string}
     * @memberof PbProductVariant
     */
    'short_description'?: string;
    /**
     * unique identifier of the product
     * @type {string}
     * @memberof PbProductVariant
     */
    'sku'?: string;
    /**
     * Per-unit weight in grams (NOT total). When present, overrides the parent  Product.weight for line items pointing at this variant.
     * @type {string}
     * @memberof PbProductVariant
     */
    'weight'?: string;
}
/**
 * 
 * @export
 * @interface PbPromocode
 */
export interface PbPromocode {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbPromocode
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {string}
     * @memberof PbPromocode
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbPromocode
     */
    'created_at'?: string;
}
/**
 * 
 * @export
 * @interface PbPromocodeCompensation
 */
export interface PbPromocodeCompensation {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbPromocodeCompensation
     */
    'amount'?: PbMoneyBag;
    /**
     * 
     * @type {PbPromocode}
     * @memberof PbPromocodeCompensation
     */
    'promocode'?: PbPromocode;
    /**
     * 
     * @type {PbCompensationSummary}
     * @memberof PbPromocodeCompensation
     */
    'summary'?: PbCompensationSummary;
}
/**
 * TODO: this should be named Province
 * @export
 * @interface PbProvinceData
 */
export interface PbProvinceData {
    /**
     * code of the province (no standard)
     * @type {string}
     * @memberof PbProvinceData
     */
    'code'?: string;
    /**
     * name of the province
     * @type {string}
     * @memberof PbProvinceData
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface PbPublicReturnProcess
 */
export interface PbPublicReturnProcess {
    /**
     * Review flow: MANUAL or AUTO. Name kept as-is for JSON compatibility.  protolint:disable:next FIELD_NAMES_LOWER_SNAKE_CASE
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'ReviewFlow'?: string;
    /**
     * Refund action configurations.
     * @type {Array<ModelsRefundActionConfig>}
     * @memberof PbPublicReturnProcess
     */
    'action_config'?: Array<ModelsRefundActionConfig>;
    /**
     * Line items approved for return.
     * @type {Array<ModelsReturnLineItem>}
     * @memberof PbPublicReturnProcess
     */
    'approved_line_items'?: Array<ModelsReturnLineItem>;
    /**
     * Authorization status.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'authorization_status'?: string;
    /**
     * Bank account country.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'bank_account_country'?: string;
    /**
     * Amount committed to refund via bank transfer.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'bank_transfer_refund_amount'?: string;
    /**
     * BBAN basic bank account number.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'bban'?: string;
    /**
     * Deprecated: not stored in the db.
     * @type {ModelsAddress}
     * @memberof PbPublicReturnProcess
     */
    'billing_address'?: ModelsAddress;
    /**
     * When the process was canceled.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'canceled_at'?: string;
    /**
     * The name of the carrier (!= provider).
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'carrier_name'?: string;
    /**
     * Checkout id.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'checkout_id'?: string;
    /**
     * When the return was collected.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'collected_at'?: string;
    /**
     * Payment amount committed.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'committed_payment_amount'?: string;
    /**
     * When the process was completed.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'completed_at'?: string;
    /**
     * Process currency (usually the currency the order was paid in).
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'currency'?: string;
    /**
     * Money format of the process currency.
     * @type {ModelsMoneyFormat}
     * @memberof PbPublicReturnProcess
     */
    'currency_money_format'?: ModelsMoneyFormat;
    /**
     * Shop\'s default currency.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'currency_shop'?: string;
    /**
     * Customer that ordered the return.
     * @type {ModelsCustomer}
     * @memberof PbPublicReturnProcess
     */
    'customer'?: ModelsCustomer;
    /**
     * Customer printed order id, for searching/information purposes.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'customer_printed_order_id'?: string;
    /**
     * Delivery note status.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'delivery_note_status'?: string;
    /**
     * Where to drop-off this return.
     * @type {ModelsAddress}
     * @memberof PbPublicReturnProcess
     */
    'drop_off_address'?: ModelsAddress;
    /**
     * Internal Rever e-commerce id.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'ecommerce_id'?: string;
    /**
     * Exchange flow.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'exchange_flow'?: PbPublicReturnProcessExchangeFlowEnum;
    /**
     * Order number of the order created for the exchange.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'exchange_order_number'?: string;
    /**
     * Exchange rate between shop and customer amounts.
     * @type {number}
     * @memberof PbPublicReturnProcess
     */
    'exchange_rate'?: number;
    /**
     * Amount committed to exchange.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'exchange_refund_amount'?: string;
    /**
     * Address where to send the exchanged items.
     * @type {ModelsAddress}
     * @memberof PbPublicReturnProcess
     */
    'exchange_shipping_address'?: ModelsAddress;
    /**
     * Amount already executed via bank transfer.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_bank_transfer'?: string;
    /**
     * Amount already executed via exchange.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_exchange'?: string;
    /**
     * Amount already executed via gift card.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_gift'?: string;
    /**
     * Amount already executed via original payment method.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_original_pm'?: string;
    /**
     * Payment amount already executed.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_payment_amount'?: string;
    /**
     * Amount already executed via promo code.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_promocode'?: string;
    /**
     * Total amount already executed.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'executed_total'?: string;
    /**
     * Fraud model group.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'fraud_model_group'?: string;
    /**
     * Fraud model outcome.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'fraud_model_outcome'?: string;
    /**
     * Fraud model score.
     * @type {number}
     * @memberof PbPublicReturnProcess
     */
    'fraud_model_score'?: number;
    /**
     * Whether the process has been fully refunded.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'fully_refunded'?: boolean;
    /**
     * Whether all items have been returned.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'fully_returned'?: boolean;
    /**
     * Amount committed to refund via gift card.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'gift_refund_amount'?: string;
    /**
     * Group.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'group'?: string;
    /**
     * True when a running workflow of the process is on hold, even if the  stored status is not ON_HOLD. Only computed for REVER staff tooling that  opts in; false otherwise.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'has_open_on_hold'?: boolean;
    /**
     * IBAN.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'iban'?: string;
    /**
     * Address where items are picked up from the store (IN_STORE logistics).
     * @type {ModelsAddress}
     * @memberof PbPublicReturnProcess
     */
    'in_store_pickup_address'?: ModelsAddress;
    /**
     * When the return arrived at the warehouse.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'in_warehouse_at'?: string;
    /**
     * Internal comments (only REVER should see them).
     * @type {Array<ModelsComment>}
     * @memberof PbPublicReturnProcess
     */
    'internal_comments'?: Array<ModelsComment>;
    /**
     * True when the return is, was, or will be a WFP (REVER COVER) claim: a  wfp_claim row exists, or the return is claim-shaped on a WFP-covered order  and its Seel submission is still deferred or in flight.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'is_claim'?: boolean;
    /**
     * Whether the process is lite.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'is_lite'?: boolean;
    /**
     * Whether the return process is a test one.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'is_testing'?: boolean;
    /**
     * Keep your item type.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'keep_your_item_type'?: string;
    /**
     * Last communicated status of the shipping.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'last_known_shipping_status'?: PbPublicReturnProcessLastKnownShippingStatusEnum;
    /**
     * Return line items + balance lines (e.g. shipping cost).
     * @type {Array<ModelsReturnLineItem>}
     * @memberof PbPublicReturnProcess
     */
    'line_items'?: Array<ModelsReturnLineItem>;
    /**
     * Logistic order id.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'logistic_order_id'?: string;
    /**
     * Derived logistics status. Mirrors the logistics_status filter.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'logistics_status'?: PbPublicReturnProcessLogisticsStatusEnum;
    /**
     * Arbitrary JSON metadata associated with the return process.
     * @type {object}
     * @memberof PbPublicReturnProcess
     */
    'metadata'?: object;
    /**
     * Order id in the source platform.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'order_id'?: string;
    /**
     * When the order was purchased.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'order_purchased_at'?: string;
    /**
     * Amount committed to refund via original payment method.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'original_pm_refund_amount'?: string;
    /**
     * Refund method configurations.
     * @type {Array<ModelsRefundPaymentMethodConfig>}
     * @memberof PbPublicReturnProcess
     */
    'payment_method_config'?: Array<ModelsRefundPaymentMethodConfig>;
    /**
     * Amount pending via bank transfer.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'pending_bank_transfer'?: string;
    /**
     * Total amount pending.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'pending_total'?: string;
    /**
     * Where to pick-up this return.
     * @type {ModelsAddress}
     * @memberof PbPublicReturnProcess
     */
    'pickup_address'?: ModelsAddress;
    /**
     * Pickup ranges for delivering the returns.
     * @type {Array<string>}
     * @memberof PbPublicReturnProcess
     */
    'pickup_ranges'?: Array<PbPublicReturnProcessPickupRangesEnum>;
    /**
     * Platform from where this order was retrieved.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'platform'?: PbPublicReturnProcessPlatformEnum;
    /**
     * Id of the return process in the source platform.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'platform_process_id'?: string;
    /**
     * --- Inlined models.ReturnProcess fields (flat, like the legacy find) ---  Unique ID of the return process.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'process_id'?: string;
    /**
     * Amount committed to refund via promo code.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'promocode_refund_amount'?: string;
    /**
     * Derived refund status. Mirrors the refund_status filter.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'refund_status'?: PbPublicReturnProcessRefundStatusEnum;
    /**
     * When the refund/exchange transactions will be executed.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'refund_timing'?: PbPublicReturnProcessRefundTimingEnum;
    /**
     * Refund transactions in their public form.
     * @type {Array<PbPublicTransaction>}
     * @memberof PbPublicReturnProcess
     */
    'refund_transactions'?: Array<PbPublicTransaction>;
    /**
     * When the process became fully refunded.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'refunded_at'?: string;
    /**
     * Where to return this return process.
     * @type {ModelsAddress}
     * @memberof PbPublicReturnProcess
     */
    'return_address'?: ModelsAddress;
    /**
     * Return method.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'return_method'?: PbPublicReturnProcessReturnMethodEnum;
    /**
     * Aggregated return status of the process.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'return_status'?: string;
    /**
     * When the process became fully returned.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'returned_at'?: string;
    /**
     * Total returned amount.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'returned_total'?: string;
    /**
     * Amount committed to be returned.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'returns_committed'?: string;
    /**
     * Amount pending to be returned.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'returns_pending'?: string;
    /**
     * Whether a review is available for the process.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'review_available'?: boolean;
    /**
     * Timing for starting a return on the ecommerce platform.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'start_return_on_platform_time'?: PbPublicReturnProcessStartReturnOnPlatformTimeEnum;
    /**
     * When the process was started.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'started_at'?: string;
    /**
     * Current technical status of the process.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'status'?: PbPublicReturnProcessStatusEnum;
    /**
     * SWIFT for international account numbers.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'swift'?: string;
    /**
     * Total amount committed to refund.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'total_refund_amount'?: string;
    /**
     * Tracking ID of the return shipment.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'tracking_id'?: string;
    /**
     * Tracking URL of the return shipment.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'tracking_url'?: string;
    /**
     * Transactions associated to the return process.
     * @type {Array<ModelsTransaction>}
     * @memberof PbPublicReturnProcess
     */
    'transactions'?: Array<ModelsTransaction>;
    /**
     * Whether uploading documents is enabled.
     * @type {boolean}
     * @memberof PbPublicReturnProcess
     */
    'upload_documents_enabled'?: boolean;
    /**
     * Language the user selected for the return process (e.g. \"es\", \"en-GB\").
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'user_preferred_lang'?: string;
    /**
     * Carrier the user selected (NONE or a specific one).
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'user_selected_carrier'?: string;
    /**
     * Logistics provider the user selected (NONE, OPS, SendCloud, ...).
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'user_selected_provider'?: string;
    /**
     * Warehouse details resolved from settings-api by warehouse_id. Null when  the warehouse is unknown or could not be resolved.
     * @type {PbWarehouseInfo}
     * @memberof PbPublicReturnProcess
     */
    'warehouse'?: PbWarehouseInfo;
    /**
     * Warehouse id.
     * @type {string}
     * @memberof PbPublicReturnProcess
     */
    'warehouse_id'?: string;
}

export const PbPublicReturnProcessExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type PbPublicReturnProcessExchangeFlowEnum = typeof PbPublicReturnProcessExchangeFlowEnum[keyof typeof PbPublicReturnProcessExchangeFlowEnum];
export const PbPublicReturnProcessLastKnownShippingStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbPublicReturnProcessLastKnownShippingStatusEnum = typeof PbPublicReturnProcessLastKnownShippingStatusEnum[keyof typeof PbPublicReturnProcessLastKnownShippingStatusEnum];
export const PbPublicReturnProcessLogisticsStatusEnum = {
    Unspecified: 'LOGISTICS_STATUS_UNSPECIFIED',
    Na: 'LOGISTICS_STATUS_NA',
    LabelPending: 'LOGISTICS_STATUS_LABEL_PENDING',
    Created: 'LOGISTICS_STATUS_CREATED',
    Collected: 'LOGISTICS_STATUS_COLLECTED',
    Warehouse: 'LOGISTICS_STATUS_WAREHOUSE'
} as const;

export type PbPublicReturnProcessLogisticsStatusEnum = typeof PbPublicReturnProcessLogisticsStatusEnum[keyof typeof PbPublicReturnProcessLogisticsStatusEnum];
export const PbPublicReturnProcessPickupRangesEnum = {
    NoRange: 'NO_RANGE',
    Range8To12: 'RANGE_8_TO_12',
    Range12To16: 'RANGE_12_TO_16',
    Range16To20: 'RANGE_16_TO_20'
} as const;

export type PbPublicReturnProcessPickupRangesEnum = typeof PbPublicReturnProcessPickupRangesEnum[keyof typeof PbPublicReturnProcessPickupRangesEnum];
export const PbPublicReturnProcessPlatformEnum = {
    Mock: 'MOCK',
    Woocommerce: 'WOOCOMMERCE',
    Shopify: 'SHOPIFY',
    CustomGeneric: 'CUSTOM_GENERIC',
    Prestashop: 'PRESTASHOP',
    MagentoV1: 'MAGENTO_V1',
    MagentoV2: 'MAGENTO_V2',
    Salesforce: 'SALESFORCE',
    Inditex: 'INDITEX',
    Shopware: 'SHOPWARE',
    CustomIntegrationV2: 'CUSTOM_INTEGRATION_V2',
    Commercelayer: 'COMMERCELAYER'
} as const;

export type PbPublicReturnProcessPlatformEnum = typeof PbPublicReturnProcessPlatformEnum[keyof typeof PbPublicReturnProcessPlatformEnum];
export const PbPublicReturnProcessRefundStatusEnum = {
    Unspecified: 'REFUND_STATUS_UNSPECIFIED',
    Na: 'REFUND_STATUS_NA',
    Pending: 'REFUND_STATUS_PENDING',
    Processing: 'REFUND_STATUS_PROCESSING',
    Completed: 'REFUND_STATUS_COMPLETED'
} as const;

export type PbPublicReturnProcessRefundStatusEnum = typeof PbPublicReturnProcessRefundStatusEnum[keyof typeof PbPublicReturnProcessRefundStatusEnum];
export const PbPublicReturnProcessRefundTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type PbPublicReturnProcessRefundTimingEnum = typeof PbPublicReturnProcessRefundTimingEnum[keyof typeof PbPublicReturnProcessRefundTimingEnum];
export const PbPublicReturnProcessReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type PbPublicReturnProcessReturnMethodEnum = typeof PbPublicReturnProcessReturnMethodEnum[keyof typeof PbPublicReturnProcessReturnMethodEnum];
export const PbPublicReturnProcessStartReturnOnPlatformTimeEnum = {
    Unspecified: 'START_RETURN_ON_PLATFORM_TIME_UNSPECIFIED',
    OnStart: 'START_RETURN_ON_PLATFORM_TIME_ON_START',
    OnItemVerification: 'START_RETURN_ON_PLATFORM_TIME_ON_ITEM_VERIFICATION',
    Never: 'START_RETURN_ON_PLATFORM_TIME_NEVER'
} as const;

export type PbPublicReturnProcessStartReturnOnPlatformTimeEnum = typeof PbPublicReturnProcessStartReturnOnPlatformTimeEnum[keyof typeof PbPublicReturnProcessStartReturnOnPlatformTimeEnum];
export const PbPublicReturnProcessStatusEnum = {
    Running: 'RUNNING',
    Failed: 'FAILED',
    Completed: 'COMPLETED',
    OnHold: 'ON_HOLD',
    ReturnStatusCanceled: 'RETURN_STATUS_CANCELED'
} as const;

export type PbPublicReturnProcessStatusEnum = typeof PbPublicReturnProcessStatusEnum[keyof typeof PbPublicReturnProcessStatusEnum];

/**
 * PublicTransaction is a transaction safe to share outside the REVER network.
 * @export
 * @interface PbPublicTransaction
 */
export interface PbPublicTransaction {
    /**
     * Money format of the transaction currency.
     * @type {ModelsMoneyFormat}
     * @memberof PbPublicTransaction
     */
    'currency_money_format'?: ModelsMoneyFormat;
    /**
     * Base transaction.
     * @type {ModelsTransaction}
     * @memberof PbPublicTransaction
     */
    'transaction'?: ModelsTransaction;
}
/**
 * RDVSurplusRule for the RDV Surplus BR
 * @export
 * @interface PbRDVSurplusRule
 */
export interface PbRDVSurplusRule {
    /**
     * Surplus amount
     * @type {string}
     * @memberof PbRDVSurplusRule
     */
    'surplus_amount'?: string;
    /**
     * Surplus percentage
     * @type {number}
     * @memberof PbRDVSurplusRule
     */
    'surplus_percentage'?: number;
    /**
     * When conditions to evaluate
     * @type {Array<string>}
     * @memberof PbRDVSurplusRule
     */
    'whens'?: Array<string>;
}
/**
 * RDV surplus rules of a group or an ecommerce
 * @export
 * @interface PbRDVSurplusV2
 */
export interface PbRDVSurplusV2 {
    /**
     * Rules in order: the first whose conditions all hold applies
     * @type {Array<PbRDVSurplusRule>}
     * @memberof PbRDVSurplusV2
     */
    'rules'?: Array<PbRDVSurplusRule>;
}
/**
 * ReconcileExternalRefundsInternalRequest is the request to reconcile a return process with the  refunds executed on the platform outside REVER.
 * @export
 * @interface PbReconcileExternalRefundsInternalRequest
 */
export interface PbReconcileExternalRefundsInternalRequest {
    /**
     * Report what would be reconciled without writing anything. Use it to inspect the outcome before  applying.
     * @type {boolean}
     * @memberof PbReconcileExternalRefundsInternalRequest
     */
    'dry_run'?: boolean;
    /**
     * The ID of the return process to reconcile.
     * @type {string}
     * @memberof PbReconcileExternalRefundsInternalRequest
     */
    'process_id'?: string;
    /**
     * Deprecated: ignored. See transactions.
     * @type {Array<PbExternalRefund>}
     * @memberof PbReconcileExternalRefundsInternalRequest
     */
    'refunds'?: Array<PbExternalRefund>;
    /**
     * Deprecated: ignored. The service reads the platform itself so that the captures behind the  refundable cap and the refund lines behind the recoveries always come from one snapshot; a  caller-supplied half could disagree with the other and produce a cap deduction where a recovery  was due.
     * @type {Array<PbPlatformTransaction>}
     * @memberof PbReconcileExternalRefundsInternalRequest
     */
    'transactions'?: Array<PbPlatformTransaction>;
    /**
     * User recorded on the created transactions.
     * @type {string}
     * @memberof PbReconcileExternalRefundsInternalRequest
     */
    'user'?: string;
}
/**
 * ReconcileExternalRefundsInternalResponse reports the deductions made and the refund lines  skipped.
 * @export
 * @interface PbReconcileExternalRefundsInternalResponse
 */
export interface PbReconcileExternalRefundsInternalResponse {
    /**
     * Deduction of the shortfall between the pending refund and the amount still refundable on the  platform; absent when the pending refund fits.
     * @type {PbExternalRefundDeduction}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'cap_deduction'?: PbExternalRefundDeduction;
    /**
     * ISO 4217 currency of the process, in which every amount is expressed.
     * @type {string}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'currency'?: string;
    /**
     * True when nothing was written.
     * @type {boolean}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'dry_run'?: boolean;
    /**
     * Set when the process returns an exchange order; the cap is then measured against the root order  and REVER\'s own payments rather than against the exchange order.
     * @type {PbExchangeChainRoom}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'exchange_chain'?: PbExchangeChainRoom;
    /**
     * Deductions attributed to returned line items for money the merchant refunded.
     * @type {Array<PbExternalRefundDeduction>}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'line_item_deductions'?: Array<PbExternalRefundDeduction>;
    /**
     * Refund transactions created for money REVER had already moved on the platform without recording  it.
     * @type {Array<PbRecoveredExternalRefund>}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'recovered_refunds'?: Array<PbRecoveredExternalRefund>;
    /**
     * External refund lines not reconciled, with the reason.
     * @type {Array<PbSkippedExternalRefund>}
     * @memberof PbReconcileExternalRefundsInternalResponse
     */
    'skipped'?: Array<PbSkippedExternalRefund>;
}
/**
 * RecoveredExternalRefund is a refund transaction created for money REVER moved on the platform but  never recorded, typically because the platform acknowledged the refund after failing the request  that made it.
 * @export
 * @interface PbRecoveredExternalRefund
 */
export interface PbRecoveredExternalRefund {
    /**
     * Positive amount recovered, in MoneyFormat minor units of the process currency.
     * @type {string}
     * @memberof PbRecoveredExternalRefund
     */
    'amount'?: string;
    /**
     * Technical detail written on the created transaction\'s metadata: platform refund and  transaction ids and the platform actor.
     * @type {object}
     * @memberof PbRecoveredExternalRefund
     */
    'metadata'?: object;
    /**
     * Merchant-facing note written on the created transaction.
     * @type {string}
     * @memberof PbRecoveredExternalRefund
     */
    'note'?: string;
    /**
     * Refund payment method the money went back to.
     * @type {string}
     * @memberof PbRecoveredExternalRefund
     */
    'payment_method'?: PbRecoveredExternalRefundPaymentMethodEnum;
    /**
     * Platform id of the refund the money belongs to.
     * @type {string}
     * @memberof PbRecoveredExternalRefund
     */
    'platform_refund_id'?: string;
    /**
     * Platform id of the money movement recovered; it is the created transaction\'s platform id.
     * @type {string}
     * @memberof PbRecoveredExternalRefund
     */
    'platform_transaction_id'?: string;
    /**
     * REVER id of the created transaction; empty on a dry run.
     * @type {string}
     * @memberof PbRecoveredExternalRefund
     */
    'transaction_id'?: string;
}

export const PbRecoveredExternalRefundPaymentMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbRecoveredExternalRefundPaymentMethodEnum = typeof PbRecoveredExternalRefundPaymentMethodEnum[keyof typeof PbRecoveredExternalRefundPaymentMethodEnum];

/**
 * 
 * @export
 * @interface PbRedsysCredentials
 */
export interface PbRedsysCredentials {
    /**
     * Is active
     * @type {boolean}
     * @memberof PbRedsysCredentials
     */
    'is_active'?: boolean;
    /**
     * Merchant code
     * @type {string}
     * @memberof PbRedsysCredentials
     */
    'merchant_code'?: string;
    /**
     * Signature
     * @type {string}
     * @memberof PbRedsysCredentials
     */
    'signature'?: string;
    /**
     * Terminal
     * @type {number}
     * @memberof PbRedsysCredentials
     */
    'terminal'?: number;
}
/**
 * Configuration of what REVER can offer as counterpart for a return   (refund, exchange, etc). The word refund is used as a generic term for any  type of counterpart although it\'s not 100% accurate
 * @export
 * @interface PbRefund
 */
export interface PbRefund {
    /**
     * List of actions available for executing refunds
     * @type {Array<ModelsRefundActionConfig>}
     * @memberof PbRefund
     */
    'action_configs'?: Array<ModelsRefundActionConfig>;
    /**
     * Counterparts that can be offered for a return.  Deprecated. Use `action_configs` instead
     * @type {Array<string>}
     * @memberof PbRefund
     */
    'actions'?: Array<PbRefundActionsEnum>;
    /**
     * When true, automatic discounts on returned items are re-applied to the  exchange item when the post-exchange basket still satisfies the discount\'s  condition and the exchange item is in scope. Default: false.
     * @type {boolean}
     * @memberof PbRefund
     */
    'carry_over_automatic_discounts_on_exchanges'?: boolean;
    /**
     * As exchanges as refunds can be performed in several ways, which strategy  must be used
     * @type {string}
     * @memberof PbRefund
     */
    'exchange_flow'?: PbRefundExchangeFlowEnum;
    /**
     * List of payment methods available for executing refunds
     * @type {Array<ModelsRefundPaymentMethodConfig>}
     * @memberof PbRefund
     */
    'payment_method_configs'?: Array<ModelsRefundPaymentMethodConfig>;
    /**
     * List of payment methods available for executing refunds  Deprecated. Use `payment_method_configs` instead
     * @type {Array<string>}
     * @memberof PbRefund
     */
    'payment_methods'?: Array<PbRefundPaymentMethodsEnum>;
    /**
     * When true, partial returns that break a conditional discount\'s qualifying  condition claw back the discount on kept items. Refund capped at 0. Default: false.
     * @type {boolean}
     * @memberof PbRefund
     */
    'revoke_conditional_discounts'?: boolean;
    /**
     * Whether promocode generated must be rounded to the nearest integer or not  Default: false
     * @type {boolean}
     * @memberof PbRefund
     */
    'round_promocode'?: boolean;
    /**
     * At what point of the return workflow,  the selected refund action will be executed
     * @type {string}
     * @memberof PbRefund
     */
    'timing'?: PbRefundTimingEnum;
}

export const PbRefundActionsEnum = {
    NoAction: 'NO_ACTION',
    ToExchange: 'TO_EXCHANGE',
    ToReturn: 'TO_RETURN'
} as const;

export type PbRefundActionsEnum = typeof PbRefundActionsEnum[keyof typeof PbRefundActionsEnum];
export const PbRefundExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type PbRefundExchangeFlowEnum = typeof PbRefundExchangeFlowEnum[keyof typeof PbRefundExchangeFlowEnum];
export const PbRefundPaymentMethodsEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbRefundPaymentMethodsEnum = typeof PbRefundPaymentMethodsEnum[keyof typeof PbRefundPaymentMethodsEnum];
export const PbRefundTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type PbRefundTimingEnum = typeof PbRefundTimingEnum[keyof typeof PbRefundTimingEnum];

/**
 * RefundConditions contains the conditions for refunds
 * @export
 * @interface PbRefundConditions
 */
export interface PbRefundConditions {
    /**
     * exchange
     * @type {boolean}
     * @memberof PbRefundConditions
     */
    'exchange'?: boolean;
    /**
     * fallback bank transfer
     * @type {boolean}
     * @memberof PbRefundConditions
     */
    'fallback_bank_transfer'?: boolean;
    /**
     * refund methods
     * @type {Array<string>}
     * @memberof PbRefundConditions
     */
    'refund_methods'?: Array<PbRefundConditionsRefundMethodsEnum>;
    /**
     * timing
     * @type {string}
     * @memberof PbRefundConditions
     */
    'timing'?: PbRefundConditionsTimingEnum;
}

export const PbRefundConditionsRefundMethodsEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbRefundConditionsRefundMethodsEnum = typeof PbRefundConditionsRefundMethodsEnum[keyof typeof PbRefundConditionsRefundMethodsEnum];
export const PbRefundConditionsTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type PbRefundConditionsTimingEnum = typeof PbRefundConditionsTimingEnum[keyof typeof PbRefundConditionsTimingEnum];

/**
 * Refund configuration of a group or an ecommerce. The discount carry-over on exchanges is an exchanges setting.
 * @export
 * @interface PbRefundConfigurationV2
 */
export interface PbRefundConfigurationV2 {
    /**
     * Whether returns and exchanges are offered, and when
     * @type {Array<PbActionConfig>}
     * @memberof PbRefundConfigurationV2
     */
    'action_configs'?: Array<PbActionConfig>;
    /**
     * Refund methods offered, and when
     * @type {Array<PbPaymentMethodConfig>}
     * @memberof PbRefundConfigurationV2
     */
    'payment_method_configs'?: Array<PbPaymentMethodConfig>;
    /**
     * Revoke the conditional discounts the returned items no longer meet
     * @type {boolean}
     * @memberof PbRefundConfigurationV2
     */
    'revoke_conditional_discounts'?: boolean;
    /**
     * Round promocode amounts
     * @type {boolean}
     * @memberof PbRefundConfigurationV2
     */
    'round_promocode'?: boolean;
}
/**
 * RefundGatewaySettings is the settings for the refund gateway
 * @export
 * @interface PbRefundGatewaySettings
 */
export interface PbRefundGatewaySettings {
    /**
     * Adyen settings
     * @type {PbAdyenGatewaySettings}
     * @memberof PbRefundGatewaySettings
     */
    'adyen'?: PbAdyenGatewaySettings;
    /**
     * Axerve settings
     * @type {PbAxerveGatewaySettings}
     * @memberof PbRefundGatewaySettings
     */
    'axerve'?: PbAxerveGatewaySettings;
    /**
     * Klarna settings
     * @type {PbKlarnaGatewaySettings}
     * @memberof PbRefundGatewaySettings
     */
    'klarna'?: PbKlarnaGatewaySettings;
    /**
     * PayPal settings
     * @type {PbPayPalGatewaySettings}
     * @memberof PbRefundGatewaySettings
     */
    'paypal'?: PbPayPalGatewaySettings;
}
/**
 * 
 * @export
 * @interface PbRefundLineItem
 */
export interface PbRefundLineItem {
    /**
     * Amount of the line item, without decimals, following the  currency/money format given in the `CreateRefundRequest` struct.
     * @type {string}
     * @memberof PbRefundLineItem
     */
    'amount'?: string;
    /**
     * Line item id from the e-commerce order (not REVER)
     * @type {string}
     * @memberof PbRefundLineItem
     */
    'line_item_id'?: string;
    /**
     * Number of items being refunded. Must be > 0.
     * @type {number}
     * @memberof PbRefundLineItem
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface PbRefundOverride
 */
export interface PbRefundOverride {
    /**
     * 
     * @type {PbMoney}
     * @memberof PbRefundOverride
     */
    'amount'?: PbMoney;
    /**
     * 
     * @type {string}
     * @memberof PbRefundOverride
     */
    'reason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PbRefundOverride
     */
    'requested'?: boolean;
}
/**
 * 
 * @export
 * @interface PbRefundPlannedTransaction
 */
export interface PbRefundPlannedTransaction {
    /**
     * Amount of the transaction  in the REVER money format (implicitly without decimals)
     * @type {string}
     * @memberof PbRefundPlannedTransaction
     */
    'amount'?: string;
    /**
     * Currency of the amount
     * @type {string}
     * @memberof PbRefundPlannedTransaction
     */
    'currency'?: string;
    /**
     * JSON metadata associated with the transaction
     * @type {object}
     * @memberof PbRefundPlannedTransaction
     */
    'metadata'?: object;
    /**
     * Transaction ID in the platform of the transaction refunded.
     * @type {string}
     * @memberof PbRefundPlannedTransaction
     */
    'original_platform_transaction_id'?: string;
    /**
     * PSP provider (if any) used for the transaction
     * @type {string}
     * @memberof PbRefundPlannedTransaction
     */
    'provider'?: string;
    /**
     * REVER refund method associated to the transaction (OPM, GIFTCARD, PROMOCODE...)
     * @type {string}
     * @memberof PbRefundPlannedTransaction
     */
    'rever_refund_method'?: PbRefundPlannedTransactionReverRefundMethodEnum;
}

export const PbRefundPlannedTransactionReverRefundMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbRefundPlannedTransactionReverRefundMethodEnum = typeof PbRefundPlannedTransactionReverRefundMethodEnum[keyof typeof PbRefundPlannedTransactionReverRefundMethodEnum];

/**
 * 
 * @export
 * @interface PbRefundTransaction
 */
export interface PbRefundTransaction {
    /**
     * Amount of the transaction (might have failed, check `success` field)  in the REVER money format (implicitly without decimals)
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'amount'?: string;
    /**
     * Currency of the refunded amount
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'currency'?: string;
    /**
     * Error message in case the transaction failed
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'error_message'?: string;
    /**
     * Timestamp when the transaction was executed
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'executed_at'?: string;
    /**
     * JSON metadata associated with the Refund transaction
     * @type {object}
     * @memberof PbRefundTransaction
     */
    'metadata'?: object;
    /**
     * Transaction ID in the platform of the transaction refunded. Not all of the platforms return  this value.
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'original_platform_transaction_id'?: string;
    /**
     * Whether this transaction is pending async merchant confirmation.  When true, money has not moved yet. Success is false until confirmed.
     * @type {boolean}
     * @memberof PbRefundTransaction
     */
    'pending'?: boolean;
    /**
     * ID of the transaction in the platform or PSP
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'platform_id'?: string;
    /**
     * PSP provider (if any) used for the transaction
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'provider'?: string;
    /**
     * REVER refund method associated to the transaction (OPM, GIFTCARD, PROMOCODE...)  This is used to reclassify transactions (something that was OPM but later was GIFT_CARD)
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'rever_refund_method'?: PbRefundTransactionReverRefundMethodEnum;
    /**
     * REVER\'s own transaction id, pre-minted by ecommerce-api so it can be sent to  the merchant (e.g. batch refund) ahead of this transaction being persisted.
     * @type {string}
     * @memberof PbRefundTransaction
     */
    'rever_transaction_id'?: string;
    /**
     * Whether the transaction was successfully executed or not
     * @type {boolean}
     * @memberof PbRefundTransaction
     */
    'success'?: boolean;
}

export const PbRefundTransactionReverRefundMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbRefundTransactionReverRefundMethodEnum = typeof PbRefundTransactionReverRefundMethodEnum[keyof typeof PbRefundTransactionReverRefundMethodEnum];

/**
 * 
 * @export
 * @interface PbRefundedLineItems
 */
export interface PbRefundedLineItems {
    /**
     * line item id
     * @type {string}
     * @memberof PbRefundedLineItems
     */
    'line_item_id'?: string;
    /**
     * Item name
     * @type {string}
     * @memberof PbRefundedLineItems
     */
    'name'?: string;
    /**
     * Item price
     * @type {string}
     * @memberof PbRefundedLineItems
     */
    'price'?: string;
    /**
     * Item quantity
     * @type {string}
     * @memberof PbRefundedLineItems
     */
    'quantity'?: string;
    /**
     * Item sku
     * @type {string}
     * @memberof PbRefundedLineItems
     */
    'sku'?: string;
}
/**
 * RegisterPrestashopShopRequest is the body the PrestaShop module POSTs when  a merchant installs/configures it -- the first call of the module\'s  register/confirm/link onboarding handshake (the PrestaShop counterpart to  Shopware\'s RegisterShop). Unlike Shopware, PrestaShop has no static,  deployment-wide app secret a publicly downloadable PHP module could hold,  so this call is unauthenticated: it only reports the store, and mints a  fresh per-registration secret that authenticates every subsequent call.
 * @export
 * @interface PbRegisterPrestashopShopRequest
 */
export interface PbRegisterPrestashopShopRequest {
    /**
     * REVER module version installed on the store.
     * @type {string}
     * @memberof PbRegisterPrestashopShopRequest
     */
    'module_version'?: string;
    /**
     * PrestaShop version the store is running.
     * @type {string}
     * @memberof PbRegisterPrestashopShopRequest
     */
    'prestashop_version'?: string;
    /**
     * The store\'s own base URL, reported directly by the module (no static  \"shop-id\" concept like Shopware\'s -- one store, one registration).
     * @type {string}
     * @memberof PbRegisterPrestashopShopRequest
     */
    'store_url'?: string;
}
/**
 * RegisterPrestashopShopResponse is the body returned from  RegisterPrestashopShop.
 * @export
 * @interface PbRegisterPrestashopShopResponse
 */
export interface PbRegisterPrestashopShopResponse {
    /**
     * Identifies this handshake attempt; echoed back by the module on  ConfirmPrestashopShop and LinkPrestashopShop.
     * @type {string}
     * @memberof PbRegisterPrestashopShopResponse
     */
    'registration_id'?: string;
    /**
     * Newly minted, per-registration secret (hex-encoded random bytes), signed  on every subsequent call for this registration\'s lifetime. Deliberately  no \"proof\" field here (see message comment) and no \"confirmation_url\":  both onboarding endpoints are ours, and the module already knows the  fixed confirm path.
     * @type {string}
     * @memberof PbRegisterPrestashopShopResponse
     */
    'secret'?: string;
}
/**
 * RegisterShopResponse is the body Shopware expects back from GET /app/register.
 * @export
 * @interface PbRegisterShopResponse
 */
export interface PbRegisterShopResponse {
    /**
     * URL Shopware must POST the registration-confirmation payload to
     * @type {string}
     * @memberof PbRegisterShopResponse
     */
    'confirmation_url'?: string;
    /**
     * HMAC-SHA256 of shopID+shopURL+appName, keyed with the app\'s static secret,  hex-encoded — a different formula from the inbound signature verification.
     * @type {string}
     * @memberof PbRegisterShopResponse
     */
    'proof'?: string;
    /**
     * Newly minted, per-shop secret (hex-encoded random bytes), signed on every  subsequent call for this installation\'s lifetime.
     * @type {string}
     * @memberof PbRegisterShopResponse
     */
    'secret'?: string;
}
/**
 * ReleaseWfpRsiUsageRequest identifies the free-return reservation to release.
 * @export
 * @interface PbReleaseWfpRsiUsageRequest
 */
export interface PbReleaseWfpRsiUsageRequest {
    /**
     * Return process the free return was reserved for (wfp_rsi_usage primary key). Required.
     * @type {string}
     * @memberof PbReleaseWfpRsiUsageRequest
     */
    'return_process_id'?: string;
}
/**
 * ReleaseWfpRsiUsageResponse reports whether this call released the free return.
 * @export
 * @interface PbReleaseWfpRsiUsageResponse
 */
export interface PbReleaseWfpRsiUsageResponse {
    /**
     * True when this call deleted the reservation; false when there was none or  its return process exists.
     * @type {boolean}
     * @memberof PbReleaseWfpRsiUsageResponse
     */
    'released'?: boolean;
}
/**
 * ReplacePromocodeWithGiftcardInBulkRequest
 * @export
 * @interface PbReplacePromocodeWithGiftcardInBulkRequest
 */
export interface PbReplacePromocodeWithGiftcardInBulkRequest {
    /**
     * Ecommerces to be updated with the swap PROMO_CODE -> GIFT_CARD in their refund payment method configs.
     * @type {Array<string>}
     * @memberof PbReplacePromocodeWithGiftcardInBulkRequest
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * ReplacePromocodeWithGiftcardInBulkResponse
 * @export
 * @interface PbReplacePromocodeWithGiftcardInBulkResponse
 */
export interface PbReplacePromocodeWithGiftcardInBulkResponse {
    /**
     * One entry per ecommerce id in the request, in the same order, when the request  passes validation. Requests with duplicate ecommerce_ids are rejected with a  validation error and `results` is empty in that case.
     * @type {Array<PbReplacePromocodeWithGiftcardResult>}
     * @memberof PbReplacePromocodeWithGiftcardInBulkResponse
     */
    'results'?: Array<PbReplacePromocodeWithGiftcardResult>;
}
/**
 * ReplacePromocodeWithGiftcardResult is the per-ecommerce outcome of the bulk swap.
 * @export
 * @interface PbReplacePromocodeWithGiftcardResult
 */
export interface PbReplacePromocodeWithGiftcardResult {
    /**
     * Ecommerce id this result refers to
     * @type {string}
     * @memberof PbReplacePromocodeWithGiftcardResult
     */
    'ecommerce_id'?: string;
    /**
     * Populated when status is FAILED_VALIDATION, FAILED_INTERNAL or NOT_FOUND.
     * @type {string}
     * @memberof PbReplacePromocodeWithGiftcardResult
     */
    'error_message'?: string;
    /**
     * Outcome of the swap
     * @type {string}
     * @memberof PbReplacePromocodeWithGiftcardResult
     */
    'status'?: PbReplacePromocodeWithGiftcardResultStatusEnum;
}

export const PbReplacePromocodeWithGiftcardResultStatusEnum = {
    Unspecified: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_UNSPECIFIED',
    Replaced: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_REPLACED',
    SkippedNoPromocode: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_SKIPPED_NO_PROMOCODE',
    FailedValidation: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_FAILED_VALIDATION',
    FailedInternal: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_FAILED_INTERNAL',
    NotFound: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_NOT_FOUND',
    SkippedOpenExchangeFlow: 'REPLACE_PROMOCODE_WITH_GIFTCARD_STATUS_SKIPPED_OPEN_EXCHANGE_FLOW'
} as const;

export type PbReplacePromocodeWithGiftcardResultStatusEnum = typeof PbReplacePromocodeWithGiftcardResultStatusEnum[keyof typeof PbReplacePromocodeWithGiftcardResultStatusEnum];

/**
 * 
 * @export
 * @interface PbReportStatusItems
 */
export interface PbReportStatusItems {
    /**
     * Total amount of the item, without decimals  following the money format from `currency`  Example: 1234 -->  12,34 EUR  TODO: Important, this should be int64
     * @type {string}
     * @memberof PbReportStatusItems
     */
    'amount'?: string;
    /**
     * How the return is being compensated in REVER
     * @type {string}
     * @memberof PbReportStatusItems
     */
    'compensation_method'?: string;
    /**
     * currency associated with the `amount` field
     * @type {string}
     * @memberof PbReportStatusItems
     */
    'currency'?: string;
    /**
     * Description of the item being returned
     * @type {string}
     * @memberof PbReportStatusItems
     */
    'name'?: string;
    /**
     * Number of items of this type being returned. Must be > 0.
     * @type {string}
     * @memberof PbReportStatusItems
     */
    'quantity'?: string;
}
/**
 * 
 * @export
 * @interface PbReportStatusRequest
 */
export interface PbReportStatusRequest {
    /**
     * Currency of the `total_amount` field
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'currency'?: string;
    /**
     * Customer printed order id
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'ecommerce_id'?: string;
    /**
     * Exchange order number (customer printed order id)   associated with this return (if any)
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'exchange_order_number'?: string;
    /**
     * GiftCard Code
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'gift_card_code'?: string;
    /**
     * Items of the return
     * @type {Array<PbReportStatusItems>}
     * @memberof PbReportStatusRequest
     */
    'items'?: Array<PbReportStatusItems>;
    /**
     * Logistic status of the return
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'logistic_status'?: string;
    /**
     * Tracking number of the return (if any)
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'logistic_tracking'?: string;
    /**
     * Order id (not the customer printed order id)
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'order_id'?: string;
    /**
     * payment done by the user
     * @type {PbEcommerceMoney}
     * @memberof PbReportStatusRequest
     */
    'payment'?: PbEcommerceMoney;
    /**
     * Return process ID from the REVER platform
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'process_id'?: string;
    /**
     * Timestamp when the order was fully refunded  protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'refunded_at'?: string;
    /**
     * Reviews of the return
     * @type {Array<PbReportStatusReviews>}
     * @memberof PbReportStatusRequest
     */
    'reviews'?: Array<PbReportStatusReviews>;
    /**
     * Total amount of the return, without decimals  following the money format from `currency`  TODO: Important, this should be int64
     * @type {string}
     * @memberof PbReportStatusRequest
     */
    'total_amount'?: string;
}
/**
 * 
 * @export
 * @interface PbReportStatusReviews
 */
export interface PbReportStatusReviews {
    /**
     * Total amount of the item review, without decimals  following the money format from `currency`  Example: 1234 -->  12,34 EUR  TODO: Important, this should be int64
     * @type {string}
     * @memberof PbReportStatusReviews
     */
    'amount'?: string;
    /**
     * currency associated with the `amount` field
     * @type {string}
     * @memberof PbReportStatusReviews
     */
    'currency'?: string;
    /**
     * Name of the item reviewed
     * @type {string}
     * @memberof PbReportStatusReviews
     */
    'name'?: string;
    /**
     * Status of the review (accepted, rejected, etc)
     * @type {string}
     * @memberof PbReportStatusReviews
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface PbRequestCustomerUploadPhotosRequest
 */
export interface PbRequestCustomerUploadPhotosRequest {
    /**
     * Ecommerce message
     * @type {string}
     * @memberof PbRequestCustomerUploadPhotosRequest
     */
    'ecommerce_message'?: string;
    /**
     * Process ID.
     * @type {string}
     * @memberof PbRequestCustomerUploadPhotosRequest
     */
    'process_id'?: string;
}
/**
 * require authorization request
 * @export
 * @interface PbRequireAuthorization
 */
export interface PbRequireAuthorization {
    /**
     * always
     * @type {boolean}
     * @memberof PbRequireAuthorization
     */
    'always'?: boolean;
    /**
     * options
     * @type {Array<PbRequireAuthorizationOption>}
     * @memberof PbRequireAuthorization
     */
    'options'?: Array<PbRequireAuthorizationOption>;
}
/**
 * RequireAuthorizationOption request
 * @export
 * @interface PbRequireAuthorizationOption
 */
export interface PbRequireAuthorizationOption {
    /**
     * when
     * @type {Array<string>}
     * @memberof PbRequireAuthorizationOption
     */
    'whens'?: Array<string>;
}
/**
 * ReserveWfpRsiUsageRequest records a contract\'s one free-return consumption.
 * @export
 * @interface PbReserveWfpRsiUsageRequest
 */
export interface PbReserveWfpRsiUsageRequest {
    /**
     * ISO 4217 currency of the amounts. Required.
     * @type {string}
     * @memberof PbReserveWfpRsiUsageRequest
     */
    'currency'?: string;
    /**
     * Return process consuming the free return (wfp_rsi_usage primary key). Required.
     * @type {string}
     * @memberof PbReserveWfpRsiUsageRequest
     */
    'return_process_id'?: string;
    /**
     * REVER service fee covered, in minor units (from the Calculate summary).
     * @type {string}
     * @memberof PbReserveWfpRsiUsageRequest
     */
    'service_fee_cents'?: string;
    /**
     * Seel contract id this free return belongs to; UNIQUE so only one per order. Required.
     * @type {string}
     * @memberof PbReserveWfpRsiUsageRequest
     */
    'wfp_contract_id'?: string;
}
/**
 * ReserveWfpRsiUsageResponse reports whether this call reserved the free return.
 * @export
 * @interface PbReserveWfpRsiUsageResponse
 */
export interface PbReserveWfpRsiUsageResponse {
    /**
     * True when this call inserted the row; false when the order already used its  free return (UNIQUE(wfp_contract_id) conflict).
     * @type {boolean}
     * @memberof PbReserveWfpRsiUsageResponse
     */
    'reserved'?: boolean;
}
/**
 * ResolveCarrierConnectionRequest asks which connection a route books with.
 * @export
 * @interface PbResolveCarrierConnectionRequest
 */
export interface PbResolveCarrierConnectionRequest {
    /**
     * Carrier of the route.
     * @type {string}
     * @memberof PbResolveCarrierConnectionRequest
     */
    'carrier'?: string;
    /**
     * Connection the route names; empty resolves to the carrier\'s default connection of the group.
     * @type {string}
     * @memberof PbResolveCarrierConnectionRequest
     */
    'carrier_connection_id'?: string;
    /**
     * Ecommerce the route belongs to.
     * @type {string}
     * @memberof PbResolveCarrierConnectionRequest
     */
    'ecommerce_id'?: string;
    /**
     * Provider of the route, e.g. \"sendcloud_ecommerce\"; empty resolves by carrier alone.
     * @type {string}
     * @memberof PbResolveCarrierConnectionRequest
     */
    'provider'?: string;
}
/**
 * ResolveCarrierConnectionResponse is the resolved booking, settings in plain text.
 * @export
 * @interface PbResolveCarrierConnectionResponse
 */
export interface PbResolveCarrierConnectionResponse {
    /**
     * Carrier connection the route books with.
     * @type {PbCarrierConnection}
     * @memberof PbResolveCarrierConnectionResponse
     */
    'connection'?: PbCarrierConnection;
    /**
     * Merchant\'s partner account the connection books through, when it has one.
     * @type {PbPartnerConnection}
     * @memberof PbResolveCarrierConnectionResponse
     */
    'partner_connection'?: PbPartnerConnection;
}
/**
 * ResolveRouteContractRequest names a route that books a merchant contract through a partner.
 * @export
 * @interface PbResolveRouteContractRequest
 */
export interface PbResolveRouteContractRequest {
    /**
     * Carrier of the route, e.g. \"ups\".
     * @type {string}
     * @memberof PbResolveRouteContractRequest
     */
    'carrier'?: string;
    /**
     * Connection a rule not saved yet names, empty for the default. Unset reads the  ecommerce\'s stored routes.
     * @type {string}
     * @memberof PbResolveRouteContractRequest
     */
    'carrier_connection_id'?: string;
    /**
     * Ecommerce the route belongs to.
     * @type {string}
     * @memberof PbResolveRouteContractRequest
     */
    'ecommerce_id'?: string;
    /**
     * Provider of the route, e.g. \"sendcloud_ecommerce\".
     * @type {string}
     * @memberof PbResolveRouteContractRequest
     */
    'provider'?: string;
}
/**
 * ResolveRouteContractResponse is the contract connection the route books with, settings in plain text.
 * @export
 * @interface PbResolveRouteContractResponse
 */
export interface PbResolveRouteContractResponse {
    /**
     * Connection the route names, or the carrier\'s default when it names none. Set only when enabled.
     * @type {PbCarrierConnection}
     * @memberof PbResolveRouteContractResponse
     */
    'connection'?: PbCarrierConnection;
    /**
     * False while the group\'s flag for the provider is off: the caller keeps reading its own contracts.
     * @type {boolean}
     * @memberof PbResolveRouteContractResponse
     */
    'enabled'?: boolean;
}
/**
 * TODO: enhance description
 * @export
 * @interface PbResponsiveStyle
 */
export interface PbResponsiveStyle {
    /**
     * TODO: enhance description
     * @type {string}
     * @memberof PbResponsiveStyle
     */
    'desktop'?: string;
    /**
     * TODO: enhance description
     * @type {string}
     * @memberof PbResponsiveStyle
     */
    'mobile'?: string;
}
/**
 * 
 * @export
 * @interface PbRestockDTO
 */
export interface PbRestockDTO {
    /**
     * Ecommerce Group. Required
     * @type {string}
     * @memberof PbRestockDTO
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce ID. Required.
     * @type {string}
     * @memberof PbRestockDTO
     */
    'ecommerce_id'?: string;
    /**
     * Line item ID of the item restocked. Required.
     * @type {string}
     * @memberof PbRestockDTO
     */
    'line_item_id'?: string;
    /**
     * location id
     * @type {string}
     * @memberof PbRestockDTO
     */
    'location_id'?: string;
    /**
     * Process ID. Required.
     * @type {string}
     * @memberof PbRestockDTO
     */
    'process_id'?: string;
    /**
     * Quantity restocked. Required
     * @type {number}
     * @memberof PbRestockDTO
     */
    'quantity'?: number;
}
/**
 * Restock location
 * @export
 * @interface PbRestockLocation
 */
export interface PbRestockLocation {
    /**
     * Location address
     * @type {ModelsAddress}
     * @memberof PbRestockLocation
     */
    'address'?: ModelsAddress;
    /**
     * Is default location
     * @type {boolean}
     * @memberof PbRestockLocation
     */
    'is_default'?: boolean;
    /**
     * Location ID
     * @type {string}
     * @memberof PbRestockLocation
     */
    'location_id'?: string;
    /**
     * Location name
     * @type {string}
     * @memberof PbRestockLocation
     */
    'location_name'?: string;
}
/**
 * ReturnAmount with business rules
 * @export
 * @interface PbReturnAmount
 */
export interface PbReturnAmount {
    /**
     * List of business rules that impact in the calculation of   the return amount, for example: shipping costs
     * @type {Array<PbBusinessRule>}
     * @memberof PbReturnAmount
     */
    'business_rules'?: Array<PbBusinessRule>;
}
/**
 * ReturnAmountRule for the return amount
 * @export
 * @interface PbReturnAmountRule
 */
export interface PbReturnAmountRule {
    /**
     * Name of Business rule
     * @type {string}
     * @memberof PbReturnAmountRule
     */
    'name'?: string;
    /**
     * Params needed for the business rule
     * @type {{ [key: string]: string; }}
     * @memberof PbReturnAmountRule
     */
    'params'?: { [key: string]: string; };
    /**
     * ReturnOriginal_shipping_costs
     * @type {boolean}
     * @memberof PbReturnAmountRule
     */
    'return_original_shipping_costs'?: boolean;
    /**
     * When conditions to evaluate
     * @type {PbWhen}
     * @memberof PbReturnAmountRule
     */
    'when'?: PbWhen;
}
/**
 * ReturnConditions is the conditions for the return
 * @export
 * @interface PbReturnConditions
 */
export interface PbReturnConditions {
    /**
     * return period days
     * @type {number}
     * @memberof PbReturnConditions
     */
    'return_period_days'?: number;
}
/**
 * 
 * @export
 * @interface PbReturnCustomer
 */
export interface PbReturnCustomer {
    /**
     * Customer email
     * @type {string}
     * @memberof PbReturnCustomer
     */
    'email'?: string;
    /**
     * Customer full name
     * @type {string}
     * @memberof PbReturnCustomer
     */
    'full_name'?: string;
}
/**
 * 
 * @export
 * @interface PbReturnLineItem
 */
export interface PbReturnLineItem {
    /**
     * TODO: difference with `amount_before_costs` ?
     * @type {string}
     * @memberof PbReturnLineItem
     */
    'amount_after_costs'?: string;
    /**
     * TODO: difference with `amount_after_costs` ?  Amount of the line item, without decimals, with the currency  given in the `CompleteReturnRequest` struct.
     * @type {string}
     * @memberof PbReturnLineItem
     */
    'amount_before_costs'?: string;
    /**
     * Line item id from the e-commerce order referred by `order_id`
     * @type {string}
     * @memberof PbReturnLineItem
     */
    'line_item_id'?: string;
    /**
     * Product Info
     * @type {PbProductInfo}
     * @memberof PbReturnLineItem
     */
    'product_info'?: PbProductInfo;
    /**
     * Number of items being returned. Must be > 0.
     * @type {number}
     * @memberof PbReturnLineItem
     */
    'quantity'?: number;
    /**
     * Return Reason
     * @type {string}
     * @memberof PbReturnLineItem
     */
    'return_reason'?: string;
    /**
     * status of the return
     * @type {string}
     * @memberof PbReturnLineItem
     */
    'status'?: PbReturnLineItemStatusEnum;
}

export const PbReturnLineItemStatusEnum = {
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    Missing: 'MISSING'
} as const;

export type PbReturnLineItemStatusEnum = typeof PbReturnLineItemStatusEnum[keyof typeof PbReturnLineItemStatusEnum];

/**
 * Return logistics configures a way for the users  to return the products to the e-commerce
 * @export
 * @interface PbReturnLogistics
 */
export interface PbReturnLogistics {
    /**
     * carrier that is effectively handling the return  Example: CorreosExpress, Correos, etc
     * @type {string}
     * @memberof PbReturnLogistics
     */
    'carrier'?: string;
    /**
     * Carrier connection the route books with. Empty books the carrier\'s default connection of the group.
     * @type {string}
     * @memberof PbReturnLogistics
     */
    'carrier_connection_id'?: string;
    /**
     * Label options for this route, keyed by the option keys the provider declares (e.g. UPS line_items_type).
     * @type {{ [key: string]: string; }}
     * @memberof PbReturnLogistics
     */
    'options'?: { [key: string]: string; };
    /**
     * provider is the platform that manages the creation of the return label  Example: Sendcloud, OPS, etc  Important: the value `OPS` means that the REVER ops team manages   the creation of the return label
     * @type {string}
     * @memberof PbReturnLogistics
     */
    'provider'?: string;
    /**
     * type of return method: DROP_OFF, PICKUP...
     * @type {string}
     * @memberof PbReturnLogistics
     */
    'return_method'?: PbReturnLogisticsReturnMethodEnum;
    /**
     * Optional carrier service used by provider integrations. For Sendcloud, a v2 shipping method id  (e.g. 4216) or a v3 shipping option code (e.g. correos:paqretorno/return).  When empty provider-specific default service resolution is used.
     * @type {string}
     * @memberof PbReturnLogistics
     */
    'service_id'?: string;
    /**
     * list of dynamic evaluations to determine if this logistics is available  They are evaluated in order, and all of them must be true to evaluate   together as true (AND condition)  IF not specified, is considered as true always  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbReturnLogistics
     */
    'when'?: Array<string>;
}

export const PbReturnLogisticsReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type PbReturnLogisticsReturnMethodEnum = typeof PbReturnLogisticsReturnMethodEnum[keyof typeof PbReturnLogisticsReturnMethodEnum];

/**
 * 
 * @export
 * @interface PbReturnLogisticsInfo
 */
export interface PbReturnLogisticsInfo {
    /**
     * return address
     * @type {ModelsAddress}
     * @memberof PbReturnLogisticsInfo
     */
    'return_address'?: ModelsAddress;
    /**
     * return method
     * @type {string}
     * @memberof PbReturnLogisticsInfo
     */
    'return_method'?: PbReturnLogisticsInfoReturnMethodEnum;
}

export const PbReturnLogisticsInfoReturnMethodEnum = {
    NoReturnMethod: 'NO_RETURN_METHOD',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    SelfShipping: 'SELF_SHIPPING'
} as const;

export type PbReturnLogisticsInfoReturnMethodEnum = typeof PbReturnLogisticsInfoReturnMethodEnum[keyof typeof PbReturnLogisticsInfoReturnMethodEnum];

/**
 * 
 * @export
 * @interface PbReturnOrderedItem
 */
export interface PbReturnOrderedItem {
    /**
     * Line item id
     * @type {string}
     * @memberof PbReturnOrderedItem
     */
    'line_item_id'?: string;
    /**
     * product id
     * @type {string}
     * @memberof PbReturnOrderedItem
     */
    'product_id'?: string;
    /**
     * Product Name
     * @type {string}
     * @memberof PbReturnOrderedItem
     */
    'product_name'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof PbReturnOrderedItem
     */
    'quantity'?: number;
    /**
     * Total in presentment currency
     * @type {PbEcommerceMoney}
     * @memberof PbReturnOrderedItem
     */
    'total_in_presentment_currency'?: PbEcommerceMoney;
    /**
     * variant id
     * @type {string}
     * @memberof PbReturnOrderedItem
     */
    'variant_id'?: string;
    /**
     * Variant Name
     * @type {string}
     * @memberof PbReturnOrderedItem
     */
    'variant_name'?: string;
}
/**
 * Return deadline of the orders purchased between two dates
 * @export
 * @interface PbReturnPeriodRule
 */
export interface PbReturnPeriodRule {
    /**
     * Days to start a return, counted from the fulfillment like return_period_days. Set either until or days.
     * @type {number}
     * @memberof PbReturnPeriodRule
     */
    'days'?: number;
    /**
     * First purchase date the rule applies to, as YYYY-MM-DD in UTC
     * @type {string}
     * @memberof PbReturnPeriodRule
     */
    'purchased_from'?: string;
    /**
     * Last purchase date the rule applies to, included, as YYYY-MM-DD in UTC
     * @type {string}
     * @memberof PbReturnPeriodRule
     */
    'purchased_to'?: string;
    /**
     * Last day to start a return, included, as YYYY-MM-DD in UTC. Set either until or days.
     * @type {string}
     * @memberof PbReturnPeriodRule
     */
    'until'?: string;
}
/**
 * ReturnConditions model
 * @export
 * @interface PbReturnProcessConditions
 */
export interface PbReturnProcessConditions {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbReturnProcessConditions
     */
    'ecommerce_id'?: string;
    /**
     * Keep your item
     * @type {PbKeepYourItem}
     * @memberof PbReturnProcessConditions
     */
    'keep_your_item'?: PbKeepYourItem;
    /**
     * Deprecated: replaced by the per-reason NewReturnReason.mandatory_comment.  No handler reads it any more; kept for wire compatibility.
     * @type {boolean}
     * @memberof PbReturnProcessConditions
     */
    'mandatory_return_comment'?: boolean;
    /**
     * MaxDaysToSendPackage
     * @type {number}
     * @memberof PbReturnProcessConditions
     */
    'max_days_to_send_package'?: number;
    /**
     * NonReturnableBrandIds
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'non_returnable_brand_ids'?: Array<string>;
    /**
     * NonReturnableCategoryIds
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'non_returnable_category_ids'?: Array<string>;
    /**
     * NonReturnableCollectionIds
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'non_returnable_collection_ids'?: Array<string>;
    /**
     * NonReturnableOrderTagIds
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'non_returnable_order_tag_ids'?: Array<string>;
    /**
     * NonReturnableProductIds
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'non_returnable_product_ids'?: Array<string>;
    /**
     * NonReturnableTagIds
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'non_returnable_tag_ids'?: Array<string>;
    /**
     * PayForLogistics
     * @type {PbPayForLogistics}
     * @memberof PbReturnProcessConditions
     */
    'pay_for_logistics'?: PbPayForLogistics;
    /**
     * PaymentsEnabled
     * @type {boolean}
     * @memberof PbReturnProcessConditions
     */
    'payments_enabled'?: boolean;
    /**
     * Whether the returns portal shows the return reasons in a random order for  each shopper. Defaults to false (the configured order is kept).
     * @type {boolean}
     * @memberof PbReturnProcessConditions
     */
    'randomize_return_reasons_order'?: boolean;
    /**
     * RequireAuthorization
     * @type {PbRequireAuthorization}
     * @memberof PbReturnProcessConditions
     */
    'require_authorization'?: PbRequireAuthorization;
    /**
     * ReturnPeriodDays
     * @type {number}
     * @memberof PbReturnProcessConditions
     */
    'return_period_days'?: number;
    /**
     * Return deadlines of the orders purchased between two dates. The first rule that matches the  purchase date applies; return_period_days applies to every other order.
     * @type {Array<PbReturnPeriodRule>}
     * @memberof PbReturnProcessConditions
     */
    'return_period_rules'?: Array<PbReturnPeriodRule>;
    /**
     * Days to wait after the parcel reaches the warehouse before auto-completing a  MANUAL-review process with no review, applying review_auto_complete_outcome.  0 disables auto-completion (the process waits indefinitely for a review).
     * @type {number}
     * @memberof PbReturnProcessConditions
     */
    'review_auto_complete_days'?: number;
    /**
     * What the review auto-complete applies to every unreviewed unit when the window  runs out. UNSPECIFIED behaves as MISSING.
     * @type {string}
     * @memberof PbReturnProcessConditions
     */
    'review_auto_complete_outcome'?: PbReturnProcessConditionsReviewAutoCompleteOutcomeEnum;
    /**
     * ReviewFlow
     * @type {string}
     * @memberof PbReturnProcessConditions
     */
    'review_flow'?: string;
    /**
     * SkipFraudDetection
     * @type {boolean}
     * @memberof PbReturnProcessConditions
     */
    'skip_fraud_detection'?: boolean;
    /**
     * List of workflow activities to skip (e.g., \"GenerateLogisticOrder\", \"SendACKEmail\")  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbReturnProcessConditions
     */
    'skip_workflow_activities'?: Array<string>;
    /**
     * StartReturnOnPlatformTime
     * @type {string}
     * @memberof PbReturnProcessConditions
     */
    'start_return_on_platform_time'?: PbReturnProcessConditionsStartReturnOnPlatformTimeEnum;
    /**
     * UploadDocuments
     * @type {PbUploadDocuments}
     * @memberof PbReturnProcessConditions
     */
    'upload_documents'?: PbUploadDocuments;
}

export const PbReturnProcessConditionsReviewAutoCompleteOutcomeEnum = {
    Unspecified: 'REVIEW_AUTO_COMPLETE_OUTCOME_UNSPECIFIED',
    Missing: 'REVIEW_AUTO_COMPLETE_OUTCOME_MISSING',
    Approved: 'REVIEW_AUTO_COMPLETE_OUTCOME_APPROVED'
} as const;

export type PbReturnProcessConditionsReviewAutoCompleteOutcomeEnum = typeof PbReturnProcessConditionsReviewAutoCompleteOutcomeEnum[keyof typeof PbReturnProcessConditionsReviewAutoCompleteOutcomeEnum];
export const PbReturnProcessConditionsStartReturnOnPlatformTimeEnum = {
    Unspecified: 'START_RETURN_ON_PLATFORM_TIME_UNSPECIFIED',
    OnStart: 'START_RETURN_ON_PLATFORM_TIME_ON_START',
    OnItemVerification: 'START_RETURN_ON_PLATFORM_TIME_ON_ITEM_VERIFICATION',
    Never: 'START_RETURN_ON_PLATFORM_TIME_NEVER'
} as const;

export type PbReturnProcessConditionsStartReturnOnPlatformTimeEnum = typeof PbReturnProcessConditionsStartReturnOnPlatformTimeEnum[keyof typeof PbReturnProcessConditionsStartReturnOnPlatformTimeEnum];

/**
 * 
 * @export
 * @interface PbReturnProcessFilters
 */
export interface PbReturnProcessFilters {
    /**
     * Filter processes by bank transfer refund amount greater than zero
     * @type {boolean}
     * @memberof PbReturnProcessFilters
     */
    'bank_transfer_refund'?: boolean;
    /**
     * Filter processes created after or at the given date
     * @type {string}
     * @memberof PbReturnProcessFilters
     */
    'created_at_gte'?: string;
    /**
     * Filter processes created before or at the given date
     * @type {string}
     * @memberof PbReturnProcessFilters
     */
    'created_at_lte'?: string;
    /**
     * Filter processes of the given e-commerce ID
     * @type {string}
     * @memberof PbReturnProcessFilters
     */
    'ecommerce_id'?: string;
    /**
     * Filter processes containing the given text
     * @type {string}
     * @memberof PbReturnProcessFilters
     */
    'freetext'?: string;
    /**
     * Filter processes by gift refund amount greater than zero
     * @type {boolean}
     * @memberof PbReturnProcessFilters
     */
    'gift_card_refund'?: boolean;
    /**
     * Filter processes by exchange refund amount greater than zero
     * @type {boolean}
     * @memberof PbReturnProcessFilters
     */
    'is_exchange'?: boolean;
    /**
     * Filter processes by OPM refund amount greater than zero
     * @type {boolean}
     * @memberof PbReturnProcessFilters
     */
    'opm_refund'?: boolean;
    /**
     * Filter processes by promocode refund amount greater than zero
     * @type {boolean}
     * @memberof PbReturnProcessFilters
     */
    'promocode_refund'?: boolean;
    /**
     * Filter processes by the given return methods
     * @type {Array<string>}
     * @memberof PbReturnProcessFilters
     */
    'return_method'?: Array<string>;
    /**
     * Filter processes by the given return statuses
     * @type {Array<string>}
     * @memberof PbReturnProcessFilters
     */
    'return_status'?: Array<string>;
}
/**
 * collection of return reasons
 * @export
 * @interface PbReturnReasonsCollection
 */
export interface PbReturnReasonsCollection {
    /**
     * list of return reasons
     * @type {Array<PbAvailableReturnReasons>}
     * @memberof PbReturnReasonsCollection
     */
    'return_reasons'?: Array<PbAvailableReturnReasons>;
}
/**
 * 
 * @export
 * @interface PbReturnSummary
 */
export interface PbReturnSummary {
    /**
     * 
     * @type {PbBasicProcessData}
     * @memberof PbReturnSummary
     */
    'basic_process_data'?: PbBasicProcessData;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummary
     */
    'checkout_id'?: string;
    /**
     * 
     * @type {PbCompensation}
     * @memberof PbReturnSummary
     */
    'compensation'?: PbCompensation;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummary
     */
    'currency_code'?: string;
    /**
     * 
     * @type {PbReturnSummaryCustomer}
     * @memberof PbReturnSummary
     */
    'customer'?: PbReturnSummaryCustomer;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummary
     */
    'exchange_timing'?: PbReturnSummaryExchangeTimingEnum;
    /**
     * 
     * @type {PbExtraLineItems}
     * @memberof PbReturnSummary
     */
    'extra_line_items'?: PbExtraLineItems;
    /**
     * True when a Worry-Free-Purchase claim exists for this return process.
     * @type {boolean}
     * @memberof PbReturnSummary
     */
    'is_claim'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummary
     */
    'keep_your_item_type'?: PbReturnSummaryKeepYourItemTypeEnum;
    /**
     * Navigation links for the original order (admin UI today, more in the future).  Unset when navigation could not be fetched (upstream ecommerce-api error  or the return process is missing order/ecommerce identifiers); the summary  itself never fails because of this enrichment. When set but the underlying  URL is an empty string, the platform is supported but did not provide a  value for that link.
     * @type {PbReturnSummaryNavigation}
     * @memberof PbReturnSummary
     */
    'navigation'?: PbReturnSummaryNavigation;
    /**
     * 
     * @type {PbOpenExchangeItems}
     * @memberof PbReturnSummary
     */
    'open_exchange_items'?: PbOpenExchangeItems;
    /**
     * 
     * @type {PbOrderedItems}
     * @memberof PbReturnSummary
     */
    'ordered_items'?: PbOrderedItems;
    /**
     * 
     * @type {PbReturnSummaryPayments}
     * @memberof PbReturnSummary
     */
    'payments'?: PbReturnSummaryPayments;
    /**
     * Payment method chosen by the user when creating the return process.   Other payment methods can be added afterwards
     * @type {string}
     * @memberof PbReturnSummary
     */
    'refund_payment_method'?: PbReturnSummaryRefundPaymentMethodEnum;
    /**
     * Refund timing committed to the user when creating the return process.   If other payment methods are added afterwards, the timing for them can vary
     * @type {string}
     * @memberof PbReturnSummary
     */
    'refund_timing'?: PbReturnSummaryRefundTimingEnum;
    /**
     * 
     * @type {PbReturnedItems}
     * @memberof PbReturnSummary
     */
    'returned_items'?: PbReturnedItems;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummary
     */
    'start_return_on_platform_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummary
     */
    'status'?: PbReturnSummaryStatusEnum;
    /**
     * 
     * @type {PbReturnSummaryUploadDocumentsInfo}
     * @memberof PbReturnSummary
     */
    'upload_documents_info'?: PbReturnSummaryUploadDocumentsInfo;
}

export const PbReturnSummaryExchangeTimingEnum = {
    Unspecified: 'TIMING_UNSPECIFIED',
    NoTiming: 'TIMING_NO_TIMING',
    OnStart: 'TIMING_ON_START',
    OnSent: 'TIMING_ON_SENT',
    OnVerified: 'TIMING_ON_VERIFIED'
} as const;

export type PbReturnSummaryExchangeTimingEnum = typeof PbReturnSummaryExchangeTimingEnum[keyof typeof PbReturnSummaryExchangeTimingEnum];
export const PbReturnSummaryKeepYourItemTypeEnum = {
    Unspecified: 'KEEP_YOUR_ITEM_TYPE_UNSPECIFIED',
    None: 'KEEP_YOUR_ITEM_TYPE_NONE',
    WithoutValidation: 'KEEP_YOUR_ITEM_TYPE_WITHOUT_VALIDATION'
} as const;

export type PbReturnSummaryKeepYourItemTypeEnum = typeof PbReturnSummaryKeepYourItemTypeEnum[keyof typeof PbReturnSummaryKeepYourItemTypeEnum];
export const PbReturnSummaryRefundPaymentMethodEnum = {
    Unspecified: 'REFUND_PAYMENT_METHOD_UNSPECIFIED',
    NoPaymentMethod: 'REFUND_PAYMENT_METHOD_NO_PAYMENT_METHOD',
    BankTransfer: 'REFUND_PAYMENT_METHOD_BANK_TRANSFER',
    Original: 'REFUND_PAYMENT_METHOD_ORIGINAL',
    PromoCode: 'REFUND_PAYMENT_METHOD_PROMO_CODE',
    GiftCard: 'REFUND_PAYMENT_METHOD_GIFT_CARD'
} as const;

export type PbReturnSummaryRefundPaymentMethodEnum = typeof PbReturnSummaryRefundPaymentMethodEnum[keyof typeof PbReturnSummaryRefundPaymentMethodEnum];
export const PbReturnSummaryRefundTimingEnum = {
    Unspecified: 'TIMING_UNSPECIFIED',
    NoTiming: 'TIMING_NO_TIMING',
    OnStart: 'TIMING_ON_START',
    OnSent: 'TIMING_ON_SENT',
    OnVerified: 'TIMING_ON_VERIFIED'
} as const;

export type PbReturnSummaryRefundTimingEnum = typeof PbReturnSummaryRefundTimingEnum[keyof typeof PbReturnSummaryRefundTimingEnum];
export const PbReturnSummaryStatusEnum = {
    Unspecified: 'RETURN_PROCESS_STATUS_UNSPECIFIED',
    Started: 'RETURN_PROCESS_STATUS_STARTED',
    Collected: 'RETURN_PROCESS_STATUS_COLLECTED',
    ReviewRequired: 'RETURN_PROCESS_STATUS_REVIEW_REQUIRED',
    Completed: 'RETURN_PROCESS_STATUS_COMPLETED',
    Canceled: 'RETURN_PROCESS_STATUS_CANCELED',
    AuthorizationPending: 'RETURN_PROCESS_STATUS_AUTHORIZATION_PENDING',
    DocumentUploadPending: 'RETURN_PROCESS_STATUS_DOCUMENT_UPLOAD_PENDING',
    NotAuthorized: 'RETURN_PROCESS_STATUS_NOT_AUTHORIZED'
} as const;

export type PbReturnSummaryStatusEnum = typeof PbReturnSummaryStatusEnum[keyof typeof PbReturnSummaryStatusEnum];

/**
 * 
 * @export
 * @interface PbReturnSummaryCustomer
 */
export interface PbReturnSummaryCustomer {
    /**
     * 
     * @type {PbCustomerAddress}
     * @memberof PbReturnSummaryCustomer
     */
    'address'?: PbCustomerAddress;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummaryCustomer
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummaryCustomer
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnSummaryCustomer
     */
    'last_name'?: string;
    /**
     * User preferred language
     * @type {string}
     * @memberof PbReturnSummaryCustomer
     */
    'preferred_language'?: string;
}
/**
 * 
 * @export
 * @interface PbReturnSummaryNavigation
 */
export interface PbReturnSummaryNavigation {
    /**
     * Browser-navigable URL to view the order in the platform admin UI.  Empty when the platform is unsupported.
     * @type {string}
     * @memberof PbReturnSummaryNavigation
     */
    'admin_html_order_url'?: string;
}
/**
 * 
 * @export
 * @interface PbReturnSummaryPayments
 */
export interface PbReturnSummaryPayments {
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbReturnSummaryPayments
     */
    'commitment'?: PbMoneyBag;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbReturnSummaryPayments
     */
    'executed'?: PbMoneyBag;
}
/**
 * 
 * @export
 * @interface PbReturnSummaryUploadDocumentsInfo
 */
export interface PbReturnSummaryUploadDocumentsInfo {
    /**
     * 
     * @type {boolean}
     * @memberof PbReturnSummaryUploadDocumentsInfo
     */
    'upload_documents_enabled'?: boolean;
    /**
     * 
     * @type {Array<PbUploadDocumentsInfoUploadedDocuments>}
     * @memberof PbReturnSummaryUploadDocumentsInfo
     */
    'uploaded_documents'?: Array<PbUploadDocumentsInfoUploadedDocuments>;
}
/**
 * 
 * @export
 * @interface PbReturnedItem
 */
export interface PbReturnedItem {
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItem
     */
    'action'?: PbReturnedItemActionEnum;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItem
     */
    'platform_line_item_id'?: string;
    /**
     * 
     * @type {PbReturnedItemProductInfo}
     * @memberof PbReturnedItem
     */
    'product_info'?: PbReturnedItemProductInfo;
    /**
     * 
     * @type {number}
     * @memberof PbReturnedItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItem
     */
    'return_reason_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItem
     */
    'return_reason_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItem
     */
    'rever_id'?: string;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbReturnedItem
     */
    'total'?: PbMoneyBag;
    /**
     * UnitPrice includes taxes and discounts. It is total/quantity
     * @type {PbMoneyBag}
     * @memberof PbReturnedItem
     */
    'unit_price'?: PbMoneyBag;
    /**
     * True when the customer is asked for photos or documents of this item.
     * @type {boolean}
     * @memberof PbReturnedItem
     */
    'upload_documents_required'?: boolean;
}

export const PbReturnedItemActionEnum = {
    Unspecified: 'ACTION_UNSPECIFIED',
    Refund: 'ACTION_REFUND',
    Exchange: 'ACTION_EXCHANGE'
} as const;

export type PbReturnedItemActionEnum = typeof PbReturnedItemActionEnum[keyof typeof PbReturnedItemActionEnum];

/**
 * 
 * @export
 * @interface PbReturnedItemProductInfo
 */
export interface PbReturnedItemProductInfo {
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'image_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'product_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'variant_ean'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'variant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'variant_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbReturnedItemProductInfo
     */
    'variant_reference'?: string;
}
/**
 * 
 * @export
 * @interface PbReturnedItems
 */
export interface PbReturnedItems {
    /**
     * 
     * @type {Array<PbReturnedItem>}
     * @memberof PbReturnedItems
     */
    'returned_items'?: Array<PbReturnedItem>;
    /**
     * 
     * @type {PbMoneyBag}
     * @memberof PbReturnedItems
     */
    'total'?: PbMoneyBag;
}
/**
 * item from order for return
 * @export
 * @interface PbReturningItem
 */
export interface PbReturningItem {
    /**
     * Caller-chosen id of the item, unique within the request. Echoed back by calls  that answer per item, such as UploadDocuments.
     * @type {string}
     * @memberof PbReturningItem
     */
    'id'?: string;
    /**
     * The item product
     * @type {PbItemProduct}
     * @memberof PbReturningItem
     */
    'product'?: PbItemProduct;
    /**
     * The quantity of the item
     * @type {number}
     * @memberof PbReturningItem
     */
    'quantity'?: number;
    /**
     * The reason of the return
     * @type {string}
     * @memberof PbReturningItem
     */
    'reason'?: string;
    /**
     * The total amount of the item in shop currency
     * @type {string}
     * @memberof PbReturningItem
     */
    'total_in_shop_currency'?: string;
}
/**
 * 
 * @export
 * @interface PbReviewLineItem
 */
export interface PbReviewLineItem {
    /**
     * User that performed the review. Required.  TODO: should be created_by  protolint:disable:next FIELD_NAMES_EXCLUDE_PREPOSITIONS
     * @type {string}
     * @memberof PbReviewLineItem
     */
    'created_by_user'?: string;
    /**
     * REVER ID of the line item of the return process (return items)  to be reviewed. Required.
     * @type {string}
     * @memberof PbReviewLineItem
     */
    'line_item_id'?: string;
    /**
     * Reason for rejecting the line item. Required if status == REJECTED
     * @type {string}
     * @memberof PbReviewLineItem
     */
    'reject_reason'?: string;
    /**
     * Should show reject reason to the user
     * @type {boolean}
     * @memberof PbReviewLineItem
     */
    'show_reject_reason'?: boolean;
    /**
     * Review status. Required.  TODO: valid values??
     * @type {string}
     * @memberof PbReviewLineItem
     */
    'status'?: string;
}
/**
 * RevokeWebhookSigningSecretResponse is the outcome of a revocation.
 * @export
 * @interface PbRevokeWebhookSigningSecretResponse
 */
export interface PbRevokeWebhookSigningSecretResponse {
    /**
     * False when the ecommerce had no active secret to revoke
     * @type {boolean}
     * @memberof PbRevokeWebhookSigningSecretResponse
     */
    'revoked'?: boolean;
}
/**
 * Settings for Salesforce integration
 * @export
 * @interface PbSalesforceSettings
 */
export interface PbSalesforceSettings {
    /**
     * B2C Commerce specific settings
     * @type {PbB2CSettings}
     * @memberof PbSalesforceSettings
     */
    'b2c_settings'?: PbB2CSettings;
    /**
     * Credentials for Business Manager
     * @type {PbBusinessManagerCredentials}
     * @memberof PbSalesforceSettings
     */
    'business_manager_credentials'?: PbBusinessManagerCredentials;
    /**
     * Integration settings
     * @type {PbIntegrationSettings}
     * @memberof PbSalesforceSettings
     */
    'integration_settings'?: PbIntegrationSettings;
    /**
     * Credentials for Salesforce Core
     * @type {PbOAuth2Credentials}
     * @memberof PbSalesforceSettings
     */
    'salesforce_core_credentials'?: PbOAuth2Credentials;
    /**
     * Credentials for SCAPI (Salesforce Commerce API)
     * @type {PbOAuth2Credentials}
     * @memberof PbSalesforceSettings
     */
    'scapi_credentials'?: PbOAuth2Credentials;
    /**
     * Credentials for SCAPI Shopper
     * @type {PbOAuth2Credentials}
     * @memberof PbSalesforceSettings
     */
    'scapi_shopper_credentials'?: PbOAuth2Credentials;
    /**
     * Multi-site configuration; empty means single-site mode (use b2c_settings.site_id)
     * @type {Array<PbSiteEntry>}
     * @memberof PbSalesforceSettings
     */
    'sites'?: Array<PbSiteEntry>;
}
/**
 * SalesforceSettingsResponse response
 * @export
 * @interface PbSalesforceSettingsResponse
 */
export interface PbSalesforceSettingsResponse {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSalesforceSettingsResponse
     */
    'ecommerce_id'?: string;
    /**
     * Optional -- only if Salesforce
     * @type {PbSalesforceSettings}
     * @memberof PbSalesforceSettingsResponse
     */
    'salesforce_settings'?: PbSalesforceSettings;
}
/**
 * Payload used to persist a debit or credit risk exposure event.
 * @export
 * @interface PbSaveAllocatedRiskExposureEventRequest
 */
export interface PbSaveAllocatedRiskExposureEventRequest {
    /**
     * Allocated timing identifier.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'allocated_timing_id'?: string;
    /**
     * Timestamp of the event.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'created_at'?: string;
    /**
     * End-customer identifier belonging to the ecommerce account.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'customer_id'?: string;
    /**
     * Platform-wide ecommerce identifier.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'ecommerce_id'?: string;
    /**
     * Describes how the event impacts risk (captured, cleared, expired).
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'event_action'?: PbSaveAllocatedRiskExposureEventRequestEventActionEnum;
    /**
     * Classifies whether the event is a debit or a credit event.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'event_type'?: PbSaveAllocatedRiskExposureEventRequestEventTypeEnum;
    /**
     * Client-facing return identifier from external systems.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'external_return_id'?: string;
    /**
     * Amount at risk expressed in euro cents.
     * @type {string}
     * @memberof PbSaveAllocatedRiskExposureEventRequest
     */
    'risked_amount_eur'?: string;
}

export const PbSaveAllocatedRiskExposureEventRequestEventActionEnum = {
    Unspecified: 'RISK_EVENT_ACTION_UNSPECIFIED',
    Captured: 'RISK_EVENT_ACTION_CAPTURED',
    Cleared: 'RISK_EVENT_ACTION_CLEARED',
    Expired: 'RISK_EVENT_ACTION_EXPIRED'
} as const;

export type PbSaveAllocatedRiskExposureEventRequestEventActionEnum = typeof PbSaveAllocatedRiskExposureEventRequestEventActionEnum[keyof typeof PbSaveAllocatedRiskExposureEventRequestEventActionEnum];
export const PbSaveAllocatedRiskExposureEventRequestEventTypeEnum = {
    Unspecified: 'RISK_EVENT_TYPE_UNSPECIFIED',
    Debit: 'RISK_EVENT_TYPE_DEBIT',
    Credit: 'RISK_EVENT_TYPE_CREDIT'
} as const;

export type PbSaveAllocatedRiskExposureEventRequestEventTypeEnum = typeof PbSaveAllocatedRiskExposureEventRequestEventTypeEnum[keyof typeof PbSaveAllocatedRiskExposureEventRequestEventTypeEnum];

/**
 * Branding save request
 * @export
 * @interface PbSaveBrandingReq
 */
export interface PbSaveBrandingReq {
    /**
     * BackgroundImageUrl
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'background_image_url'?: string;
    /**
     * BackgroundTextColor
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'background_text_color'?: string;
    /**
     * BorderRadius
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'border_radius'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'ecommerce_id'?: string;
    /**
     * FaviconUrl
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'favicon_url'?: string;
    /**
     * FullCatalogProductImageRatio
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'full_catalog_product_image_ratio'?: string;
    /**
     * InputVariant
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'input_variant'?: string;
    /**
     * LayoutDesignValues
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'layout_design_values'?: PbSaveBrandingReqLayoutDesignValuesEnum;
    /**
     * LogoHeightDesktop
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'logo_height_desktop'?: string;
    /**
     * LogoHeightMobile
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'logo_height_mobile'?: string;
    /**
     * LogoUrl
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'logo_url'?: string;
    /**
     * MailLogoUrl
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'mail_logo_url'?: string;
    /**
     * MailMainColor
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'mail_main_color'?: string;
    /**
     * PersistentLogoType
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'persistent_logo_type'?: PbSaveBrandingReqPersistentLogoTypeEnum;
    /**
     * PrimaryThemeColorContrastText
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'primary_theme_color_contrast_text'?: string;
    /**
     * PrimaryThemeColorDark
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'primary_theme_color_dark'?: string;
    /**
     * PrimaryThemeColorLight
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'primary_theme_color_light'?: string;
    /**
     * PrimaryThemeColorMain
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'primary_theme_color_main'?: string;
    /**
     * SecondaryThemeColorContrastText
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'secondary_theme_color_contrast_text'?: string;
    /**
     * SecondaryThemeColorDark
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'secondary_theme_color_dark'?: string;
    /**
     * SecondaryThemeColorLight
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'secondary_theme_color_light'?: string;
    /**
     * SecondaryThemeColorMain
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'secondary_theme_color_main'?: string;
    /**
     * Slogan
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'slogan'?: string;
    /**
     * Title
     * @type {string}
     * @memberof PbSaveBrandingReq
     */
    'title'?: string;
}

export const PbSaveBrandingReqLayoutDesignValuesEnum = {
    Default: 'DEFAULT',
    Vertical: 'VERTICAL',
    Simplified: 'SIMPLIFIED'
} as const;

export type PbSaveBrandingReqLayoutDesignValuesEnum = typeof PbSaveBrandingReqLayoutDesignValuesEnum[keyof typeof PbSaveBrandingReqLayoutDesignValuesEnum];
export const PbSaveBrandingReqPersistentLogoTypeEnum = {
    Unspecified: 'PERSISTENT_LOGO_TYPE_UNSPECIFIED',
    Enabled: 'PERSISTENT_LOGO_TYPE_ENABLED',
    Disabled: 'PERSISTENT_LOGO_TYPE_DISABLED'
} as const;

export type PbSaveBrandingReqPersistentLogoTypeEnum = typeof PbSaveBrandingReqPersistentLogoTypeEnum[keyof typeof PbSaveBrandingReqPersistentLogoTypeEnum];

/**
 * SaveCarrierConnectionRequest creates or updates a carrier connection.
 * @export
 * @interface PbSaveCarrierConnectionRequest
 */
export interface PbSaveCarrierConnectionRequest {
    /**
     * Connection to save; an empty id creates it.  Send every setting on update: the stored settings are replaced, and a masked value keeps the stored secret.
     * @type {PbCarrierConnection}
     * @memberof PbSaveCarrierConnectionRequest
     */
    'connection'?: PbCarrierConnection;
}
/**
 * SaveCarrierConnectionResponse returns the saved carrier connection.
 * @export
 * @interface PbSaveCarrierConnectionResponse
 */
export interface PbSaveCarrierConnectionResponse {
    /**
     * Saved connection, secrets masked.
     * @type {PbCarrierConnection}
     * @memberof PbSaveCarrierConnectionResponse
     */
    'connection'?: PbCarrierConnection;
}
/**
 * SaveCustomCredentialsRequest is used to save credentials for a custom platform
 * @export
 * @interface PbSaveCustomCredentialsRequest
 */
export interface PbSaveCustomCredentialsRequest {
    /**
     * Credentials to be saved
     * @type {Array<PbCustomCredentials>}
     * @memberof PbSaveCustomCredentialsRequest
     */
    'credentials'?: Array<PbCustomCredentials>;
    /**
     * ID of the ecommerce platform
     * @type {string}
     * @memberof PbSaveCustomCredentialsRequest
     */
    'ecommerce_id'?: string;
}
/**
 * SaveCustomCredentialsResponse confirms credentials were saved
 * @export
 * @interface PbSaveCustomCredentialsResponse
 */
export interface PbSaveCustomCredentialsResponse {
    /**
     * ID of the ecommerce platform the credentials were saved for
     * @type {string}
     * @memberof PbSaveCustomCredentialsResponse
     */
    'ecommerce_id'?: string;
}
/**
 * SaveCustomPlatformSettingsRequest request
 * @export
 * @interface PbSaveCustomPlatformSettingsRequest
 */
export interface PbSaveCustomPlatformSettingsRequest {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional -- Generic custom platform settings
     * @type {PbGenericCustomSettings}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'generic_settings'?: PbGenericCustomSettings;
    /**
     * Optional -- Only if Logicommerce
     * @type {PbLogicommerceSettings}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'logicommerce_settings'?: PbLogicommerceSettings;
    /**
     * Optional -- Only if Mirakl
     * @type {PbMiraklPlatformSettings}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'mirakl_settings'?: PbMiraklPlatformSettings;
    /**
     * Optional -- Only if own platform
     * @type {PbOwnPlatformSettings}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'own_platform_settings'?: PbOwnPlatformSettings;
    /**
     * Optional -- Only if Tiktok
     * @type {PbTiktokPlatformSettings}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'tiktok_settings'?: PbTiktokPlatformSettings;
    /**
     * Optional -- Only if Vtex
     * @type {PbVtexPlatformSettings}
     * @memberof PbSaveCustomPlatformSettingsRequest
     */
    'vtex_settings'?: PbVtexPlatformSettings;
}
/**
 * SaveEcommerceContactsRequest replaces the points of contact of an  e-commerce\'s group.
 * @export
 * @interface PbSaveEcommerceContactsRequest
 */
export interface PbSaveEcommerceContactsRequest {
    /**
     * Full set of contacts. Anything stored but missing from the list is  removed; a contact with every field blank counts as missing.
     * @type {Array<PbEcommerceContact>}
     * @memberof PbSaveEcommerceContactsRequest
     */
    'contacts'?: Array<PbEcommerceContact>;
    /**
     * EcommerceID. Required.
     * @type {string}
     * @memberof PbSaveEcommerceContactsRequest
     */
    'ecommerce_id'?: string;
}
/**
 * Overrides exchanges settings of an ecommerce
 * @export
 * @interface PbSaveEcommerceExchangesSettingsV2Request
 */
export interface PbSaveEcommerceExchangesSettingsV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbSaveEcommerceExchangesSettingsV2Request
     */
    'ecommerce_id'?: string;
    /**
     * The kinds to override
     * @type {PbExchangesSettingsV2}
     * @memberof PbSaveEcommerceExchangesSettingsV2Request
     */
    'settings'?: PbExchangesSettingsV2;
}
/**
 * Overrides the RDV surplus rules of an ecommerce
 * @export
 * @interface PbSaveEcommerceRDVSurplusV2Request
 */
export interface PbSaveEcommerceRDVSurplusV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbSaveEcommerceRDVSurplusV2Request
     */
    'ecommerce_id'?: string;
    /**
     * The rules
     * @type {PbRDVSurplusV2}
     * @memberof PbSaveEcommerceRDVSurplusV2Request
     */
    'rdv_surplus'?: PbRDVSurplusV2;
}
/**
 * Overrides the refund configuration of an ecommerce
 * @export
 * @interface PbSaveEcommerceRefundConfigurationV2Request
 */
export interface PbSaveEcommerceRefundConfigurationV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbSaveEcommerceRefundConfigurationV2Request
     */
    'ecommerce_id'?: string;
    /**
     * The configuration
     * @type {PbRefundConfigurationV2}
     * @memberof PbSaveEcommerceRefundConfigurationV2Request
     */
    'refund_configuration'?: PbRefundConfigurationV2;
}
/**
 * Ecommerce save request
 * @export
 * @interface PbSaveEcommerceReq
 */
export interface PbSaveEcommerceReq {
    /**
     * Allows incrementally reviewing the line items of a process, that is, does  not require to bring all of the line items at once
     * @type {boolean}
     * @memberof PbSaveEcommerceReq
     */
    'are_partial_reviews_allowed'?: boolean;
    /**
     * CurrencyCode
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'currency_code'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'ecommerce_id'?: string;
    /**
     * EmailProvider
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'email_provider'?: PbSaveEcommerceReqEmailProviderEnum;
    /**
     * external policy url
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'external_return_policy_url'?: string;
    /**
     * Group
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'group'?: string;
    /**
     * How shoppers identify their orders
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'identification_flow'?: PbSaveEcommerceReqIdentificationFlowEnum;
    /**
     * IsEnabled
     * @type {boolean}
     * @memberof PbSaveEcommerceReq
     */
    'is_enabled'?: boolean;
    /**
     * IsTesting
     * @type {boolean}
     * @memberof PbSaveEcommerceReq
     */
    'is_testing'?: boolean;
    /**
     * When a review brings fewer line items than expected, treat every unit not  present in the review as MISSING instead of rejecting the review
     * @type {boolean}
     * @memberof PbSaveEcommerceReq
     */
    'mark_unreviewed_items_as_missing'?: boolean;
    /**
     * name
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'name'?: string;
    /**
     * OrdersSyncDisabled
     * @type {boolean}
     * @memberof PbSaveEcommerceReq
     */
    'orders_sync_disabled'?: boolean;
    /**
     * Platform
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'platform'?: string;
    /**
     * RestockingEnabled
     * @type {boolean}
     * @memberof PbSaveEcommerceReq
     */
    'restocking_enabled'?: boolean;
    /**
     * slug
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'slug'?: string;
    /**
     * StoreID
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'store_id'?: string;
    /**
     * UseCase
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'use_case'?: string;
    /**
     * WebsiteURL
     * @type {string}
     * @memberof PbSaveEcommerceReq
     */
    'website_url'?: string;
}

export const PbSaveEcommerceReqEmailProviderEnum = {
    Unspecified: 'EMAIL_PROVIDER_UNSPECIFIED',
    AwsSes: 'EMAIL_PROVIDER_AWS_SES',
    Inditex: 'EMAIL_PROVIDER_INDITEX'
} as const;

export type PbSaveEcommerceReqEmailProviderEnum = typeof PbSaveEcommerceReqEmailProviderEnum[keyof typeof PbSaveEcommerceReqEmailProviderEnum];
export const PbSaveEcommerceReqIdentificationFlowEnum = {
    IdentificationFlowUnspecified: 'IDENTIFICATION_FLOW_UNSPECIFIED',
    OrderIdAndEmail: 'ORDER_ID_AND_EMAIL',
    OrderIdAndPostalCode: 'ORDER_ID_AND_POSTAL_CODE'
} as const;

export type PbSaveEcommerceReqIdentificationFlowEnum = typeof PbSaveEcommerceReqIdentificationFlowEnum[keyof typeof PbSaveEcommerceReqIdentificationFlowEnum];

/**
 * Overrides the return conditions of an ecommerce
 * @export
 * @interface PbSaveEcommerceReturnProcessConditionsV2Request
 */
export interface PbSaveEcommerceReturnProcessConditionsV2Request {
    /**
     * The conditions. Their ecommerce_id is ignored.
     * @type {PbSaveReturnProcessConditionsReq}
     * @memberof PbSaveEcommerceReturnProcessConditionsV2Request
     */
    'conditions'?: PbSaveReturnProcessConditionsReq;
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbSaveEcommerceReturnProcessConditionsV2Request
     */
    'ecommerce_id'?: string;
}
/**
 * Overrides the return reasons of an ecommerce
 * @export
 * @interface PbSaveEcommerceReturnReasonsV2Request
 */
export interface PbSaveEcommerceReturnReasonsV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof PbSaveEcommerceReturnReasonsV2Request
     */
    'ecommerce_id'?: string;
    /**
     * The whole list, sub-reasons included. Names outside the group\'s catalog are dropped.
     * @type {Array<PbNewReturnReason>}
     * @memberof PbSaveEcommerceReturnReasonsV2Request
     */
    'return_reasons'?: Array<PbNewReturnReason>;
}
/**
 * ExchangeConditions save request
 * @export
 * @interface PbSaveExchangeConditionsReq
 */
export interface PbSaveExchangeConditionsReq {
    /**
     * Use the destination warehouse\'s stock for exchanges instead of the store-wide total.  Optional so callers that predate the field (Appsmith) leave the stored value untouched  instead of resetting it to false.
     * @type {boolean}
     * @memberof PbSaveExchangeConditionsReq
     */
    'destination_scoped_stock'?: boolean;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveExchangeConditionsReq
     */
    'ecommerce_id'?: string;
    /**
     * exchange flow
     * @type {string}
     * @memberof PbSaveExchangeConditionsReq
     */
    'exchange_flow'?: PbSaveExchangeConditionsReqExchangeFlowEnum;
    /**
     * PlatformMainMenuID
     * @type {string}
     * @memberof PbSaveExchangeConditionsReq
     */
    'platform_main_menu_id'?: string;
    /**
     * Threshold
     * @type {number}
     * @memberof PbSaveExchangeConditionsReq
     */
    'threshold'?: number;
}

export const PbSaveExchangeConditionsReqExchangeFlowEnum = {
    NoExchangeFlow: 'NO_EXCHANGE_FLOW',
    Open: 'OPEN',
    OneOnOne: 'ONE_ON_ONE',
    OpenWithGiftCard: 'OPEN_WITH_GIFT_CARD',
    Full: 'FULL'
} as const;

export type PbSaveExchangeConditionsReqExchangeFlowEnum = typeof PbSaveExchangeConditionsReqExchangeFlowEnum[keyof typeof PbSaveExchangeConditionsReqExchangeFlowEnum];

/**
 * ExchangeOrder save request
 * @export
 * @interface PbSaveExchangeOrderWithEcommerceReq
 */
export interface PbSaveExchangeOrderWithEcommerceReq {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveExchangeOrderWithEcommerceReq
     */
    'ecommerce_id'?: string;
    /**
     * PaymentMethod
     * @type {string}
     * @memberof PbSaveExchangeOrderWithEcommerceReq
     */
    'payment_method'?: string;
    /**
     * Price
     * @type {string}
     * @memberof PbSaveExchangeOrderWithEcommerceReq
     */
    'price'?: string;
    /**
     * ShippingLine
     * @type {string}
     * @memberof PbSaveExchangeOrderWithEcommerceReq
     */
    'shipping_line'?: string;
}
/**
 * SaveGroupContactsRequest replaces the points of contact of a group.
 * @export
 * @interface PbSaveGroupContactsRequest
 */
export interface PbSaveGroupContactsRequest {
    /**
     * Full set of contacts. Anything stored but missing from the list is  removed; a contact with every field blank counts as missing.
     * @type {Array<PbEcommerceContact>}
     * @memberof PbSaveGroupContactsRequest
     */
    'contacts'?: Array<PbEcommerceContact>;
    /**
     * Group. Required.
     * @type {string}
     * @memberof PbSaveGroupContactsRequest
     */
    'ecommerce_group'?: string;
}
/**
 * Replaces exchanges settings of a group
 * @export
 * @interface PbSaveGroupExchangesSettingsV2Request
 */
export interface PbSaveGroupExchangesSettingsV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof PbSaveGroupExchangesSettingsV2Request
     */
    'ecommerce_group'?: string;
    /**
     * The kinds to replace
     * @type {PbExchangesSettingsV2}
     * @memberof PbSaveGroupExchangesSettingsV2Request
     */
    'settings'?: PbExchangesSettingsV2;
}
/**
 * Replaces the RDV surplus rules of a group
 * @export
 * @interface PbSaveGroupRDVSurplusV2Request
 */
export interface PbSaveGroupRDVSurplusV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof PbSaveGroupRDVSurplusV2Request
     */
    'ecommerce_group'?: string;
    /**
     * The rules
     * @type {PbRDVSurplusV2}
     * @memberof PbSaveGroupRDVSurplusV2Request
     */
    'rdv_surplus'?: PbRDVSurplusV2;
}
/**
 * Replaces the refund configuration of a group
 * @export
 * @interface PbSaveGroupRefundConfigurationV2Request
 */
export interface PbSaveGroupRefundConfigurationV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof PbSaveGroupRefundConfigurationV2Request
     */
    'ecommerce_group'?: string;
    /**
     * The configuration
     * @type {PbRefundConfigurationV2}
     * @memberof PbSaveGroupRefundConfigurationV2Request
     */
    'refund_configuration'?: PbRefundConfigurationV2;
}
/**
 * Replaces the return conditions of a group
 * @export
 * @interface PbSaveGroupReturnProcessConditionsV2Request
 */
export interface PbSaveGroupReturnProcessConditionsV2Request {
    /**
     * The conditions. Their ecommerce_id is ignored.
     * @type {PbSaveReturnProcessConditionsReq}
     * @memberof PbSaveGroupReturnProcessConditionsV2Request
     */
    'conditions'?: PbSaveReturnProcessConditionsReq;
    /**
     * Ecommerce group
     * @type {string}
     * @memberof PbSaveGroupReturnProcessConditionsV2Request
     */
    'ecommerce_group'?: string;
}
/**
 * Replaces the return reasons of a group
 * @export
 * @interface PbSaveGroupReturnReasonsV2Request
 */
export interface PbSaveGroupReturnReasonsV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof PbSaveGroupReturnReasonsV2Request
     */
    'ecommerce_group'?: string;
    /**
     * The whole list, sub-reasons included. Names outside the group\'s catalog are dropped.
     * @type {Array<PbNewReturnReason>}
     * @memberof PbSaveGroupReturnReasonsV2Request
     */
    'return_reasons'?: Array<PbNewReturnReason>;
}
/**
 * Replaces the warehouse routing rules of a group
 * @export
 * @interface PbSaveGroupWarehouseConfigsV2Request
 */
export interface PbSaveGroupWarehouseConfigsV2Request {
    /**
     * Ecommerce group whose routing rules to replace
     * @type {string}
     * @memberof PbSaveGroupWarehouseConfigsV2Request
     */
    'ecommerce_group'?: string;
    /**
     * Routing rules
     * @type {Array<PbWarehouseConfig>}
     * @memberof PbSaveGroupWarehouseConfigsV2Request
     */
    'warehouse_configs'?: Array<PbWarehouseConfig>;
}
/**
 * InStoreSettings save request
 * @export
 * @interface PbSaveInStoreSettingsReq
 */
export interface PbSaveInStoreSettingsReq {
    /**
     * Whether the automated store-to-warehouse logistics is enabled for this ecommerce.  When enabled, after clerk review a pickup courier is automatically created from  the store address to the warehouse.
     * @type {boolean}
     * @memberof PbSaveInStoreSettingsReq
     */
    'automated_store_to_warehouse_logistics_enabled'?: boolean;
    /**
     * Preferred time window for the internal store-to-warehouse pickup courier (e.g. \"RANGE_8_TO_12\").
     * @type {string}
     * @memberof PbSaveInStoreSettingsReq
     */
    'default_pickup_range'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveInStoreSettingsReq
     */
    'ecommerce_id'?: string;
    /**
     * IsEnabled
     * @type {boolean}
     * @memberof PbSaveInStoreSettingsReq
     */
    'is_enabled'?: boolean;
    /**
     * LocationID
     * @type {string}
     * @memberof PbSaveInStoreSettingsReq
     */
    'location_id'?: string;
    /**
     * Name
     * @type {string}
     * @memberof PbSaveInStoreSettingsReq
     */
    'name'?: string;
}
/**
 * SaveInstantExchangeSettingsReq is the request to upsert instant exchange settings for an e-commerce.
 * @export
 * @interface PbSaveInstantExchangeSettingsReq
 */
export interface PbSaveInstantExchangeSettingsReq {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'ecommerce_id'?: string;
    /**
     * Whether instant exchange is enabled (default: false).
     * @type {boolean}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'enabled'?: boolean;
    /**
     * Optional maximum fee amount (minor units) when fee_type is PERCENTAGE (0 means unset).
     * @type {number}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'fee_cap_amount'?: number;
    /**
     * Optional minimum fee amount (minor units) when fee_type is PERCENTAGE (0 means unset).  Stripe requires at least 50 (e.g., $0.50).
     * @type {number}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'fee_floor_amount'?: number;
    /**
     * Fee type (PERCENTAGE or FIXED).
     * @type {string}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'fee_type'?: PbSaveInstantExchangeSettingsReqFeeTypeEnum;
    /**
     * Fixed fee amount (in the shop currency\'s minor units) when fee_type is FIXED.
     * @type {number}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'fixed_fee_amount'?: number;
    /**
     * Percentage fee value (e.g., 5 = 5%) when fee_type is PERCENTAGE.
     * @type {number}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'percentage_fee_value'?: number;
    /**
     * Timing when instant exchange is available.  Only ON_START_RETURN_PROCESS and ON_ITEM_SENT are supported.
     * @type {string}
     * @memberof PbSaveInstantExchangeSettingsReq
     */
    'timing'?: PbSaveInstantExchangeSettingsReqTimingEnum;
}

export const PbSaveInstantExchangeSettingsReqFeeTypeEnum = {
    InstantExchangeFeeTypeUnspecified: 'INSTANT_EXCHANGE_FEE_TYPE_UNSPECIFIED',
    Percentage: 'PERCENTAGE',
    Fixed: 'FIXED'
} as const;

export type PbSaveInstantExchangeSettingsReqFeeTypeEnum = typeof PbSaveInstantExchangeSettingsReqFeeTypeEnum[keyof typeof PbSaveInstantExchangeSettingsReqFeeTypeEnum];
export const PbSaveInstantExchangeSettingsReqTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type PbSaveInstantExchangeSettingsReqTimingEnum = typeof PbSaveInstantExchangeSettingsReqTimingEnum[keyof typeof PbSaveInstantExchangeSettingsReqTimingEnum];

/**
 * LogisticSetting save request
 * @export
 * @interface PbSaveLogisticSettingReq
 */
export interface PbSaveLogisticSettingReq {
    /**
     * DeliveryNoteType
     * @type {string}
     * @memberof PbSaveLogisticSettingReq
     */
    'delivery_note_type'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveLogisticSettingReq
     */
    'ecommerce_id'?: string;
    /**
     * ReminderFlow
     * @type {string}
     * @memberof PbSaveLogisticSettingReq
     */
    'reminder_flow'?: string;
    /**
     * ReturnLogistics
     * @type {Array<PbReturnLogistics>}
     * @memberof PbSaveLogisticSettingReq
     */
    'return_logistics'?: Array<PbReturnLogistics>;
    /**
     * StoreListUrl
     * @type {string}
     * @memberof PbSaveLogisticSettingReq
     */
    'store_list_url'?: string;
}
/**
 * SavePartnerConnectionRequest creates or updates a partner connection.
 * @export
 * @interface PbSavePartnerConnectionRequest
 */
export interface PbSavePartnerConnectionRequest {
    /**
     * Connection to save; an empty id creates it.  Send every setting on update: the stored settings are replaced, and a masked value keeps the stored secret.
     * @type {PbPartnerConnection}
     * @memberof PbSavePartnerConnectionRequest
     */
    'connection'?: PbPartnerConnection;
}
/**
 * SavePartnerConnectionResponse returns the saved partner connection.
 * @export
 * @interface PbSavePartnerConnectionResponse
 */
export interface PbSavePartnerConnectionResponse {
    /**
     * Saved connection, secrets masked.
     * @type {PbPartnerConnection}
     * @memberof PbSavePartnerConnectionResponse
     */
    'connection'?: PbPartnerConnection;
}
/**
 * RDVSurplus save request
 * @export
 * @interface PbSaveRDVSurplusReq
 */
export interface PbSaveRDVSurplusReq {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveRDVSurplusReq
     */
    'ecommerce_id'?: string;
    /**
     * Rules
     * @type {Array<PbRDVSurplusRule>}
     * @memberof PbSaveRDVSurplusReq
     */
    'rules'?: Array<PbRDVSurplusRule>;
}
/**
 * Payload used to persist a debit or credit risk exposure event.
 * @export
 * @interface PbSaveRealizedRiskExposureEventRequest
 */
export interface PbSaveRealizedRiskExposureEventRequest {
    /**
     * Timestamp of the event.
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'created_at'?: string;
    /**
     * End-customer identifier belonging to the ecommerce account.
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'customer_id'?: string;
    /**
     * Platform-wide ecommerce identifier.
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'ecommerce_id'?: string;
    /**
     * Describes how the event impacts risk (captured, cleared, expired).
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'event_action'?: PbSaveRealizedRiskExposureEventRequestEventActionEnum;
    /**
     * Classifies whether the event is a debit or a credit event.
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'event_type'?: PbSaveRealizedRiskExposureEventRequestEventTypeEnum;
    /**
     * Client-facing return identifier from external systems.
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'external_return_id'?: string;
    /**
     * Internal return identifier (deterministic with the external_return_id).
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'return_process_id'?: string;
    /**
     * Amount at risk expressed in euro cents.
     * @type {string}
     * @memberof PbSaveRealizedRiskExposureEventRequest
     */
    'risked_amount_eur'?: string;
}

export const PbSaveRealizedRiskExposureEventRequestEventActionEnum = {
    Unspecified: 'RISK_EVENT_ACTION_UNSPECIFIED',
    Captured: 'RISK_EVENT_ACTION_CAPTURED',
    Cleared: 'RISK_EVENT_ACTION_CLEARED',
    Expired: 'RISK_EVENT_ACTION_EXPIRED'
} as const;

export type PbSaveRealizedRiskExposureEventRequestEventActionEnum = typeof PbSaveRealizedRiskExposureEventRequestEventActionEnum[keyof typeof PbSaveRealizedRiskExposureEventRequestEventActionEnum];
export const PbSaveRealizedRiskExposureEventRequestEventTypeEnum = {
    Unspecified: 'RISK_EVENT_TYPE_UNSPECIFIED',
    Debit: 'RISK_EVENT_TYPE_DEBIT',
    Credit: 'RISK_EVENT_TYPE_CREDIT'
} as const;

export type PbSaveRealizedRiskExposureEventRequestEventTypeEnum = typeof PbSaveRealizedRiskExposureEventRequestEventTypeEnum[keyof typeof PbSaveRealizedRiskExposureEventRequestEventTypeEnum];

/**
 * SaveRefundConfigurationRequest
 * @export
 * @interface PbSaveRefundConfigurationRequest
 */
export interface PbSaveRefundConfigurationRequest {
    /**
     * ActionConfig
     * @type {Array<PbActionConfig>}
     * @memberof PbSaveRefundConfigurationRequest
     */
    'action_configs'?: Array<PbActionConfig>;
    /**
     * carry_over_automatic_discounts_on_exchanges
     * @type {boolean}
     * @memberof PbSaveRefundConfigurationRequest
     */
    'carry_over_automatic_discounts_on_exchanges'?: boolean;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbSaveRefundConfigurationRequest
     */
    'ecommerce_id'?: string;
    /**
     * PaymentMethodConfig
     * @type {Array<PbPaymentMethodConfig>}
     * @memberof PbSaveRefundConfigurationRequest
     */
    'payment_method_configs'?: Array<PbPaymentMethodConfig>;
    /**
     * revoke_conditional_discounts
     * @type {boolean}
     * @memberof PbSaveRefundConfigurationRequest
     */
    'revoke_conditional_discounts'?: boolean;
    /**
     * round_promocode
     * @type {boolean}
     * @memberof PbSaveRefundConfigurationRequest
     */
    'round_promocode'?: boolean;
}
/**
 * SaveRefundConfigurationResponse
 * @export
 * @interface PbSaveRefundConfigurationResponse
 */
export interface PbSaveRefundConfigurationResponse {
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbSaveRefundConfigurationResponse
     */
    'ecommerce_id'?: string;
}
/**
 * SaveRefundGatewaySettingsRequest is the request for the SaveRefundGatewaySettings method
 * @export
 * @interface PbSaveRefundGatewaySettingsRequest
 */
export interface PbSaveRefundGatewaySettingsRequest {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbSaveRefundGatewaySettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Refund gateway settings
     * @type {PbRefundGatewaySettings}
     * @memberof PbSaveRefundGatewaySettingsRequest
     */
    'settings'?: PbRefundGatewaySettings;
}
/**
 * SaveRefundGatewaySettingsResponse is the response for the SaveRefundGatewaySettings method
 * @export
 * @interface PbSaveRefundGatewaySettingsResponse
 */
export interface PbSaveRefundGatewaySettingsResponse {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbSaveRefundGatewaySettingsResponse
     */
    'ecommerce_id'?: string;
}
/**
 * ReturnConditions save request
 * @export
 * @interface PbSaveReturnProcessConditionsReq
 */
export interface PbSaveReturnProcessConditionsReq {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'ecommerce_id'?: string;
    /**
     * Keep your item
     * @type {PbKeepYourItem}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'keep_your_item'?: PbKeepYourItem;
    /**
     * Deprecated: replaced by the per-reason NewReturnReason.mandatory_comment.  No handler reads it any more; kept for wire compatibility.
     * @type {boolean}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'mandatory_return_comment'?: boolean;
    /**
     * MaxDaysToSendPackage
     * @type {number}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'max_days_to_send_package'?: number;
    /**
     * NonReturnableBrandIds
     * @type {Array<string>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'non_returnable_brand_ids'?: Array<string>;
    /**
     * NonReturnableCategoryIds
     * @type {Array<string>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'non_returnable_category_ids'?: Array<string>;
    /**
     * NonReturnableCollectionIds
     * @type {Array<string>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'non_returnable_collection_ids'?: Array<string>;
    /**
     * NonReturnableOrderTagIds
     * @type {Array<string>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'non_returnable_order_tag_ids'?: Array<string>;
    /**
     * NonReturnableProductIds
     * @type {Array<string>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'non_returnable_product_ids'?: Array<string>;
    /**
     * NonReturnableTagIds
     * @type {Array<string>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'non_returnable_tag_ids'?: Array<string>;
    /**
     * PayForLogistics
     * @type {PbPayForLogistics}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'pay_for_logistics'?: PbPayForLogistics;
    /**
     * PaymentsEnabled
     * @type {boolean}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'payments_enabled'?: boolean;
    /**
     * Whether the returns portal shows the return reasons in a random order for  each shopper. Defaults to false (the configured order is kept).
     * @type {boolean}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'randomize_return_reasons_order'?: boolean;
    /**
     * RequireAuthorization
     * @type {PbRequireAuthorization}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'require_authorization'?: PbRequireAuthorization;
    /**
     * ReturnPeriodDays
     * @type {number}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'return_period_days'?: number;
    /**
     * Return deadlines of the orders purchased between two dates. The first rule that matches the  purchase date applies; return_period_days applies to every other order. Saved only on the v2  return conditions.
     * @type {Array<PbReturnPeriodRule>}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'return_period_rules'?: Array<PbReturnPeriodRule>;
    /**
     * Days to wait after the parcel reaches the warehouse before auto-completing a  MANUAL-review process with no review, applying review_auto_complete_outcome.  0 disables auto-completion (the process waits indefinitely for a review).
     * @type {number}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'review_auto_complete_days'?: number;
    /**
     * What the review auto-complete applies to every unreviewed unit when the window  runs out. UNSPECIFIED behaves as MISSING.
     * @type {string}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'review_auto_complete_outcome'?: PbSaveReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum;
    /**
     * ReviewFlow
     * @type {string}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'review_flow'?: string;
    /**
     * SkipFraudDetection
     * @type {boolean}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'skip_fraud_detection'?: boolean;
    /**
     * StartReturnOnPlatformTime
     * @type {string}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'start_return_on_platform_time'?: PbSaveReturnProcessConditionsReqStartReturnOnPlatformTimeEnum;
    /**
     * UploadDocuments
     * @type {PbUploadDocuments}
     * @memberof PbSaveReturnProcessConditionsReq
     */
    'upload_documents'?: PbUploadDocuments;
}

export const PbSaveReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum = {
    Unspecified: 'REVIEW_AUTO_COMPLETE_OUTCOME_UNSPECIFIED',
    Missing: 'REVIEW_AUTO_COMPLETE_OUTCOME_MISSING',
    Approved: 'REVIEW_AUTO_COMPLETE_OUTCOME_APPROVED'
} as const;

export type PbSaveReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum = typeof PbSaveReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum[keyof typeof PbSaveReturnProcessConditionsReqReviewAutoCompleteOutcomeEnum];
export const PbSaveReturnProcessConditionsReqStartReturnOnPlatformTimeEnum = {
    Unspecified: 'START_RETURN_ON_PLATFORM_TIME_UNSPECIFIED',
    OnStart: 'START_RETURN_ON_PLATFORM_TIME_ON_START',
    OnItemVerification: 'START_RETURN_ON_PLATFORM_TIME_ON_ITEM_VERIFICATION',
    Never: 'START_RETURN_ON_PLATFORM_TIME_NEVER'
} as const;

export type PbSaveReturnProcessConditionsReqStartReturnOnPlatformTimeEnum = typeof PbSaveReturnProcessConditionsReqStartReturnOnPlatformTimeEnum[keyof typeof PbSaveReturnProcessConditionsReqStartReturnOnPlatformTimeEnum];

/**
 * save all return reasons request
 * @export
 * @interface PbSaveReturnReasonsReq
 */
export interface PbSaveReturnReasonsReq {
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbSaveReturnReasonsReq
     */
    'ecommerce_id'?: string;
    /**
     * return reasons to save
     * @type {Array<PbNewReturnReason>}
     * @memberof PbSaveReturnReasonsReq
     */
    'return_reasons'?: Array<PbNewReturnReason>;
}
/**
 * RiskExposureSettings save request
 * @export
 * @interface PbSaveRiskExposureSettingsRequest
 */
export interface PbSaveRiskExposureSettingsRequest {
    /**
     * AllocationTimeoutHours - hours before allocated risk expires (default: 6)
     * @type {string}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'allocation_timeout_hours'?: string;
    /**
     * ControlGroupProbability - probability for control group assignment, 0.0 to 1.0 (default: 0.1)
     * @type {number}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'control_group_probability'?: number;
    /**
     * CustomerThresholdEurCents
     * @type {string}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'customer_threshold_eur_cents'?: string;
    /**
     * DailyThresholdEurCents
     * @type {string}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'daily_threshold_eur_cents'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * GlobalThresholdEurCents
     * @type {string}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'global_threshold_eur_cents'?: string;
    /**
     * OnItemSentThreshold - threshold for ON_ITEM_SENT timing, 0.0 to 1.0 (default: 0.5)
     * @type {number}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'on_item_sent_threshold'?: number;
    /**
     * OnItemVerifiedThreshold - threshold for ON_ITEM_VERIFIED timing, 0.0 to 1.0 (default: 1.0). Must be >=  on_item_sent_threshold.
     * @type {number}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'on_item_verified_threshold'?: number;
    /**
     * RealizationTimeoutDays - days before realized risk expires (default: 45)
     * @type {string}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'realization_timeout_days'?: string;
    /**
     * RiskEvaluationEnabled
     * @type {boolean}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'risk_evaluation_enabled'?: boolean;
    /**
     * TestingEnabled
     * @type {boolean}
     * @memberof PbSaveRiskExposureSettingsRequest
     */
    'testing_enabled'?: boolean;
}
/**
 * SaveSalesforceSettingsRequest request
 * @export
 * @interface PbSaveSalesforceSettingsRequest
 */
export interface PbSaveSalesforceSettingsRequest {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveSalesforceSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Optional -- only if Salesforce
     * @type {PbSalesforceSettings}
     * @memberof PbSaveSalesforceSettingsRequest
     */
    'salesforce_settings'?: PbSalesforceSettings;
}
/**
 * SaveServiceDefaultRequest saves a group\'s label options for a carrier.
 * @export
 * @interface PbSaveServiceDefaultRequest
 */
export interface PbSaveServiceDefaultRequest {
    /**
     * Service default to save; its options replace the stored ones, and a blank value unsets the key.
     * @type {PbServiceDefault}
     * @memberof PbSaveServiceDefaultRequest
     */
    'service_default'?: PbServiceDefault;
}
/**
 * SaveServiceDefaultResponse returns the saved service default.
 * @export
 * @interface PbSaveServiceDefaultResponse
 */
export interface PbSaveServiceDefaultResponse {
    /**
     * Saved service default.
     * @type {PbServiceDefault}
     * @memberof PbSaveServiceDefaultResponse
     */
    'service_default'?: PbServiceDefault;
}
/**
 * Save service fees request
 * @export
 * @interface PbSaveServiceFeesReq
 */
export interface PbSaveServiceFeesReq {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveServiceFeesReq
     */
    'ecommerce_id'?: string;
    /**
     * Rules
     * @type {Array<PbServiceFeesRule>}
     * @memberof PbSaveServiceFeesReq
     */
    'rules'?: Array<PbServiceFeesRule>;
}
/**
 * SaveShopifyAppAutomationTokenRequest replaces a Shopify store\'s App Automation token.
 * @export
 * @interface PbSaveShopifyAppAutomationTokenRequest
 */
export interface PbSaveShopifyAppAutomationTokenRequest {
    /**
     * Ecommerce of the Shopify store; it must read its credentials from Nango.
     * @type {string}
     * @memberof PbSaveShopifyAppAutomationTokenRequest
     */
    'ecommerce_id'?: string;
    /**
     * When the token expires, as the Shopify Dev Dashboard shows it; it must be in the future.
     * @type {string}
     * @memberof PbSaveShopifyAppAutomationTokenRequest
     */
    'expires_at'?: string;
    /**
     * Token generated in the store\'s Shopify Dev Dashboard. It is never returned.
     * @type {string}
     * @memberof PbSaveShopifyAppAutomationTokenRequest
     */
    'token'?: string;
}
/**
 * A shop registering the app.
 * @export
 * @interface PbSaveShopwareAppInstallationRequest
 */
export interface PbSaveShopwareAppInstallationRequest {
    /**
     * The shop\'s id.
     * @type {string}
     * @memberof PbSaveShopwareAppInstallationRequest
     */
    'shop_id'?: string;
    /**
     * The new per-shop secret. A re-registration stores it as pending.
     * @type {string}
     * @memberof PbSaveShopwareAppInstallationRequest
     */
    'shop_secret'?: string;
    /**
     * Whether shopware-shop-signature verified against verified_shop_secret. Sets  verified_with_double_signature.
     * @type {boolean}
     * @memberof PbSaveShopwareAppInstallationRequest
     */
    'shop_signature_verified'?: boolean;
    /**
     * The shop\'s Admin API base URL.
     * @type {string}
     * @memberof PbSaveShopwareAppInstallationRequest
     */
    'shop_url'?: string;
    /**
     * The stored per-shop secret the caller verified shopware-shop-signature with. Required, and must  still be the current one, for a confirmed shop that has used the double signature, and for a  registration from another host, whose move its confirmation applies.
     * @type {string}
     * @memberof PbSaveShopwareAppInstallationRequest
     */
    'verified_shop_secret'?: string;
}
/**
 * SaveWarehouseConfigRequest
 * @export
 * @interface PbSaveWarehouseConfigRequest
 */
export interface PbSaveWarehouseConfigRequest {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveWarehouseConfigRequest
     */
    'ecommerce_id'?: string;
    /**
     * List of warehouse configs
     * @type {Array<PbWarehouseConfig>}
     * @memberof PbSaveWarehouseConfigRequest
     */
    'warehouse_configs'?: Array<PbWarehouseConfig>;
}
/**
 * SaveWarehouseConfigResponse
 * @export
 * @interface PbSaveWarehouseConfigResponse
 */
export interface PbSaveWarehouseConfigResponse {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbSaveWarehouseConfigResponse
     */
    'ecommerce_id'?: string;
}
/**
 * Ecomerce\'s save warehouses request
 * @export
 * @interface PbSaveWarehousesReq
 */
export interface PbSaveWarehousesReq {
    /**
     * Warehouses
     * @type {Array<PbWarehouse>}
     * @memberof PbSaveWarehousesReq
     */
    'warehouses'?: Array<PbWarehouse>;
}
/**
 * Saves warehouses of an ecommerce group
 * @export
 * @interface PbSaveWarehousesV2Req
 */
export interface PbSaveWarehousesV2Req {
    /**
     * Ecommerce group that owns the warehouses
     * @type {string}
     * @memberof PbSaveWarehousesV2Req
     */
    'ecommerce_group'?: string;
    /**
     * Warehouses to create or update. An empty or foreign id creates a new warehouse.
     * @type {Array<PbWarehouse>}
     * @memberof PbSaveWarehousesV2Req
     */
    'warehouses'?: Array<PbWarehouse>;
}
/**
 * SaveWarehousesV2Res
 * @export
 * @interface PbSaveWarehousesV2Res
 */
export interface PbSaveWarehousesV2Res {
    /**
     * Ids of the saved warehouses, in request order; a warehouse whose id the group does not own is created with a new id
     * @type {Array<string>}
     * @memberof PbSaveWarehousesV2Res
     */
    'ids'?: Array<string>;
}
/**
 * SaveWfpClaimRequest carries the identifiers of a claim filed at Seel.
 * @export
 * @interface PbSaveWfpClaimRequest
 */
export interface PbSaveWfpClaimRequest {
    /**
     * Return process id the claim belongs to. Required.
     * @type {string}
     * @memberof PbSaveWfpClaimRequest
     */
    'return_process_id'?: string;
    /**
     * Seel-assigned claim id (wfp_claim primary key). Required.
     * @type {string}
     * @memberof PbSaveWfpClaimRequest
     */
    'seel_claim_id'?: string;
    /**
     * Seel contract id the claim was filed against. Required.
     * @type {string}
     * @memberof PbSaveWfpClaimRequest
     */
    'wfp_contract_id'?: string;
}
/**
 * SaveWfpFreeReturnRequest carries the ledger data for a notified free return.
 * @export
 * @interface PbSaveWfpFreeReturnRequest
 */
export interface PbSaveWfpFreeReturnRequest {
    /**
     * Currency of the amounts (ISO-4217). Required.
     * @type {string}
     * @memberof PbSaveWfpFreeReturnRequest
     */
    'currency'?: string;
    /**
     * Logistics label cost in cents (absolute).
     * @type {string}
     * @memberof PbSaveWfpFreeReturnRequest
     */
    'label_cost_cents'?: string;
    /**
     * Return process id the free return belongs to. Required.
     * @type {string}
     * @memberof PbSaveWfpFreeReturnRequest
     */
    'return_process_id'?: string;
    /**
     * Provider-assigned return id; empty when stubbed/skipped.
     * @type {string}
     * @memberof PbSaveWfpFreeReturnRequest
     */
    'seel_return_id'?: string;
    /**
     * Service fee in cents (absolute, = 150).
     * @type {string}
     * @memberof PbSaveWfpFreeReturnRequest
     */
    'service_fee_cents'?: string;
    /**
     * Seel contract id (wfp_rsi_usage UNIQUE key). Required.
     * @type {string}
     * @memberof PbSaveWfpFreeReturnRequest
     */
    'wfp_contract_id'?: string;
}
/**
 * WorkflowConfigurations save request
 * @export
 * @interface PbSaveWorkflowConfigurationsReq
 */
export interface PbSaveWorkflowConfigurationsReq {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbSaveWorkflowConfigurationsReq
     */
    'ecommerce_id'?: string;
    /**
     * List of workflow activities to skip (e.g., \"GenerateLogisticOrder\", \"SendACKEmail\")  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbSaveWorkflowConfigurationsReq
     */
    'skip_workflow_activities'?: Array<string>;
}
/**
 * The catalog entries that match a SearchCatalogRequest
 * @export
 * @interface PbSearchCatalogResponse
 */
export interface PbSearchCatalogResponse {
    /**
     * Matching entries, at most 20 for a search
     * @type {Array<PbCatalogItem>}
     * @memberof PbSearchCatalogResponse
     */
    'items'?: Array<PbCatalogItem>;
}
/**
 * 
 * @export
 * @interface PbSendSignalToWorkflowRequest
 */
export interface PbSendSignalToWorkflowRequest {
    /**
     * Optional on-hold occurrence to resolve. When set the signal is addressed to that episode alone;  when empty every parked branch of the workflow answers it, whichever reads it first.
     * @type {string}
     * @memberof PbSendSignalToWorkflowRequest
     */
    'on_hold_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbSendSignalToWorkflowRequest
     */
    'signal'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbSendSignalToWorkflowRequest
     */
    'workflow_id'?: string;
}
/**
 * SendTestWebhookRequest names the webhook to sample and where to send it.
 * @export
 * @interface PbSendTestWebhookRequest
 */
export interface PbSendTestWebhookRequest {
    /**
     * The ecommerce id
     * @type {string}
     * @memberof PbSendTestWebhookRequest
     */
    'ecommerce_id'?: string;
    /**
     * Destination URL the sample is POSTed to. It need not be saved yet, so a URL can be  checked before subscribing to it. A URL without a scheme gets https://.
     * @type {string}
     * @memberof PbSendTestWebhookRequest
     */
    'url'?: string;
    /**
     * The webhook whose sample is sent, which sets the payload\'s event_name
     * @type {string}
     * @memberof PbSendTestWebhookRequest
     */
    'webhook'?: PbSendTestWebhookRequestWebhookEnum;
}

export const PbSendTestWebhookRequestWebhookEnum = {
    Unspecified: 'WEBHOOK_SUBSCRIPTION_TYPE_UNSPECIFIED',
    OnStart: 'WEBHOOK_SUBSCRIPTION_TYPE_ON_START',
    OnCompleted: 'WEBHOOK_SUBSCRIPTION_TYPE_ON_COMPLETED'
} as const;

export type PbSendTestWebhookRequestWebhookEnum = typeof PbSendTestWebhookRequestWebhookEnum[keyof typeof PbSendTestWebhookRequestWebhookEnum];

/**
 * SendTestWebhookResponse reports how the destination answered the sample.
 * @export
 * @interface PbSendTestWebhookResponse
 */
export interface PbSendTestWebhookResponse {
    /**
     * Whether the destination answered with a 2xx status, which is what a real delivery  needs to count as delivered
     * @type {boolean}
     * @memberof PbSendTestWebhookResponse
     */
    'delivered'?: boolean;
    /**
     * Technical detail of a failure to reach the destination, such as a DNS or TLS error
     * @type {string}
     * @memberof PbSendTestWebhookResponse
     */
    'error'?: string;
    /**
     * The payload\'s event_name
     * @type {string}
     * @memberof PbSendTestWebhookResponse
     */
    'event_name'?: string;
    /**
     * Why the sample was not delivered; unspecified when it was
     * @type {string}
     * @memberof PbSendTestWebhookResponse
     */
    'failure'?: PbSendTestWebhookResponseFailureEnum;
    /**
     * First bytes of the destination\'s response body, to tell why it refused the sample
     * @type {string}
     * @memberof PbSendTestWebhookResponse
     */
    'response_body'?: string;
    /**
     * Whether the sample carried an X-REVER-Signature header. False when the ecommerce\'s  group has no signing secret, in which case real deliveries go unsigned too.
     * @type {boolean}
     * @memberof PbSendTestWebhookResponse
     */
    'signed'?: boolean;
    /**
     * HTTP status the destination answered with; 0 when it never answered
     * @type {number}
     * @memberof PbSendTestWebhookResponse
     */
    'status_code'?: number;
    /**
     * The URL the sample was sent to, after normalization
     * @type {string}
     * @memberof PbSendTestWebhookResponse
     */
    'url'?: string;
}

export const PbSendTestWebhookResponseFailureEnum = {
    Unspecified: 'TEST_WEBHOOK_FAILURE_UNSPECIFIED',
    Rejected: 'TEST_WEBHOOK_FAILURE_REJECTED',
    Unreachable: 'TEST_WEBHOOK_FAILURE_UNREACHABLE',
    Timeout: 'TEST_WEBHOOK_FAILURE_TIMEOUT',
    Redirect: 'TEST_WEBHOOK_FAILURE_REDIRECT',
    NonPublicAddress: 'TEST_WEBHOOK_FAILURE_NON_PUBLIC_ADDRESS'
} as const;

export type PbSendTestWebhookResponseFailureEnum = typeof PbSendTestWebhookResponseFailureEnum[keyof typeof PbSendTestWebhookResponseFailureEnum];

/**
 * 
 * @export
 * @interface PbSequraCredentials
 */
export interface PbSequraCredentials {
    /**
     * Is active
     * @type {boolean}
     * @memberof PbSequraCredentials
     */
    'is_active'?: boolean;
    /**
     * Password
     * @type {string}
     * @memberof PbSequraCredentials
     */
    'password'?: string;
    /**
     * Username
     * @type {string}
     * @memberof PbSequraCredentials
     */
    'username'?: string;
}
/**
 * ServiceDefault holds a group\'s label options for a carrier, applied to every connection of that carrier.
 * @export
 * @interface PbServiceDefault
 */
export interface PbServiceDefault {
    /**
     * Carrier the options apply to, e.g. \"ups\".
     * @type {string}
     * @memberof PbServiceDefault
     */
    'carrier'?: string;
    /**
     * Ecommerce group.
     * @type {string}
     * @memberof PbServiceDefault
     */
    'group'?: string;
    /**
     * Service default id, assigned on create.
     * @type {string}
     * @memberof PbServiceDefault
     */
    'id'?: string;
    /**
     * Lane the options apply to; empty means every lane.
     * @type {string}
     * @memberof PbServiceDefault
     */
    'lane'?: string;
    /**
     * Label options, keyed as the provider declares them.
     * @type {{ [key: string]: string; }}
     * @memberof PbServiceDefault
     */
    'options'?: { [key: string]: string; };
    /**
     * Partner the carrier is booked through; empty for a direct booking.
     * @type {string}
     * @memberof PbServiceDefault
     */
    'partner'?: string;
}
/**
 * Business rule for service fees
 * @export
 * @interface PbServiceFeesRule
 */
export interface PbServiceFeesRule {
    /**
     * apply_only_if_payment_at_checkout
     * @type {boolean}
     * @memberof PbServiceFeesRule
     */
    'apply_only_if_payment_at_checkout'?: boolean;
    /**
     * Service fee amount
     * @type {string}
     * @memberof PbServiceFeesRule
     */
    'service_fee_amount'?: string;
    /**
     * Service fee percentage
     * @type {number}
     * @memberof PbServiceFeesRule
     */
    'service_fee_percentage'?: number;
    /**
     * When conditions to evaluate
     * @type {Array<string>}
     * @memberof PbServiceFeesRule
     */
    'whens'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PbSetReturnLogisticDataRequest
 */
export interface PbSetReturnLogisticDataRequest {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof PbSetReturnLogisticDataRequest
     */
    'ecommerce_id'?: string;
    /**
     * Logistic data
     * @type {PbLogisticData}
     * @memberof PbSetReturnLogisticDataRequest
     */
    'logistic_data'?: PbLogisticData;
    /**
     * Order ID
     * @type {string}
     * @memberof PbSetReturnLogisticDataRequest
     */
    'order_id'?: string;
    /**
     * Return process platform ID
     * @type {string}
     * @memberof PbSetReturnLogisticDataRequest
     */
    'return_process_id'?: string;
}
/**
 * 
 * @export
 * @interface PbSetReturnLogisticDataResponse
 */
export interface PbSetReturnLogisticDataResponse {
    /**
     * Whether the request was successful
     * @type {boolean}
     * @memberof PbSetReturnLogisticDataResponse
     */
    'success'?: boolean;
}
/**
 * SetRouteConnectionRequest names the connection an ecommerce\'s routes for a carrier book with.
 * @export
 * @interface PbSetRouteConnectionRequest
 */
export interface PbSetRouteConnectionRequest {
    /**
     * Carrier section the routes read, e.g. dhl for dhlexpress routes; partner routes match by their own carrier.
     * @type {string}
     * @memberof PbSetRouteConnectionRequest
     */
    'carrier'?: string;
    /**
     * Connection the routes book with; empty makes them book the carrier\'s default connection of the group.
     * @type {string}
     * @memberof PbSetRouteConnectionRequest
     */
    'carrier_connection_id'?: string;
    /**
     * Ecommerce whose routes change.
     * @type {string}
     * @memberof PbSetRouteConnectionRequest
     */
    'ecommerce_id'?: string;
    /**
     * Provider of the routes; empty changes the carrier\'s routes of every provider.
     * @type {string}
     * @memberof PbSetRouteConnectionRequest
     */
    'provider'?: string;
}
/**
 * SetRouteConnectionResponse says how many routes changed.
 * @export
 * @interface PbSetRouteConnectionResponse
 */
export interface PbSetRouteConnectionResponse {
    /**
     * Number of routes now naming the connection, or naming none.
     * @type {number}
     * @memberof PbSetRouteConnectionResponse
     */
    'routes'?: number;
}
/**
 * SetRouteOptionsRequest sets the label options of an ecommerce\'s routes for a carrier.
 * @export
 * @interface PbSetRouteOptionsRequest
 */
export interface PbSetRouteOptionsRequest {
    /**
     * Carrier section the routes read, e.g. dhl for dhlexpress routes; partner routes match by their own carrier.
     * @type {string}
     * @memberof PbSetRouteOptionsRequest
     */
    'carrier'?: string;
    /**
     * Ecommerce whose routes change.
     * @type {string}
     * @memberof PbSetRouteOptionsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Label options to set, at least one, keyed as the provider declares them.  A blank value unsets the key, and keys not sent are kept.
     * @type {{ [key: string]: string; }}
     * @memberof PbSetRouteOptionsRequest
     */
    'options'?: { [key: string]: string; };
    /**
     * Provider of the routes; empty changes the carrier\'s routes of every provider.
     * @type {string}
     * @memberof PbSetRouteOptionsRequest
     */
    'provider'?: string;
}
/**
 * SetRouteOptionsResponse says how many routes changed.
 * @export
 * @interface PbSetRouteOptionsResponse
 */
export interface PbSetRouteOptionsResponse {
    /**
     * Number of routes the options were set on.
     * @type {number}
     * @memberof PbSetRouteOptionsResponse
     */
    'routes'?: number;
}
/**
 * A shop confirming the registration handshake.
 * @export
 * @interface PbSetShopwareAppInstallationCredentialsRequest
 */
export interface PbSetShopwareAppInstallationCredentialsRequest {
    /**
     * The app integration\'s OAuth client id.
     * @type {string}
     * @memberof PbSetShopwareAppInstallationCredentialsRequest
     */
    'client_id'?: string;
    /**
     * The app integration\'s OAuth client secret.
     * @type {string}
     * @memberof PbSetShopwareAppInstallationCredentialsRequest
     */
    'client_secret'?: string;
    /**
     * The shop\'s id.
     * @type {string}
     * @memberof PbSetShopwareAppInstallationCredentialsRequest
     */
    'shop_id'?: string;
    /**
     * The pending shop secret the confirmation was verified with. A mismatch means another  registration started since, and the confirmation is refused.
     * @type {string}
     * @memberof PbSetShopwareAppInstallationCredentialsRequest
     */
    'shop_secret'?: string;
    /**
     * The shop\'s Admin API base URL.
     * @type {string}
     * @memberof PbSetShopwareAppInstallationCredentialsRequest
     */
    'shop_url'?: string;
}
/**
 * Outcome of pushing new client credentials to the linked e-commerces.
 * @export
 * @interface PbSetShopwareAppInstallationCredentialsResponse
 */
export interface PbSetShopwareAppInstallationCredentialsResponse {
    /**
     * One result per e-commerce the installation linked.
     * @type {Array<PbShopwareAppLinkResult>}
     * @memberof PbSetShopwareAppInstallationCredentialsResponse
     */
    'results'?: Array<PbShopwareAppLinkResult>;
}
/**
 * SetSizeSuggestionsSettingsRequest patches the Size Suggestions configuration  of one merchant. Only the fields present in the request are written; an absent  field leaves the stored value untouched, so enabling a merchant does not  require restating its traffic allocation.
 * @export
 * @interface PbSetSizeSuggestionsSettingsRequest
 */
export interface PbSetSizeSuggestionsSettingsRequest {
    /**
     * EcommerceID. Required.
     * @type {string}
     * @memberof PbSetSizeSuggestionsSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * What the pipeline may do for this merchant.
     * @type {string}
     * @memberof PbSetSizeSuggestionsSettingsRequest
     */
    'mode'?: PbSetSizeSuggestionsSettingsRequestModeEnum;
    /**
     * Percentage of visitors bucketed into `see_banner`. Must be 0-100.
     * @type {number}
     * @memberof PbSetSizeSuggestionsSettingsRequest
     */
    'traffic_allocation'?: number;
}

export const PbSetSizeSuggestionsSettingsRequestModeEnum = {
    Unspecified: 'SIZE_SUGGESTIONS_MODE_UNSPECIFIED',
    Off: 'SIZE_SUGGESTIONS_MODE_OFF',
    ResultsOnly: 'SIZE_SUGGESTIONS_MODE_RESULTS_ONLY',
    Full: 'SIZE_SUGGESTIONS_MODE_FULL'
} as const;

export type PbSetSizeSuggestionsSettingsRequestModeEnum = typeof PbSetSizeSuggestionsSettingsRequestModeEnum[keyof typeof PbSetSizeSuggestionsSettingsRequestModeEnum];

/**
 * 
 * @export
 * @interface PbSetStoreAddressRequest
 */
export interface PbSetStoreAddressRequest {
    /**
     * Store address to set. Required.
     * @type {ModelsAddress}
     * @memberof PbSetStoreAddressRequest
     */
    'address'?: ModelsAddress;
    /**
     * ID of the return process to update. Required.
     * @type {string}
     * @memberof PbSetStoreAddressRequest
     */
    'process_id'?: string;
    /**
     * User performing the action (for audit trail). Required.
     * @type {string}
     * @memberof PbSetStoreAddressRequest
     */
    'user'?: string;
}
/**
 * SetUserBlockedRequest
 * @export
 * @interface PbSetUserBlockedRequest
 */
export interface PbSetUserBlockedRequest {
    /**
     * blocked
     * @type {boolean}
     * @memberof PbSetUserBlockedRequest
     */
    'blocked'?: boolean;
    /**
     * Optional. Scopes the write to this ecommerce\'s group instead of the caller\'s own,  for REVER staff acting on a merchant. See UpdateUserRequest.ecommerce_id.
     * @type {string}
     * @memberof PbSetUserBlockedRequest
     */
    'ecommerce_id'?: string;
    /**
     * Auth0 user id
     * @type {string}
     * @memberof PbSetUserBlockedRequest
     */
    'id'?: string;
}
/**
 * SetWfpSettingsRequest is the request to set the WFP state for a merchant.  Called by the activation/deactivation orchestrator. The `enabled` field  selects between enable and disable behavior. Idempotent.   When `enabled` is true, `seel_merchant_id`, `currency`, and  `shopify_wfp_product_id` are required. When `enabled` is false, those fields  are ignored.
 * @export
 * @interface PbSetWfpSettingsRequest
 */
export interface PbSetWfpSettingsRequest {
    /**
     * Whether and when the WFP Cover line item is fulfilled on Shopify. Optional;  UNSPECIFIED leaves the stored value unchanged on update and defaults to  FULFILL_AFTER_ITEM_FULFILLMENT for new rows.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'cover_fulfillment_mode'?: PbSetWfpSettingsRequestCoverFulfillmentModeEnum;
    /**
     * ISO 4217 currency code snapshotted from ecommerces.currency_code at  activation time. Required when `enabled` is true.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'currency'?: string;
    /**
     * EcommerceID. Required.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Whether to enable (true) or disable (false) Worry Free Purchase for the  merchant.
     * @type {boolean}
     * @memberof PbSetWfpSettingsRequest
     */
    'enabled'?: boolean;
    /**
     * Logistic recipes applied only to WFP free returns. Seeded with the REVER  default template at activation; preserved on re-activation when already set.
     * @type {Array<PbReturnLogistics>}
     * @memberof PbSetWfpSettingsRequest
     */
    'free_return_logistics'?: Array<PbReturnLogistics>;
    /**
     * URL of the image used for the WFP Shopify product. Required when  `enabled` is true.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'product_image_url'?: string;
    /**
     * Display name of the WFP product as created in Shopify. Required when  `enabled` is true.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'product_title'?: string;
    /**
     * Admin domain registered with Seel for this merchant (e.g.  \"my-shop.myshopify.com\"). Required when `enabled` is true — Seel  resolves the merchant by admin_domain on every quote call.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'seel_admin_domain'?: string;
    /**
     * Seel-side merchant_id returned by Seel. Required when `enabled` is true.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'seel_merchant_id'?: string;
    /**
     * Numeric Shopify product id for the WFP product (the trailing segment of  the `gid://shopify/Product/...` GID, without the prefix). Required when  `enabled` is true.
     * @type {string}
     * @memberof PbSetWfpSettingsRequest
     */
    'shopify_wfp_product_id'?: string;
}

export const PbSetWfpSettingsRequestCoverFulfillmentModeEnum = {
    Unspecified: 'WFP_COVER_FULFILLMENT_MODE_UNSPECIFIED',
    FulfillOnPurchase: 'WFP_COVER_FULFILLMENT_MODE_FULFILL_ON_PURCHASE',
    NeverFulfill: 'WFP_COVER_FULFILLMENT_MODE_NEVER_FULFILL',
    FulfillAfterItemFulfillment: 'WFP_COVER_FULFILLMENT_MODE_FULFILL_AFTER_ITEM_FULFILLMENT'
} as const;

export type PbSetWfpSettingsRequestCoverFulfillmentModeEnum = typeof PbSetWfpSettingsRequestCoverFulfillmentModeEnum[keyof typeof PbSetWfpSettingsRequestCoverFulfillmentModeEnum];

/**
 * 
 * @export
 * @interface PbSetWithdrawalRequestClosedRequest
 */
export interface PbSetWithdrawalRequestClosedRequest {
    /**
     * True to close it, false to reopen it
     * @type {boolean}
     * @memberof PbSetWithdrawalRequestClosedRequest
     */
    'closed'?: boolean;
    /**
     * E-commerce the request belongs to. Required.
     * @type {string}
     * @memberof PbSetWithdrawalRequestClosedRequest
     */
    'ecommerce_id'?: string;
    /**
     * ID of the withdrawal request. Required.
     * @type {string}
     * @memberof PbSetWithdrawalRequestClosedRequest
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PbSetWithdrawalRequestClosedResponse
 */
export interface PbSetWithdrawalRequestClosedResponse {
    /**
     * When it was closed. Empty when it was reopened.
     * @type {string}
     * @memberof PbSetWithdrawalRequestClosedResponse
     */
    'closed_at'?: string;
}
/**
 * SetWithdrawalSettingsRequest turns the EU withdrawal button on or off for an  e-commerce\'s portal.
 * @export
 * @interface PbSetWithdrawalSettingsRequest
 */
export interface PbSetWithdrawalSettingsRequest {
    /**
     * E-commerce to configure. Required.
     * @type {string}
     * @memberof PbSetWithdrawalSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Whether the portal gets the withdrawal button.
     * @type {boolean}
     * @memberof PbSetWithdrawalSettingsRequest
     */
    'enabled'?: boolean;
}
/**
 * ShippingCost keeps the data for the shipping cost of an order
 * @export
 * @interface PbShippingCost
 */
export interface PbShippingCost {
    /**
     * Total amount of shipping cost in customer currency
     * @type {string}
     * @memberof PbShippingCost
     */
    'total'?: string;
}
/**
 * ShopifyAppAutomationToken describes a Shopify store\'s App Automation token without revealing it.
 * @export
 * @interface PbShopifyAppAutomationToken
 */
export interface PbShopifyAppAutomationToken {
    /**
     * When the token expires; unset when the store has no token, or a token saved without its expiry.
     * @type {string}
     * @memberof PbShopifyAppAutomationToken
     */
    'expires_at'?: string;
    /**
     * Whether REVER deploys its Shopify app to the store, which takes the token: WFP or size suggestions are on.
     * @type {boolean}
     * @memberof PbShopifyAppAutomationToken
     */
    'required'?: boolean;
    /**
     * Whether the store has a token.
     * @type {boolean}
     * @memberof PbShopifyAppAutomationToken
     */
    'token_set'?: boolean;
}
/**
 * ShopifyOAuthCallbackResponse is returned after successfully processing the OAuth callback  and exchanging the authorization code for credentials.
 * @export
 * @interface PbShopifyOAuthCallbackResponse
 */
export interface PbShopifyOAuthCallbackResponse {
    /**
     * The ecommerce ID where the credentials were saved
     * @type {string}
     * @memberof PbShopifyOAuthCallbackResponse
     */
    'ecommerce_id'?: string;
}
/**
 * Specific settings for an e-commerce using the Shopify platform
 * @export
 * @interface PbShopifySettings
 */
export interface PbShopifySettings {
    /**
     * OAuth2 Access Token URL
     * @type {string}
     * @memberof PbShopifySettings
     */
    'access_token_url'?: string;
    /**
     * API token generated when installing the REVER app in Shopify
     * @type {string}
     * @memberof PbShopifySettings
     */
    'api_token'?: string;
    /**
     * App Automation Token generated in the Shopify Dev Dashboard. Used by the  WFP CI workflow as `SHOPIFY_APP_AUTOMATION_TOKEN` to run  `shopify app deploy --client-id=<id>`. Expires (max 6 months); rotated  from the dashboard\'s Integrations page (SaveShopifyAppAutomationToken).
     * @type {string}
     * @memberof PbShopifySettings
     */
    'app_automation_token'?: string;
    /**
     * Expiration date of `app_automation_token` (ISO 8601). Used by the WFP  activation orchestrator pre-check and shown in the dashboard\'s  Integrations page.
     * @type {string}
     * @memberof PbShopifySettings
     */
    'app_automation_token_expires_at'?: string;
    /**
     * OAuth2 Client ID
     * @type {string}
     * @memberof PbShopifySettings
     */
    'client_id'?: string;
    /**
     * OAuth2 Client Secret
     * @type {string}
     * @memberof PbShopifySettings
     */
    'client_secret'?: string;
    /**
     * Is Returns API enabled
     * @type {boolean}
     * @memberof PbShopifySettings
     */
    'is_returns_api_enabled'?: boolean;
    /**
     * Mark items as refunded in Shopify
     * @type {boolean}
     * @memberof PbShopifySettings
     */
    'mark_items_as_refunded'?: boolean;
    /**
     * ID of the store in shopify
     * @type {string}
     * @memberof PbShopifySettings
     */
    'store_id'?: string;
    /**
     * Token generated at onboarding time, used to create exchange orders
     * @type {string}
     * @memberof PbShopifySettings
     */
    'storefront_token'?: string;
}
/**
 * A Shopware shop that installed the REVER app.
 * @export
 * @interface PbShopwareAppInstallation
 */
export interface PbShopwareAppInstallation {
    /**
     * The app integration\'s OAuth client id. Empty until the handshake is confirmed.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'client_id'?: string;
    /**
     * The app integration\'s OAuth client secret. Empty until the handshake is confirmed.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'client_secret'?: string;
    /**
     * The installation\'s id, e.g. swapp_... A reinstall after an uninstall gets a new one.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'id'?: string;
    /**
     * The version of the installation\'s links, to pass to SyncShopwareAppLinksInternal.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'links_version'?: string;
    /**
     * The shop secret of a registration not confirmed yet. Empty when none is pending.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'pending_shop_secret'?: string;
    /**
     * The URL of a registration not confirmed yet. Empty when none is pending.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'pending_shop_url'?: string;
    /**
     * The shop secret the last confirmation replaced, while it still verifies requests: for 60 seconds  after secrets_rotated_at. Empty otherwise.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'previous_shop_secret'?: string;
    /**
     * When the last confirmation rotated the shop secret. Unset if it never did.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'secrets_rotated_at'?: string;
    /**
     * The shop\'s id, as Shopware sends it on every request.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'shop_id'?: string;
    /**
     * The per-shop secret that signs Shopware\'s requests after registration.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'shop_secret'?: string;
    /**
     * The shop\'s Admin API base URL, e.g. https://shop.example.com.
     * @type {string}
     * @memberof PbShopwareAppInstallation
     */
    'shop_url'?: string;
    /**
     * Whether a registration\'s shopware-shop-signature verified. Once set, every re-registration of  the confirmed shop, and its confirmation, must be signed with the current shop secret.
     * @type {boolean}
     * @memberof PbShopwareAppInstallation
     */
    'verified_with_double_signature'?: boolean;
}
/**
 * One e-commerce a shop\'s app configuration names.
 * @export
 * @interface PbShopwareAppLink
 */
export interface PbShopwareAppLink {
    /**
     * The e-commerce to link. It must be a Shopware e-commerce.
     * @type {string}
     * @memberof PbShopwareAppLink
     */
    'ecommerce_id'?: string;
    /**
     * The shop\'s sales channels set to this e-commerce. An empty id is \"All Sales Channels\".
     * @type {Array<string>}
     * @memberof PbShopwareAppLink
     */
    'sales_channel_ids'?: Array<string>;
}
/**
 * Outcome for one e-commerce.
 * @export
 * @interface PbShopwareAppLinkResult
 */
export interface PbShopwareAppLinkResult {
    /**
     * The e-commerce.
     * @type {string}
     * @memberof PbShopwareAppLinkResult
     */
    'ecommerce_id'?: string;
    /**
     * Why it was refused. Empty otherwise.
     * @type {string}
     * @memberof PbShopwareAppLinkResult
     */
    'reason'?: string;
    /**
     * Whether it was linked, refused or unlinked.
     * @type {string}
     * @memberof PbShopwareAppLinkResult
     */
    'status'?: PbShopwareAppLinkResultStatusEnum;
}

export const PbShopwareAppLinkResultStatusEnum = {
    Unspecified: 'SHOPWARE_APP_LINK_STATUS_UNSPECIFIED',
    Linked: 'SHOPWARE_APP_LINK_STATUS_LINKED',
    Refused: 'SHOPWARE_APP_LINK_STATUS_REFUSED',
    Unlinked: 'SHOPWARE_APP_LINK_STATUS_UNLINKED'
} as const;

export type PbShopwareAppLinkResultStatusEnum = typeof PbShopwareAppLinkResultStatusEnum[keyof typeof PbShopwareAppLinkResultStatusEnum];

/**
 * Specific settings for an e-commerce using the Shopware platform
 * @export
 * @interface PbShopwareSettings
 */
export interface PbShopwareSettings {
    /**
     * Base URL of the Shopware API
     * @type {string}
     * @memberof PbShopwareSettings
     */
    'api_base_url'?: string;
    /**
     * OAuth2 API access token (obtained via OAuth2 flow)
     * @type {string}
     * @memberof PbShopwareSettings
     */
    'api_token'?: string;
    /**
     * OAuth2 Client ID (Access Key ID)
     * @type {string}
     * @memberof PbShopwareSettings
     */
    'client_id'?: string;
    /**
     * OAuth2 Client Secret (Access Key Secret)
     * @type {string}
     * @memberof PbShopwareSettings
     */
    'client_secret'?: string;
    /**
     * Default Sales Channel API Key for Store API endpoints  Corresponds to Shopware\'s sw-access-key header
     * @type {string}
     * @memberof PbShopwareSettings
     */
    'default_channel_api_key'?: string;
    /**
     * OAuth2 Grant Type (should be \"client_credentials\")
     * @type {string}
     * @memberof PbShopwareSettings
     */
    'grant_type'?: string;
}
/**
 * A single Salesforce site entry for multi-site configurations
 * @export
 * @interface PbSiteEntry
 */
export interface PbSiteEntry {
    /**
     * ID of the product catalog for this site; empty falls back to the portal-level catalog_id
     * @type {string}
     * @memberof PbSiteEntry
     */
    'catalog_id'?: string;
    /**
     * ID of the B2C Commerce site
     * @type {string}
     * @memberof PbSiteEntry
     */
    'site_id'?: string;
}
/**
 * SizeSuggestionsSettings is the per-ecommerce Size Suggestions configuration.  Read by the serving endpoint on every product page (cached), by the Shopify  app deploy CI, and by the scheduler that decides which merchants to run.
 * @export
 * @interface PbSizeSuggestionsSettings
 */
export interface PbSizeSuggestionsSettings {
    /**
     * When this Size Suggestions settings row was first created.
     * @type {string}
     * @memberof PbSizeSuggestionsSettings
     */
    'created_at'?: string;
    /**
     * EcommerceID. Primary key.
     * @type {string}
     * @memberof PbSizeSuggestionsSettings
     */
    'ecommerce_id'?: string;
    /**
     * What the pipeline may do for this merchant.
     * @type {string}
     * @memberof PbSizeSuggestionsSettings
     */
    'mode'?: PbSizeSuggestionsSettingsModeEnum;
    /**
     * Percentage of visitors bucketed into the `see_banner` A/B group, 0-100. The  remainder is the holdout that never sees a banner, which is what makes the  effect measurable. Defaults to 90.
     * @type {number}
     * @memberof PbSizeSuggestionsSettings
     */
    'traffic_allocation'?: number;
    /**
     * Last time this Size Suggestions settings row was updated.
     * @type {string}
     * @memberof PbSizeSuggestionsSettings
     */
    'updated_at'?: string;
}

export const PbSizeSuggestionsSettingsModeEnum = {
    Unspecified: 'SIZE_SUGGESTIONS_MODE_UNSPECIFIED',
    Off: 'SIZE_SUGGESTIONS_MODE_OFF',
    ResultsOnly: 'SIZE_SUGGESTIONS_MODE_RESULTS_ONLY',
    Full: 'SIZE_SUGGESTIONS_MODE_FULL'
} as const;

export type PbSizeSuggestionsSettingsModeEnum = typeof PbSizeSuggestionsSettingsModeEnum[keyof typeof PbSizeSuggestionsSettingsModeEnum];

/**
 * SkippedExternalRefund is an external refund line that was not deducted.
 * @export
 * @interface PbSkippedExternalRefund
 */
export interface PbSkippedExternalRefund {
    /**
     * Platform line item id of the refund line; empty when the whole refund was skipped.
     * @type {string}
     * @memberof PbSkippedExternalRefund
     */
    'line_item_id'?: string;
    /**
     * Platform refund id of the external refund.
     * @type {string}
     * @memberof PbSkippedExternalRefund
     */
    'platform_refund_id'?: string;
    /**
     * Platform id of the money movement skipped; empty when a whole refund or a refund line was  skipped rather than one movement. A refund can move money more than once, so without it two  movements of the same refund are indistinguishable.
     * @type {string}
     * @memberof PbSkippedExternalRefund
     */
    'platform_transaction_id'?: string;
    /**
     * Why it was skipped. One of: already_applied, already_applied_on_sibling,  already_deducted_on_summary, line_item_not_returned, currency_mismatch, non_positive_amount,  missing_platform_refund_id, missing_line_item_id, refunded_before_process_start,  already_in_ledger, already_in_ledger_pending_confirmation, missing_platform_transaction_id,  amount_matched_in_ledger, marked_as_refunded_externally or movement_not_found. Treat it as an  open set.
     * @type {string}
     * @memberof PbSkippedExternalRefund
     */
    'reason'?: string;
}
/**
 * StartReturnCompensation is the compensation for the return
 * @export
 * @interface PbStartReturnCompensation
 */
export interface PbStartReturnCompensation {
    /**
     * StartReturnCompensation amount
     * @type {PbEcommerceMoney}
     * @memberof PbStartReturnCompensation
     */
    'amount_opm'?: PbEcommerceMoney;
}
/**
 * 
 * @export
 * @interface PbStartReturnLineItem
 */
export interface PbStartReturnLineItem {
    /**
     * Line item id
     * @type {string}
     * @memberof PbStartReturnLineItem
     */
    'line_item_id'?: string;
    /**
     * note for the return of this item
     * @type {string}
     * @memberof PbStartReturnLineItem
     */
    'note'?: string;
    /**
     * Number of items of this type being returned. Must be > 0.
     * @type {number}
     * @memberof PbStartReturnLineItem
     */
    'quantity'?: number;
    /**
     * reason for the return
     * @type {string}
     * @memberof PbStartReturnLineItem
     */
    'reason'?: string;
    /**
     * total in presentment currency
     * @type {PbEcommerceMoney}
     * @memberof PbStartReturnLineItem
     */
    'total_in_presentment_currency'?: PbEcommerceMoney;
}
/**
 * 
 * @export
 * @interface PbStartReturnProcessRequest
 */
export interface PbStartReturnProcessRequest {
    /**
     * StartReturnCompensation data
     * @type {PbStartReturnCompensation}
     * @memberof PbStartReturnProcessRequest
     */
    'compensation'?: PbStartReturnCompensation;
    /**
     * ecommerce id
     * @type {string}
     * @memberof PbStartReturnProcessRequest
     */
    'ecommerce_id'?: string;
    /**
     * group
     * @type {string}
     * @memberof PbStartReturnProcessRequest
     */
    'ecommmerce_group'?: string;
    /**
     * timing of the request to start the return( on start / on item verification)
     * @type {string}
     * @memberof PbStartReturnProcessRequest
     */
    'execution_time'?: string;
    /**
     * Items of the return
     * @type {Array<PbStartReturnLineItem>}
     * @memberof PbStartReturnProcessRequest
     */
    'line_items'?: Array<PbStartReturnLineItem>;
    /**
     * order id (not the customer printed order id)
     * @type {string}
     * @memberof PbStartReturnProcessRequest
     */
    'order_id'?: string;
    /**
     * Ordered items
     * @type {Array<PbReturnOrderedItem>}
     * @memberof PbStartReturnProcessRequest
     */
    'ordered_items'?: Array<PbReturnOrderedItem>;
    /**
     * Previous return processes
     * @type {Array<PbPreviousOrderReturnProcess>}
     * @memberof PbStartReturnProcessRequest
     */
    'previous_order_return_processes'?: Array<PbPreviousOrderReturnProcess>;
    /**
     * Return customer
     * @type {PbReturnCustomer}
     * @memberof PbStartReturnProcessRequest
     */
    'return_customer'?: PbReturnCustomer;
    /**
     * return logistics info
     * @type {PbReturnLogisticsInfo}
     * @memberof PbStartReturnProcessRequest
     */
    'return_logistics_info'?: PbReturnLogisticsInfo;
    /**
     * Return Fee Shipping
     * @type {PbEcommerceMoney}
     * @memberof PbStartReturnProcessRequest
     */
    'return_shipping_fee'?: PbEcommerceMoney;
    /**
     * rever return process id
     * @type {string}
     * @memberof PbStartReturnProcessRequest
     */
    'rever_return_process_id'?: string;
    /**
     * Start return on platform time
     * @type {string}
     * @memberof PbStartReturnProcessRequest
     */
    'start_return_on_platform_time'?: string;
}
/**
 * 
 * @export
 * @interface PbStartReturnProcessResponse
 */
export interface PbStartReturnProcessResponse {
    /**
     * Return process ID from the REVER platform
     * @type {string}
     * @memberof PbStartReturnProcessResponse
     */
    'return_platform_id'?: string;
}
/**
 * SubmitWfpClaimRequest identifies the return process whose claim to file.
 * @export
 * @interface PbSubmitWfpClaimRequest
 */
export interface PbSubmitWfpClaimRequest {
    /**
     * True when the shopper has finished uploading damage photo evidence: a  damaged claim then submits with claim_type=damage and the uploaded  document URLs as attachments instead of deferring.
     * @type {boolean}
     * @memberof PbSubmitWfpClaimRequest
     */
    'photos_uploaded'?: boolean;
    /**
     * Return process id. Required.
     * @type {string}
     * @memberof PbSubmitWfpClaimRequest
     */
    'return_process_id'?: string;
}
/**
 * SubmitWfpClaimResponse reports the submission outcome.
 * @export
 * @interface PbSubmitWfpClaimResponse
 */
export interface PbSubmitWfpClaimResponse {
    /**
     * Outcome of the submission. One of:    \"submitted\"                       - claim filed at Seel; persist via SaveWfpClaim    \"not_a_claim\"                     - return reasons are not claim reasons, or no contract    \"deferred_pending_photos\"         - damaged claim; submission waits for photo evidence    \"claim_already_exists_for_return\" - this return process already has a claim    \"coverage_not_allowed\"            - contract not active or outside coverage window
     * @type {string}
     * @memberof PbSubmitWfpClaimResponse
     */
    'result'?: string;
    /**
     * Seel-assigned claim id. Populated when result = \"submitted\".
     * @type {string}
     * @memberof PbSubmitWfpClaimResponse
     */
    'seel_claim_id'?: string;
    /**
     * Seel contract the claim was filed against. Populated when result = \"submitted\".
     * @type {string}
     * @memberof PbSubmitWfpClaimResponse
     */
    'wfp_contract_id'?: string;
}
/**
 * Request to connect a PrestaShop module installation to e-commerces
 * @export
 * @interface PbSyncPrestashopLinksRequest
 */
export interface PbSyncPrestashopLinksRequest {
    /**
     * URL of the store\'s admin panel
     * @type {string}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'admin_url'?: string;
    /**
     * Base URL of the store\'s API
     * @type {string}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'api_base_url'?: string;
    /**
     * Webservice API key generated by the module. Required unless ecommerce_ids is empty
     * @type {string}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'api_key'?: string;
    /**
     * Installation path of the REVER PrestaShop module
     * @type {string}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'api_module_path'?: string;
    /**
     * Every PrestaShop e-commerce the installation should be connected to, without  duplicates. Empty deactivates all its connections, and the fields below are then ignored
     * @type {Array<string>}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'ecommerce_ids'?: Array<string>;
    /**
     * The module installation to connect, as minted by ecommerce-api on register
     * @type {string}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'registration_id'?: string;
    /**
     * Whether authentication with PrestaShop is done with query string  or using the header. Default: false (header)
     * @type {boolean}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'use_query_string_auth'?: boolean;
    /**
     * E-commerces of ecommerce_ids connected via the legacy flow whose store, at  the URL already stored for them, proved it runs this installation. Only  these legacy connections may be taken over; their api_key is replaced by this request\'s
     * @type {Array<string>}
     * @memberof PbSyncPrestashopLinksRequest
     */
    'verified_legacy_ecommerce_ids'?: Array<string>;
}
/**
 * Result of syncing a module installation\'s e-commerces
 * @export
 * @interface PbSyncPrestashopLinksResponse
 */
export interface PbSyncPrestashopLinksResponse {
    /**
     * E-commerces this call switched from active to inactive because the request  no longer lists them, sorted
     * @type {Array<string>}
     * @memberof PbSyncPrestashopLinksResponse
     */
    'unlinked_ecommerce_ids'?: Array<string>;
}
/**
 * The full set of e-commerces a shop\'s app installation should link.
 * @export
 * @interface PbSyncShopwareAppLinksRequest
 */
export interface PbSyncShopwareAppLinksRequest {
    /**
     * The links_version the links were computed from.
     * @type {string}
     * @memberof PbSyncShopwareAppLinksRequest
     */
    'expected_links_version'?: string;
    /**
     * Every e-commerce to link. E-commerces linked today and missing here lose their link  but keep their credentials.
     * @type {Array<PbShopwareAppLink>}
     * @memberof PbSyncShopwareAppLinksRequest
     */
    'links'?: Array<PbShopwareAppLink>;
    /**
     * The shop\'s id.
     * @type {string}
     * @memberof PbSyncShopwareAppLinksRequest
     */
    'shop_id'?: string;
}
/**
 * Outcome of a links sync.
 * @export
 * @interface PbSyncShopwareAppLinksResponse
 */
export interface PbSyncShopwareAppLinksResponse {
    /**
     * The installation\'s new links_version.
     * @type {string}
     * @memberof PbSyncShopwareAppLinksResponse
     */
    'links_version'?: string;
    /**
     * One result per requested e-commerce, plus one per e-commerce that lost its link.
     * @type {Array<PbShopwareAppLinkResult>}
     * @memberof PbSyncShopwareAppLinksResponse
     */
    'results'?: Array<PbShopwareAppLinkResult>;
}
/**
 * 
 * @export
 * @interface PbTag
 */
export interface PbTag {
    /**
     * tag name
     * @type {string}
     * @memberof PbTag
     */
    'name'?: string;
}
/**
 * Array of multiple copies
 * @export
 * @interface PbTagCopyDetails
 */
export interface PbTagCopyDetails {
    /**
     * The copy details.
     * @type {Array<PbCopyDetail>}
     * @memberof PbTagCopyDetails
     */
    'copies'?: Array<PbCopyDetail>;
    /**
     * Is FieldTag editable by ecommerce.
     * @type {boolean}
     * @memberof PbTagCopyDetails
     */
    'is_ecommerce_editable'?: boolean;
}
/**
 * Color of a theme
 * @export
 * @interface PbThemeColor
 */
export interface PbThemeColor {
    /**
     * HTML coded color
     * @type {string}
     * @memberof PbThemeColor
     */
    'contrast_text'?: string;
    /**
     * HTML coded color
     * @type {string}
     * @memberof PbThemeColor
     */
    'dark'?: string;
    /**
     * HTML coded color
     * @type {string}
     * @memberof PbThemeColor
     */
    'light'?: string;
    /**
     * HTML coded color
     * @type {string}
     * @memberof PbThemeColor
     */
    'main'?: string;
}
/**
 * defines the theme of an e-commerce
 * @export
 * @interface PbTheming
 */
export interface PbTheming {
    /**
     * URL of the background image
     * @type {string}
     * @memberof PbTheming
     */
    'background_image_url'?: string;
    /**
     * TODO: enhance description
     * @type {string}
     * @memberof PbTheming
     */
    'background_text_color'?: string;
    /**
     * TODO: enhance description
     * @type {string}
     * @memberof PbTheming
     */
    'border_radius'?: string;
    /**
     * Layout to be used in the returns portal (VERTICAL, SIMPLIFIED...)
     * @type {string}
     * @memberof PbTheming
     */
    'design'?: PbThemingDesignEnum;
    /**
     * URL of the favicon
     * @type {string}
     * @memberof PbTheming
     */
    'favicon_url'?: string;
    /**
     * TODO: enhance description
     * @type {string}
     * @memberof PbTheming
     */
    'input_variant'?: string;
    /**
     * TODO: enhance description   responsive strategy of the logo in the returns portal
     * @type {PbResponsiveStyle}
     * @memberof PbTheming
     */
    'logo_height'?: PbResponsiveStyle;
    /**
     * URL of the logo
     * @type {string}
     * @memberof PbTheming
     */
    'logo_url'?: string;
    /**
     * Primary color of the theme for the returns portal
     * @type {PbThemeColor}
     * @memberof PbTheming
     */
    'primary'?: PbThemeColor;
    /**
     * Secoundary color of the theme for the returns portal
     * @type {PbThemeColor}
     * @memberof PbTheming
     */
    'secondary'?: PbThemeColor;
    /**
     * Optional slogan (secoundary) of the returns portal page for this e-commerce
     * @type {string}
     * @memberof PbTheming
     */
    'slogan'?: string;
    /**
     * Title of the returns portal page for this e-commerce
     * @type {string}
     * @memberof PbTheming
     */
    'title'?: string;
}

export const PbThemingDesignEnum = {
    Default: 'DEFAULT',
    Vertical: 'VERTICAL',
    Simplified: 'SIMPLIFIED'
} as const;

export type PbThemingDesignEnum = typeof PbThemingDesignEnum[keyof typeof PbThemingDesignEnum];

/**
 * Tiktok platform settings
 * @export
 * @interface PbTiktokPlatformSettings
 */
export interface PbTiktokPlatformSettings {
    /**
     * Refresh token
     * @type {string}
     * @memberof PbTiktokPlatformSettings
     */
    'refresh_token'?: string;
    /**
     * Shop country
     * @type {string}
     * @memberof PbTiktokPlatformSettings
     */
    'shop_country'?: string;
    /**
     * Shop ID
     * @type {string}
     * @memberof PbTiktokPlatformSettings
     */
    'shop_id'?: string;
}
/**
 * Tracking number
 * @export
 * @interface PbTrackingNumber
 */
export interface PbTrackingNumber {
    /**
     * Carrier that shipped the original outbound order (e.g. \"DHL\", \"UPS\")
     * @type {string}
     * @memberof PbTrackingNumber
     */
    'carrier'?: string;
    /**
     * Platform fulfillment id this shipment belongs to. Empty on platforms that  do not expose one.
     * @type {string}
     * @memberof PbTrackingNumber
     */
    'fulfillment_id'?: string;
    /**
     * Line items
     * @type {Array<PbTrackingNumberLineItem>}
     * @memberof PbTrackingNumber
     */
    'line_items'?: Array<PbTrackingNumberLineItem>;
    /**
     * When the original outbound shipment was dispatched
     * @type {string}
     * @memberof PbTrackingNumber
     */
    'shipped_at'?: string;
    /**
     * Tracking number
     * @type {string}
     * @memberof PbTrackingNumber
     */
    'tracking_number'?: string;
}
/**
 * line items fulfilled in the tracking number
 * @export
 * @interface PbTrackingNumberLineItem
 */
export interface PbTrackingNumberLineItem {
    /**
     * Line item ID
     * @type {string}
     * @memberof PbTrackingNumberLineItem
     */
    'line_item_id'?: string;
    /**
     * Units of this line item that shipped in this fulfillment. Zero when the  platform does not expose per-shipment quantities.
     * @type {string}
     * @memberof PbTrackingNumberLineItem
     */
    'quantity'?: string;
}
/**
 * Inputs for a transaction to be added
 * @export
 * @interface PbTransactionInput
 */
export interface PbTransactionInput {
    /**
     * Amount following MoneyFormat
     * @type {string}
     * @memberof PbTransactionInput
     */
    'amount'?: string;
    /**
     * Pre-assigns when the transaction happened, for internal callers only. Left empty, the insert  time is used.
     * @type {string}
     * @memberof PbTransactionInput
     */
    'created_at'?: string;
    /**
     * Currency
     * @type {string}
     * @memberof PbTransactionInput
     */
    'currency'?: string;
    /**
     * Metadata, arbitrary JSON
     * @type {object}
     * @memberof PbTransactionInput
     */
    'metadata'?: object;
    /**
     * Description/notes associated
     * @type {string}
     * @memberof PbTransactionInput
     */
    'note'?: string;
    /**
     * Links a TX_COMPLETED / TX_FAILED confirmation to the original TX_IN_PROGRESS record.
     * @type {string}
     * @memberof PbTransactionInput
     */
    'parent_transaction_id'?: string;
    /**
     * Identifier of the transaction in the provider
     * @type {string}
     * @memberof PbTransactionInput
     */
    'platform_id'?: string;
    /**
     * URL associated to this transaction in the external system
     * @type {string}
     * @memberof PbTransactionInput
     */
    'platform_url'?: string;
    /**
     * Provider of the transaction (where we execute the transaction)
     * @type {string}
     * @memberof PbTransactionInput
     */
    'provider'?: PbTransactionInputProviderEnum;
    /**
     * Payment method associated (only when action == TO_REFUND)
     * @type {string}
     * @memberof PbTransactionInput
     */
    'refund_payment_method'?: PbTransactionInputRefundPaymentMethodEnum;
    /**
     * Pre-assigns this transaction\'s REVER id. Left empty, one is generated as usual.
     * @type {string}
     * @memberof PbTransactionInput
     */
    'rever_id'?: string;
    /**
     * Status of the transaction. Only consider COMPLETED as succesful
     * @type {string}
     * @memberof PbTransactionInput
     */
    'status'?: PbTransactionInputStatusEnum;
    /**
     * Type of transaction (exchange operation, refund operation....)
     * @type {string}
     * @memberof PbTransactionInput
     */
    'type'?: PbTransactionInputTypeEnum;
}

export const PbTransactionInputProviderEnum = {
    Mock: 'TXPROVIDER_MOCK',
    Woocommerce: 'TXPROVIDER_WOOCOMMERCE',
    Shopify: 'TXPROVIDER_SHOPIFY',
    CustomGeneric: 'TXPROVIDER_CUSTOM_GENERIC',
    Prestashop: 'TXPROVIDER_PRESTASHOP',
    MagentoV1: 'TXPROVIDER_MAGENTO_V1',
    MagentoV2: 'TXPROVIDER_MAGENTO_V2',
    Salesforce: 'TXPROVIDER_SALESFORCE',
    Revolut: 'TXPROVIDER_REVOLUT',
    Stripe: 'TXPROVIDER_STRIPE',
    Sendcloud: 'TXPROVIDER_SENDCLOUD',
    Correos: 'TXPROVIDER_CORREOS',
    CorreosExpress: 'TXPROVIDER_CORREOS_EXPRESS',
    ShippyPro: 'TXPROVIDER_SHIPPY_PRO',
    Ups: 'TXPROVIDER_UPS',
    Gls: 'TXPROVIDER_GLS',
    Dhl: 'TXPROVIDER_DHL',
    DhlExpress: 'TXPROVIDER_DHL_EXPRESS',
    DhlParcel: 'TXPROVIDER_DHL_PARCEL',
    Rhenus: 'TXPROVIDER_RHENUS',
    Fedex: 'TXPROVIDER_FEDEX',
    Zeleris: 'TXPROVIDER_ZELERIS',
    SendcloudEcommerce: 'TXPROVIDER_SENDCLOUD_ECOMMERCE',
    Enovo: 'TXPROVIDER_ENOVO',
    Zelo: 'TXPROVIDER_ZELO',
    Colissimo: 'TXPROVIDER_COLISSIMO',
    Ctt: 'TXPROVIDER_CTT',
    Monta: 'TXPROVIDER_MONTA',
    Brt: 'TXPROVIDER_BRT',
    Esendeo: 'TXPROVIDER_ESENDEO',
    Estafeta: 'TXPROVIDER_ESTAFETA',
    Chronopost: 'TXPROVIDER_CHRONOPOST',
    Canadapost: 'TXPROVIDER_CANADAPOST',
    Inpost: 'TXPROVIDER_INPOST',
    Packeta: 'TXPROVIDER_PACKETA',
    Dpd: 'TXPROVIDER_DPD',
    Mondialrelay: 'TXPROVIDER_MONDIALRELAY',
    Easypost: 'TXPROVIDER_EASYPOST',
    Flexport: 'TXPROVIDER_FLEXPORT',
    Tamdis: 'TXPROVIDER_TAMDIS',
    Seur: 'TXPROVIDER_SEUR',
    Cttportugal: 'TXPROVIDER_CTTPORTUGAL',
    Tnt: 'TXPROVIDER_TNT',
    Dhleconnect: 'TXPROVIDER_DHLECONNECT',
    Dhlbenelux: 'TXPROVIDER_DHLBENELUX',
    Swisspost: 'TXPROVIDER_SWISSPOST',
    Dpdportugal: 'TXPROVIDER_DPDPORTUGAL',
    Mbe: 'TXPROVIDER_MBE',
    Globale: 'TXPROVIDER_GLOBALE',
    Amphora: 'TXPROVIDER_AMPHORA',
    Dpdireland: 'TXPROVIDER_DPDIRELAND',
    Innosend: 'TXPROVIDER_INNOSEND',
    Exporto: 'TXPROVIDER_EXPORTO',
    Royalmail: 'TXPROVIDER_ROYALMAIL',
    Glsitaly: 'TXPROVIDER_GLSITALY',
    Glsczech: 'TXPROVIDER_GLSCZECH',
    Bigblue: 'TXPROVIDER_BIGBLUE',
    Myparcel: 'TXPROVIDER_MYPARCEL',
    Boardriders: 'TXPROVIDER_BOARDRIDERS',
    Glsshopreturns: 'TXPROVIDER_GLSSHOPRETURNS',
    None: 'TXPROVIDER_NONE'
} as const;

export type PbTransactionInputProviderEnum = typeof PbTransactionInputProviderEnum[keyof typeof PbTransactionInputProviderEnum];
export const PbTransactionInputRefundPaymentMethodEnum = {
    NoPaymentMethod: 'NO_PAYMENT_METHOD',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    Manual: 'MANUAL'
} as const;

export type PbTransactionInputRefundPaymentMethodEnum = typeof PbTransactionInputRefundPaymentMethodEnum[keyof typeof PbTransactionInputRefundPaymentMethodEnum];
export const PbTransactionInputStatusEnum = {
    NoTransactionStatus: 'NO_TRANSACTION_STATUS',
    TxCompleted: 'TX_COMPLETED',
    TxDenied: 'TX_DENIED',
    TxInProgress: 'TX_IN_PROGRESS',
    TxError: 'TX_ERROR',
    TxCanceled: 'TX_CANCELED',
    TxFailed: 'TX_FAILED'
} as const;

export type PbTransactionInputStatusEnum = typeof PbTransactionInputStatusEnum[keyof typeof PbTransactionInputStatusEnum];
export const PbTransactionInputTypeEnum = {
    Unknown: 'TXTYPE_UNKNOWN',
    Refund: 'TXTYPE_REFUND',
    Exchange: 'TXTYPE_EXCHANGE',
    Logistics: 'TXTYPE_LOGISTICS',
    Return: 'TXTYPE_RETURN',
    Pickup: 'TXTYPE_PICKUP',
    Commit: 'TXTYPE_COMMIT',
    Lost: 'TXTYPE_LOST',
    Payment: 'TXTYPE_PAYMENT',
    CommitPayment: 'TXTYPE_COMMIT_PAYMENT',
    CommitExchange: 'TXTYPE_COMMIT_EXCHANGE'
} as const;

export type PbTransactionInputTypeEnum = typeof PbTransactionInputTypeEnum[keyof typeof PbTransactionInputTypeEnum];

/**
 * 
 * @export
 * @interface PbTransitionLKSSInternalRequest
 */
export interface PbTransitionLKSSInternalRequest {
    /**
     * Target shipping status to transition to
     * @type {string}
     * @memberof PbTransitionLKSSInternalRequest
     */
    'lkss'?: PbTransitionLKSSInternalRequestLkssEnum;
    /**
     * Platform process ID, used when process_id is not provided
     * @type {string}
     * @memberof PbTransitionLKSSInternalRequest
     */
    'platform_process_id'?: string;
    /**
     * ID of the process whose shipping status should transition
     * @type {string}
     * @memberof PbTransitionLKSSInternalRequest
     */
    'process_id'?: string;
    /**
     * Actor performing the transition, recorded in the audit trail
     * @type {string}
     * @memberof PbTransitionLKSSInternalRequest
     */
    'user'?: string;
}

export const PbTransitionLKSSInternalRequestLkssEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbTransitionLKSSInternalRequestLkssEnum = typeof PbTransitionLKSSInternalRequestLkssEnum[keyof typeof PbTransitionLKSSInternalRequestLkssEnum];

/**
 * 
 * @export
 * @interface PbTransitionLKSSInternalResponse
 */
export interface PbTransitionLKSSInternalResponse {
    /**
     * Shipping status after the request was processed (unchanged when not transitioned)
     * @type {string}
     * @memberof PbTransitionLKSSInternalResponse
     */
    'current_status'?: PbTransitionLKSSInternalResponseCurrentStatusEnum;
    /**
     * Shipping status before the request was processed
     * @type {string}
     * @memberof PbTransitionLKSSInternalResponse
     */
    'previous_status'?: PbTransitionLKSSInternalResponsePreviousStatusEnum;
    /**
     * True when the status changed; false when the transition was invalid and skipped
     * @type {boolean}
     * @memberof PbTransitionLKSSInternalResponse
     */
    'transitioned'?: boolean;
}

export const PbTransitionLKSSInternalResponseCurrentStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbTransitionLKSSInternalResponseCurrentStatusEnum = typeof PbTransitionLKSSInternalResponseCurrentStatusEnum[keyof typeof PbTransitionLKSSInternalResponseCurrentStatusEnum];
export const PbTransitionLKSSInternalResponsePreviousStatusEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbTransitionLKSSInternalResponsePreviousStatusEnum = typeof PbTransitionLKSSInternalResponsePreviousStatusEnum[keyof typeof PbTransitionLKSSInternalResponsePreviousStatusEnum];

/**
 * Request to deactivate every e-commerce connected to a module installation
 * @export
 * @interface PbUninstallPrestashopModuleRequest
 */
export interface PbUninstallPrestashopModuleRequest {
    /**
     * The uninstalled module installation
     * @type {string}
     * @memberof PbUninstallPrestashopModuleRequest
     */
    'registration_id'?: string;
}
/**
 * Result of deactivating a module installation\'s e-commerces
 * @export
 * @interface PbUninstallPrestashopModuleResponse
 */
export interface PbUninstallPrestashopModuleResponse {
    /**
     * Number of e-commerce connections this call switched from active to inactive
     * @type {string}
     * @memberof PbUninstallPrestashopModuleResponse
     */
    'deactivated_count'?: string;
}
/**
 * A shop uninstalling the app.
 * @export
 * @interface PbUninstallShopwareAppRequest
 */
export interface PbUninstallShopwareAppRequest {
    /**
     * The shop\'s id.
     * @type {string}
     * @memberof PbUninstallShopwareAppRequest
     */
    'shop_id'?: string;
    /**
     * The shop secret the uninstall request was verified with: the current one, or the  previous one within 60 seconds of the rotation. Any other is refused.
     * @type {string}
     * @memberof PbUninstallShopwareAppRequest
     */
    'shop_secret'?: string;
}
/**
 * Outcome of an uninstall.
 * @export
 * @interface PbUninstallShopwareAppResponse
 */
export interface PbUninstallShopwareAppResponse {
    /**
     * The e-commerces whose app credentials were cleared.
     * @type {Array<string>}
     * @memberof PbUninstallShopwareAppResponse
     */
    'revoked_ecommerce_ids'?: Array<string>;
}
/**
 * Request to get the copies for a given e-commerce
 * @export
 * @interface PbUpdateEcommerceCopyRequest
 */
export interface PbUpdateEcommerceCopyRequest {
    /**
     * Map of array of Copies to be updated
     * @type {{ [key: string]: PbTagCopyDetails; }}
     * @memberof PbUpdateEcommerceCopyRequest
     */
    'copy_details'?: { [key: string]: PbTagCopyDetails; };
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof PbUpdateEcommerceCopyRequest
     */
    'ecommerce_id'?: string;
}
/**
 * 
 * @export
 * @interface PbUpdateLKSSInternalRequest
 */
export interface PbUpdateLKSSInternalRequest {
    /**
     * New last known shipping status
     * @type {string}
     * @memberof PbUpdateLKSSInternalRequest
     */
    'lkss'?: PbUpdateLKSSInternalRequestLkssEnum;
    /**
     * Platform process ID, used when process_id is not provided
     * @type {string}
     * @memberof PbUpdateLKSSInternalRequest
     */
    'platform_process_id'?: string;
    /**
     * ID of the process. Optional when platform_process_id is set.
     * @type {string}
     * @memberof PbUpdateLKSSInternalRequest
     */
    'process_id'?: string;
    /**
     * User recorded as the author of the change
     * @type {string}
     * @memberof PbUpdateLKSSInternalRequest
     */
    'user'?: string;
}

export const PbUpdateLKSSInternalRequestLkssEnum = {
    NoShippingStatus: 'NO_SHIPPING_STATUS',
    Created: 'CREATED',
    Collected: 'COLLECTED',
    InWarehouse: 'IN_WAREHOUSE',
    Error: 'ERROR',
    Canceled: 'CANCELED'
} as const;

export type PbUpdateLKSSInternalRequestLkssEnum = typeof PbUpdateLKSSInternalRequestLkssEnum[keyof typeof PbUpdateLKSSInternalRequestLkssEnum];

/**
 * Payload for updating the logistics fields of a given return process
 * @export
 * @interface PbUpdateLogisticsRequest
 */
export interface PbUpdateLogisticsRequest {
    /**
     * The process ID to update. Required.
     * @type {string}
     * @memberof PbUpdateLogisticsRequest
     */
    'process_id'?: string;
    /**
     * The user that performed the update. Required.
     * @type {string}
     * @memberof PbUpdateLogisticsRequest
     */
    'user'?: string;
    /**
     * The new logistics carrier of the process.  It\'s used by the process to request the creation to the provider  of the shipping order using his carrier  If it\'s already created, has no effect.  Required.
     * @type {string}
     * @memberof PbUpdateLogisticsRequest
     */
    'user_selected_carrier'?: string;
    /**
     * The new logistics provider of the process.  It\'s used by the process to request the creation of the shipping  order to this provider. If it\'s already created, has no effect.  Required.
     * @type {string}
     * @memberof PbUpdateLogisticsRequest
     */
    'user_selected_provider'?: string;
}
/**
 * UpdateMaximumReturnDaysInBulkRequest
 * @export
 * @interface PbUpdateMaximumReturnDaysInBulkRequest
 */
export interface PbUpdateMaximumReturnDaysInBulkRequest {
    /**
     * List of ecommerce IDs
     * @type {Array<PbUpdateMaximumReturnDaysRequest>}
     * @memberof PbUpdateMaximumReturnDaysInBulkRequest
     */
    'update_maximum_return_days_requests'?: Array<PbUpdateMaximumReturnDaysRequest>;
}
/**
 * UpdateMaximumReturnDaysRequest
 * @export
 * @interface PbUpdateMaximumReturnDaysRequest
 */
export interface PbUpdateMaximumReturnDaysRequest {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbUpdateMaximumReturnDaysRequest
     */
    'ecommerce_id'?: string;
    /**
     * Maximum return days
     * @type {number}
     * @memberof PbUpdateMaximumReturnDaysRequest
     */
    'maximum_return_days'?: number;
}
/**
 * UpdatePrestashopModuleResponse represents the response for updating Prestashop modules
 * @export
 * @interface PbUpdatePrestashopModuleResponse
 */
export interface PbUpdatePrestashopModuleResponse {
    /**
     * List of updated ecommerces
     * @type {Array<PbUpdatedEcommerce>}
     * @memberof PbUpdatePrestashopModuleResponse
     */
    'updated_ecommerces'?: Array<PbUpdatedEcommerce>;
}
/**
 * UpdateProductAutomationsSettingsRequest contains the request to update the PA settings for an ecommerce
 * @export
 * @interface PbUpdateProductAutomationsSettingsRequest
 */
export interface PbUpdateProductAutomationsSettingsRequest {
    /**
     * The ecommerce id
     * @type {string}
     * @memberof PbUpdateProductAutomationsSettingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * The ecommerce group
     * @type {string}
     * @memberof PbUpdateProductAutomationsSettingsRequest
     */
    'group'?: string;
    /**
     * The settings section to update
     * @type {PbPASection}
     * @memberof PbUpdateProductAutomationsSettingsRequest
     */
    'updated_section'?: PbPASection;
}
/**
 * 
 * @export
 * @interface PbUpdateStockRequest
 */
export interface PbUpdateStockRequest {
    /**
     * ecommerce_id of the stores
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'ecommerce_id'?: string;
    /**
     * line item id
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'line_item_id'?: string;
    /**
     * location id
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'location_id'?: string;
    /**
     * order id
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'order_id'?: string;
    /**
     * platform_id
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'platform_id'?: string;
    /**
     * product id to update
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'product_id'?: string;
    /**
     * quantity to update
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'quantity'?: string;
    /**
     * variant id to update
     * @type {string}
     * @memberof PbUpdateStockRequest
     */
    'variant_id'?: string;
}
/**
 * UpdateUserRequest
 * @export
 * @interface PbUpdateUserRequest
 */
export interface PbUpdateUserRequest {
    /**
     * assigned warehouses
     * @type {Array<string>}
     * @memberof PbUpdateUserRequest
     */
    'assigned_warehouses'?: Array<string>;
    /**
     * Optional. Scopes the write to this ecommerce\'s group instead of the caller\'s own,  for REVER staff acting on a merchant. Derived server-side from the id rather than  taken as a group: for a \"*\" caller any group would authorize, so a stale group would  silently touch the wrong merchant.
     * @type {string}
     * @memberof PbUpdateUserRequest
     */
    'ecommerce_id'?: string;
    /**
     * Auth0 user id
     * @type {string}
     * @memberof PbUpdateUserRequest
     */
    'id'?: string;
    /**
     * role
     * @type {string}
     * @memberof PbUpdateUserRequest
     */
    'role'?: PbUpdateUserRequestRoleEnum;
}

export const PbUpdateUserRequestRoleEnum = {
    Unspecified: 'ROLE_UNSPECIFIED',
    WriteAll: 'ROLE_WRITE_ALL',
    ReadOnly: 'ROLE_READ_ONLY',
    Reviewer: 'ROLE_REVIEWER',
    AnalyticsOnly: 'ROLE_ANALYTICS_ONLY'
} as const;

export type PbUpdateUserRequestRoleEnum = typeof PbUpdateUserRequestRoleEnum[keyof typeof PbUpdateUserRequestRoleEnum];

/**
 * Payload for updating the status of the main workflow a given return process  The status of the process can be RUNNING, COMPLETED, ON_HOLD...
 * @export
 * @interface PbUpdateWorkflowStatusRequest
 */
export interface PbUpdateWorkflowStatusRequest {
    /**
     * The process ID to update. Required.
     * @type {string}
     * @memberof PbUpdateWorkflowStatusRequest
     */
    'process_id'?: string;
    /**
     * The new status of the process. Required.
     * @type {string}
     * @memberof PbUpdateWorkflowStatusRequest
     */
    'status'?: PbUpdateWorkflowStatusRequestStatusEnum;
}

export const PbUpdateWorkflowStatusRequestStatusEnum = {
    Running: 'RUNNING',
    Failed: 'FAILED',
    Completed: 'COMPLETED',
    OnHold: 'ON_HOLD',
    ReturnStatusCanceled: 'RETURN_STATUS_CANCELED'
} as const;

export type PbUpdateWorkflowStatusRequestStatusEnum = typeof PbUpdateWorkflowStatusRequestStatusEnum[keyof typeof PbUpdateWorkflowStatusRequestStatusEnum];

/**
 * UpdatedEcommerce contains information about an updated ecommerce
 * @export
 * @interface PbUpdatedEcommerce
 */
export interface PbUpdatedEcommerce {
    /**
     * ID of the updated ecommerce
     * @type {string}
     * @memberof PbUpdatedEcommerce
     */
    'ecommerce_id'?: string;
    /**
     * Error
     * @type {string}
     * @memberof PbUpdatedEcommerce
     */
    'error'?: string;
    /**
     * Version of the updated module
     * @type {string}
     * @memberof PbUpdatedEcommerce
     */
    'version'?: string;
}
/**
 * Branding image upload request
 * @export
 * @interface PbUploadBrandingImageReq
 */
export interface PbUploadBrandingImageReq {
    /**
     * The image itself, PNG, JPEG, GIF or WEBP, up to 512 KiB. Required.
     * @type {string}
     * @memberof PbUploadBrandingImageReq
     */
    'content'?: string;
    /**
     * The e-commerce the image belongs to. Required.
     * @type {string}
     * @memberof PbUploadBrandingImageReq
     */
    'ecommerce_id'?: string;
    /**
     * Which portal image the upload replaces. Required.
     * @type {string}
     * @memberof PbUploadBrandingImageReq
     */
    'image_type'?: PbUploadBrandingImageReqImageTypeEnum;
}

export const PbUploadBrandingImageReqImageTypeEnum = {
    Unspecified: 'BRANDING_IMAGE_TYPE_UNSPECIFIED',
    Logo: 'BRANDING_IMAGE_TYPE_LOGO',
    Favicon: 'BRANDING_IMAGE_TYPE_FAVICON',
    Background: 'BRANDING_IMAGE_TYPE_BACKGROUND'
} as const;

export type PbUploadBrandingImageReqImageTypeEnum = typeof PbUploadBrandingImageReqImageTypeEnum[keyof typeof PbUploadBrandingImageReqImageTypeEnum];

/**
 * Branding image upload response
 * @export
 * @interface PbUploadBrandingImageRes
 */
export interface PbUploadBrandingImageRes {
    /**
     * Url the stored image is served from, already written into the branding.
     * @type {string}
     * @memberof PbUploadBrandingImageRes
     */
    'url'?: string;
}
/**
 * UploadDocuments request
 * @export
 * @interface PbUploadDocuments
 */
export interface PbUploadDocuments {
    /**
     * always
     * @type {boolean}
     * @memberof PbUploadDocuments
     */
    'always'?: boolean;
    /**
     * options
     * @type {Array<PbUploadDocumentsOption>}
     * @memberof PbUploadDocuments
     */
    'options'?: Array<PbUploadDocumentsOption>;
}
/**
 * 
 * @export
 * @interface PbUploadDocumentsInfoUploadedDocuments
 */
export interface PbUploadDocumentsInfoUploadedDocuments {
    /**
     * 
     * @type {string}
     * @memberof PbUploadDocumentsInfoUploadedDocuments
     */
    'document_info'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbUploadDocumentsInfoUploadedDocuments
     */
    'document_url'?: string;
    /**
     * REVER ID of the returned line item the document belongs to (ReturnedItem.rever_id).  Empty when the document was uploaded for the whole return process.
     * @type {string}
     * @memberof PbUploadDocumentsInfoUploadedDocuments
     */
    'line_item_id'?: string;
    /**
     * Return reason key of that line item (ReturnedItem.return_reason_key) when the  document was uploaded. Empty when line_item_id is empty.
     * @type {string}
     * @memberof PbUploadDocumentsInfoUploadedDocuments
     */
    'return_reason_key'?: string;
}
/**
 * request to know if we should UploadDocuments
 * @export
 * @interface PbUploadDocumentsOption
 */
export interface PbUploadDocumentsOption {
    /**
     * when
     * @type {Array<string>}
     * @memberof PbUploadDocumentsOption
     */
    'whens'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PbUploadReturnDocumentsRequest
 */
export interface PbUploadReturnDocumentsRequest {
    /**
     * 
     * @type {Array<PbUploadReturnDocumentsRequestDocument>}
     * @memberof PbUploadReturnDocumentsRequest
     */
    'documents'?: Array<PbUploadReturnDocumentsRequestDocument>;
    /**
     * 
     * @type {string}
     * @memberof PbUploadReturnDocumentsRequest
     */
    'process_id'?: string;
}
/**
 * 
 * @export
 * @interface PbUploadReturnDocumentsRequestDocument
 */
export interface PbUploadReturnDocumentsRequestDocument {
    /**
     * 
     * @type {string}
     * @memberof PbUploadReturnDocumentsRequestDocument
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbUploadReturnDocumentsRequestDocument
     */
    'document_information'?: string;
    /**
     * REVER ID of the returned line item the document belongs to (ReturnedItem.rever_id).  Optional: leave it empty for a document about the whole return process.
     * @type {string}
     * @memberof PbUploadReturnDocumentsRequestDocument
     */
    'line_item_id'?: string;
}
/**
 * UpsertWebhookSubscriptionsRequest sets the ecommerce\'s webhook subscription state.
 * @export
 * @interface PbUpsertWebhookSubscriptionsRequest
 */
export interface PbUpsertWebhookSubscriptionsRequest {
    /**
     * The ecommerce id
     * @type {string}
     * @memberof PbUpsertWebhookSubscriptionsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Subscribes to the webhook fired when a return process is completed
     * @type {boolean}
     * @memberof PbUpsertWebhookSubscriptionsRequest
     */
    'on_completed_enabled'?: boolean;
    /**
     * Subscribes to the webhook fired when a return process starts
     * @type {boolean}
     * @memberof PbUpsertWebhookSubscriptionsRequest
     */
    'on_start_enabled'?: boolean;
    /**
     * Destination URL the webhooks are POSTed to, shared by both webhooks.  Required whenever either webhook is enabled.
     * @type {string}
     * @memberof PbUpsertWebhookSubscriptionsRequest
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface PbUpsertZendeskTicketInternalRequest
 */
export interface PbUpsertZendeskTicketInternalRequest {
    /**
     * Zendesk ID of the assigned agent. Empty when unassigned.
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'agent_id'?: string;
    /**
     * Contact reason custom field value
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'contact_reason'?: string;
    /**
     * Ticket creation time, RFC 3339
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'created_at'?: string;
    /**
     * Incidence type custom field value
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'incidence_type'?: string;
    /**
     * Return process ID from the ticket\'s process custom field. Empty when the ticket is not about a  return.
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'process_id'?: string;
    /**
     * Email of the ticket requester
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'requester_email'?: string;
    /**
     * Requester type custom field value
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'requester_type'?: string;
    /**
     * Zendesk ticket status (new, open, pending, hold, solved, closed)
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'status'?: string;
    /**
     * Ticket subject
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'subject'?: string;
    /**
     * Zendesk ticket ID
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'ticket_id'?: string;
    /**
     * Time of the ticket update that fired the trigger, RFC 3339
     * @type {string}
     * @memberof PbUpsertZendeskTicketInternalRequest
     */
    'updated_at'?: string;
}
/**
 * User
 * @export
 * @interface PbUser
 */
export interface PbUser {
    /**
     * ECommerces
     * @type {Array<string>}
     * @memberof PbUser
     */
    'e_commerces_ids'?: Array<string>;
    /**
     * Group
     * @type {string}
     * @memberof PbUser
     */
    'group'?: string;
    /**
     * Groups the user can access, each with its e-commerces, sorted by group ID
     * @type {Array<PbUserEcommerceGroup>}
     * @memberof PbUser
     */
    'groups'?: Array<PbUserEcommerceGroup>;
    /**
     * Name
     * @type {string}
     * @memberof PbUser
     */
    'name'?: string;
    /**
     * Role
     * @type {string}
     * @memberof PbUser
     */
    'role'?: string;
}
/**
 * UserEcommerceGroup is an e-commerce group visible to the user
 * @export
 * @interface PbUserEcommerceGroup
 */
export interface PbUserEcommerceGroup {
    /**
     * ECommerces in the group, sorted by ID
     * @type {Array<string>}
     * @memberof PbUserEcommerceGroup
     */
    'e_commerces_ids'?: Array<string>;
    /**
     * Group ID
     * @type {string}
     * @memberof PbUserEcommerceGroup
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PbValidateReviewRequest
 */
export interface PbValidateReviewRequest {
    /**
     * process ID to validate
     * @type {string}
     * @memberof PbValidateReviewRequest
     */
    'process_id'?: string;
    /**
     * Refund override
     * @type {PbRefundOverride}
     * @memberof PbValidateReviewRequest
     */
    'refund_override'?: PbRefundOverride;
    /**
     * Review data
     * @type {Array<PbReviewLineItem>}
     * @memberof PbValidateReviewRequest
     */
    'reviews'?: Array<PbReviewLineItem>;
}
/**
 * 
 * @export
 * @interface PbValidateReviewResponse
 */
export interface PbValidateReviewResponse {
    /**
     * error message
     * @type {string}
     * @memberof PbValidateReviewResponse
     */
    'error_message'?: string;
    /**
     * is Review Request valid
     * @type {boolean}
     * @memberof PbValidateReviewResponse
     */
    'is_valid'?: boolean;
    /**
     * True when the review is invalid because the process has an open WFP claim, which locks reviews  until Seel resolves it
     * @type {boolean}
     * @memberof PbValidateReviewResponse
     */
    'locked_by_wfp_claim'?: boolean;
}
/**
 * Restock locations for the requested items
 * @export
 * @interface PbVariantRestockLocations
 */
export interface PbVariantRestockLocations {
    /**
     * Restock locations
     * @type {Array<PbRestockLocation>}
     * @memberof PbVariantRestockLocations
     */
    'restock_locations'?: Array<PbRestockLocation>;
    /**
     * Variant ID
     * @type {string}
     * @memberof PbVariantRestockLocations
     */
    'variant_id'?: string;
}
/**
 * Vtex platform settings
 * @export
 * @interface PbVtexPlatformSettings
 */
export interface PbVtexPlatformSettings {
    /**
     * App key
     * @type {string}
     * @memberof PbVtexPlatformSettings
     */
    'app_key'?: string;
    /**
     * App token
     * @type {string}
     * @memberof PbVtexPlatformSettings
     */
    'app_token'?: string;
}
/**
 * Warehouse model
 * @export
 * @interface PbWarehouse
 */
export interface PbWarehouse {
    /**
     * AddressLine1
     * @type {string}
     * @memberof PbWarehouse
     */
    'address_line1'?: string;
    /**
     * AddressLine2
     * @type {string}
     * @memberof PbWarehouse
     */
    'address_line2'?: string;
    /**
     * City
     * @type {string}
     * @memberof PbWarehouse
     */
    'city'?: string;
    /**
     * Company
     * @type {string}
     * @memberof PbWarehouse
     */
    'company'?: string;
    /**
     * Country
     * @type {string}
     * @memberof PbWarehouse
     */
    'country'?: string;
    /**
     * CountryCode
     * @type {string}
     * @memberof PbWarehouse
     */
    'country_code'?: string;
    /**
     * Ecommerce group that owns a group-level warehouse, which has no ecommerce_id. Empty for ecommerce warehouses.
     * @type {string}
     * @memberof PbWarehouse
     */
    'ecommerce_group'?: string;
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbWarehouse
     */
    'ecommerce_id'?: string;
    /**
     * Email
     * @type {string}
     * @memberof PbWarehouse
     */
    'email'?: string;
    /**
     * FirstName
     * @type {string}
     * @memberof PbWarehouse
     */
    'first_name'?: string;
    /**
     * ID
     * @type {string}
     * @memberof PbWarehouse
     */
    'id'?: string;
    /**
     * LastName
     * @type {string}
     * @memberof PbWarehouse
     */
    'last_name'?: string;
    /**
     * Free-form JSON annotations for integrations (e.g. the merchant\'s own warehouse id).  Omitted: stored value is kept. Empty object: stored value is cleared. Never store credentials here.  SaveWarehouses (v1) ignores it; the other save RPCs write it. Send integers of 2^53 or more as strings.
     * @type {object}
     * @memberof PbWarehouse
     */
    'metadata'?: object;
    /**
     * Phone
     * @type {string}
     * @memberof PbWarehouse
     */
    'phone'?: string;
    /**
     * Postcode
     * @type {string}
     * @memberof PbWarehouse
     */
    'postcode'?: string;
    /**
     * Group-level warehouse that replaced this ecommerce warehouse when its group moved to group-level warehouses.  Read-only; empty for group-level warehouses and for ecommerce warehouses that were not migrated.
     * @type {string}
     * @memberof PbWarehouse
     */
    'replaced_by_id'?: string;
    /**
     * StateProvince
     * @type {string}
     * @memberof PbWarehouse
     */
    'state_province'?: string;
    /**
     * StateProvinceCode
     * @type {string}
     * @memberof PbWarehouse
     */
    'state_province_code'?: string;
}
/**
 * WarehouseAddress is the address where the items will be returned
 * @export
 * @interface PbWarehouseAddress
 */
export interface PbWarehouseAddress {
    /**
     * address line 1
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'address_line_1'?: string;
    /**
     * address line 2
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'address_line_2'?: string;
    /**
     * city
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'city'?: string;
    /**
     * company
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'company'?: string;
    /**
     * country
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'country'?: string;
    /**
     * country code
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'country_code'?: string;
    /**
     * email
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'email'?: string;
    /**
     * name
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'name'?: string;
    /**
     * phone
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'phone'?: string;
    /**
     * postal code
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'postal_code'?: string;
    /**
     * province
     * @type {string}
     * @memberof PbWarehouseAddress
     */
    'province'?: string;
}
/**
 * WarehouseConfig
 * @export
 * @interface PbWarehouseConfig
 */
export interface PbWarehouseConfig {
    /**
     * WarehouseConfigOptions
     * @type {Array<PbWarehouseConfigOptions>}
     * @memberof PbWarehouseConfig
     */
    'options'?: Array<PbWarehouseConfigOptions>;
}
/**
 * WarehouseConfigOptions
 * @export
 * @interface PbWarehouseConfigOptions
 */
export interface PbWarehouseConfigOptions {
    /**
     * WarehouseID
     * @type {string}
     * @memberof PbWarehouseConfigOptions
     */
    'warehouse_id'?: string;
    /**
     * Whens
     * @type {Array<string>}
     * @memberof PbWarehouseConfigOptions
     */
    'whens'?: Array<string>;
}
/**
 * Routing rules an ecommerce uses instead of its group\'s
 * @export
 * @interface PbWarehouseConfigOverride
 */
export interface PbWarehouseConfigOverride {
    /**
     * Ecommerce that overrides its group\'s routing rules
     * @type {string}
     * @memberof PbWarehouseConfigOverride
     */
    'ecommerce_id'?: string;
    /**
     * Its routing rules
     * @type {Array<PbWarehouseConfig>}
     * @memberof PbWarehouseConfigOverride
     */
    'warehouse_configs'?: Array<PbWarehouseConfig>;
}
/**
 * WarehouseInfo groups the warehouse details resolved from settings-api for a  return process (by warehouse_id).
 * @export
 * @interface PbWarehouseInfo
 */
export interface PbWarehouseInfo {
    /**
     * Warehouse city.
     * @type {string}
     * @memberof PbWarehouseInfo
     */
    'city'?: string;
    /**
     * Warehouse country.
     * @type {string}
     * @memberof PbWarehouseInfo
     */
    'country'?: string;
    /**
     * Warehouse ID (same value as return_process.warehouse_id).
     * @type {string}
     * @memberof PbWarehouseInfo
     */
    'id'?: string;
    /**
     * Human-readable warehouse name (company).
     * @type {string}
     * @memberof PbWarehouseInfo
     */
    'name'?: string;
}
/**
 * Warehouses
 * @export
 * @interface PbWarehouses
 */
export interface PbWarehouses {
    /**
     * List of warehouses
     * @type {Array<PbWarehouse>}
     * @memberof PbWarehouses
     */
    'warehouses'?: Array<PbWarehouse>;
}
/**
 * WebhookSigningSecretRequest identifies the ecommerce whose group\'s signing secret is  acted on. Secrets are stored per group, so any ecommerce of a group reaches the single  secret they all share.
 * @export
 * @interface PbWebhookSigningSecretRequest
 */
export interface PbWebhookSigningSecretRequest {
    /**
     * The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
     * @type {string}
     * @memberof PbWebhookSigningSecretRequest
     */
    'ecommerce_id'?: string;
}
/**
 * WebhookSigningSecretResponse carries one signing secret.   The secret field is a LIVE CREDENTIAL: callers must never log it, cache it, or forward  it to another system. Hand it to the requesting user and drop it.
 * @export
 * @interface PbWebhookSigningSecretResponse
 */
export interface PbWebhookSigningSecretResponse {
    /**
     * When it was generated.
     * @type {string}
     * @memberof PbWebhookSigningSecretResponse
     */
    'created_at'?: string;
    /**
     * Email of whoever generated it.
     * @type {string}
     * @memberof PbWebhookSigningSecretResponse
     */
    'created_by'?: string;
    /**
     * Ecommerce group the secret belongs to. Every ecommerce in it is signed with this  same value.
     * @type {string}
     * @memberof PbWebhookSigningSecretResponse
     */
    'ecommerce_group'?: string;
    /**
     * Prefix plus last characters, e.g. \"whsec_...a3f9\", for display without the value.
     * @type {string}
     * @memberof PbWebhookSigningSecretResponse
     */
    'redacted_value'?: string;
    /**
     * The signing secret in the clear, e.g. \"whsec_...\". Empty when the ecommerce has none.
     * @type {string}
     * @memberof PbWebhookSigningSecretResponse
     */
    'secret'?: string;
    /**
     * SHA-256 of the secret. Lets the customer confirm they hold the same value by  comparing fingerprints, without either side revealing it.
     * @type {string}
     * @memberof PbWebhookSigningSecretResponse
     */
    'secret_hash'?: string;
}
/**
 * WebhookSigningSecretSummary is one entry of the audit history. It never carries the  secret value.
 * @export
 * @interface PbWebhookSigningSecretSummary
 */
export interface PbWebhookSigningSecretSummary {
    /**
     * When it was generated
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'created_at'?: string;
    /**
     * Email of whoever generated it
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'created_by'?: string;
    /**
     * Identifier of this issued secret
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'id'?: string;
    /**
     * Prefix plus last characters, e.g. \"whsec_...a3f9\"
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'redacted_value'?: string;
    /**
     * When it was revoked. Unset while it is the active secret.
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'revoked_at'?: string;
    /**
     * Email of whoever revoked it. Empty while it is the active secret.
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'revoked_by'?: string;
    /**
     * SHA-256 of the secret
     * @type {string}
     * @memberof PbWebhookSigningSecretSummary
     */
    'secret_hash'?: string;
}
/**
 * WebhookSubscriptionsResponse is the current webhook subscription state of the  ecommerce.
 * @export
 * @interface PbWebhookSubscriptionsResponse
 */
export interface PbWebhookSubscriptionsResponse {
    /**
     * Whether the webhook fired when a return process is completed is enabled
     * @type {boolean}
     * @memberof PbWebhookSubscriptionsResponse
     */
    'on_completed_enabled'?: boolean;
    /**
     * Whether the webhook fired when a return process starts is enabled
     * @type {boolean}
     * @memberof PbWebhookSubscriptionsResponse
     */
    'on_start_enabled'?: boolean;
    /**
     * Destination URL the webhooks are POSTed to
     * @type {string}
     * @memberof PbWebhookSubscriptionsResponse
     */
    'url'?: string;
}
/**
 * misc information about the e-commerce
 * @export
 * @interface PbWebsiteSettings
 */
export interface PbWebsiteSettings {
    /**
     * url of th e-commerce (used to redirect after return creation)
     * @type {string}
     * @memberof PbWebsiteSettings
     */
    'url'?: string;
}
/**
 * WfpClaim is the full persisted state of a WFP claim (the wfp_claim table).
 * @export
 * @interface PbWfpClaim
 */
export interface PbWfpClaim {
    /**
     * Row creation timestamp.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'created_at'?: string;
    /**
     * ISO-4217 currency paired with refund_amount_cents. Absent when unset.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'currency'?: string;
    /**
     * Approved refund amount in minor units; set when claim.accepted carries it.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'refund_amount_cents'?: string;
    /**
     * When the claim reached a terminal state (accepted/rejected/closed/resolved).  Null while non-terminal.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'resolved_at'?: string;
    /**
     * Return process the claim originates from (UNIQUE — one claim per process).
     * @type {string}
     * @memberof PbWfpClaim
     */
    'return_process_id'?: string;
    /**
     * Seel claim id (wfp_claim primary key).
     * @type {string}
     * @memberof PbWfpClaim
     */
    'seel_claim_id'?: string;
    /**
     * REVER-internal lifecycle status of the claim.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'status'?: PbWfpClaimStatusEnum;
    /**
     * Seel-provided reason (e.g. rejection text). Absent when Seel sends none.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'status_reason'?: string;
    /**
     * When the claim was submitted to Seel (DEFAULT now() at insert).
     * @type {string}
     * @memberof PbWfpClaim
     */
    'submitted_at'?: string;
    /**
     * Row last-update timestamp.
     * @type {string}
     * @memberof PbWfpClaim
     */
    'updated_at'?: string;
    /**
     * Seel contract the claim belongs to (multiple claims per contract allowed).
     * @type {string}
     * @memberof PbWfpClaim
     */
    'wfp_contract_id'?: string;
}

export const PbWfpClaimStatusEnum = {
    Unspecified: 'WFP_CLAIM_STATUS_UNSPECIFIED',
    PendingSubmission: 'WFP_CLAIM_STATUS_PENDING_SUBMISSION',
    Created: 'WFP_CLAIM_STATUS_CREATED',
    Accepted: 'WFP_CLAIM_STATUS_ACCEPTED',
    Rejected: 'WFP_CLAIM_STATUS_REJECTED',
    Closed: 'WFP_CLAIM_STATUS_CLOSED',
    Resolved: 'WFP_CLAIM_STATUS_RESOLVED'
} as const;

export type PbWfpClaimStatusEnum = typeof PbWfpClaimStatusEnum[keyof typeof PbWfpClaimStatusEnum];

/**
 * WfpCoverage mirrors a Seel coverage block stored verbatim on the contract.
 * @export
 * @interface PbWfpCoverage
 */
export interface PbWfpCoverage {
    /**
     * Type of coverage (e.g. return assurance).
     * @type {string}
     * @memberof PbWfpCoverage
     */
    'coverage_type'?: string;
    /**
     * Items eligible under this coverage.
     * @type {Array<PbWfpEligibleItem>}
     * @memberof PbWfpCoverage
     */
    'eligible_items'?: Array<PbWfpEligibleItem>;
    /**
     * Coverage price in the contract currency major units.
     * @type {number}
     * @memberof PbWfpCoverage
     */
    'price'?: number;
    /**
     * Sales tax applied to the coverage in major units.
     * @type {number}
     * @memberof PbWfpCoverage
     */
    'sales_tax'?: number;
}
/**
 * WfpEligibleItem is a single covered line item.
 * @export
 * @interface PbWfpEligibleItem
 */
export interface PbWfpEligibleItem {
    /**
     * Shopify line item id covered by the contract.
     * @type {string}
     * @memberof PbWfpEligibleItem
     */
    'line_item_id'?: string;
    /**
     * Quantity of the line item that is covered.
     * @type {number}
     * @memberof PbWfpEligibleItem
     */
    'quantity'?: number;
}
/**
 * WfpSettings is the per-ecommerce Worry Free Purchase configuration.
 * @export
 * @interface PbWfpSettings
 */
export interface PbWfpSettings {
    /**
     * Whether and when the WFP Cover line item is fulfilled on Shopify.  Defaults to FULFILL_AFTER_ITEM_FULFILLMENT (UNSPECIFIED is treated as the  default).
     * @type {string}
     * @memberof PbWfpSettings
     */
    'cover_fulfillment_mode'?: PbWfpSettingsCoverFulfillmentModeEnum;
    /**
     * When this WFP settings row was first created.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'created_at'?: string;
    /**
     * ISO 4217 currency code (e.g., \"EUR\"). Snapshot of ecommerces.currency_code  at activation time; propagated to every Seel call. If the merchant\'s  currency_code is edited after activation, this snapshot goes stale until  the merchant is re-activated (out of scope for v1).
     * @type {string}
     * @memberof PbWfpSettings
     */
    'currency'?: string;
    /**
     * EcommerceID. Primary key.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'ecommerce_id'?: string;
    /**
     * Whether Worry Free Purchase is enabled for this merchant.
     * @type {boolean}
     * @memberof PbWfpSettings
     */
    'enabled'?: boolean;
    /**
     * Logistic recipes applied only to WFP free returns. Selected (and seeded  at activation) as part of WFP config; read at label-generation time to  route a free return to its own carrier/provider.
     * @type {Array<PbReturnLogistics>}
     * @memberof PbWfpSettings
     */
    'free_return_logistics'?: Array<PbReturnLogistics>;
    /**
     * URL of the image used for the WFP Shopify product. Snapshot of the  value used at activation.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'product_image_url'?: string;
    /**
     * Display name of the WFP product as created in the merchant\'s Shopify  catalog (e.g. \"Acme Cover\"). Snapshot of the value used at activation.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'product_title'?: string;
    /**
     * Admin domain registered with Seel for this merchant (e.g.  \"my-shop.myshopify.com\"). Seel\'s /v1/shopify/quotes resolves the  merchant by `admin_domain` rather than `merchant_id`, so this field  is the lookup key on every quote call. Snapshot of the value sent  to Seel at activation time.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'seel_admin_domain'?: string;
    /**
     * Seel-side merchant_id returned by Seel at merchant creation. Required by  every downstream Seel call (Quote / Order / Batch APIs).
     * @type {string}
     * @memberof PbWfpSettings
     */
    'seel_merchant_id'?: string;
    /**
     * Numeric Shopify product id for the WFP product (the trailing segment of  the `gid://shopify/Product/...` GID, without the prefix). Needed so the  deactivation orchestrator can delete the product and so downstream  services can identify WFP line items by product id.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'shopify_wfp_product_id'?: string;
    /**
     * Last time this WFP settings row was updated.
     * @type {string}
     * @memberof PbWfpSettings
     */
    'updated_at'?: string;
}

export const PbWfpSettingsCoverFulfillmentModeEnum = {
    Unspecified: 'WFP_COVER_FULFILLMENT_MODE_UNSPECIFIED',
    FulfillOnPurchase: 'WFP_COVER_FULFILLMENT_MODE_FULFILL_ON_PURCHASE',
    NeverFulfill: 'WFP_COVER_FULFILLMENT_MODE_NEVER_FULFILL',
    FulfillAfterItemFulfillment: 'WFP_COVER_FULFILLMENT_MODE_FULFILL_AFTER_ITEM_FULFILLMENT'
} as const;

export type PbWfpSettingsCoverFulfillmentModeEnum = typeof PbWfpSettingsCoverFulfillmentModeEnum[keyof typeof PbWfpSettingsCoverFulfillmentModeEnum];

/**
 * When conditions to evaluate
 * @export
 * @interface PbWhen
 */
export interface PbWhen {
    /**
     * Every entry is evaluated as an AND condition
     * @type {Array<PbCondition>}
     * @memberof PbWhen
     */
    'conditions'?: Array<PbCondition>;
}
/**
 * WithdrawalRequest is a shopper\'s EU withdrawal request. Nothing in it changes after it is  received.
 * @export
 * @interface PbWithdrawalRequest
 */
export interface PbWithdrawalRequest {
    /**
     * When the merchant marked it as closed. Empty while it\'s open.
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'closed_at'?: string;
    /**
     * E-commerce whose portal received it
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopper\'s email
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'email'?: string;
    /**
     * ID of the request, the reference the shopper gets
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'id'?: string;
    /**
     * Language of the form, ISO 639-1
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'lang'?: string;
    /**
     * Shopper\'s name
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'name'?: string;
    /**
     * Platform ID of the order. Empty when no order matched the number and email.
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'order_id'?: string;
    /**
     * Order number as the shopper typed it
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'order_number'?: string;
    /**
     * First return process started for the same order after the request, if any
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'process_id'?: string;
    /**
     * When REVER received it: the legal proof of when the shopper withdrew
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'received_at'?: string;
    /**
     * Deadline for the merchant\'s refund: 14 days after received_at (Art. 13). For shipped  orders the merchant may wait until it has the goods back or proof they were sent.
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'refund_by'?: string;
    /**
     * Where the request stands, worked out from its return process
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'status'?: PbWithdrawalRequestStatusEnum;
    /**
     * Approximate end of the shopper\'s 14-day withdrawal period, from when the order\'s last  item was delivered, or shipped when the carrier didn\'t report the delivery. For  information only. Empty when we don\'t know.
     * @type {string}
     * @memberof PbWithdrawalRequest
     */
    'withdrawal_period_ends_at'?: string;
}

export const PbWithdrawalRequestStatusEnum = {
    Unspecified: 'WITHDRAWAL_STATUS_UNSPECIFIED',
    Received: 'WITHDRAWAL_STATUS_RECEIVED',
    AwaitingReturn: 'WITHDRAWAL_STATUS_AWAITING_RETURN',
    Returned: 'WITHDRAWAL_STATUS_RETURNED',
    Refunded: 'WITHDRAWAL_STATUS_REFUNDED',
    Closed: 'WITHDRAWAL_STATUS_CLOSED'
} as const;

export type PbWithdrawalRequestStatusEnum = typeof PbWithdrawalRequestStatusEnum[keyof typeof PbWithdrawalRequestStatusEnum];

/**
 * WithdrawalSettings is the EU withdrawal button (Directive 2023/2673)  configuration of an e-commerce\'s portal.
 * @export
 * @interface PbWithdrawalSettings
 */
export interface PbWithdrawalSettings {
    /**
     * E-commerce the settings belong to.
     * @type {string}
     * @memberof PbWithdrawalSettings
     */
    'ecommerce_id'?: string;
    /**
     * Whether the portal shows the withdrawal form and accepts requests.
     * @type {boolean}
     * @memberof PbWithdrawalSettings
     */
    'enabled'?: boolean;
}
/**
 * Specific settings for an e-commerce using the WooCommerce platform
 * @export
 * @interface PbWooCommerceSettings
 */
export interface PbWooCommerceSettings {
    /**
     * The url of the wordpress site
     * @type {string}
     * @memberof PbWooCommerceSettings
     */
    'api_base_url'?: string;
    /**
     * API key
     * @type {string}
     * @memberof PbWooCommerceSettings
     */
    'api_key'?: string;
    /**
     * API secret
     * @type {string}
     * @memberof PbWooCommerceSettings
     */
    'api_secret'?: string;
    /**
     * Version of WooCommerce -- compatibility and breaking changes
     * @type {string}
     * @memberof PbWooCommerceSettings
     */
    'major_version'?: string;
    /**
     * whether authentication with WooCommerce is done with query string  or via header. Default: false (header)
     * @type {boolean}
     * @memberof PbWooCommerceSettings
     */
    'use_query_string_auth'?: boolean;
}
/**
 * 
 * @export
 * @interface PbWorkflow
 */
export interface PbWorkflow {
    /**
     * 
     * @type {string}
     * @memberof PbWorkflow
     */
    'rever_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbWorkflow
     */
    'workflow_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PbWorkflow
     */
    'workflow_type'?: string;
}
/**
 * WorkflowConfigurations model
 * @export
 * @interface PbWorkflowConfigurations
 */
export interface PbWorkflowConfigurations {
    /**
     * EcommerceID
     * @type {string}
     * @memberof PbWorkflowConfigurations
     */
    'ecommerce_id'?: string;
    /**
     * List of workflow activities to skip (e.g., \"GenerateLogisticOrder\", \"SendACKEmail\")  protolint:disable:next REPEATED_FIELD_NAMES_PLURALIZED
     * @type {Array<string>}
     * @memberof PbWorkflowConfigurations
     */
    'skip_workflow_activities'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubAddress
 */
export interface Pbcustomv1directstubAddress {
    /**
     * First line of the street address.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'address_line_1'?: string;
    /**
     * Second line of the street address (floor, apartment, ...). May be empty.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'address_line_2'?: string;
    /**
     * City or town.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'city'?: string;
    /**
     * Country name (e.g. \"United Kingdom\").
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'country'?: string;
    /**
     * ISO 3166-1 alpha-2 country code (e.g. \"GB\").
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'country_code'?: string;
    /**
     * Contact email for this address.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'email'?: string;
    /**
     * First name of the addressee.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'first_name'?: string;
    /**
     * Contact phone number for this address.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'phone'?: string;
    /**
     * Postal or ZIP code.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'postal_code'?: string;
    /**
     * Code of the state, province or region (e.g. \"SRY\").
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'province_code'?: string;
    /**
     * Last name (surname) of the addressee, despite the field name.
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'second_name'?: string;
    /**
     * Name of the state, province or region (e.g. \"Surrey\").
     * @type {string}
     * @memberof Pbcustomv1directstubAddress
     */
    'state_province'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubAssociatedCosts
 */
export interface Pbcustomv1directstubAssociatedCosts {
    /**
     * Shipping cost charged on the order, as a decimal string. REVER records it as the order\'s  shipping cost; unparseable values count as 0.
     * @type {string}
     * @memberof Pbcustomv1directstubAssociatedCosts
     */
    'logistic_costs'?: string;
    /**
     * Order-level discount, as a decimal string. REVER does not read it.
     * @type {string}
     * @memberof Pbcustomv1directstubAssociatedCosts
     */
    'order_discount_amount'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderBody
 */
export interface Pbcustomv1directstubCreateOrderBody {
    /**
     * Customer the exchange order is for.
     * @type {Pbcustomv1directstubCreateOrderCustomerInfo}
     * @memberof Pbcustomv1directstubCreateOrderBody
     */
    'customer_info'?: Pbcustomv1directstubCreateOrderCustomerInfo;
    /**
     * Items to include; REVER merges entries with the same variantID and productID.
     * @type {Array<Pbcustomv1directstubCreateOrderLineItem>}
     * @memberof Pbcustomv1directstubCreateOrderBody
     */
    'line_items'?: Array<Pbcustomv1directstubCreateOrderLineItem>;
    /**
     * Payment attached to the exchange order.
     * @type {Pbcustomv1directstubCreateOrderPayment}
     * @memberof Pbcustomv1directstubCreateOrderBody
     */
    'payment'?: Pbcustomv1directstubCreateOrderPayment;
    /**
     * Address to ship the exchange order to.
     * @type {Pbcustomv1directstubCreateOrderShippingAddress}
     * @memberof Pbcustomv1directstubCreateOrderBody
     */
    'shipping_address'?: Pbcustomv1directstubCreateOrderShippingAddress;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderCustomerInfo
 */
export interface Pbcustomv1directstubCreateOrderCustomerInfo {
    /**
     * Customer\'s company. REVER always sends it empty.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderCustomerInfo
     */
    'company'?: string;
    /**
     * ISO 4217 code of the currency to create the exchange order in.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderCustomerInfo
     */
    'currency'?: string;
    /**
     * Customer\'s email address.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderCustomerInfo
     */
    'email'?: string;
    /**
     * Customer\'s first name, taken from the shipping address.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderCustomerInfo
     */
    'first_name'?: string;
    /**
     * Customer\'s last name, taken from the shipping address.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderCustomerInfo
     */
    'last_name'?: string;
    /**
     * Customer\'s phone number, taken from the shipping address.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderCustomerInfo
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderLineItem
 */
export interface Pbcustomv1directstubCreateOrderLineItem {
    /**
     * Merchant\'s id of the product the variant belongs to.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderLineItem
     */
    'productID'?: string;
    /**
     * Units of this variant to include.
     * @type {number}
     * @memberof Pbcustomv1directstubCreateOrderLineItem
     */
    'quantity'?: number;
    /**
     * Merchant\'s id of the variant to send.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderLineItem
     */
    'variantID'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderOriginal
 */
export interface Pbcustomv1directstubCreateOrderOriginal {
    /**
     * ISO 4217 code of total.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderOriginal
     */
    'currency'?: string;
    /**
     * Customer-facing number of the original order; REVER sends orderID when it has none.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderOriginal
     */
    'order_number'?: string;
    /**
     * Merchant order id of the original order (not the customer-facing number).
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderOriginal
     */
    'orderID'?: string;
    /**
     * Exchange order total REVER derived from the original order\'s discounts, as a decimal in  major units.
     * @type {number}
     * @memberof Pbcustomv1directstubCreateOrderOriginal
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderPayment
 */
export interface Pbcustomv1directstubCreateOrderPayment {
    /**
     * Payment amount for the exchange order, as a decimal in major units; 0 when REVER sends  no payment.
     * @type {number}
     * @memberof Pbcustomv1directstubCreateOrderPayment
     */
    'amount'?: number;
    /**
     * ISO 4217 code of amount; defaults to the exchange order currency.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderPayment
     */
    'currency'?: string;
}
/**
 * Mirrors createOrderRequest. Field casing matches the README verbatim.
 * @export
 * @interface Pbcustomv1directstubCreateOrderRequest
 */
export interface Pbcustomv1directstubCreateOrderRequest {
    /**
     * REVER\'s id of the merchant\'s store.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderRequest
     */
    'ecommerceID'?: string;
    /**
     * Exchange order to create.
     * @type {Pbcustomv1directstubCreateOrderBody}
     * @memberof Pbcustomv1directstubCreateOrderRequest
     */
    'order'?: Pbcustomv1directstubCreateOrderBody;
    /**
     * Order whose return triggered this exchange.
     * @type {Pbcustomv1directstubCreateOrderOriginal}
     * @memberof Pbcustomv1directstubCreateOrderRequest
     */
    'original_order'?: Pbcustomv1directstubCreateOrderOriginal;
}
/**
 * Mirrors createOrderResponse.
 * @export
 * @interface Pbcustomv1directstubCreateOrderResponse
 */
export interface Pbcustomv1directstubCreateOrderResponse {
    /**
     * ISO 4217 code of order_total_price. REVER fails the exchange if it does not support it.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderResponse
     */
    'currency'?: string;
    /**
     * Items of the created exchange order.
     * @type {Array<Pbcustomv1directstubCreateOrderResponseLineItem>}
     * @memberof Pbcustomv1directstubCreateOrderResponse
     */
    'line_items'?: Array<Pbcustomv1directstubCreateOrderResponseLineItem>;
    /**
     * Merchant\'s id of the new exchange order.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderResponse
     */
    'order_id'?: string;
    /**
     * Customer-facing number of the new exchange order.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderResponse
     */
    'order_number'?: string;
    /**
     * Total price of the exchange order, as a decimal in major units of currency.
     * @type {number}
     * @memberof Pbcustomv1directstubCreateOrderResponse
     */
    'order_total_price'?: number;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderResponseLineItem
 */
export interface Pbcustomv1directstubCreateOrderResponseLineItem {
    /**
     * Merchant\'s id of the product.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderResponseLineItem
     */
    'product_id'?: string;
    /**
     * Units of the variant in the exchange order.
     * @type {number}
     * @memberof Pbcustomv1directstubCreateOrderResponseLineItem
     */
    'quantity'?: number;
    /**
     * Merchant\'s id of the variant.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderResponseLineItem
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateOrderShippingAddress
 */
export interface Pbcustomv1directstubCreateOrderShippingAddress {
    /**
     * First line of the street address.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'address_line_1'?: string;
    /**
     * Second line of the street address. May be empty.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'address_line_2'?: string;
    /**
     * City or town.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'city'?: string;
    /**
     * Country name.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'country'?: string;
    /**
     * ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'country_code'?: string;
    /**
     * Postal or ZIP code.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'postcode'?: string;
    /**
     * Name of the state, province or region.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'state_province'?: string;
    /**
     * Code of the state, province or region.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateOrderShippingAddress
     */
    'state_province_code'?: string;
}
/**
 * Mirrors the createPromocodeRequest struct built in  custom/direct/create_promocode.go. Field casing matches the README  verbatim.
 * @export
 * @interface Pbcustomv1directstubCreatePromocodeRequest
 */
export interface Pbcustomv1directstubCreatePromocodeRequest {
    /**
     * ISO 4217 code of the return process currency.
     * @type {string}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'currency_customer'?: string;
    /**
     * ISO 4217 code of the shop currency.
     * @type {string}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'currency_shop'?: string;
    /**
     * REVER\'s id of the merchant\'s store.
     * @type {string}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'ecommerceID'?: string;
    /**
     * Customer-facing number of the order the promocode compensates. A 404 response is read  as order not found.
     * @type {string}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'order_number'?: string;
    /**
     * Code generated by REVER from the order number; register this exact code.
     * @type {string}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'promocode'?: string;
    /**
     * Value of the promocode in currency_customer, as a decimal in major units.
     * @type {number}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'total_customer'?: number;
    /**
     * Value of the promocode in currency_shop, as a decimal in major units.
     * @type {number}
     * @memberof Pbcustomv1directstubCreatePromocodeRequest
     */
    'total_shop'?: number;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCreateReturnLineItem
 */
export interface Pbcustomv1directstubCreateReturnLineItem {
    /**
     * Amount for the returned units after return costs are deducted, in minor units.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnLineItem
     */
    'amount_after_costs'?: string;
    /**
     * Value of the returned units before return costs, in minor units of currency.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnLineItem
     */
    'amount_before_costs'?: string;
    /**
     * Id of the order line being returned (LineItem.id from StoreFindOrder).
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnLineItem
     */
    'line_item_id'?: string;
    /**
     * Units of the line covered by this entry.
     * @type {number}
     * @memberof Pbcustomv1directstubCreateReturnLineItem
     */
    'quantity'?: number;
    /**
     * Review outcome for these units: APPROVED, REJECTED or MISSING.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnLineItem
     */
    'return_status'?: string;
}
/**
 * Mirrors completeReturnRequest. Field casing (orderID, ecommerceID) matches  the README verbatim — do not normalise.
 * @export
 * @interface Pbcustomv1directstubCreateReturnRequest
 */
export interface Pbcustomv1directstubCreateReturnRequest {
    /**
     * ISO 4217 code of every amount in this request.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnRequest
     */
    'currency'?: string;
    /**
     * REVER\'s id of the merchant\'s store.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnRequest
     */
    'ecommerceID'?: string;
    /**
     * Merchant order id of the returned order (the order_id from StoreFindOrder).
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnRequest
     */
    'orderID'?: string;
    /**
     * Order lines covered by the return, each with its review outcome.
     * @type {Array<Pbcustomv1directstubCreateReturnLineItem>}
     * @memberof Pbcustomv1directstubCreateReturnRequest
     */
    'return_line_items'?: Array<Pbcustomv1directstubCreateReturnLineItem>;
    /**
     * Return costs deducted from the refund, in minor units: the sum over return_line_items of  the difference between amount_before_costs and amount_after_costs.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnRequest
     */
    'return_shipping_cost_amount'?: string;
    /**
     * Original shipping cost refunded to the customer, in minor units of currency (cents).
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnRequest
     */
    'shipping_cost_refund_amount'?: string;
}
/**
 * Mirrors completeReturnResponseBody.
 * @export
 * @interface Pbcustomv1directstubCreateReturnResponse
 */
export interface Pbcustomv1directstubCreateReturnResponse {
    /**
     * Merchant\'s id for the created return. Optional; REVER proceeds without it.
     * @type {string}
     * @memberof Pbcustomv1directstubCreateReturnResponse
     */
    'return_id'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubCustomerInfo
 */
export interface Pbcustomv1directstubCustomerInfo {
    /**
     * ISO 4217 code of the currency the customer paid in. REVER reads every order amount in  this currency; when empty it falls back to shop_currency.
     * @type {string}
     * @memberof Pbcustomv1directstubCustomerInfo
     */
    'currency'?: string;
    /**
     * Customer\'s email. REVER compares it, ignoring case, with the email the shopper enters;  a mismatch is reported as order not found.
     * @type {string}
     * @memberof Pbcustomv1directstubCustomerInfo
     */
    'email'?: string;
    /**
     * First name of the customer who placed the order.
     * @type {string}
     * @memberof Pbcustomv1directstubCustomerInfo
     */
    'first_name'?: string;
    /**
     * Last name of the customer who placed the order.
     * @type {string}
     * @memberof Pbcustomv1directstubCustomerInfo
     */
    'last_name'?: string;
    /**
     * Customer\'s phone number. REVER does not read it.
     * @type {string}
     * @memberof Pbcustomv1directstubCustomerInfo
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubLineItem
 */
export interface Pbcustomv1directstubLineItem {
    /**
     * Merchant\'s id for this order line. REVER sends it back as line_item_id when returning it.
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'id'?: string;
    /**
     * Whether the line can be returned. When false, REVER marks all its units non-returnable;  omitted means returnable.
     * @type {boolean}
     * @memberof Pbcustomv1directstubLineItem
     */
    'is_returnable'?: boolean;
    /**
     * Why the line cannot be returned, as a REVER NonReturnableReason number (e.g. 3 =  NON_RETURNABLE). Read only when is_returnable is false; 0 or unknown values become 3.
     * @type {number}
     * @memberof Pbcustomv1directstubLineItem
     */
    'non_returnable_reason'?: number;
    /**
     * Product of this line, including its variants.
     * @type {Pbcustomv1directstubProduct}
     * @memberof Pbcustomv1directstubLineItem
     */
    'product'?: Pbcustomv1directstubProduct;
    /**
     * Units of the variant bought on this line.
     * @type {number}
     * @memberof Pbcustomv1directstubLineItem
     */
    'quantity'?: number;
    /**
     * SKU of the purchased variant.
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'sku'?: string;
    /**
     * Amount of the whole line before discounts (unit_price x quantity), as a decimal string.
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'subtotal'?: string;
    /**
     * Amount paid for the whole line after discounts, as a decimal string. REVER bases the  refund on it.
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'total'?: string;
    /**
     * Discount on each unit, as a decimal string. REVER subtracts it from unit_price (never  going below 0); empty means no discount.
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'unit_discount_amount'?: string;
    /**
     * Price of one unit before discounts, as a decimal string in major units (e.g. \"45.00\").
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'unit_price'?: string;
    /**
     * Merchant\'s id of the purchased variant.
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'variant_id'?: string;
    /**
     * Name of the purchased variant (e.g. \"Large\").
     * @type {string}
     * @memberof Pbcustomv1directstubLineItem
     */
    'variant_name'?: string;
}
/**
 * Mirrors orderResponse in custom/direct/models.go.
 * @export
 * @interface Pbcustomv1directstubOrder
 */
export interface Pbcustomv1directstubOrder {
    /**
     * Order-level shipping cost and discount.
     * @type {Pbcustomv1directstubAssociatedCosts}
     * @memberof Pbcustomv1directstubOrder
     */
    'associated_costs'?: Pbcustomv1directstubAssociatedCosts;
    /**
     * Billing address of the order.
     * @type {Pbcustomv1directstubAddress}
     * @memberof Pbcustomv1directstubOrder
     */
    'billing_address'?: Pbcustomv1directstubAddress;
    /**
     * Customer who placed the order.
     * @type {Pbcustomv1directstubCustomerInfo}
     * @memberof Pbcustomv1directstubOrder
     */
    'customer_info'?: Pbcustomv1directstubCustomerInfo;
    /**
     * Rate between the customer\'s currency and shop_currency. REVER divides every order amount  by it; 0 or unset is treated as 1.
     * @type {number}
     * @memberof Pbcustomv1directstubOrder
     */
    'exchange_rate'?: number;
    /**
     * When the order was fulfilled, as an RFC 3339 timestamp; return-period checks use it.  May be empty; any other format fails the order lookup.
     * @type {string}
     * @memberof Pbcustomv1directstubOrder
     */
    'fulfilled_at'?: string;
    /**
     * Lines purchased in the order; these are what the customer can return.
     * @type {Array<Pbcustomv1directstubLineItem>}
     * @memberof Pbcustomv1directstubOrder
     */
    'line_items'?: Array<Pbcustomv1directstubLineItem>;
    /**
     * Merchant\'s internal order id. REVER sends it back as orderID in StoreCreateReturn.
     * @type {string}
     * @memberof Pbcustomv1directstubOrder
     */
    'order_id'?: string;
    /**
     * Customer-facing order number, as shown to the shopper (e.g. \"QQS-20045\").
     * @type {string}
     * @memberof Pbcustomv1directstubOrder
     */
    'order_number'?: string;
    /**
     * How the order was paid. Decides whether REVER can refund to the original payment method.
     * @type {Pbcustomv1directstubPaymentMethod}
     * @memberof Pbcustomv1directstubOrder
     */
    'payment_method'?: Pbcustomv1directstubPaymentMethod;
    /**
     * When the order was placed, as an RFC 3339 timestamp (e.g. \"2025-01-01T10:00:00Z\").  May be empty; any other format fails the order lookup.
     * @type {string}
     * @memberof Pbcustomv1directstubOrder
     */
    'purchased_at'?: string;
    /**
     * Address the order was shipped to.
     * @type {Pbcustomv1directstubAddress}
     * @memberof Pbcustomv1directstubOrder
     */
    'shipping_address'?: Pbcustomv1directstubAddress;
    /**
     * ISO 4217 code of the shop\'s base currency (e.g. \"EUR\").
     * @type {string}
     * @memberof Pbcustomv1directstubOrder
     */
    'shop_currency'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubPaymentDetails
 */
export interface Pbcustomv1directstubPaymentDetails {
    /**
     * Gateway transaction id of the payment. REVER refunds against it and fails the refund  when it is empty.
     * @type {string}
     * @memberof Pbcustomv1directstubPaymentDetails
     */
    'transaction_id'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubPaymentMethod
 */
export interface Pbcustomv1directstubPaymentMethod {
    /**
     * Gateway details of the payment, used to refund to the original payment method.
     * @type {Pbcustomv1directstubPaymentDetails}
     * @memberof Pbcustomv1directstubPaymentMethod
     */
    'payment_details'?: Pbcustomv1directstubPaymentDetails;
    /**
     * Must be one of redsys, bizum, paypal, sequra, stripe, klarna for CreateRefund to route  correctly on the ecommerce-api side.
     * @type {string}
     * @memberof Pbcustomv1directstubPaymentMethod
     */
    'platform_id'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubProduct
 */
export interface Pbcustomv1directstubProduct {
    /**
     * Long description of the product.
     * @type {string}
     * @memberof Pbcustomv1directstubProduct
     */
    'description'?: string;
    /**
     * Merchant\'s product id. REVER uses it as the line\'s product id.
     * @type {string}
     * @memberof Pbcustomv1directstubProduct
     */
    'id'?: string;
    /**
     * Images of the product.
     * @type {Array<Pbcustomv1directstubProductImage>}
     * @memberof Pbcustomv1directstubProduct
     */
    'images'?: Array<Pbcustomv1directstubProductImage>;
    /**
     * Product name. REVER also uses it as the line item name.
     * @type {string}
     * @memberof Pbcustomv1directstubProduct
     */
    'name'?: string;
    /**
     * Variants of the product. REVER ignores those with is_enabled set to false.
     * @type {Array<Pbcustomv1directstubVariant>}
     * @memberof Pbcustomv1directstubProduct
     */
    'variants'?: Array<Pbcustomv1directstubVariant>;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubProductImage
 */
export interface Pbcustomv1directstubProductImage {
    /**
     * Alternative text of the image.
     * @type {string}
     * @memberof Pbcustomv1directstubProductImage
     */
    'alt'?: string;
    /**
     * Public URL of the image.
     * @type {string}
     * @memberof Pbcustomv1directstubProductImage
     */
    'src'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubVariant
 */
export interface Pbcustomv1directstubVariant {
    /**
     * Whether the variant is available. REVER drops disabled variants from the product.
     * @type {boolean}
     * @memberof Pbcustomv1directstubVariant
     */
    'is_enabled'?: boolean;
    /**
     * Options that define this variant (e.g. Size: L).
     * @type {Array<Pbcustomv1directstubVariantOption>}
     * @memberof Pbcustomv1directstubVariant
     */
    'options'?: Array<Pbcustomv1directstubVariantOption>;
    /**
     * Description of the variant.
     * @type {string}
     * @memberof Pbcustomv1directstubVariant
     */
    'variant_description'?: string;
    /**
     * Merchant\'s id of the variant, as referenced by LineItem.variant_id.
     * @type {string}
     * @memberof Pbcustomv1directstubVariant
     */
    'variant_id'?: string;
    /**
     * Name of the variant (e.g. \"Large\").
     * @type {string}
     * @memberof Pbcustomv1directstubVariant
     */
    'variant_name'?: string;
    /**
     * Price of one unit of the variant, as a decimal string; unparseable values count as 0.
     * @type {string}
     * @memberof Pbcustomv1directstubVariant
     */
    'variant_price'?: string;
    /**
     * SKU of the variant.
     * @type {string}
     * @memberof Pbcustomv1directstubVariant
     */
    'variant_sku'?: string;
}
/**
 * 
 * @export
 * @interface Pbcustomv1directstubVariantOption
 */
export interface Pbcustomv1directstubVariantOption {
    /**
     * Merchant\'s id of the option (e.g. \"Size\").
     * @type {string}
     * @memberof Pbcustomv1directstubVariantOption
     */
    'option_id'?: string;
    /**
     * Display name of the option (e.g. \"Size\").
     * @type {string}
     * @memberof Pbcustomv1directstubVariantOption
     */
    'option_name'?: string;
    /**
     * Value the variant has for this option (e.g. \"L\").
     * @type {string}
     * @memberof Pbcustomv1directstubVariantOption
     */
    'option_value'?: string;
}
/**
 * Postal address used for shipping or billing.
 * @export
 * @interface Pbcustomv2stubAddress
 */
export interface Pbcustomv2stubAddress {
    /**
     * First line of the street address (e.g. `Carrer de Mallorca 207`).
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'address_line_1'?: string;
    /**
     * Second line of the street address, such as floor and door (e.g. `3r 2a`). Optional.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'address_line_2'?: string;
    /**
     * City or town (e.g. `Barcelona`).
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'city'?: string;
    /**
     * Display name of the country.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'country'?: string;
    /**
     * ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'country_code'?: string;
    /**
     * Contact email for this address. When empty on an order, REVER uses `customer_info.email`.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'email'?: string;
    /**
     * Recipient\'s first name. When empty on an order, REVER uses `customer_info.first_name`.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'first_name'?: string;
    /**
     * Recipient\'s last name. When empty on an order, REVER uses `customer_info.last_name`.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'last_name'?: string;
    /**
     * Contact phone for this address. When empty on an order, REVER uses `customer_info.phone`.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'phone'?: string;
    /**
     * Postal / ZIP code (e.g. `08036`).
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'postal_code'?: string;
    /**
     * Display name of the province / state / region. Free-form text. Omit  when the country has no meaningful subdivision.
     * @type {string}
     * @memberof Pbcustomv2stubAddress
     */
    'province_state'?: string;
}
/**
 * The state of one line of the exchange order after the cancel call.
 * @export
 * @interface Pbcustomv2stubCancelExchangeOrderLineItem
 */
export interface Pbcustomv2stubCancelExchangeOrderLineItem {
    /**
     * Units of this line canceled, by this call or an earlier one.
     * @type {number}
     * @memberof Pbcustomv2stubCancelExchangeOrderLineItem
     */
    'canceled_quantity'?: number;
    /**
     * Line item id (ecommerce-side identifier).
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderLineItem
     */
    'line_item_id'?: string;
    /**
     * Units ordered on this line.
     * @type {number}
     * @memberof Pbcustomv2stubCancelExchangeOrderLineItem
     */
    'quantity'?: number;
    /**
     * Units of this line handed to a carrier.
     * @type {number}
     * @memberof Pbcustomv2stubCancelExchangeOrderLineItem
     */
    'shipped_quantity'?: number;
    /**
     * Variant on this line.
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderLineItem
     */
    'variant_id'?: string;
}
/**
 * Request body for POST /rever/v2/orders/{order_id}/cancel.
 * @export
 * @interface Pbcustomv2stubCancelExchangeOrderRequest
 */
export interface Pbcustomv2stubCancelExchangeOrderRequest {
    /**
     * Source ecommerce id.
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * Deterministic key REVER derives as `\"{ecommerce_id}:{order_id}:cancel\"`  and replays on retry.
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderRequest
     */
    'idempotency_key'?: string;
    /**
     * Internal id of the exchange order, as returned by POST /rever/v2/orders.  Set in the path.
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderRequest
     */
    'order_id'?: string;
}
/**
 * Response body for POST /rever/v2/orders/{order_id}/cancel.
 * @export
 * @interface Pbcustomv2stubCancelExchangeOrderResponse
 */
export interface Pbcustomv2stubCancelExchangeOrderResponse {
    /**
     * Every line of the order, with its state after the call.
     * @type {Array<Pbcustomv2stubCancelExchangeOrderLineItem>}
     * @memberof Pbcustomv2stubCancelExchangeOrderResponse
     */
    'line_items'?: Array<Pbcustomv2stubCancelExchangeOrderLineItem>;
    /**
     * Internal id of the exchange order.
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderResponse
     */
    'order_id'?: string;
    /**
     * What the call did to the order.
     * @type {string}
     * @memberof Pbcustomv2stubCancelExchangeOrderResponse
     */
    'outcome'?: Pbcustomv2stubCancelExchangeOrderResponseOutcomeEnum;
}

export const Pbcustomv2stubCancelExchangeOrderResponseOutcomeEnum = {
    OutcomeUnspecified: 'OUTCOME_UNSPECIFIED',
    Canceled: 'CANCELED',
    AlreadyCanceled: 'ALREADY_CANCELED',
    AlreadyShipped: 'ALREADY_SHIPPED'
} as const;

export type Pbcustomv2stubCancelExchangeOrderResponseOutcomeEnum = typeof Pbcustomv2stubCancelExchangeOrderResponseOutcomeEnum[keyof typeof Pbcustomv2stubCancelExchangeOrderResponseOutcomeEnum];

/**
 * The new order REVER asks the ecommerce to create.
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderBody
 */
export interface Pbcustomv2stubCreateExchangeOrderBody {
    /**
     * Customer information for the exchange order.
     * @type {Pbcustomv2stubCustomerInfo}
     * @memberof Pbcustomv2stubCreateExchangeOrderBody
     */
    'customer_info'?: Pbcustomv2stubCustomerInfo;
    /**
     * Lines to fulfil.
     * @type {Array<Pbcustomv2stubCreateExchangeOrderLineItem>}
     * @memberof Pbcustomv2stubCreateExchangeOrderBody
     */
    'line_items'?: Array<Pbcustomv2stubCreateExchangeOrderLineItem>;
    /**
     * Upcharge paid by the shopper, when applicable.
     * @type {Pbcustomv2stubCreateExchangeOrderPayment}
     * @memberof Pbcustomv2stubCreateExchangeOrderBody
     */
    'payment'?: Pbcustomv2stubCreateExchangeOrderPayment;
    /**
     * Shipping address for the exchange order.
     * @type {Pbcustomv2stubAddress}
     * @memberof Pbcustomv2stubCreateExchangeOrderBody
     */
    'shipping_address'?: Pbcustomv2stubAddress;
}
/**
 * One requested line in an exchange order — a specific variant of a  specific product, with quantity.
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderLineItem
 */
export interface Pbcustomv2stubCreateExchangeOrderLineItem {
    /**
     * Product the variant belongs to.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderLineItem
     */
    'product_id'?: string;
    /**
     * Units to fulfil.
     * @type {number}
     * @memberof Pbcustomv2stubCreateExchangeOrderLineItem
     */
    'quantity'?: number;
    /**
     * Variant chosen by the shopper.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderLineItem
     */
    'variant_id'?: string;
}
/**
 * Reference to the order being exchanged from.
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderOriginal
 */
export interface Pbcustomv2stubCreateExchangeOrderOriginal {
    /**
     * Shopper currency (ISO 4217) of the original order.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderOriginal
     */
    'currency'?: string;
    /**
     * Internal id on the ecommerce side of the order being exchanged from.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderOriginal
     */
    'order_id'?: string;
    /**
     * Customer-facing number of the original order. REVER sends `order_id` here when it has no  order number for the return.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderOriginal
     */
    'order_number'?: string;
    /**
     * Decimal string in the original order\'s shopper currency.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderOriginal
     */
    'total'?: string;
}
/**
 * Optional payment the shopper made for the exchange — only present when  the chosen variant costs more than the original.
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderPayment
 */
export interface Pbcustomv2stubCreateExchangeOrderPayment {
    /**
     * Decimal string in `currency`.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderPayment
     */
    'amount'?: string;
    /**
     * ISO 4217, the shopper\'s currency.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderPayment
     */
    'currency'?: string;
}
/**
 * Request body for POST /rever/v2/orders.
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderRequest
 */
export interface Pbcustomv2stubCreateExchangeOrderRequest {
    /**
     * Source ecommerce id.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * Deterministic key REVER derives as  `\"{ecommerce_id}:{return_id}:exchange\"` and replays on retry.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderRequest
     */
    'idempotency_key'?: string;
    /**
     * The new order to create.
     * @type {Pbcustomv2stubCreateExchangeOrderBody}
     * @memberof Pbcustomv2stubCreateExchangeOrderRequest
     */
    'order'?: Pbcustomv2stubCreateExchangeOrderBody;
    /**
     * Reference to the original order being exchanged from.
     * @type {Pbcustomv2stubCreateExchangeOrderOriginal}
     * @memberof Pbcustomv2stubCreateExchangeOrderRequest
     */
    'original_order'?: Pbcustomv2stubCreateExchangeOrderOriginal;
    /**
     * Return process id this exchange settles.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderRequest
     */
    'return_id'?: string;
}
/**
 * Response body for POST /rever/v2/orders. On a replay (same  `idempotency_key`), return the same body as the original successful  response.
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderResponse
 */
export interface Pbcustomv2stubCreateExchangeOrderResponse {
    /**
     * Shopper currency (ISO 4217) of the new order.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponse
     */
    'currency'?: string;
    /**
     * Lines actually fulfilled. May be a strict subset of the request.
     * @type {Array<Pbcustomv2stubCreateExchangeOrderResponseLineItem>}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponse
     */
    'line_items'?: Array<Pbcustomv2stubCreateExchangeOrderResponseLineItem>;
    /**
     * Internal id of the new exchange order. Stable across re-deliveries of  the same idempotency key.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponse
     */
    'order_id'?: string;
    /**
     * Customer-facing order number.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponse
     */
    'order_number'?: string;
    /**
     * Decimal string in the new order\'s shopper currency.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponse
     */
    'total'?: string;
}
/**
 * One line in the exchange-order response — what the ecommerce actually  fulfilled (which may be a subset of the request when partial fulfilment  was needed).
 * @export
 * @interface Pbcustomv2stubCreateExchangeOrderResponseLineItem
 */
export interface Pbcustomv2stubCreateExchangeOrderResponseLineItem {
    /**
     * Product the fulfilled variant belongs to.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponseLineItem
     */
    'product_id'?: string;
    /**
     * Units of this variant the ecommerce actually fulfilled.
     * @type {number}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponseLineItem
     */
    'quantity'?: number;
    /**
     * Variant the ecommerce fulfilled, matching a `variant_id` from the request.
     * @type {string}
     * @memberof Pbcustomv2stubCreateExchangeOrderResponseLineItem
     */
    'variant_id'?: string;
}
/**
 * Request body for POST /rever/v2/giftcards. Gift cards are always  denominated in the source order\'s shopper currency.
 * @export
 * @interface Pbcustomv2stubCreateGiftCardRequest
 */
export interface Pbcustomv2stubCreateGiftCardRequest {
    /**
     * Initial face value of the gift card.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardRequest
     */
    'amount'?: string;
    /**
     * ISO 4217. Must equal the source order\'s `customer_currency`.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardRequest
     */
    'currency'?: string;
    /**
     * Source ecommerce id.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardRequest
     */
    'ecommerce_id'?: string;
    /**
     * Deterministic key REVER derives as  `\"{ecommerce_id}:{return_id}:giftcard\"` and replays on retry. The  ecommerce must dedupe on it.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardRequest
     */
    'idempotency_key'?: string;
    /**
     * Source order number — the order whose return is producing this gift  card.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardRequest
     */
    'order_number'?: string;
    /**
     * Taxes already included in `amount`. Empty string is treated as \"0.00\".
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardRequest
     */
    'taxes'?: string;
}
/**
 * Response body for POST /rever/v2/giftcards.
 * @export
 * @interface Pbcustomv2stubCreateGiftCardResponse
 */
export interface Pbcustomv2stubCreateGiftCardResponse {
    /**
     * Customer-facing gift-card code (the value the shopper types or scans).
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardResponse
     */
    'code'?: string;
    /**
     * ISO 8601 expiration timestamp, if any.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardResponse
     */
    'expires_on'?: string;
    /**
     * Ecommerce-side identifier for this gift card; used on the GET / DELETE  endpoints.
     * @type {string}
     * @memberof Pbcustomv2stubCreateGiftCardResponse
     */
    'platform_id'?: string;
}
/**
 * Request body for POST /rever/v2/promocodes. Promocodes are always  denominated in the source order\'s shopper currency.
 * @export
 * @interface Pbcustomv2stubCreatePromocodeRequest
 */
export interface Pbcustomv2stubCreatePromocodeRequest {
    /**
     * Face value of the promocode (maximum discount it can apply).
     * @type {string}
     * @memberof Pbcustomv2stubCreatePromocodeRequest
     */
    'amount'?: string;
    /**
     * ISO 4217. Must equal the source order\'s `customer_currency`.
     * @type {string}
     * @memberof Pbcustomv2stubCreatePromocodeRequest
     */
    'currency'?: string;
    /**
     * Source ecommerce id.
     * @type {string}
     * @memberof Pbcustomv2stubCreatePromocodeRequest
     */
    'ecommerce_id'?: string;
    /**
     * Deterministic key REVER derives as  `\"{ecommerce_id}:{return_id}:promocode\"` and replays on retry. The  ecommerce must dedupe on it.
     * @type {string}
     * @memberof Pbcustomv2stubCreatePromocodeRequest
     */
    'idempotency_key'?: string;
    /**
     * Source order number — the order whose return is producing this  promocode.
     * @type {string}
     * @memberof Pbcustomv2stubCreatePromocodeRequest
     */
    'order_number'?: string;
}
/**
 * Response body for POST /rever/v2/promocodes.
 * @export
 * @interface Pbcustomv2stubCreatePromocodeResponse
 */
export interface Pbcustomv2stubCreatePromocodeResponse {
    /**
     * Promocode value. Convention: `RV-{order_number}-{random}`, length 15.  Same value used on the GET / DELETE endpoints.
     * @type {string}
     * @memberof Pbcustomv2stubCreatePromocodeResponse
     */
    'code'?: string;
}
/**
 * Customer information attached to an order.
 * @export
 * @interface Pbcustomv2stubCustomerInfo
 */
export interface Pbcustomv2stubCustomerInfo {
    /**
     * Customer\'s email address. On orders, REVER also uses it for addresses without `email`.
     * @type {string}
     * @memberof Pbcustomv2stubCustomerInfo
     */
    'email'?: string;
    /**
     * Customer\'s first name. On orders, REVER also uses it for addresses without `first_name`.
     * @type {string}
     * @memberof Pbcustomv2stubCustomerInfo
     */
    'first_name'?: string;
    /**
     * Customer\'s last name. On orders, REVER also uses it for addresses without `last_name`.
     * @type {string}
     * @memberof Pbcustomv2stubCustomerInfo
     */
    'last_name'?: string;
    /**
     * Customer\'s phone number (e.g. `+34600123456`). May be empty. On orders, REVER also uses it  for addresses without `phone`.
     * @type {string}
     * @memberof Pbcustomv2stubCustomerInfo
     */
    'phone'?: string;
}
/**
 * A length × width × height bounding box. All three lengths share `unit`.
 * @export
 * @interface Pbcustomv2stubDimensions
 */
export interface Pbcustomv2stubDimensions {
    /**
     * Height as a decimal string in `unit` (e.g. `13`). REVER rounds it to whole centimeters.
     * @type {string}
     * @memberof Pbcustomv2stubDimensions
     */
    'height'?: string;
    /**
     * Length as a decimal string in `unit` (e.g. `33`). REVER rounds it to whole centimeters.
     * @type {string}
     * @memberof Pbcustomv2stubDimensions
     */
    'length'?: string;
    /**
     * m · cm · in.
     * @type {string}
     * @memberof Pbcustomv2stubDimensions
     */
    'unit'?: string;
    /**
     * Width as a decimal string in `unit` (e.g. `21`). REVER rounds it to whole centimeters.
     * @type {string}
     * @memberof Pbcustomv2stubDimensions
     */
    'width'?: string;
}
/**
 * Response envelope for GET /rever/v2/orders/{order_id}/transactions.
 * @export
 * @interface Pbcustomv2stubGetTransactionsResponse
 */
export interface Pbcustomv2stubGetTransactionsResponse {
    /**
     * Transactions ordered as the ecommerce returned them.
     * @type {Array<Pbcustomv2stubTransaction>}
     * @memberof Pbcustomv2stubGetTransactionsResponse
     */
    'transactions'?: Array<Pbcustomv2stubTransaction>;
}
/**
 * State of a previously issued gift card.
 * @export
 * @interface Pbcustomv2stubGiftCard
 */
export interface Pbcustomv2stubGiftCard {
    /**
     * Initial face value.
     * @type {string}
     * @memberof Pbcustomv2stubGiftCard
     */
    'amount'?: string;
    /**
     * Current spendable balance.
     * @type {string}
     * @memberof Pbcustomv2stubGiftCard
     */
    'balance'?: string;
    /**
     * Customer-facing code.
     * @type {string}
     * @memberof Pbcustomv2stubGiftCard
     */
    'code'?: string;
    /**
     * ISO 4217.
     * @type {string}
     * @memberof Pbcustomv2stubGiftCard
     */
    'currency'?: string;
    /**
     * ISO 8601 expiration timestamp, if any.
     * @type {string}
     * @memberof Pbcustomv2stubGiftCard
     */
    'expires_on'?: string;
    /**
     * Ecommerce-side identifier.
     * @type {string}
     * @memberof Pbcustomv2stubGiftCard
     */
    'platform_id'?: string;
}
/**
 * An image reference.
 * @export
 * @interface Pbcustomv2stubImage
 */
export interface Pbcustomv2stubImage {
    /**
     * Accessibility text describing the image.
     * @type {string}
     * @memberof Pbcustomv2stubImage
     */
    'alt_text'?: string;
    /**
     * Publicly reachable URL of the image.
     * @type {string}
     * @memberof Pbcustomv2stubImage
     */
    'url'?: string;
}
/**
 * A single order-level fee on top of the line items. All amounts are in  shopper currency (`Order.customer_currency`). Net contribution to the  order total is `amount - discount + taxes`.
 * @export
 * @interface Pbcustomv2stubLineFee
 */
export interface Pbcustomv2stubLineFee {
    /**
     * Gross fee charged to the customer.
     * @type {string}
     * @memberof Pbcustomv2stubLineFee
     */
    'amount'?: string;
    /**
     * Discount applied to this fee (free-shipping promotion, loyalty perk,  …). Empty string is treated as \"0.00\".
     * @type {string}
     * @memberof Pbcustomv2stubLineFee
     */
    'discount'?: string;
    /**
     * Taxes on this fee, on top of `amount - discount`. Empty string is  treated as \"0.00\".
     * @type {string}
     * @memberof Pbcustomv2stubLineFee
     */
    'taxes'?: string;
    /**
     * Fee type. Open string so new categories can appear without a spec  change. Today REVER only acts on `SHIPPING_FEE` specifically; others  (`HANDLING_FEE`, `INSURANCE_FEE`, `OTHER`, …) still contribute to the  order total.
     * @type {string}
     * @memberof Pbcustomv2stubLineFee
     */
    'type'?: string;
}
/**
 * A line in an order. All monetary fields are in shopper currency  (`Order.customer_currency`).
 * @export
 * @interface Pbcustomv2stubLineItem
 */
export interface Pbcustomv2stubLineItem {
    /**
     * Units of this line canceled. Required if you implement  POST /rever/v2/orders/{order_id}/cancel.
     * @type {number}
     * @memberof Pbcustomv2stubLineItem
     */
    'canceled_quantity'?: number;
    /**
     * Bounding-box dimensions of this line, if known.
     * @type {Pbcustomv2stubDimensions}
     * @memberof Pbcustomv2stubLineItem
     */
    'dimensions'?: Pbcustomv2stubDimensions;
    /**
     * Line item id (ecommerce-side identifier).
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'id'?: string;
    /**
     * Whether this line is returnable under the merchant\'s policy.
     * @type {boolean}
     * @memberof Pbcustomv2stubLineItem
     */
    'is_returnable'?: boolean;
    /**
     * When `is_returnable` is false, encodes the reason: 2 = already returned,  3 = policy, 4 = not yet fulfilled, 5 = out of return window.
     * @type {number}
     * @memberof Pbcustomv2stubLineItem
     */
    'non_returnable_reason'?: number;
    /**
     * The product purchased on this line.
     * @type {Pbcustomv2stubProduct}
     * @memberof Pbcustomv2stubLineItem
     */
    'product'?: Pbcustomv2stubProduct;
    /**
     * Units of this product in the order.
     * @type {number}
     * @memberof Pbcustomv2stubLineItem
     */
    'quantity'?: number;
    /**
     * Units of this line handed to a carrier. Required if you implement  POST /rever/v2/orders/{order_id}/cancel: REVER reads it to show whether an  exchange order has shipped, and never cancels one that has.
     * @type {number}
     * @memberof Pbcustomv2stubLineItem
     */
    'shipped_quantity'?: number;
    /**
     * `(unit_price - unit_discount) * quantity`.
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'subtotal'?: string;
    /**
     * Final amount paid for this line — `subtotal + total_taxes`.
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'total'?: string;
    /**
     * Taxes on this line, on top of `subtotal`.
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'total_taxes'?: string;
    /**
     * Discount per unit, absolute amount. Empty string is treated as \"0.00\".
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'unit_discount'?: string;
    /**
     * Price of one unit, pre-discount and pre-tax.
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'unit_price'?: string;
    /**
     * Variant id. Optional — only set when the parent product has variants.
     * @type {string}
     * @memberof Pbcustomv2stubLineItem
     */
    'variant_id'?: string;
    /**
     * Physical weight of this line, if known.
     * @type {Pbcustomv2stubWeight}
     * @memberof Pbcustomv2stubLineItem
     */
    'weight'?: Pbcustomv2stubWeight;
}
/**
 * Response envelope for GET /rever/v2/products.
 * @export
 * @interface Pbcustomv2stubListProductsResponse
 */
export interface Pbcustomv2stubListProductsResponse {
    /**
     * Pagination metadata.
     * @type {Pbcustomv2stubPageInfo}
     * @memberof Pbcustomv2stubListProductsResponse
     */
    'page_info'?: Pbcustomv2stubPageInfo;
    /**
     * Page of products.
     * @type {Array<Pbcustomv2stubProduct>}
     * @memberof Pbcustomv2stubListProductsResponse
     */
    'products'?: Array<Pbcustomv2stubProduct>;
}
/**
 * Response envelope for GET /rever/v2/menu.
 * @export
 * @interface Pbcustomv2stubMenu
 */
export interface Pbcustomv2stubMenu {
    /**
     * Root id (typically `root`).
     * @type {string}
     * @memberof Pbcustomv2stubMenu
     */
    'id'?: string;
    /**
     * Top-level menu items.
     * @type {Array<Pbcustomv2stubMenuItem>}
     * @memberof Pbcustomv2stubMenu
     */
    'items'?: Array<Pbcustomv2stubMenuItem>;
}
/**
 * One node of the category hierarchy.
 * @export
 * @interface Pbcustomv2stubMenuItem
 */
export interface Pbcustomv2stubMenuItem {
    /**
     * Sub-categories under this node.
     * @type {Array<Pbcustomv2stubMenuItem>}
     * @memberof Pbcustomv2stubMenuItem
     */
    'children'?: Array<Pbcustomv2stubMenuItem>;
    /**
     * Stable id of the node.
     * @type {string}
     * @memberof Pbcustomv2stubMenuItem
     */
    'id'?: string;
    /**
     * Identifier of the resource this menu item points to.
     * @type {string}
     * @memberof Pbcustomv2stubMenuItem
     */
    'resource_id'?: string;
    /**
     * COLLECTION · CATALOG · SEARCH.
     * @type {string}
     * @memberof Pbcustomv2stubMenuItem
     */
    'resource_type'?: string;
    /**
     * Localized display title.
     * @type {string}
     * @memberof Pbcustomv2stubMenuItem
     */
    'title'?: string;
}
/**
 * An order on the ecommerce side. Carries two currencies — `shop_currency`  (the merchant\'s home currency, used by the catalog) and  `customer_currency` (what the shopper was charged). `exchange_rate` is  required and non-zero when they differ; otherwise it can be omitted and  defaults to 1.0.
 * @export
 * @interface Pbcustomv2stubOrder
 */
export interface Pbcustomv2stubOrder {
    /**
     * Billing address. Optional — REVER falls back to `shipping_address` when  absent.
     * @type {Pbcustomv2stubAddress}
     * @memberof Pbcustomv2stubOrder
     */
    'billing_address'?: Pbcustomv2stubAddress;
    /**
     * ISO 8601 timestamp when the order was canceled. Empty or absent while it  is not. Required if you implement POST /rever/v2/orders/{order_id}/cancel:  REVER reads it to show whether an exchange order can still be canceled.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'canceled_at'?: string;
    /**
     * Optional order-level categories.
     * @type {Array<string>}
     * @memberof Pbcustomv2stubOrder
     */
    'categories'?: Array<string>;
    /**
     * Shopper currency (ISO 4217). All line-item amounts, line fees,  transactions and refunds on this order are in this currency.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'customer_currency'?: string;
    /**
     * Customer information.
     * @type {Pbcustomv2stubCustomerInfo}
     * @memberof Pbcustomv2stubOrder
     */
    'customer_info'?: Pbcustomv2stubCustomerInfo;
    /**
     * Conversion factor between `shop_currency` and `customer_currency`,  captured at purchase time. `customer_amount = shop_amount * exchange_rate`.  Required and non-zero when the two currencies differ.
     * @type {number}
     * @memberof Pbcustomv2stubOrder
     */
    'exchange_rate'?: number;
    /**
     * ISO 8601 timestamp when the order was fulfilled.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'fulfilled_at'?: string;
    /**
     * Order-level fees on top of the line items (shipping, handling,  insurance, …). May be empty.
     * @type {Array<Pbcustomv2stubLineFee>}
     * @memberof Pbcustomv2stubOrder
     */
    'line_fees'?: Array<Pbcustomv2stubLineFee>;
    /**
     * Line items in the order.
     * @type {Array<Pbcustomv2stubLineItem>}
     * @memberof Pbcustomv2stubOrder
     */
    'line_items'?: Array<Pbcustomv2stubLineItem>;
    /**
     * Internal order id on the ecommerce side.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'order_id'?: string;
    /**
     * Customer-facing order number.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'order_number'?: string;
    /**
     * ISO 8601 timestamp when the order was placed.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'purchased_at'?: string;
    /**
     * Shipping address.
     * @type {Pbcustomv2stubAddress}
     * @memberof Pbcustomv2stubOrder
     */
    'shipping_address'?: Pbcustomv2stubAddress;
    /**
     * Ecommerce currency (ISO 4217). The merchant\'s catalog and books are  denominated in this currency.
     * @type {string}
     * @memberof Pbcustomv2stubOrder
     */
    'shop_currency'?: string;
    /**
     * Optional order-level tags.
     * @type {Array<string>}
     * @memberof Pbcustomv2stubOrder
     */
    'tags'?: Array<string>;
}
/**
 * Pagination metadata for offset-based listings.
 * @export
 * @interface Pbcustomv2stubPageInfo
 */
export interface Pbcustomv2stubPageInfo {
    /**
     * True when more products exist beyond this page.
     * @type {boolean}
     * @memberof Pbcustomv2stubPageInfo
     */
    'has_next_page'?: boolean;
    /**
     * Total count of products in the active catalog, when the ecommerce can  compute it cheaply. Optional — used by REVER for progress reporting.
     * @type {number}
     * @memberof Pbcustomv2stubPageInfo
     */
    'total'?: number;
}
/**
 * A product. Used both as a catalog entry (`GET /products`, `GET  /products/{product_id}`) and as the nested `LineItem.product` reference.   Product-level physical attributes (`unit_price`, `weight`, `dimensions`)  apply only when the product has no variants (single-SKU). When variants  are present, each variant carries its own copies and the product-level  fields are ignored by REVER.
 * @export
 * @interface Pbcustomv2stubProduct
 */
export interface Pbcustomv2stubProduct {
    /**
     * Categories this product belongs to.
     * @type {Array<string>}
     * @memberof Pbcustomv2stubProduct
     */
    'categories'?: Array<string>;
    /**
     * Collections this product belongs to.
     * @type {Array<string>}
     * @memberof Pbcustomv2stubProduct
     */
    'collections'?: Array<string>;
    /**
     * ISO 4217. The ecommerce currency every price under this product is  denominated in.
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'currency'?: string;
    /**
     * Localized product description.
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'description'?: string;
    /**
     * Physical dimensions. Used only when the product has no variants.
     * @type {Pbcustomv2stubDimensions}
     * @memberof Pbcustomv2stubProduct
     */
    'dimensions'?: Pbcustomv2stubDimensions;
    /**
     * Stable product id.
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'id'?: string;
    /**
     * Product images.
     * @type {Array<Pbcustomv2stubImage>}
     * @memberof Pbcustomv2stubProduct
     */
    'images'?: Array<Pbcustomv2stubImage>;
    /**
     * Localized product name.
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'name'?: string;
    /**
     * Optional short description.
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'short_description'?: string;
    /**
     * Product-level SKU (grouping reference; variants carry their own SKUs).
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'sku'?: string;
    /**
     * Stock for products without variants. Omit when the product has variants  (stock lives on each variant instead) or when the ecommerce does not  track inventory for this product.
     * @type {Pbcustomv2stubStock}
     * @memberof Pbcustomv2stubProduct
     */
    'stock'?: Pbcustomv2stubStock;
    /**
     * Tags applied to this product.
     * @type {Array<string>}
     * @memberof Pbcustomv2stubProduct
     */
    'tags'?: Array<string>;
    /**
     * Minimum unit price across variants when there are multiple. Decimal  string in `currency` (the ecommerce currency).
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'unit_price'?: string;
    /**
     * ISO 8601 timestamp when the product was last modified. Optional.
     * @type {string}
     * @memberof Pbcustomv2stubProduct
     */
    'updated_at'?: string;
    /**
     * Variants of this product. Empty when the product is single-SKU.
     * @type {Array<Pbcustomv2stubVariant>}
     * @memberof Pbcustomv2stubProduct
     */
    'variants'?: Array<Pbcustomv2stubVariant>;
    /**
     * Physical weight. Used only when the product has no variants.
     * @type {Pbcustomv2stubWeight}
     * @memberof Pbcustomv2stubProduct
     */
    'weight'?: Pbcustomv2stubWeight;
}
/**
 * State of a previously issued promocode.
 * @export
 * @interface Pbcustomv2stubPromocode
 */
export interface Pbcustomv2stubPromocode {
    /**
     * Face value of the promocode.
     * @type {string}
     * @memberof Pbcustomv2stubPromocode
     */
    'amount'?: string;
    /**
     * Promocode value.
     * @type {string}
     * @memberof Pbcustomv2stubPromocode
     */
    'code'?: string;
    /**
     * ISO 4217.
     * @type {string}
     * @memberof Pbcustomv2stubPromocode
     */
    'currency'?: string;
    /**
     * Whether the promocode is currently active.
     * @type {boolean}
     * @memberof Pbcustomv2stubPromocode
     */
    'enabled'?: boolean;
    /**
     * Orders that have redeemed this promocode.
     * @type {Array<string>}
     * @memberof Pbcustomv2stubPromocode
     */
    'order_ids'?: Array<string>;
    /**
     * Whether the promocode has been redeemed at least once.
     * @type {boolean}
     * @memberof Pbcustomv2stubPromocode
     */
    'used'?: boolean;
}
/**
 * Tracked inventory. `quantity = 0` unambiguously means out of stock,  distinct from \"untracked / unknown\" (which is encoded by omitting Stock  entirely).
 * @export
 * @interface Pbcustomv2stubStock
 */
export interface Pbcustomv2stubStock {
    /**
     * Sellable units available right now.
     * @type {number}
     * @memberof Pbcustomv2stubStock
     */
    'quantity'?: number;
}
/**
 * A payment leg on an order. Carries everything REVER needs to issue a  refund through the same processor.
 * @export
 * @interface Pbcustomv2stubTransaction
 */
export interface Pbcustomv2stubTransaction {
    /**
     * Amount in the currency declared on the sibling `currency` field.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'amount'?: string;
    /**
     * ISO 4217 currency. Normally matches `Order.customer_currency`; explicit  here so cross-currency processors remain unambiguous.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'currency'?: string;
    /**
     * ISO 8601 timestamp when the platform executed this leg.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'executed_at'?: string;
    /**
     * Ecommerce-side transaction id — the merchant\'s own identifier for this  leg.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'id'?: string;
    /**
     * SALE · CAPTURE · AUTHORIZATION · VOID · REFUND.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'kind'?: string;
    /**
     * For REFUND rows, the id of the original SALE or CAPTURE this refund is  against — when the platform exposes the linkage.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'parent_id'?: string;
    /**
     * Identifier of the payment platform that processed this leg — `paypal`,  `redsys`, `sequra`, `stripe`, `giftcard`, `manual`, …
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'platform_id'?: string;
    /**
     * SUCCESS · PENDING · FAILURE · ERROR.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'status'?: string;
    /**
     * Platform-specific identifier REVER will use to refund this leg.
     * @type {string}
     * @memberof Pbcustomv2stubTransaction
     */
    'transaction_id'?: string;
}
/**
 * A specific purchasable combination of a product\'s options  (e.g. `XS / Green`). Only available-for-purchase variants are returned;  discontinued or unavailable variants should be filtered out server-side.
 * @export
 * @interface Pbcustomv2stubVariant
 */
export interface Pbcustomv2stubVariant {
    /**
     * Optional variant-specific description.
     * @type {string}
     * @memberof Pbcustomv2stubVariant
     */
    'description'?: string;
    /**
     * Physical dimensions of one unit of this variant.
     * @type {Pbcustomv2stubDimensions}
     * @memberof Pbcustomv2stubVariant
     */
    'dimensions'?: Pbcustomv2stubDimensions;
    /**
     * Stable variant id.
     * @type {string}
     * @memberof Pbcustomv2stubVariant
     */
    'id'?: string;
    /**
     * Human-readable label. Convention is to join the axis values, e.g.  `XS / Green`.
     * @type {string}
     * @memberof Pbcustomv2stubVariant
     */
    'name'?: string;
    /**
     * Option dimensions along which the parent product is sold (Size, Color,  Material, …). Empty array when the product has no options.
     * @type {Array<Pbcustomv2stubVariantOption>}
     * @memberof Pbcustomv2stubVariant
     */
    'options'?: Array<Pbcustomv2stubVariantOption>;
    /**
     * Variant SKU.
     * @type {string}
     * @memberof Pbcustomv2stubVariant
     */
    'sku'?: string;
    /**
     * Inventory for this variant. Omit when the ecommerce does not track  inventory.
     * @type {Pbcustomv2stubStock}
     * @memberof Pbcustomv2stubVariant
     */
    'stock'?: Pbcustomv2stubStock;
    /**
     * Price of one unit in the ecommerce currency (`Product.currency`).
     * @type {string}
     * @memberof Pbcustomv2stubVariant
     */
    'unit_price'?: string;
    /**
     * Physical weight of one unit of this variant.
     * @type {Pbcustomv2stubWeight}
     * @memberof Pbcustomv2stubVariant
     */
    'weight'?: Pbcustomv2stubWeight;
}
/**
 * One option dimension along which the parent product is sold (Size,  Color, …) plus the value this variant takes for it.
 * @export
 * @interface Pbcustomv2stubVariantOption
 */
export interface Pbcustomv2stubVariantOption {
    /**
     * Stable identifier for the option (e.g. `Size`). Stays stable across  languages while `name` may be localized.
     * @type {string}
     * @memberof Pbcustomv2stubVariantOption
     */
    'id'?: string;
    /**
     * Display name of the option, in the requested language (e.g. `Size`,  `Talla`).
     * @type {string}
     * @memberof Pbcustomv2stubVariantOption
     */
    'name'?: string;
    /**
     * The value this variant takes for this option (e.g. `XS`).
     * @type {string}
     * @memberof Pbcustomv2stubVariantOption
     */
    'value'?: string;
}
/**
 * A weight value with a restricted unit.
 * @export
 * @interface Pbcustomv2stubWeight
 */
export interface Pbcustomv2stubWeight {
    /**
     * kg · gr · lb.
     * @type {string}
     * @memberof Pbcustomv2stubWeight
     */
    'unit'?: string;
    /**
     * Decimal value.
     * @type {string}
     * @memberof Pbcustomv2stubWeight
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface PbshoppingCalculateOrderPriceRes
 */
export interface PbshoppingCalculateOrderPriceRes {
    /**
     * Currency of the `order_total_price` field  ISO 4217 currency code (\"EUR\", \"USD\", \"GBP\"...)
     * @type {string}
     * @memberof PbshoppingCalculateOrderPriceRes
     */
    'currency_code'?: string;
    /**
     * Line items of the created order
     * @type {Array<PbshoppingOrderPriceLineItem>}
     * @memberof PbshoppingCalculateOrderPriceRes
     */
    'order_line_items'?: Array<PbshoppingOrderPriceLineItem>;
    /**
     * the order subtotal price
     * @type {string}
     * @memberof PbshoppingCalculateOrderPriceRes
     */
    'order_subtotal_price'?: string;
    /**
     * Total price of the order, without decimals, with the currency `currency_code`
     * @type {string}
     * @memberof PbshoppingCalculateOrderPriceRes
     */
    'order_total_price'?: string;
    /**
     * Total taxes of the order
     * @type {string}
     * @memberof PbshoppingCalculateOrderPriceRes
     */
    'order_total_taxes'?: string;
}
/**
 * Catalog products
 * @export
 * @interface PbshoppingCatalogProducts
 */
export interface PbshoppingCatalogProducts {
    /**
     * The page info
     * @type {PbshoppingPageInfo}
     * @memberof PbshoppingCatalogProducts
     */
    'page_info'?: PbshoppingPageInfo;
    /**
     * Collection of products with basic details
     * @type {Array<PbshoppingProductInfo>}
     * @memberof PbshoppingCatalogProducts
     */
    'products'?: Array<PbshoppingProductInfo>;
}
/**
 * Menu is the menu of the store
 * @export
 * @interface PbshoppingMenu
 */
export interface PbshoppingMenu {
    /**
     * The id of the menu
     * @type {string}
     * @memberof PbshoppingMenu
     */
    'id'?: string;
    /**
     * The items of the menu
     * @type {Array<PbshoppingMenuItem>}
     * @memberof PbshoppingMenu
     */
    'items'?: Array<PbshoppingMenuItem>;
}
/**
 * MenuItem is the item of the menu
 * @export
 * @interface PbshoppingMenuItem
 */
export interface PbshoppingMenuItem {
    /**
     * The id of the menu item
     * @type {string}
     * @memberof PbshoppingMenuItem
     */
    'platform_id'?: string;
    /**
     * The name of the menu item
     * @type {string}
     * @memberof PbshoppingMenuItem
     */
    'resource_id'?: string;
    /**
     * The type of the resource
     * @type {string}
     * @memberof PbshoppingMenuItem
     */
    'resource_type'?: PbshoppingMenuItemResourceTypeEnum;
    /**
     * The title of the menu item
     * @type {string}
     * @memberof PbshoppingMenuItem
     */
    'title'?: string;
}

export const PbshoppingMenuItemResourceTypeEnum = {
    ResourceTypeUnspecified: 'RESOURCE_TYPE_UNSPECIFIED',
    Collection: 'COLLECTION',
    Catalog: 'CATALOG',
    Search: 'SEARCH'
} as const;

export type PbshoppingMenuItemResourceTypeEnum = typeof PbshoppingMenuItemResourceTypeEnum[keyof typeof PbshoppingMenuItemResourceTypeEnum];

/**
 * Options is the options of the product
 * @export
 * @interface PbshoppingOptions
 */
export interface PbshoppingOptions {
    /**
     * The name of the option
     * @type {string}
     * @memberof PbshoppingOptions
     */
    'name'?: string;
    /**
     * The value of the option
     * @type {string}
     * @memberof PbshoppingOptions
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface PbshoppingOrderPriceLineItem
 */
export interface PbshoppingOrderPriceLineItem {
    /**
     * the item subtotal price
     * @type {string}
     * @memberof PbshoppingOrderPriceLineItem
     */
    'item_subtotal_price'?: string;
    /**
     * the item total price
     * @type {string}
     * @memberof PbshoppingOrderPriceLineItem
     */
    'item_total_price'?: string;
    /**
     * the item total taxes
     * @type {string}
     * @memberof PbshoppingOrderPriceLineItem
     */
    'item_total_taxes'?: string;
    /**
     * Product id
     * @type {string}
     * @memberof PbshoppingOrderPriceLineItem
     */
    'product_id'?: string;
    /**
     * Numer of items of type `product_id` + `variant_id`
     * @type {number}
     * @memberof PbshoppingOrderPriceLineItem
     */
    'quantity'?: number;
    /**
     * Variant id of the product
     * @type {string}
     * @memberof PbshoppingOrderPriceLineItem
     */
    'variant_id'?: string;
}
/**
 * 
 * @export
 * @interface PbshoppingPageInfo
 */
export interface PbshoppingPageInfo {
    /**
     * end_cursor, for request it would be empty   for response, it would be the next page start_cursor
     * @type {string}
     * @memberof PbshoppingPageInfo
     */
    'end_cursor'?: string;
    /**
     * Has next page, for request it would be empty
     * @type {boolean}
     * @memberof PbshoppingPageInfo
     */
    'has_next_page'?: boolean;
    /**
     * page size, for response it would be empty
     * @type {number}
     * @memberof PbshoppingPageInfo
     */
    'page_size'?: number;
    /**
     * start_cursor, for first request , it would be empty
     * @type {string}
     * @memberof PbshoppingPageInfo
     */
    'start_cursor'?: string;
}
/**
 * Price is the price of the product
 * @export
 * @interface PbshoppingPrice
 */
export interface PbshoppingPrice {
    /**
     * The amount of the price
     * @type {string}
     * @memberof PbshoppingPrice
     */
    'amount'?: string;
    /**
     * The currency of the price
     * @type {string}
     * @memberof PbshoppingPrice
     */
    'currency'?: string;
}
/**
 * PriceRange is the price range of the product
 * @export
 * @interface PbshoppingPriceRange
 */
export interface PbshoppingPriceRange {
    /**
     * The max price of the product
     * @type {PbshoppingPrice}
     * @memberof PbshoppingPriceRange
     */
    'max'?: PbshoppingPrice;
    /**
     * The min price of the product
     * @type {PbshoppingPrice}
     * @memberof PbshoppingPriceRange
     */
    'min'?: PbshoppingPrice;
}
/**
 * Products Basic Info
 * @export
 * @interface PbshoppingProductInfo
 */
export interface PbshoppingProductInfo {
    /**
     * Collection IDs
     * @type {Array<string>}
     * @memberof PbshoppingProductInfo
     */
    'collection_ids'?: Array<string>;
    /**
     * The Description of the product
     * @type {string}
     * @memberof PbshoppingProductInfo
     */
    'description'?: string;
    /**
     * Details of the product
     * @type {string}
     * @memberof PbshoppingProductInfo
     */
    'details'?: string;
    /**
     * The featured image of the product
     * @type {string}
     * @memberof PbshoppingProductInfo
     */
    'featured_image_url'?: string;
    /**
     * The id of the product
     * @type {string}
     * @memberof PbshoppingProductInfo
     */
    'id'?: string;
    /**
     * Images URLs
     * @type {Array<string>}
     * @memberof PbshoppingProductInfo
     */
    'image_urls'?: Array<string>;
    /**
     * The options of the product
     * @type {Array<PbshoppingProductOptions>}
     * @memberof PbshoppingProductInfo
     */
    'options'?: Array<PbshoppingProductOptions>;
    /**
     * The price range of the product
     * @type {PbshoppingPriceRange}
     * @memberof PbshoppingProductInfo
     */
    'price_range'?: PbshoppingPriceRange;
    /**
     * The title of the product
     * @type {string}
     * @memberof PbshoppingProductInfo
     */
    'title'?: string;
}
/**
 * ProductOptions is the options of the product
 * @export
 * @interface PbshoppingProductOptions
 */
export interface PbshoppingProductOptions {
    /**
     * The name of the option
     * @type {string}
     * @memberof PbshoppingProductOptions
     */
    'name'?: string;
    /**
     * The id of the option
     * @type {string}
     * @memberof PbshoppingProductOptions
     */
    'platform_id'?: string;
    /**
     * The values of the option
     * @type {Array<string>}
     * @memberof PbshoppingProductOptions
     */
    'values'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PbshoppingStoreFrontProductDetails
 */
export interface PbshoppingStoreFrontProductDetails {
    /**
     * images of the product
     * @type {Array<string>}
     * @memberof PbshoppingStoreFrontProductDetails
     */
    'image_urls'?: Array<string>;
    /**
     * Product details
     * @type {PbshoppingProductInfo}
     * @memberof PbshoppingStoreFrontProductDetails
     */
    'product_info'?: PbshoppingProductInfo;
    /**
     * Variant Details
     * @type {Array<PbshoppingStoreFrontVariant>}
     * @memberof PbshoppingStoreFrontProductDetails
     */
    'variants'?: Array<PbshoppingStoreFrontVariant>;
}
/**
 * 
 * @export
 * @interface PbshoppingStoreFrontVariant
 */
export interface PbshoppingStoreFrontVariant {
    /**
     * The enabled status of the variant
     * @type {boolean}
     * @memberof PbshoppingStoreFrontVariant
     */
    'enabled'?: boolean;
    /**
     * images urls
     * @type {Array<string>}
     * @memberof PbshoppingStoreFrontVariant
     */
    'image_urls'?: Array<string>;
    /**
     * The inventory of the variant
     * @type {number}
     * @memberof PbshoppingStoreFrontVariant
     */
    'inventory_quantity'?: number;
    /**
     * is inventory enabled
     * @type {boolean}
     * @memberof PbshoppingStoreFrontVariant
     */
    'is_inventory_enabled'?: boolean;
    /**
     * The id of the variant
     * @type {string}
     * @memberof PbshoppingStoreFrontVariant
     */
    'platform_id'?: string;
    /**
     * The price of the variant
     * @type {PbshoppingPrice}
     * @memberof PbshoppingStoreFrontVariant
     */
    'price'?: PbshoppingPrice;
    /**
     * The options of the variant
     * @type {Array<PbshoppingOptions>}
     * @memberof PbshoppingStoreFrontVariant
     */
    'selected_options'?: Array<PbshoppingOptions>;
    /**
     * The sku of the variant
     * @type {string}
     * @memberof PbshoppingStoreFrontVariant
     */
    'sku'?: string;
    /**
     * The title of the variant
     * @type {string}
     * @memberof PbshoppingStoreFrontVariant
     */
    'title'?: string;
}
/**
 * Request to activate Worry Free Purchase for an ecommerce.
 * @export
 * @interface PbwfpActivateRequest
 */
export interface PbwfpActivateRequest {
    /**
     * Whether/when the WFP Cover line is fulfilled on Shopify. Required —  UNSPECIFIED is rejected downstream by settings-api.
     * @type {string}
     * @memberof PbwfpActivateRequest
     */
    'cover_fulfillment_mode'?: PbwfpActivateRequestCoverFulfillmentModeEnum;
    /**
     * EcommerceID of the merchant to activate. Required.
     * @type {string}
     * @memberof PbwfpActivateRequest
     */
    'ecommerce_id'?: string;
    /**
     * Publicly accessible URL of the image to use for the WFP product  (uploaded by the operator, same flow as the returns-portal theme  logo). Required.
     * @type {string}
     * @memberof PbwfpActivateRequest
     */
    'product_image_url'?: string;
    /**
     * Display name for the WFP product created in the merchant\'s Shopify  catalog. Required.
     * @type {string}
     * @memberof PbwfpActivateRequest
     */
    'product_title'?: string;
}

export const PbwfpActivateRequestCoverFulfillmentModeEnum = {
    Unspecified: 'WFP_COVER_FULFILLMENT_MODE_UNSPECIFIED',
    FulfillOnPurchase: 'WFP_COVER_FULFILLMENT_MODE_FULFILL_ON_PURCHASE',
    NeverFulfill: 'WFP_COVER_FULFILLMENT_MODE_NEVER_FULFILL',
    FulfillAfterItemFulfillment: 'WFP_COVER_FULFILLMENT_MODE_FULFILL_AFTER_ITEM_FULFILLMENT'
} as const;

export type PbwfpActivateRequestCoverFulfillmentModeEnum = typeof PbwfpActivateRequestCoverFulfillmentModeEnum[keyof typeof PbwfpActivateRequestCoverFulfillmentModeEnum];

/**
 * EnsureShopifyExtensionsDeployedRequest asks for the merchant\'s Shopify app  extensions to be (re)deployed.
 * @export
 * @interface PbwfpEnsureShopifyExtensionsDeployedRequest
 */
export interface PbwfpEnsureShopifyExtensionsDeployedRequest {
    /**
     * EcommerceID whose per-client Shopify app should get the extensions.
     * @type {string}
     * @memberof PbwfpEnsureShopifyExtensionsDeployedRequest
     */
    'ecommerce_id'?: string;
}
/**
 * EnsureShopifyExtensionsDeployedResponse reports whether the deploy was  dispatched, and why not when it was not.
 * @export
 * @interface PbwfpEnsureShopifyExtensionsDeployedResponse
 */
export interface PbwfpEnsureShopifyExtensionsDeployedResponse {
    /**
     * True when the CI deploy was dispatched. The deploy itself runs  asynchronously and reports to #wfp-alerts.
     * @type {boolean}
     * @memberof PbwfpEnsureShopifyExtensionsDeployedResponse
     */
    'dispatched'?: boolean;
    /**
     * Empty when dispatched. Otherwise the blocking reason code, e.g.  \"app_automation_token_missing\", \"app_automation_token_expired\" or  \"legacy_app_must_migrate_first\".
     * @type {string}
     * @memberof PbwfpEnsureShopifyExtensionsDeployedResponse
     */
    'reason'?: string;
}
/**
 * GetQuoteRequest carries the data needed to quote a cart. The  endpoint is a pure wirer: it validates the request, resolves  `admin_domain` from the merchant\'s WFP settings, hardcodes the quote  `type`, and forwards `cart_info` verbatim (it is a 1:1 pass-through  of Shopify\'s `cart.js` shape).
 * @export
 * @interface PbwfpGetQuoteRequest
 */
export interface PbwfpGetQuoteRequest {
    /**
     * Raw `cart.js` payload from the storefront, forwarded verbatim. The  widget must include items / currency / items_subtotal_price; the  rest of the Shopify-defined fields are accepted unchanged.  Required.
     * @type {object}
     * @memberof PbwfpGetQuoteRequest
     */
    'cart_info'?: object;
    /**
     * Per-shopper context block. `browser_ip` is the only required field  upstream; `user_id` and `device_id` improve risk modeling when  available (the widget persists `device_id` in a first-party cookie).  Required.
     * @type {PbwfpQuoteCustomerInfo}
     * @memberof PbwfpGetQuoteRequest
     */
    'customer_info'?: PbwfpQuoteCustomerInfo;
    /**
     * Storefront surface the quote was requested from. The client declares  the origin and the server decides policy from it — today that policy  is whether the call is written to the `wfp_quotes` audit log.  Optional; unset is treated as the cart surface for policy purposes.
     * @type {string}
     * @memberof PbwfpGetQuoteRequest
     */
    'origin'?: PbwfpGetQuoteRequestOriginEnum;
    /**
     * Merchant store identifier (Shopify store slug). Used to resolve the  WFP-enabled ecommerce and its `admin_domain`. Required.
     * @type {string}
     * @memberof PbwfpGetQuoteRequest
     */
    'store_id'?: string;
}

export const PbwfpGetQuoteRequestOriginEnum = {
    Unspecified: 'QUOTE_ORIGIN_UNSPECIFIED',
    Cart: 'QUOTE_ORIGIN_CART',
    Pdp: 'QUOTE_ORIGIN_PDP'
} as const;

export type PbwfpGetQuoteRequestOriginEnum = typeof PbwfpGetQuoteRequestOriginEnum[keyof typeof PbwfpGetQuoteRequestOriginEnum];

/**
 * GetQuoteResponse is the widget-facing response. When `eligible` is  false, `reason` is populated and the other premium fields are empty.
 * @export
 * @interface PbwfpGetQuoteResponse
 */
export interface PbwfpGetQuoteResponse {
    /**
     * Coverages granted for this quote, deduplicated across all eligible  items (e.g. [\"gdd\",\"rsi\"]). Populated when eligible=true.
     * @type {Array<string>}
     * @memberof PbwfpGetQuoteResponse
     */
    'coverages'?: Array<string>;
    /**
     * ISO-4217 currency code of the premium. Populated when eligible=true.
     * @type {string}
     * @memberof PbwfpGetQuoteResponse
     */
    'currency'?: string;
    /**
     * Whether the WFP premium is offered for this cart (true when the  upstream status is \"accepted\").
     * @type {boolean}
     * @memberof PbwfpGetQuoteResponse
     */
    'eligible'?: boolean;
    /**
     * Per-line coverages as returned by the provider. Populated when  eligible=true so the widget can highlight which items are covered.
     * @type {Array<PbwfpQuoteEligibleItem>}
     * @memberof PbwfpGetQuoteResponse
     */
    'eligible_items'?: Array<PbwfpQuoteEligibleItem>;
    /**
     * Free-form display copy from the provider (widget text, terms URL,  privacy URL, coverage details). Forwarded verbatim. Populated when  eligible=true.
     * @type {object}
     * @memberof PbwfpGetQuoteResponse
     */
    'extra_info'?: object;
    /**
     * Premium amount in the request currency. Populated when eligible=true.
     * @type {number}
     * @memberof PbwfpGetQuoteResponse
     */
    'price'?: number;
    /**
     * Quote identifier. Populated whenever the upstream call succeeds —  including rejected quotes, so callers can correlate with provider  telemetry.
     * @type {string}
     * @memberof PbwfpGetQuoteResponse
     */
    'quote_id'?: string;
    /**
     * Reason for ineligibility. Empty when eligible=true. One of:    \"shop_not_found\"          - store_id does not map to any ecommerce    \"wfp_disabled_for_shop\"   - shop exists but WFP is disabled    \"seel_rejected\"           - the quote was declined for this cart                                (string kept for backwards                                compatibility with the storefront)
     * @type {string}
     * @memberof PbwfpGetQuoteResponse
     */
    'reason'?: string;
}
/**
 * QuoteCoverage is the per-line coverage detail.
 * @export
 * @interface PbwfpQuoteCoverage
 */
export interface PbwfpQuoteCoverage {
    /**
     * Human-readable description (e.g. \"Fulfillment Risk\").
     * @type {string}
     * @memberof PbwfpQuoteCoverage
     */
    'description'?: string;
    /**
     * Coverage identifier (e.g. \"gdd\", \"rsi\").
     * @type {string}
     * @memberof PbwfpQuoteCoverage
     */
    'type'?: string;
}
/**
 * QuoteCustomerInfo carries per-shopper context. `browser_ip` is  required upstream — Shopify does not always populate it on the cart,  so the widget resolves it itself before sending.
 * @export
 * @interface PbwfpQuoteCustomerInfo
 */
export interface PbwfpQuoteCustomerInfo {
    /**
     * Public IP of the shopper as observed by the storefront. Required.
     * @type {string}
     * @memberof PbwfpQuoteCustomerInfo
     */
    'browser_ip'?: string;
    /**
     * Stable per-device identifier (UUID persisted in a first-party  cookie). Optional but recommended.
     * @type {string}
     * @memberof PbwfpQuoteCustomerInfo
     */
    'device_id'?: string;
    /**
     * Unix timestamp (milliseconds) of the request. Optional.
     * @type {string}
     * @memberof PbwfpQuoteCustomerInfo
     */
    'timestamp_in_ms'?: string;
    /**
     * Logged-in customer identifier on the merchant side. Optional.
     * @type {string}
     * @memberof PbwfpQuoteCustomerInfo
     */
    'user_id'?: string;
}
/**
 * QuoteEligibleItem reports the per-line coverages granted for the  quote.
 * @export
 * @interface PbwfpQuoteEligibleItem
 */
export interface PbwfpQuoteEligibleItem {
    /**
     * Coverages granted for this line.
     * @type {Array<PbwfpQuoteCoverage>}
     * @memberof PbwfpQuoteEligibleItem
     */
    'coverages'?: Array<PbwfpQuoteCoverage>;
    /**
     * Product identifier on the merchant side.
     * @type {string}
     * @memberof PbwfpQuoteEligibleItem
     */
    'product_id'?: string;
    /**
     * Variant identifier on the merchant side.
     * @type {string}
     * @memberof PbwfpQuoteEligibleItem
     */
    'variant_id'?: string;
}
/**
 * Request to get product recommendations
 * @export
 * @interface ProductrecommenderpbGetRecommendationsRequest
 */
export interface ProductrecommenderpbGetRecommendationsRequest {
    /**
     * Channel where recommendations will be shown
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsRequest
     */
    'channel'?: ProductrecommenderpbGetRecommendationsRequestChannelEnum;
    /**
     * Checkout ID for deterministic A/B experiment assignment (optional; generated if  empty)
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsRequest
     */
    'checkout_id'?: string;
    /**
     * Ecommerce ID (required)
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsRequest
     */
    'ecommerce_id': string;
    /**
     * Order reference; required to resolve the correct site for multi-site Salesforce  portals. Optional otherwise.
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsRequest
     */
    'order_reference'?: string;
    /**
     * Information about returned items
     * @type {Array<ProductrecommenderpbReturnItem>}
     * @memberof ProductrecommenderpbGetRecommendationsRequest
     */
    'return_items': Array<ProductrecommenderpbReturnItem>;
    /**
     * User information (required)
     * @type {ProductrecommenderpbUserInformation}
     * @memberof ProductrecommenderpbGetRecommendationsRequest
     */
    'user_information': ProductrecommenderpbUserInformation;
}

export const ProductrecommenderpbGetRecommendationsRequestChannelEnum = {
    Portal: 'CHANNEL_PORTAL',
    FullCatalog: 'CHANNEL_FULL_CATALOG',
    TrackingInterface: 'CHANNEL_TRACKING_INTERFACE',
    Email: 'CHANNEL_EMAIL'
} as const;

export type ProductrecommenderpbGetRecommendationsRequestChannelEnum = typeof ProductrecommenderpbGetRecommendationsRequestChannelEnum[keyof typeof ProductrecommenderpbGetRecommendationsRequestChannelEnum];

/**
 * Response with product recommendations
 * @export
 * @interface ProductrecommenderpbGetRecommendationsResponse
 */
export interface ProductrecommenderpbGetRecommendationsResponse {
    /**
     * Candidate generation option that was chosen
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'candidate_generation_option_chosen'?: string;
    /**
     * Copywriting option that was chosen
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'copywriting_option_chosen'?: string;
    /**
     * Diversification option that was chosen
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'diversification_option_chosen'?: string;
    /**
     * Filtering option that was chosen
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'filtering_option_chosen'?: string;
    /**
     * UUID generated for this recommendation request
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'recommendations_uuid'?: string;
    /**
     * List of recommended products
     * @type {Array<ProductrecommenderpbRecommendedProduct>}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'recommended_products'?: Array<ProductrecommenderpbRecommendedProduct>;
    /**
     * Scoring option that was chosen
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'scoring_option_chosen'?: string;
    /**
     * UI text to display
     * @type {string}
     * @memberof ProductrecommenderpbGetRecommendationsResponse
     */
    'ui_text'?: string;
}
/**
 * Response for the user data for Two Tower model
 * @export
 * @interface ProductrecommenderpbGetUserTwoTowerDataResponse
 */
export interface ProductrecommenderpbGetUserTwoTowerDataResponse {
    /**
     * Data for the processes
     * @type {Array<ProductrecommenderpbTwoTowerUser>}
     * @memberof ProductrecommenderpbGetUserTwoTowerDataResponse
     */
    'users_data'?: Array<ProductrecommenderpbTwoTowerUser>;
}
/**
 * Price with currency and amount for display
 * @export
 * @interface ProductrecommenderpbProductPrice
 */
export interface ProductrecommenderpbProductPrice {
    /**
     * Price amount as string for display
     * @type {string}
     * @memberof ProductrecommenderpbProductPrice
     */
    'amount'?: string;
    /**
     * Currency code (e.g. \"EUR\", \"USD\")
     * @type {string}
     * @memberof ProductrecommenderpbProductPrice
     */
    'currency'?: string;
}
/**
 * Price range for display (min and max), same structure as ecommerce-api Store  FrontProductDetails
 * @export
 * @interface ProductrecommenderpbProductPriceRange
 */
export interface ProductrecommenderpbProductPriceRange {
    /**
     * Maximum price of the product
     * @type {ProductrecommenderpbProductPrice}
     * @memberof ProductrecommenderpbProductPriceRange
     */
    'max'?: ProductrecommenderpbProductPrice;
    /**
     * Minimum price of the product
     * @type {ProductrecommenderpbProductPrice}
     * @memberof ProductrecommenderpbProductPriceRange
     */
    'min'?: ProductrecommenderpbProductPrice;
}
/**
 * Recommended product with explanation
 * @export
 * @interface ProductrecommenderpbRecommendedProduct
 */
export interface ProductrecommenderpbRecommendedProduct {
    /**
     * Main product image URL for display
     * @type {string}
     * @memberof ProductrecommenderpbRecommendedProduct
     */
    'image_url'?: string;
    /**
     * Display name of the product
     * @type {string}
     * @memberof ProductrecommenderpbRecommendedProduct
     */
    'name'?: string;
    /**
     * Price range for display (min and max), aligned with ecommerce-api product details
     * @type {ProductrecommenderpbProductPriceRange}
     * @memberof ProductrecommenderpbRecommendedProduct
     */
    'price_range'?: ProductrecommenderpbProductPriceRange;
    /**
     * Product ID of the recommended product
     * @type {string}
     * @memberof ProductrecommenderpbRecommendedProduct
     */
    'product_id'?: string;
    /**
     * Explanation of why this product was recommended
     * @type {string}
     * @memberof ProductrecommenderpbRecommendedProduct
     */
    'reason'?: string;
}
/**
 * Return item information
 * @export
 * @interface ProductrecommenderpbReturnItem
 */
export interface ProductrecommenderpbReturnItem {
    /**
     * Comment about the return
     * @type {string}
     * @memberof ProductrecommenderpbReturnItem
     */
    'comment'?: string;
    /**
     * Product ID of the returned item (required)
     * @type {string}
     * @memberof ProductrecommenderpbReturnItem
     */
    'product_id': string;
    /**
     * Refund amount for this item
     * @type {number}
     * @memberof ProductrecommenderpbReturnItem
     */
    'refund_amount'?: number;
    /**
     * Reason for the return
     * @type {string}
     * @memberof ProductrecommenderpbReturnItem
     */
    'return_reason'?: string;
    /**
     * Variant ID of the returned item
     * @type {string}
     * @memberof ProductrecommenderpbReturnItem
     */
    'variant_id'?: string;
}
/**
 * User data for Two Tower model
 * @export
 * @interface ProductrecommenderpbTwoTowerUser
 */
export interface ProductrecommenderpbTwoTowerUser {
    /**
     * Country ISO
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'country_iso'?: string;
    /**
     * Created at
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'created_at'?: string;
    /**
     * Email
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'customer_email'?: string;
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'ecommerce_id'?: string;
    /**
     * Last 20 products ordered
     * @type {Array<string>}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'last_20_ordered_products'?: Array<string>;
    /**
     * Last 20 products returned
     * @type {Array<string>}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'last_20_returned_products'?: Array<string>;
    /**
     * ID of the process
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'process_id'?: string;
    /**
     * Number of previous orders
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'total_orders'?: string;
    /**
     * Number of previous returns
     * @type {string}
     * @memberof ProductrecommenderpbTwoTowerUser
     */
    'total_returns'?: string;
}
/**
 * User information
 * @export
 * @interface ProductrecommenderpbUserInformation
 */
export interface ProductrecommenderpbUserInformation {
    /**
     * User address
     * @type {string}
     * @memberof ProductrecommenderpbUserInformation
     */
    'address'?: string;
    /**
     * Country code of the shopper or checkout (e.g. \"ES\", \"US\") (required). Required for  stock availability check via ecommerce-api.
     * @type {string}
     * @memberof ProductrecommenderpbUserInformation
     */
    'country_code': string;
    /**
     * Currency code of the order or checkout (e.g. \"EUR\", \"USD\") (required). Required for  stock availability check via ecommerce-api.
     * @type {string}
     * @memberof ProductrecommenderpbUserInformation
     */
    'currency_code': string;
    /**
     * User email address (required). Used for purchase history and filtering already-shown  products.
     * @type {string}
     * @memberof ProductrecommenderpbUserInformation
     */
    'email': string;
    /**
     * User language preference (required). Used for localized UI text and product display  info.
     * @type {string}
     * @memberof ProductrecommenderpbUserInformation
     */
    'language': string;
}
/**
 * Payload for the GetReferralsByGroup response
 * @export
 * @interface ReferralspbGetReferralsGroupResponse
 */
export interface ReferralspbGetReferralsGroupResponse {
    /**
     * List of referrals
     * @type {Array<ReferralspbReferral>}
     * @memberof ReferralspbGetReferralsGroupResponse
     */
    'referrals'?: Array<ReferralspbReferral>;
}
/**
 * Referral model
 * @export
 * @interface ReferralspbReferral
 */
export interface ReferralspbReferral {
    /**
     * The time of the last update to the referral
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'last_updated_time'?: string;
    /**
     * ID of the referral
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referral_id'?: string;
    /**
     * The name of the brand referred. Can be empty
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referred_brand'?: string;
    /**
     * The email of the brand referred
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referred_email'?: string;
    /**
     * The phone of the brand referred. Can be empty
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referred_phone'?: string;
    /**
     * The time when the referral was made
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referred_time'?: string;
    /**
     * The email of the user making the referral
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referrer_email'?: string;
    /**
     * The group of the ecommerce making the referral
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'referrer_group'?: string;
    /**
     * The status of the referral. Not used yet
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'status'?: string;
    /**
     * The website of the referred brand. Can be empty
     * @type {string}
     * @memberof ReferralspbReferral
     */
    'website'?: string;
}
/**
 * Payload for the Alpinestars orders export response.
 * @export
 * @interface ReportspbAlpinestarsOrdersExportResponse
 */
export interface ReportspbAlpinestarsOrdersExportResponse {
    /**
     * List of exported Alpinestars orders.
     * @type {Array<ReportspbAlpinestarsOrdersExportRow>}
     * @memberof ReportspbAlpinestarsOrdersExportResponse
     */
    'rows'?: Array<ReportspbAlpinestarsOrdersExportRow>;
}
/**
 * A single row in the Alpinestars orders export, matching the CSV schema used  by Funnel.io.
 * @export
 * @interface ReportspbAlpinestarsOrdersExportRow
 */
export interface ReportspbAlpinestarsOrdersExportRow {
    /**
     * Carrier selected by the user.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'carrier'?: string;
    /**
     * Date when the parcel was collected.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'collected_at'?: string;
    /**
     * How the customer was compensated (refund method).
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'compensation_method'?: string;
    /**
     * Date when the process was completed.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'completed_at'?: string;
    /**
     * ISO country code.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'country'?: string;
    /**
     * Currency of the refund (EUR).
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'currency'?: string;
    /**
     * Full name of the customer.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'customer'?: string;
    /**
     * Customer-facing order identifier.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'customer_printed_order_id'?: string;
    /**
     * Ecommerce identifier.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'ecommerce_id'?: string;
    /**
     * Exchange order number, if any.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'exchange_order_number'?: string;
    /**
     * Date when the parcel was in warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'in_warehouse_at'?: string;
    /**
     * Number of items in the return.
     * @type {number}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'item_count'?: number;
    /**
     * Identifier of the original order.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'order_id'?: string;
    /**
     * Date when the original order was purchased.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'order_purchased_at'?: string;
    /**
     * Identifier of the return process.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'process_id'?: string;
    /**
     * Total refund amount in EUR.
     * @type {number}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'refund_total'?: number;
    /**
     * Date when the refund was processed.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'refunded_at'?: string;
    /**
     * Date when the return was created.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'return_date'?: string;
    /**
     * Return method selected by the customer.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'return_method'?: string;
    /**
     * Total return shipping costs in EUR.
     * @type {number}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'return_shipping_costs'?: number;
    /**
     * Current return status.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'return_status'?: string;
    /**
     * Review outcome of the return (e.g. approved, rejected).
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'reviewed'?: string;
    /**
     * First address line of the warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'warehouse_address_line1'?: string;
    /**
     * Second address line of the warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'warehouse_address_line2'?: string;
    /**
     * City of the warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'warehouse_city'?: string;
    /**
     * Country of the warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'warehouse_country'?: string;
    /**
     * Name of the warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'warehouse_name'?: string;
    /**
     * Postcode of the warehouse.
     * @type {string}
     * @memberof ReportspbAlpinestarsOrdersExportRow
     */
    'warehouse_postcode'?: string;
}
/**
 * GeneralReportResponse holds exactly one concrete report payload. New reports  should add a new field to this oneof.
 * @export
 * @interface ReportspbGeneralReportResponse
 */
export interface ReportspbGeneralReportResponse {
    /**
     * Payload for the Alpinestars orders export response.
     * @type {ReportspbAlpinestarsOrdersExportResponse}
     * @memberof ReportspbGeneralReportResponse
     */
    'alpinestars_orders_export'?: ReportspbAlpinestarsOrdersExportResponse;
    /**
     * Payload for the amount of pending labels grouped by carrier.
     * @type {ReportspbPendingLabelsByCarrierResponse}
     * @memberof ReportspbGeneralReportResponse
     */
    'amount_of_pending_labels_grouped_by_carrier'?: ReportspbPendingLabelsByCarrierResponse;
    /**
     * Payload for the Laveste logistics report.
     * @type {ReportspbLavesteLogisticsReportResponse}
     * @memberof ReportspbGeneralReportResponse
     */
    'laveste_logistics_report'?: ReportspbLavesteLogisticsReportResponse;
    /**
     * Payload for the Returns Pending Review response.
     * @type {ReportspbReturnsPendingReviewResponse}
     * @memberof ReportspbGeneralReportResponse
     */
    'returns_pending_review'?: ReportspbReturnsPendingReviewResponse;
    /**
     * Payload for the upsell report. Used by any group that needs a checkout,  upsell, and logistics cost breakdown. Requires the \"groups\" field with  exactly one group.
     * @type {ReportspbUpsellReportResponse}
     * @memberof ReportspbGeneralReportResponse
     */
    'upsell_report'?: ReportspbUpsellReportResponse;
}
/**
 * Payload for the Laveste logistics report.
 * @export
 * @interface ReportspbLavesteLogisticsReportResponse
 */
export interface ReportspbLavesteLogisticsReportResponse {
    /**
     * List of Laveste logistics report rows.
     * @type {Array<ReportspbLavesteLogisticsReportRow>}
     * @memberof ReportspbLavesteLogisticsReportResponse
     */
    'rows'?: Array<ReportspbLavesteLogisticsReportRow>;
}
/**
 * A single row in the Laveste logistics report with cost breakdowns per  invoiced process.
 * @export
 * @interface ReportspbLavesteLogisticsReportRow
 */
export interface ReportspbLavesteLogisticsReportRow {
    /**
     * ISO country code.
     * @type {string}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'country_iso'?: string;
    /**
     * Customer-facing order identifier.
     * @type {string}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'customer_printed_order_id'?: string;
    /**
     * Invoicing period identifier (e.g. \"M 2025-10-01 - 2025-10-31\").
     * @type {string}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'invoicing_period'?: string;
    /**
     * Logistics amount charged to Laveste (logistic_cost + custom_cost, rounded  to 2 decimals).
     * @type {number}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'logistics_charged_to_laveste'?: number;
    /**
     * Logistics amount charged to the shopper (negated return_fee, rounded to 2  decimals).
     * @type {number}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'logistics_charged_to_shopper'?: number;
    /**
     * Carrier selected by the user.
     * @type {string}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'user_selected_carrier'?: string;
    /**
     * Weight adjustment amount from logistics adjustments (rounded to 2  decimals).
     * @type {number}
     * @memberof ReportspbLavesteLogisticsReportRow
     */
    'weight_adjustment'?: number;
}
/**
 * Payload for the amount of pending labels grouped by carrier.
 * @export
 * @interface ReportspbPendingLabelsByCarrierResponse
 */
export interface ReportspbPendingLabelsByCarrierResponse {
    /**
     * List of carriers and their pending process counts.
     * @type {Array<ReportspbPendingLabelsByCarrierRow>}
     * @memberof ReportspbPendingLabelsByCarrierResponse
     */
    'rows'?: Array<ReportspbPendingLabelsByCarrierRow>;
}
/**
 * A single row with the carrier and the number of pending processes.
 * @export
 * @interface ReportspbPendingLabelsByCarrierRow
 */
export interface ReportspbPendingLabelsByCarrierRow {
    /**
     * Number of pending processes for this carrier.
     * @type {number}
     * @memberof ReportspbPendingLabelsByCarrierRow
     */
    'pending_processes'?: number;
    /**
     * Name of the user selected carrier.
     * @type {string}
     * @memberof ReportspbPendingLabelsByCarrierRow
     */
    'user_selected_carrier'?: string;
}
/**
 * Message that represents a single order in the Returns Pending Review report.
 * @export
 * @interface ReportspbReturnsPendingReviewOrder
 */
export interface ReportspbReturnsPendingReviewOrder {
    /**
     * Created at timestamp.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'created_at'?: string;
    /**
     * Delivery date timestamp.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'delivery_date'?: string;
    /**
     * Order ID.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'order_id'?: string;
    /**
     * Process ID.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'process_id'?: string;
    /**
     * Return method.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'return_method'?: string;
    /**
     * Tracking ID.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'tracking_id'?: string;
    /**
     * Warehouse name.
     * @type {string}
     * @memberof ReportspbReturnsPendingReviewOrder
     */
    'warehouse'?: string;
}
/**
 * Payload for the Returns Pending Review response.
 * @export
 * @interface ReportspbReturnsPendingReviewResponse
 */
export interface ReportspbReturnsPendingReviewResponse {
    /**
     * List of report orders.
     * @type {Array<ReportspbReturnsPendingReviewOrder>}
     * @memberof ReportspbReturnsPendingReviewResponse
     */
    'orders'?: Array<ReportspbReturnsPendingReviewOrder>;
}
/**
 * Payload for the upsell report. Reusable across any group that needs a  checkout, upsell, and logistics cost breakdown.
 * @export
 * @interface ReportspbUpsellReportResponse
 */
export interface ReportspbUpsellReportResponse {
    /**
     * List of upsell report rows.
     * @type {Array<ReportspbUpsellReportRow>}
     * @memberof ReportspbUpsellReportResponse
     */
    'rows'?: Array<ReportspbUpsellReportRow>;
}
/**
 * A single row in the upsell report with checkout, upsell, and logistics cost  breakdowns per process.
 * @export
 * @interface ReportspbUpsellReportRow
 */
export interface ReportspbUpsellReportRow {
    /**
     * Invoicing period identifier (e.g. \"M 2025-10-01 - 2025-10-31\").
     * @type {string}
     * @memberof ReportspbUpsellReportRow
     */
    'invoicing_period'?: string;
    /**
     * Customer-facing order identifier.
     * @type {string}
     * @memberof ReportspbUpsellReportRow
     */
    'order_number'?: string;
    /**
     * Ordered items amount in EUR.
     * @type {number}
     * @memberof ReportspbUpsellReportRow
     */
    'ordered_items'?: number;
    /**
     * Pay for logistics amount in EUR (checkout minus upsell, rounded to 2  decimals).
     * @type {number}
     * @memberof ReportspbUpsellReportRow
     */
    'pay_for_logistics'?: number;
    /**
     * Promotion amount in EUR (exchange promotions /100, rounded to 2 decimals).
     * @type {number}
     * @memberof ReportspbUpsellReportRow
     */
    'promotion'?: number;
    /**
     * Timestamp when the return was completed (RFC 3339, date precision).
     * @type {string}
     * @memberof ReportspbUpsellReportRow
     */
    'return_completion_date'?: string;
    /**
     * Timestamp when the return was created (RFC 3339, date precision).
     * @type {string}
     * @memberof ReportspbUpsellReportRow
     */
    'return_creation_date'?: string;
    /**
     * REVER Checkout amount in EUR (transaction total + service fees, /100,  rounded to 2 decimals).
     * @type {number}
     * @memberof ReportspbUpsellReportRow
     */
    'rever_checkout'?: number;
    /**
     * Upsell amount in EUR (upselling + exchange promotions, rounded to 2  decimals).
     * @type {number}
     * @memberof ReportspbUpsellReportRow
     */
    'upsell'?: number;
}
/**
 * Address represents a physical address
 * @export
 * @interface ReturnsAddress
 */
export interface ReturnsAddress {
    /**
     * Street address line 1
     * @type {string}
     * @memberof ReturnsAddress
     */
    'address_line_1'?: string;
    /**
     * Street address line 2
     * @type {string}
     * @memberof ReturnsAddress
     */
    'address_line_2'?: string;
    /**
     * City
     * @type {string}
     * @memberof ReturnsAddress
     */
    'city'?: string;
    /**
     * Country ISO code
     * @type {string}
     * @memberof ReturnsAddress
     */
    'country_iso'?: string;
    /**
     * Email address
     * @type {string}
     * @memberof ReturnsAddress
     */
    'email'?: string;
    /**
     * Name of the recipient
     * @type {string}
     * @memberof ReturnsAddress
     */
    'name'?: string;
    /**
     * Phone number
     * @type {string}
     * @memberof ReturnsAddress
     */
    'phone'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof ReturnsAddress
     */
    'postal_code'?: string;
    /**
     * State or province
     * @type {string}
     * @memberof ReturnsAddress
     */
    'state_province'?: string;
}
/**
 * Response listing the original refund method and available alternatives.
 * @export
 * @interface ReturnsAvailableRefundMethodChangeOptionsResponse
 */
export interface ReturnsAvailableRefundMethodChangeOptionsResponse {
    /**
     * Why the exchange cannot move to the original payment method, when it cannot.
     * @type {string}
     * @memberof ReturnsAvailableRefundMethodChangeOptionsResponse
     */
    'exchange_to_opm_blocker'?: ReturnsAvailableRefundMethodChangeOptionsResponseExchangeToOpmBlockerEnum;
    /**
     * Refund method currently associated with the process.
     * @type {string}
     * @memberof ReturnsAvailableRefundMethodChangeOptionsResponse
     */
    'from'?: ReturnsAvailableRefundMethodChangeOptionsResponseFromEnum;
    /**
     * True when the change moves an exchange to the original payment method; `to` then holds ORIGINAL.
     * @type {boolean}
     * @memberof ReturnsAvailableRefundMethodChangeOptionsResponse
     */
    'from_exchange'?: boolean;
    /**
     * True when the change also refunds the surplus the shopper paid at checkout through the payments provider.
     * @type {boolean}
     * @memberof ReturnsAvailableRefundMethodChangeOptionsResponse
     */
    'refunds_checkout_surplus'?: boolean;
    /**
     * New refund methods that the user can switch to.
     * @type {Array<string>}
     * @memberof ReturnsAvailableRefundMethodChangeOptionsResponse
     */
    'to'?: Array<ReturnsAvailableRefundMethodChangeOptionsResponseToEnum>;
}

export const ReturnsAvailableRefundMethodChangeOptionsResponseExchangeToOpmBlockerEnum = {
    None: 'EXCHANGE_TO_OPM_BLOCKER_NONE',
    NoExchangeOrder: 'EXCHANGE_TO_OPM_BLOCKER_NO_EXCHANGE_ORDER',
    NotHeld: 'EXCHANGE_TO_OPM_BLOCKER_NOT_HELD',
    NotSupported: 'EXCHANGE_TO_OPM_BLOCKER_NOT_SUPPORTED',
    AlreadyShipped: 'EXCHANGE_TO_OPM_BLOCKER_ALREADY_SHIPPED',
    MixedMethods: 'EXCHANGE_TO_OPM_BLOCKER_MIXED_METHODS',
    CompensationIssued: 'EXCHANGE_TO_OPM_BLOCKER_COMPENSATION_ISSUED',
    OpenExchange: 'EXCHANGE_TO_OPM_BLOCKER_OPEN_EXCHANGE',
    CheckoutSurplus: 'EXCHANGE_TO_OPM_BLOCKER_CHECKOUT_SURPLUS',
    OpmUnavailable: 'EXCHANGE_TO_OPM_BLOCKER_OPM_UNAVAILABLE'
} as const;

export type ReturnsAvailableRefundMethodChangeOptionsResponseExchangeToOpmBlockerEnum = typeof ReturnsAvailableRefundMethodChangeOptionsResponseExchangeToOpmBlockerEnum[keyof typeof ReturnsAvailableRefundMethodChangeOptionsResponseExchangeToOpmBlockerEnum];
export const ReturnsAvailableRefundMethodChangeOptionsResponseFromEnum = {
    RefundPaymentMethodUnspecified: 'REFUND_PAYMENT_METHOD_UNSPECIFIED',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    RefundPaymentMethodNotNecessary: 'REFUND_PAYMENT_METHOD_NOT_NECESSARY'
} as const;

export type ReturnsAvailableRefundMethodChangeOptionsResponseFromEnum = typeof ReturnsAvailableRefundMethodChangeOptionsResponseFromEnum[keyof typeof ReturnsAvailableRefundMethodChangeOptionsResponseFromEnum];
export const ReturnsAvailableRefundMethodChangeOptionsResponseToEnum = {
    RefundPaymentMethodUnspecified: 'REFUND_PAYMENT_METHOD_UNSPECIFIED',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    RefundPaymentMethodNotNecessary: 'REFUND_PAYMENT_METHOD_NOT_NECESSARY'
} as const;

export type ReturnsAvailableRefundMethodChangeOptionsResponseToEnum = typeof ReturnsAvailableRefundMethodChangeOptionsResponseToEnum[keyof typeof ReturnsAvailableRefundMethodChangeOptionsResponseToEnum];

/**
 * Request to calculate the refund methods for a given order
 * @export
 * @interface ReturnsCalculateRefundMethodsRequest
 */
export interface ReturnsCalculateRefundMethodsRequest {
    /**
     * Available refund methods
     * @type {Array<string>}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'available_methods'?: Array<ReturnsCalculateRefundMethodsRequestAvailableMethodsEnum>;
    /**
     * Created at timestamp used for replaying events
     * @type {string}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'created_at'?: string;
    /**
     * Ecommerce identifier
     * @type {string}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Items to return
     * @type {Array<ReturnsItem>}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'items'?: Array<ReturnsItem>;
    /**
     * HTTP request headers
     * @type {ReturnsRequestHeaders}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'request_headers'?: ReturnsRequestHeaders;
    /**
     * Return request form ID
     * @type {string}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'return_request_form_id'?: string;
    /**
     * User ID
     * @type {string}
     * @memberof ReturnsCalculateRefundMethodsRequest
     */
    'user_id'?: string;
}

export const ReturnsCalculateRefundMethodsRequestAvailableMethodsEnum = {
    Unspecified: 'INDITEX_REFUND_METHOD_UNSPECIFIED',
    OriginalPaymentMethod: 'INDITEX_REFUND_METHOD_ORIGINAL_PAYMENT_METHOD',
    GiftCard: 'INDITEX_REFUND_METHOD_GIFT_CARD'
} as const;

export type ReturnsCalculateRefundMethodsRequestAvailableMethodsEnum = typeof ReturnsCalculateRefundMethodsRequestAvailableMethodsEnum[keyof typeof ReturnsCalculateRefundMethodsRequestAvailableMethodsEnum];

/**
 * Response to CalculateRefundMethodsRequest containing the refund methods
 * @export
 * @interface ReturnsCalculateRefundMethodsResponse
 */
export interface ReturnsCalculateRefundMethodsResponse {
    /**
     * Available refund methods
     * @type {Array<ReturnsTimedRefundMethod>}
     * @memberof ReturnsCalculateRefundMethodsResponse
     */
    'refund_methods'?: Array<ReturnsTimedRefundMethod>;
}
/**
 * Response for calculating update for changing compensation to Original Payment Method (OPM)
 * @export
 * @interface ReturnsCalculateUpdateAmountResponse
 */
export interface ReturnsCalculateUpdateAmountResponse {
    /**
     * Amount to be refunded
     * @type {string}
     * @memberof ReturnsCalculateUpdateAmountResponse
     */
    'amount'?: string;
    /**
     * Money format
     * @type {ModelsMoneyFormat}
     * @memberof ReturnsCalculateUpdateAmountResponse
     */
    'money_format'?: ModelsMoneyFormat;
}
/**
 * Calculated summary
 * @export
 * @interface ReturnsCalculatedSummary
 */
export interface ReturnsCalculatedSummary {
    /**
     * Costs
     * @type {Array<ReturnsCalculatedSummaryCost>}
     * @memberof ReturnsCalculatedSummary
     */
    'costs'?: Array<ReturnsCalculatedSummaryCost>;
    /**
     * Exchange items
     * @type {Array<ReturnsCalculatedSummaryExchangeItem>}
     * @memberof ReturnsCalculatedSummary
     */
    'exchange_items'?: Array<ReturnsCalculatedSummaryExchangeItem>;
    /**
     * Is negative
     * @type {boolean}
     * @memberof ReturnsCalculatedSummary
     */
    'is_negative'?: boolean;
    /**
     * Returned items
     * @type {Array<ReturnsCalculatedSummaryReturnedItem>}
     * @memberof ReturnsCalculatedSummary
     */
    'returned_items'?: Array<ReturnsCalculatedSummaryReturnedItem>;
    /**
     * Subtotal formatted
     * @type {string}
     * @memberof ReturnsCalculatedSummary
     */
    'subtotal_formatted'?: string;
    /**
     * Total formatted
     * @type {string}
     * @memberof ReturnsCalculatedSummary
     */
    'total_formatted'?: string;
}
/**
 * Cost
 * @export
 * @interface ReturnsCalculatedSummaryCost
 */
export interface ReturnsCalculatedSummaryCost {
    /**
     * Name
     * @type {string}
     * @memberof ReturnsCalculatedSummaryCost
     */
    'name'?: string;
    /**
     * Price formatted
     * @type {string}
     * @memberof ReturnsCalculatedSummaryCost
     */
    'price_formatted'?: string;
    /**
     * Subtype
     * @type {string}
     * @memberof ReturnsCalculatedSummaryCost
     */
    'subtype'?: string;
    /**
     * Total
     * @type {number}
     * @memberof ReturnsCalculatedSummaryCost
     */
    'total'?: number;
}
/**
 * Exchange item
 * @export
 * @interface ReturnsCalculatedSummaryExchangeItem
 */
export interface ReturnsCalculatedSummaryExchangeItem {
    /**
     * ID
     * @type {string}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'id'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'image_url'?: string;
    /**
     * Name
     * @type {string}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'name'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'quantity'?: number;
    /**
     * Total
     * @type {number}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'total'?: number;
    /**
     * Total formatted
     * @type {string}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'total_formatted'?: string;
    /**
     * Variant name
     * @type {string}
     * @memberof ReturnsCalculatedSummaryExchangeItem
     */
    'variant_name'?: string;
}
/**
 * Returned item
 * @export
 * @interface ReturnsCalculatedSummaryReturnedItem
 */
export interface ReturnsCalculatedSummaryReturnedItem {
    /**
     * ID
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'id'?: string;
    /**
     * Image URL
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'image_url'?: string;
    /**
     * Name
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'name'?: string;
    /**
     * Price formatted
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'price_formatted'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'quantity'?: number;
    /**
     * Return reason
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'return_reason'?: string;
    /**
     * REVER ID of the returned line item. Uploaded documents reference it in line_item_id.
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'rever_id'?: string;
    /**
     * Total
     * @type {number}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'total'?: number;
    /**
     * True when the customer is asked for photos or documents of this item.
     * @type {boolean}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'upload_documents_required'?: boolean;
    /**
     * Variant name
     * @type {string}
     * @memberof ReturnsCalculatedSummaryReturnedItem
     */
    'variant_name'?: string;
}
/**
 * Request to cancel a return process
 * @export
 * @interface ReturnsCancelReturnProcessRequest
 */
export interface ReturnsCancelReturnProcessRequest {
    /**
     * Return process ID
     * @type {string}
     * @memberof ReturnsCancelReturnProcessRequest
     */
    'process_id'?: string;
    /**
     * Reason for the cancellation
     * @type {string}
     * @memberof ReturnsCancelReturnProcessRequest
     */
    'reason'?: string;
}
/**
 * Request to cancel a Worry-Free-Purchase contract from the self-service form.
 * @export
 * @interface ReturnsCancelWfpContractRequest
 */
export interface ReturnsCancelWfpContractRequest {
    /**
     * Order number the shopper sees (same value used by ImportReturn).
     * @type {string}
     * @memberof ReturnsCancelWfpContractRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * E-commerce ID (path param).
     * @type {string}
     * @memberof ReturnsCancelWfpContractRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopper email; authenticates the order lookup.
     * @type {string}
     * @memberof ReturnsCancelWfpContractRequest
     */
    'email'?: string;
}
/**
 * Category information
 * @export
 * @interface ReturnsCategory
 */
export interface ReturnsCategory {
    /**
     * ID
     * @type {string}
     * @memberof ReturnsCategory
     */
    'id'?: string;
}
/**
 * Request to create lite order
 * @export
 * @interface ReturnsCreateLiteOrderRequest
 */
export interface ReturnsCreateLiteOrderRequest {
    /**
     * Customer printed order ID
     * @type {string}
     * @memberof ReturnsCreateLiteOrderRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsCreateLiteOrderRequest
     */
    'ecommerce_id'?: string;
    /**
     * Email
     * @type {string}
     * @memberof ReturnsCreateLiteOrderRequest
     */
    'email'?: string;
    /**
     * Products to return
     * @type {Array<ReturnsCreateLiteOrderRequestProductToReturn>}
     * @memberof ReturnsCreateLiteOrderRequest
     */
    'products_to_return'?: Array<ReturnsCreateLiteOrderRequestProductToReturn>;
}
/**
 * Product to return
 * @export
 * @interface ReturnsCreateLiteOrderRequestProductToReturn
 */
export interface ReturnsCreateLiteOrderRequestProductToReturn {
    /**
     * Product name
     * @type {string}
     * @memberof ReturnsCreateLiteOrderRequestProductToReturn
     */
    'product_name'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsCreateLiteOrderRequestProductToReturn
     */
    'quantity'?: number;
    /**
     * Reason
     * @type {string}
     * @memberof ReturnsCreateLiteOrderRequestProductToReturn
     */
    'reason'?: string;
}
/**
 * Response with created lite order
 * @export
 * @interface ReturnsCreateLiteOrderResponse
 */
export interface ReturnsCreateLiteOrderResponse {
    /**
     * Checkout ID
     * @type {string}
     * @memberof ReturnsCreateLiteOrderResponse
     */
    'checkout_id'?: string;
    /**
     * Order
     * @type {ReturnsOrder}
     * @memberof ReturnsCreateLiteOrderResponse
     */
    'order'?: ReturnsOrder;
}
/**
 * Customer information
 * @export
 * @interface ReturnsCustomer
 */
export interface ReturnsCustomer {
    /**
     * Email
     * @type {string}
     * @memberof ReturnsCustomer
     */
    'email'?: string;
    /**
     * First name
     * @type {string}
     * @memberof ReturnsCustomer
     */
    'first_name'?: string;
    /**
     * Last name
     * @type {string}
     * @memberof ReturnsCustomer
     */
    'last_name'?: string;
}
/**
 * Request for delivery note presigned URL
 * @export
 * @interface ReturnsDeliveryNotePresignedURLRequest
 */
export interface ReturnsDeliveryNotePresignedURLRequest {
    /**
     * Return process identification
     * @type {ReturnsReturnProcessIdentification}
     * @memberof ReturnsDeliveryNotePresignedURLRequest
     */
    'return_process_identification'?: ReturnsReturnProcessIdentification;
}
/**
 * Response with delivery note presigned URL
 * @export
 * @interface ReturnsDeliveryNotePresignedURLResponse
 */
export interface ReturnsDeliveryNotePresignedURLResponse {
    /**
     * Presigned URL
     * @type {string}
     * @memberof ReturnsDeliveryNotePresignedURLResponse
     */
    'url'?: string;
}
/**
 * Request to derive the allocated timing ID
 * @export
 * @interface ReturnsDeriveAllocatedTimingIdRequest
 */
export interface ReturnsDeriveAllocatedTimingIdRequest {
    /**
     * Ecommerce identifier
     * @type {string}
     * @memberof ReturnsDeriveAllocatedTimingIdRequest
     */
    'ecommerce_id'?: string;
    /**
     * Items to return
     * @type {Array<ReturnsItem>}
     * @memberof ReturnsDeriveAllocatedTimingIdRequest
     */
    'items'?: Array<ReturnsItem>;
    /**
     * Return request form ID (external return ID from the platform)
     * @type {string}
     * @memberof ReturnsDeriveAllocatedTimingIdRequest
     */
    'return_request_form_id'?: string;
}
/**
 * Response containing the derived allocated timing ID
 * @export
 * @interface ReturnsDeriveAllocatedTimingIdResponse
 */
export interface ReturnsDeriveAllocatedTimingIdResponse {
    /**
     * The derived allocated timing ID
     * @type {string}
     * @memberof ReturnsDeriveAllocatedTimingIdResponse
     */
    'allocated_timing_id'?: string;
}
/**
 * Exchange options
 * @export
 * @interface ReturnsExchangeOptions
 */
export interface ReturnsExchangeOptions {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsExchangeOptions
     */
    'ecommerce_id'?: string;
    /**
     * Exchange flow
     * @type {string}
     * @memberof ReturnsExchangeOptions
     */
    'exchange_flow'?: ReturnsExchangeOptionsExchangeFlowEnum;
    /**
     * Force exchange
     * @type {boolean}
     * @memberof ReturnsExchangeOptions
     */
    'force_exchange'?: boolean;
    /**
     * Line item platform ID
     * @type {string}
     * @memberof ReturnsExchangeOptions
     */
    'line_item_platform_id'?: string;
}

export const ReturnsExchangeOptionsExchangeFlowEnum = {
    Unspecified: 'EXCHANGE_FLOW_UNSPECIFIED',
    None: 'EXCHANGE_FLOW_NONE',
    Open: 'EXCHANGE_FLOW_OPEN',
    OneOnOne: 'EXCHANGE_FLOW_ONE_ON_ONE',
    OpenWithGiftCard: 'EXCHANGE_FLOW_OPEN_WITH_GIFT_CARD',
    Full: 'EXCHANGE_FLOW_FULL'
} as const;

export type ReturnsExchangeOptionsExchangeFlowEnum = typeof ReturnsExchangeOptionsExchangeFlowEnum[keyof typeof ReturnsExchangeOptionsExchangeFlowEnum];

/**
 * Request for exchange options
 * @export
 * @interface ReturnsExchangeOptionsRequest
 */
export interface ReturnsExchangeOptionsRequest {
    /**
     * Checkout ID
     * @type {string}
     * @memberof ReturnsExchangeOptionsRequest
     */
    'checkout_id'?: string;
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsExchangeOptionsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Language
     * @type {string}
     * @memberof ReturnsExchangeOptionsRequest
     */
    'language'?: string;
    /**
     * Line item platform ID
     * @type {string}
     * @memberof ReturnsExchangeOptionsRequest
     */
    'line_item_platform_id'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsExchangeOptionsRequest
     */
    'quantity'?: number;
    /**
     * Return reason
     * @type {string}
     * @memberof ReturnsExchangeOptionsRequest
     */
    'return_reason'?: string;
}
/**
 * Response with exchange options
 * @export
 * @interface ReturnsExchangeOptionsResponse
 */
export interface ReturnsExchangeOptionsResponse {
    /**
     * Exchange options to be offered
     * @type {ReturnsExchangeOptions}
     * @memberof ReturnsExchangeOptionsResponse
     */
    'exchange_options'?: ReturnsExchangeOptions;
    /**
     * Info about line item\'s product (for one-on-one exchanges)
     * @type {ReturnsExchangeOptionsResponseOneOnOneProductInfo}
     * @memberof ReturnsExchangeOptionsResponse
     */
    'line_item_product_info'?: ReturnsExchangeOptionsResponseOneOnOneProductInfo;
    /**
     * How a replacement is priced when the line item\'s promotion carries over; unset when none does
     * @type {ReturnsExchangeOptionsResponsePromotionalExchange}
     * @memberof ReturnsExchangeOptionsResponse
     */
    'promotional_exchange'?: ReturnsExchangeOptionsResponsePromotionalExchange;
    /**
     * Line item\'s product (signed, raw)
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponse
     */
    'signed_line_item_product_raw'?: string;
}
/**
 * One-on-one product information
 * @export
 * @interface ReturnsExchangeOptionsResponseOneOnOneProductInfo
 */
export interface ReturnsExchangeOptionsResponseOneOnOneProductInfo {
    /**
     * Product name
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneProductInfo
     */
    'name'?: string;
    /**
     * Product ID in e-commerce platform
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneProductInfo
     */
    'platform_id'?: string;
    /**
     * Product variants
     * @type {Array<ReturnsExchangeOptionsResponseOneOnOneVariantInfo>}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneProductInfo
     */
    'variants'?: Array<ReturnsExchangeOptionsResponseOneOnOneVariantInfo>;
}
/**
 * One-on-one variant information
 * @export
 * @interface ReturnsExchangeOptionsResponseOneOnOneVariantInfo
 */
export interface ReturnsExchangeOptionsResponseOneOnOneVariantInfo {
    /**
     * Variant price to be applied (after exchange promotions, if any)
     * @type {ReturnsMoney}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'applied_price'?: ReturnsMoney;
    /**
     * EAN of the variant
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'ean'?: string;
    /**
     * Inventory quantity available (only relevant if inventory is enabled)
     * @type {number}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'inventory_quantity'?: number;
    /**
     * Variant availability
     * @type {boolean}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'is_available'?: boolean;
    /**
     * Status of inventory tracking for this variant
     * @type {boolean}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'is_inventory_enabled'?: boolean;
    /**
     * Variant name
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'name'?: string;
    /**
     * Variant ID in e-commerce platform
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'platform_id'?: string;
    /**
     * Variant unavailability reason
     * @type {string}
     * @memberof ReturnsExchangeOptionsResponseOneOnOneVariantInfo
     */
    'unavailability_reason'?: ReturnsExchangeOptionsResponseOneOnOneVariantInfoUnavailabilityReasonEnum;
}

export const ReturnsExchangeOptionsResponseOneOnOneVariantInfoUnavailabilityReasonEnum = {
    Unspecified: 'UNAVAILABILITY_REASON_UNSPECIFIED',
    NotApplicable: 'UNAVAILABILITY_REASON_NOT_APPLICABLE',
    PriceTooHigh: 'UNAVAILABILITY_REASON_PRICE_TOO_HIGH'
} as const;

export type ReturnsExchangeOptionsResponseOneOnOneVariantInfoUnavailabilityReasonEnum = typeof ReturnsExchangeOptionsResponseOneOnOneVariantInfoUnavailabilityReasonEnum[keyof typeof ReturnsExchangeOptionsResponseOneOnOneVariantInfoUnavailabilityReasonEnum];

/**
 * Pricing of a replacement for a line item whose promotion carries onto the exchange
 * @export
 * @interface ReturnsExchangeOptionsResponsePromotionalExchange
 */
export interface ReturnsExchangeOptionsResponsePromotionalExchange {
    /**
     * True when any product keeps the promotion
     * @type {boolean}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'applies_to_all_products'?: boolean;
    /**
     * Fraction (0-1] taken off a replacement\'s unit price when the promotion takes a percentage; 0 otherwise
     * @type {number}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'carried_discount_percentage'?: number;
    /**
     * Units of the line item the promotion covers; further units pay their own price
     * @type {number}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'carried_quantity'?: number;
    /**
     * Taken off a replacement\'s unit price when the promotion takes a fixed amount; unset when it takes a percentage
     * @type {ReturnsMoney}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'carried_unit_discount'?: ReturnsMoney;
    /**
     * Lowest unit price charged for a replacement that keeps the promotion: what was paid  for the returned unit. A pricier replacement pays its own price less the promotion\'s  discount, never less than this.
     * @type {ReturnsMoney}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'carried_unit_price'?: ReturnsMoney;
    /**
     * Collections whose products keep the promotion
     * @type {Array<string>}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'qualifying_collection_ids'?: Array<string>;
    /**
     * Products that keep the promotion, including the line item\'s own product
     * @type {Array<string>}
     * @memberof ReturnsExchangeOptionsResponsePromotionalExchange
     */
    'qualifying_product_ids'?: Array<string>;
}
/**
 * Exchange item information
 * @export
 * @interface ReturnsExchangeOrderInfoExchangeItem
 */
export interface ReturnsExchangeOrderInfoExchangeItem {
    /**
     * Product image URL
     * @type {string}
     * @memberof ReturnsExchangeOrderInfoExchangeItem
     */
    'image_url'?: string;
    /**
     * Product name
     * @type {string}
     * @memberof ReturnsExchangeOrderInfoExchangeItem
     */
    'product_name'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsExchangeOrderInfoExchangeItem
     */
    'quantity'?: number;
    /**
     * Variant name
     * @type {string}
     * @memberof ReturnsExchangeOrderInfoExchangeItem
     */
    'variant_name'?: string;
}
/**
 * Selection of an item for exchange
 * @export
 * @interface ReturnsExchangeSelection
 */
export interface ReturnsExchangeSelection {
    /**
     * Collection IDs of the selected product
     * @type {Array<string>}
     * @memberof ReturnsExchangeSelection
     */
    'collection_ids'?: Array<string>;
    /**
     * Line item platform ID
     * @type {string}
     * @memberof ReturnsExchangeSelection
     */
    'line_item_platform_id'?: string;
    /**
     * Quantity to exchange
     * @type {number}
     * @memberof ReturnsExchangeSelection
     */
    'quantity'?: number;
    /**
     * Signed product raw (from ProductDetails or ExchangeOptions)
     * @type {string}
     * @memberof ReturnsExchangeSelection
     */
    'signed_product_raw'?: string;
    /**
     * Selected variant ID
     * @type {string}
     * @memberof ReturnsExchangeSelection
     */
    'variant_id'?: string;
}
/**
 * A single timing option for exchange
 * @export
 * @interface ReturnsExchangeTimingOption
 */
export interface ReturnsExchangeTimingOption {
    /**
     * Whether this is the default timing
     * @type {boolean}
     * @memberof ReturnsExchangeTimingOption
     */
    'is_default'?: boolean;
    /**
     * Price in minor currency units
     * @type {string}
     * @memberof ReturnsExchangeTimingOption
     */
    'price'?: string;
    /**
     * Timing when the exchange will be executed
     * @type {string}
     * @memberof ReturnsExchangeTimingOption
     */
    'timing'?: ReturnsExchangeTimingOptionTimingEnum;
}

export const ReturnsExchangeTimingOptionTimingEnum = {
    NoTiming: 'NO_TIMING',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type ReturnsExchangeTimingOptionTimingEnum = typeof ReturnsExchangeTimingOptionTimingEnum[keyof typeof ReturnsExchangeTimingOptionTimingEnum];

/**
 * Request for exchange timing options
 * @export
 * @interface ReturnsExchangeTimingsRequest
 */
export interface ReturnsExchangeTimingsRequest {
    /**
     * Checkout ID to fetch order data for fraud check
     * @type {string}
     * @memberof ReturnsExchangeTimingsRequest
     */
    'checkout_id'?: string;
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsExchangeTimingsRequest
     */
    'ecommerce_id'?: string;
    /**
     * Selected exchange items
     * @type {Array<ReturnsExchangeSelection>}
     * @memberof ReturnsExchangeTimingsRequest
     */
    'exchange_selections'?: Array<ReturnsExchangeSelection>;
    /**
     * Items to return for fraud check context
     * @type {Array<ReturnsItemToReturn>}
     * @memberof ReturnsExchangeTimingsRequest
     */
    'items_to_return'?: Array<ReturnsItemToReturn>;
}
/**
 * Response with exchange timing options
 * @export
 * @interface ReturnsExchangeTimingsResponse
 */
export interface ReturnsExchangeTimingsResponse {
    /**
     * Available timing options
     * @type {Array<ReturnsExchangeTimingOption>}
     * @memberof ReturnsExchangeTimingsResponse
     */
    'timing_options'?: Array<ReturnsExchangeTimingOption>;
}
/**
 * Response with order
 * @export
 * @interface ReturnsGetOrderResponse
 */
export interface ReturnsGetOrderResponse {
    /**
     * Checkout ID
     * @type {string}
     * @memberof ReturnsGetOrderResponse
     */
    'checkout_id'?: string;
    /**
     * Order
     * @type {ReturnsOrder}
     * @memberof ReturnsGetOrderResponse
     */
    'order'?: ReturnsOrder;
    /**
     * Previous return processes
     * @type {Array<ReturnsPreviousReturnProcess>}
     * @memberof ReturnsGetOrderResponse
     */
    'previous_return_processes'?: Array<ReturnsPreviousReturnProcess>;
}
/**
 * Identification information
 * @export
 * @interface ReturnsIdentification
 */
export interface ReturnsIdentification {
    /**
     * Customer printed order ID
     * @type {string}
     * @memberof ReturnsIdentification
     */
    'customer_printed_order_id'?: string;
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsIdentification
     */
    'ecommerce_id'?: string;
    /**
     * ID
     * @type {string}
     * @memberof ReturnsIdentification
     */
    'id'?: string;
}
/**
 * Image information
 * @export
 * @interface ReturnsImage
 */
export interface ReturnsImage {
    /**
     * Alt text
     * @type {string}
     * @memberof ReturnsImage
     */
    'alt'?: string;
    /**
     * Name
     * @type {string}
     * @memberof ReturnsImage
     */
    'name'?: string;
    /**
     * Source URL
     * @type {string}
     * @memberof ReturnsImage
     */
    'src'?: string;
}
/**
 * Request to import a line item for an existing order
 * @export
 * @interface ReturnsImportLineItem
 */
export interface ReturnsImportLineItem {
    /**
     * Line item ID
     * @type {string}
     * @memberof ReturnsImportLineItem
     */
    'line_item_id'?: string;
    /**
     * Product return reason
     * @type {string}
     * @memberof ReturnsImportLineItem
     */
    'product_return_reason'?: string;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsImportLineItem
     */
    'quantity'?: number;
    /**
     * Return reason comment
     * @type {string}
     * @memberof ReturnsImportLineItem
     */
    'return_reason_comment'?: string;
    /**
     * SKU
     * @type {string}
     * @memberof ReturnsImportLineItem
     */
    'sku'?: string;
}
/**
 * Structured error for ImportReturn failures.
 * @export
 * @interface ReturnsImportReturnError
 */
export interface ReturnsImportReturnError {
    /**
     * Machine-readable code. Clients should branch on this value.
     * @type {string}
     * @memberof ReturnsImportReturnError
     */
    'code'?: ReturnsImportReturnErrorCodeEnum;
    /**
     * Human-readable message safe to display to end users.
     * @type {string}
     * @memberof ReturnsImportReturnError
     */
    'message'?: string;
}

export const ReturnsImportReturnErrorCodeEnum = {
    Unspecified: 'IMPORT_RETURN_ERROR_CODE_UNSPECIFIED',
    OrderNotFound: 'IMPORT_RETURN_ERROR_CODE_ORDER_NOT_FOUND',
    InvalidIdentificationMethod: 'IMPORT_RETURN_ERROR_CODE_INVALID_IDENTIFICATION_METHOD',
    InvalidInput: 'IMPORT_RETURN_ERROR_CODE_INVALID_INPUT',
    ItemsNotAvailableForReturn: 'IMPORT_RETURN_ERROR_CODE_ITEMS_NOT_AVAILABLE_FOR_RETURN',
    NoReturnMethodsAvailable: 'IMPORT_RETURN_ERROR_CODE_NO_RETURN_METHODS_AVAILABLE',
    NoRefundMethodsAvailable: 'IMPORT_RETURN_ERROR_CODE_NO_REFUND_METHODS_AVAILABLE',
    NotAuthorized: 'IMPORT_RETURN_ERROR_CODE_NOT_AUTHORIZED',
    PreconditionFailed: 'IMPORT_RETURN_ERROR_CODE_PRECONDITION_FAILED'
} as const;

export type ReturnsImportReturnErrorCodeEnum = typeof ReturnsImportReturnErrorCodeEnum[keyof typeof ReturnsImportReturnErrorCodeEnum];

/**
 * Request to import a return process for an existing order
 * @export
 * @interface ReturnsImportReturnRequest
 */
export interface ReturnsImportReturnRequest {
    /**
     * Customer printed order ID
     * @type {string}
     * @memberof ReturnsImportReturnRequest
     */
    'customer_printed_order_id'?: string;
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsImportReturnRequest
     */
    'ecommerce_id'?: string;
    /**
     * Email
     * @type {string}
     * @memberof ReturnsImportReturnRequest
     */
    'email'?: string;
    /**
     * Line items
     * @type {Array<ReturnsImportLineItem>}
     * @memberof ReturnsImportReturnRequest
     */
    'line_items'?: Array<ReturnsImportLineItem>;
    /**
     * User preferred language
     * @type {string}
     * @memberof ReturnsImportReturnRequest
     */
    'user_preferred_lang'?: string;
}
/**
 * Response for ImportReturn. Exactly one of `process_id` or `error` is populated:  `process_id` carries the created return process on success; `error` carries a  structured failure for user-actionable errors. System errors (platform  unavailable, internal failures) are still returned as gRPC status codes and  produce non-2xx HTTP responses with empty bodies.
 * @export
 * @interface ReturnsImportReturnResponse
 */
export interface ReturnsImportReturnResponse {
    /**
     * Structured error. Populated when the import failed with a user-actionable cause.
     * @type {ReturnsImportReturnError}
     * @memberof ReturnsImportReturnResponse
     */
    'error'?: ReturnsImportReturnError;
    /**
     * Process ID. Empty when the import failed.
     * @type {string}
     * @memberof ReturnsImportReturnResponse
     */
    'process_id'?: string;
}
/**
 * InditexCustomer represents customer information for Inditex returns
 * @export
 * @interface ReturnsInditexCustomer
 */
export interface ReturnsInditexCustomer {
    /**
     * Optional email of the customer. Can be redacted.
     * @type {string}
     * @memberof ReturnsInditexCustomer
     */
    'email'?: string;
    /**
     * Optional first name of the customer. Can be redacted.
     * @type {string}
     * @memberof ReturnsInditexCustomer
     */
    'first_name'?: string;
    /**
     * Optional last name of the customer. Can be redacted.
     * @type {string}
     * @memberof ReturnsInditexCustomer
     */
    'last_name'?: string;
    /**
     * Optional phone number of the customer. Can be redacted.
     * @type {string}
     * @memberof ReturnsInditexCustomer
     */
    'phone'?: string;
    /**
     * ID of the customer in the ecommerce platform. Required.
     * @type {string}
     * @memberof ReturnsInditexCustomer
     */
    'platform_customer_id'?: string;
}
/**
 * Request for instructions presigned URL
 * @export
 * @interface ReturnsInstructionsPresignedURLRequest
 */
export interface ReturnsInstructionsPresignedURLRequest {
    /**
     * Return process identification
     * @type {ReturnsReturnProcessIdentification}
     * @memberof ReturnsInstructionsPresignedURLRequest
     */
    'return_process_identification'?: ReturnsReturnProcessIdentification;
}
/**
 * Response with instructions presigned URL
 * @export
 * @interface ReturnsInstructionsPresignedURLResponse
 */
export interface ReturnsInstructionsPresignedURLResponse {
    /**
     * Presigned URL
     * @type {string}
     * @memberof ReturnsInstructionsPresignedURLResponse
     */
    'url'?: string;
}
/**
 * Item represents a line item in a return request
 * @export
 * @interface ReturnsItem
 */
export interface ReturnsItem {
    /**
     * Amount for this item
     * @type {ReturnsItemAmount}
     * @memberof ReturnsItem
     */
    'amount'?: ReturnsItemAmount;
    /**
     * Catalog entry ID
     * @type {string}
     * @memberof ReturnsItem
     */
    'cat_entry_id'?: string;
    /**
     * Order ID
     * @type {string}
     * @memberof ReturnsItem
     */
    'order_id'?: string;
    /**
     * Order line item ID
     * @type {string}
     * @memberof ReturnsItem
     */
    'order_line_item_id'?: string;
    /**
     * Quantity of items to return
     * @type {number}
     * @memberof ReturnsItem
     */
    'quantity'?: number;
    /**
     * Reason for return
     * @type {string}
     * @memberof ReturnsItem
     */
    'return_reason'?: string;
}
/**
 * ItemAmount represents a monetary amount
 * @export
 * @interface ReturnsItemAmount
 */
export interface ReturnsItemAmount {
    /**
     * Amount value
     * @type {string}
     * @memberof ReturnsItemAmount
     */
    'amount'?: string;
    /**
     * Currency code (ISO 4217)
     * @type {string}
     * @memberof ReturnsItemAmount
     */
    'currency_code'?: string;
    /**
     * Exponent for decimal places
     * @type {number}
     * @memberof ReturnsItemAmount
     */
    'exponent'?: number;
}
/**
 * Item to return — used for fraud check context in exchange timings
 * @export
 * @interface ReturnsItemToReturn
 */
export interface ReturnsItemToReturn {
    /**
     * Action (TO_RETURN or TO_EXCHANGE)
     * @type {string}
     * @memberof ReturnsItemToReturn
     */
    'action'?: ReturnsItemToReturnActionEnum;
    /**
     * Line item platform ID
     * @type {string}
     * @memberof ReturnsItemToReturn
     */
    'line_item_platform_id'?: string;
    /**
     * Product return reason
     * @type {string}
     * @memberof ReturnsItemToReturn
     */
    'product_return_reason'?: string;
    /**
     * Quantity to return
     * @type {number}
     * @memberof ReturnsItemToReturn
     */
    'quantity'?: number;
    /**
     * Return reason comment
     * @type {string}
     * @memberof ReturnsItemToReturn
     */
    'return_reason_comment'?: string;
}

export const ReturnsItemToReturnActionEnum = {
    NoAction: 'NO_ACTION',
    ToExchange: 'TO_EXCHANGE',
    ToReturn: 'TO_RETURN'
} as const;

export type ReturnsItemToReturnActionEnum = typeof ReturnsItemToReturnActionEnum[keyof typeof ReturnsItemToReturnActionEnum];

/**
 * Request for label presigned URL
 * @export
 * @interface ReturnsLabelPresignedURLRequest
 */
export interface ReturnsLabelPresignedURLRequest {
    /**
     * Return process identification
     * @type {ReturnsReturnProcessIdentification}
     * @memberof ReturnsLabelPresignedURLRequest
     */
    'return_process_identification'?: ReturnsReturnProcessIdentification;
}
/**
 * Response with label presigned URL
 * @export
 * @interface ReturnsLabelPresignedURLResponse
 */
export interface ReturnsLabelPresignedURLResponse {
    /**
     * Presigned URL
     * @type {string}
     * @memberof ReturnsLabelPresignedURLResponse
     */
    'url'?: string;
}
/**
 * Line item
 * @export
 * @interface ReturnsLineItem
 */
export interface ReturnsLineItem {
    /**
     * ID
     * @type {string}
     * @memberof ReturnsLineItem
     */
    'id'?: string;
    /**
     * Name
     * @type {string}
     * @memberof ReturnsLineItem
     */
    'name'?: string;
    /**
     * Non-returnable items
     * @type {Array<ReturnsNonReturnableItem>}
     * @memberof ReturnsLineItem
     */
    'non_returnable_items'?: Array<ReturnsNonReturnableItem>;
    /**
     * Product
     * @type {ReturnsOrderProduct}
     * @memberof ReturnsLineItem
     */
    'product'?: ReturnsOrderProduct;
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsLineItem
     */
    'quantity'?: number;
    /**
     * Total
     * @type {number}
     * @memberof ReturnsLineItem
     */
    'total'?: number;
    /**
     * Variant name
     * @type {string}
     * @memberof ReturnsLineItem
     */
    'variant_name'?: string;
}
/**
 * Dropoff information
 * @export
 * @interface ReturnsLogisticsInfoDropoffInfo
 */
export interface ReturnsLogisticsInfoDropoffInfo {
    /**
     * Points URL
     * @type {string}
     * @memberof ReturnsLogisticsInfoDropoffInfo
     */
    'points_url'?: string;
}
/**
 * In-store information
 * @export
 * @interface ReturnsLogisticsInfoInStoreInfo
 */
export interface ReturnsLogisticsInfoInStoreInfo {
    /**
     * Barcode URL
     * @type {string}
     * @memberof ReturnsLogisticsInfoInStoreInfo
     */
    'barcode_url'?: string;
    /**
     * Store list URL
     * @type {string}
     * @memberof ReturnsLogisticsInfoInStoreInfo
     */
    'store_list_url'?: string;
}
/**
 * Pickup information
 * @export
 * @interface ReturnsLogisticsInfoPickupInfo
 */
export interface ReturnsLogisticsInfoPickupInfo {
    /**
     * Address the return is picked up from; unset for non-pickup methods
     * @type {ModelsAddress}
     * @memberof ReturnsLogisticsInfoPickupInfo
     */
    'pickup_address'?: ModelsAddress;
    /**
     * Schedule URL
     * @type {string}
     * @memberof ReturnsLogisticsInfoPickupInfo
     */
    'schedule_url'?: string;
}
/**
 * Money representation
 * @export
 * @interface ReturnsMoney
 */
export interface ReturnsMoney {
    /**
     * Amount
     * @type {string}
     * @memberof ReturnsMoney
     */
    'amount'?: string;
    /**
     * Currency code
     * @type {string}
     * @memberof ReturnsMoney
     */
    'currency_code'?: string;
}
/**
 * Non-returnable item
 * @export
 * @interface ReturnsNonReturnableItem
 */
export interface ReturnsNonReturnableItem {
    /**
     * Quantity
     * @type {number}
     * @memberof ReturnsNonReturnableItem
     */
    'quantity'?: number;
    /**
     * Reason
     * @type {string}
     * @memberof ReturnsNonReturnableItem
     */
    'reason'?: ReturnsNonReturnableItemReasonEnum;
}

export const ReturnsNonReturnableItemReasonEnum = {
    None: 'NON_RETURNABLE_REASON_NONE',
    InProgress: 'NON_RETURNABLE_REASON_IN_PROGRESS',
    Returned: 'NON_RETURNABLE_REASON_RETURNED',
    NonReturnable: 'NON_RETURNABLE_REASON_NON_RETURNABLE',
    NotFulfilled: 'NON_RETURNABLE_REASON_NOT_FULFILLED',
    OutOfReturnPeriod: 'NON_RETURNABLE_REASON_OUT_OF_RETURN_PERIOD',
    ParentNotCompleted: 'NON_RETURNABLE_REASON_PARENT_NOT_COMPLETED',
    Platform: 'NON_RETURNABLE_REASON_PLATFORM'
} as const;

export type ReturnsNonReturnableItemReasonEnum = typeof ReturnsNonReturnableItemReasonEnum[keyof typeof ReturnsNonReturnableItemReasonEnum];

/**
 * Order information
 * @export
 * @interface ReturnsOrder
 */
export interface ReturnsOrder {
    /**
     * Customer
     * @type {ReturnsCustomer}
     * @memberof ReturnsOrder
     */
    'customer'?: ReturnsCustomer;
    /**
     * Identification
     * @type {ReturnsIdentification}
     * @memberof ReturnsOrder
     */
    'identification'?: ReturnsIdentification;
    /**
     * Line items
     * @type {Array<ReturnsLineItem>}
     * @memberof ReturnsOrder
     */
    'line_items'?: Array<ReturnsLineItem>;
    /**
     * Money format
     * @type {ModelsMoneyFormat}
     * @memberof ReturnsOrder
     */
    'money_format'?: ModelsMoneyFormat;
    /**
     * Purchased at timestamp
     * @type {string}
     * @memberof ReturnsOrder
     */
    'purchased_at'?: string;
    /**
     * Shipping address
     * @type {ModelsAddress}
     * @memberof ReturnsOrder
     */
    'shipping_address'?: ModelsAddress;
}
/**
 * Order product information
 * @export
 * @interface ReturnsOrderProduct
 */
export interface ReturnsOrderProduct {
    /**
     * Categories
     * @type {Array<ReturnsCategory>}
     * @memberof ReturnsOrderProduct
     */
    'categories'?: Array<ReturnsCategory>;
    /**
     * ID
     * @type {string}
     * @memberof ReturnsOrderProduct
     */
    'id'?: string;
    /**
     * Images
     * @type {Array<ReturnsImage>}
     * @memberof ReturnsOrderProduct
     */
    'images'?: Array<ReturnsImage>;
    /**
     * Unit price for this product in the order, following the order money format
     * @type {number}
     * @memberof ReturnsOrderProduct
     */
    'price'?: number;
    /**
     * SKU
     * @type {string}
     * @memberof ReturnsOrderProduct
     */
    'sku'?: string;
}
/**
 * Previous return process
 * @export
 * @interface ReturnsPreviousReturnProcess
 */
export interface ReturnsPreviousReturnProcess {
    /**
     * Process ID
     * @type {string}
     * @memberof ReturnsPreviousReturnProcess
     */
    'process_id'?: string;
    /**
     * Started at timestamp
     * @type {string}
     * @memberof ReturnsPreviousReturnProcess
     */
    'started_at'?: string;
}
/**
 * Request to add a return process
 * @export
 * @interface ReturnsProcessReturnRequest
 */
export interface ReturnsProcessReturnRequest {
    /**
     * Additional costs associated to the return, like shipping costs  These costs are subtracted from the total refund amount
     * @type {Array<ReturnsReturnCost>}
     * @memberof ReturnsProcessReturnRequest
     */
    'additional_costs'?: Array<ReturnsReturnCost>;
    /**
     * Country in where the return is being created. Required.
     * @type {string}
     * @memberof ReturnsProcessReturnRequest
     */
    'country_iso'?: string;
    /**
     * Customer information. Required.
     * @type {ReturnsInditexCustomer}
     * @memberof ReturnsProcessReturnRequest
     */
    'customer'?: ReturnsInditexCustomer;
    /**
     * where to drop-off this return
     * @type {ReturnsAddress}
     * @memberof ReturnsProcessReturnRequest
     */
    'drop_off_address'?: ReturnsAddress;
    /**
     * REVER ecommerce identifier. Required.
     * @type {string}
     * @memberof ReturnsProcessReturnRequest
     */
    'ecommerce_id'?: string;
    /**
     * address to send the exchanged items
     * @type {ReturnsAddress}
     * @memberof ReturnsProcessReturnRequest
     */
    'exchange_shipping_address'?: ReturnsAddress;
    /**
     * Line items being returned
     * @type {Array<ReturnsReturnLineItem>}
     * @memberof ReturnsProcessReturnRequest
     */
    'items'?: Array<ReturnsReturnLineItem>;
    /**
     * Pickup address, required if return method is pickup
     * @type {ReturnsAddress}
     * @memberof ReturnsProcessReturnRequest
     */
    'pickup_address'?: ReturnsAddress;
    /**
     * The return request unique id in the ecommerce platform  This is used as unique identifier of the return request. If multiple  requests are received with the same return_request_id, they will  be considered duplicates and will be rejected. Required.
     * @type {string}
     * @memberof ReturnsProcessReturnRequest
     */
    'platform_return_request_id'?: string;
    /**
     * creation datetime of the return request.Required.
     * @type {string}
     * @memberof ReturnsProcessReturnRequest
     */
    'return_creation_date'?: string;
    /**
     * Return method for the entire return. Required.
     * @type {string}
     * @memberof ReturnsProcessReturnRequest
     */
    'return_method'?: ReturnsProcessReturnRequestReturnMethodEnum;
    /**
     * User preferred language (ISO 639-1), for localization purposes. Optional. Defaults to \"en\".
     * @type {string}
     * @memberof ReturnsProcessReturnRequest
     */
    'user_preferred_lang'?: string;
    /**
     * warehouse address, if applicable
     * @type {ReturnsAddress}
     * @memberof ReturnsProcessReturnRequest
     */
    'warehouse_address'?: ReturnsAddress;
}

export const ReturnsProcessReturnRequestReturnMethodEnum = {
    Unspecified: 'INDITEX_RETURN_METHOD_UNSPECIFIED',
    DropOffPoint: 'INDITEX_RETURN_METHOD_DROP_OFF_POINT',
    DeliveryPickup: 'INDITEX_RETURN_METHOD_DELIVERY_PICKUP',
    HomePickup: 'INDITEX_RETURN_METHOD_HOME_PICKUP',
    InStore: 'INDITEX_RETURN_METHOD_IN_STORE',
    NoReturnMethod: 'INDITEX_RETURN_METHOD_NO_RETURN_METHOD'
} as const;

export type ReturnsProcessReturnRequestReturnMethodEnum = typeof ReturnsProcessReturnRequestReturnMethodEnum[keyof typeof ReturnsProcessReturnRequestReturnMethodEnum];

/**
 * Response with product details
 * @export
 * @interface ReturnsProductDetailsResponse
 */
export interface ReturnsProductDetailsResponse {
    /**
     * Product information
     * @type {ReturnsProductDetailsResponseProductInfo}
     * @memberof ReturnsProductDetailsResponse
     */
    'product_info'?: ReturnsProductDetailsResponseProductInfo;
    /**
     * Signed product raw
     * @type {string}
     * @memberof ReturnsProductDetailsResponse
     */
    'signed_product_raw'?: string;
}
/**
 * Product information
 * @export
 * @interface ReturnsProductDetailsResponseProductInfo
 */
export interface ReturnsProductDetailsResponseProductInfo {
    /**
     * Collection IDs
     * @type {Array<string>}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'collection_ids'?: Array<string>;
    /**
     * Description
     * @type {string}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'description'?: string;
    /**
     * Details
     * @type {string}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'details'?: string;
    /**
     * Featured image URL
     * @type {string}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'featured_image_url'?: string;
    /**
     * Other image URLs
     * @type {Array<string>}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'image_urls'?: Array<string>;
    /**
     * Product name
     * @type {string}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'name'?: string;
    /**
     * Product ID in e-commerce platform
     * @type {string}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'platform_id'?: string;
    /**
     * Product variants
     * @type {Array<ReturnsProductDetailsResponseVariantInfo>}
     * @memberof ReturnsProductDetailsResponseProductInfo
     */
    'variants'?: Array<ReturnsProductDetailsResponseVariantInfo>;
}
/**
 * Variant information
 * @export
 * @interface ReturnsProductDetailsResponseVariantInfo
 */
export interface ReturnsProductDetailsResponseVariantInfo {
    /**
     * EAN of the variant
     * @type {string}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'ean'?: string;
    /**
     * Image URLs
     * @type {Array<string>}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'image_urls'?: Array<string>;
    /**
     * Inventory quantity available (only relevant if inventory is enabled)
     * @type {number}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'inventory_quantity'?: number;
    /**
     * Status of inventory tracking for this variant
     * @type {boolean}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'is_inventory_enabled'?: boolean;
    /**
     * Variant name
     * @type {string}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'name'?: string;
    /**
     * Variant ID in e-commerce platform
     * @type {string}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'platform_id'?: string;
    /**
     * Variant price
     * @type {ReturnsMoney}
     * @memberof ReturnsProductDetailsResponseVariantInfo
     */
    'price'?: ReturnsMoney;
}
/**
 * RequestHeaders contains HTTP request headers
 * @export
 * @interface ReturnsRequestHeaders
 */
export interface ReturnsRequestHeaders {
    /**
     * Forwarded header
     * @type {string}
     * @memberof ReturnsRequestHeaders
     */
    'forwarded'?: string;
    /**
     * Host header
     * @type {string}
     * @memberof ReturnsRequestHeaders
     */
    'host'?: string;
    /**
     * Origin header
     * @type {string}
     * @memberof ReturnsRequestHeaders
     */
    'origin'?: string;
    /**
     * Referer header
     * @type {string}
     * @memberof ReturnsRequestHeaders
     */
    'referer'?: string;
    /**
     * User-Agent header
     * @type {string}
     * @memberof ReturnsRequestHeaders
     */
    'user_agent'?: string;
}
/**
 * 
 * @export
 * @interface ReturnsRequestNewLabelRequest
 */
export interface ReturnsRequestNewLabelRequest {
    /**
     * Return process identification
     * @type {ReturnsReturnProcessIdentification}
     * @memberof ReturnsRequestNewLabelRequest
     */
    'return_process_identification'?: ReturnsReturnProcessIdentification;
}
/**
 * ReturnCost represents an additional cost associated with a return
 * @export
 * @interface ReturnsReturnCost
 */
export interface ReturnsReturnCost {
    /**
     * Comments of the additional cost
     * @type {string}
     * @memberof ReturnsReturnCost
     */
    'comments'?: string;
    /**
     * Name/Description of the additional cost
     * @type {string}
     * @memberof ReturnsReturnCost
     */
    'name'?: string;
    /**
     * Quantity being returned. Required.
     * @type {number}
     * @memberof ReturnsReturnCost
     */
    'quantity'?: number;
    /**
     * Total amount for this cost, including taxes and discounts. Required.  Should be equal to (unit_price * quantity) - total_discounts + total_taxes
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnCost
     */
    'total_amount'?: ReturnsItemAmount;
    /**
     * Total discount amount applied to the subtotal (quantity * unit_price) amount.
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnCost
     */
    'total_discounts'?: ReturnsItemAmount;
    /**
     * Total tax amount applied to the subtotal (quantity * unit_price) amount, after discounts.
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnCost
     */
    'total_taxes'?: ReturnsItemAmount;
    /**
     * Type of the additional cost
     * @type {string}
     * @memberof ReturnsReturnCost
     */
    'type'?: ReturnsReturnCostTypeEnum;
    /**
     * Amount for the cost, with  no discounts nor taxes. Positive for costs, negative for promotions. Required.
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnCost
     */
    'unit_price'?: ReturnsItemAmount;
}

export const ReturnsReturnCostTypeEnum = {
    Unspecified: 'TYPE_OF_RETURN_COST_UNSPECIFIED',
    Shipping: 'TYPE_OF_RETURN_COST_SHIPPING',
    ServiceFee: 'TYPE_OF_RETURN_COST_SERVICE_FEE',
    Promotion: 'TYPE_OF_RETURN_COST_PROMOTION'
} as const;

export type ReturnsReturnCostTypeEnum = typeof ReturnsReturnCostTypeEnum[keyof typeof ReturnsReturnCostTypeEnum];

/**
 * A ReturnLineItem represents returning a specific quantity of a product/variant  that was purchased in a previous fulfilled order.
 * @export
 * @interface ReturnsReturnLineItem
 */
export interface ReturnsReturnLineItem {
    /**
     * Manual comments associated to this line item
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'comments'?: string;
    /**
     * Name of the line item (not necessarily, but often, the title of the product)
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'name'?: string;
    /**
     * Optional line item identifier in the ecommerce platform
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_line_item_id'?: string;
    /**
     * Platform order identifier. This is the id in the platform of the   order in where the product was purchased. Required.
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_order_id'?: string;
    /**
     * Platform order identifier visible by the customer. Can be the same as platform_order_id. Optional.
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_order_id_visible_by_customer'?: string;
    /**
     * Platform order purchased at timestamp. Required.
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_order_purchased_at'?: string;
    /**
     * Product identifier in the ecommerce platform. Required.
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_product_id'?: string;
    /**
     * Optional platform SKU associated to the product. Will default to platform_product_id if not provided.
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_sku'?: string;
    /**
     * Variant identifier in the ecommerce platform. Optional.
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'platform_variant_id'?: string;
    /**
     * URL of the main image of the product/line-item
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'product_image_url'?: string;
    /**
     * Return reason. Required. The accepted values are defined by the ecommerce platform  in its return reasons configuration.  TODO: Investigate if we should do a regex transformation internally from an open text to return reasons. (IA?)
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'product_return_reason'?: string;
    /**
     * Quantity being returned. Required.
     * @type {number}
     * @memberof ReturnsReturnLineItem
     */
    'quantity'?: number;
    /**
     * refund method selected for this line item  The timing will be extracted from the DB based on the refund method selected  With a fallback to ON_ITEM_VERIFIED
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'refund_method'?: ReturnsReturnLineItemRefundMethodEnum;
    /**
     * Refund timing selected for this line item
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'refund_timing'?: ReturnsReturnLineItemRefundTimingEnum;
    /**
     * Total amount paid (and returned) for this line item in the original order, including taxes and discounts. Required.  Should be equal to (unit_price * quantity) - total_discounts + total_taxes
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnLineItem
     */
    'total_amount'?: ReturnsItemAmount;
    /**
     * Total discount amount applied to the subtotal (quantity * unit_price) amount.
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnLineItem
     */
    'total_discounts'?: ReturnsItemAmount;
    /**
     * Total tax amount applied to the subtotal (quantity * unit_price) amount, after discounts.
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnLineItem
     */
    'total_taxes'?: ReturnsItemAmount;
    /**
     * Amount paid for a single unit of the product in the original order, with  no discounts nor taxes. Required.
     * @type {ReturnsItemAmount}
     * @memberof ReturnsReturnLineItem
     */
    'unit_price'?: ReturnsItemAmount;
    /**
     * Name of the variant
     * @type {string}
     * @memberof ReturnsReturnLineItem
     */
    'variant_name'?: string;
}

export const ReturnsReturnLineItemRefundMethodEnum = {
    Unspecified: 'INDITEX_REFUND_METHOD_UNSPECIFIED',
    OriginalPaymentMethod: 'INDITEX_REFUND_METHOD_ORIGINAL_PAYMENT_METHOD',
    GiftCard: 'INDITEX_REFUND_METHOD_GIFT_CARD'
} as const;

export type ReturnsReturnLineItemRefundMethodEnum = typeof ReturnsReturnLineItemRefundMethodEnum[keyof typeof ReturnsReturnLineItemRefundMethodEnum];
export const ReturnsReturnLineItemRefundTimingEnum = {
    Unspecified: 'INDITEX_TIMING_UNSPECIFIED',
    OnStartReturnProcess: 'INDITEX_TIMING_ON_START_RETURN_PROCESS',
    OnItemSent: 'INDITEX_TIMING_ON_ITEM_SENT',
    OnItemVerified: 'INDITEX_TIMING_ON_ITEM_VERIFIED'
} as const;

export type ReturnsReturnLineItemRefundTimingEnum = typeof ReturnsReturnLineItemRefundTimingEnum[keyof typeof ReturnsReturnLineItemRefundTimingEnum];

/**
 * Return process identification
 * @export
 * @interface ReturnsReturnProcessIdentification
 */
export interface ReturnsReturnProcessIdentification {
    /**
     * Email address of the customer related to the return process
     * @type {string}
     * @memberof ReturnsReturnProcessIdentification
     */
    'email'?: string;
    /**
     * Return process ID
     * @type {string}
     * @memberof ReturnsReturnProcessIdentification
     */
    'process_id'?: string;
}
/**
 * Request payload for SubmitWithdrawal.
 * @export
 * @interface ReturnsSubmitWithdrawalRequest
 */
export interface ReturnsSubmitWithdrawalRequest {
    /**
     * E-commerce whose portal received it (path param).
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalRequest
     */
    'ecommerce_id'?: string;
    /**
     * Shopper\'s email. The acknowledgment goes to it, and it matches the order.
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalRequest
     */
    'email'?: string;
    /**
     * Language of the form, ISO 639-1. Defaults to en.
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalRequest
     */
    'lang'?: string;
    /**
     * Shopper\'s first and last name.
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalRequest
     */
    'name'?: string;
    /**
     * Order number as the shopper typed it.
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalRequest
     */
    'order_number'?: string;
}
/**
 * Response for SubmitWithdrawal.
 * @export
 * @interface ReturnsSubmitWithdrawalResponse
 */
export interface ReturnsSubmitWithdrawalResponse {
    /**
     * Reference the shopper gets.
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalResponse
     */
    'id'?: string;
    /**
     * Whether any item of the matched order had shipped, so the shopper has goods to return.
     * @type {boolean}
     * @memberof ReturnsSubmitWithdrawalResponse
     */
    'order_shipped'?: boolean;
    /**
     * When REVER received it: the legal proof of when the shopper withdrew.
     * @type {string}
     * @memberof ReturnsSubmitWithdrawalResponse
     */
    'received_at'?: string;
}
/**
 * RefundMethod represents a refund method option
 * @export
 * @interface ReturnsTimedRefundMethod
 */
export interface ReturnsTimedRefundMethod {
    /**
     * Refund method identifier
     * @type {string}
     * @memberof ReturnsTimedRefundMethod
     */
    'method'?: ReturnsTimedRefundMethodMethodEnum;
    /**
     * Refund timing
     * @type {string}
     * @memberof ReturnsTimedRefundMethod
     */
    'timing'?: ReturnsTimedRefundMethodTimingEnum;
}

export const ReturnsTimedRefundMethodMethodEnum = {
    Unspecified: 'INDITEX_REFUND_METHOD_UNSPECIFIED',
    OriginalPaymentMethod: 'INDITEX_REFUND_METHOD_ORIGINAL_PAYMENT_METHOD',
    GiftCard: 'INDITEX_REFUND_METHOD_GIFT_CARD'
} as const;

export type ReturnsTimedRefundMethodMethodEnum = typeof ReturnsTimedRefundMethodMethodEnum[keyof typeof ReturnsTimedRefundMethodMethodEnum];
export const ReturnsTimedRefundMethodTimingEnum = {
    Unspecified: 'INDITEX_TIMING_UNSPECIFIED',
    OnStartReturnProcess: 'INDITEX_TIMING_ON_START_RETURN_PROCESS',
    OnItemSent: 'INDITEX_TIMING_ON_ITEM_SENT',
    OnItemVerified: 'INDITEX_TIMING_ON_ITEM_VERIFIED'
} as const;

export type ReturnsTimedRefundMethodTimingEnum = typeof ReturnsTimedRefundMethodTimingEnum[keyof typeof ReturnsTimedRefundMethodTimingEnum];

/**
 * Request for tracking information
 * @export
 * @interface ReturnsTrackingInfoRequest
 */
export interface ReturnsTrackingInfoRequest {
    /**
     * Return process identification
     * @type {ReturnsReturnProcessIdentification}
     * @memberof ReturnsTrackingInfoRequest
     */
    'return_process_identification'?: ReturnsReturnProcessIdentification;
}
/**
 * Response with tracking information
 * @export
 * @interface ReturnsTrackingInfoResponse
 */
export interface ReturnsTrackingInfoResponse {
    /**
     * Customer printed order ID
     * @type {string}
     * @memberof ReturnsTrackingInfoResponse
     */
    'customer_printed_order_id'?: string;
    /**
     * Exchange order information
     * @type {ReturnsTrackingInfoResponseExchangeOrderInfo}
     * @memberof ReturnsTrackingInfoResponse
     */
    'exchange_order_info'?: ReturnsTrackingInfoResponseExchangeOrderInfo;
    /**
     * Keep your item type
     * @type {string}
     * @memberof ReturnsTrackingInfoResponse
     */
    'keep_your_item_type'?: ReturnsTrackingInfoResponseKeepYourItemTypeEnum;
    /**
     * Logistics information
     * @type {ReturnsTrackingInfoResponseLogisticsInfo}
     * @memberof ReturnsTrackingInfoResponse
     */
    'logistics_info'?: ReturnsTrackingInfoResponseLogisticsInfo;
    /**
     * Refund information
     * @type {ReturnsTrackingInfoResponseRefundInfo}
     * @memberof ReturnsTrackingInfoResponse
     */
    'refund_info'?: ReturnsTrackingInfoResponseRefundInfo;
    /**
     * Review result
     * @type {string}
     * @memberof ReturnsTrackingInfoResponse
     */
    'review_result'?: ReturnsTrackingInfoResponseReviewResultEnum;
    /**
     * Return status
     * @type {string}
     * @memberof ReturnsTrackingInfoResponse
     */
    'status'?: ReturnsTrackingInfoResponseStatusEnum;
    /**
     * Calculated summary
     * @type {ReturnsCalculatedSummary}
     * @memberof ReturnsTrackingInfoResponse
     */
    'summary'?: ReturnsCalculatedSummary;
    /**
     * Upload documents information
     * @type {ReturnsTrackingInfoResponseUploadDocumentsInfo}
     * @memberof ReturnsTrackingInfoResponse
     */
    'upload_documents_info'?: ReturnsTrackingInfoResponseUploadDocumentsInfo;
}

export const ReturnsTrackingInfoResponseKeepYourItemTypeEnum = {
    Unspecified: 'KEEP_YOUR_ITEM_TYPE_UNSPECIFIED',
    None: 'KEEP_YOUR_ITEM_TYPE_NONE',
    WithoutValidation: 'KEEP_YOUR_ITEM_TYPE_WITHOUT_VALIDATION'
} as const;

export type ReturnsTrackingInfoResponseKeepYourItemTypeEnum = typeof ReturnsTrackingInfoResponseKeepYourItemTypeEnum[keyof typeof ReturnsTrackingInfoResponseKeepYourItemTypeEnum];
export const ReturnsTrackingInfoResponseReviewResultEnum = {
    ReviewResultUnspecified: 'REVIEW_RESULT_UNSPECIFIED',
    NotReviewed: 'NOT_REVIEWED',
    FullyApproved: 'FULLY_APPROVED',
    PartiallyApproved: 'PARTIALLY_APPROVED',
    FullyDeclined: 'FULLY_DECLINED'
} as const;

export type ReturnsTrackingInfoResponseReviewResultEnum = typeof ReturnsTrackingInfoResponseReviewResultEnum[keyof typeof ReturnsTrackingInfoResponseReviewResultEnum];
export const ReturnsTrackingInfoResponseStatusEnum = {
    ReturnStatusUnspecified: 'RETURN_STATUS_UNSPECIFIED',
    Started: 'STARTED',
    InTransit: 'IN_TRANSIT',
    InWarehouse: 'IN_WAREHOUSE',
    Reviewed: 'REVIEWED',
    AuthorizationPending: 'AUTHORIZATION_PENDING',
    DocumentUploadPending: 'DOCUMENT_UPLOAD_PENDING',
    Canceled: 'CANCELED',
    NotAuthorized: 'NOT_AUTHORIZED'
} as const;

export type ReturnsTrackingInfoResponseStatusEnum = typeof ReturnsTrackingInfoResponseStatusEnum[keyof typeof ReturnsTrackingInfoResponseStatusEnum];

/**
 * Exchange order information
 * @export
 * @interface ReturnsTrackingInfoResponseExchangeOrderInfo
 */
export interface ReturnsTrackingInfoResponseExchangeOrderInfo {
    /**
     * Exchange items
     * @type {Array<ReturnsExchangeOrderInfoExchangeItem>}
     * @memberof ReturnsTrackingInfoResponseExchangeOrderInfo
     */
    'exchange_items'?: Array<ReturnsExchangeOrderInfoExchangeItem>;
    /**
     * Order number
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseExchangeOrderInfo
     */
    'order_number'?: string;
}
/**
 * Logistics information
 * @export
 * @interface ReturnsTrackingInfoResponseLogisticsInfo
 */
export interface ReturnsTrackingInfoResponseLogisticsInfo {
    /**
     * Carrier
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'carrier'?: string;
    /**
     * Delivery note status
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'delivery_note_status'?: ReturnsTrackingInfoResponseLogisticsInfoDeliveryNoteStatusEnum;
    /**
     * Dropoff information
     * @type {ReturnsLogisticsInfoDropoffInfo}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'dropoff_info'?: ReturnsLogisticsInfoDropoffInfo;
    /**
     * In-store information
     * @type {ReturnsLogisticsInfoInStoreInfo}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'in_store_info'?: ReturnsLogisticsInfoInStoreInfo;
    /**
     * Instructions status
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'instructions_status'?: ReturnsTrackingInfoResponseLogisticsInfoInstructionsStatusEnum;
    /**
     * Label status
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'label_status'?: ReturnsTrackingInfoResponseLogisticsInfoLabelStatusEnum;
    /**
     * Pickup information
     * @type {ReturnsLogisticsInfoPickupInfo}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'pickup_info'?: ReturnsLogisticsInfoPickupInfo;
    /**
     * Return method
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'return_method'?: ReturnsTrackingInfoResponseLogisticsInfoReturnMethodEnum;
    /**
     * Carrier tracking ID / number
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'tracking_id'?: string;
    /**
     * Carrier tracking URL
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseLogisticsInfo
     */
    'tracking_url'?: string;
}

export const ReturnsTrackingInfoResponseLogisticsInfoDeliveryNoteStatusEnum = {
    DocumentStatusUnspecified: 'DOCUMENT_STATUS_UNSPECIFIED',
    Available: 'AVAILABLE',
    Pending: 'PENDING',
    NotRequired: 'NOT_REQUIRED',
    Expired: 'EXPIRED'
} as const;

export type ReturnsTrackingInfoResponseLogisticsInfoDeliveryNoteStatusEnum = typeof ReturnsTrackingInfoResponseLogisticsInfoDeliveryNoteStatusEnum[keyof typeof ReturnsTrackingInfoResponseLogisticsInfoDeliveryNoteStatusEnum];
export const ReturnsTrackingInfoResponseLogisticsInfoInstructionsStatusEnum = {
    DocumentStatusUnspecified: 'DOCUMENT_STATUS_UNSPECIFIED',
    Available: 'AVAILABLE',
    Pending: 'PENDING',
    NotRequired: 'NOT_REQUIRED',
    Expired: 'EXPIRED'
} as const;

export type ReturnsTrackingInfoResponseLogisticsInfoInstructionsStatusEnum = typeof ReturnsTrackingInfoResponseLogisticsInfoInstructionsStatusEnum[keyof typeof ReturnsTrackingInfoResponseLogisticsInfoInstructionsStatusEnum];
export const ReturnsTrackingInfoResponseLogisticsInfoLabelStatusEnum = {
    DocumentStatusUnspecified: 'DOCUMENT_STATUS_UNSPECIFIED',
    Available: 'AVAILABLE',
    Pending: 'PENDING',
    NotRequired: 'NOT_REQUIRED',
    Expired: 'EXPIRED'
} as const;

export type ReturnsTrackingInfoResponseLogisticsInfoLabelStatusEnum = typeof ReturnsTrackingInfoResponseLogisticsInfoLabelStatusEnum[keyof typeof ReturnsTrackingInfoResponseLogisticsInfoLabelStatusEnum];
export const ReturnsTrackingInfoResponseLogisticsInfoReturnMethodEnum = {
    ReturnMethodUnspecified: 'RETURN_METHOD_UNSPECIFIED',
    HomePickUp: 'HOME_PICK_UP',
    DropOffPoint: 'DROP_OFF_POINT',
    DeliveryPickup: 'DELIVERY_PICKUP',
    InStore: 'IN_STORE',
    NoReturnMethod: 'NO_RETURN_METHOD'
} as const;

export type ReturnsTrackingInfoResponseLogisticsInfoReturnMethodEnum = typeof ReturnsTrackingInfoResponseLogisticsInfoReturnMethodEnum[keyof typeof ReturnsTrackingInfoResponseLogisticsInfoReturnMethodEnum];

/**
 * Refund information
 * @export
 * @interface ReturnsTrackingInfoResponseRefundInfo
 */
export interface ReturnsTrackingInfoResponseRefundInfo {
    /**
     * Bank account last digits
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'bank_account_last_digits'?: string;
    /**
     * Executed formatted amount
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'executed_formatted_amount'?: string;
    /**
     * Gift card code
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'gift_card_code'?: string;
    /**
     * Payment method
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'payment_method'?: ReturnsTrackingInfoResponseRefundInfoPaymentMethodEnum;
    /**
     * Pending formatted amount
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'pending_formatted_amount'?: string;
    /**
     * Refunded at timestamp
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'refunded_at'?: string;
    /**
     * Refund status
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'status'?: ReturnsTrackingInfoResponseRefundInfoStatusEnum;
    /**
     * Refund timing
     * @type {string}
     * @memberof ReturnsTrackingInfoResponseRefundInfo
     */
    'timing'?: ReturnsTrackingInfoResponseRefundInfoTimingEnum;
}

export const ReturnsTrackingInfoResponseRefundInfoPaymentMethodEnum = {
    RefundPaymentMethodUnspecified: 'REFUND_PAYMENT_METHOD_UNSPECIFIED',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    RefundPaymentMethodNotNecessary: 'REFUND_PAYMENT_METHOD_NOT_NECESSARY'
} as const;

export type ReturnsTrackingInfoResponseRefundInfoPaymentMethodEnum = typeof ReturnsTrackingInfoResponseRefundInfoPaymentMethodEnum[keyof typeof ReturnsTrackingInfoResponseRefundInfoPaymentMethodEnum];
export const ReturnsTrackingInfoResponseRefundInfoStatusEnum = {
    RefundStatusUnspecified: 'REFUND_STATUS_UNSPECIFIED',
    FullyRefunded: 'FULLY_REFUNDED',
    PartiallyRefunded: 'PARTIALLY_REFUNDED',
    NotRefunded: 'NOT_REFUNDED',
    RefundNotNecessary: 'REFUND_NOT_NECESSARY'
} as const;

export type ReturnsTrackingInfoResponseRefundInfoStatusEnum = typeof ReturnsTrackingInfoResponseRefundInfoStatusEnum[keyof typeof ReturnsTrackingInfoResponseRefundInfoStatusEnum];
export const ReturnsTrackingInfoResponseRefundInfoTimingEnum = {
    RefundTimingUnspecified: 'REFUND_TIMING_UNSPECIFIED',
    OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
    OnItemSent: 'ON_ITEM_SENT',
    OnItemVerified: 'ON_ITEM_VERIFIED'
} as const;

export type ReturnsTrackingInfoResponseRefundInfoTimingEnum = typeof ReturnsTrackingInfoResponseRefundInfoTimingEnum[keyof typeof ReturnsTrackingInfoResponseRefundInfoTimingEnum];

/**
 * Upload documents information
 * @export
 * @interface ReturnsTrackingInfoResponseUploadDocumentsInfo
 */
export interface ReturnsTrackingInfoResponseUploadDocumentsInfo {
    /**
     * Whether upload documents is enabled
     * @type {boolean}
     * @memberof ReturnsTrackingInfoResponseUploadDocumentsInfo
     */
    'upload_documents_enabled'?: boolean;
    /**
     * List of uploaded documents
     * @type {Array<ReturnsUploadDocumentsInfoUploadedDocuments>}
     * @memberof ReturnsTrackingInfoResponseUploadDocumentsInfo
     */
    'uploaded_documents'?: Array<ReturnsUploadDocumentsInfoUploadedDocuments>;
}
/**
 * Request to update a return process with amount adjustment or refund method change
 * @export
 * @interface ReturnsUpdateReturnProcessRequest
 */
export interface ReturnsUpdateReturnProcessRequest {
    /**
     * Amount adjustment
     * @type {number}
     * @memberof ReturnsUpdateReturnProcessRequest
     */
    'amount'?: number;
    /**
     * Set when the change moves an exchange to the original payment method
     * @type {boolean}
     * @memberof ReturnsUpdateReturnProcessRequest
     */
    'from_exchange'?: boolean;
    /**
     * Reason used by operations team for the update
     * @type {string}
     * @memberof ReturnsUpdateReturnProcessRequest
     */
    'internal_reason'?: string;
    /**
     * Return process ID
     * @type {string}
     * @memberof ReturnsUpdateReturnProcessRequest
     */
    'process_id'?: string;
    /**
     * Reason for the update
     * @type {string}
     * @memberof ReturnsUpdateReturnProcessRequest
     */
    'reason'?: string;
    /**
     * Refund method to change to (optional)
     * @type {string}
     * @memberof ReturnsUpdateReturnProcessRequest
     */
    'refund_method'?: ReturnsUpdateReturnProcessRequestRefundMethodEnum;
}

export const ReturnsUpdateReturnProcessRequestRefundMethodEnum = {
    RefundPaymentMethodUnspecified: 'REFUND_PAYMENT_METHOD_UNSPECIFIED',
    BankTransfer: 'BANK_TRANSFER',
    Original: 'ORIGINAL',
    PromoCode: 'PROMO_CODE',
    GiftCard: 'GIFT_CARD',
    RefundPaymentMethodNotNecessary: 'REFUND_PAYMENT_METHOD_NOT_NECESSARY'
} as const;

export type ReturnsUpdateReturnProcessRequestRefundMethodEnum = typeof ReturnsUpdateReturnProcessRequestRefundMethodEnum[keyof typeof ReturnsUpdateReturnProcessRequestRefundMethodEnum];

/**
 * Uploaded documents information
 * @export
 * @interface ReturnsUploadDocumentsInfoUploadedDocuments
 */
export interface ReturnsUploadDocumentsInfoUploadedDocuments {
    /**
     * Document info
     * @type {string}
     * @memberof ReturnsUploadDocumentsInfoUploadedDocuments
     */
    'document_info'?: string;
    /**
     * Document URL
     * @type {string}
     * @memberof ReturnsUploadDocumentsInfoUploadedDocuments
     */
    'document_url'?: string;
    /**
     * REVER ID of the returned line item the document belongs to (ReturnedItem.rever_id).  Empty when the document was uploaded for the whole return process.
     * @type {string}
     * @memberof ReturnsUploadDocumentsInfoUploadedDocuments
     */
    'line_item_id'?: string;
}
/**
 * SaveShopifyCredentialsFromAuthorizationCodeRequest is the request for saving Shopify credentials  from an OAuth authorization code
 * @export
 * @interface ShopifypbSaveShopifyCredentialsFromAuthorizationCodeRequest
 */
export interface ShopifypbSaveShopifyCredentialsFromAuthorizationCodeRequest {
    /**
     * The OAuth authorization code received from Shopify\'s OAuth callback
     * @type {string}
     * @memberof ShopifypbSaveShopifyCredentialsFromAuthorizationCodeRequest
     */
    'authorization_code'?: string;
    /**
     * The Shopify store ID (e.g., \"mystore\" from \"mystore.myshopify.com\")
     * @type {string}
     * @memberof ShopifypbSaveShopifyCredentialsFromAuthorizationCodeRequest
     */
    'store_id'?: string;
}
/**
 * SaveShopifyCredentialsFromAuthorizationCodeResponse is the response after saving credentials
 * @export
 * @interface ShopifypbSaveShopifyCredentialsFromAuthorizationCodeResponse
 */
export interface ShopifypbSaveShopifyCredentialsFromAuthorizationCodeResponse {
    /**
     * The ecommerce ID where the credentials were saved
     * @type {string}
     * @memberof ShopifypbSaveShopifyCredentialsFromAuthorizationCodeResponse
     */
    'ecommerce_id'?: string;
}
/**
 * ApplyBannerChangesRequest applies pipeline decisions to the live banner table.
 * @export
 * @interface SizesuggestionspbApplyBannerChangesRequest
 */
export interface SizesuggestionspbApplyBannerChangesRequest {
    /**
     * Banners to activate (insert-if-absent).
     * @type {Array<SizesuggestionspbBannerActivation>}
     * @memberof SizesuggestionspbApplyBannerChangesRequest
     */
    'activations'?: Array<SizesuggestionspbBannerActivation>;
    /**
     * Banners to deactivate.
     * @type {Array<SizesuggestionspbBannerDeactivation>}
     * @memberof SizesuggestionspbApplyBannerChangesRequest
     */
    'deactivations'?: Array<SizesuggestionspbBannerDeactivation>;
    /**
     * Store to apply the changes to.
     * @type {string}
     * @memberof SizesuggestionspbApplyBannerChangesRequest
     */
    'store_id'?: string;
}
/**
 * ApplyBannerChangesResponse reports the rows actually touched.
 * @export
 * @interface SizesuggestionspbApplyBannerChangesResponse
 */
export interface SizesuggestionspbApplyBannerChangesResponse {
    /**
     * Banner rows actually inserted.
     * @type {string}
     * @memberof SizesuggestionspbApplyBannerChangesResponse
     */
    'activated'?: string;
    /**
     * Banner rows actually retired.
     * @type {string}
     * @memberof SizesuggestionspbApplyBannerChangesResponse
     */
    'deactivated'?: string;
}
/**
 * BannerActivation describes one banner to insert into wrongly_sized_products.
 * @export
 * @interface SizesuggestionspbBannerActivation
 */
export interface SizesuggestionspbBannerActivation {
    /**
     * Country (\"WW\" = worldwide).
     * @type {string}
     * @memberof SizesuggestionspbBannerActivation
     */
    'country'?: string;
    /**
     * Platform product id to activate the banner for.
     * @type {string}
     * @memberof SizesuggestionspbBannerActivation
     */
    'product_id'?: string;
    /**
     * Product too-big sizing return rate backing the banner.
     * @type {number}
     * @memberof SizesuggestionspbBannerActivation
     */
    'return_rate_too_big_prod'?: number;
    /**
     * Store-level too-big sizing return rate at activation time.
     * @type {number}
     * @memberof SizesuggestionspbBannerActivation
     */
    'return_rate_too_big_store'?: number;
    /**
     * Product too-small sizing return rate backing the banner.
     * @type {number}
     * @memberof SizesuggestionspbBannerActivation
     */
    'return_rate_too_small_prod'?: number;
    /**
     * Store-level too-small sizing return rate at activation time.
     * @type {number}
     * @memberof SizesuggestionspbBannerActivation
     */
    'return_rate_too_small_store'?: number;
    /**
     * Estimated yearly savings in returns (EUR).
     * @type {number}
     * @memberof SizesuggestionspbBannerActivation
     */
    'savings_in_returns'?: number;
    /**
     * Banner direction, in the v1 table vocabulary.
     * @type {string}
     * @memberof SizesuggestionspbBannerActivation
     */
    'size_problem'?: string;
}
/**
 * BannerDeactivation describes one live banner to retire.
 * @export
 * @interface SizesuggestionspbBannerDeactivation
 */
export interface SizesuggestionspbBannerDeactivation {
    /**
     * Country of the live banner row.
     * @type {string}
     * @memberof SizesuggestionspbBannerDeactivation
     */
    'country'?: string;
    /**
     * Platform product id whose banner to retire.
     * @type {string}
     * @memberof SizesuggestionspbBannerDeactivation
     */
    'product_id'?: string;
}
/**
 * A classified return comment (permanent cache row, never re-classified).
 * @export
 * @interface SizesuggestionspbCommentClassification
 */
export interface SizesuggestionspbCommentClassification {
    /**
     * Classifier confidence in [0, 1].
     * @type {number}
     * @memberof SizesuggestionspbCommentClassification
     */
    'confidence'?: number;
    /**
     * Platform product id of the returned item.
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'product_id'?: string;
    /**
     * Version (hash) of the classification prompt used — audit metadata.
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'prompt_version'?: string;
    /**
     * Literal supporting quote from the comment (\"\" when signal is NONE).
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'quote'?: string;
    /**
     * Return reason tag the shopper selected at return time.
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'return_reason'?: string;
    /**
     * REVER returned-item line id — the cache key, one row per comment.
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'rever_id'?: string;
    /**
     * Directional sizing signal in the comment: TOO_SMALL, TOO_BIG, OTHER or NONE.
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'sizing_signal'?: string;
    /**
     * Store the comment belongs to.
     * @type {string}
     * @memberof SizesuggestionspbCommentClassification
     */
    'store_id'?: string;
}
/**
 * GetCommentClassificationsRequest asks for the cached rows of a set of stores.
 * @export
 * @interface SizesuggestionspbGetCommentClassificationsRequest
 */
export interface SizesuggestionspbGetCommentClassificationsRequest {
    /**
     * Stores whose cached classifications to fetch.
     * @type {Array<string>}
     * @memberof SizesuggestionspbGetCommentClassificationsRequest
     */
    'store_ids'?: Array<string>;
}
/**
 * GetCommentClassificationsResponse returns the cached classification rows.
 * @export
 * @interface SizesuggestionspbGetCommentClassificationsResponse
 */
export interface SizesuggestionspbGetCommentClassificationsResponse {
    /**
     * Cached classification rows for the requested stores.
     * @type {Array<SizesuggestionspbCommentClassification>}
     * @memberof SizesuggestionspbGetCommentClassificationsResponse
     */
    'classifications'?: Array<SizesuggestionspbCommentClassification>;
}
/**
 * GetGroupingRuleRequest asks for a store\'s validated model-grouping rule.
 * @export
 * @interface SizesuggestionspbGetGroupingRuleRequest
 */
export interface SizesuggestionspbGetGroupingRuleRequest {
    /**
     * Store whose grouping rule to fetch.
     * @type {string}
     * @memberof SizesuggestionspbGetGroupingRuleRequest
     */
    'store_id'?: string;
}
/**
 * GetGroupingRuleResponse returns the stored rule, if any.
 * @export
 * @interface SizesuggestionspbGetGroupingRuleResponse
 */
export interface SizesuggestionspbGetGroupingRuleResponse {
    /**
     * Measured accuracy of the rule at validation time.
     * @type {number}
     * @memberof SizesuggestionspbGetGroupingRuleResponse
     */
    'accuracy'?: number;
    /**
     * JSON descriptor of the validated grouping rule; \"\" when none stored.
     * @type {string}
     * @memberof SizesuggestionspbGetGroupingRuleResponse
     */
    'rule_json'?: string;
    /**
     * When the rule was validated (RFC3339).
     * @type {string}
     * @memberof SizesuggestionspbGetGroupingRuleResponse
     */
    'validated_at'?: string;
}
/**
 * GetRetiredBannerResultsRequest asks for the frozen rows of a set of stores.
 * @export
 * @interface SizesuggestionspbGetRetiredBannerResultsRequest
 */
export interface SizesuggestionspbGetRetiredBannerResultsRequest {
    /**
     * Stores whose retired-banner results to fetch.
     * @type {Array<string>}
     * @memberof SizesuggestionspbGetRetiredBannerResultsRequest
     */
    'store_ids'?: Array<string>;
}
/**
 * GetRetiredBannerResultsResponse returns the frozen rows.
 * @export
 * @interface SizesuggestionspbGetRetiredBannerResultsResponse
 */
export interface SizesuggestionspbGetRetiredBannerResultsResponse {
    /**
     * Frozen retired-banner measurement rows.
     * @type {Array<SizesuggestionspbRetiredBannerResult>}
     * @memberof SizesuggestionspbGetRetiredBannerResultsResponse
     */
    'results'?: Array<SizesuggestionspbRetiredBannerResult>;
}
/**
 * GetSizingCycleResponse is the \"Novedades del mes\" tab payload.
 * @export
 * @interface SizesuggestionspbGetSizingCycleResponse
 */
export interface SizesuggestionspbGetSizingCycleResponse {
    /**
     * Whether the cycle applied banner changes.
     * @type {boolean}
     * @memberof SizesuggestionspbGetSizingCycleResponse
     */
    'actuated'?: boolean;
    /**
     * Cycle date, YYYY-MM-DD; \"\" when no cycle is persisted yet.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingCycleResponse
     */
    'cycle_date'?: string;
    /**
     * Changelog entries of the cycle.
     * @type {Array<SizesuggestionspbSizingCycleEventView>}
     * @memberof SizesuggestionspbGetSizingCycleResponse
     */
    'events'?: Array<SizesuggestionspbSizingCycleEventView>;
    /**
     * Merchant monthly report, markdown (\"\" when not generated).
     * @type {string}
     * @memberof SizesuggestionspbGetSizingCycleResponse
     */
    'report_md'?: string;
    /**
     * The cycle\'s model measurements, both directions pre-oriented.
     * @type {Array<SizesuggestionspbSizingModelResult>}
     * @memberof SizesuggestionspbGetSizingCycleResponse
     */
    'results'?: Array<SizesuggestionspbSizingModelResult>;
}
/**
 * GetSizingModelResponse is the model detail: both directions always together.
 * @export
 * @interface SizesuggestionspbGetSizingModelResponse
 */
export interface SizesuggestionspbGetSizingModelResponse {
    /**
     * Real activation date (banner_date carries the retirement cycle on retired models).
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'banner_active_from'?: string;
    /**
     * Date the banner went live, YYYY-MM-DD.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'banner_date'?: string;
    /**
     * Internal taxonomy category (\"\" when unclassified).
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'category'?: string;
    /**
     * The model\'s colorways.
     * @type {Array<SizesuggestionspbSizingColorway>}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'colorways'?: Array<SizesuggestionspbSizingColorway>;
    /**
     * Country of the banner (\"WW\" = worldwide).
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'country'?: string;
    /**
     * Cycle the measurement belongs to, YYYY-MM-DD.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'cycle_date'?: string;
    /**
     * Rate change in the opposite direction, as a fraction (positive = leak).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'leak_pp'?: number;
    /**
     * Rate change in the banner\'s direction, as a fraction (negative = improvement).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'lift_pp'?: number;
    /**
     * Model key.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'model_key'?: string;
    /**
     * Human-readable model name.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'model_name'?: string;
    /**
     * The opposite direction, before/after.
     * @type {SizesuggestionspbSizingDirectionMeasurement}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'opposite_direction'?: SizesuggestionspbSizingDirectionMeasurement;
    /**
     * COLLECTING_DATA progress: days since the banner went live.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'progress_days'?: number;
    /**
     * Days needed before the model can be measured.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'progress_days_target'?: number;
    /**
     * COLLECTING_DATA progress: units sold since the banner went live.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'progress_units'?: number;
    /**
     * Units needed before the model can be measured.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'progress_units_target'?: number;
    /**
     * Anonymized customer quotes matching the banner\'s direction.
     * @type {Array<string>}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'quotes'?: Array<string>;
    /**
     * Real EUR saved so far: the measured window\'s savings, not annualized  (absent when not measurable).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'saved_eur_to_date'?: number;
    /**
     * Banner direction: TOO_SMALL or TOO_BIG.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'size_problem'?: string;
    /**
     * Business status.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'status'?: string;
    /**
     * The banner\'s own direction, before/after.
     * @type {SizesuggestionspbSizingDirectionMeasurement}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'target_direction'?: SizesuggestionspbSizingDirectionMeasurement;
    /**
     * Units sold in the AFTER window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'units_after'?: number;
    /**
     * Units sold in the BEFORE window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingModelResponse
     */
    'units_before'?: number;
}
/**
 * GetSizingOverviewResponse is the \"Resumen\" tab payload.
 * @export
 * @interface SizesuggestionspbGetSizingOverviewResponse
 */
export interface SizesuggestionspbGetSizingOverviewResponse {
    /**
     * Measured EUR saved per month (saved EUR per year / 12).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'avoided_eur_month'?: number;
    /**
     * Measured returns avoided per month (saved units per year / 12).
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'avoided_returns_month'?: number;
    /**
     * Cycle the numbers belong to (YYYY-MM-DD); \"\" when no cycle is persisted yet.
     * @type {string}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'cycle_date'?: string;
    /**
     * Models with a live banner this cycle.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'models_with_banner'?: number;
    /**
     * Models whose banner went live within the cycle\'s month.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'new_models_this_cycle'?: number;
    /**
     * Products (colorways) covered by those banners.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'products_with_banner'?: number;
    /**
     * Of which, saved in the last 90 measured days.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'saved_eur_last_3m'?: number;
    /**
     * Hero: real EUR saved so far, summed over the measured models plus the  accumulated total of the retired ones. Not annualized.
     * @type {number}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'saved_eur_to_date'?: number;
    /**
     * Model counts per business status.
     * @type {SizesuggestionspbSizingStatusCounts}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'status_counts'?: SizesuggestionspbSizingStatusCounts;
    /**
     * Store sizing-return series by month of purchase (up to 24 months).
     * @type {Array<SizesuggestionspbSizingTrendPoint>}
     * @memberof SizesuggestionspbGetSizingOverviewResponse
     */
    'trend'?: Array<SizesuggestionspbSizingTrendPoint>;
}
/**
 * GetThresholdLedgerRequest asks for a brand\'s threshold ledger.
 * @export
 * @interface SizesuggestionspbGetThresholdLedgerRequest
 */
export interface SizesuggestionspbGetThresholdLedgerRequest {
    /**
     * Brand (ecommerce group) whose ledger to fetch.
     * @type {string}
     * @memberof SizesuggestionspbGetThresholdLedgerRequest
     */
    'ecommerce_group'?: string;
}
/**
 * GetThresholdLedgerResponse returns the stored ledger, if any.
 * @export
 * @interface SizesuggestionspbGetThresholdLedgerResponse
 */
export interface SizesuggestionspbGetThresholdLedgerResponse {
    /**
     * JSON array of ledger hypotheses; \"\" when the group has no ledger yet.
     * @type {string}
     * @memberof SizesuggestionspbGetThresholdLedgerResponse
     */
    'hypotheses_json'?: string;
    /**
     * Run that last updated the ledger.
     * @type {string}
     * @memberof SizesuggestionspbGetThresholdLedgerResponse
     */
    'run_id'?: string;
}
/**
 * ListSizingCyclesResponse returns the persisted cycles, newest first.
 * @export
 * @interface SizesuggestionspbListSizingCyclesResponse
 */
export interface SizesuggestionspbListSizingCyclesResponse {
    /**
     * Persisted cycles, newest first.
     * @type {Array<SizesuggestionspbSizingCycleSummary>}
     * @memberof SizesuggestionspbListSizingCyclesResponse
     */
    'cycles'?: Array<SizesuggestionspbSizingCycleSummary>;
}
/**
 * ListSizingModelsResponse returns the model rows of a cycle.
 * @export
 * @interface SizesuggestionspbListSizingModelsResponse
 */
export interface SizesuggestionspbListSizingModelsResponse {
    /**
     * Cycle the rows belong to (YYYY-MM-DD); \"\" when no cycle is persisted yet.
     * @type {string}
     * @memberof SizesuggestionspbListSizingModelsResponse
     */
    'cycle_date'?: string;
    /**
     * Model rows, live banners first.
     * @type {Array<SizesuggestionspbSizingModelListItem>}
     * @memberof SizesuggestionspbListSizingModelsResponse
     */
    'models'?: Array<SizesuggestionspbSizingModelListItem>;
}
/**
 * Payload for the GetProductSizeBanner request.
 * @export
 * @interface SizesuggestionspbProductSizeBannerRequest
 */
export interface SizesuggestionspbProductSizeBannerRequest {
    /**
     * Shipping destination country, ISO-3166 alpha-2 uppercase (e.g. \"ES\").  Empty is treated as \"WW\" (no country-specific data).
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'country'?: string;
    /**
     * How the widget is configured to render the answer (text notice or fit  indicator bar). Optional; recorded on the impression.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'display'?: SizesuggestionspbProductSizeBannerRequestDisplayEnum;
    /**
     * Logged-in shopper\'s email, taken from liquid\'s `customer` object when  present. Optional; recorded on the impression.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'email'?: string;
    /**
     * Storefront language as a 2-letter code (e.g. \"es\"). Unknown or empty falls  back to English.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'language'?: string;
    /**
     * Platform product id of the product page being viewed. Required.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'product_id'?: string;
    /**
     * Which integration is calling.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'source'?: SizesuggestionspbProductSizeBannerRequestSourceEnum;
    /**
     * Shopify shop prefix of the storefront asking (e.g. \"reverwfpdemo\"). Required.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'store_id'?: string;
    /**
     * Stable per-device visitor identifier, minted by the widget and kept in  localStorage (falling back to Shopify\'s `_shopify_y`). Required: it is what  the A/B bucket is derived from, so the same shopper always gets the same  answer. No IP lookup is involved.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerRequest
     */
    'visitor_id'?: string;
}

export const SizesuggestionspbProductSizeBannerRequestDisplayEnum = {
    Unspecified: 'SIZE_BANNER_DISPLAY_UNSPECIFIED',
    Notice: 'SIZE_BANNER_DISPLAY_NOTICE',
    FitBar: 'SIZE_BANNER_DISPLAY_FIT_BAR'
} as const;

export type SizesuggestionspbProductSizeBannerRequestDisplayEnum = typeof SizesuggestionspbProductSizeBannerRequestDisplayEnum[keyof typeof SizesuggestionspbProductSizeBannerRequestDisplayEnum];
export const SizesuggestionspbProductSizeBannerRequestSourceEnum = {
    Unspecified: 'SIZE_BANNER_SOURCE_UNSPECIFIED',
    Snippet: 'SIZE_BANNER_SOURCE_SNIPPET',
    App: 'SIZE_BANNER_SOURCE_APP'
} as const;

export type SizesuggestionspbProductSizeBannerRequestSourceEnum = typeof SizesuggestionspbProductSizeBannerRequestSourceEnum[keyof typeof SizesuggestionspbProductSizeBannerRequestSourceEnum];

/**
 * Payload for the GetProductSizeBanner response.
 * @export
 * @interface SizesuggestionspbProductSizeBannerResponse
 */
export interface SizesuggestionspbProductSizeBannerResponse {
    /**
     * A/B group this visitor was assigned to, decided server-side from  visitor_id and the merchant\'s traffic_allocation. Always set, including for  the holdout, so the widget can tag the cart for outcome measurement.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerResponse
     */
    'ab_group'?: string;
    /**
     * Copy to render. Absent when show_banner is false.
     * @type {SizesuggestionspbSizeBannerCopy}
     * @memberof SizesuggestionspbProductSizeBannerResponse
     */
    'copy'?: SizesuggestionspbSizeBannerCopy;
    /**
     * Whether the widget should render a banner. False when Size Suggestions is  disabled for the merchant, when the product has no live banner, or when the  visitor fell into the holdout group.
     * @type {boolean}
     * @memberof SizesuggestionspbProductSizeBannerResponse
     */
    'show_banner'?: boolean;
    /**
     * Direction of the sizing problem. UNSPECIFIED when show_banner is false.
     * @type {string}
     * @memberof SizesuggestionspbProductSizeBannerResponse
     */
    'size_problem'?: SizesuggestionspbProductSizeBannerResponseSizeProblemEnum;
}

export const SizesuggestionspbProductSizeBannerResponseSizeProblemEnum = {
    Unspecified: 'SIZE_PROBLEM_UNSPECIFIED',
    TooSmall: 'SIZE_PROBLEM_TOO_SMALL',
    TooBig: 'SIZE_PROBLEM_TOO_BIG'
} as const;

export type SizesuggestionspbProductSizeBannerResponseSizeProblemEnum = typeof SizesuggestionspbProductSizeBannerResponseSizeProblemEnum[keyof typeof SizesuggestionspbProductSizeBannerResponseSizeProblemEnum];

/**
 * Payload for the ProductSizeSugestionRequest request
 * @export
 * @interface SizesuggestionspbProductSizeSuggestionRequest
 */
export interface SizesuggestionspbProductSizeSuggestionRequest {
    /**
     * Country code for the shopper shipping destination, ISO-3166 alpha-2 uppercase (e.g.  \"ES\", \"DE\"). Special value: \"WW\" means worldwide / no country-specific data. If  empty, the backend will treat it as \"WW\".
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'country'?: string;
    /**
     * Email (optional, for banner impression tracking)
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'email'?: string;
    /**
     * IP address (for banner impression tracking)
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'ip_address'?: string;
    /**
     * Language
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'language'?: string;
    /**
     * Product ID
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'product_id'?: string;
    /**
     * A/B test group identifier (e.g. \"control\", \"treatment\"; banner not shown for  \"control\")
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'rever_ab_group'?: string;
    /**
     * Rever visitor identifier (for banner impression tracking)
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'rever_visitor_id'?: string;
    /**
     * Store ID
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionRequest
     */
    'store_id'?: string;
}
/**
 * Payload for the ProductSizeSuggestionResponse response
 * @export
 * @interface SizesuggestionspbProductSizeSuggestionResponse
 */
export interface SizesuggestionspbProductSizeSuggestionResponse {
    /**
     * Product ID
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionResponse
     */
    'product_id'?: string;
    /**
     * Store ID
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionResponse
     */
    'store_id'?: string;
    /**
     * Suggestion
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionResponse
     */
    'suggestion'?: string;
    /**
     * Suggestion copy
     * @type {string}
     * @memberof SizesuggestionspbProductSizeSuggestionResponse
     */
    'suggestion_copy'?: string;
}
/**
 * RetiredBannerResult is the frozen final measurement of a banner whose  product left the catalog.
 * @export
 * @interface SizesuggestionspbRetiredBannerResult
 */
export interface SizesuggestionspbRetiredBannerResult {
    /**
     * Average unit price of the frozen window, in cents. The savings are derived  from the counts above and this, never stored on their own.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'avg_unit_price_cents'?: number;
    /**
     * Date the banner went live (YYYY-MM-DD).
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'banner_date'?: string;
    /**
     * Final measured classification (SUCCESS, NEUTRAL, OVERCORRECT, UNRESOLVED,  INELIGIBLE).
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'classification'?: string;
    /**
     * Country of the banner (\"WW\" = worldwide).
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'country'?: string;
    /**
     * Days the measured window covered (banner_date + days_after = window end).
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'days_after'?: number;
    /**
     * Raw opposite-direction worsening in fraction points.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'leak_pp'?: number;
    /**
     * Raw return-rate change of the targeted direction in fraction points.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'lift_pp'?: number;
    /**
     * Model key the product belonged to (\"\" when unknown).
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'model_key'?: string;
    /**
     * Platform product id (no longer in the catalog).
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'product_id'?: string;
    /**
     * Same for the opposite direction.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'rate_o_before'?: number;
    /**
     * Counterfactual BEFORE rates (fractions) the frozen savings were billed  against. Without them a retirement can only show ratio/lift_pp, which are  the raw targeted-direction move and can disagree with its own euros.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'rate_t_before'?: number;
    /**
     * rr_after / rr_before of the targeted direction (unset when not measurable).
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'ratio'?: number;
    /**
     * Returns in the opposite direction over the same window.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'ret_o_after'?: number;
    /**
     * Returns in the banner\'s direction over the frozen AFTER window.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'ret_t_after'?: number;
    /**
     * When the retirement was first detected (RFC3339; set by the server).
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'retired_at'?: string;
    /**
     * Run that froze the measurement.
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'run_id'?: string;
    /**
     * Real EUR saved over the banner\'s whole active life, frozen at retirement.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'saved_eur_to_date'?: number;
    /**
     * Net EUR saved per year at retirement time.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'saved_eur_yr'?: number;
    /**
     * Net returns saved per year at retirement time.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'saved_units_yr'?: number;
    /**
     * Banner direction: TOO_SMALL or TOO_BIG.
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'size_problem'?: string;
    /**
     * Store the banner belonged to.
     * @type {string}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'store_id'?: string;
    /**
     * Units sold under the banner (exposed population when the store measures by  exposure). Retired models with zero never made a sale with the notice.
     * @type {number}
     * @memberof SizesuggestionspbRetiredBannerResult
     */
    'units_after'?: number;
}
/**
 * SaveGroupingRuleRequest stores a store\'s validated model-grouping rule.
 * @export
 * @interface SizesuggestionspbSaveGroupingRuleRequest
 */
export interface SizesuggestionspbSaveGroupingRuleRequest {
    /**
     * Measured accuracy of the rule at validation time.
     * @type {number}
     * @memberof SizesuggestionspbSaveGroupingRuleRequest
     */
    'accuracy'?: number;
    /**
     * JSON descriptor of the grouping rule.
     * @type {string}
     * @memberof SizesuggestionspbSaveGroupingRuleRequest
     */
    'rule_json'?: string;
    /**
     * Store the rule belongs to.
     * @type {string}
     * @memberof SizesuggestionspbSaveGroupingRuleRequest
     */
    'store_id'?: string;
}
/**
 * SaveGroupingRuleResponse acknowledges the write.
 * @export
 * @interface SizesuggestionspbSaveGroupingRuleResponse
 */
export interface SizesuggestionspbSaveGroupingRuleResponse {
    /**
     * Status of the operation.
     * @type {string}
     * @memberof SizesuggestionspbSaveGroupingRuleResponse
     */
    'status'?: string;
}
/**
 * SaveThresholdLedgerRequest replaces a brand\'s threshold ledger.
 * @export
 * @interface SizesuggestionspbSaveThresholdLedgerRequest
 */
export interface SizesuggestionspbSaveThresholdLedgerRequest {
    /**
     * Brand (ecommerce group) whose ledger to replace.
     * @type {string}
     * @memberof SizesuggestionspbSaveThresholdLedgerRequest
     */
    'ecommerce_group'?: string;
    /**
     * JSON array with the full set of ledger hypotheses.
     * @type {string}
     * @memberof SizesuggestionspbSaveThresholdLedgerRequest
     */
    'hypotheses_json'?: string;
    /**
     * Run performing the update.
     * @type {string}
     * @memberof SizesuggestionspbSaveThresholdLedgerRequest
     */
    'run_id'?: string;
}
/**
 * SaveThresholdLedgerResponse acknowledges the write.
 * @export
 * @interface SizesuggestionspbSaveThresholdLedgerResponse
 */
export interface SizesuggestionspbSaveThresholdLedgerResponse {
    /**
     * Status of the operation.
     * @type {string}
     * @memberof SizesuggestionspbSaveThresholdLedgerResponse
     */
    'status'?: string;
}
/**
 * Fixed banner copy, as plain text in the storefront language. The widget owns  the markup (D3), so nothing here is HTML: `recommendation` is the part meant  to be emphasized, and the attribution parts bracket the REVER logo.
 * @export
 * @interface SizesuggestionspbSizeBannerCopy
 */
export interface SizesuggestionspbSizeBannerCopy {
    /**
     * Text placed before the REVER logo, e.g. \"Based on previous orders,\".
     * @type {string}
     * @memberof SizesuggestionspbSizeBannerCopy
     */
    'attribution_prefix'?: string;
    /**
     * Text placed after the REVER logo, e.g. \"suggests:\".
     * @type {string}
     * @memberof SizesuggestionspbSizeBannerCopy
     */
    'attribution_suffix'?: string;
    /**
     * Lead-in to the advice, e.g. \"When in doubt,\".
     * @type {string}
     * @memberof SizesuggestionspbSizeBannerCopy
     */
    'lead_in'?: string;
    /**
     * The finding, e.g. \"This item sizes smaller than usual.\".
     * @type {string}
     * @memberof SizesuggestionspbSizeBannerCopy
     */
    'message'?: string;
    /**
     * The advice itself, rendered emphasized, e.g. \"we recommend choosing a  larger size.\".
     * @type {string}
     * @memberof SizesuggestionspbSizeBannerCopy
     */
    'recommendation'?: string;
}
/**
 * SizingColorway is one product of the model.
 * @export
 * @interface SizesuggestionspbSizingColorway
 */
export interface SizesuggestionspbSizingColorway {
    /**
     * Product image (\"\" when unknown).
     * @type {string}
     * @memberof SizesuggestionspbSizingColorway
     */
    'image_url'?: string;
    /**
     * Product display name.
     * @type {string}
     * @memberof SizesuggestionspbSizingColorway
     */
    'name'?: string;
    /**
     * Platform product id.
     * @type {string}
     * @memberof SizesuggestionspbSizingColorway
     */
    'product_id'?: string;
    /**
     * Units sold across the measured windows.
     * @type {number}
     * @memberof SizesuggestionspbSizingColorway
     */
    'units'?: number;
}
/**
 * SizingCycle identifies one store\'s pipeline cycle and carries its report.
 * @export
 * @interface SizesuggestionspbSizingCycle
 */
export interface SizesuggestionspbSizingCycle {
    /**
     * Whether this cycle\'s decisions were applied to the live banner table.
     * @type {boolean}
     * @memberof SizesuggestionspbSizingCycle
     */
    'actuated'?: boolean;
    /**
     * Measured EUR saved per month.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'avoided_eur_month'?: number;
    /**
     * Measured returns avoided per month.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'avoided_returns_month'?: number;
    /**
     * Cycle date (the run\'s asOf), YYYY-MM-DD. Upsert key with store_id.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycle
     */
    'cycle_date'?: string;
    /**
     * Models with a live banner this cycle.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'models_with_banner'?: number;
    /**
     * Models whose banner went live in this cycle.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'new_models_this_cycle'?: number;
    /**
     * Products (colorways) covered by those banners.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'products_with_banner'?: number;
    /**
     * Merchant-facing monthly report, markdown (\"\" when not generated).
     * @type {string}
     * @memberof SizesuggestionspbSizingCycle
     */
    'report_md'?: string;
    /**
     * Real EUR saved in the last 90 measured days (pro-rata of each banner\'s window).
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'saved_eur_last_3m'?: number;
    /**
     * Real EUR saved so far across every banner of the store. Not annualized.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'saved_eur_to_date'?: number;
    /**
     * Models with status COLLECTING_DATA.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'status_collecting_data'?: number;
    /**
     * Models with status NO_CLEAR_EFFECT.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'status_no_clear_effect'?: number;
    /**
     * Models with status REDIAGNOSIS.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'status_rediagnosis'?: number;
    /**
     * Models with status RETIRED.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'status_retired'?: number;
    /**
     * Models with status WORKING.
     * @type {number}
     * @memberof SizesuggestionspbSizingCycle
     */
    'status_working'?: number;
    /**
     * Store the cycle belongs to.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycle
     */
    'store_id'?: string;
}
/**
 * SizingCycleEvent is one changelog entry of a cycle.
 * @export
 * @interface SizesuggestionspbSizingCycleEvent
 */
export interface SizesuggestionspbSizingCycleEvent {
    /**
     * Countries the event applies to (empty = WW).
     * @type {Array<string>}
     * @memberof SizesuggestionspbSizingCycleEvent
     */
    'countries'?: Array<string>;
    /**
     * Event type: ACTIVATED, RETIRED, REDIAGNOSIS or WATCH.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEvent
     */
    'event_type'?: string;
    /**
     * Structured evidence for localized merchant copy, JSON object  (e.g. {excess_pp, units_12m, comment_count, category, colorway_count}).
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEvent
     */
    'evidence_json'?: string;
    /**
     * Model key the event is about.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEvent
     */
    'model_key'?: string;
    /**
     * Human-readable model name at event time.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEvent
     */
    'model_name'?: string;
    /**
     * Banner direction the event refers to (\"\" when not applicable).
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEvent
     */
    'size_problem'?: string;
}
/**
 * SizingCycleEventView is one \"Novedades del mes\" entry.
 * @export
 * @interface SizesuggestionspbSizingCycleEventView
 */
export interface SizesuggestionspbSizingCycleEventView {
    /**
     * Countries the event applies to (empty = WW).
     * @type {Array<string>}
     * @memberof SizesuggestionspbSizingCycleEventView
     */
    'countries'?: Array<string>;
    /**
     * Event type: ACTIVATED, RETIRED, REDIAGNOSIS or WATCH.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEventView
     */
    'event_type'?: string;
    /**
     * Structured evidence for localized copy, JSON object (\"\" when absent).  Rates inside are FRACTIONS.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEventView
     */
    'evidence_json'?: string;
    /**
     * Model key the event is about.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEventView
     */
    'model_key'?: string;
    /**
     * Human-readable model name at event time.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEventView
     */
    'model_name'?: string;
    /**
     * Banner direction the event refers to (\"\" when not applicable).
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleEventView
     */
    'size_problem'?: string;
}
/**
 * SizingCycleSummary is one selectable cycle.
 * @export
 * @interface SizesuggestionspbSizingCycleSummary
 */
export interface SizesuggestionspbSizingCycleSummary {
    /**
     * Whether the cycle applied banner changes.
     * @type {boolean}
     * @memberof SizesuggestionspbSizingCycleSummary
     */
    'actuated'?: boolean;
    /**
     * Cycle date, YYYY-MM-DD.
     * @type {string}
     * @memberof SizesuggestionspbSizingCycleSummary
     */
    'cycle_date'?: string;
}
/**
 * SizingDirectionMeasurement is one direction\'s before/after counts.
 * @export
 * @interface SizesuggestionspbSizingDirectionMeasurement
 */
export interface SizesuggestionspbSizingDirectionMeasurement {
    /**
     * BEFORE rate (fraction) the savings are billed against: ret_before is this  rate rounded onto units_before, and only the rate adds up to the euros.
     * @type {number}
     * @memberof SizesuggestionspbSizingDirectionMeasurement
     */
    'rate_before'?: number;
    /**
     * Returns in this direction, AFTER window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingDirectionMeasurement
     */
    'ret_after'?: number;
    /**
     * Returns in this direction, BEFORE window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingDirectionMeasurement
     */
    'ret_before'?: number;
}
/**
 * SizingModelListItem is one row of the \"Modelos\" tab.
 * @export
 * @interface SizesuggestionspbSizingModelListItem
 */
export interface SizesuggestionspbSizingModelListItem {
    /**
     * First day the banner was live, YYYY-MM-DD (absent when unknown).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'banner_active_from'?: string;
    /**
     * Date the banner went live, YYYY-MM-DD (\"\" for retired rows without one).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'banner_date'?: string;
    /**
     * True when the model left the store catalog, as opposed to a banner REVER  deactivated. Only meaningful on RETIRED rows.
     * @type {boolean}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'catalog_retired'?: boolean;
    /**
     * Internal taxonomy category (\"\" when unclassified).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'category'?: string;
    /**
     * Measurement verdict (SUCCESS, NEUTRAL, ...). A NEUTRAL retirement reads  \"no measurable change\" instead of a raw rate move the verdict called noise.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'classification'?: string;
    /**
     * Number of colorways the banner covers.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'colorway_count'?: number;
    /**
     * Country of the banner (\"WW\" = worldwide).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'country'?: string;
    /**
     * Representative product image (\"\" when unknown).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'image_url'?: string;
    /**
     * True when the banner was activated in this cycle.
     * @type {boolean}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'is_new'?: boolean;
    /**
     * Measured rate change in percentage points (after - before), same window.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'lift_pp'?: number;
    /**
     * Model key (stable id; the detail route parameter).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'model_key'?: string;
    /**
     * Human-readable model name.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'model_name'?: string;
    /**
     * COLLECTING_DATA progress: days since the banner went live.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'progress_days'?: number;
    /**
     * Days needed before the model can be measured.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'progress_days_target'?: number;
    /**
     * COLLECTING_DATA progress: units sold since the banner went live.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'progress_units'?: number;
    /**
     * Units needed before the model can be measured.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'progress_units_target'?: number;
    /**
     * Sizing-return rate (fraction, both directions) the savings are billed  against. ret_total_before is the same figure rounded onto units_before, so  only this one makes the displayed % reconcile with the euros.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'rate_total_before'?: number;
    /**
     * Measured rate ratio (after/before) of the banner\'s own direction. Lets a  frozen retirement show its change when the underlying counts are gone.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'ratio'?: number;
    /**
     * Sizing returns (both directions) in the AFTER window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'ret_total_after'?: number;
    /**
     * Sizing returns (both directions) in the BEFORE window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'ret_total_before'?: number;
    /**
     * Real EUR saved so far: the measured window\'s savings, not annualized  (absent when not measurable). On RETIRED rows it is the accumulated total.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'saved_eur_to_date'?: number;
    /**
     * Banner direction: TOO_SMALL or TOO_BIG.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'size_problem'?: string;
    /**
     * Business status: WORKING, COLLECTING_DATA, NO_CLEAR_EFFECT, REDIAGNOSIS or RETIRED.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'status'?: string;
    /**
     * Units sold in the AFTER window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'units_after'?: number;
    /**
     * Units sold in the BEFORE window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelListItem
     */
    'units_before'?: number;
}
/**
 * SizingModelResult is one row of a cycle\'s model list: a measurement when the  model was measurable, otherwise the display state of a freshly activated or  retired banner. Directions are pre-oriented: t = the banner\'s own direction,  o = the opposite one.
 * @export
 * @interface SizesuggestionspbSizingModelResult
 */
export interface SizesuggestionspbSizingModelResult {
    /**
     * First day the banner was live, YYYY-MM-DD (\"\" when unknown).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'banner_active_from'?: string;
    /**
     * Date the banner went live, YYYY-MM-DD.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'banner_date'?: string;
    /**
     * Whether the model left the store catalog (only meaningful when RETIRED).
     * @type {boolean}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'catalog_retired'?: boolean;
    /**
     * Internal taxonomy category of the model (\"\" when unclassified).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'category'?: string;
    /**
     * Pipeline classification: SUCCESS, NEUTRAL, UNRESOLVED, OVERCORRECT or INELIGIBLE.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'classification'?: string;
    /**
     * JSON array of the model\'s colorways: [{product_id, name, units, image_url}].
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'colorways_json'?: string;
    /**
     * Country of the banner (\"WW\" = worldwide).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'country'?: string;
    /**
     * Days of effective AFTER window (visibility-clamped).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'days_after'?: number;
    /**
     * Whether the measurement gate (>=20 units and >=30 days) was met.
     * @type {boolean}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'eligible'?: boolean;
    /**
     * Representative product image of the model (\"\" when unknown).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'image_url'?: string;
    /**
     * Whether the banner was activated in this cycle.
     * @type {boolean}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'is_new'?: boolean;
    /**
     * Rate change in the opposite direction, as a fraction (positive = leak).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'leak_pp'?: number;
    /**
     * Rate change in the banner\'s direction, as a fraction (negative = improvement).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'lift_pp'?: number;
    /**
     * Model key (colorway group) the measurement is for.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'model_key'?: string;
    /**
     * Human-readable model name.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'model_name'?: string;
    /**
     * COLLECTING_DATA progress: days since the banner went live.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'progress_days'?: number;
    /**
     * COLLECTING_DATA progress: units sold since the banner went live.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'progress_units'?: number;
    /**
     * Same for the opposite direction (the leak\'s counterfactual).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'rate_o_before'?: number;
    /**
     * BEFORE rate (fraction) of the banner\'s direction that the savings are  billed against: the DiD counterfactual, unrounded. ret_t_before is this  rate rounded onto units_before, so only the rate reconciles with the euros.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'rate_t_before'?: number;
    /**
     * after/before return-rate ratio in the banner\'s direction (absent when unmeasurable).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'ratio'?: number;
    /**
     * Returns in the opposite direction, AFTER window.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'ret_o_after'?: number;
    /**
     * Returns in the opposite direction, BEFORE window.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'ret_o_before'?: number;
    /**
     * Returns in the banner\'s direction, AFTER window.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'ret_t_after'?: number;
    /**
     * Returns in the banner\'s direction, BEFORE window.
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'ret_t_before'?: number;
    /**
     * Real EUR saved so far, not annualized (absent when not measurable).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'saved_eur_to_date'?: number;
    /**
     * Banner direction: TOO_SMALL or TOO_BIG.
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'size_problem'?: string;
    /**
     * Display status: WORKING, COLLECTING_DATA, NO_CLEAR_EFFECT, REDIAGNOSIS or  RETIRED (\"\" is stored as COLLECTING_DATA).
     * @type {string}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'status'?: string;
    /**
     * Units sold in the AFTER window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'units_after'?: number;
    /**
     * Units sold in the BEFORE window (absent when unknown).
     * @type {number}
     * @memberof SizesuggestionspbSizingModelResult
     */
    'units_before'?: number;
}
/**
 * SizingStatusCounts is the model count per business status.
 * @export
 * @interface SizesuggestionspbSizingStatusCounts
 */
export interface SizesuggestionspbSizingStatusCounts {
    /**
     * Models still inside the measurement gate (INELIGIBLE).
     * @type {number}
     * @memberof SizesuggestionspbSizingStatusCounts
     */
    'collecting_data'?: number;
    /**
     * Models measured without a clear effect (NEUTRAL).
     * @type {number}
     * @memberof SizesuggestionspbSizingStatusCounts
     */
    'no_clear_effect'?: number;
    /**
     * Models under re-analysis (UNRESOLVED).
     * @type {number}
     * @memberof SizesuggestionspbSizingStatusCounts
     */
    'rediagnosis'?: number;
    /**
     * Models whose banner was retired.
     * @type {number}
     * @memberof SizesuggestionspbSizingStatusCounts
     */
    'retired'?: number;
    /**
     * Models with a measured reduction (SUCCESS).
     * @type {number}
     * @memberof SizesuggestionspbSizingStatusCounts
     */
    'working'?: number;
}
/**
 * SizingStoreMonthly is one month of the store-level sizing return series.
 * @export
 * @interface SizesuggestionspbSizingStoreMonthly
 */
export interface SizesuggestionspbSizingStoreMonthly {
    /**
     * First day of the purchase month, YYYY-MM-DD.
     * @type {string}
     * @memberof SizesuggestionspbSizingStoreMonthly
     */
    'month'?: string;
    /**
     * Sizing returns tagged too-big for that month\'s purchases.
     * @type {number}
     * @memberof SizesuggestionspbSizingStoreMonthly
     */
    'ret_big'?: number;
    /**
     * Sizing returns tagged too-small for that month\'s purchases.
     * @type {number}
     * @memberof SizesuggestionspbSizingStoreMonthly
     */
    'ret_small'?: number;
    /**
     * Units sold that month.
     * @type {string}
     * @memberof SizesuggestionspbSizingStoreMonthly
     */
    'units_sold'?: string;
}
/**
 * SizingTrendPoint is one month of the store sizing-return series.
 * @export
 * @interface SizesuggestionspbSizingTrendPoint
 */
export interface SizesuggestionspbSizingTrendPoint {
    /**
     * First day of the purchase month, YYYY-MM-DD.
     * @type {string}
     * @memberof SizesuggestionspbSizingTrendPoint
     */
    'month'?: string;
    /**
     * Sizing returns tagged too-big for that month\'s purchases.
     * @type {number}
     * @memberof SizesuggestionspbSizingTrendPoint
     */
    'ret_big'?: number;
    /**
     * Sizing returns tagged too-small for that month\'s purchases.
     * @type {number}
     * @memberof SizesuggestionspbSizingTrendPoint
     */
    'ret_small'?: number;
    /**
     * Units sold that month.
     * @type {string}
     * @memberof SizesuggestionspbSizingTrendPoint
     */
    'units_sold'?: string;
}
/**
 * UpsertCommentClassificationsRequest inserts newly classified comments.
 * @export
 * @interface SizesuggestionspbUpsertCommentClassificationsRequest
 */
export interface SizesuggestionspbUpsertCommentClassificationsRequest {
    /**
     * Rows to insert; already-cached rever_ids are left untouched.
     * @type {Array<SizesuggestionspbCommentClassification>}
     * @memberof SizesuggestionspbUpsertCommentClassificationsRequest
     */
    'classifications'?: Array<SizesuggestionspbCommentClassification>;
}
/**
 * UpsertCommentClassificationsResponse reports how many rows were new.
 * @export
 * @interface SizesuggestionspbUpsertCommentClassificationsResponse
 */
export interface SizesuggestionspbUpsertCommentClassificationsResponse {
    /**
     * Number of rows newly inserted (conflicts skipped).
     * @type {string}
     * @memberof SizesuggestionspbUpsertCommentClassificationsResponse
     */
    'inserted'?: string;
}
/**
 * UpsertRetiredBannerResultsRequest freezes retired-banner measurements.
 * @export
 * @interface SizesuggestionspbUpsertRetiredBannerResultsRequest
 */
export interface SizesuggestionspbUpsertRetiredBannerResultsRequest {
    /**
     * Rows to freeze; already-frozen banners are left untouched (first snapshot wins).
     * @type {Array<SizesuggestionspbRetiredBannerResult>}
     * @memberof SizesuggestionspbUpsertRetiredBannerResultsRequest
     */
    'results'?: Array<SizesuggestionspbRetiredBannerResult>;
}
/**
 * UpsertRetiredBannerResultsResponse reports how many rows were new.
 * @export
 * @interface SizesuggestionspbUpsertRetiredBannerResultsResponse
 */
export interface SizesuggestionspbUpsertRetiredBannerResultsResponse {
    /**
     * Number of rows newly inserted (conflicts skipped).
     * @type {string}
     * @memberof SizesuggestionspbUpsertRetiredBannerResultsResponse
     */
    'inserted'?: string;
}
/**
 * UpsertSizingCycleRequest replaces one store\'s dashboard read model for a cycle.
 * @export
 * @interface SizesuggestionspbUpsertSizingCycleRequest
 */
export interface SizesuggestionspbUpsertSizingCycleRequest {
    /**
     * The cycle row to upsert (last-wins on store_id + cycle_date).
     * @type {SizesuggestionspbSizingCycle}
     * @memberof SizesuggestionspbUpsertSizingCycleRequest
     */
    'cycle'?: SizesuggestionspbSizingCycle;
    /**
     * The cycle\'s changelog events; previous events of the cycle are replaced.
     * @type {Array<SizesuggestionspbSizingCycleEvent>}
     * @memberof SizesuggestionspbUpsertSizingCycleRequest
     */
    'events'?: Array<SizesuggestionspbSizingCycleEvent>;
    /**
     * Store-level monthly series to upsert (independent of the cycle key).
     * @type {Array<SizesuggestionspbSizingStoreMonthly>}
     * @memberof SizesuggestionspbUpsertSizingCycleRequest
     */
    'monthly'?: Array<SizesuggestionspbSizingStoreMonthly>;
    /**
     * The cycle\'s model results; previous results of the cycle are replaced.
     * @type {Array<SizesuggestionspbSizingModelResult>}
     * @memberof SizesuggestionspbUpsertSizingCycleRequest
     */
    'results'?: Array<SizesuggestionspbSizingModelResult>;
}
/**
 * UpsertSizingCycleResponse reports how many rows were written.
 * @export
 * @interface SizesuggestionspbUpsertSizingCycleResponse
 */
export interface SizesuggestionspbUpsertSizingCycleResponse {
    /**
     * Event rows written for the cycle.
     * @type {string}
     * @memberof SizesuggestionspbUpsertSizingCycleResponse
     */
    'events_written'?: string;
    /**
     * Monthly series rows upserted.
     * @type {string}
     * @memberof SizesuggestionspbUpsertSizingCycleResponse
     */
    'monthly_written'?: string;
    /**
     * Model result rows written for the cycle.
     * @type {string}
     * @memberof SizesuggestionspbUpsertSizingCycleResponse
     */
    'results_written'?: string;
}
/**
 * Payload for the WronglySizedProductsTabResponse response
 * @export
 * @interface SizesuggestionspbWronglySizedProductsTabResponse
 */
export interface SizesuggestionspbWronglySizedProductsTabResponse {
    /**
     * Whether Size Suggestions is switched on for the store in settings-api.
     * @type {boolean}
     * @memberof SizesuggestionspbWronglySizedProductsTabResponse
     */
    'show_tab'?: boolean;
}
/**
 * AssignTaskRequest changes a task\'s assignment. assigned_team and assigned_user are optional so  present-vs-absent is distinguishable: omit to leave unchanged, send assigned_user=\"\" to unassign  the user. At least one of assigned_team/assigned_user must be present.
 * @export
 * @interface TaskspbAssignTaskRequest
 */
export interface TaskspbAssignTaskRequest {
    /**
     * When true, apply the assignment to every live task in the same error group.
     * @type {boolean}
     * @memberof TaskspbAssignTaskRequest
     */
    'apply_to_group'?: boolean;
    /**
     * New assigned team (validated against tasks.team). Omit to leave unchanged.
     * @type {string}
     * @memberof TaskspbAssignTaskRequest
     */
    'assigned_team'?: string;
    /**
     * New assigned user email; \"\" unassigns. Omit to leave unchanged.
     * @type {string}
     * @memberof TaskspbAssignTaskRequest
     */
    'assigned_user'?: string;
    /**
     * Why the task is being handed over (e.g. why it is for OPS). Recorded on every affected task as a  comment and included in the assignee\'s notification. Required when the team actually changes.
     * @type {string}
     * @memberof TaskspbAssignTaskRequest
     */
    'reason'?: string;
    /**
     * ID of the task to (re)assign. Required.
     * @type {string}
     * @memberof TaskspbAssignTaskRequest
     */
    'task_id': string;
}
/**
 * AssignTaskResponse echoes the task\'s assignment after the change.
 * @export
 * @interface TaskspbAssignTaskResponse
 */
export interface TaskspbAssignTaskResponse {
    /**
     * Number of tasks updated (1 unless apply_to_group cascaded).
     * @type {number}
     * @memberof TaskspbAssignTaskResponse
     */
    'affected'?: number;
    /**
     * The task\'s assigned team after the change.
     * @type {string}
     * @memberof TaskspbAssignTaskResponse
     */
    'assigned_team'?: string;
    /**
     * The task\'s assigned user after the change, if any.
     * @type {string}
     * @memberof TaskspbAssignTaskResponse
     */
    'assigned_user'?: string;
    /**
     * ID of the (re)assigned task.
     * @type {string}
     * @memberof TaskspbAssignTaskResponse
     */
    'task_id'?: string;
}
/**
 * BulkOperation is a bulk action over a set of tasks, with its live progress counters.
 * @export
 * @interface TaskspbBulkOperation
 */
export interface TaskspbBulkOperation {
    /**
     * The action applied to every task in the operation.
     * @type {string}
     * @memberof TaskspbBulkOperation
     */
    'action'?: TaskspbBulkOperationActionEnum;
    /**
     * Email of the operator who started it; also the actor recorded on each task\'s audit log.
     * @type {string}
     * @memberof TaskspbBulkOperation
     */
    'actor'?: string;
    /**
     * Whether each task\'s action cascades to its whole error group.
     * @type {boolean}
     * @memberof TaskspbBulkOperation
     */
    'apply_to_group'?: boolean;
    /**
     * Tasks canceled before they started.
     * @type {number}
     * @memberof TaskspbBulkOperation
     */
    'canceled'?: number;
    /**
     * When the operation was created.
     * @type {string}
     * @memberof TaskspbBulkOperation
     */
    'created_at'?: string;
    /**
     * Tasks whose action failed so far.
     * @type {number}
     * @memberof TaskspbBulkOperation
     */
    'failed'?: number;
    /**
     * When the last item reached a terminal state; absent while the operation is still running.
     * @type {string}
     * @memberof TaskspbBulkOperation
     */
    'finished_at'?: string;
    /**
     * ID of the operation.
     * @type {string}
     * @memberof TaskspbBulkOperation
     */
    'operation_id'?: string;
    /**
     * Tasks still pending or in flight.
     * @type {number}
     * @memberof TaskspbBulkOperation
     */
    'remaining'?: number;
    /**
     * Current lifecycle state.
     * @type {string}
     * @memberof TaskspbBulkOperation
     */
    'state'?: TaskspbBulkOperationStateEnum;
    /**
     * Tasks actioned successfully so far.
     * @type {number}
     * @memberof TaskspbBulkOperation
     */
    'succeeded'?: number;
    /**
     * Total number of tasks in the operation.
     * @type {number}
     * @memberof TaskspbBulkOperation
     */
    'total'?: number;
}

export const TaskspbBulkOperationActionEnum = {
    Unspecified: 'TASK_ACTION_TYPE_UNSPECIFIED',
    Retry: 'TASK_ACTION_TYPE_RETRY',
    Skip: 'TASK_ACTION_TYPE_SKIP',
    Fail: 'TASK_ACTION_TYPE_FAIL',
    Jira: 'TASK_ACTION_TYPE_JIRA',
    Escalate: 'TASK_ACTION_TYPE_ESCALATE'
} as const;

export type TaskspbBulkOperationActionEnum = typeof TaskspbBulkOperationActionEnum[keyof typeof TaskspbBulkOperationActionEnum];
export const TaskspbBulkOperationStateEnum = {
    Unspecified: 'BULK_OPERATION_STATE_UNSPECIFIED',
    Running: 'BULK_OPERATION_STATE_RUNNING',
    Completed: 'BULK_OPERATION_STATE_COMPLETED',
    Canceled: 'BULK_OPERATION_STATE_CANCELED'
} as const;

export type TaskspbBulkOperationStateEnum = typeof TaskspbBulkOperationStateEnum[keyof typeof TaskspbBulkOperationStateEnum];

/**
 * BulkOperationItem is one task\'s slot in a bulk operation.
 * @export
 * @interface TaskspbBulkOperationItem
 */
export interface TaskspbBulkOperationItem {
    /**
     * Tasks successfully actioned through this item — more than 1 when apply_to_group cascaded.
     * @type {number}
     * @memberof TaskspbBulkOperationItem
     */
    'affected'?: number;
    /**
     * Failure reason; empty unless the state is FAILED.
     * @type {string}
     * @memberof TaskspbBulkOperationItem
     */
    'error'?: string;
    /**
     * Current state of this item.
     * @type {string}
     * @memberof TaskspbBulkOperationItem
     */
    'state'?: TaskspbBulkOperationItemStateEnum;
    /**
     * ID of the task.
     * @type {string}
     * @memberof TaskspbBulkOperationItem
     */
    'task_id'?: string;
    /**
     * The task\'s title at read time, so a client that did not start the operation can render it.
     * @type {string}
     * @memberof TaskspbBulkOperationItem
     */
    'title'?: string;
}

export const TaskspbBulkOperationItemStateEnum = {
    Unspecified: 'BULK_OPERATION_ITEM_STATE_UNSPECIFIED',
    Pending: 'BULK_OPERATION_ITEM_STATE_PENDING',
    Running: 'BULK_OPERATION_ITEM_STATE_RUNNING',
    Succeeded: 'BULK_OPERATION_ITEM_STATE_SUCCEEDED',
    Failed: 'BULK_OPERATION_ITEM_STATE_FAILED',
    Canceled: 'BULK_OPERATION_ITEM_STATE_CANCELED'
} as const;

export type TaskspbBulkOperationItemStateEnum = typeof TaskspbBulkOperationItemStateEnum[keyof typeof TaskspbBulkOperationItemStateEnum];

/**
 * CancelBulkTaskActionRequest asks to stop an operation.
 * @export
 * @interface TaskspbCancelBulkTaskActionRequest
 */
export interface TaskspbCancelBulkTaskActionRequest {
    /**
     * ID of the operation to cancel. Required.
     * @type {string}
     * @memberof TaskspbCancelBulkTaskActionRequest
     */
    'operation_id': string;
}
/**
 * CancelBulkTaskActionResponse reports the operation after the cancellation was applied.
 * @export
 * @interface TaskspbCancelBulkTaskActionResponse
 */
export interface TaskspbCancelBulkTaskActionResponse {
    /**
     * The operation with its progress counters. Items already in flight may still be RUNNING.
     * @type {TaskspbBulkOperation}
     * @memberof TaskspbCancelBulkTaskActionResponse
     */
    'operation'?: TaskspbBulkOperation;
}
/**
 * ClosureSlice is the number of closures of one team\'s tasks credited to one closer.
 * @export
 * @interface TaskspbClosureSlice
 */
export interface TaskspbClosureSlice {
    /**
     * Team the task is currently assigned to; empty when unassigned.
     * @type {string}
     * @memberof TaskspbClosureSlice
     */
    'assigned_team'?: string;
    /**
     * Email of the person, \"mastra-agent\" for the Mastra workflows, or empty when nobody acted on the  task before it closed (resumed on its own, canceled, delivered, backfilled).
     * @type {string}
     * @memberof TaskspbClosureSlice
     */
    'closer'?: string;
    /**
     * Number of closures.
     * @type {string}
     * @memberof TaskspbClosureSlice
     */
    'count'?: string;
}
/**
 * CreateTaskRequest describes the task to create or reopen. Source-specific identity  (activity_name, event_id, subscription_id) travels in metadata.
 * @export
 * @interface TaskspbCreateTaskRequest
 */
export interface TaskspbCreateTaskRequest {
    /**
     * Coarse categorization of the task.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'area'?: string;
    /**
     * REVER team the task is assigned to. Defaults to CORE when empty.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'assigned_team'?: string;
    /**
     * Logistics carrier of the related return process (e.g. Correos, UPS), if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'carrier'?: string;
    /**
     * ISO code of the parcel\'s destination country (the warehouse), if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'dest_country'?: string;
    /**
     * When true, the task is created standalone and never joined to, or used to found, an error group.
     * @type {boolean}
     * @memberof TaskspbCreateTaskRequest
     */
    'dont_group'?: boolean;
    /**
     * Ecommerce group the task belongs to (e.g. inditex); part of the task identity.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce the task relates to, if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'ecommerce_id'?: string;
    /**
     * Raw error text; normalized and fingerprinted server-side for dedup and grouping.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'error_string'?: string;
    /**
     * When true, the task belongs to a testing ecommerce; created standalone (never grouped).
     * @type {boolean}
     * @memberof TaskspbCreateTaskRequest
     */
    'is_testing'?: boolean;
    /**
     * Free-form source-specific payload as a JSON object string.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'metadata'?: string;
    /**
     * ISO code of the parcel\'s origin country (drop-off/customer/pickup address), if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'origin_country'?: string;
    /**
     * Ecommerce platform (e.g. SHOPIFY, PRESTASHOP), if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'platform'?: string;
    /**
     * Return process the task relates to, if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'process_id'?: string;
    /**
     * Last known shipping status of the related return process (e.g. CREATED, COLLECTED), if any.  Set at creation, then kept live via the ON_SHIPPING_STATUS_CHANGED event.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'process_shipping_status'?: string;
    /**
     * Start time of the related return process, if known.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'process_started_at'?: string;
    /**
     * Return status of the related return process (e.g. RUNNING), if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'process_status'?: string;
    /**
     * Logistics provider of the related return process (e.g. NONE, OPS, SendCloud), if any.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'provider'?: string;
    /**
     * Identified root cause of the task.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'root_cause'?: string;
    /**
     * Originating system: RETURNS (workflow), EVENTS or MANUAL. Required.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'source': string;
    /**
     * Finer categorization within area.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'sub_area'?: string;
    /**
     * Labels attached to the task.
     * @type {Array<string>}
     * @memberof TaskspbCreateTaskRequest
     */
    'tags'?: Array<string>;
    /**
     * Human-readable task title. Required.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'title': string;
    /**
     * Priority: LOW, MID, HIGH or URGENT. Defaults to LOW when empty.
     * @type {string}
     * @memberof TaskspbCreateTaskRequest
     */
    'urgency'?: string;
}
/**
 * CreateTaskResponse returns the resulting task and what happened to it.
 * @export
 * @interface TaskspbCreateTaskResponse
 */
export interface TaskspbCreateTaskResponse {
    /**
     * What CreateTask did with the request.
     * @type {string}
     * @memberof TaskspbCreateTaskResponse
     */
    'outcome'?: TaskspbCreateTaskResponseOutcomeEnum;
    /**
     * ID of the created, reopened or matched task.
     * @type {string}
     * @memberof TaskspbCreateTaskResponse
     */
    'task_id'?: string;
}

export const TaskspbCreateTaskResponseOutcomeEnum = {
    Unspecified: 'OUTCOME_UNSPECIFIED',
    Created: 'OUTCOME_CREATED',
    Reopened: 'OUTCOME_REOPENED',
    Matched: 'OUTCOME_MATCHED'
} as const;

export type TaskspbCreateTaskResponseOutcomeEnum = typeof TaskspbCreateTaskResponseOutcomeEnum[keyof typeof TaskspbCreateTaskResponseOutcomeEnum];

/**
 * CreateTaskTagRequest adds a tag to the catalog.
 * @export
 * @interface TaskspbCreateTaskTagRequest
 */
export interface TaskspbCreateTaskTagRequest {
    /**
     * Tag name. Required; must not be blank and must not already exist (case-insensitively).
     * @type {string}
     * @memberof TaskspbCreateTaskTagRequest
     */
    'name': string;
}
/**
 * CreateTaskTagResponse echoes the created tag.
 * @export
 * @interface TaskspbCreateTaskTagResponse
 */
export interface TaskspbCreateTaskTagResponse {
    /**
     * 
     * @type {TaskspbTaskTag}
     * @memberof TaskspbCreateTaskTagResponse
     */
    'tag'?: TaskspbTaskTag;
}
/**
 * FindTasksRequest carries the filters and pagination for FindTasks. Absent optional fields mean  \"no filtering\"; an empty request returns all non-deleted tasks.
 * @export
 * @interface TaskspbFindTasksRequest
 */
export interface TaskspbFindTasksRequest {
    /**
     * Filter by area.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'area'?: string;
    /**
     * Filter by assigned team.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'assigned_team'?: string;
    /**
     * Restrict to tasks assigned to the invoking user.
     * @type {boolean}
     * @memberof TaskspbFindTasksRequest
     */
    'assigned_to_me_only'?: boolean;
    /**
     * Filter by assigned user.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'assigned_user'?: string;
    /**
     * Filter by logistics carrier (case-insensitive; stored casing is inconsistent).
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'carrier'?: string;
    /**
     * Only tasks created at or after this time.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'created_from'?: string;
    /**
     * Only tasks created at or before this time.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'created_to'?: string;
    /**
     * Maximum days opened.
     * @type {number}
     * @memberof TaskspbFindTasksRequest
     */
    'days_opened_max'?: number;
    /**
     * Minimum days opened.
     * @type {number}
     * @memberof TaskspbFindTasksRequest
     */
    'days_opened_min'?: number;
    /**
     * Filter by parcel destination country ISO code (case-insensitive).
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'dest_country'?: string;
    /**
     * Deprecated: use ecommerce_ids. Kept for backward compatibility; when set it is merged into ecommerce_ids.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'ecommerce_id'?: string;
    /**
     * Filter by ecommerce; a task matches if its ecommerce_id equals any listed value. Empty = no  filter. Supersedes the singular ecommerce_id field.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'ecommerce_ids'?: Array<string>;
    /**
     * Filter by the original failing event\'s id (metadata.event_id, EVENTS source). Empty = no filter.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'event_id'?: string;
    /**
     * Exclude by ecommerce; a task is dropped if its ecommerce_id equals any listed value (tasks with  no ecommerce_id are kept). Empty = no exclusion. Applied on top of ecommerce_ids.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'exclude_ecommerce_ids'?: Array<string>;
    /**
     * Exclude by ecommerce platform; a task is dropped if its platform equals any listed value (tasks  with no platform are kept). Empty = no exclusion. Applied on top of platforms.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'exclude_platforms'?: Array<string>;
    /**
     * Exclude by tag; a task is dropped if it carries any listed tag (matched case-insensitively).  Empty = no exclusion. Applied on top of tags.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'exclude_tags'?: Array<string>;
    /**
     * Exclude by workflow activity name; a task is dropped if its activity equals any listed value  (tasks with no activity are kept). Empty = no exclusion. Applied on top of workflow_activity_names.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'exclude_workflow_activity_names'?: Array<string>;
    /**
     * Open text search: each whitespace-separated word must appear (case-insensitive substring) in  one of title, process_id, ecommerce_id, group_id, error_string, workflow activity, area,  sub_area, root_cause or platform.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'freetext'?: string;
    /**
     * Filter by ecommerce group.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'group_id'?: string;
    /**
     * Collapse each error-fingerprint group to one representative (oldest) row, nesting the  rest as children; filters match against the representative. Default false (flat list).
     * @type {boolean}
     * @memberof TaskspbFindTasksRequest
     */
    'grouped'?: boolean;
    /**
     * Include soft-deleted tasks (default false).
     * @type {boolean}
     * @memberof TaskspbFindTasksRequest
     */
    'include_deleted'?: boolean;
    /**
     * Deprecated: use testing_filter. Kept for backward compatibility — honored only when  testing_filter is UNSPECIFIED (true => INCLUDE, false => EXCLUDE).
     * @type {boolean}
     * @memberof TaskspbFindTasksRequest
     */
    'include_testing'?: boolean;
    /**
     * Page size. Defaults to 20, capped at 100.
     * @type {number}
     * @memberof TaskspbFindTasksRequest
     */
    'limit'?: number;
    /**
     * Pagination offset. Default 0.
     * @type {number}
     * @memberof TaskspbFindTasksRequest
     */
    'offset'?: number;
    /**
     * Filter by the on-hold occurrence the task was raised for (metadata.on_hold_id). Scopes a lookup  to one parked branch when several on-holds on the same process share an activity name.  Empty = no filter.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'on_hold_id'?: string;
    /**
     * Filter by parcel origin country ISO code (case-insensitive).
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'origin_country'?: string;
    /**
     * Deprecated: use platforms. Kept for backward compatibility; when set it is merged into platforms.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'platform'?: string;
    /**
     * Filter by ecommerce platform; a task matches if its platform equals any listed value (e.g.  SHOPIFY, PRESTASHOP). Empty = no filter. Supersedes the singular platform field.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'platforms'?: Array<string>;
    /**
     * Filter by return process.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'process_id'?: string;
    /**
     * Only tasks whose related process started at least this many days ago.
     * @type {number}
     * @memberof TaskspbFindTasksRequest
     */
    'process_started_min_age_days'?: number;
    /**
     * Filter by the related process\'s return status (e.g. RUNNING).
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'process_status'?: string;
    /**
     * Filter by logistics provider (case-insensitive; stored casing is inconsistent).
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'provider'?: string;
    /**
     * Filter by root cause.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'root_cause'?: string;
    /**
     * Filter by the related process\'s last known shipping status: a task matches if its cached value  (kept in sync via the ON_SHIPPING_STATUS_CHANGED event, not a one-time snapshot) equals any of  the listed values (e.g. CREATED, COLLECTED). Empty = no filter.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'shipping_statuses'?: Array<string>;
    /**
     * Task-row field to sort by (e.g. \"createdAt\", \"urgency\", \"daysOpened\"). Empty = default order  (newest first). Unknown keys are ignored and fall back to the default order.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'sort_by'?: string;
    /**
     * Sort direction, \"asc\" or \"desc\" (case-insensitive). Defaults to \"desc\". Ignored when sort_by is empty.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'sort_direction'?: string;
    /**
     * Filter by status; multiple values are OR-ed (e.g. OPEN + ON_HOLD).
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'statuses'?: Array<TaskspbFindTasksRequestStatusesEnum>;
    /**
     * Filter by sub-area.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'sub_area'?: string;
    /**
     * Filter by the original failing subscription\'s id (metadata.subscription_id, EVENTS source).  Empty = no filter.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'subscription_id'?: string;
    /**
     * Filter by tags (task must contain all).
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'tags'?: Array<string>;
    /**
     * Whether to include, exclude, or return only testing-ecommerce tasks. UNSPECIFIED falls back to  include_testing (default: testing tasks are excluded).
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'testing_filter'?: TaskspbFindTasksRequestTestingFilterEnum;
    /**
     * Filter by urgency.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'urgency'?: string;
    /**
     * Deprecated: use workflow_activity_names. Kept for backward compatibility; when set it is merged  into workflow_activity_names.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'workflow_activity_name'?: string;
    /**
     * Filter by workflow activity name (RETURNS source); a task matches if its activity equals any  listed value. Empty = no filter. Supersedes the singular workflow_activity_name field.
     * @type {Array<string>}
     * @memberof TaskspbFindTasksRequest
     */
    'workflow_activity_names'?: Array<string>;
    /**
     * Filter by the Temporal workflow that raised the task (matched against metadata.workflow_id).  Scopes a close/lookup to a single parked workflow when several on-holds on the same process  share an activity name. Empty = no filter.
     * @type {string}
     * @memberof TaskspbFindTasksRequest
     */
    'workflow_id'?: string;
}

export const TaskspbFindTasksRequestStatusesEnum = {
    Unspecified: 'TASK_STATUS_UNSPECIFIED',
    Open: 'TASK_STATUS_OPEN',
    Closed: 'TASK_STATUS_CLOSED',
    OnHold: 'TASK_STATUS_ON_HOLD',
    Deleted: 'TASK_STATUS_DELETED',
    Actioned: 'TASK_STATUS_ACTIONED'
} as const;

export type TaskspbFindTasksRequestStatusesEnum = typeof TaskspbFindTasksRequestStatusesEnum[keyof typeof TaskspbFindTasksRequestStatusesEnum];
export const TaskspbFindTasksRequestTestingFilterEnum = {
    Unspecified: 'TESTING_FILTER_UNSPECIFIED',
    Exclude: 'TESTING_FILTER_EXCLUDE',
    Only: 'TESTING_FILTER_ONLY',
    Include: 'TESTING_FILTER_INCLUDE'
} as const;

export type TaskspbFindTasksRequestTestingFilterEnum = typeof TaskspbFindTasksRequestTestingFilterEnum[keyof typeof TaskspbFindTasksRequestTestingFilterEnum];

/**
 * FindTasksResponse is the paginated result of FindTasks.
 * @export
 * @interface TaskspbFindTasksResponse
 */
export interface TaskspbFindTasksResponse {
    /**
     * Offset of the next page, or -1 when there are no more results.
     * @type {number}
     * @memberof TaskspbFindTasksResponse
     */
    'next_offset'?: number;
    /**
     * Page of matching task rows.
     * @type {Array<TaskspbTaskRow>}
     * @memberof TaskspbFindTasksResponse
     */
    'tasks'?: Array<TaskspbTaskRow>;
    /**
     * Total number of tasks matching the filters, ignoring pagination.
     * @type {string}
     * @memberof TaskspbFindTasksResponse
     */
    'total_count'?: string;
}
/**
 * GetBulkTaskActionResponse carries the operation and each task\'s outcome.
 * @export
 * @interface TaskspbGetBulkTaskActionResponse
 */
export interface TaskspbGetBulkTaskActionResponse {
    /**
     * One entry per task, in the order the operation was created with.
     * @type {Array<TaskspbBulkOperationItem>}
     * @memberof TaskspbGetBulkTaskActionResponse
     */
    'items'?: Array<TaskspbBulkOperationItem>;
    /**
     * The operation with its progress counters.
     * @type {TaskspbBulkOperation}
     * @memberof TaskspbGetBulkTaskActionResponse
     */
    'operation'?: TaskspbBulkOperation;
}
/**
 * GetClosedTaskDurationsRequest asks for the time-alive of tasks closed within [from, to].
 * @export
 * @interface TaskspbGetClosedTaskDurationsRequest
 */
export interface TaskspbGetClosedTaskDurationsRequest {
    /**
     * When set, restricts to tasks currently assigned to this team (empty/absent = all teams).
     * @type {string}
     * @memberof TaskspbGetClosedTaskDurationsRequest
     */
    'assigned_team'?: string;
    /**
     * Start of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetClosedTaskDurationsRequest
     */
    'from': string;
    /**
     * End of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetClosedTaskDurationsRequest
     */
    'to': string;
}
/**
 * GetClosedTaskDurationsResponse carries one time-alive value per closure event in the range.
 * @export
 * @interface TaskspbGetClosedTaskDurationsResponse
 */
export interface TaskspbGetClosedTaskDurationsResponse {
    /**
     * Time-alive in seconds for each task closed within [from, to] (close time minus the later of the  task\'s creation and its most recent prior reopen). One entry per closure event.
     * @type {Array<string>}
     * @memberof TaskspbGetClosedTaskDurationsResponse
     */
    'durations_seconds'?: Array<string>;
}
/**
 * GetClosureAttributionRequest asks who caused the closures within [from, to].
 * @export
 * @interface TaskspbGetClosureAttributionRequest
 */
export interface TaskspbGetClosureAttributionRequest {
    /**
     * When set, restricts to tasks currently assigned to this team (empty/absent = all teams).
     * @type {string}
     * @memberof TaskspbGetClosureAttributionRequest
     */
    'assigned_team'?: string;
    /**
     * Start of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetClosureAttributionRequest
     */
    'from': string;
    /**
     * End of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetClosureAttributionRequest
     */
    'to': string;
}
/**
 * GetClosureAttributionResponse returns the closures grouped by team and closer.
 * @export
 * @interface TaskspbGetClosureAttributionResponse
 */
export interface TaskspbGetClosureAttributionResponse {
    /**
     * One slice per (assigned_team, closer) pair, descending by count.
     * @type {Array<TaskspbClosureSlice>}
     * @memberof TaskspbGetClosureAttributionResponse
     */
    'slices'?: Array<TaskspbClosureSlice>;
    /**
     * Sum of all counts: every closure in the range.
     * @type {string}
     * @memberof TaskspbGetClosureAttributionResponse
     */
    'total'?: string;
}
/**
 * GetOpenTaskCountRequest asks how many tasks were open at the given instant.
 * @export
 * @interface TaskspbGetOpenTaskCountRequest
 */
export interface TaskspbGetOpenTaskCountRequest {
    /**
     * When set, restricts to tasks currently assigned to this team (empty/absent = all teams).
     * @type {string}
     * @memberof TaskspbGetOpenTaskCountRequest
     */
    'assigned_team'?: string;
    /**
     * The instant to reconstruct the open backlog at. Required.
     * @type {string}
     * @memberof TaskspbGetOpenTaskCountRequest
     */
    'at': string;
}
/**
 * GetOpenTaskCountResponse carries the reconstructed open-task count at the requested instant.
 * @export
 * @interface TaskspbGetOpenTaskCountResponse
 */
export interface TaskspbGetOpenTaskCountResponse {
    /**
     * Number of tasks open (non-terminal) at the instant.
     * @type {string}
     * @memberof TaskspbGetOpenTaskCountResponse
     */
    'count'?: string;
}
/**
 * GetOpenTaskSeriesRequest asks for the open backlog at the end of every calendar day the range  touches, in the request timezone.
 * @export
 * @interface TaskspbGetOpenTaskSeriesRequest
 */
export interface TaskspbGetOpenTaskSeriesRequest {
    /**
     * When set, restricts to tasks currently assigned to this team (empty/absent = all teams).
     * @type {string}
     * @memberof TaskspbGetOpenTaskSeriesRequest
     */
    'assigned_team'?: string;
    /**
     * Start of the range; the calendar day it falls on is the first point. Required.
     * @type {string}
     * @memberof TaskspbGetOpenTaskSeriesRequest
     */
    'from': string;
    /**
     * IANA timezone defining the calendar days and their boundaries (e.g. \"Europe/Madrid\"). Defaults  to UTC.
     * @type {string}
     * @memberof TaskspbGetOpenTaskSeriesRequest
     */
    'timezone'?: string;
    /**
     * End of the range; the calendar day it falls on is the last point. Required.
     * @type {string}
     * @memberof TaskspbGetOpenTaskSeriesRequest
     */
    'to': string;
}
/**
 * GetOpenTaskSeriesResponse is the gap-free daily backlog series, ascending by day.
 * @export
 * @interface TaskspbGetOpenTaskSeriesResponse
 */
export interface TaskspbGetOpenTaskSeriesResponse {
    /**
     * One point per calendar day the requested range touches, ascending by day_start.
     * @type {Array<TaskspbOpenTaskPoint>}
     * @memberof TaskspbGetOpenTaskSeriesResponse
     */
    'points'?: Array<TaskspbOpenTaskPoint>;
}
/**
 * GetTaskActivitySeriesRequest asks for per-bucket counts of the given metrics over [from, to].
 * @export
 * @interface TaskspbGetTaskActivitySeriesRequest
 */
export interface TaskspbGetTaskActivitySeriesRequest {
    /**
     * When set, restricts counts to tasks currently assigned to this team (empty/absent = all teams).
     * @type {string}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'assigned_team'?: string;
    /**
     * Bucket granularity. Required.
     * @type {string}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'bucket': TaskspbGetTaskActivitySeriesRequestBucketEnum;
    /**
     * Start of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'from': string;
    /**
     * When set, each bucket also carries a per-value breakdown of the same metrics grouped by this  dimension (only ASSIGNED_TEAM is supported). Absent = no breakdown (groups empty).
     * @type {string}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'group_by'?: TaskspbGetTaskActivitySeriesRequestGroupByEnum;
    /**
     * Metrics to count; at least one. Required.
     * @type {Array<string>}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'metrics': Array<TaskspbGetTaskActivitySeriesRequestMetricsEnum>;
    /**
     * IANA timezone used to place events into day buckets (e.g. \"Europe/Madrid\"). Defaults to UTC.
     * @type {string}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'timezone'?: string;
    /**
     * End of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetTaskActivitySeriesRequest
     */
    'to': string;
}

export const TaskspbGetTaskActivitySeriesRequestBucketEnum = {
    Unspecified: 'STATS_BUCKET_UNSPECIFIED',
    Day: 'STATS_BUCKET_DAY'
} as const;

export type TaskspbGetTaskActivitySeriesRequestBucketEnum = typeof TaskspbGetTaskActivitySeriesRequestBucketEnum[keyof typeof TaskspbGetTaskActivitySeriesRequestBucketEnum];
export const TaskspbGetTaskActivitySeriesRequestGroupByEnum = {
    Unspecified: 'TASK_BREAKDOWN_DIMENSION_UNSPECIFIED',
    AssignedTeam: 'TASK_BREAKDOWN_DIMENSION_ASSIGNED_TEAM',
    AssignedUser: 'TASK_BREAKDOWN_DIMENSION_ASSIGNED_USER',
    Status: 'TASK_BREAKDOWN_DIMENSION_STATUS',
    Actor: 'TASK_BREAKDOWN_DIMENSION_ACTOR',
    Area: 'TASK_BREAKDOWN_DIMENSION_AREA',
    Action: 'TASK_BREAKDOWN_DIMENSION_ACTION',
    RootCause: 'TASK_BREAKDOWN_DIMENSION_ROOT_CAUSE',
    SubArea: 'TASK_BREAKDOWN_DIMENSION_SUB_AREA'
} as const;

export type TaskspbGetTaskActivitySeriesRequestGroupByEnum = typeof TaskspbGetTaskActivitySeriesRequestGroupByEnum[keyof typeof TaskspbGetTaskActivitySeriesRequestGroupByEnum];
export const TaskspbGetTaskActivitySeriesRequestMetricsEnum = {
    Unspecified: 'TASK_ACTIVITY_METRIC_UNSPECIFIED',
    Created: 'TASK_ACTIVITY_METRIC_CREATED',
    Closed: 'TASK_ACTIVITY_METRIC_CLOSED',
    Reopened: 'TASK_ACTIVITY_METRIC_REOPENED',
    Deleted: 'TASK_ACTIVITY_METRIC_DELETED',
    Escalated: 'TASK_ACTIVITY_METRIC_ESCALATED'
} as const;

export type TaskspbGetTaskActivitySeriesRequestMetricsEnum = typeof TaskspbGetTaskActivitySeriesRequestMetricsEnum[keyof typeof TaskspbGetTaskActivitySeriesRequestMetricsEnum];

/**
 * GetTaskActivitySeriesResponse is the ordered list of buckets (ascending by time). Buckets with no  events for any requested metric may be omitted; callers should treat missing buckets as zero.
 * @export
 * @interface TaskspbGetTaskActivitySeriesResponse
 */
export interface TaskspbGetTaskActivitySeriesResponse {
    /**
     * Buckets ordered ascending by bucket_start.
     * @type {Array<TaskspbTaskActivityBucket>}
     * @memberof TaskspbGetTaskActivitySeriesResponse
     */
    'buckets'?: Array<TaskspbTaskActivityBucket>;
}
/**
 * GetTaskBreakdownRequest asks for counts grouped by dimension for the given metric.
 * @export
 * @interface TaskspbGetTaskBreakdownRequest
 */
export interface TaskspbGetTaskBreakdownRequest {
    /**
     * When set, counts only events performed by this audit-log actor (e.g. \"mastra-agent\"). Only for  CLOSED_EVENTS and RESOLUTION_EVENTS; rejected with OPEN_TASKS, whose rows carry no actor.
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownRequest
     */
    'actor'?: string;
    /**
     * When set, restricts counts to tasks currently assigned to this team (empty/absent = all teams).
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownRequest
     */
    'assigned_team'?: string;
    /**
     * Field to group by. Required.
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownRequest
     */
    'dimension': TaskspbGetTaskBreakdownRequestDimensionEnum;
    /**
     * Start of the range, inclusive. Required for CLOSED_EVENTS; ignored for OPEN_TASKS.
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownRequest
     */
    'from'?: string;
    /**
     * What to count. Required.
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownRequest
     */
    'metric': TaskspbGetTaskBreakdownRequestMetricEnum;
    /**
     * End of the range, inclusive. Required for CLOSED_EVENTS; ignored for OPEN_TASKS.
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownRequest
     */
    'to'?: string;
}

export const TaskspbGetTaskBreakdownRequestDimensionEnum = {
    Unspecified: 'TASK_BREAKDOWN_DIMENSION_UNSPECIFIED',
    AssignedTeam: 'TASK_BREAKDOWN_DIMENSION_ASSIGNED_TEAM',
    AssignedUser: 'TASK_BREAKDOWN_DIMENSION_ASSIGNED_USER',
    Status: 'TASK_BREAKDOWN_DIMENSION_STATUS',
    Actor: 'TASK_BREAKDOWN_DIMENSION_ACTOR',
    Area: 'TASK_BREAKDOWN_DIMENSION_AREA',
    Action: 'TASK_BREAKDOWN_DIMENSION_ACTION',
    RootCause: 'TASK_BREAKDOWN_DIMENSION_ROOT_CAUSE',
    SubArea: 'TASK_BREAKDOWN_DIMENSION_SUB_AREA'
} as const;

export type TaskspbGetTaskBreakdownRequestDimensionEnum = typeof TaskspbGetTaskBreakdownRequestDimensionEnum[keyof typeof TaskspbGetTaskBreakdownRequestDimensionEnum];
export const TaskspbGetTaskBreakdownRequestMetricEnum = {
    Unspecified: 'TASK_BREAKDOWN_METRIC_UNSPECIFIED',
    OpenTasks: 'TASK_BREAKDOWN_METRIC_OPEN_TASKS',
    ClosedEvents: 'TASK_BREAKDOWN_METRIC_CLOSED_EVENTS',
    ResolutionEvents: 'TASK_BREAKDOWN_METRIC_RESOLUTION_EVENTS'
} as const;

export type TaskspbGetTaskBreakdownRequestMetricEnum = typeof TaskspbGetTaskBreakdownRequestMetricEnum[keyof typeof TaskspbGetTaskBreakdownRequestMetricEnum];

/**
 * GetTaskBreakdownResponse returns the slices and their total.
 * @export
 * @interface TaskspbGetTaskBreakdownResponse
 */
export interface TaskspbGetTaskBreakdownResponse {
    /**
     * One slice per distinct dimension value, descending by count.
     * @type {Array<TaskspbTaskBreakdownSlice>}
     * @memberof TaskspbGetTaskBreakdownResponse
     */
    'slices'?: Array<TaskspbTaskBreakdownSlice>;
    /**
     * Sum of all slice counts.
     * @type {string}
     * @memberof TaskspbGetTaskBreakdownResponse
     */
    'total'?: string;
}
/**
 * GetTaskResponse returns the task detail.
 * @export
 * @interface TaskspbGetTaskResponse
 */
export interface TaskspbGetTaskResponse {
    /**
     * The requested task\'s full detail.
     * @type {TaskspbTaskDetail}
     * @memberof TaskspbGetTaskResponse
     */
    'task'?: TaskspbTaskDetail;
}
/**
 * GetTeamFlowsRequest asks for the team-to-team handovers within [from, to].
 * @export
 * @interface TaskspbGetTeamFlowsRequest
 */
export interface TaskspbGetTeamFlowsRequest {
    /**
     * Start of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetTeamFlowsRequest
     */
    'from': string;
    /**
     * End of the range, inclusive. Required.
     * @type {string}
     * @memberof TaskspbGetTeamFlowsRequest
     */
    'to': string;
}
/**
 * GetTeamFlowsResponse returns the handovers between every pair of teams.
 * @export
 * @interface TaskspbGetTeamFlowsResponse
 */
export interface TaskspbGetTeamFlowsResponse {
    /**
     * One entry per (from_team, to_team) pair with at least one handover, descending by count.
     * @type {Array<TaskspbTeamFlow>}
     * @memberof TaskspbGetTeamFlowsResponse
     */
    'flows'?: Array<TaskspbTeamFlow>;
    /**
     * Sum of all counts.
     * @type {string}
     * @memberof TaskspbGetTeamFlowsResponse
     */
    'total'?: string;
}
/**
 * ListBulkTaskActionsResponse carries the matching operations without their items.
 * @export
 * @interface TaskspbListBulkTaskActionsResponse
 */
export interface TaskspbListBulkTaskActionsResponse {
    /**
     * Matching operations, newest first.
     * @type {Array<TaskspbBulkOperation>}
     * @memberof TaskspbListBulkTaskActionsResponse
     */
    'operations'?: Array<TaskspbBulkOperation>;
}
/**
 * ListEcommerceIdsResponse is the distinct set of ecommerce ids on tasks.
 * @export
 * @interface TaskspbListEcommerceIdsResponse
 */
export interface TaskspbListEcommerceIdsResponse {
    /**
     * Distinct ecommerce ids, sorted ascending.
     * @type {Array<string>}
     * @memberof TaskspbListEcommerceIdsResponse
     */
    'ecommerce_ids'?: Array<string>;
}
/**
 * ListTaskTagsResponse returns the full tag catalog, alphabetically.
 * @export
 * @interface TaskspbListTaskTagsResponse
 */
export interface TaskspbListTaskTagsResponse {
    /**
     * 
     * @type {Array<TaskspbTaskTag>}
     * @memberof TaskspbListTaskTagsResponse
     */
    'tags'?: Array<TaskspbTaskTag>;
}
/**
 * ListTeamMembershipsResponse returns all teams and their members.
 * @export
 * @interface TaskspbListTeamMembershipsResponse
 */
export interface TaskspbListTeamMembershipsResponse {
    /**
     * One entry per team (including teams with no members).
     * @type {Array<TaskspbTeamMembership>}
     * @memberof TaskspbListTeamMembershipsResponse
     */
    'memberships'?: Array<TaskspbTeamMembership>;
}
/**
 * ListWorkflowActivityNamesResponse is the distinct set of workflow activity names on tasks.
 * @export
 * @interface TaskspbListWorkflowActivityNamesResponse
 */
export interface TaskspbListWorkflowActivityNamesResponse {
    /**
     * Distinct workflow activity names, sorted ascending.
     * @type {Array<string>}
     * @memberof TaskspbListWorkflowActivityNamesResponse
     */
    'activity_names'?: Array<string>;
}
/**
 * OpenTaskPoint is one calendar day\'s backlog.
 * @export
 * @interface TaskspbOpenTaskPoint
 */
export interface TaskspbOpenTaskPoint {
    /**
     * Tasks open (non-terminal) at the END of that day, i.e. at the following local midnight.
     * @type {string}
     * @memberof TaskspbOpenTaskPoint
     */
    'count'?: string;
    /**
     * Instant of the local midnight that STARTS the day (same anchoring as TaskActivityBucket).
     * @type {string}
     * @memberof TaskspbOpenTaskPoint
     */
    'day_start'?: string;
}
/**
 * RenameTaskTagRequest renames a tag in the catalog.
 * @export
 * @interface TaskspbRenameTaskTagRequest
 */
export interface TaskspbRenameTaskTagRequest {
    /**
     * Current tag name. Required.
     * @type {string}
     * @memberof TaskspbRenameTaskTagRequest
     */
    'name': string;
    /**
     * New tag name. Required; must not be blank and must not already exist (case-insensitively).
     * @type {string}
     * @memberof TaskspbRenameTaskTagRequest
     */
    'new_name': string;
}
/**
 * RenameTaskTagResponse echoes the renamed tag.
 * @export
 * @interface TaskspbRenameTaskTagResponse
 */
export interface TaskspbRenameTaskTagResponse {
    /**
     * 
     * @type {TaskspbTaskTag}
     * @memberof TaskspbRenameTaskTagResponse
     */
    'tag'?: TaskspbTaskTag;
}
/**
 * ReopenTaskRequest reopens a process\'s ACTIONED task(s). The fresh fields come from the failed  retry; omit any of them to leave the task\'s current value unchanged.
 * @export
 * @interface TaskspbReopenTaskRequest
 */
export interface TaskspbReopenTaskRequest {
    /**
     * Logistics carrier of the related return process.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'carrier'?: string;
    /**
     * ISO code of the parcel\'s destination country (the assigned warehouse).
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'dest_country'?: string;
    /**
     * Ecommerce group the task belongs to (e.g. inditex).
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'ecommerce_group'?: string;
    /**
     * Ecommerce the task relates to.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'ecommerce_id'?: string;
    /**
     * Raw error text from the failed retry; drives change detection and re-fingerprinting.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'error_string'?: string;
    /**
     * Whether the task\'s ecommerce is a testing one; a testing task is kept standalone and not re-run.
     * @type {boolean}
     * @memberof TaskspbReopenTaskRequest
     */
    'is_testing'?: boolean;
    /**
     * On-hold occurrence the failed retry belongs to (metadata.on_hold_id). When set, reopen only that  task; absent for episodes parked before per-occurrence tracking.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'on_hold_id'?: string;
    /**
     * ISO code of the parcel\'s origin country (drop-off/customer/pickup address).
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'origin_country'?: string;
    /**
     * Ecommerce platform (e.g. SHOPIFY).
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'platform'?: string;
    /**
     * Return process whose ACTIONED task(s) to reopen. Required.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'process_id': string;
    /**
     * Last known shipping status of the related return process (e.g. COLLECTED), refreshed on reopen.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'process_shipping_status'?: string;
    /**
     * Logistics provider of the related return process.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'provider'?: string;
    /**
     * When set, reopen only the task raised for this workflow activity; otherwise all the process\'s  ACTIONED tasks.
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'workflow_activity_name'?: string;
    /**
     * Workflow the failed retry re-parked (metadata.workflow_id). Scopes the reopen to that workflow;  the on-hold occurrence is keyed by (workflow_id, on_hold_id).
     * @type {string}
     * @memberof TaskspbReopenTaskRequest
     */
    'workflow_id'?: string;
}
/**
 * ReopenTaskResponse lists the tasks reopened by the request.
 * @export
 * @interface TaskspbReopenTaskResponse
 */
export interface TaskspbReopenTaskResponse {
    /**
     * The tasks that were reopened (empty when the process had no ACTIONED task to reopen).
     * @type {Array<TaskspbReopenedTask>}
     * @memberof TaskspbReopenTaskResponse
     */
    'reopened'?: Array<TaskspbReopenedTask>;
}
/**
 * ReopenedTask reports one reopened task and whether its error changed enough to warrant re-running  the on-hold workflow, carrying the fields needed to re-fire that workflow.
 * @export
 * @interface TaskspbReopenedTask
 */
export interface TaskspbReopenedTask {
    /**
     * Failed workflow activity name from the task\'s metadata.
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'activity_name'?: string;
    /**
     * Logistics carrier (after refresh).
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'carrier'?: string;
    /**
     * Ecommerce the task relates to (after refresh).
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'ecommerce_id'?: string;
    /**
     * Raw error text (after refresh).
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'error_string'?: string;
    /**
     * Ecommerce platform (after refresh).
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'platform'?: string;
    /**
     * Return process the task relates to.
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'process_id'?: string;
    /**
     * Logistics provider (after refresh).
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'provider'?: string;
    /**
     * True when the error essentially changed: computed classification/embedding were cleared, the task  was re-clustered, and the on-hold workflow should be re-run to regenerate its classification.
     * @type {boolean}
     * @memberof TaskspbReopenedTask
     */
    'reclassify_needed'?: boolean;
    /**
     * Originating system of the task (e.g. RETURNS).
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'source'?: string;
    /**
     * Error cluster the task belongs to after re-grouping, if any.
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'task_group_id'?: string;
    /**
     * ID of the reopened task.
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'task_id'?: string;
    /**
     * On-hold workflow id from the task\'s metadata.
     * @type {string}
     * @memberof TaskspbReopenedTask
     */
    'workflow_id'?: string;
}
/**
 * SetTeamSlackChannelRequest sets a team\'s Slack channel.
 * @export
 * @interface TaskspbSetTeamSlackChannelRequest
 */
export interface TaskspbSetTeamSlackChannelRequest {
    /**
     * Slack channel id; empty clears it (disables notifications for the team).
     * @type {string}
     * @memberof TaskspbSetTeamSlackChannelRequest
     */
    'slack_channel'?: string;
    /**
     * Team to update. Required.
     * @type {string}
     * @memberof TaskspbSetTeamSlackChannelRequest
     */
    'team': string;
}
/**
 * SetTeamSlackChannelResponse echoes the updated team membership.
 * @export
 * @interface TaskspbSetTeamSlackChannelResponse
 */
export interface TaskspbSetTeamSlackChannelResponse {
    /**
     * The team\'s membership after the update.
     * @type {TaskspbTeamMembership}
     * @memberof TaskspbSetTeamSlackChannelResponse
     */
    'membership'?: TaskspbTeamMembership;
}
/**
 * StartBulkTaskActionRequest applies one action to many tasks asynchronously.
 * @export
 * @interface TaskspbStartBulkTaskActionRequest
 */
export interface TaskspbStartBulkTaskActionRequest {
    /**
     * Action to apply to every task. Required.
     * @type {string}
     * @memberof TaskspbStartBulkTaskActionRequest
     */
    'action': TaskspbStartBulkTaskActionRequestActionEnum;
    /**
     * When true, each task\'s action also applies to every live task in its error group.
     * @type {boolean}
     * @memberof TaskspbStartBulkTaskActionRequest
     */
    'apply_to_group'?: boolean;
    /**
     * Operator note: the reason TASK_ACTION_TYPE_ESCALATE requires, recorded on every task. Ignored  by other actions.
     * @type {string}
     * @memberof TaskspbStartBulkTaskActionRequest
     */
    'message'?: string;
    /**
     * IDs of the tasks to action. Required, non-empty; duplicates are collapsed. Capped server-side.
     * @type {Array<string>}
     * @memberof TaskspbStartBulkTaskActionRequest
     */
    'task_ids': Array<string>;
}

export const TaskspbStartBulkTaskActionRequestActionEnum = {
    Unspecified: 'TASK_ACTION_TYPE_UNSPECIFIED',
    Retry: 'TASK_ACTION_TYPE_RETRY',
    Skip: 'TASK_ACTION_TYPE_SKIP',
    Fail: 'TASK_ACTION_TYPE_FAIL',
    Jira: 'TASK_ACTION_TYPE_JIRA',
    Escalate: 'TASK_ACTION_TYPE_ESCALATE'
} as const;

export type TaskspbStartBulkTaskActionRequestActionEnum = typeof TaskspbStartBulkTaskActionRequestActionEnum[keyof typeof TaskspbStartBulkTaskActionRequestActionEnum];

/**
 * StartBulkTaskActionResponse identifies the accepted operation. Progress starts empty: nothing has  been actioned yet when this returns.
 * @export
 * @interface TaskspbStartBulkTaskActionResponse
 */
export interface TaskspbStartBulkTaskActionResponse {
    /**
     * ID of the created operation; poll GetBulkTaskAction with it.
     * @type {string}
     * @memberof TaskspbStartBulkTaskActionResponse
     */
    'operation_id'?: string;
    /**
     * Number of tasks accepted into the operation, after collapsing duplicates.
     * @type {number}
     * @memberof TaskspbStartBulkTaskActionResponse
     */
    'total'?: number;
}
/**
 * TagList wraps a repeated tag set so its presence is distinguishable from \"unset\" in a patch.
 * @export
 * @interface TaskspbTagList
 */
export interface TaskspbTagList {
    /**
     * The tags to set. Present TagList replaces the task\'s whole tag set.
     * @type {Array<string>}
     * @memberof TaskspbTagList
     */
    'values'?: Array<string>;
}
/**
 * TaskActionRequest actions a single task\'s source system.
 * @export
 * @interface TaskspbTaskActionRequest
 */
export interface TaskspbTaskActionRequest {
    /**
     * Action to apply. Required.
     * @type {string}
     * @memberof TaskspbTaskActionRequest
     */
    'action': TaskspbTaskActionRequestActionEnum;
    /**
     * When true, apply the action to every live task in the same error group (best-effort per task).
     * @type {boolean}
     * @memberof TaskspbTaskActionRequest
     */
    'apply_to_group'?: boolean;
    /**
     * Operator note: the reason TASK_ACTION_TYPE_ESCALATE requires. Ignored by other actions.
     * @type {string}
     * @memberof TaskspbTaskActionRequest
     */
    'message'?: string;
    /**
     * ID of the task to action. Required.
     * @type {string}
     * @memberof TaskspbTaskActionRequest
     */
    'task_id': string;
}

export const TaskspbTaskActionRequestActionEnum = {
    Unspecified: 'TASK_ACTION_TYPE_UNSPECIFIED',
    Retry: 'TASK_ACTION_TYPE_RETRY',
    Skip: 'TASK_ACTION_TYPE_SKIP',
    Fail: 'TASK_ACTION_TYPE_FAIL',
    Jira: 'TASK_ACTION_TYPE_JIRA',
    Escalate: 'TASK_ACTION_TYPE_ESCALATE'
} as const;

export type TaskspbTaskActionRequestActionEnum = typeof TaskspbTaskActionRequestActionEnum[keyof typeof TaskspbTaskActionRequestActionEnum];

/**
 * TaskActionResponse echoes the task and its status after the action.
 * @export
 * @interface TaskspbTaskActionResponse
 */
export interface TaskspbTaskActionResponse {
    /**
     * Number of tasks successfully actioned (1 unless apply_to_group cascaded).
     * @type {number}
     * @memberof TaskspbTaskActionResponse
     */
    'affected'?: number;
    /**
     * Number of group members that could not be actioned (apply_to_group only).
     * @type {number}
     * @memberof TaskspbTaskActionResponse
     */
    'failed'?: number;
    /**
     * The task\'s status after the action (ACTIONED on success; unchanged by an escalation).
     * @type {string}
     * @memberof TaskspbTaskActionResponse
     */
    'status'?: TaskspbTaskActionResponseStatusEnum;
    /**
     * ID of the actioned task.
     * @type {string}
     * @memberof TaskspbTaskActionResponse
     */
    'task_id'?: string;
}

export const TaskspbTaskActionResponseStatusEnum = {
    Unspecified: 'TASK_STATUS_UNSPECIFIED',
    Open: 'TASK_STATUS_OPEN',
    Closed: 'TASK_STATUS_CLOSED',
    OnHold: 'TASK_STATUS_ON_HOLD',
    Deleted: 'TASK_STATUS_DELETED',
    Actioned: 'TASK_STATUS_ACTIONED'
} as const;

export type TaskspbTaskActionResponseStatusEnum = typeof TaskspbTaskActionResponseStatusEnum[keyof typeof TaskspbTaskActionResponseStatusEnum];

/**
 * TaskActivityBucket is one time bucket with a count per requested metric.
 * @export
 * @interface TaskspbTaskActivityBucket
 */
export interface TaskspbTaskActivityBucket {
    /**
     * Start instant of the bucket (bucket boundary in the request timezone).
     * @type {string}
     * @memberof TaskspbTaskActivityBucket
     */
    'bucket_start'?: string;
    /**
     * Count per metric, keyed by the TaskActivityMetric enum name (e.g. \"CREATED\"). Absent = 0.
     * @type {{ [key: string]: string; }}
     * @memberof TaskspbTaskActivityBucket
     */
    'counts'?: { [key: string]: string; };
    /**
     * Per-group counts when group_by was requested; empty otherwise. Group counts sum to counts.
     * @type {Array<TaskspbTaskActivityGroup>}
     * @memberof TaskspbTaskActivityBucket
     */
    'groups'?: Array<TaskspbTaskActivityGroup>;
}
/**
 * TaskActivityGroup is one value of the group_by dimension within a bucket, with a count per metric.
 * @export
 * @interface TaskspbTaskActivityGroup
 */
export interface TaskspbTaskActivityGroup {
    /**
     * Count per metric for this group, keyed by the TaskActivityMetric enum name. Absent = 0.
     * @type {{ [key: string]: string; }}
     * @memberof TaskspbTaskActivityGroup
     */
    'counts'?: { [key: string]: string; };
    /**
     * Dimension value (e.g. team name). Empty string when the grouped column is null.
     * @type {string}
     * @memberof TaskspbTaskActivityGroup
     */
    'key'?: string;
}
/**
 * TaskBreakdownSlice is the count for one value of the grouping dimension.
 * @export
 * @interface TaskspbTaskBreakdownSlice
 */
export interface TaskspbTaskBreakdownSlice {
    /**
     * Count for this slice.
     * @type {string}
     * @memberof TaskspbTaskBreakdownSlice
     */
    'count'?: string;
    /**
     * Dimension value (team name, user email, status, area, root cause, actor). Empty string when the  grouped column is null (e.g. unassigned user, unclassified task).
     * @type {string}
     * @memberof TaskspbTaskBreakdownSlice
     */
    'key'?: string;
}
/**
 * TaskComment is a text content block attached to a task.
 * @export
 * @interface TaskspbTaskComment
 */
export interface TaskspbTaskComment {
    /**
     * Author of the comment.
     * @type {string}
     * @memberof TaskspbTaskComment
     */
    'author'?: string;
    /**
     * Comment body.
     * @type {string}
     * @memberof TaskspbTaskComment
     */
    'body'?: string;
    /**
     * When the comment was added.
     * @type {string}
     * @memberof TaskspbTaskComment
     */
    'created_at'?: string;
}
/**
 * TaskCommentRequest appends a Markdown note to a task. The author is the invoking user (from the  request context), not a field here.
 * @export
 * @interface TaskspbTaskCommentRequest
 */
export interface TaskspbTaskCommentRequest {
    /**
     * Markdown body of the comment. Required, non-empty.
     * @type {string}
     * @memberof TaskspbTaskCommentRequest
     */
    'body': string;
    /**
     * ID of the task to comment on. Required.
     * @type {string}
     * @memberof TaskspbTaskCommentRequest
     */
    'task_id': string;
}
/**
 * TaskCommentResponse returns the created comment.
 * @export
 * @interface TaskspbTaskCommentResponse
 */
export interface TaskspbTaskCommentResponse {
    /**
     * The comment that was appended.
     * @type {TaskspbTaskComment}
     * @memberof TaskspbTaskCommentResponse
     */
    'comment'?: TaskspbTaskComment;
    /**
     * ID of the commented task.
     * @type {string}
     * @memberof TaskspbTaskCommentResponse
     */
    'task_id'?: string;
}
/**
 * TaskDetail is the full view of a single task.
 * @export
 * @interface TaskspbTaskDetail
 */
export interface TaskspbTaskDetail {
    /**
     * Comments, oldest first.
     * @type {Array<TaskspbTaskComment>}
     * @memberof TaskspbTaskDetail
     */
    'comments'?: Array<TaskspbTaskComment>;
    /**
     * Short human-readable error summary; falls back to error_string when empty.
     * @type {string}
     * @memberof TaskspbTaskDetail
     */
    'display_error'?: string;
    /**
     * Raw error text, if any.
     * @type {string}
     * @memberof TaskspbTaskDetail
     */
    'error_string'?: string;
    /**
     * True when this task is its group\'s representative; actions on it cascade to the whole group.
     * @type {boolean}
     * @memberof TaskspbTaskDetail
     */
    'is_group_representative'?: boolean;
    /**
     * Other live tasks in the same error-fingerprint group.
     * @type {Array<TaskspbTaskRow>}
     * @memberof TaskspbTaskDetail
     */
    'linked_tasks'?: Array<TaskspbTaskRow>;
    /**
     * Audit log entries, oldest first.
     * @type {Array<TaskspbTaskLog>}
     * @memberof TaskspbTaskDetail
     */
    'logs'?: Array<TaskspbTaskLog>;
    /**
     * Source-specific metadata as a JSON object string.
     * @type {string}
     * @memberof TaskspbTaskDetail
     */
    'metadata'?: string;
    /**
     * The task\'s preview fields.
     * @type {TaskspbTaskRow}
     * @memberof TaskspbTaskDetail
     */
    'task'?: TaskspbTaskRow;
}
/**
 * TaskLog is an entry in a task\'s audit log.
 * @export
 * @interface TaskspbTaskLog
 */
export interface TaskspbTaskLog {
    /**
     * Action type (CREATED, REOPENED, CLOSED, ON_HOLD, DELETED, GROUPED, ...).
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'action'?: string;
    /**
     * Actor who performed the action.
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'actor'?: string;
    /**
     * Client software the actor used when it was not the backoffice, user-agent style, e.g.  \"tasks-mcp/1.0.0 (claude-code/2.1.10)\" when a person acted through the tasks MCP. Absent otherwise.
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'client'?: string;
    /**
     * When the action occurred.
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'created_at'?: string;
    /**
     * Team the task was handed to, under the same conditions as previous_team.
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'new_team'?: string;
    /**
     * Team the task was taken from, on ASSIGNED (team changed) and ESCALATED entries recorded since  the audit log stores handovers. Absent otherwise.
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'previous_team'?: string;
    /**
     * The actor\'s justification for the action, when one was supplied: today the reason required to  hand a task to another team (ASSIGNED) or to escalate it to OPS (ESCALATED). Absent for actions  that carry none.
     * @type {string}
     * @memberof TaskspbTaskLog
     */
    'reason'?: string;
}
/**
 * TaskPatch carries the denormalized task columns to set. Every field is optional: a present field is  applied, an absent one is left unchanged. Shared by any task-field update path.
 * @export
 * @interface TaskspbTaskPatch
 */
export interface TaskspbTaskPatch {
    /**
     * Coarse categorization. An empty string clears it.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'area'?: string;
    /**
     * Logistics carrier of the related return process (task\'s denormalized copy).
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'carrier'?: string;
    /**
     * ISO code of the parcel\'s destination country.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'dest_country'?: string;
    /**
     * Short human-readable error summary derived from the raw error.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'display_error'?: string;
    /**
     * Whether the task belongs to a testing ecommerce.
     * @type {boolean}
     * @memberof TaskspbTaskPatch
     */
    'is_testing'?: boolean;
    /**
     * ISO code of the parcel\'s origin country.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'origin_country'?: string;
    /**
     * Ecommerce platform (e.g. SHOPIFY, PRESTASHOP).
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'platform'?: string;
    /**
     * Last known shipping status of the related return process (e.g. COLLECTED).
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'process_shipping_status'?: string;
    /**
     * Start time of the related return process.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'process_started_at'?: string;
    /**
     * Return status of the related return process (e.g. RUNNING).
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'process_status'?: string;
    /**
     * Logistics provider of the related return process (task\'s denormalized copy).
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'provider'?: string;
    /**
     * Identified root cause. An empty string clears it.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'root_cause'?: string;
    /**
     * Finer categorization within area. An empty string clears it.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'sub_area'?: string;
    /**
     * Labels attached to the task; present TagList replaces the whole set.
     * @type {TaskspbTagList}
     * @memberof TaskspbTaskPatch
     */
    'tags'?: TaskspbTagList;
    /**
     * Priority: LOW, MID, HIGH or URGENT.
     * @type {string}
     * @memberof TaskspbTaskPatch
     */
    'urgency'?: string;
}
/**
 * TaskRow is a lightweight task preview for table listings. It carries the linked-task count  (tasks_linked) but not the linked tasks themselves.
 * @export
 * @interface TaskspbTaskRow
 */
export interface TaskspbTaskRow {
    /**
     * Coarse categorization.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'area'?: string;
    /**
     * REVER team the task is assigned to.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'assigned_team'?: string;
    /**
     * User the task is assigned to, if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'assigned_user'?: string;
    /**
     * Logistics carrier of the related return process (e.g. Correos, UPS), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'carrier'?: string;
    /**
     * In grouped mode, the other live tasks in this row\'s error-fingerprint group, nested  under the representative; empty in ungrouped mode. Children never nest further.
     * @type {Array<TaskspbTaskRow>}
     * @memberof TaskspbTaskRow
     */
    'children'?: Array<TaskspbTaskRow>;
    /**
     * Creation time.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'created_at'?: string;
    /**
     * Whole days elapsed since the task was created; a reopen does not restart the count.
     * @type {number}
     * @memberof TaskspbTaskRow
     */
    'days_opened'?: number;
    /**
     * ISO code of the parcel\'s destination country (the warehouse), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'dest_country'?: string;
    /**
     * Short human-readable error summary; falls back to error_string when empty.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'display_error'?: string;
    /**
     * Ecommerce the task relates to, if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'ecommerce_id'?: string;
    /**
     * Raw error text, if any (shown truncated in the table).
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'error_string'?: string;
    /**
     * Ecommerce group the task belongs to (e.g. inditex), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'group_id'?: string;
    /**
     * True when the task belongs to a testing ecommerce.
     * @type {boolean}
     * @memberof TaskspbTaskRow
     */
    'is_testing'?: boolean;
    /**
     * On-hold occurrence this task was raised for (metadata.on_hold_id). Empty for tasks raised before  targeting shipped, and for tasks that do not come from a parked workflow.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'on_hold_id'?: string;
    /**
     * ISO code of the parcel\'s origin country (drop-off/customer/pickup address), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'origin_country'?: string;
    /**
     * Ecommerce platform (e.g. SHOPIFY, PRESTASHOP), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'platform'?: string;
    /**
     * Return process the task relates to, if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'process_id'?: string;
    /**
     * Last known shipping status of the related return process (e.g. CREATED, COLLECTED). Set at task  creation and kept live via the ON_SHIPPING_STATUS_CHANGED event. Empty if unknown.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'process_shipping_status'?: string;
    /**
     * Start time of the related return process, if known.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'process_started_at'?: string;
    /**
     * Return status of the related return process at task creation (e.g. RUNNING). Snapshot; may be  stale. Empty if unknown.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'process_status'?: string;
    /**
     * Logistics provider of the related return process (e.g. NONE, OPS, SendCloud), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'provider'?: string;
    /**
     * Identified root cause.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'root_cause'?: string;
    /**
     * Originating system: RETURNS, EVENTS or MANUAL.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'source'?: string;
    /**
     * Lifecycle status.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'status'?: TaskspbTaskRowStatusEnum;
    /**
     * Finer categorization within area.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'sub_area'?: string;
    /**
     * Labels attached to the task.
     * @type {Array<string>}
     * @memberof TaskspbTaskRow
     */
    'tags'?: Array<string>;
    /**
     * Task ID.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'task_id'?: string;
    /**
     * Number of tasks in the same error-fingerprint group.
     * @type {number}
     * @memberof TaskspbTaskRow
     */
    'tasks_linked'?: number;
    /**
     * Human-readable title.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'title'?: string;
    /**
     * Last update time.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'updated_at'?: string;
    /**
     * Priority: LOW, MID, HIGH or URGENT.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'urgency'?: string;
    /**
     * Workflow activity that originated the task (RETURNS source), if any.
     * @type {string}
     * @memberof TaskspbTaskRow
     */
    'workflow_activity_name'?: string;
}

export const TaskspbTaskRowStatusEnum = {
    Unspecified: 'TASK_STATUS_UNSPECIFIED',
    Open: 'TASK_STATUS_OPEN',
    Closed: 'TASK_STATUS_CLOSED',
    OnHold: 'TASK_STATUS_ON_HOLD',
    Deleted: 'TASK_STATUS_DELETED',
    Actioned: 'TASK_STATUS_ACTIONED'
} as const;

export type TaskspbTaskRowStatusEnum = typeof TaskspbTaskRowStatusEnum[keyof typeof TaskspbTaskRowStatusEnum];

/**
 * TaskTag is a single predefined tag in the catalog.
 * @export
 * @interface TaskspbTaskTag
 */
export interface TaskspbTaskTag {
    /**
     * Tag name; unique case-insensitively.
     * @type {string}
     * @memberof TaskspbTaskTag
     */
    'name'?: string;
    /**
     * Number of non-deleted tasks currently carrying this tag. Only populated by ListTaskTags.
     * @type {number}
     * @memberof TaskspbTaskTag
     */
    'task_count'?: number;
}
/**
 * 
 * @export
 * @interface TaskspbTaskUnlinkRequest
 */
export interface TaskspbTaskUnlinkRequest {
    /**
     * ID of the task to detach from its error group. Required.
     * @type {string}
     * @memberof TaskspbTaskUnlinkRequest
     */
    'task_id': string;
}
/**
 * 
 * @export
 * @interface TaskspbTaskUnlinkResponse
 */
export interface TaskspbTaskUnlinkResponse {
    /**
     * Number of other members detached by auto-dissolve (0 normally, 1 when the group was left with a  single remaining member).
     * @type {number}
     * @memberof TaskspbTaskUnlinkResponse
     */
    'dissolved'?: number;
    /**
     * ID of the unlinked task.
     * @type {string}
     * @memberof TaskspbTaskUnlinkResponse
     */
    'task_id'?: string;
}
/**
 * TeamFlow is the number of handovers from one team to another.
 * @export
 * @interface TaskspbTeamFlow
 */
export interface TaskspbTeamFlow {
    /**
     * Number of tasks handed over.
     * @type {string}
     * @memberof TaskspbTeamFlow
     */
    'count'?: string;
    /**
     * Team the tasks were taken from.
     * @type {string}
     * @memberof TaskspbTeamFlow
     */
    'from_team'?: string;
    /**
     * Team the tasks were handed to.
     * @type {string}
     * @memberof TaskspbTeamFlow
     */
    'to_team'?: string;
}
/**
 * TeamMembership is a team, the ids (emails) of its member users, and its notification settings.
 * @export
 * @interface TaskspbTeamMembership
 */
export interface TaskspbTeamMembership {
    /**
     * Slack channel id notifications for this team are sent to; empty disables notifications.
     * @type {string}
     * @memberof TaskspbTeamMembership
     */
    'slack_channel'?: string;
    /**
     * Team name.
     * @type {string}
     * @memberof TaskspbTeamMembership
     */
    'team'?: string;
    /**
     * Ids of the users that belong to the team.
     * @type {Array<string>}
     * @memberof TaskspbTeamMembership
     */
    'user_ids'?: Array<string>;
}
/**
 * UpdateProcessForTaskRequest updates selected fields on the return process linked to a task. Only  the fields present are applied; unset optional fields are left unchanged. At least one field is  required.
 * @export
 * @interface TaskspbUpdateProcessForTaskRequest
 */
export interface TaskspbUpdateProcessForTaskRequest {
    /**
     * When true, apply the update to every live task in the same error group (best-effort per task,  patching each member\'s own process).
     * @type {boolean}
     * @memberof TaskspbUpdateProcessForTaskRequest
     */
    'apply_to_group'?: boolean;
    /**
     * When present, the new return method for the process, as the models.ReturnMethod enum name.  Only \"DROP_OFF_POINT\" and \"HOME_PICK_UP\" are accepted: the other methods depend on address  state this endpoint cannot set (IN_STORE, DELIVERY_PICKUP) or disable logistics entirely  (NO_RETURN_METHOD).
     * @type {string}
     * @memberof TaskspbUpdateProcessForTaskRequest
     */
    'return_method'?: string;
    /**
     * ID of the task whose linked process should be updated. Required.
     * @type {string}
     * @memberof TaskspbUpdateProcessForTaskRequest
     */
    'task_id': string;
    /**
     * When present, the new user-selected carrier for the process.
     * @type {string}
     * @memberof TaskspbUpdateProcessForTaskRequest
     */
    'user_selected_carrier'?: string;
    /**
     * When present, the new user-selected provider for the process.
     * @type {string}
     * @memberof TaskspbUpdateProcessForTaskRequest
     */
    'user_selected_provider'?: string;
}
/**
 * UpdateProcessForTaskResponse reports how many tasks\' processes were updated.
 * @export
 * @interface TaskspbUpdateProcessForTaskResponse
 */
export interface TaskspbUpdateProcessForTaskResponse {
    /**
     * Number of tasks whose process was successfully updated (1 unless apply_to_group cascaded).
     * @type {number}
     * @memberof TaskspbUpdateProcessForTaskResponse
     */
    'affected'?: number;
    /**
     * Number of group members that could not be updated (apply_to_group only).
     * @type {number}
     * @memberof TaskspbUpdateProcessForTaskResponse
     */
    'failed'?: number;
}
/**
 * UpdateTaskMetadataRequest merges entries into a task\'s metadata (create-or-update per key).
 * @export
 * @interface TaskspbUpdateTaskMetadataRequest
 */
export interface TaskspbUpdateTaskMetadataRequest {
    /**
     * Metadata entries to create or update; other keys are left untouched. Required, non-empty.
     * @type {{ [key: string]: string; }}
     * @memberof TaskspbUpdateTaskMetadataRequest
     */
    'metadata': { [key: string]: string; };
    /**
     * ID of the task. Required.
     * @type {string}
     * @memberof TaskspbUpdateTaskMetadataRequest
     */
    'task_id': string;
}
/**
 * UpdateTaskMetadataResponse echoes the task id.
 * @export
 * @interface TaskspbUpdateTaskMetadataResponse
 */
export interface TaskspbUpdateTaskMetadataResponse {
    /**
     * ID of the updated task.
     * @type {string}
     * @memberof TaskspbUpdateTaskMetadataResponse
     */
    'task_id'?: string;
}
/**
 * UpdateTaskRequest patches a single task\'s denormalized attribute columns.
 * @export
 * @interface TaskspbUpdateTaskRequest
 */
export interface TaskspbUpdateTaskRequest {
    /**
     * Fields to set; only present fields are applied. At least one field is required.
     * @type {TaskspbTaskPatch}
     * @memberof TaskspbUpdateTaskRequest
     */
    'patch': TaskspbTaskPatch;
    /**
     * ID of the task to patch. Required.
     * @type {string}
     * @memberof TaskspbUpdateTaskRequest
     */
    'task_id': string;
}
/**
 * UpdateTaskResponse reports whether the patch changed anything.
 * @export
 * @interface TaskspbUpdateTaskResponse
 */
export interface TaskspbUpdateTaskResponse {
    /**
     * ID of the patched task.
     * @type {string}
     * @memberof TaskspbUpdateTaskResponse
     */
    'task_id'?: string;
    /**
     * True when at least one column changed; false on an idempotent no-op.
     * @type {boolean}
     * @memberof TaskspbUpdateTaskResponse
     */
    'updated'?: boolean;
}
/**
 * UpdateTaskStatusRequest transitions a single task.
 * @export
 * @interface TaskspbUpdateTaskStatusRequest
 */
export interface TaskspbUpdateTaskStatusRequest {
    /**
     * When true and closing, bypass the source close guards (on-hold / failing subscription). Used  when the source is definitively resolved, e.g. the return process was canceled.
     * @type {boolean}
     * @memberof TaskspbUpdateTaskStatusRequest
     */
    'force'?: boolean;
    /**
     * Target status. Required.
     * @type {string}
     * @memberof TaskspbUpdateTaskStatusRequest
     */
    'status': TaskspbUpdateTaskStatusRequestStatusEnum;
    /**
     * ID of the task to transition. Required.
     * @type {string}
     * @memberof TaskspbUpdateTaskStatusRequest
     */
    'task_id': string;
}

export const TaskspbUpdateTaskStatusRequestStatusEnum = {
    Unspecified: 'TASK_STATUS_UNSPECIFIED',
    Open: 'TASK_STATUS_OPEN',
    Closed: 'TASK_STATUS_CLOSED',
    OnHold: 'TASK_STATUS_ON_HOLD',
    Deleted: 'TASK_STATUS_DELETED',
    Actioned: 'TASK_STATUS_ACTIONED'
} as const;

export type TaskspbUpdateTaskStatusRequestStatusEnum = typeof TaskspbUpdateTaskStatusRequestStatusEnum[keyof typeof TaskspbUpdateTaskStatusRequestStatusEnum];

/**
 * UpdateTaskStatusResponse echoes the task and its new status.
 * @export
 * @interface TaskspbUpdateTaskStatusResponse
 */
export interface TaskspbUpdateTaskStatusResponse {
    /**
     * The task\'s status after the transition.
     * @type {string}
     * @memberof TaskspbUpdateTaskStatusResponse
     */
    'status'?: TaskspbUpdateTaskStatusResponseStatusEnum;
    /**
     * ID of the transitioned task.
     * @type {string}
     * @memberof TaskspbUpdateTaskStatusResponse
     */
    'task_id'?: string;
}

export const TaskspbUpdateTaskStatusResponseStatusEnum = {
    Unspecified: 'TASK_STATUS_UNSPECIFIED',
    Open: 'TASK_STATUS_OPEN',
    Closed: 'TASK_STATUS_CLOSED',
    OnHold: 'TASK_STATUS_ON_HOLD',
    Deleted: 'TASK_STATUS_DELETED',
    Actioned: 'TASK_STATUS_ACTIONED'
} as const;

export type TaskspbUpdateTaskStatusResponseStatusEnum = typeof TaskspbUpdateTaskStatusResponseStatusEnum[keyof typeof TaskspbUpdateTaskStatusResponseStatusEnum];

/**
 * UpdateTeamMembershipRequest replaces a team\'s membership.
 * @export
 * @interface TaskspbUpdateTeamMembershipRequest
 */
export interface TaskspbUpdateTeamMembershipRequest {
    /**
     * Team to update. Required.
     * @type {string}
     * @memberof TaskspbUpdateTeamMembershipRequest
     */
    'team': string;
    /**
     * Ids of the users that should belong to the team after the update.
     * @type {Array<string>}
     * @memberof TaskspbUpdateTeamMembershipRequest
     */
    'user_ids'?: Array<string>;
}
/**
 * UpdateTeamMembershipResponse echoes the updated team membership.
 * @export
 * @interface TaskspbUpdateTeamMembershipResponse
 */
export interface TaskspbUpdateTeamMembershipResponse {
    /**
     * The team\'s membership after the update.
     * @type {TaskspbTeamMembership}
     * @memberof TaskspbUpdateTeamMembershipResponse
     */
    'membership'?: TaskspbTeamMembership;
}
/**
 * Payload for the ClassifyFreeTextRequest response
 * @export
 * @interface TicketclassifierpbClassifyFreeTextResponse
 */
export interface TicketclassifierpbClassifyFreeTextResponse {
    /**
     * The classification of the text
     * @type {string}
     * @memberof TicketclassifierpbClassifyFreeTextResponse
     */
    'classification'?: string;
}

/**
 * AIInsightsApi - axios parameter creator
 * @export
 */
export const AIInsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get ai insights for a given ecommerce
         * @param {string} [ecommerceId] Ecommerce ID for which to fetch insights
         * @param {string} [language] Language of the insight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAIInsights: async (ecommerceId?: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/get_ai_insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post ai insights feedback from ecommerce
         * @param {AiinsightspbPostAIInsightsFeedbackRequest} aiinsightspbPostAIInsightsFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAIInsightsFeedback: async (aiinsightspbPostAIInsightsFeedbackRequest: AiinsightspbPostAIInsightsFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiinsightspbPostAIInsightsFeedbackRequest' is not null or undefined
            assertParamExists('postAIInsightsFeedback', 'aiinsightspbPostAIInsightsFeedbackRequest', aiinsightspbPostAIInsightsFeedbackRequest)
            const localVarPath = `/v1/analytics/ai_insights_feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiinsightspbPostAIInsightsFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIInsightsApi - functional programming interface
 * @export
 */
export const AIInsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIInsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get ai insights for a given ecommerce
         * @param {string} [ecommerceId] Ecommerce ID for which to fetch insights
         * @param {string} [language] Language of the insight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAIInsights(ecommerceId?: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiinsightspbAIInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAIInsights(ecommerceId, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIInsightsApi.getAIInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Post ai insights feedback from ecommerce
         * @param {AiinsightspbPostAIInsightsFeedbackRequest} aiinsightspbPostAIInsightsFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAIInsightsFeedback(aiinsightspbPostAIInsightsFeedbackRequest: AiinsightspbPostAIInsightsFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAIInsightsFeedback(aiinsightspbPostAIInsightsFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIInsightsApi.postAIInsightsFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIInsightsApi - factory interface
 * @export
 */
export const AIInsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIInsightsApiFp(configuration)
    return {
        /**
         * Get ai insights for a given ecommerce
         * @param {AIInsightsApiGetAIInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAIInsights(requestParameters: AIInsightsApiGetAIInsightsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AiinsightspbAIInsightsResponse> {
            return localVarFp.getAIInsights(requestParameters.ecommerceId, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         * Post ai insights feedback from ecommerce
         * @param {AIInsightsApiPostAIInsightsFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAIInsightsFeedback(requestParameters: AIInsightsApiPostAIInsightsFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postAIInsightsFeedback(requestParameters.aiinsightspbPostAIInsightsFeedbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAIInsights operation in AIInsightsApi.
 * @export
 * @interface AIInsightsApiGetAIInsightsRequest
 */
export interface AIInsightsApiGetAIInsightsRequest {
    /**
     * Ecommerce ID for which to fetch insights
     * @type {string}
     * @memberof AIInsightsApiGetAIInsights
     */
    readonly ecommerceId?: string

    /**
     * Language of the insight
     * @type {string}
     * @memberof AIInsightsApiGetAIInsights
     */
    readonly language?: string
}

/**
 * Request parameters for postAIInsightsFeedback operation in AIInsightsApi.
 * @export
 * @interface AIInsightsApiPostAIInsightsFeedbackRequest
 */
export interface AIInsightsApiPostAIInsightsFeedbackRequest {
    /**
     * 
     * @type {AiinsightspbPostAIInsightsFeedbackRequest}
     * @memberof AIInsightsApiPostAIInsightsFeedback
     */
    readonly aiinsightspbPostAIInsightsFeedbackRequest: AiinsightspbPostAIInsightsFeedbackRequest
}

/**
 * AIInsightsApi - object-oriented interface
 * @export
 * @class AIInsightsApi
 * @extends {BaseAPI}
 */
export class AIInsightsApi extends BaseAPI {
    /**
     * Get ai insights for a given ecommerce
     * @param {AIInsightsApiGetAIInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIInsightsApi
     */
    public getAIInsights(requestParameters: AIInsightsApiGetAIInsightsRequest = {}, options?: RawAxiosRequestConfig) {
        return AIInsightsApiFp(this.configuration).getAIInsights(requestParameters.ecommerceId, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post ai insights feedback from ecommerce
     * @param {AIInsightsApiPostAIInsightsFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIInsightsApi
     */
    public postAIInsightsFeedback(requestParameters: AIInsightsApiPostAIInsightsFeedbackRequest, options?: RawAxiosRequestConfig) {
        return AIInsightsApiFp(this.configuration).postAIInsightsFeedback(requestParameters.aiinsightspbPostAIInsightsFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppStoreIntegrationsApi - axios parameter creator
 * @export
 */
export const AppStoreIntegrationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get detailed information about a specific integration
         * @param {string} integrationName Name of the integration to get details for
         * @param {string} [ecommerceId] Ecommerce ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationDetails: async (integrationName: string, ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integrationName' is not null or undefined
            assertParamExists('getIntegrationDetails', 'integrationName', integrationName)
            const localVarPath = `/v1/analytics/integrations/{integration_name}/details`
                .replace(`{${"integration_name"}}`, encodeURIComponent(String(integrationName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get integrations status returns the status of all integrations for an ecommerce
         * @param {string} [ecommerceId] ID of the ecommerce to get integrations status for - optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsStatus: async (ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/integrations/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all integrations for marketplace
         * @param {string} [ecommerceId] ID of the ecommerce to check connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableIntegrations: async (ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save integration credentials
         * @param {AppstoreintegrationspbSaveIntegrationCredentialsRequest} appstoreintegrationspbSaveIntegrationCredentialsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIntegrationCredentials: async (appstoreintegrationspbSaveIntegrationCredentialsRequest: AppstoreintegrationspbSaveIntegrationCredentialsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appstoreintegrationspbSaveIntegrationCredentialsRequest' is not null or undefined
            assertParamExists('saveIntegrationCredentials', 'appstoreintegrationspbSaveIntegrationCredentialsRequest', appstoreintegrationspbSaveIntegrationCredentialsRequest)
            const localVarPath = `/v1/analytics/integrations/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appstoreintegrationspbSaveIntegrationCredentialsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppStoreIntegrationsApi - functional programming interface
 * @export
 */
export const AppStoreIntegrationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppStoreIntegrationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get detailed information about a specific integration
         * @param {string} integrationName Name of the integration to get details for
         * @param {string} [ecommerceId] Ecommerce ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntegrationDetails(integrationName: string, ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppstoreintegrationspbGetIntegrationDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationDetails(integrationName, ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppStoreIntegrationsApi.getIntegrationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get integrations status returns the status of all integrations for an ecommerce
         * @param {string} [ecommerceId] ID of the ecommerce to get integrations status for - optional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntegrationsStatus(ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppstoreintegrationspbGetIntegrationsStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntegrationsStatus(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppStoreIntegrationsApi.getIntegrationsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all integrations for marketplace
         * @param {string} [ecommerceId] ID of the ecommerce to check connection status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailableIntegrations(ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppstoreintegrationspbListAvailableIntegrationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailableIntegrations(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppStoreIntegrationsApi.listAvailableIntegrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save integration credentials
         * @param {AppstoreintegrationspbSaveIntegrationCredentialsRequest} appstoreintegrationspbSaveIntegrationCredentialsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveIntegrationCredentials(appstoreintegrationspbSaveIntegrationCredentialsRequest: AppstoreintegrationspbSaveIntegrationCredentialsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveIntegrationCredentials(appstoreintegrationspbSaveIntegrationCredentialsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppStoreIntegrationsApi.saveIntegrationCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppStoreIntegrationsApi - factory interface
 * @export
 */
export const AppStoreIntegrationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppStoreIntegrationsApiFp(configuration)
    return {
        /**
         * Get detailed information about a specific integration
         * @param {AppStoreIntegrationsApiGetIntegrationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationDetails(requestParameters: AppStoreIntegrationsApiGetIntegrationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AppstoreintegrationspbGetIntegrationDetailsResponse> {
            return localVarFp.getIntegrationDetails(requestParameters.integrationName, requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get integrations status returns the status of all integrations for an ecommerce
         * @param {AppStoreIntegrationsApiGetIntegrationsStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntegrationsStatus(requestParameters: AppStoreIntegrationsApiGetIntegrationsStatusRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppstoreintegrationspbGetIntegrationsStatusResponse> {
            return localVarFp.getIntegrationsStatus(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all integrations for marketplace
         * @param {AppStoreIntegrationsApiListAvailableIntegrationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableIntegrations(requestParameters: AppStoreIntegrationsApiListAvailableIntegrationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AppstoreintegrationspbListAvailableIntegrationsResponse> {
            return localVarFp.listAvailableIntegrations(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Save integration credentials
         * @param {AppStoreIntegrationsApiSaveIntegrationCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIntegrationCredentials(requestParameters: AppStoreIntegrationsApiSaveIntegrationCredentialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveIntegrationCredentials(requestParameters.appstoreintegrationspbSaveIntegrationCredentialsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getIntegrationDetails operation in AppStoreIntegrationsApi.
 * @export
 * @interface AppStoreIntegrationsApiGetIntegrationDetailsRequest
 */
export interface AppStoreIntegrationsApiGetIntegrationDetailsRequest {
    /**
     * Name of the integration to get details for
     * @type {string}
     * @memberof AppStoreIntegrationsApiGetIntegrationDetails
     */
    readonly integrationName: string

    /**
     * Ecommerce ID
     * @type {string}
     * @memberof AppStoreIntegrationsApiGetIntegrationDetails
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for getIntegrationsStatus operation in AppStoreIntegrationsApi.
 * @export
 * @interface AppStoreIntegrationsApiGetIntegrationsStatusRequest
 */
export interface AppStoreIntegrationsApiGetIntegrationsStatusRequest {
    /**
     * ID of the ecommerce to get integrations status for - optional
     * @type {string}
     * @memberof AppStoreIntegrationsApiGetIntegrationsStatus
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for listAvailableIntegrations operation in AppStoreIntegrationsApi.
 * @export
 * @interface AppStoreIntegrationsApiListAvailableIntegrationsRequest
 */
export interface AppStoreIntegrationsApiListAvailableIntegrationsRequest {
    /**
     * ID of the ecommerce to check connection status
     * @type {string}
     * @memberof AppStoreIntegrationsApiListAvailableIntegrations
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for saveIntegrationCredentials operation in AppStoreIntegrationsApi.
 * @export
 * @interface AppStoreIntegrationsApiSaveIntegrationCredentialsRequest
 */
export interface AppStoreIntegrationsApiSaveIntegrationCredentialsRequest {
    /**
     * 
     * @type {AppstoreintegrationspbSaveIntegrationCredentialsRequest}
     * @memberof AppStoreIntegrationsApiSaveIntegrationCredentials
     */
    readonly appstoreintegrationspbSaveIntegrationCredentialsRequest: AppstoreintegrationspbSaveIntegrationCredentialsRequest
}

/**
 * AppStoreIntegrationsApi - object-oriented interface
 * @export
 * @class AppStoreIntegrationsApi
 * @extends {BaseAPI}
 */
export class AppStoreIntegrationsApi extends BaseAPI {
    /**
     * Get detailed information about a specific integration
     * @param {AppStoreIntegrationsApiGetIntegrationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppStoreIntegrationsApi
     */
    public getIntegrationDetails(requestParameters: AppStoreIntegrationsApiGetIntegrationDetailsRequest, options?: RawAxiosRequestConfig) {
        return AppStoreIntegrationsApiFp(this.configuration).getIntegrationDetails(requestParameters.integrationName, requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get integrations status returns the status of all integrations for an ecommerce
     * @param {AppStoreIntegrationsApiGetIntegrationsStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppStoreIntegrationsApi
     */
    public getIntegrationsStatus(requestParameters: AppStoreIntegrationsApiGetIntegrationsStatusRequest = {}, options?: RawAxiosRequestConfig) {
        return AppStoreIntegrationsApiFp(this.configuration).getIntegrationsStatus(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all integrations for marketplace
     * @param {AppStoreIntegrationsApiListAvailableIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppStoreIntegrationsApi
     */
    public listAvailableIntegrations(requestParameters: AppStoreIntegrationsApiListAvailableIntegrationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AppStoreIntegrationsApiFp(this.configuration).listAvailableIntegrations(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save integration credentials
     * @param {AppStoreIntegrationsApiSaveIntegrationCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppStoreIntegrationsApi
     */
    public saveIntegrationCredentials(requestParameters: AppStoreIntegrationsApiSaveIntegrationCredentialsRequest, options?: RawAxiosRequestConfig) {
        return AppStoreIntegrationsApiFp(this.configuration).saveIntegrationCredentials(requestParameters.appstoreintegrationspbSaveIntegrationCredentialsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BillingApi - axios parameter creator
 * @export
 */
export const BillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a temporary link to one of the documents generated next to an invoice
         * @param {string} invoiceId The stripe invoice the document belongs to. Required.
         * @param {string} [ecommerceId] The id of the e-commerce. Required.
         * @param {GetInvoiceFileURLFileEnum} [file] Which document to download. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceFileURL: async (invoiceId: string, ecommerceId?: string, file?: GetInvoiceFileURLFileEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('getInvoiceFileURL', 'invoiceId', invoiceId)
            const localVarPath = `/v1/invoicing/invoices/{invoice_id}/file`
                .replace(`{${"invoice_id"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (file !== undefined) {
                localVarQueryParameter['file'] = file;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the e-commerces REVER invoices, among the one or the group asked for
         * @param {string} [ecommerceId] The id of one e-commerce to ask about. Optional, takes precedence over the group.
         * @param {string} [slug] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {string} [group] The group whose e-commerces to ask about. Used when no e-commerce id is given.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicedEcommerces: async (ecommerceId?: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/invoicing/portals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the invoices REVER issued to the e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce. Required.
         * @param {string} [slug] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {string} [group] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices: async (ecommerceId?: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/invoicing/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a url to redirect the user to the stripe customer portal
         * @param {string} [ecommerceId] The id of the e-commerce. Required.
         * @param {string} [slug] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {string} [group] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicingPortalURL: async (ecommerceId?: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/invoicing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingApi - functional programming interface
 * @export
 */
export const BillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BillingApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a temporary link to one of the documents generated next to an invoice
         * @param {string} invoiceId The stripe invoice the document belongs to. Required.
         * @param {string} [ecommerceId] The id of the e-commerce. Required.
         * @param {GetInvoiceFileURLFileEnum} [file] Which document to download. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceFileURL(invoiceId: string, ecommerceId?: string, file?: GetInvoiceFileURLFileEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingapipbGetInvoiceFileURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceFileURL(invoiceId, ecommerceId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getInvoiceFileURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the e-commerces REVER invoices, among the one or the group asked for
         * @param {string} [ecommerceId] The id of one e-commerce to ask about. Optional, takes precedence over the group.
         * @param {string} [slug] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {string} [group] The group whose e-commerces to ask about. Used when no e-commerce id is given.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicedEcommerces(ecommerceId?: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingapipbECommerceIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicedEcommerces(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getInvoicedEcommerces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the invoices REVER issued to the e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce. Required.
         * @param {string} [slug] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {string} [group] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoices(ecommerceId?: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingapipbGetInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoices(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a url to redirect the user to the stripe customer portal
         * @param {string} [ecommerceId] The id of the e-commerce. Required.
         * @param {string} [slug] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {string} [group] Accepted and ignored, so the published request shape is the one settings-api served.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicingPortalURL(ecommerceId?: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingapipbStripeCustomerPortalURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicingPortalURL(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BillingApi.getInvoicingPortalURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BillingApi - factory interface
 * @export
 */
export const BillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BillingApiFp(configuration)
    return {
        /**
         * Get a temporary link to one of the documents generated next to an invoice
         * @param {BillingApiGetInvoiceFileURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceFileURL(requestParameters: BillingApiGetInvoiceFileURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingapipbGetInvoiceFileURLResponse> {
            return localVarFp.getInvoiceFileURL(requestParameters.invoiceId, requestParameters.ecommerceId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * List the e-commerces REVER invoices, among the one or the group asked for
         * @param {BillingApiGetInvoicedEcommercesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicedEcommerces(requestParameters: BillingApiGetInvoicedEcommercesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingapipbECommerceIdResponse> {
            return localVarFp.getInvoicedEcommerces(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * List the invoices REVER issued to the e-commerce
         * @param {BillingApiGetInvoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoices(requestParameters: BillingApiGetInvoicesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingapipbGetInvoicesResponse> {
            return localVarFp.getInvoices(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a url to redirect the user to the stripe customer portal
         * @param {BillingApiGetInvoicingPortalURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicingPortalURL(requestParameters: BillingApiGetInvoicingPortalURLRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingapipbStripeCustomerPortalURL> {
            return localVarFp.getInvoicingPortalURL(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getInvoiceFileURL operation in BillingApi.
 * @export
 * @interface BillingApiGetInvoiceFileURLRequest
 */
export interface BillingApiGetInvoiceFileURLRequest {
    /**
     * The stripe invoice the document belongs to. Required.
     * @type {string}
     * @memberof BillingApiGetInvoiceFileURL
     */
    readonly invoiceId: string

    /**
     * The id of the e-commerce. Required.
     * @type {string}
     * @memberof BillingApiGetInvoiceFileURL
     */
    readonly ecommerceId?: string

    /**
     * Which document to download. Required.
     * @type {'INVOICE_FILE_UNSPECIFIED' | 'INVOICE_FILE_BREAKDOWN' | 'INVOICE_FILE_SUPPLIED_NOTE'}
     * @memberof BillingApiGetInvoiceFileURL
     */
    readonly file?: GetInvoiceFileURLFileEnum
}

/**
 * Request parameters for getInvoicedEcommerces operation in BillingApi.
 * @export
 * @interface BillingApiGetInvoicedEcommercesRequest
 */
export interface BillingApiGetInvoicedEcommercesRequest {
    /**
     * The id of one e-commerce to ask about. Optional, takes precedence over the group.
     * @type {string}
     * @memberof BillingApiGetInvoicedEcommerces
     */
    readonly ecommerceId?: string

    /**
     * Accepted and ignored, so the published request shape is the one settings-api served.
     * @type {string}
     * @memberof BillingApiGetInvoicedEcommerces
     */
    readonly slug?: string

    /**
     * The group whose e-commerces to ask about. Used when no e-commerce id is given.
     * @type {string}
     * @memberof BillingApiGetInvoicedEcommerces
     */
    readonly group?: string
}

/**
 * Request parameters for getInvoices operation in BillingApi.
 * @export
 * @interface BillingApiGetInvoicesRequest
 */
export interface BillingApiGetInvoicesRequest {
    /**
     * The id of the e-commerce. Required.
     * @type {string}
     * @memberof BillingApiGetInvoices
     */
    readonly ecommerceId?: string

    /**
     * Accepted and ignored, so the published request shape is the one settings-api served.
     * @type {string}
     * @memberof BillingApiGetInvoices
     */
    readonly slug?: string

    /**
     * Accepted and ignored, so the published request shape is the one settings-api served.
     * @type {string}
     * @memberof BillingApiGetInvoices
     */
    readonly group?: string
}

/**
 * Request parameters for getInvoicingPortalURL operation in BillingApi.
 * @export
 * @interface BillingApiGetInvoicingPortalURLRequest
 */
export interface BillingApiGetInvoicingPortalURLRequest {
    /**
     * The id of the e-commerce. Required.
     * @type {string}
     * @memberof BillingApiGetInvoicingPortalURL
     */
    readonly ecommerceId?: string

    /**
     * Accepted and ignored, so the published request shape is the one settings-api served.
     * @type {string}
     * @memberof BillingApiGetInvoicingPortalURL
     */
    readonly slug?: string

    /**
     * Accepted and ignored, so the published request shape is the one settings-api served.
     * @type {string}
     * @memberof BillingApiGetInvoicingPortalURL
     */
    readonly group?: string
}

/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
export class BillingApi extends BaseAPI {
    /**
     * Get a temporary link to one of the documents generated next to an invoice
     * @param {BillingApiGetInvoiceFileURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getInvoiceFileURL(requestParameters: BillingApiGetInvoiceFileURLRequest, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getInvoiceFileURL(requestParameters.invoiceId, requestParameters.ecommerceId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the e-commerces REVER invoices, among the one or the group asked for
     * @param {BillingApiGetInvoicedEcommercesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getInvoicedEcommerces(requestParameters: BillingApiGetInvoicedEcommercesRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getInvoicedEcommerces(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the invoices REVER issued to the e-commerce
     * @param {BillingApiGetInvoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getInvoices(requestParameters: BillingApiGetInvoicesRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getInvoices(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a url to redirect the user to the stripe customer portal
     * @param {BillingApiGetInvoicingPortalURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    public getInvoicingPortalURL(requestParameters: BillingApiGetInvoicingPortalURLRequest = {}, options?: RawAxiosRequestConfig) {
        return BillingApiFp(this.configuration).getInvoicingPortalURL(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetInvoiceFileURLFileEnum = {
    Unspecified: 'INVOICE_FILE_UNSPECIFIED',
    Breakdown: 'INVOICE_FILE_BREAKDOWN',
    SuppliedNote: 'INVOICE_FILE_SUPPLIED_NOTE'
} as const;
export type GetInvoiceFileURLFileEnum = typeof GetInvoiceFileURLFileEnum[keyof typeof GetInvoiceFileURLFileEnum];


/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Chat answers the user\'s message in the context of the screen they are on  (carried in payload.current_tab) and returns the assistant\'s reply plus an  optional per-tab result.
         * @param {string} ecommerceId Ecommerce ID the conversation is about. Required.
         * @param {ChatpbChatRequest} chatpbChatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat: async (ecommerceId: string, chatpbChatRequest: ChatpbChatRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('chat', 'ecommerceId', ecommerceId)
            // verify required parameter 'chatpbChatRequest' is not null or undefined
            assertParamExists('chat', 'chatpbChatRequest', chatpbChatRequest)
            const localVarPath = `/v1/analytics/ecommerce/{ecommerce_id}/chat`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatpbChatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Chat answers the user\'s message in the context of the screen they are on  (carried in payload.current_tab) and returns the assistant\'s reply plus an  optional per-tab result.
         * @param {string} ecommerceId Ecommerce ID the conversation is about. Required.
         * @param {ChatpbChatRequest} chatpbChatRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chat(ecommerceId: string, chatpbChatRequest: ChatpbChatRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatpbChatResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chat(ecommerceId, chatpbChatRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * Chat answers the user\'s message in the context of the screen they are on  (carried in payload.current_tab) and returns the assistant\'s reply plus an  optional per-tab result.
         * @param {ChatApiChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chat(requestParameters: ChatApiChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatpbChatResponse> {
            return localVarFp.chat(requestParameters.ecommerceId, requestParameters.chatpbChatRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for chat operation in ChatApi.
 * @export
 * @interface ChatApiChatRequest
 */
export interface ChatApiChatRequest {
    /**
     * Ecommerce ID the conversation is about. Required.
     * @type {string}
     * @memberof ChatApiChat
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ChatpbChatRequest}
     * @memberof ChatApiChat
     */
    readonly chatpbChatRequest: ChatpbChatRequest
}

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * Chat answers the user\'s message in the context of the screen they are on  (carried in payload.current_tab) and returns the assistant\'s reply plus an  optional per-tab result.
     * @param {ChatApiChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chat(requestParameters: ChatApiChatRequest, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chat(requestParameters.ecommerceId, requestParameters.chatpbChatRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomIntegrationV1DirectStubApi - axios parameter creator
 * @export
 */
export const CustomIntegrationV1DirectStubApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an exchange order on the merchant side. Mirrors  create_order_url_template.
         * @param {Pbcustomv1directstubCreateOrderRequest} pbcustomv1directstubCreateOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeCreateOrder: async (pbcustomv1directstubCreateOrderRequest: Pbcustomv1directstubCreateOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbcustomv1directstubCreateOrderRequest' is not null or undefined
            assertParamExists('storeCreateOrder', 'pbcustomv1directstubCreateOrderRequest', pbcustomv1directstubCreateOrderRequest)
            const localVarPath = `/rever/v1-direct-stub/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv1directstubCreateOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue a promocode for a return. Mirrors create_promocode_url_template.  The real custom/direct client only checks the HTTP status of this call  and discards the body (it generates the code client-side), so the  response is empty.
         * @param {Pbcustomv1directstubCreatePromocodeRequest} pbcustomv1directstubCreatePromocodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeCreatePromocode: async (pbcustomv1directstubCreatePromocodeRequest: Pbcustomv1directstubCreatePromocodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbcustomv1directstubCreatePromocodeRequest' is not null or undefined
            assertParamExists('storeCreatePromocode', 'pbcustomv1directstubCreatePromocodeRequest', pbcustomv1directstubCreatePromocodeRequest)
            const localVarPath = `/rever/v1-direct-stub/promocodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv1directstubCreatePromocodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete a return on the merchant side. Mirrors  create_return_url_template.
         * @param {Pbcustomv1directstubCreateReturnRequest} pbcustomv1directstubCreateReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeCreateReturn: async (pbcustomv1directstubCreateReturnRequest: Pbcustomv1directstubCreateReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbcustomv1directstubCreateReturnRequest' is not null or undefined
            assertParamExists('storeCreateReturn', 'pbcustomv1directstubCreateReturnRequest', pbcustomv1directstubCreateReturnRequest)
            const localVarPath = `/rever/v1-direct-stub/returns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv1directstubCreateReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find an order by its customer-facing order number. Mirrors  find_order_url_template.   The order number picks a test scenario (case-insensitive, surrounding  spaces ignored). Every order belongs to harry.potter@hogwarts.wiz.   | Order number   | Answer                                                          |  |----------------|-----------------------------------------------------------------|  | `QQS-404`      | 404 Not Found                                                   |  | `QQS-OLD`      | Fulfilled October 2024, every line is past the return window    |  | `QQS-ALLFINAL` | Every line is non-returnable (final sale)                       |  | `QQS-EUR`      | Shop currency GBP, customer currency EUR, exchange_rate 0.85    |  | anything else  | The default order, fulfilled yesterday                          |
         * @param {string} orderNumber Customer-facing order number, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeFindOrder: async (orderNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('storeFindOrder', 'orderNumber', orderNumber)
            const localVarPath = `/rever/v1-direct-stub/orders/{order_number}`
                .replace(`{${"order_number"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomIntegrationV1DirectStubApi - functional programming interface
 * @export
 */
export const CustomIntegrationV1DirectStubApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomIntegrationV1DirectStubApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an exchange order on the merchant side. Mirrors  create_order_url_template.
         * @param {Pbcustomv1directstubCreateOrderRequest} pbcustomv1directstubCreateOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeCreateOrder(pbcustomv1directstubCreateOrderRequest: Pbcustomv1directstubCreateOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv1directstubCreateOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeCreateOrder(pbcustomv1directstubCreateOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV1DirectStubApi.storeCreateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue a promocode for a return. Mirrors create_promocode_url_template.  The real custom/direct client only checks the HTTP status of this call  and discards the body (it generates the code client-side), so the  response is empty.
         * @param {Pbcustomv1directstubCreatePromocodeRequest} pbcustomv1directstubCreatePromocodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeCreatePromocode(pbcustomv1directstubCreatePromocodeRequest: Pbcustomv1directstubCreatePromocodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeCreatePromocode(pbcustomv1directstubCreatePromocodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV1DirectStubApi.storeCreatePromocode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete a return on the merchant side. Mirrors  create_return_url_template.
         * @param {Pbcustomv1directstubCreateReturnRequest} pbcustomv1directstubCreateReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeCreateReturn(pbcustomv1directstubCreateReturnRequest: Pbcustomv1directstubCreateReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv1directstubCreateReturnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeCreateReturn(pbcustomv1directstubCreateReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV1DirectStubApi.storeCreateReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find an order by its customer-facing order number. Mirrors  find_order_url_template.   The order number picks a test scenario (case-insensitive, surrounding  spaces ignored). Every order belongs to harry.potter@hogwarts.wiz.   | Order number   | Answer                                                          |  |----------------|-----------------------------------------------------------------|  | `QQS-404`      | 404 Not Found                                                   |  | `QQS-OLD`      | Fulfilled October 2024, every line is past the return window    |  | `QQS-ALLFINAL` | Every line is non-returnable (final sale)                       |  | `QQS-EUR`      | Shop currency GBP, customer currency EUR, exchange_rate 0.85    |  | anything else  | The default order, fulfilled yesterday                          |
         * @param {string} orderNumber Customer-facing order number, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeFindOrder(orderNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv1directstubOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeFindOrder(orderNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV1DirectStubApi.storeFindOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomIntegrationV1DirectStubApi - factory interface
 * @export
 */
export const CustomIntegrationV1DirectStubApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomIntegrationV1DirectStubApiFp(configuration)
    return {
        /**
         * Create an exchange order on the merchant side. Mirrors  create_order_url_template.
         * @param {CustomIntegrationV1DirectStubApiStoreCreateOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeCreateOrder(requestParameters: CustomIntegrationV1DirectStubApiStoreCreateOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv1directstubCreateOrderResponse> {
            return localVarFp.storeCreateOrder(requestParameters.pbcustomv1directstubCreateOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue a promocode for a return. Mirrors create_promocode_url_template.  The real custom/direct client only checks the HTTP status of this call  and discards the body (it generates the code client-side), so the  response is empty.
         * @param {CustomIntegrationV1DirectStubApiStoreCreatePromocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeCreatePromocode(requestParameters: CustomIntegrationV1DirectStubApiStoreCreatePromocodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.storeCreatePromocode(requestParameters.pbcustomv1directstubCreatePromocodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete a return on the merchant side. Mirrors  create_return_url_template.
         * @param {CustomIntegrationV1DirectStubApiStoreCreateReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeCreateReturn(requestParameters: CustomIntegrationV1DirectStubApiStoreCreateReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv1directstubCreateReturnResponse> {
            return localVarFp.storeCreateReturn(requestParameters.pbcustomv1directstubCreateReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Find an order by its customer-facing order number. Mirrors  find_order_url_template.   The order number picks a test scenario (case-insensitive, surrounding  spaces ignored). Every order belongs to harry.potter@hogwarts.wiz.   | Order number   | Answer                                                          |  |----------------|-----------------------------------------------------------------|  | `QQS-404`      | 404 Not Found                                                   |  | `QQS-OLD`      | Fulfilled October 2024, every line is past the return window    |  | `QQS-ALLFINAL` | Every line is non-returnable (final sale)                       |  | `QQS-EUR`      | Shop currency GBP, customer currency EUR, exchange_rate 0.85    |  | anything else  | The default order, fulfilled yesterday                          |
         * @param {CustomIntegrationV1DirectStubApiStoreFindOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeFindOrder(requestParameters: CustomIntegrationV1DirectStubApiStoreFindOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv1directstubOrder> {
            return localVarFp.storeFindOrder(requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for storeCreateOrder operation in CustomIntegrationV1DirectStubApi.
 * @export
 * @interface CustomIntegrationV1DirectStubApiStoreCreateOrderRequest
 */
export interface CustomIntegrationV1DirectStubApiStoreCreateOrderRequest {
    /**
     * 
     * @type {Pbcustomv1directstubCreateOrderRequest}
     * @memberof CustomIntegrationV1DirectStubApiStoreCreateOrder
     */
    readonly pbcustomv1directstubCreateOrderRequest: Pbcustomv1directstubCreateOrderRequest
}

/**
 * Request parameters for storeCreatePromocode operation in CustomIntegrationV1DirectStubApi.
 * @export
 * @interface CustomIntegrationV1DirectStubApiStoreCreatePromocodeRequest
 */
export interface CustomIntegrationV1DirectStubApiStoreCreatePromocodeRequest {
    /**
     * 
     * @type {Pbcustomv1directstubCreatePromocodeRequest}
     * @memberof CustomIntegrationV1DirectStubApiStoreCreatePromocode
     */
    readonly pbcustomv1directstubCreatePromocodeRequest: Pbcustomv1directstubCreatePromocodeRequest
}

/**
 * Request parameters for storeCreateReturn operation in CustomIntegrationV1DirectStubApi.
 * @export
 * @interface CustomIntegrationV1DirectStubApiStoreCreateReturnRequest
 */
export interface CustomIntegrationV1DirectStubApiStoreCreateReturnRequest {
    /**
     * 
     * @type {Pbcustomv1directstubCreateReturnRequest}
     * @memberof CustomIntegrationV1DirectStubApiStoreCreateReturn
     */
    readonly pbcustomv1directstubCreateReturnRequest: Pbcustomv1directstubCreateReturnRequest
}

/**
 * Request parameters for storeFindOrder operation in CustomIntegrationV1DirectStubApi.
 * @export
 * @interface CustomIntegrationV1DirectStubApiStoreFindOrderRequest
 */
export interface CustomIntegrationV1DirectStubApiStoreFindOrderRequest {
    /**
     * Customer-facing order number, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV1DirectStubApiStoreFindOrder
     */
    readonly orderNumber: string
}

/**
 * CustomIntegrationV1DirectStubApi - object-oriented interface
 * @export
 * @class CustomIntegrationV1DirectStubApi
 * @extends {BaseAPI}
 */
export class CustomIntegrationV1DirectStubApi extends BaseAPI {
    /**
     * Create an exchange order on the merchant side. Mirrors  create_order_url_template.
     * @param {CustomIntegrationV1DirectStubApiStoreCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV1DirectStubApi
     */
    public storeCreateOrder(requestParameters: CustomIntegrationV1DirectStubApiStoreCreateOrderRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV1DirectStubApiFp(this.configuration).storeCreateOrder(requestParameters.pbcustomv1directstubCreateOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue a promocode for a return. Mirrors create_promocode_url_template.  The real custom/direct client only checks the HTTP status of this call  and discards the body (it generates the code client-side), so the  response is empty.
     * @param {CustomIntegrationV1DirectStubApiStoreCreatePromocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV1DirectStubApi
     */
    public storeCreatePromocode(requestParameters: CustomIntegrationV1DirectStubApiStoreCreatePromocodeRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV1DirectStubApiFp(this.configuration).storeCreatePromocode(requestParameters.pbcustomv1directstubCreatePromocodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete a return on the merchant side. Mirrors  create_return_url_template.
     * @param {CustomIntegrationV1DirectStubApiStoreCreateReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV1DirectStubApi
     */
    public storeCreateReturn(requestParameters: CustomIntegrationV1DirectStubApiStoreCreateReturnRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV1DirectStubApiFp(this.configuration).storeCreateReturn(requestParameters.pbcustomv1directstubCreateReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find an order by its customer-facing order number. Mirrors  find_order_url_template.   The order number picks a test scenario (case-insensitive, surrounding  spaces ignored). Every order belongs to harry.potter@hogwarts.wiz.   | Order number   | Answer                                                          |  |----------------|-----------------------------------------------------------------|  | `QQS-404`      | 404 Not Found                                                   |  | `QQS-OLD`      | Fulfilled October 2024, every line is past the return window    |  | `QQS-ALLFINAL` | Every line is non-returnable (final sale)                       |  | `QQS-EUR`      | Shop currency GBP, customer currency EUR, exchange_rate 0.85    |  | anything else  | The default order, fulfilled yesterday                          |
     * @param {CustomIntegrationV1DirectStubApiStoreFindOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV1DirectStubApi
     */
    public storeFindOrder(requestParameters: CustomIntegrationV1DirectStubApiStoreFindOrderRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV1DirectStubApiFp(this.configuration).storeFindOrder(requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomIntegrationV2StubApi - axios parameter creator
 * @export
 */
export const CustomIntegrationV2StubApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel an exchange order REVER created through POST /rever/v2/orders  that is no longer needed (the return was canceled or its review  declined). Optional: implement it only if you implement  POST /rever/v2/orders; REVER calls it only once it is enabled for you.   All or nothing: if no unit has shipped, cancel every unit and put it  back in stock (`CANCELED`). If any unit has been handed to a carrier,  change nothing and answer `ALREADY_SHIPPED`, even if the other units are  canceled. An order canceled with nothing shipped answers  `ALREADY_CANCELED`. All three are 200, with the state of every line after  the call. Check and cancel atomically: the order must not ship between  the two.   Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{order_id}:cancel\"` and replays it on retry; a replay  may answer the original body or `ALREADY_CANCELED`.   Errors: 404 when the order is unknown. 409 when the order cannot be  canceled for another reason (already being picked, locked by the ERP):  as for POST /rever/v2/orders, REVER treats it as final, does not retry,  and the merchant handles the order by hand. 501 when canceling is not  supported. Any other status (400, 5xx) or a timeout is retried.
         * @param {string} orderId Internal id of the exchange order, as returned by POST /rever/v2/orders.  Set in the path.
         * @param {Pbcustomv2stubCancelExchangeOrderRequest} pbcustomv2stubCancelExchangeOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelExchangeOrder: async (orderId: string, pbcustomv2stubCancelExchangeOrderRequest: Pbcustomv2stubCancelExchangeOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelExchangeOrder', 'orderId', orderId)
            // verify required parameter 'pbcustomv2stubCancelExchangeOrderRequest' is not null or undefined
            assertParamExists('cancelExchangeOrder', 'pbcustomv2stubCancelExchangeOrderRequest', pbcustomv2stubCancelExchangeOrderRequest)
            const localVarPath = `/rever/v2/orders/{order_id}/cancel`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv2stubCancelExchangeOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a gift card. Returns 409 if the gift card has been fully  redeemed.
         * @param {string} platformId Ecommerce-side gift card identifier, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelGiftCard: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('cancelGiftCard', 'platformId', platformId)
            const localVarPath = `/rever/v2/giftcards/{platform_id}`
                .replace(`{${"platform_id"}}`, encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a promocode. Returns 409 if the promocode has already been used  and cannot be cancelled.
         * @param {string} code Promocode value, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPromocode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('cancelPromocode', 'code', code)
            const localVarPath = `/rever/v2/promocodes/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an exchange order on the ecommerce platform. Optional —  implement only if the ecommerce supports exchanges through the REVER  portal. Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{return_id}:exchange\"` and replays it on retry; a  second call must return the originally-created order, not a duplicate.  Answer 409 when the order cannot be created (out of stock, product  unavailable): REVER treats it as final and does not retry.
         * @param {Pbcustomv2stubCreateExchangeOrderRequest} pbcustomv2stubCreateExchangeOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeOrder: async (pbcustomv2stubCreateExchangeOrderRequest: Pbcustomv2stubCreateExchangeOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbcustomv2stubCreateExchangeOrderRequest' is not null or undefined
            assertParamExists('createExchangeOrder', 'pbcustomv2stubCreateExchangeOrderRequest', pbcustomv2stubCreateExchangeOrderRequest)
            const localVarPath = `/rever/v2/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv2stubCreateExchangeOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue a gift card for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:giftcard\"` and replays  it on retry.
         * @param {Pbcustomv2stubCreateGiftCardRequest} pbcustomv2stubCreateGiftCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCard: async (pbcustomv2stubCreateGiftCardRequest: Pbcustomv2stubCreateGiftCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbcustomv2stubCreateGiftCardRequest' is not null or undefined
            assertParamExists('createGiftCard', 'pbcustomv2stubCreateGiftCardRequest', pbcustomv2stubCreateGiftCardRequest)
            const localVarPath = `/rever/v2/giftcards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv2stubCreateGiftCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue a promocode for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:promocode\"` and replays  it on retry. A second call with the same key must return the originally  issued code, not a new one.
         * @param {Pbcustomv2stubCreatePromocodeRequest} pbcustomv2stubCreatePromocodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromocode: async (pbcustomv2stubCreatePromocodeRequest: Pbcustomv2stubCreatePromocodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbcustomv2stubCreatePromocodeRequest' is not null or undefined
            assertParamExists('createPromocode', 'pbcustomv2stubCreatePromocodeRequest', pbcustomv2stubCreatePromocodeRequest)
            const localVarPath = `/rever/v2/promocodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbcustomv2stubCreatePromocodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the state of a previously issued gift card, including its current  balance.
         * @param {string} platformId Ecommerce-side gift card identifier, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCard: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('getGiftCard', 'platformId', platformId)
            const localVarPath = `/rever/v2/giftcards/{platform_id}`
                .replace(`{${"platform_id"}}`, encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the category hierarchy (menu + sub-menus) shown in the REVER  exchange catalog navigation.
         * @param {string} [countryCode] Optional ISO 3166-1 alpha-2 country code.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenu: async (countryCode?: string, lang?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rever/v2/menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an order by its internal id (the platform\'s own identifier).
         * @param {string} orderId Internal order id, as set in the path.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code, query parameter &#x60;lang&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById: async (orderId: string, lang?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderById', 'orderId', orderId)
            const localVarPath = `/rever/v2/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an order by its customer-facing order number. Returns the single  matching order (404 if no match, 200 if exactly one).
         * @param {string} [orderNumber] Customer-facing order number without prefix or suffix (e.g. &#x60;12345&#x60;, not &#x60;#12345&#x60;).
         * @param {string} [lang] Optional ISO 639-1 two-letter language code, query parameter &#x60;lang&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByNumber: async (orderNumber?: string, lang?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rever/v2/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the payment transactions of an order — sales, captures, refunds,  voids — so REVER can issue refunds through the same processor that took  the original payment.
         * @param {string} orderId Internal order id, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTransactions: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderTransactions', 'orderId', orderId)
            const localVarPath = `/rever/v2/orders/{order_id}/transactions`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single product with full variant detail.
         * @param {string} productId Product id, as set in the path.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: async (productId: string, lang?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProduct', 'productId', productId)
            const localVarPath = `/rever/v2/products/{product_id}`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the state of a previously issued promocode.
         * @param {string} code Promocode value, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromocode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getPromocode', 'code', code)
            const localVarPath = `/rever/v2/promocodes/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List active products (paginated by offset). REVER walks `offset` from 0  upward in steps of `page_size` until `page_info.has_next_page` is false.  Products that disappear between syncs are treated as removed.
         * @param {number} [offset] Zero-based index of the first product to return. Default 0.
         * @param {number} [pageSize] Maximum number of products to return per page. Default 50, max 100.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: async (offset?: number, pageSize?: number, lang?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rever/v2/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomIntegrationV2StubApi - functional programming interface
 * @export
 */
export const CustomIntegrationV2StubApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomIntegrationV2StubApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel an exchange order REVER created through POST /rever/v2/orders  that is no longer needed (the return was canceled or its review  declined). Optional: implement it only if you implement  POST /rever/v2/orders; REVER calls it only once it is enabled for you.   All or nothing: if no unit has shipped, cancel every unit and put it  back in stock (`CANCELED`). If any unit has been handed to a carrier,  change nothing and answer `ALREADY_SHIPPED`, even if the other units are  canceled. An order canceled with nothing shipped answers  `ALREADY_CANCELED`. All three are 200, with the state of every line after  the call. Check and cancel atomically: the order must not ship between  the two.   Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{order_id}:cancel\"` and replays it on retry; a replay  may answer the original body or `ALREADY_CANCELED`.   Errors: 404 when the order is unknown. 409 when the order cannot be  canceled for another reason (already being picked, locked by the ERP):  as for POST /rever/v2/orders, REVER treats it as final, does not retry,  and the merchant handles the order by hand. 501 when canceling is not  supported. Any other status (400, 5xx) or a timeout is retried.
         * @param {string} orderId Internal id of the exchange order, as returned by POST /rever/v2/orders.  Set in the path.
         * @param {Pbcustomv2stubCancelExchangeOrderRequest} pbcustomv2stubCancelExchangeOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelExchangeOrder(orderId: string, pbcustomv2stubCancelExchangeOrderRequest: Pbcustomv2stubCancelExchangeOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubCancelExchangeOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelExchangeOrder(orderId, pbcustomv2stubCancelExchangeOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.cancelExchangeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a gift card. Returns 409 if the gift card has been fully  redeemed.
         * @param {string} platformId Ecommerce-side gift card identifier, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelGiftCard(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelGiftCard(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.cancelGiftCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a promocode. Returns 409 if the promocode has already been used  and cannot be cancelled.
         * @param {string} code Promocode value, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelPromocode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelPromocode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.cancelPromocode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an exchange order on the ecommerce platform. Optional —  implement only if the ecommerce supports exchanges through the REVER  portal. Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{return_id}:exchange\"` and replays it on retry; a  second call must return the originally-created order, not a duplicate.  Answer 409 when the order cannot be created (out of stock, product  unavailable): REVER treats it as final and does not retry.
         * @param {Pbcustomv2stubCreateExchangeOrderRequest} pbcustomv2stubCreateExchangeOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExchangeOrder(pbcustomv2stubCreateExchangeOrderRequest: Pbcustomv2stubCreateExchangeOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubCreateExchangeOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExchangeOrder(pbcustomv2stubCreateExchangeOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.createExchangeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue a gift card for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:giftcard\"` and replays  it on retry.
         * @param {Pbcustomv2stubCreateGiftCardRequest} pbcustomv2stubCreateGiftCardRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGiftCard(pbcustomv2stubCreateGiftCardRequest: Pbcustomv2stubCreateGiftCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubCreateGiftCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGiftCard(pbcustomv2stubCreateGiftCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.createGiftCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue a promocode for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:promocode\"` and replays  it on retry. A second call with the same key must return the originally  issued code, not a new one.
         * @param {Pbcustomv2stubCreatePromocodeRequest} pbcustomv2stubCreatePromocodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromocode(pbcustomv2stubCreatePromocodeRequest: Pbcustomv2stubCreatePromocodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubCreatePromocodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromocode(pbcustomv2stubCreatePromocodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.createPromocode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the state of a previously issued gift card, including its current  balance.
         * @param {string} platformId Ecommerce-side gift card identifier, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGiftCard(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubGiftCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGiftCard(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getGiftCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the category hierarchy (menu + sub-menus) shown in the REVER  exchange catalog navigation.
         * @param {string} [countryCode] Optional ISO 3166-1 alpha-2 country code.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMenu(countryCode?: string, lang?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubMenu>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMenu(countryCode, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an order by its internal id (the platform\'s own identifier).
         * @param {string} orderId Internal order id, as set in the path.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code, query parameter &#x60;lang&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderById(orderId: string, lang?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderById(orderId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get an order by its customer-facing order number. Returns the single  matching order (404 if no match, 200 if exactly one).
         * @param {string} [orderNumber] Customer-facing order number without prefix or suffix (e.g. &#x60;12345&#x60;, not &#x60;#12345&#x60;).
         * @param {string} [lang] Optional ISO 639-1 two-letter language code, query parameter &#x60;lang&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderByNumber(orderNumber?: string, lang?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderByNumber(orderNumber, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getOrderByNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the payment transactions of an order — sales, captures, refunds,  voids — so REVER can issue refunds through the same processor that took  the original payment.
         * @param {string} orderId Internal order id, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTransactions(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubGetTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTransactions(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getOrderTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single product with full variant detail.
         * @param {string} productId Product id, as set in the path.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProduct(productId: string, lang?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProduct(productId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the state of a previously issued promocode.
         * @param {string} code Promocode value, as set in the path.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromocode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubPromocode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromocode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.getPromocode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List active products (paginated by offset). REVER walks `offset` from 0  upward in steps of `page_size` until `page_info.has_next_page` is false.  Products that disappear between syncs are treated as removed.
         * @param {number} [offset] Zero-based index of the first product to return. Default 0.
         * @param {number} [pageSize] Maximum number of products to return per page. Default 50, max 100.
         * @param {string} [lang] Optional ISO 639-1 two-letter language code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProducts(offset?: number, pageSize?: number, lang?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Pbcustomv2stubListProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProducts(offset, pageSize, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomIntegrationV2StubApi.listProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomIntegrationV2StubApi - factory interface
 * @export
 */
export const CustomIntegrationV2StubApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomIntegrationV2StubApiFp(configuration)
    return {
        /**
         * Cancel an exchange order REVER created through POST /rever/v2/orders  that is no longer needed (the return was canceled or its review  declined). Optional: implement it only if you implement  POST /rever/v2/orders; REVER calls it only once it is enabled for you.   All or nothing: if no unit has shipped, cancel every unit and put it  back in stock (`CANCELED`). If any unit has been handed to a carrier,  change nothing and answer `ALREADY_SHIPPED`, even if the other units are  canceled. An order canceled with nothing shipped answers  `ALREADY_CANCELED`. All three are 200, with the state of every line after  the call. Check and cancel atomically: the order must not ship between  the two.   Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{order_id}:cancel\"` and replays it on retry; a replay  may answer the original body or `ALREADY_CANCELED`.   Errors: 404 when the order is unknown. 409 when the order cannot be  canceled for another reason (already being picked, locked by the ERP):  as for POST /rever/v2/orders, REVER treats it as final, does not retry,  and the merchant handles the order by hand. 501 when canceling is not  supported. Any other status (400, 5xx) or a timeout is retried.
         * @param {CustomIntegrationV2StubApiCancelExchangeOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelExchangeOrder(requestParameters: CustomIntegrationV2StubApiCancelExchangeOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubCancelExchangeOrderResponse> {
            return localVarFp.cancelExchangeOrder(requestParameters.orderId, requestParameters.pbcustomv2stubCancelExchangeOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a gift card. Returns 409 if the gift card has been fully  redeemed.
         * @param {CustomIntegrationV2StubApiCancelGiftCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelGiftCard(requestParameters: CustomIntegrationV2StubApiCancelGiftCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelGiftCard(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a promocode. Returns 409 if the promocode has already been used  and cannot be cancelled.
         * @param {CustomIntegrationV2StubApiCancelPromocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelPromocode(requestParameters: CustomIntegrationV2StubApiCancelPromocodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelPromocode(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an exchange order on the ecommerce platform. Optional —  implement only if the ecommerce supports exchanges through the REVER  portal. Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{return_id}:exchange\"` and replays it on retry; a  second call must return the originally-created order, not a duplicate.  Answer 409 when the order cannot be created (out of stock, product  unavailable): REVER treats it as final and does not retry.
         * @param {CustomIntegrationV2StubApiCreateExchangeOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExchangeOrder(requestParameters: CustomIntegrationV2StubApiCreateExchangeOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubCreateExchangeOrderResponse> {
            return localVarFp.createExchangeOrder(requestParameters.pbcustomv2stubCreateExchangeOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue a gift card for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:giftcard\"` and replays  it on retry.
         * @param {CustomIntegrationV2StubApiCreateGiftCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGiftCard(requestParameters: CustomIntegrationV2StubApiCreateGiftCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubCreateGiftCardResponse> {
            return localVarFp.createGiftCard(requestParameters.pbcustomv2stubCreateGiftCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue a promocode for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:promocode\"` and replays  it on retry. A second call with the same key must return the originally  issued code, not a new one.
         * @param {CustomIntegrationV2StubApiCreatePromocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromocode(requestParameters: CustomIntegrationV2StubApiCreatePromocodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubCreatePromocodeResponse> {
            return localVarFp.createPromocode(requestParameters.pbcustomv2stubCreatePromocodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the state of a previously issued gift card, including its current  balance.
         * @param {CustomIntegrationV2StubApiGetGiftCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGiftCard(requestParameters: CustomIntegrationV2StubApiGetGiftCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubGiftCard> {
            return localVarFp.getGiftCard(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the category hierarchy (menu + sub-menus) shown in the REVER  exchange catalog navigation.
         * @param {CustomIntegrationV2StubApiGetMenuRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMenu(requestParameters: CustomIntegrationV2StubApiGetMenuRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubMenu> {
            return localVarFp.getMenu(requestParameters.countryCode, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an order by its internal id (the platform\'s own identifier).
         * @param {CustomIntegrationV2StubApiGetOrderByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(requestParameters: CustomIntegrationV2StubApiGetOrderByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubOrder> {
            return localVarFp.getOrderById(requestParameters.orderId, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get an order by its customer-facing order number. Returns the single  matching order (404 if no match, 200 if exactly one).
         * @param {CustomIntegrationV2StubApiGetOrderByNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderByNumber(requestParameters: CustomIntegrationV2StubApiGetOrderByNumberRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubOrder> {
            return localVarFp.getOrderByNumber(requestParameters.orderNumber, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
        /**
         * List the payment transactions of an order — sales, captures, refunds,  voids — so REVER can issue refunds through the same processor that took  the original payment.
         * @param {CustomIntegrationV2StubApiGetOrderTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTransactions(requestParameters: CustomIntegrationV2StubApiGetOrderTransactionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubGetTransactionsResponse> {
            return localVarFp.getOrderTransactions(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single product with full variant detail.
         * @param {CustomIntegrationV2StubApiGetProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct(requestParameters: CustomIntegrationV2StubApiGetProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubProduct> {
            return localVarFp.getProduct(requestParameters.productId, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the state of a previously issued promocode.
         * @param {CustomIntegrationV2StubApiGetPromocodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromocode(requestParameters: CustomIntegrationV2StubApiGetPromocodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubPromocode> {
            return localVarFp.getPromocode(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * List active products (paginated by offset). REVER walks `offset` from 0  upward in steps of `page_size` until `page_info.has_next_page` is false.  Products that disappear between syncs are treated as removed.
         * @param {CustomIntegrationV2StubApiListProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(requestParameters: CustomIntegrationV2StubApiListProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Pbcustomv2stubListProductsResponse> {
            return localVarFp.listProducts(requestParameters.offset, requestParameters.pageSize, requestParameters.lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelExchangeOrder operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiCancelExchangeOrderRequest
 */
export interface CustomIntegrationV2StubApiCancelExchangeOrderRequest {
    /**
     * Internal id of the exchange order, as returned by POST /rever/v2/orders.  Set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiCancelExchangeOrder
     */
    readonly orderId: string

    /**
     * 
     * @type {Pbcustomv2stubCancelExchangeOrderRequest}
     * @memberof CustomIntegrationV2StubApiCancelExchangeOrder
     */
    readonly pbcustomv2stubCancelExchangeOrderRequest: Pbcustomv2stubCancelExchangeOrderRequest
}

/**
 * Request parameters for cancelGiftCard operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiCancelGiftCardRequest
 */
export interface CustomIntegrationV2StubApiCancelGiftCardRequest {
    /**
     * Ecommerce-side gift card identifier, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiCancelGiftCard
     */
    readonly platformId: string
}

/**
 * Request parameters for cancelPromocode operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiCancelPromocodeRequest
 */
export interface CustomIntegrationV2StubApiCancelPromocodeRequest {
    /**
     * Promocode value, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiCancelPromocode
     */
    readonly code: string
}

/**
 * Request parameters for createExchangeOrder operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiCreateExchangeOrderRequest
 */
export interface CustomIntegrationV2StubApiCreateExchangeOrderRequest {
    /**
     * 
     * @type {Pbcustomv2stubCreateExchangeOrderRequest}
     * @memberof CustomIntegrationV2StubApiCreateExchangeOrder
     */
    readonly pbcustomv2stubCreateExchangeOrderRequest: Pbcustomv2stubCreateExchangeOrderRequest
}

/**
 * Request parameters for createGiftCard operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiCreateGiftCardRequest
 */
export interface CustomIntegrationV2StubApiCreateGiftCardRequest {
    /**
     * 
     * @type {Pbcustomv2stubCreateGiftCardRequest}
     * @memberof CustomIntegrationV2StubApiCreateGiftCard
     */
    readonly pbcustomv2stubCreateGiftCardRequest: Pbcustomv2stubCreateGiftCardRequest
}

/**
 * Request parameters for createPromocode operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiCreatePromocodeRequest
 */
export interface CustomIntegrationV2StubApiCreatePromocodeRequest {
    /**
     * 
     * @type {Pbcustomv2stubCreatePromocodeRequest}
     * @memberof CustomIntegrationV2StubApiCreatePromocode
     */
    readonly pbcustomv2stubCreatePromocodeRequest: Pbcustomv2stubCreatePromocodeRequest
}

/**
 * Request parameters for getGiftCard operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetGiftCardRequest
 */
export interface CustomIntegrationV2StubApiGetGiftCardRequest {
    /**
     * Ecommerce-side gift card identifier, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetGiftCard
     */
    readonly platformId: string
}

/**
 * Request parameters for getMenu operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetMenuRequest
 */
export interface CustomIntegrationV2StubApiGetMenuRequest {
    /**
     * Optional ISO 3166-1 alpha-2 country code.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetMenu
     */
    readonly countryCode?: string

    /**
     * Optional ISO 639-1 two-letter language code.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetMenu
     */
    readonly lang?: string
}

/**
 * Request parameters for getOrderById operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetOrderByIdRequest
 */
export interface CustomIntegrationV2StubApiGetOrderByIdRequest {
    /**
     * Internal order id, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetOrderById
     */
    readonly orderId: string

    /**
     * Optional ISO 639-1 two-letter language code, query parameter &#x60;lang&#x60;.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetOrderById
     */
    readonly lang?: string
}

/**
 * Request parameters for getOrderByNumber operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetOrderByNumberRequest
 */
export interface CustomIntegrationV2StubApiGetOrderByNumberRequest {
    /**
     * Customer-facing order number without prefix or suffix (e.g. &#x60;12345&#x60;, not &#x60;#12345&#x60;).
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetOrderByNumber
     */
    readonly orderNumber?: string

    /**
     * Optional ISO 639-1 two-letter language code, query parameter &#x60;lang&#x60;.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetOrderByNumber
     */
    readonly lang?: string
}

/**
 * Request parameters for getOrderTransactions operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetOrderTransactionsRequest
 */
export interface CustomIntegrationV2StubApiGetOrderTransactionsRequest {
    /**
     * Internal order id, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetOrderTransactions
     */
    readonly orderId: string
}

/**
 * Request parameters for getProduct operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetProductRequest
 */
export interface CustomIntegrationV2StubApiGetProductRequest {
    /**
     * Product id, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetProduct
     */
    readonly productId: string

    /**
     * Optional ISO 639-1 two-letter language code.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetProduct
     */
    readonly lang?: string
}

/**
 * Request parameters for getPromocode operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiGetPromocodeRequest
 */
export interface CustomIntegrationV2StubApiGetPromocodeRequest {
    /**
     * Promocode value, as set in the path.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiGetPromocode
     */
    readonly code: string
}

/**
 * Request parameters for listProducts operation in CustomIntegrationV2StubApi.
 * @export
 * @interface CustomIntegrationV2StubApiListProductsRequest
 */
export interface CustomIntegrationV2StubApiListProductsRequest {
    /**
     * Zero-based index of the first product to return. Default 0.
     * @type {number}
     * @memberof CustomIntegrationV2StubApiListProducts
     */
    readonly offset?: number

    /**
     * Maximum number of products to return per page. Default 50, max 100.
     * @type {number}
     * @memberof CustomIntegrationV2StubApiListProducts
     */
    readonly pageSize?: number

    /**
     * Optional ISO 639-1 two-letter language code.
     * @type {string}
     * @memberof CustomIntegrationV2StubApiListProducts
     */
    readonly lang?: string
}

/**
 * CustomIntegrationV2StubApi - object-oriented interface
 * @export
 * @class CustomIntegrationV2StubApi
 * @extends {BaseAPI}
 */
export class CustomIntegrationV2StubApi extends BaseAPI {
    /**
     * Cancel an exchange order REVER created through POST /rever/v2/orders  that is no longer needed (the return was canceled or its review  declined). Optional: implement it only if you implement  POST /rever/v2/orders; REVER calls it only once it is enabled for you.   All or nothing: if no unit has shipped, cancel every unit and put it  back in stock (`CANCELED`). If any unit has been handed to a carrier,  change nothing and answer `ALREADY_SHIPPED`, even if the other units are  canceled. An order canceled with nothing shipped answers  `ALREADY_CANCELED`. All three are 200, with the state of every line after  the call. Check and cancel atomically: the order must not ship between  the two.   Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{order_id}:cancel\"` and replays it on retry; a replay  may answer the original body or `ALREADY_CANCELED`.   Errors: 404 when the order is unknown. 409 when the order cannot be  canceled for another reason (already being picked, locked by the ERP):  as for POST /rever/v2/orders, REVER treats it as final, does not retry,  and the merchant handles the order by hand. 501 when canceling is not  supported. Any other status (400, 5xx) or a timeout is retried.
     * @param {CustomIntegrationV2StubApiCancelExchangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public cancelExchangeOrder(requestParameters: CustomIntegrationV2StubApiCancelExchangeOrderRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).cancelExchangeOrder(requestParameters.orderId, requestParameters.pbcustomv2stubCancelExchangeOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a gift card. Returns 409 if the gift card has been fully  redeemed.
     * @param {CustomIntegrationV2StubApiCancelGiftCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public cancelGiftCard(requestParameters: CustomIntegrationV2StubApiCancelGiftCardRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).cancelGiftCard(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a promocode. Returns 409 if the promocode has already been used  and cannot be cancelled.
     * @param {CustomIntegrationV2StubApiCancelPromocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public cancelPromocode(requestParameters: CustomIntegrationV2StubApiCancelPromocodeRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).cancelPromocode(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an exchange order on the ecommerce platform. Optional —  implement only if the ecommerce supports exchanges through the REVER  portal. Idempotent: REVER derives `idempotency_key` as  `\"{ecommerce_id}:{return_id}:exchange\"` and replays it on retry; a  second call must return the originally-created order, not a duplicate.  Answer 409 when the order cannot be created (out of stock, product  unavailable): REVER treats it as final and does not retry.
     * @param {CustomIntegrationV2StubApiCreateExchangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public createExchangeOrder(requestParameters: CustomIntegrationV2StubApiCreateExchangeOrderRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).createExchangeOrder(requestParameters.pbcustomv2stubCreateExchangeOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue a gift card for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:giftcard\"` and replays  it on retry.
     * @param {CustomIntegrationV2StubApiCreateGiftCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public createGiftCard(requestParameters: CustomIntegrationV2StubApiCreateGiftCardRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).createGiftCard(requestParameters.pbcustomv2stubCreateGiftCardRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue a promocode for a return. Idempotent: REVER derives  `idempotency_key` as `\"{ecommerce_id}:{return_id}:promocode\"` and replays  it on retry. A second call with the same key must return the originally  issued code, not a new one.
     * @param {CustomIntegrationV2StubApiCreatePromocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public createPromocode(requestParameters: CustomIntegrationV2StubApiCreatePromocodeRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).createPromocode(requestParameters.pbcustomv2stubCreatePromocodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the state of a previously issued gift card, including its current  balance.
     * @param {CustomIntegrationV2StubApiGetGiftCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getGiftCard(requestParameters: CustomIntegrationV2StubApiGetGiftCardRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getGiftCard(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the category hierarchy (menu + sub-menus) shown in the REVER  exchange catalog navigation.
     * @param {CustomIntegrationV2StubApiGetMenuRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getMenu(requestParameters: CustomIntegrationV2StubApiGetMenuRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getMenu(requestParameters.countryCode, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an order by its internal id (the platform\'s own identifier).
     * @param {CustomIntegrationV2StubApiGetOrderByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getOrderById(requestParameters: CustomIntegrationV2StubApiGetOrderByIdRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getOrderById(requestParameters.orderId, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an order by its customer-facing order number. Returns the single  matching order (404 if no match, 200 if exactly one).
     * @param {CustomIntegrationV2StubApiGetOrderByNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getOrderByNumber(requestParameters: CustomIntegrationV2StubApiGetOrderByNumberRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getOrderByNumber(requestParameters.orderNumber, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the payment transactions of an order — sales, captures, refunds,  voids — so REVER can issue refunds through the same processor that took  the original payment.
     * @param {CustomIntegrationV2StubApiGetOrderTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getOrderTransactions(requestParameters: CustomIntegrationV2StubApiGetOrderTransactionsRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getOrderTransactions(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single product with full variant detail.
     * @param {CustomIntegrationV2StubApiGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getProduct(requestParameters: CustomIntegrationV2StubApiGetProductRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getProduct(requestParameters.productId, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the state of a previously issued promocode.
     * @param {CustomIntegrationV2StubApiGetPromocodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public getPromocode(requestParameters: CustomIntegrationV2StubApiGetPromocodeRequest, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).getPromocode(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List active products (paginated by offset). REVER walks `offset` from 0  upward in steps of `page_size` until `page_info.has_next_page` is false.  Products that disappear between syncs are treated as removed.
     * @param {CustomIntegrationV2StubApiListProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomIntegrationV2StubApi
     */
    public listProducts(requestParameters: CustomIntegrationV2StubApiListProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomIntegrationV2StubApiFp(this.configuration).listProducts(requestParameters.offset, requestParameters.pageSize, requestParameters.lang, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardAnalyticsApi - axios parameter creator
 * @export
 */
export const DashboardAnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Country Return Rate
         * @param {string} ecommerceId ecommerce id
         * @param {string} [startDate] start date of the table
         * @param {string} [endDate] end date of the table (inclusive)
         * @param {number} [pageNumber] page number
         * @param {number} [pageLength] page length
         * @param {string} [orderingValue] ordering value
         * @param {string} [orderingDirection] ordering direction
         * @param {Array<string>} [countries] List of countries to filter by. Optional.
         * @param {Array<string>} [collections] List of collections to filter by. Optional.
         * @param {CountryReturnRateChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countryReturnRate: async (ecommerceId: string, startDate?: string, endDate?: string, pageNumber?: number, pageLength?: number, orderingValue?: string, orderingDirection?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: CountryReturnRateChartMetricEnum, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('countryReturnRate', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/return_rate_table/countries`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page.number'] = pageNumber;
            }

            if (pageLength !== undefined) {
                localVarQueryParameter['page.length'] = pageLength;
            }

            if (orderingValue !== undefined) {
                localVarQueryParameter['ordering.value'] = orderingValue;
            }

            if (orderingDirection !== undefined) {
                localVarQueryParameter['ordering.direction'] = orderingDirection;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (chartMetric !== undefined) {
                localVarQueryParameter['chart_metric'] = chartMetric;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves products and total distinct returned products on a time range,   can be filtered by product_id or product name.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the period to retrieve the data. Required.
         * @param {string} [endDate] End date of the period to retrieve the data. Required.
         * @param {number} [offset] Offset of the pagination. Optional.
         * @param {number} [limit] Limit of the pagination. Optional.
         * @param {string} [searchText] TextSearch to filter by product name or product ID. Optional.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProducts: async (ecommerceId: string, startDate?: string, endDate?: string, offset?: number, limit?: number, searchText?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findProducts', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/products`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchText !== undefined) {
                localVarQueryParameter['search_text'] = searchText;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves available filters (countries, collections) for the analytics.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFilters: async (ecommerceId: string, startDate?: string, endDate?: string, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getAvailableFilters', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/available_filters`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves number of items and totals by day
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemsAndTotalsPerDay: async (ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getItemsAndTotalsPerDay', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/returns_analytics/types_by_day`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Portals of the caller\'s group, with the flags the analytics UI needs to render a  portal selector.
         * @param {string} [startDate] Start of the range the has_sales_data flag is evaluated over. Optional.
         * @param {string} [endDate] End of the range the has_sales_data flag is evaluated over. Optional.
         * @param {string} [group] Group to list. Read only for REVER staff, who belong to no group; other  callers always get their own group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopePortals: async (startDate?: string, endDate?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/scope/portals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the exchanges that were an upsell and the extra value they brought in
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpsell: async (ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getUpsell', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/returns_analytics/upsell`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Period Return Rate aggregated by month
         * @param {string} ecommerceId ecommerce id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date (inclusive)
         * @param {Array<string>} [countries] list of countries to filter by. Optional.
         * @param {Array<string>} [collections] list of collections to filter by. Optional.
         * @param {PeriodReturnRateChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        periodReturnRate: async (ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: PeriodReturnRateChartMetricEnum, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('periodReturnRate', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/period_return_rate`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (chartMetric !== undefined) {
                localVarQueryParameter['chart_metric'] = chartMetric;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Problematic Products
         * @param {string} ecommerceId ecommerce id
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        problematicProducts: async (ecommerceId: string, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('problematicProducts', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/problematic_products`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves product analytics details for a single product.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {string} [productId] ID of the product. Optional.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDetailView: async (ecommerceId: string, startDate?: string, endDate?: string, productId?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('productDetailView', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/product_analytics/detail_view`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves product analytics data for the given ecommerce and time range.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productMainView: async (ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('productMainView', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/products/main_view`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return Rate By Product
         * @param {string} ecommerceId ecommerce id
         * @param {string} productId product id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date
         * @param {Array<string>} [countries] list of countries to filter by. Optional.
         * @param {Array<string>} [collections] list of collections to filter by. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateByProduct: async (ecommerceId: string, productId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('returnRateByProduct', 'ecommerceId', ecommerceId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('returnRateByProduct', 'productId', productId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/products/{product_id}/return_rate`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return Rate By Product grouped by shipping country
         * @param {string} ecommerceId ecommerce id
         * @param {string} productId product id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date
         * @param {Array<string>} [countries] list of countries to filter by. Optional.
         * @param {Array<string>} [collections] list of collections to filter by. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateByProductCountry: async (ecommerceId: string, productId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('returnRateByProductCountry', 'ecommerceId', ecommerceId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('returnRateByProductCountry', 'productId', productId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/products/{product_id}/return_rate/countries`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return Rate By Product at Store Level
         * @param {string} storeId store id
         * @param {string} productId product id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateByProductInStoreLevel: async (storeId: string, productId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('returnRateByProductInStoreLevel', 'storeId', storeId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('returnRateByProductInStoreLevel', 'productId', productId)
            const localVarPath = `/v1/analytics/{store_id}/products/{product_id}/return_rate/store_level`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return Rate Table
         * @param {string} ecommerceId ecommerce id
         * @param {string} [startDate] start date of the table
         * @param {string} [endDate] end date of the table (inclusive)
         * @param {number} [pageNumber] page number
         * @param {number} [pageLength] page length
         * @param {string} [orderingValue] ordering value
         * @param {string} [orderingDirection] ordering direction
         * @param {Array<string>} [countries] List of countries to filter by. Optional.
         * @param {Array<string>} [collections] List of collections to filter by. Optional.
         * @param {ReturnRateTableChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateTable: async (ecommerceId: string, startDate?: string, endDate?: string, pageNumber?: number, pageLength?: number, orderingValue?: string, orderingDirection?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: ReturnRateTableChartMetricEnum, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('returnRateTable', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/return_rate_table`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['page.number'] = pageNumber;
            }

            if (pageLength !== undefined) {
                localVarQueryParameter['page.length'] = pageLength;
            }

            if (orderingValue !== undefined) {
                localVarQueryParameter['ordering.value'] = orderingValue;
            }

            if (orderingDirection !== undefined) {
                localVarQueryParameter['ordering.direction'] = orderingDirection;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (chartMetric !== undefined) {
                localVarQueryParameter['chart_metric'] = chartMetric;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves returns by country
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {ReturnsByCountryChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnsByCountry: async (ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: ReturnsByCountryChartMetricEnum, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('returnsByCountry', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/returns_analytics/returns_by_country`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (chartMetric !== undefined) {
                localVarQueryParameter['chart_metric'] = chartMetric;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves returns by country and product id
         * @param {string} storeId ID of the store. Required.
         * @param {string} productId product id. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnsByCountryAndProduct: async (storeId: string, productId: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('returnsByCountryAndProduct', 'storeId', storeId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('returnsByCountryAndProduct', 'productId', productId)
            const localVarPath = `/v1/analytics/{store_id}/products/{product_id}/returns_by_country`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves main view info for Returns analytics
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnsMainView: async (ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('returnsMainView', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/returns_analytics/main_view`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (collections) {
                localVarQueryParameter['collections'] = collections;
            }

            if (ecommerceIds) {
                localVarQueryParameter['ecommerce_ids'] = ecommerceIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardAnalyticsApi - functional programming interface
 * @export
 */
export const DashboardAnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardAnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Country Return Rate
         * @param {string} ecommerceId ecommerce id
         * @param {string} [startDate] start date of the table
         * @param {string} [endDate] end date of the table (inclusive)
         * @param {number} [pageNumber] page number
         * @param {number} [pageLength] page length
         * @param {string} [orderingValue] ordering value
         * @param {string} [orderingDirection] ordering direction
         * @param {Array<string>} [countries] List of countries to filter by. Optional.
         * @param {Array<string>} [collections] List of collections to filter by. Optional.
         * @param {CountryReturnRateChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countryReturnRate(ecommerceId: string, startDate?: string, endDate?: string, pageNumber?: number, pageLength?: number, orderingValue?: string, orderingDirection?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: CountryReturnRateChartMetricEnum, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbCountryReturnRateTableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countryReturnRate(ecommerceId, startDate, endDate, pageNumber, pageLength, orderingValue, orderingDirection, countries, collections, chartMetric, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.countryReturnRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves products and total distinct returned products on a time range,   can be filtered by product_id or product name.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the period to retrieve the data. Required.
         * @param {string} [endDate] End date of the period to retrieve the data. Required.
         * @param {number} [offset] Offset of the pagination. Optional.
         * @param {number} [limit] Limit of the pagination. Optional.
         * @param {string} [searchText] TextSearch to filter by product name or product ID. Optional.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProducts(ecommerceId: string, startDate?: string, endDate?: string, offset?: number, limit?: number, searchText?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbFindProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProducts(ecommerceId, startDate, endDate, offset, limit, searchText, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.findProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves available filters (countries, collections) for the analytics.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableFilters(ecommerceId: string, startDate?: string, endDate?: string, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbGetAvailableFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableFilters(ecommerceId, startDate, endDate, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.getAvailableFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves number of items and totals by day
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemsAndTotalsPerDay(ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbGetItemsAndTotalsPerDayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemsAndTotalsPerDay(ecommerceId, startDate, endDate, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.getItemsAndTotalsPerDay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Portals of the caller\'s group, with the flags the analytics UI needs to render a  portal selector.
         * @param {string} [startDate] Start of the range the has_sales_data flag is evaluated over. Optional.
         * @param {string} [endDate] End of the range the has_sales_data flag is evaluated over. Optional.
         * @param {string} [group] Group to list. Read only for REVER staff, who belong to no group; other  callers always get their own group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScopePortals(startDate?: string, endDate?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbGetScopePortalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScopePortals(startDate, endDate, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.getScopePortals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the exchanges that were an upsell and the extra value they brought in
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUpsell(ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbGetUpsellResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUpsell(ecommerceId, startDate, endDate, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.getUpsell']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Period Return Rate aggregated by month
         * @param {string} ecommerceId ecommerce id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date (inclusive)
         * @param {Array<string>} [countries] list of countries to filter by. Optional.
         * @param {Array<string>} [collections] list of collections to filter by. Optional.
         * @param {PeriodReturnRateChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async periodReturnRate(ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: PeriodReturnRateChartMetricEnum, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbPeriodReturnRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.periodReturnRate(ecommerceId, startDate, endDate, countries, collections, chartMetric, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.periodReturnRate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Problematic Products
         * @param {string} ecommerceId ecommerce id
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async problematicProducts(ecommerceId: string, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbProblematicProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.problematicProducts(ecommerceId, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.problematicProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves product analytics details for a single product.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {string} [productId] ID of the product. Optional.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDetailView(ecommerceId: string, startDate?: string, endDate?: string, productId?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbProductDetailViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDetailView(ecommerceId, startDate, endDate, productId, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.productDetailView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves product analytics data for the given ecommerce and time range.
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productMainView(ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbProductMainViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productMainView(ecommerceId, startDate, endDate, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.productMainView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return Rate By Product
         * @param {string} ecommerceId ecommerce id
         * @param {string} productId product id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date
         * @param {Array<string>} [countries] list of countries to filter by. Optional.
         * @param {Array<string>} [collections] list of collections to filter by. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnRateByProduct(ecommerceId: string, productId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbProductReturnRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnRateByProduct(ecommerceId, productId, startDate, endDate, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnRateByProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return Rate By Product grouped by shipping country
         * @param {string} ecommerceId ecommerce id
         * @param {string} productId product id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date
         * @param {Array<string>} [countries] list of countries to filter by. Optional.
         * @param {Array<string>} [collections] list of collections to filter by. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnRateByProductCountry(ecommerceId: string, productId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbProductCountryReturnRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnRateByProductCountry(ecommerceId, productId, startDate, endDate, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnRateByProductCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return Rate By Product at Store Level
         * @param {string} storeId store id
         * @param {string} productId product id
         * @param {string} [startDate] start date
         * @param {string} [endDate] end date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnRateByProductInStoreLevel(storeId: string, productId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbProductReturnRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnRateByProductInStoreLevel(storeId, productId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnRateByProductInStoreLevel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return Rate Table
         * @param {string} ecommerceId ecommerce id
         * @param {string} [startDate] start date of the table
         * @param {string} [endDate] end date of the table (inclusive)
         * @param {number} [pageNumber] page number
         * @param {number} [pageLength] page length
         * @param {string} [orderingValue] ordering value
         * @param {string} [orderingDirection] ordering direction
         * @param {Array<string>} [countries] List of countries to filter by. Optional.
         * @param {Array<string>} [collections] List of collections to filter by. Optional.
         * @param {ReturnRateTableChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnRateTable(ecommerceId: string, startDate?: string, endDate?: string, pageNumber?: number, pageLength?: number, orderingValue?: string, orderingDirection?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: ReturnRateTableChartMetricEnum, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbReturnRateTableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnRateTable(ecommerceId, startDate, endDate, pageNumber, pageLength, orderingValue, orderingDirection, countries, collections, chartMetric, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnRateTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves returns by country
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {ReturnsByCountryChartMetricEnum} [chartMetric] chart metric
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnsByCountry(ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, chartMetric?: ReturnsByCountryChartMetricEnum, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbReturnsCountryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnsByCountry(ecommerceId, startDate, endDate, countries, collections, chartMetric, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnsByCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves returns by country and product id
         * @param {string} storeId ID of the store. Required.
         * @param {string} productId product id. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnsByCountryAndProduct(storeId: string, productId: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbReturnsCountryProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnsByCountryAndProduct(storeId, productId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnsByCountryAndProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves main view info for Returns analytics
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {string} [startDate] Start date of the range of time for which to retrieve data. Required.
         * @param {string} [endDate] End date of the range of time for which to retrieve data. Required.
         * @param {Array<string>} [countries] List of countries to filter the data. Optional.
         * @param {Array<string>} [collections] List of collections to filter the data. Optional.
         * @param {Array<string>} [ecommerceIds] Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnsMainView(ecommerceId: string, startDate?: string, endDate?: string, countries?: Array<string>, collections?: Array<string>, ecommerceIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardanalyticspbReturnsMainViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnsMainView(ecommerceId, startDate, endDate, countries, collections, ecommerceIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAnalyticsApi.returnsMainView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardAnalyticsApi - factory interface
 * @export
 */
export const DashboardAnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardAnalyticsApiFp(configuration)
    return {
        /**
         * Country Return Rate
         * @param {DashboardAnalyticsApiCountryReturnRateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countryReturnRate(requestParameters: DashboardAnalyticsApiCountryReturnRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbCountryReturnRateTableResponse> {
            return localVarFp.countryReturnRate(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.pageNumber, requestParameters.pageLength, requestParameters.orderingValue, requestParameters.orderingDirection, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves products and total distinct returned products on a time range,   can be filtered by product_id or product name.
         * @param {DashboardAnalyticsApiFindProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProducts(requestParameters: DashboardAnalyticsApiFindProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbFindProductsResponse> {
            return localVarFp.findProducts(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.offset, requestParameters.limit, requestParameters.searchText, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves available filters (countries, collections) for the analytics.
         * @param {DashboardAnalyticsApiGetAvailableFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFilters(requestParameters: DashboardAnalyticsApiGetAvailableFiltersRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbGetAvailableFiltersResponse> {
            return localVarFp.getAvailableFilters(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves number of items and totals by day
         * @param {DashboardAnalyticsApiGetItemsAndTotalsPerDayRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemsAndTotalsPerDay(requestParameters: DashboardAnalyticsApiGetItemsAndTotalsPerDayRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbGetItemsAndTotalsPerDayResponse> {
            return localVarFp.getItemsAndTotalsPerDay(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Portals of the caller\'s group, with the flags the analytics UI needs to render a  portal selector.
         * @param {DashboardAnalyticsApiGetScopePortalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopePortals(requestParameters: DashboardAnalyticsApiGetScopePortalsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbGetScopePortalsResponse> {
            return localVarFp.getScopePortals(requestParameters.startDate, requestParameters.endDate, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the exchanges that were an upsell and the extra value they brought in
         * @param {DashboardAnalyticsApiGetUpsellRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpsell(requestParameters: DashboardAnalyticsApiGetUpsellRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbGetUpsellResponse> {
            return localVarFp.getUpsell(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Period Return Rate aggregated by month
         * @param {DashboardAnalyticsApiPeriodReturnRateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        periodReturnRate(requestParameters: DashboardAnalyticsApiPeriodReturnRateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbPeriodReturnRateResponse> {
            return localVarFp.periodReturnRate(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Problematic Products
         * @param {DashboardAnalyticsApiProblematicProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        problematicProducts(requestParameters: DashboardAnalyticsApiProblematicProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbProblematicProductsResponse> {
            return localVarFp.problematicProducts(requestParameters.ecommerceId, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves product analytics details for a single product.
         * @param {DashboardAnalyticsApiProductDetailViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDetailView(requestParameters: DashboardAnalyticsApiProductDetailViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbProductDetailViewResponse> {
            return localVarFp.productDetailView(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.productId, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves product analytics data for the given ecommerce and time range.
         * @param {DashboardAnalyticsApiProductMainViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productMainView(requestParameters: DashboardAnalyticsApiProductMainViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbProductMainViewResponse> {
            return localVarFp.productMainView(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Return Rate By Product
         * @param {DashboardAnalyticsApiReturnRateByProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateByProduct(requestParameters: DashboardAnalyticsApiReturnRateByProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbProductReturnRateResponse> {
            return localVarFp.returnRateByProduct(requestParameters.ecommerceId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Return Rate By Product grouped by shipping country
         * @param {DashboardAnalyticsApiReturnRateByProductCountryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateByProductCountry(requestParameters: DashboardAnalyticsApiReturnRateByProductCountryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbProductCountryReturnRateResponse> {
            return localVarFp.returnRateByProductCountry(requestParameters.ecommerceId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Return Rate By Product at Store Level
         * @param {DashboardAnalyticsApiReturnRateByProductInStoreLevelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateByProductInStoreLevel(requestParameters: DashboardAnalyticsApiReturnRateByProductInStoreLevelRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbProductReturnRateResponse> {
            return localVarFp.returnRateByProductInStoreLevel(requestParameters.storeId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Return Rate Table
         * @param {DashboardAnalyticsApiReturnRateTableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnRateTable(requestParameters: DashboardAnalyticsApiReturnRateTableRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbReturnRateTableResponse> {
            return localVarFp.returnRateTable(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.pageNumber, requestParameters.pageLength, requestParameters.orderingValue, requestParameters.orderingDirection, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves returns by country
         * @param {DashboardAnalyticsApiReturnsByCountryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnsByCountry(requestParameters: DashboardAnalyticsApiReturnsByCountryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbReturnsCountryResponse> {
            return localVarFp.returnsByCountry(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves returns by country and product id
         * @param {DashboardAnalyticsApiReturnsByCountryAndProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnsByCountryAndProduct(requestParameters: DashboardAnalyticsApiReturnsByCountryAndProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbReturnsCountryProductResponse> {
            return localVarFp.returnsByCountryAndProduct(requestParameters.storeId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves main view info for Returns analytics
         * @param {DashboardAnalyticsApiReturnsMainViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnsMainView(requestParameters: DashboardAnalyticsApiReturnsMainViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardanalyticspbReturnsMainViewResponse> {
            return localVarFp.returnsMainView(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for countryReturnRate operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiCountryReturnRateRequest
 */
export interface DashboardAnalyticsApiCountryReturnRateRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly ecommerceId: string

    /**
     * start date of the table
     * @type {string}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly startDate?: string

    /**
     * end date of the table (inclusive)
     * @type {string}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly endDate?: string

    /**
     * page number
     * @type {number}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly pageNumber?: number

    /**
     * page length
     * @type {number}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly pageLength?: number

    /**
     * ordering value
     * @type {string}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly orderingValue?: string

    /**
     * ordering direction
     * @type {string}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly orderingDirection?: string

    /**
     * List of countries to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly collections?: Array<string>

    /**
     * chart metric
     * @type {'RETURN_RATE_CHART_METRIC_UNSPECIFIED' | 'RETURN_RATE_CHART_METRIC_QUANTITY' | 'RETURN_RATE_CHART_METRIC_AMOUNT'}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly chartMetric?: CountryReturnRateChartMetricEnum

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiCountryReturnRate
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for findProducts operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiFindProductsRequest
 */
export interface DashboardAnalyticsApiFindProductsRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly ecommerceId: string

    /**
     * Start date of the period to retrieve the data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly startDate?: string

    /**
     * End date of the period to retrieve the data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly endDate?: string

    /**
     * Offset of the pagination. Optional.
     * @type {number}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly offset?: number

    /**
     * Limit of the pagination. Optional.
     * @type {number}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly limit?: number

    /**
     * TextSearch to filter by product name or product ID. Optional.
     * @type {string}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly searchText?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiFindProducts
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for getAvailableFilters operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiGetAvailableFiltersRequest
 */
export interface DashboardAnalyticsApiGetAvailableFiltersRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetAvailableFilters
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetAvailableFilters
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetAvailableFilters
     */
    readonly endDate?: string

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetAvailableFilters
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for getItemsAndTotalsPerDay operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiGetItemsAndTotalsPerDayRequest
 */
export interface DashboardAnalyticsApiGetItemsAndTotalsPerDayRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetItemsAndTotalsPerDay
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetItemsAndTotalsPerDay
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetItemsAndTotalsPerDay
     */
    readonly endDate?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetItemsAndTotalsPerDay
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetItemsAndTotalsPerDay
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetItemsAndTotalsPerDay
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for getScopePortals operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiGetScopePortalsRequest
 */
export interface DashboardAnalyticsApiGetScopePortalsRequest {
    /**
     * Start of the range the has_sales_data flag is evaluated over. Optional.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetScopePortals
     */
    readonly startDate?: string

    /**
     * End of the range the has_sales_data flag is evaluated over. Optional.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetScopePortals
     */
    readonly endDate?: string

    /**
     * Group to list. Read only for REVER staff, who belong to no group; other  callers always get their own group. Optional.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetScopePortals
     */
    readonly group?: string
}

/**
 * Request parameters for getUpsell operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiGetUpsellRequest
 */
export interface DashboardAnalyticsApiGetUpsellRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetUpsell
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetUpsell
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiGetUpsell
     */
    readonly endDate?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetUpsell
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetUpsell
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiGetUpsell
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for periodReturnRate operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiPeriodReturnRateRequest
 */
export interface DashboardAnalyticsApiPeriodReturnRateRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly ecommerceId: string

    /**
     * start date
     * @type {string}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly startDate?: string

    /**
     * end date (inclusive)
     * @type {string}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly endDate?: string

    /**
     * list of countries to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly countries?: Array<string>

    /**
     * list of collections to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly collections?: Array<string>

    /**
     * chart metric
     * @type {'RETURN_RATE_CHART_METRIC_UNSPECIFIED' | 'RETURN_RATE_CHART_METRIC_QUANTITY' | 'RETURN_RATE_CHART_METRIC_AMOUNT'}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly chartMetric?: PeriodReturnRateChartMetricEnum

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiPeriodReturnRate
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for problematicProducts operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiProblematicProductsRequest
 */
export interface DashboardAnalyticsApiProblematicProductsRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof DashboardAnalyticsApiProblematicProducts
     */
    readonly ecommerceId: string

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProblematicProducts
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for productDetailView operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiProductDetailViewRequest
 */
export interface DashboardAnalyticsApiProductDetailViewRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly endDate?: string

    /**
     * ID of the product. Optional.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly productId?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProductDetailView
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for productMainView operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiProductMainViewRequest
 */
export interface DashboardAnalyticsApiProductMainViewRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductMainView
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductMainView
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiProductMainView
     */
    readonly endDate?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProductMainView
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProductMainView
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiProductMainView
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for returnRateByProduct operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnRateByProductRequest
 */
export interface DashboardAnalyticsApiReturnRateByProductRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly ecommerceId: string

    /**
     * product id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly productId: string

    /**
     * start date
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly startDate?: string

    /**
     * end date
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly endDate?: string

    /**
     * list of countries to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly countries?: Array<string>

    /**
     * list of collections to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateByProduct
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for returnRateByProductCountry operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnRateByProductCountryRequest
 */
export interface DashboardAnalyticsApiReturnRateByProductCountryRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly ecommerceId: string

    /**
     * product id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly productId: string

    /**
     * start date
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly startDate?: string

    /**
     * end date
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly endDate?: string

    /**
     * list of countries to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly countries?: Array<string>

    /**
     * list of collections to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateByProductCountry
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for returnRateByProductInStoreLevel operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnRateByProductInStoreLevelRequest
 */
export interface DashboardAnalyticsApiReturnRateByProductInStoreLevelRequest {
    /**
     * store id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductInStoreLevel
     */
    readonly storeId: string

    /**
     * product id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductInStoreLevel
     */
    readonly productId: string

    /**
     * start date
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductInStoreLevel
     */
    readonly startDate?: string

    /**
     * end date
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateByProductInStoreLevel
     */
    readonly endDate?: string
}

/**
 * Request parameters for returnRateTable operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnRateTableRequest
 */
export interface DashboardAnalyticsApiReturnRateTableRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly ecommerceId: string

    /**
     * start date of the table
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly startDate?: string

    /**
     * end date of the table (inclusive)
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly endDate?: string

    /**
     * page number
     * @type {number}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly pageNumber?: number

    /**
     * page length
     * @type {number}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly pageLength?: number

    /**
     * ordering value
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly orderingValue?: string

    /**
     * ordering direction
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly orderingDirection?: string

    /**
     * List of countries to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter by. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly collections?: Array<string>

    /**
     * chart metric
     * @type {'RETURN_RATE_CHART_METRIC_UNSPECIFIED' | 'RETURN_RATE_CHART_METRIC_QUANTITY' | 'RETURN_RATE_CHART_METRIC_AMOUNT'}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly chartMetric?: ReturnRateTableChartMetricEnum

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnRateTable
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for returnsByCountry operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnsByCountryRequest
 */
export interface DashboardAnalyticsApiReturnsByCountryRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly endDate?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly collections?: Array<string>

    /**
     * chart metric
     * @type {'RETURN_RATE_CHART_METRIC_UNSPECIFIED' | 'RETURN_RATE_CHART_METRIC_QUANTITY' | 'RETURN_RATE_CHART_METRIC_AMOUNT'}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly chartMetric?: ReturnsByCountryChartMetricEnum

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnsByCountry
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * Request parameters for returnsByCountryAndProduct operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnsByCountryAndProductRequest
 */
export interface DashboardAnalyticsApiReturnsByCountryAndProductRequest {
    /**
     * ID of the store. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountryAndProduct
     */
    readonly storeId: string

    /**
     * product id. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountryAndProduct
     */
    readonly productId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountryAndProduct
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsByCountryAndProduct
     */
    readonly endDate?: string
}

/**
 * Request parameters for returnsMainView operation in DashboardAnalyticsApi.
 * @export
 * @interface DashboardAnalyticsApiReturnsMainViewRequest
 */
export interface DashboardAnalyticsApiReturnsMainViewRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsMainView
     */
    readonly ecommerceId: string

    /**
     * Start date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsMainView
     */
    readonly startDate?: string

    /**
     * End date of the range of time for which to retrieve data. Required.
     * @type {string}
     * @memberof DashboardAnalyticsApiReturnsMainView
     */
    readonly endDate?: string

    /**
     * List of countries to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnsMainView
     */
    readonly countries?: Array<string>

    /**
     * List of collections to filter the data. Optional.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnsMainView
     */
    readonly collections?: Array<string>

    /**
     * Portals the query covers. At least one is required; ids outside the caller\&#39;s group  are rejected.
     * @type {Array<string>}
     * @memberof DashboardAnalyticsApiReturnsMainView
     */
    readonly ecommerceIds?: Array<string>
}

/**
 * DashboardAnalyticsApi - object-oriented interface
 * @export
 * @class DashboardAnalyticsApi
 * @extends {BaseAPI}
 */
export class DashboardAnalyticsApi extends BaseAPI {
    /**
     * Country Return Rate
     * @param {DashboardAnalyticsApiCountryReturnRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public countryReturnRate(requestParameters: DashboardAnalyticsApiCountryReturnRateRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).countryReturnRate(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.pageNumber, requestParameters.pageLength, requestParameters.orderingValue, requestParameters.orderingDirection, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves products and total distinct returned products on a time range,   can be filtered by product_id or product name.
     * @param {DashboardAnalyticsApiFindProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public findProducts(requestParameters: DashboardAnalyticsApiFindProductsRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).findProducts(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.offset, requestParameters.limit, requestParameters.searchText, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves available filters (countries, collections) for the analytics.
     * @param {DashboardAnalyticsApiGetAvailableFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public getAvailableFilters(requestParameters: DashboardAnalyticsApiGetAvailableFiltersRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).getAvailableFilters(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves number of items and totals by day
     * @param {DashboardAnalyticsApiGetItemsAndTotalsPerDayRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public getItemsAndTotalsPerDay(requestParameters: DashboardAnalyticsApiGetItemsAndTotalsPerDayRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).getItemsAndTotalsPerDay(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Portals of the caller\'s group, with the flags the analytics UI needs to render a  portal selector.
     * @param {DashboardAnalyticsApiGetScopePortalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public getScopePortals(requestParameters: DashboardAnalyticsApiGetScopePortalsRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).getScopePortals(requestParameters.startDate, requestParameters.endDate, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the exchanges that were an upsell and the extra value they brought in
     * @param {DashboardAnalyticsApiGetUpsellRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public getUpsell(requestParameters: DashboardAnalyticsApiGetUpsellRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).getUpsell(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Period Return Rate aggregated by month
     * @param {DashboardAnalyticsApiPeriodReturnRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public periodReturnRate(requestParameters: DashboardAnalyticsApiPeriodReturnRateRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).periodReturnRate(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Problematic Products
     * @param {DashboardAnalyticsApiProblematicProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public problematicProducts(requestParameters: DashboardAnalyticsApiProblematicProductsRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).problematicProducts(requestParameters.ecommerceId, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves product analytics details for a single product.
     * @param {DashboardAnalyticsApiProductDetailViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public productDetailView(requestParameters: DashboardAnalyticsApiProductDetailViewRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).productDetailView(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.productId, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves product analytics data for the given ecommerce and time range.
     * @param {DashboardAnalyticsApiProductMainViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public productMainView(requestParameters: DashboardAnalyticsApiProductMainViewRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).productMainView(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return Rate By Product
     * @param {DashboardAnalyticsApiReturnRateByProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnRateByProduct(requestParameters: DashboardAnalyticsApiReturnRateByProductRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnRateByProduct(requestParameters.ecommerceId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return Rate By Product grouped by shipping country
     * @param {DashboardAnalyticsApiReturnRateByProductCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnRateByProductCountry(requestParameters: DashboardAnalyticsApiReturnRateByProductCountryRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnRateByProductCountry(requestParameters.ecommerceId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return Rate By Product at Store Level
     * @param {DashboardAnalyticsApiReturnRateByProductInStoreLevelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnRateByProductInStoreLevel(requestParameters: DashboardAnalyticsApiReturnRateByProductInStoreLevelRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnRateByProductInStoreLevel(requestParameters.storeId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return Rate Table
     * @param {DashboardAnalyticsApiReturnRateTableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnRateTable(requestParameters: DashboardAnalyticsApiReturnRateTableRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnRateTable(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.pageNumber, requestParameters.pageLength, requestParameters.orderingValue, requestParameters.orderingDirection, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves returns by country
     * @param {DashboardAnalyticsApiReturnsByCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnsByCountry(requestParameters: DashboardAnalyticsApiReturnsByCountryRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnsByCountry(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.chartMetric, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves returns by country and product id
     * @param {DashboardAnalyticsApiReturnsByCountryAndProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnsByCountryAndProduct(requestParameters: DashboardAnalyticsApiReturnsByCountryAndProductRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnsByCountryAndProduct(requestParameters.storeId, requestParameters.productId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves main view info for Returns analytics
     * @param {DashboardAnalyticsApiReturnsMainViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAnalyticsApi
     */
    public returnsMainView(requestParameters: DashboardAnalyticsApiReturnsMainViewRequest, options?: RawAxiosRequestConfig) {
        return DashboardAnalyticsApiFp(this.configuration).returnsMainView(requestParameters.ecommerceId, requestParameters.startDate, requestParameters.endDate, requestParameters.countries, requestParameters.collections, requestParameters.ecommerceIds, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CountryReturnRateChartMetricEnum = {
    Unspecified: 'RETURN_RATE_CHART_METRIC_UNSPECIFIED',
    Quantity: 'RETURN_RATE_CHART_METRIC_QUANTITY',
    Amount: 'RETURN_RATE_CHART_METRIC_AMOUNT'
} as const;
export type CountryReturnRateChartMetricEnum = typeof CountryReturnRateChartMetricEnum[keyof typeof CountryReturnRateChartMetricEnum];
/**
 * @export
 */
export const PeriodReturnRateChartMetricEnum = {
    Unspecified: 'RETURN_RATE_CHART_METRIC_UNSPECIFIED',
    Quantity: 'RETURN_RATE_CHART_METRIC_QUANTITY',
    Amount: 'RETURN_RATE_CHART_METRIC_AMOUNT'
} as const;
export type PeriodReturnRateChartMetricEnum = typeof PeriodReturnRateChartMetricEnum[keyof typeof PeriodReturnRateChartMetricEnum];
/**
 * @export
 */
export const ReturnRateTableChartMetricEnum = {
    Unspecified: 'RETURN_RATE_CHART_METRIC_UNSPECIFIED',
    Quantity: 'RETURN_RATE_CHART_METRIC_QUANTITY',
    Amount: 'RETURN_RATE_CHART_METRIC_AMOUNT'
} as const;
export type ReturnRateTableChartMetricEnum = typeof ReturnRateTableChartMetricEnum[keyof typeof ReturnRateTableChartMetricEnum];
/**
 * @export
 */
export const ReturnsByCountryChartMetricEnum = {
    Unspecified: 'RETURN_RATE_CHART_METRIC_UNSPECIFIED',
    Quantity: 'RETURN_RATE_CHART_METRIC_QUANTITY',
    Amount: 'RETURN_RATE_CHART_METRIC_AMOUNT'
} as const;
export type ReturnsByCountryChartMetricEnum = typeof ReturnsByCountryChartMetricEnum[keyof typeof ReturnsByCountryChartMetricEnum];


/**
 * ECommerceApi - axios parameter creator
 * @export
 */
export const ECommerceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ConfirmPrestashopShop handles the second call of the handshake: proof  the module received the secret minted by RegisterPrestashopShop, via the  X-REVER-Signature header (webhooksign, HMAC-SHA256 of the raw body,  keyed with that per-registration secret). The raw body is forwarded so  the signature can be verified over the exact bytes the module signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPrestashopShop: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/prestashop/register/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ConfirmShop handles the second call of the registration handshake, header  shopware-shop-signature (HMAC-SHA256 of the raw body, per-shop secret).  The raw body is forwarded so the signature can be verified over the exact  bytes Shopware signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmShop: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/shopware/register/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DeactivatePrestashopShop receives the module\'s uninstall notification,  same X-REVER-Signature scheme as ConfirmPrestashopShop/LinkPrestashopShop.  The JSON body is {\"registration_id\"}. It deactivates every ecommerce  connected to the installation, keeping their credentials, and then the  installation. Idempotent, so the module can retry it.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePrestashopShop: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/prestashop/deactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for getting CustomPlatformSettings model
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomPlatformSettings: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/custom-platform/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding CustomPlatformSettings model by Shop ID
         * @param {string} shopId Shop ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomSettingsFromShopID: async (shopId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shopId' is not null or undefined
            assertParamExists('findCustomSettingsFromShopID', 'shopId', shopId)
            const localVarPath = `/v1/ecommerce/custom-platform/credentials/by-shop-id/{shop_id}`
                .replace(`{${"shop_id"}}`, encodeURIComponent(String(shopId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding SalesforceSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSalesforceSettings: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findSalesforceSettings', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/ecommerce/salesforce/credentials/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetAvailableRestockLocations gets the available restock locations for the requested items
         * @param {string} [ecommerceId] Ecommerce ID
         * @param {Array<string>} [variantIds] Variant IDs of the requested items
         * @param {string} [orderId] Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableRestockLocations: async (ecommerceId?: string, variantIds?: Array<string>, orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/restock-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (variantIds) {
                localVarQueryParameter['variant_ids'] = variantIds;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order_id'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Custom endpoint for ecommerce thebradery - get products and brands
         * @param {string} [email] The email of the customer. Required.
         * @param {string} [orderNumber] The order number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsAndBrandsFromTheBradery: async (email?: string, orderNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/thebradery/products-and-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['order_number'] = orderNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LinkPrestashopShop handles the final call of the handshake, same  X-REVER-Signature scheme as ConfirmPrestashopShop. The JSON body is  {\"registration_id\", \"ecommerce_ids\": [...], \"api_key\"}: the complete set of  ecommerces the merchant was given out of band and the PrestaShop  webservice key the module generated for REVER. ecommerce_ids must be  present; an empty list disconnects every ecommerce of the installation  and is the only case where api_key may be empty. The registration must be  confirmed and installed, and every ecommerce must exist and be a  PrestaShop store (otherwise INVALID_ARGUMENT). A rejection names every  offending ecommerce at once: \"rejected ecommerce ids: <id> (<reason>), ...\".  An ecommerce connected via the legacy flow is migrated,  taking api_key as its new key, only if the module answers  GET {stored store URL}/rever-api/verify?registration_id=&nonce= with  {\"signature\": hex HMAC-SHA256(secret, registration_id + \":\" + nonce)};  otherwise PERMISSION_DENIED. settings-api then connects the installation  to all of them or none, disconnecting the ones it no longer lists (they  keep their credentials), and rejecting ecommerces actively connected to  another installation or left by an uninstalled installation of a  different store (ALREADY_EXISTS).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkPrestashopShop: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/prestashop/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ListStores returns the physical stores for a given ecommerce platform and country.  Only platforms that have a store concept return results; others return an empty list.
         * @param {string} ecommerceId Ecommerce ID. Required.
         * @param {string} [countryCode] ISO 3166-1 alpha-2 country code filter. Optional — when empty, all stores are returned.
         * @param {string} [orderReference] Optional order reference; required to resolve the correct site for multi-site portals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStores: async (ecommerceId: string, countryCode?: string, orderReference?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('listStores', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/ecommerce/{ecommerce_id}/stores`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['order_reference'] = orderReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This informs the REVER platform to authenticate the e-commerce and  trigger the creation of the OAUTH token  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magentoIdentityLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/magento/oauth1/identity-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Callback for the OAuth1 flow in the Magento platform. This is used to  save the credentials that the platform has assigned to the app/module  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magentoOauth1Callback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/magento/oauth1/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks as refunded in the e-commerce platform each of the line items given in the request,  belonging to the given order
         * @param {PbMarkAsRefundedRequest} pbMarkAsRefundedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRefundedPublic: async (pbMarkAsRefundedRequest: PbMarkAsRefundedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbMarkAsRefundedRequest' is not null or undefined
            assertParamExists('markAsRefundedPublic', 'pbMarkAsRefundedRequest', pbMarkAsRefundedRequest)
            const localVarPath = `/v1/ecommerce/mark-as-refunded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbMarkAsRefundedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RegisterPrestashopShop handles the first call of the PrestaShop module\'s  register/confirm/link onboarding handshake. Unauthenticated (see  RegisterPrestashopShopRequest): mints and persists a per-registration  secret that verifies every subsequent call for this handshake.
         * @param {PbRegisterPrestashopShopRequest} pbRegisterPrestashopShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPrestashopShop: async (pbRegisterPrestashopShopRequest: PbRegisterPrestashopShopRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbRegisterPrestashopShopRequest' is not null or undefined
            assertParamExists('registerPrestashopShop', 'pbRegisterPrestashopShopRequest', pbRegisterPrestashopShopRequest)
            const localVarPath = `/v1/ecommerce/prestashop/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbRegisterPrestashopShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RegisterShop handles the first call of Shopware\'s App System registration  handshake, verified via the \"shopware-app-signature\" header (HMAC-SHA256  of the raw query string, app\'s static secret). Mints and persists a  per-shop secret that verifies every subsequent call for this install.
         * @param {string} [shopId] Shopware\&#39;s unique identifier for the shop installing the app
         * @param {string} [shopUrl] The shop\&#39;s base Admin API URL (e.g. \&quot;https://my-shop.example.com\&quot;)
         * @param {string} [timestamp] Unix timestamp (seconds, as a string) sent by Shopware
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerShop: async (shopId?: string, shopUrl?: string, timestamp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/shopware/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shopId !== undefined) {
                localVarQueryParameter['shop_id'] = shopId;
            }

            if (shopUrl !== undefined) {
                localVarQueryParameter['shop_url'] = shopUrl;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SearchCatalog searches the e-commerce\'s own catalog for the entries a non-returnable  rule or the Full Catalog can name, or resolves the ids already stored. Only Shopify is  supported; other platforms return UNIMPLEMENTED.
         * @param {string} ecommerceId Ecommerce ID
         * @param {SearchCatalogKindEnum} [kind] The kind of entry to search
         * @param {string} [query] Text to search for; empty returns the first entries
         * @param {Array<string>} [ids] Stored ids to resolve instead of searching; ids that no longer exist are left out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCatalog: async (ecommerceId: string, kind?: SearchCatalogKindEnum, query?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('searchCatalog', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/ecommerce/{ecommerce_id}/catalog`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ShopLifecycleWebhook receives app.activated/app.deactivated/app.deleted  events (event name via \"event\" query param, one registered URL per  event). Same shopware-shop-signature raw-body HMAC scheme as ConfirmShop.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopLifecycleWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/shopware/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ShopifyAppInstall handles the callback when a user installs the REVER app  through the Shopify App Store or using an installation link.  This endpoint verifies the authenticity of the request using HMAC-SHA256  and then initiates the OAuth flow.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
         * @param {string} [hmac] HMAC-SHA256 signature used to verify the authenticity of the request.  This value must be validated against all query parameters (except hmac itself)  using the app\&#39;s client secret from settings.
         * @param {string} [shop] The Shopify store domain (e.g., \&quot;mystore.myshopify.com\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyAppInstall: async (hmac?: string, shop?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/shopify/oauth/install`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hmac !== undefined) {
                localVarQueryParameter['hmac'] = hmac;
            }

            if (shop !== undefined) {
                localVarQueryParameter['shop'] = shop;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ShopifyOAuthCallback handles the OAuth callback after a user authorizes the app.  It validates the request parameters, verifies the state/nonce, and exchanges the  authorization code for access tokens.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
         * @param {string} [code] Authorization code that will be exchanged for access tokens
         * @param {string} [hmac] HMAC-SHA256 signature used to verify the authenticity of the request  This value must be validated against all query parameters (except hmac itself)
         * @param {string} [shop] The Shopify store domain (e.g., \&quot;mystore.myshopify.com\&quot;)
         * @param {string} [state] State parameter (nonce) that was originally sent in the install request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyOAuthCallback: async (code?: string, hmac?: string, shop?: string, state?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ecommerce/shopify/oauth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (hmac !== undefined) {
                localVarQueryParameter['hmac'] = hmac;
            }

            if (shop !== undefined) {
                localVarQueryParameter['shop'] = shop;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ECommerceApi - functional programming interface
 * @export
 */
export const ECommerceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ECommerceApiAxiosParamCreator(configuration)
    return {
        /**
         * ConfirmPrestashopShop handles the second call of the handshake: proof  the module received the secret minted by RegisterPrestashopShop, via the  X-REVER-Signature header (webhooksign, HMAC-SHA256 of the raw body,  keyed with that per-registration secret). The raw body is forwarded so  the signature can be verified over the exact bytes the module signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmPrestashopShop(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmPrestashopShop(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.confirmPrestashopShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ConfirmShop handles the second call of the registration handshake, header  shopware-shop-signature (HMAC-SHA256 of the raw body, per-shop secret).  The raw body is forwarded so the signature can be verified over the exact  bytes Shopware signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmShop(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmShop(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.confirmShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * DeactivatePrestashopShop receives the module\'s uninstall notification,  same X-REVER-Signature scheme as ConfirmPrestashopShop/LinkPrestashopShop.  The JSON body is {\"registration_id\"}. It deactivates every ecommerce  connected to the installation, keeping their credentials, and then the  installation. Idempotent, so the module can retry it.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivatePrestashopShop(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivatePrestashopShop(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.deactivatePrestashopShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for getting CustomPlatformSettings model
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCustomPlatformSettings(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCustomPlatformSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCustomPlatformSettings(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.findCustomPlatformSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding CustomPlatformSettings model by Shop ID
         * @param {string} shopId Shop ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCustomSettingsFromShopID(shopId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCustomPlatformSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCustomSettingsFromShopID(shopId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.findCustomSettingsFromShopID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding SalesforceSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSalesforceSettings(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSalesforceSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSalesforceSettings(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.findSalesforceSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetAvailableRestockLocations gets the available restock locations for the requested items
         * @param {string} [ecommerceId] Ecommerce ID
         * @param {Array<string>} [variantIds] Variant IDs of the requested items
         * @param {string} [orderId] Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableRestockLocations(ecommerceId?: string, variantIds?: Array<string>, orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetAvailableRestockLocationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableRestockLocations(ecommerceId, variantIds, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.getAvailableRestockLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Custom endpoint for ecommerce thebradery - get products and brands
         * @param {string} [email] The email of the customer. Required.
         * @param {string} [orderNumber] The order number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductsAndBrandsFromTheBradery(email?: string, orderNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetProductsAndBrandsTheBraderyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsAndBrandsFromTheBradery(email, orderNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.getProductsAndBrandsFromTheBradery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LinkPrestashopShop handles the final call of the handshake, same  X-REVER-Signature scheme as ConfirmPrestashopShop. The JSON body is  {\"registration_id\", \"ecommerce_ids\": [...], \"api_key\"}: the complete set of  ecommerces the merchant was given out of band and the PrestaShop  webservice key the module generated for REVER. ecommerce_ids must be  present; an empty list disconnects every ecommerce of the installation  and is the only case where api_key may be empty. The registration must be  confirmed and installed, and every ecommerce must exist and be a  PrestaShop store (otherwise INVALID_ARGUMENT). A rejection names every  offending ecommerce at once: \"rejected ecommerce ids: <id> (<reason>), ...\".  An ecommerce connected via the legacy flow is migrated,  taking api_key as its new key, only if the module answers  GET {stored store URL}/rever-api/verify?registration_id=&nonce= with  {\"signature\": hex HMAC-SHA256(secret, registration_id + \":\" + nonce)};  otherwise PERMISSION_DENIED. settings-api then connects the installation  to all of them or none, disconnecting the ones it no longer lists (they  keep their credentials), and rejecting ecommerces actively connected to  another installation or left by an uninstalled installation of a  different store (ALREADY_EXISTS).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkPrestashopShop(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbLinkPrestashopShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkPrestashopShop(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.linkPrestashopShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ListStores returns the physical stores for a given ecommerce platform and country.  Only platforms that have a store concept return results; others return an empty list.
         * @param {string} ecommerceId Ecommerce ID. Required.
         * @param {string} [countryCode] ISO 3166-1 alpha-2 country code filter. Optional — when empty, all stores are returned.
         * @param {string} [orderReference] Optional order reference; required to resolve the correct site for multi-site portals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStores(ecommerceId: string, countryCode?: string, orderReference?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListStoresResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStores(ecommerceId, countryCode, orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.listStores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This informs the REVER platform to authenticate the e-commerce and  trigger the creation of the OAUTH token  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async magentoIdentityLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.magentoIdentityLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.magentoIdentityLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Callback for the OAuth1 flow in the Magento platform. This is used to  save the credentials that the platform has assigned to the app/module  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async magentoOauth1Callback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.magentoOauth1Callback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.magentoOauth1Callback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks as refunded in the e-commerce platform each of the line items given in the request,  belonging to the given order
         * @param {PbMarkAsRefundedRequest} pbMarkAsRefundedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRefundedPublic(pbMarkAsRefundedRequest: PbMarkAsRefundedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbMarkAsRefundedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRefundedPublic(pbMarkAsRefundedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.markAsRefundedPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * RegisterPrestashopShop handles the first call of the PrestaShop module\'s  register/confirm/link onboarding handshake. Unauthenticated (see  RegisterPrestashopShopRequest): mints and persists a per-registration  secret that verifies every subsequent call for this handshake.
         * @param {PbRegisterPrestashopShopRequest} pbRegisterPrestashopShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPrestashopShop(pbRegisterPrestashopShopRequest: PbRegisterPrestashopShopRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbRegisterPrestashopShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPrestashopShop(pbRegisterPrestashopShopRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.registerPrestashopShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * RegisterShop handles the first call of Shopware\'s App System registration  handshake, verified via the \"shopware-app-signature\" header (HMAC-SHA256  of the raw query string, app\'s static secret). Mints and persists a  per-shop secret that verifies every subsequent call for this install.
         * @param {string} [shopId] Shopware\&#39;s unique identifier for the shop installing the app
         * @param {string} [shopUrl] The shop\&#39;s base Admin API URL (e.g. \&quot;https://my-shop.example.com\&quot;)
         * @param {string} [timestamp] Unix timestamp (seconds, as a string) sent by Shopware
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerShop(shopId?: string, shopUrl?: string, timestamp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbRegisterShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerShop(shopId, shopUrl, timestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.registerShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SearchCatalog searches the e-commerce\'s own catalog for the entries a non-returnable  rule or the Full Catalog can name, or resolves the ids already stored. Only Shopify is  supported; other platforms return UNIMPLEMENTED.
         * @param {string} ecommerceId Ecommerce ID
         * @param {SearchCatalogKindEnum} [kind] The kind of entry to search
         * @param {string} [query] Text to search for; empty returns the first entries
         * @param {Array<string>} [ids] Stored ids to resolve instead of searching; ids that no longer exist are left out
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCatalog(ecommerceId: string, kind?: SearchCatalogKindEnum, query?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSearchCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCatalog(ecommerceId, kind, query, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.searchCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ShopLifecycleWebhook receives app.activated/app.deactivated/app.deleted  events (event name via \"event\" query param, one registered URL per  event). Same shopware-shop-signature raw-body HMAC scheme as ConfirmShop.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopLifecycleWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopLifecycleWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.shopLifecycleWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ShopifyAppInstall handles the callback when a user installs the REVER app  through the Shopify App Store or using an installation link.  This endpoint verifies the authenticity of the request using HMAC-SHA256  and then initiates the OAuth flow.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
         * @param {string} [hmac] HMAC-SHA256 signature used to verify the authenticity of the request.  This value must be validated against all query parameters (except hmac itself)  using the app\&#39;s client secret from settings.
         * @param {string} [shop] The Shopify store domain (e.g., \&quot;mystore.myshopify.com\&quot;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyAppInstall(hmac?: string, shop?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyAppInstall(hmac, shop, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.shopifyAppInstall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ShopifyOAuthCallback handles the OAuth callback after a user authorizes the app.  It validates the request parameters, verifies the state/nonce, and exchanges the  authorization code for access tokens.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
         * @param {string} [code] Authorization code that will be exchanged for access tokens
         * @param {string} [hmac] HMAC-SHA256 signature used to verify the authenticity of the request  This value must be validated against all query parameters (except hmac itself)
         * @param {string} [shop] The Shopify store domain (e.g., \&quot;mystore.myshopify.com\&quot;)
         * @param {string} [state] State parameter (nonce) that was originally sent in the install request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyOAuthCallback(code?: string, hmac?: string, shop?: string, state?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbShopifyOAuthCallbackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyOAuthCallback(code, hmac, shop, state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ECommerceApi.shopifyOAuthCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ECommerceApi - factory interface
 * @export
 */
export const ECommerceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ECommerceApiFp(configuration)
    return {
        /**
         * ConfirmPrestashopShop handles the second call of the handshake: proof  the module received the secret minted by RegisterPrestashopShop, via the  X-REVER-Signature header (webhooksign, HMAC-SHA256 of the raw body,  keyed with that per-registration secret). The raw body is forwarded so  the signature can be verified over the exact bytes the module signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPrestashopShop(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.confirmPrestashopShop(options).then((request) => request(axios, basePath));
        },
        /**
         * ConfirmShop handles the second call of the registration handshake, header  shopware-shop-signature (HMAC-SHA256 of the raw body, per-shop secret).  The raw body is forwarded so the signature can be verified over the exact  bytes Shopware signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmShop(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.confirmShop(options).then((request) => request(axios, basePath));
        },
        /**
         * DeactivatePrestashopShop receives the module\'s uninstall notification,  same X-REVER-Signature scheme as ConfirmPrestashopShop/LinkPrestashopShop.  The JSON body is {\"registration_id\"}. It deactivates every ecommerce  connected to the installation, keeping their credentials, and then the  installation. Idempotent, so the module can retry it.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivatePrestashopShop(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deactivatePrestashopShop(options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for getting CustomPlatformSettings model
         * @param {ECommerceApiFindCustomPlatformSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomPlatformSettings(requestParameters: ECommerceApiFindCustomPlatformSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbCustomPlatformSettingsResponse> {
            return localVarFp.findCustomPlatformSettings(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding CustomPlatformSettings model by Shop ID
         * @param {ECommerceApiFindCustomSettingsFromShopIDRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCustomSettingsFromShopID(requestParameters: ECommerceApiFindCustomSettingsFromShopIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCustomPlatformSettingsResponse> {
            return localVarFp.findCustomSettingsFromShopID(requestParameters.shopId, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding SalesforceSettings model
         * @param {ECommerceApiFindSalesforceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSalesforceSettings(requestParameters: ECommerceApiFindSalesforceSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSalesforceSettingsResponse> {
            return localVarFp.findSalesforceSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * GetAvailableRestockLocations gets the available restock locations for the requested items
         * @param {ECommerceApiGetAvailableRestockLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableRestockLocations(requestParameters: ECommerceApiGetAvailableRestockLocationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGetAvailableRestockLocationsResponse> {
            return localVarFp.getAvailableRestockLocations(requestParameters.ecommerceId, requestParameters.variantIds, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Custom endpoint for ecommerce thebradery - get products and brands
         * @param {ECommerceApiGetProductsAndBrandsFromTheBraderyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsAndBrandsFromTheBradery(requestParameters: ECommerceApiGetProductsAndBrandsFromTheBraderyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGetProductsAndBrandsTheBraderyResponse> {
            return localVarFp.getProductsAndBrandsFromTheBradery(requestParameters.email, requestParameters.orderNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * LinkPrestashopShop handles the final call of the handshake, same  X-REVER-Signature scheme as ConfirmPrestashopShop. The JSON body is  {\"registration_id\", \"ecommerce_ids\": [...], \"api_key\"}: the complete set of  ecommerces the merchant was given out of band and the PrestaShop  webservice key the module generated for REVER. ecommerce_ids must be  present; an empty list disconnects every ecommerce of the installation  and is the only case where api_key may be empty. The registration must be  confirmed and installed, and every ecommerce must exist and be a  PrestaShop store (otherwise INVALID_ARGUMENT). A rejection names every  offending ecommerce at once: \"rejected ecommerce ids: <id> (<reason>), ...\".  An ecommerce connected via the legacy flow is migrated,  taking api_key as its new key, only if the module answers  GET {stored store URL}/rever-api/verify?registration_id=&nonce= with  {\"signature\": hex HMAC-SHA256(secret, registration_id + \":\" + nonce)};  otherwise PERMISSION_DENIED. settings-api then connects the installation  to all of them or none, disconnecting the ones it no longer lists (they  keep their credentials), and rejecting ecommerces actively connected to  another installation or left by an uninstalled installation of a  different store (ALREADY_EXISTS).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkPrestashopShop(options?: RawAxiosRequestConfig): AxiosPromise<PbLinkPrestashopShopResponse> {
            return localVarFp.linkPrestashopShop(options).then((request) => request(axios, basePath));
        },
        /**
         * ListStores returns the physical stores for a given ecommerce platform and country.  Only platforms that have a store concept return results; others return an empty list.
         * @param {ECommerceApiListStoresRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStores(requestParameters: ECommerceApiListStoresRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbListStoresResponse> {
            return localVarFp.listStores(requestParameters.ecommerceId, requestParameters.countryCode, requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * This informs the REVER platform to authenticate the e-commerce and  trigger the creation of the OAUTH token  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magentoIdentityLink(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.magentoIdentityLink(options).then((request) => request(axios, basePath));
        },
        /**
         * Callback for the OAuth1 flow in the Magento platform. This is used to  save the credentials that the platform has assigned to the app/module  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magentoOauth1Callback(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.magentoOauth1Callback(options).then((request) => request(axios, basePath));
        },
        /**
         * Marks as refunded in the e-commerce platform each of the line items given in the request,  belonging to the given order
         * @param {ECommerceApiMarkAsRefundedPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRefundedPublic(requestParameters: ECommerceApiMarkAsRefundedPublicRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbMarkAsRefundedResponse> {
            return localVarFp.markAsRefundedPublic(requestParameters.pbMarkAsRefundedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * RegisterPrestashopShop handles the first call of the PrestaShop module\'s  register/confirm/link onboarding handshake. Unauthenticated (see  RegisterPrestashopShopRequest): mints and persists a per-registration  secret that verifies every subsequent call for this handshake.
         * @param {ECommerceApiRegisterPrestashopShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPrestashopShop(requestParameters: ECommerceApiRegisterPrestashopShopRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbRegisterPrestashopShopResponse> {
            return localVarFp.registerPrestashopShop(requestParameters.pbRegisterPrestashopShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * RegisterShop handles the first call of Shopware\'s App System registration  handshake, verified via the \"shopware-app-signature\" header (HMAC-SHA256  of the raw query string, app\'s static secret). Mints and persists a  per-shop secret that verifies every subsequent call for this install.
         * @param {ECommerceApiRegisterShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerShop(requestParameters: ECommerceApiRegisterShopRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbRegisterShopResponse> {
            return localVarFp.registerShop(requestParameters.shopId, requestParameters.shopUrl, requestParameters.timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * SearchCatalog searches the e-commerce\'s own catalog for the entries a non-returnable  rule or the Full Catalog can name, or resolves the ids already stored. Only Shopify is  supported; other platforms return UNIMPLEMENTED.
         * @param {ECommerceApiSearchCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCatalog(requestParameters: ECommerceApiSearchCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSearchCatalogResponse> {
            return localVarFp.searchCatalog(requestParameters.ecommerceId, requestParameters.kind, requestParameters.query, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * ShopLifecycleWebhook receives app.activated/app.deactivated/app.deleted  events (event name via \"event\" query param, one registered URL per  event). Same shopware-shop-signature raw-body HMAC scheme as ConfirmShop.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopLifecycleWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.shopLifecycleWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * ShopifyAppInstall handles the callback when a user installs the REVER app  through the Shopify App Store or using an installation link.  This endpoint verifies the authenticity of the request using HMAC-SHA256  and then initiates the OAuth flow.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
         * @param {ECommerceApiShopifyAppInstallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyAppInstall(requestParameters: ECommerceApiShopifyAppInstallRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.shopifyAppInstall(requestParameters.hmac, requestParameters.shop, options).then((request) => request(axios, basePath));
        },
        /**
         * ShopifyOAuthCallback handles the OAuth callback after a user authorizes the app.  It validates the request parameters, verifies the state/nonce, and exchanges the  authorization code for access tokens.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
         * @param {ECommerceApiShopifyOAuthCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyOAuthCallback(requestParameters: ECommerceApiShopifyOAuthCallbackRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbShopifyOAuthCallbackResponse> {
            return localVarFp.shopifyOAuthCallback(requestParameters.code, requestParameters.hmac, requestParameters.shop, requestParameters.state, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findCustomPlatformSettings operation in ECommerceApi.
 * @export
 * @interface ECommerceApiFindCustomPlatformSettingsRequest
 */
export interface ECommerceApiFindCustomPlatformSettingsRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof ECommerceApiFindCustomPlatformSettings
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof ECommerceApiFindCustomPlatformSettings
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof ECommerceApiFindCustomPlatformSettings
     */
    readonly group?: string
}

/**
 * Request parameters for findCustomSettingsFromShopID operation in ECommerceApi.
 * @export
 * @interface ECommerceApiFindCustomSettingsFromShopIDRequest
 */
export interface ECommerceApiFindCustomSettingsFromShopIDRequest {
    /**
     * Shop ID
     * @type {string}
     * @memberof ECommerceApiFindCustomSettingsFromShopID
     */
    readonly shopId: string
}

/**
 * Request parameters for findSalesforceSettings operation in ECommerceApi.
 * @export
 * @interface ECommerceApiFindSalesforceSettingsRequest
 */
export interface ECommerceApiFindSalesforceSettingsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof ECommerceApiFindSalesforceSettings
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof ECommerceApiFindSalesforceSettings
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof ECommerceApiFindSalesforceSettings
     */
    readonly group?: string
}

/**
 * Request parameters for getAvailableRestockLocations operation in ECommerceApi.
 * @export
 * @interface ECommerceApiGetAvailableRestockLocationsRequest
 */
export interface ECommerceApiGetAvailableRestockLocationsRequest {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof ECommerceApiGetAvailableRestockLocations
     */
    readonly ecommerceId?: string

    /**
     * Variant IDs of the requested items
     * @type {Array<string>}
     * @memberof ECommerceApiGetAvailableRestockLocations
     */
    readonly variantIds?: Array<string>

    /**
     * Order ID
     * @type {string}
     * @memberof ECommerceApiGetAvailableRestockLocations
     */
    readonly orderId?: string
}

/**
 * Request parameters for getProductsAndBrandsFromTheBradery operation in ECommerceApi.
 * @export
 * @interface ECommerceApiGetProductsAndBrandsFromTheBraderyRequest
 */
export interface ECommerceApiGetProductsAndBrandsFromTheBraderyRequest {
    /**
     * The email of the customer. Required.
     * @type {string}
     * @memberof ECommerceApiGetProductsAndBrandsFromTheBradery
     */
    readonly email?: string

    /**
     * The order number
     * @type {string}
     * @memberof ECommerceApiGetProductsAndBrandsFromTheBradery
     */
    readonly orderNumber?: string
}

/**
 * Request parameters for listStores operation in ECommerceApi.
 * @export
 * @interface ECommerceApiListStoresRequest
 */
export interface ECommerceApiListStoresRequest {
    /**
     * Ecommerce ID. Required.
     * @type {string}
     * @memberof ECommerceApiListStores
     */
    readonly ecommerceId: string

    /**
     * ISO 3166-1 alpha-2 country code filter. Optional — when empty, all stores are returned.
     * @type {string}
     * @memberof ECommerceApiListStores
     */
    readonly countryCode?: string

    /**
     * Optional order reference; required to resolve the correct site for multi-site portals
     * @type {string}
     * @memberof ECommerceApiListStores
     */
    readonly orderReference?: string
}

/**
 * Request parameters for markAsRefundedPublic operation in ECommerceApi.
 * @export
 * @interface ECommerceApiMarkAsRefundedPublicRequest
 */
export interface ECommerceApiMarkAsRefundedPublicRequest {
    /**
     * 
     * @type {PbMarkAsRefundedRequest}
     * @memberof ECommerceApiMarkAsRefundedPublic
     */
    readonly pbMarkAsRefundedRequest: PbMarkAsRefundedRequest
}

/**
 * Request parameters for registerPrestashopShop operation in ECommerceApi.
 * @export
 * @interface ECommerceApiRegisterPrestashopShopRequest
 */
export interface ECommerceApiRegisterPrestashopShopRequest {
    /**
     * 
     * @type {PbRegisterPrestashopShopRequest}
     * @memberof ECommerceApiRegisterPrestashopShop
     */
    readonly pbRegisterPrestashopShopRequest: PbRegisterPrestashopShopRequest
}

/**
 * Request parameters for registerShop operation in ECommerceApi.
 * @export
 * @interface ECommerceApiRegisterShopRequest
 */
export interface ECommerceApiRegisterShopRequest {
    /**
     * Shopware\&#39;s unique identifier for the shop installing the app
     * @type {string}
     * @memberof ECommerceApiRegisterShop
     */
    readonly shopId?: string

    /**
     * The shop\&#39;s base Admin API URL (e.g. \&quot;https://my-shop.example.com\&quot;)
     * @type {string}
     * @memberof ECommerceApiRegisterShop
     */
    readonly shopUrl?: string

    /**
     * Unix timestamp (seconds, as a string) sent by Shopware
     * @type {string}
     * @memberof ECommerceApiRegisterShop
     */
    readonly timestamp?: string
}

/**
 * Request parameters for searchCatalog operation in ECommerceApi.
 * @export
 * @interface ECommerceApiSearchCatalogRequest
 */
export interface ECommerceApiSearchCatalogRequest {
    /**
     * Ecommerce ID
     * @type {string}
     * @memberof ECommerceApiSearchCatalog
     */
    readonly ecommerceId: string

    /**
     * The kind of entry to search
     * @type {'CATALOG_KIND_UNSPECIFIED' | 'CATALOG_KIND_PRODUCT' | 'CATALOG_KIND_COLLECTION' | 'CATALOG_KIND_PRODUCT_TYPE' | 'CATALOG_KIND_PRODUCT_TAG' | 'CATALOG_KIND_MENU'}
     * @memberof ECommerceApiSearchCatalog
     */
    readonly kind?: SearchCatalogKindEnum

    /**
     * Text to search for; empty returns the first entries
     * @type {string}
     * @memberof ECommerceApiSearchCatalog
     */
    readonly query?: string

    /**
     * Stored ids to resolve instead of searching; ids that no longer exist are left out
     * @type {Array<string>}
     * @memberof ECommerceApiSearchCatalog
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for shopifyAppInstall operation in ECommerceApi.
 * @export
 * @interface ECommerceApiShopifyAppInstallRequest
 */
export interface ECommerceApiShopifyAppInstallRequest {
    /**
     * HMAC-SHA256 signature used to verify the authenticity of the request.  This value must be validated against all query parameters (except hmac itself)  using the app\&#39;s client secret from settings.
     * @type {string}
     * @memberof ECommerceApiShopifyAppInstall
     */
    readonly hmac?: string

    /**
     * The Shopify store domain (e.g., \&quot;mystore.myshopify.com\&quot;)
     * @type {string}
     * @memberof ECommerceApiShopifyAppInstall
     */
    readonly shop?: string
}

/**
 * Request parameters for shopifyOAuthCallback operation in ECommerceApi.
 * @export
 * @interface ECommerceApiShopifyOAuthCallbackRequest
 */
export interface ECommerceApiShopifyOAuthCallbackRequest {
    /**
     * Authorization code that will be exchanged for access tokens
     * @type {string}
     * @memberof ECommerceApiShopifyOAuthCallback
     */
    readonly code?: string

    /**
     * HMAC-SHA256 signature used to verify the authenticity of the request  This value must be validated against all query parameters (except hmac itself)
     * @type {string}
     * @memberof ECommerceApiShopifyOAuthCallback
     */
    readonly hmac?: string

    /**
     * The Shopify store domain (e.g., \&quot;mystore.myshopify.com\&quot;)
     * @type {string}
     * @memberof ECommerceApiShopifyOAuthCallback
     */
    readonly shop?: string

    /**
     * State parameter (nonce) that was originally sent in the install request
     * @type {string}
     * @memberof ECommerceApiShopifyOAuthCallback
     */
    readonly state?: string
}

/**
 * ECommerceApi - object-oriented interface
 * @export
 * @class ECommerceApi
 * @extends {BaseAPI}
 */
export class ECommerceApi extends BaseAPI {
    /**
     * ConfirmPrestashopShop handles the second call of the handshake: proof  the module received the secret minted by RegisterPrestashopShop, via the  X-REVER-Signature header (webhooksign, HMAC-SHA256 of the raw body,  keyed with that per-registration secret). The raw body is forwarded so  the signature can be verified over the exact bytes the module signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public confirmPrestashopShop(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).confirmPrestashopShop(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ConfirmShop handles the second call of the registration handshake, header  shopware-shop-signature (HMAC-SHA256 of the raw body, per-shop secret).  The raw body is forwarded so the signature can be verified over the exact  bytes Shopware signed.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public confirmShop(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).confirmShop(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DeactivatePrestashopShop receives the module\'s uninstall notification,  same X-REVER-Signature scheme as ConfirmPrestashopShop/LinkPrestashopShop.  The JSON body is {\"registration_id\"}. It deactivates every ecommerce  connected to the installation, keeping their credentials, and then the  installation. Idempotent, so the module can retry it.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public deactivatePrestashopShop(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).deactivatePrestashopShop(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for getting CustomPlatformSettings model
     * @param {ECommerceApiFindCustomPlatformSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public findCustomPlatformSettings(requestParameters: ECommerceApiFindCustomPlatformSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).findCustomPlatformSettings(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding CustomPlatformSettings model by Shop ID
     * @param {ECommerceApiFindCustomSettingsFromShopIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public findCustomSettingsFromShopID(requestParameters: ECommerceApiFindCustomSettingsFromShopIDRequest, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).findCustomSettingsFromShopID(requestParameters.shopId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding SalesforceSettings model
     * @param {ECommerceApiFindSalesforceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public findSalesforceSettings(requestParameters: ECommerceApiFindSalesforceSettingsRequest, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).findSalesforceSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetAvailableRestockLocations gets the available restock locations for the requested items
     * @param {ECommerceApiGetAvailableRestockLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public getAvailableRestockLocations(requestParameters: ECommerceApiGetAvailableRestockLocationsRequest = {}, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).getAvailableRestockLocations(requestParameters.ecommerceId, requestParameters.variantIds, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Custom endpoint for ecommerce thebradery - get products and brands
     * @param {ECommerceApiGetProductsAndBrandsFromTheBraderyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public getProductsAndBrandsFromTheBradery(requestParameters: ECommerceApiGetProductsAndBrandsFromTheBraderyRequest = {}, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).getProductsAndBrandsFromTheBradery(requestParameters.email, requestParameters.orderNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LinkPrestashopShop handles the final call of the handshake, same  X-REVER-Signature scheme as ConfirmPrestashopShop. The JSON body is  {\"registration_id\", \"ecommerce_ids\": [...], \"api_key\"}: the complete set of  ecommerces the merchant was given out of band and the PrestaShop  webservice key the module generated for REVER. ecommerce_ids must be  present; an empty list disconnects every ecommerce of the installation  and is the only case where api_key may be empty. The registration must be  confirmed and installed, and every ecommerce must exist and be a  PrestaShop store (otherwise INVALID_ARGUMENT). A rejection names every  offending ecommerce at once: \"rejected ecommerce ids: <id> (<reason>), ...\".  An ecommerce connected via the legacy flow is migrated,  taking api_key as its new key, only if the module answers  GET {stored store URL}/rever-api/verify?registration_id=&nonce= with  {\"signature\": hex HMAC-SHA256(secret, registration_id + \":\" + nonce)};  otherwise PERMISSION_DENIED. settings-api then connects the installation  to all of them or none, disconnecting the ones it no longer lists (they  keep their credentials), and rejecting ecommerces actively connected to  another installation or left by an uninstalled installation of a  different store (ALREADY_EXISTS).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public linkPrestashopShop(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).linkPrestashopShop(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ListStores returns the physical stores for a given ecommerce platform and country.  Only platforms that have a store concept return results; others return an empty list.
     * @param {ECommerceApiListStoresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public listStores(requestParameters: ECommerceApiListStoresRequest, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).listStores(requestParameters.ecommerceId, requestParameters.countryCode, requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This informs the REVER platform to authenticate the e-commerce and  trigger the creation of the OAUTH token  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public magentoIdentityLink(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).magentoIdentityLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Callback for the OAuth1 flow in the Magento platform. This is used to  save the credentials that the platform has assigned to the app/module  https://devdocs.magento.com/guides/v2.3/get-started/  authentication/gs-authentication-oauth.html
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public magentoOauth1Callback(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).magentoOauth1Callback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks as refunded in the e-commerce platform each of the line items given in the request,  belonging to the given order
     * @param {ECommerceApiMarkAsRefundedPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public markAsRefundedPublic(requestParameters: ECommerceApiMarkAsRefundedPublicRequest, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).markAsRefundedPublic(requestParameters.pbMarkAsRefundedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RegisterPrestashopShop handles the first call of the PrestaShop module\'s  register/confirm/link onboarding handshake. Unauthenticated (see  RegisterPrestashopShopRequest): mints and persists a per-registration  secret that verifies every subsequent call for this handshake.
     * @param {ECommerceApiRegisterPrestashopShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public registerPrestashopShop(requestParameters: ECommerceApiRegisterPrestashopShopRequest, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).registerPrestashopShop(requestParameters.pbRegisterPrestashopShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RegisterShop handles the first call of Shopware\'s App System registration  handshake, verified via the \"shopware-app-signature\" header (HMAC-SHA256  of the raw query string, app\'s static secret). Mints and persists a  per-shop secret that verifies every subsequent call for this install.
     * @param {ECommerceApiRegisterShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public registerShop(requestParameters: ECommerceApiRegisterShopRequest = {}, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).registerShop(requestParameters.shopId, requestParameters.shopUrl, requestParameters.timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SearchCatalog searches the e-commerce\'s own catalog for the entries a non-returnable  rule or the Full Catalog can name, or resolves the ids already stored. Only Shopify is  supported; other platforms return UNIMPLEMENTED.
     * @param {ECommerceApiSearchCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public searchCatalog(requestParameters: ECommerceApiSearchCatalogRequest, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).searchCatalog(requestParameters.ecommerceId, requestParameters.kind, requestParameters.query, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ShopLifecycleWebhook receives app.activated/app.deactivated/app.deleted  events (event name via \"event\" query param, one registered URL per  event). Same shopware-shop-signature raw-body HMAC scheme as ConfirmShop.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public shopLifecycleWebhook(options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).shopLifecycleWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ShopifyAppInstall handles the callback when a user installs the REVER app  through the Shopify App Store or using an installation link.  This endpoint verifies the authenticity of the request using HMAC-SHA256  and then initiates the OAuth flow.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
     * @param {ECommerceApiShopifyAppInstallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public shopifyAppInstall(requestParameters: ECommerceApiShopifyAppInstallRequest = {}, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).shopifyAppInstall(requestParameters.hmac, requestParameters.shop, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ShopifyOAuthCallback handles the OAuth callback after a user authorizes the app.  It validates the request parameters, verifies the state/nonce, and exchanges the  authorization code for access tokens.  Reference: https://shopify.dev/docs/apps/auth/oauth/getting-started
     * @param {ECommerceApiShopifyOAuthCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ECommerceApi
     */
    public shopifyOAuthCallback(requestParameters: ECommerceApiShopifyOAuthCallbackRequest = {}, options?: RawAxiosRequestConfig) {
        return ECommerceApiFp(this.configuration).shopifyOAuthCallback(requestParameters.code, requestParameters.hmac, requestParameters.shop, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SearchCatalogKindEnum = {
    Unspecified: 'CATALOG_KIND_UNSPECIFIED',
    Product: 'CATALOG_KIND_PRODUCT',
    Collection: 'CATALOG_KIND_COLLECTION',
    ProductType: 'CATALOG_KIND_PRODUCT_TYPE',
    ProductTag: 'CATALOG_KIND_PRODUCT_TAG',
    Menu: 'CATALOG_KIND_MENU'
} as const;
export type SearchCatalogKindEnum = typeof SearchCatalogKindEnum[keyof typeof SearchCatalogKindEnum];


/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * AmphoraReturnWebhook receives return lifecycle notifications from Amphora\'s Partner API.  The raw body is forwarded so the shared secret in the x-amphora-secret header can be checked  before the payload is processed. Amphora sends a partner-defined static secret rather than an  HMAC, and the body shape is set by a Liquid template configured in their partner portal.  Successful calls publish an AMPHORA_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amphoraReturnWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/amphora/return-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * AsyncRefundConfirmationWebhook receives the outcome of the refund legs REVER asked an  async-refund merchant (e.g. Boardriders) to execute. The raw body is forwarded so the  X-REVER-Signature header (HMAC-SHA256 over \"{t}.{raw_body}\", signed with the group\'s  webhook signing secret, the same one REVER signs its outbound refund request with) can be  verified before processing. The body may be wrapped in \"webhook\" or sent bare; each entry\'s  rever_transaction_id identifies the pending transaction. Confirmed entries are forwarded to  ops-api.ConfirmRefundTransaction, which signals the refund workflow.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asyncRefundConfirmationWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/async-refund/confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * EasypostTrackerWebhook receives EasyPost Event webhook notifications. The raw body is  forwarded so that the HMAC-SHA256 signature in the X-Hmac-Signature header can be  verified before the payload is processed. Only tracker.updated events are processed  (other event types are acknowledged and ignored). Successful calls publish an  EASYPOST_TRACKER_UPDATED event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        easypostTrackerWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/easypost/tracker-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FlexportReturnWebhook receives Return.Updated notifications from Flexport\'s Logistics API.  The raw body is forwarded so the shared secret in the x-flexport-secret header can be checked  before the payload is processed. Flexport echoes a static token under a header name we choose  when registering the webhook (its tokenHeader parameter) rather than signing the body. The  delivery carries the complete return object, per-unit dispositions included, so no follow-up  call to Flexport is needed. Only a PROCESSED return publishes a FLEXPORT_RETURN_EVENT into the  events pipeline; Return.Updated also fires on warehouse intake, and that delivery carries no  verdict.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flexportReturnWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/flexport/return-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PicqerReturnWebhook receives Picqer\'s returns.products_received notifications, which carry  what the warehouse found. The raw body is forwarded so the base64 HMAC-SHA256 signature in  the X-Picqer-Signature header can be verified over the exact bytes Picqer signed.  Deliveries for returns not created by REVER (reference is not a process id) are  acknowledged and ignored. Successful calls publish a PICQER_RETURN_EVENT into the  events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        picqerReturnWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/picqer/return-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SeelWebhook receives a Seel webhook notification (contract.* or claim.* events).  The raw body is forwarded so the HMAC-SHA256 signature can be verified before processing.  Successful calls publish the corresponding SEEL_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seelWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/seel/worry-free-purchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SendcloudParcelStatusWebhook receives a SENDCLOUD_PARCEL_STATUS_CHANGED webhook event  from Sendcloud. The raw body is forwarded so that the HMAC-SHA256 signature in the  Sendcloud-Signature header can be verified before the payload is processed. Successful  calls publish a SENDCLOUD_PARCEL_STATUS_CHANGED event into the events pipeline which  triggers any configured subscriptions.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendcloudParcelStatusWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/sendcloud/parcel-status-changed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SevicaReviewWebhook receives item-review results from Sevica\'s warehouse system for a  return process. The x-sevica-secret header carries a partner-defined static shared  secret (like Amphora, not an HMAC). Deliveries for returns not created by REVER  (reference is not a process id) are acknowledged and ignored. Successful calls  publish a SEVICA_RETURN_EVENT into the events pipeline; nothing subscribes to it in  this PR (the sevica_review transformer is a separate change).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sevicaReviewWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/sevica/review-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ShopifyWebhook receives Shopify webhook notifications for topics:  app/uninstalled, orders/create, orders/cancelled, orders/updated,  fulfillments/create, fulfillments/update, products/update.  The raw body is forwarded so the HMAC-SHA256 signature in the  X-Shopify-Hmac-Sha256 header can be verified before processing.  The topic is read from the X-Shopify-Topic header.  Successful calls publish the corresponding SHOPIFY_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/shopify/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * TypeformWebhook receives CSAT survey responses and publishes a TYPEFORM_FORM_RESPONSE event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        typeformWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/typeform/form-responses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Way2SendReturnWebhook receives return status changes from Way2Send\'s WMS, which the  warehouse operator built for REVER: there is no standard webhook in their customer API.  The x-way2send-secret header carries a partner-defined static shared secret (like  Amphora and Sevica, not an HMAC). The delivery names the return, the status it moved  from and to, and the per-SKU condition the warehouse found. Deliveries for returns not  created by REVER (returnId is not a process id) are acknowledged and ignored.  Successful calls publish a WAY2SEND_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        way2SendReturnWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/way2send/return-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ZendeskWebhook receives Zendesk ticket updates and publishes a ZENDESK_TICKET_UPDATED event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zendeskWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/zendesk/ticket-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * AmphoraReturnWebhook receives return lifecycle notifications from Amphora\'s Partner API.  The raw body is forwarded so the shared secret in the x-amphora-secret header can be checked  before the payload is processed. Amphora sends a partner-defined static secret rather than an  HMAC, and the body shape is set by a Liquid template configured in their partner portal.  Successful calls publish an AMPHORA_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async amphoraReturnWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.amphoraReturnWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.amphoraReturnWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * AsyncRefundConfirmationWebhook receives the outcome of the refund legs REVER asked an  async-refund merchant (e.g. Boardriders) to execute. The raw body is forwarded so the  X-REVER-Signature header (HMAC-SHA256 over \"{t}.{raw_body}\", signed with the group\'s  webhook signing secret, the same one REVER signs its outbound refund request with) can be  verified before processing. The body may be wrapped in \"webhook\" or sent bare; each entry\'s  rever_transaction_id identifies the pending transaction. Confirmed entries are forwarded to  ops-api.ConfirmRefundTransaction, which signals the refund workflow.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asyncRefundConfirmationWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventspbAsyncRefundConfirmationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asyncRefundConfirmationWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.asyncRefundConfirmationWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * EasypostTrackerWebhook receives EasyPost Event webhook notifications. The raw body is  forwarded so that the HMAC-SHA256 signature in the X-Hmac-Signature header can be  verified before the payload is processed. Only tracker.updated events are processed  (other event types are acknowledged and ignored). Successful calls publish an  EASYPOST_TRACKER_UPDATED event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async easypostTrackerWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.easypostTrackerWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.easypostTrackerWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FlexportReturnWebhook receives Return.Updated notifications from Flexport\'s Logistics API.  The raw body is forwarded so the shared secret in the x-flexport-secret header can be checked  before the payload is processed. Flexport echoes a static token under a header name we choose  when registering the webhook (its tokenHeader parameter) rather than signing the body. The  delivery carries the complete return object, per-unit dispositions included, so no follow-up  call to Flexport is needed. Only a PROCESSED return publishes a FLEXPORT_RETURN_EVENT into the  events pipeline; Return.Updated also fires on warehouse intake, and that delivery carries no  verdict.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flexportReturnWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flexportReturnWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.flexportReturnWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PicqerReturnWebhook receives Picqer\'s returns.products_received notifications, which carry  what the warehouse found. The raw body is forwarded so the base64 HMAC-SHA256 signature in  the X-Picqer-Signature header can be verified over the exact bytes Picqer signed.  Deliveries for returns not created by REVER (reference is not a process id) are  acknowledged and ignored. Successful calls publish a PICQER_RETURN_EVENT into the  events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async picqerReturnWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.picqerReturnWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.picqerReturnWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SeelWebhook receives a Seel webhook notification (contract.* or claim.* events).  The raw body is forwarded so the HMAC-SHA256 signature can be verified before processing.  Successful calls publish the corresponding SEEL_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seelWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seelWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.seelWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SendcloudParcelStatusWebhook receives a SENDCLOUD_PARCEL_STATUS_CHANGED webhook event  from Sendcloud. The raw body is forwarded so that the HMAC-SHA256 signature in the  Sendcloud-Signature header can be verified before the payload is processed. Successful  calls publish a SENDCLOUD_PARCEL_STATUS_CHANGED event into the events pipeline which  triggers any configured subscriptions.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendcloudParcelStatusWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendcloudParcelStatusWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.sendcloudParcelStatusWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SevicaReviewWebhook receives item-review results from Sevica\'s warehouse system for a  return process. The x-sevica-secret header carries a partner-defined static shared  secret (like Amphora, not an HMAC). Deliveries for returns not created by REVER  (reference is not a process id) are acknowledged and ignored. Successful calls  publish a SEVICA_RETURN_EVENT into the events pipeline; nothing subscribes to it in  this PR (the sevica_review transformer is a separate change).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sevicaReviewWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sevicaReviewWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.sevicaReviewWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ShopifyWebhook receives Shopify webhook notifications for topics:  app/uninstalled, orders/create, orders/cancelled, orders/updated,  fulfillments/create, fulfillments/update, products/update.  The raw body is forwarded so the HMAC-SHA256 signature in the  X-Shopify-Hmac-Sha256 header can be verified before processing.  The topic is read from the X-Shopify-Topic header.  Successful calls publish the corresponding SHOPIFY_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.shopifyWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * TypeformWebhook receives CSAT survey responses and publishes a TYPEFORM_FORM_RESPONSE event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async typeformWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.typeformWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.typeformWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Way2SendReturnWebhook receives return status changes from Way2Send\'s WMS, which the  warehouse operator built for REVER: there is no standard webhook in their customer API.  The x-way2send-secret header carries a partner-defined static shared secret (like  Amphora and Sevica, not an HMAC). The delivery names the return, the status it moved  from and to, and the per-SKU condition the warehouse found. Deliveries for returns not  created by REVER (returnId is not a process id) are acknowledged and ignored.  Successful calls publish a WAY2SEND_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async way2SendReturnWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.way2SendReturnWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.way2SendReturnWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ZendeskWebhook receives Zendesk ticket updates and publishes a ZENDESK_TICKET_UPDATED event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zendeskWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zendeskWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.zendeskWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * AmphoraReturnWebhook receives return lifecycle notifications from Amphora\'s Partner API.  The raw body is forwarded so the shared secret in the x-amphora-secret header can be checked  before the payload is processed. Amphora sends a partner-defined static secret rather than an  HMAC, and the body shape is set by a Liquid template configured in their partner portal.  Successful calls publish an AMPHORA_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amphoraReturnWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.amphoraReturnWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * AsyncRefundConfirmationWebhook receives the outcome of the refund legs REVER asked an  async-refund merchant (e.g. Boardriders) to execute. The raw body is forwarded so the  X-REVER-Signature header (HMAC-SHA256 over \"{t}.{raw_body}\", signed with the group\'s  webhook signing secret, the same one REVER signs its outbound refund request with) can be  verified before processing. The body may be wrapped in \"webhook\" or sent bare; each entry\'s  rever_transaction_id identifies the pending transaction. Confirmed entries are forwarded to  ops-api.ConfirmRefundTransaction, which signals the refund workflow.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asyncRefundConfirmationWebhook(options?: RawAxiosRequestConfig): AxiosPromise<EventspbAsyncRefundConfirmationResponse> {
            return localVarFp.asyncRefundConfirmationWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * EasypostTrackerWebhook receives EasyPost Event webhook notifications. The raw body is  forwarded so that the HMAC-SHA256 signature in the X-Hmac-Signature header can be  verified before the payload is processed. Only tracker.updated events are processed  (other event types are acknowledged and ignored). Successful calls publish an  EASYPOST_TRACKER_UPDATED event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        easypostTrackerWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.easypostTrackerWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * FlexportReturnWebhook receives Return.Updated notifications from Flexport\'s Logistics API.  The raw body is forwarded so the shared secret in the x-flexport-secret header can be checked  before the payload is processed. Flexport echoes a static token under a header name we choose  when registering the webhook (its tokenHeader parameter) rather than signing the body. The  delivery carries the complete return object, per-unit dispositions included, so no follow-up  call to Flexport is needed. Only a PROCESSED return publishes a FLEXPORT_RETURN_EVENT into the  events pipeline; Return.Updated also fires on warehouse intake, and that delivery carries no  verdict.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flexportReturnWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.flexportReturnWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * PicqerReturnWebhook receives Picqer\'s returns.products_received notifications, which carry  what the warehouse found. The raw body is forwarded so the base64 HMAC-SHA256 signature in  the X-Picqer-Signature header can be verified over the exact bytes Picqer signed.  Deliveries for returns not created by REVER (reference is not a process id) are  acknowledged and ignored. Successful calls publish a PICQER_RETURN_EVENT into the  events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        picqerReturnWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.picqerReturnWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * SeelWebhook receives a Seel webhook notification (contract.* or claim.* events).  The raw body is forwarded so the HMAC-SHA256 signature can be verified before processing.  Successful calls publish the corresponding SEEL_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seelWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.seelWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * SendcloudParcelStatusWebhook receives a SENDCLOUD_PARCEL_STATUS_CHANGED webhook event  from Sendcloud. The raw body is forwarded so that the HMAC-SHA256 signature in the  Sendcloud-Signature header can be verified before the payload is processed. Successful  calls publish a SENDCLOUD_PARCEL_STATUS_CHANGED event into the events pipeline which  triggers any configured subscriptions.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendcloudParcelStatusWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.sendcloudParcelStatusWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * SevicaReviewWebhook receives item-review results from Sevica\'s warehouse system for a  return process. The x-sevica-secret header carries a partner-defined static shared  secret (like Amphora, not an HMAC). Deliveries for returns not created by REVER  (reference is not a process id) are acknowledged and ignored. Successful calls  publish a SEVICA_RETURN_EVENT into the events pipeline; nothing subscribes to it in  this PR (the sevica_review transformer is a separate change).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sevicaReviewWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.sevicaReviewWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * ShopifyWebhook receives Shopify webhook notifications for topics:  app/uninstalled, orders/create, orders/cancelled, orders/updated,  fulfillments/create, fulfillments/update, products/update.  The raw body is forwarded so the HMAC-SHA256 signature in the  X-Shopify-Hmac-Sha256 header can be verified before processing.  The topic is read from the X-Shopify-Topic header.  Successful calls publish the corresponding SHOPIFY_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.shopifyWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * TypeformWebhook receives CSAT survey responses and publishes a TYPEFORM_FORM_RESPONSE event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        typeformWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.typeformWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * Way2SendReturnWebhook receives return status changes from Way2Send\'s WMS, which the  warehouse operator built for REVER: there is no standard webhook in their customer API.  The x-way2send-secret header carries a partner-defined static shared secret (like  Amphora and Sevica, not an HMAC). The delivery names the return, the status it moved  from and to, and the per-SKU condition the warehouse found. Deliveries for returns not  created by REVER (returnId is not a process id) are acknowledged and ignored.  Successful calls publish a WAY2SEND_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        way2SendReturnWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.way2SendReturnWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * ZendeskWebhook receives Zendesk ticket updates and publishes a ZENDESK_TICKET_UPDATED event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zendeskWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.zendeskWebhook(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * AmphoraReturnWebhook receives return lifecycle notifications from Amphora\'s Partner API.  The raw body is forwarded so the shared secret in the x-amphora-secret header can be checked  before the payload is processed. Amphora sends a partner-defined static secret rather than an  HMAC, and the body shape is set by a Liquid template configured in their partner portal.  Successful calls publish an AMPHORA_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public amphoraReturnWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).amphoraReturnWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * AsyncRefundConfirmationWebhook receives the outcome of the refund legs REVER asked an  async-refund merchant (e.g. Boardriders) to execute. The raw body is forwarded so the  X-REVER-Signature header (HMAC-SHA256 over \"{t}.{raw_body}\", signed with the group\'s  webhook signing secret, the same one REVER signs its outbound refund request with) can be  verified before processing. The body may be wrapped in \"webhook\" or sent bare; each entry\'s  rever_transaction_id identifies the pending transaction. Confirmed entries are forwarded to  ops-api.ConfirmRefundTransaction, which signals the refund workflow.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public asyncRefundConfirmationWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).asyncRefundConfirmationWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * EasypostTrackerWebhook receives EasyPost Event webhook notifications. The raw body is  forwarded so that the HMAC-SHA256 signature in the X-Hmac-Signature header can be  verified before the payload is processed. Only tracker.updated events are processed  (other event types are acknowledged and ignored). Successful calls publish an  EASYPOST_TRACKER_UPDATED event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public easypostTrackerWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).easypostTrackerWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FlexportReturnWebhook receives Return.Updated notifications from Flexport\'s Logistics API.  The raw body is forwarded so the shared secret in the x-flexport-secret header can be checked  before the payload is processed. Flexport echoes a static token under a header name we choose  when registering the webhook (its tokenHeader parameter) rather than signing the body. The  delivery carries the complete return object, per-unit dispositions included, so no follow-up  call to Flexport is needed. Only a PROCESSED return publishes a FLEXPORT_RETURN_EVENT into the  events pipeline; Return.Updated also fires on warehouse intake, and that delivery carries no  verdict.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public flexportReturnWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).flexportReturnWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PicqerReturnWebhook receives Picqer\'s returns.products_received notifications, which carry  what the warehouse found. The raw body is forwarded so the base64 HMAC-SHA256 signature in  the X-Picqer-Signature header can be verified over the exact bytes Picqer signed.  Deliveries for returns not created by REVER (reference is not a process id) are  acknowledged and ignored. Successful calls publish a PICQER_RETURN_EVENT into the  events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public picqerReturnWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).picqerReturnWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SeelWebhook receives a Seel webhook notification (contract.* or claim.* events).  The raw body is forwarded so the HMAC-SHA256 signature can be verified before processing.  Successful calls publish the corresponding SEEL_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public seelWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).seelWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SendcloudParcelStatusWebhook receives a SENDCLOUD_PARCEL_STATUS_CHANGED webhook event  from Sendcloud. The raw body is forwarded so that the HMAC-SHA256 signature in the  Sendcloud-Signature header can be verified before the payload is processed. Successful  calls publish a SENDCLOUD_PARCEL_STATUS_CHANGED event into the events pipeline which  triggers any configured subscriptions.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public sendcloudParcelStatusWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).sendcloudParcelStatusWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SevicaReviewWebhook receives item-review results from Sevica\'s warehouse system for a  return process. The x-sevica-secret header carries a partner-defined static shared  secret (like Amphora, not an HMAC). Deliveries for returns not created by REVER  (reference is not a process id) are acknowledged and ignored. Successful calls  publish a SEVICA_RETURN_EVENT into the events pipeline; nothing subscribes to it in  this PR (the sevica_review transformer is a separate change).  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public sevicaReviewWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).sevicaReviewWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ShopifyWebhook receives Shopify webhook notifications for topics:  app/uninstalled, orders/create, orders/cancelled, orders/updated,  fulfillments/create, fulfillments/update, products/update.  The raw body is forwarded so the HMAC-SHA256 signature in the  X-Shopify-Hmac-Sha256 header can be verified before processing.  The topic is read from the X-Shopify-Topic header.  Successful calls publish the corresponding SHOPIFY_* event into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public shopifyWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).shopifyWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * TypeformWebhook receives CSAT survey responses and publishes a TYPEFORM_FORM_RESPONSE event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public typeformWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).typeformWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Way2SendReturnWebhook receives return status changes from Way2Send\'s WMS, which the  warehouse operator built for REVER: there is no standard webhook in their customer API.  The x-way2send-secret header carries a partner-defined static shared secret (like  Amphora and Sevica, not an HMAC). The delivery names the return, the status it moved  from and to, and the per-SKU condition the warehouse found. Deliveries for returns not  created by REVER (returnId is not a process id) are acknowledged and ignored.  Successful calls publish a WAY2SEND_RETURN_EVENT into the events pipeline.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public way2SendReturnWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).way2SendReturnWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ZendeskWebhook receives Zendesk ticket updates and publishes a ZENDESK_TICKET_UPDATED event.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public zendeskWebhook(options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).zendeskWebhook(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InditexReturnsServiceApi - axios parameter creator
 * @export
 */
export const InditexReturnsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CalculateRefundMethods - calculates the refund methods for a given order
         * @param {string} ecommerceId Ecommerce identifier
         * @param {ReturnsCalculateRefundMethodsRequest} returnsCalculateRefundMethodsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateRefundMethods: async (ecommerceId: string, returnsCalculateRefundMethodsRequest: ReturnsCalculateRefundMethodsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('calculateRefundMethods', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsCalculateRefundMethodsRequest' is not null or undefined
            assertParamExists('calculateRefundMethods', 'returnsCalculateRefundMethodsRequest', returnsCalculateRefundMethodsRequest)
            const localVarPath = `/v1/inditex/{ecommerce_id}/refund_methods/calculate`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsCalculateRefundMethodsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * DeriveAllocatedTimingId - derives the allocated timing ID for a given return request
         * @param {string} ecommerceId Ecommerce identifier
         * @param {ReturnsDeriveAllocatedTimingIdRequest} returnsDeriveAllocatedTimingIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deriveAllocatedTimingId: async (ecommerceId: string, returnsDeriveAllocatedTimingIdRequest: ReturnsDeriveAllocatedTimingIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deriveAllocatedTimingId', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsDeriveAllocatedTimingIdRequest' is not null or undefined
            assertParamExists('deriveAllocatedTimingId', 'returnsDeriveAllocatedTimingIdRequest', returnsDeriveAllocatedTimingIdRequest)
            const localVarPath = `/v1/inditex/{ecommerce_id}/allocated_timing_id/derive`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsDeriveAllocatedTimingIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PostProcess - adds a process to the order
         * @param {string} ecommerceId REVER ecommerce identifier. Required.
         * @param {ReturnsProcessReturnRequest} returnsProcessReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processReturn: async (ecommerceId: string, returnsProcessReturnRequest: ReturnsProcessReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('processReturn', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsProcessReturnRequest' is not null or undefined
            assertParamExists('processReturn', 'returnsProcessReturnRequest', returnsProcessReturnRequest)
            const localVarPath = `/v1/inditex/{ecommerce_id}/process`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsProcessReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InditexReturnsServiceApi - functional programming interface
 * @export
 */
export const InditexReturnsServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InditexReturnsServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * CalculateRefundMethods - calculates the refund methods for a given order
         * @param {string} ecommerceId Ecommerce identifier
         * @param {ReturnsCalculateRefundMethodsRequest} returnsCalculateRefundMethodsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateRefundMethods(ecommerceId: string, returnsCalculateRefundMethodsRequest: ReturnsCalculateRefundMethodsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsCalculateRefundMethodsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateRefundMethods(ecommerceId, returnsCalculateRefundMethodsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InditexReturnsServiceApi.calculateRefundMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * DeriveAllocatedTimingId - derives the allocated timing ID for a given return request
         * @param {string} ecommerceId Ecommerce identifier
         * @param {ReturnsDeriveAllocatedTimingIdRequest} returnsDeriveAllocatedTimingIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deriveAllocatedTimingId(ecommerceId: string, returnsDeriveAllocatedTimingIdRequest: ReturnsDeriveAllocatedTimingIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsDeriveAllocatedTimingIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deriveAllocatedTimingId(ecommerceId, returnsDeriveAllocatedTimingIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InditexReturnsServiceApi.deriveAllocatedTimingId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PostProcess - adds a process to the order
         * @param {string} ecommerceId REVER ecommerce identifier. Required.
         * @param {ReturnsProcessReturnRequest} returnsProcessReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processReturn(ecommerceId: string, returnsProcessReturnRequest: ReturnsProcessReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processReturn(ecommerceId, returnsProcessReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InditexReturnsServiceApi.processReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InditexReturnsServiceApi - factory interface
 * @export
 */
export const InditexReturnsServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InditexReturnsServiceApiFp(configuration)
    return {
        /**
         * CalculateRefundMethods - calculates the refund methods for a given order
         * @param {InditexReturnsServiceApiCalculateRefundMethodsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateRefundMethods(requestParameters: InditexReturnsServiceApiCalculateRefundMethodsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsCalculateRefundMethodsResponse> {
            return localVarFp.calculateRefundMethods(requestParameters.ecommerceId, requestParameters.returnsCalculateRefundMethodsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * DeriveAllocatedTimingId - derives the allocated timing ID for a given return request
         * @param {InditexReturnsServiceApiDeriveAllocatedTimingIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deriveAllocatedTimingId(requestParameters: InditexReturnsServiceApiDeriveAllocatedTimingIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsDeriveAllocatedTimingIdResponse> {
            return localVarFp.deriveAllocatedTimingId(requestParameters.ecommerceId, requestParameters.returnsDeriveAllocatedTimingIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * PostProcess - adds a process to the order
         * @param {InditexReturnsServiceApiProcessReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processReturn(requestParameters: InditexReturnsServiceApiProcessReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.processReturn(requestParameters.ecommerceId, requestParameters.returnsProcessReturnRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateRefundMethods operation in InditexReturnsServiceApi.
 * @export
 * @interface InditexReturnsServiceApiCalculateRefundMethodsRequest
 */
export interface InditexReturnsServiceApiCalculateRefundMethodsRequest {
    /**
     * Ecommerce identifier
     * @type {string}
     * @memberof InditexReturnsServiceApiCalculateRefundMethods
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsCalculateRefundMethodsRequest}
     * @memberof InditexReturnsServiceApiCalculateRefundMethods
     */
    readonly returnsCalculateRefundMethodsRequest: ReturnsCalculateRefundMethodsRequest
}

/**
 * Request parameters for deriveAllocatedTimingId operation in InditexReturnsServiceApi.
 * @export
 * @interface InditexReturnsServiceApiDeriveAllocatedTimingIdRequest
 */
export interface InditexReturnsServiceApiDeriveAllocatedTimingIdRequest {
    /**
     * Ecommerce identifier
     * @type {string}
     * @memberof InditexReturnsServiceApiDeriveAllocatedTimingId
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsDeriveAllocatedTimingIdRequest}
     * @memberof InditexReturnsServiceApiDeriveAllocatedTimingId
     */
    readonly returnsDeriveAllocatedTimingIdRequest: ReturnsDeriveAllocatedTimingIdRequest
}

/**
 * Request parameters for processReturn operation in InditexReturnsServiceApi.
 * @export
 * @interface InditexReturnsServiceApiProcessReturnRequest
 */
export interface InditexReturnsServiceApiProcessReturnRequest {
    /**
     * REVER ecommerce identifier. Required.
     * @type {string}
     * @memberof InditexReturnsServiceApiProcessReturn
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsProcessReturnRequest}
     * @memberof InditexReturnsServiceApiProcessReturn
     */
    readonly returnsProcessReturnRequest: ReturnsProcessReturnRequest
}

/**
 * InditexReturnsServiceApi - object-oriented interface
 * @export
 * @class InditexReturnsServiceApi
 * @extends {BaseAPI}
 */
export class InditexReturnsServiceApi extends BaseAPI {
    /**
     * CalculateRefundMethods - calculates the refund methods for a given order
     * @param {InditexReturnsServiceApiCalculateRefundMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InditexReturnsServiceApi
     */
    public calculateRefundMethods(requestParameters: InditexReturnsServiceApiCalculateRefundMethodsRequest, options?: RawAxiosRequestConfig) {
        return InditexReturnsServiceApiFp(this.configuration).calculateRefundMethods(requestParameters.ecommerceId, requestParameters.returnsCalculateRefundMethodsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * DeriveAllocatedTimingId - derives the allocated timing ID for a given return request
     * @param {InditexReturnsServiceApiDeriveAllocatedTimingIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InditexReturnsServiceApi
     */
    public deriveAllocatedTimingId(requestParameters: InditexReturnsServiceApiDeriveAllocatedTimingIdRequest, options?: RawAxiosRequestConfig) {
        return InditexReturnsServiceApiFp(this.configuration).deriveAllocatedTimingId(requestParameters.ecommerceId, requestParameters.returnsDeriveAllocatedTimingIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PostProcess - adds a process to the order
     * @param {InditexReturnsServiceApiProcessReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InditexReturnsServiceApi
     */
    public processReturn(requestParameters: InditexReturnsServiceApiProcessReturnRequest, options?: RawAxiosRequestConfig) {
        return InditexReturnsServiceApiFp(this.configuration).processReturn(requestParameters.ecommerceId, requestParameters.returnsProcessReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InditexServiceApi - axios parameter creator
 * @export
 */
export const InditexServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload orders endpoint
         * @param {string} groupId group_id of the group
         * @param {InditexpbGenerateFileUploadURLRequest} inditexpbGenerateFileUploadURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFileUploadURL: async (groupId: string, inditexpbGenerateFileUploadURLRequest: InditexpbGenerateFileUploadURLRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('generateFileUploadURL', 'groupId', groupId)
            // verify required parameter 'inditexpbGenerateFileUploadURLRequest' is not null or undefined
            assertParamExists('generateFileUploadURL', 'inditexpbGenerateFileUploadURLRequest', inditexpbGenerateFileUploadURLRequest)
            const localVarPath = `/v1/analytics/{group_id}/files/uploads/generate_presigned_url`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inditexpbGenerateFileUploadURLRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InditexServiceApi - functional programming interface
 * @export
 */
export const InditexServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InditexServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload orders endpoint
         * @param {string} groupId group_id of the group
         * @param {InditexpbGenerateFileUploadURLRequest} inditexpbGenerateFileUploadURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateFileUploadURL(groupId: string, inditexpbGenerateFileUploadURLRequest: InditexpbGenerateFileUploadURLRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InditexpbGenerateFileUploadURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFileUploadURL(groupId, inditexpbGenerateFileUploadURLRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InditexServiceApi.generateFileUploadURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InditexServiceApi - factory interface
 * @export
 */
export const InditexServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InditexServiceApiFp(configuration)
    return {
        /**
         * Upload orders endpoint
         * @param {InditexServiceApiGenerateFileUploadURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFileUploadURL(requestParameters: InditexServiceApiGenerateFileUploadURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<InditexpbGenerateFileUploadURLResponse> {
            return localVarFp.generateFileUploadURL(requestParameters.groupId, requestParameters.inditexpbGenerateFileUploadURLRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generateFileUploadURL operation in InditexServiceApi.
 * @export
 * @interface InditexServiceApiGenerateFileUploadURLRequest
 */
export interface InditexServiceApiGenerateFileUploadURLRequest {
    /**
     * group_id of the group
     * @type {string}
     * @memberof InditexServiceApiGenerateFileUploadURL
     */
    readonly groupId: string

    /**
     * 
     * @type {InditexpbGenerateFileUploadURLRequest}
     * @memberof InditexServiceApiGenerateFileUploadURL
     */
    readonly inditexpbGenerateFileUploadURLRequest: InditexpbGenerateFileUploadURLRequest
}

/**
 * InditexServiceApi - object-oriented interface
 * @export
 * @class InditexServiceApi
 * @extends {BaseAPI}
 */
export class InditexServiceApi extends BaseAPI {
    /**
     * Upload orders endpoint
     * @param {InditexServiceApiGenerateFileUploadURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InditexServiceApi
     */
    public generateFileUploadURL(requestParameters: InditexServiceApiGenerateFileUploadURLRequest, options?: RawAxiosRequestConfig) {
        return InditexServiceApiFp(this.configuration).generateFileUploadURL(requestParameters.groupId, requestParameters.inditexpbGenerateFileUploadURLRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntegrationApi - axios parameter creator
 * @export
 */
export const IntegrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This method is used to add a note (arbitrary text, no format like HTML or markdown) to an existing order by its `customer_printed_order_id`.  REVER uses this method to log the steps that are being executed, for example: `Started a return process in REVER with ID {id}`.  It\'s recommended that the implementation associates the text with the timestamp on when the method was executed so that users can see a history of what happened with an order. Once a note is added to an order, is expected to be appended to the existing notes in the order.  Further calls to [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid) should return the note in the order. 
         * @summary Adds a note (text) to an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;order_id&#x60; as seen by the customer (for example, in the email body)
         * @param {AddNoteToOrderRequest} addNoteToOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNoteToOrder: async (customerPrintedOrderId: string, addNoteToOrderRequest: AddNoteToOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPrintedOrderId' is not null or undefined
            assertParamExists('addNoteToOrder', 'customerPrintedOrderId', customerPrintedOrderId)
            // verify required parameter 'addNoteToOrderRequest' is not null or undefined
            assertParamExists('addNoteToOrder', 'addNoteToOrderRequest', addNoteToOrderRequest)
            const localVarPath = `/integration/orders/{customer_printed_order_id}/note`
                .replace(`{${"customer_printed_order_id"}}`, encodeURIComponent(String(customerPrintedOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addNoteToOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to create a refund to the original payment method for an existing order. The refund includes the `customer_printed_order_id` as the unique identifier of the order and a list of refund `line_items` indicating which line items have to be refunded(and the quantity of each one). 
         * @summary Creates a refund for an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
         * @param {IntegrationRefundRequest} integrationRefundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund: async (customerPrintedOrderId: string, integrationRefundRequest: IntegrationRefundRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPrintedOrderId' is not null or undefined
            assertParamExists('createRefund', 'customerPrintedOrderId', customerPrintedOrderId)
            // verify required parameter 'integrationRefundRequest' is not null or undefined
            assertParamExists('createRefund', 'integrationRefundRequest', integrationRefundRequest)
            const localVarPath = `/integration/orders/{customer_printed_order_id}/refund`
                .replace(`{${"customer_printed_order_id"}}`, encodeURIComponent(String(customerPrintedOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationRefundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to create a return for an existing order.  A return means that one or more items of an order are **already** returned to the e-commerce. The return includes the `customer_printed_order_id` as the unique identifier of the order and a list of return `line_items`` indicating which line items of the order are returned(and the quantity of each one).  This method will be called when the package will arrive in the warehouse despite the review workflow.    **Important Notes**:     - This method doesn\'t indicate the start of return process in REVER. Rather it indicates that the items are received in the warehouse.   - Once the return is created , we should be able to verify this return in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - The return can be created only once for an order hence method can\'t be called twice.   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
         * @summary Creates return in the ecommerce portal for an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
         * @param {IntegrationReturnRequest} integrationReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReturn: async (customerPrintedOrderId: string, integrationReturnRequest: IntegrationReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPrintedOrderId' is not null or undefined
            assertParamExists('createReturn', 'customerPrintedOrderId', customerPrintedOrderId)
            // verify required parameter 'integrationReturnRequest' is not null or undefined
            assertParamExists('createReturn', 'integrationReturnRequest', integrationReturnRequest)
            const localVarPath = `/integration/orders/{customer_printed_order_id}/return`
                .replace(`{${"customer_printed_order_id"}}`, encodeURIComponent(String(customerPrintedOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds a single order by its `customer_printed_order_id`. In case of multiple matches, the most recent one is returned.  Please note that `customer_printed_order_id` is the `order_id` as seen by the customer, typically in the order mail. It\'s not necessarily the same as the `order_id` as seen by the platform.  The path provided is the suggested one for this methods, you can choose your own in your integration. In case of receiving a different response code than the ones listed below, REVER might contact the integration for further investigation.  When returning the order, please note the following:  - Your e-commerce can work with simple products or product variants.    In case of variants, both the `product_id` and `variant_id` and should be provided.    The properties of the variant override the ones from the product. - If you want to support exchange orders, variants must be used. - If you want to support exchange orders, stock information is mandatory.  In order to verify that the implementation is correct, you should test it with the corresponding  [testing scenarios](https://github.com/itsrever/integration/blob/main/docs/FindOrderByCustomerPrintedOrderId.md) in the  [provided testing framework](https://github.com/itsrever/integration). 
         * @summary Find Order by `customer_printed_order_id`
         * @param {string} customerPrintedOrderId This is the &#x60;order_id&#x60; as seen by the customer (for example, in the email body)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrderByCustomerPrintedOrderId: async (customerPrintedOrderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPrintedOrderId' is not null or undefined
            assertParamExists('findOrderByCustomerPrintedOrderId', 'customerPrintedOrderId', customerPrintedOrderId)
            const localVarPath = `/integration/orders/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerPrintedOrderId !== undefined) {
                localVarQueryParameter['customer_printed_order_id'] = customerPrintedOrderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to update a previous return detail for an existing order.  The update return request includes the `customer_printed_order_id` as the unique identifier of the order and the `return_id`  along with the updated return status information for the `line_items`` This method will be called when the manual review will be done for the order.     **Important Notes**:     - Once the return is Updated , we should be able to verify this update in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
         * @summary Updates return in the ecommerce portal for an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
         * @param {string} returnId This is the &#x60;return_id&#x60; as a unique identifier of the previously created return
         * @param {IntegrationReturnRequest} integrationReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReturn: async (customerPrintedOrderId: string, returnId: string, integrationReturnRequest: IntegrationReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerPrintedOrderId' is not null or undefined
            assertParamExists('updateReturn', 'customerPrintedOrderId', customerPrintedOrderId)
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('updateReturn', 'returnId', returnId)
            // verify required parameter 'integrationReturnRequest' is not null or undefined
            assertParamExists('updateReturn', 'integrationReturnRequest', integrationReturnRequest)
            const localVarPath = `/integration/orders/{customer_printed_order_id}/{return_id}/return`
                .replace(`{${"customer_printed_order_id"}}`, encodeURIComponent(String(customerPrintedOrderId)))
                .replace(`{${"return_id"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(integrationReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationApi - functional programming interface
 * @export
 */
export const IntegrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationApiAxiosParamCreator(configuration)
    return {
        /**
         * This method is used to add a note (arbitrary text, no format like HTML or markdown) to an existing order by its `customer_printed_order_id`.  REVER uses this method to log the steps that are being executed, for example: `Started a return process in REVER with ID {id}`.  It\'s recommended that the implementation associates the text with the timestamp on when the method was executed so that users can see a history of what happened with an order. Once a note is added to an order, is expected to be appended to the existing notes in the order.  Further calls to [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid) should return the note in the order. 
         * @summary Adds a note (text) to an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;order_id&#x60; as seen by the customer (for example, in the email body)
         * @param {AddNoteToOrderRequest} addNoteToOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNoteToOrder(customerPrintedOrderId: string, addNoteToOrderRequest: AddNoteToOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNoteToOrder(customerPrintedOrderId, addNoteToOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.addNoteToOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This method is used to create a refund to the original payment method for an existing order. The refund includes the `customer_printed_order_id` as the unique identifier of the order and a list of refund `line_items` indicating which line items have to be refunded(and the quantity of each one). 
         * @summary Creates a refund for an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
         * @param {IntegrationRefundRequest} integrationRefundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefund(customerPrintedOrderId: string, integrationRefundRequest: IntegrationRefundRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationRefundResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRefund(customerPrintedOrderId, integrationRefundRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.createRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This method is used to create a return for an existing order.  A return means that one or more items of an order are **already** returned to the e-commerce. The return includes the `customer_printed_order_id` as the unique identifier of the order and a list of return `line_items`` indicating which line items of the order are returned(and the quantity of each one).  This method will be called when the package will arrive in the warehouse despite the review workflow.    **Important Notes**:     - This method doesn\'t indicate the start of return process in REVER. Rather it indicates that the items are received in the warehouse.   - Once the return is created , we should be able to verify this return in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - The return can be created only once for an order hence method can\'t be called twice.   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
         * @summary Creates return in the ecommerce portal for an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
         * @param {IntegrationReturnRequest} integrationReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReturn(customerPrintedOrderId: string, integrationReturnRequest: IntegrationReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReturn200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReturn(customerPrintedOrderId, integrationReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.createReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Finds a single order by its `customer_printed_order_id`. In case of multiple matches, the most recent one is returned.  Please note that `customer_printed_order_id` is the `order_id` as seen by the customer, typically in the order mail. It\'s not necessarily the same as the `order_id` as seen by the platform.  The path provided is the suggested one for this methods, you can choose your own in your integration. In case of receiving a different response code than the ones listed below, REVER might contact the integration for further investigation.  When returning the order, please note the following:  - Your e-commerce can work with simple products or product variants.    In case of variants, both the `product_id` and `variant_id` and should be provided.    The properties of the variant override the ones from the product. - If you want to support exchange orders, variants must be used. - If you want to support exchange orders, stock information is mandatory.  In order to verify that the implementation is correct, you should test it with the corresponding  [testing scenarios](https://github.com/itsrever/integration/blob/main/docs/FindOrderByCustomerPrintedOrderId.md) in the  [provided testing framework](https://github.com/itsrever/integration). 
         * @summary Find Order by `customer_printed_order_id`
         * @param {string} customerPrintedOrderId This is the &#x60;order_id&#x60; as seen by the customer (for example, in the email body)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findOrderByCustomerPrintedOrderId(customerPrintedOrderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntegrationOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findOrderByCustomerPrintedOrderId(customerPrintedOrderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.findOrderByCustomerPrintedOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This method is used to update a previous return detail for an existing order.  The update return request includes the `customer_printed_order_id` as the unique identifier of the order and the `return_id`  along with the updated return status information for the `line_items`` This method will be called when the manual review will be done for the order.     **Important Notes**:     - Once the return is Updated , we should be able to verify this update in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
         * @summary Updates return in the ecommerce portal for an existing order
         * @param {string} customerPrintedOrderId This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
         * @param {string} returnId This is the &#x60;return_id&#x60; as a unique identifier of the previously created return
         * @param {IntegrationReturnRequest} integrationReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReturn(customerPrintedOrderId: string, returnId: string, integrationReturnRequest: IntegrationReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReturn(customerPrintedOrderId, returnId, integrationReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntegrationApi.updateReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntegrationApi - factory interface
 * @export
 */
export const IntegrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationApiFp(configuration)
    return {
        /**
         * This method is used to add a note (arbitrary text, no format like HTML or markdown) to an existing order by its `customer_printed_order_id`.  REVER uses this method to log the steps that are being executed, for example: `Started a return process in REVER with ID {id}`.  It\'s recommended that the implementation associates the text with the timestamp on when the method was executed so that users can see a history of what happened with an order. Once a note is added to an order, is expected to be appended to the existing notes in the order.  Further calls to [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid) should return the note in the order. 
         * @summary Adds a note (text) to an existing order
         * @param {IntegrationApiAddNoteToOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNoteToOrder(requestParameters: IntegrationApiAddNoteToOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addNoteToOrder(requestParameters.customerPrintedOrderId, requestParameters.addNoteToOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to create a refund to the original payment method for an existing order. The refund includes the `customer_printed_order_id` as the unique identifier of the order and a list of refund `line_items` indicating which line items have to be refunded(and the quantity of each one). 
         * @summary Creates a refund for an existing order
         * @param {IntegrationApiCreateRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefund(requestParameters: IntegrationApiCreateRefundRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationRefundResponse> {
            return localVarFp.createRefund(requestParameters.customerPrintedOrderId, requestParameters.integrationRefundRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to create a return for an existing order.  A return means that one or more items of an order are **already** returned to the e-commerce. The return includes the `customer_printed_order_id` as the unique identifier of the order and a list of return `line_items`` indicating which line items of the order are returned(and the quantity of each one).  This method will be called when the package will arrive in the warehouse despite the review workflow.    **Important Notes**:     - This method doesn\'t indicate the start of return process in REVER. Rather it indicates that the items are received in the warehouse.   - Once the return is created , we should be able to verify this return in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - The return can be created only once for an order hence method can\'t be called twice.   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
         * @summary Creates return in the ecommerce portal for an existing order
         * @param {IntegrationApiCreateReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReturn(requestParameters: IntegrationApiCreateReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateReturn200Response> {
            return localVarFp.createReturn(requestParameters.customerPrintedOrderId, requestParameters.integrationReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds a single order by its `customer_printed_order_id`. In case of multiple matches, the most recent one is returned.  Please note that `customer_printed_order_id` is the `order_id` as seen by the customer, typically in the order mail. It\'s not necessarily the same as the `order_id` as seen by the platform.  The path provided is the suggested one for this methods, you can choose your own in your integration. In case of receiving a different response code than the ones listed below, REVER might contact the integration for further investigation.  When returning the order, please note the following:  - Your e-commerce can work with simple products or product variants.    In case of variants, both the `product_id` and `variant_id` and should be provided.    The properties of the variant override the ones from the product. - If you want to support exchange orders, variants must be used. - If you want to support exchange orders, stock information is mandatory.  In order to verify that the implementation is correct, you should test it with the corresponding  [testing scenarios](https://github.com/itsrever/integration/blob/main/docs/FindOrderByCustomerPrintedOrderId.md) in the  [provided testing framework](https://github.com/itsrever/integration). 
         * @summary Find Order by `customer_printed_order_id`
         * @param {IntegrationApiFindOrderByCustomerPrintedOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrderByCustomerPrintedOrderId(requestParameters: IntegrationApiFindOrderByCustomerPrintedOrderIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntegrationOrder> {
            return localVarFp.findOrderByCustomerPrintedOrderId(requestParameters.customerPrintedOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to update a previous return detail for an existing order.  The update return request includes the `customer_printed_order_id` as the unique identifier of the order and the `return_id`  along with the updated return status information for the `line_items`` This method will be called when the manual review will be done for the order.     **Important Notes**:     - Once the return is Updated , we should be able to verify this update in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
         * @summary Updates return in the ecommerce portal for an existing order
         * @param {IntegrationApiUpdateReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReturn(requestParameters: IntegrationApiUpdateReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateReturn(requestParameters.customerPrintedOrderId, requestParameters.returnId, requestParameters.integrationReturnRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNoteToOrder operation in IntegrationApi.
 * @export
 * @interface IntegrationApiAddNoteToOrderRequest
 */
export interface IntegrationApiAddNoteToOrderRequest {
    /**
     * This is the &#x60;order_id&#x60; as seen by the customer (for example, in the email body)
     * @type {string}
     * @memberof IntegrationApiAddNoteToOrder
     */
    readonly customerPrintedOrderId: string

    /**
     * 
     * @type {AddNoteToOrderRequest}
     * @memberof IntegrationApiAddNoteToOrder
     */
    readonly addNoteToOrderRequest: AddNoteToOrderRequest
}

/**
 * Request parameters for createRefund operation in IntegrationApi.
 * @export
 * @interface IntegrationApiCreateRefundRequest
 */
export interface IntegrationApiCreateRefundRequest {
    /**
     * This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
     * @type {string}
     * @memberof IntegrationApiCreateRefund
     */
    readonly customerPrintedOrderId: string

    /**
     * 
     * @type {IntegrationRefundRequest}
     * @memberof IntegrationApiCreateRefund
     */
    readonly integrationRefundRequest: IntegrationRefundRequest
}

/**
 * Request parameters for createReturn operation in IntegrationApi.
 * @export
 * @interface IntegrationApiCreateReturnRequest
 */
export interface IntegrationApiCreateReturnRequest {
    /**
     * This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
     * @type {string}
     * @memberof IntegrationApiCreateReturn
     */
    readonly customerPrintedOrderId: string

    /**
     * 
     * @type {IntegrationReturnRequest}
     * @memberof IntegrationApiCreateReturn
     */
    readonly integrationReturnRequest: IntegrationReturnRequest
}

/**
 * Request parameters for findOrderByCustomerPrintedOrderId operation in IntegrationApi.
 * @export
 * @interface IntegrationApiFindOrderByCustomerPrintedOrderIdRequest
 */
export interface IntegrationApiFindOrderByCustomerPrintedOrderIdRequest {
    /**
     * This is the &#x60;order_id&#x60; as seen by the customer (for example, in the email body)
     * @type {string}
     * @memberof IntegrationApiFindOrderByCustomerPrintedOrderId
     */
    readonly customerPrintedOrderId: string
}

/**
 * Request parameters for updateReturn operation in IntegrationApi.
 * @export
 * @interface IntegrationApiUpdateReturnRequest
 */
export interface IntegrationApiUpdateReturnRequest {
    /**
     * This is the &#x60;customer_printed_order_id&#x60; as a unique identifier of the order
     * @type {string}
     * @memberof IntegrationApiUpdateReturn
     */
    readonly customerPrintedOrderId: string

    /**
     * This is the &#x60;return_id&#x60; as a unique identifier of the previously created return
     * @type {string}
     * @memberof IntegrationApiUpdateReturn
     */
    readonly returnId: string

    /**
     * 
     * @type {IntegrationReturnRequest}
     * @memberof IntegrationApiUpdateReturn
     */
    readonly integrationReturnRequest: IntegrationReturnRequest
}

/**
 * IntegrationApi - object-oriented interface
 * @export
 * @class IntegrationApi
 * @extends {BaseAPI}
 */
export class IntegrationApi extends BaseAPI {
    /**
     * This method is used to add a note (arbitrary text, no format like HTML or markdown) to an existing order by its `customer_printed_order_id`.  REVER uses this method to log the steps that are being executed, for example: `Started a return process in REVER with ID {id}`.  It\'s recommended that the implementation associates the text with the timestamp on when the method was executed so that users can see a history of what happened with an order. Once a note is added to an order, is expected to be appended to the existing notes in the order.  Further calls to [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid) should return the note in the order. 
     * @summary Adds a note (text) to an existing order
     * @param {IntegrationApiAddNoteToOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public addNoteToOrder(requestParameters: IntegrationApiAddNoteToOrderRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).addNoteToOrder(requestParameters.customerPrintedOrderId, requestParameters.addNoteToOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This method is used to create a refund to the original payment method for an existing order. The refund includes the `customer_printed_order_id` as the unique identifier of the order and a list of refund `line_items` indicating which line items have to be refunded(and the quantity of each one). 
     * @summary Creates a refund for an existing order
     * @param {IntegrationApiCreateRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public createRefund(requestParameters: IntegrationApiCreateRefundRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).createRefund(requestParameters.customerPrintedOrderId, requestParameters.integrationRefundRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This method is used to create a return for an existing order.  A return means that one or more items of an order are **already** returned to the e-commerce. The return includes the `customer_printed_order_id` as the unique identifier of the order and a list of return `line_items`` indicating which line items of the order are returned(and the quantity of each one).  This method will be called when the package will arrive in the warehouse despite the review workflow.    **Important Notes**:     - This method doesn\'t indicate the start of return process in REVER. Rather it indicates that the items are received in the warehouse.   - Once the return is created , we should be able to verify this return in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - The return can be created only once for an order hence method can\'t be called twice.   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
     * @summary Creates return in the ecommerce portal for an existing order
     * @param {IntegrationApiCreateReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public createReturn(requestParameters: IntegrationApiCreateReturnRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).createReturn(requestParameters.customerPrintedOrderId, requestParameters.integrationReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finds a single order by its `customer_printed_order_id`. In case of multiple matches, the most recent one is returned.  Please note that `customer_printed_order_id` is the `order_id` as seen by the customer, typically in the order mail. It\'s not necessarily the same as the `order_id` as seen by the platform.  The path provided is the suggested one for this methods, you can choose your own in your integration. In case of receiving a different response code than the ones listed below, REVER might contact the integration for further investigation.  When returning the order, please note the following:  - Your e-commerce can work with simple products or product variants.    In case of variants, both the `product_id` and `variant_id` and should be provided.    The properties of the variant override the ones from the product. - If you want to support exchange orders, variants must be used. - If you want to support exchange orders, stock information is mandatory.  In order to verify that the implementation is correct, you should test it with the corresponding  [testing scenarios](https://github.com/itsrever/integration/blob/main/docs/FindOrderByCustomerPrintedOrderId.md) in the  [provided testing framework](https://github.com/itsrever/integration). 
     * @summary Find Order by `customer_printed_order_id`
     * @param {IntegrationApiFindOrderByCustomerPrintedOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public findOrderByCustomerPrintedOrderId(requestParameters: IntegrationApiFindOrderByCustomerPrintedOrderIdRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).findOrderByCustomerPrintedOrderId(requestParameters.customerPrintedOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This method is used to update a previous return detail for an existing order.  The update return request includes the `customer_printed_order_id` as the unique identifier of the order and the `return_id`  along with the updated return status information for the `line_items`` This method will be called when the manual review will be done for the order.     **Important Notes**:     - Once the return is Updated , we should be able to verify this update in the order by calling the method [FindOrderByCustomerPrintedOrderId](#findorderbycustomerprintedorderid)   - Same `line_item_id` could appear twice in case the quantity was more than one and few return are accepted and others are rejected.   
     * @summary Updates return in the ecommerce portal for an existing order
     * @param {IntegrationApiUpdateReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationApi
     */
    public updateReturn(requestParameters: IntegrationApiUpdateReturnRequest, options?: RawAxiosRequestConfig) {
        return IntegrationApiFp(this.configuration).updateReturn(requestParameters.customerPrintedOrderId, requestParameters.returnId, requestParameters.integrationReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicingApi - axios parameter creator
 * @export
 */
export const InvoicingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves ecommerce information regarding invoicing
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceInvoicingInfo: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceInvoicingInfo', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/analytics/{ecommerce_id}/invoicing_info`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves ecommerce information regarding invoicing by stripe customer id
         * @param {string} [stripeCustomerId] Stripe customer ID. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceInvoicingInfoByStripeCustomer: async (stripeCustomerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/invoicing_info_by_stripe_customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeCustomerId !== undefined) {
                localVarQueryParameter['stripe_customer_id'] = stripeCustomerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrives invoicing copies
         * @param {string} [language] Language code of the copies to retrieve. Required.
         * @param {string} [type] Type of the copies to retrieve. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicingCopies: async (language?: string, type?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/invoicing_copies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records an invoicing transaction in the database
         * @param {string} [stripeCustomerId] Stripe customer ID. Required.
         * @param {string} [ecommerceGroup] Ecommerce group. Required.
         * @param {string} [invoicingPeriod] Invoicing period. Required.
         * @param {string} [txType] Action. Required.
         * @param {string} [description] Description. Can be empty.
         * @param {number} [amount] Amount in cents. Can be empty.
         * @param {string} [currency] Currency. Can be empty.
         * @param {boolean} [isTesting] Is testing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInvoicingTransaction: async (stripeCustomerId?: string, ecommerceGroup?: string, invoicingPeriod?: string, txType?: string, description?: string, amount?: number, currency?: string, isTesting?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/invoicing_transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeCustomerId !== undefined) {
                localVarQueryParameter['stripe_customer_id'] = stripeCustomerId;
            }

            if (ecommerceGroup !== undefined) {
                localVarQueryParameter['ecommerce_group'] = ecommerceGroup;
            }

            if (invoicingPeriod !== undefined) {
                localVarQueryParameter['invoicing_period'] = invoicingPeriod;
            }

            if (txType !== undefined) {
                localVarQueryParameter['tx_type'] = txType;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (isTesting !== undefined) {
                localVarQueryParameter['is_testing'] = isTesting;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicingApi - functional programming interface
 * @export
 */
export const InvoicingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves ecommerce information regarding invoicing
         * @param {string} ecommerceId ID of the ecommerce. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceInvoicingInfo(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingpbGetEcommerceInvoicingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceInvoicingInfo(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicingApi.getEcommerceInvoicingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves ecommerce information regarding invoicing by stripe customer id
         * @param {string} [stripeCustomerId] Stripe customer ID. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceInvoicingInfoByStripeCustomer(stripeCustomerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingpbGetEcommerceInvoicingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceInvoicingInfoByStripeCustomer(stripeCustomerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicingApi.getEcommerceInvoicingInfoByStripeCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrives invoicing copies
         * @param {string} [language] Language code of the copies to retrieve. Required.
         * @param {string} [type] Type of the copies to retrieve. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoicingCopies(language?: string, type?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicingpbGetInvoicingCopiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoicingCopies(language, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicingApi.getInvoicingCopies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Records an invoicing transaction in the database
         * @param {string} [stripeCustomerId] Stripe customer ID. Required.
         * @param {string} [ecommerceGroup] Ecommerce group. Required.
         * @param {string} [invoicingPeriod] Invoicing period. Required.
         * @param {string} [txType] Action. Required.
         * @param {string} [description] Description. Can be empty.
         * @param {number} [amount] Amount in cents. Can be empty.
         * @param {string} [currency] Currency. Can be empty.
         * @param {boolean} [isTesting] Is testing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInvoicingTransaction(stripeCustomerId?: string, ecommerceGroup?: string, invoicingPeriod?: string, txType?: string, description?: string, amount?: number, currency?: string, isTesting?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInvoicingTransaction(stripeCustomerId, ecommerceGroup, invoicingPeriod, txType, description, amount, currency, isTesting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoicingApi.postInvoicingTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoicingApi - factory interface
 * @export
 */
export const InvoicingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicingApiFp(configuration)
    return {
        /**
         * Retrieves ecommerce information regarding invoicing
         * @param {InvoicingApiGetEcommerceInvoicingInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceInvoicingInfo(requestParameters: InvoicingApiGetEcommerceInvoicingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingpbGetEcommerceInvoicingInfoResponse> {
            return localVarFp.getEcommerceInvoicingInfo(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves ecommerce information regarding invoicing by stripe customer id
         * @param {InvoicingApiGetEcommerceInvoicingInfoByStripeCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceInvoicingInfoByStripeCustomer(requestParameters: InvoicingApiGetEcommerceInvoicingInfoByStripeCustomerRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingpbGetEcommerceInvoicingInfoResponse> {
            return localVarFp.getEcommerceInvoicingInfoByStripeCustomer(requestParameters.stripeCustomerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrives invoicing copies
         * @param {InvoicingApiGetInvoicingCopiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoicingCopies(requestParameters: InvoicingApiGetInvoicingCopiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InvoicingpbGetInvoicingCopiesResponse> {
            return localVarFp.getInvoicingCopies(requestParameters.language, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Records an invoicing transaction in the database
         * @param {InvoicingApiPostInvoicingTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInvoicingTransaction(requestParameters: InvoicingApiPostInvoicingTransactionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postInvoicingTransaction(requestParameters.stripeCustomerId, requestParameters.ecommerceGroup, requestParameters.invoicingPeriod, requestParameters.txType, requestParameters.description, requestParameters.amount, requestParameters.currency, requestParameters.isTesting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getEcommerceInvoicingInfo operation in InvoicingApi.
 * @export
 * @interface InvoicingApiGetEcommerceInvoicingInfoRequest
 */
export interface InvoicingApiGetEcommerceInvoicingInfoRequest {
    /**
     * ID of the ecommerce. Required.
     * @type {string}
     * @memberof InvoicingApiGetEcommerceInvoicingInfo
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for getEcommerceInvoicingInfoByStripeCustomer operation in InvoicingApi.
 * @export
 * @interface InvoicingApiGetEcommerceInvoicingInfoByStripeCustomerRequest
 */
export interface InvoicingApiGetEcommerceInvoicingInfoByStripeCustomerRequest {
    /**
     * Stripe customer ID. Required.
     * @type {string}
     * @memberof InvoicingApiGetEcommerceInvoicingInfoByStripeCustomer
     */
    readonly stripeCustomerId?: string
}

/**
 * Request parameters for getInvoicingCopies operation in InvoicingApi.
 * @export
 * @interface InvoicingApiGetInvoicingCopiesRequest
 */
export interface InvoicingApiGetInvoicingCopiesRequest {
    /**
     * Language code of the copies to retrieve. Required.
     * @type {string}
     * @memberof InvoicingApiGetInvoicingCopies
     */
    readonly language?: string

    /**
     * Type of the copies to retrieve. Required.
     * @type {string}
     * @memberof InvoicingApiGetInvoicingCopies
     */
    readonly type?: string
}

/**
 * Request parameters for postInvoicingTransaction operation in InvoicingApi.
 * @export
 * @interface InvoicingApiPostInvoicingTransactionRequest
 */
export interface InvoicingApiPostInvoicingTransactionRequest {
    /**
     * Stripe customer ID. Required.
     * @type {string}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly stripeCustomerId?: string

    /**
     * Ecommerce group. Required.
     * @type {string}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly ecommerceGroup?: string

    /**
     * Invoicing period. Required.
     * @type {string}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly invoicingPeriod?: string

    /**
     * Action. Required.
     * @type {string}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly txType?: string

    /**
     * Description. Can be empty.
     * @type {string}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly description?: string

    /**
     * Amount in cents. Can be empty.
     * @type {number}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly amount?: number

    /**
     * Currency. Can be empty.
     * @type {string}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly currency?: string

    /**
     * Is testing.
     * @type {boolean}
     * @memberof InvoicingApiPostInvoicingTransaction
     */
    readonly isTesting?: boolean
}

/**
 * InvoicingApi - object-oriented interface
 * @export
 * @class InvoicingApi
 * @extends {BaseAPI}
 */
export class InvoicingApi extends BaseAPI {
    /**
     * Retrieves ecommerce information regarding invoicing
     * @param {InvoicingApiGetEcommerceInvoicingInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    public getEcommerceInvoicingInfo(requestParameters: InvoicingApiGetEcommerceInvoicingInfoRequest, options?: RawAxiosRequestConfig) {
        return InvoicingApiFp(this.configuration).getEcommerceInvoicingInfo(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves ecommerce information regarding invoicing by stripe customer id
     * @param {InvoicingApiGetEcommerceInvoicingInfoByStripeCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    public getEcommerceInvoicingInfoByStripeCustomer(requestParameters: InvoicingApiGetEcommerceInvoicingInfoByStripeCustomerRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicingApiFp(this.configuration).getEcommerceInvoicingInfoByStripeCustomer(requestParameters.stripeCustomerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrives invoicing copies
     * @param {InvoicingApiGetInvoicingCopiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    public getInvoicingCopies(requestParameters: InvoicingApiGetInvoicingCopiesRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicingApiFp(this.configuration).getInvoicingCopies(requestParameters.language, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records an invoicing transaction in the database
     * @param {InvoicingApiPostInvoicingTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    public postInvoicingTransaction(requestParameters: InvoicingApiPostInvoicingTransactionRequest = {}, options?: RawAxiosRequestConfig) {
        return InvoicingApiFp(this.configuration).postInvoicingTransaction(requestParameters.stripeCustomerId, requestParameters.ecommerceGroup, requestParameters.invoicingPeriod, requestParameters.txType, requestParameters.description, requestParameters.amount, requestParameters.currency, requestParameters.isTesting, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogisticsApi - axios parameter creator
 * @export
 */
export const LogisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a logistic order for a given process_id, customer and address.  Must specify the provider and carrier to be used to create the pickup.   - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
         * @param {LogisticsCreateLogisticOrderRequest} logisticsCreateLogisticOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderV2: async (logisticsCreateLogisticOrderRequest: LogisticsCreateLogisticOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticsCreateLogisticOrderRequest' is not null or undefined
            assertParamExists('createOrderV2', 'logisticsCreateLogisticOrderRequest', logisticsCreateLogisticOrderRequest)
            const localVarPath = `/v1/logistics/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logisticsCreateLogisticOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a pickup for a given process_id, customer and address  A logistic order must be created prior requesting a pickup   Must specify the provider and carrier to be used to create the pickup:  - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
         * @param {LogisticsCreatePickupRequest} logisticsCreatePickupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPickup: async (logisticsCreatePickupRequest: LogisticsCreatePickupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticsCreatePickupRequest' is not null or undefined
            assertParamExists('createPickup', 'logisticsCreatePickupRequest', logisticsCreatePickupRequest)
            const localVarPath = `/v1/logistics/pickup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logisticsCreatePickupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetLogisticOrderById returns a logistic order by its id
         * @param {string} orderId logistic order_id as returned by the &#x60;CreateLogisticOrder&#x60;&#x60; method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticOrderById: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getLogisticOrderById', 'orderId', orderId)
            const localVarPath = `/v1/logistics/orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetPresignedURLLabel creates a URL to download the label  file associated to the given process_id
         * @param {string} processId Id of the process to identify the label from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedURLLabel: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getPresignedURLLabel', 'processId', processId)
            const localVarPath = `/v1/logistics/{process_id}/presigned_url_label`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetPublicProcessInfo is the REST counterpart of GetProcessInfo: it returns the  warehouse stored for a return process. Returns INVALID_ARGUMENT without process_id.
         * @param {string} processId Id of the return process whose stored warehouse is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProcessInfo: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getPublicProcessInfo', 'processId', processId)
            const localVarPath = `/v1/logistics/process-info/{process_id}`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * IsPickupAvailable tells whether the carrier can collect a parcel at the given  address. Only UPS and CorreosExpress block countries or postcodes; every other  carrier is available. returns-api uses it to drop HOME_PICK_UP methods.
         * @param {LogisticsIsPickupAvailableRequest} logisticsIsPickupAvailableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPickupAvailable: async (logisticsIsPickupAvailableRequest: LogisticsIsPickupAvailableRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticsIsPickupAvailableRequest' is not null or undefined
            assertParamExists('isPickupAvailable', 'logisticsIsPickupAvailableRequest', logisticsIsPickupAvailableRequest)
            const localVarPath = `/v1/logistics/pickup/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logisticsIsPickupAvailableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SaveManuallyCreatedLogisticOrder creates a logistic order associated  to a given process_id, and saves the label file in the database
         * @param {LogisticsSaveManuallyCreatedLogisticOrderRequest} logisticsSaveManuallyCreatedLogisticOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManuallyCreatedLogisticOrder: async (logisticsSaveManuallyCreatedLogisticOrderRequest: LogisticsSaveManuallyCreatedLogisticOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logisticsSaveManuallyCreatedLogisticOrderRequest' is not null or undefined
            assertParamExists('saveManuallyCreatedLogisticOrder', 'logisticsSaveManuallyCreatedLogisticOrderRequest', logisticsSaveManuallyCreatedLogisticOrderRequest)
            const localVarPath = `/v1/logistics/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logisticsSaveManuallyCreatedLogisticOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogisticsApi - functional programming interface
 * @export
 */
export const LogisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a logistic order for a given process_id, customer and address.  Must specify the provider and carrier to be used to create the pickup.   - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
         * @param {LogisticsCreateLogisticOrderRequest} logisticsCreateLogisticOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrderV2(logisticsCreateLogisticOrderRequest: LogisticsCreateLogisticOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsSaveLogisticOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrderV2(logisticsCreateLogisticOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.createOrderV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a pickup for a given process_id, customer and address  A logistic order must be created prior requesting a pickup   Must specify the provider and carrier to be used to create the pickup:  - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
         * @param {LogisticsCreatePickupRequest} logisticsCreatePickupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPickup(logisticsCreatePickupRequest: LogisticsCreatePickupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsCreatePickupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPickup(logisticsCreatePickupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.createPickup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetLogisticOrderById returns a logistic order by its id
         * @param {string} orderId logistic order_id as returned by the &#x60;CreateLogisticOrder&#x60;&#x60; method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogisticOrderById(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsGetLogisticOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogisticOrderById(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.getLogisticOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetPresignedURLLabel creates a URL to download the label  file associated to the given process_id
         * @param {string} processId Id of the process to identify the label from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresignedURLLabel(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsGetPresignedURLLabelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresignedURLLabel(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.getPresignedURLLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetPublicProcessInfo is the REST counterpart of GetProcessInfo: it returns the  warehouse stored for a return process. Returns INVALID_ARGUMENT without process_id.
         * @param {string} processId Id of the return process whose stored warehouse is returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicProcessInfo(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsGetProcessInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicProcessInfo(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.getPublicProcessInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * IsPickupAvailable tells whether the carrier can collect a parcel at the given  address. Only UPS and CorreosExpress block countries or postcodes; every other  carrier is available. returns-api uses it to drop HOME_PICK_UP methods.
         * @param {LogisticsIsPickupAvailableRequest} logisticsIsPickupAvailableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isPickupAvailable(logisticsIsPickupAvailableRequest: LogisticsIsPickupAvailableRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsIsPickupAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isPickupAvailable(logisticsIsPickupAvailableRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.isPickupAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SaveManuallyCreatedLogisticOrder creates a logistic order associated  to a given process_id, and saves the label file in the database
         * @param {LogisticsSaveManuallyCreatedLogisticOrderRequest} logisticsSaveManuallyCreatedLogisticOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveManuallyCreatedLogisticOrder(logisticsSaveManuallyCreatedLogisticOrderRequest: LogisticsSaveManuallyCreatedLogisticOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogisticsSaveLogisticOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveManuallyCreatedLogisticOrder(logisticsSaveManuallyCreatedLogisticOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogisticsApi.saveManuallyCreatedLogisticOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogisticsApi - factory interface
 * @export
 */
export const LogisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogisticsApiFp(configuration)
    return {
        /**
         * Creates a logistic order for a given process_id, customer and address.  Must specify the provider and carrier to be used to create the pickup.   - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
         * @param {LogisticsApiCreateOrderV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderV2(requestParameters: LogisticsApiCreateOrderV2Request, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsSaveLogisticOrderResponse> {
            return localVarFp.createOrderV2(requestParameters.logisticsCreateLogisticOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a pickup for a given process_id, customer and address  A logistic order must be created prior requesting a pickup   Must specify the provider and carrier to be used to create the pickup:  - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
         * @param {LogisticsApiCreatePickupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPickup(requestParameters: LogisticsApiCreatePickupRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsCreatePickupResponse> {
            return localVarFp.createPickup(requestParameters.logisticsCreatePickupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * GetLogisticOrderById returns a logistic order by its id
         * @param {LogisticsApiGetLogisticOrderByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticOrderById(requestParameters: LogisticsApiGetLogisticOrderByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsGetLogisticOrderResponse> {
            return localVarFp.getLogisticOrderById(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetPresignedURLLabel creates a URL to download the label  file associated to the given process_id
         * @param {LogisticsApiGetPresignedURLLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresignedURLLabel(requestParameters: LogisticsApiGetPresignedURLLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsGetPresignedURLLabelResponse> {
            return localVarFp.getPresignedURLLabel(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetPublicProcessInfo is the REST counterpart of GetProcessInfo: it returns the  warehouse stored for a return process. Returns INVALID_ARGUMENT without process_id.
         * @param {LogisticsApiGetPublicProcessInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicProcessInfo(requestParameters: LogisticsApiGetPublicProcessInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsGetProcessInfoResponse> {
            return localVarFp.getPublicProcessInfo(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * IsPickupAvailable tells whether the carrier can collect a parcel at the given  address. Only UPS and CorreosExpress block countries or postcodes; every other  carrier is available. returns-api uses it to drop HOME_PICK_UP methods.
         * @param {LogisticsApiIsPickupAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isPickupAvailable(requestParameters: LogisticsApiIsPickupAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsIsPickupAvailableResponse> {
            return localVarFp.isPickupAvailable(requestParameters.logisticsIsPickupAvailableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SaveManuallyCreatedLogisticOrder creates a logistic order associated  to a given process_id, and saves the label file in the database
         * @param {LogisticsApiSaveManuallyCreatedLogisticOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveManuallyCreatedLogisticOrder(requestParameters: LogisticsApiSaveManuallyCreatedLogisticOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogisticsSaveLogisticOrderResponse> {
            return localVarFp.saveManuallyCreatedLogisticOrder(requestParameters.logisticsSaveManuallyCreatedLogisticOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createOrderV2 operation in LogisticsApi.
 * @export
 * @interface LogisticsApiCreateOrderV2Request
 */
export interface LogisticsApiCreateOrderV2Request {
    /**
     * 
     * @type {LogisticsCreateLogisticOrderRequest}
     * @memberof LogisticsApiCreateOrderV2
     */
    readonly logisticsCreateLogisticOrderRequest: LogisticsCreateLogisticOrderRequest
}

/**
 * Request parameters for createPickup operation in LogisticsApi.
 * @export
 * @interface LogisticsApiCreatePickupRequest
 */
export interface LogisticsApiCreatePickupRequest {
    /**
     * 
     * @type {LogisticsCreatePickupRequest}
     * @memberof LogisticsApiCreatePickup
     */
    readonly logisticsCreatePickupRequest: LogisticsCreatePickupRequest
}

/**
 * Request parameters for getLogisticOrderById operation in LogisticsApi.
 * @export
 * @interface LogisticsApiGetLogisticOrderByIdRequest
 */
export interface LogisticsApiGetLogisticOrderByIdRequest {
    /**
     * logistic order_id as returned by the &#x60;CreateLogisticOrder&#x60;&#x60; method
     * @type {string}
     * @memberof LogisticsApiGetLogisticOrderById
     */
    readonly orderId: string
}

/**
 * Request parameters for getPresignedURLLabel operation in LogisticsApi.
 * @export
 * @interface LogisticsApiGetPresignedURLLabelRequest
 */
export interface LogisticsApiGetPresignedURLLabelRequest {
    /**
     * Id of the process to identify the label from
     * @type {string}
     * @memberof LogisticsApiGetPresignedURLLabel
     */
    readonly processId: string
}

/**
 * Request parameters for getPublicProcessInfo operation in LogisticsApi.
 * @export
 * @interface LogisticsApiGetPublicProcessInfoRequest
 */
export interface LogisticsApiGetPublicProcessInfoRequest {
    /**
     * Id of the return process whose stored warehouse is returned
     * @type {string}
     * @memberof LogisticsApiGetPublicProcessInfo
     */
    readonly processId: string
}

/**
 * Request parameters for isPickupAvailable operation in LogisticsApi.
 * @export
 * @interface LogisticsApiIsPickupAvailableRequest
 */
export interface LogisticsApiIsPickupAvailableRequest {
    /**
     * 
     * @type {LogisticsIsPickupAvailableRequest}
     * @memberof LogisticsApiIsPickupAvailable
     */
    readonly logisticsIsPickupAvailableRequest: LogisticsIsPickupAvailableRequest
}

/**
 * Request parameters for saveManuallyCreatedLogisticOrder operation in LogisticsApi.
 * @export
 * @interface LogisticsApiSaveManuallyCreatedLogisticOrderRequest
 */
export interface LogisticsApiSaveManuallyCreatedLogisticOrderRequest {
    /**
     * 
     * @type {LogisticsSaveManuallyCreatedLogisticOrderRequest}
     * @memberof LogisticsApiSaveManuallyCreatedLogisticOrder
     */
    readonly logisticsSaveManuallyCreatedLogisticOrderRequest: LogisticsSaveManuallyCreatedLogisticOrderRequest
}

/**
 * LogisticsApi - object-oriented interface
 * @export
 * @class LogisticsApi
 * @extends {BaseAPI}
 */
export class LogisticsApi extends BaseAPI {
    /**
     * Creates a logistic order for a given process_id, customer and address.  Must specify the provider and carrier to be used to create the pickup.   - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
     * @param {LogisticsApiCreateOrderV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public createOrderV2(requestParameters: LogisticsApiCreateOrderV2Request, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).createOrderV2(requestParameters.logisticsCreateLogisticOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a pickup for a given process_id, customer and address  A logistic order must be created prior requesting a pickup   Must specify the provider and carrier to be used to create the pickup:  - Returns UNIMPLEMENTED (gRPC code 12) if the provider is `OPS`,  meaning it didn\'t generated any action.   - Returns InvalidArgument (gRPC code 3) if the combination of   `return-method`, `provider`and `carrier` is not supported.
     * @param {LogisticsApiCreatePickupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public createPickup(requestParameters: LogisticsApiCreatePickupRequest, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).createPickup(requestParameters.logisticsCreatePickupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetLogisticOrderById returns a logistic order by its id
     * @param {LogisticsApiGetLogisticOrderByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public getLogisticOrderById(requestParameters: LogisticsApiGetLogisticOrderByIdRequest, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).getLogisticOrderById(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetPresignedURLLabel creates a URL to download the label  file associated to the given process_id
     * @param {LogisticsApiGetPresignedURLLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public getPresignedURLLabel(requestParameters: LogisticsApiGetPresignedURLLabelRequest, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).getPresignedURLLabel(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetPublicProcessInfo is the REST counterpart of GetProcessInfo: it returns the  warehouse stored for a return process. Returns INVALID_ARGUMENT without process_id.
     * @param {LogisticsApiGetPublicProcessInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public getPublicProcessInfo(requestParameters: LogisticsApiGetPublicProcessInfoRequest, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).getPublicProcessInfo(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * IsPickupAvailable tells whether the carrier can collect a parcel at the given  address. Only UPS and CorreosExpress block countries or postcodes; every other  carrier is available. returns-api uses it to drop HOME_PICK_UP methods.
     * @param {LogisticsApiIsPickupAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public isPickupAvailable(requestParameters: LogisticsApiIsPickupAvailableRequest, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).isPickupAvailable(requestParameters.logisticsIsPickupAvailableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SaveManuallyCreatedLogisticOrder creates a logistic order associated  to a given process_id, and saves the label file in the database
     * @param {LogisticsApiSaveManuallyCreatedLogisticOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogisticsApi
     */
    public saveManuallyCreatedLogisticOrder(requestParameters: LogisticsApiSaveManuallyCreatedLogisticOrderRequest, options?: RawAxiosRequestConfig) {
        return LogisticsApiFp(this.configuration).saveManuallyCreatedLogisticOrder(requestParameters.logisticsSaveManuallyCreatedLogisticOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagingApi - axios parameter creator
 * @export
 */
export const MessagingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * VerifyWhatsAppWebhook answers Meta\'s subscription check: it echoes hub.challenge when  hub.verify_token matches the configured token.  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} [hubMode] Always \&quot;subscribe\&quot;.
         * @param {string} [hubChallenge] Value to echo back.
         * @param {string} [hubVerifyToken] Token configured in the Meta app, compared with ours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWhatsAppWebhook: async (hubMode?: string, hubChallenge?: string, hubVerifyToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/messaging/whatsapp/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hubMode !== undefined) {
                localVarQueryParameter['hub.mode'] = hubMode;
            }

            if (hubChallenge !== undefined) {
                localVarQueryParameter['hub.challenge'] = hubChallenge;
            }

            if (hubVerifyToken !== undefined) {
                localVarQueryParameter['hub.verify_token'] = hubVerifyToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WhatsAppWebhook receives WhatsApp Cloud API notifications. The raw body is forwarded so the  X-Hub-Signature-256 header can be verified. Each message is stored and published to events-api  before the response; the reply is produced by ProcessWhatsAppMessageInternal.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/messaging/whatsapp/webhooks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagingApi - functional programming interface
 * @export
 */
export const MessagingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagingApiAxiosParamCreator(configuration)
    return {
        /**
         * VerifyWhatsAppWebhook answers Meta\'s subscription check: it echoes hub.challenge when  hub.verify_token matches the configured token.  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} [hubMode] Always \&quot;subscribe\&quot;.
         * @param {string} [hubChallenge] Value to echo back.
         * @param {string} [hubVerifyToken] Token configured in the Meta app, compared with ours.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyWhatsAppWebhook(hubMode?: string, hubChallenge?: string, hubVerifyToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyWhatsAppWebhook(hubMode, hubChallenge, hubVerifyToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagingApi.verifyWhatsAppWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WhatsAppWebhook receives WhatsApp Cloud API notifications. The raw body is forwarded so the  X-Hub-Signature-256 header can be verified. Each message is stored and published to events-api  before the response; the reply is produced by ProcessWhatsAppMessageInternal.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsAppWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsAppWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagingApi.whatsAppWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagingApi - factory interface
 * @export
 */
export const MessagingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagingApiFp(configuration)
    return {
        /**
         * VerifyWhatsAppWebhook answers Meta\'s subscription check: it echoes hub.challenge when  hub.verify_token matches the configured token.  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {MessagingApiVerifyWhatsAppWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWhatsAppWebhook(requestParameters: MessagingApiVerifyWhatsAppWebhookRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verifyWhatsAppWebhook(requestParameters.hubMode, requestParameters.hubChallenge, requestParameters.hubVerifyToken, options).then((request) => request(axios, basePath));
        },
        /**
         * WhatsAppWebhook receives WhatsApp Cloud API notifications. The raw body is forwarded so the  X-Hub-Signature-256 header can be verified. Each message is stored and published to events-api  before the response; the reply is produced by ProcessWhatsAppMessageInternal.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsAppWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.whatsAppWebhook(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for verifyWhatsAppWebhook operation in MessagingApi.
 * @export
 * @interface MessagingApiVerifyWhatsAppWebhookRequest
 */
export interface MessagingApiVerifyWhatsAppWebhookRequest {
    /**
     * Always \&quot;subscribe\&quot;.
     * @type {string}
     * @memberof MessagingApiVerifyWhatsAppWebhook
     */
    readonly hubMode?: string

    /**
     * Value to echo back.
     * @type {string}
     * @memberof MessagingApiVerifyWhatsAppWebhook
     */
    readonly hubChallenge?: string

    /**
     * Token configured in the Meta app, compared with ours.
     * @type {string}
     * @memberof MessagingApiVerifyWhatsAppWebhook
     */
    readonly hubVerifyToken?: string
}

/**
 * MessagingApi - object-oriented interface
 * @export
 * @class MessagingApi
 * @extends {BaseAPI}
 */
export class MessagingApi extends BaseAPI {
    /**
     * VerifyWhatsAppWebhook answers Meta\'s subscription check: it echoes hub.challenge when  hub.verify_token matches the configured token.  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {MessagingApiVerifyWhatsAppWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public verifyWhatsAppWebhook(requestParameters: MessagingApiVerifyWhatsAppWebhookRequest = {}, options?: RawAxiosRequestConfig) {
        return MessagingApiFp(this.configuration).verifyWhatsAppWebhook(requestParameters.hubMode, requestParameters.hubChallenge, requestParameters.hubVerifyToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WhatsAppWebhook receives WhatsApp Cloud API notifications. The raw body is forwarded so the  X-Hub-Signature-256 header can be verified. Each message is stored and published to events-api  before the response; the reply is produced by ProcessWhatsAppMessageInternal.  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingApi
     */
    public whatsAppWebhook(options?: RawAxiosRequestConfig) {
        return MessagingApiFp(this.configuration).whatsAppWebhook(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OpsApi - axios parameter creator
 * @export
 */
export const OpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Routes another Shopify product tag to a The Bradery brand\'s warehouse, so a new sale of the brand under another  tag keeps its warehouse and dashboard login
         * @param {string} tag Any Shopify product tag the brand already has
         * @param {OpspbAddTheBraderyBrandTagRequest} opspbAddTheBraderyBrandTagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTheBraderyBrandTag: async (tag: string, opspbAddTheBraderyBrandTagRequest: OpspbAddTheBraderyBrandTagRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('addTheBraderyBrandTag', 'tag', tag)
            // verify required parameter 'opspbAddTheBraderyBrandTagRequest' is not null or undefined
            assertParamExists('addTheBraderyBrandTag', 'opspbAddTheBraderyBrandTagRequest', opspbAddTheBraderyBrandTagRequest)
            const localVarPath = `/v1/ops/thebradery/brands/{tag}/tags`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbAddTheBraderyBrandTagRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OpspbCancelRequest} opspbCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (opspbCancelRequest: OpspbCancelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbCancelRequest' is not null or undefined
            assertParamExists('cancel', 'opspbCancelRequest', opspbCancelRequest)
            const localVarPath = `/v1/ops/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbCancelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a The Bradery brand: stores its warehouse, routes its tag to it in every store of the group that does not  route it yet, announces it in Slack and gives the reviewer with the warehouse\'s email access to it
         * @param {OpspbCreateTheBraderyBrandRequest} opspbCreateTheBraderyBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTheBraderyBrand: async (opspbCreateTheBraderyBrandRequest: OpspbCreateTheBraderyBrandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbCreateTheBraderyBrandRequest' is not null or undefined
            assertParamExists('createTheBraderyBrand', 'opspbCreateTheBraderyBrandRequest', opspbCreateTheBraderyBrandRequest)
            const localVarPath = `/v1/ops/thebradery/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbCreateTheBraderyBrandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists The Bradery\'s brands: each Shopify product tag its stores route to a brand\'s warehouse, with that warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTheBraderyBrands: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ops/thebradery/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OpspbLogisticsRequest} opspbLogisticsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logistics: async (opspbLogisticsRequest: OpspbLogisticsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbLogisticsRequest' is not null or undefined
            assertParamExists('logistics', 'opspbLogisticsRequest', opspbLogisticsRequest)
            const localVarPath = `/v1/ops/logistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbLogisticsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a return process as refunded externally (manual refund)
         * @param {OpspbMarkAsRefundedExternallyRequest} opspbMarkAsRefundedExternallyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRefundedExternally: async (opspbMarkAsRefundedExternallyRequest: OpspbMarkAsRefundedExternallyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbMarkAsRefundedExternallyRequest' is not null or undefined
            assertParamExists('markAsRefundedExternally', 'opspbMarkAsRefundedExternallyRequest', opspbMarkAsRefundedExternallyRequest)
            const localVarPath = `/v1/ops/mark_as_refunded_externally`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbMarkAsRefundedExternallyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [processId] 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToContactForm: async (processId?: string, source?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/ops/contact_form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (processId !== undefined) {
                localVarQueryParameter['process_id'] = processId;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stops routing a Shopify product tag to its The Bradery brand\'s warehouse; returns of its products then go where  those of products without a brand go. A brand\'s last tag cannot be removed
         * @param {string} tag Shopify product tag to remove from its brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTheBraderyBrandTag: async (tag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('removeTheBraderyBrandTag', 'tag', tag)
            const localVarPath = `/v1/ops/thebradery/tags/{tag}`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OpspbRestockItemsRequest} opspbRestockItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restockItems: async (opspbRestockItemsRequest: OpspbRestockItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbRestockItemsRequest' is not null or undefined
            assertParamExists('restockItems', 'opspbRestockItemsRequest', opspbRestockItemsRequest)
            const localVarPath = `/v1/ops/restock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbRestockItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ReviewItemByOrderSKU reviews a specific return line item identified by order ID and SKU. It  resolves the matching process and line item, then submits a complete review where the matched  item receives the provided status and all remaining product line items receive MISSING status.  This supports partial review scenarios (e.g. Inditex CSV rows) where only some items are  explicitly reviewed and the rest are considered genuinely missing. Returns processed=false when  no matching line item is found (graceful skip, not an error).
         * @param {OpspbReviewItemByOrderSKURequest} opspbReviewItemByOrderSKURequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewItemByOrderSKU: async (opspbReviewItemByOrderSKURequest: OpspbReviewItemByOrderSKURequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbReviewItemByOrderSKURequest' is not null or undefined
            assertParamExists('reviewItemByOrderSKU', 'opspbReviewItemByOrderSKURequest', opspbReviewItemByOrderSKURequest)
            const localVarPath = `/v1/ops/review_by_order_sku`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbReviewItemByOrderSKURequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tells REVER the outcome of the warehouse review of a return, identifying each item by its  REVER line item id. `POST /v1/ops/ecommerce/review` also accepts platform line item ids and SKUs.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds. Its amount is in major units (\"12.50\").   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued. A process can be reviewed once:  a second request returns 400.
         * @summary Review a return process by REVER line item id
         * @param {OpspbReviewItemsRequest} opspbReviewItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewItems: async (opspbReviewItemsRequest: OpspbReviewItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbReviewItemsRequest' is not null or undefined
            assertParamExists('reviewItems', 'opspbReviewItemsRequest', opspbReviewItemsRequest)
            const localVarPath = `/v1/ops/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbReviewItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tells REVER the outcome of the warehouse review of a return. The outcome decides the refund,  the restock and the emails the customer receives.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds.   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued.   For a process that is already reviewed, REVER compares how many reviews each item has per status.  If they match, it returns 200 and changes nothing, otherwise 409. Other fields, such as  `reject_reason` or `should_restock`, are not compared. When REVER added `MISSING` reviews for  units the request left out, a retry has to include them.
         * @summary Review a return process
         * @param {OpspbReviewItemsGenericRequest} opspbReviewItemsGenericRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewItemsGeneric: async (opspbReviewItemsGenericRequest: OpspbReviewItemsGenericRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbReviewItemsGenericRequest' is not null or undefined
            assertParamExists('reviewItemsGeneric', 'opspbReviewItemsGenericRequest', opspbReviewItemsGenericRequest)
            const localVarPath = `/v1/ops/ecommerce/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbReviewItemsGenericRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OpspbSubmitAuthorizationRequest} opspbSubmitAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAuthorization: async (opspbSubmitAuthorizationRequest: OpspbSubmitAuthorizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbSubmitAuthorizationRequest' is not null or undefined
            assertParamExists('submitAuthorization', 'opspbSubmitAuthorizationRequest', opspbSubmitAuthorizationRequest)
            const localVarPath = `/v1/ops/submit_authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbSubmitAuthorizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * TransitionLKSS sets the last-known shipping status only when the move from  the current status is a valid transition (see the shipping-status state  machine). An invalid transition is a no-op, not an error: the response  reports the previous and current status and whether a change was applied.  It errors only on bad parameters or a database/persistence failure.
         * @param {OpspbTransitionLKSSRequest} opspbTransitionLKSSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitionLKSS: async (opspbTransitionLKSSRequest: OpspbTransitionLKSSRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbTransitionLKSSRequest' is not null or undefined
            assertParamExists('transitionLKSS', 'opspbTransitionLKSSRequest', opspbTransitionLKSSRequest)
            const localVarPath = `/v1/ops/transition_lkss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbTransitionLKSSRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateLKSS sets the last-known shipping status unconditionally. It does NOT  validate the transition: any status is written as requested. Prefer  TransitionLKSS when the change must respect the shipping-status state machine.
         * @param {OpspbUpdateLKSSRequest} opspbUpdateLKSSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLKSS: async (opspbUpdateLKSSRequest: OpspbUpdateLKSSRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'opspbUpdateLKSSRequest' is not null or undefined
            assertParamExists('updateLKSS', 'opspbUpdateLKSSRequest', opspbUpdateLKSSRequest)
            const localVarPath = `/v1/ops/update_lkss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbUpdateLKSSRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes the email of a The Bradery brand\'s warehouses and makes it the brand\'s dashboard login
         * @param {string} tag Shopify product tag of the brand
         * @param {OpspbUpdateTheBraderyBrandEmailRequest} opspbUpdateTheBraderyBrandEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTheBraderyBrandEmail: async (tag: string, opspbUpdateTheBraderyBrandEmailRequest: OpspbUpdateTheBraderyBrandEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('updateTheBraderyBrandEmail', 'tag', tag)
            // verify required parameter 'opspbUpdateTheBraderyBrandEmailRequest' is not null or undefined
            assertParamExists('updateTheBraderyBrandEmail', 'opspbUpdateTheBraderyBrandEmailRequest', opspbUpdateTheBraderyBrandEmailRequest)
            const localVarPath = `/v1/ops/thebradery/brands/{tag}/email`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(opspbUpdateTheBraderyBrandEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpsApi - functional programming interface
 * @export
 */
export const OpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpsApiAxiosParamCreator(configuration)
    return {
        /**
         * Routes another Shopify product tag to a The Bradery brand\'s warehouse, so a new sale of the brand under another  tag keeps its warehouse and dashboard login
         * @param {string} tag Any Shopify product tag the brand already has
         * @param {OpspbAddTheBraderyBrandTagRequest} opspbAddTheBraderyBrandTagRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTheBraderyBrandTag(tag: string, opspbAddTheBraderyBrandTagRequest: OpspbAddTheBraderyBrandTagRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbTheBraderyBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTheBraderyBrandTag(tag, opspbAddTheBraderyBrandTagRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.addTheBraderyBrandTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OpspbCancelRequest} opspbCancelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(opspbCancelRequest: OpspbCancelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(opspbCancelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a The Bradery brand: stores its warehouse, routes its tag to it in every store of the group that does not  route it yet, announces it in Slack and gives the reviewer with the warehouse\'s email access to it
         * @param {OpspbCreateTheBraderyBrandRequest} opspbCreateTheBraderyBrandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTheBraderyBrand(opspbCreateTheBraderyBrandRequest: OpspbCreateTheBraderyBrandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbTheBraderyBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTheBraderyBrand(opspbCreateTheBraderyBrandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.createTheBraderyBrand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists The Bradery\'s brands: each Shopify product tag its stores route to a brand\'s warehouse, with that warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTheBraderyBrands(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbListTheBraderyBrandsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTheBraderyBrands(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.listTheBraderyBrands']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OpspbLogisticsRequest} opspbLogisticsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logistics(opspbLogisticsRequest: OpspbLogisticsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logistics(opspbLogisticsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.logistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a return process as refunded externally (manual refund)
         * @param {OpspbMarkAsRefundedExternallyRequest} opspbMarkAsRefundedExternallyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsRefundedExternally(opspbMarkAsRefundedExternallyRequest: OpspbMarkAsRefundedExternallyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsRefundedExternally(opspbMarkAsRefundedExternallyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.markAsRefundedExternally']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [processId] 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redirectToContactForm(processId?: string, source?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redirectToContactForm(processId, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.redirectToContactForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stops routing a Shopify product tag to its The Bradery brand\'s warehouse; returns of its products then go where  those of products without a brand go. A brand\'s last tag cannot be removed
         * @param {string} tag Shopify product tag to remove from its brand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTheBraderyBrandTag(tag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbTheBraderyBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTheBraderyBrandTag(tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.removeTheBraderyBrandTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OpspbRestockItemsRequest} opspbRestockItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restockItems(opspbRestockItemsRequest: OpspbRestockItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restockItems(opspbRestockItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.restockItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ReviewItemByOrderSKU reviews a specific return line item identified by order ID and SKU. It  resolves the matching process and line item, then submits a complete review where the matched  item receives the provided status and all remaining product line items receive MISSING status.  This supports partial review scenarios (e.g. Inditex CSV rows) where only some items are  explicitly reviewed and the rest are considered genuinely missing. Returns processed=false when  no matching line item is found (graceful skip, not an error).
         * @param {OpspbReviewItemByOrderSKURequest} opspbReviewItemByOrderSKURequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewItemByOrderSKU(opspbReviewItemByOrderSKURequest: OpspbReviewItemByOrderSKURequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbReviewItemByOrderSKUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewItemByOrderSKU(opspbReviewItemByOrderSKURequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.reviewItemByOrderSKU']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tells REVER the outcome of the warehouse review of a return, identifying each item by its  REVER line item id. `POST /v1/ops/ecommerce/review` also accepts platform line item ids and SKUs.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds. Its amount is in major units (\"12.50\").   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued. A process can be reviewed once:  a second request returns 400.
         * @summary Review a return process by REVER line item id
         * @param {OpspbReviewItemsRequest} opspbReviewItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewItems(opspbReviewItemsRequest: OpspbReviewItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewItems(opspbReviewItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.reviewItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tells REVER the outcome of the warehouse review of a return. The outcome decides the refund,  the restock and the emails the customer receives.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds.   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued.   For a process that is already reviewed, REVER compares how many reviews each item has per status.  If they match, it returns 200 and changes nothing, otherwise 409. Other fields, such as  `reject_reason` or `should_restock`, are not compared. When REVER added `MISSING` reviews for  units the request left out, a retry has to include them.
         * @summary Review a return process
         * @param {OpspbReviewItemsGenericRequest} opspbReviewItemsGenericRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewItemsGeneric(opspbReviewItemsGenericRequest: OpspbReviewItemsGenericRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewItemsGeneric(opspbReviewItemsGenericRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.reviewItemsGeneric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OpspbSubmitAuthorizationRequest} opspbSubmitAuthorizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitAuthorization(opspbSubmitAuthorizationRequest: OpspbSubmitAuthorizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitAuthorization(opspbSubmitAuthorizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.submitAuthorization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * TransitionLKSS sets the last-known shipping status only when the move from  the current status is a valid transition (see the shipping-status state  machine). An invalid transition is a no-op, not an error: the response  reports the previous and current status and whether a change was applied.  It errors only on bad parameters or a database/persistence failure.
         * @param {OpspbTransitionLKSSRequest} opspbTransitionLKSSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transitionLKSS(opspbTransitionLKSSRequest: OpspbTransitionLKSSRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbTransitionLKSSResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transitionLKSS(opspbTransitionLKSSRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.transitionLKSS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * UpdateLKSS sets the last-known shipping status unconditionally. It does NOT  validate the transition: any status is written as requested. Prefer  TransitionLKSS when the change must respect the shipping-status state machine.
         * @param {OpspbUpdateLKSSRequest} opspbUpdateLKSSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLKSS(opspbUpdateLKSSRequest: OpspbUpdateLKSSRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLKSS(opspbUpdateLKSSRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.updateLKSS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Changes the email of a The Bradery brand\'s warehouses and makes it the brand\'s dashboard login
         * @param {string} tag Shopify product tag of the brand
         * @param {OpspbUpdateTheBraderyBrandEmailRequest} opspbUpdateTheBraderyBrandEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTheBraderyBrandEmail(tag: string, opspbUpdateTheBraderyBrandEmailRequest: OpspbUpdateTheBraderyBrandEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpspbTheBraderyBrand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTheBraderyBrandEmail(tag, opspbUpdateTheBraderyBrandEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OpsApi.updateTheBraderyBrandEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OpsApi - factory interface
 * @export
 */
export const OpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpsApiFp(configuration)
    return {
        /**
         * Routes another Shopify product tag to a The Bradery brand\'s warehouse, so a new sale of the brand under another  tag keeps its warehouse and dashboard login
         * @param {OpsApiAddTheBraderyBrandTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTheBraderyBrandTag(requestParameters: OpsApiAddTheBraderyBrandTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpspbTheBraderyBrand> {
            return localVarFp.addTheBraderyBrandTag(requestParameters.tag, requestParameters.opspbAddTheBraderyBrandTagRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpsApiCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(requestParameters: OpsApiCancelRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cancel(requestParameters.opspbCancelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a The Bradery brand: stores its warehouse, routes its tag to it in every store of the group that does not  route it yet, announces it in Slack and gives the reviewer with the warehouse\'s email access to it
         * @param {OpsApiCreateTheBraderyBrandRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTheBraderyBrand(requestParameters: OpsApiCreateTheBraderyBrandRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpspbTheBraderyBrand> {
            return localVarFp.createTheBraderyBrand(requestParameters.opspbCreateTheBraderyBrandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists The Bradery\'s brands: each Shopify product tag its stores route to a brand\'s warehouse, with that warehouse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTheBraderyBrands(options?: RawAxiosRequestConfig): AxiosPromise<OpspbListTheBraderyBrandsResponse> {
            return localVarFp.listTheBraderyBrands(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpsApiLogisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logistics(requestParameters: OpsApiLogisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.logistics(requestParameters.opspbLogisticsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a return process as refunded externally (manual refund)
         * @param {OpsApiMarkAsRefundedExternallyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsRefundedExternally(requestParameters: OpsApiMarkAsRefundedExternallyRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.markAsRefundedExternally(requestParameters.opspbMarkAsRefundedExternallyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpsApiRedirectToContactFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToContactForm(requestParameters: OpsApiRedirectToContactFormRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.redirectToContactForm(requestParameters.processId, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * Stops routing a Shopify product tag to its The Bradery brand\'s warehouse; returns of its products then go where  those of products without a brand go. A brand\'s last tag cannot be removed
         * @param {OpsApiRemoveTheBraderyBrandTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTheBraderyBrandTag(requestParameters: OpsApiRemoveTheBraderyBrandTagRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpspbTheBraderyBrand> {
            return localVarFp.removeTheBraderyBrandTag(requestParameters.tag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpsApiRestockItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restockItems(requestParameters: OpsApiRestockItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.restockItems(requestParameters.opspbRestockItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ReviewItemByOrderSKU reviews a specific return line item identified by order ID and SKU. It  resolves the matching process and line item, then submits a complete review where the matched  item receives the provided status and all remaining product line items receive MISSING status.  This supports partial review scenarios (e.g. Inditex CSV rows) where only some items are  explicitly reviewed and the rest are considered genuinely missing. Returns processed=false when  no matching line item is found (graceful skip, not an error).
         * @param {OpsApiReviewItemByOrderSKURequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewItemByOrderSKU(requestParameters: OpsApiReviewItemByOrderSKURequest, options?: RawAxiosRequestConfig): AxiosPromise<OpspbReviewItemByOrderSKUResponse> {
            return localVarFp.reviewItemByOrderSKU(requestParameters.opspbReviewItemByOrderSKURequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Tells REVER the outcome of the warehouse review of a return, identifying each item by its  REVER line item id. `POST /v1/ops/ecommerce/review` also accepts platform line item ids and SKUs.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds. Its amount is in major units (\"12.50\").   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued. A process can be reviewed once:  a second request returns 400.
         * @summary Review a return process by REVER line item id
         * @param {OpsApiReviewItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewItems(requestParameters: OpsApiReviewItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.reviewItems(requestParameters.opspbReviewItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Tells REVER the outcome of the warehouse review of a return. The outcome decides the refund,  the restock and the emails the customer receives.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds.   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued.   For a process that is already reviewed, REVER compares how many reviews each item has per status.  If they match, it returns 200 and changes nothing, otherwise 409. Other fields, such as  `reject_reason` or `should_restock`, are not compared. When REVER added `MISSING` reviews for  units the request left out, a retry has to include them.
         * @summary Review a return process
         * @param {OpsApiReviewItemsGenericRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewItemsGeneric(requestParameters: OpsApiReviewItemsGenericRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.reviewItemsGeneric(requestParameters.opspbReviewItemsGenericRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpsApiSubmitAuthorizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAuthorization(requestParameters: OpsApiSubmitAuthorizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.submitAuthorization(requestParameters.opspbSubmitAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * TransitionLKSS sets the last-known shipping status only when the move from  the current status is a valid transition (see the shipping-status state  machine). An invalid transition is a no-op, not an error: the response  reports the previous and current status and whether a change was applied.  It errors only on bad parameters or a database/persistence failure.
         * @param {OpsApiTransitionLKSSRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitionLKSS(requestParameters: OpsApiTransitionLKSSRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpspbTransitionLKSSResponse> {
            return localVarFp.transitionLKSS(requestParameters.opspbTransitionLKSSRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateLKSS sets the last-known shipping status unconditionally. It does NOT  validate the transition: any status is written as requested. Prefer  TransitionLKSS when the change must respect the shipping-status state machine.
         * @param {OpsApiUpdateLKSSRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLKSS(requestParameters: OpsApiUpdateLKSSRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateLKSS(requestParameters.opspbUpdateLKSSRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Changes the email of a The Bradery brand\'s warehouses and makes it the brand\'s dashboard login
         * @param {OpsApiUpdateTheBraderyBrandEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTheBraderyBrandEmail(requestParameters: OpsApiUpdateTheBraderyBrandEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpspbTheBraderyBrand> {
            return localVarFp.updateTheBraderyBrandEmail(requestParameters.tag, requestParameters.opspbUpdateTheBraderyBrandEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTheBraderyBrandTag operation in OpsApi.
 * @export
 * @interface OpsApiAddTheBraderyBrandTagRequest
 */
export interface OpsApiAddTheBraderyBrandTagRequest {
    /**
     * Any Shopify product tag the brand already has
     * @type {string}
     * @memberof OpsApiAddTheBraderyBrandTag
     */
    readonly tag: string

    /**
     * 
     * @type {OpspbAddTheBraderyBrandTagRequest}
     * @memberof OpsApiAddTheBraderyBrandTag
     */
    readonly opspbAddTheBraderyBrandTagRequest: OpspbAddTheBraderyBrandTagRequest
}

/**
 * Request parameters for cancel operation in OpsApi.
 * @export
 * @interface OpsApiCancelRequest
 */
export interface OpsApiCancelRequest {
    /**
     * 
     * @type {OpspbCancelRequest}
     * @memberof OpsApiCancel
     */
    readonly opspbCancelRequest: OpspbCancelRequest
}

/**
 * Request parameters for createTheBraderyBrand operation in OpsApi.
 * @export
 * @interface OpsApiCreateTheBraderyBrandRequest
 */
export interface OpsApiCreateTheBraderyBrandRequest {
    /**
     * 
     * @type {OpspbCreateTheBraderyBrandRequest}
     * @memberof OpsApiCreateTheBraderyBrand
     */
    readonly opspbCreateTheBraderyBrandRequest: OpspbCreateTheBraderyBrandRequest
}

/**
 * Request parameters for logistics operation in OpsApi.
 * @export
 * @interface OpsApiLogisticsRequest
 */
export interface OpsApiLogisticsRequest {
    /**
     * 
     * @type {OpspbLogisticsRequest}
     * @memberof OpsApiLogistics
     */
    readonly opspbLogisticsRequest: OpspbLogisticsRequest
}

/**
 * Request parameters for markAsRefundedExternally operation in OpsApi.
 * @export
 * @interface OpsApiMarkAsRefundedExternallyRequest
 */
export interface OpsApiMarkAsRefundedExternallyRequest {
    /**
     * 
     * @type {OpspbMarkAsRefundedExternallyRequest}
     * @memberof OpsApiMarkAsRefundedExternally
     */
    readonly opspbMarkAsRefundedExternallyRequest: OpspbMarkAsRefundedExternallyRequest
}

/**
 * Request parameters for redirectToContactForm operation in OpsApi.
 * @export
 * @interface OpsApiRedirectToContactFormRequest
 */
export interface OpsApiRedirectToContactFormRequest {
    /**
     * 
     * @type {string}
     * @memberof OpsApiRedirectToContactForm
     */
    readonly processId?: string

    /**
     * 
     * @type {string}
     * @memberof OpsApiRedirectToContactForm
     */
    readonly source?: string
}

/**
 * Request parameters for removeTheBraderyBrandTag operation in OpsApi.
 * @export
 * @interface OpsApiRemoveTheBraderyBrandTagRequest
 */
export interface OpsApiRemoveTheBraderyBrandTagRequest {
    /**
     * Shopify product tag to remove from its brand
     * @type {string}
     * @memberof OpsApiRemoveTheBraderyBrandTag
     */
    readonly tag: string
}

/**
 * Request parameters for restockItems operation in OpsApi.
 * @export
 * @interface OpsApiRestockItemsRequest
 */
export interface OpsApiRestockItemsRequest {
    /**
     * 
     * @type {OpspbRestockItemsRequest}
     * @memberof OpsApiRestockItems
     */
    readonly opspbRestockItemsRequest: OpspbRestockItemsRequest
}

/**
 * Request parameters for reviewItemByOrderSKU operation in OpsApi.
 * @export
 * @interface OpsApiReviewItemByOrderSKURequest
 */
export interface OpsApiReviewItemByOrderSKURequest {
    /**
     * 
     * @type {OpspbReviewItemByOrderSKURequest}
     * @memberof OpsApiReviewItemByOrderSKU
     */
    readonly opspbReviewItemByOrderSKURequest: OpspbReviewItemByOrderSKURequest
}

/**
 * Request parameters for reviewItems operation in OpsApi.
 * @export
 * @interface OpsApiReviewItemsRequest
 */
export interface OpsApiReviewItemsRequest {
    /**
     * 
     * @type {OpspbReviewItemsRequest}
     * @memberof OpsApiReviewItems
     */
    readonly opspbReviewItemsRequest: OpspbReviewItemsRequest
}

/**
 * Request parameters for reviewItemsGeneric operation in OpsApi.
 * @export
 * @interface OpsApiReviewItemsGenericRequest
 */
export interface OpsApiReviewItemsGenericRequest {
    /**
     * 
     * @type {OpspbReviewItemsGenericRequest}
     * @memberof OpsApiReviewItemsGeneric
     */
    readonly opspbReviewItemsGenericRequest: OpspbReviewItemsGenericRequest
}

/**
 * Request parameters for submitAuthorization operation in OpsApi.
 * @export
 * @interface OpsApiSubmitAuthorizationRequest
 */
export interface OpsApiSubmitAuthorizationRequest {
    /**
     * 
     * @type {OpspbSubmitAuthorizationRequest}
     * @memberof OpsApiSubmitAuthorization
     */
    readonly opspbSubmitAuthorizationRequest: OpspbSubmitAuthorizationRequest
}

/**
 * Request parameters for transitionLKSS operation in OpsApi.
 * @export
 * @interface OpsApiTransitionLKSSRequest
 */
export interface OpsApiTransitionLKSSRequest {
    /**
     * 
     * @type {OpspbTransitionLKSSRequest}
     * @memberof OpsApiTransitionLKSS
     */
    readonly opspbTransitionLKSSRequest: OpspbTransitionLKSSRequest
}

/**
 * Request parameters for updateLKSS operation in OpsApi.
 * @export
 * @interface OpsApiUpdateLKSSRequest
 */
export interface OpsApiUpdateLKSSRequest {
    /**
     * 
     * @type {OpspbUpdateLKSSRequest}
     * @memberof OpsApiUpdateLKSS
     */
    readonly opspbUpdateLKSSRequest: OpspbUpdateLKSSRequest
}

/**
 * Request parameters for updateTheBraderyBrandEmail operation in OpsApi.
 * @export
 * @interface OpsApiUpdateTheBraderyBrandEmailRequest
 */
export interface OpsApiUpdateTheBraderyBrandEmailRequest {
    /**
     * Shopify product tag of the brand
     * @type {string}
     * @memberof OpsApiUpdateTheBraderyBrandEmail
     */
    readonly tag: string

    /**
     * 
     * @type {OpspbUpdateTheBraderyBrandEmailRequest}
     * @memberof OpsApiUpdateTheBraderyBrandEmail
     */
    readonly opspbUpdateTheBraderyBrandEmailRequest: OpspbUpdateTheBraderyBrandEmailRequest
}

/**
 * OpsApi - object-oriented interface
 * @export
 * @class OpsApi
 * @extends {BaseAPI}
 */
export class OpsApi extends BaseAPI {
    /**
     * Routes another Shopify product tag to a The Bradery brand\'s warehouse, so a new sale of the brand under another  tag keeps its warehouse and dashboard login
     * @param {OpsApiAddTheBraderyBrandTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public addTheBraderyBrandTag(requestParameters: OpsApiAddTheBraderyBrandTagRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).addTheBraderyBrandTag(requestParameters.tag, requestParameters.opspbAddTheBraderyBrandTagRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpsApiCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public cancel(requestParameters: OpsApiCancelRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).cancel(requestParameters.opspbCancelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a The Bradery brand: stores its warehouse, routes its tag to it in every store of the group that does not  route it yet, announces it in Slack and gives the reviewer with the warehouse\'s email access to it
     * @param {OpsApiCreateTheBraderyBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public createTheBraderyBrand(requestParameters: OpsApiCreateTheBraderyBrandRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).createTheBraderyBrand(requestParameters.opspbCreateTheBraderyBrandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists The Bradery\'s brands: each Shopify product tag its stores route to a brand\'s warehouse, with that warehouse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public listTheBraderyBrands(options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).listTheBraderyBrands(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpsApiLogisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public logistics(requestParameters: OpsApiLogisticsRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).logistics(requestParameters.opspbLogisticsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a return process as refunded externally (manual refund)
     * @param {OpsApiMarkAsRefundedExternallyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public markAsRefundedExternally(requestParameters: OpsApiMarkAsRefundedExternallyRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).markAsRefundedExternally(requestParameters.opspbMarkAsRefundedExternallyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpsApiRedirectToContactFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public redirectToContactForm(requestParameters: OpsApiRedirectToContactFormRequest = {}, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).redirectToContactForm(requestParameters.processId, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stops routing a Shopify product tag to its The Bradery brand\'s warehouse; returns of its products then go where  those of products without a brand go. A brand\'s last tag cannot be removed
     * @param {OpsApiRemoveTheBraderyBrandTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public removeTheBraderyBrandTag(requestParameters: OpsApiRemoveTheBraderyBrandTagRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).removeTheBraderyBrandTag(requestParameters.tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpsApiRestockItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public restockItems(requestParameters: OpsApiRestockItemsRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).restockItems(requestParameters.opspbRestockItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ReviewItemByOrderSKU reviews a specific return line item identified by order ID and SKU. It  resolves the matching process and line item, then submits a complete review where the matched  item receives the provided status and all remaining product line items receive MISSING status.  This supports partial review scenarios (e.g. Inditex CSV rows) where only some items are  explicitly reviewed and the rest are considered genuinely missing. Returns processed=false when  no matching line item is found (graceful skip, not an error).
     * @param {OpsApiReviewItemByOrderSKURequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public reviewItemByOrderSKU(requestParameters: OpsApiReviewItemByOrderSKURequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).reviewItemByOrderSKU(requestParameters.opspbReviewItemByOrderSKURequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tells REVER the outcome of the warehouse review of a return, identifying each item by its  REVER line item id. `POST /v1/ops/ecommerce/review` also accepts platform line item ids and SKUs.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds. Its amount is in major units (\"12.50\").   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued. A process can be reviewed once:  a second request returns 400.
     * @summary Review a return process by REVER line item id
     * @param {OpsApiReviewItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public reviewItems(requestParameters: OpsApiReviewItemsRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).reviewItems(requestParameters.opspbReviewItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tells REVER the outcome of the warehouse review of a return. The outcome decides the refund,  the restock and the emails the customer receives.   - Send one review per returned unit. An item returned with quantity 2 needs two entries in `reviews`.  - Review every returned unit in the same request. A request that leaves units out is rejected,  unless the store is set up to mark unreviewed units as `MISSING`.  - Use `MISSING` for a unit that was expected but not received.  - Use `refund_override` only to change the amount REVER refunds.   REVER validates the request before answering and processes it asynchronously: a 200 means the  reviews were accepted, not that the refund has been issued.   For a process that is already reviewed, REVER compares how many reviews each item has per status.  If they match, it returns 200 and changes nothing, otherwise 409. Other fields, such as  `reject_reason` or `should_restock`, are not compared. When REVER added `MISSING` reviews for  units the request left out, a retry has to include them.
     * @summary Review a return process
     * @param {OpsApiReviewItemsGenericRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public reviewItemsGeneric(requestParameters: OpsApiReviewItemsGenericRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).reviewItemsGeneric(requestParameters.opspbReviewItemsGenericRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpsApiSubmitAuthorizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public submitAuthorization(requestParameters: OpsApiSubmitAuthorizationRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).submitAuthorization(requestParameters.opspbSubmitAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * TransitionLKSS sets the last-known shipping status only when the move from  the current status is a valid transition (see the shipping-status state  machine). An invalid transition is a no-op, not an error: the response  reports the previous and current status and whether a change was applied.  It errors only on bad parameters or a database/persistence failure.
     * @param {OpsApiTransitionLKSSRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public transitionLKSS(requestParameters: OpsApiTransitionLKSSRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).transitionLKSS(requestParameters.opspbTransitionLKSSRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateLKSS sets the last-known shipping status unconditionally. It does NOT  validate the transition: any status is written as requested. Prefer  TransitionLKSS when the change must respect the shipping-status state machine.
     * @param {OpsApiUpdateLKSSRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public updateLKSS(requestParameters: OpsApiUpdateLKSSRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).updateLKSS(requestParameters.opspbUpdateLKSSRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Changes the email of a The Bradery brand\'s warehouses and makes it the brand\'s dashboard login
     * @param {OpsApiUpdateTheBraderyBrandEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpsApi
     */
    public updateTheBraderyBrandEmail(requestParameters: OpsApiUpdateTheBraderyBrandEmailRequest, options?: RawAxiosRequestConfig) {
        return OpsApiFp(this.configuration).updateTheBraderyBrandEmail(requestParameters.tag, requestParameters.opspbUpdateTheBraderyBrandEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessesApi - axios parameter creator
 * @export
 */
export const ProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds an adjustment transaction to a given process
         * @param {string} processId The ID of the return process to add the adjustment to.
         * @param {PbAddAdjustmentRequest} pbAddAdjustmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdjustment: async (processId: string, pbAddAdjustmentRequest: PbAddAdjustmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addAdjustment', 'processId', processId)
            // verify required parameter 'pbAddAdjustmentRequest' is not null or undefined
            assertParamExists('addAdjustment', 'pbAddAdjustmentRequest', pbAddAdjustmentRequest)
            const localVarPath = `/v1/processes/{process_id}/adjustment`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAddAdjustmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a comment to a given process
         * @param {string} processId Process ID to associate the comment. Required.
         * @param {PbAddCommentRequest} pbAddCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: async (processId: string, pbAddCommentRequest: PbAddCommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addComment', 'processId', processId)
            // verify required parameter 'pbAddCommentRequest' is not null or undefined
            assertParamExists('addComment', 'pbAddCommentRequest', pbAddCommentRequest)
            const localVarPath = `/v1/processes/{process_id}/comment`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAddCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a review (approve/decline/missing) to a given process
         * @param {string} processId ID of the process in where the review is being added. Required.
         * @param {PbAddReviewRequest} pbAddReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReview: async (processId: string, pbAddReviewRequest: PbAddReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addReview', 'processId', processId)
            // verify required parameter 'pbAddReviewRequest' is not null or undefined
            assertParamExists('addReview', 'pbAddReviewRequest', pbAddReviewRequest)
            const localVarPath = `/v1/processes/{process_id}/review`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAddReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds transactions to a given process that belongs to an e-commerce of  the authenticated user\'s group
         * @param {string} processId Process ID to associate the transactions. Required.
         * @param {PbAddTransactionsRequest} pbAddTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransactions: async (processId: string, pbAddTransactionsRequest: PbAddTransactionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addTransactions', 'processId', processId)
            // verify required parameter 'pbAddTransactionsRequest' is not null or undefined
            assertParamExists('addTransactions', 'pbAddTransactionsRequest', pbAddTransactionsRequest)
            const localVarPath = `/v1/processes/{process_id}/transactions`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAddTransactionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approves all the pending items being returned in a given process
         * @param {string} processId ID of the process withe the return items to be approved. Required.
         * @param {PbApproveAllRequest} pbApproveAllRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAll: async (processId: string, pbApproveAllRequest: PbApproveAllRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('approveAll', 'processId', processId)
            // verify required parameter 'pbApproveAllRequest' is not null or undefined
            assertParamExists('approveAll', 'pbApproveAllRequest', pbApproveAllRequest)
            const localVarPath = `/v1/processes/{process_id}/approve_all`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbApproveAllRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ChangeCompensationMethod changes the compensation method for a process
         * @param {string} processId 
         * @param {PbChangeCompensationMethodRequest} pbChangeCompensationMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCompensationMethod: async (processId: string, pbChangeCompensationMethodRequest: PbChangeCompensationMethodRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('changeCompensationMethod', 'processId', processId)
            // verify required parameter 'pbChangeCompensationMethodRequest' is not null or undefined
            assertParamExists('changeCompensationMethod', 'pbChangeCompensationMethodRequest', pbChangeCompensationMethodRequest)
            const localVarPath = `/v1/public/processes/{process_id}/change_compensation_method`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbChangeCompensationMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ChangeToBankTransfer changes the compensation to bank transfer
         * @param {string} processId 
         * @param {string} [email] 
         * @param {string} [iban] 
         * @param {string} [bban] 
         * @param {string} [swift] 
         * @param {string} [bankAccountCountry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeToBankTransfer: async (processId: string, email?: string, iban?: string, bban?: string, swift?: string, bankAccountCountry?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('changeToBankTransfer', 'processId', processId)
            const localVarPath = `/v1/public/processes/{process_id}/change_to_bank_transfer`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (iban !== undefined) {
                localVarQueryParameter['iban'] = iban;
            }

            if (bban !== undefined) {
                localVarQueryParameter['bban'] = bban;
            }

            if (swift !== undefined) {
                localVarQueryParameter['swift'] = swift;
            }

            if (bankAccountCountry !== undefined) {
                localVarQueryParameter['bank_account_country'] = bankAccountCountry;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates presigned URLs to upload the documents attached to an incident reported on a return  process (e.g. the commercial invoice and photos of a damaged package), and to download them  afterwards. The caller PUTs each file to its upload_url with the declared content type.
         * @param {string} processId id of the return process the incident is reported on
         * @param {PbCreateIncidentDocumentUploadsRequest} pbCreateIncidentDocumentUploadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentDocumentUploads: async (processId: string, pbCreateIncidentDocumentUploadsRequest: PbCreateIncidentDocumentUploadsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createIncidentDocumentUploads', 'processId', processId)
            // verify required parameter 'pbCreateIncidentDocumentUploadsRequest' is not null or undefined
            assertParamExists('createIncidentDocumentUploads', 'pbCreateIncidentDocumentUploadsRequest', pbCreateIncidentDocumentUploadsRequest)
            const localVarPath = `/v1/processes/{process_id}/incident_documents`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCreateIncidentDocumentUploadsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download return processes info for a given filter set
         * @param {PbExportReturnProcessesRequest} pbExportReturnProcessesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportReturnProcesses: async (pbExportReturnProcessesRequest: PbExportReturnProcessesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbExportReturnProcessesRequest' is not null or undefined
            assertParamExists('exportReturnProcesses', 'pbExportReturnProcessesRequest', pbExportReturnProcessesRequest)
            const localVarPath = `/v1/processes/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbExportReturnProcessesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ExportReturnProcessesCsv downloads return processes as CSV using the same  filters as the FindProcesses listing endpoint. Supersedes ExportReturnProcesses.
         * @param {PbExportReturnProcessesCsvRequest} pbExportReturnProcessesCsvRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportReturnProcessesCsv: async (pbExportReturnProcessesCsvRequest: PbExportReturnProcessesCsvRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbExportReturnProcessesCsvRequest' is not null or undefined
            assertParamExists('exportReturnProcessesCsv', 'pbExportReturnProcessesCsvRequest', pbExportReturnProcessesCsvRequest)
            const localVarPath = `/v1/processes/export-csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbExportReturnProcessesCsvRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindLineItemReturnReasons returns the distinct return reasons of the  caller\'s returned products (scoped by group/warehouse), to populate the  reason filter dropdown of the items listing.
         * @param {PbFindLineItemReturnReasonsRequest} pbFindLineItemReturnReasonsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLineItemReturnReasons: async (pbFindLineItemReturnReasonsRequest: PbFindLineItemReturnReasonsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbFindLineItemReturnReasonsRequest' is not null or undefined
            assertParamExists('findLineItemReturnReasons', 'pbFindLineItemReturnReasonsRequest', pbFindLineItemReturnReasonsRequest)
            const localVarPath = `/v1/processes/line_items/return_reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbFindLineItemReturnReasonsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindProcessCarriers returns the distinct carriers present in the caller\'s  processes (scoped by group/warehouse), to populate the carrier filter  dropdown of the listing.
         * @param {PbFindProcessCarriersRequest} pbFindProcessCarriersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessCarriers: async (pbFindProcessCarriersRequest: PbFindProcessCarriersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbFindProcessCarriersRequest' is not null or undefined
            assertParamExists('findProcessCarriers', 'pbFindProcessCarriersRequest', pbFindProcessCarriersRequest)
            const localVarPath = `/v1/processes/carriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbFindProcessCarriersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindProcessCountries returns the distinct origin countries present in the  caller\'s processes (scoped by group/warehouse), to populate the country  filter dropdown of the listing.
         * @param {PbFindProcessCountriesRequest} pbFindProcessCountriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessCountries: async (pbFindProcessCountriesRequest: PbFindProcessCountriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbFindProcessCountriesRequest' is not null or undefined
            assertParamExists('findProcessCountries', 'pbFindProcessCountriesRequest', pbFindProcessCountriesRequest)
            const localVarPath = `/v1/processes/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbFindProcessCountriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindProcessWarehouses returns the warehouses the caller is allowed to see  (a reviewer is limited to its assigned warehouses; anyone else sees all in  the group), to populate the warehouse filter dropdown of the listing.
         * @param {PbFindProcessWarehousesRequest} pbFindProcessWarehousesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessWarehouses: async (pbFindProcessWarehousesRequest: PbFindProcessWarehousesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbFindProcessWarehousesRequest' is not null or undefined
            assertParamExists('findProcessWarehouses', 'pbFindProcessWarehousesRequest', pbFindProcessWarehousesRequest)
            const localVarPath = `/v1/processes/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbFindProcessWarehousesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindProcesses retrieves return processes by several filters, freetext  search and pagination. gRPC equivalent of the legacy GET /v1/processes/find.
         * @param {PbFindProcessesRequest} pbFindProcessesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcesses: async (pbFindProcessesRequest: PbFindProcessesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbFindProcessesRequest' is not null or undefined
            assertParamExists('findProcesses', 'pbFindProcessesRequest', pbFindProcessesRequest)
            const localVarPath = `/v1/processes/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbFindProcessesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated: use GetReturnSummary instead
         * @param {string} processId ID of the process to be recovered. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('get', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/full`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetAuthorizationStatus returns the authorization status and details of a process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationStatus: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getAuthorizationStatus', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/authorization_status`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Says what canceling this return will do to its exchange order, for the cancel dialog.  Read-only.
         * @param {string} processId Return process id. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelExchangePreview: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCancelExchangePreview', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/cancel-exchange-preview`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetHelpDeskProcessesByEmailAndEcommerceGroup finds processes per email
         * @param {string} email 
         * @param {string} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHelpDeskProcessesByEmailAndEcommerceGroup: async (email: string, group: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getHelpDeskProcessesByEmailAndEcommerceGroup', 'email', email)
            // verify required parameter 'group' is not null or undefined
            assertParamExists('getHelpDeskProcessesByEmailAndEcommerceGroup', 'group', group)
            const localVarPath = `/v1/processes/helpdesk/find/{email}/{group}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)))
                .replace(`{${"group"}}`, encodeURIComponent(String(group)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Logistic Summaries
         * @param {string} [groupId] 
         * @param {number} [page] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticSummaries: async (groupId?: string, page?: number, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/processes/logistics/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the logistic info of a Return Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticsSummary: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getLogisticsSummary', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/logistics`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all the documents uploaded for a given return process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnDocuments: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getReturnDocuments', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/documents`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Return Summaries
         * @param {string} [groupId] 
         * @param {number} [page] 
         * @param {number} [days] 
         * @param {string} [orderId] 
         * @param {string} [warehouseId] 
         * @param {string} [startedBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnSummaries: async (groupId?: string, page?: number, days?: number, orderId?: string, warehouseId?: string, startedBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/processes/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['order_id'] = orderId;
            }

            if (warehouseId !== undefined) {
                localVarQueryParameter['warehouse_id'] = warehouseId;
            }

            if (startedBefore !== undefined) {
                localVarQueryParameter['started_before'] = (startedBefore as any instanceof Date) ?
                    (startedBefore as any).toISOString() :
                    startedBefore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Return Summary
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnSummary: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getReturnSummary', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Return Summary by platform ID, used for public access
         * @param {string} platformProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnSummaryByPlatform: async (platformProcessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformProcessId' is not null or undefined
            assertParamExists('getReturnSummaryByPlatform', 'platformProcessId', platformProcessId)
            const localVarPath = `/v1/processes/ecommerce/{platform_process_id}`
                .replace(`{${"platform_process_id"}}`, encodeURIComponent(String(platformProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the reviews associated to a Return Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getReviews', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/reviews`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetTransactions returns all transactions for a given process
         * @param {string} processId The ID of the return process to get transactions for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactions: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getTransactions', 'processId', processId)
            const localVarPath = `/v1/processes/{process_id}/transactions`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetWfpClaimByReturnProcessID returns the (at most one) wfp_claim linked to a  return process. Public, authenticated variant used by the dashboard  return-process detail page to show claim status; enforces caller-group  ownership of the return process. Read-only and idempotent. Returns NotFound  when the process has no claim or the caller is not in its group.
         * @param {PbGetWfpClaimByReturnProcessIDRequest} pbGetWfpClaimByReturnProcessIDRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWfpClaimByReturnProcessID: async (pbGetWfpClaimByReturnProcessIDRequest: PbGetWfpClaimByReturnProcessIDRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbGetWfpClaimByReturnProcessIDRequest' is not null or undefined
            assertParamExists('getWfpClaimByReturnProcessID', 'pbGetWfpClaimByReturnProcessIDRequest', pbGetWfpClaimByReturnProcessIDRequest)
            const localVarPath = `/v1/processes/wfp/claims/get-by-return-process-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbGetWfpClaimByReturnProcessIDRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ListWithdrawalRequests returns an e-commerce\'s withdrawal requests, newest first.
         * @param {string} [ecommerceId] E-commerce whose requests to list. Required.
         * @param {number} [offset] Number of requests to skip
         * @param {number} [limit] Maximum number of requests to return: 20 by default, 100 at most
         * @param {Array<ListWithdrawalRequestsStatusesEnum>} [statuses] Only requests in one of these statuses. All of them when empty
         * @param {string} [receivedFrom] Only requests received at or after this time
         * @param {string} [receivedTo] Only requests received at or before this time
         * @param {string} [search] Only requests whose customer name, email or order number contains this text, ignoring case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWithdrawalRequests: async (ecommerceId?: string, offset?: number, limit?: number, statuses?: Array<ListWithdrawalRequestsStatusesEnum>, receivedFrom?: string, receivedTo?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/processes/withdrawal_requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (receivedFrom !== undefined) {
                localVarQueryParameter['received_from'] = (receivedFrom as any instanceof Date) ?
                    (receivedFrom as any).toISOString() :
                    receivedFrom;
            }

            if (receivedTo !== undefined) {
                localVarQueryParameter['received_to'] = (receivedTo as any instanceof Date) ?
                    (receivedTo as any).toISOString() :
                    receivedTo;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a return process via a PATCH (updating only certain fields)  To update \'last_known_shipping_status\' with side effects on the process, call ops-api
         * @param {string} processId ID of the process to be updated. Required.
         * @param {PbPatchReturnProcessRequest} pbPatchReturnProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReturnProcess: async (processId: string, pbPatchReturnProcessRequest: PbPatchReturnProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('patchReturnProcess', 'processId', processId)
            // verify required parameter 'pbPatchReturnProcessRequest' is not null or undefined
            assertParamExists('patchReturnProcess', 'pbPatchReturnProcessRequest', pbPatchReturnProcessRequest)
            const localVarPath = `/v1/processes/{process_id}/patch`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbPatchReturnProcessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RateLimitTest request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateLimitTest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/processes/RateLimitTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send customer an email requesting to upload more photos
         * @param {string} processId Process ID.
         * @param {PbRequestCustomerUploadPhotosRequest} pbRequestCustomerUploadPhotosRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomerUploadPhotos: async (processId: string, pbRequestCustomerUploadPhotosRequest: PbRequestCustomerUploadPhotosRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('requestCustomerUploadPhotos', 'processId', processId)
            // verify required parameter 'pbRequestCustomerUploadPhotosRequest' is not null or undefined
            assertParamExists('requestCustomerUploadPhotos', 'pbRequestCustomerUploadPhotosRequest', pbRequestCustomerUploadPhotosRequest)
            const localVarPath = `/v1/processes/{process_id}/request_photos`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbRequestCustomerUploadPhotosRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the store address for a return process (IN_STORE internal logistics)
         * @param {string} processId ID of the return process to update. Required.
         * @param {PbSetStoreAddressRequest} pbSetStoreAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStoreAddress: async (processId: string, pbSetStoreAddressRequest: PbSetStoreAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('setStoreAddress', 'processId', processId)
            // verify required parameter 'pbSetStoreAddressRequest' is not null or undefined
            assertParamExists('setStoreAddress', 'pbSetStoreAddressRequest', pbSetStoreAddressRequest)
            const localVarPath = `/v1/processes/{process_id}/store_address`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSetStoreAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SetWithdrawalRequestClosed marks a withdrawal request as handled by the merchant, or  reopens it. The request itself and when it was received never change.
         * @param {string} id ID of the withdrawal request. Required.
         * @param {PbSetWithdrawalRequestClosedRequest} pbSetWithdrawalRequestClosedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWithdrawalRequestClosed: async (id: string, pbSetWithdrawalRequestClosedRequest: PbSetWithdrawalRequestClosedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setWithdrawalRequestClosed', 'id', id)
            // verify required parameter 'pbSetWithdrawalRequestClosedRequest' is not null or undefined
            assertParamExists('setWithdrawalRequestClosed', 'pbSetWithdrawalRequestClosedRequest', pbSetWithdrawalRequestClosedRequest)
            const localVarPath = `/v1/processes/withdrawal_requests/{id}/closed`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSetWithdrawalRequestClosedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the logistics fields associated to a given return process
         * @param {string} processId The process ID to update. Required.
         * @param {PbUpdateLogisticsRequest} pbUpdateLogisticsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogistics: async (processId: string, pbUpdateLogisticsRequest: PbUpdateLogisticsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateLogistics', 'processId', processId)
            // verify required parameter 'pbUpdateLogisticsRequest' is not null or undefined
            assertParamExists('updateLogistics', 'pbUpdateLogisticsRequest', pbUpdateLogisticsRequest)
            const localVarPath = `/v1/processes/{process_id}/logistics`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUpdateLogisticsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the status associated to the main workflow  of a given return process
         * @param {string} processId The process ID to update. Required.
         * @param {PbUpdateWorkflowStatusRequest} pbUpdateWorkflowStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkflowStatus: async (processId: string, pbUpdateWorkflowStatusRequest: PbUpdateWorkflowStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateWorkflowStatus', 'processId', processId)
            // verify required parameter 'pbUpdateWorkflowStatusRequest' is not null or undefined
            assertParamExists('updateWorkflowStatus', 'pbUpdateWorkflowStatusRequest', pbUpdateWorkflowStatusRequest)
            const localVarPath = `/v1/processes/{process_id}/worfklow_status`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUpdateWorkflowStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads documents associated to a return process which consists in  photo + text. The documents are stored in S3 and the URL is saved in  the database
         * @param {string} processId 
         * @param {PbUploadReturnDocumentsRequest} pbUploadReturnDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadReturnDocuments: async (processId: string, pbUploadReturnDocumentsRequest: PbUploadReturnDocumentsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('uploadReturnDocuments', 'processId', processId)
            // verify required parameter 'pbUploadReturnDocumentsRequest' is not null or undefined
            assertParamExists('uploadReturnDocuments', 'pbUploadReturnDocumentsRequest', pbUploadReturnDocumentsRequest)
            const localVarPath = `/v1/public/processes/{process_id}/documents`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUploadReturnDocumentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates if the review request is valid
         * @param {string} processId process ID to validate
         * @param {PbValidateReviewRequest} pbValidateReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateReview: async (processId: string, pbValidateReviewRequest: PbValidateReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('validateReview', 'processId', processId)
            // verify required parameter 'pbValidateReviewRequest' is not null or undefined
            assertParamExists('validateReview', 'pbValidateReviewRequest', pbValidateReviewRequest)
            const localVarPath = `/v1/processes/{process_id}/review`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbValidateReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessesApi - functional programming interface
 * @export
 */
export const ProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds an adjustment transaction to a given process
         * @param {string} processId The ID of the return process to add the adjustment to.
         * @param {PbAddAdjustmentRequest} pbAddAdjustmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdjustment(processId: string, pbAddAdjustmentRequest: PbAddAdjustmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdjustment(processId, pbAddAdjustmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.addAdjustment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a comment to a given process
         * @param {string} processId Process ID to associate the comment. Required.
         * @param {PbAddCommentRequest} pbAddCommentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComment(processId: string, pbAddCommentRequest: PbAddCommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComment(processId, pbAddCommentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.addComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a review (approve/decline/missing) to a given process
         * @param {string} processId ID of the process in where the review is being added. Required.
         * @param {PbAddReviewRequest} pbAddReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addReview(processId: string, pbAddReviewRequest: PbAddReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addReview(processId, pbAddReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.addReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds transactions to a given process that belongs to an e-commerce of  the authenticated user\'s group
         * @param {string} processId Process ID to associate the transactions. Required.
         * @param {PbAddTransactionsRequest} pbAddTransactionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTransactions(processId: string, pbAddTransactionsRequest: PbAddTransactionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbAddTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTransactions(processId, pbAddTransactionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.addTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approves all the pending items being returned in a given process
         * @param {string} processId ID of the process withe the return items to be approved. Required.
         * @param {PbApproveAllRequest} pbApproveAllRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAll(processId: string, pbApproveAllRequest: PbApproveAllRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAll(processId, pbApproveAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.approveAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ChangeCompensationMethod changes the compensation method for a process
         * @param {string} processId 
         * @param {PbChangeCompensationMethodRequest} pbChangeCompensationMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCompensationMethod(processId: string, pbChangeCompensationMethodRequest: PbChangeCompensationMethodRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCompensationMethod(processId, pbChangeCompensationMethodRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.changeCompensationMethod']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ChangeToBankTransfer changes the compensation to bank transfer
         * @param {string} processId 
         * @param {string} [email] 
         * @param {string} [iban] 
         * @param {string} [bban] 
         * @param {string} [swift] 
         * @param {string} [bankAccountCountry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeToBankTransfer(processId: string, email?: string, iban?: string, bban?: string, swift?: string, bankAccountCountry?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeToBankTransfer(processId, email, iban, bban, swift, bankAccountCountry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.changeToBankTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates presigned URLs to upload the documents attached to an incident reported on a return  process (e.g. the commercial invoice and photos of a damaged package), and to download them  afterwards. The caller PUTs each file to its upload_url with the declared content type.
         * @param {string} processId id of the return process the incident is reported on
         * @param {PbCreateIncidentDocumentUploadsRequest} pbCreateIncidentDocumentUploadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIncidentDocumentUploads(processId: string, pbCreateIncidentDocumentUploadsRequest: PbCreateIncidentDocumentUploadsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCreateIncidentDocumentUploadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIncidentDocumentUploads(processId, pbCreateIncidentDocumentUploadsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.createIncidentDocumentUploads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download return processes info for a given filter set
         * @param {PbExportReturnProcessesRequest} pbExportReturnProcessesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportReturnProcesses(pbExportReturnProcessesRequest: PbExportReturnProcessesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbExportReturnProcessesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportReturnProcesses(pbExportReturnProcessesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.exportReturnProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ExportReturnProcessesCsv downloads return processes as CSV using the same  filters as the FindProcesses listing endpoint. Supersedes ExportReturnProcesses.
         * @param {PbExportReturnProcessesCsvRequest} pbExportReturnProcessesCsvRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportReturnProcessesCsv(pbExportReturnProcessesCsvRequest: PbExportReturnProcessesCsvRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbExportReturnProcessesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportReturnProcessesCsv(pbExportReturnProcessesCsvRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.exportReturnProcessesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindLineItemReturnReasons returns the distinct return reasons of the  caller\'s returned products (scoped by group/warehouse), to populate the  reason filter dropdown of the items listing.
         * @param {PbFindLineItemReturnReasonsRequest} pbFindLineItemReturnReasonsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLineItemReturnReasons(pbFindLineItemReturnReasonsRequest: PbFindLineItemReturnReasonsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindLineItemReturnReasonsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLineItemReturnReasons(pbFindLineItemReturnReasonsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findLineItemReturnReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindProcessCarriers returns the distinct carriers present in the caller\'s  processes (scoped by group/warehouse), to populate the carrier filter  dropdown of the listing.
         * @param {PbFindProcessCarriersRequest} pbFindProcessCarriersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProcessCarriers(pbFindProcessCarriersRequest: PbFindProcessCarriersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindProcessCarriersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProcessCarriers(pbFindProcessCarriersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findProcessCarriers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindProcessCountries returns the distinct origin countries present in the  caller\'s processes (scoped by group/warehouse), to populate the country  filter dropdown of the listing.
         * @param {PbFindProcessCountriesRequest} pbFindProcessCountriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProcessCountries(pbFindProcessCountriesRequest: PbFindProcessCountriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindProcessCountriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProcessCountries(pbFindProcessCountriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findProcessCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindProcessWarehouses returns the warehouses the caller is allowed to see  (a reviewer is limited to its assigned warehouses; anyone else sees all in  the group), to populate the warehouse filter dropdown of the listing.
         * @param {PbFindProcessWarehousesRequest} pbFindProcessWarehousesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProcessWarehouses(pbFindProcessWarehousesRequest: PbFindProcessWarehousesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindProcessWarehousesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProcessWarehouses(pbFindProcessWarehousesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findProcessWarehouses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindProcesses retrieves return processes by several filters, freetext  search and pagination. gRPC equivalent of the legacy GET /v1/processes/find.
         * @param {PbFindProcessesRequest} pbFindProcessesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findProcesses(pbFindProcessesRequest: PbFindProcessesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindProcessesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findProcesses(pbFindProcessesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.findProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated: use GetReturnSummary instead
         * @param {string} processId ID of the process to be recovered. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetAuthorizationStatus returns the authorization status and details of a process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizationStatus(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetAuthorizationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizationStatus(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getAuthorizationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Says what canceling this return will do to its exchange order, for the cancel dialog.  Read-only.
         * @param {string} processId Return process id. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCancelExchangePreview(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetCancelExchangePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCancelExchangePreview(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getCancelExchangePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetHelpDeskProcessesByEmailAndEcommerceGroup finds processes per email
         * @param {string} email 
         * @param {string} group 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHelpDeskProcessesByEmailAndEcommerceGroup(email: string, group: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindProcessesByEmailAndEcommerceGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHelpDeskProcessesByEmailAndEcommerceGroup(email, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getHelpDeskProcessesByEmailAndEcommerceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Logistic Summaries
         * @param {string} [groupId] 
         * @param {number} [page] 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogisticSummaries(groupId?: string, page?: number, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetLogisticSummariesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogisticSummaries(groupId, page, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getLogisticSummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the logistic info of a Return Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogisticsSummary(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetLogisticsSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogisticsSummary(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getLogisticsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all the documents uploaded for a given return process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnDocuments(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnDocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnDocuments(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getReturnDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Return Summaries
         * @param {string} [groupId] 
         * @param {number} [page] 
         * @param {number} [days] 
         * @param {string} [orderId] 
         * @param {string} [warehouseId] 
         * @param {string} [startedBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnSummaries(groupId?: string, page?: number, days?: number, orderId?: string, warehouseId?: string, startedBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnSummariesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnSummaries(groupId, page, days, orderId, warehouseId, startedBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getReturnSummaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Return Summary
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnSummary(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnSummary(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getReturnSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Return Summary by platform ID, used for public access
         * @param {string} platformProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnSummaryByPlatform(platformProcessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnSummaryByPlatform(platformProcessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getReturnSummaryByPlatform']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the reviews associated to a Return Process
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviews(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviews(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetTransactions returns all transactions for a given process
         * @param {string} processId The ID of the return process to get transactions for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactions(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactions(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetWfpClaimByReturnProcessID returns the (at most one) wfp_claim linked to a  return process. Public, authenticated variant used by the dashboard  return-process detail page to show claim status; enforces caller-group  ownership of the return process. Read-only and idempotent. Returns NotFound  when the process has no claim or the caller is not in its group.
         * @param {PbGetWfpClaimByReturnProcessIDRequest} pbGetWfpClaimByReturnProcessIDRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWfpClaimByReturnProcessID(pbGetWfpClaimByReturnProcessIDRequest: PbGetWfpClaimByReturnProcessIDRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetWfpClaimByReturnProcessIDResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWfpClaimByReturnProcessID(pbGetWfpClaimByReturnProcessIDRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.getWfpClaimByReturnProcessID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ListWithdrawalRequests returns an e-commerce\'s withdrawal requests, newest first.
         * @param {string} [ecommerceId] E-commerce whose requests to list. Required.
         * @param {number} [offset] Number of requests to skip
         * @param {number} [limit] Maximum number of requests to return: 20 by default, 100 at most
         * @param {Array<ListWithdrawalRequestsStatusesEnum>} [statuses] Only requests in one of these statuses. All of them when empty
         * @param {string} [receivedFrom] Only requests received at or after this time
         * @param {string} [receivedTo] Only requests received at or before this time
         * @param {string} [search] Only requests whose customer name, email or order number contains this text, ignoring case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWithdrawalRequests(ecommerceId?: string, offset?: number, limit?: number, statuses?: Array<ListWithdrawalRequestsStatusesEnum>, receivedFrom?: string, receivedTo?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListWithdrawalRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWithdrawalRequests(ecommerceId, offset, limit, statuses, receivedFrom, receivedTo, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.listWithdrawalRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a return process via a PATCH (updating only certain fields)  To update \'last_known_shipping_status\' with side effects on the process, call ops-api
         * @param {string} processId ID of the process to be updated. Required.
         * @param {PbPatchReturnProcessRequest} pbPatchReturnProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchReturnProcess(processId: string, pbPatchReturnProcessRequest: PbPatchReturnProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbPatchReturnProcessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchReturnProcess(processId, pbPatchReturnProcessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.patchReturnProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * RateLimitTest request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rateLimitTest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rateLimitTest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.rateLimitTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send customer an email requesting to upload more photos
         * @param {string} processId Process ID.
         * @param {PbRequestCustomerUploadPhotosRequest} pbRequestCustomerUploadPhotosRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestCustomerUploadPhotos(processId: string, pbRequestCustomerUploadPhotosRequest: PbRequestCustomerUploadPhotosRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestCustomerUploadPhotos(processId, pbRequestCustomerUploadPhotosRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.requestCustomerUploadPhotos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets the store address for a return process (IN_STORE internal logistics)
         * @param {string} processId ID of the return process to update. Required.
         * @param {PbSetStoreAddressRequest} pbSetStoreAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStoreAddress(processId: string, pbSetStoreAddressRequest: PbSetStoreAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStoreAddress(processId, pbSetStoreAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.setStoreAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SetWithdrawalRequestClosed marks a withdrawal request as handled by the merchant, or  reopens it. The request itself and when it was received never change.
         * @param {string} id ID of the withdrawal request. Required.
         * @param {PbSetWithdrawalRequestClosedRequest} pbSetWithdrawalRequestClosedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWithdrawalRequestClosed(id: string, pbSetWithdrawalRequestClosedRequest: PbSetWithdrawalRequestClosedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSetWithdrawalRequestClosedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWithdrawalRequestClosed(id, pbSetWithdrawalRequestClosedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.setWithdrawalRequestClosed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the logistics fields associated to a given return process
         * @param {string} processId The process ID to update. Required.
         * @param {PbUpdateLogisticsRequest} pbUpdateLogisticsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLogistics(processId: string, pbUpdateLogisticsRequest: PbUpdateLogisticsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLogistics(processId, pbUpdateLogisticsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.updateLogistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the status associated to the main workflow  of a given return process
         * @param {string} processId The process ID to update. Required.
         * @param {PbUpdateWorkflowStatusRequest} pbUpdateWorkflowStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkflowStatus(processId: string, pbUpdateWorkflowStatusRequest: PbUpdateWorkflowStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkflowStatus(processId, pbUpdateWorkflowStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.updateWorkflowStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads documents associated to a return process which consists in  photo + text. The documents are stored in S3 and the URL is saved in  the database
         * @param {string} processId 
         * @param {PbUploadReturnDocumentsRequest} pbUploadReturnDocumentsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadReturnDocuments(processId: string, pbUploadReturnDocumentsRequest: PbUploadReturnDocumentsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadReturnDocuments(processId, pbUploadReturnDocumentsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.uploadReturnDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates if the review request is valid
         * @param {string} processId process ID to validate
         * @param {PbValidateReviewRequest} pbValidateReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateReview(processId: string, pbValidateReviewRequest: PbValidateReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbValidateReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateReview(processId, pbValidateReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessesApi.validateReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessesApi - factory interface
 * @export
 */
export const ProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessesApiFp(configuration)
    return {
        /**
         * Adds an adjustment transaction to a given process
         * @param {ProcessesApiAddAdjustmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdjustment(requestParameters: ProcessesApiAddAdjustmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.addAdjustment(requestParameters.processId, requestParameters.pbAddAdjustmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a comment to a given process
         * @param {ProcessesApiAddCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(requestParameters: ProcessesApiAddCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.addComment(requestParameters.processId, requestParameters.pbAddCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a review (approve/decline/missing) to a given process
         * @param {ProcessesApiAddReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addReview(requestParameters: ProcessesApiAddReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.addReview(requestParameters.processId, requestParameters.pbAddReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds transactions to a given process that belongs to an e-commerce of  the authenticated user\'s group
         * @param {ProcessesApiAddTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTransactions(requestParameters: ProcessesApiAddTransactionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbAddTransactionsResponse> {
            return localVarFp.addTransactions(requestParameters.processId, requestParameters.pbAddTransactionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Approves all the pending items being returned in a given process
         * @param {ProcessesApiApproveAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAll(requestParameters: ProcessesApiApproveAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.approveAll(requestParameters.processId, requestParameters.pbApproveAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ChangeCompensationMethod changes the compensation method for a process
         * @param {ProcessesApiChangeCompensationMethodRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCompensationMethod(requestParameters: ProcessesApiChangeCompensationMethodRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.changeCompensationMethod(requestParameters.processId, requestParameters.pbChangeCompensationMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ChangeToBankTransfer changes the compensation to bank transfer
         * @param {ProcessesApiChangeToBankTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeToBankTransfer(requestParameters: ProcessesApiChangeToBankTransferRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.changeToBankTransfer(requestParameters.processId, requestParameters.email, requestParameters.iban, requestParameters.bban, requestParameters.swift, requestParameters.bankAccountCountry, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates presigned URLs to upload the documents attached to an incident reported on a return  process (e.g. the commercial invoice and photos of a damaged package), and to download them  afterwards. The caller PUTs each file to its upload_url with the declared content type.
         * @param {ProcessesApiCreateIncidentDocumentUploadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIncidentDocumentUploads(requestParameters: ProcessesApiCreateIncidentDocumentUploadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCreateIncidentDocumentUploadsResponse> {
            return localVarFp.createIncidentDocumentUploads(requestParameters.processId, requestParameters.pbCreateIncidentDocumentUploadsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download return processes info for a given filter set
         * @param {ProcessesApiExportReturnProcessesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportReturnProcesses(requestParameters: ProcessesApiExportReturnProcessesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbExportReturnProcessesResponse> {
            return localVarFp.exportReturnProcesses(requestParameters.pbExportReturnProcessesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ExportReturnProcessesCsv downloads return processes as CSV using the same  filters as the FindProcesses listing endpoint. Supersedes ExportReturnProcesses.
         * @param {ProcessesApiExportReturnProcessesCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportReturnProcessesCsv(requestParameters: ProcessesApiExportReturnProcessesCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbExportReturnProcessesResponse> {
            return localVarFp.exportReturnProcessesCsv(requestParameters.pbExportReturnProcessesCsvRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * FindLineItemReturnReasons returns the distinct return reasons of the  caller\'s returned products (scoped by group/warehouse), to populate the  reason filter dropdown of the items listing.
         * @param {ProcessesApiFindLineItemReturnReasonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLineItemReturnReasons(requestParameters: ProcessesApiFindLineItemReturnReasonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFindLineItemReturnReasonsResponse> {
            return localVarFp.findLineItemReturnReasons(requestParameters.pbFindLineItemReturnReasonsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * FindProcessCarriers returns the distinct carriers present in the caller\'s  processes (scoped by group/warehouse), to populate the carrier filter  dropdown of the listing.
         * @param {ProcessesApiFindProcessCarriersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessCarriers(requestParameters: ProcessesApiFindProcessCarriersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFindProcessCarriersResponse> {
            return localVarFp.findProcessCarriers(requestParameters.pbFindProcessCarriersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * FindProcessCountries returns the distinct origin countries present in the  caller\'s processes (scoped by group/warehouse), to populate the country  filter dropdown of the listing.
         * @param {ProcessesApiFindProcessCountriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessCountries(requestParameters: ProcessesApiFindProcessCountriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFindProcessCountriesResponse> {
            return localVarFp.findProcessCountries(requestParameters.pbFindProcessCountriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * FindProcessWarehouses returns the warehouses the caller is allowed to see  (a reviewer is limited to its assigned warehouses; anyone else sees all in  the group), to populate the warehouse filter dropdown of the listing.
         * @param {ProcessesApiFindProcessWarehousesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcessWarehouses(requestParameters: ProcessesApiFindProcessWarehousesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFindProcessWarehousesResponse> {
            return localVarFp.findProcessWarehouses(requestParameters.pbFindProcessWarehousesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * FindProcesses retrieves return processes by several filters, freetext  search and pagination. gRPC equivalent of the legacy GET /v1/processes/find.
         * @param {ProcessesApiFindProcessesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProcesses(requestParameters: ProcessesApiFindProcessesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFindProcessesResponse> {
            return localVarFp.findProcesses(requestParameters.pbFindProcessesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated: use GetReturnSummary instead
         * @param {ProcessesApiGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(requestParameters: ProcessesApiGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetResponse> {
            return localVarFp.get(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetAuthorizationStatus returns the authorization status and details of a process
         * @param {ProcessesApiGetAuthorizationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizationStatus(requestParameters: ProcessesApiGetAuthorizationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetAuthorizationStatusResponse> {
            return localVarFp.getAuthorizationStatus(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Says what canceling this return will do to its exchange order, for the cancel dialog.  Read-only.
         * @param {ProcessesApiGetCancelExchangePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCancelExchangePreview(requestParameters: ProcessesApiGetCancelExchangePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetCancelExchangePreviewResponse> {
            return localVarFp.getCancelExchangePreview(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetHelpDeskProcessesByEmailAndEcommerceGroup finds processes per email
         * @param {ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHelpDeskProcessesByEmailAndEcommerceGroup(requestParameters: ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFindProcessesByEmailAndEcommerceGroupResponse> {
            return localVarFp.getHelpDeskProcessesByEmailAndEcommerceGroup(requestParameters.email, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Logistic Summaries
         * @param {ProcessesApiGetLogisticSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticSummaries(requestParameters: ProcessesApiGetLogisticSummariesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGetLogisticSummariesResponse> {
            return localVarFp.getLogisticSummaries(requestParameters.groupId, requestParameters.page, requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the logistic info of a Return Process
         * @param {ProcessesApiGetLogisticsSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogisticsSummary(requestParameters: ProcessesApiGetLogisticsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetLogisticsSummaryResponse> {
            return localVarFp.getLogisticsSummary(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all the documents uploaded for a given return process
         * @param {ProcessesApiGetReturnDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnDocuments(requestParameters: ProcessesApiGetReturnDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnDocumentsResponse> {
            return localVarFp.getReturnDocuments(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Return Summaries
         * @param {ProcessesApiGetReturnSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnSummaries(requestParameters: ProcessesApiGetReturnSummariesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnSummariesResponse> {
            return localVarFp.getReturnSummaries(requestParameters.groupId, requestParameters.page, requestParameters.days, requestParameters.orderId, requestParameters.warehouseId, requestParameters.startedBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Return Summary
         * @param {ProcessesApiGetReturnSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnSummary(requestParameters: ProcessesApiGetReturnSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnSummaryResponse> {
            return localVarFp.getReturnSummary(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Return Summary by platform ID, used for public access
         * @param {ProcessesApiGetReturnSummaryByPlatformRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnSummaryByPlatform(requestParameters: ProcessesApiGetReturnSummaryByPlatformRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnSummaryResponse> {
            return localVarFp.getReturnSummaryByPlatform(requestParameters.platformProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the reviews associated to a Return Process
         * @param {ProcessesApiGetReviewsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews(requestParameters: ProcessesApiGetReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReviewsResponse> {
            return localVarFp.getReviews(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetTransactions returns all transactions for a given process
         * @param {ProcessesApiGetTransactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactions(requestParameters: ProcessesApiGetTransactionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetTransactionsResponse> {
            return localVarFp.getTransactions(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * GetWfpClaimByReturnProcessID returns the (at most one) wfp_claim linked to a  return process. Public, authenticated variant used by the dashboard  return-process detail page to show claim status; enforces caller-group  ownership of the return process. Read-only and idempotent. Returns NotFound  when the process has no claim or the caller is not in its group.
         * @param {ProcessesApiGetWfpClaimByReturnProcessIDRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWfpClaimByReturnProcessID(requestParameters: ProcessesApiGetWfpClaimByReturnProcessIDRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetWfpClaimByReturnProcessIDResponse> {
            return localVarFp.getWfpClaimByReturnProcessID(requestParameters.pbGetWfpClaimByReturnProcessIDRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ListWithdrawalRequests returns an e-commerce\'s withdrawal requests, newest first.
         * @param {ProcessesApiListWithdrawalRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWithdrawalRequests(requestParameters: ProcessesApiListWithdrawalRequestsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbListWithdrawalRequestsResponse> {
            return localVarFp.listWithdrawalRequests(requestParameters.ecommerceId, requestParameters.offset, requestParameters.limit, requestParameters.statuses, requestParameters.receivedFrom, requestParameters.receivedTo, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a return process via a PATCH (updating only certain fields)  To update \'last_known_shipping_status\' with side effects on the process, call ops-api
         * @param {ProcessesApiPatchReturnProcessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReturnProcess(requestParameters: ProcessesApiPatchReturnProcessRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbPatchReturnProcessResponse> {
            return localVarFp.patchReturnProcess(requestParameters.processId, requestParameters.pbPatchReturnProcessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * RateLimitTest request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateLimitTest(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.rateLimitTest(options).then((request) => request(axios, basePath));
        },
        /**
         * Send customer an email requesting to upload more photos
         * @param {ProcessesApiRequestCustomerUploadPhotosRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCustomerUploadPhotos(requestParameters: ProcessesApiRequestCustomerUploadPhotosRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.requestCustomerUploadPhotos(requestParameters.processId, requestParameters.pbRequestCustomerUploadPhotosRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the store address for a return process (IN_STORE internal logistics)
         * @param {ProcessesApiSetStoreAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStoreAddress(requestParameters: ProcessesApiSetStoreAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.setStoreAddress(requestParameters.processId, requestParameters.pbSetStoreAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SetWithdrawalRequestClosed marks a withdrawal request as handled by the merchant, or  reopens it. The request itself and when it was received never change.
         * @param {ProcessesApiSetWithdrawalRequestClosedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWithdrawalRequestClosed(requestParameters: ProcessesApiSetWithdrawalRequestClosedRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSetWithdrawalRequestClosedResponse> {
            return localVarFp.setWithdrawalRequestClosed(requestParameters.id, requestParameters.pbSetWithdrawalRequestClosedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the logistics fields associated to a given return process
         * @param {ProcessesApiUpdateLogisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogistics(requestParameters: ProcessesApiUpdateLogisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateLogistics(requestParameters.processId, requestParameters.pbUpdateLogisticsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the status associated to the main workflow  of a given return process
         * @param {ProcessesApiUpdateWorkflowStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkflowStatus(requestParameters: ProcessesApiUpdateWorkflowStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateWorkflowStatus(requestParameters.processId, requestParameters.pbUpdateWorkflowStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads documents associated to a return process which consists in  photo + text. The documents are stored in S3 and the URL is saved in  the database
         * @param {ProcessesApiUploadReturnDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadReturnDocuments(requestParameters: ProcessesApiUploadReturnDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.uploadReturnDocuments(requestParameters.processId, requestParameters.pbUploadReturnDocumentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates if the review request is valid
         * @param {ProcessesApiValidateReviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateReview(requestParameters: ProcessesApiValidateReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbValidateReviewResponse> {
            return localVarFp.validateReview(requestParameters.processId, requestParameters.pbValidateReviewRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addAdjustment operation in ProcessesApi.
 * @export
 * @interface ProcessesApiAddAdjustmentRequest
 */
export interface ProcessesApiAddAdjustmentRequest {
    /**
     * The ID of the return process to add the adjustment to.
     * @type {string}
     * @memberof ProcessesApiAddAdjustment
     */
    readonly processId: string

    /**
     * 
     * @type {PbAddAdjustmentRequest}
     * @memberof ProcessesApiAddAdjustment
     */
    readonly pbAddAdjustmentRequest: PbAddAdjustmentRequest
}

/**
 * Request parameters for addComment operation in ProcessesApi.
 * @export
 * @interface ProcessesApiAddCommentRequest
 */
export interface ProcessesApiAddCommentRequest {
    /**
     * Process ID to associate the comment. Required.
     * @type {string}
     * @memberof ProcessesApiAddComment
     */
    readonly processId: string

    /**
     * 
     * @type {PbAddCommentRequest}
     * @memberof ProcessesApiAddComment
     */
    readonly pbAddCommentRequest: PbAddCommentRequest
}

/**
 * Request parameters for addReview operation in ProcessesApi.
 * @export
 * @interface ProcessesApiAddReviewRequest
 */
export interface ProcessesApiAddReviewRequest {
    /**
     * ID of the process in where the review is being added. Required.
     * @type {string}
     * @memberof ProcessesApiAddReview
     */
    readonly processId: string

    /**
     * 
     * @type {PbAddReviewRequest}
     * @memberof ProcessesApiAddReview
     */
    readonly pbAddReviewRequest: PbAddReviewRequest
}

/**
 * Request parameters for addTransactions operation in ProcessesApi.
 * @export
 * @interface ProcessesApiAddTransactionsRequest
 */
export interface ProcessesApiAddTransactionsRequest {
    /**
     * Process ID to associate the transactions. Required.
     * @type {string}
     * @memberof ProcessesApiAddTransactions
     */
    readonly processId: string

    /**
     * 
     * @type {PbAddTransactionsRequest}
     * @memberof ProcessesApiAddTransactions
     */
    readonly pbAddTransactionsRequest: PbAddTransactionsRequest
}

/**
 * Request parameters for approveAll operation in ProcessesApi.
 * @export
 * @interface ProcessesApiApproveAllRequest
 */
export interface ProcessesApiApproveAllRequest {
    /**
     * ID of the process withe the return items to be approved. Required.
     * @type {string}
     * @memberof ProcessesApiApproveAll
     */
    readonly processId: string

    /**
     * 
     * @type {PbApproveAllRequest}
     * @memberof ProcessesApiApproveAll
     */
    readonly pbApproveAllRequest: PbApproveAllRequest
}

/**
 * Request parameters for changeCompensationMethod operation in ProcessesApi.
 * @export
 * @interface ProcessesApiChangeCompensationMethodRequest
 */
export interface ProcessesApiChangeCompensationMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeCompensationMethod
     */
    readonly processId: string

    /**
     * 
     * @type {PbChangeCompensationMethodRequest}
     * @memberof ProcessesApiChangeCompensationMethod
     */
    readonly pbChangeCompensationMethodRequest: PbChangeCompensationMethodRequest
}

/**
 * Request parameters for changeToBankTransfer operation in ProcessesApi.
 * @export
 * @interface ProcessesApiChangeToBankTransferRequest
 */
export interface ProcessesApiChangeToBankTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeToBankTransfer
     */
    readonly processId: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeToBankTransfer
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeToBankTransfer
     */
    readonly iban?: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeToBankTransfer
     */
    readonly bban?: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeToBankTransfer
     */
    readonly swift?: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiChangeToBankTransfer
     */
    readonly bankAccountCountry?: string
}

/**
 * Request parameters for createIncidentDocumentUploads operation in ProcessesApi.
 * @export
 * @interface ProcessesApiCreateIncidentDocumentUploadsRequest
 */
export interface ProcessesApiCreateIncidentDocumentUploadsRequest {
    /**
     * id of the return process the incident is reported on
     * @type {string}
     * @memberof ProcessesApiCreateIncidentDocumentUploads
     */
    readonly processId: string

    /**
     * 
     * @type {PbCreateIncidentDocumentUploadsRequest}
     * @memberof ProcessesApiCreateIncidentDocumentUploads
     */
    readonly pbCreateIncidentDocumentUploadsRequest: PbCreateIncidentDocumentUploadsRequest
}

/**
 * Request parameters for exportReturnProcesses operation in ProcessesApi.
 * @export
 * @interface ProcessesApiExportReturnProcessesRequest
 */
export interface ProcessesApiExportReturnProcessesRequest {
    /**
     * 
     * @type {PbExportReturnProcessesRequest}
     * @memberof ProcessesApiExportReturnProcesses
     */
    readonly pbExportReturnProcessesRequest: PbExportReturnProcessesRequest
}

/**
 * Request parameters for exportReturnProcessesCsv operation in ProcessesApi.
 * @export
 * @interface ProcessesApiExportReturnProcessesCsvRequest
 */
export interface ProcessesApiExportReturnProcessesCsvRequest {
    /**
     * 
     * @type {PbExportReturnProcessesCsvRequest}
     * @memberof ProcessesApiExportReturnProcessesCsv
     */
    readonly pbExportReturnProcessesCsvRequest: PbExportReturnProcessesCsvRequest
}

/**
 * Request parameters for findLineItemReturnReasons operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindLineItemReturnReasonsRequest
 */
export interface ProcessesApiFindLineItemReturnReasonsRequest {
    /**
     * 
     * @type {PbFindLineItemReturnReasonsRequest}
     * @memberof ProcessesApiFindLineItemReturnReasons
     */
    readonly pbFindLineItemReturnReasonsRequest: PbFindLineItemReturnReasonsRequest
}

/**
 * Request parameters for findProcessCarriers operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindProcessCarriersRequest
 */
export interface ProcessesApiFindProcessCarriersRequest {
    /**
     * 
     * @type {PbFindProcessCarriersRequest}
     * @memberof ProcessesApiFindProcessCarriers
     */
    readonly pbFindProcessCarriersRequest: PbFindProcessCarriersRequest
}

/**
 * Request parameters for findProcessCountries operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindProcessCountriesRequest
 */
export interface ProcessesApiFindProcessCountriesRequest {
    /**
     * 
     * @type {PbFindProcessCountriesRequest}
     * @memberof ProcessesApiFindProcessCountries
     */
    readonly pbFindProcessCountriesRequest: PbFindProcessCountriesRequest
}

/**
 * Request parameters for findProcessWarehouses operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindProcessWarehousesRequest
 */
export interface ProcessesApiFindProcessWarehousesRequest {
    /**
     * 
     * @type {PbFindProcessWarehousesRequest}
     * @memberof ProcessesApiFindProcessWarehouses
     */
    readonly pbFindProcessWarehousesRequest: PbFindProcessWarehousesRequest
}

/**
 * Request parameters for findProcesses operation in ProcessesApi.
 * @export
 * @interface ProcessesApiFindProcessesRequest
 */
export interface ProcessesApiFindProcessesRequest {
    /**
     * 
     * @type {PbFindProcessesRequest}
     * @memberof ProcessesApiFindProcesses
     */
    readonly pbFindProcessesRequest: PbFindProcessesRequest
}

/**
 * Request parameters for get operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetRequest
 */
export interface ProcessesApiGetRequest {
    /**
     * ID of the process to be recovered. Required.
     * @type {string}
     * @memberof ProcessesApiGet
     */
    readonly processId: string
}

/**
 * Request parameters for getAuthorizationStatus operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetAuthorizationStatusRequest
 */
export interface ProcessesApiGetAuthorizationStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetAuthorizationStatus
     */
    readonly processId: string
}

/**
 * Request parameters for getCancelExchangePreview operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetCancelExchangePreviewRequest
 */
export interface ProcessesApiGetCancelExchangePreviewRequest {
    /**
     * Return process id. Required.
     * @type {string}
     * @memberof ProcessesApiGetCancelExchangePreview
     */
    readonly processId: string
}

/**
 * Request parameters for getHelpDeskProcessesByEmailAndEcommerceGroup operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroupRequest
 */
export interface ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroup
     */
    readonly email: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroup
     */
    readonly group: string
}

/**
 * Request parameters for getLogisticSummaries operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetLogisticSummariesRequest
 */
export interface ProcessesApiGetLogisticSummariesRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetLogisticSummaries
     */
    readonly groupId?: string

    /**
     * 
     * @type {number}
     * @memberof ProcessesApiGetLogisticSummaries
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ProcessesApiGetLogisticSummaries
     */
    readonly days?: number
}

/**
 * Request parameters for getLogisticsSummary operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetLogisticsSummaryRequest
 */
export interface ProcessesApiGetLogisticsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetLogisticsSummary
     */
    readonly processId: string
}

/**
 * Request parameters for getReturnDocuments operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetReturnDocumentsRequest
 */
export interface ProcessesApiGetReturnDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnDocuments
     */
    readonly processId: string
}

/**
 * Request parameters for getReturnSummaries operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetReturnSummariesRequest
 */
export interface ProcessesApiGetReturnSummariesRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnSummaries
     */
    readonly groupId?: string

    /**
     * 
     * @type {number}
     * @memberof ProcessesApiGetReturnSummaries
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ProcessesApiGetReturnSummaries
     */
    readonly days?: number

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnSummaries
     */
    readonly orderId?: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnSummaries
     */
    readonly warehouseId?: string

    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnSummaries
     */
    readonly startedBefore?: string
}

/**
 * Request parameters for getReturnSummary operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetReturnSummaryRequest
 */
export interface ProcessesApiGetReturnSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnSummary
     */
    readonly processId: string
}

/**
 * Request parameters for getReturnSummaryByPlatform operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetReturnSummaryByPlatformRequest
 */
export interface ProcessesApiGetReturnSummaryByPlatformRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReturnSummaryByPlatform
     */
    readonly platformProcessId: string
}

/**
 * Request parameters for getReviews operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetReviewsRequest
 */
export interface ProcessesApiGetReviewsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiGetReviews
     */
    readonly processId: string
}

/**
 * Request parameters for getTransactions operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetTransactionsRequest
 */
export interface ProcessesApiGetTransactionsRequest {
    /**
     * The ID of the return process to get transactions for
     * @type {string}
     * @memberof ProcessesApiGetTransactions
     */
    readonly processId: string
}

/**
 * Request parameters for getWfpClaimByReturnProcessID operation in ProcessesApi.
 * @export
 * @interface ProcessesApiGetWfpClaimByReturnProcessIDRequest
 */
export interface ProcessesApiGetWfpClaimByReturnProcessIDRequest {
    /**
     * 
     * @type {PbGetWfpClaimByReturnProcessIDRequest}
     * @memberof ProcessesApiGetWfpClaimByReturnProcessID
     */
    readonly pbGetWfpClaimByReturnProcessIDRequest: PbGetWfpClaimByReturnProcessIDRequest
}

/**
 * Request parameters for listWithdrawalRequests operation in ProcessesApi.
 * @export
 * @interface ProcessesApiListWithdrawalRequestsRequest
 */
export interface ProcessesApiListWithdrawalRequestsRequest {
    /**
     * E-commerce whose requests to list. Required.
     * @type {string}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly ecommerceId?: string

    /**
     * Number of requests to skip
     * @type {number}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly offset?: number

    /**
     * Maximum number of requests to return: 20 by default, 100 at most
     * @type {number}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly limit?: number

    /**
     * Only requests in one of these statuses. All of them when empty
     * @type {Array<'WITHDRAWAL_STATUS_UNSPECIFIED' | 'WITHDRAWAL_STATUS_RECEIVED' | 'WITHDRAWAL_STATUS_AWAITING_RETURN' | 'WITHDRAWAL_STATUS_RETURNED' | 'WITHDRAWAL_STATUS_REFUNDED' | 'WITHDRAWAL_STATUS_CLOSED'>}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly statuses?: Array<ListWithdrawalRequestsStatusesEnum>

    /**
     * Only requests received at or after this time
     * @type {string}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly receivedFrom?: string

    /**
     * Only requests received at or before this time
     * @type {string}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly receivedTo?: string

    /**
     * Only requests whose customer name, email or order number contains this text, ignoring case
     * @type {string}
     * @memberof ProcessesApiListWithdrawalRequests
     */
    readonly search?: string
}

/**
 * Request parameters for patchReturnProcess operation in ProcessesApi.
 * @export
 * @interface ProcessesApiPatchReturnProcessRequest
 */
export interface ProcessesApiPatchReturnProcessRequest {
    /**
     * ID of the process to be updated. Required.
     * @type {string}
     * @memberof ProcessesApiPatchReturnProcess
     */
    readonly processId: string

    /**
     * 
     * @type {PbPatchReturnProcessRequest}
     * @memberof ProcessesApiPatchReturnProcess
     */
    readonly pbPatchReturnProcessRequest: PbPatchReturnProcessRequest
}

/**
 * Request parameters for requestCustomerUploadPhotos operation in ProcessesApi.
 * @export
 * @interface ProcessesApiRequestCustomerUploadPhotosRequest
 */
export interface ProcessesApiRequestCustomerUploadPhotosRequest {
    /**
     * Process ID.
     * @type {string}
     * @memberof ProcessesApiRequestCustomerUploadPhotos
     */
    readonly processId: string

    /**
     * 
     * @type {PbRequestCustomerUploadPhotosRequest}
     * @memberof ProcessesApiRequestCustomerUploadPhotos
     */
    readonly pbRequestCustomerUploadPhotosRequest: PbRequestCustomerUploadPhotosRequest
}

/**
 * Request parameters for setStoreAddress operation in ProcessesApi.
 * @export
 * @interface ProcessesApiSetStoreAddressRequest
 */
export interface ProcessesApiSetStoreAddressRequest {
    /**
     * ID of the return process to update. Required.
     * @type {string}
     * @memberof ProcessesApiSetStoreAddress
     */
    readonly processId: string

    /**
     * 
     * @type {PbSetStoreAddressRequest}
     * @memberof ProcessesApiSetStoreAddress
     */
    readonly pbSetStoreAddressRequest: PbSetStoreAddressRequest
}

/**
 * Request parameters for setWithdrawalRequestClosed operation in ProcessesApi.
 * @export
 * @interface ProcessesApiSetWithdrawalRequestClosedRequest
 */
export interface ProcessesApiSetWithdrawalRequestClosedRequest {
    /**
     * ID of the withdrawal request. Required.
     * @type {string}
     * @memberof ProcessesApiSetWithdrawalRequestClosed
     */
    readonly id: string

    /**
     * 
     * @type {PbSetWithdrawalRequestClosedRequest}
     * @memberof ProcessesApiSetWithdrawalRequestClosed
     */
    readonly pbSetWithdrawalRequestClosedRequest: PbSetWithdrawalRequestClosedRequest
}

/**
 * Request parameters for updateLogistics operation in ProcessesApi.
 * @export
 * @interface ProcessesApiUpdateLogisticsRequest
 */
export interface ProcessesApiUpdateLogisticsRequest {
    /**
     * The process ID to update. Required.
     * @type {string}
     * @memberof ProcessesApiUpdateLogistics
     */
    readonly processId: string

    /**
     * 
     * @type {PbUpdateLogisticsRequest}
     * @memberof ProcessesApiUpdateLogistics
     */
    readonly pbUpdateLogisticsRequest: PbUpdateLogisticsRequest
}

/**
 * Request parameters for updateWorkflowStatus operation in ProcessesApi.
 * @export
 * @interface ProcessesApiUpdateWorkflowStatusRequest
 */
export interface ProcessesApiUpdateWorkflowStatusRequest {
    /**
     * The process ID to update. Required.
     * @type {string}
     * @memberof ProcessesApiUpdateWorkflowStatus
     */
    readonly processId: string

    /**
     * 
     * @type {PbUpdateWorkflowStatusRequest}
     * @memberof ProcessesApiUpdateWorkflowStatus
     */
    readonly pbUpdateWorkflowStatusRequest: PbUpdateWorkflowStatusRequest
}

/**
 * Request parameters for uploadReturnDocuments operation in ProcessesApi.
 * @export
 * @interface ProcessesApiUploadReturnDocumentsRequest
 */
export interface ProcessesApiUploadReturnDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessesApiUploadReturnDocuments
     */
    readonly processId: string

    /**
     * 
     * @type {PbUploadReturnDocumentsRequest}
     * @memberof ProcessesApiUploadReturnDocuments
     */
    readonly pbUploadReturnDocumentsRequest: PbUploadReturnDocumentsRequest
}

/**
 * Request parameters for validateReview operation in ProcessesApi.
 * @export
 * @interface ProcessesApiValidateReviewRequest
 */
export interface ProcessesApiValidateReviewRequest {
    /**
     * process ID to validate
     * @type {string}
     * @memberof ProcessesApiValidateReview
     */
    readonly processId: string

    /**
     * 
     * @type {PbValidateReviewRequest}
     * @memberof ProcessesApiValidateReview
     */
    readonly pbValidateReviewRequest: PbValidateReviewRequest
}

/**
 * ProcessesApi - object-oriented interface
 * @export
 * @class ProcessesApi
 * @extends {BaseAPI}
 */
export class ProcessesApi extends BaseAPI {
    /**
     * Adds an adjustment transaction to a given process
     * @param {ProcessesApiAddAdjustmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public addAdjustment(requestParameters: ProcessesApiAddAdjustmentRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).addAdjustment(requestParameters.processId, requestParameters.pbAddAdjustmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a comment to a given process
     * @param {ProcessesApiAddCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public addComment(requestParameters: ProcessesApiAddCommentRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).addComment(requestParameters.processId, requestParameters.pbAddCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a review (approve/decline/missing) to a given process
     * @param {ProcessesApiAddReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public addReview(requestParameters: ProcessesApiAddReviewRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).addReview(requestParameters.processId, requestParameters.pbAddReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds transactions to a given process that belongs to an e-commerce of  the authenticated user\'s group
     * @param {ProcessesApiAddTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public addTransactions(requestParameters: ProcessesApiAddTransactionsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).addTransactions(requestParameters.processId, requestParameters.pbAddTransactionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approves all the pending items being returned in a given process
     * @param {ProcessesApiApproveAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public approveAll(requestParameters: ProcessesApiApproveAllRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).approveAll(requestParameters.processId, requestParameters.pbApproveAllRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ChangeCompensationMethod changes the compensation method for a process
     * @param {ProcessesApiChangeCompensationMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public changeCompensationMethod(requestParameters: ProcessesApiChangeCompensationMethodRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).changeCompensationMethod(requestParameters.processId, requestParameters.pbChangeCompensationMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ChangeToBankTransfer changes the compensation to bank transfer
     * @param {ProcessesApiChangeToBankTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public changeToBankTransfer(requestParameters: ProcessesApiChangeToBankTransferRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).changeToBankTransfer(requestParameters.processId, requestParameters.email, requestParameters.iban, requestParameters.bban, requestParameters.swift, requestParameters.bankAccountCountry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates presigned URLs to upload the documents attached to an incident reported on a return  process (e.g. the commercial invoice and photos of a damaged package), and to download them  afterwards. The caller PUTs each file to its upload_url with the declared content type.
     * @param {ProcessesApiCreateIncidentDocumentUploadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public createIncidentDocumentUploads(requestParameters: ProcessesApiCreateIncidentDocumentUploadsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).createIncidentDocumentUploads(requestParameters.processId, requestParameters.pbCreateIncidentDocumentUploadsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download return processes info for a given filter set
     * @param {ProcessesApiExportReturnProcessesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public exportReturnProcesses(requestParameters: ProcessesApiExportReturnProcessesRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).exportReturnProcesses(requestParameters.pbExportReturnProcessesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ExportReturnProcessesCsv downloads return processes as CSV using the same  filters as the FindProcesses listing endpoint. Supersedes ExportReturnProcesses.
     * @param {ProcessesApiExportReturnProcessesCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public exportReturnProcessesCsv(requestParameters: ProcessesApiExportReturnProcessesCsvRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).exportReturnProcessesCsv(requestParameters.pbExportReturnProcessesCsvRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindLineItemReturnReasons returns the distinct return reasons of the  caller\'s returned products (scoped by group/warehouse), to populate the  reason filter dropdown of the items listing.
     * @param {ProcessesApiFindLineItemReturnReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findLineItemReturnReasons(requestParameters: ProcessesApiFindLineItemReturnReasonsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findLineItemReturnReasons(requestParameters.pbFindLineItemReturnReasonsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindProcessCarriers returns the distinct carriers present in the caller\'s  processes (scoped by group/warehouse), to populate the carrier filter  dropdown of the listing.
     * @param {ProcessesApiFindProcessCarriersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findProcessCarriers(requestParameters: ProcessesApiFindProcessCarriersRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findProcessCarriers(requestParameters.pbFindProcessCarriersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindProcessCountries returns the distinct origin countries present in the  caller\'s processes (scoped by group/warehouse), to populate the country  filter dropdown of the listing.
     * @param {ProcessesApiFindProcessCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findProcessCountries(requestParameters: ProcessesApiFindProcessCountriesRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findProcessCountries(requestParameters.pbFindProcessCountriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindProcessWarehouses returns the warehouses the caller is allowed to see  (a reviewer is limited to its assigned warehouses; anyone else sees all in  the group), to populate the warehouse filter dropdown of the listing.
     * @param {ProcessesApiFindProcessWarehousesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findProcessWarehouses(requestParameters: ProcessesApiFindProcessWarehousesRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findProcessWarehouses(requestParameters.pbFindProcessWarehousesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindProcesses retrieves return processes by several filters, freetext  search and pagination. gRPC equivalent of the legacy GET /v1/processes/find.
     * @param {ProcessesApiFindProcessesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public findProcesses(requestParameters: ProcessesApiFindProcessesRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).findProcesses(requestParameters.pbFindProcessesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated: use GetReturnSummary instead
     * @param {ProcessesApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public get(requestParameters: ProcessesApiGetRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).get(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetAuthorizationStatus returns the authorization status and details of a process
     * @param {ProcessesApiGetAuthorizationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getAuthorizationStatus(requestParameters: ProcessesApiGetAuthorizationStatusRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getAuthorizationStatus(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Says what canceling this return will do to its exchange order, for the cancel dialog.  Read-only.
     * @param {ProcessesApiGetCancelExchangePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getCancelExchangePreview(requestParameters: ProcessesApiGetCancelExchangePreviewRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getCancelExchangePreview(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetHelpDeskProcessesByEmailAndEcommerceGroup finds processes per email
     * @param {ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getHelpDeskProcessesByEmailAndEcommerceGroup(requestParameters: ProcessesApiGetHelpDeskProcessesByEmailAndEcommerceGroupRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getHelpDeskProcessesByEmailAndEcommerceGroup(requestParameters.email, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Logistic Summaries
     * @param {ProcessesApiGetLogisticSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getLogisticSummaries(requestParameters: ProcessesApiGetLogisticSummariesRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getLogisticSummaries(requestParameters.groupId, requestParameters.page, requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the logistic info of a Return Process
     * @param {ProcessesApiGetLogisticsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getLogisticsSummary(requestParameters: ProcessesApiGetLogisticsSummaryRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getLogisticsSummary(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all the documents uploaded for a given return process
     * @param {ProcessesApiGetReturnDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getReturnDocuments(requestParameters: ProcessesApiGetReturnDocumentsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getReturnDocuments(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Return Summaries
     * @param {ProcessesApiGetReturnSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getReturnSummaries(requestParameters: ProcessesApiGetReturnSummariesRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getReturnSummaries(requestParameters.groupId, requestParameters.page, requestParameters.days, requestParameters.orderId, requestParameters.warehouseId, requestParameters.startedBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Return Summary
     * @param {ProcessesApiGetReturnSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getReturnSummary(requestParameters: ProcessesApiGetReturnSummaryRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getReturnSummary(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Return Summary by platform ID, used for public access
     * @param {ProcessesApiGetReturnSummaryByPlatformRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getReturnSummaryByPlatform(requestParameters: ProcessesApiGetReturnSummaryByPlatformRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getReturnSummaryByPlatform(requestParameters.platformProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the reviews associated to a Return Process
     * @param {ProcessesApiGetReviewsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getReviews(requestParameters: ProcessesApiGetReviewsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getReviews(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetTransactions returns all transactions for a given process
     * @param {ProcessesApiGetTransactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getTransactions(requestParameters: ProcessesApiGetTransactionsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getTransactions(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetWfpClaimByReturnProcessID returns the (at most one) wfp_claim linked to a  return process. Public, authenticated variant used by the dashboard  return-process detail page to show claim status; enforces caller-group  ownership of the return process. Read-only and idempotent. Returns NotFound  when the process has no claim or the caller is not in its group.
     * @param {ProcessesApiGetWfpClaimByReturnProcessIDRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public getWfpClaimByReturnProcessID(requestParameters: ProcessesApiGetWfpClaimByReturnProcessIDRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).getWfpClaimByReturnProcessID(requestParameters.pbGetWfpClaimByReturnProcessIDRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ListWithdrawalRequests returns an e-commerce\'s withdrawal requests, newest first.
     * @param {ProcessesApiListWithdrawalRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public listWithdrawalRequests(requestParameters: ProcessesApiListWithdrawalRequestsRequest = {}, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).listWithdrawalRequests(requestParameters.ecommerceId, requestParameters.offset, requestParameters.limit, requestParameters.statuses, requestParameters.receivedFrom, requestParameters.receivedTo, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a return process via a PATCH (updating only certain fields)  To update \'last_known_shipping_status\' with side effects on the process, call ops-api
     * @param {ProcessesApiPatchReturnProcessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public patchReturnProcess(requestParameters: ProcessesApiPatchReturnProcessRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).patchReturnProcess(requestParameters.processId, requestParameters.pbPatchReturnProcessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RateLimitTest request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public rateLimitTest(options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).rateLimitTest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send customer an email requesting to upload more photos
     * @param {ProcessesApiRequestCustomerUploadPhotosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public requestCustomerUploadPhotos(requestParameters: ProcessesApiRequestCustomerUploadPhotosRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).requestCustomerUploadPhotos(requestParameters.processId, requestParameters.pbRequestCustomerUploadPhotosRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the store address for a return process (IN_STORE internal logistics)
     * @param {ProcessesApiSetStoreAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public setStoreAddress(requestParameters: ProcessesApiSetStoreAddressRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).setStoreAddress(requestParameters.processId, requestParameters.pbSetStoreAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SetWithdrawalRequestClosed marks a withdrawal request as handled by the merchant, or  reopens it. The request itself and when it was received never change.
     * @param {ProcessesApiSetWithdrawalRequestClosedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public setWithdrawalRequestClosed(requestParameters: ProcessesApiSetWithdrawalRequestClosedRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).setWithdrawalRequestClosed(requestParameters.id, requestParameters.pbSetWithdrawalRequestClosedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the logistics fields associated to a given return process
     * @param {ProcessesApiUpdateLogisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public updateLogistics(requestParameters: ProcessesApiUpdateLogisticsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).updateLogistics(requestParameters.processId, requestParameters.pbUpdateLogisticsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the status associated to the main workflow  of a given return process
     * @param {ProcessesApiUpdateWorkflowStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public updateWorkflowStatus(requestParameters: ProcessesApiUpdateWorkflowStatusRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).updateWorkflowStatus(requestParameters.processId, requestParameters.pbUpdateWorkflowStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads documents associated to a return process which consists in  photo + text. The documents are stored in S3 and the URL is saved in  the database
     * @param {ProcessesApiUploadReturnDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public uploadReturnDocuments(requestParameters: ProcessesApiUploadReturnDocumentsRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).uploadReturnDocuments(requestParameters.processId, requestParameters.pbUploadReturnDocumentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates if the review request is valid
     * @param {ProcessesApiValidateReviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessesApi
     */
    public validateReview(requestParameters: ProcessesApiValidateReviewRequest, options?: RawAxiosRequestConfig) {
        return ProcessesApiFp(this.configuration).validateReview(requestParameters.processId, requestParameters.pbValidateReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListWithdrawalRequestsStatusesEnum = {
    Unspecified: 'WITHDRAWAL_STATUS_UNSPECIFIED',
    Received: 'WITHDRAWAL_STATUS_RECEIVED',
    AwaitingReturn: 'WITHDRAWAL_STATUS_AWAITING_RETURN',
    Returned: 'WITHDRAWAL_STATUS_RETURNED',
    Refunded: 'WITHDRAWAL_STATUS_REFUNDED',
    Closed: 'WITHDRAWAL_STATUS_CLOSED'
} as const;
export type ListWithdrawalRequestsStatusesEnum = typeof ListWithdrawalRequestsStatusesEnum[keyof typeof ListWithdrawalRequestsStatusesEnum];


/**
 * ProductRecommenderApi - axios parameter creator
 * @export
 */
export const ProductRecommenderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get product recommendations based on return information and user data
         * @param {ProductrecommenderpbGetRecommendationsRequest} productrecommenderpbGetRecommendationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendations: async (productrecommenderpbGetRecommendationsRequest: ProductrecommenderpbGetRecommendationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productrecommenderpbGetRecommendationsRequest' is not null or undefined
            assertParamExists('getRecommendations', 'productrecommenderpbGetRecommendationsRequest', productrecommenderpbGetRecommendationsRequest)
            const localVarPath = `/v1/public/analytics/product-recommender/recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productrecommenderpbGetRecommendationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductRecommenderApi - functional programming interface
 * @export
 */
export const ProductRecommenderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductRecommenderApiAxiosParamCreator(configuration)
    return {
        /**
         * Get product recommendations based on return information and user data
         * @param {ProductrecommenderpbGetRecommendationsRequest} productrecommenderpbGetRecommendationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendations(productrecommenderpbGetRecommendationsRequest: ProductrecommenderpbGetRecommendationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductrecommenderpbGetRecommendationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendations(productrecommenderpbGetRecommendationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductRecommenderApi.getRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductRecommenderApi - factory interface
 * @export
 */
export const ProductRecommenderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductRecommenderApiFp(configuration)
    return {
        /**
         * Get product recommendations based on return information and user data
         * @param {ProductRecommenderApiGetRecommendationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendations(requestParameters: ProductRecommenderApiGetRecommendationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductrecommenderpbGetRecommendationsResponse> {
            return localVarFp.getRecommendations(requestParameters.productrecommenderpbGetRecommendationsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRecommendations operation in ProductRecommenderApi.
 * @export
 * @interface ProductRecommenderApiGetRecommendationsRequest
 */
export interface ProductRecommenderApiGetRecommendationsRequest {
    /**
     * 
     * @type {ProductrecommenderpbGetRecommendationsRequest}
     * @memberof ProductRecommenderApiGetRecommendations
     */
    readonly productrecommenderpbGetRecommendationsRequest: ProductrecommenderpbGetRecommendationsRequest
}

/**
 * ProductRecommenderApi - object-oriented interface
 * @export
 * @class ProductRecommenderApi
 * @extends {BaseAPI}
 */
export class ProductRecommenderApi extends BaseAPI {
    /**
     * Get product recommendations based on return information and user data
     * @param {ProductRecommenderApiGetRecommendationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductRecommenderApi
     */
    public getRecommendations(requestParameters: ProductRecommenderApiGetRecommendationsRequest, options?: RawAxiosRequestConfig) {
        return ProductRecommenderApiFp(this.configuration).getRecommendations(requestParameters.productrecommenderpbGetRecommendationsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferralsApi - axios parameter creator
 * @export
 */
export const ReferralsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the referrals of a given ecommerce group
         * @param {string} ecommerceGroup The group of the ecommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralsByGroup: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getReferralsByGroup', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v1/analytics/dashboard_referrals/{ecommerce_group}`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new referral
         * @param {string} [referrerGroup] The group of the ecommerce making the referral
         * @param {string} [referrerEmail] The email of the user making the referral
         * @param {string} [referredEmail] The email of the brand referred
         * @param {string} [referredBrand] The name of the brand referred. Can be empty
         * @param {string} [referredPhone] The phone of the brand referred. Can be empty
         * @param {string} [status] The status of the referral. Not used yet
         * @param {string} [website] The website of the referred brand. Can be empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReferral: async (referrerGroup?: string, referrerEmail?: string, referredEmail?: string, referredBrand?: string, referredPhone?: string, status?: string, website?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/dashboard_referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (referrerGroup !== undefined) {
                localVarQueryParameter['referrer_group'] = referrerGroup;
            }

            if (referrerEmail !== undefined) {
                localVarQueryParameter['referrer_email'] = referrerEmail;
            }

            if (referredEmail !== undefined) {
                localVarQueryParameter['referred_email'] = referredEmail;
            }

            if (referredBrand !== undefined) {
                localVarQueryParameter['referred_brand'] = referredBrand;
            }

            if (referredPhone !== undefined) {
                localVarQueryParameter['referred_phone'] = referredPhone;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (website !== undefined) {
                localVarQueryParameter['website'] = website;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferralsApi - functional programming interface
 * @export
 */
export const ReferralsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferralsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the referrals of a given ecommerce group
         * @param {string} ecommerceGroup The group of the ecommerce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralsByGroup(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralspbGetReferralsGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralsByGroup(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.getReferralsByGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new referral
         * @param {string} [referrerGroup] The group of the ecommerce making the referral
         * @param {string} [referrerEmail] The email of the user making the referral
         * @param {string} [referredEmail] The email of the brand referred
         * @param {string} [referredBrand] The name of the brand referred. Can be empty
         * @param {string} [referredPhone] The phone of the brand referred. Can be empty
         * @param {string} [status] The status of the referral. Not used yet
         * @param {string} [website] The website of the referred brand. Can be empty
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReferral(referrerGroup?: string, referrerEmail?: string, referredEmail?: string, referredBrand?: string, referredPhone?: string, status?: string, website?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReferral(referrerGroup, referrerEmail, referredEmail, referredBrand, referredPhone, status, website, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralsApi.postReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferralsApi - factory interface
 * @export
 */
export const ReferralsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferralsApiFp(configuration)
    return {
        /**
         * Retrieves the referrals of a given ecommerce group
         * @param {ReferralsApiGetReferralsByGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralsByGroup(requestParameters: ReferralsApiGetReferralsByGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReferralspbGetReferralsGroupResponse> {
            return localVarFp.getReferralsByGroup(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new referral
         * @param {ReferralsApiPostReferralRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReferral(requestParameters: ReferralsApiPostReferralRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postReferral(requestParameters.referrerGroup, requestParameters.referrerEmail, requestParameters.referredEmail, requestParameters.referredBrand, requestParameters.referredPhone, requestParameters.status, requestParameters.website, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getReferralsByGroup operation in ReferralsApi.
 * @export
 * @interface ReferralsApiGetReferralsByGroupRequest
 */
export interface ReferralsApiGetReferralsByGroupRequest {
    /**
     * The group of the ecommerce
     * @type {string}
     * @memberof ReferralsApiGetReferralsByGroup
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for postReferral operation in ReferralsApi.
 * @export
 * @interface ReferralsApiPostReferralRequest
 */
export interface ReferralsApiPostReferralRequest {
    /**
     * The group of the ecommerce making the referral
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly referrerGroup?: string

    /**
     * The email of the user making the referral
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly referrerEmail?: string

    /**
     * The email of the brand referred
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly referredEmail?: string

    /**
     * The name of the brand referred. Can be empty
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly referredBrand?: string

    /**
     * The phone of the brand referred. Can be empty
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly referredPhone?: string

    /**
     * The status of the referral. Not used yet
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly status?: string

    /**
     * The website of the referred brand. Can be empty
     * @type {string}
     * @memberof ReferralsApiPostReferral
     */
    readonly website?: string
}

/**
 * ReferralsApi - object-oriented interface
 * @export
 * @class ReferralsApi
 * @extends {BaseAPI}
 */
export class ReferralsApi extends BaseAPI {
    /**
     * Retrieves the referrals of a given ecommerce group
     * @param {ReferralsApiGetReferralsByGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public getReferralsByGroup(requestParameters: ReferralsApiGetReferralsByGroupRequest, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).getReferralsByGroup(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new referral
     * @param {ReferralsApiPostReferralRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralsApi
     */
    public postReferral(requestParameters: ReferralsApiPostReferralRequest = {}, options?: RawAxiosRequestConfig) {
        return ReferralsApiFp(this.configuration).postReferral(requestParameters.referrerGroup, requestParameters.referrerEmail, requestParameters.referredEmail, requestParameters.referredBrand, requestParameters.referredPhone, requestParameters.status, requestParameters.website, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsServiceApi - axios parameter creator
 * @export
 */
export const ReportsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GeneralReport executes the report identified by query_key and returns the  corresponding payload in the oneof response.
         * @param {string} [queryKey] Key that selects which report to run, for example:  - \&quot;returns_pending_review\&quot;
         * @param {Array<string>} [groups] List of groups to include in the report. Must contain at least one element  for the \&quot;returns_pending_review\&quot; report.
         * @param {string} [startDate] Optional start date of the time range for which to retrieve data  (YYYY-MM-DD). Not used by all reports.
         * @param {string} [endDate] Optional end date of the time range for which to retrieve data  (YYYY-MM-DD). Not used by all reports.
         * @param {string} [invoicingPeriod] Invoicing period filter used by \&quot;laveste_logistics_report\&quot; and  \&quot;upsell_report\&quot;. Example: \&quot;M 2025-10-01 - 2025-10-31\&quot;. When empty,  defaults to the previous calendar month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalReport: async (queryKey?: string, groups?: Array<string>, startDate?: string, endDate?: string, invoicingPeriod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (queryKey !== undefined) {
                localVarQueryParameter['query_key'] = queryKey;
            }

            if (groups) {
                localVarQueryParameter['groups'] = groups;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (invoicingPeriod !== undefined) {
                localVarQueryParameter['invoicing_period'] = invoicingPeriod;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsServiceApi - functional programming interface
 * @export
 */
export const ReportsServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * GeneralReport executes the report identified by query_key and returns the  corresponding payload in the oneof response.
         * @param {string} [queryKey] Key that selects which report to run, for example:  - \&quot;returns_pending_review\&quot;
         * @param {Array<string>} [groups] List of groups to include in the report. Must contain at least one element  for the \&quot;returns_pending_review\&quot; report.
         * @param {string} [startDate] Optional start date of the time range for which to retrieve data  (YYYY-MM-DD). Not used by all reports.
         * @param {string} [endDate] Optional end date of the time range for which to retrieve data  (YYYY-MM-DD). Not used by all reports.
         * @param {string} [invoicingPeriod] Invoicing period filter used by \&quot;laveste_logistics_report\&quot; and  \&quot;upsell_report\&quot;. Example: \&quot;M 2025-10-01 - 2025-10-31\&quot;. When empty,  defaults to the previous calendar month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalReport(queryKey?: string, groups?: Array<string>, startDate?: string, endDate?: string, invoicingPeriod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportspbGeneralReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalReport(queryKey, groups, startDate, endDate, invoicingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsServiceApi.generalReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsServiceApi - factory interface
 * @export
 */
export const ReportsServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsServiceApiFp(configuration)
    return {
        /**
         * GeneralReport executes the report identified by query_key and returns the  corresponding payload in the oneof response.
         * @param {ReportsServiceApiGeneralReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalReport(requestParameters: ReportsServiceApiGeneralReportRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ReportspbGeneralReportResponse> {
            return localVarFp.generalReport(requestParameters.queryKey, requestParameters.groups, requestParameters.startDate, requestParameters.endDate, requestParameters.invoicingPeriod, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalReport operation in ReportsServiceApi.
 * @export
 * @interface ReportsServiceApiGeneralReportRequest
 */
export interface ReportsServiceApiGeneralReportRequest {
    /**
     * Key that selects which report to run, for example:  - \&quot;returns_pending_review\&quot;
     * @type {string}
     * @memberof ReportsServiceApiGeneralReport
     */
    readonly queryKey?: string

    /**
     * List of groups to include in the report. Must contain at least one element  for the \&quot;returns_pending_review\&quot; report.
     * @type {Array<string>}
     * @memberof ReportsServiceApiGeneralReport
     */
    readonly groups?: Array<string>

    /**
     * Optional start date of the time range for which to retrieve data  (YYYY-MM-DD). Not used by all reports.
     * @type {string}
     * @memberof ReportsServiceApiGeneralReport
     */
    readonly startDate?: string

    /**
     * Optional end date of the time range for which to retrieve data  (YYYY-MM-DD). Not used by all reports.
     * @type {string}
     * @memberof ReportsServiceApiGeneralReport
     */
    readonly endDate?: string

    /**
     * Invoicing period filter used by \&quot;laveste_logistics_report\&quot; and  \&quot;upsell_report\&quot;. Example: \&quot;M 2025-10-01 - 2025-10-31\&quot;. When empty,  defaults to the previous calendar month.
     * @type {string}
     * @memberof ReportsServiceApiGeneralReport
     */
    readonly invoicingPeriod?: string
}

/**
 * ReportsServiceApi - object-oriented interface
 * @export
 * @class ReportsServiceApi
 * @extends {BaseAPI}
 */
export class ReportsServiceApi extends BaseAPI {
    /**
     * GeneralReport executes the report identified by query_key and returns the  corresponding payload in the oneof response.
     * @param {ReportsServiceApiGeneralReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsServiceApi
     */
    public generalReport(requestParameters: ReportsServiceApiGeneralReportRequest = {}, options?: RawAxiosRequestConfig) {
        return ReportsServiceApiFp(this.configuration).generalReport(requestParameters.queryKey, requestParameters.groups, requestParameters.startDate, requestParameters.endDate, requestParameters.invoicingPeriod, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RestockApi - axios parameter creator
 * @export
 */
export const RestockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the restock of a given process for external use
         * @param {string} processId Process ID. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestockExternal: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getRestockExternal', 'processId', processId)
            const localVarPath = `/v1/restocks/{process_id}`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestockApi - functional programming interface
 * @export
 */
export const RestockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestockApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the restock of a given process for external use
         * @param {string} processId Process ID. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestockExternal(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetRestockResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestockExternal(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestockApi.getRestockExternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestockApi - factory interface
 * @export
 */
export const RestockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestockApiFp(configuration)
    return {
        /**
         * Gets the restock of a given process for external use
         * @param {RestockApiGetRestockExternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestockExternal(requestParameters: RestockApiGetRestockExternalRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetRestockResponse> {
            return localVarFp.getRestockExternal(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRestockExternal operation in RestockApi.
 * @export
 * @interface RestockApiGetRestockExternalRequest
 */
export interface RestockApiGetRestockExternalRequest {
    /**
     * Process ID. Required.
     * @type {string}
     * @memberof RestockApiGetRestockExternal
     */
    readonly processId: string
}

/**
 * RestockApi - object-oriented interface
 * @export
 * @class RestockApi
 * @extends {BaseAPI}
 */
export class RestockApi extends BaseAPI {
    /**
     * Gets the restock of a given process for external use
     * @param {RestockApiGetRestockExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestockApi
     */
    public getRestockExternal(requestParameters: RestockApiGetRestockExternalRequest, options?: RawAxiosRequestConfig) {
        return RestockApiFp(this.configuration).getRestockExternal(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReturnsApi - axios parameter creator
 * @export
 */
export const ReturnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns available refund method change options for a process  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} processId Process ID the change belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableRefundMethodChangeOptions: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('availableRefundMethodChangeOptions', 'processId', processId)
            const localVarPath = `/v1/update/returns/{process_id}/available_refund_method_change_options`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculate update for changing compensation to Original Payment Method (gRPC only)  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} processId Return process ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateUpdateAmount: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('calculateUpdateAmount', 'processId', processId)
            const localVarPath = `/v1/update/returns/{process_id}/calculate_update`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a return process. Only allowed while the process is in STARTED  status; cancelling reverses any committed refund/exchange/payment amounts,  notifies the customer, cancels the process on the ecommerce platform, and  cancels the process\'s underlying workflows.
         * @param {string} processId Return process ID
         * @param {ReturnsCancelReturnProcessRequest} returnsCancelReturnProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelReturnProcess: async (processId: string, returnsCancelReturnProcessRequest: ReturnsCancelReturnProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('cancelReturnProcess', 'processId', processId)
            // verify required parameter 'returnsCancelReturnProcessRequest' is not null or undefined
            assertParamExists('cancelReturnProcess', 'returnsCancelReturnProcessRequest', returnsCancelReturnProcessRequest)
            const localVarPath = `/v1/update/returns/{process_id}/cancel`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsCancelReturnProcessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CancelWfpContract - self-service Worry-Free-Purchase cancellation for the  shopper cancellation form. Resolves + authenticates the order (order id +  email), validates WFP eligibility (contract status + 24h window), triggers  the Seel cancel exactly once (no retry), and idempotently records the  cancellation request. The refund is NOT issued here — it is driven by the  contract.cancelled Seel webhook. Failures surface as gRPC status codes  (InvalidArgument, NotFound, FailedPrecondition; Internal for unexpected).
         * @param {string} ecommerceId E-commerce ID (path param).
         * @param {ReturnsCancelWfpContractRequest} returnsCancelWfpContractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWfpContract: async (ecommerceId: string, returnsCancelWfpContractRequest: ReturnsCancelWfpContractRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('cancelWfpContract', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsCancelWfpContractRequest' is not null or undefined
            assertParamExists('cancelWfpContract', 'returnsCancelWfpContractRequest', returnsCancelWfpContractRequest)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/wfp/cancel`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsCancelWfpContractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateOrder
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsCreateLiteOrderRequest} returnsCreateLiteOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiteOrder: async (ecommerceId: string, returnsCreateLiteOrderRequest: ReturnsCreateLiteOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('createLiteOrder', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsCreateLiteOrderRequest' is not null or undefined
            assertParamExists('createLiteOrder', 'returnsCreateLiteOrderRequest', returnsCreateLiteOrderRequest)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/order`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsCreateLiteOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns presigned URL to download delivery note
         * @param {ReturnsDeliveryNotePresignedURLRequest} returnsDeliveryNotePresignedURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryNotePresignedURL: async (returnsDeliveryNotePresignedURLRequest: ReturnsDeliveryNotePresignedURLRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnsDeliveryNotePresignedURLRequest' is not null or undefined
            assertParamExists('deliveryNotePresignedURL', 'returnsDeliveryNotePresignedURLRequest', returnsDeliveryNotePresignedURLRequest)
            const localVarPath = `/v1/public/returns/tracking/delivery_note_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsDeliveryNotePresignedURLRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns exchange options for a given line item of an order
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsExchangeOptionsRequest} returnsExchangeOptionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeOptions: async (ecommerceId: string, returnsExchangeOptionsRequest: ReturnsExchangeOptionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('exchangeOptions', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsExchangeOptionsRequest' is not null or undefined
            assertParamExists('exchangeOptions', 'returnsExchangeOptionsRequest', returnsExchangeOptionsRequest)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/exchange_options`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsExchangeOptionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns available exchange timing options for a given ecommerce
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsExchangeTimingsRequest} returnsExchangeTimingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeTimings: async (ecommerceId: string, returnsExchangeTimingsRequest: ReturnsExchangeTimingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('exchangeTimings', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsExchangeTimingsRequest' is not null or undefined
            assertParamExists('exchangeTimings', 'returnsExchangeTimingsRequest', returnsExchangeTimingsRequest)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/exchange/timings`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsExchangeTimingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GetOrder
         * @param {string} ecommerceId E-commerce ID
         * @param {string} [customerPrintedOrderId] Customer printed order ID
         * @param {string} [email] Email
         * @param {string} [userPreferredLang] User preferred language
         * @param {string} [postalCode] Postal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (ecommerceId: string, customerPrintedOrderId?: string, email?: string, userPreferredLang?: string, postalCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getOrder', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/order`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerPrintedOrderId !== undefined) {
                localVarQueryParameter['customer_printed_order_id'] = customerPrintedOrderId;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (userPreferredLang !== undefined) {
                localVarQueryParameter['user_preferred_lang'] = userPreferredLang;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ImportReturn - starts a return given order info and selected items
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsImportReturnRequest} returnsImportReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importReturn: async (ecommerceId: string, returnsImportReturnRequest: ReturnsImportReturnRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('importReturn', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsImportReturnRequest' is not null or undefined
            assertParamExists('importReturn', 'returnsImportReturnRequest', returnsImportReturnRequest)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/import_return`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsImportReturnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns presigned URL to download return instructions
         * @param {ReturnsInstructionsPresignedURLRequest} returnsInstructionsPresignedURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instructionsPresignedURL: async (returnsInstructionsPresignedURLRequest: ReturnsInstructionsPresignedURLRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnsInstructionsPresignedURLRequest' is not null or undefined
            assertParamExists('instructionsPresignedURL', 'returnsInstructionsPresignedURLRequest', returnsInstructionsPresignedURLRequest)
            const localVarPath = `/v1/public/returns/tracking/instructions_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsInstructionsPresignedURLRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns presigned URL to download return label
         * @param {ReturnsLabelPresignedURLRequest} returnsLabelPresignedURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labelPresignedURL: async (returnsLabelPresignedURLRequest: ReturnsLabelPresignedURLRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnsLabelPresignedURLRequest' is not null or undefined
            assertParamExists('labelPresignedURL', 'returnsLabelPresignedURLRequest', returnsLabelPresignedURLRequest)
            const localVarPath = `/v1/public/returns/tracking/label_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsLabelPresignedURLRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns signed product details for given product
         * @param {string} ecommerceId E-commerce ID
         * @param {string} [productId] Product ID
         * @param {string} [language] Language
         * @param {string} [currency] Currency
         * @param {string} [countryCode] Country code
         * @param {string} [orderReference] Order reference; required to resolve the correct site for multi-site Salesforce portals. Optional otherwise.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDetails: async (ecommerceId: string, productId?: string, language?: string, currency?: string, countryCode?: string, orderReference?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('productDetails', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/product_details`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['order_reference'] = orderReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asks for a new return label once the previous one expired unused. Only accepted  while the label status is EXPIRED
         * @param {ReturnsRequestNewLabelRequest} returnsRequestNewLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewLabel: async (returnsRequestNewLabelRequest: ReturnsRequestNewLabelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnsRequestNewLabelRequest' is not null or undefined
            assertParamExists('requestNewLabel', 'returnsRequestNewLabelRequest', returnsRequestNewLabelRequest)
            const localVarPath = `/v1/public/returns/tracking/new_label`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsRequestNewLabelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles a Stripe webhook from live environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeLiveWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/returns/stripe/live/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles a Stripe webhook from test environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeTestWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/returns/stripe/test/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SubmitWithdrawal records a shopper\'s EU right-of-withdrawal declaration from  the portal form and sends the acknowledgment. It never rejects a request  because the order isn\'t found: the time REVER receives it is the legal proof.  FailedPrecondition when the ecommerce hasn\'t enabled the withdrawal form.
         * @param {string} ecommerceId E-commerce whose portal received it (path param).
         * @param {ReturnsSubmitWithdrawalRequest} returnsSubmitWithdrawalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWithdrawal: async (ecommerceId: string, returnsSubmitWithdrawalRequest: ReturnsSubmitWithdrawalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('submitWithdrawal', 'ecommerceId', ecommerceId)
            // verify required parameter 'returnsSubmitWithdrawalRequest' is not null or undefined
            assertParamExists('submitWithdrawal', 'returnsSubmitWithdrawalRequest', returnsSubmitWithdrawalRequest)
            const localVarPath = `/v1/public/returns/{ecommerce_id}/withdrawal`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsSubmitWithdrawalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns tracking information for a given return process
         * @param {ReturnsTrackingInfoRequest} returnsTrackingInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingInfo: async (returnsTrackingInfoRequest: ReturnsTrackingInfoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'returnsTrackingInfoRequest' is not null or undefined
            assertParamExists('trackingInfo', 'returnsTrackingInfoRequest', returnsTrackingInfoRequest)
            const localVarPath = `/v1/public/returns/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsTrackingInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update return process with amount adjustment or refund method change  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} processId Return process ID
         * @param {ReturnsUpdateReturnProcessRequest} returnsUpdateReturnProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReturnProcess: async (processId: string, returnsUpdateReturnProcessRequest: ReturnsUpdateReturnProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateReturnProcess', 'processId', processId)
            // verify required parameter 'returnsUpdateReturnProcessRequest' is not null or undefined
            assertParamExists('updateReturnProcess', 'returnsUpdateReturnProcessRequest', returnsUpdateReturnProcessRequest)
            const localVarPath = `/v1/update/returns/{process_id}/update`
                .replace(`{${"process_id"}}`, encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(returnsUpdateReturnProcessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReturnsApi - functional programming interface
 * @export
 */
export const ReturnsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReturnsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns available refund method change options for a process  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} processId Process ID the change belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableRefundMethodChangeOptions(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsAvailableRefundMethodChangeOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableRefundMethodChangeOptions(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.availableRefundMethodChangeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calculate update for changing compensation to Original Payment Method (gRPC only)  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} processId Return process ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateUpdateAmount(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsCalculateUpdateAmountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateUpdateAmount(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.calculateUpdateAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a return process. Only allowed while the process is in STARTED  status; cancelling reverses any committed refund/exchange/payment amounts,  notifies the customer, cancels the process on the ecommerce platform, and  cancels the process\'s underlying workflows.
         * @param {string} processId Return process ID
         * @param {ReturnsCancelReturnProcessRequest} returnsCancelReturnProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelReturnProcess(processId: string, returnsCancelReturnProcessRequest: ReturnsCancelReturnProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelReturnProcess(processId, returnsCancelReturnProcessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.cancelReturnProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CancelWfpContract - self-service Worry-Free-Purchase cancellation for the  shopper cancellation form. Resolves + authenticates the order (order id +  email), validates WFP eligibility (contract status + 24h window), triggers  the Seel cancel exactly once (no retry), and idempotently records the  cancellation request. The refund is NOT issued here — it is driven by the  contract.cancelled Seel webhook. Failures surface as gRPC status codes  (InvalidArgument, NotFound, FailedPrecondition; Internal for unexpected).
         * @param {string} ecommerceId E-commerce ID (path param).
         * @param {ReturnsCancelWfpContractRequest} returnsCancelWfpContractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelWfpContract(ecommerceId: string, returnsCancelWfpContractRequest: ReturnsCancelWfpContractRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelWfpContract(ecommerceId, returnsCancelWfpContractRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.cancelWfpContract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CreateOrder
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsCreateLiteOrderRequest} returnsCreateLiteOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLiteOrder(ecommerceId: string, returnsCreateLiteOrderRequest: ReturnsCreateLiteOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsCreateLiteOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLiteOrder(ecommerceId, returnsCreateLiteOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.createLiteOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns presigned URL to download delivery note
         * @param {ReturnsDeliveryNotePresignedURLRequest} returnsDeliveryNotePresignedURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryNotePresignedURL(returnsDeliveryNotePresignedURLRequest: ReturnsDeliveryNotePresignedURLRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsDeliveryNotePresignedURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryNotePresignedURL(returnsDeliveryNotePresignedURLRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.deliveryNotePresignedURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns exchange options for a given line item of an order
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsExchangeOptionsRequest} returnsExchangeOptionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeOptions(ecommerceId: string, returnsExchangeOptionsRequest: ReturnsExchangeOptionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsExchangeOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeOptions(ecommerceId, returnsExchangeOptionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.exchangeOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns available exchange timing options for a given ecommerce
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsExchangeTimingsRequest} returnsExchangeTimingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeTimings(ecommerceId: string, returnsExchangeTimingsRequest: ReturnsExchangeTimingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsExchangeTimingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeTimings(ecommerceId, returnsExchangeTimingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.exchangeTimings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GetOrder
         * @param {string} ecommerceId E-commerce ID
         * @param {string} [customerPrintedOrderId] Customer printed order ID
         * @param {string} [email] Email
         * @param {string} [userPreferredLang] User preferred language
         * @param {string} [postalCode] Postal code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(ecommerceId: string, customerPrintedOrderId?: string, email?: string, userPreferredLang?: string, postalCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsGetOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(ecommerceId, customerPrintedOrderId, email, userPreferredLang, postalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.getOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ImportReturn - starts a return given order info and selected items
         * @param {string} ecommerceId E-commerce ID
         * @param {ReturnsImportReturnRequest} returnsImportReturnRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importReturn(ecommerceId: string, returnsImportReturnRequest: ReturnsImportReturnRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsImportReturnResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importReturn(ecommerceId, returnsImportReturnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.importReturn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns presigned URL to download return instructions
         * @param {ReturnsInstructionsPresignedURLRequest} returnsInstructionsPresignedURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instructionsPresignedURL(returnsInstructionsPresignedURLRequest: ReturnsInstructionsPresignedURLRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsInstructionsPresignedURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsPresignedURL(returnsInstructionsPresignedURLRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.instructionsPresignedURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns presigned URL to download return label
         * @param {ReturnsLabelPresignedURLRequest} returnsLabelPresignedURLRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async labelPresignedURL(returnsLabelPresignedURLRequest: ReturnsLabelPresignedURLRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsLabelPresignedURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.labelPresignedURL(returnsLabelPresignedURLRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.labelPresignedURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns signed product details for given product
         * @param {string} ecommerceId E-commerce ID
         * @param {string} [productId] Product ID
         * @param {string} [language] Language
         * @param {string} [currency] Currency
         * @param {string} [countryCode] Country code
         * @param {string} [orderReference] Order reference; required to resolve the correct site for multi-site Salesforce portals. Optional otherwise.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDetails(ecommerceId: string, productId?: string, language?: string, currency?: string, countryCode?: string, orderReference?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsProductDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDetails(ecommerceId, productId, language, currency, countryCode, orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.productDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Asks for a new return label once the previous one expired unused. Only accepted  while the label status is EXPIRED
         * @param {ReturnsRequestNewLabelRequest} returnsRequestNewLabelRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestNewLabel(returnsRequestNewLabelRequest: ReturnsRequestNewLabelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestNewLabel(returnsRequestNewLabelRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.requestNewLabel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles a Stripe webhook from live environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeLiveWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeLiveWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.stripeLiveWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles a Stripe webhook from test environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeTestWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeTestWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.stripeTestWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SubmitWithdrawal records a shopper\'s EU right-of-withdrawal declaration from  the portal form and sends the acknowledgment. It never rejects a request  because the order isn\'t found: the time REVER receives it is the legal proof.  FailedPrecondition when the ecommerce hasn\'t enabled the withdrawal form.
         * @param {string} ecommerceId E-commerce whose portal received it (path param).
         * @param {ReturnsSubmitWithdrawalRequest} returnsSubmitWithdrawalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitWithdrawal(ecommerceId: string, returnsSubmitWithdrawalRequest: ReturnsSubmitWithdrawalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsSubmitWithdrawalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitWithdrawal(ecommerceId, returnsSubmitWithdrawalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.submitWithdrawal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns tracking information for a given return process
         * @param {ReturnsTrackingInfoRequest} returnsTrackingInfoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackingInfo(returnsTrackingInfoRequest: ReturnsTrackingInfoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturnsTrackingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackingInfo(returnsTrackingInfoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.trackingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update return process with amount adjustment or refund method change  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {string} processId Return process ID
         * @param {ReturnsUpdateReturnProcessRequest} returnsUpdateReturnProcessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReturnProcess(processId: string, returnsUpdateReturnProcessRequest: ReturnsUpdateReturnProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReturnProcess(processId, returnsUpdateReturnProcessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReturnsApi.updateReturnProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReturnsApi - factory interface
 * @export
 */
export const ReturnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReturnsApiFp(configuration)
    return {
        /**
         * Returns available refund method change options for a process  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {ReturnsApiAvailableRefundMethodChangeOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableRefundMethodChangeOptions(requestParameters: ReturnsApiAvailableRefundMethodChangeOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsAvailableRefundMethodChangeOptionsResponse> {
            return localVarFp.availableRefundMethodChangeOptions(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculate update for changing compensation to Original Payment Method (gRPC only)  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {ReturnsApiCalculateUpdateAmountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateUpdateAmount(requestParameters: ReturnsApiCalculateUpdateAmountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsCalculateUpdateAmountResponse> {
            return localVarFp.calculateUpdateAmount(requestParameters.processId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a return process. Only allowed while the process is in STARTED  status; cancelling reverses any committed refund/exchange/payment amounts,  notifies the customer, cancels the process on the ecommerce platform, and  cancels the process\'s underlying workflows.
         * @param {ReturnsApiCancelReturnProcessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelReturnProcess(requestParameters: ReturnsApiCancelReturnProcessRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cancelReturnProcess(requestParameters.processId, requestParameters.returnsCancelReturnProcessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * CancelWfpContract - self-service Worry-Free-Purchase cancellation for the  shopper cancellation form. Resolves + authenticates the order (order id +  email), validates WFP eligibility (contract status + 24h window), triggers  the Seel cancel exactly once (no retry), and idempotently records the  cancellation request. The refund is NOT issued here — it is driven by the  contract.cancelled Seel webhook. Failures surface as gRPC status codes  (InvalidArgument, NotFound, FailedPrecondition; Internal for unexpected).
         * @param {ReturnsApiCancelWfpContractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelWfpContract(requestParameters: ReturnsApiCancelWfpContractRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.cancelWfpContract(requestParameters.ecommerceId, requestParameters.returnsCancelWfpContractRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateOrder
         * @param {ReturnsApiCreateLiteOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiteOrder(requestParameters: ReturnsApiCreateLiteOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsCreateLiteOrderResponse> {
            return localVarFp.createLiteOrder(requestParameters.ecommerceId, requestParameters.returnsCreateLiteOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns presigned URL to download delivery note
         * @param {ReturnsApiDeliveryNotePresignedURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryNotePresignedURL(requestParameters: ReturnsApiDeliveryNotePresignedURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsDeliveryNotePresignedURLResponse> {
            return localVarFp.deliveryNotePresignedURL(requestParameters.returnsDeliveryNotePresignedURLRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns exchange options for a given line item of an order
         * @param {ReturnsApiExchangeOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeOptions(requestParameters: ReturnsApiExchangeOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsExchangeOptionsResponse> {
            return localVarFp.exchangeOptions(requestParameters.ecommerceId, requestParameters.returnsExchangeOptionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns available exchange timing options for a given ecommerce
         * @param {ReturnsApiExchangeTimingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeTimings(requestParameters: ReturnsApiExchangeTimingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsExchangeTimingsResponse> {
            return localVarFp.exchangeTimings(requestParameters.ecommerceId, requestParameters.returnsExchangeTimingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * GetOrder
         * @param {ReturnsApiGetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(requestParameters: ReturnsApiGetOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsGetOrderResponse> {
            return localVarFp.getOrder(requestParameters.ecommerceId, requestParameters.customerPrintedOrderId, requestParameters.email, requestParameters.userPreferredLang, requestParameters.postalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * ImportReturn - starts a return given order info and selected items
         * @param {ReturnsApiImportReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importReturn(requestParameters: ReturnsApiImportReturnRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsImportReturnResponse> {
            return localVarFp.importReturn(requestParameters.ecommerceId, requestParameters.returnsImportReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns presigned URL to download return instructions
         * @param {ReturnsApiInstructionsPresignedURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instructionsPresignedURL(requestParameters: ReturnsApiInstructionsPresignedURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsInstructionsPresignedURLResponse> {
            return localVarFp.instructionsPresignedURL(requestParameters.returnsInstructionsPresignedURLRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns presigned URL to download return label
         * @param {ReturnsApiLabelPresignedURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labelPresignedURL(requestParameters: ReturnsApiLabelPresignedURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsLabelPresignedURLResponse> {
            return localVarFp.labelPresignedURL(requestParameters.returnsLabelPresignedURLRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns signed product details for given product
         * @param {ReturnsApiProductDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDetails(requestParameters: ReturnsApiProductDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsProductDetailsResponse> {
            return localVarFp.productDetails(requestParameters.ecommerceId, requestParameters.productId, requestParameters.language, requestParameters.currency, requestParameters.countryCode, requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Asks for a new return label once the previous one expired unused. Only accepted  while the label status is EXPIRED
         * @param {ReturnsApiRequestNewLabelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestNewLabel(requestParameters: ReturnsApiRequestNewLabelRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.requestNewLabel(requestParameters.returnsRequestNewLabelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handles a Stripe webhook from live environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeLiveWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.stripeLiveWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * Handles a Stripe webhook from test environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeTestWebhook(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.stripeTestWebhook(options).then((request) => request(axios, basePath));
        },
        /**
         * SubmitWithdrawal records a shopper\'s EU right-of-withdrawal declaration from  the portal form and sends the acknowledgment. It never rejects a request  because the order isn\'t found: the time REVER receives it is the legal proof.  FailedPrecondition when the ecommerce hasn\'t enabled the withdrawal form.
         * @param {ReturnsApiSubmitWithdrawalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitWithdrawal(requestParameters: ReturnsApiSubmitWithdrawalRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsSubmitWithdrawalResponse> {
            return localVarFp.submitWithdrawal(requestParameters.ecommerceId, requestParameters.returnsSubmitWithdrawalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns tracking information for a given return process
         * @param {ReturnsApiTrackingInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackingInfo(requestParameters: ReturnsApiTrackingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReturnsTrackingInfoResponse> {
            return localVarFp.trackingInfo(requestParameters.returnsTrackingInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update return process with amount adjustment or refund method change  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
         * @param {ReturnsApiUpdateReturnProcessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReturnProcess(requestParameters: ReturnsApiUpdateReturnProcessRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateReturnProcess(requestParameters.processId, requestParameters.returnsUpdateReturnProcessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for availableRefundMethodChangeOptions operation in ReturnsApi.
 * @export
 * @interface ReturnsApiAvailableRefundMethodChangeOptionsRequest
 */
export interface ReturnsApiAvailableRefundMethodChangeOptionsRequest {
    /**
     * Process ID the change belongs to.
     * @type {string}
     * @memberof ReturnsApiAvailableRefundMethodChangeOptions
     */
    readonly processId: string
}

/**
 * Request parameters for calculateUpdateAmount operation in ReturnsApi.
 * @export
 * @interface ReturnsApiCalculateUpdateAmountRequest
 */
export interface ReturnsApiCalculateUpdateAmountRequest {
    /**
     * Return process ID
     * @type {string}
     * @memberof ReturnsApiCalculateUpdateAmount
     */
    readonly processId: string
}

/**
 * Request parameters for cancelReturnProcess operation in ReturnsApi.
 * @export
 * @interface ReturnsApiCancelReturnProcessRequest
 */
export interface ReturnsApiCancelReturnProcessRequest {
    /**
     * Return process ID
     * @type {string}
     * @memberof ReturnsApiCancelReturnProcess
     */
    readonly processId: string

    /**
     * 
     * @type {ReturnsCancelReturnProcessRequest}
     * @memberof ReturnsApiCancelReturnProcess
     */
    readonly returnsCancelReturnProcessRequest: ReturnsCancelReturnProcessRequest
}

/**
 * Request parameters for cancelWfpContract operation in ReturnsApi.
 * @export
 * @interface ReturnsApiCancelWfpContractRequest
 */
export interface ReturnsApiCancelWfpContractRequest {
    /**
     * E-commerce ID (path param).
     * @type {string}
     * @memberof ReturnsApiCancelWfpContract
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsCancelWfpContractRequest}
     * @memberof ReturnsApiCancelWfpContract
     */
    readonly returnsCancelWfpContractRequest: ReturnsCancelWfpContractRequest
}

/**
 * Request parameters for createLiteOrder operation in ReturnsApi.
 * @export
 * @interface ReturnsApiCreateLiteOrderRequest
 */
export interface ReturnsApiCreateLiteOrderRequest {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsApiCreateLiteOrder
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsCreateLiteOrderRequest}
     * @memberof ReturnsApiCreateLiteOrder
     */
    readonly returnsCreateLiteOrderRequest: ReturnsCreateLiteOrderRequest
}

/**
 * Request parameters for deliveryNotePresignedURL operation in ReturnsApi.
 * @export
 * @interface ReturnsApiDeliveryNotePresignedURLRequest
 */
export interface ReturnsApiDeliveryNotePresignedURLRequest {
    /**
     * 
     * @type {ReturnsDeliveryNotePresignedURLRequest}
     * @memberof ReturnsApiDeliveryNotePresignedURL
     */
    readonly returnsDeliveryNotePresignedURLRequest: ReturnsDeliveryNotePresignedURLRequest
}

/**
 * Request parameters for exchangeOptions operation in ReturnsApi.
 * @export
 * @interface ReturnsApiExchangeOptionsRequest
 */
export interface ReturnsApiExchangeOptionsRequest {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsApiExchangeOptions
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsExchangeOptionsRequest}
     * @memberof ReturnsApiExchangeOptions
     */
    readonly returnsExchangeOptionsRequest: ReturnsExchangeOptionsRequest
}

/**
 * Request parameters for exchangeTimings operation in ReturnsApi.
 * @export
 * @interface ReturnsApiExchangeTimingsRequest
 */
export interface ReturnsApiExchangeTimingsRequest {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsApiExchangeTimings
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsExchangeTimingsRequest}
     * @memberof ReturnsApiExchangeTimings
     */
    readonly returnsExchangeTimingsRequest: ReturnsExchangeTimingsRequest
}

/**
 * Request parameters for getOrder operation in ReturnsApi.
 * @export
 * @interface ReturnsApiGetOrderRequest
 */
export interface ReturnsApiGetOrderRequest {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsApiGetOrder
     */
    readonly ecommerceId: string

    /**
     * Customer printed order ID
     * @type {string}
     * @memberof ReturnsApiGetOrder
     */
    readonly customerPrintedOrderId?: string

    /**
     * Email
     * @type {string}
     * @memberof ReturnsApiGetOrder
     */
    readonly email?: string

    /**
     * User preferred language
     * @type {string}
     * @memberof ReturnsApiGetOrder
     */
    readonly userPreferredLang?: string

    /**
     * Postal code
     * @type {string}
     * @memberof ReturnsApiGetOrder
     */
    readonly postalCode?: string
}

/**
 * Request parameters for importReturn operation in ReturnsApi.
 * @export
 * @interface ReturnsApiImportReturnRequest
 */
export interface ReturnsApiImportReturnRequest {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsApiImportReturn
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsImportReturnRequest}
     * @memberof ReturnsApiImportReturn
     */
    readonly returnsImportReturnRequest: ReturnsImportReturnRequest
}

/**
 * Request parameters for instructionsPresignedURL operation in ReturnsApi.
 * @export
 * @interface ReturnsApiInstructionsPresignedURLRequest
 */
export interface ReturnsApiInstructionsPresignedURLRequest {
    /**
     * 
     * @type {ReturnsInstructionsPresignedURLRequest}
     * @memberof ReturnsApiInstructionsPresignedURL
     */
    readonly returnsInstructionsPresignedURLRequest: ReturnsInstructionsPresignedURLRequest
}

/**
 * Request parameters for labelPresignedURL operation in ReturnsApi.
 * @export
 * @interface ReturnsApiLabelPresignedURLRequest
 */
export interface ReturnsApiLabelPresignedURLRequest {
    /**
     * 
     * @type {ReturnsLabelPresignedURLRequest}
     * @memberof ReturnsApiLabelPresignedURL
     */
    readonly returnsLabelPresignedURLRequest: ReturnsLabelPresignedURLRequest
}

/**
 * Request parameters for productDetails operation in ReturnsApi.
 * @export
 * @interface ReturnsApiProductDetailsRequest
 */
export interface ReturnsApiProductDetailsRequest {
    /**
     * E-commerce ID
     * @type {string}
     * @memberof ReturnsApiProductDetails
     */
    readonly ecommerceId: string

    /**
     * Product ID
     * @type {string}
     * @memberof ReturnsApiProductDetails
     */
    readonly productId?: string

    /**
     * Language
     * @type {string}
     * @memberof ReturnsApiProductDetails
     */
    readonly language?: string

    /**
     * Currency
     * @type {string}
     * @memberof ReturnsApiProductDetails
     */
    readonly currency?: string

    /**
     * Country code
     * @type {string}
     * @memberof ReturnsApiProductDetails
     */
    readonly countryCode?: string

    /**
     * Order reference; required to resolve the correct site for multi-site Salesforce portals. Optional otherwise.
     * @type {string}
     * @memberof ReturnsApiProductDetails
     */
    readonly orderReference?: string
}

/**
 * Request parameters for requestNewLabel operation in ReturnsApi.
 * @export
 * @interface ReturnsApiRequestNewLabelRequest
 */
export interface ReturnsApiRequestNewLabelRequest {
    /**
     * 
     * @type {ReturnsRequestNewLabelRequest}
     * @memberof ReturnsApiRequestNewLabel
     */
    readonly returnsRequestNewLabelRequest: ReturnsRequestNewLabelRequest
}

/**
 * Request parameters for submitWithdrawal operation in ReturnsApi.
 * @export
 * @interface ReturnsApiSubmitWithdrawalRequest
 */
export interface ReturnsApiSubmitWithdrawalRequest {
    /**
     * E-commerce whose portal received it (path param).
     * @type {string}
     * @memberof ReturnsApiSubmitWithdrawal
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {ReturnsSubmitWithdrawalRequest}
     * @memberof ReturnsApiSubmitWithdrawal
     */
    readonly returnsSubmitWithdrawalRequest: ReturnsSubmitWithdrawalRequest
}

/**
 * Request parameters for trackingInfo operation in ReturnsApi.
 * @export
 * @interface ReturnsApiTrackingInfoRequest
 */
export interface ReturnsApiTrackingInfoRequest {
    /**
     * 
     * @type {ReturnsTrackingInfoRequest}
     * @memberof ReturnsApiTrackingInfo
     */
    readonly returnsTrackingInfoRequest: ReturnsTrackingInfoRequest
}

/**
 * Request parameters for updateReturnProcess operation in ReturnsApi.
 * @export
 * @interface ReturnsApiUpdateReturnProcessRequest
 */
export interface ReturnsApiUpdateReturnProcessRequest {
    /**
     * Return process ID
     * @type {string}
     * @memberof ReturnsApiUpdateReturnProcess
     */
    readonly processId: string

    /**
     * 
     * @type {ReturnsUpdateReturnProcessRequest}
     * @memberof ReturnsApiUpdateReturnProcess
     */
    readonly returnsUpdateReturnProcessRequest: ReturnsUpdateReturnProcessRequest
}

/**
 * ReturnsApi - object-oriented interface
 * @export
 * @class ReturnsApi
 * @extends {BaseAPI}
 */
export class ReturnsApi extends BaseAPI {
    /**
     * Returns available refund method change options for a process  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {ReturnsApiAvailableRefundMethodChangeOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public availableRefundMethodChangeOptions(requestParameters: ReturnsApiAvailableRefundMethodChangeOptionsRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).availableRefundMethodChangeOptions(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calculate update for changing compensation to Original Payment Method (gRPC only)  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {ReturnsApiCalculateUpdateAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public calculateUpdateAmount(requestParameters: ReturnsApiCalculateUpdateAmountRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).calculateUpdateAmount(requestParameters.processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a return process. Only allowed while the process is in STARTED  status; cancelling reverses any committed refund/exchange/payment amounts,  notifies the customer, cancels the process on the ecommerce platform, and  cancels the process\'s underlying workflows.
     * @param {ReturnsApiCancelReturnProcessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public cancelReturnProcess(requestParameters: ReturnsApiCancelReturnProcessRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).cancelReturnProcess(requestParameters.processId, requestParameters.returnsCancelReturnProcessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CancelWfpContract - self-service Worry-Free-Purchase cancellation for the  shopper cancellation form. Resolves + authenticates the order (order id +  email), validates WFP eligibility (contract status + 24h window), triggers  the Seel cancel exactly once (no retry), and idempotently records the  cancellation request. The refund is NOT issued here — it is driven by the  contract.cancelled Seel webhook. Failures surface as gRPC status codes  (InvalidArgument, NotFound, FailedPrecondition; Internal for unexpected).
     * @param {ReturnsApiCancelWfpContractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public cancelWfpContract(requestParameters: ReturnsApiCancelWfpContractRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).cancelWfpContract(requestParameters.ecommerceId, requestParameters.returnsCancelWfpContractRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateOrder
     * @param {ReturnsApiCreateLiteOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public createLiteOrder(requestParameters: ReturnsApiCreateLiteOrderRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).createLiteOrder(requestParameters.ecommerceId, requestParameters.returnsCreateLiteOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns presigned URL to download delivery note
     * @param {ReturnsApiDeliveryNotePresignedURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public deliveryNotePresignedURL(requestParameters: ReturnsApiDeliveryNotePresignedURLRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).deliveryNotePresignedURL(requestParameters.returnsDeliveryNotePresignedURLRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns exchange options for a given line item of an order
     * @param {ReturnsApiExchangeOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public exchangeOptions(requestParameters: ReturnsApiExchangeOptionsRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).exchangeOptions(requestParameters.ecommerceId, requestParameters.returnsExchangeOptionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns available exchange timing options for a given ecommerce
     * @param {ReturnsApiExchangeTimingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public exchangeTimings(requestParameters: ReturnsApiExchangeTimingsRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).exchangeTimings(requestParameters.ecommerceId, requestParameters.returnsExchangeTimingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GetOrder
     * @param {ReturnsApiGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public getOrder(requestParameters: ReturnsApiGetOrderRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).getOrder(requestParameters.ecommerceId, requestParameters.customerPrintedOrderId, requestParameters.email, requestParameters.userPreferredLang, requestParameters.postalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ImportReturn - starts a return given order info and selected items
     * @param {ReturnsApiImportReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public importReturn(requestParameters: ReturnsApiImportReturnRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).importReturn(requestParameters.ecommerceId, requestParameters.returnsImportReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns presigned URL to download return instructions
     * @param {ReturnsApiInstructionsPresignedURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public instructionsPresignedURL(requestParameters: ReturnsApiInstructionsPresignedURLRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).instructionsPresignedURL(requestParameters.returnsInstructionsPresignedURLRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns presigned URL to download return label
     * @param {ReturnsApiLabelPresignedURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public labelPresignedURL(requestParameters: ReturnsApiLabelPresignedURLRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).labelPresignedURL(requestParameters.returnsLabelPresignedURLRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns signed product details for given product
     * @param {ReturnsApiProductDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public productDetails(requestParameters: ReturnsApiProductDetailsRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).productDetails(requestParameters.ecommerceId, requestParameters.productId, requestParameters.language, requestParameters.currency, requestParameters.countryCode, requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asks for a new return label once the previous one expired unused. Only accepted  while the label status is EXPIRED
     * @param {ReturnsApiRequestNewLabelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public requestNewLabel(requestParameters: ReturnsApiRequestNewLabelRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).requestNewLabel(requestParameters.returnsRequestNewLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handles a Stripe webhook from live environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public stripeLiveWebhook(options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).stripeLiveWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handles a Stripe webhook from test environment  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public stripeTestWebhook(options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).stripeTestWebhook(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SubmitWithdrawal records a shopper\'s EU right-of-withdrawal declaration from  the portal form and sends the acknowledgment. It never rejects a request  because the order isn\'t found: the time REVER receives it is the legal proof.  FailedPrecondition when the ecommerce hasn\'t enabled the withdrawal form.
     * @param {ReturnsApiSubmitWithdrawalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public submitWithdrawal(requestParameters: ReturnsApiSubmitWithdrawalRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).submitWithdrawal(requestParameters.ecommerceId, requestParameters.returnsSubmitWithdrawalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns tracking information for a given return process
     * @param {ReturnsApiTrackingInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public trackingInfo(requestParameters: ReturnsApiTrackingInfoRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).trackingInfo(requestParameters.returnsTrackingInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update return process with amount adjustment or refund method change  buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE  buf:lint:ignore RPC_REQUEST_STANDARD_NAME  buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
     * @param {ReturnsApiUpdateReturnProcessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReturnsApi
     */
    public updateReturnProcess(requestParameters: ReturnsApiUpdateReturnProcessRequest, options?: RawAxiosRequestConfig) {
        return ReturnsApiFp(this.configuration).updateReturnProcess(requestParameters.processId, requestParameters.returnsUpdateReturnProcessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a new set of settings to a given section (column)
         * @param {PbAddNewPASettingRequest} pbAddNewPASettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewPASetting: async (pbAddNewPASettingRequest: PbAddNewPASettingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbAddNewPASettingRequest' is not null or undefined
            assertParamExists('addNewPASetting', 'pbAddNewPASettingRequest', pbAddNewPASettingRequest)
            const localVarPath = `/v1/configs/product-automations/utils/add_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAddNewPASettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new section (column) to the PA settings table
         * @param {PbAddPASettingsSectionRequest} pbAddPASettingsSectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPASettingsSection: async (pbAddPASettingsSectionRequest: PbAddPASettingsSectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbAddPASettingsSectionRequest' is not null or undefined
            assertParamExists('addPASettingsSection', 'pbAddPASettingsSectionRequest', pbAddPASettingsSectionRequest)
            const localVarPath = `/v1/configs/product-automations/utils/add_section`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAddPASettingsSectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Makes one of the group\'s Nango connections the one an ecommerce reads its platform credentials from
         * @param {PbAssignNangoPlatformConnectionRequest} pbAssignNangoPlatformConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignNangoPlatformConnection: async (pbAssignNangoPlatformConnectionRequest: PbAssignNangoPlatformConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbAssignNangoPlatformConnectionRequest' is not null or undefined
            assertParamExists('assignNangoPlatformConnection', 'pbAssignNangoPlatformConnectionRequest', pbAssignNangoPlatformConnectionRequest)
            const localVarPath = `/v1/configs/integrations/nango/platform-connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbAssignNangoPlatformConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Asks the store whether it accepts one of the group\'s Nango connections now, and records the answer
         * @param {string} group Ecommerce group the connection belongs to.
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {PbCheckNangoConnectionRequest} pbCheckNangoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNangoConnection: async (group: string, integration: string, connectionId: string, pbCheckNangoConnectionRequest: PbCheckNangoConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('checkNangoConnection', 'group', group)
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('checkNangoConnection', 'integration', integration)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('checkNangoConnection', 'connectionId', connectionId)
            // verify required parameter 'pbCheckNangoConnectionRequest' is not null or undefined
            assertParamExists('checkNangoConnection', 'pbCheckNangoConnectionRequest', pbCheckNangoConnectionRequest)
            const localVarPath = `/v1/configs/integrations/nango/groups/{group}/connections/{integration}/{connection_id}/check`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)))
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCheckNangoConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an API key with the chosen scopes for an ecommerce group and returns its value.  Creating a name the group already holds returns that existing key. Admins only.
         * @param {PbCreateAPIKeyRequest} pbCreateAPIKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAPIKey: async (pbCreateAPIKeyRequest: PbCreateAPIKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbCreateAPIKeyRequest' is not null or undefined
            assertParamExists('createAPIKey', 'pbCreateAPIKeyRequest', pbCreateAPIKeyRequest)
            const localVarPath = `/v1/configs/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCreateAPIKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Opens a Nango Connect session whose connections are tagged with the group
         * @param {PbCreateNangoConnectSessionRequest} pbCreateNangoConnectSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNangoConnectSession: async (pbCreateNangoConnectSessionRequest: PbCreateNangoConnectSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbCreateNangoConnectSessionRequest' is not null or undefined
            assertParamExists('createNangoConnectSession', 'pbCreateNangoConnectSessionRequest', pbCreateNangoConnectSessionRequest)
            const localVarPath = `/v1/configs/integrations/nango/connect-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCreateNangoConnectSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Opens a Nango Connect session that replaces the credentials of one of the group\'s connections
         * @param {string} group Ecommerce group the connection belongs to.
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {PbCreateNangoReconnectSessionRequest} pbCreateNangoReconnectSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNangoReconnectSession: async (group: string, integration: string, connectionId: string, pbCreateNangoReconnectSessionRequest: PbCreateNangoReconnectSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('createNangoReconnectSession', 'group', group)
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('createNangoReconnectSession', 'integration', integration)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('createNangoReconnectSession', 'connectionId', connectionId)
            // verify required parameter 'pbCreateNangoReconnectSessionRequest' is not null or undefined
            assertParamExists('createNangoReconnectSession', 'pbCreateNangoReconnectSessionRequest', pbCreateNangoReconnectSessionRequest)
            const localVarPath = `/v1/configs/integrations/nango/groups/{group}/connections/{integration}/{connection_id}/reconnect-session`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)))
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCreateNangoReconnectSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CreateUser
         * @param {PbCreateUserRequest} pbCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (pbCreateUserRequest: PbCreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbCreateUserRequest' is not null or undefined
            assertParamExists('createUser', 'pbCreateUserRequest', pbCreateUserRequest)
            const localVarPath = `/v1/configs/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCreateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a carrier connection
         * @param {string} id Connection id.
         * @param {string} [group] Ecommerce group the connection belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierConnection: async (id: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCarrierConnection', 'id', id)
            const localVarPath = `/v1/configs/logistics/connections/carriers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the overrides of an ecommerce for the given kinds, which locks them back to its group\'s
         * @param {string} ecommerceId Ecommerce id
         * @param {Array<DeleteExchangesSettingsOverridesV2KindsEnum>} [kinds] The kinds to follow from its group again
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExchangesSettingsOverridesV2: async (ecommerceId: string, kinds?: Array<DeleteExchangesSettingsOverridesV2KindsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deleteExchangesSettingsOverridesV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/exchanges/overrides`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes one of the group\'s Nango connections, unassigning it from every store
         * @param {string} group Ecommerce group the connection belongs to.
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNangoConnection: async (group: string, integration: string, connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('deleteNangoConnection', 'group', group)
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('deleteNangoConnection', 'integration', integration)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('deleteNangoConnection', 'connectionId', connectionId)
            const localVarPath = `/v1/configs/integrations/nango/groups/{group}/connections/{integration}/{connection_id}`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)))
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a partner connection; fails while a carrier connection still books through it
         * @param {string} id Connection id.
         * @param {string} [group] Ecommerce group the connection belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerConnection: async (id: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePartnerConnection', 'id', id)
            const localVarPath = `/v1/configs/logistics/connections/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the override of an ecommerce, which locks its RDV surplus rules back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRDVSurplusOverrideV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deleteRDVSurplusOverrideV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/rdv-surplus/override`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the override of an ecommerce, which locks its refund configuration back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRefundConfigurationOverrideV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deleteRefundConfigurationOverrideV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/refunds/override`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the override of an ecommerce, which locks its return conditions back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReturnProcessConditionsOverrideV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deleteReturnProcessConditionsOverrideV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/return-conditions/override`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the override of an ecommerce, which locks its return reasons back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReturnReasonsOverrideV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deleteReturnReasonsOverrideV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/return-reasons/override`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the routing rules override of an ecommerce, which locks it back to its group\'s rules
         * @param {string} ecommerceId Ecommerce id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWarehouseConfigOverrideV2: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('deleteWarehouseConfigOverrideV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/warehouses/config/override`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes warehouses of an ecommerce group. Fails while a routing rule still uses one of them.
         * @param {string} ecommerceGroup Ecommerce group that owns the warehouses
         * @param {PbDeleteWarehousesV2Request} pbDeleteWarehousesV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWarehousesV2: async (ecommerceGroup: string, pbDeleteWarehousesV2Request: PbDeleteWarehousesV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('deleteWarehousesV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbDeleteWarehousesV2Request' is not null or undefined
            assertParamExists('deleteWarehousesV2', 'pbDeleteWarehousesV2Request', pbDeleteWarehousesV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/warehouses/delete`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbDeleteWarehousesV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding LogisticsSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBranding: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findBranding', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/branding/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Branding model
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBrandingPublic: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/configs/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Credentials model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCredentials: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findCredentials', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/credentials/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Ecommerce model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEcommerce: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findEcommerce', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/ecommerce/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the points of contact of the e-commerce\'s group, which every store of  the group shares. Deprecated: use FindGroupContacts.
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEcommerceContacts: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findEcommerceContacts', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/contacts/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding ExchangeConditions model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findExchangeConditions: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findExchangeConditions', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/exchangeconditions/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding ExchangeOrder model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findExchangeOrder: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findExchangeOrder', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/exchangeorders/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the points of contact of a group, shared by every store of the  group. A group with no stored contacts gets an empty list back.
         * @param {string} ecommerceGroup Group. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupContacts: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('findGroupContacts', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v1/configs/group-contacts/{ecommerce_group}`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding InStoreSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInStoreSettings: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findInStoreSettings', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/instoresettings/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * finds the return reasons to show for a specific item
         * @param {string} [ecommerceId] ecommerce id
         * @param {Array<string>} [categoryIds] category ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findItemReturnReasons: async (ecommerceId?: string, categoryIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/configs/return-reasons/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * POST variant of FindItemReturnReasons for callers that need to send the  request in the body (e.g. very large category_ids lists that would exceed  URL length limits at Envoy). Delegates to the same handler.
         * @param {PbFindItemReturnReason} pbFindItemReturnReason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findItemReturnReasonsByBody: async (pbFindItemReturnReason: PbFindItemReturnReason, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbFindItemReturnReason' is not null or undefined
            assertParamExists('findItemReturnReasonsByBody', 'pbFindItemReturnReason', pbFindItemReturnReason)
            const localVarPath = `/v1/public/configs/return-reasons/find`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbFindItemReturnReason, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding LogisticSetting model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLogisticSetting: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findLogisticSetting', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/logisticsetting/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Branding model
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPortalSettings: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/configs/portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindRefundConfiguration
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRefundConfiguration: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding LogisticsSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReturnProcessConditions: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findReturnProcessConditions', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/returnconditions/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tells whether a Shopify store has the App Automation token REVER deploys its Shopify app with, and when it expires
         * @param {string} [ecommerceId] Ecommerce of the Shopify store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findShopifyAppAutomationToken: async (ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/integrations/nango/app-automation-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FindUsers lists the dashboard users of the caller\'s own group. The group is  taken from the caller\'s claim, never from the request, so it cannot be spoofed.
         * @param {string} [ecommerceId] Optional. Lists the users of this ecommerce\&#39;s group instead of the caller\&#39;s own group.  The dashboard needs it for REVER staff, whose own group is \&quot;*\&quot;: without it the list  answers with other REVER staff no matter which ecommerce is on screen. A caller may  only name an ecommerce in their own group, or be REVER staff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers: async (ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Warehouse model, ecommerce or group-level
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWarehouse: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findWarehouse', 'id', id)
            const localVarPath = `/v1/configs/warehouses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Warehouses by ecommerce id
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWarehousesByEcommerce: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findWarehousesByEcommerce', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/ecommerces/{ecommerce_id}/warehouses`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finds the warehouses of an ecommerce group
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWarehousesByGroupV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('findWarehousesByGroupV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/warehouses`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves whether an e-commerce\'s portal has the EU withdrawal form. Callers  only see their own group\'s e-commerces.
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWithdrawalSettings: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findWithdrawalSettings', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/ecommerces/{ecommerce_id}/withdrawal`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding WorkflowConfigurations model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkflowConfigurations: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('findWorkflowConfigurations', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/workflowconfigurations/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates the secret REVER signs this ecommerce group\'s outgoing webhooks with,  replacing and revoking the current one. Returns the plaintext so the caller can show  it.   The secret belongs to the group, not to the ecommerce: receivers normally handle  every ecommerce of a group in one endpoint, and picking a key per ecommerce would  force them to parse the body before they could verify it. The ecommerce id here only  says which ecommerce the caller came in through.   One path serves both surfaces: the dashboard reaches it through Envoy with the  tenant\'s own group claim, and the backoffice over gRPC directly with the \"*\" claims  it injects itself. Attribution comes from the username claim, never from a request  field, so no caller can record the change against someone else.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {PbWebhookSigningSecretRequest} pbWebhookSigningSecretRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebhookSigningSecret: async (ecommerceId: string, pbWebhookSigningSecretRequest: PbWebhookSigningSecretRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('generateWebhookSigningSecret', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbWebhookSigningSecretRequest' is not null or undefined
            assertParamExists('generateWebhookSigningSecret', 'pbWebhookSigningSecretRequest', pbWebhookSigningSecretRequest)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/signing-secret`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbWebhookSigningSecretRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the value of an existing API key so an admin can copy it again. Admins only.
         * @param {string} [ecommerceGroup] Ecommerce group of the key
         * @param {string} [name] Name of the key within its group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPIKeyValue: async (ecommerceGroup?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/api-keys/value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceGroup !== undefined) {
                localVarQueryParameter['ecommerce_group'] = ecommerceGroup;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * finds all ecommerce return reasons by ecommerce id
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReturnReasons: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/configs/return-reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding warehouse address
         * @param {string} ecommerceId ecommerce id
         * @param {PbGetWarehouseRequest} pbGetWarehouseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicWarehouse: async (ecommerceId: string, pbGetWarehouseRequest: PbGetWarehouseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getDynamicWarehouse', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbGetWarehouseRequest' is not null or undefined
            assertParamExists('getDynamicWarehouse', 'pbGetWarehouseRequest', pbGetWarehouseRequest)
            const localVarPath = `/v1/configs/ecommerces/{ecommerce_id}/dynamicwarehouse`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbGetWarehouseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the settings for the given e-commerce, without secrets
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceSettings: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/settings/ecommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the settings for the given e-commerce, without secrets
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceSettingsDeprecated: async (slug?: string, ecommerceId?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/settings/ecommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {string} [slug] The slug of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceTextCopies: async (ecommerceId?: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/settings/ecommerce/copies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {string} [slug] The slug of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceTextCopiesV2: async (ecommerceId?: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/settings/copies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {string} [slug] The slug of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceTextCopiesV3: async (ecommerceId?: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/settings/portal/i18n`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the exchanges settings an ecommerce gets: for each kind, its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceExchangesSettingsV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceExchangesSettingsV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/exchanges`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the PA settings for the specified ecommerce
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommercePASettings: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommercePASettings', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/product-automations/ecommerce/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the RDV surplus rules an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceRDVSurplusV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceRDVSurplusV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/rdv-surplus`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the refund configuration an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceRefundConfigurationV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceRefundConfigurationV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/refunds`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the return conditions an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceReturnProcessConditionsV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceReturnProcessConditionsV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/return-conditions`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the return reasons an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceReturnReasonsV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceReturnReasonsV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/return-reasons`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of settings, without secrets,   one per e-commerce in the group
         * @param {string} [name] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceSettingsByGroup: async (name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/settings/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of settings, without secrets,   one per e-commerce in the group
         * @param {string} [name] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceSettingsByGroupDeprecated: async (name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/settings/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the effective warehouse routing rules of an ecommerce: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceWarehouseConfigsV2: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getEcommerceWarehouseConfigsV2', 'ecommerceId', ecommerceId)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/warehouses/config`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the PA settings for an ecommerce and returns them flattened
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlattenedPASettings: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getFlattenedPASettings', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/product-automations/ecommerces/{ecommerce_id}/flattened`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the exchanges settings of a group, and the ones each of its ecommerces overrides
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupExchangesSettingsV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getGroupExchangesSettingsV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/exchanges`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the RDV surplus rules of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupRDVSurplusV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getGroupRDVSurplusV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/rdv-surplus`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the refund configuration of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupRefundConfigurationV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getGroupRefundConfigurationV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/refunds`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the return conditions of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupReturnProcessConditionsV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getGroupReturnProcessConditionsV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/return-conditions`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the return reasons of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupReturnReasonsV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getGroupReturnReasonsV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/return-reasons`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads the warehouse routing rules of a group
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupWarehouseConfigsV2: async (ecommerceGroup: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('getGroupWarehouseConfigsV2', 'ecommerceGroup', ecommerceGroup)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/warehouses/config`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of return amount business rules for a given e-commerce
         * @param {string} ecommerceId The id of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnAmount: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getReturnAmount', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/businessrules/ecommerce/{ecommerce_id}/returnamount`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of return amount available businessrules for a given e-commerce
         * @param {string} ecommerceId The id of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnAmountAvailable: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getReturnAmountAvailable', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/businessrules/ecommerce/{ecommerce_id}/returnamount-available`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get risk exposure settings for an e-commerce
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskExposureSettings: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getRiskExposureSettings', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/risk-exposure-settings/{ecommerce_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for finding Warehouses config by ecommerce id
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseConfigsPublic: async (ecommerceId: string, slug?: string, group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getWarehouseConfigsPublic', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/ecommerces/{ecommerce_id}/warehouses/config`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reveals the active webhook signing secret of the ecommerce\'s group so the tenant can  compare it against what its own verification code uses.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookSigningSecret: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getWebhookSigningSecret', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/signing-secret`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns whether the ecommerce is subscribed to the return-started and  return-completed webhooks and the destination URL they are posted to.
         * @param {string} ecommerceId The ecommerce id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookSubscriptions: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('getWebhookSubscriptions', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/subscriptions`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Links one of the group\'s Nango connections to an ecommerce
         * @param {PbLinkNangoConnectionRequest} pbLinkNangoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkNangoConnection: async (pbLinkNangoConnectionRequest: PbLinkNangoConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbLinkNangoConnectionRequest' is not null or undefined
            assertParamExists('linkNangoConnection', 'pbLinkNangoConnectionRequest', pbLinkNangoConnectionRequest)
            const localVarPath = `/v1/configs/integrations/nango/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbLinkNangoConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the ecommerce groups that hold at least one API key and that the caller may manage:  every group for REVER staff, the caller\'s own group for anyone else. Admins only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeyGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/api-keys/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the API keys of the requested ecommerce groups, never their values. Admins only,  and only groups the caller\'s claim covers.
         * @param {Array<string>} [ecommerceGroups] Ecommerce groups to list. Empty lists the caller\&#39;s own group; REVER staff, who have no  group of their own, must name at least one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeys: async (ecommerceGroups?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceGroups) {
                localVarQueryParameter['ecommerce_groups'] = ecommerceGroups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists a group\'s carrier connections, secrets masked
         * @param {string} [group] Ecommerce group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierConnections: async (group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/logistics/connections/carriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the Nango connections of a group, with the stores each one is assigned to
         * @param {string} group Ecommerce group whose connections to list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupNangoConnections: async (group: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'group' is not null or undefined
            assertParamExists('listGroupNangoConnections', 'group', group)
            const localVarPath = `/v1/configs/integrations/nango/groups/{group}/connections`
                .replace(`{${"group"}}`, encodeURIComponent(String(group)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists the Nango connections an ecommerce uses
         * @param {string} [ecommerceId] Ecommerce whose connections to list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNangoConnections: async (ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/integrations/nango/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists a group\'s partner connections, secrets masked
         * @param {string} [group] Ecommerce group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerConnections: async (group?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/logistics/connections/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists every signing secret ever issued to the ecommerce\'s group, newest first,  redacted, along with the ecommerces that share it. The audit view for \"who rotated  this and when\"; it never returns a secret value.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhookSigningSecrets: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('listWebhookSigningSecrets', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/signing-secrets`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for Me request with accesible ecommerces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Onboard an e-commerce with the return amount business rules
         * @param {PbOnboardingRequest} pbOnboardingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboard: async (pbOnboardingRequest: PbOnboardingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbOnboardingRequest' is not null or undefined
            assertParamExists('onboard', 'pbOnboardingRequest', pbOnboardingRequest)
            const localVarPath = `/v1/onboarding/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbOnboardingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint an e-commerce may use to change a subset of its own branding
         * @param {PbPatchBrandingReq} pbPatchBrandingReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBranding: async (pbPatchBrandingReq: PbPatchBrandingReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbPatchBrandingReq' is not null or undefined
            assertParamExists('patchBranding', 'pbPatchBrandingReq', pbPatchBrandingReq)
            const localVarPath = `/v1/configs/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbPatchBrandingReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for patching the ReturnConditions attributes an e-commerce may change  itself: the return period, the shipping deadline, the return reason options, the  review auto-completion and the non-returnable product, collection, category, tag and  order tag lists. Any other attribute is rejected with PERMISSION_DENIED.
         * @param {PbPatchReturnProcessConditionsReq} pbPatchReturnProcessConditionsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReturnProcessConditions: async (pbPatchReturnProcessConditionsReq: PbPatchReturnProcessConditionsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbPatchReturnProcessConditionsReq' is not null or undefined
            assertParamExists('patchReturnProcessConditions', 'pbPatchReturnProcessConditionsReq', pbPatchReturnProcessConditionsReq)
            const localVarPath = `/v1/configs/returnconditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbPatchReturnProcessConditionsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the list of return amount business rules to a given e-commerce
         * @param {string} ecommerceId The id of the e-commerce.
         * @param {PbPostReturnAmountRequest} pbPostReturnAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReturnAmount: async (ecommerceId: string, pbPostReturnAmountRequest: PbPostReturnAmountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('postReturnAmount', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbPostReturnAmountRequest' is not null or undefined
            assertParamExists('postReturnAmount', 'pbPostReturnAmountRequest', pbPostReturnAmountRequest)
            const localVarPath = `/v1/businessrules/ecommerce/{ecommerce_id}/returnamount`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbPostReturnAmountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return list of return amount available businessrules for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicReturnAmountAvailable: async (ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/onboarding/returnamounts/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revokes an API key: requests made with it stop being authorized. Admins only.
         * @param {string} [ecommerceGroup] Ecommerce group of the key
         * @param {string} [name] Name of the key within its group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAPIKey: async (ecommerceGroup?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/configs/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceGroup !== undefined) {
                localVarQueryParameter['ecommerce_group'] = ecommerceGroup;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revokes the active webhook signing secret, returning every ecommerce of the group to  unsigned deliveries.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeWebhookSigningSecret: async (ecommerceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('revokeWebhookSigningSecret', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/signing-secret`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving LogisticsSettings model
         * @param {PbSaveBrandingReq} pbSaveBrandingReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBranding: async (pbSaveBrandingReq: PbSaveBrandingReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveBrandingReq' is not null or undefined
            assertParamExists('saveBranding', 'pbSaveBrandingReq', pbSaveBrandingReq)
            const localVarPath = `/v1/configs/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveBrandingReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates a carrier connection, validated against the provider declarations
         * @param {PbSaveCarrierConnectionRequest} pbSaveCarrierConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCarrierConnection: async (pbSaveCarrierConnectionRequest: PbSaveCarrierConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveCarrierConnectionRequest' is not null or undefined
            assertParamExists('saveCarrierConnection', 'pbSaveCarrierConnectionRequest', pbSaveCarrierConnectionRequest)
            const localVarPath = `/v1/configs/logistics/connections/carriers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveCarrierConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving Credentials model
         * @param {PbCredentials} pbCredentials 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCredentials: async (pbCredentials: PbCredentials, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbCredentials' is not null or undefined
            assertParamExists('saveCredentials', 'pbCredentials', pbCredentials)
            const localVarPath = `/v1/configs/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving Ecommerce model
         * @param {PbSaveEcommerceReq} pbSaveEcommerceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerce: async (pbSaveEcommerceReq: PbSaveEcommerceReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveEcommerceReq' is not null or undefined
            assertParamExists('saveEcommerce', 'pbSaveEcommerceReq', pbSaveEcommerceReq)
            const localVarPath = `/v1/configs/ecommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the points of contact of the e-commerce\'s group with the ones in the  request. Deprecated: use SaveGroupContacts.
         * @param {PbSaveEcommerceContactsRequest} pbSaveEcommerceContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceContacts: async (pbSaveEcommerceContactsRequest: PbSaveEcommerceContactsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveEcommerceContactsRequest' is not null or undefined
            assertParamExists('saveEcommerceContacts', 'pbSaveEcommerceContactsRequest', pbSaveEcommerceContactsRequest)
            const localVarPath = `/v1/configs/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the override of an ecommerce for the kinds present in the request, which unlocks them from  its group\'s. Needs write access; instant exchange is REVER only.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceExchangesSettingsV2Request} pbSaveEcommerceExchangesSettingsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceExchangesSettingsV2: async (ecommerceId: string, pbSaveEcommerceExchangesSettingsV2Request: PbSaveEcommerceExchangesSettingsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('saveEcommerceExchangesSettingsV2', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSaveEcommerceExchangesSettingsV2Request' is not null or undefined
            assertParamExists('saveEcommerceExchangesSettingsV2', 'pbSaveEcommerceExchangesSettingsV2Request', pbSaveEcommerceExchangesSettingsV2Request)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/exchanges`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceExchangesSettingsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its RDV surplus rules from its group\'s. Needs  write access.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceRDVSurplusV2Request} pbSaveEcommerceRDVSurplusV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceRDVSurplusV2: async (ecommerceId: string, pbSaveEcommerceRDVSurplusV2Request: PbSaveEcommerceRDVSurplusV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('saveEcommerceRDVSurplusV2', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSaveEcommerceRDVSurplusV2Request' is not null or undefined
            assertParamExists('saveEcommerceRDVSurplusV2', 'pbSaveEcommerceRDVSurplusV2Request', pbSaveEcommerceRDVSurplusV2Request)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/rdv-surplus`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceRDVSurplusV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its refund configuration from its group\'s.  Needs write access.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceRefundConfigurationV2Request} pbSaveEcommerceRefundConfigurationV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceRefundConfigurationV2: async (ecommerceId: string, pbSaveEcommerceRefundConfigurationV2Request: PbSaveEcommerceRefundConfigurationV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('saveEcommerceRefundConfigurationV2', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSaveEcommerceRefundConfigurationV2Request' is not null or undefined
            assertParamExists('saveEcommerceRefundConfigurationV2', 'pbSaveEcommerceRefundConfigurationV2Request', pbSaveEcommerceRefundConfigurationV2Request)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/refunds`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceRefundConfigurationV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its return conditions from its group\'s. Needs  write access; skip_fraud_detection, payments_enabled and the fields v1 keeps from merchants are REVER only.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceReturnProcessConditionsV2Request} pbSaveEcommerceReturnProcessConditionsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceReturnProcessConditionsV2: async (ecommerceId: string, pbSaveEcommerceReturnProcessConditionsV2Request: PbSaveEcommerceReturnProcessConditionsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('saveEcommerceReturnProcessConditionsV2', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSaveEcommerceReturnProcessConditionsV2Request' is not null or undefined
            assertParamExists('saveEcommerceReturnProcessConditionsV2', 'pbSaveEcommerceReturnProcessConditionsV2Request', pbSaveEcommerceReturnProcessConditionsV2Request)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/return-conditions`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceReturnProcessConditionsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its return reasons from its group\'s. Needs write  access.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceReturnReasonsV2Request} pbSaveEcommerceReturnReasonsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceReturnReasonsV2: async (ecommerceId: string, pbSaveEcommerceReturnReasonsV2Request: PbSaveEcommerceReturnReasonsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('saveEcommerceReturnReasonsV2', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSaveEcommerceReturnReasonsV2Request' is not null or undefined
            assertParamExists('saveEcommerceReturnReasonsV2', 'pbSaveEcommerceReturnReasonsV2Request', pbSaveEcommerceReturnReasonsV2Request)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/return-reasons`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveEcommerceReturnReasonsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or replaces the routing rules override of an ecommerce, which unlocks it from its group\'s rules.  The override may only use the group\'s warehouses.
         * @param {string} ecommerceId EcommerceID
         * @param {PbSaveWarehouseConfigRequest} pbSaveWarehouseConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceWarehouseConfigsV2: async (ecommerceId: string, pbSaveWarehouseConfigRequest: PbSaveWarehouseConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('saveEcommerceWarehouseConfigsV2', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSaveWarehouseConfigRequest' is not null or undefined
            assertParamExists('saveEcommerceWarehouseConfigsV2', 'pbSaveWarehouseConfigRequest', pbSaveWarehouseConfigRequest)
            const localVarPath = `/v2/configs/ecommerces/{ecommerce_id}/warehouses/config`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveWarehouseConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving ExchangeConditions model
         * @param {PbSaveExchangeConditionsReq} pbSaveExchangeConditionsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExchangeConditions: async (pbSaveExchangeConditionsReq: PbSaveExchangeConditionsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveExchangeConditionsReq' is not null or undefined
            assertParamExists('saveExchangeConditions', 'pbSaveExchangeConditionsReq', pbSaveExchangeConditionsReq)
            const localVarPath = `/v1/configs/exchangeconditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveExchangeConditionsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving ExchangeOrder model
         * @param {PbSaveExchangeOrderWithEcommerceReq} pbSaveExchangeOrderWithEcommerceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExchangeOrder: async (pbSaveExchangeOrderWithEcommerceReq: PbSaveExchangeOrderWithEcommerceReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveExchangeOrderWithEcommerceReq' is not null or undefined
            assertParamExists('saveExchangeOrder', 'pbSaveExchangeOrderWithEcommerceReq', pbSaveExchangeOrderWithEcommerceReq)
            const localVarPath = `/v1/configs/exchangeorders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveExchangeOrderWithEcommerceReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the points of contact of a group with the ones in the request.  Anything stored but missing from the request is removed.
         * @param {PbSaveGroupContactsRequest} pbSaveGroupContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupContacts: async (pbSaveGroupContactsRequest: PbSaveGroupContactsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveGroupContactsRequest' is not null or undefined
            assertParamExists('saveGroupContacts', 'pbSaveGroupContactsRequest', pbSaveGroupContactsRequest)
            const localVarPath = `/v1/configs/group-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupContactsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the kinds of exchanges settings present in the request for a group. Needs write access; instant  exchange is REVER only.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupExchangesSettingsV2Request} pbSaveGroupExchangesSettingsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupExchangesSettingsV2: async (ecommerceGroup: string, pbSaveGroupExchangesSettingsV2Request: PbSaveGroupExchangesSettingsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveGroupExchangesSettingsV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveGroupExchangesSettingsV2Request' is not null or undefined
            assertParamExists('saveGroupExchangesSettingsV2', 'pbSaveGroupExchangesSettingsV2Request', pbSaveGroupExchangesSettingsV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/exchanges`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupExchangesSettingsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the RDV surplus rules of a group. Needs write access.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupRDVSurplusV2Request} pbSaveGroupRDVSurplusV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupRDVSurplusV2: async (ecommerceGroup: string, pbSaveGroupRDVSurplusV2Request: PbSaveGroupRDVSurplusV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveGroupRDVSurplusV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveGroupRDVSurplusV2Request' is not null or undefined
            assertParamExists('saveGroupRDVSurplusV2', 'pbSaveGroupRDVSurplusV2Request', pbSaveGroupRDVSurplusV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/rdv-surplus`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupRDVSurplusV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the refund configuration of a group. Needs write access.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupRefundConfigurationV2Request} pbSaveGroupRefundConfigurationV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupRefundConfigurationV2: async (ecommerceGroup: string, pbSaveGroupRefundConfigurationV2Request: PbSaveGroupRefundConfigurationV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveGroupRefundConfigurationV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveGroupRefundConfigurationV2Request' is not null or undefined
            assertParamExists('saveGroupRefundConfigurationV2', 'pbSaveGroupRefundConfigurationV2Request', pbSaveGroupRefundConfigurationV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/refunds`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupRefundConfigurationV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the return conditions of a group. Needs write access; skip_fraud_detection, payments_enabled and the  fields v1 keeps from merchants are REVER only.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupReturnProcessConditionsV2Request} pbSaveGroupReturnProcessConditionsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupReturnProcessConditionsV2: async (ecommerceGroup: string, pbSaveGroupReturnProcessConditionsV2Request: PbSaveGroupReturnProcessConditionsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveGroupReturnProcessConditionsV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveGroupReturnProcessConditionsV2Request' is not null or undefined
            assertParamExists('saveGroupReturnProcessConditionsV2', 'pbSaveGroupReturnProcessConditionsV2Request', pbSaveGroupReturnProcessConditionsV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/return-conditions`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupReturnProcessConditionsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the return reasons of a group. Needs write access.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupReturnReasonsV2Request} pbSaveGroupReturnReasonsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupReturnReasonsV2: async (ecommerceGroup: string, pbSaveGroupReturnReasonsV2Request: PbSaveGroupReturnReasonsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveGroupReturnReasonsV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveGroupReturnReasonsV2Request' is not null or undefined
            assertParamExists('saveGroupReturnReasonsV2', 'pbSaveGroupReturnReasonsV2Request', pbSaveGroupReturnReasonsV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/return-reasons`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupReturnReasonsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces the warehouse routing rules of a group, which may only use the group\'s warehouses
         * @param {string} ecommerceGroup Ecommerce group whose routing rules to replace
         * @param {PbSaveGroupWarehouseConfigsV2Request} pbSaveGroupWarehouseConfigsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupWarehouseConfigsV2: async (ecommerceGroup: string, pbSaveGroupWarehouseConfigsV2Request: PbSaveGroupWarehouseConfigsV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveGroupWarehouseConfigsV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveGroupWarehouseConfigsV2Request' is not null or undefined
            assertParamExists('saveGroupWarehouseConfigsV2', 'pbSaveGroupWarehouseConfigsV2Request', pbSaveGroupWarehouseConfigsV2Request)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/warehouses/config`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveGroupWarehouseConfigsV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving InStoreSettings model
         * @param {PbSaveInStoreSettingsReq} pbSaveInStoreSettingsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInStoreSettings: async (pbSaveInStoreSettingsReq: PbSaveInStoreSettingsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveInStoreSettingsReq' is not null or undefined
            assertParamExists('saveInStoreSettings', 'pbSaveInStoreSettingsReq', pbSaveInStoreSettingsReq)
            const localVarPath = `/v1/configs/instoresettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveInStoreSettingsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving LogisticSetting model
         * @param {PbSaveLogisticSettingReq} pbSaveLogisticSettingReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLogisticSetting: async (pbSaveLogisticSettingReq: PbSaveLogisticSettingReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveLogisticSettingReq' is not null or undefined
            assertParamExists('saveLogisticSetting', 'pbSaveLogisticSettingReq', pbSaveLogisticSettingReq)
            const localVarPath = `/v1/configs/logisticsetting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveLogisticSettingReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates a partner connection, validated against the provider declarations
         * @param {PbSavePartnerConnectionRequest} pbSavePartnerConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePartnerConnection: async (pbSavePartnerConnectionRequest: PbSavePartnerConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSavePartnerConnectionRequest' is not null or undefined
            assertParamExists('savePartnerConnection', 'pbSavePartnerConnectionRequest', pbSavePartnerConnectionRequest)
            const localVarPath = `/v1/configs/logistics/connections/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSavePartnerConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SaveRefundConfiguration
         * @param {PbSaveRefundConfigurationRequest} pbSaveRefundConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRefundConfiguration: async (pbSaveRefundConfigurationRequest: PbSaveRefundConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveRefundConfigurationRequest' is not null or undefined
            assertParamExists('saveRefundConfiguration', 'pbSaveRefundConfigurationRequest', pbSaveRefundConfigurationRequest)
            const localVarPath = `/v1/configs/refunds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveRefundConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving LogisticsSettings model
         * @param {PbSaveReturnProcessConditionsReq} pbSaveReturnProcessConditionsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReturnProcessConditions: async (pbSaveReturnProcessConditionsReq: PbSaveReturnProcessConditionsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveReturnProcessConditionsReq' is not null or undefined
            assertParamExists('saveReturnProcessConditions', 'pbSaveReturnProcessConditionsReq', pbSaveReturnProcessConditionsReq)
            const localVarPath = `/v1/configs/returnconditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveReturnProcessConditionsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves return reasons to the database
         * @param {PbSaveReturnReasonsReq} pbSaveReturnReasonsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReturnReasons: async (pbSaveReturnReasonsReq: PbSaveReturnReasonsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveReturnReasonsReq' is not null or undefined
            assertParamExists('saveReturnReasons', 'pbSaveReturnReasonsReq', pbSaveReturnReasonsReq)
            const localVarPath = `/v1/configs/return-reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveReturnReasonsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save risk exposure settings for an e-commerce
         * @param {PbSaveRiskExposureSettingsRequest} pbSaveRiskExposureSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRiskExposureSettings: async (pbSaveRiskExposureSettingsRequest: PbSaveRiskExposureSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveRiskExposureSettingsRequest' is not null or undefined
            assertParamExists('saveRiskExposureSettings', 'pbSaveRiskExposureSettingsRequest', pbSaveRiskExposureSettingsRequest)
            const localVarPath = `/v1/configs/risk-exposure-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveRiskExposureSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replaces a Shopify store\'s App Automation token, generated in the store\'s Shopify Dev Dashboard
         * @param {PbSaveShopifyAppAutomationTokenRequest} pbSaveShopifyAppAutomationTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveShopifyAppAutomationToken: async (pbSaveShopifyAppAutomationTokenRequest: PbSaveShopifyAppAutomationTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveShopifyAppAutomationTokenRequest' is not null or undefined
            assertParamExists('saveShopifyAppAutomationToken', 'pbSaveShopifyAppAutomationTokenRequest', pbSaveShopifyAppAutomationTokenRequest)
            const localVarPath = `/v1/configs/integrations/nango/app-automation-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveShopifyAppAutomationTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for save Warehouse config by ecommerce id
         * @param {PbSaveWarehouseConfigRequest} pbSaveWarehouseConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWarehouseConfigsPublic: async (pbSaveWarehouseConfigRequest: PbSaveWarehouseConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveWarehouseConfigRequest' is not null or undefined
            assertParamExists('saveWarehouseConfigsPublic', 'pbSaveWarehouseConfigRequest', pbSaveWarehouseConfigRequest)
            const localVarPath = `/v1/configs/ecommerces/warehouses/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveWarehouseConfigRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving Warehouses for a given ecommerce
         * @param {PbSaveWarehousesReq} pbSaveWarehousesReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWarehouses: async (pbSaveWarehousesReq: PbSaveWarehousesReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveWarehousesReq' is not null or undefined
            assertParamExists('saveWarehouses', 'pbSaveWarehousesReq', pbSaveWarehousesReq)
            const localVarPath = `/v1/configs/warehouses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveWarehousesReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates or updates warehouses of an ecommerce group
         * @param {string} ecommerceGroup Ecommerce group that owns the warehouses
         * @param {PbSaveWarehousesV2Req} pbSaveWarehousesV2Req 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWarehousesV2: async (ecommerceGroup: string, pbSaveWarehousesV2Req: PbSaveWarehousesV2Req, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceGroup' is not null or undefined
            assertParamExists('saveWarehousesV2', 'ecommerceGroup', ecommerceGroup)
            // verify required parameter 'pbSaveWarehousesV2Req' is not null or undefined
            assertParamExists('saveWarehousesV2', 'pbSaveWarehousesV2Req', pbSaveWarehousesV2Req)
            const localVarPath = `/v2/configs/groups/{ecommerce_group}/warehouses`
                .replace(`{${"ecommerce_group"}}`, encodeURIComponent(String(ecommerceGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveWarehousesV2Req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint for saving WorkflowConfigurations model
         * @param {PbSaveWorkflowConfigurationsReq} pbSaveWorkflowConfigurationsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkflowConfigurations: async (pbSaveWorkflowConfigurationsReq: PbSaveWorkflowConfigurationsReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSaveWorkflowConfigurationsReq' is not null or undefined
            assertParamExists('saveWorkflowConfigurations', 'pbSaveWorkflowConfigurationsReq', pbSaveWorkflowConfigurationsReq)
            const localVarPath = `/v1/configs/workflowconfigurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSaveWorkflowConfigurationsReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a sample of a webhook to a destination URL so the tenant can check that its  endpoint accepts REVER\'s deliveries before subscribing. The sample has the shape of  a real delivery, is marked is_testing, and is signed and authenticated like one.  The URL is not stored, and the sample refers to no real return.
         * @param {string} ecommerceId The ecommerce id
         * @param {PbSendTestWebhookRequest} pbSendTestWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestWebhook: async (ecommerceId: string, pbSendTestWebhookRequest: PbSendTestWebhookRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('sendTestWebhook', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSendTestWebhookRequest' is not null or undefined
            assertParamExists('sendTestWebhook', 'pbSendTestWebhookRequest', pbSendTestWebhookRequest)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/test`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSendTestWebhookRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SetUserBlocked blocks or unblocks a dashboard user belonging to the caller\'s  own group, revoking or restoring their access to the dashboard
         * @param {PbSetUserBlockedRequest} pbSetUserBlockedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserBlocked: async (pbSetUserBlockedRequest: PbSetUserBlockedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbSetUserBlockedRequest' is not null or undefined
            assertParamExists('setUserBlocked', 'pbSetUserBlockedRequest', pbSetUserBlockedRequest)
            const localVarPath = `/v1/configs/users/blocked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSetUserBlockedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Turns the EU withdrawal form on or off for an e-commerce\'s portal. Only REVER  staff can: anyone else gets PermissionDenied.
         * @param {string} ecommerceId E-commerce to configure. Required.
         * @param {PbSetWithdrawalSettingsRequest} pbSetWithdrawalSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWithdrawalSettings: async (ecommerceId: string, pbSetWithdrawalSettingsRequest: PbSetWithdrawalSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('setWithdrawalSettings', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbSetWithdrawalSettingsRequest' is not null or undefined
            assertParamExists('setWithdrawalSettings', 'pbSetWithdrawalSettingsRequest', pbSetWithdrawalSettingsRequest)
            const localVarPath = `/v1/configs/ecommerces/{ecommerce_id}/withdrawal`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbSetWithdrawalSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlinks a Nango connection from an ecommerce, keeping it in Nango
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {string} [ecommerceId] Ecommerce that uses the connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkNangoConnection: async (integration: string, connectionId: string, ecommerceId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'integration' is not null or undefined
            assertParamExists('unlinkNangoConnection', 'integration', integration)
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('unlinkNangoConnection', 'connectionId', connectionId)
            const localVarPath = `/v1/configs/integrations/nango/connections/{integration}/{connection_id}`
                .replace(`{${"integration"}}`, encodeURIComponent(String(integration)))
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ecommerceId !== undefined) {
                localVarQueryParameter['ecommerce_id'] = ecommerceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update list of copies for a given e-commerce
         * @param {PbUpdateEcommerceCopyRequest} pbUpdateEcommerceCopyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCopies: async (pbUpdateEcommerceCopyRequest: PbUpdateEcommerceCopyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbUpdateEcommerceCopyRequest' is not null or undefined
            assertParamExists('updateCopies', 'pbUpdateEcommerceCopyRequest', pbUpdateEcommerceCopyRequest)
            const localVarPath = `/v1/copies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUpdateEcommerceCopyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UpdateUser updates the role and assigned warehouses of a dashboard user  belonging to the caller\'s own group
         * @param {PbUpdateUserRequest} pbUpdateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (pbUpdateUserRequest: PbUpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbUpdateUserRequest' is not null or undefined
            assertParamExists('updateUser', 'pbUpdateUserRequest', pbUpdateUserRequest)
            const localVarPath = `/v1/configs/users/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUpdateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * endpoint an e-commerce may use to upload one of its own portal images
         * @param {PbUploadBrandingImageReq} pbUploadBrandingImageReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBrandingImage: async (pbUploadBrandingImageReq: PbUploadBrandingImageReq, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbUploadBrandingImageReq' is not null or undefined
            assertParamExists('uploadBrandingImage', 'pbUploadBrandingImageReq', pbUploadBrandingImageReq)
            const localVarPath = `/v1/configs/branding/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUploadBrandingImageReq, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the PA settings for the specified ecommerce
         * @param {PbUpdateProductAutomationsSettingsRequest} pbUpdateProductAutomationsSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertEcommercePASettings: async (pbUpdateProductAutomationsSettingsRequest: PbUpdateProductAutomationsSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbUpdateProductAutomationsSettingsRequest' is not null or undefined
            assertParamExists('upsertEcommercePASettings', 'pbUpdateProductAutomationsSettingsRequest', pbUpdateProductAutomationsSettingsRequest)
            const localVarPath = `/v1/configs/product-automations/ecommerce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUpdateProductAutomationsSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Subscribes or unsubscribes the ecommerce to the return-started and  return-completed webhooks. Enabling either one requires a destination URL.  The URL is shared by both webhooks.
         * @param {string} ecommerceId The ecommerce id
         * @param {PbUpsertWebhookSubscriptionsRequest} pbUpsertWebhookSubscriptionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWebhookSubscriptions: async (ecommerceId: string, pbUpsertWebhookSubscriptionsRequest: PbUpsertWebhookSubscriptionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('upsertWebhookSubscriptions', 'ecommerceId', ecommerceId)
            // verify required parameter 'pbUpsertWebhookSubscriptionsRequest' is not null or undefined
            assertParamExists('upsertWebhookSubscriptions', 'pbUpsertWebhookSubscriptionsRequest', pbUpsertWebhookSubscriptionsRequest)
            const localVarPath = `/v1/configs/webhooks/ecommerce/{ecommerce_id}/subscriptions`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbUpsertWebhookSubscriptionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a new set of settings to a given section (column)
         * @param {PbAddNewPASettingRequest} pbAddNewPASettingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewPASetting(pbAddNewPASettingRequest: PbAddNewPASettingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewPASetting(pbAddNewPASettingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.addNewPASetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a new section (column) to the PA settings table
         * @param {PbAddPASettingsSectionRequest} pbAddPASettingsSectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPASettingsSection(pbAddPASettingsSectionRequest: PbAddPASettingsSectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPASettingsSection(pbAddPASettingsSectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.addPASettingsSection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Makes one of the group\'s Nango connections the one an ecommerce reads its platform credentials from
         * @param {PbAssignNangoPlatformConnectionRequest} pbAssignNangoPlatformConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignNangoPlatformConnection(pbAssignNangoPlatformConnectionRequest: PbAssignNangoPlatformConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbAssignNangoPlatformConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignNangoPlatformConnection(pbAssignNangoPlatformConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.assignNangoPlatformConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Asks the store whether it accepts one of the group\'s Nango connections now, and records the answer
         * @param {string} group Ecommerce group the connection belongs to.
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {PbCheckNangoConnectionRequest} pbCheckNangoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkNangoConnection(group: string, integration: string, connectionId: string, pbCheckNangoConnectionRequest: PbCheckNangoConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCheckNangoConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkNangoConnection(group, integration, connectionId, pbCheckNangoConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.checkNangoConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates an API key with the chosen scopes for an ecommerce group and returns its value.  Creating a name the group already holds returns that existing key. Admins only.
         * @param {PbCreateAPIKeyRequest} pbCreateAPIKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAPIKey(pbCreateAPIKeyRequest: PbCreateAPIKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCreateAPIKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAPIKey(pbCreateAPIKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.createAPIKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Opens a Nango Connect session whose connections are tagged with the group
         * @param {PbCreateNangoConnectSessionRequest} pbCreateNangoConnectSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNangoConnectSession(pbCreateNangoConnectSessionRequest: PbCreateNangoConnectSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCreateNangoConnectSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNangoConnectSession(pbCreateNangoConnectSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.createNangoConnectSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Opens a Nango Connect session that replaces the credentials of one of the group\'s connections
         * @param {string} group Ecommerce group the connection belongs to.
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {PbCreateNangoReconnectSessionRequest} pbCreateNangoReconnectSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNangoReconnectSession(group: string, integration: string, connectionId: string, pbCreateNangoReconnectSessionRequest: PbCreateNangoReconnectSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCreateNangoConnectSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNangoReconnectSession(group, integration, connectionId, pbCreateNangoReconnectSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.createNangoReconnectSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CreateUser
         * @param {PbCreateUserRequest} pbCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(pbCreateUserRequest: PbCreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(pbCreateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a carrier connection
         * @param {string} id Connection id.
         * @param {string} [group] Ecommerce group the connection belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCarrierConnection(id: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCarrierConnection(id, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteCarrierConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the overrides of an ecommerce for the given kinds, which locks them back to its group\'s
         * @param {string} ecommerceId Ecommerce id
         * @param {Array<DeleteExchangesSettingsOverridesV2KindsEnum>} [kinds] The kinds to follow from its group again
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteExchangesSettingsOverridesV2(ecommerceId: string, kinds?: Array<DeleteExchangesSettingsOverridesV2KindsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteExchangesSettingsOverridesV2(ecommerceId, kinds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteExchangesSettingsOverridesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes one of the group\'s Nango connections, unassigning it from every store
         * @param {string} group Ecommerce group the connection belongs to.
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNangoConnection(group: string, integration: string, connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNangoConnection(group, integration, connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteNangoConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a partner connection; fails while a carrier connection still books through it
         * @param {string} id Connection id.
         * @param {string} [group] Ecommerce group the connection belongs to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePartnerConnection(id: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePartnerConnection(id, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deletePartnerConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the override of an ecommerce, which locks its RDV surplus rules back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRDVSurplusOverrideV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRDVSurplusOverrideV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteRDVSurplusOverrideV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the override of an ecommerce, which locks its refund configuration back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRefundConfigurationOverrideV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRefundConfigurationOverrideV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteRefundConfigurationOverrideV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the override of an ecommerce, which locks its return conditions back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReturnProcessConditionsOverrideV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReturnProcessConditionsOverrideV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteReturnProcessConditionsOverrideV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the override of an ecommerce, which locks its return reasons back to its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReturnReasonsOverrideV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReturnReasonsOverrideV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteReturnReasonsOverrideV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the routing rules override of an ecommerce, which locks it back to its group\'s rules
         * @param {string} ecommerceId Ecommerce id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWarehouseConfigOverrideV2(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWarehouseConfigOverrideV2(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteWarehouseConfigOverrideV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes warehouses of an ecommerce group. Fails while a routing rule still uses one of them.
         * @param {string} ecommerceGroup Ecommerce group that owns the warehouses
         * @param {PbDeleteWarehousesV2Request} pbDeleteWarehousesV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWarehousesV2(ecommerceGroup: string, pbDeleteWarehousesV2Request: PbDeleteWarehousesV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbDeleteWarehousesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWarehousesV2(ecommerceGroup, pbDeleteWarehousesV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.deleteWarehousesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding LogisticsSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBranding(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbBranding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBranding(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Branding model
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findBrandingPublic(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbBranding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findBrandingPublic(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findBrandingPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Credentials model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findCredentials(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbCredentials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findCredentials(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Ecommerce model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEcommerce(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbEcommerce>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEcommerce(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findEcommerce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the points of contact of the e-commerce\'s group, which every store of  the group shares. Deprecated: use FindGroupContacts.
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findEcommerceContacts(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbEcommerceContacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findEcommerceContacts(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findEcommerceContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding ExchangeConditions model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findExchangeConditions(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbExchangeConditions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findExchangeConditions(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findExchangeConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding ExchangeOrder model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findExchangeOrder(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbExchangeOrderWithEcommerce>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findExchangeOrder(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findExchangeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the points of contact of a group, shared by every store of the  group. A group with no stored contacts gets an empty list back.
         * @param {string} ecommerceGroup Group. Required.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findGroupContacts(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGroupContacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findGroupContacts(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findGroupContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding InStoreSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findInStoreSettings(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbInStoreSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findInStoreSettings(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findInStoreSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * finds the return reasons to show for a specific item
         * @param {string} [ecommerceId] ecommerce id
         * @param {Array<string>} [categoryIds] category ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findItemReturnReasons(ecommerceId?: string, categoryIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbReturnReasonsCollection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findItemReturnReasons(ecommerceId, categoryIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findItemReturnReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * POST variant of FindItemReturnReasons for callers that need to send the  request in the body (e.g. very large category_ids lists that would exceed  URL length limits at Envoy). Delegates to the same handler.
         * @param {PbFindItemReturnReason} pbFindItemReturnReason 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findItemReturnReasonsByBody(pbFindItemReturnReason: PbFindItemReturnReason, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbReturnReasonsCollection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findItemReturnReasonsByBody(pbFindItemReturnReason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findItemReturnReasonsByBody']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding LogisticSetting model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findLogisticSetting(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbLogisticSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findLogisticSetting(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findLogisticSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Branding model
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPortalSettings(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbPortalSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPortalSettings(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findPortalSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindRefundConfiguration
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findRefundConfiguration(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFindRefundConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findRefundConfiguration(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findRefundConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding LogisticsSettings model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findReturnProcessConditions(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbReturnProcessConditions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findReturnProcessConditions(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findReturnProcessConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tells whether a Shopify store has the App Automation token REVER deploys its Shopify app with, and when it expires
         * @param {string} [ecommerceId] Ecommerce of the Shopify store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findShopifyAppAutomationToken(ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbShopifyAppAutomationToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findShopifyAppAutomationToken(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findShopifyAppAutomationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FindUsers lists the dashboard users of the caller\'s own group. The group is  taken from the caller\'s claim, never from the request, so it cannot be spoofed.
         * @param {string} [ecommerceId] Optional. Lists the users of this ecommerce\&#39;s group instead of the caller\&#39;s own group.  The dashboard needs it for REVER staff, whose own group is \&quot;*\&quot;: without it the list  answers with other REVER staff no matter which ecommerce is on screen. A caller may  only name an ecommerce in their own group, or be REVER staff.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUsers(ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbDashboardUsers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findUsers(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Warehouse model, ecommerce or group-level
         * @param {string} id ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWarehouse(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWarehouse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWarehouse(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findWarehouse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Warehouses by ecommerce id
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWarehousesByEcommerce(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWarehouses>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWarehousesByEcommerce(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findWarehousesByEcommerce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Finds the warehouses of an ecommerce group
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWarehousesByGroupV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWarehouses>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWarehousesByGroupV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findWarehousesByGroupV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves whether an e-commerce\'s portal has the EU withdrawal form. Callers  only see their own group\'s e-commerces.
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWithdrawalSettings(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWithdrawalSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWithdrawalSettings(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findWithdrawalSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding WorkflowConfigurations model
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findWorkflowConfigurations(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWorkflowConfigurations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findWorkflowConfigurations(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.findWorkflowConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates the secret REVER signs this ecommerce group\'s outgoing webhooks with,  replacing and revoking the current one. Returns the plaintext so the caller can show  it.   The secret belongs to the group, not to the ecommerce: receivers normally handle  every ecommerce of a group in one endpoint, and picking a key per ecommerce would  force them to parse the body before they could verify it. The ecommerce id here only  says which ecommerce the caller came in through.   One path serves both surfaces: the dashboard reaches it through Envoy with the  tenant\'s own group claim, and the backoffice over gRPC directly with the \"*\" claims  it injects itself. Attribution comes from the username claim, never from a request  field, so no caller can record the change against someone else.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {PbWebhookSigningSecretRequest} pbWebhookSigningSecretRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWebhookSigningSecret(ecommerceId: string, pbWebhookSigningSecretRequest: PbWebhookSigningSecretRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWebhookSigningSecretResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWebhookSigningSecret(ecommerceId, pbWebhookSigningSecretRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.generateWebhookSigningSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the value of an existing API key so an admin can copy it again. Admins only.
         * @param {string} [ecommerceGroup] Ecommerce group of the key
         * @param {string} [name] Name of the key within its group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAPIKeyValue(ecommerceGroup?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbAPIKeyValueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAPIKeyValue(ecommerceGroup, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getAPIKeyValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * finds all ecommerce return reasons by ecommerce id
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReturnReasons(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbReturnReasonsCollection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReturnReasons(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getAllReturnReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding warehouse address
         * @param {string} ecommerceId ecommerce id
         * @param {PbGetWarehouseRequest} pbGetWarehouseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDynamicWarehouse(ecommerceId: string, pbGetWarehouseRequest: PbGetWarehouseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetWarehouseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDynamicWarehouse(ecommerceId, pbGetWarehouseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getDynamicWarehouse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the settings for the given e-commerce, without secrets
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getECommerceSettings(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbECommerceSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getECommerceSettings(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getECommerceSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the settings for the given e-commerce, without secrets
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [ecommerceId] The id of the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getECommerceSettingsDeprecated(slug?: string, ecommerceId?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbECommerceSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getECommerceSettingsDeprecated(slug, ecommerceId, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getECommerceSettingsDeprecated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {string} [slug] The slug of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getECommerceTextCopies(ecommerceId?: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbECommerceCopies>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getECommerceTextCopies(ecommerceId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getECommerceTextCopies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {string} [slug] The slug of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getECommerceTextCopiesV2(ecommerceId?: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbECommerceCopiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getECommerceTextCopiesV2(ecommerceId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getECommerceTextCopiesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {string} [slug] The slug of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getECommerceTextCopiesV3(ecommerceId?: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbOptimizedCopyData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getECommerceTextCopiesV3(ecommerceId, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getECommerceTextCopiesV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the exchanges settings an ecommerce gets: for each kind, its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceExchangesSettingsV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetExchangesSettingsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceExchangesSettingsV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceExchangesSettingsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the PA settings for the specified ecommerce
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommercePASettings(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbEcommercePASettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommercePASettings(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommercePASettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the RDV surplus rules an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceRDVSurplusV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetRDVSurplusV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceRDVSurplusV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceRDVSurplusV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the refund configuration an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceRefundConfigurationV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetRefundConfigurationV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceRefundConfigurationV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceRefundConfigurationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the return conditions an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceReturnProcessConditionsV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnProcessConditionsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceReturnProcessConditionsV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceReturnProcessConditionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the return reasons an ecommerce gets: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceReturnReasonsV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnReasonsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceReturnReasonsV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceReturnReasonsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of settings, without secrets,   one per e-commerce in the group
         * @param {string} [name] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceSettingsByGroup(name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGroupSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceSettingsByGroup(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceSettingsByGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of settings, without secrets,   one per e-commerce in the group
         * @param {string} [name] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceSettingsByGroupDeprecated(name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGroupSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceSettingsByGroupDeprecated(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceSettingsByGroupDeprecated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the effective warehouse routing rules of an ecommerce: its override if it has one, else its group\'s
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEcommerceWarehouseConfigsV2(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetWarehouseConfigsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEcommerceWarehouseConfigsV2(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getEcommerceWarehouseConfigsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the PA settings for an ecommerce and returns them flattened
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlattenedPASettings(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbFlattenedEcommercePASettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlattenedPASettings(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getFlattenedPASettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the exchanges settings of a group, and the ones each of its ecommerces overrides
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupExchangesSettingsV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetExchangesSettingsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupExchangesSettingsV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getGroupExchangesSettingsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the RDV surplus rules of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupRDVSurplusV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetRDVSurplusV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupRDVSurplusV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getGroupRDVSurplusV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the refund configuration of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupRefundConfigurationV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetRefundConfigurationV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupRefundConfigurationV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getGroupRefundConfigurationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the return conditions of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupReturnProcessConditionsV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnProcessConditionsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupReturnProcessConditionsV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getGroupReturnProcessConditionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the return reasons of a group, and the overrides of its ecommerces
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupReturnReasonsV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnReasonsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupReturnReasonsV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getGroupReturnReasonsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads the warehouse routing rules of a group
         * @param {string} ecommerceGroup Ecommerce Group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupWarehouseConfigsV2(ecommerceGroup: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetWarehouseConfigsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupWarehouseConfigsV2(ecommerceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getGroupWarehouseConfigsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return list of return amount business rules for a given e-commerce
         * @param {string} ecommerceId The id of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnAmount(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnAmountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnAmount(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getReturnAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return list of return amount available businessrules for a given e-commerce
         * @param {string} ecommerceId The id of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReturnAmountAvailable(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnAmountAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReturnAmountAvailable(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getReturnAmountAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get risk exposure settings for an e-commerce
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRiskExposureSettings(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetRiskExposureSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskExposureSettings(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getRiskExposureSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for finding Warehouses config by ecommerce id
         * @param {string} ecommerceId The id of the e-commerce. Optional.
         * @param {string} [slug] The path of an URL identifying the e-commerce. Optional.
         * @param {string} [group] The group of the e-commerce. Several e-commerces can have the same group. Optional.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWarehouseConfigsPublic(ecommerceId: string, slug?: string, group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetWarehouseConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWarehouseConfigsPublic(ecommerceId, slug, group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getWarehouseConfigsPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reveals the active webhook signing secret of the ecommerce\'s group so the tenant can  compare it against what its own verification code uses.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookSigningSecret(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWebhookSigningSecretResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookSigningSecret(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getWebhookSigningSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns whether the ecommerce is subscribed to the return-started and  return-completed webhooks and the destination URL they are posted to.
         * @param {string} ecommerceId The ecommerce id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookSubscriptions(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWebhookSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookSubscriptions(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.getWebhookSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Links one of the group\'s Nango connections to an ecommerce
         * @param {PbLinkNangoConnectionRequest} pbLinkNangoConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkNangoConnection(pbLinkNangoConnectionRequest: PbLinkNangoConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbLinkNangoConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkNangoConnection(pbLinkNangoConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.linkNangoConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the ecommerce groups that hold at least one API key and that the caller may manage:  every group for REVER staff, the caller\'s own group for anyone else. Admins only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAPIKeyGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListAPIKeyGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAPIKeyGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listAPIKeyGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the API keys of the requested ecommerce groups, never their values. Admins only,  and only groups the caller\'s claim covers.
         * @param {Array<string>} [ecommerceGroups] Ecommerce groups to list. Empty lists the caller\&#39;s own group; REVER staff, who have no  group of their own, must name at least one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAPIKeys(ecommerceGroups?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListAPIKeysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAPIKeys(ecommerceGroups, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listAPIKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists a group\'s carrier connections, secrets masked
         * @param {string} [group] Ecommerce group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCarrierConnections(group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListCarrierConnectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCarrierConnections(group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listCarrierConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the Nango connections of a group, with the stores each one is assigned to
         * @param {string} group Ecommerce group whose connections to list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroupNangoConnections(group: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListGroupNangoConnectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroupNangoConnections(group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listGroupNangoConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists the Nango connections an ecommerce uses
         * @param {string} [ecommerceId] Ecommerce whose connections to list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNangoConnections(ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListNangoConnectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNangoConnections(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listNangoConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists a group\'s partner connections, secrets masked
         * @param {string} [group] Ecommerce group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartnerConnections(group?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListPartnerConnectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartnerConnections(group, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listPartnerConnections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists every signing secret ever issued to the ecommerce\'s group, newest first,  redacted, along with the ecommerces that share it. The audit view for \"who rotated  this and when\"; it never returns a secret value.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWebhookSigningSecrets(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbListWebhookSigningSecretsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWebhookSigningSecrets(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.listWebhookSigningSecrets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for Me request with accesible ecommerces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbMeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.me']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Onboard an e-commerce with the return amount business rules
         * @param {PbOnboardingRequest} pbOnboardingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onboard(pbOnboardingRequest: PbOnboardingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onboard(pbOnboardingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.onboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint an e-commerce may use to change a subset of its own branding
         * @param {PbPatchBrandingReq} pbPatchBrandingReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchBranding(pbPatchBrandingReq: PbPatchBrandingReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchBranding(pbPatchBrandingReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for patching the ReturnConditions attributes an e-commerce may change  itself: the return period, the shipping deadline, the return reason options, the  review auto-completion and the non-returnable product, collection, category, tag and  order tag lists. Any other attribute is rejected with PERMISSION_DENIED.
         * @param {PbPatchReturnProcessConditionsReq} pbPatchReturnProcessConditionsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchReturnProcessConditions(pbPatchReturnProcessConditionsReq: PbPatchReturnProcessConditionsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchReturnProcessConditions(pbPatchReturnProcessConditionsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.patchReturnProcessConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the list of return amount business rules to a given e-commerce
         * @param {string} ecommerceId The id of the e-commerce.
         * @param {PbPostReturnAmountRequest} pbPostReturnAmountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReturnAmount(ecommerceId: string, pbPostReturnAmountRequest: PbPostReturnAmountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReturnAmount(ecommerceId, pbPostReturnAmountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.postReturnAmount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return list of return amount available businessrules for a given e-commerce
         * @param {string} [ecommerceId] The id of the e-commerce.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicReturnAmountAvailable(ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGetReturnAmountAvailableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicReturnAmountAvailable(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.publicReturnAmountAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revokes an API key: requests made with it stop being authorized. Admins only.
         * @param {string} [ecommerceGroup] Ecommerce group of the key
         * @param {string} [name] Name of the key within its group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAPIKey(ecommerceGroup?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAPIKey(ecommerceGroup, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.revokeAPIKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revokes the active webhook signing secret, returning every ecommerce of the group to  unsigned deliveries.
         * @param {string} ecommerceId The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeWebhookSigningSecret(ecommerceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbRevokeWebhookSigningSecretResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeWebhookSigningSecret(ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.revokeWebhookSigningSecret']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving LogisticsSettings model
         * @param {PbSaveBrandingReq} pbSaveBrandingReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveBranding(pbSaveBrandingReq: PbSaveBrandingReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveBranding(pbSaveBrandingReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or updates a carrier connection, validated against the provider declarations
         * @param {PbSaveCarrierConnectionRequest} pbSaveCarrierConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCarrierConnection(pbSaveCarrierConnectionRequest: PbSaveCarrierConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSaveCarrierConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCarrierConnection(pbSaveCarrierConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveCarrierConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving Credentials model
         * @param {PbCredentials} pbCredentials 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCredentials(pbCredentials: PbCredentials, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCredentials(pbCredentials, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving Ecommerce model
         * @param {PbSaveEcommerceReq} pbSaveEcommerceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerce(pbSaveEcommerceReq: PbSaveEcommerceReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerce(pbSaveEcommerceReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerce']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the points of contact of the e-commerce\'s group with the ones in the  request. Deprecated: use SaveGroupContacts.
         * @param {PbSaveEcommerceContactsRequest} pbSaveEcommerceContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceContacts(pbSaveEcommerceContactsRequest: PbSaveEcommerceContactsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbEcommerceContacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceContacts(pbSaveEcommerceContactsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the override of an ecommerce for the kinds present in the request, which unlocks them from  its group\'s. Needs write access; instant exchange is REVER only.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceExchangesSettingsV2Request} pbSaveEcommerceExchangesSettingsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceExchangesSettingsV2(ecommerceId: string, pbSaveEcommerceExchangesSettingsV2Request: PbSaveEcommerceExchangesSettingsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceExchangesSettingsV2(ecommerceId, pbSaveEcommerceExchangesSettingsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceExchangesSettingsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its RDV surplus rules from its group\'s. Needs  write access.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceRDVSurplusV2Request} pbSaveEcommerceRDVSurplusV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceRDVSurplusV2(ecommerceId: string, pbSaveEcommerceRDVSurplusV2Request: PbSaveEcommerceRDVSurplusV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceRDVSurplusV2(ecommerceId, pbSaveEcommerceRDVSurplusV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceRDVSurplusV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its refund configuration from its group\'s.  Needs write access.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceRefundConfigurationV2Request} pbSaveEcommerceRefundConfigurationV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceRefundConfigurationV2(ecommerceId: string, pbSaveEcommerceRefundConfigurationV2Request: PbSaveEcommerceRefundConfigurationV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceRefundConfigurationV2(ecommerceId, pbSaveEcommerceRefundConfigurationV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceRefundConfigurationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its return conditions from its group\'s. Needs  write access; skip_fraud_detection, payments_enabled and the fields v1 keeps from merchants are REVER only.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceReturnProcessConditionsV2Request} pbSaveEcommerceReturnProcessConditionsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceReturnProcessConditionsV2(ecommerceId: string, pbSaveEcommerceReturnProcessConditionsV2Request: PbSaveEcommerceReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceReturnProcessConditionsV2(ecommerceId, pbSaveEcommerceReturnProcessConditionsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceReturnProcessConditionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its return reasons from its group\'s. Needs write  access.
         * @param {string} ecommerceId Ecommerce id
         * @param {PbSaveEcommerceReturnReasonsV2Request} pbSaveEcommerceReturnReasonsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceReturnReasonsV2(ecommerceId: string, pbSaveEcommerceReturnReasonsV2Request: PbSaveEcommerceReturnReasonsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceReturnReasonsV2(ecommerceId, pbSaveEcommerceReturnReasonsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceReturnReasonsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or replaces the routing rules override of an ecommerce, which unlocks it from its group\'s rules.  The override may only use the group\'s warehouses.
         * @param {string} ecommerceId EcommerceID
         * @param {PbSaveWarehouseConfigRequest} pbSaveWarehouseConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveEcommerceWarehouseConfigsV2(ecommerceId: string, pbSaveWarehouseConfigRequest: PbSaveWarehouseConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveEcommerceWarehouseConfigsV2(ecommerceId, pbSaveWarehouseConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveEcommerceWarehouseConfigsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving ExchangeConditions model
         * @param {PbSaveExchangeConditionsReq} pbSaveExchangeConditionsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveExchangeConditions(pbSaveExchangeConditionsReq: PbSaveExchangeConditionsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveExchangeConditions(pbSaveExchangeConditionsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveExchangeConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving ExchangeOrder model
         * @param {PbSaveExchangeOrderWithEcommerceReq} pbSaveExchangeOrderWithEcommerceReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveExchangeOrder(pbSaveExchangeOrderWithEcommerceReq: PbSaveExchangeOrderWithEcommerceReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveExchangeOrder(pbSaveExchangeOrderWithEcommerceReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveExchangeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the points of contact of a group with the ones in the request.  Anything stored but missing from the request is removed.
         * @param {PbSaveGroupContactsRequest} pbSaveGroupContactsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupContacts(pbSaveGroupContactsRequest: PbSaveGroupContactsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbGroupContacts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupContacts(pbSaveGroupContactsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the kinds of exchanges settings present in the request for a group. Needs write access; instant  exchange is REVER only.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupExchangesSettingsV2Request} pbSaveGroupExchangesSettingsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupExchangesSettingsV2(ecommerceGroup: string, pbSaveGroupExchangesSettingsV2Request: PbSaveGroupExchangesSettingsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupExchangesSettingsV2(ecommerceGroup, pbSaveGroupExchangesSettingsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupExchangesSettingsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the RDV surplus rules of a group. Needs write access.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupRDVSurplusV2Request} pbSaveGroupRDVSurplusV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupRDVSurplusV2(ecommerceGroup: string, pbSaveGroupRDVSurplusV2Request: PbSaveGroupRDVSurplusV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupRDVSurplusV2(ecommerceGroup, pbSaveGroupRDVSurplusV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupRDVSurplusV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the refund configuration of a group. Needs write access.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupRefundConfigurationV2Request} pbSaveGroupRefundConfigurationV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupRefundConfigurationV2(ecommerceGroup: string, pbSaveGroupRefundConfigurationV2Request: PbSaveGroupRefundConfigurationV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupRefundConfigurationV2(ecommerceGroup, pbSaveGroupRefundConfigurationV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupRefundConfigurationV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the return conditions of a group. Needs write access; skip_fraud_detection, payments_enabled and the  fields v1 keeps from merchants are REVER only.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupReturnProcessConditionsV2Request} pbSaveGroupReturnProcessConditionsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupReturnProcessConditionsV2(ecommerceGroup: string, pbSaveGroupReturnProcessConditionsV2Request: PbSaveGroupReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupReturnProcessConditionsV2(ecommerceGroup, pbSaveGroupReturnProcessConditionsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupReturnProcessConditionsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the return reasons of a group. Needs write access.
         * @param {string} ecommerceGroup Ecommerce group
         * @param {PbSaveGroupReturnReasonsV2Request} pbSaveGroupReturnReasonsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupReturnReasonsV2(ecommerceGroup: string, pbSaveGroupReturnReasonsV2Request: PbSaveGroupReturnReasonsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupReturnReasonsV2(ecommerceGroup, pbSaveGroupReturnReasonsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupReturnReasonsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces the warehouse routing rules of a group, which may only use the group\'s warehouses
         * @param {string} ecommerceGroup Ecommerce group whose routing rules to replace
         * @param {PbSaveGroupWarehouseConfigsV2Request} pbSaveGroupWarehouseConfigsV2Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGroupWarehouseConfigsV2(ecommerceGroup: string, pbSaveGroupWarehouseConfigsV2Request: PbSaveGroupWarehouseConfigsV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGroupWarehouseConfigsV2(ecommerceGroup, pbSaveGroupWarehouseConfigsV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveGroupWarehouseConfigsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving InStoreSettings model
         * @param {PbSaveInStoreSettingsReq} pbSaveInStoreSettingsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveInStoreSettings(pbSaveInStoreSettingsReq: PbSaveInStoreSettingsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveInStoreSettings(pbSaveInStoreSettingsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveInStoreSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving LogisticSetting model
         * @param {PbSaveLogisticSettingReq} pbSaveLogisticSettingReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveLogisticSetting(pbSaveLogisticSettingReq: PbSaveLogisticSettingReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveLogisticSetting(pbSaveLogisticSettingReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveLogisticSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or updates a partner connection, validated against the provider declarations
         * @param {PbSavePartnerConnectionRequest} pbSavePartnerConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePartnerConnection(pbSavePartnerConnectionRequest: PbSavePartnerConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSavePartnerConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePartnerConnection(pbSavePartnerConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.savePartnerConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SaveRefundConfiguration
         * @param {PbSaveRefundConfigurationRequest} pbSaveRefundConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRefundConfiguration(pbSaveRefundConfigurationRequest: PbSaveRefundConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSaveRefundConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRefundConfiguration(pbSaveRefundConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveRefundConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving LogisticsSettings model
         * @param {PbSaveReturnProcessConditionsReq} pbSaveReturnProcessConditionsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveReturnProcessConditions(pbSaveReturnProcessConditionsReq: PbSaveReturnProcessConditionsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveReturnProcessConditions(pbSaveReturnProcessConditionsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveReturnProcessConditions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Saves return reasons to the database
         * @param {PbSaveReturnReasonsReq} pbSaveReturnReasonsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveReturnReasons(pbSaveReturnReasonsReq: PbSaveReturnReasonsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveReturnReasons(pbSaveReturnReasonsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveReturnReasons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save risk exposure settings for an e-commerce
         * @param {PbSaveRiskExposureSettingsRequest} pbSaveRiskExposureSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveRiskExposureSettings(pbSaveRiskExposureSettingsRequest: PbSaveRiskExposureSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveRiskExposureSettings(pbSaveRiskExposureSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveRiskExposureSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replaces a Shopify store\'s App Automation token, generated in the store\'s Shopify Dev Dashboard
         * @param {PbSaveShopifyAppAutomationTokenRequest} pbSaveShopifyAppAutomationTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveShopifyAppAutomationToken(pbSaveShopifyAppAutomationTokenRequest: PbSaveShopifyAppAutomationTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbShopifyAppAutomationToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveShopifyAppAutomationToken(pbSaveShopifyAppAutomationTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveShopifyAppAutomationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for save Warehouse config by ecommerce id
         * @param {PbSaveWarehouseConfigRequest} pbSaveWarehouseConfigRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWarehouseConfigsPublic(pbSaveWarehouseConfigRequest: PbSaveWarehouseConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSaveWarehouseConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWarehouseConfigsPublic(pbSaveWarehouseConfigRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveWarehouseConfigsPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving Warehouses for a given ecommerce
         * @param {PbSaveWarehousesReq} pbSaveWarehousesReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWarehouses(pbSaveWarehousesReq: PbSaveWarehousesReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWarehouses(pbSaveWarehousesReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveWarehouses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates or updates warehouses of an ecommerce group
         * @param {string} ecommerceGroup Ecommerce group that owns the warehouses
         * @param {PbSaveWarehousesV2Req} pbSaveWarehousesV2Req 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWarehousesV2(ecommerceGroup: string, pbSaveWarehousesV2Req: PbSaveWarehousesV2Req, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSaveWarehousesV2Res>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWarehousesV2(ecommerceGroup, pbSaveWarehousesV2Req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveWarehousesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint for saving WorkflowConfigurations model
         * @param {PbSaveWorkflowConfigurationsReq} pbSaveWorkflowConfigurationsReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWorkflowConfigurations(pbSaveWorkflowConfigurationsReq: PbSaveWorkflowConfigurationsReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWorkflowConfigurations(pbSaveWorkflowConfigurationsReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.saveWorkflowConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a sample of a webhook to a destination URL so the tenant can check that its  endpoint accepts REVER\'s deliveries before subscribing. The sample has the shape of  a real delivery, is marked is_testing, and is signed and authenticated like one.  The URL is not stored, and the sample refers to no real return.
         * @param {string} ecommerceId The ecommerce id
         * @param {PbSendTestWebhookRequest} pbSendTestWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestWebhook(ecommerceId: string, pbSendTestWebhookRequest: PbSendTestWebhookRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbSendTestWebhookResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestWebhook(ecommerceId, pbSendTestWebhookRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.sendTestWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SetUserBlocked blocks or unblocks a dashboard user belonging to the caller\'s  own group, revoking or restoring their access to the dashboard
         * @param {PbSetUserBlockedRequest} pbSetUserBlockedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserBlocked(pbSetUserBlockedRequest: PbSetUserBlockedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserBlocked(pbSetUserBlockedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.setUserBlocked']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Turns the EU withdrawal form on or off for an e-commerce\'s portal. Only REVER  staff can: anyone else gets PermissionDenied.
         * @param {string} ecommerceId E-commerce to configure. Required.
         * @param {PbSetWithdrawalSettingsRequest} pbSetWithdrawalSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setWithdrawalSettings(ecommerceId: string, pbSetWithdrawalSettingsRequest: PbSetWithdrawalSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWithdrawalSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setWithdrawalSettings(ecommerceId, pbSetWithdrawalSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.setWithdrawalSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlinks a Nango connection from an ecommerce, keeping it in Nango
         * @param {string} integration Nango integration (provider_config_key) the connection belongs to.
         * @param {string} connectionId Nango connection id.
         * @param {string} [ecommerceId] Ecommerce that uses the connection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkNangoConnection(integration: string, connectionId: string, ecommerceId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkNangoConnection(integration, connectionId, ecommerceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.unlinkNangoConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update list of copies for a given e-commerce
         * @param {PbUpdateEcommerceCopyRequest} pbUpdateEcommerceCopyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCopies(pbUpdateEcommerceCopyRequest: PbUpdateEcommerceCopyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCopies(pbUpdateEcommerceCopyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.updateCopies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * UpdateUser updates the role and assigned warehouses of a dashboard user  belonging to the caller\'s own group
         * @param {PbUpdateUserRequest} pbUpdateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(pbUpdateUserRequest: PbUpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(pbUpdateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * endpoint an e-commerce may use to upload one of its own portal images
         * @param {PbUploadBrandingImageReq} pbUploadBrandingImageReq 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBrandingImage(pbUploadBrandingImageReq: PbUploadBrandingImageReq, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbUploadBrandingImageRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBrandingImage(pbUploadBrandingImageReq, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.uploadBrandingImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the PA settings for the specified ecommerce
         * @param {PbUpdateProductAutomationsSettingsRequest} pbUpdateProductAutomationsSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertEcommercePASettings(pbUpdateProductAutomationsSettingsRequest: PbUpdateProductAutomationsSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertEcommercePASettings(pbUpdateProductAutomationsSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.upsertEcommercePASettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Subscribes or unsubscribes the ecommerce to the return-started and  return-completed webhooks. Enabling either one requires a destination URL.  The URL is shared by both webhooks.
         * @param {string} ecommerceId The ecommerce id
         * @param {PbUpsertWebhookSubscriptionsRequest} pbUpsertWebhookSubscriptionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertWebhookSubscriptions(ecommerceId: string, pbUpsertWebhookSubscriptionsRequest: PbUpsertWebhookSubscriptionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbWebhookSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertWebhookSubscriptions(ecommerceId, pbUpsertWebhookSubscriptionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.upsertWebhookSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * Adds a new set of settings to a given section (column)
         * @param {SettingsApiAddNewPASettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewPASetting(requestParameters: SettingsApiAddNewPASettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.addNewPASetting(requestParameters.pbAddNewPASettingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a new section (column) to the PA settings table
         * @param {SettingsApiAddPASettingsSectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPASettingsSection(requestParameters: SettingsApiAddPASettingsSectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.addPASettingsSection(requestParameters.pbAddPASettingsSectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Makes one of the group\'s Nango connections the one an ecommerce reads its platform credentials from
         * @param {SettingsApiAssignNangoPlatformConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignNangoPlatformConnection(requestParameters: SettingsApiAssignNangoPlatformConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbAssignNangoPlatformConnectionResponse> {
            return localVarFp.assignNangoPlatformConnection(requestParameters.pbAssignNangoPlatformConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Asks the store whether it accepts one of the group\'s Nango connections now, and records the answer
         * @param {SettingsApiCheckNangoConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkNangoConnection(requestParameters: SettingsApiCheckNangoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCheckNangoConnectionResponse> {
            return localVarFp.checkNangoConnection(requestParameters.group, requestParameters.integration, requestParameters.connectionId, requestParameters.pbCheckNangoConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an API key with the chosen scopes for an ecommerce group and returns its value.  Creating a name the group already holds returns that existing key. Admins only.
         * @param {SettingsApiCreateAPIKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAPIKey(requestParameters: SettingsApiCreateAPIKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCreateAPIKeyResponse> {
            return localVarFp.createAPIKey(requestParameters.pbCreateAPIKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Opens a Nango Connect session whose connections are tagged with the group
         * @param {SettingsApiCreateNangoConnectSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNangoConnectSession(requestParameters: SettingsApiCreateNangoConnectSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCreateNangoConnectSessionResponse> {
            return localVarFp.createNangoConnectSession(requestParameters.pbCreateNangoConnectSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Opens a Nango Connect session that replaces the credentials of one of the group\'s connections
         * @param {SettingsApiCreateNangoReconnectSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNangoReconnectSession(requestParameters: SettingsApiCreateNangoReconnectSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCreateNangoConnectSessionResponse> {
            return localVarFp.createNangoReconnectSession(requestParameters.group, requestParameters.integration, requestParameters.connectionId, requestParameters.pbCreateNangoReconnectSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * CreateUser
         * @param {SettingsApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: SettingsApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCreateUserResponse> {
            return localVarFp.createUser(requestParameters.pbCreateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a carrier connection
         * @param {SettingsApiDeleteCarrierConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarrierConnection(requestParameters: SettingsApiDeleteCarrierConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteCarrierConnection(requestParameters.id, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the overrides of an ecommerce for the given kinds, which locks them back to its group\'s
         * @param {SettingsApiDeleteExchangesSettingsOverridesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExchangesSettingsOverridesV2(requestParameters: SettingsApiDeleteExchangesSettingsOverridesV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteExchangesSettingsOverridesV2(requestParameters.ecommerceId, requestParameters.kinds, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes one of the group\'s Nango connections, unassigning it from every store
         * @param {SettingsApiDeleteNangoConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNangoConnection(requestParameters: SettingsApiDeleteNangoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteNangoConnection(requestParameters.group, requestParameters.integration, requestParameters.connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a partner connection; fails while a carrier connection still books through it
         * @param {SettingsApiDeletePartnerConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartnerConnection(requestParameters: SettingsApiDeletePartnerConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deletePartnerConnection(requestParameters.id, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the override of an ecommerce, which locks its RDV surplus rules back to its group\'s
         * @param {SettingsApiDeleteRDVSurplusOverrideV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRDVSurplusOverrideV2(requestParameters: SettingsApiDeleteRDVSurplusOverrideV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteRDVSurplusOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the override of an ecommerce, which locks its refund configuration back to its group\'s
         * @param {SettingsApiDeleteRefundConfigurationOverrideV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRefundConfigurationOverrideV2(requestParameters: SettingsApiDeleteRefundConfigurationOverrideV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteRefundConfigurationOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the override of an ecommerce, which locks its return conditions back to its group\'s
         * @param {SettingsApiDeleteReturnProcessConditionsOverrideV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReturnProcessConditionsOverrideV2(requestParameters: SettingsApiDeleteReturnProcessConditionsOverrideV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteReturnProcessConditionsOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the override of an ecommerce, which locks its return reasons back to its group\'s
         * @param {SettingsApiDeleteReturnReasonsOverrideV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReturnReasonsOverrideV2(requestParameters: SettingsApiDeleteReturnReasonsOverrideV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteReturnReasonsOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the routing rules override of an ecommerce, which locks it back to its group\'s rules
         * @param {SettingsApiDeleteWarehouseConfigOverrideV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWarehouseConfigOverrideV2(requestParameters: SettingsApiDeleteWarehouseConfigOverrideV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteWarehouseConfigOverrideV2(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes warehouses of an ecommerce group. Fails while a routing rule still uses one of them.
         * @param {SettingsApiDeleteWarehousesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWarehousesV2(requestParameters: SettingsApiDeleteWarehousesV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbDeleteWarehousesResponse> {
            return localVarFp.deleteWarehousesV2(requestParameters.ecommerceGroup, requestParameters.pbDeleteWarehousesV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding LogisticsSettings model
         * @param {SettingsApiFindBrandingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBranding(requestParameters: SettingsApiFindBrandingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbBranding> {
            return localVarFp.findBranding(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Branding model
         * @param {SettingsApiFindBrandingPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBrandingPublic(requestParameters: SettingsApiFindBrandingPublicRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbBranding> {
            return localVarFp.findBrandingPublic(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Credentials model
         * @param {SettingsApiFindCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCredentials(requestParameters: SettingsApiFindCredentialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbCredentials> {
            return localVarFp.findCredentials(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Ecommerce model
         * @param {SettingsApiFindEcommerceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEcommerce(requestParameters: SettingsApiFindEcommerceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbEcommerce> {
            return localVarFp.findEcommerce(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the points of contact of the e-commerce\'s group, which every store of  the group shares. Deprecated: use FindGroupContacts.
         * @param {SettingsApiFindEcommerceContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findEcommerceContacts(requestParameters: SettingsApiFindEcommerceContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbEcommerceContacts> {
            return localVarFp.findEcommerceContacts(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding ExchangeConditions model
         * @param {SettingsApiFindExchangeConditionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findExchangeConditions(requestParameters: SettingsApiFindExchangeConditionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbExchangeConditions> {
            return localVarFp.findExchangeConditions(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding ExchangeOrder model
         * @param {SettingsApiFindExchangeOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findExchangeOrder(requestParameters: SettingsApiFindExchangeOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbExchangeOrderWithEcommerce> {
            return localVarFp.findExchangeOrder(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the points of contact of a group, shared by every store of the  group. A group with no stored contacts gets an empty list back.
         * @param {SettingsApiFindGroupContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupContacts(requestParameters: SettingsApiFindGroupContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGroupContacts> {
            return localVarFp.findGroupContacts(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding InStoreSettings model
         * @param {SettingsApiFindInStoreSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findInStoreSettings(requestParameters: SettingsApiFindInStoreSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbInStoreSettings> {
            return localVarFp.findInStoreSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * finds the return reasons to show for a specific item
         * @param {SettingsApiFindItemReturnReasonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findItemReturnReasons(requestParameters: SettingsApiFindItemReturnReasonsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbReturnReasonsCollection> {
            return localVarFp.findItemReturnReasons(requestParameters.ecommerceId, requestParameters.categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         * POST variant of FindItemReturnReasons for callers that need to send the  request in the body (e.g. very large category_ids lists that would exceed  URL length limits at Envoy). Delegates to the same handler.
         * @param {SettingsApiFindItemReturnReasonsByBodyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findItemReturnReasonsByBody(requestParameters: SettingsApiFindItemReturnReasonsByBodyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbReturnReasonsCollection> {
            return localVarFp.findItemReturnReasonsByBody(requestParameters.pbFindItemReturnReason, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding LogisticSetting model
         * @param {SettingsApiFindLogisticSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLogisticSetting(requestParameters: SettingsApiFindLogisticSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbLogisticSetting> {
            return localVarFp.findLogisticSetting(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Branding model
         * @param {SettingsApiFindPortalSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPortalSettings(requestParameters: SettingsApiFindPortalSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbPortalSettings> {
            return localVarFp.findPortalSettings(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * FindRefundConfiguration
         * @param {SettingsApiFindRefundConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRefundConfiguration(requestParameters: SettingsApiFindRefundConfigurationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbFindRefundConfigurationResponse> {
            return localVarFp.findRefundConfiguration(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding LogisticsSettings model
         * @param {SettingsApiFindReturnProcessConditionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReturnProcessConditions(requestParameters: SettingsApiFindReturnProcessConditionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbReturnProcessConditions> {
            return localVarFp.findReturnProcessConditions(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Tells whether a Shopify store has the App Automation token REVER deploys its Shopify app with, and when it expires
         * @param {SettingsApiFindShopifyAppAutomationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findShopifyAppAutomationToken(requestParameters: SettingsApiFindShopifyAppAutomationTokenRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbShopifyAppAutomationToken> {
            return localVarFp.findShopifyAppAutomationToken(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * FindUsers lists the dashboard users of the caller\'s own group. The group is  taken from the caller\'s claim, never from the request, so it cannot be spoofed.
         * @param {SettingsApiFindUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUsers(requestParameters: SettingsApiFindUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbDashboardUsers> {
            return localVarFp.findUsers(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Warehouse model, ecommerce or group-level
         * @param {SettingsApiFindWarehouseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWarehouse(requestParameters: SettingsApiFindWarehouseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWarehouse> {
            return localVarFp.findWarehouse(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Warehouses by ecommerce id
         * @param {SettingsApiFindWarehousesByEcommerceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWarehousesByEcommerce(requestParameters: SettingsApiFindWarehousesByEcommerceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWarehouses> {
            return localVarFp.findWarehousesByEcommerce(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Finds the warehouses of an ecommerce group
         * @param {SettingsApiFindWarehousesByGroupV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWarehousesByGroupV2(requestParameters: SettingsApiFindWarehousesByGroupV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbWarehouses> {
            return localVarFp.findWarehousesByGroupV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves whether an e-commerce\'s portal has the EU withdrawal form. Callers  only see their own group\'s e-commerces.
         * @param {SettingsApiFindWithdrawalSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWithdrawalSettings(requestParameters: SettingsApiFindWithdrawalSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWithdrawalSettings> {
            return localVarFp.findWithdrawalSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding WorkflowConfigurations model
         * @param {SettingsApiFindWorkflowConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findWorkflowConfigurations(requestParameters: SettingsApiFindWorkflowConfigurationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWorkflowConfigurations> {
            return localVarFp.findWorkflowConfigurations(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates the secret REVER signs this ecommerce group\'s outgoing webhooks with,  replacing and revoking the current one. Returns the plaintext so the caller can show  it.   The secret belongs to the group, not to the ecommerce: receivers normally handle  every ecommerce of a group in one endpoint, and picking a key per ecommerce would  force them to parse the body before they could verify it. The ecommerce id here only  says which ecommerce the caller came in through.   One path serves both surfaces: the dashboard reaches it through Envoy with the  tenant\'s own group claim, and the backoffice over gRPC directly with the \"*\" claims  it injects itself. Attribution comes from the username claim, never from a request  field, so no caller can record the change against someone else.
         * @param {SettingsApiGenerateWebhookSigningSecretRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebhookSigningSecret(requestParameters: SettingsApiGenerateWebhookSigningSecretRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWebhookSigningSecretResponse> {
            return localVarFp.generateWebhookSigningSecret(requestParameters.ecommerceId, requestParameters.pbWebhookSigningSecretRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the value of an existing API key so an admin can copy it again. Admins only.
         * @param {SettingsApiGetAPIKeyValueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAPIKeyValue(requestParameters: SettingsApiGetAPIKeyValueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbAPIKeyValueResponse> {
            return localVarFp.getAPIKeyValue(requestParameters.ecommerceGroup, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * finds all ecommerce return reasons by ecommerce id
         * @param {SettingsApiGetAllReturnReasonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReturnReasons(requestParameters: SettingsApiGetAllReturnReasonsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbReturnReasonsCollection> {
            return localVarFp.getAllReturnReasons(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding warehouse address
         * @param {SettingsApiGetDynamicWarehouseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDynamicWarehouse(requestParameters: SettingsApiGetDynamicWarehouseRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetWarehouseResponse> {
            return localVarFp.getDynamicWarehouse(requestParameters.ecommerceId, requestParameters.pbGetWarehouseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the settings for the given e-commerce, without secrets
         * @param {SettingsApiGetECommerceSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceSettings(requestParameters: SettingsApiGetECommerceSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbECommerceSettings> {
            return localVarFp.getECommerceSettings(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the settings for the given e-commerce, without secrets
         * @param {SettingsApiGetECommerceSettingsDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceSettingsDeprecated(requestParameters: SettingsApiGetECommerceSettingsDeprecatedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbECommerceSettings> {
            return localVarFp.getECommerceSettingsDeprecated(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {SettingsApiGetECommerceTextCopiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceTextCopies(requestParameters: SettingsApiGetECommerceTextCopiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbECommerceCopies> {
            return localVarFp.getECommerceTextCopies(requestParameters.ecommerceId, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {SettingsApiGetECommerceTextCopiesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceTextCopiesV2(requestParameters: SettingsApiGetECommerceTextCopiesV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbECommerceCopiesResponse> {
            return localVarFp.getECommerceTextCopiesV2(requestParameters.ecommerceId, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of copies for a given e-commerce
         * @param {SettingsApiGetECommerceTextCopiesV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getECommerceTextCopiesV3(requestParameters: SettingsApiGetECommerceTextCopiesV3Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbOptimizedCopyData> {
            return localVarFp.getECommerceTextCopiesV3(requestParameters.ecommerceId, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the exchanges settings an ecommerce gets: for each kind, its override if it has one, else its group\'s
         * @param {SettingsApiGetEcommerceExchangesSettingsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceExchangesSettingsV2(requestParameters: SettingsApiGetEcommerceExchangesSettingsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetExchangesSettingsV2Response> {
            return localVarFp.getEcommerceExchangesSettingsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the PA settings for the specified ecommerce
         * @param {SettingsApiGetEcommercePASettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommercePASettings(requestParameters: SettingsApiGetEcommercePASettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbEcommercePASettings> {
            return localVarFp.getEcommercePASettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the RDV surplus rules an ecommerce gets: its override if it has one, else its group\'s
         * @param {SettingsApiGetEcommerceRDVSurplusV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceRDVSurplusV2(requestParameters: SettingsApiGetEcommerceRDVSurplusV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetRDVSurplusV2Response> {
            return localVarFp.getEcommerceRDVSurplusV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the refund configuration an ecommerce gets: its override if it has one, else its group\'s
         * @param {SettingsApiGetEcommerceRefundConfigurationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceRefundConfigurationV2(requestParameters: SettingsApiGetEcommerceRefundConfigurationV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetRefundConfigurationV2Response> {
            return localVarFp.getEcommerceRefundConfigurationV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the return conditions an ecommerce gets: its override if it has one, else its group\'s
         * @param {SettingsApiGetEcommerceReturnProcessConditionsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceReturnProcessConditionsV2(requestParameters: SettingsApiGetEcommerceReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnProcessConditionsV2Response> {
            return localVarFp.getEcommerceReturnProcessConditionsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the return reasons an ecommerce gets: its override if it has one, else its group\'s
         * @param {SettingsApiGetEcommerceReturnReasonsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceReturnReasonsV2(requestParameters: SettingsApiGetEcommerceReturnReasonsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnReasonsV2Response> {
            return localVarFp.getEcommerceReturnReasonsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of settings, without secrets,   one per e-commerce in the group
         * @param {SettingsApiGetEcommerceSettingsByGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceSettingsByGroup(requestParameters: SettingsApiGetEcommerceSettingsByGroupRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGroupSettingsResponse> {
            return localVarFp.getEcommerceSettingsByGroup(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of settings, without secrets,   one per e-commerce in the group
         * @param {SettingsApiGetEcommerceSettingsByGroupDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceSettingsByGroupDeprecated(requestParameters: SettingsApiGetEcommerceSettingsByGroupDeprecatedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGroupSettingsResponse> {
            return localVarFp.getEcommerceSettingsByGroupDeprecated(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the effective warehouse routing rules of an ecommerce: its override if it has one, else its group\'s
         * @param {SettingsApiGetEcommerceWarehouseConfigsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEcommerceWarehouseConfigsV2(requestParameters: SettingsApiGetEcommerceWarehouseConfigsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetWarehouseConfigsV2Response> {
            return localVarFp.getEcommerceWarehouseConfigsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the PA settings for an ecommerce and returns them flattened
         * @param {SettingsApiGetFlattenedPASettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlattenedPASettings(requestParameters: SettingsApiGetFlattenedPASettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbFlattenedEcommercePASettings> {
            return localVarFp.getFlattenedPASettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the exchanges settings of a group, and the ones each of its ecommerces overrides
         * @param {SettingsApiGetGroupExchangesSettingsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupExchangesSettingsV2(requestParameters: SettingsApiGetGroupExchangesSettingsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetExchangesSettingsV2Response> {
            return localVarFp.getGroupExchangesSettingsV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the RDV surplus rules of a group, and the overrides of its ecommerces
         * @param {SettingsApiGetGroupRDVSurplusV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupRDVSurplusV2(requestParameters: SettingsApiGetGroupRDVSurplusV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetRDVSurplusV2Response> {
            return localVarFp.getGroupRDVSurplusV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the refund configuration of a group, and the overrides of its ecommerces
         * @param {SettingsApiGetGroupRefundConfigurationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupRefundConfigurationV2(requestParameters: SettingsApiGetGroupRefundConfigurationV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetRefundConfigurationV2Response> {
            return localVarFp.getGroupRefundConfigurationV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the return conditions of a group, and the overrides of its ecommerces
         * @param {SettingsApiGetGroupReturnProcessConditionsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupReturnProcessConditionsV2(requestParameters: SettingsApiGetGroupReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnProcessConditionsV2Response> {
            return localVarFp.getGroupReturnProcessConditionsV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the return reasons of a group, and the overrides of its ecommerces
         * @param {SettingsApiGetGroupReturnReasonsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupReturnReasonsV2(requestParameters: SettingsApiGetGroupReturnReasonsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnReasonsV2Response> {
            return localVarFp.getGroupReturnReasonsV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Reads the warehouse routing rules of a group
         * @param {SettingsApiGetGroupWarehouseConfigsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupWarehouseConfigsV2(requestParameters: SettingsApiGetGroupWarehouseConfigsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbGetWarehouseConfigsV2Response> {
            return localVarFp.getGroupWarehouseConfigsV2(requestParameters.ecommerceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of return amount business rules for a given e-commerce
         * @param {SettingsApiGetReturnAmountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnAmount(requestParameters: SettingsApiGetReturnAmountRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnAmountResponse> {
            return localVarFp.getReturnAmount(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of return amount available businessrules for a given e-commerce
         * @param {SettingsApiGetReturnAmountAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReturnAmountAvailable(requestParameters: SettingsApiGetReturnAmountAvailableRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnAmountAvailableResponse> {
            return localVarFp.getReturnAmountAvailable(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get risk exposure settings for an e-commerce
         * @param {SettingsApiGetRiskExposureSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskExposureSettings(requestParameters: SettingsApiGetRiskExposureSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetRiskExposureSettingsResponse> {
            return localVarFp.getRiskExposureSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for finding Warehouses config by ecommerce id
         * @param {SettingsApiGetWarehouseConfigsPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWarehouseConfigsPublic(requestParameters: SettingsApiGetWarehouseConfigsPublicRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGetWarehouseConfigResponse> {
            return localVarFp.getWarehouseConfigsPublic(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Reveals the active webhook signing secret of the ecommerce\'s group so the tenant can  compare it against what its own verification code uses.
         * @param {SettingsApiGetWebhookSigningSecretRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookSigningSecret(requestParameters: SettingsApiGetWebhookSigningSecretRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWebhookSigningSecretResponse> {
            return localVarFp.getWebhookSigningSecret(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns whether the ecommerce is subscribed to the return-started and  return-completed webhooks and the destination URL they are posted to.
         * @param {SettingsApiGetWebhookSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookSubscriptions(requestParameters: SettingsApiGetWebhookSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWebhookSubscriptionsResponse> {
            return localVarFp.getWebhookSubscriptions(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Links one of the group\'s Nango connections to an ecommerce
         * @param {SettingsApiLinkNangoConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkNangoConnection(requestParameters: SettingsApiLinkNangoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbLinkNangoConnectionResponse> {
            return localVarFp.linkNangoConnection(requestParameters.pbLinkNangoConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the ecommerce groups that hold at least one API key and that the caller may manage:  every group for REVER staff, the caller\'s own group for anyone else. Admins only.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeyGroups(options?: RawAxiosRequestConfig): AxiosPromise<PbListAPIKeyGroupsResponse> {
            return localVarFp.listAPIKeyGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the API keys of the requested ecommerce groups, never their values. Admins only,  and only groups the caller\'s claim covers.
         * @param {SettingsApiListAPIKeysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAPIKeys(requestParameters: SettingsApiListAPIKeysRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbListAPIKeysResponse> {
            return localVarFp.listAPIKeys(requestParameters.ecommerceGroups, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists a group\'s carrier connections, secrets masked
         * @param {SettingsApiListCarrierConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarrierConnections(requestParameters: SettingsApiListCarrierConnectionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbListCarrierConnectionsResponse> {
            return localVarFp.listCarrierConnections(requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the Nango connections of a group, with the stores each one is assigned to
         * @param {SettingsApiListGroupNangoConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupNangoConnections(requestParameters: SettingsApiListGroupNangoConnectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbListGroupNangoConnectionsResponse> {
            return localVarFp.listGroupNangoConnections(requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists the Nango connections an ecommerce uses
         * @param {SettingsApiListNangoConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNangoConnections(requestParameters: SettingsApiListNangoConnectionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbListNangoConnectionsResponse> {
            return localVarFp.listNangoConnections(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists a group\'s partner connections, secrets masked
         * @param {SettingsApiListPartnerConnectionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerConnections(requestParameters: SettingsApiListPartnerConnectionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbListPartnerConnectionsResponse> {
            return localVarFp.listPartnerConnections(requestParameters.group, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists every signing secret ever issued to the ecommerce\'s group, newest first,  redacted, along with the ecommerces that share it. The audit view for \"who rotated  this and when\"; it never returns a secret value.
         * @param {SettingsApiListWebhookSigningSecretsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWebhookSigningSecrets(requestParameters: SettingsApiListWebhookSigningSecretsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbListWebhookSigningSecretsResponse> {
            return localVarFp.listWebhookSigningSecrets(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for Me request with accesible ecommerces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options?: RawAxiosRequestConfig): AxiosPromise<PbMeResponse> {
            return localVarFp.me(options).then((request) => request(axios, basePath));
        },
        /**
         * Onboard an e-commerce with the return amount business rules
         * @param {SettingsApiOnboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboard(requestParameters: SettingsApiOnboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.onboard(requestParameters.pbOnboardingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint an e-commerce may use to change a subset of its own branding
         * @param {SettingsApiPatchBrandingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchBranding(requestParameters: SettingsApiPatchBrandingRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.patchBranding(requestParameters.pbPatchBrandingReq, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for patching the ReturnConditions attributes an e-commerce may change  itself: the return period, the shipping deadline, the return reason options, the  review auto-completion and the non-returnable product, collection, category, tag and  order tag lists. Any other attribute is rejected with PERMISSION_DENIED.
         * @param {SettingsApiPatchReturnProcessConditionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchReturnProcessConditions(requestParameters: SettingsApiPatchReturnProcessConditionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.patchReturnProcessConditions(requestParameters.pbPatchReturnProcessConditionsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the list of return amount business rules to a given e-commerce
         * @param {SettingsApiPostReturnAmountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReturnAmount(requestParameters: SettingsApiPostReturnAmountRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.postReturnAmount(requestParameters.ecommerceId, requestParameters.pbPostReturnAmountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return list of return amount available businessrules for a given e-commerce
         * @param {SettingsApiPublicReturnAmountAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicReturnAmountAvailable(requestParameters: SettingsApiPublicReturnAmountAvailableRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PbGetReturnAmountAvailableResponse> {
            return localVarFp.publicReturnAmountAvailable(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Revokes an API key: requests made with it stop being authorized. Admins only.
         * @param {SettingsApiRevokeAPIKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAPIKey(requestParameters: SettingsApiRevokeAPIKeyRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.revokeAPIKey(requestParameters.ecommerceGroup, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Revokes the active webhook signing secret, returning every ecommerce of the group to  unsigned deliveries.
         * @param {SettingsApiRevokeWebhookSigningSecretRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeWebhookSigningSecret(requestParameters: SettingsApiRevokeWebhookSigningSecretRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbRevokeWebhookSigningSecretResponse> {
            return localVarFp.revokeWebhookSigningSecret(requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving LogisticsSettings model
         * @param {SettingsApiSaveBrandingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveBranding(requestParameters: SettingsApiSaveBrandingRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveBranding(requestParameters.pbSaveBrandingReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates a carrier connection, validated against the provider declarations
         * @param {SettingsApiSaveCarrierConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCarrierConnection(requestParameters: SettingsApiSaveCarrierConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSaveCarrierConnectionResponse> {
            return localVarFp.saveCarrierConnection(requestParameters.pbSaveCarrierConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving Credentials model
         * @param {SettingsApiSaveCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCredentials(requestParameters: SettingsApiSaveCredentialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveCredentials(requestParameters.pbCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving Ecommerce model
         * @param {SettingsApiSaveEcommerceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerce(requestParameters: SettingsApiSaveEcommerceRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerce(requestParameters.pbSaveEcommerceReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the points of contact of the e-commerce\'s group with the ones in the  request. Deprecated: use SaveGroupContacts.
         * @param {SettingsApiSaveEcommerceContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceContacts(requestParameters: SettingsApiSaveEcommerceContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbEcommerceContacts> {
            return localVarFp.saveEcommerceContacts(requestParameters.pbSaveEcommerceContactsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the override of an ecommerce for the kinds present in the request, which unlocks them from  its group\'s. Needs write access; instant exchange is REVER only.
         * @param {SettingsApiSaveEcommerceExchangesSettingsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceExchangesSettingsV2(requestParameters: SettingsApiSaveEcommerceExchangesSettingsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerceExchangesSettingsV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceExchangesSettingsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its RDV surplus rules from its group\'s. Needs  write access.
         * @param {SettingsApiSaveEcommerceRDVSurplusV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceRDVSurplusV2(requestParameters: SettingsApiSaveEcommerceRDVSurplusV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerceRDVSurplusV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceRDVSurplusV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its refund configuration from its group\'s.  Needs write access.
         * @param {SettingsApiSaveEcommerceRefundConfigurationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceRefundConfigurationV2(requestParameters: SettingsApiSaveEcommerceRefundConfigurationV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerceRefundConfigurationV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceRefundConfigurationV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its return conditions from its group\'s. Needs  write access; skip_fraud_detection, payments_enabled and the fields v1 keeps from merchants are REVER only.
         * @param {SettingsApiSaveEcommerceReturnProcessConditionsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceReturnProcessConditionsV2(requestParameters: SettingsApiSaveEcommerceReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerceReturnProcessConditionsV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceReturnProcessConditionsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the override of an ecommerce, which unlocks its return reasons from its group\'s. Needs write  access.
         * @param {SettingsApiSaveEcommerceReturnReasonsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceReturnReasonsV2(requestParameters: SettingsApiSaveEcommerceReturnReasonsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerceReturnReasonsV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceReturnReasonsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or replaces the routing rules override of an ecommerce, which unlocks it from its group\'s rules.  The override may only use the group\'s warehouses.
         * @param {SettingsApiSaveEcommerceWarehouseConfigsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveEcommerceWarehouseConfigsV2(requestParameters: SettingsApiSaveEcommerceWarehouseConfigsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveEcommerceWarehouseConfigsV2(requestParameters.ecommerceId, requestParameters.pbSaveWarehouseConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving ExchangeConditions model
         * @param {SettingsApiSaveExchangeConditionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExchangeConditions(requestParameters: SettingsApiSaveExchangeConditionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveExchangeConditions(requestParameters.pbSaveExchangeConditionsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving ExchangeOrder model
         * @param {SettingsApiSaveExchangeOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveExchangeOrder(requestParameters: SettingsApiSaveExchangeOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveExchangeOrder(requestParameters.pbSaveExchangeOrderWithEcommerceReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the points of contact of a group with the ones in the request.  Anything stored but missing from the request is removed.
         * @param {SettingsApiSaveGroupContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupContacts(requestParameters: SettingsApiSaveGroupContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbGroupContacts> {
            return localVarFp.saveGroupContacts(requestParameters.pbSaveGroupContactsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the kinds of exchanges settings present in the request for a group. Needs write access; instant  exchange is REVER only.
         * @param {SettingsApiSaveGroupExchangesSettingsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupExchangesSettingsV2(requestParameters: SettingsApiSaveGroupExchangesSettingsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveGroupExchangesSettingsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupExchangesSettingsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the RDV surplus rules of a group. Needs write access.
         * @param {SettingsApiSaveGroupRDVSurplusV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupRDVSurplusV2(requestParameters: SettingsApiSaveGroupRDVSurplusV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveGroupRDVSurplusV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupRDVSurplusV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the refund configuration of a group. Needs write access.
         * @param {SettingsApiSaveGroupRefundConfigurationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupRefundConfigurationV2(requestParameters: SettingsApiSaveGroupRefundConfigurationV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveGroupRefundConfigurationV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupRefundConfigurationV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the return conditions of a group. Needs write access; skip_fraud_detection, payments_enabled and the  fields v1 keeps from merchants are REVER only.
         * @param {SettingsApiSaveGroupReturnProcessConditionsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupReturnProcessConditionsV2(requestParameters: SettingsApiSaveGroupReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveGroupReturnProcessConditionsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupReturnProcessConditionsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the return reasons of a group. Needs write access.
         * @param {SettingsApiSaveGroupReturnReasonsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupReturnReasonsV2(requestParameters: SettingsApiSaveGroupReturnReasonsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveGroupReturnReasonsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupReturnReasonsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces the warehouse routing rules of a group, which may only use the group\'s warehouses
         * @param {SettingsApiSaveGroupWarehouseConfigsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGroupWarehouseConfigsV2(requestParameters: SettingsApiSaveGroupWarehouseConfigsV2Request, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveGroupWarehouseConfigsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupWarehouseConfigsV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving InStoreSettings model
         * @param {SettingsApiSaveInStoreSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveInStoreSettings(requestParameters: SettingsApiSaveInStoreSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveInStoreSettings(requestParameters.pbSaveInStoreSettingsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving LogisticSetting model
         * @param {SettingsApiSaveLogisticSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveLogisticSetting(requestParameters: SettingsApiSaveLogisticSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveLogisticSetting(requestParameters.pbSaveLogisticSettingReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates a partner connection, validated against the provider declarations
         * @param {SettingsApiSavePartnerConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePartnerConnection(requestParameters: SettingsApiSavePartnerConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSavePartnerConnectionResponse> {
            return localVarFp.savePartnerConnection(requestParameters.pbSavePartnerConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SaveRefundConfiguration
         * @param {SettingsApiSaveRefundConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRefundConfiguration(requestParameters: SettingsApiSaveRefundConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSaveRefundConfigurationResponse> {
            return localVarFp.saveRefundConfiguration(requestParameters.pbSaveRefundConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving LogisticsSettings model
         * @param {SettingsApiSaveReturnProcessConditionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReturnProcessConditions(requestParameters: SettingsApiSaveReturnProcessConditionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveReturnProcessConditions(requestParameters.pbSaveReturnProcessConditionsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Saves return reasons to the database
         * @param {SettingsApiSaveReturnReasonsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveReturnReasons(requestParameters: SettingsApiSaveReturnReasonsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveReturnReasons(requestParameters.pbSaveReturnReasonsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Save risk exposure settings for an e-commerce
         * @param {SettingsApiSaveRiskExposureSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveRiskExposureSettings(requestParameters: SettingsApiSaveRiskExposureSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveRiskExposureSettings(requestParameters.pbSaveRiskExposureSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Replaces a Shopify store\'s App Automation token, generated in the store\'s Shopify Dev Dashboard
         * @param {SettingsApiSaveShopifyAppAutomationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveShopifyAppAutomationToken(requestParameters: SettingsApiSaveShopifyAppAutomationTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbShopifyAppAutomationToken> {
            return localVarFp.saveShopifyAppAutomationToken(requestParameters.pbSaveShopifyAppAutomationTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for save Warehouse config by ecommerce id
         * @param {SettingsApiSaveWarehouseConfigsPublicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWarehouseConfigsPublic(requestParameters: SettingsApiSaveWarehouseConfigsPublicRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSaveWarehouseConfigResponse> {
            return localVarFp.saveWarehouseConfigsPublic(requestParameters.pbSaveWarehouseConfigRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving Warehouses for a given ecommerce
         * @param {SettingsApiSaveWarehousesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWarehouses(requestParameters: SettingsApiSaveWarehousesRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveWarehouses(requestParameters.pbSaveWarehousesReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates or updates warehouses of an ecommerce group
         * @param {SettingsApiSaveWarehousesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWarehousesV2(requestParameters: SettingsApiSaveWarehousesV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PbSaveWarehousesV2Res> {
            return localVarFp.saveWarehousesV2(requestParameters.ecommerceGroup, requestParameters.pbSaveWarehousesV2Req, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint for saving WorkflowConfigurations model
         * @param {SettingsApiSaveWorkflowConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWorkflowConfigurations(requestParameters: SettingsApiSaveWorkflowConfigurationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.saveWorkflowConfigurations(requestParameters.pbSaveWorkflowConfigurationsReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a sample of a webhook to a destination URL so the tenant can check that its  endpoint accepts REVER\'s deliveries before subscribing. The sample has the shape of  a real delivery, is marked is_testing, and is signed and authenticated like one.  The URL is not stored, and the sample refers to no real return.
         * @param {SettingsApiSendTestWebhookRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestWebhook(requestParameters: SettingsApiSendTestWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbSendTestWebhookResponse> {
            return localVarFp.sendTestWebhook(requestParameters.ecommerceId, requestParameters.pbSendTestWebhookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SetUserBlocked blocks or unblocks a dashboard user belonging to the caller\'s  own group, revoking or restoring their access to the dashboard
         * @param {SettingsApiSetUserBlockedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserBlocked(requestParameters: SettingsApiSetUserBlockedRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.setUserBlocked(requestParameters.pbSetUserBlockedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Turns the EU withdrawal form on or off for an e-commerce\'s portal. Only REVER  staff can: anyone else gets PermissionDenied.
         * @param {SettingsApiSetWithdrawalSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setWithdrawalSettings(requestParameters: SettingsApiSetWithdrawalSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWithdrawalSettings> {
            return localVarFp.setWithdrawalSettings(requestParameters.ecommerceId, requestParameters.pbSetWithdrawalSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlinks a Nango connection from an ecommerce, keeping it in Nango
         * @param {SettingsApiUnlinkNangoConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkNangoConnection(requestParameters: SettingsApiUnlinkNangoConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.unlinkNangoConnection(requestParameters.integration, requestParameters.connectionId, requestParameters.ecommerceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update list of copies for a given e-commerce
         * @param {SettingsApiUpdateCopiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCopies(requestParameters: SettingsApiUpdateCopiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateCopies(requestParameters.pbUpdateEcommerceCopyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * UpdateUser updates the role and assigned warehouses of a dashboard user  belonging to the caller\'s own group
         * @param {SettingsApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: SettingsApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateUser(requestParameters.pbUpdateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * endpoint an e-commerce may use to upload one of its own portal images
         * @param {SettingsApiUploadBrandingImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBrandingImage(requestParameters: SettingsApiUploadBrandingImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbUploadBrandingImageRes> {
            return localVarFp.uploadBrandingImage(requestParameters.pbUploadBrandingImageReq, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the PA settings for the specified ecommerce
         * @param {SettingsApiUpsertEcommercePASettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertEcommercePASettings(requestParameters: SettingsApiUpsertEcommercePASettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.upsertEcommercePASettings(requestParameters.pbUpdateProductAutomationsSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Subscribes or unsubscribes the ecommerce to the return-started and  return-completed webhooks. Enabling either one requires a destination URL.  The URL is shared by both webhooks.
         * @param {SettingsApiUpsertWebhookSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertWebhookSubscriptions(requestParameters: SettingsApiUpsertWebhookSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbWebhookSubscriptionsResponse> {
            return localVarFp.upsertWebhookSubscriptions(requestParameters.ecommerceId, requestParameters.pbUpsertWebhookSubscriptionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNewPASetting operation in SettingsApi.
 * @export
 * @interface SettingsApiAddNewPASettingRequest
 */
export interface SettingsApiAddNewPASettingRequest {
    /**
     * 
     * @type {PbAddNewPASettingRequest}
     * @memberof SettingsApiAddNewPASetting
     */
    readonly pbAddNewPASettingRequest: PbAddNewPASettingRequest
}

/**
 * Request parameters for addPASettingsSection operation in SettingsApi.
 * @export
 * @interface SettingsApiAddPASettingsSectionRequest
 */
export interface SettingsApiAddPASettingsSectionRequest {
    /**
     * 
     * @type {PbAddPASettingsSectionRequest}
     * @memberof SettingsApiAddPASettingsSection
     */
    readonly pbAddPASettingsSectionRequest: PbAddPASettingsSectionRequest
}

/**
 * Request parameters for assignNangoPlatformConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiAssignNangoPlatformConnectionRequest
 */
export interface SettingsApiAssignNangoPlatformConnectionRequest {
    /**
     * 
     * @type {PbAssignNangoPlatformConnectionRequest}
     * @memberof SettingsApiAssignNangoPlatformConnection
     */
    readonly pbAssignNangoPlatformConnectionRequest: PbAssignNangoPlatformConnectionRequest
}

/**
 * Request parameters for checkNangoConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiCheckNangoConnectionRequest
 */
export interface SettingsApiCheckNangoConnectionRequest {
    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof SettingsApiCheckNangoConnection
     */
    readonly group: string

    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof SettingsApiCheckNangoConnection
     */
    readonly integration: string

    /**
     * Nango connection id.
     * @type {string}
     * @memberof SettingsApiCheckNangoConnection
     */
    readonly connectionId: string

    /**
     * 
     * @type {PbCheckNangoConnectionRequest}
     * @memberof SettingsApiCheckNangoConnection
     */
    readonly pbCheckNangoConnectionRequest: PbCheckNangoConnectionRequest
}

/**
 * Request parameters for createAPIKey operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateAPIKeyRequest
 */
export interface SettingsApiCreateAPIKeyRequest {
    /**
     * 
     * @type {PbCreateAPIKeyRequest}
     * @memberof SettingsApiCreateAPIKey
     */
    readonly pbCreateAPIKeyRequest: PbCreateAPIKeyRequest
}

/**
 * Request parameters for createNangoConnectSession operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateNangoConnectSessionRequest
 */
export interface SettingsApiCreateNangoConnectSessionRequest {
    /**
     * 
     * @type {PbCreateNangoConnectSessionRequest}
     * @memberof SettingsApiCreateNangoConnectSession
     */
    readonly pbCreateNangoConnectSessionRequest: PbCreateNangoConnectSessionRequest
}

/**
 * Request parameters for createNangoReconnectSession operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateNangoReconnectSessionRequest
 */
export interface SettingsApiCreateNangoReconnectSessionRequest {
    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof SettingsApiCreateNangoReconnectSession
     */
    readonly group: string

    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof SettingsApiCreateNangoReconnectSession
     */
    readonly integration: string

    /**
     * Nango connection id.
     * @type {string}
     * @memberof SettingsApiCreateNangoReconnectSession
     */
    readonly connectionId: string

    /**
     * 
     * @type {PbCreateNangoReconnectSessionRequest}
     * @memberof SettingsApiCreateNangoReconnectSession
     */
    readonly pbCreateNangoReconnectSessionRequest: PbCreateNangoReconnectSessionRequest
}

/**
 * Request parameters for createUser operation in SettingsApi.
 * @export
 * @interface SettingsApiCreateUserRequest
 */
export interface SettingsApiCreateUserRequest {
    /**
     * 
     * @type {PbCreateUserRequest}
     * @memberof SettingsApiCreateUser
     */
    readonly pbCreateUserRequest: PbCreateUserRequest
}

/**
 * Request parameters for deleteCarrierConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteCarrierConnectionRequest
 */
export interface SettingsApiDeleteCarrierConnectionRequest {
    /**
     * Connection id.
     * @type {string}
     * @memberof SettingsApiDeleteCarrierConnection
     */
    readonly id: string

    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof SettingsApiDeleteCarrierConnection
     */
    readonly group?: string
}

/**
 * Request parameters for deleteExchangesSettingsOverridesV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteExchangesSettingsOverridesV2Request
 */
export interface SettingsApiDeleteExchangesSettingsOverridesV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiDeleteExchangesSettingsOverridesV2
     */
    readonly ecommerceId: string

    /**
     * The kinds to follow from its group again
     * @type {Array<'EXCHANGES_SETTINGS_KIND_V2_UNSPECIFIED' | 'EXCHANGES_SETTINGS_KIND_V2_POLICY' | 'EXCHANGES_SETTINGS_KIND_V2_EXCHANGE_ORDERS' | 'EXCHANGES_SETTINGS_KIND_V2_FULL_CATALOG' | 'EXCHANGES_SETTINGS_KIND_V2_INSTANT_EXCHANGE'>}
     * @memberof SettingsApiDeleteExchangesSettingsOverridesV2
     */
    readonly kinds?: Array<DeleteExchangesSettingsOverridesV2KindsEnum>
}

/**
 * Request parameters for deleteNangoConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteNangoConnectionRequest
 */
export interface SettingsApiDeleteNangoConnectionRequest {
    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof SettingsApiDeleteNangoConnection
     */
    readonly group: string

    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof SettingsApiDeleteNangoConnection
     */
    readonly integration: string

    /**
     * Nango connection id.
     * @type {string}
     * @memberof SettingsApiDeleteNangoConnection
     */
    readonly connectionId: string
}

/**
 * Request parameters for deletePartnerConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiDeletePartnerConnectionRequest
 */
export interface SettingsApiDeletePartnerConnectionRequest {
    /**
     * Connection id.
     * @type {string}
     * @memberof SettingsApiDeletePartnerConnection
     */
    readonly id: string

    /**
     * Ecommerce group the connection belongs to.
     * @type {string}
     * @memberof SettingsApiDeletePartnerConnection
     */
    readonly group?: string
}

/**
 * Request parameters for deleteRDVSurplusOverrideV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteRDVSurplusOverrideV2Request
 */
export interface SettingsApiDeleteRDVSurplusOverrideV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteRDVSurplusOverrideV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteRDVSurplusOverrideV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteRDVSurplusOverrideV2
     */
    readonly group?: string
}

/**
 * Request parameters for deleteRefundConfigurationOverrideV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteRefundConfigurationOverrideV2Request
 */
export interface SettingsApiDeleteRefundConfigurationOverrideV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteRefundConfigurationOverrideV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteRefundConfigurationOverrideV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteRefundConfigurationOverrideV2
     */
    readonly group?: string
}

/**
 * Request parameters for deleteReturnProcessConditionsOverrideV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteReturnProcessConditionsOverrideV2Request
 */
export interface SettingsApiDeleteReturnProcessConditionsOverrideV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteReturnProcessConditionsOverrideV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteReturnProcessConditionsOverrideV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteReturnProcessConditionsOverrideV2
     */
    readonly group?: string
}

/**
 * Request parameters for deleteReturnReasonsOverrideV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteReturnReasonsOverrideV2Request
 */
export interface SettingsApiDeleteReturnReasonsOverrideV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteReturnReasonsOverrideV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteReturnReasonsOverrideV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiDeleteReturnReasonsOverrideV2
     */
    readonly group?: string
}

/**
 * Request parameters for deleteWarehouseConfigOverrideV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteWarehouseConfigOverrideV2Request
 */
export interface SettingsApiDeleteWarehouseConfigOverrideV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiDeleteWarehouseConfigOverrideV2
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for deleteWarehousesV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiDeleteWarehousesV2Request
 */
export interface SettingsApiDeleteWarehousesV2Request {
    /**
     * Ecommerce group that owns the warehouses
     * @type {string}
     * @memberof SettingsApiDeleteWarehousesV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbDeleteWarehousesV2Request}
     * @memberof SettingsApiDeleteWarehousesV2
     */
    readonly pbDeleteWarehousesV2Request: PbDeleteWarehousesV2Request
}

/**
 * Request parameters for findBranding operation in SettingsApi.
 * @export
 * @interface SettingsApiFindBrandingRequest
 */
export interface SettingsApiFindBrandingRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindBranding
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindBranding
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindBranding
     */
    readonly group?: string
}

/**
 * Request parameters for findBrandingPublic operation in SettingsApi.
 * @export
 * @interface SettingsApiFindBrandingPublicRequest
 */
export interface SettingsApiFindBrandingPublicRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindBrandingPublic
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindBrandingPublic
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindBrandingPublic
     */
    readonly group?: string
}

/**
 * Request parameters for findCredentials operation in SettingsApi.
 * @export
 * @interface SettingsApiFindCredentialsRequest
 */
export interface SettingsApiFindCredentialsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindCredentials
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindCredentials
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindCredentials
     */
    readonly group?: string
}

/**
 * Request parameters for findEcommerce operation in SettingsApi.
 * @export
 * @interface SettingsApiFindEcommerceRequest
 */
export interface SettingsApiFindEcommerceRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindEcommerce
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindEcommerce
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindEcommerce
     */
    readonly group?: string
}

/**
 * Request parameters for findEcommerceContacts operation in SettingsApi.
 * @export
 * @interface SettingsApiFindEcommerceContactsRequest
 */
export interface SettingsApiFindEcommerceContactsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindEcommerceContacts
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindEcommerceContacts
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindEcommerceContacts
     */
    readonly group?: string
}

/**
 * Request parameters for findExchangeConditions operation in SettingsApi.
 * @export
 * @interface SettingsApiFindExchangeConditionsRequest
 */
export interface SettingsApiFindExchangeConditionsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindExchangeConditions
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindExchangeConditions
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindExchangeConditions
     */
    readonly group?: string
}

/**
 * Request parameters for findExchangeOrder operation in SettingsApi.
 * @export
 * @interface SettingsApiFindExchangeOrderRequest
 */
export interface SettingsApiFindExchangeOrderRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindExchangeOrder
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindExchangeOrder
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindExchangeOrder
     */
    readonly group?: string
}

/**
 * Request parameters for findGroupContacts operation in SettingsApi.
 * @export
 * @interface SettingsApiFindGroupContactsRequest
 */
export interface SettingsApiFindGroupContactsRequest {
    /**
     * Group. Required.
     * @type {string}
     * @memberof SettingsApiFindGroupContacts
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for findInStoreSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiFindInStoreSettingsRequest
 */
export interface SettingsApiFindInStoreSettingsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindInStoreSettings
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindInStoreSettings
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindInStoreSettings
     */
    readonly group?: string
}

/**
 * Request parameters for findItemReturnReasons operation in SettingsApi.
 * @export
 * @interface SettingsApiFindItemReturnReasonsRequest
 */
export interface SettingsApiFindItemReturnReasonsRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof SettingsApiFindItemReturnReasons
     */
    readonly ecommerceId?: string

    /**
     * category ids
     * @type {Array<string>}
     * @memberof SettingsApiFindItemReturnReasons
     */
    readonly categoryIds?: Array<string>
}

/**
 * Request parameters for findItemReturnReasonsByBody operation in SettingsApi.
 * @export
 * @interface SettingsApiFindItemReturnReasonsByBodyRequest
 */
export interface SettingsApiFindItemReturnReasonsByBodyRequest {
    /**
     * 
     * @type {PbFindItemReturnReason}
     * @memberof SettingsApiFindItemReturnReasonsByBody
     */
    readonly pbFindItemReturnReason: PbFindItemReturnReason
}

/**
 * Request parameters for findLogisticSetting operation in SettingsApi.
 * @export
 * @interface SettingsApiFindLogisticSettingRequest
 */
export interface SettingsApiFindLogisticSettingRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindLogisticSetting
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindLogisticSetting
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindLogisticSetting
     */
    readonly group?: string
}

/**
 * Request parameters for findPortalSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiFindPortalSettingsRequest
 */
export interface SettingsApiFindPortalSettingsRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindPortalSettings
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindPortalSettings
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindPortalSettings
     */
    readonly group?: string
}

/**
 * Request parameters for findRefundConfiguration operation in SettingsApi.
 * @export
 * @interface SettingsApiFindRefundConfigurationRequest
 */
export interface SettingsApiFindRefundConfigurationRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindRefundConfiguration
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindRefundConfiguration
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindRefundConfiguration
     */
    readonly group?: string
}

/**
 * Request parameters for findReturnProcessConditions operation in SettingsApi.
 * @export
 * @interface SettingsApiFindReturnProcessConditionsRequest
 */
export interface SettingsApiFindReturnProcessConditionsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindReturnProcessConditions
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindReturnProcessConditions
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindReturnProcessConditions
     */
    readonly group?: string
}

/**
 * Request parameters for findShopifyAppAutomationToken operation in SettingsApi.
 * @export
 * @interface SettingsApiFindShopifyAppAutomationTokenRequest
 */
export interface SettingsApiFindShopifyAppAutomationTokenRequest {
    /**
     * Ecommerce of the Shopify store.
     * @type {string}
     * @memberof SettingsApiFindShopifyAppAutomationToken
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for findUsers operation in SettingsApi.
 * @export
 * @interface SettingsApiFindUsersRequest
 */
export interface SettingsApiFindUsersRequest {
    /**
     * Optional. Lists the users of this ecommerce\&#39;s group instead of the caller\&#39;s own group.  The dashboard needs it for REVER staff, whose own group is \&quot;*\&quot;: without it the list  answers with other REVER staff no matter which ecommerce is on screen. A caller may  only name an ecommerce in their own group, or be REVER staff.
     * @type {string}
     * @memberof SettingsApiFindUsers
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for findWarehouse operation in SettingsApi.
 * @export
 * @interface SettingsApiFindWarehouseRequest
 */
export interface SettingsApiFindWarehouseRequest {
    /**
     * ID
     * @type {string}
     * @memberof SettingsApiFindWarehouse
     */
    readonly id: string
}

/**
 * Request parameters for findWarehousesByEcommerce operation in SettingsApi.
 * @export
 * @interface SettingsApiFindWarehousesByEcommerceRequest
 */
export interface SettingsApiFindWarehousesByEcommerceRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindWarehousesByEcommerce
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindWarehousesByEcommerce
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindWarehousesByEcommerce
     */
    readonly group?: string
}

/**
 * Request parameters for findWarehousesByGroupV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiFindWarehousesByGroupV2Request
 */
export interface SettingsApiFindWarehousesByGroupV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiFindWarehousesByGroupV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for findWithdrawalSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiFindWithdrawalSettingsRequest
 */
export interface SettingsApiFindWithdrawalSettingsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindWithdrawalSettings
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindWithdrawalSettings
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindWithdrawalSettings
     */
    readonly group?: string
}

/**
 * Request parameters for findWorkflowConfigurations operation in SettingsApi.
 * @export
 * @interface SettingsApiFindWorkflowConfigurationsRequest
 */
export interface SettingsApiFindWorkflowConfigurationsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindWorkflowConfigurations
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiFindWorkflowConfigurations
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiFindWorkflowConfigurations
     */
    readonly group?: string
}

/**
 * Request parameters for generateWebhookSigningSecret operation in SettingsApi.
 * @export
 * @interface SettingsApiGenerateWebhookSigningSecretRequest
 */
export interface SettingsApiGenerateWebhookSigningSecretRequest {
    /**
     * The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
     * @type {string}
     * @memberof SettingsApiGenerateWebhookSigningSecret
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbWebhookSigningSecretRequest}
     * @memberof SettingsApiGenerateWebhookSigningSecret
     */
    readonly pbWebhookSigningSecretRequest: PbWebhookSigningSecretRequest
}

/**
 * Request parameters for getAPIKeyValue operation in SettingsApi.
 * @export
 * @interface SettingsApiGetAPIKeyValueRequest
 */
export interface SettingsApiGetAPIKeyValueRequest {
    /**
     * Ecommerce group of the key
     * @type {string}
     * @memberof SettingsApiGetAPIKeyValue
     */
    readonly ecommerceGroup?: string

    /**
     * Name of the key within its group
     * @type {string}
     * @memberof SettingsApiGetAPIKeyValue
     */
    readonly name?: string
}

/**
 * Request parameters for getAllReturnReasons operation in SettingsApi.
 * @export
 * @interface SettingsApiGetAllReturnReasonsRequest
 */
export interface SettingsApiGetAllReturnReasonsRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetAllReturnReasons
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetAllReturnReasons
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetAllReturnReasons
     */
    readonly group?: string
}

/**
 * Request parameters for getDynamicWarehouse operation in SettingsApi.
 * @export
 * @interface SettingsApiGetDynamicWarehouseRequest
 */
export interface SettingsApiGetDynamicWarehouseRequest {
    /**
     * ecommerce id
     * @type {string}
     * @memberof SettingsApiGetDynamicWarehouse
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbGetWarehouseRequest}
     * @memberof SettingsApiGetDynamicWarehouse
     */
    readonly pbGetWarehouseRequest: PbGetWarehouseRequest
}

/**
 * Request parameters for getECommerceSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiGetECommerceSettingsRequest
 */
export interface SettingsApiGetECommerceSettingsRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetECommerceSettings
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetECommerceSettings
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetECommerceSettings
     */
    readonly group?: string
}

/**
 * Request parameters for getECommerceSettingsDeprecated operation in SettingsApi.
 * @export
 * @interface SettingsApiGetECommerceSettingsDeprecatedRequest
 */
export interface SettingsApiGetECommerceSettingsDeprecatedRequest {
    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetECommerceSettingsDeprecated
     */
    readonly slug?: string

    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetECommerceSettingsDeprecated
     */
    readonly ecommerceId?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetECommerceSettingsDeprecated
     */
    readonly group?: string
}

/**
 * Request parameters for getECommerceTextCopies operation in SettingsApi.
 * @export
 * @interface SettingsApiGetECommerceTextCopiesRequest
 */
export interface SettingsApiGetECommerceTextCopiesRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetECommerceTextCopies
     */
    readonly ecommerceId?: string

    /**
     * The slug of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetECommerceTextCopies
     */
    readonly slug?: string
}

/**
 * Request parameters for getECommerceTextCopiesV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetECommerceTextCopiesV2Request
 */
export interface SettingsApiGetECommerceTextCopiesV2Request {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetECommerceTextCopiesV2
     */
    readonly ecommerceId?: string

    /**
     * The slug of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetECommerceTextCopiesV2
     */
    readonly slug?: string
}

/**
 * Request parameters for getECommerceTextCopiesV3 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetECommerceTextCopiesV3Request
 */
export interface SettingsApiGetECommerceTextCopiesV3Request {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetECommerceTextCopiesV3
     */
    readonly ecommerceId?: string

    /**
     * The slug of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetECommerceTextCopiesV3
     */
    readonly slug?: string
}

/**
 * Request parameters for getEcommerceExchangesSettingsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceExchangesSettingsV2Request
 */
export interface SettingsApiGetEcommerceExchangesSettingsV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceExchangesSettingsV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceExchangesSettingsV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceExchangesSettingsV2
     */
    readonly group?: string
}

/**
 * Request parameters for getEcommercePASettings operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommercePASettingsRequest
 */
export interface SettingsApiGetEcommercePASettingsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommercePASettings
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommercePASettings
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommercePASettings
     */
    readonly group?: string
}

/**
 * Request parameters for getEcommerceRDVSurplusV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceRDVSurplusV2Request
 */
export interface SettingsApiGetEcommerceRDVSurplusV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceRDVSurplusV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceRDVSurplusV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceRDVSurplusV2
     */
    readonly group?: string
}

/**
 * Request parameters for getEcommerceRefundConfigurationV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceRefundConfigurationV2Request
 */
export interface SettingsApiGetEcommerceRefundConfigurationV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceRefundConfigurationV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceRefundConfigurationV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceRefundConfigurationV2
     */
    readonly group?: string
}

/**
 * Request parameters for getEcommerceReturnProcessConditionsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceReturnProcessConditionsV2Request
 */
export interface SettingsApiGetEcommerceReturnProcessConditionsV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceReturnProcessConditionsV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceReturnProcessConditionsV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceReturnProcessConditionsV2
     */
    readonly group?: string
}

/**
 * Request parameters for getEcommerceReturnReasonsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceReturnReasonsV2Request
 */
export interface SettingsApiGetEcommerceReturnReasonsV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceReturnReasonsV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceReturnReasonsV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceReturnReasonsV2
     */
    readonly group?: string
}

/**
 * Request parameters for getEcommerceSettingsByGroup operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceSettingsByGroupRequest
 */
export interface SettingsApiGetEcommerceSettingsByGroupRequest {
    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceSettingsByGroup
     */
    readonly name?: string
}

/**
 * Request parameters for getEcommerceSettingsByGroupDeprecated operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceSettingsByGroupDeprecatedRequest
 */
export interface SettingsApiGetEcommerceSettingsByGroupDeprecatedRequest {
    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceSettingsByGroupDeprecated
     */
    readonly name?: string
}

/**
 * Request parameters for getEcommerceWarehouseConfigsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetEcommerceWarehouseConfigsV2Request
 */
export interface SettingsApiGetEcommerceWarehouseConfigsV2Request {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceWarehouseConfigsV2
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceWarehouseConfigsV2
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetEcommerceWarehouseConfigsV2
     */
    readonly group?: string
}

/**
 * Request parameters for getFlattenedPASettings operation in SettingsApi.
 * @export
 * @interface SettingsApiGetFlattenedPASettingsRequest
 */
export interface SettingsApiGetFlattenedPASettingsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetFlattenedPASettings
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetFlattenedPASettings
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetFlattenedPASettings
     */
    readonly group?: string
}

/**
 * Request parameters for getGroupExchangesSettingsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetGroupExchangesSettingsV2Request
 */
export interface SettingsApiGetGroupExchangesSettingsV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiGetGroupExchangesSettingsV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for getGroupRDVSurplusV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetGroupRDVSurplusV2Request
 */
export interface SettingsApiGetGroupRDVSurplusV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiGetGroupRDVSurplusV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for getGroupRefundConfigurationV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetGroupRefundConfigurationV2Request
 */
export interface SettingsApiGetGroupRefundConfigurationV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiGetGroupRefundConfigurationV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for getGroupReturnProcessConditionsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetGroupReturnProcessConditionsV2Request
 */
export interface SettingsApiGetGroupReturnProcessConditionsV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiGetGroupReturnProcessConditionsV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for getGroupReturnReasonsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetGroupReturnReasonsV2Request
 */
export interface SettingsApiGetGroupReturnReasonsV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiGetGroupReturnReasonsV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for getGroupWarehouseConfigsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiGetGroupWarehouseConfigsV2Request
 */
export interface SettingsApiGetGroupWarehouseConfigsV2Request {
    /**
     * Ecommerce Group
     * @type {string}
     * @memberof SettingsApiGetGroupWarehouseConfigsV2
     */
    readonly ecommerceGroup: string
}

/**
 * Request parameters for getReturnAmount operation in SettingsApi.
 * @export
 * @interface SettingsApiGetReturnAmountRequest
 */
export interface SettingsApiGetReturnAmountRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetReturnAmount
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for getReturnAmountAvailable operation in SettingsApi.
 * @export
 * @interface SettingsApiGetReturnAmountAvailableRequest
 */
export interface SettingsApiGetReturnAmountAvailableRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiGetReturnAmountAvailable
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for getRiskExposureSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiGetRiskExposureSettingsRequest
 */
export interface SettingsApiGetRiskExposureSettingsRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetRiskExposureSettings
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetRiskExposureSettings
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetRiskExposureSettings
     */
    readonly group?: string
}

/**
 * Request parameters for getWarehouseConfigsPublic operation in SettingsApi.
 * @export
 * @interface SettingsApiGetWarehouseConfigsPublicRequest
 */
export interface SettingsApiGetWarehouseConfigsPublicRequest {
    /**
     * The id of the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetWarehouseConfigsPublic
     */
    readonly ecommerceId: string

    /**
     * The path of an URL identifying the e-commerce. Optional.
     * @type {string}
     * @memberof SettingsApiGetWarehouseConfigsPublic
     */
    readonly slug?: string

    /**
     * The group of the e-commerce. Several e-commerces can have the same group. Optional.
     * @type {string}
     * @memberof SettingsApiGetWarehouseConfigsPublic
     */
    readonly group?: string
}

/**
 * Request parameters for getWebhookSigningSecret operation in SettingsApi.
 * @export
 * @interface SettingsApiGetWebhookSigningSecretRequest
 */
export interface SettingsApiGetWebhookSigningSecretRequest {
    /**
     * The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
     * @type {string}
     * @memberof SettingsApiGetWebhookSigningSecret
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for getWebhookSubscriptions operation in SettingsApi.
 * @export
 * @interface SettingsApiGetWebhookSubscriptionsRequest
 */
export interface SettingsApiGetWebhookSubscriptionsRequest {
    /**
     * The ecommerce id
     * @type {string}
     * @memberof SettingsApiGetWebhookSubscriptions
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for linkNangoConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiLinkNangoConnectionRequest
 */
export interface SettingsApiLinkNangoConnectionRequest {
    /**
     * 
     * @type {PbLinkNangoConnectionRequest}
     * @memberof SettingsApiLinkNangoConnection
     */
    readonly pbLinkNangoConnectionRequest: PbLinkNangoConnectionRequest
}

/**
 * Request parameters for listAPIKeys operation in SettingsApi.
 * @export
 * @interface SettingsApiListAPIKeysRequest
 */
export interface SettingsApiListAPIKeysRequest {
    /**
     * Ecommerce groups to list. Empty lists the caller\&#39;s own group; REVER staff, who have no  group of their own, must name at least one.
     * @type {Array<string>}
     * @memberof SettingsApiListAPIKeys
     */
    readonly ecommerceGroups?: Array<string>
}

/**
 * Request parameters for listCarrierConnections operation in SettingsApi.
 * @export
 * @interface SettingsApiListCarrierConnectionsRequest
 */
export interface SettingsApiListCarrierConnectionsRequest {
    /**
     * Ecommerce group.
     * @type {string}
     * @memberof SettingsApiListCarrierConnections
     */
    readonly group?: string
}

/**
 * Request parameters for listGroupNangoConnections operation in SettingsApi.
 * @export
 * @interface SettingsApiListGroupNangoConnectionsRequest
 */
export interface SettingsApiListGroupNangoConnectionsRequest {
    /**
     * Ecommerce group whose connections to list.
     * @type {string}
     * @memberof SettingsApiListGroupNangoConnections
     */
    readonly group: string
}

/**
 * Request parameters for listNangoConnections operation in SettingsApi.
 * @export
 * @interface SettingsApiListNangoConnectionsRequest
 */
export interface SettingsApiListNangoConnectionsRequest {
    /**
     * Ecommerce whose connections to list.
     * @type {string}
     * @memberof SettingsApiListNangoConnections
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for listPartnerConnections operation in SettingsApi.
 * @export
 * @interface SettingsApiListPartnerConnectionsRequest
 */
export interface SettingsApiListPartnerConnectionsRequest {
    /**
     * Ecommerce group.
     * @type {string}
     * @memberof SettingsApiListPartnerConnections
     */
    readonly group?: string
}

/**
 * Request parameters for listWebhookSigningSecrets operation in SettingsApi.
 * @export
 * @interface SettingsApiListWebhookSigningSecretsRequest
 */
export interface SettingsApiListWebhookSigningSecretsRequest {
    /**
     * The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
     * @type {string}
     * @memberof SettingsApiListWebhookSigningSecrets
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for onboard operation in SettingsApi.
 * @export
 * @interface SettingsApiOnboardRequest
 */
export interface SettingsApiOnboardRequest {
    /**
     * 
     * @type {PbOnboardingRequest}
     * @memberof SettingsApiOnboard
     */
    readonly pbOnboardingRequest: PbOnboardingRequest
}

/**
 * Request parameters for patchBranding operation in SettingsApi.
 * @export
 * @interface SettingsApiPatchBrandingRequest
 */
export interface SettingsApiPatchBrandingRequest {
    /**
     * 
     * @type {PbPatchBrandingReq}
     * @memberof SettingsApiPatchBranding
     */
    readonly pbPatchBrandingReq: PbPatchBrandingReq
}

/**
 * Request parameters for patchReturnProcessConditions operation in SettingsApi.
 * @export
 * @interface SettingsApiPatchReturnProcessConditionsRequest
 */
export interface SettingsApiPatchReturnProcessConditionsRequest {
    /**
     * 
     * @type {PbPatchReturnProcessConditionsReq}
     * @memberof SettingsApiPatchReturnProcessConditions
     */
    readonly pbPatchReturnProcessConditionsReq: PbPatchReturnProcessConditionsReq
}

/**
 * Request parameters for postReturnAmount operation in SettingsApi.
 * @export
 * @interface SettingsApiPostReturnAmountRequest
 */
export interface SettingsApiPostReturnAmountRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiPostReturnAmount
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbPostReturnAmountRequest}
     * @memberof SettingsApiPostReturnAmount
     */
    readonly pbPostReturnAmountRequest: PbPostReturnAmountRequest
}

/**
 * Request parameters for publicReturnAmountAvailable operation in SettingsApi.
 * @export
 * @interface SettingsApiPublicReturnAmountAvailableRequest
 */
export interface SettingsApiPublicReturnAmountAvailableRequest {
    /**
     * The id of the e-commerce.
     * @type {string}
     * @memberof SettingsApiPublicReturnAmountAvailable
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for revokeAPIKey operation in SettingsApi.
 * @export
 * @interface SettingsApiRevokeAPIKeyRequest
 */
export interface SettingsApiRevokeAPIKeyRequest {
    /**
     * Ecommerce group of the key
     * @type {string}
     * @memberof SettingsApiRevokeAPIKey
     */
    readonly ecommerceGroup?: string

    /**
     * Name of the key within its group
     * @type {string}
     * @memberof SettingsApiRevokeAPIKey
     */
    readonly name?: string
}

/**
 * Request parameters for revokeWebhookSigningSecret operation in SettingsApi.
 * @export
 * @interface SettingsApiRevokeWebhookSigningSecretRequest
 */
export interface SettingsApiRevokeWebhookSigningSecretRequest {
    /**
     * The ecommerce id. The group it belongs to is resolved server-side; a caller cannot  name a group directly.
     * @type {string}
     * @memberof SettingsApiRevokeWebhookSigningSecret
     */
    readonly ecommerceId: string
}

/**
 * Request parameters for saveBranding operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveBrandingRequest
 */
export interface SettingsApiSaveBrandingRequest {
    /**
     * 
     * @type {PbSaveBrandingReq}
     * @memberof SettingsApiSaveBranding
     */
    readonly pbSaveBrandingReq: PbSaveBrandingReq
}

/**
 * Request parameters for saveCarrierConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveCarrierConnectionRequest
 */
export interface SettingsApiSaveCarrierConnectionRequest {
    /**
     * 
     * @type {PbSaveCarrierConnectionRequest}
     * @memberof SettingsApiSaveCarrierConnection
     */
    readonly pbSaveCarrierConnectionRequest: PbSaveCarrierConnectionRequest
}

/**
 * Request parameters for saveCredentials operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveCredentialsRequest
 */
export interface SettingsApiSaveCredentialsRequest {
    /**
     * 
     * @type {PbCredentials}
     * @memberof SettingsApiSaveCredentials
     */
    readonly pbCredentials: PbCredentials
}

/**
 * Request parameters for saveEcommerce operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceRequest
 */
export interface SettingsApiSaveEcommerceRequest {
    /**
     * 
     * @type {PbSaveEcommerceReq}
     * @memberof SettingsApiSaveEcommerce
     */
    readonly pbSaveEcommerceReq: PbSaveEcommerceReq
}

/**
 * Request parameters for saveEcommerceContacts operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceContactsRequest
 */
export interface SettingsApiSaveEcommerceContactsRequest {
    /**
     * 
     * @type {PbSaveEcommerceContactsRequest}
     * @memberof SettingsApiSaveEcommerceContacts
     */
    readonly pbSaveEcommerceContactsRequest: PbSaveEcommerceContactsRequest
}

/**
 * Request parameters for saveEcommerceExchangesSettingsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceExchangesSettingsV2Request
 */
export interface SettingsApiSaveEcommerceExchangesSettingsV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiSaveEcommerceExchangesSettingsV2
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSaveEcommerceExchangesSettingsV2Request}
     * @memberof SettingsApiSaveEcommerceExchangesSettingsV2
     */
    readonly pbSaveEcommerceExchangesSettingsV2Request: PbSaveEcommerceExchangesSettingsV2Request
}

/**
 * Request parameters for saveEcommerceRDVSurplusV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceRDVSurplusV2Request
 */
export interface SettingsApiSaveEcommerceRDVSurplusV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiSaveEcommerceRDVSurplusV2
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSaveEcommerceRDVSurplusV2Request}
     * @memberof SettingsApiSaveEcommerceRDVSurplusV2
     */
    readonly pbSaveEcommerceRDVSurplusV2Request: PbSaveEcommerceRDVSurplusV2Request
}

/**
 * Request parameters for saveEcommerceRefundConfigurationV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceRefundConfigurationV2Request
 */
export interface SettingsApiSaveEcommerceRefundConfigurationV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiSaveEcommerceRefundConfigurationV2
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSaveEcommerceRefundConfigurationV2Request}
     * @memberof SettingsApiSaveEcommerceRefundConfigurationV2
     */
    readonly pbSaveEcommerceRefundConfigurationV2Request: PbSaveEcommerceRefundConfigurationV2Request
}

/**
 * Request parameters for saveEcommerceReturnProcessConditionsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceReturnProcessConditionsV2Request
 */
export interface SettingsApiSaveEcommerceReturnProcessConditionsV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiSaveEcommerceReturnProcessConditionsV2
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSaveEcommerceReturnProcessConditionsV2Request}
     * @memberof SettingsApiSaveEcommerceReturnProcessConditionsV2
     */
    readonly pbSaveEcommerceReturnProcessConditionsV2Request: PbSaveEcommerceReturnProcessConditionsV2Request
}

/**
 * Request parameters for saveEcommerceReturnReasonsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceReturnReasonsV2Request
 */
export interface SettingsApiSaveEcommerceReturnReasonsV2Request {
    /**
     * Ecommerce id
     * @type {string}
     * @memberof SettingsApiSaveEcommerceReturnReasonsV2
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSaveEcommerceReturnReasonsV2Request}
     * @memberof SettingsApiSaveEcommerceReturnReasonsV2
     */
    readonly pbSaveEcommerceReturnReasonsV2Request: PbSaveEcommerceReturnReasonsV2Request
}

/**
 * Request parameters for saveEcommerceWarehouseConfigsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveEcommerceWarehouseConfigsV2Request
 */
export interface SettingsApiSaveEcommerceWarehouseConfigsV2Request {
    /**
     * EcommerceID
     * @type {string}
     * @memberof SettingsApiSaveEcommerceWarehouseConfigsV2
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSaveWarehouseConfigRequest}
     * @memberof SettingsApiSaveEcommerceWarehouseConfigsV2
     */
    readonly pbSaveWarehouseConfigRequest: PbSaveWarehouseConfigRequest
}

/**
 * Request parameters for saveExchangeConditions operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveExchangeConditionsRequest
 */
export interface SettingsApiSaveExchangeConditionsRequest {
    /**
     * 
     * @type {PbSaveExchangeConditionsReq}
     * @memberof SettingsApiSaveExchangeConditions
     */
    readonly pbSaveExchangeConditionsReq: PbSaveExchangeConditionsReq
}

/**
 * Request parameters for saveExchangeOrder operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveExchangeOrderRequest
 */
export interface SettingsApiSaveExchangeOrderRequest {
    /**
     * 
     * @type {PbSaveExchangeOrderWithEcommerceReq}
     * @memberof SettingsApiSaveExchangeOrder
     */
    readonly pbSaveExchangeOrderWithEcommerceReq: PbSaveExchangeOrderWithEcommerceReq
}

/**
 * Request parameters for saveGroupContacts operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupContactsRequest
 */
export interface SettingsApiSaveGroupContactsRequest {
    /**
     * 
     * @type {PbSaveGroupContactsRequest}
     * @memberof SettingsApiSaveGroupContacts
     */
    readonly pbSaveGroupContactsRequest: PbSaveGroupContactsRequest
}

/**
 * Request parameters for saveGroupExchangesSettingsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupExchangesSettingsV2Request
 */
export interface SettingsApiSaveGroupExchangesSettingsV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof SettingsApiSaveGroupExchangesSettingsV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveGroupExchangesSettingsV2Request}
     * @memberof SettingsApiSaveGroupExchangesSettingsV2
     */
    readonly pbSaveGroupExchangesSettingsV2Request: PbSaveGroupExchangesSettingsV2Request
}

/**
 * Request parameters for saveGroupRDVSurplusV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupRDVSurplusV2Request
 */
export interface SettingsApiSaveGroupRDVSurplusV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof SettingsApiSaveGroupRDVSurplusV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveGroupRDVSurplusV2Request}
     * @memberof SettingsApiSaveGroupRDVSurplusV2
     */
    readonly pbSaveGroupRDVSurplusV2Request: PbSaveGroupRDVSurplusV2Request
}

/**
 * Request parameters for saveGroupRefundConfigurationV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupRefundConfigurationV2Request
 */
export interface SettingsApiSaveGroupRefundConfigurationV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof SettingsApiSaveGroupRefundConfigurationV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveGroupRefundConfigurationV2Request}
     * @memberof SettingsApiSaveGroupRefundConfigurationV2
     */
    readonly pbSaveGroupRefundConfigurationV2Request: PbSaveGroupRefundConfigurationV2Request
}

/**
 * Request parameters for saveGroupReturnProcessConditionsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupReturnProcessConditionsV2Request
 */
export interface SettingsApiSaveGroupReturnProcessConditionsV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof SettingsApiSaveGroupReturnProcessConditionsV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveGroupReturnProcessConditionsV2Request}
     * @memberof SettingsApiSaveGroupReturnProcessConditionsV2
     */
    readonly pbSaveGroupReturnProcessConditionsV2Request: PbSaveGroupReturnProcessConditionsV2Request
}

/**
 * Request parameters for saveGroupReturnReasonsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupReturnReasonsV2Request
 */
export interface SettingsApiSaveGroupReturnReasonsV2Request {
    /**
     * Ecommerce group
     * @type {string}
     * @memberof SettingsApiSaveGroupReturnReasonsV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveGroupReturnReasonsV2Request}
     * @memberof SettingsApiSaveGroupReturnReasonsV2
     */
    readonly pbSaveGroupReturnReasonsV2Request: PbSaveGroupReturnReasonsV2Request
}

/**
 * Request parameters for saveGroupWarehouseConfigsV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveGroupWarehouseConfigsV2Request
 */
export interface SettingsApiSaveGroupWarehouseConfigsV2Request {
    /**
     * Ecommerce group whose routing rules to replace
     * @type {string}
     * @memberof SettingsApiSaveGroupWarehouseConfigsV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveGroupWarehouseConfigsV2Request}
     * @memberof SettingsApiSaveGroupWarehouseConfigsV2
     */
    readonly pbSaveGroupWarehouseConfigsV2Request: PbSaveGroupWarehouseConfigsV2Request
}

/**
 * Request parameters for saveInStoreSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveInStoreSettingsRequest
 */
export interface SettingsApiSaveInStoreSettingsRequest {
    /**
     * 
     * @type {PbSaveInStoreSettingsReq}
     * @memberof SettingsApiSaveInStoreSettings
     */
    readonly pbSaveInStoreSettingsReq: PbSaveInStoreSettingsReq
}

/**
 * Request parameters for saveLogisticSetting operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveLogisticSettingRequest
 */
export interface SettingsApiSaveLogisticSettingRequest {
    /**
     * 
     * @type {PbSaveLogisticSettingReq}
     * @memberof SettingsApiSaveLogisticSetting
     */
    readonly pbSaveLogisticSettingReq: PbSaveLogisticSettingReq
}

/**
 * Request parameters for savePartnerConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiSavePartnerConnectionRequest
 */
export interface SettingsApiSavePartnerConnectionRequest {
    /**
     * 
     * @type {PbSavePartnerConnectionRequest}
     * @memberof SettingsApiSavePartnerConnection
     */
    readonly pbSavePartnerConnectionRequest: PbSavePartnerConnectionRequest
}

/**
 * Request parameters for saveRefundConfiguration operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveRefundConfigurationRequest
 */
export interface SettingsApiSaveRefundConfigurationRequest {
    /**
     * 
     * @type {PbSaveRefundConfigurationRequest}
     * @memberof SettingsApiSaveRefundConfiguration
     */
    readonly pbSaveRefundConfigurationRequest: PbSaveRefundConfigurationRequest
}

/**
 * Request parameters for saveReturnProcessConditions operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveReturnProcessConditionsRequest
 */
export interface SettingsApiSaveReturnProcessConditionsRequest {
    /**
     * 
     * @type {PbSaveReturnProcessConditionsReq}
     * @memberof SettingsApiSaveReturnProcessConditions
     */
    readonly pbSaveReturnProcessConditionsReq: PbSaveReturnProcessConditionsReq
}

/**
 * Request parameters for saveReturnReasons operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveReturnReasonsRequest
 */
export interface SettingsApiSaveReturnReasonsRequest {
    /**
     * 
     * @type {PbSaveReturnReasonsReq}
     * @memberof SettingsApiSaveReturnReasons
     */
    readonly pbSaveReturnReasonsReq: PbSaveReturnReasonsReq
}

/**
 * Request parameters for saveRiskExposureSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveRiskExposureSettingsRequest
 */
export interface SettingsApiSaveRiskExposureSettingsRequest {
    /**
     * 
     * @type {PbSaveRiskExposureSettingsRequest}
     * @memberof SettingsApiSaveRiskExposureSettings
     */
    readonly pbSaveRiskExposureSettingsRequest: PbSaveRiskExposureSettingsRequest
}

/**
 * Request parameters for saveShopifyAppAutomationToken operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveShopifyAppAutomationTokenRequest
 */
export interface SettingsApiSaveShopifyAppAutomationTokenRequest {
    /**
     * 
     * @type {PbSaveShopifyAppAutomationTokenRequest}
     * @memberof SettingsApiSaveShopifyAppAutomationToken
     */
    readonly pbSaveShopifyAppAutomationTokenRequest: PbSaveShopifyAppAutomationTokenRequest
}

/**
 * Request parameters for saveWarehouseConfigsPublic operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveWarehouseConfigsPublicRequest
 */
export interface SettingsApiSaveWarehouseConfigsPublicRequest {
    /**
     * 
     * @type {PbSaveWarehouseConfigRequest}
     * @memberof SettingsApiSaveWarehouseConfigsPublic
     */
    readonly pbSaveWarehouseConfigRequest: PbSaveWarehouseConfigRequest
}

/**
 * Request parameters for saveWarehouses operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveWarehousesRequest
 */
export interface SettingsApiSaveWarehousesRequest {
    /**
     * 
     * @type {PbSaveWarehousesReq}
     * @memberof SettingsApiSaveWarehouses
     */
    readonly pbSaveWarehousesReq: PbSaveWarehousesReq
}

/**
 * Request parameters for saveWarehousesV2 operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveWarehousesV2Request
 */
export interface SettingsApiSaveWarehousesV2Request {
    /**
     * Ecommerce group that owns the warehouses
     * @type {string}
     * @memberof SettingsApiSaveWarehousesV2
     */
    readonly ecommerceGroup: string

    /**
     * 
     * @type {PbSaveWarehousesV2Req}
     * @memberof SettingsApiSaveWarehousesV2
     */
    readonly pbSaveWarehousesV2Req: PbSaveWarehousesV2Req
}

/**
 * Request parameters for saveWorkflowConfigurations operation in SettingsApi.
 * @export
 * @interface SettingsApiSaveWorkflowConfigurationsRequest
 */
export interface SettingsApiSaveWorkflowConfigurationsRequest {
    /**
     * 
     * @type {PbSaveWorkflowConfigurationsReq}
     * @memberof SettingsApiSaveWorkflowConfigurations
     */
    readonly pbSaveWorkflowConfigurationsReq: PbSaveWorkflowConfigurationsReq
}

/**
 * Request parameters for sendTestWebhook operation in SettingsApi.
 * @export
 * @interface SettingsApiSendTestWebhookRequest
 */
export interface SettingsApiSendTestWebhookRequest {
    /**
     * The ecommerce id
     * @type {string}
     * @memberof SettingsApiSendTestWebhook
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSendTestWebhookRequest}
     * @memberof SettingsApiSendTestWebhook
     */
    readonly pbSendTestWebhookRequest: PbSendTestWebhookRequest
}

/**
 * Request parameters for setUserBlocked operation in SettingsApi.
 * @export
 * @interface SettingsApiSetUserBlockedRequest
 */
export interface SettingsApiSetUserBlockedRequest {
    /**
     * 
     * @type {PbSetUserBlockedRequest}
     * @memberof SettingsApiSetUserBlocked
     */
    readonly pbSetUserBlockedRequest: PbSetUserBlockedRequest
}

/**
 * Request parameters for setWithdrawalSettings operation in SettingsApi.
 * @export
 * @interface SettingsApiSetWithdrawalSettingsRequest
 */
export interface SettingsApiSetWithdrawalSettingsRequest {
    /**
     * E-commerce to configure. Required.
     * @type {string}
     * @memberof SettingsApiSetWithdrawalSettings
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbSetWithdrawalSettingsRequest}
     * @memberof SettingsApiSetWithdrawalSettings
     */
    readonly pbSetWithdrawalSettingsRequest: PbSetWithdrawalSettingsRequest
}

/**
 * Request parameters for unlinkNangoConnection operation in SettingsApi.
 * @export
 * @interface SettingsApiUnlinkNangoConnectionRequest
 */
export interface SettingsApiUnlinkNangoConnectionRequest {
    /**
     * Nango integration (provider_config_key) the connection belongs to.
     * @type {string}
     * @memberof SettingsApiUnlinkNangoConnection
     */
    readonly integration: string

    /**
     * Nango connection id.
     * @type {string}
     * @memberof SettingsApiUnlinkNangoConnection
     */
    readonly connectionId: string

    /**
     * Ecommerce that uses the connection.
     * @type {string}
     * @memberof SettingsApiUnlinkNangoConnection
     */
    readonly ecommerceId?: string
}

/**
 * Request parameters for updateCopies operation in SettingsApi.
 * @export
 * @interface SettingsApiUpdateCopiesRequest
 */
export interface SettingsApiUpdateCopiesRequest {
    /**
     * 
     * @type {PbUpdateEcommerceCopyRequest}
     * @memberof SettingsApiUpdateCopies
     */
    readonly pbUpdateEcommerceCopyRequest: PbUpdateEcommerceCopyRequest
}

/**
 * Request parameters for updateUser operation in SettingsApi.
 * @export
 * @interface SettingsApiUpdateUserRequest
 */
export interface SettingsApiUpdateUserRequest {
    /**
     * 
     * @type {PbUpdateUserRequest}
     * @memberof SettingsApiUpdateUser
     */
    readonly pbUpdateUserRequest: PbUpdateUserRequest
}

/**
 * Request parameters for uploadBrandingImage operation in SettingsApi.
 * @export
 * @interface SettingsApiUploadBrandingImageRequest
 */
export interface SettingsApiUploadBrandingImageRequest {
    /**
     * 
     * @type {PbUploadBrandingImageReq}
     * @memberof SettingsApiUploadBrandingImage
     */
    readonly pbUploadBrandingImageReq: PbUploadBrandingImageReq
}

/**
 * Request parameters for upsertEcommercePASettings operation in SettingsApi.
 * @export
 * @interface SettingsApiUpsertEcommercePASettingsRequest
 */
export interface SettingsApiUpsertEcommercePASettingsRequest {
    /**
     * 
     * @type {PbUpdateProductAutomationsSettingsRequest}
     * @memberof SettingsApiUpsertEcommercePASettings
     */
    readonly pbUpdateProductAutomationsSettingsRequest: PbUpdateProductAutomationsSettingsRequest
}

/**
 * Request parameters for upsertWebhookSubscriptions operation in SettingsApi.
 * @export
 * @interface SettingsApiUpsertWebhookSubscriptionsRequest
 */
export interface SettingsApiUpsertWebhookSubscriptionsRequest {
    /**
     * The ecommerce id
     * @type {string}
     * @memberof SettingsApiUpsertWebhookSubscriptions
     */
    readonly ecommerceId: string

    /**
     * 
     * @type {PbUpsertWebhookSubscriptionsRequest}
     * @memberof SettingsApiUpsertWebhookSubscriptions
     */
    readonly pbUpsertWebhookSubscriptionsRequest: PbUpsertWebhookSubscriptionsRequest
}

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * Adds a new set of settings to a given section (column)
     * @param {SettingsApiAddNewPASettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public addNewPASetting(requestParameters: SettingsApiAddNewPASettingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).addNewPASetting(requestParameters.pbAddNewPASettingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a new section (column) to the PA settings table
     * @param {SettingsApiAddPASettingsSectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public addPASettingsSection(requestParameters: SettingsApiAddPASettingsSectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).addPASettingsSection(requestParameters.pbAddPASettingsSectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Makes one of the group\'s Nango connections the one an ecommerce reads its platform credentials from
     * @param {SettingsApiAssignNangoPlatformConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public assignNangoPlatformConnection(requestParameters: SettingsApiAssignNangoPlatformConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).assignNangoPlatformConnection(requestParameters.pbAssignNangoPlatformConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Asks the store whether it accepts one of the group\'s Nango connections now, and records the answer
     * @param {SettingsApiCheckNangoConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public checkNangoConnection(requestParameters: SettingsApiCheckNangoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).checkNangoConnection(requestParameters.group, requestParameters.integration, requestParameters.connectionId, requestParameters.pbCheckNangoConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an API key with the chosen scopes for an ecommerce group and returns its value.  Creating a name the group already holds returns that existing key. Admins only.
     * @param {SettingsApiCreateAPIKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createAPIKey(requestParameters: SettingsApiCreateAPIKeyRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createAPIKey(requestParameters.pbCreateAPIKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Opens a Nango Connect session whose connections are tagged with the group
     * @param {SettingsApiCreateNangoConnectSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createNangoConnectSession(requestParameters: SettingsApiCreateNangoConnectSessionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createNangoConnectSession(requestParameters.pbCreateNangoConnectSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Opens a Nango Connect session that replaces the credentials of one of the group\'s connections
     * @param {SettingsApiCreateNangoReconnectSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createNangoReconnectSession(requestParameters: SettingsApiCreateNangoReconnectSessionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createNangoReconnectSession(requestParameters.group, requestParameters.integration, requestParameters.connectionId, requestParameters.pbCreateNangoReconnectSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CreateUser
     * @param {SettingsApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public createUser(requestParameters: SettingsApiCreateUserRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).createUser(requestParameters.pbCreateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a carrier connection
     * @param {SettingsApiDeleteCarrierConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteCarrierConnection(requestParameters: SettingsApiDeleteCarrierConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteCarrierConnection(requestParameters.id, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the overrides of an ecommerce for the given kinds, which locks them back to its group\'s
     * @param {SettingsApiDeleteExchangesSettingsOverridesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteExchangesSettingsOverridesV2(requestParameters: SettingsApiDeleteExchangesSettingsOverridesV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteExchangesSettingsOverridesV2(requestParameters.ecommerceId, requestParameters.kinds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes one of the group\'s Nango connections, unassigning it from every store
     * @param {SettingsApiDeleteNangoConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteNangoConnection(requestParameters: SettingsApiDeleteNangoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteNangoConnection(requestParameters.group, requestParameters.integration, requestParameters.connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a partner connection; fails while a carrier connection still books through it
     * @param {SettingsApiDeletePartnerConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deletePartnerConnection(requestParameters: SettingsApiDeletePartnerConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deletePartnerConnection(requestParameters.id, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the override of an ecommerce, which locks its RDV surplus rules back to its group\'s
     * @param {SettingsApiDeleteRDVSurplusOverrideV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteRDVSurplusOverrideV2(requestParameters: SettingsApiDeleteRDVSurplusOverrideV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteRDVSurplusOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the override of an ecommerce, which locks its refund configuration back to its group\'s
     * @param {SettingsApiDeleteRefundConfigurationOverrideV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteRefundConfigurationOverrideV2(requestParameters: SettingsApiDeleteRefundConfigurationOverrideV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteRefundConfigurationOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the override of an ecommerce, which locks its return conditions back to its group\'s
     * @param {SettingsApiDeleteReturnProcessConditionsOverrideV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteReturnProcessConditionsOverrideV2(requestParameters: SettingsApiDeleteReturnProcessConditionsOverrideV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteReturnProcessConditionsOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the override of an ecommerce, which locks its return reasons back to its group\'s
     * @param {SettingsApiDeleteReturnReasonsOverrideV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteReturnReasonsOverrideV2(requestParameters: SettingsApiDeleteReturnReasonsOverrideV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteReturnReasonsOverrideV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the routing rules override of an ecommerce, which locks it back to its group\'s rules
     * @param {SettingsApiDeleteWarehouseConfigOverrideV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteWarehouseConfigOverrideV2(requestParameters: SettingsApiDeleteWarehouseConfigOverrideV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteWarehouseConfigOverrideV2(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes warehouses of an ecommerce group. Fails while a routing rule still uses one of them.
     * @param {SettingsApiDeleteWarehousesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public deleteWarehousesV2(requestParameters: SettingsApiDeleteWarehousesV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).deleteWarehousesV2(requestParameters.ecommerceGroup, requestParameters.pbDeleteWarehousesV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding LogisticsSettings model
     * @param {SettingsApiFindBrandingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findBranding(requestParameters: SettingsApiFindBrandingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findBranding(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Branding model
     * @param {SettingsApiFindBrandingPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findBrandingPublic(requestParameters: SettingsApiFindBrandingPublicRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findBrandingPublic(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Credentials model
     * @param {SettingsApiFindCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findCredentials(requestParameters: SettingsApiFindCredentialsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findCredentials(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Ecommerce model
     * @param {SettingsApiFindEcommerceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findEcommerce(requestParameters: SettingsApiFindEcommerceRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findEcommerce(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the points of contact of the e-commerce\'s group, which every store of  the group shares. Deprecated: use FindGroupContacts.
     * @param {SettingsApiFindEcommerceContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findEcommerceContacts(requestParameters: SettingsApiFindEcommerceContactsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findEcommerceContacts(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding ExchangeConditions model
     * @param {SettingsApiFindExchangeConditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findExchangeConditions(requestParameters: SettingsApiFindExchangeConditionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findExchangeConditions(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding ExchangeOrder model
     * @param {SettingsApiFindExchangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findExchangeOrder(requestParameters: SettingsApiFindExchangeOrderRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findExchangeOrder(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the points of contact of a group, shared by every store of the  group. A group with no stored contacts gets an empty list back.
     * @param {SettingsApiFindGroupContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findGroupContacts(requestParameters: SettingsApiFindGroupContactsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findGroupContacts(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding InStoreSettings model
     * @param {SettingsApiFindInStoreSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findInStoreSettings(requestParameters: SettingsApiFindInStoreSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findInStoreSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * finds the return reasons to show for a specific item
     * @param {SettingsApiFindItemReturnReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findItemReturnReasons(requestParameters: SettingsApiFindItemReturnReasonsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findItemReturnReasons(requestParameters.ecommerceId, requestParameters.categoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * POST variant of FindItemReturnReasons for callers that need to send the  request in the body (e.g. very large category_ids lists that would exceed  URL length limits at Envoy). Delegates to the same handler.
     * @param {SettingsApiFindItemReturnReasonsByBodyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findItemReturnReasonsByBody(requestParameters: SettingsApiFindItemReturnReasonsByBodyRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findItemReturnReasonsByBody(requestParameters.pbFindItemReturnReason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding LogisticSetting model
     * @param {SettingsApiFindLogisticSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findLogisticSetting(requestParameters: SettingsApiFindLogisticSettingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findLogisticSetting(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Branding model
     * @param {SettingsApiFindPortalSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findPortalSettings(requestParameters: SettingsApiFindPortalSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findPortalSettings(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindRefundConfiguration
     * @param {SettingsApiFindRefundConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findRefundConfiguration(requestParameters: SettingsApiFindRefundConfigurationRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findRefundConfiguration(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding LogisticsSettings model
     * @param {SettingsApiFindReturnProcessConditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findReturnProcessConditions(requestParameters: SettingsApiFindReturnProcessConditionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findReturnProcessConditions(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tells whether a Shopify store has the App Automation token REVER deploys its Shopify app with, and when it expires
     * @param {SettingsApiFindShopifyAppAutomationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findShopifyAppAutomationToken(requestParameters: SettingsApiFindShopifyAppAutomationTokenRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findShopifyAppAutomationToken(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FindUsers lists the dashboard users of the caller\'s own group. The group is  taken from the caller\'s claim, never from the request, so it cannot be spoofed.
     * @param {SettingsApiFindUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findUsers(requestParameters: SettingsApiFindUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findUsers(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Warehouse model, ecommerce or group-level
     * @param {SettingsApiFindWarehouseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findWarehouse(requestParameters: SettingsApiFindWarehouseRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findWarehouse(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Warehouses by ecommerce id
     * @param {SettingsApiFindWarehousesByEcommerceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findWarehousesByEcommerce(requestParameters: SettingsApiFindWarehousesByEcommerceRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findWarehousesByEcommerce(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finds the warehouses of an ecommerce group
     * @param {SettingsApiFindWarehousesByGroupV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findWarehousesByGroupV2(requestParameters: SettingsApiFindWarehousesByGroupV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findWarehousesByGroupV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves whether an e-commerce\'s portal has the EU withdrawal form. Callers  only see their own group\'s e-commerces.
     * @param {SettingsApiFindWithdrawalSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findWithdrawalSettings(requestParameters: SettingsApiFindWithdrawalSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findWithdrawalSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding WorkflowConfigurations model
     * @param {SettingsApiFindWorkflowConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public findWorkflowConfigurations(requestParameters: SettingsApiFindWorkflowConfigurationsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).findWorkflowConfigurations(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates the secret REVER signs this ecommerce group\'s outgoing webhooks with,  replacing and revoking the current one. Returns the plaintext so the caller can show  it.   The secret belongs to the group, not to the ecommerce: receivers normally handle  every ecommerce of a group in one endpoint, and picking a key per ecommerce would  force them to parse the body before they could verify it. The ecommerce id here only  says which ecommerce the caller came in through.   One path serves both surfaces: the dashboard reaches it through Envoy with the  tenant\'s own group claim, and the backoffice over gRPC directly with the \"*\" claims  it injects itself. Attribution comes from the username claim, never from a request  field, so no caller can record the change against someone else.
     * @param {SettingsApiGenerateWebhookSigningSecretRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public generateWebhookSigningSecret(requestParameters: SettingsApiGenerateWebhookSigningSecretRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).generateWebhookSigningSecret(requestParameters.ecommerceId, requestParameters.pbWebhookSigningSecretRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the value of an existing API key so an admin can copy it again. Admins only.
     * @param {SettingsApiGetAPIKeyValueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getAPIKeyValue(requestParameters: SettingsApiGetAPIKeyValueRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getAPIKeyValue(requestParameters.ecommerceGroup, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * finds all ecommerce return reasons by ecommerce id
     * @param {SettingsApiGetAllReturnReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getAllReturnReasons(requestParameters: SettingsApiGetAllReturnReasonsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getAllReturnReasons(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding warehouse address
     * @param {SettingsApiGetDynamicWarehouseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getDynamicWarehouse(requestParameters: SettingsApiGetDynamicWarehouseRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getDynamicWarehouse(requestParameters.ecommerceId, requestParameters.pbGetWarehouseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the settings for the given e-commerce, without secrets
     * @param {SettingsApiGetECommerceSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getECommerceSettings(requestParameters: SettingsApiGetECommerceSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getECommerceSettings(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the settings for the given e-commerce, without secrets
     * @param {SettingsApiGetECommerceSettingsDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getECommerceSettingsDeprecated(requestParameters: SettingsApiGetECommerceSettingsDeprecatedRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getECommerceSettingsDeprecated(requestParameters.slug, requestParameters.ecommerceId, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of copies for a given e-commerce
     * @param {SettingsApiGetECommerceTextCopiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getECommerceTextCopies(requestParameters: SettingsApiGetECommerceTextCopiesRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getECommerceTextCopies(requestParameters.ecommerceId, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of copies for a given e-commerce
     * @param {SettingsApiGetECommerceTextCopiesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getECommerceTextCopiesV2(requestParameters: SettingsApiGetECommerceTextCopiesV2Request = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getECommerceTextCopiesV2(requestParameters.ecommerceId, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of copies for a given e-commerce
     * @param {SettingsApiGetECommerceTextCopiesV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getECommerceTextCopiesV3(requestParameters: SettingsApiGetECommerceTextCopiesV3Request = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getECommerceTextCopiesV3(requestParameters.ecommerceId, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the exchanges settings an ecommerce gets: for each kind, its override if it has one, else its group\'s
     * @param {SettingsApiGetEcommerceExchangesSettingsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceExchangesSettingsV2(requestParameters: SettingsApiGetEcommerceExchangesSettingsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceExchangesSettingsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the PA settings for the specified ecommerce
     * @param {SettingsApiGetEcommercePASettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommercePASettings(requestParameters: SettingsApiGetEcommercePASettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommercePASettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the RDV surplus rules an ecommerce gets: its override if it has one, else its group\'s
     * @param {SettingsApiGetEcommerceRDVSurplusV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceRDVSurplusV2(requestParameters: SettingsApiGetEcommerceRDVSurplusV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceRDVSurplusV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the refund configuration an ecommerce gets: its override if it has one, else its group\'s
     * @param {SettingsApiGetEcommerceRefundConfigurationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceRefundConfigurationV2(requestParameters: SettingsApiGetEcommerceRefundConfigurationV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceRefundConfigurationV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the return conditions an ecommerce gets: its override if it has one, else its group\'s
     * @param {SettingsApiGetEcommerceReturnProcessConditionsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceReturnProcessConditionsV2(requestParameters: SettingsApiGetEcommerceReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceReturnProcessConditionsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the return reasons an ecommerce gets: its override if it has one, else its group\'s
     * @param {SettingsApiGetEcommerceReturnReasonsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceReturnReasonsV2(requestParameters: SettingsApiGetEcommerceReturnReasonsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceReturnReasonsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of settings, without secrets,   one per e-commerce in the group
     * @param {SettingsApiGetEcommerceSettingsByGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceSettingsByGroup(requestParameters: SettingsApiGetEcommerceSettingsByGroupRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceSettingsByGroup(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of settings, without secrets,   one per e-commerce in the group
     * @param {SettingsApiGetEcommerceSettingsByGroupDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceSettingsByGroupDeprecated(requestParameters: SettingsApiGetEcommerceSettingsByGroupDeprecatedRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceSettingsByGroupDeprecated(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the effective warehouse routing rules of an ecommerce: its override if it has one, else its group\'s
     * @param {SettingsApiGetEcommerceWarehouseConfigsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getEcommerceWarehouseConfigsV2(requestParameters: SettingsApiGetEcommerceWarehouseConfigsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getEcommerceWarehouseConfigsV2(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the PA settings for an ecommerce and returns them flattened
     * @param {SettingsApiGetFlattenedPASettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getFlattenedPASettings(requestParameters: SettingsApiGetFlattenedPASettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getFlattenedPASettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the exchanges settings of a group, and the ones each of its ecommerces overrides
     * @param {SettingsApiGetGroupExchangesSettingsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getGroupExchangesSettingsV2(requestParameters: SettingsApiGetGroupExchangesSettingsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getGroupExchangesSettingsV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the RDV surplus rules of a group, and the overrides of its ecommerces
     * @param {SettingsApiGetGroupRDVSurplusV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getGroupRDVSurplusV2(requestParameters: SettingsApiGetGroupRDVSurplusV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getGroupRDVSurplusV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the refund configuration of a group, and the overrides of its ecommerces
     * @param {SettingsApiGetGroupRefundConfigurationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getGroupRefundConfigurationV2(requestParameters: SettingsApiGetGroupRefundConfigurationV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getGroupRefundConfigurationV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the return conditions of a group, and the overrides of its ecommerces
     * @param {SettingsApiGetGroupReturnProcessConditionsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getGroupReturnProcessConditionsV2(requestParameters: SettingsApiGetGroupReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getGroupReturnProcessConditionsV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the return reasons of a group, and the overrides of its ecommerces
     * @param {SettingsApiGetGroupReturnReasonsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getGroupReturnReasonsV2(requestParameters: SettingsApiGetGroupReturnReasonsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getGroupReturnReasonsV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads the warehouse routing rules of a group
     * @param {SettingsApiGetGroupWarehouseConfigsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getGroupWarehouseConfigsV2(requestParameters: SettingsApiGetGroupWarehouseConfigsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getGroupWarehouseConfigsV2(requestParameters.ecommerceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of return amount business rules for a given e-commerce
     * @param {SettingsApiGetReturnAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getReturnAmount(requestParameters: SettingsApiGetReturnAmountRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getReturnAmount(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of return amount available businessrules for a given e-commerce
     * @param {SettingsApiGetReturnAmountAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getReturnAmountAvailable(requestParameters: SettingsApiGetReturnAmountAvailableRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getReturnAmountAvailable(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get risk exposure settings for an e-commerce
     * @param {SettingsApiGetRiskExposureSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getRiskExposureSettings(requestParameters: SettingsApiGetRiskExposureSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getRiskExposureSettings(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for finding Warehouses config by ecommerce id
     * @param {SettingsApiGetWarehouseConfigsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getWarehouseConfigsPublic(requestParameters: SettingsApiGetWarehouseConfigsPublicRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getWarehouseConfigsPublic(requestParameters.ecommerceId, requestParameters.slug, requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reveals the active webhook signing secret of the ecommerce\'s group so the tenant can  compare it against what its own verification code uses.
     * @param {SettingsApiGetWebhookSigningSecretRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getWebhookSigningSecret(requestParameters: SettingsApiGetWebhookSigningSecretRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getWebhookSigningSecret(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns whether the ecommerce is subscribed to the return-started and  return-completed webhooks and the destination URL they are posted to.
     * @param {SettingsApiGetWebhookSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public getWebhookSubscriptions(requestParameters: SettingsApiGetWebhookSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).getWebhookSubscriptions(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Links one of the group\'s Nango connections to an ecommerce
     * @param {SettingsApiLinkNangoConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public linkNangoConnection(requestParameters: SettingsApiLinkNangoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).linkNangoConnection(requestParameters.pbLinkNangoConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the ecommerce groups that hold at least one API key and that the caller may manage:  every group for REVER staff, the caller\'s own group for anyone else. Admins only.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listAPIKeyGroups(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listAPIKeyGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the API keys of the requested ecommerce groups, never their values. Admins only,  and only groups the caller\'s claim covers.
     * @param {SettingsApiListAPIKeysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listAPIKeys(requestParameters: SettingsApiListAPIKeysRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listAPIKeys(requestParameters.ecommerceGroups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists a group\'s carrier connections, secrets masked
     * @param {SettingsApiListCarrierConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listCarrierConnections(requestParameters: SettingsApiListCarrierConnectionsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listCarrierConnections(requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the Nango connections of a group, with the stores each one is assigned to
     * @param {SettingsApiListGroupNangoConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listGroupNangoConnections(requestParameters: SettingsApiListGroupNangoConnectionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listGroupNangoConnections(requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists the Nango connections an ecommerce uses
     * @param {SettingsApiListNangoConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listNangoConnections(requestParameters: SettingsApiListNangoConnectionsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listNangoConnections(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists a group\'s partner connections, secrets masked
     * @param {SettingsApiListPartnerConnectionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listPartnerConnections(requestParameters: SettingsApiListPartnerConnectionsRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listPartnerConnections(requestParameters.group, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists every signing secret ever issued to the ecommerce\'s group, newest first,  redacted, along with the ecommerces that share it. The audit view for \"who rotated  this and when\"; it never returns a secret value.
     * @param {SettingsApiListWebhookSigningSecretsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public listWebhookSigningSecrets(requestParameters: SettingsApiListWebhookSigningSecretsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).listWebhookSigningSecrets(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for Me request with accesible ecommerces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public me(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).me(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Onboard an e-commerce with the return amount business rules
     * @param {SettingsApiOnboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public onboard(requestParameters: SettingsApiOnboardRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).onboard(requestParameters.pbOnboardingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint an e-commerce may use to change a subset of its own branding
     * @param {SettingsApiPatchBrandingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public patchBranding(requestParameters: SettingsApiPatchBrandingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).patchBranding(requestParameters.pbPatchBrandingReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for patching the ReturnConditions attributes an e-commerce may change  itself: the return period, the shipping deadline, the return reason options, the  review auto-completion and the non-returnable product, collection, category, tag and  order tag lists. Any other attribute is rejected with PERMISSION_DENIED.
     * @param {SettingsApiPatchReturnProcessConditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public patchReturnProcessConditions(requestParameters: SettingsApiPatchReturnProcessConditionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).patchReturnProcessConditions(requestParameters.pbPatchReturnProcessConditionsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the list of return amount business rules to a given e-commerce
     * @param {SettingsApiPostReturnAmountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public postReturnAmount(requestParameters: SettingsApiPostReturnAmountRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).postReturnAmount(requestParameters.ecommerceId, requestParameters.pbPostReturnAmountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return list of return amount available businessrules for a given e-commerce
     * @param {SettingsApiPublicReturnAmountAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public publicReturnAmountAvailable(requestParameters: SettingsApiPublicReturnAmountAvailableRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).publicReturnAmountAvailable(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revokes an API key: requests made with it stop being authorized. Admins only.
     * @param {SettingsApiRevokeAPIKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public revokeAPIKey(requestParameters: SettingsApiRevokeAPIKeyRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).revokeAPIKey(requestParameters.ecommerceGroup, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revokes the active webhook signing secret, returning every ecommerce of the group to  unsigned deliveries.
     * @param {SettingsApiRevokeWebhookSigningSecretRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public revokeWebhookSigningSecret(requestParameters: SettingsApiRevokeWebhookSigningSecretRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).revokeWebhookSigningSecret(requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving LogisticsSettings model
     * @param {SettingsApiSaveBrandingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveBranding(requestParameters: SettingsApiSaveBrandingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveBranding(requestParameters.pbSaveBrandingReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates a carrier connection, validated against the provider declarations
     * @param {SettingsApiSaveCarrierConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveCarrierConnection(requestParameters: SettingsApiSaveCarrierConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveCarrierConnection(requestParameters.pbSaveCarrierConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving Credentials model
     * @param {SettingsApiSaveCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveCredentials(requestParameters: SettingsApiSaveCredentialsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveCredentials(requestParameters.pbCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving Ecommerce model
     * @param {SettingsApiSaveEcommerceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerce(requestParameters: SettingsApiSaveEcommerceRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerce(requestParameters.pbSaveEcommerceReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the points of contact of the e-commerce\'s group with the ones in the  request. Deprecated: use SaveGroupContacts.
     * @param {SettingsApiSaveEcommerceContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceContacts(requestParameters: SettingsApiSaveEcommerceContactsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceContacts(requestParameters.pbSaveEcommerceContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the override of an ecommerce for the kinds present in the request, which unlocks them from  its group\'s. Needs write access; instant exchange is REVER only.
     * @param {SettingsApiSaveEcommerceExchangesSettingsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceExchangesSettingsV2(requestParameters: SettingsApiSaveEcommerceExchangesSettingsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceExchangesSettingsV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceExchangesSettingsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the override of an ecommerce, which unlocks its RDV surplus rules from its group\'s. Needs  write access.
     * @param {SettingsApiSaveEcommerceRDVSurplusV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceRDVSurplusV2(requestParameters: SettingsApiSaveEcommerceRDVSurplusV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceRDVSurplusV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceRDVSurplusV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the override of an ecommerce, which unlocks its refund configuration from its group\'s.  Needs write access.
     * @param {SettingsApiSaveEcommerceRefundConfigurationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceRefundConfigurationV2(requestParameters: SettingsApiSaveEcommerceRefundConfigurationV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceRefundConfigurationV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceRefundConfigurationV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the override of an ecommerce, which unlocks its return conditions from its group\'s. Needs  write access; skip_fraud_detection, payments_enabled and the fields v1 keeps from merchants are REVER only.
     * @param {SettingsApiSaveEcommerceReturnProcessConditionsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceReturnProcessConditionsV2(requestParameters: SettingsApiSaveEcommerceReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceReturnProcessConditionsV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceReturnProcessConditionsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the override of an ecommerce, which unlocks its return reasons from its group\'s. Needs write  access.
     * @param {SettingsApiSaveEcommerceReturnReasonsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceReturnReasonsV2(requestParameters: SettingsApiSaveEcommerceReturnReasonsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceReturnReasonsV2(requestParameters.ecommerceId, requestParameters.pbSaveEcommerceReturnReasonsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or replaces the routing rules override of an ecommerce, which unlocks it from its group\'s rules.  The override may only use the group\'s warehouses.
     * @param {SettingsApiSaveEcommerceWarehouseConfigsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveEcommerceWarehouseConfigsV2(requestParameters: SettingsApiSaveEcommerceWarehouseConfigsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveEcommerceWarehouseConfigsV2(requestParameters.ecommerceId, requestParameters.pbSaveWarehouseConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving ExchangeConditions model
     * @param {SettingsApiSaveExchangeConditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveExchangeConditions(requestParameters: SettingsApiSaveExchangeConditionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveExchangeConditions(requestParameters.pbSaveExchangeConditionsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving ExchangeOrder model
     * @param {SettingsApiSaveExchangeOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveExchangeOrder(requestParameters: SettingsApiSaveExchangeOrderRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveExchangeOrder(requestParameters.pbSaveExchangeOrderWithEcommerceReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the points of contact of a group with the ones in the request.  Anything stored but missing from the request is removed.
     * @param {SettingsApiSaveGroupContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupContacts(requestParameters: SettingsApiSaveGroupContactsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupContacts(requestParameters.pbSaveGroupContactsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the kinds of exchanges settings present in the request for a group. Needs write access; instant  exchange is REVER only.
     * @param {SettingsApiSaveGroupExchangesSettingsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupExchangesSettingsV2(requestParameters: SettingsApiSaveGroupExchangesSettingsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupExchangesSettingsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupExchangesSettingsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the RDV surplus rules of a group. Needs write access.
     * @param {SettingsApiSaveGroupRDVSurplusV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupRDVSurplusV2(requestParameters: SettingsApiSaveGroupRDVSurplusV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupRDVSurplusV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupRDVSurplusV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the refund configuration of a group. Needs write access.
     * @param {SettingsApiSaveGroupRefundConfigurationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupRefundConfigurationV2(requestParameters: SettingsApiSaveGroupRefundConfigurationV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupRefundConfigurationV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupRefundConfigurationV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the return conditions of a group. Needs write access; skip_fraud_detection, payments_enabled and the  fields v1 keeps from merchants are REVER only.
     * @param {SettingsApiSaveGroupReturnProcessConditionsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupReturnProcessConditionsV2(requestParameters: SettingsApiSaveGroupReturnProcessConditionsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupReturnProcessConditionsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupReturnProcessConditionsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the return reasons of a group. Needs write access.
     * @param {SettingsApiSaveGroupReturnReasonsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupReturnReasonsV2(requestParameters: SettingsApiSaveGroupReturnReasonsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupReturnReasonsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupReturnReasonsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces the warehouse routing rules of a group, which may only use the group\'s warehouses
     * @param {SettingsApiSaveGroupWarehouseConfigsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveGroupWarehouseConfigsV2(requestParameters: SettingsApiSaveGroupWarehouseConfigsV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveGroupWarehouseConfigsV2(requestParameters.ecommerceGroup, requestParameters.pbSaveGroupWarehouseConfigsV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving InStoreSettings model
     * @param {SettingsApiSaveInStoreSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveInStoreSettings(requestParameters: SettingsApiSaveInStoreSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveInStoreSettings(requestParameters.pbSaveInStoreSettingsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving LogisticSetting model
     * @param {SettingsApiSaveLogisticSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveLogisticSetting(requestParameters: SettingsApiSaveLogisticSettingRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveLogisticSetting(requestParameters.pbSaveLogisticSettingReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates a partner connection, validated against the provider declarations
     * @param {SettingsApiSavePartnerConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public savePartnerConnection(requestParameters: SettingsApiSavePartnerConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).savePartnerConnection(requestParameters.pbSavePartnerConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SaveRefundConfiguration
     * @param {SettingsApiSaveRefundConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveRefundConfiguration(requestParameters: SettingsApiSaveRefundConfigurationRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveRefundConfiguration(requestParameters.pbSaveRefundConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving LogisticsSettings model
     * @param {SettingsApiSaveReturnProcessConditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveReturnProcessConditions(requestParameters: SettingsApiSaveReturnProcessConditionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveReturnProcessConditions(requestParameters.pbSaveReturnProcessConditionsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Saves return reasons to the database
     * @param {SettingsApiSaveReturnReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveReturnReasons(requestParameters: SettingsApiSaveReturnReasonsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveReturnReasons(requestParameters.pbSaveReturnReasonsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save risk exposure settings for an e-commerce
     * @param {SettingsApiSaveRiskExposureSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveRiskExposureSettings(requestParameters: SettingsApiSaveRiskExposureSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveRiskExposureSettings(requestParameters.pbSaveRiskExposureSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replaces a Shopify store\'s App Automation token, generated in the store\'s Shopify Dev Dashboard
     * @param {SettingsApiSaveShopifyAppAutomationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveShopifyAppAutomationToken(requestParameters: SettingsApiSaveShopifyAppAutomationTokenRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveShopifyAppAutomationToken(requestParameters.pbSaveShopifyAppAutomationTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for save Warehouse config by ecommerce id
     * @param {SettingsApiSaveWarehouseConfigsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveWarehouseConfigsPublic(requestParameters: SettingsApiSaveWarehouseConfigsPublicRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveWarehouseConfigsPublic(requestParameters.pbSaveWarehouseConfigRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving Warehouses for a given ecommerce
     * @param {SettingsApiSaveWarehousesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveWarehouses(requestParameters: SettingsApiSaveWarehousesRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveWarehouses(requestParameters.pbSaveWarehousesReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates or updates warehouses of an ecommerce group
     * @param {SettingsApiSaveWarehousesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveWarehousesV2(requestParameters: SettingsApiSaveWarehousesV2Request, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveWarehousesV2(requestParameters.ecommerceGroup, requestParameters.pbSaveWarehousesV2Req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint for saving WorkflowConfigurations model
     * @param {SettingsApiSaveWorkflowConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public saveWorkflowConfigurations(requestParameters: SettingsApiSaveWorkflowConfigurationsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).saveWorkflowConfigurations(requestParameters.pbSaveWorkflowConfigurationsReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a sample of a webhook to a destination URL so the tenant can check that its  endpoint accepts REVER\'s deliveries before subscribing. The sample has the shape of  a real delivery, is marked is_testing, and is signed and authenticated like one.  The URL is not stored, and the sample refers to no real return.
     * @param {SettingsApiSendTestWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public sendTestWebhook(requestParameters: SettingsApiSendTestWebhookRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).sendTestWebhook(requestParameters.ecommerceId, requestParameters.pbSendTestWebhookRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SetUserBlocked blocks or unblocks a dashboard user belonging to the caller\'s  own group, revoking or restoring their access to the dashboard
     * @param {SettingsApiSetUserBlockedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public setUserBlocked(requestParameters: SettingsApiSetUserBlockedRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).setUserBlocked(requestParameters.pbSetUserBlockedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Turns the EU withdrawal form on or off for an e-commerce\'s portal. Only REVER  staff can: anyone else gets PermissionDenied.
     * @param {SettingsApiSetWithdrawalSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public setWithdrawalSettings(requestParameters: SettingsApiSetWithdrawalSettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).setWithdrawalSettings(requestParameters.ecommerceId, requestParameters.pbSetWithdrawalSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlinks a Nango connection from an ecommerce, keeping it in Nango
     * @param {SettingsApiUnlinkNangoConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public unlinkNangoConnection(requestParameters: SettingsApiUnlinkNangoConnectionRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).unlinkNangoConnection(requestParameters.integration, requestParameters.connectionId, requestParameters.ecommerceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update list of copies for a given e-commerce
     * @param {SettingsApiUpdateCopiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public updateCopies(requestParameters: SettingsApiUpdateCopiesRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).updateCopies(requestParameters.pbUpdateEcommerceCopyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UpdateUser updates the role and assigned warehouses of a dashboard user  belonging to the caller\'s own group
     * @param {SettingsApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public updateUser(requestParameters: SettingsApiUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).updateUser(requestParameters.pbUpdateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * endpoint an e-commerce may use to upload one of its own portal images
     * @param {SettingsApiUploadBrandingImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public uploadBrandingImage(requestParameters: SettingsApiUploadBrandingImageRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).uploadBrandingImage(requestParameters.pbUploadBrandingImageReq, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the PA settings for the specified ecommerce
     * @param {SettingsApiUpsertEcommercePASettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public upsertEcommercePASettings(requestParameters: SettingsApiUpsertEcommercePASettingsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).upsertEcommercePASettings(requestParameters.pbUpdateProductAutomationsSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Subscribes or unsubscribes the ecommerce to the return-started and  return-completed webhooks. Enabling either one requires a destination URL.  The URL is shared by both webhooks.
     * @param {SettingsApiUpsertWebhookSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public upsertWebhookSubscriptions(requestParameters: SettingsApiUpsertWebhookSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).upsertWebhookSubscriptions(requestParameters.ecommerceId, requestParameters.pbUpsertWebhookSubscriptionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeleteExchangesSettingsOverridesV2KindsEnum = {
    Unspecified: 'EXCHANGES_SETTINGS_KIND_V2_UNSPECIFIED',
    Policy: 'EXCHANGES_SETTINGS_KIND_V2_POLICY',
    ExchangeOrders: 'EXCHANGES_SETTINGS_KIND_V2_EXCHANGE_ORDERS',
    FullCatalog: 'EXCHANGES_SETTINGS_KIND_V2_FULL_CATALOG',
    InstantExchange: 'EXCHANGES_SETTINGS_KIND_V2_INSTANT_EXCHANGE'
} as const;
export type DeleteExchangesSettingsOverridesV2KindsEnum = typeof DeleteExchangesSettingsOverridesV2KindsEnum[keyof typeof DeleteExchangesSettingsOverridesV2KindsEnum];


/**
 * SizeSuggestionsApi - axios parameter creator
 * @export
 */
export const SizeSuggestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Resolve the size banner for one product view. Public and unauthenticated:  it is called from the merchant\'s storefront on every product page.
         * @param {SizesuggestionspbProductSizeBannerRequest} sizesuggestionspbProductSizeBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSizeBanner: async (sizesuggestionspbProductSizeBannerRequest: SizesuggestionspbProductSizeBannerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizesuggestionspbProductSizeBannerRequest' is not null or undefined
            assertParamExists('getProductSizeBanner', 'sizesuggestionspbProductSizeBannerRequest', sizesuggestionspbProductSizeBannerRequest)
            const localVarPath = `/v1/public/analytics/size_suggestions/banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sizesuggestionspbProductSizeBannerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get product size suggestion
         * @param {SizesuggestionspbProductSizeSuggestionRequest} sizesuggestionspbProductSizeSuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSizeSuggestion: async (sizesuggestionspbProductSizeSuggestionRequest: SizesuggestionspbProductSizeSuggestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sizesuggestionspbProductSizeSuggestionRequest' is not null or undefined
            assertParamExists('getProductSizeSuggestion', 'sizesuggestionspbProductSizeSuggestionRequest', sizesuggestionspbProductSizeSuggestionRequest)
            const localVarPath = `/v1/public/analytics/get_product_size_suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sizesuggestionspbProductSizeSuggestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one cycle\'s changelog and monthly report (Novedades tab)
         * @param {string} storeId Store the cycle belongs to.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizingCycle: async (storeId: string, cycleDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getSizingCycle', 'storeId', storeId)
            const localVarPath = `/v1/analytics/sizing/cycle/{store_id}`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cycleDate !== undefined) {
                localVarQueryParameter['cycle_date'] = cycleDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get one sizing model\'s detail (both directions, colorways, quotes)
         * @param {string} storeId Store the model belongs to.
         * @param {string} modelKey Model key from the list endpoint.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizingModel: async (storeId: string, modelKey: string, cycleDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getSizingModel', 'storeId', storeId)
            // verify required parameter 'modelKey' is not null or undefined
            assertParamExists('getSizingModel', 'modelKey', modelKey)
            const localVarPath = `/v1/analytics/sizing/models/{store_id}/{model_key}`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"model_key"}}`, encodeURIComponent(String(modelKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cycleDate !== undefined) {
                localVarQueryParameter['cycle_date'] = cycleDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the sizing overview (Resumen tab) for a store
         * @param {string} storeId Store to fetch the overview for.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizingOverview: async (storeId: string, cycleDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getSizingOverview', 'storeId', storeId)
            const localVarPath = `/v1/analytics/sizing/overview/{store_id}`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cycleDate !== undefined) {
                localVarQueryParameter['cycle_date'] = cycleDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Whether to offer the Sizing page for a store
         * @param {string} storeId Store ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWronglySizedProductsTab: async (storeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getWronglySizedProductsTab', 'storeId', storeId)
            const localVarPath = `/v1/analytics/wrongly_sized_products/tab/{store_id}`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List a store\'s persisted sizing cycles (cycle selector)
         * @param {string} storeId Store to list cycles for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSizingCycles: async (storeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listSizingCycles', 'storeId', storeId)
            const localVarPath = `/v1/analytics/sizing/cycles/{store_id}`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List a store\'s sizing models (Modelos tab)
         * @param {string} storeId Store to list models for.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSizingModels: async (storeId: string, cycleDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listSizingModels', 'storeId', storeId)
            const localVarPath = `/v1/analytics/sizing/models/{store_id}`
                .replace(`{${"store_id"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cycleDate !== undefined) {
                localVarQueryParameter['cycle_date'] = cycleDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SizeSuggestionsApi - functional programming interface
 * @export
 */
export const SizeSuggestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SizeSuggestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Resolve the size banner for one product view. Public and unauthenticated:  it is called from the merchant\'s storefront on every product page.
         * @param {SizesuggestionspbProductSizeBannerRequest} sizesuggestionspbProductSizeBannerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSizeBanner(sizesuggestionspbProductSizeBannerRequest: SizesuggestionspbProductSizeBannerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbProductSizeBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSizeBanner(sizesuggestionspbProductSizeBannerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.getProductSizeBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get product size suggestion
         * @param {SizesuggestionspbProductSizeSuggestionRequest} sizesuggestionspbProductSizeSuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSizeSuggestion(sizesuggestionspbProductSizeSuggestionRequest: SizesuggestionspbProductSizeSuggestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbProductSizeSuggestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSizeSuggestion(sizesuggestionspbProductSizeSuggestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.getProductSizeSuggestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one cycle\'s changelog and monthly report (Novedades tab)
         * @param {string} storeId Store the cycle belongs to.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSizingCycle(storeId: string, cycleDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbGetSizingCycleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSizingCycle(storeId, cycleDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.getSizingCycle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get one sizing model\'s detail (both directions, colorways, quotes)
         * @param {string} storeId Store the model belongs to.
         * @param {string} modelKey Model key from the list endpoint.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSizingModel(storeId: string, modelKey: string, cycleDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbGetSizingModelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSizingModel(storeId, modelKey, cycleDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.getSizingModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the sizing overview (Resumen tab) for a store
         * @param {string} storeId Store to fetch the overview for.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSizingOverview(storeId: string, cycleDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbGetSizingOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSizingOverview(storeId, cycleDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.getSizingOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Whether to offer the Sizing page for a store
         * @param {string} storeId Store ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWronglySizedProductsTab(storeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbWronglySizedProductsTabResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWronglySizedProductsTab(storeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.getWronglySizedProductsTab']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List a store\'s persisted sizing cycles (cycle selector)
         * @param {string} storeId Store to list cycles for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSizingCycles(storeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbListSizingCyclesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSizingCycles(storeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.listSizingCycles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List a store\'s sizing models (Modelos tab)
         * @param {string} storeId Store to list models for.
         * @param {string} [cycleDate] Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSizingModels(storeId: string, cycleDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SizesuggestionspbListSizingModelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSizingModels(storeId, cycleDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SizeSuggestionsApi.listSizingModels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SizeSuggestionsApi - factory interface
 * @export
 */
export const SizeSuggestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SizeSuggestionsApiFp(configuration)
    return {
        /**
         * Resolve the size banner for one product view. Public and unauthenticated:  it is called from the merchant\'s storefront on every product page.
         * @param {SizeSuggestionsApiGetProductSizeBannerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSizeBanner(requestParameters: SizeSuggestionsApiGetProductSizeBannerRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbProductSizeBannerResponse> {
            return localVarFp.getProductSizeBanner(requestParameters.sizesuggestionspbProductSizeBannerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get product size suggestion
         * @param {SizeSuggestionsApiGetProductSizeSuggestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSizeSuggestion(requestParameters: SizeSuggestionsApiGetProductSizeSuggestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbProductSizeSuggestionResponse> {
            return localVarFp.getProductSizeSuggestion(requestParameters.sizesuggestionspbProductSizeSuggestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one cycle\'s changelog and monthly report (Novedades tab)
         * @param {SizeSuggestionsApiGetSizingCycleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizingCycle(requestParameters: SizeSuggestionsApiGetSizingCycleRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbGetSizingCycleResponse> {
            return localVarFp.getSizingCycle(requestParameters.storeId, requestParameters.cycleDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get one sizing model\'s detail (both directions, colorways, quotes)
         * @param {SizeSuggestionsApiGetSizingModelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizingModel(requestParameters: SizeSuggestionsApiGetSizingModelRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbGetSizingModelResponse> {
            return localVarFp.getSizingModel(requestParameters.storeId, requestParameters.modelKey, requestParameters.cycleDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the sizing overview (Resumen tab) for a store
         * @param {SizeSuggestionsApiGetSizingOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSizingOverview(requestParameters: SizeSuggestionsApiGetSizingOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbGetSizingOverviewResponse> {
            return localVarFp.getSizingOverview(requestParameters.storeId, requestParameters.cycleDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Whether to offer the Sizing page for a store
         * @param {SizeSuggestionsApiGetWronglySizedProductsTabRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWronglySizedProductsTab(requestParameters: SizeSuggestionsApiGetWronglySizedProductsTabRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbWronglySizedProductsTabResponse> {
            return localVarFp.getWronglySizedProductsTab(requestParameters.storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * List a store\'s persisted sizing cycles (cycle selector)
         * @param {SizeSuggestionsApiListSizingCyclesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSizingCycles(requestParameters: SizeSuggestionsApiListSizingCyclesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbListSizingCyclesResponse> {
            return localVarFp.listSizingCycles(requestParameters.storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * List a store\'s sizing models (Modelos tab)
         * @param {SizeSuggestionsApiListSizingModelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSizingModels(requestParameters: SizeSuggestionsApiListSizingModelsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SizesuggestionspbListSizingModelsResponse> {
            return localVarFp.listSizingModels(requestParameters.storeId, requestParameters.cycleDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getProductSizeBanner operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiGetProductSizeBannerRequest
 */
export interface SizeSuggestionsApiGetProductSizeBannerRequest {
    /**
     * 
     * @type {SizesuggestionspbProductSizeBannerRequest}
     * @memberof SizeSuggestionsApiGetProductSizeBanner
     */
    readonly sizesuggestionspbProductSizeBannerRequest: SizesuggestionspbProductSizeBannerRequest
}

/**
 * Request parameters for getProductSizeSuggestion operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiGetProductSizeSuggestionRequest
 */
export interface SizeSuggestionsApiGetProductSizeSuggestionRequest {
    /**
     * 
     * @type {SizesuggestionspbProductSizeSuggestionRequest}
     * @memberof SizeSuggestionsApiGetProductSizeSuggestion
     */
    readonly sizesuggestionspbProductSizeSuggestionRequest: SizesuggestionspbProductSizeSuggestionRequest
}

/**
 * Request parameters for getSizingCycle operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiGetSizingCycleRequest
 */
export interface SizeSuggestionsApiGetSizingCycleRequest {
    /**
     * Store the cycle belongs to.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingCycle
     */
    readonly storeId: string

    /**
     * Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingCycle
     */
    readonly cycleDate?: string
}

/**
 * Request parameters for getSizingModel operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiGetSizingModelRequest
 */
export interface SizeSuggestionsApiGetSizingModelRequest {
    /**
     * Store the model belongs to.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingModel
     */
    readonly storeId: string

    /**
     * Model key from the list endpoint.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingModel
     */
    readonly modelKey: string

    /**
     * Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingModel
     */
    readonly cycleDate?: string
}

/**
 * Request parameters for getSizingOverview operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiGetSizingOverviewRequest
 */
export interface SizeSuggestionsApiGetSizingOverviewRequest {
    /**
     * Store to fetch the overview for.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingOverview
     */
    readonly storeId: string

    /**
     * Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
     * @type {string}
     * @memberof SizeSuggestionsApiGetSizingOverview
     */
    readonly cycleDate?: string
}

/**
 * Request parameters for getWronglySizedProductsTab operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiGetWronglySizedProductsTabRequest
 */
export interface SizeSuggestionsApiGetWronglySizedProductsTabRequest {
    /**
     * Store ID
     * @type {string}
     * @memberof SizeSuggestionsApiGetWronglySizedProductsTab
     */
    readonly storeId: string
}

/**
 * Request parameters for listSizingCycles operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiListSizingCyclesRequest
 */
export interface SizeSuggestionsApiListSizingCyclesRequest {
    /**
     * Store to list cycles for.
     * @type {string}
     * @memberof SizeSuggestionsApiListSizingCycles
     */
    readonly storeId: string
}

/**
 * Request parameters for listSizingModels operation in SizeSuggestionsApi.
 * @export
 * @interface SizeSuggestionsApiListSizingModelsRequest
 */
export interface SizeSuggestionsApiListSizingModelsRequest {
    /**
     * Store to list models for.
     * @type {string}
     * @memberof SizeSuggestionsApiListSizingModels
     */
    readonly storeId: string

    /**
     * Cycle to read (YYYY-MM-DD); empty picks the latest persisted cycle.
     * @type {string}
     * @memberof SizeSuggestionsApiListSizingModels
     */
    readonly cycleDate?: string
}

/**
 * SizeSuggestionsApi - object-oriented interface
 * @export
 * @class SizeSuggestionsApi
 * @extends {BaseAPI}
 */
export class SizeSuggestionsApi extends BaseAPI {
    /**
     * Resolve the size banner for one product view. Public and unauthenticated:  it is called from the merchant\'s storefront on every product page.
     * @param {SizeSuggestionsApiGetProductSizeBannerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public getProductSizeBanner(requestParameters: SizeSuggestionsApiGetProductSizeBannerRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).getProductSizeBanner(requestParameters.sizesuggestionspbProductSizeBannerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get product size suggestion
     * @param {SizeSuggestionsApiGetProductSizeSuggestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public getProductSizeSuggestion(requestParameters: SizeSuggestionsApiGetProductSizeSuggestionRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).getProductSizeSuggestion(requestParameters.sizesuggestionspbProductSizeSuggestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one cycle\'s changelog and monthly report (Novedades tab)
     * @param {SizeSuggestionsApiGetSizingCycleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public getSizingCycle(requestParameters: SizeSuggestionsApiGetSizingCycleRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).getSizingCycle(requestParameters.storeId, requestParameters.cycleDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get one sizing model\'s detail (both directions, colorways, quotes)
     * @param {SizeSuggestionsApiGetSizingModelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public getSizingModel(requestParameters: SizeSuggestionsApiGetSizingModelRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).getSizingModel(requestParameters.storeId, requestParameters.modelKey, requestParameters.cycleDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the sizing overview (Resumen tab) for a store
     * @param {SizeSuggestionsApiGetSizingOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public getSizingOverview(requestParameters: SizeSuggestionsApiGetSizingOverviewRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).getSizingOverview(requestParameters.storeId, requestParameters.cycleDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Whether to offer the Sizing page for a store
     * @param {SizeSuggestionsApiGetWronglySizedProductsTabRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public getWronglySizedProductsTab(requestParameters: SizeSuggestionsApiGetWronglySizedProductsTabRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).getWronglySizedProductsTab(requestParameters.storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List a store\'s persisted sizing cycles (cycle selector)
     * @param {SizeSuggestionsApiListSizingCyclesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public listSizingCycles(requestParameters: SizeSuggestionsApiListSizingCyclesRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).listSizingCycles(requestParameters.storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List a store\'s sizing models (Modelos tab)
     * @param {SizeSuggestionsApiListSizingModelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SizeSuggestionsApi
     */
    public listSizingModels(requestParameters: SizeSuggestionsApiListSizingModelsRequest, options?: RawAxiosRequestConfig) {
        return SizeSuggestionsApiFp(this.configuration).listSizingModels(requestParameters.storeId, requestParameters.cycleDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoreApi - axios parameter creator
 * @export
 */
export const StoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculate order price
         * @param {string} ecommerceId Ecommerce id. Required.
         * @param {string} [email] e-mail of the customer. Required.
         * @param {string} [shippingAddressReverId] Unique ID in the rever platform
         * @param {string} [shippingAddressFirstName] 
         * @param {string} [shippingAddressLastName] 
         * @param {string} [shippingAddressCompany] 
         * @param {string} [shippingAddressAddressLine1] 
         * @param {string} [shippingAddressAddressLine2] 
         * @param {string} [shippingAddressCity] 
         * @param {string} [shippingAddressStateProvince] 
         * @param {string} [shippingAddressPostcode] 
         * @param {string} [shippingAddressCountry] 
         * @param {string} [shippingAddressCountryCode] 
         * @param {string} [shippingAddressEmail] 
         * @param {string} [shippingAddressPhone] 
         * @param {string} [shippingAddressStateProvinceCode] 
         * @param {string} [originalOrderId] Original platform &#x60;order_id&#x60; (not the customer printed order id) that
         * @param {string} [currency] Currency in which the order should be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderPrice: async (ecommerceId: string, email?: string, shippingAddressReverId?: string, shippingAddressFirstName?: string, shippingAddressLastName?: string, shippingAddressCompany?: string, shippingAddressAddressLine1?: string, shippingAddressAddressLine2?: string, shippingAddressCity?: string, shippingAddressStateProvince?: string, shippingAddressPostcode?: string, shippingAddressCountry?: string, shippingAddressCountryCode?: string, shippingAddressEmail?: string, shippingAddressPhone?: string, shippingAddressStateProvinceCode?: string, originalOrderId?: string, currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('calculateOrderPrice', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/public/shopping/ecommerce/{ecommerce_id}/calculate-order-price`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (shippingAddressReverId !== undefined) {
                localVarQueryParameter['shipping_address.rever_id'] = shippingAddressReverId;
            }

            if (shippingAddressFirstName !== undefined) {
                localVarQueryParameter['shipping_address.first_name'] = shippingAddressFirstName;
            }

            if (shippingAddressLastName !== undefined) {
                localVarQueryParameter['shipping_address.last_name'] = shippingAddressLastName;
            }

            if (shippingAddressCompany !== undefined) {
                localVarQueryParameter['shipping_address.company'] = shippingAddressCompany;
            }

            if (shippingAddressAddressLine1 !== undefined) {
                localVarQueryParameter['shipping_address.address_line_1'] = shippingAddressAddressLine1;
            }

            if (shippingAddressAddressLine2 !== undefined) {
                localVarQueryParameter['shipping_address.address_line_2'] = shippingAddressAddressLine2;
            }

            if (shippingAddressCity !== undefined) {
                localVarQueryParameter['shipping_address.city'] = shippingAddressCity;
            }

            if (shippingAddressStateProvince !== undefined) {
                localVarQueryParameter['shipping_address.state_province'] = shippingAddressStateProvince;
            }

            if (shippingAddressPostcode !== undefined) {
                localVarQueryParameter['shipping_address.postcode'] = shippingAddressPostcode;
            }

            if (shippingAddressCountry !== undefined) {
                localVarQueryParameter['shipping_address.country'] = shippingAddressCountry;
            }

            if (shippingAddressCountryCode !== undefined) {
                localVarQueryParameter['shipping_address.country_code'] = shippingAddressCountryCode;
            }

            if (shippingAddressEmail !== undefined) {
                localVarQueryParameter['shipping_address.email'] = shippingAddressEmail;
            }

            if (shippingAddressPhone !== undefined) {
                localVarQueryParameter['shipping_address.phone'] = shippingAddressPhone;
            }

            if (shippingAddressStateProvinceCode !== undefined) {
                localVarQueryParameter['shipping_address.state_province_code'] = shippingAddressStateProvinceCode;
            }

            if (originalOrderId !== undefined) {
                localVarQueryParameter['original_order_id'] = originalOrderId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FetchMenu fetches the menu of the store
         * @param {string} ecommerceId The id of the ecommerce
         * @param {string} [language] The language of the menu
         * @param {string} [countryCode] The country code of the menu
         * @param {string} [orderReference] Optional order reference; required to resolve the correct site for multi-site portals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMenu: async (ecommerceId: string, language?: string, countryCode?: string, orderReference?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('fetchMenu', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/public/shopping/ecommerce/{ecommerce_id}/menu`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['order_reference'] = orderReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FetchProductDetails fetches the details of a product
         * @param {string} ecommerceId The id of the ecommerce
         * @param {string} productId The id of the product
         * @param {string} [language] The language of the product
         * @param {string} [countryCode] The country code of the product
         * @param {string} [currencyCode] currency code
         * @param {string} [shopperEmail] The shopper email
         * @param {string} [orderReference] The order reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProductDetails: async (ecommerceId: string, productId: string, language?: string, countryCode?: string, currencyCode?: string, shopperEmail?: string, orderReference?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('fetchProductDetails', 'ecommerceId', ecommerceId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('fetchProductDetails', 'productId', productId)
            const localVarPath = `/v1/public/shopping/ecommerce/{ecommerce_id}/products/{product_id}`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)))
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }

            if (shopperEmail !== undefined) {
                localVarQueryParameter['shopper_email'] = shopperEmail;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['order_reference'] = orderReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * LoadProducts for catalog
         * @param {string} ecommerceId The id of the ecommerce
         * @param {string} [resourceId] The id of the catalog
         * @param {string} [resourceType] The id of the catalog
         * @param {string} [language] The language of the product
         * @param {string} [countryCode] The country code of the product
         * @param {string} [orderCurrency] The Currency of the order
         * @param {number} [pageInfoPageSize] page size, for response it would be empty
         * @param {string} [pageInfoStartCursor] start_cursor, for first request , it would be empty
         * @param {string} [pageInfoEndCursor] end_cursor, for request it would be empty   for response, it would be the next page start_cursor
         * @param {boolean} [pageInfoHasNextPage] Has next page, for request it would be empty
         * @param {string} [filterText] text of the product
         * @param {string} [shopperEmail] The shopper email
         * @param {string} [orderReference] The order reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProducts: async (ecommerceId: string, resourceId?: string, resourceType?: string, language?: string, countryCode?: string, orderCurrency?: string, pageInfoPageSize?: number, pageInfoStartCursor?: string, pageInfoEndCursor?: string, pageInfoHasNextPage?: boolean, filterText?: string, shopperEmail?: string, orderReference?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ecommerceId' is not null or undefined
            assertParamExists('fetchProducts', 'ecommerceId', ecommerceId)
            const localVarPath = `/v1/public/shopping/ecommerce/{ecommerce_id}/products`
                .replace(`{${"ecommerce_id"}}`, encodeURIComponent(String(ecommerceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceId !== undefined) {
                localVarQueryParameter['resource_id'] = resourceId;
            }

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }

            if (orderCurrency !== undefined) {
                localVarQueryParameter['order_currency'] = orderCurrency;
            }

            if (pageInfoPageSize !== undefined) {
                localVarQueryParameter['page_info.page_size'] = pageInfoPageSize;
            }

            if (pageInfoStartCursor !== undefined) {
                localVarQueryParameter['page_info.start_cursor'] = pageInfoStartCursor;
            }

            if (pageInfoEndCursor !== undefined) {
                localVarQueryParameter['page_info.end_cursor'] = pageInfoEndCursor;
            }

            if (pageInfoHasNextPage !== undefined) {
                localVarQueryParameter['page_info.has_next_page'] = pageInfoHasNextPage;
            }

            if (filterText !== undefined) {
                localVarQueryParameter['filter.text'] = filterText;
            }

            if (shopperEmail !== undefined) {
                localVarQueryParameter['shopper_email'] = shopperEmail;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['order_reference'] = orderReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreApi - functional programming interface
 * @export
 */
export const StoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculate order price
         * @param {string} ecommerceId Ecommerce id. Required.
         * @param {string} [email] e-mail of the customer. Required.
         * @param {string} [shippingAddressReverId] Unique ID in the rever platform
         * @param {string} [shippingAddressFirstName] 
         * @param {string} [shippingAddressLastName] 
         * @param {string} [shippingAddressCompany] 
         * @param {string} [shippingAddressAddressLine1] 
         * @param {string} [shippingAddressAddressLine2] 
         * @param {string} [shippingAddressCity] 
         * @param {string} [shippingAddressStateProvince] 
         * @param {string} [shippingAddressPostcode] 
         * @param {string} [shippingAddressCountry] 
         * @param {string} [shippingAddressCountryCode] 
         * @param {string} [shippingAddressEmail] 
         * @param {string} [shippingAddressPhone] 
         * @param {string} [shippingAddressStateProvinceCode] 
         * @param {string} [originalOrderId] Original platform &#x60;order_id&#x60; (not the customer printed order id) that
         * @param {string} [currency] Currency in which the order should be created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOrderPrice(ecommerceId: string, email?: string, shippingAddressReverId?: string, shippingAddressFirstName?: string, shippingAddressLastName?: string, shippingAddressCompany?: string, shippingAddressAddressLine1?: string, shippingAddressAddressLine2?: string, shippingAddressCity?: string, shippingAddressStateProvince?: string, shippingAddressPostcode?: string, shippingAddressCountry?: string, shippingAddressCountryCode?: string, shippingAddressEmail?: string, shippingAddressPhone?: string, shippingAddressStateProvinceCode?: string, originalOrderId?: string, currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbshoppingCalculateOrderPriceRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOrderPrice(ecommerceId, email, shippingAddressReverId, shippingAddressFirstName, shippingAddressLastName, shippingAddressCompany, shippingAddressAddressLine1, shippingAddressAddressLine2, shippingAddressCity, shippingAddressStateProvince, shippingAddressPostcode, shippingAddressCountry, shippingAddressCountryCode, shippingAddressEmail, shippingAddressPhone, shippingAddressStateProvinceCode, originalOrderId, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoreApi.calculateOrderPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FetchMenu fetches the menu of the store
         * @param {string} ecommerceId The id of the ecommerce
         * @param {string} [language] The language of the menu
         * @param {string} [countryCode] The country code of the menu
         * @param {string} [orderReference] Optional order reference; required to resolve the correct site for multi-site portals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchMenu(ecommerceId: string, language?: string, countryCode?: string, orderReference?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbshoppingMenu>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchMenu(ecommerceId, language, countryCode, orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoreApi.fetchMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * FetchProductDetails fetches the details of a product
         * @param {string} ecommerceId The id of the ecommerce
         * @param {string} productId The id of the product
         * @param {string} [language] The language of the product
         * @param {string} [countryCode] The country code of the product
         * @param {string} [currencyCode] currency code
         * @param {string} [shopperEmail] The shopper email
         * @param {string} [orderReference] The order reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchProductDetails(ecommerceId: string, productId: string, language?: string, countryCode?: string, currencyCode?: string, shopperEmail?: string, orderReference?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbshoppingStoreFrontProductDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchProductDetails(ecommerceId, productId, language, countryCode, currencyCode, shopperEmail, orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoreApi.fetchProductDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * LoadProducts for catalog
         * @param {string} ecommerceId The id of the ecommerce
         * @param {string} [resourceId] The id of the catalog
         * @param {string} [resourceType] The id of the catalog
         * @param {string} [language] The language of the product
         * @param {string} [countryCode] The country code of the product
         * @param {string} [orderCurrency] The Currency of the order
         * @param {number} [pageInfoPageSize] page size, for response it would be empty
         * @param {string} [pageInfoStartCursor] start_cursor, for first request , it would be empty
         * @param {string} [pageInfoEndCursor] end_cursor, for request it would be empty   for response, it would be the next page start_cursor
         * @param {boolean} [pageInfoHasNextPage] Has next page, for request it would be empty
         * @param {string} [filterText] text of the product
         * @param {string} [shopperEmail] The shopper email
         * @param {string} [orderReference] The order reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchProducts(ecommerceId: string, resourceId?: string, resourceType?: string, language?: string, countryCode?: string, orderCurrency?: string, pageInfoPageSize?: number, pageInfoStartCursor?: string, pageInfoEndCursor?: string, pageInfoHasNextPage?: boolean, filterText?: string, shopperEmail?: string, orderReference?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbshoppingCatalogProducts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchProducts(ecommerceId, resourceId, resourceType, language, countryCode, orderCurrency, pageInfoPageSize, pageInfoStartCursor, pageInfoEndCursor, pageInfoHasNextPage, filterText, shopperEmail, orderReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoreApi.fetchProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StoreApi - factory interface
 * @export
 */
export const StoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreApiFp(configuration)
    return {
        /**
         * Calculate order price
         * @param {StoreApiCalculateOrderPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderPrice(requestParameters: StoreApiCalculateOrderPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbshoppingCalculateOrderPriceRes> {
            return localVarFp.calculateOrderPrice(requestParameters.ecommerceId, requestParameters.email, requestParameters.shippingAddressReverId, requestParameters.shippingAddressFirstName, requestParameters.shippingAddressLastName, requestParameters.shippingAddressCompany, requestParameters.shippingAddressAddressLine1, requestParameters.shippingAddressAddressLine2, requestParameters.shippingAddressCity, requestParameters.shippingAddressStateProvince, requestParameters.shippingAddressPostcode, requestParameters.shippingAddressCountry, requestParameters.shippingAddressCountryCode, requestParameters.shippingAddressEmail, requestParameters.shippingAddressPhone, requestParameters.shippingAddressStateProvinceCode, requestParameters.originalOrderId, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
        /**
         * FetchMenu fetches the menu of the store
         * @param {StoreApiFetchMenuRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchMenu(requestParameters: StoreApiFetchMenuRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbshoppingMenu> {
            return localVarFp.fetchMenu(requestParameters.ecommerceId, requestParameters.language, requestParameters.countryCode, requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * FetchProductDetails fetches the details of a product
         * @param {StoreApiFetchProductDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProductDetails(requestParameters: StoreApiFetchProductDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbshoppingStoreFrontProductDetails> {
            return localVarFp.fetchProductDetails(requestParameters.ecommerceId, requestParameters.productId, requestParameters.language, requestParameters.countryCode, requestParameters.currencyCode, requestParameters.shopperEmail, requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
        /**
         * LoadProducts for catalog
         * @param {StoreApiFetchProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchProducts(requestParameters: StoreApiFetchProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbshoppingCatalogProducts> {
            return localVarFp.fetchProducts(requestParameters.ecommerceId, requestParameters.resourceId, requestParameters.resourceType, requestParameters.language, requestParameters.countryCode, requestParameters.orderCurrency, requestParameters.pageInfoPageSize, requestParameters.pageInfoStartCursor, requestParameters.pageInfoEndCursor, requestParameters.pageInfoHasNextPage, requestParameters.filterText, requestParameters.shopperEmail, requestParameters.orderReference, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateOrderPrice operation in StoreApi.
 * @export
 * @interface StoreApiCalculateOrderPriceRequest
 */
export interface StoreApiCalculateOrderPriceRequest {
    /**
     * Ecommerce id. Required.
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly ecommerceId: string

    /**
     * e-mail of the customer. Required.
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly email?: string

    /**
     * Unique ID in the rever platform
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressReverId?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressFirstName?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressLastName?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressCompany?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressAddressLine1?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressAddressLine2?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressCity?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressStateProvince?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressPostcode?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressCountry?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressCountryCode?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressEmail?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressPhone?: string

    /**
     * 
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly shippingAddressStateProvinceCode?: string

    /**
     * Original platform &#x60;order_id&#x60; (not the customer printed order id) that
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly originalOrderId?: string

    /**
     * Currency in which the order should be created
     * @type {string}
     * @memberof StoreApiCalculateOrderPrice
     */
    readonly currency?: string
}

/**
 * Request parameters for fetchMenu operation in StoreApi.
 * @export
 * @interface StoreApiFetchMenuRequest
 */
export interface StoreApiFetchMenuRequest {
    /**
     * The id of the ecommerce
     * @type {string}
     * @memberof StoreApiFetchMenu
     */
    readonly ecommerceId: string

    /**
     * The language of the menu
     * @type {string}
     * @memberof StoreApiFetchMenu
     */
    readonly language?: string

    /**
     * The country code of the menu
     * @type {string}
     * @memberof StoreApiFetchMenu
     */
    readonly countryCode?: string

    /**
     * Optional order reference; required to resolve the correct site for multi-site portals
     * @type {string}
     * @memberof StoreApiFetchMenu
     */
    readonly orderReference?: string
}

/**
 * Request parameters for fetchProductDetails operation in StoreApi.
 * @export
 * @interface StoreApiFetchProductDetailsRequest
 */
export interface StoreApiFetchProductDetailsRequest {
    /**
     * The id of the ecommerce
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly ecommerceId: string

    /**
     * The id of the product
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly productId: string

    /**
     * The language of the product
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly language?: string

    /**
     * The country code of the product
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly countryCode?: string

    /**
     * currency code
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly currencyCode?: string

    /**
     * The shopper email
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly shopperEmail?: string

    /**
     * The order reference
     * @type {string}
     * @memberof StoreApiFetchProductDetails
     */
    readonly orderReference?: string
}

/**
 * Request parameters for fetchProducts operation in StoreApi.
 * @export
 * @interface StoreApiFetchProductsRequest
 */
export interface StoreApiFetchProductsRequest {
    /**
     * The id of the ecommerce
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly ecommerceId: string

    /**
     * The id of the catalog
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly resourceId?: string

    /**
     * The id of the catalog
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly resourceType?: string

    /**
     * The language of the product
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly language?: string

    /**
     * The country code of the product
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly countryCode?: string

    /**
     * The Currency of the order
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly orderCurrency?: string

    /**
     * page size, for response it would be empty
     * @type {number}
     * @memberof StoreApiFetchProducts
     */
    readonly pageInfoPageSize?: number

    /**
     * start_cursor, for first request , it would be empty
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly pageInfoStartCursor?: string

    /**
     * end_cursor, for request it would be empty   for response, it would be the next page start_cursor
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly pageInfoEndCursor?: string

    /**
     * Has next page, for request it would be empty
     * @type {boolean}
     * @memberof StoreApiFetchProducts
     */
    readonly pageInfoHasNextPage?: boolean

    /**
     * text of the product
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly filterText?: string

    /**
     * The shopper email
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly shopperEmail?: string

    /**
     * The order reference
     * @type {string}
     * @memberof StoreApiFetchProducts
     */
    readonly orderReference?: string
}

/**
 * StoreApi - object-oriented interface
 * @export
 * @class StoreApi
 * @extends {BaseAPI}
 */
export class StoreApi extends BaseAPI {
    /**
     * Calculate order price
     * @param {StoreApiCalculateOrderPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public calculateOrderPrice(requestParameters: StoreApiCalculateOrderPriceRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).calculateOrderPrice(requestParameters.ecommerceId, requestParameters.email, requestParameters.shippingAddressReverId, requestParameters.shippingAddressFirstName, requestParameters.shippingAddressLastName, requestParameters.shippingAddressCompany, requestParameters.shippingAddressAddressLine1, requestParameters.shippingAddressAddressLine2, requestParameters.shippingAddressCity, requestParameters.shippingAddressStateProvince, requestParameters.shippingAddressPostcode, requestParameters.shippingAddressCountry, requestParameters.shippingAddressCountryCode, requestParameters.shippingAddressEmail, requestParameters.shippingAddressPhone, requestParameters.shippingAddressStateProvinceCode, requestParameters.originalOrderId, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FetchMenu fetches the menu of the store
     * @param {StoreApiFetchMenuRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public fetchMenu(requestParameters: StoreApiFetchMenuRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).fetchMenu(requestParameters.ecommerceId, requestParameters.language, requestParameters.countryCode, requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FetchProductDetails fetches the details of a product
     * @param {StoreApiFetchProductDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public fetchProductDetails(requestParameters: StoreApiFetchProductDetailsRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).fetchProductDetails(requestParameters.ecommerceId, requestParameters.productId, requestParameters.language, requestParameters.countryCode, requestParameters.currencyCode, requestParameters.shopperEmail, requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * LoadProducts for catalog
     * @param {StoreApiFetchProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreApi
     */
    public fetchProducts(requestParameters: StoreApiFetchProductsRequest, options?: RawAxiosRequestConfig) {
        return StoreApiFp(this.configuration).fetchProducts(requestParameters.ecommerceId, requestParameters.resourceId, requestParameters.resourceType, requestParameters.language, requestParameters.countryCode, requestParameters.orderCurrency, requestParameters.pageInfoPageSize, requestParameters.pageInfoStartCursor, requestParameters.pageInfoEndCursor, requestParameters.pageInfoHasNextPage, requestParameters.filterText, requestParameters.shopperEmail, requestParameters.orderReference, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketClassifierApi - axios parameter creator
 * @export
 */
export const TicketClassifierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Classifies a Free text ticket to customer support
         * @param {string} [text] The text to classify
         * @param {string} [typeformId] Typeform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        classifyFreeTextTicket: async (text?: string, typeformId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/analytics/classify_free_text_ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (text !== undefined) {
                localVarQueryParameter['text'] = text;
            }

            if (typeformId !== undefined) {
                localVarQueryParameter['typeform_id'] = typeformId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketClassifierApi - functional programming interface
 * @export
 */
export const TicketClassifierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketClassifierApiAxiosParamCreator(configuration)
    return {
        /**
         * Classifies a Free text ticket to customer support
         * @param {string} [text] The text to classify
         * @param {string} [typeformId] Typeform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async classifyFreeTextTicket(text?: string, typeformId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketclassifierpbClassifyFreeTextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.classifyFreeTextTicket(text, typeformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TicketClassifierApi.classifyFreeTextTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TicketClassifierApi - factory interface
 * @export
 */
export const TicketClassifierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketClassifierApiFp(configuration)
    return {
        /**
         * Classifies a Free text ticket to customer support
         * @param {TicketClassifierApiClassifyFreeTextTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        classifyFreeTextTicket(requestParameters: TicketClassifierApiClassifyFreeTextTicketRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TicketclassifierpbClassifyFreeTextResponse> {
            return localVarFp.classifyFreeTextTicket(requestParameters.text, requestParameters.typeformId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for classifyFreeTextTicket operation in TicketClassifierApi.
 * @export
 * @interface TicketClassifierApiClassifyFreeTextTicketRequest
 */
export interface TicketClassifierApiClassifyFreeTextTicketRequest {
    /**
     * The text to classify
     * @type {string}
     * @memberof TicketClassifierApiClassifyFreeTextTicket
     */
    readonly text?: string

    /**
     * Typeform ID
     * @type {string}
     * @memberof TicketClassifierApiClassifyFreeTextTicket
     */
    readonly typeformId?: string
}

/**
 * TicketClassifierApi - object-oriented interface
 * @export
 * @class TicketClassifierApi
 * @extends {BaseAPI}
 */
export class TicketClassifierApi extends BaseAPI {
    /**
     * Classifies a Free text ticket to customer support
     * @param {TicketClassifierApiClassifyFreeTextTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketClassifierApi
     */
    public classifyFreeTextTicket(requestParameters: TicketClassifierApiClassifyFreeTextTicketRequest = {}, options?: RawAxiosRequestConfig) {
        return TicketClassifierApiFp(this.configuration).classifyFreeTextTicket(requestParameters.text, requestParameters.typeformId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WfpApi - axios parameter creator
 * @export
 */
export const WfpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GetQuote returns the Worry Free Purchase premium for a shopper\'s cart.  Public endpoint consumed by the storefront cart widget via the  ppf-lambdas MiddlewareFunction. The widget calls only this endpoint;  the handler resolves the shop, validates that WFP is enabled, and  fulfills the request.   The endpoint always returns HTTP 200 on business-rule failures and  surfaces the reason in the response body, so the widget can hide  cleanly without triggering CORS errors on the storefront. Transport  and downstream 5xx errors propagate as gRPC Internal (HTTP 5xx).
         * @param {PbwfpGetQuoteRequest} pbwfpGetQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote: async (pbwfpGetQuoteRequest: PbwfpGetQuoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pbwfpGetQuoteRequest' is not null or undefined
            assertParamExists('getQuote', 'pbwfpGetQuoteRequest', pbwfpGetQuoteRequest)
            const localVarPath = `/v1/public/wfp/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pbwfpGetQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WfpApi - functional programming interface
 * @export
 */
export const WfpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WfpApiAxiosParamCreator(configuration)
    return {
        /**
         * GetQuote returns the Worry Free Purchase premium for a shopper\'s cart.  Public endpoint consumed by the storefront cart widget via the  ppf-lambdas MiddlewareFunction. The widget calls only this endpoint;  the handler resolves the shop, validates that WFP is enabled, and  fulfills the request.   The endpoint always returns HTTP 200 on business-rule failures and  surfaces the reason in the response body, so the widget can hide  cleanly without triggering CORS errors on the storefront. Transport  and downstream 5xx errors propagate as gRPC Internal (HTTP 5xx).
         * @param {PbwfpGetQuoteRequest} pbwfpGetQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuote(pbwfpGetQuoteRequest: PbwfpGetQuoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PbwfpGetQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuote(pbwfpGetQuoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WfpApi.getQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WfpApi - factory interface
 * @export
 */
export const WfpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WfpApiFp(configuration)
    return {
        /**
         * GetQuote returns the Worry Free Purchase premium for a shopper\'s cart.  Public endpoint consumed by the storefront cart widget via the  ppf-lambdas MiddlewareFunction. The widget calls only this endpoint;  the handler resolves the shop, validates that WFP is enabled, and  fulfills the request.   The endpoint always returns HTTP 200 on business-rule failures and  surfaces the reason in the response body, so the widget can hide  cleanly without triggering CORS errors on the storefront. Transport  and downstream 5xx errors propagate as gRPC Internal (HTTP 5xx).
         * @param {WfpApiGetQuoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote(requestParameters: WfpApiGetQuoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<PbwfpGetQuoteResponse> {
            return localVarFp.getQuote(requestParameters.pbwfpGetQuoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getQuote operation in WfpApi.
 * @export
 * @interface WfpApiGetQuoteRequest
 */
export interface WfpApiGetQuoteRequest {
    /**
     * 
     * @type {PbwfpGetQuoteRequest}
     * @memberof WfpApiGetQuote
     */
    readonly pbwfpGetQuoteRequest: PbwfpGetQuoteRequest
}

/**
 * WfpApi - object-oriented interface
 * @export
 * @class WfpApi
 * @extends {BaseAPI}
 */
export class WfpApi extends BaseAPI {
    /**
     * GetQuote returns the Worry Free Purchase premium for a shopper\'s cart.  Public endpoint consumed by the storefront cart widget via the  ppf-lambdas MiddlewareFunction. The widget calls only this endpoint;  the handler resolves the shop, validates that WFP is enabled, and  fulfills the request.   The endpoint always returns HTTP 200 on business-rule failures and  surfaces the reason in the response body, so the widget can hide  cleanly without triggering CORS errors on the storefront. Transport  and downstream 5xx errors propagate as gRPC Internal (HTTP 5xx).
     * @param {WfpApiGetQuoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WfpApi
     */
    public getQuote(requestParameters: WfpApiGetQuoteRequest, options?: RawAxiosRequestConfig) {
        return WfpApiFp(this.configuration).getQuote(requestParameters.pbwfpGetQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



